var ii = Object.defineProperty;
var ai = (c, t, n) => t in c ? ii(c, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : c[t] = n;
var Zn = (c, t, n) => ai(c, typeof t != "symbol" ? t + "" : t, n);
var Chain = /* @__PURE__ */ ((c) => (c.CASPER = "CASPER", c.POLYGON = "POLYGON", c.BINANCE = "BINANCE", c.STACKS = "STACKS", c.XRPLSIDECHAIN = "XRPLSIDECHAIN", c.NEAR = "NEAR", c.SKALE = "SKALE", c.BASE = "BASE", c.LINEA = "LINEA", c.ETH = "ETH", c.SOLANA = "SOLANA", c.REDBELLY = "REDBELLY", c.UNSTOPPABLE = "UNSTOPPABLE", c.BITLAYER = "BITLAYER", c))(Chain || {}), PaymentTokens = /* @__PURE__ */ ((c) => (c.ETH = "ETH", c.RBNT = "RBNT", c.SOL = "SOL", c.USDC = "USDC", c.USDT = "USDT", c.MEW = "MEW", c.BNB = "BNB", c.MATIC = "MATIC", c.CSPR = "CSPR", c.PARAM = "PARAM", c.BDC = "BDC", c.BTC = "BTC", c))(PaymentTokens || {}), Network = /* @__PURE__ */ ((c) => (c[c.MAINNET = 0] = "MAINNET", c[c.TESTNET = 1] = "TESTNET", c[c.DEV = 2] = "DEV", c))(Network || {}), ChainWallet = /* @__PURE__ */ ((c) => (c.Metamask = "Metamask", c.CoinBase = "CoinBase", c.CasperWallet = "CasperWallet", c.Phantom = "Phantom", c.BaseSmartWallet = "BaseSmartWallet", c.UnstoppableDomains = "UnstoppableDomains", c))(ChainWallet || {});
async function getGasPrice$1(c) {
  return (await c.getGasPrice()).toBigInt();
}
function toEthAddress(c) {
  return c;
}
var NFTType = /* @__PURE__ */ ((c) => (c[c.ERC1155 = 0] = "ERC1155", c[c.ERC721 = 1] = "ERC721", c))(NFTType || {}), PaymentMethodType = /* @__PURE__ */ ((c) => (c[c.NATIVE_TOKEN = 0] = "NATIVE_TOKEN", c[c.USD = 1] = "USD", c[c.TOKEN = 2] = "TOKEN", c))(PaymentMethodType || {}), ProductType = /* @__PURE__ */ ((c) => (c[c.DIGITAL = 0] = "DIGITAL", c[c.POD = 1] = "POD", c[c.PHYSICAL = 2] = "PHYSICAL", c))(ProductType || {});
class HTTPError extends Error {
  constructor(n, ie, fe) {
    const ae = n.status || n.status === 0 ? n.status : "", le = n.statusText || "", he = `${ae} ${le}`.trim(), me = he ? `status code ${he}` : "an unknown error";
    super(`Request failed with ${me}: ${ie.method} ${ie.url}`);
    Zn(this, "response");
    Zn(this, "request");
    Zn(this, "options");
    this.name = "HTTPError", this.response = n, this.request = ie, this.options = fe;
  }
}
class TimeoutError extends Error {
  constructor(n) {
    super(`Request timed out: ${n.method} ${n.url}`);
    Zn(this, "request");
    this.name = "TimeoutError", this.request = n;
  }
}
const isObject$4 = (c) => c !== null && typeof c == "object", validateAndMerge = (...c) => {
  for (const t of c)
    if ((!isObject$4(t) || Array.isArray(t)) && t !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return deepMerge({}, ...c);
}, mergeHeaders = (c = {}, t = {}) => {
  const n = new globalThis.Headers(c), ie = t instanceof globalThis.Headers, fe = new globalThis.Headers(t);
  for (const [ae, le] of fe.entries())
    ie && le === "undefined" || le === void 0 ? n.delete(ae) : n.set(ae, le);
  return n;
};
function newHookValue(c, t, n) {
  return Object.hasOwn(t, n) && t[n] === void 0 ? [] : deepMerge(c[n] ?? [], t[n] ?? []);
}
const mergeHooks = (c = {}, t = {}) => ({
  beforeRequest: newHookValue(c, t, "beforeRequest"),
  beforeRetry: newHookValue(c, t, "beforeRetry"),
  afterResponse: newHookValue(c, t, "afterResponse"),
  beforeError: newHookValue(c, t, "beforeError")
}), deepMerge = (...c) => {
  let t = {}, n = {}, ie = {};
  for (const fe of c)
    if (Array.isArray(fe))
      Array.isArray(t) || (t = []), t = [...t, ...fe];
    else if (isObject$4(fe)) {
      for (let [ae, le] of Object.entries(fe))
        isObject$4(le) && ae in t && (le = deepMerge(t[ae], le)), t = { ...t, [ae]: le };
      isObject$4(fe.hooks) && (ie = mergeHooks(ie, fe.hooks), t.hooks = ie), isObject$4(fe.headers) && (n = mergeHeaders(n, fe.headers), t.headers = n);
    }
  return t;
}, supportsRequestStreams = (() => {
  let c = !1, t = !1;
  const n = typeof globalThis.ReadableStream == "function", ie = typeof globalThis.Request == "function";
  if (n && ie)
    try {
      t = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return c = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (fe) {
      if (fe instanceof Error && fe.message === "unsupported BodyInit type")
        return !1;
      throw fe;
    }
  return c && !t;
})(), supportsAbortController = typeof globalThis.AbortController == "function", supportsResponseStreams = typeof globalThis.ReadableStream == "function", supportsFormData = typeof globalThis.FormData == "function", requestMethods = ["get", "post", "put", "patch", "head", "delete"], responseTypes = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, maxSafeTimeout = 2147483647, stop = Symbol("stop"), kyOptionKeys = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, requestOptionsRegistry = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, normalizeRequestMethod = (c) => requestMethods.includes(c) ? c.toUpperCase() : c, retryMethods = ["get", "put", "head", "delete", "options", "trace"], retryStatusCodes = [408, 413, 429, 500, 502, 503, 504], retryAfterStatusCodes = [413, 429, 503], defaultRetryOptions = {
  limit: 2,
  methods: retryMethods,
  statusCodes: retryStatusCodes,
  afterStatusCodes: retryAfterStatusCodes,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (c) => 0.3 * 2 ** (c - 1) * 1e3
}, normalizeRetryOptions = (c = {}) => {
  if (typeof c == "number")
    return {
      ...defaultRetryOptions,
      limit: c
    };
  if (c.methods && !Array.isArray(c.methods))
    throw new Error("retry.methods must be an array");
  if (c.statusCodes && !Array.isArray(c.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...defaultRetryOptions,
    ...c
  };
};
async function timeout(c, t, n, ie) {
  return new Promise((fe, ae) => {
    const le = setTimeout(() => {
      n && n.abort(), ae(new TimeoutError(c));
    }, ie.timeout);
    ie.fetch(c, t).then(fe).catch(ae).then(() => {
      clearTimeout(le);
    });
  });
}
async function delay(c, { signal: t }) {
  return new Promise((n, ie) => {
    t && (t.throwIfAborted(), t.addEventListener("abort", fe, { once: !0 }));
    function fe() {
      clearTimeout(ae), ie(t.reason);
    }
    const ae = setTimeout(() => {
      t == null || t.removeEventListener("abort", fe), n();
    }, c);
  });
}
const findUnknownOptions = (c, t) => {
  const n = {};
  for (const ie in t)
    !(ie in requestOptionsRegistry) && !(ie in kyOptionKeys) && !(ie in c) && (n[ie] = t[ie]);
  return n;
};
class Ky {
  // eslint-disable-next-line complexity
  constructor(t, n = {}) {
    Zn(this, "request");
    Zn(this, "abortController");
    Zn(this, "_retryCount", 0);
    Zn(this, "_input");
    Zn(this, "_options");
    var ie, fe;
    if (this._input = t, this._options = {
      ...n,
      headers: mergeHeaders(this._input.headers, n.headers),
      hooks: mergeHooks({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: normalizeRequestMethod(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: normalizeRetryOptions(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (supportsAbortController) {
      this.abortController = new globalThis.AbortController();
      const ae = this._options.signal ?? this._input.signal;
      ae == null || ae.addEventListener("abort", () => {
        this.abortController.abort(ae.reason);
      }), this._options.signal = this.abortController.signal;
    }
    if (supportsRequestStreams && (this._options.duplex = "half"), this._options.json !== void 0 && (this._options.body = ((fe = (ie = this._options).stringifyJson) == null ? void 0 : fe.call(ie, this._options.json)) ?? JSON.stringify(this._options.json), this._options.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json")), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const le = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), he = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, le);
      (supportsFormData && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(he, { ...this.request }), this._options);
    }
  }
  static create(t, n) {
    const ie = new Ky(t, n), fe = async () => {
      if (typeof ie._options.timeout == "number" && ie._options.timeout > maxSafeTimeout)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${maxSafeTimeout}`);
      await Promise.resolve();
      let he = await ie._fetch();
      for (const me of ie._options.hooks.afterResponse) {
        const ye = await me(ie.request, ie._options, ie._decorateResponse(he.clone()));
        ye instanceof globalThis.Response && (he = ye);
      }
      if (ie._decorateResponse(he), !he.ok && ie._options.throwHttpErrors) {
        let me = new HTTPError(he, ie.request, ie._options);
        for (const ye of ie._options.hooks.beforeError)
          me = await ye(me);
        throw me;
      }
      if (ie._options.onDownloadProgress) {
        if (typeof ie._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!supportsResponseStreams)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return ie._stream(he.clone(), ie._options.onDownloadProgress);
      }
      return he;
    }, le = ie._options.retry.methods.includes(ie.request.method.toLowerCase()) ? ie._retry(fe) : fe();
    for (const [he, me] of Object.entries(responseTypes))
      le[he] = async () => {
        ie.request.headers.set("accept", ie.request.headers.get("accept") || me);
        const be = (await le).clone();
        if (he === "json") {
          if (be.status === 204 || (await be.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await be.text());
        }
        return be[he]();
      };
    return le;
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount > this._options.retry.limit || t instanceof TimeoutError)
      throw t;
    if (t instanceof HTTPError) {
      if (!this._options.retry.statusCodes.includes(t.response.status))
        throw t;
      const ie = t.response.headers.get("Retry-After") ?? t.response.headers.get("RateLimit-Reset") ?? t.response.headers.get("X-RateLimit-Reset") ?? t.response.headers.get("X-Rate-Limit-Reset");
      if (ie && this._options.retry.afterStatusCodes.includes(t.response.status)) {
        let fe = Number(ie) * 1e3;
        Number.isNaN(fe) ? fe = Date.parse(ie) - Date.now() : fe >= Date.parse("2024-01-01") && (fe -= Date.now());
        const ae = this._options.retry.maxRetryAfter ?? fe;
        return fe < ae ? fe : ae;
      }
      if (t.response.status === 413)
        throw t;
    }
    const n = this._options.retry.delay(this._retryCount);
    return Math.min(this._options.retry.backoffLimit, n);
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (n) {
      const ie = Math.min(this._calculateRetryDelay(n), maxSafeTimeout);
      if (this._retryCount < 1)
        throw n;
      await delay(ie, { signal: this._options.signal });
      for (const fe of this._options.hooks.beforeRetry)
        if (await fe({
          request: this.request,
          options: this._options,
          error: n,
          retryCount: this._retryCount
        }) === stop)
          return;
      return this._retry(t);
    }
  }
  async _fetch() {
    for (const ie of this._options.hooks.beforeRequest) {
      const fe = await ie(this.request, this._options);
      if (fe instanceof Request) {
        this.request = fe;
        break;
      }
      if (fe instanceof Response)
        return fe;
    }
    const t = findUnknownOptions(this.request, this._options), n = this.request;
    return this.request = n.clone(), this._options.timeout === !1 ? this._options.fetch(n, t) : timeout(n, t, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, n) {
    const ie = Number(t.headers.get("content-length")) || 0;
    let fe = 0;
    return t.status === 204 ? (n && n({ percent: 1, totalBytes: ie, transferredBytes: fe }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(ae) {
        const le = t.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: ie }, new Uint8Array());
        async function he() {
          const { done: me, value: ye } = await le.read();
          if (me) {
            ae.close();
            return;
          }
          if (n) {
            fe += ye.byteLength;
            const be = ie === 0 ? 0 : fe / ie;
            n({ percent: be, transferredBytes: fe, totalBytes: ie }, ye);
          }
          ae.enqueue(ye), await he();
        }
        await he();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const createInstance = (c) => {
  const t = (n, ie) => Ky.create(n, validateAndMerge(c, ie));
  for (const n of requestMethods)
    t[n] = (ie, fe) => Ky.create(ie, validateAndMerge(c, fe, { method: n }));
  return t.create = (n) => createInstance(validateAndMerge(n)), t.extend = (n) => (typeof n == "function" && (n = n(c ?? {})), createInstance(validateAndMerge(c, n))), t.stop = stop, t;
}, ky = createInstance(), ZERO_ADDRESS = "0x0000000000000000000000000000000000000000", DROPLINKED_MANAGER = "0x2F86E1B1A69D259b9609b40E3cbEBEa29946f979";
async function getAddress$1(c, t, n) {
  const ie = (fe) => fe.charAt(0).toUpperCase() + fe.slice(1).toLowerCase();
  try {
    const fe = t === Network.TESTNET ? "apiv3dev" : "apiv3", ae = ie(Chain[c]), le = ie(Network[t]), he = `https://${fe}.droplinked.com/storage/${ae}${le}ContractAddress${n}`;
    return (await await ky.get(he).json()).value;
  } catch (fe) {
    throw console.error(
      `Failed to fetch ${n.toLowerCase()} address:`,
      fe
    ), new Error(`Unable to get ${n.toLowerCase()} address`);
  }
}
async function getDeployerAddress(c, t) {
  return getAddress$1(c, t, "Deployer");
}
async function getProxyAddress(c, t) {
  return getAddress$1(c, t, "Proxy");
}
async function getAirdropAddress(c, t) {
  return getAddress$1(c, t, "Airdrop");
}
async function getShopByteCode() {
  try {
    return String((await await ky.get("https://apiv3dev.droplinked.com/storage/shopByteCodeType0").json()).value);
  } catch (c) {
    throw console.error(`Failed to get shop bytecode: ${c}`), new Error("Unable to get shop bytecode");
  }
}
async function getGasPrice(c) {
  return (await c.getGasPrice()).toBigInt();
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$2(c) {
  return c && c.__esModule && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c;
}
function getAugmentedNamespace(c) {
  if (c.__esModule) return c;
  var t = c.default;
  if (typeof t == "function") {
    var n = function ie() {
      return this instanceof ie ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(c).forEach(function(ie) {
    var fe = Object.getOwnPropertyDescriptor(c, ie);
    Object.defineProperty(n, ie, fe.get ? fe : {
      enumerable: !0,
      get: function() {
        return c[ie];
      }
    });
  }), n;
}
var bn$9 = { exports: {} }, buffer$2 = {}, base64Js$1 = {};
base64Js$1.byteLength = byteLength$1;
base64Js$1.toByteArray = toByteArray$1;
base64Js$1.fromByteArray = fromByteArray$1;
var lookup$1 = [], revLookup$1 = [], Arr$1 = typeof Uint8Array < "u" ? Uint8Array : Array, code$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$4 = 0, len$1 = code$1.length; i$4 < len$1; ++i$4)
  lookup$1[i$4] = code$1[i$4], revLookup$1[code$1.charCodeAt(i$4)] = i$4;
revLookup$1[45] = 62;
revLookup$1[95] = 63;
function getLens$1(c) {
  var t = c.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = c.indexOf("=");
  n === -1 && (n = t);
  var ie = n === t ? 0 : 4 - n % 4;
  return [n, ie];
}
function byteLength$1(c) {
  var t = getLens$1(c), n = t[0], ie = t[1];
  return (n + ie) * 3 / 4 - ie;
}
function _byteLength$1(c, t, n) {
  return (t + n) * 3 / 4 - n;
}
function toByteArray$1(c) {
  var t, n = getLens$1(c), ie = n[0], fe = n[1], ae = new Arr$1(_byteLength$1(c, ie, fe)), le = 0, he = fe > 0 ? ie - 4 : ie, me;
  for (me = 0; me < he; me += 4)
    t = revLookup$1[c.charCodeAt(me)] << 18 | revLookup$1[c.charCodeAt(me + 1)] << 12 | revLookup$1[c.charCodeAt(me + 2)] << 6 | revLookup$1[c.charCodeAt(me + 3)], ae[le++] = t >> 16 & 255, ae[le++] = t >> 8 & 255, ae[le++] = t & 255;
  return fe === 2 && (t = revLookup$1[c.charCodeAt(me)] << 2 | revLookup$1[c.charCodeAt(me + 1)] >> 4, ae[le++] = t & 255), fe === 1 && (t = revLookup$1[c.charCodeAt(me)] << 10 | revLookup$1[c.charCodeAt(me + 1)] << 4 | revLookup$1[c.charCodeAt(me + 2)] >> 2, ae[le++] = t >> 8 & 255, ae[le++] = t & 255), ae;
}
function tripletToBase64$1(c) {
  return lookup$1[c >> 18 & 63] + lookup$1[c >> 12 & 63] + lookup$1[c >> 6 & 63] + lookup$1[c & 63];
}
function encodeChunk$1(c, t, n) {
  for (var ie, fe = [], ae = t; ae < n; ae += 3)
    ie = (c[ae] << 16 & 16711680) + (c[ae + 1] << 8 & 65280) + (c[ae + 2] & 255), fe.push(tripletToBase64$1(ie));
  return fe.join("");
}
function fromByteArray$1(c) {
  for (var t, n = c.length, ie = n % 3, fe = [], ae = 16383, le = 0, he = n - ie; le < he; le += ae)
    fe.push(encodeChunk$1(c, le, le + ae > he ? he : le + ae));
  return ie === 1 ? (t = c[n - 1], fe.push(
    lookup$1[t >> 2] + lookup$1[t << 4 & 63] + "=="
  )) : ie === 2 && (t = (c[n - 2] << 8) + c[n - 1], fe.push(
    lookup$1[t >> 10] + lookup$1[t >> 4 & 63] + lookup$1[t << 2 & 63] + "="
  )), fe.join("");
}
var ieee754$1 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754$1.read = function(c, t, n, ie, fe) {
  var ae, le, he = fe * 8 - ie - 1, me = (1 << he) - 1, ye = me >> 1, be = -7, Ae = n ? fe - 1 : 0, Se = n ? -1 : 1, $e = c[t + Ae];
  for (Ae += Se, ae = $e & (1 << -be) - 1, $e >>= -be, be += he; be > 0; ae = ae * 256 + c[t + Ae], Ae += Se, be -= 8)
    ;
  for (le = ae & (1 << -be) - 1, ae >>= -be, be += ie; be > 0; le = le * 256 + c[t + Ae], Ae += Se, be -= 8)
    ;
  if (ae === 0)
    ae = 1 - ye;
  else {
    if (ae === me)
      return le ? NaN : ($e ? -1 : 1) * (1 / 0);
    le = le + Math.pow(2, ie), ae = ae - ye;
  }
  return ($e ? -1 : 1) * le * Math.pow(2, ae - ie);
};
ieee754$1.write = function(c, t, n, ie, fe, ae) {
  var le, he, me, ye = ae * 8 - fe - 1, be = (1 << ye) - 1, Ae = be >> 1, Se = fe === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, $e = ie ? 0 : ae - 1, Re = ie ? 1 : -1, Me = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (he = isNaN(t) ? 1 : 0, le = be) : (le = Math.floor(Math.log(t) / Math.LN2), t * (me = Math.pow(2, -le)) < 1 && (le--, me *= 2), le + Ae >= 1 ? t += Se / me : t += Se * Math.pow(2, 1 - Ae), t * me >= 2 && (le++, me /= 2), le + Ae >= be ? (he = 0, le = be) : le + Ae >= 1 ? (he = (t * me - 1) * Math.pow(2, fe), le = le + Ae) : (he = t * Math.pow(2, Ae - 1) * Math.pow(2, fe), le = 0)); fe >= 8; c[n + $e] = he & 255, $e += Re, he /= 256, fe -= 8)
    ;
  for (le = le << fe | he, ye += fe; ye > 0; c[n + $e] = le & 255, $e += Re, le /= 256, ye -= 8)
    ;
  c[n + $e - Re] |= Me * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(c) {
  const t = base64Js$1, n = ieee754$1, ie = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  c.Buffer = be, c.SlowBuffer = ze, c.INSPECT_MAX_BYTES = 50;
  const fe = 2147483647;
  c.kMaxLength = fe;
  const { Uint8Array: ae, ArrayBuffer: le, SharedArrayBuffer: he } = globalThis;
  be.TYPED_ARRAY_SUPPORT = me(), !be.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function me() {
    try {
      const Oe = new ae(1), Ce = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Ce, ae.prototype), Object.setPrototypeOf(Oe, Ce), Oe.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(be.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (be.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(be.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (be.isBuffer(this))
        return this.byteOffset;
    }
  });
  function ye(Oe) {
    if (Oe > fe)
      throw new RangeError('The value "' + Oe + '" is invalid for option "size"');
    const Ce = new ae(Oe);
    return Object.setPrototypeOf(Ce, be.prototype), Ce;
  }
  function be(Oe, Ce, He) {
    if (typeof Oe == "number") {
      if (typeof Ce == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Re(Oe);
    }
    return Ae(Oe, Ce, He);
  }
  be.poolSize = 8192;
  function Ae(Oe, Ce, He) {
    if (typeof Oe == "string")
      return Me(Oe, Ce);
    if (le.isView(Oe))
      return Te(Oe);
    if (Oe == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Oe
      );
    if (Dt(Oe, le) || Oe && Dt(Oe.buffer, le) || typeof he < "u" && (Dt(Oe, he) || Oe && Dt(Oe.buffer, he)))
      return Ie(Oe, Ce, He);
    if (typeof Oe == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Xe = Oe.valueOf && Oe.valueOf();
    if (Xe != null && Xe !== Oe)
      return be.from(Xe, Ce, He);
    const Kt = qe(Oe);
    if (Kt) return Kt;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Oe[Symbol.toPrimitive] == "function")
      return be.from(Oe[Symbol.toPrimitive]("string"), Ce, He);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Oe
    );
  }
  be.from = function(Oe, Ce, He) {
    return Ae(Oe, Ce, He);
  }, Object.setPrototypeOf(be.prototype, ae.prototype), Object.setPrototypeOf(be, ae);
  function Se(Oe) {
    if (typeof Oe != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Oe < 0)
      throw new RangeError('The value "' + Oe + '" is invalid for option "size"');
  }
  function $e(Oe, Ce, He) {
    return Se(Oe), Oe <= 0 ? ye(Oe) : Ce !== void 0 ? typeof He == "string" ? ye(Oe).fill(Ce, He) : ye(Oe).fill(Ce) : ye(Oe);
  }
  be.alloc = function(Oe, Ce, He) {
    return $e(Oe, Ce, He);
  };
  function Re(Oe) {
    return Se(Oe), ye(Oe < 0 ? 0 : Ue(Oe) | 0);
  }
  be.allocUnsafe = function(Oe) {
    return Re(Oe);
  }, be.allocUnsafeSlow = function(Oe) {
    return Re(Oe);
  };
  function Me(Oe, Ce) {
    if ((typeof Ce != "string" || Ce === "") && (Ce = "utf8"), !be.isEncoding(Ce))
      throw new TypeError("Unknown encoding: " + Ce);
    const He = Ve(Oe, Ce) | 0;
    let Xe = ye(He);
    const Kt = Xe.write(Oe, Ce);
    return Kt !== He && (Xe = Xe.slice(0, Kt)), Xe;
  }
  function ke(Oe) {
    const Ce = Oe.length < 0 ? 0 : Ue(Oe.length) | 0, He = ye(Ce);
    for (let Xe = 0; Xe < Ce; Xe += 1)
      He[Xe] = Oe[Xe] & 255;
    return He;
  }
  function Te(Oe) {
    if (Dt(Oe, ae)) {
      const Ce = new ae(Oe);
      return Ie(Ce.buffer, Ce.byteOffset, Ce.byteLength);
    }
    return ke(Oe);
  }
  function Ie(Oe, Ce, He) {
    if (Ce < 0 || Oe.byteLength < Ce)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Oe.byteLength < Ce + (He || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Xe;
    return Ce === void 0 && He === void 0 ? Xe = new ae(Oe) : He === void 0 ? Xe = new ae(Oe, Ce) : Xe = new ae(Oe, Ce, He), Object.setPrototypeOf(Xe, be.prototype), Xe;
  }
  function qe(Oe) {
    if (be.isBuffer(Oe)) {
      const Ce = Ue(Oe.length) | 0, He = ye(Ce);
      return He.length === 0 || Oe.copy(He, 0, 0, Ce), He;
    }
    if (Oe.length !== void 0)
      return typeof Oe.length != "number" || en(Oe.length) ? ye(0) : ke(Oe);
    if (Oe.type === "Buffer" && Array.isArray(Oe.data))
      return ke(Oe.data);
  }
  function Ue(Oe) {
    if (Oe >= fe)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + fe.toString(16) + " bytes");
    return Oe | 0;
  }
  function ze(Oe) {
    return +Oe != Oe && (Oe = 0), be.alloc(+Oe);
  }
  be.isBuffer = function(Ce) {
    return Ce != null && Ce._isBuffer === !0 && Ce !== be.prototype;
  }, be.compare = function(Ce, He) {
    if (Dt(Ce, ae) && (Ce = be.from(Ce, Ce.offset, Ce.byteLength)), Dt(He, ae) && (He = be.from(He, He.offset, He.byteLength)), !be.isBuffer(Ce) || !be.isBuffer(He))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Ce === He) return 0;
    let Xe = Ce.length, Kt = He.length;
    for (let tn = 0, Wt = Math.min(Xe, Kt); tn < Wt; ++tn)
      if (Ce[tn] !== He[tn]) {
        Xe = Ce[tn], Kt = He[tn];
        break;
      }
    return Xe < Kt ? -1 : Kt < Xe ? 1 : 0;
  }, be.isEncoding = function(Ce) {
    switch (String(Ce).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, be.concat = function(Ce, He) {
    if (!Array.isArray(Ce))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Ce.length === 0)
      return be.alloc(0);
    let Xe;
    if (He === void 0)
      for (He = 0, Xe = 0; Xe < Ce.length; ++Xe)
        He += Ce[Xe].length;
    const Kt = be.allocUnsafe(He);
    let tn = 0;
    for (Xe = 0; Xe < Ce.length; ++Xe) {
      let Wt = Ce[Xe];
      if (Dt(Wt, ae))
        tn + Wt.length > Kt.length ? (be.isBuffer(Wt) || (Wt = be.from(Wt)), Wt.copy(Kt, tn)) : ae.prototype.set.call(
          Kt,
          Wt,
          tn
        );
      else if (be.isBuffer(Wt))
        Wt.copy(Kt, tn);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      tn += Wt.length;
    }
    return Kt;
  };
  function Ve(Oe, Ce) {
    if (be.isBuffer(Oe))
      return Oe.length;
    if (le.isView(Oe) || Dt(Oe, le))
      return Oe.byteLength;
    if (typeof Oe != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Oe
      );
    const He = Oe.length, Xe = arguments.length > 2 && arguments[2] === !0;
    if (!Xe && He === 0) return 0;
    let Kt = !1;
    for (; ; )
      switch (Ce) {
        case "ascii":
        case "latin1":
        case "binary":
          return He;
        case "utf8":
        case "utf-8":
          return An(Oe).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return He * 2;
        case "hex":
          return He >>> 1;
        case "base64":
          return wn(Oe).length;
        default:
          if (Kt)
            return Xe ? -1 : An(Oe).length;
          Ce = ("" + Ce).toLowerCase(), Kt = !0;
      }
  }
  be.byteLength = Ve;
  function Mt(Oe, Ce, He) {
    let Xe = !1;
    if ((Ce === void 0 || Ce < 0) && (Ce = 0), Ce > this.length || ((He === void 0 || He > this.length) && (He = this.length), He <= 0) || (He >>>= 0, Ce >>>= 0, He <= Ce))
      return "";
    for (Oe || (Oe = "utf8"); ; )
      switch (Oe) {
        case "hex":
          return Be(this, Ce, He);
        case "utf8":
        case "utf-8":
          return we(this, Ce, He);
        case "ascii":
          return ue(this, Ce, He);
        case "latin1":
        case "binary":
          return ge(this, Ce, He);
        case "base64":
          return ve(this, Ce, He);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ne(this, Ce, He);
        default:
          if (Xe) throw new TypeError("Unknown encoding: " + Oe);
          Oe = (Oe + "").toLowerCase(), Xe = !0;
      }
  }
  be.prototype._isBuffer = !0;
  function Rt(Oe, Ce, He) {
    const Xe = Oe[Ce];
    Oe[Ce] = Oe[He], Oe[He] = Xe;
  }
  be.prototype.swap16 = function() {
    const Ce = this.length;
    if (Ce % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let He = 0; He < Ce; He += 2)
      Rt(this, He, He + 1);
    return this;
  }, be.prototype.swap32 = function() {
    const Ce = this.length;
    if (Ce % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let He = 0; He < Ce; He += 4)
      Rt(this, He, He + 3), Rt(this, He + 1, He + 2);
    return this;
  }, be.prototype.swap64 = function() {
    const Ce = this.length;
    if (Ce % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let He = 0; He < Ce; He += 8)
      Rt(this, He, He + 7), Rt(this, He + 1, He + 6), Rt(this, He + 2, He + 5), Rt(this, He + 3, He + 4);
    return this;
  }, be.prototype.toString = function() {
    const Ce = this.length;
    return Ce === 0 ? "" : arguments.length === 0 ? we(this, 0, Ce) : Mt.apply(this, arguments);
  }, be.prototype.toLocaleString = be.prototype.toString, be.prototype.equals = function(Ce) {
    if (!be.isBuffer(Ce)) throw new TypeError("Argument must be a Buffer");
    return this === Ce ? !0 : be.compare(this, Ce) === 0;
  }, be.prototype.inspect = function() {
    let Ce = "";
    const He = c.INSPECT_MAX_BYTES;
    return Ce = this.toString("hex", 0, He).replace(/(.{2})/g, "$1 ").trim(), this.length > He && (Ce += " ... "), "<Buffer " + Ce + ">";
  }, ie && (be.prototype[ie] = be.prototype.inspect), be.prototype.compare = function(Ce, He, Xe, Kt, tn) {
    if (Dt(Ce, ae) && (Ce = be.from(Ce, Ce.offset, Ce.byteLength)), !be.isBuffer(Ce))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Ce
      );
    if (He === void 0 && (He = 0), Xe === void 0 && (Xe = Ce ? Ce.length : 0), Kt === void 0 && (Kt = 0), tn === void 0 && (tn = this.length), He < 0 || Xe > Ce.length || Kt < 0 || tn > this.length)
      throw new RangeError("out of range index");
    if (Kt >= tn && He >= Xe)
      return 0;
    if (Kt >= tn)
      return -1;
    if (He >= Xe)
      return 1;
    if (He >>>= 0, Xe >>>= 0, Kt >>>= 0, tn >>>= 0, this === Ce) return 0;
    let Wt = tn - Kt, Yt = Xe - He;
    const _n = Math.min(Wt, Yt), rn = this.slice(Kt, tn), nn = Ce.slice(He, Xe);
    for (let En = 0; En < _n; ++En)
      if (rn[En] !== nn[En]) {
        Wt = rn[En], Yt = nn[En];
        break;
      }
    return Wt < Yt ? -1 : Yt < Wt ? 1 : 0;
  };
  function je(Oe, Ce, He, Xe, Kt) {
    if (Oe.length === 0) return -1;
    if (typeof He == "string" ? (Xe = He, He = 0) : He > 2147483647 ? He = 2147483647 : He < -2147483648 && (He = -2147483648), He = +He, en(He) && (He = Kt ? 0 : Oe.length - 1), He < 0 && (He = Oe.length + He), He >= Oe.length) {
      if (Kt) return -1;
      He = Oe.length - 1;
    } else if (He < 0)
      if (Kt) He = 0;
      else return -1;
    if (typeof Ce == "string" && (Ce = be.from(Ce, Xe)), be.isBuffer(Ce))
      return Ce.length === 0 ? -1 : jt(Oe, Ce, He, Xe, Kt);
    if (typeof Ce == "number")
      return Ce = Ce & 255, typeof ae.prototype.indexOf == "function" ? Kt ? ae.prototype.indexOf.call(Oe, Ce, He) : ae.prototype.lastIndexOf.call(Oe, Ce, He) : jt(Oe, [Ce], He, Xe, Kt);
    throw new TypeError("val must be string, number or Buffer");
  }
  function jt(Oe, Ce, He, Xe, Kt) {
    let tn = 1, Wt = Oe.length, Yt = Ce.length;
    if (Xe !== void 0 && (Xe = String(Xe).toLowerCase(), Xe === "ucs2" || Xe === "ucs-2" || Xe === "utf16le" || Xe === "utf-16le")) {
      if (Oe.length < 2 || Ce.length < 2)
        return -1;
      tn = 2, Wt /= 2, Yt /= 2, He /= 2;
    }
    function _n(nn, En) {
      return tn === 1 ? nn[En] : nn.readUInt16BE(En * tn);
    }
    let rn;
    if (Kt) {
      let nn = -1;
      for (rn = He; rn < Wt; rn++)
        if (_n(Oe, rn) === _n(Ce, nn === -1 ? 0 : rn - nn)) {
          if (nn === -1 && (nn = rn), rn - nn + 1 === Yt) return nn * tn;
        } else
          nn !== -1 && (rn -= rn - nn), nn = -1;
    } else
      for (He + Yt > Wt && (He = Wt - Yt), rn = He; rn >= 0; rn--) {
        let nn = !0;
        for (let En = 0; En < Yt; En++)
          if (_n(Oe, rn + En) !== _n(Ce, En)) {
            nn = !1;
            break;
          }
        if (nn) return rn;
      }
    return -1;
  }
  be.prototype.includes = function(Ce, He, Xe) {
    return this.indexOf(Ce, He, Xe) !== -1;
  }, be.prototype.indexOf = function(Ce, He, Xe) {
    return je(this, Ce, He, Xe, !0);
  }, be.prototype.lastIndexOf = function(Ce, He, Xe) {
    return je(this, Ce, He, Xe, !1);
  };
  function _e(Oe, Ce, He, Xe) {
    He = Number(He) || 0;
    const Kt = Oe.length - He;
    Xe ? (Xe = Number(Xe), Xe > Kt && (Xe = Kt)) : Xe = Kt;
    const tn = Ce.length;
    Xe > tn / 2 && (Xe = tn / 2);
    let Wt;
    for (Wt = 0; Wt < Xe; ++Wt) {
      const Yt = parseInt(Ce.substr(Wt * 2, 2), 16);
      if (en(Yt)) return Wt;
      Oe[He + Wt] = Yt;
    }
    return Wt;
  }
  function se(Oe, Ce, He, Xe) {
    return Qe(An(Ce, Oe.length - He), Oe, He, Xe);
  }
  function ce(Oe, Ce, He, Xe) {
    return Qe(Qt(Ce), Oe, He, Xe);
  }
  function de(Oe, Ce, He, Xe) {
    return Qe(wn(Ce), Oe, He, Xe);
  }
  function pe(Oe, Ce, He, Xe) {
    return Qe(Xt(Ce, Oe.length - He), Oe, He, Xe);
  }
  be.prototype.write = function(Ce, He, Xe, Kt) {
    if (He === void 0)
      Kt = "utf8", Xe = this.length, He = 0;
    else if (Xe === void 0 && typeof He == "string")
      Kt = He, Xe = this.length, He = 0;
    else if (isFinite(He))
      He = He >>> 0, isFinite(Xe) ? (Xe = Xe >>> 0, Kt === void 0 && (Kt = "utf8")) : (Kt = Xe, Xe = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const tn = this.length - He;
    if ((Xe === void 0 || Xe > tn) && (Xe = tn), Ce.length > 0 && (Xe < 0 || He < 0) || He > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Kt || (Kt = "utf8");
    let Wt = !1;
    for (; ; )
      switch (Kt) {
        case "hex":
          return _e(this, Ce, He, Xe);
        case "utf8":
        case "utf-8":
          return se(this, Ce, He, Xe);
        case "ascii":
        case "latin1":
        case "binary":
          return ce(this, Ce, He, Xe);
        case "base64":
          return de(this, Ce, He, Xe);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return pe(this, Ce, He, Xe);
        default:
          if (Wt) throw new TypeError("Unknown encoding: " + Kt);
          Kt = ("" + Kt).toLowerCase(), Wt = !0;
      }
  }, be.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ve(Oe, Ce, He) {
    return Ce === 0 && He === Oe.length ? t.fromByteArray(Oe) : t.fromByteArray(Oe.slice(Ce, He));
  }
  function we(Oe, Ce, He) {
    He = Math.min(Oe.length, He);
    const Xe = [];
    let Kt = Ce;
    for (; Kt < He; ) {
      const tn = Oe[Kt];
      let Wt = null, Yt = tn > 239 ? 4 : tn > 223 ? 3 : tn > 191 ? 2 : 1;
      if (Kt + Yt <= He) {
        let _n, rn, nn, En;
        switch (Yt) {
          case 1:
            tn < 128 && (Wt = tn);
            break;
          case 2:
            _n = Oe[Kt + 1], (_n & 192) === 128 && (En = (tn & 31) << 6 | _n & 63, En > 127 && (Wt = En));
            break;
          case 3:
            _n = Oe[Kt + 1], rn = Oe[Kt + 2], (_n & 192) === 128 && (rn & 192) === 128 && (En = (tn & 15) << 12 | (_n & 63) << 6 | rn & 63, En > 2047 && (En < 55296 || En > 57343) && (Wt = En));
            break;
          case 4:
            _n = Oe[Kt + 1], rn = Oe[Kt + 2], nn = Oe[Kt + 3], (_n & 192) === 128 && (rn & 192) === 128 && (nn & 192) === 128 && (En = (tn & 15) << 18 | (_n & 63) << 12 | (rn & 63) << 6 | nn & 63, En > 65535 && En < 1114112 && (Wt = En));
        }
      }
      Wt === null ? (Wt = 65533, Yt = 1) : Wt > 65535 && (Wt -= 65536, Xe.push(Wt >>> 10 & 1023 | 55296), Wt = 56320 | Wt & 1023), Xe.push(Wt), Kt += Yt;
    }
    return xe(Xe);
  }
  const Ee = 4096;
  function xe(Oe) {
    const Ce = Oe.length;
    if (Ce <= Ee)
      return String.fromCharCode.apply(String, Oe);
    let He = "", Xe = 0;
    for (; Xe < Ce; )
      He += String.fromCharCode.apply(
        String,
        Oe.slice(Xe, Xe += Ee)
      );
    return He;
  }
  function ue(Oe, Ce, He) {
    let Xe = "";
    He = Math.min(Oe.length, He);
    for (let Kt = Ce; Kt < He; ++Kt)
      Xe += String.fromCharCode(Oe[Kt] & 127);
    return Xe;
  }
  function ge(Oe, Ce, He) {
    let Xe = "";
    He = Math.min(Oe.length, He);
    for (let Kt = Ce; Kt < He; ++Kt)
      Xe += String.fromCharCode(Oe[Kt]);
    return Xe;
  }
  function Be(Oe, Ce, He) {
    const Xe = Oe.length;
    (!Ce || Ce < 0) && (Ce = 0), (!He || He < 0 || He > Xe) && (He = Xe);
    let Kt = "";
    for (let tn = Ce; tn < He; ++tn)
      Kt += We[Oe[tn]];
    return Kt;
  }
  function Ne(Oe, Ce, He) {
    const Xe = Oe.slice(Ce, He);
    let Kt = "";
    for (let tn = 0; tn < Xe.length - 1; tn += 2)
      Kt += String.fromCharCode(Xe[tn] + Xe[tn + 1] * 256);
    return Kt;
  }
  be.prototype.slice = function(Ce, He) {
    const Xe = this.length;
    Ce = ~~Ce, He = He === void 0 ? Xe : ~~He, Ce < 0 ? (Ce += Xe, Ce < 0 && (Ce = 0)) : Ce > Xe && (Ce = Xe), He < 0 ? (He += Xe, He < 0 && (He = 0)) : He > Xe && (He = Xe), He < Ce && (He = Ce);
    const Kt = this.subarray(Ce, He);
    return Object.setPrototypeOf(Kt, be.prototype), Kt;
  };
  function Fe(Oe, Ce, He) {
    if (Oe % 1 !== 0 || Oe < 0) throw new RangeError("offset is not uint");
    if (Oe + Ce > He) throw new RangeError("Trying to access beyond buffer length");
  }
  be.prototype.readUintLE = be.prototype.readUIntLE = function(Ce, He, Xe) {
    Ce = Ce >>> 0, He = He >>> 0, Xe || Fe(Ce, He, this.length);
    let Kt = this[Ce], tn = 1, Wt = 0;
    for (; ++Wt < He && (tn *= 256); )
      Kt += this[Ce + Wt] * tn;
    return Kt;
  }, be.prototype.readUintBE = be.prototype.readUIntBE = function(Ce, He, Xe) {
    Ce = Ce >>> 0, He = He >>> 0, Xe || Fe(Ce, He, this.length);
    let Kt = this[Ce + --He], tn = 1;
    for (; He > 0 && (tn *= 256); )
      Kt += this[Ce + --He] * tn;
    return Kt;
  }, be.prototype.readUint8 = be.prototype.readUInt8 = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 1, this.length), this[Ce];
  }, be.prototype.readUint16LE = be.prototype.readUInt16LE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 2, this.length), this[Ce] | this[Ce + 1] << 8;
  }, be.prototype.readUint16BE = be.prototype.readUInt16BE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 2, this.length), this[Ce] << 8 | this[Ce + 1];
  }, be.prototype.readUint32LE = be.prototype.readUInt32LE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), (this[Ce] | this[Ce + 1] << 8 | this[Ce + 2] << 16) + this[Ce + 3] * 16777216;
  }, be.prototype.readUint32BE = be.prototype.readUInt32BE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), this[Ce] * 16777216 + (this[Ce + 1] << 16 | this[Ce + 2] << 8 | this[Ce + 3]);
  }, be.prototype.readBigUInt64LE = De(function(Ce) {
    Ce = Ce >>> 0, Vt(Ce, "offset");
    const He = this[Ce], Xe = this[Ce + 7];
    (He === void 0 || Xe === void 0) && xn(Ce, this.length - 8);
    const Kt = He + this[++Ce] * 2 ** 8 + this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 24, tn = this[++Ce] + this[++Ce] * 2 ** 8 + this[++Ce] * 2 ** 16 + Xe * 2 ** 24;
    return BigInt(Kt) + (BigInt(tn) << BigInt(32));
  }), be.prototype.readBigUInt64BE = De(function(Ce) {
    Ce = Ce >>> 0, Vt(Ce, "offset");
    const He = this[Ce], Xe = this[Ce + 7];
    (He === void 0 || Xe === void 0) && xn(Ce, this.length - 8);
    const Kt = He * 2 ** 24 + this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 8 + this[++Ce], tn = this[++Ce] * 2 ** 24 + this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 8 + Xe;
    return (BigInt(Kt) << BigInt(32)) + BigInt(tn);
  }), be.prototype.readIntLE = function(Ce, He, Xe) {
    Ce = Ce >>> 0, He = He >>> 0, Xe || Fe(Ce, He, this.length);
    let Kt = this[Ce], tn = 1, Wt = 0;
    for (; ++Wt < He && (tn *= 256); )
      Kt += this[Ce + Wt] * tn;
    return tn *= 128, Kt >= tn && (Kt -= Math.pow(2, 8 * He)), Kt;
  }, be.prototype.readIntBE = function(Ce, He, Xe) {
    Ce = Ce >>> 0, He = He >>> 0, Xe || Fe(Ce, He, this.length);
    let Kt = He, tn = 1, Wt = this[Ce + --Kt];
    for (; Kt > 0 && (tn *= 256); )
      Wt += this[Ce + --Kt] * tn;
    return tn *= 128, Wt >= tn && (Wt -= Math.pow(2, 8 * He)), Wt;
  }, be.prototype.readInt8 = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 1, this.length), this[Ce] & 128 ? (255 - this[Ce] + 1) * -1 : this[Ce];
  }, be.prototype.readInt16LE = function(Ce, He) {
    Ce = Ce >>> 0, He || Fe(Ce, 2, this.length);
    const Xe = this[Ce] | this[Ce + 1] << 8;
    return Xe & 32768 ? Xe | 4294901760 : Xe;
  }, be.prototype.readInt16BE = function(Ce, He) {
    Ce = Ce >>> 0, He || Fe(Ce, 2, this.length);
    const Xe = this[Ce + 1] | this[Ce] << 8;
    return Xe & 32768 ? Xe | 4294901760 : Xe;
  }, be.prototype.readInt32LE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), this[Ce] | this[Ce + 1] << 8 | this[Ce + 2] << 16 | this[Ce + 3] << 24;
  }, be.prototype.readInt32BE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), this[Ce] << 24 | this[Ce + 1] << 16 | this[Ce + 2] << 8 | this[Ce + 3];
  }, be.prototype.readBigInt64LE = De(function(Ce) {
    Ce = Ce >>> 0, Vt(Ce, "offset");
    const He = this[Ce], Xe = this[Ce + 7];
    (He === void 0 || Xe === void 0) && xn(Ce, this.length - 8);
    const Kt = this[Ce + 4] + this[Ce + 5] * 2 ** 8 + this[Ce + 6] * 2 ** 16 + (Xe << 24);
    return (BigInt(Kt) << BigInt(32)) + BigInt(He + this[++Ce] * 2 ** 8 + this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 24);
  }), be.prototype.readBigInt64BE = De(function(Ce) {
    Ce = Ce >>> 0, Vt(Ce, "offset");
    const He = this[Ce], Xe = this[Ce + 7];
    (He === void 0 || Xe === void 0) && xn(Ce, this.length - 8);
    const Kt = (He << 24) + // Overflow
    this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 8 + this[++Ce];
    return (BigInt(Kt) << BigInt(32)) + BigInt(this[++Ce] * 2 ** 24 + this[++Ce] * 2 ** 16 + this[++Ce] * 2 ** 8 + Xe);
  }), be.prototype.readFloatLE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), n.read(this, Ce, !0, 23, 4);
  }, be.prototype.readFloatBE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 4, this.length), n.read(this, Ce, !1, 23, 4);
  }, be.prototype.readDoubleLE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 8, this.length), n.read(this, Ce, !0, 52, 8);
  }, be.prototype.readDoubleBE = function(Ce, He) {
    return Ce = Ce >>> 0, He || Fe(Ce, 8, this.length), n.read(this, Ce, !1, 52, 8);
  };
  function Pe(Oe, Ce, He, Xe, Kt, tn) {
    if (!be.isBuffer(Oe)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Ce > Kt || Ce < tn) throw new RangeError('"value" argument is out of bounds');
    if (He + Xe > Oe.length) throw new RangeError("Index out of range");
  }
  be.prototype.writeUintLE = be.prototype.writeUIntLE = function(Ce, He, Xe, Kt) {
    if (Ce = +Ce, He = He >>> 0, Xe = Xe >>> 0, !Kt) {
      const Yt = Math.pow(2, 8 * Xe) - 1;
      Pe(this, Ce, He, Xe, Yt, 0);
    }
    let tn = 1, Wt = 0;
    for (this[He] = Ce & 255; ++Wt < Xe && (tn *= 256); )
      this[He + Wt] = Ce / tn & 255;
    return He + Xe;
  }, be.prototype.writeUintBE = be.prototype.writeUIntBE = function(Ce, He, Xe, Kt) {
    if (Ce = +Ce, He = He >>> 0, Xe = Xe >>> 0, !Kt) {
      const Yt = Math.pow(2, 8 * Xe) - 1;
      Pe(this, Ce, He, Xe, Yt, 0);
    }
    let tn = Xe - 1, Wt = 1;
    for (this[He + tn] = Ce & 255; --tn >= 0 && (Wt *= 256); )
      this[He + tn] = Ce / Wt & 255;
    return He + Xe;
  }, be.prototype.writeUint8 = be.prototype.writeUInt8 = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 1, 255, 0), this[He] = Ce & 255, He + 1;
  }, be.prototype.writeUint16LE = be.prototype.writeUInt16LE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 2, 65535, 0), this[He] = Ce & 255, this[He + 1] = Ce >>> 8, He + 2;
  }, be.prototype.writeUint16BE = be.prototype.writeUInt16BE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 2, 65535, 0), this[He] = Ce >>> 8, this[He + 1] = Ce & 255, He + 2;
  }, be.prototype.writeUint32LE = be.prototype.writeUInt32LE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 4, 4294967295, 0), this[He + 3] = Ce >>> 24, this[He + 2] = Ce >>> 16, this[He + 1] = Ce >>> 8, this[He] = Ce & 255, He + 4;
  }, be.prototype.writeUint32BE = be.prototype.writeUInt32BE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 4, 4294967295, 0), this[He] = Ce >>> 24, this[He + 1] = Ce >>> 16, this[He + 2] = Ce >>> 8, this[He + 3] = Ce & 255, He + 4;
  };
  function Je(Oe, Ce, He, Xe, Kt) {
    Ht(Ce, Xe, Kt, Oe, He, 7);
    let tn = Number(Ce & BigInt(4294967295));
    Oe[He++] = tn, tn = tn >> 8, Oe[He++] = tn, tn = tn >> 8, Oe[He++] = tn, tn = tn >> 8, Oe[He++] = tn;
    let Wt = Number(Ce >> BigInt(32) & BigInt(4294967295));
    return Oe[He++] = Wt, Wt = Wt >> 8, Oe[He++] = Wt, Wt = Wt >> 8, Oe[He++] = Wt, Wt = Wt >> 8, Oe[He++] = Wt, He;
  }
  function Ke(Oe, Ce, He, Xe, Kt) {
    Ht(Ce, Xe, Kt, Oe, He, 7);
    let tn = Number(Ce & BigInt(4294967295));
    Oe[He + 7] = tn, tn = tn >> 8, Oe[He + 6] = tn, tn = tn >> 8, Oe[He + 5] = tn, tn = tn >> 8, Oe[He + 4] = tn;
    let Wt = Number(Ce >> BigInt(32) & BigInt(4294967295));
    return Oe[He + 3] = Wt, Wt = Wt >> 8, Oe[He + 2] = Wt, Wt = Wt >> 8, Oe[He + 1] = Wt, Wt = Wt >> 8, Oe[He] = Wt, He + 8;
  }
  be.prototype.writeBigUInt64LE = De(function(Ce, He = 0) {
    return Je(this, Ce, He, BigInt(0), BigInt("0xffffffffffffffff"));
  }), be.prototype.writeBigUInt64BE = De(function(Ce, He = 0) {
    return Ke(this, Ce, He, BigInt(0), BigInt("0xffffffffffffffff"));
  }), be.prototype.writeIntLE = function(Ce, He, Xe, Kt) {
    if (Ce = +Ce, He = He >>> 0, !Kt) {
      const _n = Math.pow(2, 8 * Xe - 1);
      Pe(this, Ce, He, Xe, _n - 1, -_n);
    }
    let tn = 0, Wt = 1, Yt = 0;
    for (this[He] = Ce & 255; ++tn < Xe && (Wt *= 256); )
      Ce < 0 && Yt === 0 && this[He + tn - 1] !== 0 && (Yt = 1), this[He + tn] = (Ce / Wt >> 0) - Yt & 255;
    return He + Xe;
  }, be.prototype.writeIntBE = function(Ce, He, Xe, Kt) {
    if (Ce = +Ce, He = He >>> 0, !Kt) {
      const _n = Math.pow(2, 8 * Xe - 1);
      Pe(this, Ce, He, Xe, _n - 1, -_n);
    }
    let tn = Xe - 1, Wt = 1, Yt = 0;
    for (this[He + tn] = Ce & 255; --tn >= 0 && (Wt *= 256); )
      Ce < 0 && Yt === 0 && this[He + tn + 1] !== 0 && (Yt = 1), this[He + tn] = (Ce / Wt >> 0) - Yt & 255;
    return He + Xe;
  }, be.prototype.writeInt8 = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 1, 127, -128), Ce < 0 && (Ce = 255 + Ce + 1), this[He] = Ce & 255, He + 1;
  }, be.prototype.writeInt16LE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 2, 32767, -32768), this[He] = Ce & 255, this[He + 1] = Ce >>> 8, He + 2;
  }, be.prototype.writeInt16BE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 2, 32767, -32768), this[He] = Ce >>> 8, this[He + 1] = Ce & 255, He + 2;
  }, be.prototype.writeInt32LE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 4, 2147483647, -2147483648), this[He] = Ce & 255, this[He + 1] = Ce >>> 8, this[He + 2] = Ce >>> 16, this[He + 3] = Ce >>> 24, He + 4;
  }, be.prototype.writeInt32BE = function(Ce, He, Xe) {
    return Ce = +Ce, He = He >>> 0, Xe || Pe(this, Ce, He, 4, 2147483647, -2147483648), Ce < 0 && (Ce = 4294967295 + Ce + 1), this[He] = Ce >>> 24, this[He + 1] = Ce >>> 16, this[He + 2] = Ce >>> 8, this[He + 3] = Ce & 255, He + 4;
  }, be.prototype.writeBigInt64LE = De(function(Ce, He = 0) {
    return Je(this, Ce, He, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), be.prototype.writeBigInt64BE = De(function(Ce, He = 0) {
    return Ke(this, Ce, He, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Ze(Oe, Ce, He, Xe, Kt, tn) {
    if (He + Xe > Oe.length) throw new RangeError("Index out of range");
    if (He < 0) throw new RangeError("Index out of range");
  }
  function Ye(Oe, Ce, He, Xe, Kt) {
    return Ce = +Ce, He = He >>> 0, Kt || Ze(Oe, Ce, He, 4), n.write(Oe, Ce, He, Xe, 23, 4), He + 4;
  }
  be.prototype.writeFloatLE = function(Ce, He, Xe) {
    return Ye(this, Ce, He, !0, Xe);
  }, be.prototype.writeFloatBE = function(Ce, He, Xe) {
    return Ye(this, Ce, He, !1, Xe);
  };
  function Pt(Oe, Ce, He, Xe, Kt) {
    return Ce = +Ce, He = He >>> 0, Kt || Ze(Oe, Ce, He, 8), n.write(Oe, Ce, He, Xe, 52, 8), He + 8;
  }
  be.prototype.writeDoubleLE = function(Ce, He, Xe) {
    return Pt(this, Ce, He, !0, Xe);
  }, be.prototype.writeDoubleBE = function(Ce, He, Xe) {
    return Pt(this, Ce, He, !1, Xe);
  }, be.prototype.copy = function(Ce, He, Xe, Kt) {
    if (!be.isBuffer(Ce)) throw new TypeError("argument should be a Buffer");
    if (Xe || (Xe = 0), !Kt && Kt !== 0 && (Kt = this.length), He >= Ce.length && (He = Ce.length), He || (He = 0), Kt > 0 && Kt < Xe && (Kt = Xe), Kt === Xe || Ce.length === 0 || this.length === 0) return 0;
    if (He < 0)
      throw new RangeError("targetStart out of bounds");
    if (Xe < 0 || Xe >= this.length) throw new RangeError("Index out of range");
    if (Kt < 0) throw new RangeError("sourceEnd out of bounds");
    Kt > this.length && (Kt = this.length), Ce.length - He < Kt - Xe && (Kt = Ce.length - He + Xe);
    const tn = Kt - Xe;
    return this === Ce && typeof ae.prototype.copyWithin == "function" ? this.copyWithin(He, Xe, Kt) : ae.prototype.set.call(
      Ce,
      this.subarray(Xe, Kt),
      He
    ), tn;
  }, be.prototype.fill = function(Ce, He, Xe, Kt) {
    if (typeof Ce == "string") {
      if (typeof He == "string" ? (Kt = He, He = 0, Xe = this.length) : typeof Xe == "string" && (Kt = Xe, Xe = this.length), Kt !== void 0 && typeof Kt != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Kt == "string" && !be.isEncoding(Kt))
        throw new TypeError("Unknown encoding: " + Kt);
      if (Ce.length === 1) {
        const Wt = Ce.charCodeAt(0);
        (Kt === "utf8" && Wt < 128 || Kt === "latin1") && (Ce = Wt);
      }
    } else typeof Ce == "number" ? Ce = Ce & 255 : typeof Ce == "boolean" && (Ce = Number(Ce));
    if (He < 0 || this.length < He || this.length < Xe)
      throw new RangeError("Out of range index");
    if (Xe <= He)
      return this;
    He = He >>> 0, Xe = Xe === void 0 ? this.length : Xe >>> 0, Ce || (Ce = 0);
    let tn;
    if (typeof Ce == "number")
      for (tn = He; tn < Xe; ++tn)
        this[tn] = Ce;
    else {
      const Wt = be.isBuffer(Ce) ? Ce : be.from(Ce, Kt), Yt = Wt.length;
      if (Yt === 0)
        throw new TypeError('The value "' + Ce + '" is invalid for argument "value"');
      for (tn = 0; tn < Xe - He; ++tn)
        this[tn + He] = Wt[tn % Yt];
    }
    return this;
  };
  const Ft = {};
  function Le(Oe, Ce, He) {
    Ft[Oe] = class extends He {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Ce.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Oe}]`, this.stack, delete this.name;
      }
      get code() {
        return Oe;
      }
      set code(Kt) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Kt,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Oe}]: ${this.message}`;
      }
    };
  }
  Le(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Oe) {
      return Oe ? `${Oe} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Le(
    "ERR_INVALID_ARG_TYPE",
    function(Oe, Ce) {
      return `The "${Oe}" argument must be of type number. Received type ${typeof Ce}`;
    },
    TypeError
  ), Le(
    "ERR_OUT_OF_RANGE",
    function(Oe, Ce, He) {
      let Xe = `The value of "${Oe}" is out of range.`, Kt = He;
      return Number.isInteger(He) && Math.abs(He) > 2 ** 32 ? Kt = $t(String(He)) : typeof He == "bigint" && (Kt = String(He), (He > BigInt(2) ** BigInt(32) || He < -(BigInt(2) ** BigInt(32))) && (Kt = $t(Kt)), Kt += "n"), Xe += ` It must be ${Ce}. Received ${Kt}`, Xe;
    },
    RangeError
  );
  function $t(Oe) {
    let Ce = "", He = Oe.length;
    const Xe = Oe[0] === "-" ? 1 : 0;
    for (; He >= Xe + 4; He -= 3)
      Ce = `_${Oe.slice(He - 3, He)}${Ce}`;
    return `${Oe.slice(0, He)}${Ce}`;
  }
  function Jt(Oe, Ce, He) {
    Vt(Ce, "offset"), (Oe[Ce] === void 0 || Oe[Ce + He] === void 0) && xn(Ce, Oe.length - (He + 1));
  }
  function Ht(Oe, Ce, He, Xe, Kt, tn) {
    if (Oe > He || Oe < Ce) {
      const Wt = typeof Ce == "bigint" ? "n" : "";
      let Yt;
      throw Ce === 0 || Ce === BigInt(0) ? Yt = `>= 0${Wt} and < 2${Wt} ** ${(tn + 1) * 8}${Wt}` : Yt = `>= -(2${Wt} ** ${(tn + 1) * 8 - 1}${Wt}) and < 2 ** ${(tn + 1) * 8 - 1}${Wt}`, new Ft.ERR_OUT_OF_RANGE("value", Yt, Oe);
    }
    Jt(Xe, Kt, tn);
  }
  function Vt(Oe, Ce) {
    if (typeof Oe != "number")
      throw new Ft.ERR_INVALID_ARG_TYPE(Ce, "number", Oe);
  }
  function xn(Oe, Ce, He) {
    throw Math.floor(Oe) !== Oe ? (Vt(Oe, He), new Ft.ERR_OUT_OF_RANGE("offset", "an integer", Oe)) : Ce < 0 ? new Ft.ERR_BUFFER_OUT_OF_BOUNDS() : new Ft.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Ce}`,
      Oe
    );
  }
  const Zt = /[^+/0-9A-Za-z-_]/g;
  function Gt(Oe) {
    if (Oe = Oe.split("=")[0], Oe = Oe.trim().replace(Zt, ""), Oe.length < 2) return "";
    for (; Oe.length % 4 !== 0; )
      Oe = Oe + "=";
    return Oe;
  }
  function An(Oe, Ce) {
    Ce = Ce || 1 / 0;
    let He;
    const Xe = Oe.length;
    let Kt = null;
    const tn = [];
    for (let Wt = 0; Wt < Xe; ++Wt) {
      if (He = Oe.charCodeAt(Wt), He > 55295 && He < 57344) {
        if (!Kt) {
          if (He > 56319) {
            (Ce -= 3) > -1 && tn.push(239, 191, 189);
            continue;
          } else if (Wt + 1 === Xe) {
            (Ce -= 3) > -1 && tn.push(239, 191, 189);
            continue;
          }
          Kt = He;
          continue;
        }
        if (He < 56320) {
          (Ce -= 3) > -1 && tn.push(239, 191, 189), Kt = He;
          continue;
        }
        He = (Kt - 55296 << 10 | He - 56320) + 65536;
      } else Kt && (Ce -= 3) > -1 && tn.push(239, 191, 189);
      if (Kt = null, He < 128) {
        if ((Ce -= 1) < 0) break;
        tn.push(He);
      } else if (He < 2048) {
        if ((Ce -= 2) < 0) break;
        tn.push(
          He >> 6 | 192,
          He & 63 | 128
        );
      } else if (He < 65536) {
        if ((Ce -= 3) < 0) break;
        tn.push(
          He >> 12 | 224,
          He >> 6 & 63 | 128,
          He & 63 | 128
        );
      } else if (He < 1114112) {
        if ((Ce -= 4) < 0) break;
        tn.push(
          He >> 18 | 240,
          He >> 12 & 63 | 128,
          He >> 6 & 63 | 128,
          He & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return tn;
  }
  function Qt(Oe) {
    const Ce = [];
    for (let He = 0; He < Oe.length; ++He)
      Ce.push(Oe.charCodeAt(He) & 255);
    return Ce;
  }
  function Xt(Oe, Ce) {
    let He, Xe, Kt;
    const tn = [];
    for (let Wt = 0; Wt < Oe.length && !((Ce -= 2) < 0); ++Wt)
      He = Oe.charCodeAt(Wt), Xe = He >> 8, Kt = He % 256, tn.push(Kt), tn.push(Xe);
    return tn;
  }
  function wn(Oe) {
    return t.toByteArray(Gt(Oe));
  }
  function Qe(Oe, Ce, He, Xe) {
    let Kt;
    for (Kt = 0; Kt < Xe && !(Kt + He >= Ce.length || Kt >= Oe.length); ++Kt)
      Ce[Kt + He] = Oe[Kt];
    return Kt;
  }
  function Dt(Oe, Ce) {
    return Oe instanceof Ce || Oe != null && Oe.constructor != null && Oe.constructor.name != null && Oe.constructor.name === Ce.name;
  }
  function en(Oe) {
    return Oe !== Oe;
  }
  const We = function() {
    const Oe = "0123456789abcdef", Ce = new Array(256);
    for (let He = 0; He < 16; ++He) {
      const Xe = He * 16;
      for (let Kt = 0; Kt < 16; ++Kt)
        Ce[Xe + Kt] = Oe[He] + Oe[Kt];
    }
    return Ce;
  }();
  function De(Oe) {
    return typeof BigInt > "u" ? Ge : Oe;
  }
  function Ge() {
    throw new Error("BigInt not supported");
  }
})(buffer$2);
const Buffer$7 = buffer$2.Buffer, Blob$3 = buffer$2.Blob, BlobOptions = buffer$2.BlobOptions, Buffer$1$1 = buffer$2.Buffer, File = buffer$2.File, FileOptions = buffer$2.FileOptions, INSPECT_MAX_BYTES = buffer$2.INSPECT_MAX_BYTES, SlowBuffer = buffer$2.SlowBuffer, TranscodeEncoding = buffer$2.TranscodeEncoding, atob$1 = buffer$2.atob, btoa$1 = buffer$2.btoa, constants$4 = buffer$2.constants, isAscii = buffer$2.isAscii, isUtf8 = buffer$2.isUtf8, kMaxLength = buffer$2.kMaxLength, kStringMaxLength = buffer$2.kStringMaxLength, resolveObjectURL = buffer$2.resolveObjectURL, transcode = buffer$2.transcode, dist$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$3,
  BlobOptions,
  Buffer: Buffer$1$1,
  File,
  FileOptions,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$1,
  btoa: btoa$1,
  constants: constants$4,
  default: Buffer$7,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" })), require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(dist$1);
bn$9.exports;
(function(c) {
  (function(t, n) {
    function ie(ce, de) {
      if (!ce) throw new Error(de || "Assertion failed");
    }
    function fe(ce, de) {
      ce.super_ = de;
      var pe = function() {
      };
      pe.prototype = de.prototype, ce.prototype = new pe(), ce.prototype.constructor = ce;
    }
    function ae(ce, de, pe) {
      if (ae.isBN(ce))
        return ce;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, ce !== null && ((de === "le" || de === "be") && (pe = de, de = 10), this._init(ce || 0, de || 10, pe || "be"));
    }
    typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
    var le;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
    } catch {
    }
    ae.isBN = function(de) {
      return de instanceof ae ? !0 : de !== null && typeof de == "object" && de.constructor.wordSize === ae.wordSize && Array.isArray(de.words);
    }, ae.max = function(de, pe) {
      return de.cmp(pe) > 0 ? de : pe;
    }, ae.min = function(de, pe) {
      return de.cmp(pe) < 0 ? de : pe;
    }, ae.prototype._init = function(de, pe, ve) {
      if (typeof de == "number")
        return this._initNumber(de, pe, ve);
      if (typeof de == "object")
        return this._initArray(de, pe, ve);
      pe === "hex" && (pe = 16), ie(pe === (pe | 0) && pe >= 2 && pe <= 36), de = de.toString().replace(/\s+/g, "");
      var we = 0;
      de[0] === "-" && (we++, this.negative = 1), we < de.length && (pe === 16 ? this._parseHex(de, we, ve) : (this._parseBase(de, pe, we), ve === "le" && this._initArray(this.toArray(), pe, ve)));
    }, ae.prototype._initNumber = function(de, pe, ve) {
      de < 0 && (this.negative = 1, de = -de), de < 67108864 ? (this.words = [de & 67108863], this.length = 1) : de < 4503599627370496 ? (this.words = [
        de & 67108863,
        de / 67108864 & 67108863
      ], this.length = 2) : (ie(de < 9007199254740992), this.words = [
        de & 67108863,
        de / 67108864 & 67108863,
        1
      ], this.length = 3), ve === "le" && this._initArray(this.toArray(), pe, ve);
    }, ae.prototype._initArray = function(de, pe, ve) {
      if (ie(typeof de.length == "number"), de.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(de.length / 3), this.words = new Array(this.length);
      for (var we = 0; we < this.length; we++)
        this.words[we] = 0;
      var Ee, xe, ue = 0;
      if (ve === "be")
        for (we = de.length - 1, Ee = 0; we >= 0; we -= 3)
          xe = de[we] | de[we - 1] << 8 | de[we - 2] << 16, this.words[Ee] |= xe << ue & 67108863, this.words[Ee + 1] = xe >>> 26 - ue & 67108863, ue += 24, ue >= 26 && (ue -= 26, Ee++);
      else if (ve === "le")
        for (we = 0, Ee = 0; we < de.length; we += 3)
          xe = de[we] | de[we + 1] << 8 | de[we + 2] << 16, this.words[Ee] |= xe << ue & 67108863, this.words[Ee + 1] = xe >>> 26 - ue & 67108863, ue += 24, ue >= 26 && (ue -= 26, Ee++);
      return this._strip();
    };
    function he(ce, de) {
      var pe = ce.charCodeAt(de);
      if (pe >= 48 && pe <= 57)
        return pe - 48;
      if (pe >= 65 && pe <= 70)
        return pe - 55;
      if (pe >= 97 && pe <= 102)
        return pe - 87;
      ie(!1, "Invalid character in " + ce);
    }
    function me(ce, de, pe) {
      var ve = he(ce, pe);
      return pe - 1 >= de && (ve |= he(ce, pe - 1) << 4), ve;
    }
    ae.prototype._parseHex = function(de, pe, ve) {
      this.length = Math.ceil((de.length - pe) / 6), this.words = new Array(this.length);
      for (var we = 0; we < this.length; we++)
        this.words[we] = 0;
      var Ee = 0, xe = 0, ue;
      if (ve === "be")
        for (we = de.length - 1; we >= pe; we -= 2)
          ue = me(de, pe, we) << Ee, this.words[xe] |= ue & 67108863, Ee >= 18 ? (Ee -= 18, xe += 1, this.words[xe] |= ue >>> 26) : Ee += 8;
      else {
        var ge = de.length - pe;
        for (we = ge % 2 === 0 ? pe + 1 : pe; we < de.length; we += 2)
          ue = me(de, pe, we) << Ee, this.words[xe] |= ue & 67108863, Ee >= 18 ? (Ee -= 18, xe += 1, this.words[xe] |= ue >>> 26) : Ee += 8;
      }
      this._strip();
    };
    function ye(ce, de, pe, ve) {
      for (var we = 0, Ee = 0, xe = Math.min(ce.length, pe), ue = de; ue < xe; ue++) {
        var ge = ce.charCodeAt(ue) - 48;
        we *= ve, ge >= 49 ? Ee = ge - 49 + 10 : ge >= 17 ? Ee = ge - 17 + 10 : Ee = ge, ie(ge >= 0 && Ee < ve, "Invalid character"), we += Ee;
      }
      return we;
    }
    ae.prototype._parseBase = function(de, pe, ve) {
      this.words = [0], this.length = 1;
      for (var we = 0, Ee = 1; Ee <= 67108863; Ee *= pe)
        we++;
      we--, Ee = Ee / pe | 0;
      for (var xe = de.length - ve, ue = xe % we, ge = Math.min(xe, xe - ue) + ve, Be = 0, Ne = ve; Ne < ge; Ne += we)
        Be = ye(de, Ne, Ne + we, pe), this.imuln(Ee), this.words[0] + Be < 67108864 ? this.words[0] += Be : this._iaddn(Be);
      if (ue !== 0) {
        var Fe = 1;
        for (Be = ye(de, Ne, de.length, pe), Ne = 0; Ne < ue; Ne++)
          Fe *= pe;
        this.imuln(Fe), this.words[0] + Be < 67108864 ? this.words[0] += Be : this._iaddn(Be);
      }
      this._strip();
    }, ae.prototype.copy = function(de) {
      de.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        de.words[pe] = this.words[pe];
      de.length = this.length, de.negative = this.negative, de.red = this.red;
    };
    function be(ce, de) {
      ce.words = de.words, ce.length = de.length, ce.negative = de.negative, ce.red = de.red;
    }
    if (ae.prototype._move = function(de) {
      be(de, this);
    }, ae.prototype.clone = function() {
      var de = new ae(null);
      return this.copy(de), de;
    }, ae.prototype._expand = function(de) {
      for (; this.length < de; )
        this.words[this.length++] = 0;
      return this;
    }, ae.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, ae.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        ae.prototype[Symbol.for("nodejs.util.inspect.custom")] = Ae;
      } catch {
        ae.prototype.inspect = Ae;
      }
    else
      ae.prototype.inspect = Ae;
    function Ae() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Se = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], $e = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Re = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    ae.prototype.toString = function(de, pe) {
      de = de || 10, pe = pe | 0 || 1;
      var ve;
      if (de === 16 || de === "hex") {
        ve = "";
        for (var we = 0, Ee = 0, xe = 0; xe < this.length; xe++) {
          var ue = this.words[xe], ge = ((ue << we | Ee) & 16777215).toString(16);
          Ee = ue >>> 24 - we & 16777215, we += 2, we >= 26 && (we -= 26, xe--), Ee !== 0 || xe !== this.length - 1 ? ve = Se[6 - ge.length] + ge + ve : ve = ge + ve;
        }
        for (Ee !== 0 && (ve = Ee.toString(16) + ve); ve.length % pe !== 0; )
          ve = "0" + ve;
        return this.negative !== 0 && (ve = "-" + ve), ve;
      }
      if (de === (de | 0) && de >= 2 && de <= 36) {
        var Be = $e[de], Ne = Re[de];
        ve = "";
        var Fe = this.clone();
        for (Fe.negative = 0; !Fe.isZero(); ) {
          var Pe = Fe.modrn(Ne).toString(de);
          Fe = Fe.idivn(Ne), Fe.isZero() ? ve = Pe + ve : ve = Se[Be - Pe.length] + Pe + ve;
        }
        for (this.isZero() && (ve = "0" + ve); ve.length % pe !== 0; )
          ve = "0" + ve;
        return this.negative !== 0 && (ve = "-" + ve), ve;
      }
      ie(!1, "Base should be between 2 and 36");
    }, ae.prototype.toNumber = function() {
      var de = this.words[0];
      return this.length === 2 ? de += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? de += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -de : de;
    }, ae.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, le && (ae.prototype.toBuffer = function(de, pe) {
      return this.toArrayLike(le, de, pe);
    }), ae.prototype.toArray = function(de, pe) {
      return this.toArrayLike(Array, de, pe);
    };
    var Me = function(de, pe) {
      return de.allocUnsafe ? de.allocUnsafe(pe) : new de(pe);
    };
    ae.prototype.toArrayLike = function(de, pe, ve) {
      this._strip();
      var we = this.byteLength(), Ee = ve || Math.max(1, we);
      ie(we <= Ee, "byte array longer than desired length"), ie(Ee > 0, "Requested array length <= 0");
      var xe = Me(de, Ee), ue = pe === "le" ? "LE" : "BE";
      return this["_toArrayLike" + ue](xe, we), xe;
    }, ae.prototype._toArrayLikeLE = function(de, pe) {
      for (var ve = 0, we = 0, Ee = 0, xe = 0; Ee < this.length; Ee++) {
        var ue = this.words[Ee] << xe | we;
        de[ve++] = ue & 255, ve < de.length && (de[ve++] = ue >> 8 & 255), ve < de.length && (de[ve++] = ue >> 16 & 255), xe === 6 ? (ve < de.length && (de[ve++] = ue >> 24 & 255), we = 0, xe = 0) : (we = ue >>> 24, xe += 2);
      }
      if (ve < de.length)
        for (de[ve++] = we; ve < de.length; )
          de[ve++] = 0;
    }, ae.prototype._toArrayLikeBE = function(de, pe) {
      for (var ve = de.length - 1, we = 0, Ee = 0, xe = 0; Ee < this.length; Ee++) {
        var ue = this.words[Ee] << xe | we;
        de[ve--] = ue & 255, ve >= 0 && (de[ve--] = ue >> 8 & 255), ve >= 0 && (de[ve--] = ue >> 16 & 255), xe === 6 ? (ve >= 0 && (de[ve--] = ue >> 24 & 255), we = 0, xe = 0) : (we = ue >>> 24, xe += 2);
      }
      if (ve >= 0)
        for (de[ve--] = we; ve >= 0; )
          de[ve--] = 0;
    }, Math.clz32 ? ae.prototype._countBits = function(de) {
      return 32 - Math.clz32(de);
    } : ae.prototype._countBits = function(de) {
      var pe = de, ve = 0;
      return pe >= 4096 && (ve += 13, pe >>>= 13), pe >= 64 && (ve += 7, pe >>>= 7), pe >= 8 && (ve += 4, pe >>>= 4), pe >= 2 && (ve += 2, pe >>>= 2), ve + pe;
    }, ae.prototype._zeroBits = function(de) {
      if (de === 0) return 26;
      var pe = de, ve = 0;
      return pe & 8191 || (ve += 13, pe >>>= 13), pe & 127 || (ve += 7, pe >>>= 7), pe & 15 || (ve += 4, pe >>>= 4), pe & 3 || (ve += 2, pe >>>= 2), pe & 1 || ve++, ve;
    }, ae.prototype.bitLength = function() {
      var de = this.words[this.length - 1], pe = this._countBits(de);
      return (this.length - 1) * 26 + pe;
    };
    function ke(ce) {
      for (var de = new Array(ce.bitLength()), pe = 0; pe < de.length; pe++) {
        var ve = pe / 26 | 0, we = pe % 26;
        de[pe] = ce.words[ve] >>> we & 1;
      }
      return de;
    }
    ae.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var de = 0, pe = 0; pe < this.length; pe++) {
        var ve = this._zeroBits(this.words[pe]);
        if (de += ve, ve !== 26) break;
      }
      return de;
    }, ae.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, ae.prototype.toTwos = function(de) {
      return this.negative !== 0 ? this.abs().inotn(de).iaddn(1) : this.clone();
    }, ae.prototype.fromTwos = function(de) {
      return this.testn(de - 1) ? this.notn(de).iaddn(1).ineg() : this.clone();
    }, ae.prototype.isNeg = function() {
      return this.negative !== 0;
    }, ae.prototype.neg = function() {
      return this.clone().ineg();
    }, ae.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, ae.prototype.iuor = function(de) {
      for (; this.length < de.length; )
        this.words[this.length++] = 0;
      for (var pe = 0; pe < de.length; pe++)
        this.words[pe] = this.words[pe] | de.words[pe];
      return this._strip();
    }, ae.prototype.ior = function(de) {
      return ie((this.negative | de.negative) === 0), this.iuor(de);
    }, ae.prototype.or = function(de) {
      return this.length > de.length ? this.clone().ior(de) : de.clone().ior(this);
    }, ae.prototype.uor = function(de) {
      return this.length > de.length ? this.clone().iuor(de) : de.clone().iuor(this);
    }, ae.prototype.iuand = function(de) {
      var pe;
      this.length > de.length ? pe = de : pe = this;
      for (var ve = 0; ve < pe.length; ve++)
        this.words[ve] = this.words[ve] & de.words[ve];
      return this.length = pe.length, this._strip();
    }, ae.prototype.iand = function(de) {
      return ie((this.negative | de.negative) === 0), this.iuand(de);
    }, ae.prototype.and = function(de) {
      return this.length > de.length ? this.clone().iand(de) : de.clone().iand(this);
    }, ae.prototype.uand = function(de) {
      return this.length > de.length ? this.clone().iuand(de) : de.clone().iuand(this);
    }, ae.prototype.iuxor = function(de) {
      var pe, ve;
      this.length > de.length ? (pe = this, ve = de) : (pe = de, ve = this);
      for (var we = 0; we < ve.length; we++)
        this.words[we] = pe.words[we] ^ ve.words[we];
      if (this !== pe)
        for (; we < pe.length; we++)
          this.words[we] = pe.words[we];
      return this.length = pe.length, this._strip();
    }, ae.prototype.ixor = function(de) {
      return ie((this.negative | de.negative) === 0), this.iuxor(de);
    }, ae.prototype.xor = function(de) {
      return this.length > de.length ? this.clone().ixor(de) : de.clone().ixor(this);
    }, ae.prototype.uxor = function(de) {
      return this.length > de.length ? this.clone().iuxor(de) : de.clone().iuxor(this);
    }, ae.prototype.inotn = function(de) {
      ie(typeof de == "number" && de >= 0);
      var pe = Math.ceil(de / 26) | 0, ve = de % 26;
      this._expand(pe), ve > 0 && pe--;
      for (var we = 0; we < pe; we++)
        this.words[we] = ~this.words[we] & 67108863;
      return ve > 0 && (this.words[we] = ~this.words[we] & 67108863 >> 26 - ve), this._strip();
    }, ae.prototype.notn = function(de) {
      return this.clone().inotn(de);
    }, ae.prototype.setn = function(de, pe) {
      ie(typeof de == "number" && de >= 0);
      var ve = de / 26 | 0, we = de % 26;
      return this._expand(ve + 1), pe ? this.words[ve] = this.words[ve] | 1 << we : this.words[ve] = this.words[ve] & ~(1 << we), this._strip();
    }, ae.prototype.iadd = function(de) {
      var pe;
      if (this.negative !== 0 && de.negative === 0)
        return this.negative = 0, pe = this.isub(de), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && de.negative !== 0)
        return de.negative = 0, pe = this.isub(de), de.negative = 1, pe._normSign();
      var ve, we;
      this.length > de.length ? (ve = this, we = de) : (ve = de, we = this);
      for (var Ee = 0, xe = 0; xe < we.length; xe++)
        pe = (ve.words[xe] | 0) + (we.words[xe] | 0) + Ee, this.words[xe] = pe & 67108863, Ee = pe >>> 26;
      for (; Ee !== 0 && xe < ve.length; xe++)
        pe = (ve.words[xe] | 0) + Ee, this.words[xe] = pe & 67108863, Ee = pe >>> 26;
      if (this.length = ve.length, Ee !== 0)
        this.words[this.length] = Ee, this.length++;
      else if (ve !== this)
        for (; xe < ve.length; xe++)
          this.words[xe] = ve.words[xe];
      return this;
    }, ae.prototype.add = function(de) {
      var pe;
      return de.negative !== 0 && this.negative === 0 ? (de.negative = 0, pe = this.sub(de), de.negative ^= 1, pe) : de.negative === 0 && this.negative !== 0 ? (this.negative = 0, pe = de.sub(this), this.negative = 1, pe) : this.length > de.length ? this.clone().iadd(de) : de.clone().iadd(this);
    }, ae.prototype.isub = function(de) {
      if (de.negative !== 0) {
        de.negative = 0;
        var pe = this.iadd(de);
        return de.negative = 1, pe._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(de), this.negative = 1, this._normSign();
      var ve = this.cmp(de);
      if (ve === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var we, Ee;
      ve > 0 ? (we = this, Ee = de) : (we = de, Ee = this);
      for (var xe = 0, ue = 0; ue < Ee.length; ue++)
        pe = (we.words[ue] | 0) - (Ee.words[ue] | 0) + xe, xe = pe >> 26, this.words[ue] = pe & 67108863;
      for (; xe !== 0 && ue < we.length; ue++)
        pe = (we.words[ue] | 0) + xe, xe = pe >> 26, this.words[ue] = pe & 67108863;
      if (xe === 0 && ue < we.length && we !== this)
        for (; ue < we.length; ue++)
          this.words[ue] = we.words[ue];
      return this.length = Math.max(this.length, ue), we !== this && (this.negative = 1), this._strip();
    }, ae.prototype.sub = function(de) {
      return this.clone().isub(de);
    };
    function Te(ce, de, pe) {
      pe.negative = de.negative ^ ce.negative;
      var ve = ce.length + de.length | 0;
      pe.length = ve, ve = ve - 1 | 0;
      var we = ce.words[0] | 0, Ee = de.words[0] | 0, xe = we * Ee, ue = xe & 67108863, ge = xe / 67108864 | 0;
      pe.words[0] = ue;
      for (var Be = 1; Be < ve; Be++) {
        for (var Ne = ge >>> 26, Fe = ge & 67108863, Pe = Math.min(Be, de.length - 1), Je = Math.max(0, Be - ce.length + 1); Je <= Pe; Je++) {
          var Ke = Be - Je | 0;
          we = ce.words[Ke] | 0, Ee = de.words[Je] | 0, xe = we * Ee + Fe, Ne += xe / 67108864 | 0, Fe = xe & 67108863;
        }
        pe.words[Be] = Fe | 0, ge = Ne | 0;
      }
      return ge !== 0 ? pe.words[Be] = ge | 0 : pe.length--, pe._strip();
    }
    var Ie = function(de, pe, ve) {
      var we = de.words, Ee = pe.words, xe = ve.words, ue = 0, ge, Be, Ne, Fe = we[0] | 0, Pe = Fe & 8191, Je = Fe >>> 13, Ke = we[1] | 0, Ze = Ke & 8191, Ye = Ke >>> 13, Pt = we[2] | 0, Ft = Pt & 8191, Le = Pt >>> 13, $t = we[3] | 0, Jt = $t & 8191, Ht = $t >>> 13, Vt = we[4] | 0, xn = Vt & 8191, Zt = Vt >>> 13, Gt = we[5] | 0, An = Gt & 8191, Qt = Gt >>> 13, Xt = we[6] | 0, wn = Xt & 8191, Qe = Xt >>> 13, Dt = we[7] | 0, en = Dt & 8191, We = Dt >>> 13, De = we[8] | 0, Ge = De & 8191, Oe = De >>> 13, Ce = we[9] | 0, He = Ce & 8191, Xe = Ce >>> 13, Kt = Ee[0] | 0, tn = Kt & 8191, Wt = Kt >>> 13, Yt = Ee[1] | 0, _n = Yt & 8191, rn = Yt >>> 13, nn = Ee[2] | 0, En = nn & 8191, an = nn >>> 13, dn = Ee[3] | 0, Mn = dn & 8191, on = dn >>> 13, hn = Ee[4] | 0, Rn = hn & 8191, sn = hn >>> 13, pn = Ee[5] | 0, Bn = pn & 8191, fn = pn >>> 13, yn = Ee[6] | 0, kn = yn & 8191, un = yn >>> 13, mn = Ee[7] | 0, Tn = mn & 8191, cn = mn >>> 13, gn = Ee[8] | 0, Cn = gn & 8191, ln = gn >>> 13, vn = Ee[9] | 0, Sn = vn & 8191, $n = vn >>> 13;
      ve.negative = de.negative ^ pe.negative, ve.length = 19, ge = Math.imul(Pe, tn), Be = Math.imul(Pe, Wt), Be = Be + Math.imul(Je, tn) | 0, Ne = Math.imul(Je, Wt);
      var Nn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, ge = Math.imul(Ze, tn), Be = Math.imul(Ze, Wt), Be = Be + Math.imul(Ye, tn) | 0, Ne = Math.imul(Ye, Wt), ge = ge + Math.imul(Pe, _n) | 0, Be = Be + Math.imul(Pe, rn) | 0, Be = Be + Math.imul(Je, _n) | 0, Ne = Ne + Math.imul(Je, rn) | 0;
      var In = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, ge = Math.imul(Ft, tn), Be = Math.imul(Ft, Wt), Be = Be + Math.imul(Le, tn) | 0, Ne = Math.imul(Le, Wt), ge = ge + Math.imul(Ze, _n) | 0, Be = Be + Math.imul(Ze, rn) | 0, Be = Be + Math.imul(Ye, _n) | 0, Ne = Ne + Math.imul(Ye, rn) | 0, ge = ge + Math.imul(Pe, En) | 0, Be = Be + Math.imul(Pe, an) | 0, Be = Be + Math.imul(Je, En) | 0, Ne = Ne + Math.imul(Je, an) | 0;
      var Pn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, ge = Math.imul(Jt, tn), Be = Math.imul(Jt, Wt), Be = Be + Math.imul(Ht, tn) | 0, Ne = Math.imul(Ht, Wt), ge = ge + Math.imul(Ft, _n) | 0, Be = Be + Math.imul(Ft, rn) | 0, Be = Be + Math.imul(Le, _n) | 0, Ne = Ne + Math.imul(Le, rn) | 0, ge = ge + Math.imul(Ze, En) | 0, Be = Be + Math.imul(Ze, an) | 0, Be = Be + Math.imul(Ye, En) | 0, Ne = Ne + Math.imul(Ye, an) | 0, ge = ge + Math.imul(Pe, Mn) | 0, Be = Be + Math.imul(Pe, on) | 0, Be = Be + Math.imul(Je, Mn) | 0, Ne = Ne + Math.imul(Je, on) | 0;
      var On = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, ge = Math.imul(xn, tn), Be = Math.imul(xn, Wt), Be = Be + Math.imul(Zt, tn) | 0, Ne = Math.imul(Zt, Wt), ge = ge + Math.imul(Jt, _n) | 0, Be = Be + Math.imul(Jt, rn) | 0, Be = Be + Math.imul(Ht, _n) | 0, Ne = Ne + Math.imul(Ht, rn) | 0, ge = ge + Math.imul(Ft, En) | 0, Be = Be + Math.imul(Ft, an) | 0, Be = Be + Math.imul(Le, En) | 0, Ne = Ne + Math.imul(Le, an) | 0, ge = ge + Math.imul(Ze, Mn) | 0, Be = Be + Math.imul(Ze, on) | 0, Be = Be + Math.imul(Ye, Mn) | 0, Ne = Ne + Math.imul(Ye, on) | 0, ge = ge + Math.imul(Pe, Rn) | 0, Be = Be + Math.imul(Pe, sn) | 0, Be = Be + Math.imul(Je, Rn) | 0, Ne = Ne + Math.imul(Je, sn) | 0;
      var Ln = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, ge = Math.imul(An, tn), Be = Math.imul(An, Wt), Be = Be + Math.imul(Qt, tn) | 0, Ne = Math.imul(Qt, Wt), ge = ge + Math.imul(xn, _n) | 0, Be = Be + Math.imul(xn, rn) | 0, Be = Be + Math.imul(Zt, _n) | 0, Ne = Ne + Math.imul(Zt, rn) | 0, ge = ge + Math.imul(Jt, En) | 0, Be = Be + Math.imul(Jt, an) | 0, Be = Be + Math.imul(Ht, En) | 0, Ne = Ne + Math.imul(Ht, an) | 0, ge = ge + Math.imul(Ft, Mn) | 0, Be = Be + Math.imul(Ft, on) | 0, Be = Be + Math.imul(Le, Mn) | 0, Ne = Ne + Math.imul(Le, on) | 0, ge = ge + Math.imul(Ze, Rn) | 0, Be = Be + Math.imul(Ze, sn) | 0, Be = Be + Math.imul(Ye, Rn) | 0, Ne = Ne + Math.imul(Ye, sn) | 0, ge = ge + Math.imul(Pe, Bn) | 0, Be = Be + Math.imul(Pe, fn) | 0, Be = Be + Math.imul(Je, Bn) | 0, Ne = Ne + Math.imul(Je, fn) | 0;
      var Dn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, ge = Math.imul(wn, tn), Be = Math.imul(wn, Wt), Be = Be + Math.imul(Qe, tn) | 0, Ne = Math.imul(Qe, Wt), ge = ge + Math.imul(An, _n) | 0, Be = Be + Math.imul(An, rn) | 0, Be = Be + Math.imul(Qt, _n) | 0, Ne = Ne + Math.imul(Qt, rn) | 0, ge = ge + Math.imul(xn, En) | 0, Be = Be + Math.imul(xn, an) | 0, Be = Be + Math.imul(Zt, En) | 0, Ne = Ne + Math.imul(Zt, an) | 0, ge = ge + Math.imul(Jt, Mn) | 0, Be = Be + Math.imul(Jt, on) | 0, Be = Be + Math.imul(Ht, Mn) | 0, Ne = Ne + Math.imul(Ht, on) | 0, ge = ge + Math.imul(Ft, Rn) | 0, Be = Be + Math.imul(Ft, sn) | 0, Be = Be + Math.imul(Le, Rn) | 0, Ne = Ne + Math.imul(Le, sn) | 0, ge = ge + Math.imul(Ze, Bn) | 0, Be = Be + Math.imul(Ze, fn) | 0, Be = Be + Math.imul(Ye, Bn) | 0, Ne = Ne + Math.imul(Ye, fn) | 0, ge = ge + Math.imul(Pe, kn) | 0, Be = Be + Math.imul(Pe, un) | 0, Be = Be + Math.imul(Je, kn) | 0, Ne = Ne + Math.imul(Je, un) | 0;
      var qn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, ge = Math.imul(en, tn), Be = Math.imul(en, Wt), Be = Be + Math.imul(We, tn) | 0, Ne = Math.imul(We, Wt), ge = ge + Math.imul(wn, _n) | 0, Be = Be + Math.imul(wn, rn) | 0, Be = Be + Math.imul(Qe, _n) | 0, Ne = Ne + Math.imul(Qe, rn) | 0, ge = ge + Math.imul(An, En) | 0, Be = Be + Math.imul(An, an) | 0, Be = Be + Math.imul(Qt, En) | 0, Ne = Ne + Math.imul(Qt, an) | 0, ge = ge + Math.imul(xn, Mn) | 0, Be = Be + Math.imul(xn, on) | 0, Be = Be + Math.imul(Zt, Mn) | 0, Ne = Ne + Math.imul(Zt, on) | 0, ge = ge + Math.imul(Jt, Rn) | 0, Be = Be + Math.imul(Jt, sn) | 0, Be = Be + Math.imul(Ht, Rn) | 0, Ne = Ne + Math.imul(Ht, sn) | 0, ge = ge + Math.imul(Ft, Bn) | 0, Be = Be + Math.imul(Ft, fn) | 0, Be = Be + Math.imul(Le, Bn) | 0, Ne = Ne + Math.imul(Le, fn) | 0, ge = ge + Math.imul(Ze, kn) | 0, Be = Be + Math.imul(Ze, un) | 0, Be = Be + Math.imul(Ye, kn) | 0, Ne = Ne + Math.imul(Ye, un) | 0, ge = ge + Math.imul(Pe, Tn) | 0, Be = Be + Math.imul(Pe, cn) | 0, Be = Be + Math.imul(Je, Tn) | 0, Ne = Ne + Math.imul(Je, cn) | 0;
      var Fn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, ge = Math.imul(Ge, tn), Be = Math.imul(Ge, Wt), Be = Be + Math.imul(Oe, tn) | 0, Ne = Math.imul(Oe, Wt), ge = ge + Math.imul(en, _n) | 0, Be = Be + Math.imul(en, rn) | 0, Be = Be + Math.imul(We, _n) | 0, Ne = Ne + Math.imul(We, rn) | 0, ge = ge + Math.imul(wn, En) | 0, Be = Be + Math.imul(wn, an) | 0, Be = Be + Math.imul(Qe, En) | 0, Ne = Ne + Math.imul(Qe, an) | 0, ge = ge + Math.imul(An, Mn) | 0, Be = Be + Math.imul(An, on) | 0, Be = Be + Math.imul(Qt, Mn) | 0, Ne = Ne + Math.imul(Qt, on) | 0, ge = ge + Math.imul(xn, Rn) | 0, Be = Be + Math.imul(xn, sn) | 0, Be = Be + Math.imul(Zt, Rn) | 0, Ne = Ne + Math.imul(Zt, sn) | 0, ge = ge + Math.imul(Jt, Bn) | 0, Be = Be + Math.imul(Jt, fn) | 0, Be = Be + Math.imul(Ht, Bn) | 0, Ne = Ne + Math.imul(Ht, fn) | 0, ge = ge + Math.imul(Ft, kn) | 0, Be = Be + Math.imul(Ft, un) | 0, Be = Be + Math.imul(Le, kn) | 0, Ne = Ne + Math.imul(Le, un) | 0, ge = ge + Math.imul(Ze, Tn) | 0, Be = Be + Math.imul(Ze, cn) | 0, Be = Be + Math.imul(Ye, Tn) | 0, Ne = Ne + Math.imul(Ye, cn) | 0, ge = ge + Math.imul(Pe, Cn) | 0, Be = Be + Math.imul(Pe, ln) | 0, Be = Be + Math.imul(Je, Cn) | 0, Ne = Ne + Math.imul(Je, ln) | 0;
      var Un = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, ge = Math.imul(He, tn), Be = Math.imul(He, Wt), Be = Be + Math.imul(Xe, tn) | 0, Ne = Math.imul(Xe, Wt), ge = ge + Math.imul(Ge, _n) | 0, Be = Be + Math.imul(Ge, rn) | 0, Be = Be + Math.imul(Oe, _n) | 0, Ne = Ne + Math.imul(Oe, rn) | 0, ge = ge + Math.imul(en, En) | 0, Be = Be + Math.imul(en, an) | 0, Be = Be + Math.imul(We, En) | 0, Ne = Ne + Math.imul(We, an) | 0, ge = ge + Math.imul(wn, Mn) | 0, Be = Be + Math.imul(wn, on) | 0, Be = Be + Math.imul(Qe, Mn) | 0, Ne = Ne + Math.imul(Qe, on) | 0, ge = ge + Math.imul(An, Rn) | 0, Be = Be + Math.imul(An, sn) | 0, Be = Be + Math.imul(Qt, Rn) | 0, Ne = Ne + Math.imul(Qt, sn) | 0, ge = ge + Math.imul(xn, Bn) | 0, Be = Be + Math.imul(xn, fn) | 0, Be = Be + Math.imul(Zt, Bn) | 0, Ne = Ne + Math.imul(Zt, fn) | 0, ge = ge + Math.imul(Jt, kn) | 0, Be = Be + Math.imul(Jt, un) | 0, Be = Be + Math.imul(Ht, kn) | 0, Ne = Ne + Math.imul(Ht, un) | 0, ge = ge + Math.imul(Ft, Tn) | 0, Be = Be + Math.imul(Ft, cn) | 0, Be = Be + Math.imul(Le, Tn) | 0, Ne = Ne + Math.imul(Le, cn) | 0, ge = ge + Math.imul(Ze, Cn) | 0, Be = Be + Math.imul(Ze, ln) | 0, Be = Be + Math.imul(Ye, Cn) | 0, Ne = Ne + Math.imul(Ye, ln) | 0, ge = ge + Math.imul(Pe, Sn) | 0, Be = Be + Math.imul(Pe, $n) | 0, Be = Be + Math.imul(Je, Sn) | 0, Ne = Ne + Math.imul(Je, $n) | 0;
      var Kn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, ge = Math.imul(He, _n), Be = Math.imul(He, rn), Be = Be + Math.imul(Xe, _n) | 0, Ne = Math.imul(Xe, rn), ge = ge + Math.imul(Ge, En) | 0, Be = Be + Math.imul(Ge, an) | 0, Be = Be + Math.imul(Oe, En) | 0, Ne = Ne + Math.imul(Oe, an) | 0, ge = ge + Math.imul(en, Mn) | 0, Be = Be + Math.imul(en, on) | 0, Be = Be + Math.imul(We, Mn) | 0, Ne = Ne + Math.imul(We, on) | 0, ge = ge + Math.imul(wn, Rn) | 0, Be = Be + Math.imul(wn, sn) | 0, Be = Be + Math.imul(Qe, Rn) | 0, Ne = Ne + Math.imul(Qe, sn) | 0, ge = ge + Math.imul(An, Bn) | 0, Be = Be + Math.imul(An, fn) | 0, Be = Be + Math.imul(Qt, Bn) | 0, Ne = Ne + Math.imul(Qt, fn) | 0, ge = ge + Math.imul(xn, kn) | 0, Be = Be + Math.imul(xn, un) | 0, Be = Be + Math.imul(Zt, kn) | 0, Ne = Ne + Math.imul(Zt, un) | 0, ge = ge + Math.imul(Jt, Tn) | 0, Be = Be + Math.imul(Jt, cn) | 0, Be = Be + Math.imul(Ht, Tn) | 0, Ne = Ne + Math.imul(Ht, cn) | 0, ge = ge + Math.imul(Ft, Cn) | 0, Be = Be + Math.imul(Ft, ln) | 0, Be = Be + Math.imul(Le, Cn) | 0, Ne = Ne + Math.imul(Le, ln) | 0, ge = ge + Math.imul(Ze, Sn) | 0, Be = Be + Math.imul(Ze, $n) | 0, Be = Be + Math.imul(Ye, Sn) | 0, Ne = Ne + Math.imul(Ye, $n) | 0;
      var Hn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, ge = Math.imul(He, En), Be = Math.imul(He, an), Be = Be + Math.imul(Xe, En) | 0, Ne = Math.imul(Xe, an), ge = ge + Math.imul(Ge, Mn) | 0, Be = Be + Math.imul(Ge, on) | 0, Be = Be + Math.imul(Oe, Mn) | 0, Ne = Ne + Math.imul(Oe, on) | 0, ge = ge + Math.imul(en, Rn) | 0, Be = Be + Math.imul(en, sn) | 0, Be = Be + Math.imul(We, Rn) | 0, Ne = Ne + Math.imul(We, sn) | 0, ge = ge + Math.imul(wn, Bn) | 0, Be = Be + Math.imul(wn, fn) | 0, Be = Be + Math.imul(Qe, Bn) | 0, Ne = Ne + Math.imul(Qe, fn) | 0, ge = ge + Math.imul(An, kn) | 0, Be = Be + Math.imul(An, un) | 0, Be = Be + Math.imul(Qt, kn) | 0, Ne = Ne + Math.imul(Qt, un) | 0, ge = ge + Math.imul(xn, Tn) | 0, Be = Be + Math.imul(xn, cn) | 0, Be = Be + Math.imul(Zt, Tn) | 0, Ne = Ne + Math.imul(Zt, cn) | 0, ge = ge + Math.imul(Jt, Cn) | 0, Be = Be + Math.imul(Jt, ln) | 0, Be = Be + Math.imul(Ht, Cn) | 0, Ne = Ne + Math.imul(Ht, ln) | 0, ge = ge + Math.imul(Ft, Sn) | 0, Be = Be + Math.imul(Ft, $n) | 0, Be = Be + Math.imul(Le, Sn) | 0, Ne = Ne + Math.imul(Le, $n) | 0;
      var zn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, ge = Math.imul(He, Mn), Be = Math.imul(He, on), Be = Be + Math.imul(Xe, Mn) | 0, Ne = Math.imul(Xe, on), ge = ge + Math.imul(Ge, Rn) | 0, Be = Be + Math.imul(Ge, sn) | 0, Be = Be + Math.imul(Oe, Rn) | 0, Ne = Ne + Math.imul(Oe, sn) | 0, ge = ge + Math.imul(en, Bn) | 0, Be = Be + Math.imul(en, fn) | 0, Be = Be + Math.imul(We, Bn) | 0, Ne = Ne + Math.imul(We, fn) | 0, ge = ge + Math.imul(wn, kn) | 0, Be = Be + Math.imul(wn, un) | 0, Be = Be + Math.imul(Qe, kn) | 0, Ne = Ne + Math.imul(Qe, un) | 0, ge = ge + Math.imul(An, Tn) | 0, Be = Be + Math.imul(An, cn) | 0, Be = Be + Math.imul(Qt, Tn) | 0, Ne = Ne + Math.imul(Qt, cn) | 0, ge = ge + Math.imul(xn, Cn) | 0, Be = Be + Math.imul(xn, ln) | 0, Be = Be + Math.imul(Zt, Cn) | 0, Ne = Ne + Math.imul(Zt, ln) | 0, ge = ge + Math.imul(Jt, Sn) | 0, Be = Be + Math.imul(Jt, $n) | 0, Be = Be + Math.imul(Ht, Sn) | 0, Ne = Ne + Math.imul(Ht, $n) | 0;
      var jn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, ge = Math.imul(He, Rn), Be = Math.imul(He, sn), Be = Be + Math.imul(Xe, Rn) | 0, Ne = Math.imul(Xe, sn), ge = ge + Math.imul(Ge, Bn) | 0, Be = Be + Math.imul(Ge, fn) | 0, Be = Be + Math.imul(Oe, Bn) | 0, Ne = Ne + Math.imul(Oe, fn) | 0, ge = ge + Math.imul(en, kn) | 0, Be = Be + Math.imul(en, un) | 0, Be = Be + Math.imul(We, kn) | 0, Ne = Ne + Math.imul(We, un) | 0, ge = ge + Math.imul(wn, Tn) | 0, Be = Be + Math.imul(wn, cn) | 0, Be = Be + Math.imul(Qe, Tn) | 0, Ne = Ne + Math.imul(Qe, cn) | 0, ge = ge + Math.imul(An, Cn) | 0, Be = Be + Math.imul(An, ln) | 0, Be = Be + Math.imul(Qt, Cn) | 0, Ne = Ne + Math.imul(Qt, ln) | 0, ge = ge + Math.imul(xn, Sn) | 0, Be = Be + Math.imul(xn, $n) | 0, Be = Be + Math.imul(Zt, Sn) | 0, Ne = Ne + Math.imul(Zt, $n) | 0;
      var Gn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, ge = Math.imul(He, Bn), Be = Math.imul(He, fn), Be = Be + Math.imul(Xe, Bn) | 0, Ne = Math.imul(Xe, fn), ge = ge + Math.imul(Ge, kn) | 0, Be = Be + Math.imul(Ge, un) | 0, Be = Be + Math.imul(Oe, kn) | 0, Ne = Ne + Math.imul(Oe, un) | 0, ge = ge + Math.imul(en, Tn) | 0, Be = Be + Math.imul(en, cn) | 0, Be = Be + Math.imul(We, Tn) | 0, Ne = Ne + Math.imul(We, cn) | 0, ge = ge + Math.imul(wn, Cn) | 0, Be = Be + Math.imul(wn, ln) | 0, Be = Be + Math.imul(Qe, Cn) | 0, Ne = Ne + Math.imul(Qe, ln) | 0, ge = ge + Math.imul(An, Sn) | 0, Be = Be + Math.imul(An, $n) | 0, Be = Be + Math.imul(Qt, Sn) | 0, Ne = Ne + Math.imul(Qt, $n) | 0;
      var Wn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, ge = Math.imul(He, kn), Be = Math.imul(He, un), Be = Be + Math.imul(Xe, kn) | 0, Ne = Math.imul(Xe, un), ge = ge + Math.imul(Ge, Tn) | 0, Be = Be + Math.imul(Ge, cn) | 0, Be = Be + Math.imul(Oe, Tn) | 0, Ne = Ne + Math.imul(Oe, cn) | 0, ge = ge + Math.imul(en, Cn) | 0, Be = Be + Math.imul(en, ln) | 0, Be = Be + Math.imul(We, Cn) | 0, Ne = Ne + Math.imul(We, ln) | 0, ge = ge + Math.imul(wn, Sn) | 0, Be = Be + Math.imul(wn, $n) | 0, Be = Be + Math.imul(Qe, Sn) | 0, Ne = Ne + Math.imul(Qe, $n) | 0;
      var Vn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, ge = Math.imul(He, Tn), Be = Math.imul(He, cn), Be = Be + Math.imul(Xe, Tn) | 0, Ne = Math.imul(Xe, cn), ge = ge + Math.imul(Ge, Cn) | 0, Be = Be + Math.imul(Ge, ln) | 0, Be = Be + Math.imul(Oe, Cn) | 0, Ne = Ne + Math.imul(Oe, ln) | 0, ge = ge + Math.imul(en, Sn) | 0, Be = Be + Math.imul(en, $n) | 0, Be = Be + Math.imul(We, Sn) | 0, Ne = Ne + Math.imul(We, $n) | 0;
      var Jn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, ge = Math.imul(He, Cn), Be = Math.imul(He, ln), Be = Be + Math.imul(Xe, Cn) | 0, Ne = Math.imul(Xe, ln), ge = ge + Math.imul(Ge, Sn) | 0, Be = Be + Math.imul(Ge, $n) | 0, Be = Be + Math.imul(Oe, Sn) | 0, Ne = Ne + Math.imul(Oe, $n) | 0;
      var Qn = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      ue = (Ne + (Be >>> 13) | 0) + (Qn >>> 26) | 0, Qn &= 67108863, ge = Math.imul(He, Sn), Be = Math.imul(He, $n), Be = Be + Math.imul(Xe, Sn) | 0, Ne = Math.imul(Xe, $n);
      var ei = (ue + ge | 0) + ((Be & 8191) << 13) | 0;
      return ue = (Ne + (Be >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, xe[0] = Nn, xe[1] = In, xe[2] = Pn, xe[3] = On, xe[4] = Ln, xe[5] = Dn, xe[6] = qn, xe[7] = Fn, xe[8] = Un, xe[9] = Kn, xe[10] = Hn, xe[11] = zn, xe[12] = jn, xe[13] = Gn, xe[14] = Wn, xe[15] = Vn, xe[16] = Jn, xe[17] = Qn, xe[18] = ei, ue !== 0 && (xe[19] = ue, ve.length++), ve;
    };
    Math.imul || (Ie = Te);
    function qe(ce, de, pe) {
      pe.negative = de.negative ^ ce.negative, pe.length = ce.length + de.length;
      for (var ve = 0, we = 0, Ee = 0; Ee < pe.length - 1; Ee++) {
        var xe = we;
        we = 0;
        for (var ue = ve & 67108863, ge = Math.min(Ee, de.length - 1), Be = Math.max(0, Ee - ce.length + 1); Be <= ge; Be++) {
          var Ne = Ee - Be, Fe = ce.words[Ne] | 0, Pe = de.words[Be] | 0, Je = Fe * Pe, Ke = Je & 67108863;
          xe = xe + (Je / 67108864 | 0) | 0, Ke = Ke + ue | 0, ue = Ke & 67108863, xe = xe + (Ke >>> 26) | 0, we += xe >>> 26, xe &= 67108863;
        }
        pe.words[Ee] = ue, ve = xe, xe = we;
      }
      return ve !== 0 ? pe.words[Ee] = ve : pe.length--, pe._strip();
    }
    function Ue(ce, de, pe) {
      return qe(ce, de, pe);
    }
    ae.prototype.mulTo = function(de, pe) {
      var ve, we = this.length + de.length;
      return this.length === 10 && de.length === 10 ? ve = Ie(this, de, pe) : we < 63 ? ve = Te(this, de, pe) : we < 1024 ? ve = qe(this, de, pe) : ve = Ue(this, de, pe), ve;
    }, ae.prototype.mul = function(de) {
      var pe = new ae(null);
      return pe.words = new Array(this.length + de.length), this.mulTo(de, pe);
    }, ae.prototype.mulf = function(de) {
      var pe = new ae(null);
      return pe.words = new Array(this.length + de.length), Ue(this, de, pe);
    }, ae.prototype.imul = function(de) {
      return this.clone().mulTo(de, this);
    }, ae.prototype.imuln = function(de) {
      var pe = de < 0;
      pe && (de = -de), ie(typeof de == "number"), ie(de < 67108864);
      for (var ve = 0, we = 0; we < this.length; we++) {
        var Ee = (this.words[we] | 0) * de, xe = (Ee & 67108863) + (ve & 67108863);
        ve >>= 26, ve += Ee / 67108864 | 0, ve += xe >>> 26, this.words[we] = xe & 67108863;
      }
      return ve !== 0 && (this.words[we] = ve, this.length++), pe ? this.ineg() : this;
    }, ae.prototype.muln = function(de) {
      return this.clone().imuln(de);
    }, ae.prototype.sqr = function() {
      return this.mul(this);
    }, ae.prototype.isqr = function() {
      return this.imul(this.clone());
    }, ae.prototype.pow = function(de) {
      var pe = ke(de);
      if (pe.length === 0) return new ae(1);
      for (var ve = this, we = 0; we < pe.length && pe[we] === 0; we++, ve = ve.sqr())
        ;
      if (++we < pe.length)
        for (var Ee = ve.sqr(); we < pe.length; we++, Ee = Ee.sqr())
          pe[we] !== 0 && (ve = ve.mul(Ee));
      return ve;
    }, ae.prototype.iushln = function(de) {
      ie(typeof de == "number" && de >= 0);
      var pe = de % 26, ve = (de - pe) / 26, we = 67108863 >>> 26 - pe << 26 - pe, Ee;
      if (pe !== 0) {
        var xe = 0;
        for (Ee = 0; Ee < this.length; Ee++) {
          var ue = this.words[Ee] & we, ge = (this.words[Ee] | 0) - ue << pe;
          this.words[Ee] = ge | xe, xe = ue >>> 26 - pe;
        }
        xe && (this.words[Ee] = xe, this.length++);
      }
      if (ve !== 0) {
        for (Ee = this.length - 1; Ee >= 0; Ee--)
          this.words[Ee + ve] = this.words[Ee];
        for (Ee = 0; Ee < ve; Ee++)
          this.words[Ee] = 0;
        this.length += ve;
      }
      return this._strip();
    }, ae.prototype.ishln = function(de) {
      return ie(this.negative === 0), this.iushln(de);
    }, ae.prototype.iushrn = function(de, pe, ve) {
      ie(typeof de == "number" && de >= 0);
      var we;
      pe ? we = (pe - pe % 26) / 26 : we = 0;
      var Ee = de % 26, xe = Math.min((de - Ee) / 26, this.length), ue = 67108863 ^ 67108863 >>> Ee << Ee, ge = ve;
      if (we -= xe, we = Math.max(0, we), ge) {
        for (var Be = 0; Be < xe; Be++)
          ge.words[Be] = this.words[Be];
        ge.length = xe;
      }
      if (xe !== 0) if (this.length > xe)
        for (this.length -= xe, Be = 0; Be < this.length; Be++)
          this.words[Be] = this.words[Be + xe];
      else
        this.words[0] = 0, this.length = 1;
      var Ne = 0;
      for (Be = this.length - 1; Be >= 0 && (Ne !== 0 || Be >= we); Be--) {
        var Fe = this.words[Be] | 0;
        this.words[Be] = Ne << 26 - Ee | Fe >>> Ee, Ne = Fe & ue;
      }
      return ge && Ne !== 0 && (ge.words[ge.length++] = Ne), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, ae.prototype.ishrn = function(de, pe, ve) {
      return ie(this.negative === 0), this.iushrn(de, pe, ve);
    }, ae.prototype.shln = function(de) {
      return this.clone().ishln(de);
    }, ae.prototype.ushln = function(de) {
      return this.clone().iushln(de);
    }, ae.prototype.shrn = function(de) {
      return this.clone().ishrn(de);
    }, ae.prototype.ushrn = function(de) {
      return this.clone().iushrn(de);
    }, ae.prototype.testn = function(de) {
      ie(typeof de == "number" && de >= 0);
      var pe = de % 26, ve = (de - pe) / 26, we = 1 << pe;
      if (this.length <= ve) return !1;
      var Ee = this.words[ve];
      return !!(Ee & we);
    }, ae.prototype.imaskn = function(de) {
      ie(typeof de == "number" && de >= 0);
      var pe = de % 26, ve = (de - pe) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ve)
        return this;
      if (pe !== 0 && ve++, this.length = Math.min(ve, this.length), pe !== 0) {
        var we = 67108863 ^ 67108863 >>> pe << pe;
        this.words[this.length - 1] &= we;
      }
      return this._strip();
    }, ae.prototype.maskn = function(de) {
      return this.clone().imaskn(de);
    }, ae.prototype.iaddn = function(de) {
      return ie(typeof de == "number"), ie(de < 67108864), de < 0 ? this.isubn(-de) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= de ? (this.words[0] = de - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(de), this.negative = 1, this) : this._iaddn(de);
    }, ae.prototype._iaddn = function(de) {
      this.words[0] += de;
      for (var pe = 0; pe < this.length && this.words[pe] >= 67108864; pe++)
        this.words[pe] -= 67108864, pe === this.length - 1 ? this.words[pe + 1] = 1 : this.words[pe + 1]++;
      return this.length = Math.max(this.length, pe + 1), this;
    }, ae.prototype.isubn = function(de) {
      if (ie(typeof de == "number"), ie(de < 67108864), de < 0) return this.iaddn(-de);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(de), this.negative = 1, this;
      if (this.words[0] -= de, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var pe = 0; pe < this.length && this.words[pe] < 0; pe++)
          this.words[pe] += 67108864, this.words[pe + 1] -= 1;
      return this._strip();
    }, ae.prototype.addn = function(de) {
      return this.clone().iaddn(de);
    }, ae.prototype.subn = function(de) {
      return this.clone().isubn(de);
    }, ae.prototype.iabs = function() {
      return this.negative = 0, this;
    }, ae.prototype.abs = function() {
      return this.clone().iabs();
    }, ae.prototype._ishlnsubmul = function(de, pe, ve) {
      var we = de.length + ve, Ee;
      this._expand(we);
      var xe, ue = 0;
      for (Ee = 0; Ee < de.length; Ee++) {
        xe = (this.words[Ee + ve] | 0) + ue;
        var ge = (de.words[Ee] | 0) * pe;
        xe -= ge & 67108863, ue = (xe >> 26) - (ge / 67108864 | 0), this.words[Ee + ve] = xe & 67108863;
      }
      for (; Ee < this.length - ve; Ee++)
        xe = (this.words[Ee + ve] | 0) + ue, ue = xe >> 26, this.words[Ee + ve] = xe & 67108863;
      if (ue === 0) return this._strip();
      for (ie(ue === -1), ue = 0, Ee = 0; Ee < this.length; Ee++)
        xe = -(this.words[Ee] | 0) + ue, ue = xe >> 26, this.words[Ee] = xe & 67108863;
      return this.negative = 1, this._strip();
    }, ae.prototype._wordDiv = function(de, pe) {
      var ve = this.length - de.length, we = this.clone(), Ee = de, xe = Ee.words[Ee.length - 1] | 0, ue = this._countBits(xe);
      ve = 26 - ue, ve !== 0 && (Ee = Ee.ushln(ve), we.iushln(ve), xe = Ee.words[Ee.length - 1] | 0);
      var ge = we.length - Ee.length, Be;
      if (pe !== "mod") {
        Be = new ae(null), Be.length = ge + 1, Be.words = new Array(Be.length);
        for (var Ne = 0; Ne < Be.length; Ne++)
          Be.words[Ne] = 0;
      }
      var Fe = we.clone()._ishlnsubmul(Ee, 1, ge);
      Fe.negative === 0 && (we = Fe, Be && (Be.words[ge] = 1));
      for (var Pe = ge - 1; Pe >= 0; Pe--) {
        var Je = (we.words[Ee.length + Pe] | 0) * 67108864 + (we.words[Ee.length + Pe - 1] | 0);
        for (Je = Math.min(Je / xe | 0, 67108863), we._ishlnsubmul(Ee, Je, Pe); we.negative !== 0; )
          Je--, we.negative = 0, we._ishlnsubmul(Ee, 1, Pe), we.isZero() || (we.negative ^= 1);
        Be && (Be.words[Pe] = Je);
      }
      return Be && Be._strip(), we._strip(), pe !== "div" && ve !== 0 && we.iushrn(ve), {
        div: Be || null,
        mod: we
      };
    }, ae.prototype.divmod = function(de, pe, ve) {
      if (ie(!de.isZero()), this.isZero())
        return {
          div: new ae(0),
          mod: new ae(0)
        };
      var we, Ee, xe;
      return this.negative !== 0 && de.negative === 0 ? (xe = this.neg().divmod(de, pe), pe !== "mod" && (we = xe.div.neg()), pe !== "div" && (Ee = xe.mod.neg(), ve && Ee.negative !== 0 && Ee.iadd(de)), {
        div: we,
        mod: Ee
      }) : this.negative === 0 && de.negative !== 0 ? (xe = this.divmod(de.neg(), pe), pe !== "mod" && (we = xe.div.neg()), {
        div: we,
        mod: xe.mod
      }) : this.negative & de.negative ? (xe = this.neg().divmod(de.neg(), pe), pe !== "div" && (Ee = xe.mod.neg(), ve && Ee.negative !== 0 && Ee.isub(de)), {
        div: xe.div,
        mod: Ee
      }) : de.length > this.length || this.cmp(de) < 0 ? {
        div: new ae(0),
        mod: this
      } : de.length === 1 ? pe === "div" ? {
        div: this.divn(de.words[0]),
        mod: null
      } : pe === "mod" ? {
        div: null,
        mod: new ae(this.modrn(de.words[0]))
      } : {
        div: this.divn(de.words[0]),
        mod: new ae(this.modrn(de.words[0]))
      } : this._wordDiv(de, pe);
    }, ae.prototype.div = function(de) {
      return this.divmod(de, "div", !1).div;
    }, ae.prototype.mod = function(de) {
      return this.divmod(de, "mod", !1).mod;
    }, ae.prototype.umod = function(de) {
      return this.divmod(de, "mod", !0).mod;
    }, ae.prototype.divRound = function(de) {
      var pe = this.divmod(de);
      if (pe.mod.isZero()) return pe.div;
      var ve = pe.div.negative !== 0 ? pe.mod.isub(de) : pe.mod, we = de.ushrn(1), Ee = de.andln(1), xe = ve.cmp(we);
      return xe < 0 || Ee === 1 && xe === 0 ? pe.div : pe.div.negative !== 0 ? pe.div.isubn(1) : pe.div.iaddn(1);
    }, ae.prototype.modrn = function(de) {
      var pe = de < 0;
      pe && (de = -de), ie(de <= 67108863);
      for (var ve = (1 << 26) % de, we = 0, Ee = this.length - 1; Ee >= 0; Ee--)
        we = (ve * we + (this.words[Ee] | 0)) % de;
      return pe ? -we : we;
    }, ae.prototype.modn = function(de) {
      return this.modrn(de);
    }, ae.prototype.idivn = function(de) {
      var pe = de < 0;
      pe && (de = -de), ie(de <= 67108863);
      for (var ve = 0, we = this.length - 1; we >= 0; we--) {
        var Ee = (this.words[we] | 0) + ve * 67108864;
        this.words[we] = Ee / de | 0, ve = Ee % de;
      }
      return this._strip(), pe ? this.ineg() : this;
    }, ae.prototype.divn = function(de) {
      return this.clone().idivn(de);
    }, ae.prototype.egcd = function(de) {
      ie(de.negative === 0), ie(!de.isZero());
      var pe = this, ve = de.clone();
      pe.negative !== 0 ? pe = pe.umod(de) : pe = pe.clone();
      for (var we = new ae(1), Ee = new ae(0), xe = new ae(0), ue = new ae(1), ge = 0; pe.isEven() && ve.isEven(); )
        pe.iushrn(1), ve.iushrn(1), ++ge;
      for (var Be = ve.clone(), Ne = pe.clone(); !pe.isZero(); ) {
        for (var Fe = 0, Pe = 1; !(pe.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
        if (Fe > 0)
          for (pe.iushrn(Fe); Fe-- > 0; )
            (we.isOdd() || Ee.isOdd()) && (we.iadd(Be), Ee.isub(Ne)), we.iushrn(1), Ee.iushrn(1);
        for (var Je = 0, Ke = 1; !(ve.words[0] & Ke) && Je < 26; ++Je, Ke <<= 1) ;
        if (Je > 0)
          for (ve.iushrn(Je); Je-- > 0; )
            (xe.isOdd() || ue.isOdd()) && (xe.iadd(Be), ue.isub(Ne)), xe.iushrn(1), ue.iushrn(1);
        pe.cmp(ve) >= 0 ? (pe.isub(ve), we.isub(xe), Ee.isub(ue)) : (ve.isub(pe), xe.isub(we), ue.isub(Ee));
      }
      return {
        a: xe,
        b: ue,
        gcd: ve.iushln(ge)
      };
    }, ae.prototype._invmp = function(de) {
      ie(de.negative === 0), ie(!de.isZero());
      var pe = this, ve = de.clone();
      pe.negative !== 0 ? pe = pe.umod(de) : pe = pe.clone();
      for (var we = new ae(1), Ee = new ae(0), xe = ve.clone(); pe.cmpn(1) > 0 && ve.cmpn(1) > 0; ) {
        for (var ue = 0, ge = 1; !(pe.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
        if (ue > 0)
          for (pe.iushrn(ue); ue-- > 0; )
            we.isOdd() && we.iadd(xe), we.iushrn(1);
        for (var Be = 0, Ne = 1; !(ve.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
        if (Be > 0)
          for (ve.iushrn(Be); Be-- > 0; )
            Ee.isOdd() && Ee.iadd(xe), Ee.iushrn(1);
        pe.cmp(ve) >= 0 ? (pe.isub(ve), we.isub(Ee)) : (ve.isub(pe), Ee.isub(we));
      }
      var Fe;
      return pe.cmpn(1) === 0 ? Fe = we : Fe = Ee, Fe.cmpn(0) < 0 && Fe.iadd(de), Fe;
    }, ae.prototype.gcd = function(de) {
      if (this.isZero()) return de.abs();
      if (de.isZero()) return this.abs();
      var pe = this.clone(), ve = de.clone();
      pe.negative = 0, ve.negative = 0;
      for (var we = 0; pe.isEven() && ve.isEven(); we++)
        pe.iushrn(1), ve.iushrn(1);
      do {
        for (; pe.isEven(); )
          pe.iushrn(1);
        for (; ve.isEven(); )
          ve.iushrn(1);
        var Ee = pe.cmp(ve);
        if (Ee < 0) {
          var xe = pe;
          pe = ve, ve = xe;
        } else if (Ee === 0 || ve.cmpn(1) === 0)
          break;
        pe.isub(ve);
      } while (!0);
      return ve.iushln(we);
    }, ae.prototype.invm = function(de) {
      return this.egcd(de).a.umod(de);
    }, ae.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, ae.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, ae.prototype.andln = function(de) {
      return this.words[0] & de;
    }, ae.prototype.bincn = function(de) {
      ie(typeof de == "number");
      var pe = de % 26, ve = (de - pe) / 26, we = 1 << pe;
      if (this.length <= ve)
        return this._expand(ve + 1), this.words[ve] |= we, this;
      for (var Ee = we, xe = ve; Ee !== 0 && xe < this.length; xe++) {
        var ue = this.words[xe] | 0;
        ue += Ee, Ee = ue >>> 26, ue &= 67108863, this.words[xe] = ue;
      }
      return Ee !== 0 && (this.words[xe] = Ee, this.length++), this;
    }, ae.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, ae.prototype.cmpn = function(de) {
      var pe = de < 0;
      if (this.negative !== 0 && !pe) return -1;
      if (this.negative === 0 && pe) return 1;
      this._strip();
      var ve;
      if (this.length > 1)
        ve = 1;
      else {
        pe && (de = -de), ie(de <= 67108863, "Number is too big");
        var we = this.words[0] | 0;
        ve = we === de ? 0 : we < de ? -1 : 1;
      }
      return this.negative !== 0 ? -ve | 0 : ve;
    }, ae.prototype.cmp = function(de) {
      if (this.negative !== 0 && de.negative === 0) return -1;
      if (this.negative === 0 && de.negative !== 0) return 1;
      var pe = this.ucmp(de);
      return this.negative !== 0 ? -pe | 0 : pe;
    }, ae.prototype.ucmp = function(de) {
      if (this.length > de.length) return 1;
      if (this.length < de.length) return -1;
      for (var pe = 0, ve = this.length - 1; ve >= 0; ve--) {
        var we = this.words[ve] | 0, Ee = de.words[ve] | 0;
        if (we !== Ee) {
          we < Ee ? pe = -1 : we > Ee && (pe = 1);
          break;
        }
      }
      return pe;
    }, ae.prototype.gtn = function(de) {
      return this.cmpn(de) === 1;
    }, ae.prototype.gt = function(de) {
      return this.cmp(de) === 1;
    }, ae.prototype.gten = function(de) {
      return this.cmpn(de) >= 0;
    }, ae.prototype.gte = function(de) {
      return this.cmp(de) >= 0;
    }, ae.prototype.ltn = function(de) {
      return this.cmpn(de) === -1;
    }, ae.prototype.lt = function(de) {
      return this.cmp(de) === -1;
    }, ae.prototype.lten = function(de) {
      return this.cmpn(de) <= 0;
    }, ae.prototype.lte = function(de) {
      return this.cmp(de) <= 0;
    }, ae.prototype.eqn = function(de) {
      return this.cmpn(de) === 0;
    }, ae.prototype.eq = function(de) {
      return this.cmp(de) === 0;
    }, ae.red = function(de) {
      return new _e(de);
    }, ae.prototype.toRed = function(de) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), de.convertTo(this)._forceRed(de);
    }, ae.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, ae.prototype._forceRed = function(de) {
      return this.red = de, this;
    }, ae.prototype.forceRed = function(de) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(de);
    }, ae.prototype.redAdd = function(de) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, de);
    }, ae.prototype.redIAdd = function(de) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, de);
    }, ae.prototype.redSub = function(de) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, de);
    }, ae.prototype.redISub = function(de) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, de);
    }, ae.prototype.redShl = function(de) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, de);
    }, ae.prototype.redMul = function(de) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, de), this.red.mul(this, de);
    }, ae.prototype.redIMul = function(de) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, de), this.red.imul(this, de);
    }, ae.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, ae.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, ae.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, ae.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, ae.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, ae.prototype.redPow = function(de) {
      return ie(this.red && !de.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, de);
    };
    var ze = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ve(ce, de) {
      this.name = ce, this.p = new ae(de, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ve.prototype._tmp = function() {
      var de = new ae(null);
      return de.words = new Array(Math.ceil(this.n / 13)), de;
    }, Ve.prototype.ireduce = function(de) {
      var pe = de, ve;
      do
        this.split(pe, this.tmp), pe = this.imulK(pe), pe = pe.iadd(this.tmp), ve = pe.bitLength();
      while (ve > this.n);
      var we = ve < this.n ? -1 : pe.ucmp(this.p);
      return we === 0 ? (pe.words[0] = 0, pe.length = 1) : we > 0 ? pe.isub(this.p) : pe.strip !== void 0 ? pe.strip() : pe._strip(), pe;
    }, Ve.prototype.split = function(de, pe) {
      de.iushrn(this.n, 0, pe);
    }, Ve.prototype.imulK = function(de) {
      return de.imul(this.k);
    };
    function Mt() {
      Ve.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    fe(Mt, Ve), Mt.prototype.split = function(de, pe) {
      for (var ve = 4194303, we = Math.min(de.length, 9), Ee = 0; Ee < we; Ee++)
        pe.words[Ee] = de.words[Ee];
      if (pe.length = we, de.length <= 9) {
        de.words[0] = 0, de.length = 1;
        return;
      }
      var xe = de.words[9];
      for (pe.words[pe.length++] = xe & ve, Ee = 10; Ee < de.length; Ee++) {
        var ue = de.words[Ee] | 0;
        de.words[Ee - 10] = (ue & ve) << 4 | xe >>> 22, xe = ue;
      }
      xe >>>= 22, de.words[Ee - 10] = xe, xe === 0 && de.length > 10 ? de.length -= 10 : de.length -= 9;
    }, Mt.prototype.imulK = function(de) {
      de.words[de.length] = 0, de.words[de.length + 1] = 0, de.length += 2;
      for (var pe = 0, ve = 0; ve < de.length; ve++) {
        var we = de.words[ve] | 0;
        pe += we * 977, de.words[ve] = pe & 67108863, pe = we * 64 + (pe / 67108864 | 0);
      }
      return de.words[de.length - 1] === 0 && (de.length--, de.words[de.length - 1] === 0 && de.length--), de;
    };
    function Rt() {
      Ve.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    fe(Rt, Ve);
    function je() {
      Ve.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    fe(je, Ve);
    function jt() {
      Ve.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    fe(jt, Ve), jt.prototype.imulK = function(de) {
      for (var pe = 0, ve = 0; ve < de.length; ve++) {
        var we = (de.words[ve] | 0) * 19 + pe, Ee = we & 67108863;
        we >>>= 26, de.words[ve] = Ee, pe = we;
      }
      return pe !== 0 && (de.words[de.length++] = pe), de;
    }, ae._prime = function(de) {
      if (ze[de]) return ze[de];
      var pe;
      if (de === "k256")
        pe = new Mt();
      else if (de === "p224")
        pe = new Rt();
      else if (de === "p192")
        pe = new je();
      else if (de === "p25519")
        pe = new jt();
      else
        throw new Error("Unknown prime " + de);
      return ze[de] = pe, pe;
    };
    function _e(ce) {
      if (typeof ce == "string") {
        var de = ae._prime(ce);
        this.m = de.p, this.prime = de;
      } else
        ie(ce.gtn(1), "modulus must be greater than 1"), this.m = ce, this.prime = null;
    }
    _e.prototype._verify1 = function(de) {
      ie(de.negative === 0, "red works only with positives"), ie(de.red, "red works only with red numbers");
    }, _e.prototype._verify2 = function(de, pe) {
      ie((de.negative | pe.negative) === 0, "red works only with positives"), ie(
        de.red && de.red === pe.red,
        "red works only with red numbers"
      );
    }, _e.prototype.imod = function(de) {
      return this.prime ? this.prime.ireduce(de)._forceRed(this) : (be(de, de.umod(this.m)._forceRed(this)), de);
    }, _e.prototype.neg = function(de) {
      return de.isZero() ? de.clone() : this.m.sub(de)._forceRed(this);
    }, _e.prototype.add = function(de, pe) {
      this._verify2(de, pe);
      var ve = de.add(pe);
      return ve.cmp(this.m) >= 0 && ve.isub(this.m), ve._forceRed(this);
    }, _e.prototype.iadd = function(de, pe) {
      this._verify2(de, pe);
      var ve = de.iadd(pe);
      return ve.cmp(this.m) >= 0 && ve.isub(this.m), ve;
    }, _e.prototype.sub = function(de, pe) {
      this._verify2(de, pe);
      var ve = de.sub(pe);
      return ve.cmpn(0) < 0 && ve.iadd(this.m), ve._forceRed(this);
    }, _e.prototype.isub = function(de, pe) {
      this._verify2(de, pe);
      var ve = de.isub(pe);
      return ve.cmpn(0) < 0 && ve.iadd(this.m), ve;
    }, _e.prototype.shl = function(de, pe) {
      return this._verify1(de), this.imod(de.ushln(pe));
    }, _e.prototype.imul = function(de, pe) {
      return this._verify2(de, pe), this.imod(de.imul(pe));
    }, _e.prototype.mul = function(de, pe) {
      return this._verify2(de, pe), this.imod(de.mul(pe));
    }, _e.prototype.isqr = function(de) {
      return this.imul(de, de.clone());
    }, _e.prototype.sqr = function(de) {
      return this.mul(de, de);
    }, _e.prototype.sqrt = function(de) {
      if (de.isZero()) return de.clone();
      var pe = this.m.andln(3);
      if (ie(pe % 2 === 1), pe === 3) {
        var ve = this.m.add(new ae(1)).iushrn(2);
        return this.pow(de, ve);
      }
      for (var we = this.m.subn(1), Ee = 0; !we.isZero() && we.andln(1) === 0; )
        Ee++, we.iushrn(1);
      ie(!we.isZero());
      var xe = new ae(1).toRed(this), ue = xe.redNeg(), ge = this.m.subn(1).iushrn(1), Be = this.m.bitLength();
      for (Be = new ae(2 * Be * Be).toRed(this); this.pow(Be, ge).cmp(ue) !== 0; )
        Be.redIAdd(ue);
      for (var Ne = this.pow(Be, we), Fe = this.pow(de, we.addn(1).iushrn(1)), Pe = this.pow(de, we), Je = Ee; Pe.cmp(xe) !== 0; ) {
        for (var Ke = Pe, Ze = 0; Ke.cmp(xe) !== 0; Ze++)
          Ke = Ke.redSqr();
        ie(Ze < Je);
        var Ye = this.pow(Ne, new ae(1).iushln(Je - Ze - 1));
        Fe = Fe.redMul(Ye), Ne = Ye.redSqr(), Pe = Pe.redMul(Ne), Je = Ze;
      }
      return Fe;
    }, _e.prototype.invm = function(de) {
      var pe = de._invmp(this.m);
      return pe.negative !== 0 ? (pe.negative = 0, this.imod(pe).redNeg()) : this.imod(pe);
    }, _e.prototype.pow = function(de, pe) {
      if (pe.isZero()) return new ae(1).toRed(this);
      if (pe.cmpn(1) === 0) return de.clone();
      var ve = 4, we = new Array(1 << ve);
      we[0] = new ae(1).toRed(this), we[1] = de;
      for (var Ee = 2; Ee < we.length; Ee++)
        we[Ee] = this.mul(we[Ee - 1], de);
      var xe = we[0], ue = 0, ge = 0, Be = pe.bitLength() % 26;
      for (Be === 0 && (Be = 26), Ee = pe.length - 1; Ee >= 0; Ee--) {
        for (var Ne = pe.words[Ee], Fe = Be - 1; Fe >= 0; Fe--) {
          var Pe = Ne >> Fe & 1;
          if (xe !== we[0] && (xe = this.sqr(xe)), Pe === 0 && ue === 0) {
            ge = 0;
            continue;
          }
          ue <<= 1, ue |= Pe, ge++, !(ge !== ve && (Ee !== 0 || Fe !== 0)) && (xe = this.mul(xe, we[ue]), ge = 0, ue = 0);
        }
        Be = 26;
      }
      return xe;
    }, _e.prototype.convertTo = function(de) {
      var pe = de.umod(this.m);
      return pe === de ? pe.clone() : pe;
    }, _e.prototype.convertFrom = function(de) {
      var pe = de.clone();
      return pe.red = null, pe;
    }, ae.mont = function(de) {
      return new se(de);
    };
    function se(ce) {
      _e.call(this, ce), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    fe(se, _e), se.prototype.convertTo = function(de) {
      return this.imod(de.ushln(this.shift));
    }, se.prototype.convertFrom = function(de) {
      var pe = this.imod(de.mul(this.rinv));
      return pe.red = null, pe;
    }, se.prototype.imul = function(de, pe) {
      if (de.isZero() || pe.isZero())
        return de.words[0] = 0, de.length = 1, de;
      var ve = de.imul(pe), we = ve.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Ee = ve.isub(we).iushrn(this.shift), xe = Ee;
      return Ee.cmp(this.m) >= 0 ? xe = Ee.isub(this.m) : Ee.cmpn(0) < 0 && (xe = Ee.iadd(this.m)), xe._forceRed(this);
    }, se.prototype.mul = function(de, pe) {
      if (de.isZero() || pe.isZero()) return new ae(0)._forceRed(this);
      var ve = de.mul(pe), we = ve.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Ee = ve.isub(we).iushrn(this.shift), xe = Ee;
      return Ee.cmp(this.m) >= 0 ? xe = Ee.isub(this.m) : Ee.cmpn(0) < 0 && (xe = Ee.iadd(this.m)), xe._forceRed(this);
    }, se.prototype.invm = function(de) {
      var pe = this.imod(de._invmp(this.m).mul(this.r2));
      return pe._forceRed(this);
    };
  })(c, commonjsGlobal);
})(bn$9);
var bnExports$3 = bn$9.exports;
const BN$8 = /* @__PURE__ */ getDefaultExportFromCjs$2(bnExports$3), version$v = "logger/5.7.0";
let _permanentCensorErrors = !1, _censorErrors = !1;
const LogLevels = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels.default, _globalLogger = null;
function _checkNormalize() {
  try {
    const c = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        c.push(t);
      }
    }), c.length)
      throw new Error("missing " + c.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (c) {
    return c.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(c) {
  c.DEBUG = "DEBUG", c.INFO = "INFO", c.WARNING = "WARNING", c.ERROR = "ERROR", c.OFF = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(c) {
  c.UNKNOWN_ERROR = "UNKNOWN_ERROR", c.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", c.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", c.NETWORK_ERROR = "NETWORK_ERROR", c.SERVER_ERROR = "SERVER_ERROR", c.TIMEOUT = "TIMEOUT", c.BUFFER_OVERRUN = "BUFFER_OVERRUN", c.NUMERIC_FAULT = "NUMERIC_FAULT", c.MISSING_NEW = "MISSING_NEW", c.INVALID_ARGUMENT = "INVALID_ARGUMENT", c.MISSING_ARGUMENT = "MISSING_ARGUMENT", c.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", c.CALL_EXCEPTION = "CALL_EXCEPTION", c.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", c.NONCE_EXPIRED = "NONCE_EXPIRED", c.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", c.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", c.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", c.ACTION_REJECTED = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, n) {
    const ie = t.toLowerCase();
    LogLevels[ie] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(_logLevel > LogLevels[ie]) && console.log.apply(console, n);
  }
  debug(...t) {
    this._log(Logger.levels.DEBUG, t);
  }
  info(...t) {
    this._log(Logger.levels.INFO, t);
  }
  warn(...t) {
    this._log(Logger.levels.WARNING, t);
  }
  makeError(t, n, ie) {
    if (_censorErrors)
      return this.makeError("censored error", n, {});
    n || (n = Logger.errors.UNKNOWN_ERROR), ie || (ie = {});
    const fe = [];
    Object.keys(ie).forEach((me) => {
      const ye = ie[me];
      try {
        if (ye instanceof Uint8Array) {
          let be = "";
          for (let Ae = 0; Ae < ye.length; Ae++)
            be += HEX[ye[Ae] >> 4], be += HEX[ye[Ae] & 15];
          fe.push(me + "=Uint8Array(0x" + be + ")");
        } else
          fe.push(me + "=" + JSON.stringify(ye));
      } catch {
        fe.push(me + "=" + JSON.stringify(ie[me].toString()));
      }
    }), fe.push(`code=${n}`), fe.push(`version=${this.version}`);
    const ae = t;
    let le = "";
    switch (n) {
      case ErrorCode.NUMERIC_FAULT: {
        le = "NUMERIC_FAULT";
        const me = t;
        switch (me) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            le += "-" + me;
            break;
          case "negative-power":
          case "negative-width":
            le += "-unsupported";
            break;
          case "unbound-bitwise-result":
            le += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        le = n;
        break;
    }
    le && (t += " [ See: https://links.ethers.org/v5-errors-" + le + " ]"), fe.length && (t += " (" + fe.join(", ") + ")");
    const he = new Error(t);
    return he.reason = ae, he.code = n, Object.keys(ie).forEach(function(me) {
      he[me] = ie[me];
    }), he;
  }
  throwError(t, n, ie) {
    throw this.makeError(t, n, ie);
  }
  throwArgumentError(t, n, ie) {
    return this.throwError(t, Logger.errors.INVALID_ARGUMENT, {
      argument: n,
      value: ie
    });
  }
  assert(t, n, ie, fe) {
    t || this.throwError(n, ie, fe);
  }
  assertArgument(t, n, ie, fe) {
    t || this.throwArgumentError(n, ie, fe);
  }
  checkNormalize(t) {
    _normalizeError && this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: _normalizeError
    });
  }
  checkSafeUint53(t, n) {
    typeof t == "number" && (n == null && (n = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(n, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(n, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, n, ie) {
    ie ? ie = ": " + ie : ie = "", t < n && this.throwError("missing argument" + ie, Logger.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: n
    }), t > n && this.throwError("too many arguments" + ie, Logger.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: n
    });
  }
  checkNew(t, n) {
    (t === Object || t == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: n.name });
  }
  checkAbstract(t, n) {
    t === n ? this.throwError("cannot instantiate abstract class " + JSON.stringify(n.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: n.name });
  }
  static globalLogger() {
    return _globalLogger || (_globalLogger = new Logger(version$v)), _globalLogger;
  }
  static setCensorship(t, n) {
    if (!t && n && this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), _permanentCensorErrors) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!t, _permanentCensorErrors = !!n;
  }
  static setLogLevel(t) {
    const n = LogLevels[t.toLowerCase()];
    if (n == null) {
      Logger.globalLogger().warn("invalid log level - " + t);
      return;
    }
    _logLevel = n;
  }
  static from(t) {
    return new Logger(t);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
const lib_esm$k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ErrorCode() {
    return ErrorCode;
  },
  get LogLevel() {
    return LogLevel;
  },
  Logger
}, Symbol.toStringTag, { value: "Module" })), version$u = "bytes/5.7.0", logger$x = new Logger(version$u);
function isHexable(c) {
  return !!c.toHexString;
}
function addSlice(c) {
  return c.slice || (c.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(c, t)));
  }), c;
}
function isBytesLike(c) {
  return isHexString(c) && !(c.length % 2) || isBytes$2(c);
}
function isInteger(c) {
  return typeof c == "number" && c == c && c % 1 === 0;
}
function isBytes$2(c) {
  if (c == null)
    return !1;
  if (c.constructor === Uint8Array)
    return !0;
  if (typeof c == "string" || !isInteger(c.length) || c.length < 0)
    return !1;
  for (let t = 0; t < c.length; t++) {
    const n = c[t];
    if (!isInteger(n) || n < 0 || n >= 256)
      return !1;
  }
  return !0;
}
function arrayify(c, t) {
  if (t || (t = {}), typeof c == "number") {
    logger$x.checkSafeUint53(c, "invalid arrayify value");
    const n = [];
    for (; c; )
      n.unshift(c & 255), c = parseInt(String(c / 256));
    return n.length === 0 && n.push(0), addSlice(new Uint8Array(n));
  }
  if (t.allowMissingPrefix && typeof c == "string" && c.substring(0, 2) !== "0x" && (c = "0x" + c), isHexable(c) && (c = c.toHexString()), isHexString(c)) {
    let n = c.substring(2);
    n.length % 2 && (t.hexPad === "left" ? n = "0" + n : t.hexPad === "right" ? n += "0" : logger$x.throwArgumentError("hex data is odd-length", "value", c));
    const ie = [];
    for (let fe = 0; fe < n.length; fe += 2)
      ie.push(parseInt(n.substring(fe, fe + 2), 16));
    return addSlice(new Uint8Array(ie));
  }
  return isBytes$2(c) ? addSlice(new Uint8Array(c)) : logger$x.throwArgumentError("invalid arrayify value", "value", c);
}
function concat$1(c) {
  const t = c.map((fe) => arrayify(fe)), n = t.reduce((fe, ae) => fe + ae.length, 0), ie = new Uint8Array(n);
  return t.reduce((fe, ae) => (ie.set(ae, fe), fe + ae.length), 0), addSlice(ie);
}
function stripZeros(c) {
  let t = arrayify(c);
  if (t.length === 0)
    return t;
  let n = 0;
  for (; n < t.length && t[n] === 0; )
    n++;
  return n && (t = t.slice(n)), t;
}
function zeroPad(c, t) {
  c = arrayify(c), c.length > t && logger$x.throwArgumentError("value out of range", "value", arguments[0]);
  const n = new Uint8Array(t);
  return n.set(c, t - c.length), addSlice(n);
}
function isHexString(c, t) {
  return !(typeof c != "string" || !c.match(/^0x[0-9A-Fa-f]*$/) || t && c.length !== 2 + 2 * t);
}
const HexCharacters = "0123456789abcdef";
function hexlify(c, t) {
  if (t || (t = {}), typeof c == "number") {
    logger$x.checkSafeUint53(c, "invalid hexlify value");
    let n = "";
    for (; c; )
      n = HexCharacters[c & 15] + n, c = Math.floor(c / 16);
    return n.length ? (n.length % 2 && (n = "0" + n), "0x" + n) : "0x00";
  }
  if (typeof c == "bigint")
    return c = c.toString(16), c.length % 2 ? "0x0" + c : "0x" + c;
  if (t.allowMissingPrefix && typeof c == "string" && c.substring(0, 2) !== "0x" && (c = "0x" + c), isHexable(c))
    return c.toHexString();
  if (isHexString(c))
    return c.length % 2 && (t.hexPad === "left" ? c = "0x0" + c.substring(2) : t.hexPad === "right" ? c += "0" : logger$x.throwArgumentError("hex data is odd-length", "value", c)), c.toLowerCase();
  if (isBytes$2(c)) {
    let n = "0x";
    for (let ie = 0; ie < c.length; ie++) {
      let fe = c[ie];
      n += HexCharacters[(fe & 240) >> 4] + HexCharacters[fe & 15];
    }
    return n;
  }
  return logger$x.throwArgumentError("invalid hexlify value", "value", c);
}
function hexDataLength(c) {
  if (typeof c != "string")
    c = hexlify(c);
  else if (!isHexString(c) || c.length % 2)
    return null;
  return (c.length - 2) / 2;
}
function hexDataSlice(c, t, n) {
  return typeof c != "string" ? c = hexlify(c) : (!isHexString(c) || c.length % 2) && logger$x.throwArgumentError("invalid hexData", "value", c), t = 2 + 2 * t, n != null ? "0x" + c.substring(t, 2 + 2 * n) : "0x" + c.substring(t);
}
function hexConcat(c) {
  let t = "0x";
  return c.forEach((n) => {
    t += hexlify(n).substring(2);
  }), t;
}
function hexValue(c) {
  const t = hexStripZeros(hexlify(c, { hexPad: "left" }));
  return t === "0x" ? "0x0" : t;
}
function hexStripZeros(c) {
  typeof c != "string" && (c = hexlify(c)), isHexString(c) || logger$x.throwArgumentError("invalid hex string", "value", c), c = c.substring(2);
  let t = 0;
  for (; t < c.length && c[t] === "0"; )
    t++;
  return "0x" + c.substring(t);
}
function hexZeroPad(c, t) {
  for (typeof c != "string" ? c = hexlify(c) : isHexString(c) || logger$x.throwArgumentError("invalid hex string", "value", c), c.length > 2 * t + 2 && logger$x.throwArgumentError("value out of range", "value", arguments[1]); c.length < 2 * t + 2; )
    c = "0x0" + c.substring(2);
  return c;
}
function splitSignature(c) {
  const t = {
    r: "0x",
    s: "0x",
    _vs: "0x",
    recoveryParam: 0,
    v: 0,
    yParityAndS: "0x",
    compact: "0x"
  };
  if (isBytesLike(c)) {
    let n = arrayify(c);
    n.length === 64 ? (t.v = 27 + (n[32] >> 7), n[32] &= 127, t.r = hexlify(n.slice(0, 32)), t.s = hexlify(n.slice(32, 64))) : n.length === 65 ? (t.r = hexlify(n.slice(0, 32)), t.s = hexlify(n.slice(32, 64)), t.v = n[64]) : logger$x.throwArgumentError("invalid signature string", "signature", c), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : logger$x.throwArgumentError("signature invalid v byte", "signature", c)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (n[32] |= 128), t._vs = hexlify(n.slice(32, 64));
  } else {
    if (t.r = c.r, t.s = c.s, t.v = c.v, t.recoveryParam = c.recoveryParam, t._vs = c._vs, t._vs != null) {
      const fe = zeroPad(arrayify(t._vs), 32);
      t._vs = hexlify(fe);
      const ae = fe[0] >= 128 ? 1 : 0;
      t.recoveryParam == null ? t.recoveryParam = ae : t.recoveryParam !== ae && logger$x.throwArgumentError("signature recoveryParam mismatch _vs", "signature", c), fe[0] &= 127;
      const le = hexlify(fe);
      t.s == null ? t.s = le : t.s !== le && logger$x.throwArgumentError("signature v mismatch _vs", "signature", c);
    }
    if (t.recoveryParam == null)
      t.v == null ? logger$x.throwArgumentError("signature missing v and recoveryParam", "signature", c) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
    else if (t.v == null)
      t.v = 27 + t.recoveryParam;
    else {
      const fe = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
      t.recoveryParam !== fe && logger$x.throwArgumentError("signature recoveryParam mismatch v", "signature", c);
    }
    t.r == null || !isHexString(t.r) ? logger$x.throwArgumentError("signature missing or invalid r", "signature", c) : t.r = hexZeroPad(t.r, 32), t.s == null || !isHexString(t.s) ? logger$x.throwArgumentError("signature missing or invalid s", "signature", c) : t.s = hexZeroPad(t.s, 32);
    const n = arrayify(t.s);
    n[0] >= 128 && logger$x.throwArgumentError("signature s out of range", "signature", c), t.recoveryParam && (n[0] |= 128);
    const ie = hexlify(n);
    t._vs && (isHexString(t._vs) || logger$x.throwArgumentError("signature invalid _vs", "signature", c), t._vs = hexZeroPad(t._vs, 32)), t._vs == null ? t._vs = ie : t._vs !== ie && logger$x.throwArgumentError("signature _vs mismatch v and s", "signature", c);
  }
  return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function joinSignature(c) {
  return c = splitSignature(c), hexlify(concat$1([
    c.r,
    c.s,
    c.recoveryParam ? "0x1c" : "0x1b"
  ]));
}
const lib_esm$j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayify,
  concat: concat$1,
  hexConcat,
  hexDataLength,
  hexDataSlice,
  hexStripZeros,
  hexValue,
  hexZeroPad,
  hexlify,
  isBytes: isBytes$2,
  isBytesLike,
  isHexString,
  joinSignature,
  splitSignature,
  stripZeros,
  zeroPad
}, Symbol.toStringTag, { value: "Module" })), version$t = "bignumber/5.7.0";
var BN$7 = BN$8.BN;
const logger$w = new Logger(version$t), _constructorGuard$4 = {}, MAX_SAFE = 9007199254740991;
function isBigNumberish(c) {
  return c != null && (BigNumber.isBigNumber(c) || typeof c == "number" && c % 1 === 0 || typeof c == "string" && !!c.match(/^-?[0-9]+$/) || isHexString(c) || typeof c == "bigint" || isBytes$2(c));
}
let _warnedToStringRadix = !1;
class BigNumber {
  constructor(t, n) {
    t !== _constructorGuard$4 && logger$w.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = n, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return toBigNumber(toBN(this).fromTwos(t));
  }
  toTwos(t) {
    return toBigNumber(toBN(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? BigNumber.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return toBigNumber(toBN(this).add(toBN(t)));
  }
  sub(t) {
    return toBigNumber(toBN(this).sub(toBN(t)));
  }
  div(t) {
    return BigNumber.from(t).isZero() && throwFault$1("division-by-zero", "div"), toBigNumber(toBN(this).div(toBN(t)));
  }
  mul(t) {
    return toBigNumber(toBN(this).mul(toBN(t)));
  }
  mod(t) {
    const n = toBN(t);
    return n.isNeg() && throwFault$1("division-by-zero", "mod"), toBigNumber(toBN(this).umod(n));
  }
  pow(t) {
    const n = toBN(t);
    return n.isNeg() && throwFault$1("negative-power", "pow"), toBigNumber(toBN(this).pow(n));
  }
  and(t) {
    const n = toBN(t);
    return (this.isNegative() || n.isNeg()) && throwFault$1("unbound-bitwise-result", "and"), toBigNumber(toBN(this).and(n));
  }
  or(t) {
    const n = toBN(t);
    return (this.isNegative() || n.isNeg()) && throwFault$1("unbound-bitwise-result", "or"), toBigNumber(toBN(this).or(n));
  }
  xor(t) {
    const n = toBN(t);
    return (this.isNegative() || n.isNeg()) && throwFault$1("unbound-bitwise-result", "xor"), toBigNumber(toBN(this).xor(n));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "mask"), toBigNumber(toBN(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "shl"), toBigNumber(toBN(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "shr"), toBigNumber(toBN(this).shrn(t));
  }
  eq(t) {
    return toBN(this).eq(toBN(t));
  }
  lt(t) {
    return toBN(this).lt(toBN(t));
  }
  lte(t) {
    return toBN(this).lte(toBN(t));
  }
  gt(t) {
    return toBN(this).gt(toBN(t));
  }
  gte(t) {
    return toBN(this).gte(toBN(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch {
      throwFault$1("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return logger$w.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? _warnedToStringRadix || (_warnedToStringRadix = !0, logger$w.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? logger$w.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {}) : logger$w.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {})), toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof BigNumber)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new BigNumber(_constructorGuard$4, toHex$2(t)) : t.match(/^-?[0-9]+$/) ? new BigNumber(_constructorGuard$4, toHex$2(new BN$7(t))) : logger$w.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && throwFault$1("underflow", "BigNumber.from", t), (t >= MAX_SAFE || t <= -MAX_SAFE) && throwFault$1("overflow", "BigNumber.from", t), BigNumber.from(String(t));
    const n = t;
    if (typeof n == "bigint")
      return BigNumber.from(n.toString());
    if (isBytes$2(n))
      return BigNumber.from(hexlify(n));
    if (n)
      if (n.toHexString) {
        const ie = n.toHexString();
        if (typeof ie == "string")
          return BigNumber.from(ie);
      } else {
        let ie = n._hex;
        if (ie == null && n.type === "BigNumber" && (ie = n.hex), typeof ie == "string" && (isHexString(ie) || ie[0] === "-" && isHexString(ie.substring(1))))
          return BigNumber.from(ie);
      }
    return logger$w.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function toHex$2(c) {
  if (typeof c != "string")
    return toHex$2(c.toString(16));
  if (c[0] === "-")
    return c = c.substring(1), c[0] === "-" && logger$w.throwArgumentError("invalid hex", "value", c), c = toHex$2(c), c === "0x00" ? c : "-" + c;
  if (c.substring(0, 2) !== "0x" && (c = "0x" + c), c === "0x")
    return "0x00";
  for (c.length % 2 && (c = "0x0" + c.substring(2)); c.length > 4 && c.substring(0, 4) === "0x00"; )
    c = "0x" + c.substring(4);
  return c;
}
function toBigNumber(c) {
  return BigNumber.from(toHex$2(c));
}
function toBN(c) {
  const t = BigNumber.from(c).toHexString();
  return t[0] === "-" ? new BN$7("-" + t.substring(3), 16) : new BN$7(t.substring(2), 16);
}
function throwFault$1(c, t, n) {
  const ie = { fault: c, operation: t };
  return n != null && (ie.value = n), logger$w.throwError(c, Logger.errors.NUMERIC_FAULT, ie);
}
function _base36To16(c) {
  return new BN$7(c, 36).toString(16);
}
function _base16To36(c) {
  return new BN$7(c, 16).toString(36);
}
const logger$v = new Logger(version$t), _constructorGuard$3 = {}, Zero$2 = BigNumber.from(0), NegativeOne$2 = BigNumber.from(-1);
function throwFault(c, t, n, ie) {
  const fe = { fault: t, operation: n };
  return ie !== void 0 && (fe.value = ie), logger$v.throwError(c, Logger.errors.NUMERIC_FAULT, fe);
}
let zeros = "0";
for (; zeros.length < 256; )
  zeros += zeros;
function getMultiplier(c) {
  if (typeof c != "number")
    try {
      c = BigNumber.from(c).toNumber();
    } catch {
    }
  return typeof c == "number" && c >= 0 && c <= 256 && !(c % 1) ? "1" + zeros.substring(0, c) : logger$v.throwArgumentError("invalid decimal size", "decimals", c);
}
function formatFixed(c, t) {
  t == null && (t = 0);
  const n = getMultiplier(t);
  c = BigNumber.from(c);
  const ie = c.lt(Zero$2);
  ie && (c = c.mul(NegativeOne$2));
  let fe = c.mod(n).toString();
  for (; fe.length < n.length - 1; )
    fe = "0" + fe;
  fe = fe.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const ae = c.div(n).toString();
  return n.length === 1 ? c = ae : c = ae + "." + fe, ie && (c = "-" + c), c;
}
function parseFixed(c, t) {
  t == null && (t = 0);
  const n = getMultiplier(t);
  (typeof c != "string" || !c.match(/^-?[0-9.]+$/)) && logger$v.throwArgumentError("invalid decimal value", "value", c);
  const ie = c.substring(0, 1) === "-";
  ie && (c = c.substring(1)), c === "." && logger$v.throwArgumentError("missing value", "value", c);
  const fe = c.split(".");
  fe.length > 2 && logger$v.throwArgumentError("too many decimal points", "value", c);
  let ae = fe[0], le = fe[1];
  for (ae || (ae = "0"), le || (le = "0"); le[le.length - 1] === "0"; )
    le = le.substring(0, le.length - 1);
  for (le.length > n.length - 1 && throwFault("fractional component exceeds decimals", "underflow", "parseFixed"), le === "" && (le = "0"); le.length < n.length - 1; )
    le += "0";
  const he = BigNumber.from(ae), me = BigNumber.from(le);
  let ye = he.mul(n).add(me);
  return ie && (ye = ye.mul(NegativeOne$2)), ye;
}
class FixedFormat {
  constructor(t, n, ie, fe) {
    t !== _constructorGuard$3 && logger$v.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = n, this.width = ie, this.decimals = fe, this.name = (n ? "" : "u") + "fixed" + String(ie) + "x" + String(fe), this._multiplier = getMultiplier(fe), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof FixedFormat)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let n = !0, ie = 128, fe = 18;
    if (typeof t == "string") {
      if (t !== "fixed") if (t === "ufixed")
        n = !1;
      else {
        const ae = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        ae || logger$v.throwArgumentError("invalid fixed format", "format", t), n = ae[1] !== "u", ie = parseInt(ae[2]), fe = parseInt(ae[3]);
      }
    } else if (t) {
      const ae = (le, he, me) => t[le] == null ? me : (typeof t[le] !== he && logger$v.throwArgumentError("invalid fixed format (" + le + " not " + he + ")", "format." + le, t[le]), t[le]);
      n = ae("signed", "boolean", n), ie = ae("width", "number", ie), fe = ae("decimals", "number", fe);
    }
    return ie % 8 && logger$v.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", ie), fe > 80 && logger$v.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", fe), new FixedFormat(_constructorGuard$3, n, ie, fe);
  }
}
class FixedNumber {
  constructor(t, n, ie, fe) {
    t !== _constructorGuard$3 && logger$v.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = fe, this._hex = n, this._value = ie, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && logger$v.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const n = parseFixed(this._value, this.format.decimals), ie = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(n.add(ie), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const n = parseFixed(this._value, this.format.decimals), ie = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(n.sub(ie), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const n = parseFixed(this._value, this.format.decimals), ie = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(n.mul(ie).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const n = parseFixed(this._value, this.format.decimals), ie = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(n.mul(this.format._multiplier).div(ie), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let n = FixedNumber.from(t[0], this.format);
    const ie = !t[1].match(/^(0*)$/);
    return this.isNegative() && ie && (n = n.subUnsafe(ONE.toFormat(n.format))), n;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let n = FixedNumber.from(t[0], this.format);
    const ie = !t[1].match(/^(0*)$/);
    return !this.isNegative() && ie && (n = n.addUnsafe(ONE.toFormat(n.format))), n;
  }
  // @TODO: Support other rounding algorithms
  round(t) {
    t == null && (t = 0);
    const n = this.toString().split(".");
    if (n.length === 1 && n.push("0"), (t < 0 || t > 80 || t % 1) && logger$v.throwArgumentError("invalid decimal count", "decimals", t), n[1].length <= t)
      return this;
    const ie = FixedNumber.from("1" + zeros.substring(0, t), this.format), fe = BUMP.toFormat(this.format);
    return this.mulUnsafe(ie).addUnsafe(fe).floor().divUnsafe(ie);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && logger$v.throwArgumentError("invalid byte width", "width", t);
    const n = BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return hexZeroPad(n, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return FixedNumber.fromString(this._value, t);
  }
  static fromValue(t, n, ie) {
    return ie == null && n != null && !isBigNumberish(n) && (ie = n, n = null), n == null && (n = 0), ie == null && (ie = "fixed"), FixedNumber.fromString(formatFixed(t, n), FixedFormat.from(ie));
  }
  static fromString(t, n) {
    n == null && (n = "fixed");
    const ie = FixedFormat.from(n), fe = parseFixed(t, ie.decimals);
    !ie.signed && fe.lt(Zero$2) && throwFault("unsigned value cannot be negative", "overflow", "value", t);
    let ae = null;
    ie.signed ? ae = fe.toTwos(ie.width).toHexString() : (ae = fe.toHexString(), ae = hexZeroPad(ae, ie.width / 8));
    const le = formatFixed(fe, ie.decimals);
    return new FixedNumber(_constructorGuard$3, ae, le, ie);
  }
  static fromBytes(t, n) {
    n == null && (n = "fixed");
    const ie = FixedFormat.from(n);
    if (arrayify(t).length > ie.width / 8)
      throw new Error("overflow");
    let fe = BigNumber.from(t);
    ie.signed && (fe = fe.fromTwos(ie.width));
    const ae = fe.toTwos((ie.signed ? 0 : 1) + ie.width).toHexString(), le = formatFixed(fe, ie.decimals);
    return new FixedNumber(_constructorGuard$3, ae, le, ie);
  }
  static from(t, n) {
    if (typeof t == "string")
      return FixedNumber.fromString(t, n);
    if (isBytes$2(t))
      return FixedNumber.fromBytes(t, n);
    try {
      return FixedNumber.fromValue(t, 0, n);
    } catch (ie) {
      if (ie.code !== Logger.errors.INVALID_ARGUMENT)
        throw ie;
    }
    return logger$v.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const ONE = FixedNumber.from(1), BUMP = FixedNumber.from("0.5"), version$s = "properties/5.7.0";
var __awaiter$l = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$u = new Logger(version$s);
function defineReadOnly(c, t, n) {
  Object.defineProperty(c, t, {
    enumerable: !0,
    value: n,
    writable: !1
  });
}
function getStatic(c, t) {
  for (let n = 0; n < 32; n++) {
    if (c[t])
      return c[t];
    if (!c.prototype || typeof c.prototype != "object")
      break;
    c = Object.getPrototypeOf(c.prototype).constructor;
  }
  return null;
}
function resolveProperties(c) {
  return __awaiter$l(this, void 0, void 0, function* () {
    const t = Object.keys(c).map((ie) => {
      const fe = c[ie];
      return Promise.resolve(fe).then((ae) => ({ key: ie, value: ae }));
    });
    return (yield Promise.all(t)).reduce((ie, fe) => (ie[fe.key] = fe.value, ie), {});
  });
}
function checkProperties(c, t) {
  (!c || typeof c != "object") && logger$u.throwArgumentError("invalid object", "object", c), Object.keys(c).forEach((n) => {
    t[n] || logger$u.throwArgumentError("invalid object key - " + n, "transaction:" + n, c);
  });
}
function shallowCopy(c) {
  const t = {};
  for (const n in c)
    t[n] = c[n];
  return t;
}
const opaque = { bigint: !0, boolean: !0, function: !0, number: !0, string: !0 };
function _isFrozen(c) {
  if (c == null || opaque[typeof c])
    return !0;
  if (Array.isArray(c) || typeof c == "object") {
    if (!Object.isFrozen(c))
      return !1;
    const t = Object.keys(c);
    for (let n = 0; n < t.length; n++) {
      let ie = null;
      try {
        ie = c[t[n]];
      } catch {
        continue;
      }
      if (!_isFrozen(ie))
        return !1;
    }
    return !0;
  }
  return logger$u.throwArgumentError(`Cannot deepCopy ${typeof c}`, "object", c);
}
function _deepCopy(c) {
  if (_isFrozen(c))
    return c;
  if (Array.isArray(c))
    return Object.freeze(c.map((t) => deepCopy(t)));
  if (typeof c == "object") {
    const t = {};
    for (const n in c) {
      const ie = c[n];
      ie !== void 0 && defineReadOnly(t, n, deepCopy(ie));
    }
    return t;
  }
  return logger$u.throwArgumentError(`Cannot deepCopy ${typeof c}`, "object", c);
}
function deepCopy(c) {
  return _deepCopy(c);
}
class Description {
  constructor(t) {
    for (const n in t)
      this[n] = deepCopy(t[n]);
  }
}
const lib_esm$i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Description,
  checkProperties,
  deepCopy,
  defineReadOnly,
  getStatic,
  resolveProperties,
  shallowCopy
}, Symbol.toStringTag, { value: "Module" })), version$r = "abi/5.7.0", logger$t = new Logger(version$r), _constructorGuard$2 = {};
let ModifiersBytes = { calldata: !0, memory: !0, storage: !0 }, ModifiersNest = { calldata: !0, memory: !0 };
function checkModifier(c, t) {
  if (c === "bytes" || c === "string") {
    if (ModifiersBytes[t])
      return !0;
  } else if (c === "address") {
    if (t === "payable")
      return !0;
  } else if ((c.indexOf("[") >= 0 || c === "tuple") && ModifiersNest[t])
    return !0;
  return (ModifiersBytes[t] || t === "payable") && logger$t.throwArgumentError("invalid modifier", "name", t), !1;
}
function parseParamType(c, t) {
  let n = c;
  function ie(he) {
    logger$t.throwArgumentError(`unexpected character at position ${he}`, "param", c);
  }
  c = c.replace(/\s/g, " ");
  function fe(he) {
    let me = { type: "", name: "", parent: he, state: { allowType: !0 } };
    return t && (me.indexed = !1), me;
  }
  let ae = { type: "", name: "", state: { allowType: !0 } }, le = ae;
  for (let he = 0; he < c.length; he++) {
    let me = c[he];
    switch (me) {
      case "(":
        le.state.allowType && le.type === "" ? le.type = "tuple" : le.state.allowParams || ie(he), le.state.allowType = !1, le.type = verifyType(le.type), le.components = [fe(le)], le = le.components[0];
        break;
      case ")":
        delete le.state, le.name === "indexed" && (t || ie(he), le.indexed = !0, le.name = ""), checkModifier(le.type, le.name) && (le.name = ""), le.type = verifyType(le.type);
        let ye = le;
        le = le.parent, le || ie(he), delete ye.parent, le.state.allowParams = !1, le.state.allowName = !0, le.state.allowArray = !0;
        break;
      case ",":
        delete le.state, le.name === "indexed" && (t || ie(he), le.indexed = !0, le.name = ""), checkModifier(le.type, le.name) && (le.name = ""), le.type = verifyType(le.type);
        let be = fe(le.parent);
        le.parent.components.push(be), delete le.parent, le = be;
        break;
      case " ":
        le.state.allowType && le.type !== "" && (le.type = verifyType(le.type), delete le.state.allowType, le.state.allowName = !0, le.state.allowParams = !0), le.state.allowName && le.name !== "" && (le.name === "indexed" ? (t || ie(he), le.indexed && ie(he), le.indexed = !0, le.name = "") : checkModifier(le.type, le.name) ? le.name = "" : le.state.allowName = !1);
        break;
      case "[":
        le.state.allowArray || ie(he), le.type += me, le.state.allowArray = !1, le.state.allowName = !1, le.state.readArray = !0;
        break;
      case "]":
        le.state.readArray || ie(he), le.type += me, le.state.readArray = !1, le.state.allowArray = !0, le.state.allowName = !0;
        break;
      default:
        le.state.allowType ? (le.type += me, le.state.allowParams = !0, le.state.allowArray = !0) : le.state.allowName ? (le.name += me, delete le.state.allowArray) : le.state.readArray ? le.type += me : ie(he);
    }
  }
  return le.parent && logger$t.throwArgumentError("unexpected eof", "param", c), delete ae.state, le.name === "indexed" ? (t || ie(n.length - 7), le.indexed && ie(n.length - 7), le.indexed = !0, le.name = "") : checkModifier(le.type, le.name) && (le.name = ""), ae.type = verifyType(ae.type), ae;
}
function populate(c, t) {
  for (let n in t)
    defineReadOnly(c, n, t[n]);
}
const FormatTypes = Object.freeze({
  // Bare formatting, as is needed for computing a sighash of an event or function
  sighash: "sighash",
  // Human-Readable with Minimal spacing and without names (compact human-readable)
  minimal: "minimal",
  // Human-Readable with nice spacing, including all names
  full: "full",
  // JSON-format a la Solidity
  json: "json"
}), paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
  constructor(t, n) {
    t !== _constructorGuard$2 && logger$t.throwError("use fromString", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), populate(this, n);
    let ie = this.type.match(paramTypeArray);
    ie ? populate(this, {
      arrayLength: parseInt(ie[2] || "-1"),
      arrayChildren: ParamType.fromObject({
        type: ie[1],
        components: this.components
      }),
      baseType: "array"
    }) : populate(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  // Format the parameter fragment
  //   - sighash: "(uint256,address)"
  //   - minimal: "tuple(uint256,address) indexed"
  //   - full:    "tuple(uint256 foo, address bar) indexed baz"
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$t.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json) {
      let ie = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (ie.indexed = this.indexed), this.components && (ie.components = this.components.map((fe) => JSON.parse(fe.format(t)))), JSON.stringify(ie);
    }
    let n = "";
    return this.baseType === "array" ? (n += this.arrayChildren.format(t), n += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (t !== FormatTypes.sighash && (n += this.type), n += "(" + this.components.map((ie) => ie.format(t)).join(t === FormatTypes.full ? ", " : ",") + ")") : n += this.type, t !== FormatTypes.sighash && (this.indexed === !0 && (n += " indexed"), t === FormatTypes.full && this.name && (n += " " + this.name)), n;
  }
  static from(t, n) {
    return typeof t == "string" ? ParamType.fromString(t, n) : ParamType.fromObject(t);
  }
  static fromObject(t) {
    return ParamType.isParamType(t) ? t : new ParamType(_constructorGuard$2, {
      name: t.name || null,
      type: verifyType(t.type),
      indexed: t.indexed == null ? null : !!t.indexed,
      components: t.components ? t.components.map(ParamType.fromObject) : null
    });
  }
  static fromString(t, n) {
    function ie(fe) {
      return ParamType.fromObject({
        name: fe.name,
        type: fe.type,
        indexed: fe.indexed,
        components: fe.components
      });
    }
    return ie(parseParamType(t, !!n));
  }
  static isParamType(t) {
    return !!(t != null && t._isParamType);
  }
}
function parseParams(c, t) {
  return splitNesting(c).map((n) => ParamType.fromString(n, t));
}
class Fragment {
  constructor(t, n) {
    t !== _constructorGuard$2 && logger$t.throwError("use a static from method", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new Fragment()"
    }), populate(this, n), this._isFragment = !0, Object.freeze(this);
  }
  static from(t) {
    return Fragment.isFragment(t) ? t : typeof t == "string" ? Fragment.fromString(t) : Fragment.fromObject(t);
  }
  static fromObject(t) {
    if (Fragment.isFragment(t))
      return t;
    switch (t.type) {
      case "function":
        return FunctionFragment.fromObject(t);
      case "event":
        return EventFragment.fromObject(t);
      case "constructor":
        return ConstructorFragment.fromObject(t);
      case "error":
        return ErrorFragment.fromObject(t);
      case "fallback":
      case "receive":
        return null;
    }
    return logger$t.throwArgumentError("invalid fragment object", "value", t);
  }
  static fromString(t) {
    return t = t.replace(/\s/g, " "), t = t.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " "), t = t.trim(), t.split(" ")[0] === "event" ? EventFragment.fromString(t.substring(5).trim()) : t.split(" ")[0] === "function" ? FunctionFragment.fromString(t.substring(8).trim()) : t.split("(")[0].trim() === "constructor" ? ConstructorFragment.fromString(t.trim()) : t.split(" ")[0] === "error" ? ErrorFragment.fromString(t.substring(5).trim()) : logger$t.throwArgumentError("unsupported fragment", "value", t);
  }
  static isFragment(t) {
    return !!(t && t._isFragment);
  }
}
class EventFragment extends Fragment {
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$t.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json)
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((ie) => JSON.parse(ie.format(t)))
      });
    let n = "";
    return t !== FormatTypes.sighash && (n += "event "), n += this.name + "(" + this.inputs.map((ie) => ie.format(t)).join(t === FormatTypes.full ? ", " : ",") + ") ", t !== FormatTypes.sighash && this.anonymous && (n += "anonymous "), n.trim();
  }
  static from(t) {
    return typeof t == "string" ? EventFragment.fromString(t) : EventFragment.fromObject(t);
  }
  static fromObject(t) {
    if (EventFragment.isEventFragment(t))
      return t;
    t.type !== "event" && logger$t.throwArgumentError("invalid event object", "value", t);
    const n = {
      name: verifyIdentifier(t.name),
      anonymous: t.anonymous,
      inputs: t.inputs ? t.inputs.map(ParamType.fromObject) : [],
      type: "event"
    };
    return new EventFragment(_constructorGuard$2, n);
  }
  static fromString(t) {
    let n = t.match(regexParen);
    n || logger$t.throwArgumentError("invalid event string", "value", t);
    let ie = !1;
    return n[3].split(" ").forEach((fe) => {
      switch (fe.trim()) {
        case "anonymous":
          ie = !0;
          break;
        case "":
          break;
        default:
          logger$t.warn("unknown modifier: " + fe);
      }
    }), EventFragment.fromObject({
      name: n[1].trim(),
      anonymous: ie,
      inputs: parseParams(n[2], !0),
      type: "event"
    });
  }
  static isEventFragment(t) {
    return t && t._isFragment && t.type === "event";
  }
}
function parseGas(c, t) {
  t.gas = null;
  let n = c.split("@");
  return n.length !== 1 ? (n.length > 2 && logger$t.throwArgumentError("invalid human-readable ABI signature", "value", c), n[1].match(/^[0-9]+$/) || logger$t.throwArgumentError("invalid human-readable ABI signature gas", "value", c), t.gas = BigNumber.from(n[1]), n[0]) : c;
}
function parseModifiers(c, t) {
  t.constant = !1, t.payable = !1, t.stateMutability = "nonpayable", c.split(" ").forEach((n) => {
    switch (n.trim()) {
      case "constant":
        t.constant = !0;
        break;
      case "payable":
        t.payable = !0, t.stateMutability = "payable";
        break;
      case "nonpayable":
        t.payable = !1, t.stateMutability = "nonpayable";
        break;
      case "pure":
        t.constant = !0, t.stateMutability = "pure";
        break;
      case "view":
        t.constant = !0, t.stateMutability = "view";
        break;
      case "external":
      case "public":
      case "":
        break;
      default:
        console.log("unknown modifier: " + n);
    }
  });
}
function verifyState(c) {
  let t = {
    constant: !1,
    payable: !0,
    stateMutability: "payable"
  };
  return c.stateMutability != null ? (t.stateMutability = c.stateMutability, t.constant = t.stateMutability === "view" || t.stateMutability === "pure", c.constant != null && !!c.constant !== t.constant && logger$t.throwArgumentError("cannot have constant function with mutability " + t.stateMutability, "value", c), t.payable = t.stateMutability === "payable", c.payable != null && !!c.payable !== t.payable && logger$t.throwArgumentError("cannot have payable function with mutability " + t.stateMutability, "value", c)) : c.payable != null ? (t.payable = !!c.payable, c.constant == null && !t.payable && c.type !== "constructor" && logger$t.throwArgumentError("unable to determine stateMutability", "value", c), t.constant = !!c.constant, t.constant ? t.stateMutability = "view" : t.stateMutability = t.payable ? "payable" : "nonpayable", t.payable && t.constant && logger$t.throwArgumentError("cannot have constant payable function", "value", c)) : c.constant != null ? (t.constant = !!c.constant, t.payable = !t.constant, t.stateMutability = t.constant ? "view" : "payable") : c.type !== "constructor" && logger$t.throwArgumentError("unable to determine stateMutability", "value", c), t;
}
class ConstructorFragment extends Fragment {
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$t.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json)
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((ie) => JSON.parse(ie.format(t)))
      });
    t === FormatTypes.sighash && logger$t.throwError("cannot format a constructor for sighash", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "format(sighash)"
    });
    let n = "constructor(" + this.inputs.map((ie) => ie.format(t)).join(t === FormatTypes.full ? ", " : ",") + ") ";
    return this.stateMutability && this.stateMutability !== "nonpayable" && (n += this.stateMutability + " "), n.trim();
  }
  static from(t) {
    return typeof t == "string" ? ConstructorFragment.fromString(t) : ConstructorFragment.fromObject(t);
  }
  static fromObject(t) {
    if (ConstructorFragment.isConstructorFragment(t))
      return t;
    t.type !== "constructor" && logger$t.throwArgumentError("invalid constructor object", "value", t);
    let n = verifyState(t);
    n.constant && logger$t.throwArgumentError("constructor cannot be constant", "value", t);
    const ie = {
      name: null,
      type: t.type,
      inputs: t.inputs ? t.inputs.map(ParamType.fromObject) : [],
      payable: n.payable,
      stateMutability: n.stateMutability,
      gas: t.gas ? BigNumber.from(t.gas) : null
    };
    return new ConstructorFragment(_constructorGuard$2, ie);
  }
  static fromString(t) {
    let n = { type: "constructor" };
    t = parseGas(t, n);
    let ie = t.match(regexParen);
    return (!ie || ie[1].trim() !== "constructor") && logger$t.throwArgumentError("invalid constructor string", "value", t), n.inputs = parseParams(ie[2].trim(), !1), parseModifiers(ie[3].trim(), n), ConstructorFragment.fromObject(n);
  }
  static isConstructorFragment(t) {
    return t && t._isFragment && t.type === "constructor";
  }
}
class FunctionFragment extends ConstructorFragment {
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$t.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json)
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((ie) => JSON.parse(ie.format(t))),
        outputs: this.outputs.map((ie) => JSON.parse(ie.format(t)))
      });
    let n = "";
    return t !== FormatTypes.sighash && (n += "function "), n += this.name + "(" + this.inputs.map((ie) => ie.format(t)).join(t === FormatTypes.full ? ", " : ",") + ") ", t !== FormatTypes.sighash && (this.stateMutability ? this.stateMutability !== "nonpayable" && (n += this.stateMutability + " ") : this.constant && (n += "view "), this.outputs && this.outputs.length && (n += "returns (" + this.outputs.map((ie) => ie.format(t)).join(", ") + ") "), this.gas != null && (n += "@" + this.gas.toString() + " ")), n.trim();
  }
  static from(t) {
    return typeof t == "string" ? FunctionFragment.fromString(t) : FunctionFragment.fromObject(t);
  }
  static fromObject(t) {
    if (FunctionFragment.isFunctionFragment(t))
      return t;
    t.type !== "function" && logger$t.throwArgumentError("invalid function object", "value", t);
    let n = verifyState(t);
    const ie = {
      type: t.type,
      name: verifyIdentifier(t.name),
      constant: n.constant,
      inputs: t.inputs ? t.inputs.map(ParamType.fromObject) : [],
      outputs: t.outputs ? t.outputs.map(ParamType.fromObject) : [],
      payable: n.payable,
      stateMutability: n.stateMutability,
      gas: t.gas ? BigNumber.from(t.gas) : null
    };
    return new FunctionFragment(_constructorGuard$2, ie);
  }
  static fromString(t) {
    let n = { type: "function" };
    t = parseGas(t, n);
    let ie = t.split(" returns ");
    ie.length > 2 && logger$t.throwArgumentError("invalid function string", "value", t);
    let fe = ie[0].match(regexParen);
    if (fe || logger$t.throwArgumentError("invalid function signature", "value", t), n.name = fe[1].trim(), n.name && verifyIdentifier(n.name), n.inputs = parseParams(fe[2], !1), parseModifiers(fe[3].trim(), n), ie.length > 1) {
      let ae = ie[1].match(regexParen);
      (ae[1].trim() != "" || ae[3].trim() != "") && logger$t.throwArgumentError("unexpected tokens", "value", t), n.outputs = parseParams(ae[2], !1);
    } else
      n.outputs = [];
    return FunctionFragment.fromObject(n);
  }
  static isFunctionFragment(t) {
    return t && t._isFragment && t.type === "function";
  }
}
function checkForbidden(c) {
  const t = c.format();
  return (t === "Error(string)" || t === "Panic(uint256)") && logger$t.throwArgumentError(`cannot specify user defined ${t} error`, "fragment", c), c;
}
class ErrorFragment extends Fragment {
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$t.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json)
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((ie) => JSON.parse(ie.format(t)))
      });
    let n = "";
    return t !== FormatTypes.sighash && (n += "error "), n += this.name + "(" + this.inputs.map((ie) => ie.format(t)).join(t === FormatTypes.full ? ", " : ",") + ") ", n.trim();
  }
  static from(t) {
    return typeof t == "string" ? ErrorFragment.fromString(t) : ErrorFragment.fromObject(t);
  }
  static fromObject(t) {
    if (ErrorFragment.isErrorFragment(t))
      return t;
    t.type !== "error" && logger$t.throwArgumentError("invalid error object", "value", t);
    const n = {
      type: t.type,
      name: verifyIdentifier(t.name),
      inputs: t.inputs ? t.inputs.map(ParamType.fromObject) : []
    };
    return checkForbidden(new ErrorFragment(_constructorGuard$2, n));
  }
  static fromString(t) {
    let n = { type: "error" }, ie = t.match(regexParen);
    return ie || logger$t.throwArgumentError("invalid error signature", "value", t), n.name = ie[1].trim(), n.name && verifyIdentifier(n.name), n.inputs = parseParams(ie[2], !1), checkForbidden(ErrorFragment.fromObject(n));
  }
  static isErrorFragment(t) {
    return t && t._isFragment && t.type === "error";
  }
}
function verifyType(c) {
  return c.match(/^uint($|[^1-9])/) ? c = "uint256" + c.substring(4) : c.match(/^int($|[^1-9])/) && (c = "int256" + c.substring(3)), c;
}
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(c) {
  return (!c || !c.match(regexIdentifier)) && logger$t.throwArgumentError(`invalid identifier "${c}"`, "value", c), c;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(c) {
  c = c.trim();
  let t = [], n = "", ie = 0;
  for (let fe = 0; fe < c.length; fe++) {
    let ae = c[fe];
    ae === "," && ie === 0 ? (t.push(n), n = "") : (n += ae, ae === "(" ? ie++ : ae === ")" && (ie--, ie === -1 && logger$t.throwArgumentError("unbalanced parenthesis", "value", c)));
  }
  return n && t.push(n), t;
}
const logger$s = new Logger(version$r);
function checkResultErrors(c) {
  const t = [], n = function(ie, fe) {
    if (Array.isArray(fe))
      for (let ae in fe) {
        const le = ie.slice();
        le.push(ae);
        try {
          n(le, fe[ae]);
        } catch (he) {
          t.push({ path: le, error: he });
        }
      }
  };
  return n([], c), t;
}
class Coder {
  constructor(t, n, ie, fe) {
    this.name = t, this.type = n, this.localName = ie, this.dynamic = fe;
  }
  _throwError(t, n) {
    logger$s.throwArgumentError(t, this.localName, n);
  }
}
class Writer {
  constructor(t) {
    defineReadOnly(this, "wordSize", t || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(t);
  }
  get data() {
    return hexConcat(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(t) {
    return this._data.push(t), this._dataLength += t.length, t.length;
  }
  appendWriter(t) {
    return this._writeData(concat$1(t._data));
  }
  // Arrayish items; padded on the right to wordSize
  writeBytes(t) {
    let n = arrayify(t);
    const ie = n.length % this.wordSize;
    return ie && (n = concat$1([n, this._padding.slice(ie)])), this._writeData(n);
  }
  _getValue(t) {
    let n = arrayify(BigNumber.from(t));
    return n.length > this.wordSize && logger$s.throwError("value out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: n.length
    }), n.length % this.wordSize && (n = concat$1([this._padding.slice(n.length % this.wordSize), n])), n;
  }
  // BigNumberish items; padded on the left to wordSize
  writeValue(t) {
    return this._writeData(this._getValue(t));
  }
  writeUpdatableValue() {
    const t = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (n) => {
      this._data[t] = this._getValue(n);
    };
  }
}
class Reader {
  constructor(t, n, ie, fe) {
    defineReadOnly(this, "_data", arrayify(t)), defineReadOnly(this, "wordSize", n || 32), defineReadOnly(this, "_coerceFunc", ie), defineReadOnly(this, "allowLoose", fe), this._offset = 0;
  }
  get data() {
    return hexlify(this._data);
  }
  get consumed() {
    return this._offset;
  }
  // The default Coerce function
  static coerce(t, n) {
    let ie = t.match("^u?int([0-9]+)$");
    return ie && parseInt(ie[1]) <= 48 && (n = n.toNumber()), n;
  }
  coerce(t, n) {
    return this._coerceFunc ? this._coerceFunc(t, n) : Reader.coerce(t, n);
  }
  _peekBytes(t, n, ie) {
    let fe = Math.ceil(n / this.wordSize) * this.wordSize;
    return this._offset + fe > this._data.length && (this.allowLoose && ie && this._offset + n <= this._data.length ? fe = n : logger$s.throwError("data out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + fe
    })), this._data.slice(this._offset, this._offset + fe);
  }
  subReader(t) {
    return new Reader(this._data.slice(this._offset + t), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(t, n) {
    let ie = this._peekBytes(0, t, !!n);
    return this._offset += ie.length, ie.slice(0, t);
  }
  readValue() {
    return BigNumber.from(this.readBytes(this.wordSize));
  }
}
function getDefaultExportFromCjs$1(c) {
  return c && c.__esModule && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c;
}
var browser$e = { exports: {} }, process = browser$e.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(c) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(c, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(c, 0);
  try {
    return cachedSetTimeout(c, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, c, 0);
    } catch {
      return cachedSetTimeout.call(this, c, 0);
    }
  }
}
function runClearTimeout(c) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(c);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(c);
  try {
    return cachedClearTimeout(c);
  } catch {
    try {
      return cachedClearTimeout.call(null, c);
    } catch {
      return cachedClearTimeout.call(this, c);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var c = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var t = queue.length; t; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < t; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, t = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(c);
  }
}
process.nextTick = function(c) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  queue.push(new Item(c, t)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(c, t) {
  this.fun = c, this.array = t;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(c) {
  return [];
};
process.binding = function(c) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(c) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$e.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports);
var sha3$3 = { exports: {} };
(function(c) {
  (function() {
    var t = "input is invalid type", n = "finalize already called", ie = typeof window == "object", fe = ie ? window : {};
    fe.JS_SHA3_NO_WINDOW && (ie = !1);
    var ae = !ie && typeof self == "object", le = !fe.JS_SHA3_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    le ? fe = globalThis : ae && (fe = self);
    var he = !fe.JS_SHA3_NO_COMMON_JS && !0 && c.exports, me = !fe.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", ye = "0123456789abcdef".split(""), be = [31, 7936, 2031616, 520093696], Ae = [4, 1024, 262144, 67108864], Se = [1, 256, 65536, 16777216], $e = [6, 1536, 393216, 100663296], Re = [0, 8, 16, 24], Me = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], ke = [224, 256, 384, 512], Te = [128, 256], Ie = ["hex", "buffer", "arrayBuffer", "array", "digest"], qe = {
      128: 168,
      256: 136
    };
    (fe.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Pe) {
      return Object.prototype.toString.call(Pe) === "[object Array]";
    }), me && (fe.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Pe) {
      return typeof Pe == "object" && Pe.buffer && Pe.buffer.constructor === ArrayBuffer;
    });
    for (var Ue = function(Pe, Je, Ke) {
      return function(Ze) {
        return new Be(Pe, Je, Pe).update(Ze)[Ke]();
      };
    }, ze = function(Pe, Je, Ke) {
      return function(Ze, Ye) {
        return new Be(Pe, Je, Ye).update(Ze)[Ke]();
      };
    }, Ve = function(Pe, Je, Ke) {
      return function(Ze, Ye, Pt, Ft) {
        return de["cshake" + Pe].update(Ze, Ye, Pt, Ft)[Ke]();
      };
    }, Mt = function(Pe, Je, Ke) {
      return function(Ze, Ye, Pt, Ft) {
        return de["kmac" + Pe].update(Ze, Ye, Pt, Ft)[Ke]();
      };
    }, Rt = function(Pe, Je, Ke, Ze) {
      for (var Ye = 0; Ye < Ie.length; ++Ye) {
        var Pt = Ie[Ye];
        Pe[Pt] = Je(Ke, Ze, Pt);
      }
      return Pe;
    }, je = function(Pe, Je) {
      var Ke = Ue(Pe, Je, "hex");
      return Ke.create = function() {
        return new Be(Pe, Je, Pe);
      }, Ke.update = function(Ze) {
        return Ke.create().update(Ze);
      }, Rt(Ke, Ue, Pe, Je);
    }, jt = function(Pe, Je) {
      var Ke = ze(Pe, Je, "hex");
      return Ke.create = function(Ze) {
        return new Be(Pe, Je, Ze);
      }, Ke.update = function(Ze, Ye) {
        return Ke.create(Ye).update(Ze);
      }, Rt(Ke, ze, Pe, Je);
    }, _e = function(Pe, Je) {
      var Ke = qe[Pe], Ze = Ve(Pe, Je, "hex");
      return Ze.create = function(Ye, Pt, Ft) {
        return !Pt && !Ft ? de["shake" + Pe].create(Ye) : new Be(Pe, Je, Ye).bytepad([Pt, Ft], Ke);
      }, Ze.update = function(Ye, Pt, Ft, Le) {
        return Ze.create(Pt, Ft, Le).update(Ye);
      }, Rt(Ze, Ve, Pe, Je);
    }, se = function(Pe, Je) {
      var Ke = qe[Pe], Ze = Mt(Pe, Je, "hex");
      return Ze.create = function(Ye, Pt, Ft) {
        return new Ne(Pe, Je, Pt).bytepad(["KMAC", Ft], Ke).bytepad([Ye], Ke);
      }, Ze.update = function(Ye, Pt, Ft, Le) {
        return Ze.create(Ye, Ft, Le).update(Pt);
      }, Rt(Ze, Mt, Pe, Je);
    }, ce = [
      { name: "keccak", padding: Se, bits: ke, createMethod: je },
      { name: "sha3", padding: $e, bits: ke, createMethod: je },
      { name: "shake", padding: be, bits: Te, createMethod: jt },
      { name: "cshake", padding: Ae, bits: Te, createMethod: _e },
      { name: "kmac", padding: Ae, bits: Te, createMethod: se }
    ], de = {}, pe = [], ve = 0; ve < ce.length; ++ve)
      for (var we = ce[ve], Ee = we.bits, xe = 0; xe < Ee.length; ++xe) {
        var ue = we.name + "_" + Ee[xe];
        if (pe.push(ue), de[ue] = we.createMethod(Ee[xe], we.padding), we.name !== "sha3") {
          var ge = we.name + Ee[xe];
          pe.push(ge), de[ge] = de[ue];
        }
      }
    function Be(Pe, Je, Ke) {
      this.blocks = [], this.s = [], this.padding = Je, this.outputBits = Ke, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (Pe << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = Ke >> 5, this.extraBytes = (Ke & 31) >> 3;
      for (var Ze = 0; Ze < 50; ++Ze)
        this.s[Ze] = 0;
    }
    Be.prototype.update = function(Pe) {
      if (this.finalized)
        throw new Error(n);
      var Je, Ke = typeof Pe;
      if (Ke !== "string") {
        if (Ke === "object") {
          if (Pe === null)
            throw new Error(t);
          if (me && Pe.constructor === ArrayBuffer)
            Pe = new Uint8Array(Pe);
          else if (!Array.isArray(Pe) && (!me || !ArrayBuffer.isView(Pe)))
            throw new Error(t);
        } else
          throw new Error(t);
        Je = !0;
      }
      for (var Ze = this.blocks, Ye = this.byteCount, Pt = Pe.length, Ft = this.blockCount, Le = 0, $t = this.s, Jt, Ht; Le < Pt; ) {
        if (this.reset)
          for (this.reset = !1, Ze[0] = this.block, Jt = 1; Jt < Ft + 1; ++Jt)
            Ze[Jt] = 0;
        if (Je)
          for (Jt = this.start; Le < Pt && Jt < Ye; ++Le)
            Ze[Jt >> 2] |= Pe[Le] << Re[Jt++ & 3];
        else
          for (Jt = this.start; Le < Pt && Jt < Ye; ++Le)
            Ht = Pe.charCodeAt(Le), Ht < 128 ? Ze[Jt >> 2] |= Ht << Re[Jt++ & 3] : Ht < 2048 ? (Ze[Jt >> 2] |= (192 | Ht >> 6) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht & 63) << Re[Jt++ & 3]) : Ht < 55296 || Ht >= 57344 ? (Ze[Jt >> 2] |= (224 | Ht >> 12) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht >> 6 & 63) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht & 63) << Re[Jt++ & 3]) : (Ht = 65536 + ((Ht & 1023) << 10 | Pe.charCodeAt(++Le) & 1023), Ze[Jt >> 2] |= (240 | Ht >> 18) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht >> 12 & 63) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht >> 6 & 63) << Re[Jt++ & 3], Ze[Jt >> 2] |= (128 | Ht & 63) << Re[Jt++ & 3]);
        if (this.lastByteIndex = Jt, Jt >= Ye) {
          for (this.start = Jt - Ye, this.block = Ze[Ft], Jt = 0; Jt < Ft; ++Jt)
            $t[Jt] ^= Ze[Jt];
          Fe($t), this.reset = !0;
        } else
          this.start = Jt;
      }
      return this;
    }, Be.prototype.encode = function(Pe, Je) {
      var Ke = Pe & 255, Ze = 1, Ye = [Ke];
      for (Pe = Pe >> 8, Ke = Pe & 255; Ke > 0; )
        Ye.unshift(Ke), Pe = Pe >> 8, Ke = Pe & 255, ++Ze;
      return Je ? Ye.push(Ze) : Ye.unshift(Ze), this.update(Ye), Ye.length;
    }, Be.prototype.encodeString = function(Pe) {
      var Je, Ke = typeof Pe;
      if (Ke !== "string") {
        if (Ke === "object") {
          if (Pe === null)
            throw new Error(t);
          if (me && Pe.constructor === ArrayBuffer)
            Pe = new Uint8Array(Pe);
          else if (!Array.isArray(Pe) && (!me || !ArrayBuffer.isView(Pe)))
            throw new Error(t);
        } else
          throw new Error(t);
        Je = !0;
      }
      var Ze = 0, Ye = Pe.length;
      if (Je)
        Ze = Ye;
      else
        for (var Pt = 0; Pt < Pe.length; ++Pt) {
          var Ft = Pe.charCodeAt(Pt);
          Ft < 128 ? Ze += 1 : Ft < 2048 ? Ze += 2 : Ft < 55296 || Ft >= 57344 ? Ze += 3 : (Ft = 65536 + ((Ft & 1023) << 10 | Pe.charCodeAt(++Pt) & 1023), Ze += 4);
        }
      return Ze += this.encode(Ze * 8), this.update(Pe), Ze;
    }, Be.prototype.bytepad = function(Pe, Je) {
      for (var Ke = this.encode(Je), Ze = 0; Ze < Pe.length; ++Ze)
        Ke += this.encodeString(Pe[Ze]);
      var Ye = Je - Ke % Je, Pt = [];
      return Pt.length = Ye, this.update(Pt), this;
    }, Be.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Pe = this.blocks, Je = this.lastByteIndex, Ke = this.blockCount, Ze = this.s;
        if (Pe[Je >> 2] |= this.padding[Je & 3], this.lastByteIndex === this.byteCount)
          for (Pe[0] = Pe[Ke], Je = 1; Je < Ke + 1; ++Je)
            Pe[Je] = 0;
        for (Pe[Ke - 1] |= 2147483648, Je = 0; Je < Ke; ++Je)
          Ze[Je] ^= Pe[Je];
        Fe(Ze);
      }
    }, Be.prototype.toString = Be.prototype.hex = function() {
      this.finalize();
      for (var Pe = this.blockCount, Je = this.s, Ke = this.outputBlocks, Ze = this.extraBytes, Ye = 0, Pt = 0, Ft = "", Le; Pt < Ke; ) {
        for (Ye = 0; Ye < Pe && Pt < Ke; ++Ye, ++Pt)
          Le = Je[Ye], Ft += ye[Le >> 4 & 15] + ye[Le & 15] + ye[Le >> 12 & 15] + ye[Le >> 8 & 15] + ye[Le >> 20 & 15] + ye[Le >> 16 & 15] + ye[Le >> 28 & 15] + ye[Le >> 24 & 15];
        Pt % Pe === 0 && (Fe(Je), Ye = 0);
      }
      return Ze && (Le = Je[Ye], Ft += ye[Le >> 4 & 15] + ye[Le & 15], Ze > 1 && (Ft += ye[Le >> 12 & 15] + ye[Le >> 8 & 15]), Ze > 2 && (Ft += ye[Le >> 20 & 15] + ye[Le >> 16 & 15])), Ft;
    }, Be.prototype.arrayBuffer = function() {
      this.finalize();
      var Pe = this.blockCount, Je = this.s, Ke = this.outputBlocks, Ze = this.extraBytes, Ye = 0, Pt = 0, Ft = this.outputBits >> 3, Le;
      Ze ? Le = new ArrayBuffer(Ke + 1 << 2) : Le = new ArrayBuffer(Ft);
      for (var $t = new Uint32Array(Le); Pt < Ke; ) {
        for (Ye = 0; Ye < Pe && Pt < Ke; ++Ye, ++Pt)
          $t[Pt] = Je[Ye];
        Pt % Pe === 0 && Fe(Je);
      }
      return Ze && ($t[Ye] = Je[Ye], Le = Le.slice(0, Ft)), Le;
    }, Be.prototype.buffer = Be.prototype.arrayBuffer, Be.prototype.digest = Be.prototype.array = function() {
      this.finalize();
      for (var Pe = this.blockCount, Je = this.s, Ke = this.outputBlocks, Ze = this.extraBytes, Ye = 0, Pt = 0, Ft = [], Le, $t; Pt < Ke; ) {
        for (Ye = 0; Ye < Pe && Pt < Ke; ++Ye, ++Pt)
          Le = Pt << 2, $t = Je[Ye], Ft[Le] = $t & 255, Ft[Le + 1] = $t >> 8 & 255, Ft[Le + 2] = $t >> 16 & 255, Ft[Le + 3] = $t >> 24 & 255;
        Pt % Pe === 0 && Fe(Je);
      }
      return Ze && (Le = Pt << 2, $t = Je[Ye], Ft[Le] = $t & 255, Ze > 1 && (Ft[Le + 1] = $t >> 8 & 255), Ze > 2 && (Ft[Le + 2] = $t >> 16 & 255)), Ft;
    };
    function Ne(Pe, Je, Ke) {
      Be.call(this, Pe, Je, Ke);
    }
    Ne.prototype = new Be(), Ne.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), Be.prototype.finalize.call(this);
    };
    var Fe = function(Pe) {
      var Je, Ke, Ze, Ye, Pt, Ft, Le, $t, Jt, Ht, Vt, xn, Zt, Gt, An, Qt, Xt, wn, Qe, Dt, en, We, De, Ge, Oe, Ce, He, Xe, Kt, tn, Wt, Yt, _n, rn, nn, En, an, dn, Mn, on, hn, Rn, sn, pn, Bn, fn, yn, kn, un, mn, Tn, cn, gn, Cn, ln, vn, Sn, $n, Nn, In, Pn, On, Ln;
      for (Ze = 0; Ze < 48; Ze += 2)
        Ye = Pe[0] ^ Pe[10] ^ Pe[20] ^ Pe[30] ^ Pe[40], Pt = Pe[1] ^ Pe[11] ^ Pe[21] ^ Pe[31] ^ Pe[41], Ft = Pe[2] ^ Pe[12] ^ Pe[22] ^ Pe[32] ^ Pe[42], Le = Pe[3] ^ Pe[13] ^ Pe[23] ^ Pe[33] ^ Pe[43], $t = Pe[4] ^ Pe[14] ^ Pe[24] ^ Pe[34] ^ Pe[44], Jt = Pe[5] ^ Pe[15] ^ Pe[25] ^ Pe[35] ^ Pe[45], Ht = Pe[6] ^ Pe[16] ^ Pe[26] ^ Pe[36] ^ Pe[46], Vt = Pe[7] ^ Pe[17] ^ Pe[27] ^ Pe[37] ^ Pe[47], xn = Pe[8] ^ Pe[18] ^ Pe[28] ^ Pe[38] ^ Pe[48], Zt = Pe[9] ^ Pe[19] ^ Pe[29] ^ Pe[39] ^ Pe[49], Je = xn ^ (Ft << 1 | Le >>> 31), Ke = Zt ^ (Le << 1 | Ft >>> 31), Pe[0] ^= Je, Pe[1] ^= Ke, Pe[10] ^= Je, Pe[11] ^= Ke, Pe[20] ^= Je, Pe[21] ^= Ke, Pe[30] ^= Je, Pe[31] ^= Ke, Pe[40] ^= Je, Pe[41] ^= Ke, Je = Ye ^ ($t << 1 | Jt >>> 31), Ke = Pt ^ (Jt << 1 | $t >>> 31), Pe[2] ^= Je, Pe[3] ^= Ke, Pe[12] ^= Je, Pe[13] ^= Ke, Pe[22] ^= Je, Pe[23] ^= Ke, Pe[32] ^= Je, Pe[33] ^= Ke, Pe[42] ^= Je, Pe[43] ^= Ke, Je = Ft ^ (Ht << 1 | Vt >>> 31), Ke = Le ^ (Vt << 1 | Ht >>> 31), Pe[4] ^= Je, Pe[5] ^= Ke, Pe[14] ^= Je, Pe[15] ^= Ke, Pe[24] ^= Je, Pe[25] ^= Ke, Pe[34] ^= Je, Pe[35] ^= Ke, Pe[44] ^= Je, Pe[45] ^= Ke, Je = $t ^ (xn << 1 | Zt >>> 31), Ke = Jt ^ (Zt << 1 | xn >>> 31), Pe[6] ^= Je, Pe[7] ^= Ke, Pe[16] ^= Je, Pe[17] ^= Ke, Pe[26] ^= Je, Pe[27] ^= Ke, Pe[36] ^= Je, Pe[37] ^= Ke, Pe[46] ^= Je, Pe[47] ^= Ke, Je = Ht ^ (Ye << 1 | Pt >>> 31), Ke = Vt ^ (Pt << 1 | Ye >>> 31), Pe[8] ^= Je, Pe[9] ^= Ke, Pe[18] ^= Je, Pe[19] ^= Ke, Pe[28] ^= Je, Pe[29] ^= Ke, Pe[38] ^= Je, Pe[39] ^= Ke, Pe[48] ^= Je, Pe[49] ^= Ke, Gt = Pe[0], An = Pe[1], fn = Pe[11] << 4 | Pe[10] >>> 28, yn = Pe[10] << 4 | Pe[11] >>> 28, Xe = Pe[20] << 3 | Pe[21] >>> 29, Kt = Pe[21] << 3 | Pe[20] >>> 29, In = Pe[31] << 9 | Pe[30] >>> 23, Pn = Pe[30] << 9 | Pe[31] >>> 23, Rn = Pe[40] << 18 | Pe[41] >>> 14, sn = Pe[41] << 18 | Pe[40] >>> 14, rn = Pe[2] << 1 | Pe[3] >>> 31, nn = Pe[3] << 1 | Pe[2] >>> 31, Qt = Pe[13] << 12 | Pe[12] >>> 20, Xt = Pe[12] << 12 | Pe[13] >>> 20, kn = Pe[22] << 10 | Pe[23] >>> 22, un = Pe[23] << 10 | Pe[22] >>> 22, tn = Pe[33] << 13 | Pe[32] >>> 19, Wt = Pe[32] << 13 | Pe[33] >>> 19, On = Pe[42] << 2 | Pe[43] >>> 30, Ln = Pe[43] << 2 | Pe[42] >>> 30, Cn = Pe[5] << 30 | Pe[4] >>> 2, ln = Pe[4] << 30 | Pe[5] >>> 2, En = Pe[14] << 6 | Pe[15] >>> 26, an = Pe[15] << 6 | Pe[14] >>> 26, wn = Pe[25] << 11 | Pe[24] >>> 21, Qe = Pe[24] << 11 | Pe[25] >>> 21, mn = Pe[34] << 15 | Pe[35] >>> 17, Tn = Pe[35] << 15 | Pe[34] >>> 17, Yt = Pe[45] << 29 | Pe[44] >>> 3, _n = Pe[44] << 29 | Pe[45] >>> 3, Ge = Pe[6] << 28 | Pe[7] >>> 4, Oe = Pe[7] << 28 | Pe[6] >>> 4, vn = Pe[17] << 23 | Pe[16] >>> 9, Sn = Pe[16] << 23 | Pe[17] >>> 9, dn = Pe[26] << 25 | Pe[27] >>> 7, Mn = Pe[27] << 25 | Pe[26] >>> 7, Dt = Pe[36] << 21 | Pe[37] >>> 11, en = Pe[37] << 21 | Pe[36] >>> 11, cn = Pe[47] << 24 | Pe[46] >>> 8, gn = Pe[46] << 24 | Pe[47] >>> 8, pn = Pe[8] << 27 | Pe[9] >>> 5, Bn = Pe[9] << 27 | Pe[8] >>> 5, Ce = Pe[18] << 20 | Pe[19] >>> 12, He = Pe[19] << 20 | Pe[18] >>> 12, $n = Pe[29] << 7 | Pe[28] >>> 25, Nn = Pe[28] << 7 | Pe[29] >>> 25, on = Pe[38] << 8 | Pe[39] >>> 24, hn = Pe[39] << 8 | Pe[38] >>> 24, We = Pe[48] << 14 | Pe[49] >>> 18, De = Pe[49] << 14 | Pe[48] >>> 18, Pe[0] = Gt ^ ~Qt & wn, Pe[1] = An ^ ~Xt & Qe, Pe[10] = Ge ^ ~Ce & Xe, Pe[11] = Oe ^ ~He & Kt, Pe[20] = rn ^ ~En & dn, Pe[21] = nn ^ ~an & Mn, Pe[30] = pn ^ ~fn & kn, Pe[31] = Bn ^ ~yn & un, Pe[40] = Cn ^ ~vn & $n, Pe[41] = ln ^ ~Sn & Nn, Pe[2] = Qt ^ ~wn & Dt, Pe[3] = Xt ^ ~Qe & en, Pe[12] = Ce ^ ~Xe & tn, Pe[13] = He ^ ~Kt & Wt, Pe[22] = En ^ ~dn & on, Pe[23] = an ^ ~Mn & hn, Pe[32] = fn ^ ~kn & mn, Pe[33] = yn ^ ~un & Tn, Pe[42] = vn ^ ~$n & In, Pe[43] = Sn ^ ~Nn & Pn, Pe[4] = wn ^ ~Dt & We, Pe[5] = Qe ^ ~en & De, Pe[14] = Xe ^ ~tn & Yt, Pe[15] = Kt ^ ~Wt & _n, Pe[24] = dn ^ ~on & Rn, Pe[25] = Mn ^ ~hn & sn, Pe[34] = kn ^ ~mn & cn, Pe[35] = un ^ ~Tn & gn, Pe[44] = $n ^ ~In & On, Pe[45] = Nn ^ ~Pn & Ln, Pe[6] = Dt ^ ~We & Gt, Pe[7] = en ^ ~De & An, Pe[16] = tn ^ ~Yt & Ge, Pe[17] = Wt ^ ~_n & Oe, Pe[26] = on ^ ~Rn & rn, Pe[27] = hn ^ ~sn & nn, Pe[36] = mn ^ ~cn & pn, Pe[37] = Tn ^ ~gn & Bn, Pe[46] = In ^ ~On & Cn, Pe[47] = Pn ^ ~Ln & ln, Pe[8] = We ^ ~Gt & Qt, Pe[9] = De ^ ~An & Xt, Pe[18] = Yt ^ ~Ge & Ce, Pe[19] = _n ^ ~Oe & He, Pe[28] = Rn ^ ~rn & En, Pe[29] = sn ^ ~nn & an, Pe[38] = cn ^ ~pn & fn, Pe[39] = gn ^ ~Bn & yn, Pe[48] = On ^ ~Cn & vn, Pe[49] = Ln ^ ~ln & Sn, Pe[0] ^= Me[Ze], Pe[1] ^= Me[Ze + 1];
    };
    if (he)
      c.exports = de;
    else
      for (ve = 0; ve < pe.length; ++ve)
        fe[pe[ve]] = de[pe[ve]];
  })();
})(sha3$3);
var sha3Exports$1 = sha3$3.exports;
const sha3$2 = /* @__PURE__ */ getDefaultExportFromCjs$2(sha3Exports$1);
function keccak256$1(c) {
  return "0x" + sha3$2.keccak_256(arrayify(c));
}
const lib_esm$h = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  keccak256: keccak256$1
}, Symbol.toStringTag, { value: "Module" })), version$q = "rlp/5.7.0", logger$r = new Logger(version$q);
function arrayifyInteger(c) {
  const t = [];
  for (; c; )
    t.unshift(c & 255), c >>= 8;
  return t;
}
function unarrayifyInteger(c, t, n) {
  let ie = 0;
  for (let fe = 0; fe < n; fe++)
    ie = ie * 256 + c[t + fe];
  return ie;
}
function _encode(c) {
  if (Array.isArray(c)) {
    let ie = [];
    if (c.forEach(function(ae) {
      ie = ie.concat(_encode(ae));
    }), ie.length <= 55)
      return ie.unshift(192 + ie.length), ie;
    const fe = arrayifyInteger(ie.length);
    return fe.unshift(247 + fe.length), fe.concat(ie);
  }
  isBytesLike(c) || logger$r.throwArgumentError("RLP object must be BytesLike", "object", c);
  const t = Array.prototype.slice.call(arrayify(c));
  if (t.length === 1 && t[0] <= 127)
    return t;
  if (t.length <= 55)
    return t.unshift(128 + t.length), t;
  const n = arrayifyInteger(t.length);
  return n.unshift(183 + n.length), n.concat(t);
}
function encode$6(c) {
  return hexlify(_encode(c));
}
function _decodeChildren(c, t, n, ie) {
  const fe = [];
  for (; n < t + 1 + ie; ) {
    const ae = _decode(c, n);
    fe.push(ae.result), n += ae.consumed, n > t + 1 + ie && logger$r.throwError("child data too short", Logger.errors.BUFFER_OVERRUN, {});
  }
  return { consumed: 1 + ie, result: fe };
}
function _decode(c, t) {
  if (c.length === 0 && logger$r.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {}), c[t] >= 248) {
    const n = c[t] - 247;
    t + 1 + n > c.length && logger$r.throwError("data short segment too short", Logger.errors.BUFFER_OVERRUN, {});
    const ie = unarrayifyInteger(c, t + 1, n);
    return t + 1 + n + ie > c.length && logger$r.throwError("data long segment too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(c, t, t + 1 + n, n + ie);
  } else if (c[t] >= 192) {
    const n = c[t] - 192;
    return t + 1 + n > c.length && logger$r.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(c, t, t + 1, n);
  } else if (c[t] >= 184) {
    const n = c[t] - 183;
    t + 1 + n > c.length && logger$r.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const ie = unarrayifyInteger(c, t + 1, n);
    t + 1 + n + ie > c.length && logger$r.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const fe = hexlify(c.slice(t + 1 + n, t + 1 + n + ie));
    return { consumed: 1 + n + ie, result: fe };
  } else if (c[t] >= 128) {
    const n = c[t] - 128;
    t + 1 + n > c.length && logger$r.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {});
    const ie = hexlify(c.slice(t + 1, t + 1 + n));
    return { consumed: 1 + n, result: ie };
  }
  return { consumed: 1, result: hexlify(c[t]) };
}
function decode$7(c) {
  const t = arrayify(c), n = _decode(t, 0);
  return n.consumed !== t.length && logger$r.throwArgumentError("invalid rlp data", "data", c), n.result;
}
const lib_esm$g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$7,
  encode: encode$6
}, Symbol.toStringTag, { value: "Module" })), version$p = "address/5.7.0", logger$q = new Logger(version$p);
function getChecksumAddress(c) {
  isHexString(c, 20) || logger$q.throwArgumentError("invalid address", "address", c), c = c.toLowerCase();
  const t = c.substring(2).split(""), n = new Uint8Array(40);
  for (let fe = 0; fe < 40; fe++)
    n[fe] = t[fe].charCodeAt(0);
  const ie = arrayify(keccak256$1(n));
  for (let fe = 0; fe < 40; fe += 2)
    ie[fe >> 1] >> 4 >= 8 && (t[fe] = t[fe].toUpperCase()), (ie[fe >> 1] & 15) >= 8 && (t[fe + 1] = t[fe + 1].toUpperCase());
  return "0x" + t.join("");
}
const MAX_SAFE_INTEGER = 9007199254740991;
function log10(c) {
  return Math.log10 ? Math.log10(c) : Math.log(c) / Math.LN10;
}
const ibanLookup = {};
for (let c = 0; c < 10; c++)
  ibanLookup[String(c)] = String(c);
for (let c = 0; c < 26; c++)
  ibanLookup[String.fromCharCode(65 + c)] = String(10 + c);
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(c) {
  c = c.toUpperCase(), c = c.substring(4) + c.substring(0, 2) + "00";
  let t = c.split("").map((ie) => ibanLookup[ie]).join("");
  for (; t.length >= safeDigits; ) {
    let ie = t.substring(0, safeDigits);
    t = parseInt(ie, 10) % 97 + t.substring(ie.length);
  }
  let n = String(98 - parseInt(t, 10) % 97);
  for (; n.length < 2; )
    n = "0" + n;
  return n;
}
function getAddress(c) {
  let t = null;
  if (typeof c != "string" && logger$q.throwArgumentError("invalid address", "address", c), c.match(/^(0x)?[0-9a-fA-F]{40}$/))
    c.substring(0, 2) !== "0x" && (c = "0x" + c), t = getChecksumAddress(c), c.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== c && logger$q.throwArgumentError("bad address checksum", "address", c);
  else if (c.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (c.substring(2, 4) !== ibanChecksum(c) && logger$q.throwArgumentError("bad icap checksum", "address", c), t = _base36To16(c.substring(4)); t.length < 40; )
      t = "0" + t;
    t = getChecksumAddress("0x" + t);
  } else
    logger$q.throwArgumentError("invalid address", "address", c);
  return t;
}
function isAddress(c) {
  try {
    return getAddress(c), !0;
  } catch {
  }
  return !1;
}
function getIcapAddress(c) {
  let t = _base16To36(getAddress(c).substring(2)).toUpperCase();
  for (; t.length < 30; )
    t = "0" + t;
  return "XE" + ibanChecksum("XE00" + t) + t;
}
function getContractAddress(c) {
  let t = null;
  try {
    t = getAddress(c.from);
  } catch {
    logger$q.throwArgumentError("missing from address", "transaction", c);
  }
  const n = stripZeros(arrayify(BigNumber.from(c.nonce).toHexString()));
  return getAddress(hexDataSlice(keccak256$1(encode$6([t, n])), 12));
}
function getCreate2Address(c, t, n) {
  return hexDataLength(t) !== 32 && logger$q.throwArgumentError("salt must be 32 bytes", "salt", t), hexDataLength(n) !== 32 && logger$q.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", n), getAddress(hexDataSlice(keccak256$1(concat$1(["0xff", getAddress(c), t, n])), 12));
}
const lib_esm$f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getAddress,
  getContractAddress,
  getCreate2Address,
  getIcapAddress,
  isAddress
}, Symbol.toStringTag, { value: "Module" }));
class AddressCoder extends Coder {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, n) {
    try {
      n = getAddress(n);
    } catch (ie) {
      this._throwError(ie.message, n);
    }
    return t.writeValue(n);
  }
  decode(t) {
    return getAddress(hexZeroPad(t.readValue().toHexString(), 20));
  }
}
class AnonymousCoder extends Coder {
  constructor(t) {
    super(t.name, t.type, void 0, t.dynamic), this.coder = t;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(t, n) {
    return this.coder.encode(t, n);
  }
  decode(t) {
    return this.coder.decode(t);
  }
}
const logger$p = new Logger(version$r);
function pack$1(c, t, n) {
  let ie = null;
  if (Array.isArray(n))
    ie = n;
  else if (n && typeof n == "object") {
    let me = {};
    ie = t.map((ye) => {
      const be = ye.localName;
      return be || logger$p.throwError("cannot encode object for signature with missing names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: ye,
        value: n
      }), me[be] && logger$p.throwError("cannot encode object for signature with duplicate names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: ye,
        value: n
      }), me[be] = !0, n[be];
    });
  } else
    logger$p.throwArgumentError("invalid tuple value", "tuple", n);
  t.length !== ie.length && logger$p.throwArgumentError("types/value length mismatch", "tuple", n);
  let fe = new Writer(c.wordSize), ae = new Writer(c.wordSize), le = [];
  t.forEach((me, ye) => {
    let be = ie[ye];
    if (me.dynamic) {
      let Ae = ae.length;
      me.encode(ae, be);
      let Se = fe.writeUpdatableValue();
      le.push(($e) => {
        Se($e + Ae);
      });
    } else
      me.encode(fe, be);
  }), le.forEach((me) => {
    me(fe.length);
  });
  let he = c.appendWriter(fe);
  return he += c.appendWriter(ae), he;
}
function unpack(c, t) {
  let n = [], ie = c.subReader(0);
  t.forEach((ae) => {
    let le = null;
    if (ae.dynamic) {
      let he = c.readValue(), me = ie.subReader(he.toNumber());
      try {
        le = ae.decode(me);
      } catch (ye) {
        if (ye.code === Logger.errors.BUFFER_OVERRUN)
          throw ye;
        le = ye, le.baseType = ae.name, le.name = ae.localName, le.type = ae.type;
      }
    } else
      try {
        le = ae.decode(c);
      } catch (he) {
        if (he.code === Logger.errors.BUFFER_OVERRUN)
          throw he;
        le = he, le.baseType = ae.name, le.name = ae.localName, le.type = ae.type;
      }
    le != null && n.push(le);
  });
  const fe = t.reduce((ae, le) => {
    const he = le.localName;
    return he && (ae[he] || (ae[he] = 0), ae[he]++), ae;
  }, {});
  t.forEach((ae, le) => {
    let he = ae.localName;
    if (!he || fe[he] !== 1 || (he === "length" && (he = "_length"), n[he] != null))
      return;
    const me = n[le];
    me instanceof Error ? Object.defineProperty(n, he, {
      enumerable: !0,
      get: () => {
        throw me;
      }
    }) : n[he] = me;
  });
  for (let ae = 0; ae < n.length; ae++) {
    const le = n[ae];
    le instanceof Error && Object.defineProperty(n, ae, {
      enumerable: !0,
      get: () => {
        throw le;
      }
    });
  }
  return Object.freeze(n);
}
class ArrayCoder extends Coder {
  constructor(t, n, ie) {
    const fe = t.type + "[" + (n >= 0 ? n : "") + "]", ae = n === -1 || t.dynamic;
    super("array", fe, ie, ae), this.coder = t, this.length = n;
  }
  defaultValue() {
    const t = this.coder.defaultValue(), n = [];
    for (let ie = 0; ie < this.length; ie++)
      n.push(t);
    return n;
  }
  encode(t, n) {
    Array.isArray(n) || this._throwError("expected array value", n);
    let ie = this.length;
    ie === -1 && (ie = n.length, t.writeValue(n.length)), logger$p.checkArgumentCount(n.length, ie, "coder array" + (this.localName ? " " + this.localName : ""));
    let fe = [];
    for (let ae = 0; ae < n.length; ae++)
      fe.push(this.coder);
    return pack$1(t, fe, n);
  }
  decode(t) {
    let n = this.length;
    n === -1 && (n = t.readValue().toNumber(), n * 32 > t._data.length && logger$p.throwError("insufficient data length", Logger.errors.BUFFER_OVERRUN, {
      length: t._data.length,
      count: n
    }));
    let ie = [];
    for (let fe = 0; fe < n; fe++)
      ie.push(new AnonymousCoder(this.coder));
    return t.coerce(this.name, unpack(t, ie));
  }
}
class BooleanCoder extends Coder {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, n) {
    return t.writeValue(n ? 1 : 0);
  }
  decode(t) {
    return t.coerce(this.type, !t.readValue().isZero());
  }
}
class DynamicBytesCoder extends Coder {
  constructor(t, n) {
    super(t, t, n, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, n) {
    n = arrayify(n);
    let ie = t.writeValue(n.length);
    return ie += t.writeBytes(n), ie;
  }
  decode(t) {
    return t.readBytes(t.readValue().toNumber(), !0);
  }
}
class BytesCoder extends DynamicBytesCoder {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return t.coerce(this.name, hexlify(super.decode(t)));
  }
}
class FixedBytesCoder extends Coder {
  constructor(t, n) {
    let ie = "bytes" + String(t);
    super(ie, ie, n, !1), this.size = t;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(t, n) {
    let ie = arrayify(n);
    return ie.length !== this.size && this._throwError("incorrect data length", n), t.writeBytes(ie);
  }
  decode(t) {
    return t.coerce(this.name, hexlify(t.readBytes(this.size)));
  }
}
class NullCoder extends Coder {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, n) {
    return n != null && this._throwError("not null", n), t.writeBytes([]);
  }
  decode(t) {
    return t.readBytes(0), t.coerce(this.name, null);
  }
}
const AddressZero = "0x0000000000000000000000000000000000000000", NegativeOne$1 = /* @__PURE__ */ BigNumber.from(-1), Zero$1 = /* @__PURE__ */ BigNumber.from(0), One$1 = /* @__PURE__ */ BigNumber.from(1), MaxUint256$1 = /* @__PURE__ */ BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
class NumberCoder extends Coder {
  constructor(t, n, ie) {
    const fe = (n ? "int" : "uint") + t * 8;
    super(fe, fe, ie, !1), this.size = t, this.signed = n;
  }
  defaultValue() {
    return 0;
  }
  encode(t, n) {
    let ie = BigNumber.from(n), fe = MaxUint256$1.mask(t.wordSize * 8);
    if (this.signed) {
      let ae = fe.mask(this.size * 8 - 1);
      (ie.gt(ae) || ie.lt(ae.add(One$1).mul(NegativeOne$1))) && this._throwError("value out-of-bounds", n);
    } else (ie.lt(Zero$1) || ie.gt(fe.mask(this.size * 8))) && this._throwError("value out-of-bounds", n);
    return ie = ie.toTwos(this.size * 8).mask(this.size * 8), this.signed && (ie = ie.fromTwos(this.size * 8).toTwos(8 * t.wordSize)), t.writeValue(ie);
  }
  decode(t) {
    let n = t.readValue().mask(this.size * 8);
    return this.signed && (n = n.fromTwos(this.size * 8)), t.coerce(this.name, n);
  }
}
const version$o = "strings/5.7.0", logger$o = new Logger(version$o);
var UnicodeNormalizationForm;
(function(c) {
  c.current = "", c.NFC = "NFC", c.NFD = "NFD", c.NFKC = "NFKC", c.NFKD = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function(c) {
  c.UNEXPECTED_CONTINUE = "unexpected continuation byte", c.BAD_PREFIX = "bad codepoint prefix", c.OVERRUN = "string overrun", c.MISSING_CONTINUE = "missing continuation byte", c.OUT_OF_RANGE = "out of UTF-8 range", c.UTF16_SURROGATE = "UTF-16 surrogate", c.OVERLONG = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function errorFunc(c, t, n, ie, fe) {
  return logger$o.throwArgumentError(`invalid codepoint at offset ${t}; ${c}`, "bytes", n);
}
function ignoreFunc(c, t, n, ie, fe) {
  if (c === Utf8ErrorReason.BAD_PREFIX || c === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
    let ae = 0;
    for (let le = t + 1; le < n.length && n[le] >> 6 === 2; le++)
      ae++;
    return ae;
  }
  return c === Utf8ErrorReason.OVERRUN ? n.length - t - 1 : 0;
}
function replaceFunc(c, t, n, ie, fe) {
  return c === Utf8ErrorReason.OVERLONG ? (ie.push(fe), 0) : (ie.push(65533), ignoreFunc(c, t, n));
}
const Utf8ErrorFuncs = Object.freeze({
  error: errorFunc,
  ignore: ignoreFunc,
  replace: replaceFunc
});
function getUtf8CodePoints(c, t) {
  t == null && (t = Utf8ErrorFuncs.error), c = arrayify(c);
  const n = [];
  let ie = 0;
  for (; ie < c.length; ) {
    const fe = c[ie++];
    if (!(fe >> 7)) {
      n.push(fe);
      continue;
    }
    let ae = null, le = null;
    if ((fe & 224) === 192)
      ae = 1, le = 127;
    else if ((fe & 240) === 224)
      ae = 2, le = 2047;
    else if ((fe & 248) === 240)
      ae = 3, le = 65535;
    else {
      (fe & 192) === 128 ? ie += t(Utf8ErrorReason.UNEXPECTED_CONTINUE, ie - 1, c, n) : ie += t(Utf8ErrorReason.BAD_PREFIX, ie - 1, c, n);
      continue;
    }
    if (ie - 1 + ae >= c.length) {
      ie += t(Utf8ErrorReason.OVERRUN, ie - 1, c, n);
      continue;
    }
    let he = fe & (1 << 8 - ae - 1) - 1;
    for (let me = 0; me < ae; me++) {
      let ye = c[ie];
      if ((ye & 192) != 128) {
        ie += t(Utf8ErrorReason.MISSING_CONTINUE, ie, c, n), he = null;
        break;
      }
      he = he << 6 | ye & 63, ie++;
    }
    if (he !== null) {
      if (he > 1114111) {
        ie += t(Utf8ErrorReason.OUT_OF_RANGE, ie - 1 - ae, c, n, he);
        continue;
      }
      if (he >= 55296 && he <= 57343) {
        ie += t(Utf8ErrorReason.UTF16_SURROGATE, ie - 1 - ae, c, n, he);
        continue;
      }
      if (he <= le) {
        ie += t(Utf8ErrorReason.OVERLONG, ie - 1 - ae, c, n, he);
        continue;
      }
      n.push(he);
    }
  }
  return n;
}
function toUtf8Bytes(c, t = UnicodeNormalizationForm.current) {
  t != UnicodeNormalizationForm.current && (logger$o.checkNormalize(), c = c.normalize(t));
  let n = [];
  for (let ie = 0; ie < c.length; ie++) {
    const fe = c.charCodeAt(ie);
    if (fe < 128)
      n.push(fe);
    else if (fe < 2048)
      n.push(fe >> 6 | 192), n.push(fe & 63 | 128);
    else if ((fe & 64512) == 55296) {
      ie++;
      const ae = c.charCodeAt(ie);
      if (ie >= c.length || (ae & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const le = 65536 + ((fe & 1023) << 10) + (ae & 1023);
      n.push(le >> 18 | 240), n.push(le >> 12 & 63 | 128), n.push(le >> 6 & 63 | 128), n.push(le & 63 | 128);
    } else
      n.push(fe >> 12 | 224), n.push(fe >> 6 & 63 | 128), n.push(fe & 63 | 128);
  }
  return arrayify(n);
}
function escapeChar(c) {
  const t = "0000" + c.toString(16);
  return "\\u" + t.substring(t.length - 4);
}
function _toEscapedUtf8String(c, t) {
  return '"' + getUtf8CodePoints(c, t).map((n) => {
    if (n < 256) {
      switch (n) {
        case 8:
          return "\\b";
        case 9:
          return "\\t";
        case 10:
          return "\\n";
        case 13:
          return "\\r";
        case 34:
          return '\\"';
        case 92:
          return "\\\\";
      }
      if (n >= 32 && n < 127)
        return String.fromCharCode(n);
    }
    return n <= 65535 ? escapeChar(n) : (n -= 65536, escapeChar((n >> 10 & 1023) + 55296) + escapeChar((n & 1023) + 56320));
  }).join("") + '"';
}
function _toUtf8String(c) {
  return c.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function toUtf8String(c, t) {
  return _toUtf8String(getUtf8CodePoints(c, t));
}
function toUtf8CodePoints(c, t = UnicodeNormalizationForm.current) {
  return getUtf8CodePoints(toUtf8Bytes(c, t));
}
function formatBytes32String(c) {
  const t = toUtf8Bytes(c);
  if (t.length > 31)
    throw new Error("bytes32 string must be less than 32 bytes");
  return hexlify(concat$1([t, HashZero]).slice(0, 32));
}
function parseBytes32String(c) {
  const t = arrayify(c);
  if (t.length !== 32)
    throw new Error("invalid bytes32 - not 32 bytes long");
  if (t[31] !== 0)
    throw new Error("invalid bytes32 string - no null terminator");
  let n = 31;
  for (; t[n - 1] === 0; )
    n--;
  return toUtf8String(t.slice(0, n));
}
function bytes2(c) {
  if (c.length % 4 !== 0)
    throw new Error("bad data");
  let t = [];
  for (let n = 0; n < c.length; n += 4)
    t.push(parseInt(c.substring(n, n + 4), 16));
  return t;
}
function createTable(c, t) {
  t || (t = function(fe) {
    return [parseInt(fe, 16)];
  });
  let n = 0, ie = {};
  return c.split(",").forEach((fe) => {
    let ae = fe.split(":");
    n += parseInt(ae[0], 16), ie[n] = t(ae[1]);
  }), ie;
}
function createRangeTable(c) {
  let t = 0;
  return c.split(",").map((n) => {
    let ie = n.split("-");
    ie.length === 1 ? ie[1] = "0" : ie[1] === "" && (ie[1] = "1");
    let fe = t + parseInt(ie[0], 16);
    return t = parseInt(ie[1], 16), { l: fe, h: t };
  });
}
function matchMap(c, t) {
  let n = 0;
  for (let ie = 0; ie < t.length; ie++) {
    let fe = t[ie];
    if (n += fe.l, c >= n && c <= n + fe.h && (c - n) % (fe.d || 1) === 0) {
      if (fe.e && fe.e.indexOf(c - n) !== -1)
        continue;
      return fe;
    }
  }
  return null;
}
const Table_A_1_ranges = createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((c) => parseInt(c, 16)), Table_B_2_ranges = [
  { h: 25, s: 32, l: 65 },
  { h: 30, s: 32, e: [23], l: 127 },
  { h: 54, s: 1, e: [48], l: 64, d: 2 },
  { h: 14, s: 1, l: 57, d: 2 },
  { h: 44, s: 1, l: 17, d: 2 },
  { h: 10, s: 1, e: [2, 6, 8], l: 61, d: 2 },
  { h: 16, s: 1, l: 68, d: 2 },
  { h: 84, s: 1, e: [18, 24, 66], l: 19, d: 2 },
  { h: 26, s: 32, e: [17], l: 435 },
  { h: 22, s: 1, l: 71, d: 2 },
  { h: 15, s: 80, l: 40 },
  { h: 31, s: 32, l: 16 },
  { h: 32, s: 1, l: 80, d: 2 },
  { h: 52, s: 1, l: 42, d: 2 },
  { h: 12, s: 1, l: 55, d: 2 },
  { h: 40, s: 1, e: [38], l: 15, d: 2 },
  { h: 14, s: 1, l: 48, d: 2 },
  { h: 37, s: 48, l: 49 },
  { h: 148, s: 1, l: 6351, d: 2 },
  { h: 88, s: 1, l: 160, d: 2 },
  { h: 15, s: 16, l: 704 },
  { h: 25, s: 26, l: 854 },
  { h: 25, s: 32, l: 55915 },
  { h: 37, s: 40, l: 1247 },
  { h: 25, s: -119711, l: 53248 },
  { h: 25, s: -119763, l: 52 },
  { h: 25, s: -119815, l: 52 },
  { h: 25, s: -119867, e: [1, 4, 5, 7, 8, 11, 12, 17], l: 52 },
  { h: 25, s: -119919, l: 52 },
  { h: 24, s: -119971, e: [2, 7, 8, 17], l: 52 },
  { h: 24, s: -120023, e: [2, 7, 13, 15, 16, 17], l: 52 },
  { h: 25, s: -120075, l: 52 },
  { h: 25, s: -120127, l: 52 },
  { h: 25, s: -120179, l: 52 },
  { h: 25, s: -120231, l: 52 },
  { h: 25, s: -120283, l: 52 },
  { h: 25, s: -120335, l: 52 },
  { h: 24, s: -119543, e: [17], l: 56 },
  { h: 24, s: -119601, e: [17], l: 58 },
  { h: 24, s: -119659, e: [17], l: 58 },
  { h: 24, s: -119717, e: [17], l: 58 },
  { h: 24, s: -119775, e: [17], l: 58 }
], Table_B_2_lut_abs = createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), Table_B_2_lut_rel = createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), Table_B_2_complex = createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", bytes2), Table_C_ranges = createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function flatten(c) {
  return c.reduce((t, n) => (n.forEach((ie) => {
    t.push(ie);
  }), t), []);
}
function _nameprepTableA1(c) {
  return !!matchMap(c, Table_A_1_ranges);
}
function _nameprepTableB2(c) {
  let t = matchMap(c, Table_B_2_ranges);
  if (t)
    return [c + t.s];
  let n = Table_B_2_lut_abs[c];
  if (n)
    return n;
  let ie = Table_B_2_lut_rel[c];
  if (ie)
    return [c + ie[0]];
  let fe = Table_B_2_complex[c];
  return fe || null;
}
function _nameprepTableC(c) {
  return !!matchMap(c, Table_C_ranges);
}
function nameprep(c) {
  if (c.match(/^[a-z0-9-]*$/i) && c.length <= 59)
    return c.toLowerCase();
  let t = toUtf8CodePoints(c);
  t = flatten(t.map((ie) => {
    if (Table_B_1_flags.indexOf(ie) >= 0)
      return [];
    if (ie >= 65024 && ie <= 65039)
      return [];
    let fe = _nameprepTableB2(ie);
    return fe || [ie];
  })), t = toUtf8CodePoints(_toUtf8String(t), UnicodeNormalizationForm.NFKC), t.forEach((ie) => {
    if (_nameprepTableC(ie))
      throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
  }), t.forEach((ie) => {
    if (_nameprepTableA1(ie))
      throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
  });
  let n = _toUtf8String(t);
  if (n.substring(0, 1) === "-" || n.substring(2, 4) === "--" || n.substring(n.length - 1) === "-")
    throw new Error("invalid hyphen");
  return n;
}
const lib_esm$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get UnicodeNormalizationForm() {
    return UnicodeNormalizationForm;
  },
  Utf8ErrorFuncs,
  get Utf8ErrorReason() {
    return Utf8ErrorReason;
  },
  _toEscapedUtf8String,
  formatBytes32String,
  nameprep,
  parseBytes32String,
  toUtf8Bytes,
  toUtf8CodePoints,
  toUtf8String
}, Symbol.toStringTag, { value: "Module" }));
class StringCoder extends DynamicBytesCoder {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, n) {
    return super.encode(t, toUtf8Bytes(n));
  }
  decode(t) {
    return toUtf8String(super.decode(t));
  }
}
class TupleCoder extends Coder {
  constructor(t, n) {
    let ie = !1;
    const fe = [];
    t.forEach((le) => {
      le.dynamic && (ie = !0), fe.push(le.type);
    });
    const ae = "tuple(" + fe.join(",") + ")";
    super("tuple", ae, n, ie), this.coders = t;
  }
  defaultValue() {
    const t = [];
    this.coders.forEach((ie) => {
      t.push(ie.defaultValue());
    });
    const n = this.coders.reduce((ie, fe) => {
      const ae = fe.localName;
      return ae && (ie[ae] || (ie[ae] = 0), ie[ae]++), ie;
    }, {});
    return this.coders.forEach((ie, fe) => {
      let ae = ie.localName;
      !ae || n[ae] !== 1 || (ae === "length" && (ae = "_length"), t[ae] == null && (t[ae] = t[fe]));
    }), Object.freeze(t);
  }
  encode(t, n) {
    return pack$1(t, this.coders, n);
  }
  decode(t) {
    return t.coerce(this.name, unpack(t, this.coders));
  }
}
const logger$n = new Logger(version$r), paramTypeBytes = new RegExp(/^bytes([0-9]*)$/), paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
  constructor(t) {
    defineReadOnly(this, "coerceFunc", t || null);
  }
  _getCoder(t) {
    switch (t.baseType) {
      case "address":
        return new AddressCoder(t.name);
      case "bool":
        return new BooleanCoder(t.name);
      case "string":
        return new StringCoder(t.name);
      case "bytes":
        return new BytesCoder(t.name);
      case "array":
        return new ArrayCoder(this._getCoder(t.arrayChildren), t.arrayLength, t.name);
      case "tuple":
        return new TupleCoder((t.components || []).map((ie) => this._getCoder(ie)), t.name);
      case "":
        return new NullCoder(t.name);
    }
    let n = t.type.match(paramTypeNumber);
    if (n) {
      let ie = parseInt(n[2] || "256");
      return (ie === 0 || ie > 256 || ie % 8 !== 0) && logger$n.throwArgumentError("invalid " + n[1] + " bit length", "param", t), new NumberCoder(ie / 8, n[1] === "int", t.name);
    }
    if (n = t.type.match(paramTypeBytes), n) {
      let ie = parseInt(n[1]);
      return (ie === 0 || ie > 32) && logger$n.throwArgumentError("invalid bytes length", "param", t), new FixedBytesCoder(ie, t.name);
    }
    return logger$n.throwArgumentError("invalid type", "type", t.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(t, n) {
    return new Reader(t, this._getWordSize(), this.coerceFunc, n);
  }
  _getWriter() {
    return new Writer(this._getWordSize());
  }
  getDefaultValue(t) {
    const n = t.map((fe) => this._getCoder(ParamType.from(fe)));
    return new TupleCoder(n, "_").defaultValue();
  }
  encode(t, n) {
    t.length !== n.length && logger$n.throwError("types/values length mismatch", Logger.errors.INVALID_ARGUMENT, {
      count: { types: t.length, values: n.length },
      value: { types: t, values: n }
    });
    const ie = t.map((le) => this._getCoder(ParamType.from(le))), fe = new TupleCoder(ie, "_"), ae = this._getWriter();
    return fe.encode(ae, n), ae.data;
  }
  decode(t, n, ie) {
    const fe = t.map((le) => this._getCoder(ParamType.from(le)));
    return new TupleCoder(fe, "_").decode(this._getReader(arrayify(n), ie));
  }
}
const defaultAbiCoder = new AbiCoder();
function id(c) {
  return keccak256$1(toUtf8Bytes(c));
}
const version$n = "hash/5.7.0";
function decode$6(c) {
  c = atob(c);
  const t = [];
  for (let n = 0; n < c.length; n++)
    t.push(c.charCodeAt(n));
  return arrayify(t);
}
function encode$5(c) {
  c = arrayify(c);
  let t = "";
  for (let n = 0; n < c.length; n++)
    t += String.fromCharCode(c[n]);
  return btoa(t);
}
const lib_esm$d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$6,
  encode: encode$5
}, Symbol.toStringTag, { value: "Module" }));
function flat(c, t) {
  t == null && (t = 1);
  const n = [], ie = n.forEach, fe = function(ae, le) {
    ie.call(ae, function(he) {
      le > 0 && Array.isArray(he) ? fe(he, le - 1) : n.push(he);
    });
  };
  return fe(c, t), n;
}
function fromEntries(c) {
  const t = {};
  for (let n = 0; n < c.length; n++) {
    const ie = c[n];
    t[ie[0]] = ie[1];
  }
  return t;
}
function decode_arithmetic(c) {
  let t = 0;
  function n() {
    return c[t++] << 8 | c[t++];
  }
  let ie = n(), fe = 1, ae = [0, 1];
  for (let ze = 1; ze < ie; ze++)
    ae.push(fe += n());
  let le = n(), he = t;
  t += le;
  let me = 0, ye = 0;
  function be() {
    return me == 0 && (ye = ye << 8 | c[t++], me = 8), ye >> --me & 1;
  }
  const Ae = 31, Se = Math.pow(2, Ae), $e = Se >>> 1, Re = $e >> 1, Me = Se - 1;
  let ke = 0;
  for (let ze = 0; ze < Ae; ze++)
    ke = ke << 1 | be();
  let Te = [], Ie = 0, qe = Se;
  for (; ; ) {
    let ze = Math.floor(((ke - Ie + 1) * fe - 1) / qe), Ve = 0, Mt = ie;
    for (; Mt - Ve > 1; ) {
      let jt = Ve + Mt >>> 1;
      ze < ae[jt] ? Mt = jt : Ve = jt;
    }
    if (Ve == 0)
      break;
    Te.push(Ve);
    let Rt = Ie + Math.floor(qe * ae[Ve] / fe), je = Ie + Math.floor(qe * ae[Ve + 1] / fe) - 1;
    for (; !((Rt ^ je) & $e); )
      ke = ke << 1 & Me | be(), Rt = Rt << 1 & Me, je = je << 1 & Me | 1;
    for (; Rt & ~je & Re; )
      ke = ke & $e | ke << 1 & Me >>> 1 | be(), Rt = Rt << 1 ^ $e, je = (je ^ $e) << 1 | $e | 1;
    Ie = Rt, qe = 1 + je - Rt;
  }
  let Ue = ie - 4;
  return Te.map((ze) => {
    switch (ze - Ue) {
      case 3:
        return Ue + 65792 + (c[he++] << 16 | c[he++] << 8 | c[he++]);
      case 2:
        return Ue + 256 + (c[he++] << 8 | c[he++]);
      case 1:
        return Ue + c[he++];
      default:
        return ze - 1;
    }
  });
}
function read_payload(c) {
  let t = 0;
  return () => c[t++];
}
function read_compressed_payload(c) {
  return read_payload(decode_arithmetic(c));
}
function signed(c) {
  return c & 1 ? ~c >> 1 : c >> 1;
}
function read_counts(c, t) {
  let n = Array(c);
  for (let ie = 0; ie < c; ie++)
    n[ie] = 1 + t();
  return n;
}
function read_ascending(c, t) {
  let n = Array(c);
  for (let ie = 0, fe = -1; ie < c; ie++)
    n[ie] = fe += 1 + t();
  return n;
}
function read_deltas(c, t) {
  let n = Array(c);
  for (let ie = 0, fe = 0; ie < c; ie++)
    n[ie] = fe += signed(t());
  return n;
}
function read_member_array(c, t) {
  let n = read_ascending(c(), c), ie = c(), fe = read_ascending(ie, c), ae = read_counts(ie, c);
  for (let le = 0; le < ie; le++)
    for (let he = 0; he < ae[le]; he++)
      n.push(fe[le] + he);
  return t ? n.map((le) => t[le]) : n;
}
function read_mapped_map(c) {
  let t = [];
  for (; ; ) {
    let n = c();
    if (n == 0)
      break;
    t.push(read_linear_table(n, c));
  }
  for (; ; ) {
    let n = c() - 1;
    if (n < 0)
      break;
    t.push(read_replacement_table(n, c));
  }
  return fromEntries(flat(t));
}
function read_zero_terminated_array(c) {
  let t = [];
  for (; ; ) {
    let n = c();
    if (n == 0)
      break;
    t.push(n);
  }
  return t;
}
function read_transposed(c, t, n) {
  let ie = Array(c).fill(void 0).map(() => []);
  for (let fe = 0; fe < t; fe++)
    read_deltas(c, n).forEach((ae, le) => ie[le].push(ae));
  return ie;
}
function read_linear_table(c, t) {
  let n = 1 + t(), ie = t(), fe = read_zero_terminated_array(t), ae = read_transposed(fe.length, 1 + c, t);
  return flat(ae.map((le, he) => {
    const me = le[0], ye = le.slice(1);
    return Array(fe[he]).fill(void 0).map((be, Ae) => {
      let Se = Ae * ie;
      return [me + Ae * n, ye.map(($e) => $e + Se)];
    });
  }));
}
function read_replacement_table(c, t) {
  let n = 1 + t();
  return read_transposed(n, 1 + c, t).map((fe) => [fe[0], fe.slice(1)]);
}
function read_emoji_trie(c) {
  let t = read_member_array(c).sort((ie, fe) => ie - fe);
  return n();
  function n() {
    let ie = [];
    for (; ; ) {
      let ye = read_member_array(c, t);
      if (ye.length == 0)
        break;
      ie.push({ set: new Set(ye), node: n() });
    }
    ie.sort((ye, be) => be.set.size - ye.set.size);
    let fe = c(), ae = fe % 3;
    fe = fe / 3 | 0;
    let le = !!(fe & 1);
    fe >>= 1;
    let he = fe == 1, me = fe == 2;
    return { branches: ie, valid: ae, fe0f: le, save: he, check: me };
  }
}
function getData() {
  return read_compressed_payload(decode$6("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"));
}
const r$2 = getData(), VALID = new Set(read_member_array(r$2)), IGNORED = new Set(read_member_array(r$2)), MAPPED = read_mapped_map(r$2), EMOJI_ROOT = read_emoji_trie(r$2), HYPHEN = 45, UNDERSCORE = 95;
function explode_cp(c) {
  return toUtf8CodePoints(c);
}
function filter_fe0f(c) {
  return c.filter((t) => t != 65039);
}
function ens_normalize_post_check(c) {
  for (let t of c.split(".")) {
    let n = explode_cp(t);
    try {
      for (let ie = n.lastIndexOf(UNDERSCORE) - 1; ie >= 0; ie--)
        if (n[ie] !== UNDERSCORE)
          throw new Error("underscore only allowed at start");
      if (n.length >= 4 && n.every((ie) => ie < 128) && n[2] === HYPHEN && n[3] === HYPHEN)
        throw new Error("invalid label extension");
    } catch (ie) {
      throw new Error(`Invalid label "${t}": ${ie.message}`);
    }
  }
  return c;
}
function ens_normalize(c) {
  return ens_normalize_post_check(normalize(c, filter_fe0f));
}
function normalize(c, t) {
  let n = explode_cp(c).reverse(), ie = [];
  for (; n.length; ) {
    let fe = consume_emoji_reversed(n);
    if (fe) {
      ie.push(...t(fe));
      continue;
    }
    let ae = n.pop();
    if (VALID.has(ae)) {
      ie.push(ae);
      continue;
    }
    if (IGNORED.has(ae))
      continue;
    let le = MAPPED[ae];
    if (le) {
      ie.push(...le);
      continue;
    }
    throw new Error(`Disallowed codepoint: 0x${ae.toString(16).toUpperCase()}`);
  }
  return ens_normalize_post_check(nfc(String.fromCodePoint(...ie)));
}
function nfc(c) {
  return c.normalize("NFC");
}
function consume_emoji_reversed(c, t) {
  var n;
  let ie = EMOJI_ROOT, fe, ae, le = [], he = c.length;
  for (; he; ) {
    let me = c[--he];
    if (ie = (n = ie.branches.find((ye) => ye.set.has(me))) === null || n === void 0 ? void 0 : n.node, !ie)
      break;
    if (ie.save)
      ae = me;
    else if (ie.check && me === ae)
      break;
    le.push(me), ie.fe0f && (le.push(65039), he > 0 && c[he - 1] == 65039 && he--), ie.valid && (fe = le.slice(), ie.valid == 2 && fe.splice(1, 1), c.length = he);
  }
  return fe;
}
const logger$m = new Logger(version$n), Zeros$1 = new Uint8Array(32);
Zeros$1.fill(0);
function checkComponent(c) {
  if (c.length === 0)
    throw new Error("invalid ENS name; empty component");
  return c;
}
function ensNameSplit(c) {
  const t = toUtf8Bytes(ens_normalize(c)), n = [];
  if (c.length === 0)
    return n;
  let ie = 0;
  for (let fe = 0; fe < t.length; fe++)
    t[fe] === 46 && (n.push(checkComponent(t.slice(ie, fe))), ie = fe + 1);
  if (ie >= t.length)
    throw new Error("invalid ENS name; empty component");
  return n.push(checkComponent(t.slice(ie))), n;
}
function ensNormalize(c) {
  return ensNameSplit(c).map((t) => toUtf8String(t)).join(".");
}
function isValidName(c) {
  try {
    return ensNameSplit(c).length !== 0;
  } catch {
  }
  return !1;
}
function namehash$1(c) {
  typeof c != "string" && logger$m.throwArgumentError("invalid ENS name; not a string", "name", c);
  let t = Zeros$1;
  const n = ensNameSplit(c);
  for (; n.length; )
    t = keccak256$1(concat$1([t, keccak256$1(n.pop())]));
  return hexlify(t);
}
function dnsEncode(c) {
  return hexlify(concat$1(ensNameSplit(c).map((t) => {
    if (t.length > 63)
      throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
    const n = new Uint8Array(t.length + 1);
    return n.set(t, 1), n[0] = n.length - 1, n;
  }))) + "00";
}
const messagePrefix = `Ethereum Signed Message:
`;
function hashMessage(c) {
  return typeof c == "string" && (c = toUtf8Bytes(c)), keccak256$1(concat$1([
    toUtf8Bytes(messagePrefix),
    toUtf8Bytes(String(c.length)),
    c
  ]));
}
var __awaiter$k = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$l = new Logger(version$n), padding = new Uint8Array(32);
padding.fill(0);
const NegativeOne = BigNumber.from(-1), Zero = BigNumber.from(0), One = BigNumber.from(1), MaxUint256 = BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(c) {
  const t = arrayify(c), n = t.length % 32;
  return n ? hexConcat([t, padding.slice(n)]) : hexlify(t);
}
const hexTrue = hexZeroPad(One.toHexString(), 32), hexFalse = hexZeroPad(Zero.toHexString(), 32), domainFieldTypes = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, domainFieldNames = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function checkString(c) {
  return function(t) {
    return typeof t != "string" && logger$l.throwArgumentError(`invalid domain value for ${JSON.stringify(c)}`, `domain.${c}`, t), t;
  };
}
const domainChecks = {
  name: checkString("name"),
  version: checkString("version"),
  chainId: function(c) {
    try {
      return BigNumber.from(c).toString();
    } catch {
    }
    return logger$l.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", c);
  },
  verifyingContract: function(c) {
    try {
      return getAddress(c).toLowerCase();
    } catch {
    }
    return logger$l.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", c);
  },
  salt: function(c) {
    try {
      const t = arrayify(c);
      if (t.length !== 32)
        throw new Error("bad length");
      return hexlify(t);
    } catch {
    }
    return logger$l.throwArgumentError('invalid domain value "salt"', "domain.salt", c);
  }
};
function getBaseEncoder(c) {
  {
    const t = c.match(/^(u?)int(\d*)$/);
    if (t) {
      const n = t[1] === "", ie = parseInt(t[2] || "256");
      (ie % 8 !== 0 || ie > 256 || t[2] && t[2] !== String(ie)) && logger$l.throwArgumentError("invalid numeric width", "type", c);
      const fe = MaxUint256.mask(n ? ie - 1 : ie), ae = n ? fe.add(One).mul(NegativeOne) : Zero;
      return function(le) {
        const he = BigNumber.from(le);
        return (he.lt(ae) || he.gt(fe)) && logger$l.throwArgumentError(`value out-of-bounds for ${c}`, "value", le), hexZeroPad(he.toTwos(256).toHexString(), 32);
      };
    }
  }
  {
    const t = c.match(/^bytes(\d+)$/);
    if (t) {
      const n = parseInt(t[1]);
      return (n === 0 || n > 32 || t[1] !== String(n)) && logger$l.throwArgumentError("invalid bytes width", "type", c), function(ie) {
        return arrayify(ie).length !== n && logger$l.throwArgumentError(`invalid length for ${c}`, "value", ie), hexPadRight(ie);
      };
    }
  }
  switch (c) {
    case "address":
      return function(t) {
        return hexZeroPad(getAddress(t), 32);
      };
    case "bool":
      return function(t) {
        return t ? hexTrue : hexFalse;
      };
    case "bytes":
      return function(t) {
        return keccak256$1(t);
      };
    case "string":
      return function(t) {
        return id(t);
      };
  }
  return null;
}
function encodeType(c, t) {
  return `${c}(${t.map(({ name: n, type: ie }) => ie + " " + n).join(",")})`;
}
class TypedDataEncoder {
  constructor(t) {
    defineReadOnly(this, "types", Object.freeze(deepCopy(t))), defineReadOnly(this, "_encoderCache", {}), defineReadOnly(this, "_types", {});
    const n = {}, ie = {}, fe = {};
    Object.keys(t).forEach((he) => {
      n[he] = {}, ie[he] = [], fe[he] = {};
    });
    for (const he in t) {
      const me = {};
      t[he].forEach((ye) => {
        me[ye.name] && logger$l.throwArgumentError(`duplicate variable name ${JSON.stringify(ye.name)} in ${JSON.stringify(he)}`, "types", t), me[ye.name] = !0;
        const be = ye.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
        be === he && logger$l.throwArgumentError(`circular type reference to ${JSON.stringify(be)}`, "types", t), !getBaseEncoder(be) && (ie[be] || logger$l.throwArgumentError(`unknown type ${JSON.stringify(be)}`, "types", t), ie[be].push(he), n[he][be] = !0);
      });
    }
    const ae = Object.keys(ie).filter((he) => ie[he].length === 0);
    ae.length === 0 ? logger$l.throwArgumentError("missing primary type", "types", t) : ae.length > 1 && logger$l.throwArgumentError(`ambiguous primary types or unused types: ${ae.map((he) => JSON.stringify(he)).join(", ")}`, "types", t), defineReadOnly(this, "primaryType", ae[0]);
    function le(he, me) {
      me[he] && logger$l.throwArgumentError(`circular type reference to ${JSON.stringify(he)}`, "types", t), me[he] = !0, Object.keys(n[he]).forEach((ye) => {
        ie[ye] && (le(ye, me), Object.keys(me).forEach((be) => {
          fe[be][ye] = !0;
        }));
      }), delete me[he];
    }
    le(this.primaryType, {});
    for (const he in fe) {
      const me = Object.keys(fe[he]);
      me.sort(), this._types[he] = encodeType(he, t[he]) + me.map((ye) => encodeType(ye, t[ye])).join("");
    }
  }
  getEncoder(t) {
    let n = this._encoderCache[t];
    return n || (n = this._encoderCache[t] = this._getEncoder(t)), n;
  }
  _getEncoder(t) {
    {
      const fe = getBaseEncoder(t);
      if (fe)
        return fe;
    }
    const n = t.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (n) {
      const fe = n[1], ae = this.getEncoder(fe), le = parseInt(n[3]);
      return (he) => {
        le >= 0 && he.length !== le && logger$l.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", he);
        let me = he.map(ae);
        return this._types[fe] && (me = me.map(keccak256$1)), keccak256$1(hexConcat(me));
      };
    }
    const ie = this.types[t];
    if (ie) {
      const fe = id(this._types[t]);
      return (ae) => {
        const le = ie.map(({ name: he, type: me }) => {
          const ye = this.getEncoder(me)(ae[he]);
          return this._types[me] ? keccak256$1(ye) : ye;
        });
        return le.unshift(fe), hexConcat(le);
      };
    }
    return logger$l.throwArgumentError(`unknown type: ${t}`, "type", t);
  }
  encodeType(t) {
    const n = this._types[t];
    return n || logger$l.throwArgumentError(`unknown type: ${JSON.stringify(t)}`, "name", t), n;
  }
  encodeData(t, n) {
    return this.getEncoder(t)(n);
  }
  hashStruct(t, n) {
    return keccak256$1(this.encodeData(t, n));
  }
  encode(t) {
    return this.encodeData(this.primaryType, t);
  }
  hash(t) {
    return this.hashStruct(this.primaryType, t);
  }
  _visit(t, n, ie) {
    if (getBaseEncoder(t))
      return ie(t, n);
    const fe = t.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (fe) {
      const le = fe[1], he = parseInt(fe[3]);
      return he >= 0 && n.length !== he && logger$l.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", n), n.map((me) => this._visit(le, me, ie));
    }
    const ae = this.types[t];
    return ae ? ae.reduce((le, { name: he, type: me }) => (le[he] = this._visit(me, n[he], ie), le), {}) : logger$l.throwArgumentError(`unknown type: ${t}`, "type", t);
  }
  visit(t, n) {
    return this._visit(this.primaryType, t, n);
  }
  static from(t) {
    return new TypedDataEncoder(t);
  }
  static getPrimaryType(t) {
    return TypedDataEncoder.from(t).primaryType;
  }
  static hashStruct(t, n, ie) {
    return TypedDataEncoder.from(n).hashStruct(t, ie);
  }
  static hashDomain(t) {
    const n = [];
    for (const ie in t) {
      const fe = domainFieldTypes[ie];
      fe || logger$l.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(ie)}`, "domain", t), n.push({ name: ie, type: fe });
    }
    return n.sort((ie, fe) => domainFieldNames.indexOf(ie.name) - domainFieldNames.indexOf(fe.name)), TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: n }, t);
  }
  static encode(t, n, ie) {
    return hexConcat([
      "0x1901",
      TypedDataEncoder.hashDomain(t),
      TypedDataEncoder.from(n).hash(ie)
    ]);
  }
  static hash(t, n, ie) {
    return keccak256$1(TypedDataEncoder.encode(t, n, ie));
  }
  // Replaces all address types with ENS names with their looked up address
  static resolveNames(t, n, ie, fe) {
    return __awaiter$k(this, void 0, void 0, function* () {
      t = shallowCopy(t);
      const ae = {};
      t.verifyingContract && !isHexString(t.verifyingContract, 20) && (ae[t.verifyingContract] = "0x");
      const le = TypedDataEncoder.from(n);
      le.visit(ie, (he, me) => (he === "address" && !isHexString(me, 20) && (ae[me] = "0x"), me));
      for (const he in ae)
        ae[he] = yield fe(he);
      return t.verifyingContract && ae[t.verifyingContract] && (t.verifyingContract = ae[t.verifyingContract]), ie = le.visit(ie, (he, me) => he === "address" && ae[me] ? ae[me] : me), { domain: t, value: ie };
    });
  }
  static getPayload(t, n, ie) {
    TypedDataEncoder.hashDomain(t);
    const fe = {}, ae = [];
    domainFieldNames.forEach((me) => {
      const ye = t[me];
      ye != null && (fe[me] = domainChecks[me](ye), ae.push({ name: me, type: domainFieldTypes[me] }));
    });
    const le = TypedDataEncoder.from(n), he = shallowCopy(n);
    return he.EIP712Domain ? logger$l.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", n) : he.EIP712Domain = ae, le.encode(ie), {
      types: he,
      domain: fe,
      primaryType: le.primaryType,
      message: le.visit(ie, (me, ye) => {
        if (me.match(/^bytes(\d*)/))
          return hexlify(arrayify(ye));
        if (me.match(/^u?int/))
          return BigNumber.from(ye).toString();
        switch (me) {
          case "address":
            return ye.toLowerCase();
          case "bool":
            return !!ye;
          case "string":
            return typeof ye != "string" && logger$l.throwArgumentError("invalid string", "value", ye), ye;
        }
        return logger$l.throwArgumentError("unsupported type", "type", me);
      })
    };
  }
}
const lib_esm$c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _TypedDataEncoder: TypedDataEncoder,
  dnsEncode,
  ensNormalize,
  hashMessage,
  id,
  isValidName,
  messagePrefix,
  namehash: namehash$1
}, Symbol.toStringTag, { value: "Module" })), logger$k = new Logger(version$r);
class LogDescription extends Description {
}
class TransactionDescription extends Description {
}
class ErrorDescription extends Description {
}
class Indexed extends Description {
  static isIndexed(t) {
    return !!(t && t._isIndexed);
  }
}
const BuiltinErrors = {
  "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: !0 },
  "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function wrapAccessError(c, t) {
  const n = new Error(`deferred error during ABI decoding triggered accessing ${c}`);
  return n.error = t, n;
}
class Interface {
  constructor(t) {
    let n = [];
    typeof t == "string" ? n = JSON.parse(t) : n = t, defineReadOnly(this, "fragments", n.map((ie) => Fragment.from(ie)).filter((ie) => ie != null)), defineReadOnly(this, "_abiCoder", getStatic(new.target, "getAbiCoder")()), defineReadOnly(this, "functions", {}), defineReadOnly(this, "errors", {}), defineReadOnly(this, "events", {}), defineReadOnly(this, "structs", {}), this.fragments.forEach((ie) => {
      let fe = null;
      switch (ie.type) {
        case "constructor":
          if (this.deploy) {
            logger$k.warn("duplicate definition - constructor");
            return;
          }
          defineReadOnly(this, "deploy", ie);
          return;
        case "function":
          fe = this.functions;
          break;
        case "event":
          fe = this.events;
          break;
        case "error":
          fe = this.errors;
          break;
        default:
          return;
      }
      let ae = ie.format();
      if (fe[ae]) {
        logger$k.warn("duplicate definition - " + ae);
        return;
      }
      fe[ae] = ie;
    }), this.deploy || defineReadOnly(this, "deploy", ConstructorFragment.from({
      payable: !1,
      type: "constructor"
    })), defineReadOnly(this, "_isInterface", !0);
  }
  format(t) {
    t || (t = FormatTypes.full), t === FormatTypes.sighash && logger$k.throwArgumentError("interface does not support formatting sighash", "format", t);
    const n = this.fragments.map((ie) => ie.format(t));
    return t === FormatTypes.json ? JSON.stringify(n.map((ie) => JSON.parse(ie))) : n;
  }
  // Sub-classes can override these to handle other blockchains
  static getAbiCoder() {
    return defaultAbiCoder;
  }
  static getAddress(t) {
    return getAddress(t);
  }
  static getSighash(t) {
    return hexDataSlice(id(t.format()), 0, 4);
  }
  static getEventTopic(t) {
    return id(t.format());
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getFunction(t) {
    if (isHexString(t)) {
      for (const ie in this.functions)
        if (t === this.getSighash(ie))
          return this.functions[ie];
      logger$k.throwArgumentError("no matching function", "sighash", t);
    }
    if (t.indexOf("(") === -1) {
      const ie = t.trim(), fe = Object.keys(this.functions).filter((ae) => ae.split(
        "("
        /* fix:) */
      )[0] === ie);
      return fe.length === 0 ? logger$k.throwArgumentError("no matching function", "name", ie) : fe.length > 1 && logger$k.throwArgumentError("multiple matching functions", "name", ie), this.functions[fe[0]];
    }
    const n = this.functions[FunctionFragment.fromString(t).format()];
    return n || logger$k.throwArgumentError("no matching function", "signature", t), n;
  }
  // Find an event definition by any means necessary (unless it is ambiguous)
  getEvent(t) {
    if (isHexString(t)) {
      const ie = t.toLowerCase();
      for (const fe in this.events)
        if (ie === this.getEventTopic(fe))
          return this.events[fe];
      logger$k.throwArgumentError("no matching event", "topichash", ie);
    }
    if (t.indexOf("(") === -1) {
      const ie = t.trim(), fe = Object.keys(this.events).filter((ae) => ae.split(
        "("
        /* fix:) */
      )[0] === ie);
      return fe.length === 0 ? logger$k.throwArgumentError("no matching event", "name", ie) : fe.length > 1 && logger$k.throwArgumentError("multiple matching events", "name", ie), this.events[fe[0]];
    }
    const n = this.events[EventFragment.fromString(t).format()];
    return n || logger$k.throwArgumentError("no matching event", "signature", t), n;
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getError(t) {
    if (isHexString(t)) {
      const ie = getStatic(this.constructor, "getSighash");
      for (const fe in this.errors) {
        const ae = this.errors[fe];
        if (t === ie(ae))
          return this.errors[fe];
      }
      logger$k.throwArgumentError("no matching error", "sighash", t);
    }
    if (t.indexOf("(") === -1) {
      const ie = t.trim(), fe = Object.keys(this.errors).filter((ae) => ae.split(
        "("
        /* fix:) */
      )[0] === ie);
      return fe.length === 0 ? logger$k.throwArgumentError("no matching error", "name", ie) : fe.length > 1 && logger$k.throwArgumentError("multiple matching errors", "name", ie), this.errors[fe[0]];
    }
    const n = this.errors[FunctionFragment.fromString(t).format()];
    return n || logger$k.throwArgumentError("no matching error", "signature", t), n;
  }
  // Get the sighash (the bytes4 selector) used by Solidity to identify a function
  getSighash(t) {
    if (typeof t == "string")
      try {
        t = this.getFunction(t);
      } catch (n) {
        try {
          t = this.getError(t);
        } catch {
          throw n;
        }
      }
    return getStatic(this.constructor, "getSighash")(t);
  }
  // Get the topic (the bytes32 hash) used by Solidity to identify an event
  getEventTopic(t) {
    return typeof t == "string" && (t = this.getEvent(t)), getStatic(this.constructor, "getEventTopic")(t);
  }
  _decodeParams(t, n) {
    return this._abiCoder.decode(t, n);
  }
  _encodeParams(t, n) {
    return this._abiCoder.encode(t, n);
  }
  encodeDeploy(t) {
    return this._encodeParams(this.deploy.inputs, t || []);
  }
  decodeErrorResult(t, n) {
    typeof t == "string" && (t = this.getError(t));
    const ie = arrayify(n);
    return hexlify(ie.slice(0, 4)) !== this.getSighash(t) && logger$k.throwArgumentError(`data signature does not match error ${t.name}.`, "data", hexlify(ie)), this._decodeParams(t.inputs, ie.slice(4));
  }
  encodeErrorResult(t, n) {
    return typeof t == "string" && (t = this.getError(t)), hexlify(concat$1([
      this.getSighash(t),
      this._encodeParams(t.inputs, n || [])
    ]));
  }
  // Decode the data for a function call (e.g. tx.data)
  decodeFunctionData(t, n) {
    typeof t == "string" && (t = this.getFunction(t));
    const ie = arrayify(n);
    return hexlify(ie.slice(0, 4)) !== this.getSighash(t) && logger$k.throwArgumentError(`data signature does not match function ${t.name}.`, "data", hexlify(ie)), this._decodeParams(t.inputs, ie.slice(4));
  }
  // Encode the data for a function call (e.g. tx.data)
  encodeFunctionData(t, n) {
    return typeof t == "string" && (t = this.getFunction(t)), hexlify(concat$1([
      this.getSighash(t),
      this._encodeParams(t.inputs, n || [])
    ]));
  }
  // Decode the result from a function call (e.g. from eth_call)
  decodeFunctionResult(t, n) {
    typeof t == "string" && (t = this.getFunction(t));
    let ie = arrayify(n), fe = null, ae = "", le = null, he = null, me = null;
    switch (ie.length % this._abiCoder._getWordSize()) {
      case 0:
        try {
          return this._abiCoder.decode(t.outputs, ie);
        } catch {
        }
        break;
      case 4: {
        const ye = hexlify(ie.slice(0, 4)), be = BuiltinErrors[ye];
        if (be)
          le = this._abiCoder.decode(be.inputs, ie.slice(4)), he = be.name, me = be.signature, be.reason && (fe = le[0]), he === "Error" ? ae = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(le[0])}` : he === "Panic" && (ae = `; VM Exception while processing transaction: reverted with panic code ${le[0]}`);
        else
          try {
            const Ae = this.getError(ye);
            le = this._abiCoder.decode(Ae.inputs, ie.slice(4)), he = Ae.name, me = Ae.format();
          } catch {
          }
        break;
      }
    }
    return logger$k.throwError("call revert exception" + ae, Logger.errors.CALL_EXCEPTION, {
      method: t.format(),
      data: hexlify(n),
      errorArgs: le,
      errorName: he,
      errorSignature: me,
      reason: fe
    });
  }
  // Encode the result for a function call (e.g. for eth_call)
  encodeFunctionResult(t, n) {
    return typeof t == "string" && (t = this.getFunction(t)), hexlify(this._abiCoder.encode(t.outputs, n || []));
  }
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(t, n) {
    typeof t == "string" && (t = this.getEvent(t)), n.length > t.inputs.length && logger$k.throwError("too many arguments for " + t.format(), Logger.errors.UNEXPECTED_ARGUMENT, {
      argument: "values",
      value: n
    });
    let ie = [];
    t.anonymous || ie.push(this.getEventTopic(t));
    const fe = (ae, le) => ae.type === "string" ? id(le) : ae.type === "bytes" ? keccak256$1(hexlify(le)) : (ae.type === "bool" && typeof le == "boolean" && (le = le ? "0x01" : "0x00"), ae.type.match(/^u?int/) && (le = BigNumber.from(le).toHexString()), ae.type === "address" && this._abiCoder.encode(["address"], [le]), hexZeroPad(hexlify(le), 32));
    for (n.forEach((ae, le) => {
      let he = t.inputs[le];
      if (!he.indexed) {
        ae != null && logger$k.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + he.name, ae);
        return;
      }
      ae == null ? ie.push(null) : he.baseType === "array" || he.baseType === "tuple" ? logger$k.throwArgumentError("filtering with tuples or arrays not supported", "contract." + he.name, ae) : Array.isArray(ae) ? ie.push(ae.map((me) => fe(he, me))) : ie.push(fe(he, ae));
    }); ie.length && ie[ie.length - 1] === null; )
      ie.pop();
    return ie;
  }
  encodeEventLog(t, n) {
    typeof t == "string" && (t = this.getEvent(t));
    const ie = [], fe = [], ae = [];
    return t.anonymous || ie.push(this.getEventTopic(t)), n.length !== t.inputs.length && logger$k.throwArgumentError("event arguments/values mismatch", "values", n), t.inputs.forEach((le, he) => {
      const me = n[he];
      if (le.indexed)
        if (le.type === "string")
          ie.push(id(me));
        else if (le.type === "bytes")
          ie.push(keccak256$1(me));
        else {
          if (le.baseType === "tuple" || le.baseType === "array")
            throw new Error("not implemented");
          ie.push(this._abiCoder.encode([le.type], [me]));
        }
      else
        fe.push(le), ae.push(me);
    }), {
      data: this._abiCoder.encode(fe, ae),
      topics: ie
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(t, n, ie) {
    if (typeof t == "string" && (t = this.getEvent(t)), ie != null && !t.anonymous) {
      let Se = this.getEventTopic(t);
      (!isHexString(ie[0], 32) || ie[0].toLowerCase() !== Se) && logger$k.throwError("fragment/topic mismatch", Logger.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: Se, value: ie[0] }), ie = ie.slice(1);
    }
    let fe = [], ae = [], le = [];
    t.inputs.forEach((Se, $e) => {
      Se.indexed ? Se.type === "string" || Se.type === "bytes" || Se.baseType === "tuple" || Se.baseType === "array" ? (fe.push(ParamType.fromObject({ type: "bytes32", name: Se.name })), le.push(!0)) : (fe.push(Se), le.push(!1)) : (ae.push(Se), le.push(!1));
    });
    let he = ie != null ? this._abiCoder.decode(fe, concat$1(ie)) : null, me = this._abiCoder.decode(ae, n, !0), ye = [], be = 0, Ae = 0;
    t.inputs.forEach((Se, $e) => {
      if (Se.indexed)
        if (he == null)
          ye[$e] = new Indexed({ _isIndexed: !0, hash: null });
        else if (le[$e])
          ye[$e] = new Indexed({ _isIndexed: !0, hash: he[Ae++] });
        else
          try {
            ye[$e] = he[Ae++];
          } catch (Re) {
            ye[$e] = Re;
          }
      else
        try {
          ye[$e] = me[be++];
        } catch (Re) {
          ye[$e] = Re;
        }
      if (Se.name && ye[Se.name] == null) {
        const Re = ye[$e];
        Re instanceof Error ? Object.defineProperty(ye, Se.name, {
          enumerable: !0,
          get: () => {
            throw wrapAccessError(`property ${JSON.stringify(Se.name)}`, Re);
          }
        }) : ye[Se.name] = Re;
      }
    });
    for (let Se = 0; Se < ye.length; Se++) {
      const $e = ye[Se];
      $e instanceof Error && Object.defineProperty(ye, Se, {
        enumerable: !0,
        get: () => {
          throw wrapAccessError(`index ${Se}`, $e);
        }
      });
    }
    return Object.freeze(ye);
  }
  // Given a transaction, find the matching function fragment (if any) and
  // determine all its properties and call parameters
  parseTransaction(t) {
    let n = this.getFunction(t.data.substring(0, 10).toLowerCase());
    return n ? new TransactionDescription({
      args: this._abiCoder.decode(n.inputs, "0x" + t.data.substring(10)),
      functionFragment: n,
      name: n.name,
      signature: n.format(),
      sighash: this.getSighash(n),
      value: BigNumber.from(t.value || "0")
    }) : null;
  }
  // @TODO
  //parseCallResult(data: BytesLike): ??
  // Given an event log, find the matching event fragment (if any) and
  // determine all its properties and values
  parseLog(t) {
    let n = this.getEvent(t.topics[0]);
    return !n || n.anonymous ? null : new LogDescription({
      eventFragment: n,
      name: n.name,
      signature: n.format(),
      topic: this.getEventTopic(n),
      args: this.decodeEventLog(n, t.data, t.topics)
    });
  }
  parseError(t) {
    const n = hexlify(t);
    let ie = this.getError(n.substring(0, 10).toLowerCase());
    return ie ? new ErrorDescription({
      args: this._abiCoder.decode(ie.inputs, "0x" + n.substring(10)),
      errorFragment: ie,
      name: ie.name,
      signature: ie.format(),
      sighash: this.getSighash(ie)
    }) : null;
  }
  /*
  static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
      if (Interface.isInterface(value)) {
          return value;
      }
      if (typeof(value) === "string") {
          return new Interface(JSON.parse(value));
      }
      return new Interface(value);
  }
  */
  static isInterface(t) {
    return !!(t && t._isInterface);
  }
}
const lib_esm$b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder,
  ConstructorFragment,
  ErrorFragment,
  EventFragment,
  FormatTypes,
  Fragment,
  FunctionFragment,
  Indexed,
  Interface,
  LogDescription,
  ParamType,
  TransactionDescription,
  checkResultErrors,
  defaultAbiCoder
}, Symbol.toStringTag, { value: "Module" })), version$m = "abstract-provider/5.7.0";
var __awaiter$j = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$j = new Logger(version$m);
class ForkEvent extends Description {
  static isForkEvent(t) {
    return !!(t && t._isForkEvent);
  }
}
class Provider {
  constructor() {
    logger$j.checkAbstract(new.target, Provider), defineReadOnly(this, "_isProvider", !0);
  }
  getFeeData() {
    return __awaiter$j(this, void 0, void 0, function* () {
      const { block: t, gasPrice: n } = yield resolveProperties({
        block: this.getBlock("latest"),
        gasPrice: this.getGasPrice().catch((le) => null)
      });
      let ie = null, fe = null, ae = null;
      return t && t.baseFeePerGas && (ie = t.baseFeePerGas, ae = BigNumber.from("1500000000"), fe = t.baseFeePerGas.mul(2).add(ae)), { lastBaseFeePerGas: ie, maxFeePerGas: fe, maxPriorityFeePerGas: ae, gasPrice: n };
    });
  }
  // Alias for "on"
  addListener(t, n) {
    return this.on(t, n);
  }
  // Alias for "off"
  removeListener(t, n) {
    return this.off(t, n);
  }
  static isProvider(t) {
    return !!(t && t._isProvider);
  }
}
const version$l = "abstract-signer/5.7.0";
var __awaiter$i = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$i = new Logger(version$l), allowedTransactionKeys$2 = [
  "accessList",
  "ccipReadEnabled",
  "chainId",
  "customData",
  "data",
  "from",
  "gasLimit",
  "gasPrice",
  "maxFeePerGas",
  "maxPriorityFeePerGas",
  "nonce",
  "to",
  "type",
  "value"
], forwardErrors = [
  Logger.errors.INSUFFICIENT_FUNDS,
  Logger.errors.NONCE_EXPIRED,
  Logger.errors.REPLACEMENT_UNDERPRICED
];
class Signer {
  ///////////////////
  // Sub-classes MUST call super
  constructor() {
    logger$i.checkAbstract(new.target, Signer), defineReadOnly(this, "_isSigner", !0);
  }
  ///////////////////
  // Sub-classes MAY override these
  getBalance(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("getBalance"), yield this.provider.getBalance(this.getAddress(), t);
    });
  }
  getTransactionCount(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("getTransactionCount"), yield this.provider.getTransactionCount(this.getAddress(), t);
    });
  }
  // Populates "from" if unspecified, and estimates the gas for the transaction
  estimateGas(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      this._checkProvider("estimateGas");
      const n = yield resolveProperties(this.checkTransaction(t));
      return yield this.provider.estimateGas(n);
    });
  }
  // Populates "from" if unspecified, and calls with the transaction
  call(t, n) {
    return __awaiter$i(this, void 0, void 0, function* () {
      this._checkProvider("call");
      const ie = yield resolveProperties(this.checkTransaction(t));
      return yield this.provider.call(ie, n);
    });
  }
  // Populates all fields in a transaction, signs it and sends it to the network
  sendTransaction(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      this._checkProvider("sendTransaction");
      const n = yield this.populateTransaction(t), ie = yield this.signTransaction(n);
      return yield this.provider.sendTransaction(ie);
    });
  }
  getChainId() {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("getChainId"), (yield this.provider.getNetwork()).chainId;
    });
  }
  getGasPrice() {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("getGasPrice"), yield this.provider.getGasPrice();
    });
  }
  getFeeData() {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("getFeeData"), yield this.provider.getFeeData();
    });
  }
  resolveName(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      return this._checkProvider("resolveName"), yield this.provider.resolveName(t);
    });
  }
  // Checks a transaction does not contain invalid keys and if
  // no "from" is provided, populates it.
  // - does NOT require a provider
  // - adds "from" is not present
  // - returns a COPY (safe to mutate the result)
  // By default called from: (overriding these prevents it)
  //   - call
  //   - estimateGas
  //   - populateTransaction (and therefor sendTransaction)
  checkTransaction(t) {
    for (const ie in t)
      allowedTransactionKeys$2.indexOf(ie) === -1 && logger$i.throwArgumentError("invalid transaction key: " + ie, "transaction", t);
    const n = shallowCopy(t);
    return n.from == null ? n.from = this.getAddress() : n.from = Promise.all([
      Promise.resolve(n.from),
      this.getAddress()
    ]).then((ie) => (ie[0].toLowerCase() !== ie[1].toLowerCase() && logger$i.throwArgumentError("from address mismatch", "transaction", t), ie[0])), n;
  }
  // Populates ALL keys for a transaction and checks that "from" matches
  // this Signer. Should be used by sendTransaction but NOT by signTransaction.
  // By default called from: (overriding these prevents it)
  //   - sendTransaction
  //
  // Notes:
  //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
  populateTransaction(t) {
    return __awaiter$i(this, void 0, void 0, function* () {
      const n = yield resolveProperties(this.checkTransaction(t));
      n.to != null && (n.to = Promise.resolve(n.to).then((fe) => __awaiter$i(this, void 0, void 0, function* () {
        if (fe == null)
          return null;
        const ae = yield this.resolveName(fe);
        return ae == null && logger$i.throwArgumentError("provided ENS name resolves to null", "tx.to", fe), ae;
      })), n.to.catch((fe) => {
      }));
      const ie = n.maxFeePerGas != null || n.maxPriorityFeePerGas != null;
      if (n.gasPrice != null && (n.type === 2 || ie) ? logger$i.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", t) : (n.type === 0 || n.type === 1) && ie && logger$i.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", t), (n.type === 2 || n.type == null) && n.maxFeePerGas != null && n.maxPriorityFeePerGas != null)
        n.type = 2;
      else if (n.type === 0 || n.type === 1)
        n.gasPrice == null && (n.gasPrice = this.getGasPrice());
      else {
        const fe = yield this.getFeeData();
        if (n.type == null)
          if (fe.maxFeePerGas != null && fe.maxPriorityFeePerGas != null)
            if (n.type = 2, n.gasPrice != null) {
              const ae = n.gasPrice;
              delete n.gasPrice, n.maxFeePerGas = ae, n.maxPriorityFeePerGas = ae;
            } else
              n.maxFeePerGas == null && (n.maxFeePerGas = fe.maxFeePerGas), n.maxPriorityFeePerGas == null && (n.maxPriorityFeePerGas = fe.maxPriorityFeePerGas);
          else fe.gasPrice != null ? (ie && logger$i.throwError("network does not support EIP-1559", Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "populateTransaction"
          }), n.gasPrice == null && (n.gasPrice = fe.gasPrice), n.type = 0) : logger$i.throwError("failed to get consistent fee data", Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "signer.getFeeData"
          });
        else n.type === 2 && (n.maxFeePerGas == null && (n.maxFeePerGas = fe.maxFeePerGas), n.maxPriorityFeePerGas == null && (n.maxPriorityFeePerGas = fe.maxPriorityFeePerGas));
      }
      return n.nonce == null && (n.nonce = this.getTransactionCount("pending")), n.gasLimit == null && (n.gasLimit = this.estimateGas(n).catch((fe) => {
        if (forwardErrors.indexOf(fe.code) >= 0)
          throw fe;
        return logger$i.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
          error: fe,
          tx: n
        });
      })), n.chainId == null ? n.chainId = this.getChainId() : n.chainId = Promise.all([
        Promise.resolve(n.chainId),
        this.getChainId()
      ]).then((fe) => (fe[1] !== 0 && fe[0] !== fe[1] && logger$i.throwArgumentError("chainId address mismatch", "transaction", t), fe[0])), yield resolveProperties(n);
    });
  }
  ///////////////////
  // Sub-classes SHOULD leave these alone
  _checkProvider(t) {
    this.provider || logger$i.throwError("missing provider", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: t || "_checkProvider"
    });
  }
  static isSigner(t) {
    return !!(t && t._isSigner);
  }
}
class VoidSigner extends Signer {
  constructor(t, n) {
    super(), defineReadOnly(this, "address", t), defineReadOnly(this, "provider", n || null);
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  _fail(t, n) {
    return Promise.resolve().then(() => {
      logger$i.throwError(t, Logger.errors.UNSUPPORTED_OPERATION, { operation: n });
    });
  }
  signMessage(t) {
    return this._fail("VoidSigner cannot sign messages", "signMessage");
  }
  signTransaction(t) {
    return this._fail("VoidSigner cannot sign transactions", "signTransaction");
  }
  _signTypedData(t, n, ie) {
    return this._fail("VoidSigner cannot sign typed data", "signTypedData");
  }
  connect(t) {
    return new VoidSigner(this.address, t);
  }
}
var hash$5 = {}, utils$q = {}, minimalisticAssert$1 = assert$k;
function assert$k(c, t) {
  if (!c)
    throw new Error(t || "Assertion failed");
}
assert$k.equal = function(t, n, ie) {
  if (t != n)
    throw new Error(ie || "Assertion failed: " + t + " != " + n);
};
var inherits_browser$1 = { exports: {} };
typeof Object.create == "function" ? inherits_browser$1.exports = function(t, n) {
  n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser$1.exports = function(t, n) {
  if (n) {
    t.super_ = n;
    var ie = function() {
    };
    ie.prototype = n.prototype, t.prototype = new ie(), t.prototype.constructor = t;
  }
};
var inherits_browserExports = inherits_browser$1.exports, assert$j = minimalisticAssert$1, inherits$4 = inherits_browserExports;
utils$q.inherits = inherits$4;
function isSurrogatePair(c, t) {
  return (c.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= c.length ? !1 : (c.charCodeAt(t + 1) & 64512) === 56320;
}
function toArray(c, t) {
  if (Array.isArray(c))
    return c.slice();
  if (!c)
    return [];
  var n = [];
  if (typeof c == "string")
    if (t) {
      if (t === "hex")
        for (c = c.replace(/[^a-z0-9]+/ig, ""), c.length % 2 !== 0 && (c = "0" + c), fe = 0; fe < c.length; fe += 2)
          n.push(parseInt(c[fe] + c[fe + 1], 16));
    } else for (var ie = 0, fe = 0; fe < c.length; fe++) {
      var ae = c.charCodeAt(fe);
      ae < 128 ? n[ie++] = ae : ae < 2048 ? (n[ie++] = ae >> 6 | 192, n[ie++] = ae & 63 | 128) : isSurrogatePair(c, fe) ? (ae = 65536 + ((ae & 1023) << 10) + (c.charCodeAt(++fe) & 1023), n[ie++] = ae >> 18 | 240, n[ie++] = ae >> 12 & 63 | 128, n[ie++] = ae >> 6 & 63 | 128, n[ie++] = ae & 63 | 128) : (n[ie++] = ae >> 12 | 224, n[ie++] = ae >> 6 & 63 | 128, n[ie++] = ae & 63 | 128);
    }
  else
    for (fe = 0; fe < c.length; fe++)
      n[fe] = c[fe] | 0;
  return n;
}
utils$q.toArray = toArray;
function toHex$1(c) {
  for (var t = "", n = 0; n < c.length; n++)
    t += zero2(c[n].toString(16));
  return t;
}
utils$q.toHex = toHex$1;
function htonl(c) {
  var t = c >>> 24 | c >>> 8 & 65280 | c << 8 & 16711680 | (c & 255) << 24;
  return t >>> 0;
}
utils$q.htonl = htonl;
function toHex32(c, t) {
  for (var n = "", ie = 0; ie < c.length; ie++) {
    var fe = c[ie];
    t === "little" && (fe = htonl(fe)), n += zero8(fe.toString(16));
  }
  return n;
}
utils$q.toHex32 = toHex32;
function zero2(c) {
  return c.length === 1 ? "0" + c : c;
}
utils$q.zero2 = zero2;
function zero8(c) {
  return c.length === 7 ? "0" + c : c.length === 6 ? "00" + c : c.length === 5 ? "000" + c : c.length === 4 ? "0000" + c : c.length === 3 ? "00000" + c : c.length === 2 ? "000000" + c : c.length === 1 ? "0000000" + c : c;
}
utils$q.zero8 = zero8;
function join32(c, t, n, ie) {
  var fe = n - t;
  assert$j(fe % 4 === 0);
  for (var ae = new Array(fe / 4), le = 0, he = t; le < ae.length; le++, he += 4) {
    var me;
    ie === "big" ? me = c[he] << 24 | c[he + 1] << 16 | c[he + 2] << 8 | c[he + 3] : me = c[he + 3] << 24 | c[he + 2] << 16 | c[he + 1] << 8 | c[he], ae[le] = me >>> 0;
  }
  return ae;
}
utils$q.join32 = join32;
function split32(c, t) {
  for (var n = new Array(c.length * 4), ie = 0, fe = 0; ie < c.length; ie++, fe += 4) {
    var ae = c[ie];
    t === "big" ? (n[fe] = ae >>> 24, n[fe + 1] = ae >>> 16 & 255, n[fe + 2] = ae >>> 8 & 255, n[fe + 3] = ae & 255) : (n[fe + 3] = ae >>> 24, n[fe + 2] = ae >>> 16 & 255, n[fe + 1] = ae >>> 8 & 255, n[fe] = ae & 255);
  }
  return n;
}
utils$q.split32 = split32;
function rotr32$1(c, t) {
  return c >>> t | c << 32 - t;
}
utils$q.rotr32 = rotr32$1;
function rotl32$2(c, t) {
  return c << t | c >>> 32 - t;
}
utils$q.rotl32 = rotl32$2;
function sum32$3(c, t) {
  return c + t >>> 0;
}
utils$q.sum32 = sum32$3;
function sum32_3$1(c, t, n) {
  return c + t + n >>> 0;
}
utils$q.sum32_3 = sum32_3$1;
function sum32_4$2(c, t, n, ie) {
  return c + t + n + ie >>> 0;
}
utils$q.sum32_4 = sum32_4$2;
function sum32_5$2(c, t, n, ie, fe) {
  return c + t + n + ie + fe >>> 0;
}
utils$q.sum32_5 = sum32_5$2;
function sum64$1(c, t, n, ie) {
  var fe = c[t], ae = c[t + 1], le = ie + ae >>> 0, he = (le < ie ? 1 : 0) + n + fe;
  c[t] = he >>> 0, c[t + 1] = le;
}
utils$q.sum64 = sum64$1;
function sum64_hi$1(c, t, n, ie) {
  var fe = t + ie >>> 0, ae = (fe < t ? 1 : 0) + c + n;
  return ae >>> 0;
}
utils$q.sum64_hi = sum64_hi$1;
function sum64_lo$1(c, t, n, ie) {
  var fe = t + ie;
  return fe >>> 0;
}
utils$q.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(c, t, n, ie, fe, ae, le, he) {
  var me = 0, ye = t;
  ye = ye + ie >>> 0, me += ye < t ? 1 : 0, ye = ye + ae >>> 0, me += ye < ae ? 1 : 0, ye = ye + he >>> 0, me += ye < he ? 1 : 0;
  var be = c + n + fe + le + me;
  return be >>> 0;
}
utils$q.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(c, t, n, ie, fe, ae, le, he) {
  var me = t + ie + ae + he;
  return me >>> 0;
}
utils$q.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(c, t, n, ie, fe, ae, le, he, me, ye) {
  var be = 0, Ae = t;
  Ae = Ae + ie >>> 0, be += Ae < t ? 1 : 0, Ae = Ae + ae >>> 0, be += Ae < ae ? 1 : 0, Ae = Ae + he >>> 0, be += Ae < he ? 1 : 0, Ae = Ae + ye >>> 0, be += Ae < ye ? 1 : 0;
  var Se = c + n + fe + le + me + be;
  return Se >>> 0;
}
utils$q.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(c, t, n, ie, fe, ae, le, he, me, ye) {
  var be = t + ie + ae + he + ye;
  return be >>> 0;
}
utils$q.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(c, t, n) {
  var ie = t << 32 - n | c >>> n;
  return ie >>> 0;
}
utils$q.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(c, t, n) {
  var ie = c << 32 - n | t >>> n;
  return ie >>> 0;
}
utils$q.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(c, t, n) {
  return c >>> n;
}
utils$q.shr64_hi = shr64_hi$1;
function shr64_lo$1(c, t, n) {
  var ie = c << 32 - n | t >>> n;
  return ie >>> 0;
}
utils$q.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$p = utils$q, assert$i = minimalisticAssert$1;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(t, n) {
  if (t = utils$p.toArray(t, n), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
    t = this.pending;
    var ie = t.length % this._delta8;
    this.pending = t.slice(t.length - ie, t.length), this.pending.length === 0 && (this.pending = null), t = utils$p.join32(t, 0, t.length - ie, this.endian);
    for (var fe = 0; fe < t.length; fe += this._delta32)
      this._update(t, fe, fe + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(t) {
  return this.update(this._pad()), assert$i(this.pending === null), this._digest(t);
};
BlockHash$4.prototype._pad = function() {
  var t = this.pendingTotal, n = this._delta8, ie = n - (t + this.padLength) % n, fe = new Array(ie + this.padLength);
  fe[0] = 128;
  for (var ae = 1; ae < ie; ae++)
    fe[ae] = 0;
  if (t <<= 3, this.endian === "big") {
    for (var le = 8; le < this.padLength; le++)
      fe[ae++] = 0;
    fe[ae++] = 0, fe[ae++] = 0, fe[ae++] = 0, fe[ae++] = 0, fe[ae++] = t >>> 24 & 255, fe[ae++] = t >>> 16 & 255, fe[ae++] = t >>> 8 & 255, fe[ae++] = t & 255;
  } else
    for (fe[ae++] = t & 255, fe[ae++] = t >>> 8 & 255, fe[ae++] = t >>> 16 & 255, fe[ae++] = t >>> 24 & 255, fe[ae++] = 0, fe[ae++] = 0, fe[ae++] = 0, fe[ae++] = 0, le = 8; le < this.padLength; le++)
      fe[ae++] = 0;
  return fe;
};
var sha$1 = {}, common$4 = {}, utils$o = utils$q, rotr32 = utils$o.rotr32;
function ft_1$1(c, t, n, ie) {
  if (c === 0)
    return ch32$1(t, n, ie);
  if (c === 1 || c === 3)
    return p32(t, n, ie);
  if (c === 2)
    return maj32$1(t, n, ie);
}
common$4.ft_1 = ft_1$1;
function ch32$1(c, t, n) {
  return c & t ^ ~c & n;
}
common$4.ch32 = ch32$1;
function maj32$1(c, t, n) {
  return c & t ^ c & n ^ t & n;
}
common$4.maj32 = maj32$1;
function p32(c, t, n) {
  return c ^ t ^ n;
}
common$4.p32 = p32;
function s0_256$1(c) {
  return rotr32(c, 2) ^ rotr32(c, 13) ^ rotr32(c, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(c) {
  return rotr32(c, 6) ^ rotr32(c, 11) ^ rotr32(c, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(c) {
  return rotr32(c, 7) ^ rotr32(c, 18) ^ c >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(c) {
  return rotr32(c, 17) ^ rotr32(c, 19) ^ c >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$n = utils$q, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$n.rotl32, sum32$2 = utils$n.sum32, sum32_5$1 = utils$n.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$n.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(t, n) {
  for (var ie = this.W, fe = 0; fe < 16; fe++)
    ie[fe] = t[n + fe];
  for (; fe < ie.length; fe++)
    ie[fe] = rotl32$1(ie[fe - 3] ^ ie[fe - 8] ^ ie[fe - 14] ^ ie[fe - 16], 1);
  var ae = this.h[0], le = this.h[1], he = this.h[2], me = this.h[3], ye = this.h[4];
  for (fe = 0; fe < ie.length; fe++) {
    var be = ~~(fe / 20), Ae = sum32_5$1(rotl32$1(ae, 5), ft_1(be, le, he, me), ye, ie[fe], sha1_K[be]);
    ye = me, me = he, he = rotl32$1(le, 30), le = ae, ae = Ae;
  }
  this.h[0] = sum32$2(this.h[0], ae), this.h[1] = sum32$2(this.h[1], le), this.h[2] = sum32$2(this.h[2], he), this.h[3] = sum32$2(this.h[3], me), this.h[4] = sum32$2(this.h[4], ye);
};
SHA1.prototype._digest = function(t) {
  return t === "hex" ? utils$n.toHex32(this.h, "big") : utils$n.split32(this.h, "big");
};
var utils$m = utils$q, common$2 = common$5, shaCommon = common$4, assert$h = minimalisticAssert$1, sum32$1 = utils$m.sum32, sum32_4$1 = utils$m.sum32_4, sum32_5 = utils$m.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$2() {
  if (!(this instanceof SHA256$2))
    return new SHA256$2();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$m.inherits(SHA256$2, BlockHash$2);
var _256 = SHA256$2;
SHA256$2.blockSize = 512;
SHA256$2.outSize = 256;
SHA256$2.hmacStrength = 192;
SHA256$2.padLength = 64;
SHA256$2.prototype._update = function(t, n) {
  for (var ie = this.W, fe = 0; fe < 16; fe++)
    ie[fe] = t[n + fe];
  for (; fe < ie.length; fe++)
    ie[fe] = sum32_4$1(g1_256(ie[fe - 2]), ie[fe - 7], g0_256(ie[fe - 15]), ie[fe - 16]);
  var ae = this.h[0], le = this.h[1], he = this.h[2], me = this.h[3], ye = this.h[4], be = this.h[5], Ae = this.h[6], Se = this.h[7];
  for (assert$h(this.k.length === ie.length), fe = 0; fe < ie.length; fe++) {
    var $e = sum32_5(Se, s1_256(ye), ch32(ye, be, Ae), this.k[fe], ie[fe]), Re = sum32$1(s0_256(ae), maj32(ae, le, he));
    Se = Ae, Ae = be, be = ye, ye = sum32$1(me, $e), me = he, he = le, le = ae, ae = sum32$1($e, Re);
  }
  this.h[0] = sum32$1(this.h[0], ae), this.h[1] = sum32$1(this.h[1], le), this.h[2] = sum32$1(this.h[2], he), this.h[3] = sum32$1(this.h[3], me), this.h[4] = sum32$1(this.h[4], ye), this.h[5] = sum32$1(this.h[5], be), this.h[6] = sum32$1(this.h[6], Ae), this.h[7] = sum32$1(this.h[7], Se);
};
SHA256$2.prototype._digest = function(t) {
  return t === "hex" ? utils$m.toHex32(this.h, "big") : utils$m.split32(this.h, "big");
};
var utils$l = utils$q, SHA256$1 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256$1.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$l.inherits(SHA224, SHA256$1);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(t) {
  return t === "hex" ? utils$l.toHex32(this.h.slice(0, 7), "big") : utils$l.split32(this.h.slice(0, 7), "big");
};
var utils$k = utils$q, common$1 = common$5, assert$g = minimalisticAssert$1, rotr64_hi = utils$k.rotr64_hi, rotr64_lo = utils$k.rotr64_lo, shr64_hi = utils$k.shr64_hi, shr64_lo = utils$k.shr64_lo, sum64 = utils$k.sum64, sum64_hi = utils$k.sum64_hi, sum64_lo = utils$k.sum64_lo, sum64_4_hi = utils$k.sum64_4_hi, sum64_4_lo = utils$k.sum64_4_lo, sum64_5_hi = utils$k.sum64_5_hi, sum64_5_lo = utils$k.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$2() {
  if (!(this instanceof SHA512$2))
    return new SHA512$2();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$k.inherits(SHA512$2, BlockHash$1);
var _512 = SHA512$2;
SHA512$2.blockSize = 1024;
SHA512$2.outSize = 512;
SHA512$2.hmacStrength = 192;
SHA512$2.padLength = 128;
SHA512$2.prototype._prepareBlock = function(t, n) {
  for (var ie = this.W, fe = 0; fe < 32; fe++)
    ie[fe] = t[n + fe];
  for (; fe < ie.length; fe += 2) {
    var ae = g1_512_hi(ie[fe - 4], ie[fe - 3]), le = g1_512_lo(ie[fe - 4], ie[fe - 3]), he = ie[fe - 14], me = ie[fe - 13], ye = g0_512_hi(ie[fe - 30], ie[fe - 29]), be = g0_512_lo(ie[fe - 30], ie[fe - 29]), Ae = ie[fe - 32], Se = ie[fe - 31];
    ie[fe] = sum64_4_hi(
      ae,
      le,
      he,
      me,
      ye,
      be,
      Ae,
      Se
    ), ie[fe + 1] = sum64_4_lo(
      ae,
      le,
      he,
      me,
      ye,
      be,
      Ae,
      Se
    );
  }
};
SHA512$2.prototype._update = function(t, n) {
  this._prepareBlock(t, n);
  var ie = this.W, fe = this.h[0], ae = this.h[1], le = this.h[2], he = this.h[3], me = this.h[4], ye = this.h[5], be = this.h[6], Ae = this.h[7], Se = this.h[8], $e = this.h[9], Re = this.h[10], Me = this.h[11], ke = this.h[12], Te = this.h[13], Ie = this.h[14], qe = this.h[15];
  assert$g(this.k.length === ie.length);
  for (var Ue = 0; Ue < ie.length; Ue += 2) {
    var ze = Ie, Ve = qe, Mt = s1_512_hi(Se, $e), Rt = s1_512_lo(Se, $e), je = ch64_hi(Se, $e, Re, Me, ke), jt = ch64_lo(Se, $e, Re, Me, ke, Te), _e = this.k[Ue], se = this.k[Ue + 1], ce = ie[Ue], de = ie[Ue + 1], pe = sum64_5_hi(
      ze,
      Ve,
      Mt,
      Rt,
      je,
      jt,
      _e,
      se,
      ce,
      de
    ), ve = sum64_5_lo(
      ze,
      Ve,
      Mt,
      Rt,
      je,
      jt,
      _e,
      se,
      ce,
      de
    );
    ze = s0_512_hi(fe, ae), Ve = s0_512_lo(fe, ae), Mt = maj64_hi(fe, ae, le, he, me), Rt = maj64_lo(fe, ae, le, he, me, ye);
    var we = sum64_hi(ze, Ve, Mt, Rt), Ee = sum64_lo(ze, Ve, Mt, Rt);
    Ie = ke, qe = Te, ke = Re, Te = Me, Re = Se, Me = $e, Se = sum64_hi(be, Ae, pe, ve), $e = sum64_lo(Ae, Ae, pe, ve), be = me, Ae = ye, me = le, ye = he, le = fe, he = ae, fe = sum64_hi(pe, ve, we, Ee), ae = sum64_lo(pe, ve, we, Ee);
  }
  sum64(this.h, 0, fe, ae), sum64(this.h, 2, le, he), sum64(this.h, 4, me, ye), sum64(this.h, 6, be, Ae), sum64(this.h, 8, Se, $e), sum64(this.h, 10, Re, Me), sum64(this.h, 12, ke, Te), sum64(this.h, 14, Ie, qe);
};
SHA512$2.prototype._digest = function(t) {
  return t === "hex" ? utils$k.toHex32(this.h, "big") : utils$k.split32(this.h, "big");
};
function ch64_hi(c, t, n, ie, fe) {
  var ae = c & n ^ ~c & fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function ch64_lo(c, t, n, ie, fe, ae) {
  var le = t & ie ^ ~t & ae;
  return le < 0 && (le += 4294967296), le;
}
function maj64_hi(c, t, n, ie, fe) {
  var ae = c & n ^ c & fe ^ n & fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function maj64_lo(c, t, n, ie, fe, ae) {
  var le = t & ie ^ t & ae ^ ie & ae;
  return le < 0 && (le += 4294967296), le;
}
function s0_512_hi(c, t) {
  var n = rotr64_hi(c, t, 28), ie = rotr64_hi(t, c, 2), fe = rotr64_hi(t, c, 7), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function s0_512_lo(c, t) {
  var n = rotr64_lo(c, t, 28), ie = rotr64_lo(t, c, 2), fe = rotr64_lo(t, c, 7), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function s1_512_hi(c, t) {
  var n = rotr64_hi(c, t, 14), ie = rotr64_hi(c, t, 18), fe = rotr64_hi(t, c, 9), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function s1_512_lo(c, t) {
  var n = rotr64_lo(c, t, 14), ie = rotr64_lo(c, t, 18), fe = rotr64_lo(t, c, 9), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function g0_512_hi(c, t) {
  var n = rotr64_hi(c, t, 1), ie = rotr64_hi(c, t, 8), fe = shr64_hi(c, t, 7), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function g0_512_lo(c, t) {
  var n = rotr64_lo(c, t, 1), ie = rotr64_lo(c, t, 8), fe = shr64_lo(c, t, 7), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function g1_512_hi(c, t) {
  var n = rotr64_hi(c, t, 19), ie = rotr64_hi(t, c, 29), fe = shr64_hi(c, t, 6), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
function g1_512_lo(c, t) {
  var n = rotr64_lo(c, t, 19), ie = rotr64_lo(t, c, 29), fe = shr64_lo(c, t, 6), ae = n ^ ie ^ fe;
  return ae < 0 && (ae += 4294967296), ae;
}
var utils$j = utils$q, SHA512$1 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512$1.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$j.inherits(SHA384, SHA512$1);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(t) {
  return t === "hex" ? utils$j.toHex32(this.h.slice(0, 12), "big") : utils$j.split32(this.h.slice(0, 12), "big");
};
sha$1.sha1 = _1;
sha$1.sha224 = _224;
sha$1.sha256 = _256;
sha$1.sha384 = _384;
sha$1.sha512 = _512;
var ripemd = {}, utils$i = utils$q, common = common$5, rotl32 = utils$i.rotl32, sum32 = utils$i.sum32, sum32_3 = utils$i.sum32_3, sum32_4 = utils$i.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160$1() {
  if (!(this instanceof RIPEMD160$1))
    return new RIPEMD160$1();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$i.inherits(RIPEMD160$1, BlockHash);
ripemd.ripemd160 = RIPEMD160$1;
RIPEMD160$1.blockSize = 512;
RIPEMD160$1.outSize = 160;
RIPEMD160$1.hmacStrength = 192;
RIPEMD160$1.padLength = 64;
RIPEMD160$1.prototype._update = function(t, n) {
  for (var ie = this.h[0], fe = this.h[1], ae = this.h[2], le = this.h[3], he = this.h[4], me = ie, ye = fe, be = ae, Ae = le, Se = he, $e = 0; $e < 80; $e++) {
    var Re = sum32(
      rotl32(
        sum32_4(ie, f$2($e, fe, ae, le), t[r$1[$e] + n], K$3($e)),
        s$2[$e]
      ),
      he
    );
    ie = he, he = le, le = rotl32(ae, 10), ae = fe, fe = Re, Re = sum32(
      rotl32(
        sum32_4(me, f$2(79 - $e, ye, be, Ae), t[rh[$e] + n], Kh($e)),
        sh[$e]
      ),
      Se
    ), me = Se, Se = Ae, Ae = rotl32(be, 10), be = ye, ye = Re;
  }
  Re = sum32_3(this.h[1], ae, Ae), this.h[1] = sum32_3(this.h[2], le, Se), this.h[2] = sum32_3(this.h[3], he, me), this.h[3] = sum32_3(this.h[4], ie, ye), this.h[4] = sum32_3(this.h[0], fe, be), this.h[0] = Re;
};
RIPEMD160$1.prototype._digest = function(t) {
  return t === "hex" ? utils$i.toHex32(this.h, "little") : utils$i.split32(this.h, "little");
};
function f$2(c, t, n, ie) {
  return c <= 15 ? t ^ n ^ ie : c <= 31 ? t & n | ~t & ie : c <= 47 ? (t | ~n) ^ ie : c <= 63 ? t & ie | n & ~ie : t ^ (n | ~ie);
}
function K$3(c) {
  return c <= 15 ? 0 : c <= 31 ? 1518500249 : c <= 47 ? 1859775393 : c <= 63 ? 2400959708 : 2840853838;
}
function Kh(c) {
  return c <= 15 ? 1352829926 : c <= 31 ? 1548603684 : c <= 47 ? 1836072691 : c <= 63 ? 2053994217 : 0;
}
var r$1 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s$2 = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$h = utils$q, assert$f = minimalisticAssert$1;
function Hmac(c, t, n) {
  if (!(this instanceof Hmac))
    return new Hmac(c, t, n);
  this.Hash = c, this.blockSize = c.blockSize / 8, this.outSize = c.outSize / 8, this.inner = null, this.outer = null, this._init(utils$h.toArray(t, n));
}
var hmac$1 = Hmac;
Hmac.prototype._init = function(t) {
  t.length > this.blockSize && (t = new this.Hash().update(t).digest()), assert$f(t.length <= this.blockSize);
  for (var n = t.length; n < this.blockSize; n++)
    t.push(0);
  for (n = 0; n < t.length; n++)
    t[n] ^= 54;
  for (this.inner = new this.Hash().update(t), n = 0; n < t.length; n++)
    t[n] ^= 106;
  this.outer = new this.Hash().update(t);
};
Hmac.prototype.update = function(t, n) {
  return this.inner.update(t, n), this;
};
Hmac.prototype.digest = function(t) {
  return this.outer.update(this.inner.digest()), this.outer.digest(t);
};
(function(c) {
  var t = c;
  t.utils = utils$q, t.common = common$5, t.sha = sha$1, t.ripemd = ripemd, t.hmac = hmac$1, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
})(hash$5);
const hash$4 = /* @__PURE__ */ getDefaultExportFromCjs$2(hash$5);
function createCommonjsModule(c, t, n) {
  return n = {
    path: t,
    exports: {},
    require: function(ie, fe) {
      return commonjsRequire$1(ie, fe ?? n.path);
    }
  }, c(n, n.exports), n.exports;
}
function commonjsRequire$1() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var minimalisticAssert = assert$e;
function assert$e(c, t) {
  if (!c)
    throw new Error(t || "Assertion failed");
}
assert$e.equal = function(t, n, ie) {
  if (t != n)
    throw new Error(ie || "Assertion failed: " + t + " != " + n);
};
var utils_1$8 = createCommonjsModule(function(c, t) {
  var n = t;
  function ie(le, he) {
    if (Array.isArray(le))
      return le.slice();
    if (!le)
      return [];
    var me = [];
    if (typeof le != "string") {
      for (var ye = 0; ye < le.length; ye++)
        me[ye] = le[ye] | 0;
      return me;
    }
    if (he === "hex") {
      le = le.replace(/[^a-z0-9]+/ig, ""), le.length % 2 !== 0 && (le = "0" + le);
      for (var ye = 0; ye < le.length; ye += 2)
        me.push(parseInt(le[ye] + le[ye + 1], 16));
    } else
      for (var ye = 0; ye < le.length; ye++) {
        var be = le.charCodeAt(ye), Ae = be >> 8, Se = be & 255;
        Ae ? me.push(Ae, Se) : me.push(Se);
      }
    return me;
  }
  n.toArray = ie;
  function fe(le) {
    return le.length === 1 ? "0" + le : le;
  }
  n.zero2 = fe;
  function ae(le) {
    for (var he = "", me = 0; me < le.length; me++)
      he += fe(le[me].toString(16));
    return he;
  }
  n.toHex = ae, n.encode = function(he, me) {
    return me === "hex" ? ae(he) : he;
  };
}), utils_1$1$1 = createCommonjsModule(function(c, t) {
  var n = t;
  n.assert = minimalisticAssert, n.toArray = utils_1$8.toArray, n.zero2 = utils_1$8.zero2, n.toHex = utils_1$8.toHex, n.encode = utils_1$8.encode;
  function ie(me, ye, be) {
    var Ae = new Array(Math.max(me.bitLength(), be) + 1);
    Ae.fill(0);
    for (var Se = 1 << ye + 1, $e = me.clone(), Re = 0; Re < Ae.length; Re++) {
      var Me, ke = $e.andln(Se - 1);
      $e.isOdd() ? (ke > (Se >> 1) - 1 ? Me = (Se >> 1) - ke : Me = ke, $e.isubn(Me)) : Me = 0, Ae[Re] = Me, $e.iushrn(1);
    }
    return Ae;
  }
  n.getNAF = ie;
  function fe(me, ye) {
    var be = [
      [],
      []
    ];
    me = me.clone(), ye = ye.clone();
    for (var Ae = 0, Se = 0, $e; me.cmpn(-Ae) > 0 || ye.cmpn(-Se) > 0; ) {
      var Re = me.andln(3) + Ae & 3, Me = ye.andln(3) + Se & 3;
      Re === 3 && (Re = -1), Me === 3 && (Me = -1);
      var ke;
      Re & 1 ? ($e = me.andln(7) + Ae & 7, ($e === 3 || $e === 5) && Me === 2 ? ke = -Re : ke = Re) : ke = 0, be[0].push(ke);
      var Te;
      Me & 1 ? ($e = ye.andln(7) + Se & 7, ($e === 3 || $e === 5) && Re === 2 ? Te = -Me : Te = Me) : Te = 0, be[1].push(Te), 2 * Ae === ke + 1 && (Ae = 1 - Ae), 2 * Se === Te + 1 && (Se = 1 - Se), me.iushrn(1), ye.iushrn(1);
    }
    return be;
  }
  n.getJSF = fe;
  function ae(me, ye, be) {
    var Ae = "_" + ye;
    me.prototype[ye] = function() {
      return this[Ae] !== void 0 ? this[Ae] : this[Ae] = be.call(this);
    };
  }
  n.cachedProperty = ae;
  function le(me) {
    return typeof me == "string" ? n.toArray(me, "hex") : me;
  }
  n.parseBytes = le;
  function he(me) {
    return new BN$8(me, "hex", "le");
  }
  n.intFromLE = he;
}), getNAF$1 = utils_1$1$1.getNAF, getJSF$1 = utils_1$1$1.getJSF, assert$1$1 = utils_1$1$1.assert;
function BaseCurve$1(c, t) {
  this.type = c, this.p = new BN$8(t.p, 16), this.red = t.prime ? BN$8.red(t.prime) : BN$8.mont(this.p), this.zero = new BN$8(0).toRed(this.red), this.one = new BN$8(1).toRed(this.red), this.two = new BN$8(2).toRed(this.red), this.n = t.n && new BN$8(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var n = this.n && this.p.div(this.n);
  !n || n.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$6 = BaseCurve$1;
BaseCurve$1.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve$1.prototype._fixedNafMul = function(t, n) {
  assert$1$1(t.precomputed);
  var ie = t._getDoubles(), fe = getNAF$1(n, 1, this._bitLength), ae = (1 << ie.step + 1) - (ie.step % 2 === 0 ? 2 : 1);
  ae /= 3;
  var le = [], he, me;
  for (he = 0; he < fe.length; he += ie.step) {
    me = 0;
    for (var ye = he + ie.step - 1; ye >= he; ye--)
      me = (me << 1) + fe[ye];
    le.push(me);
  }
  for (var be = this.jpoint(null, null, null), Ae = this.jpoint(null, null, null), Se = ae; Se > 0; Se--) {
    for (he = 0; he < le.length; he++)
      me = le[he], me === Se ? Ae = Ae.mixedAdd(ie.points[he]) : me === -Se && (Ae = Ae.mixedAdd(ie.points[he].neg()));
    be = be.add(Ae);
  }
  return be.toP();
};
BaseCurve$1.prototype._wnafMul = function(t, n) {
  var ie = 4, fe = t._getNAFPoints(ie);
  ie = fe.wnd;
  for (var ae = fe.points, le = getNAF$1(n, ie, this._bitLength), he = this.jpoint(null, null, null), me = le.length - 1; me >= 0; me--) {
    for (var ye = 0; me >= 0 && le[me] === 0; me--)
      ye++;
    if (me >= 0 && ye++, he = he.dblp(ye), me < 0)
      break;
    var be = le[me];
    assert$1$1(be !== 0), t.type === "affine" ? be > 0 ? he = he.mixedAdd(ae[be - 1 >> 1]) : he = he.mixedAdd(ae[-be - 1 >> 1].neg()) : be > 0 ? he = he.add(ae[be - 1 >> 1]) : he = he.add(ae[-be - 1 >> 1].neg());
  }
  return t.type === "affine" ? he.toP() : he;
};
BaseCurve$1.prototype._wnafMulAdd = function(t, n, ie, fe, ae) {
  var le = this._wnafT1, he = this._wnafT2, me = this._wnafT3, ye = 0, be, Ae, Se;
  for (be = 0; be < fe; be++) {
    Se = n[be];
    var $e = Se._getNAFPoints(t);
    le[be] = $e.wnd, he[be] = $e.points;
  }
  for (be = fe - 1; be >= 1; be -= 2) {
    var Re = be - 1, Me = be;
    if (le[Re] !== 1 || le[Me] !== 1) {
      me[Re] = getNAF$1(ie[Re], le[Re], this._bitLength), me[Me] = getNAF$1(ie[Me], le[Me], this._bitLength), ye = Math.max(me[Re].length, ye), ye = Math.max(me[Me].length, ye);
      continue;
    }
    var ke = [
      n[Re],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      n[Me]
      /* 7 */
    ];
    n[Re].y.cmp(n[Me].y) === 0 ? (ke[1] = n[Re].add(n[Me]), ke[2] = n[Re].toJ().mixedAdd(n[Me].neg())) : n[Re].y.cmp(n[Me].y.redNeg()) === 0 ? (ke[1] = n[Re].toJ().mixedAdd(n[Me]), ke[2] = n[Re].add(n[Me].neg())) : (ke[1] = n[Re].toJ().mixedAdd(n[Me]), ke[2] = n[Re].toJ().mixedAdd(n[Me].neg()));
    var Te = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Ie = getJSF$1(ie[Re], ie[Me]);
    for (ye = Math.max(Ie[0].length, ye), me[Re] = new Array(ye), me[Me] = new Array(ye), Ae = 0; Ae < ye; Ae++) {
      var qe = Ie[0][Ae] | 0, Ue = Ie[1][Ae] | 0;
      me[Re][Ae] = Te[(qe + 1) * 3 + (Ue + 1)], me[Me][Ae] = 0, he[Re] = ke;
    }
  }
  var ze = this.jpoint(null, null, null), Ve = this._wnafT4;
  for (be = ye; be >= 0; be--) {
    for (var Mt = 0; be >= 0; ) {
      var Rt = !0;
      for (Ae = 0; Ae < fe; Ae++)
        Ve[Ae] = me[Ae][be] | 0, Ve[Ae] !== 0 && (Rt = !1);
      if (!Rt)
        break;
      Mt++, be--;
    }
    if (be >= 0 && Mt++, ze = ze.dblp(Mt), be < 0)
      break;
    for (Ae = 0; Ae < fe; Ae++) {
      var je = Ve[Ae];
      je !== 0 && (je > 0 ? Se = he[Ae][je - 1 >> 1] : je < 0 && (Se = he[Ae][-je - 1 >> 1].neg()), Se.type === "affine" ? ze = ze.mixedAdd(Se) : ze = ze.add(Se));
    }
  }
  for (be = 0; be < fe; be++)
    he[be] = null;
  return ae ? ze : ze.toP();
};
function BasePoint$1(c, t) {
  this.curve = c, this.type = t, this.precomputed = null;
}
BaseCurve$1.BasePoint = BasePoint$1;
BasePoint$1.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint$1.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve$1.prototype.decodePoint = function(t, n) {
  t = utils_1$1$1.toArray(t, n);
  var ie = this.p.byteLength();
  if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * ie) {
    t[0] === 6 ? assert$1$1(t[t.length - 1] % 2 === 0) : t[0] === 7 && assert$1$1(t[t.length - 1] % 2 === 1);
    var fe = this.point(
      t.slice(1, 1 + ie),
      t.slice(1 + ie, 1 + 2 * ie)
    );
    return fe;
  } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === ie)
    return this.pointFromX(t.slice(1, 1 + ie), t[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint$1.prototype.encodeCompressed = function(t) {
  return this.encode(t, !0);
};
BasePoint$1.prototype._encode = function(t) {
  var n = this.curve.p.byteLength(), ie = this.getX().toArray("be", n);
  return t ? [this.getY().isEven() ? 2 : 3].concat(ie) : [4].concat(ie, this.getY().toArray("be", n));
};
BasePoint$1.prototype.encode = function(t, n) {
  return utils_1$1$1.encode(this._encode(n), t);
};
BasePoint$1.prototype.precompute = function(t) {
  if (this.precomputed)
    return this;
  var n = {
    doubles: null,
    naf: null,
    beta: null
  };
  return n.naf = this._getNAFPoints(8), n.doubles = this._getDoubles(4, t), n.beta = this._getBeta(), this.precomputed = n, this;
};
BasePoint$1.prototype._hasDoubles = function(t) {
  if (!this.precomputed)
    return !1;
  var n = this.precomputed.doubles;
  return n ? n.points.length >= Math.ceil((t.bitLength() + 1) / n.step) : !1;
};
BasePoint$1.prototype._getDoubles = function(t, n) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var ie = [this], fe = this, ae = 0; ae < n; ae += t) {
    for (var le = 0; le < t; le++)
      fe = fe.dbl();
    ie.push(fe);
  }
  return {
    step: t,
    points: ie
  };
};
BasePoint$1.prototype._getNAFPoints = function(t) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var n = [this], ie = (1 << t) - 1, fe = ie === 1 ? null : this.dbl(), ae = 1; ae < ie; ae++)
    n[ae] = n[ae - 1].add(fe);
  return {
    wnd: t,
    points: n
  };
};
BasePoint$1.prototype._getBeta = function() {
  return null;
};
BasePoint$1.prototype.dblp = function(t) {
  for (var n = this, ie = 0; ie < t; ie++)
    n = n.dbl();
  return n;
};
var inherits_browser = createCommonjsModule(function(c) {
  typeof Object.create == "function" ? c.exports = function(n, ie) {
    ie && (n.super_ = ie, n.prototype = Object.create(ie.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : c.exports = function(n, ie) {
    if (ie) {
      n.super_ = ie;
      var fe = function() {
      };
      fe.prototype = ie.prototype, n.prototype = new fe(), n.prototype.constructor = n;
    }
  };
}), assert$2$1 = utils_1$1$1.assert;
function ShortCurve$1(c) {
  base$6.call(this, "short", c), this.a = new BN$8(c.a, 16).toRed(this.red), this.b = new BN$8(c.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(c), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve$1, base$6);
var short_1 = ShortCurve$1;
ShortCurve$1.prototype._getEndomorphism = function(t) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var n, ie;
    if (t.beta)
      n = new BN$8(t.beta, 16).toRed(this.red);
    else {
      var fe = this._getEndoRoots(this.p);
      n = fe[0].cmp(fe[1]) < 0 ? fe[0] : fe[1], n = n.toRed(this.red);
    }
    if (t.lambda)
      ie = new BN$8(t.lambda, 16);
    else {
      var ae = this._getEndoRoots(this.n);
      this.g.mul(ae[0]).x.cmp(this.g.x.redMul(n)) === 0 ? ie = ae[0] : (ie = ae[1], assert$2$1(this.g.mul(ie).x.cmp(this.g.x.redMul(n)) === 0));
    }
    var le;
    return t.basis ? le = t.basis.map(function(he) {
      return {
        a: new BN$8(he.a, 16),
        b: new BN$8(he.b, 16)
      };
    }) : le = this._getEndoBasis(ie), {
      beta: n,
      lambda: ie,
      basis: le
    };
  }
};
ShortCurve$1.prototype._getEndoRoots = function(t) {
  var n = t === this.p ? this.red : BN$8.mont(t), ie = new BN$8(2).toRed(n).redInvm(), fe = ie.redNeg(), ae = new BN$8(3).toRed(n).redNeg().redSqrt().redMul(ie), le = fe.redAdd(ae).fromRed(), he = fe.redSub(ae).fromRed();
  return [le, he];
};
ShortCurve$1.prototype._getEndoBasis = function(t) {
  for (var n = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), ie = t, fe = this.n.clone(), ae = new BN$8(1), le = new BN$8(0), he = new BN$8(0), me = new BN$8(1), ye, be, Ae, Se, $e, Re, Me, ke = 0, Te, Ie; ie.cmpn(0) !== 0; ) {
    var qe = fe.div(ie);
    Te = fe.sub(qe.mul(ie)), Ie = he.sub(qe.mul(ae));
    var Ue = me.sub(qe.mul(le));
    if (!Ae && Te.cmp(n) < 0)
      ye = Me.neg(), be = ae, Ae = Te.neg(), Se = Ie;
    else if (Ae && ++ke === 2)
      break;
    Me = Te, fe = ie, ie = Te, he = ae, ae = Ie, me = le, le = Ue;
  }
  $e = Te.neg(), Re = Ie;
  var ze = Ae.sqr().add(Se.sqr()), Ve = $e.sqr().add(Re.sqr());
  return Ve.cmp(ze) >= 0 && ($e = ye, Re = be), Ae.negative && (Ae = Ae.neg(), Se = Se.neg()), $e.negative && ($e = $e.neg(), Re = Re.neg()), [
    { a: Ae, b: Se },
    { a: $e, b: Re }
  ];
};
ShortCurve$1.prototype._endoSplit = function(t) {
  var n = this.endo.basis, ie = n[0], fe = n[1], ae = fe.b.mul(t).divRound(this.n), le = ie.b.neg().mul(t).divRound(this.n), he = ae.mul(ie.a), me = le.mul(fe.a), ye = ae.mul(ie.b), be = le.mul(fe.b), Ae = t.sub(he).sub(me), Se = ye.add(be).neg();
  return { k1: Ae, k2: Se };
};
ShortCurve$1.prototype.pointFromX = function(t, n) {
  t = new BN$8(t, 16), t.red || (t = t.toRed(this.red));
  var ie = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), fe = ie.redSqrt();
  if (fe.redSqr().redSub(ie).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var ae = fe.fromRed().isOdd();
  return (n && !ae || !n && ae) && (fe = fe.redNeg()), this.point(t, fe);
};
ShortCurve$1.prototype.validate = function(t) {
  if (t.inf)
    return !0;
  var n = t.x, ie = t.y, fe = this.a.redMul(n), ae = n.redSqr().redMul(n).redIAdd(fe).redIAdd(this.b);
  return ie.redSqr().redISub(ae).cmpn(0) === 0;
};
ShortCurve$1.prototype._endoWnafMulAdd = function(t, n, ie) {
  for (var fe = this._endoWnafT1, ae = this._endoWnafT2, le = 0; le < t.length; le++) {
    var he = this._endoSplit(n[le]), me = t[le], ye = me._getBeta();
    he.k1.negative && (he.k1.ineg(), me = me.neg(!0)), he.k2.negative && (he.k2.ineg(), ye = ye.neg(!0)), fe[le * 2] = me, fe[le * 2 + 1] = ye, ae[le * 2] = he.k1, ae[le * 2 + 1] = he.k2;
  }
  for (var be = this._wnafMulAdd(1, fe, ae, le * 2, ie), Ae = 0; Ae < le * 2; Ae++)
    fe[Ae] = null, ae[Ae] = null;
  return be;
};
function Point$3(c, t, n, ie) {
  base$6.BasePoint.call(this, c, "affine"), t === null && n === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$8(t, 16), this.y = new BN$8(n, 16), ie && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits_browser(Point$3, base$6.BasePoint);
ShortCurve$1.prototype.point = function(t, n, ie) {
  return new Point$3(this, t, n, ie);
};
ShortCurve$1.prototype.pointFromJSON = function(t, n) {
  return Point$3.fromJSON(this, t, n);
};
Point$3.prototype._getBeta = function() {
  if (this.curve.endo) {
    var t = this.precomputed;
    if (t && t.beta)
      return t.beta;
    var n = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (t) {
      var ie = this.curve, fe = function(ae) {
        return ie.point(ae.x.redMul(ie.endo.beta), ae.y);
      };
      t.beta = n, n.precomputed = {
        beta: null,
        naf: t.naf && {
          wnd: t.naf.wnd,
          points: t.naf.points.map(fe)
        },
        doubles: t.doubles && {
          step: t.doubles.step,
          points: t.doubles.points.map(fe)
        }
      };
    }
    return n;
  }
};
Point$3.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$3.fromJSON = function(t, n, ie) {
  typeof n == "string" && (n = JSON.parse(n));
  var fe = t.point(n[0], n[1], ie);
  if (!n[2])
    return fe;
  function ae(he) {
    return t.point(he[0], he[1], ie);
  }
  var le = n[2];
  return fe.precomputed = {
    beta: null,
    doubles: le.doubles && {
      step: le.doubles.step,
      points: [fe].concat(le.doubles.points.map(ae))
    },
    naf: le.naf && {
      wnd: le.naf.wnd,
      points: [fe].concat(le.naf.points.map(ae))
    }
  }, fe;
};
Point$3.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$3.prototype.isInfinity = function() {
  return this.inf;
};
Point$3.prototype.add = function(t) {
  if (this.inf)
    return t;
  if (t.inf)
    return this;
  if (this.eq(t))
    return this.dbl();
  if (this.neg().eq(t))
    return this.curve.point(null, null);
  if (this.x.cmp(t.x) === 0)
    return this.curve.point(null, null);
  var n = this.y.redSub(t.y);
  n.cmpn(0) !== 0 && (n = n.redMul(this.x.redSub(t.x).redInvm()));
  var ie = n.redSqr().redISub(this.x).redISub(t.x), fe = n.redMul(this.x.redSub(ie)).redISub(this.y);
  return this.curve.point(ie, fe);
};
Point$3.prototype.dbl = function() {
  if (this.inf)
    return this;
  var t = this.y.redAdd(this.y);
  if (t.cmpn(0) === 0)
    return this.curve.point(null, null);
  var n = this.curve.a, ie = this.x.redSqr(), fe = t.redInvm(), ae = ie.redAdd(ie).redIAdd(ie).redIAdd(n).redMul(fe), le = ae.redSqr().redISub(this.x.redAdd(this.x)), he = ae.redMul(this.x.redSub(le)).redISub(this.y);
  return this.curve.point(le, he);
};
Point$3.prototype.getX = function() {
  return this.x.fromRed();
};
Point$3.prototype.getY = function() {
  return this.y.fromRed();
};
Point$3.prototype.mul = function(t) {
  return t = new BN$8(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
};
Point$3.prototype.mulAdd = function(t, n, ie) {
  var fe = [this, n], ae = [t, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(fe, ae) : this.curve._wnafMulAdd(1, fe, ae, 2);
};
Point$3.prototype.jmulAdd = function(t, n, ie) {
  var fe = [this, n], ae = [t, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(fe, ae, !0) : this.curve._wnafMulAdd(1, fe, ae, 2, !0);
};
Point$3.prototype.eq = function(t) {
  return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
};
Point$3.prototype.neg = function(t) {
  if (this.inf)
    return this;
  var n = this.curve.point(this.x, this.y.redNeg());
  if (t && this.precomputed) {
    var ie = this.precomputed, fe = function(ae) {
      return ae.neg();
    };
    n.precomputed = {
      naf: ie.naf && {
        wnd: ie.naf.wnd,
        points: ie.naf.points.map(fe)
      },
      doubles: ie.doubles && {
        step: ie.doubles.step,
        points: ie.doubles.points.map(fe)
      }
    };
  }
  return n;
};
Point$3.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var t = this.curve.jpoint(this.x, this.y, this.curve.one);
  return t;
};
function JPoint$1(c, t, n, ie) {
  base$6.BasePoint.call(this, c, "jacobian"), t === null && n === null && ie === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$8(0)) : (this.x = new BN$8(t, 16), this.y = new BN$8(n, 16), this.z = new BN$8(ie, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint$1, base$6.BasePoint);
ShortCurve$1.prototype.jpoint = function(t, n, ie) {
  return new JPoint$1(this, t, n, ie);
};
JPoint$1.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var t = this.z.redInvm(), n = t.redSqr(), ie = this.x.redMul(n), fe = this.y.redMul(n).redMul(t);
  return this.curve.point(ie, fe);
};
JPoint$1.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint$1.prototype.add = function(t) {
  if (this.isInfinity())
    return t;
  if (t.isInfinity())
    return this;
  var n = t.z.redSqr(), ie = this.z.redSqr(), fe = this.x.redMul(n), ae = t.x.redMul(ie), le = this.y.redMul(n.redMul(t.z)), he = t.y.redMul(ie.redMul(this.z)), me = fe.redSub(ae), ye = le.redSub(he);
  if (me.cmpn(0) === 0)
    return ye.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var be = me.redSqr(), Ae = be.redMul(me), Se = fe.redMul(be), $e = ye.redSqr().redIAdd(Ae).redISub(Se).redISub(Se), Re = ye.redMul(Se.redISub($e)).redISub(le.redMul(Ae)), Me = this.z.redMul(t.z).redMul(me);
  return this.curve.jpoint($e, Re, Me);
};
JPoint$1.prototype.mixedAdd = function(t) {
  if (this.isInfinity())
    return t.toJ();
  if (t.isInfinity())
    return this;
  var n = this.z.redSqr(), ie = this.x, fe = t.x.redMul(n), ae = this.y, le = t.y.redMul(n).redMul(this.z), he = ie.redSub(fe), me = ae.redSub(le);
  if (he.cmpn(0) === 0)
    return me.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var ye = he.redSqr(), be = ye.redMul(he), Ae = ie.redMul(ye), Se = me.redSqr().redIAdd(be).redISub(Ae).redISub(Ae), $e = me.redMul(Ae.redISub(Se)).redISub(ae.redMul(be)), Re = this.z.redMul(he);
  return this.curve.jpoint(Se, $e, Re);
};
JPoint$1.prototype.dblp = function(t) {
  if (t === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!t)
    return this.dbl();
  var n;
  if (this.curve.zeroA || this.curve.threeA) {
    var ie = this;
    for (n = 0; n < t; n++)
      ie = ie.dbl();
    return ie;
  }
  var fe = this.curve.a, ae = this.curve.tinv, le = this.x, he = this.y, me = this.z, ye = me.redSqr().redSqr(), be = he.redAdd(he);
  for (n = 0; n < t; n++) {
    var Ae = le.redSqr(), Se = be.redSqr(), $e = Se.redSqr(), Re = Ae.redAdd(Ae).redIAdd(Ae).redIAdd(fe.redMul(ye)), Me = le.redMul(Se), ke = Re.redSqr().redISub(Me.redAdd(Me)), Te = Me.redISub(ke), Ie = Re.redMul(Te);
    Ie = Ie.redIAdd(Ie).redISub($e);
    var qe = be.redMul(me);
    n + 1 < t && (ye = ye.redMul($e)), le = ke, me = qe, be = Ie;
  }
  return this.curve.jpoint(le, be.redMul(ae), me);
};
JPoint$1.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint$1.prototype._zeroDbl = function() {
  var t, n, ie;
  if (this.zOne) {
    var fe = this.x.redSqr(), ae = this.y.redSqr(), le = ae.redSqr(), he = this.x.redAdd(ae).redSqr().redISub(fe).redISub(le);
    he = he.redIAdd(he);
    var me = fe.redAdd(fe).redIAdd(fe), ye = me.redSqr().redISub(he).redISub(he), be = le.redIAdd(le);
    be = be.redIAdd(be), be = be.redIAdd(be), t = ye, n = me.redMul(he.redISub(ye)).redISub(be), ie = this.y.redAdd(this.y);
  } else {
    var Ae = this.x.redSqr(), Se = this.y.redSqr(), $e = Se.redSqr(), Re = this.x.redAdd(Se).redSqr().redISub(Ae).redISub($e);
    Re = Re.redIAdd(Re);
    var Me = Ae.redAdd(Ae).redIAdd(Ae), ke = Me.redSqr(), Te = $e.redIAdd($e);
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), t = ke.redISub(Re).redISub(Re), n = Me.redMul(Re.redISub(t)).redISub(Te), ie = this.y.redMul(this.z), ie = ie.redIAdd(ie);
  }
  return this.curve.jpoint(t, n, ie);
};
JPoint$1.prototype._threeDbl = function() {
  var t, n, ie;
  if (this.zOne) {
    var fe = this.x.redSqr(), ae = this.y.redSqr(), le = ae.redSqr(), he = this.x.redAdd(ae).redSqr().redISub(fe).redISub(le);
    he = he.redIAdd(he);
    var me = fe.redAdd(fe).redIAdd(fe).redIAdd(this.curve.a), ye = me.redSqr().redISub(he).redISub(he);
    t = ye;
    var be = le.redIAdd(le);
    be = be.redIAdd(be), be = be.redIAdd(be), n = me.redMul(he.redISub(ye)).redISub(be), ie = this.y.redAdd(this.y);
  } else {
    var Ae = this.z.redSqr(), Se = this.y.redSqr(), $e = this.x.redMul(Se), Re = this.x.redSub(Ae).redMul(this.x.redAdd(Ae));
    Re = Re.redAdd(Re).redIAdd(Re);
    var Me = $e.redIAdd($e);
    Me = Me.redIAdd(Me);
    var ke = Me.redAdd(Me);
    t = Re.redSqr().redISub(ke), ie = this.y.redAdd(this.z).redSqr().redISub(Se).redISub(Ae);
    var Te = Se.redSqr();
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), n = Re.redMul(Me.redISub(t)).redISub(Te);
  }
  return this.curve.jpoint(t, n, ie);
};
JPoint$1.prototype._dbl = function() {
  var t = this.curve.a, n = this.x, ie = this.y, fe = this.z, ae = fe.redSqr().redSqr(), le = n.redSqr(), he = ie.redSqr(), me = le.redAdd(le).redIAdd(le).redIAdd(t.redMul(ae)), ye = n.redAdd(n);
  ye = ye.redIAdd(ye);
  var be = ye.redMul(he), Ae = me.redSqr().redISub(be.redAdd(be)), Se = be.redISub(Ae), $e = he.redSqr();
  $e = $e.redIAdd($e), $e = $e.redIAdd($e), $e = $e.redIAdd($e);
  var Re = me.redMul(Se).redISub($e), Me = ie.redAdd(ie).redMul(fe);
  return this.curve.jpoint(Ae, Re, Me);
};
JPoint$1.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var t = this.x.redSqr(), n = this.y.redSqr(), ie = this.z.redSqr(), fe = n.redSqr(), ae = t.redAdd(t).redIAdd(t), le = ae.redSqr(), he = this.x.redAdd(n).redSqr().redISub(t).redISub(fe);
  he = he.redIAdd(he), he = he.redAdd(he).redIAdd(he), he = he.redISub(le);
  var me = he.redSqr(), ye = fe.redIAdd(fe);
  ye = ye.redIAdd(ye), ye = ye.redIAdd(ye), ye = ye.redIAdd(ye);
  var be = ae.redIAdd(he).redSqr().redISub(le).redISub(me).redISub(ye), Ae = n.redMul(be);
  Ae = Ae.redIAdd(Ae), Ae = Ae.redIAdd(Ae);
  var Se = this.x.redMul(me).redISub(Ae);
  Se = Se.redIAdd(Se), Se = Se.redIAdd(Se);
  var $e = this.y.redMul(be.redMul(ye.redISub(be)).redISub(he.redMul(me)));
  $e = $e.redIAdd($e), $e = $e.redIAdd($e), $e = $e.redIAdd($e);
  var Re = this.z.redAdd(he).redSqr().redISub(ie).redISub(me);
  return this.curve.jpoint(Se, $e, Re);
};
JPoint$1.prototype.mul = function(t, n) {
  return t = new BN$8(t, n), this.curve._wnafMul(this, t);
};
JPoint$1.prototype.eq = function(t) {
  if (t.type === "affine")
    return this.eq(t.toJ());
  if (this === t)
    return !0;
  var n = this.z.redSqr(), ie = t.z.redSqr();
  if (this.x.redMul(ie).redISub(t.x.redMul(n)).cmpn(0) !== 0)
    return !1;
  var fe = n.redMul(this.z), ae = ie.redMul(t.z);
  return this.y.redMul(ae).redISub(t.y.redMul(fe)).cmpn(0) === 0;
};
JPoint$1.prototype.eqXToP = function(t) {
  var n = this.z.redSqr(), ie = t.toRed(this.curve.red).redMul(n);
  if (this.x.cmp(ie) === 0)
    return !0;
  for (var fe = t.clone(), ae = this.curve.redN.redMul(n); ; ) {
    if (fe.iadd(this.curve.n), fe.cmp(this.curve.p) >= 0)
      return !1;
    if (ie.redIAdd(ae), this.x.cmp(ie) === 0)
      return !0;
  }
};
JPoint$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var curve_1 = createCommonjsModule(function(c, t) {
  var n = t;
  n.base = base$6, n.short = short_1, n.mont = /*RicMoo:ethers:require(./mont)*/
  null, n.edwards = /*RicMoo:ethers:require(./edwards)*/
  null;
}), curves_1 = createCommonjsModule(function(c, t) {
  var n = t, ie = utils_1$1$1.assert;
  function fe(he) {
    he.type === "short" ? this.curve = new curve_1.short(he) : he.type === "edwards" ? this.curve = new curve_1.edwards(he) : this.curve = new curve_1.mont(he), this.g = this.curve.g, this.n = this.curve.n, this.hash = he.hash, ie(this.g.validate(), "Invalid curve"), ie(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  n.PresetCurve = fe;
  function ae(he, me) {
    Object.defineProperty(n, he, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var ye = new fe(me);
        return Object.defineProperty(n, he, {
          configurable: !0,
          enumerable: !0,
          value: ye
        }), ye;
      }
    });
  }
  ae("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash$4.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), ae("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash$4.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), ae("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash$4.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), ae("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash$4.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), ae("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash$4.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), ae("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$4.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), ae("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash$4.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var le;
  try {
    le = /*RicMoo:ethers:require(./precomputed/secp256k1)*/
    null.crash();
  } catch {
    le = void 0;
  }
  ae("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash$4.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      le
    ]
  });
});
function HmacDRBG$1(c) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(c);
  this.hash = c.hash, this.predResist = !!c.predResist, this.outLen = this.hash.outSize, this.minEntropy = c.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var t = utils_1$8.toArray(c.entropy, c.entropyEnc || "hex"), n = utils_1$8.toArray(c.nonce, c.nonceEnc || "hex"), ie = utils_1$8.toArray(c.pers, c.persEnc || "hex");
  minimalisticAssert(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(t, n, ie);
}
var hmacDrbg$1 = HmacDRBG$1;
HmacDRBG$1.prototype._init = function(t, n, ie) {
  var fe = t.concat(n).concat(ie);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var ae = 0; ae < this.V.length; ae++)
    this.K[ae] = 0, this.V[ae] = 1;
  this._update(fe), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function() {
  return new hash$4.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function(t) {
  var n = this._hmac().update(this.V).update([0]);
  t && (n = n.update(t)), this.K = n.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function(t, n, ie, fe) {
  typeof n != "string" && (fe = ie, ie = n, n = null), t = utils_1$8.toArray(t, n), ie = utils_1$8.toArray(ie, fe), minimalisticAssert(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(t.concat(ie || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function(t, n, ie, fe) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof n != "string" && (fe = ie, ie = n, n = null), ie && (ie = utils_1$8.toArray(ie, fe || "hex"), this._update(ie));
  for (var ae = []; ae.length < t; )
    this.V = this._hmac().update(this.V).digest(), ae = ae.concat(this.V);
  var le = ae.slice(0, t);
  return this._update(ie), this._reseed++, utils_1$8.encode(le, n);
};
var assert$3$1 = utils_1$1$1.assert;
function KeyPair$3(c, t) {
  this.ec = c, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var key$4 = KeyPair$3;
KeyPair$3.fromPublic = function(t, n, ie) {
  return n instanceof KeyPair$3 ? n : new KeyPair$3(t, {
    pub: n,
    pubEnc: ie
  });
};
KeyPair$3.fromPrivate = function(t, n, ie) {
  return n instanceof KeyPair$3 ? n : new KeyPair$3(t, {
    priv: n,
    privEnc: ie
  });
};
KeyPair$3.prototype.validate = function() {
  var t = this.getPublic();
  return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function(t, n) {
  return typeof t == "string" && (n = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), n ? this.pub.encode(n, t) : this.pub;
};
KeyPair$3.prototype.getPrivate = function(t) {
  return t === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function(t, n) {
  this.priv = new BN$8(t, n || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function(t, n) {
  if (t.x || t.y) {
    this.ec.curve.type === "mont" ? assert$3$1(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$3$1(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(t, n);
};
KeyPair$3.prototype.derive = function(t) {
  return t.validate() || assert$3$1(t.validate(), "public point not validated"), t.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function(t, n, ie) {
  return this.ec.sign(t, this, n, ie);
};
KeyPair$3.prototype.verify = function(t, n) {
  return this.ec.verify(t, n, this);
};
KeyPair$3.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var assert$4$1 = utils_1$1$1.assert;
function Signature$3(c, t) {
  if (c instanceof Signature$3)
    return c;
  this._importDER(c, t) || (assert$4$1(c.r && c.s, "Signature without r or s"), this.r = new BN$8(c.r, 16), this.s = new BN$8(c.s, 16), c.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = c.recoveryParam);
}
var signature$4 = Signature$3;
function Position$1() {
  this.place = 0;
}
function getLength$1(c, t) {
  var n = c[t.place++];
  if (!(n & 128))
    return n;
  var ie = n & 15;
  if (ie === 0 || ie > 4)
    return !1;
  for (var fe = 0, ae = 0, le = t.place; ae < ie; ae++, le++)
    fe <<= 8, fe |= c[le], fe >>>= 0;
  return fe <= 127 ? !1 : (t.place = le, fe);
}
function rmPadding$1(c) {
  for (var t = 0, n = c.length - 1; !c[t] && !(c[t + 1] & 128) && t < n; )
    t++;
  return t === 0 ? c : c.slice(t);
}
Signature$3.prototype._importDER = function(t, n) {
  t = utils_1$1$1.toArray(t, n);
  var ie = new Position$1();
  if (t[ie.place++] !== 48)
    return !1;
  var fe = getLength$1(t, ie);
  if (fe === !1 || fe + ie.place !== t.length || t[ie.place++] !== 2)
    return !1;
  var ae = getLength$1(t, ie);
  if (ae === !1)
    return !1;
  var le = t.slice(ie.place, ae + ie.place);
  if (ie.place += ae, t[ie.place++] !== 2)
    return !1;
  var he = getLength$1(t, ie);
  if (he === !1 || t.length !== he + ie.place)
    return !1;
  var me = t.slice(ie.place, he + ie.place);
  if (le[0] === 0)
    if (le[1] & 128)
      le = le.slice(1);
    else
      return !1;
  if (me[0] === 0)
    if (me[1] & 128)
      me = me.slice(1);
    else
      return !1;
  return this.r = new BN$8(le), this.s = new BN$8(me), this.recoveryParam = null, !0;
};
function constructLength$1(c, t) {
  if (t < 128) {
    c.push(t);
    return;
  }
  var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
  for (c.push(n | 128); --n; )
    c.push(t >>> (n << 3) & 255);
  c.push(t);
}
Signature$3.prototype.toDER = function(t) {
  var n = this.r.toArray(), ie = this.s.toArray();
  for (n[0] & 128 && (n = [0].concat(n)), ie[0] & 128 && (ie = [0].concat(ie)), n = rmPadding$1(n), ie = rmPadding$1(ie); !ie[0] && !(ie[1] & 128); )
    ie = ie.slice(1);
  var fe = [2];
  constructLength$1(fe, n.length), fe = fe.concat(n), fe.push(2), constructLength$1(fe, ie.length);
  var ae = fe.concat(ie), le = [48];
  return constructLength$1(le, ae.length), le = le.concat(ae), utils_1$1$1.encode(le, t);
};
var rand = (
  /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }
), assert$5$1 = utils_1$1$1.assert;
function EC(c) {
  if (!(this instanceof EC))
    return new EC(c);
  typeof c == "string" && (assert$5$1(
    Object.prototype.hasOwnProperty.call(curves_1, c),
    "Unknown curve " + c
  ), c = curves_1[c]), c instanceof curves_1.PresetCurve && (c = { curve: c }), this.curve = c.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = c.curve.g, this.g.precompute(c.curve.n.bitLength() + 1), this.hash = c.hash || c.curve.hash;
}
var ec$2 = EC;
EC.prototype.keyPair = function(t) {
  return new key$4(this, t);
};
EC.prototype.keyFromPrivate = function(t, n) {
  return key$4.fromPrivate(this, t, n);
};
EC.prototype.keyFromPublic = function(t, n) {
  return key$4.fromPublic(this, t, n);
};
EC.prototype.genKeyPair = function(t) {
  t || (t = {});
  for (var n = new hmacDrbg$1({
    hash: this.hash,
    pers: t.pers,
    persEnc: t.persEnc || "utf8",
    entropy: t.entropy || rand(this.hash.hmacStrength),
    entropyEnc: t.entropy && t.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), ie = this.n.byteLength(), fe = this.n.sub(new BN$8(2)); ; ) {
    var ae = new BN$8(n.generate(ie));
    if (!(ae.cmp(fe) > 0))
      return ae.iaddn(1), this.keyFromPrivate(ae);
  }
};
EC.prototype._truncateToN = function(t, n) {
  var ie = t.byteLength() * 8 - this.n.bitLength();
  return ie > 0 && (t = t.ushrn(ie)), !n && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
};
EC.prototype.sign = function(t, n, ie, fe) {
  typeof ie == "object" && (fe = ie, ie = null), fe || (fe = {}), n = this.keyFromPrivate(n, ie), t = this._truncateToN(new BN$8(t, 16));
  for (var ae = this.n.byteLength(), le = n.getPrivate().toArray("be", ae), he = t.toArray("be", ae), me = new hmacDrbg$1({
    hash: this.hash,
    entropy: le,
    nonce: he,
    pers: fe.pers,
    persEnc: fe.persEnc || "utf8"
  }), ye = this.n.sub(new BN$8(1)), be = 0; ; be++) {
    var Ae = fe.k ? fe.k(be) : new BN$8(me.generate(this.n.byteLength()));
    if (Ae = this._truncateToN(Ae, !0), !(Ae.cmpn(1) <= 0 || Ae.cmp(ye) >= 0)) {
      var Se = this.g.mul(Ae);
      if (!Se.isInfinity()) {
        var $e = Se.getX(), Re = $e.umod(this.n);
        if (Re.cmpn(0) !== 0) {
          var Me = Ae.invm(this.n).mul(Re.mul(n.getPrivate()).iadd(t));
          if (Me = Me.umod(this.n), Me.cmpn(0) !== 0) {
            var ke = (Se.getY().isOdd() ? 1 : 0) | ($e.cmp(Re) !== 0 ? 2 : 0);
            return fe.canonical && Me.cmp(this.nh) > 0 && (Me = this.n.sub(Me), ke ^= 1), new signature$4({ r: Re, s: Me, recoveryParam: ke });
          }
        }
      }
    }
  }
};
EC.prototype.verify = function(t, n, ie, fe) {
  t = this._truncateToN(new BN$8(t, 16)), ie = this.keyFromPublic(ie, fe), n = new signature$4(n, "hex");
  var ae = n.r, le = n.s;
  if (ae.cmpn(1) < 0 || ae.cmp(this.n) >= 0 || le.cmpn(1) < 0 || le.cmp(this.n) >= 0)
    return !1;
  var he = le.invm(this.n), me = he.mul(t).umod(this.n), ye = he.mul(ae).umod(this.n), be;
  return this.curve._maxwellTrick ? (be = this.g.jmulAdd(me, ie.getPublic(), ye), be.isInfinity() ? !1 : be.eqXToP(ae)) : (be = this.g.mulAdd(me, ie.getPublic(), ye), be.isInfinity() ? !1 : be.getX().umod(this.n).cmp(ae) === 0);
};
EC.prototype.recoverPubKey = function(c, t, n, ie) {
  assert$5$1((3 & n) === n, "The recovery param is more than two bits"), t = new signature$4(t, ie);
  var fe = this.n, ae = new BN$8(c), le = t.r, he = t.s, me = n & 1, ye = n >> 1;
  if (le.cmp(this.curve.p.umod(this.curve.n)) >= 0 && ye)
    throw new Error("Unable to find sencond key candinate");
  ye ? le = this.curve.pointFromX(le.add(this.curve.n), me) : le = this.curve.pointFromX(le, me);
  var be = t.r.invm(fe), Ae = fe.sub(ae).mul(be).umod(fe), Se = he.mul(be).umod(fe);
  return this.g.mulAdd(Ae, le, Se);
};
EC.prototype.getKeyRecoveryParam = function(c, t, n, ie) {
  if (t = new signature$4(t, ie), t.recoveryParam !== null)
    return t.recoveryParam;
  for (var fe = 0; fe < 4; fe++) {
    var ae;
    try {
      ae = this.recoverPubKey(c, t, fe);
    } catch {
      continue;
    }
    if (ae.eq(n))
      return fe;
  }
  throw new Error("Unable to find valid recovery factor");
};
var elliptic_1 = createCommonjsModule(function(c, t) {
  var n = t;
  n.version = "6.5.4", n.utils = utils_1$1$1, n.rand = /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }, n.curve = curve_1, n.curves = curves_1, n.ec = ec$2, n.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/
  null;
}), EC$1 = elliptic_1.ec;
const version$k = "signing-key/5.7.0", logger$h = new Logger(version$k);
let _curve = null;
function getCurve() {
  return _curve || (_curve = new EC$1("secp256k1")), _curve;
}
class SigningKey {
  constructor(t) {
    defineReadOnly(this, "curve", "secp256k1"), defineReadOnly(this, "privateKey", hexlify(t)), hexDataLength(this.privateKey) !== 32 && logger$h.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
    const n = getCurve().keyFromPrivate(arrayify(this.privateKey));
    defineReadOnly(this, "publicKey", "0x" + n.getPublic(!1, "hex")), defineReadOnly(this, "compressedPublicKey", "0x" + n.getPublic(!0, "hex")), defineReadOnly(this, "_isSigningKey", !0);
  }
  _addPoint(t) {
    const n = getCurve().keyFromPublic(arrayify(this.publicKey)), ie = getCurve().keyFromPublic(arrayify(t));
    return "0x" + n.pub.add(ie.pub).encodeCompressed("hex");
  }
  signDigest(t) {
    const n = getCurve().keyFromPrivate(arrayify(this.privateKey)), ie = arrayify(t);
    ie.length !== 32 && logger$h.throwArgumentError("bad digest length", "digest", t);
    const fe = n.sign(ie, { canonical: !0 });
    return splitSignature({
      recoveryParam: fe.recoveryParam,
      r: hexZeroPad("0x" + fe.r.toString(16), 32),
      s: hexZeroPad("0x" + fe.s.toString(16), 32)
    });
  }
  computeSharedSecret(t) {
    const n = getCurve().keyFromPrivate(arrayify(this.privateKey)), ie = getCurve().keyFromPublic(arrayify(computePublicKey(t)));
    return hexZeroPad("0x" + n.derive(ie.getPublic()).toString(16), 32);
  }
  static isSigningKey(t) {
    return !!(t && t._isSigningKey);
  }
}
function recoverPublicKey(c, t) {
  const n = splitSignature(t), ie = { r: arrayify(n.r), s: arrayify(n.s) };
  return "0x" + getCurve().recoverPubKey(arrayify(c), ie, n.recoveryParam).encode("hex", !1);
}
function computePublicKey(c, t) {
  const n = arrayify(c);
  if (n.length === 32) {
    const ie = new SigningKey(n);
    return t ? "0x" + getCurve().keyFromPrivate(n).getPublic(!0, "hex") : ie.publicKey;
  } else {
    if (n.length === 33)
      return t ? hexlify(n) : "0x" + getCurve().keyFromPublic(n).getPublic(!1, "hex");
    if (n.length === 65)
      return t ? "0x" + getCurve().keyFromPublic(n).getPublic(!0, "hex") : hexlify(n);
  }
  return logger$h.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const lib_esm$a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SigningKey,
  computePublicKey,
  recoverPublicKey
}, Symbol.toStringTag, { value: "Module" })), version$j = "transactions/5.7.0", logger$g = new Logger(version$j);
var TransactionTypes;
(function(c) {
  c[c.legacy = 0] = "legacy", c[c.eip2930 = 1] = "eip2930", c[c.eip1559 = 2] = "eip1559";
})(TransactionTypes || (TransactionTypes = {}));
function handleAddress(c) {
  return c === "0x" ? null : getAddress(c);
}
function handleNumber(c) {
  return c === "0x" ? Zero$1 : BigNumber.from(c);
}
const transactionFields = [
  { name: "nonce", maxLength: 32, numeric: !0 },
  { name: "gasPrice", maxLength: 32, numeric: !0 },
  { name: "gasLimit", maxLength: 32, numeric: !0 },
  { name: "to", length: 20 },
  { name: "value", maxLength: 32, numeric: !0 },
  { name: "data" }
], allowedTransactionKeys$1 = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  type: !0,
  value: !0
};
function computeAddress(c) {
  const t = computePublicKey(c);
  return getAddress(hexDataSlice(keccak256$1(hexDataSlice(t, 1)), 12));
}
function recoverAddress(c, t) {
  return computeAddress(recoverPublicKey(arrayify(c), t));
}
function formatNumber(c, t) {
  const n = stripZeros(BigNumber.from(c).toHexString());
  return n.length > 32 && logger$g.throwArgumentError("invalid length for " + t, "transaction:" + t, c), n;
}
function accessSetify(c, t) {
  return {
    address: getAddress(c),
    storageKeys: (t || []).map((n, ie) => (hexDataLength(n) !== 32 && logger$g.throwArgumentError("invalid access list storageKey", `accessList[${c}:${ie}]`, n), n.toLowerCase()))
  };
}
function accessListify(c) {
  if (Array.isArray(c))
    return c.map((n, ie) => Array.isArray(n) ? (n.length > 2 && logger$g.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${ie}]`, n), accessSetify(n[0], n[1])) : accessSetify(n.address, n.storageKeys));
  const t = Object.keys(c).map((n) => {
    const ie = c[n].reduce((fe, ae) => (fe[ae] = !0, fe), {});
    return accessSetify(n, Object.keys(ie).sort());
  });
  return t.sort((n, ie) => n.address.localeCompare(ie.address)), t;
}
function formatAccessList(c) {
  return accessListify(c).map((t) => [t.address, t.storageKeys]);
}
function _serializeEip1559(c, t) {
  if (c.gasPrice != null) {
    const ie = BigNumber.from(c.gasPrice), fe = BigNumber.from(c.maxFeePerGas || 0);
    ie.eq(fe) || logger$g.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
      gasPrice: ie,
      maxFeePerGas: fe
    });
  }
  const n = [
    formatNumber(c.chainId || 0, "chainId"),
    formatNumber(c.nonce || 0, "nonce"),
    formatNumber(c.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    formatNumber(c.maxFeePerGas || 0, "maxFeePerGas"),
    formatNumber(c.gasLimit || 0, "gasLimit"),
    c.to != null ? getAddress(c.to) : "0x",
    formatNumber(c.value || 0, "value"),
    c.data || "0x",
    formatAccessList(c.accessList || [])
  ];
  if (t) {
    const ie = splitSignature(t);
    n.push(formatNumber(ie.recoveryParam, "recoveryParam")), n.push(stripZeros(ie.r)), n.push(stripZeros(ie.s));
  }
  return hexConcat(["0x02", encode$6(n)]);
}
function _serializeEip2930(c, t) {
  const n = [
    formatNumber(c.chainId || 0, "chainId"),
    formatNumber(c.nonce || 0, "nonce"),
    formatNumber(c.gasPrice || 0, "gasPrice"),
    formatNumber(c.gasLimit || 0, "gasLimit"),
    c.to != null ? getAddress(c.to) : "0x",
    formatNumber(c.value || 0, "value"),
    c.data || "0x",
    formatAccessList(c.accessList || [])
  ];
  if (t) {
    const ie = splitSignature(t);
    n.push(formatNumber(ie.recoveryParam, "recoveryParam")), n.push(stripZeros(ie.r)), n.push(stripZeros(ie.s));
  }
  return hexConcat(["0x01", encode$6(n)]);
}
function _serialize(c, t) {
  checkProperties(c, allowedTransactionKeys$1);
  const n = [];
  transactionFields.forEach(function(le) {
    let he = c[le.name] || [];
    const me = {};
    le.numeric && (me.hexPad = "left"), he = arrayify(hexlify(he, me)), le.length && he.length !== le.length && he.length > 0 && logger$g.throwArgumentError("invalid length for " + le.name, "transaction:" + le.name, he), le.maxLength && (he = stripZeros(he), he.length > le.maxLength && logger$g.throwArgumentError("invalid length for " + le.name, "transaction:" + le.name, he)), n.push(hexlify(he));
  });
  let ie = 0;
  if (c.chainId != null ? (ie = c.chainId, typeof ie != "number" && logger$g.throwArgumentError("invalid transaction.chainId", "transaction", c)) : t && !isBytesLike(t) && t.v > 28 && (ie = Math.floor((t.v - 35) / 2)), ie !== 0 && (n.push(hexlify(ie)), n.push("0x"), n.push("0x")), !t)
    return encode$6(n);
  const fe = splitSignature(t);
  let ae = 27 + fe.recoveryParam;
  return ie !== 0 ? (n.pop(), n.pop(), n.pop(), ae += ie * 2 + 8, fe.v > 28 && fe.v !== ae && logger$g.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", t)) : fe.v !== ae && logger$g.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", t), n.push(hexlify(ae)), n.push(stripZeros(arrayify(fe.r))), n.push(stripZeros(arrayify(fe.s))), encode$6(n);
}
function serialize$1(c, t) {
  if (c.type == null || c.type === 0)
    return c.accessList != null && logger$g.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", c), _serialize(c, t);
  switch (c.type) {
    case 1:
      return _serializeEip2930(c, t);
    case 2:
      return _serializeEip1559(c, t);
  }
  return logger$g.throwError(`unsupported transaction type: ${c.type}`, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "serializeTransaction",
    transactionType: c.type
  });
}
function _parseEipSignature(c, t, n) {
  try {
    const ie = handleNumber(t[0]).toNumber();
    if (ie !== 0 && ie !== 1)
      throw new Error("bad recid");
    c.v = ie;
  } catch {
    logger$g.throwArgumentError("invalid v for transaction type: 1", "v", t[0]);
  }
  c.r = hexZeroPad(t[1], 32), c.s = hexZeroPad(t[2], 32);
  try {
    const ie = keccak256$1(n(c));
    c.from = recoverAddress(ie, { r: c.r, s: c.s, recoveryParam: c.v });
  } catch {
  }
}
function _parseEip1559(c) {
  const t = decode$7(c.slice(1));
  t.length !== 9 && t.length !== 12 && logger$g.throwArgumentError("invalid component count for transaction type: 2", "payload", hexlify(c));
  const n = handleNumber(t[2]), ie = handleNumber(t[3]), fe = {
    type: 2,
    chainId: handleNumber(t[0]).toNumber(),
    nonce: handleNumber(t[1]).toNumber(),
    maxPriorityFeePerGas: n,
    maxFeePerGas: ie,
    gasPrice: null,
    gasLimit: handleNumber(t[4]),
    to: handleAddress(t[5]),
    value: handleNumber(t[6]),
    data: t[7],
    accessList: accessListify(t[8])
  };
  return t.length === 9 || (fe.hash = keccak256$1(c), _parseEipSignature(fe, t.slice(9), _serializeEip1559)), fe;
}
function _parseEip2930(c) {
  const t = decode$7(c.slice(1));
  t.length !== 8 && t.length !== 11 && logger$g.throwArgumentError("invalid component count for transaction type: 1", "payload", hexlify(c));
  const n = {
    type: 1,
    chainId: handleNumber(t[0]).toNumber(),
    nonce: handleNumber(t[1]).toNumber(),
    gasPrice: handleNumber(t[2]),
    gasLimit: handleNumber(t[3]),
    to: handleAddress(t[4]),
    value: handleNumber(t[5]),
    data: t[6],
    accessList: accessListify(t[7])
  };
  return t.length === 8 || (n.hash = keccak256$1(c), _parseEipSignature(n, t.slice(8), _serializeEip2930)), n;
}
function _parse(c) {
  const t = decode$7(c);
  t.length !== 9 && t.length !== 6 && logger$g.throwArgumentError("invalid raw transaction", "rawTransaction", c);
  const n = {
    nonce: handleNumber(t[0]).toNumber(),
    gasPrice: handleNumber(t[1]),
    gasLimit: handleNumber(t[2]),
    to: handleAddress(t[3]),
    value: handleNumber(t[4]),
    data: t[5],
    chainId: 0
  };
  if (t.length === 6)
    return n;
  try {
    n.v = BigNumber.from(t[6]).toNumber();
  } catch {
    return n;
  }
  if (n.r = hexZeroPad(t[7], 32), n.s = hexZeroPad(t[8], 32), BigNumber.from(n.r).isZero() && BigNumber.from(n.s).isZero())
    n.chainId = n.v, n.v = 0;
  else {
    n.chainId = Math.floor((n.v - 35) / 2), n.chainId < 0 && (n.chainId = 0);
    let ie = n.v - 27;
    const fe = t.slice(0, 6);
    n.chainId !== 0 && (fe.push(hexlify(n.chainId)), fe.push("0x"), fe.push("0x"), ie -= n.chainId * 2 + 8);
    const ae = keccak256$1(encode$6(fe));
    try {
      n.from = recoverAddress(ae, { r: hexlify(n.r), s: hexlify(n.s), recoveryParam: ie });
    } catch {
    }
    n.hash = keccak256$1(c);
  }
  return n.type = null, n;
}
function parse$2(c) {
  const t = arrayify(c);
  if (t[0] > 127)
    return _parse(t);
  switch (t[0]) {
    case 1:
      return _parseEip2930(t);
    case 2:
      return _parseEip1559(t);
  }
  return logger$g.throwError(`unsupported transaction type: ${t[0]}`, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "parseTransaction",
    transactionType: t[0]
  });
}
const lib_esm$9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TransactionTypes() {
    return TransactionTypes;
  },
  accessListify,
  computeAddress,
  parse: parse$2,
  recoverAddress,
  serialize: serialize$1
}, Symbol.toStringTag, { value: "Module" })), version$i = "contracts/5.7.0";
var __awaiter$h = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$f = new Logger(version$i);
function resolveName(c, t) {
  return __awaiter$h(this, void 0, void 0, function* () {
    const n = yield t;
    typeof n != "string" && logger$f.throwArgumentError("invalid address or ENS name", "name", n);
    try {
      return getAddress(n);
    } catch {
    }
    c || logger$f.throwError("a provider or signer is needed to resolve ENS names", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "resolveName"
    });
    const ie = yield c.resolveName(n);
    return ie == null && logger$f.throwArgumentError("resolver or addr is not configured for ENS name", "name", n), ie;
  });
}
function resolveAddresses(c, t, n) {
  return __awaiter$h(this, void 0, void 0, function* () {
    return Array.isArray(n) ? yield Promise.all(n.map((ie, fe) => resolveAddresses(c, Array.isArray(t) ? t[fe] : t[ie.name], ie))) : n.type === "address" ? yield resolveName(c, t) : n.type === "tuple" ? yield resolveAddresses(c, t, n.components) : n.baseType === "array" ? Array.isArray(t) ? yield Promise.all(t.map((ie) => resolveAddresses(c, ie, n.arrayChildren))) : Promise.reject(logger$f.makeError("invalid value for array", Logger.errors.INVALID_ARGUMENT, {
      argument: "value",
      value: t
    })) : t;
  });
}
function populateTransaction(c, t, n) {
  return __awaiter$h(this, void 0, void 0, function* () {
    let ie = {};
    n.length === t.inputs.length + 1 && typeof n[n.length - 1] == "object" && (ie = shallowCopy(n.pop())), logger$f.checkArgumentCount(n.length, t.inputs.length, "passed to contract"), c.signer ? ie.from ? ie.from = resolveProperties({
      override: resolveName(c.signer, ie.from),
      signer: c.signer.getAddress()
    }).then((ye) => __awaiter$h(this, void 0, void 0, function* () {
      return getAddress(ye.signer) !== ye.override && logger$f.throwError("Contract with a Signer cannot override from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.from"
      }), ye.override;
    })) : ie.from = c.signer.getAddress() : ie.from && (ie.from = resolveName(c.provider, ie.from));
    const fe = yield resolveProperties({
      args: resolveAddresses(c.signer || c.provider, n, t.inputs),
      address: c.resolvedAddress,
      overrides: resolveProperties(ie) || {}
    }), ae = c.interface.encodeFunctionData(t, fe.args), le = {
      data: ae,
      to: fe.address
    }, he = fe.overrides;
    if (he.nonce != null && (le.nonce = BigNumber.from(he.nonce).toNumber()), he.gasLimit != null && (le.gasLimit = BigNumber.from(he.gasLimit)), he.gasPrice != null && (le.gasPrice = BigNumber.from(he.gasPrice)), he.maxFeePerGas != null && (le.maxFeePerGas = BigNumber.from(he.maxFeePerGas)), he.maxPriorityFeePerGas != null && (le.maxPriorityFeePerGas = BigNumber.from(he.maxPriorityFeePerGas)), he.from != null && (le.from = he.from), he.type != null && (le.type = he.type), he.accessList != null && (le.accessList = accessListify(he.accessList)), le.gasLimit == null && t.gas != null) {
      let ye = 21e3;
      const be = arrayify(ae);
      for (let Ae = 0; Ae < be.length; Ae++)
        ye += 4, be[Ae] && (ye += 64);
      le.gasLimit = BigNumber.from(t.gas).add(ye);
    }
    if (he.value) {
      const ye = BigNumber.from(he.value);
      !ye.isZero() && !t.payable && logger$f.throwError("non-payable method cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.value",
        value: ie.value
      }), le.value = ye;
    }
    he.customData && (le.customData = shallowCopy(he.customData)), he.ccipReadEnabled && (le.ccipReadEnabled = !!he.ccipReadEnabled), delete ie.nonce, delete ie.gasLimit, delete ie.gasPrice, delete ie.from, delete ie.value, delete ie.type, delete ie.accessList, delete ie.maxFeePerGas, delete ie.maxPriorityFeePerGas, delete ie.customData, delete ie.ccipReadEnabled;
    const me = Object.keys(ie).filter((ye) => ie[ye] != null);
    return me.length && logger$f.throwError(`cannot override ${me.map((ye) => JSON.stringify(ye)).join(",")}`, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "overrides",
      overrides: me
    }), le;
  });
}
function buildPopulate(c, t) {
  return function(...n) {
    return populateTransaction(c, t, n);
  };
}
function buildEstimate(c, t) {
  const n = c.signer || c.provider;
  return function(...ie) {
    return __awaiter$h(this, void 0, void 0, function* () {
      n || logger$f.throwError("estimate require a provider or signer", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "estimateGas"
      });
      const fe = yield populateTransaction(c, t, ie);
      return yield n.estimateGas(fe);
    });
  };
}
function addContractWait(c, t) {
  const n = t.wait.bind(t);
  t.wait = (ie) => n(ie).then((fe) => (fe.events = fe.logs.map((ae) => {
    let le = deepCopy(ae), he = null;
    try {
      he = c.interface.parseLog(ae);
    } catch {
    }
    return he && (le.args = he.args, le.decode = (me, ye) => c.interface.decodeEventLog(he.eventFragment, me, ye), le.event = he.name, le.eventSignature = he.signature), le.removeListener = () => c.provider, le.getBlock = () => c.provider.getBlock(fe.blockHash), le.getTransaction = () => c.provider.getTransaction(fe.transactionHash), le.getTransactionReceipt = () => Promise.resolve(fe), le;
  }), fe));
}
function buildCall(c, t, n) {
  const ie = c.signer || c.provider;
  return function(...fe) {
    return __awaiter$h(this, void 0, void 0, function* () {
      let ae;
      if (fe.length === t.inputs.length + 1 && typeof fe[fe.length - 1] == "object") {
        const me = shallowCopy(fe.pop());
        me.blockTag != null && (ae = yield me.blockTag), delete me.blockTag, fe.push(me);
      }
      c.deployTransaction != null && (yield c._deployed(ae));
      const le = yield populateTransaction(c, t, fe), he = yield ie.call(le, ae);
      try {
        let me = c.interface.decodeFunctionResult(t, he);
        return n && t.outputs.length === 1 && (me = me[0]), me;
      } catch (me) {
        throw me.code === Logger.errors.CALL_EXCEPTION && (me.address = c.address, me.args = fe, me.transaction = le), me;
      }
    });
  };
}
function buildSend(c, t) {
  return function(...n) {
    return __awaiter$h(this, void 0, void 0, function* () {
      c.signer || logger$f.throwError("sending a transaction requires a signer", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "sendTransaction"
      }), c.deployTransaction != null && (yield c._deployed());
      const ie = yield populateTransaction(c, t, n), fe = yield c.signer.sendTransaction(ie);
      return addContractWait(c, fe), fe;
    });
  };
}
function buildDefault(c, t, n) {
  return t.constant ? buildCall(c, t, n) : buildSend(c, t);
}
function getEventTag$1(c) {
  return c.address && (c.topics == null || c.topics.length === 0) ? "*" : (c.address || "*") + "@" + (c.topics ? c.topics.map((t) => Array.isArray(t) ? t.join("|") : t).join(":") : "");
}
class RunningEvent {
  constructor(t, n) {
    defineReadOnly(this, "tag", t), defineReadOnly(this, "filter", n), this._listeners = [];
  }
  addListener(t, n) {
    this._listeners.push({ listener: t, once: n });
  }
  removeListener(t) {
    let n = !1;
    this._listeners = this._listeners.filter((ie) => n || ie.listener !== t ? !0 : (n = !0, !1));
  }
  removeAllListeners() {
    this._listeners = [];
  }
  listeners() {
    return this._listeners.map((t) => t.listener);
  }
  listenerCount() {
    return this._listeners.length;
  }
  run(t) {
    const n = this.listenerCount();
    return this._listeners = this._listeners.filter((ie) => {
      const fe = t.slice();
      return setTimeout(() => {
        ie.listener.apply(this, fe);
      }, 0), !ie.once;
    }), n;
  }
  prepareEvent(t) {
  }
  // Returns the array that will be applied to an emit
  getEmit(t) {
    return [t];
  }
}
class ErrorRunningEvent extends RunningEvent {
  constructor() {
    super("error", null);
  }
}
class FragmentRunningEvent extends RunningEvent {
  constructor(t, n, ie, fe) {
    const ae = {
      address: t
    };
    let le = n.getEventTopic(ie);
    fe ? (le !== fe[0] && logger$f.throwArgumentError("topic mismatch", "topics", fe), ae.topics = fe.slice()) : ae.topics = [le], super(getEventTag$1(ae), ae), defineReadOnly(this, "address", t), defineReadOnly(this, "interface", n), defineReadOnly(this, "fragment", ie);
  }
  prepareEvent(t) {
    super.prepareEvent(t), t.event = this.fragment.name, t.eventSignature = this.fragment.format(), t.decode = (n, ie) => this.interface.decodeEventLog(this.fragment, n, ie);
    try {
      t.args = this.interface.decodeEventLog(this.fragment, t.data, t.topics);
    } catch (n) {
      t.args = null, t.decodeError = n;
    }
  }
  getEmit(t) {
    const n = checkResultErrors(t.args);
    if (n.length)
      throw n[0].error;
    const ie = (t.args || []).slice();
    return ie.push(t), ie;
  }
}
class WildcardRunningEvent extends RunningEvent {
  constructor(t, n) {
    super("*", { address: t }), defineReadOnly(this, "address", t), defineReadOnly(this, "interface", n);
  }
  prepareEvent(t) {
    super.prepareEvent(t);
    try {
      const n = this.interface.parseLog(t);
      t.event = n.name, t.eventSignature = n.signature, t.decode = (ie, fe) => this.interface.decodeEventLog(n.eventFragment, ie, fe), t.args = n.args;
    } catch {
    }
  }
}
class BaseContract {
  constructor(t, n, ie) {
    defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(n)), ie == null ? (defineReadOnly(this, "provider", null), defineReadOnly(this, "signer", null)) : Signer.isSigner(ie) ? (defineReadOnly(this, "provider", ie.provider || null), defineReadOnly(this, "signer", ie)) : Provider.isProvider(ie) ? (defineReadOnly(this, "provider", ie), defineReadOnly(this, "signer", null)) : logger$f.throwArgumentError("invalid signer or provider", "signerOrProvider", ie), defineReadOnly(this, "callStatic", {}), defineReadOnly(this, "estimateGas", {}), defineReadOnly(this, "functions", {}), defineReadOnly(this, "populateTransaction", {}), defineReadOnly(this, "filters", {});
    {
      const le = {};
      Object.keys(this.interface.events).forEach((he) => {
        const me = this.interface.events[he];
        defineReadOnly(this.filters, he, (...ye) => ({
          address: this.address,
          topics: this.interface.encodeFilterTopics(me, ye)
        })), le[me.name] || (le[me.name] = []), le[me.name].push(he);
      }), Object.keys(le).forEach((he) => {
        const me = le[he];
        me.length === 1 ? defineReadOnly(this.filters, he, this.filters[me[0]]) : logger$f.warn(`Duplicate definition of ${he} (${me.join(", ")})`);
      });
    }
    if (defineReadOnly(this, "_runningEvents", {}), defineReadOnly(this, "_wrappedEmits", {}), t == null && logger$f.throwArgumentError("invalid contract address or ENS name", "addressOrName", t), defineReadOnly(this, "address", t), this.provider)
      defineReadOnly(this, "resolvedAddress", resolveName(this.provider, t));
    else
      try {
        defineReadOnly(this, "resolvedAddress", Promise.resolve(getAddress(t)));
      } catch {
        logger$f.throwError("provider is required to use ENS name as contract address", Logger.errors.UNSUPPORTED_OPERATION, {
          operation: "new Contract"
        });
      }
    this.resolvedAddress.catch((le) => {
    });
    const fe = {}, ae = {};
    Object.keys(this.interface.functions).forEach((le) => {
      const he = this.interface.functions[le];
      if (ae[le]) {
        logger$f.warn(`Duplicate ABI entry for ${JSON.stringify(le)}`);
        return;
      }
      ae[le] = !0;
      {
        const me = he.name;
        fe[`%${me}`] || (fe[`%${me}`] = []), fe[`%${me}`].push(le);
      }
      this[le] == null && defineReadOnly(this, le, buildDefault(this, he, !0)), this.functions[le] == null && defineReadOnly(this.functions, le, buildDefault(this, he, !1)), this.callStatic[le] == null && defineReadOnly(this.callStatic, le, buildCall(this, he, !0)), this.populateTransaction[le] == null && defineReadOnly(this.populateTransaction, le, buildPopulate(this, he)), this.estimateGas[le] == null && defineReadOnly(this.estimateGas, le, buildEstimate(this, he));
    }), Object.keys(fe).forEach((le) => {
      const he = fe[le];
      if (he.length > 1)
        return;
      le = le.substring(1);
      const me = he[0];
      try {
        this[le] == null && defineReadOnly(this, le, this[me]);
      } catch {
      }
      this.functions[le] == null && defineReadOnly(this.functions, le, this.functions[me]), this.callStatic[le] == null && defineReadOnly(this.callStatic, le, this.callStatic[me]), this.populateTransaction[le] == null && defineReadOnly(this.populateTransaction, le, this.populateTransaction[me]), this.estimateGas[le] == null && defineReadOnly(this.estimateGas, le, this.estimateGas[me]);
    });
  }
  static getContractAddress(t) {
    return getContractAddress(t);
  }
  static getInterface(t) {
    return Interface.isInterface(t) ? t : new Interface(t);
  }
  // @TODO: Allow timeout?
  deployed() {
    return this._deployed();
  }
  _deployed(t) {
    return this._deployedPromise || (this.deployTransaction ? this._deployedPromise = this.deployTransaction.wait().then(() => this) : this._deployedPromise = this.provider.getCode(this.address, t).then((n) => (n === "0x" && logger$f.throwError("contract not deployed", Logger.errors.UNSUPPORTED_OPERATION, {
      contractAddress: this.address,
      operation: "getDeployed"
    }), this))), this._deployedPromise;
  }
  // @TODO:
  // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
  // @TODO:
  // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
  fallback(t) {
    this.signer || logger$f.throwError("sending a transactions require a signer", Logger.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
    const n = shallowCopy(t || {});
    return ["from", "to"].forEach(function(ie) {
      n[ie] != null && logger$f.throwError("cannot override " + ie, Logger.errors.UNSUPPORTED_OPERATION, { operation: ie });
    }), n.to = this.resolvedAddress, this.deployed().then(() => this.signer.sendTransaction(n));
  }
  // Reconnect to a different signer or provider
  connect(t) {
    typeof t == "string" && (t = new VoidSigner(t, this.provider));
    const n = new this.constructor(this.address, this.interface, t);
    return this.deployTransaction && defineReadOnly(n, "deployTransaction", this.deployTransaction), n;
  }
  // Re-attach to a different on-chain instance of this contract
  attach(t) {
    return new this.constructor(t, this.interface, this.signer || this.provider);
  }
  static isIndexed(t) {
    return Indexed.isIndexed(t);
  }
  _normalizeRunningEvent(t) {
    return this._runningEvents[t.tag] ? this._runningEvents[t.tag] : t;
  }
  _getRunningEvent(t) {
    if (typeof t == "string") {
      if (t === "error")
        return this._normalizeRunningEvent(new ErrorRunningEvent());
      if (t === "event")
        return this._normalizeRunningEvent(new RunningEvent("event", null));
      if (t === "*")
        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
      const n = this.interface.getEvent(t);
      return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, n));
    }
    if (t.topics && t.topics.length > 0) {
      try {
        const ie = t.topics[0];
        if (typeof ie != "string")
          throw new Error("invalid topic");
        const fe = this.interface.getEvent(ie);
        return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fe, t.topics));
      } catch {
      }
      const n = {
        address: this.address,
        topics: t.topics
      };
      return this._normalizeRunningEvent(new RunningEvent(getEventTag$1(n), n));
    }
    return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
  }
  _checkRunningEvents(t) {
    if (t.listenerCount() === 0) {
      delete this._runningEvents[t.tag];
      const n = this._wrappedEmits[t.tag];
      n && t.filter && (this.provider.off(t.filter, n), delete this._wrappedEmits[t.tag]);
    }
  }
  // Subclasses can override this to gracefully recover
  // from parse errors if they wish
  _wrapEvent(t, n, ie) {
    const fe = deepCopy(n);
    return fe.removeListener = () => {
      ie && (t.removeListener(ie), this._checkRunningEvents(t));
    }, fe.getBlock = () => this.provider.getBlock(n.blockHash), fe.getTransaction = () => this.provider.getTransaction(n.transactionHash), fe.getTransactionReceipt = () => this.provider.getTransactionReceipt(n.transactionHash), t.prepareEvent(fe), fe;
  }
  _addEventListener(t, n, ie) {
    if (this.provider || logger$f.throwError("events require a provider or a signer with a provider", Logger.errors.UNSUPPORTED_OPERATION, { operation: "once" }), t.addListener(n, ie), this._runningEvents[t.tag] = t, !this._wrappedEmits[t.tag]) {
      const fe = (ae) => {
        let le = this._wrapEvent(t, ae, n);
        if (le.decodeError == null)
          try {
            const he = t.getEmit(le);
            this.emit(t.filter, ...he);
          } catch (he) {
            le.decodeError = he.error;
          }
        t.filter != null && this.emit("event", le), le.decodeError != null && this.emit("error", le.decodeError, le);
      };
      this._wrappedEmits[t.tag] = fe, t.filter != null && this.provider.on(t.filter, fe);
    }
  }
  queryFilter(t, n, ie) {
    const fe = this._getRunningEvent(t), ae = shallowCopy(fe.filter);
    return typeof n == "string" && isHexString(n, 32) ? (ie != null && logger$f.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", ie), ae.blockHash = n) : (ae.fromBlock = n ?? 0, ae.toBlock = ie ?? "latest"), this.provider.getLogs(ae).then((le) => le.map((he) => this._wrapEvent(fe, he, null)));
  }
  on(t, n) {
    return this._addEventListener(this._getRunningEvent(t), n, !1), this;
  }
  once(t, n) {
    return this._addEventListener(this._getRunningEvent(t), n, !0), this;
  }
  emit(t, ...n) {
    if (!this.provider)
      return !1;
    const ie = this._getRunningEvent(t), fe = ie.run(n) > 0;
    return this._checkRunningEvents(ie), fe;
  }
  listenerCount(t) {
    return this.provider ? t == null ? Object.keys(this._runningEvents).reduce((n, ie) => n + this._runningEvents[ie].listenerCount(), 0) : this._getRunningEvent(t).listenerCount() : 0;
  }
  listeners(t) {
    if (!this.provider)
      return [];
    if (t == null) {
      const n = [];
      for (let ie in this._runningEvents)
        this._runningEvents[ie].listeners().forEach((fe) => {
          n.push(fe);
        });
      return n;
    }
    return this._getRunningEvent(t).listeners();
  }
  removeAllListeners(t) {
    if (!this.provider)
      return this;
    if (t == null) {
      for (const ie in this._runningEvents) {
        const fe = this._runningEvents[ie];
        fe.removeAllListeners(), this._checkRunningEvents(fe);
      }
      return this;
    }
    const n = this._getRunningEvent(t);
    return n.removeAllListeners(), this._checkRunningEvents(n), this;
  }
  off(t, n) {
    if (!this.provider)
      return this;
    const ie = this._getRunningEvent(t);
    return ie.removeListener(n), this._checkRunningEvents(ie), this;
  }
  removeListener(t, n) {
    return this.off(t, n);
  }
}
class Contract extends BaseContract {
}
class BaseX {
  constructor(t) {
    defineReadOnly(this, "alphabet", t), defineReadOnly(this, "base", t.length), defineReadOnly(this, "_alphabetMap", {}), defineReadOnly(this, "_leader", t.charAt(0));
    for (let n = 0; n < t.length; n++)
      this._alphabetMap[t.charAt(n)] = n;
  }
  encode(t) {
    let n = arrayify(t);
    if (n.length === 0)
      return "";
    let ie = [0];
    for (let ae = 0; ae < n.length; ++ae) {
      let le = n[ae];
      for (let he = 0; he < ie.length; ++he)
        le += ie[he] << 8, ie[he] = le % this.base, le = le / this.base | 0;
      for (; le > 0; )
        ie.push(le % this.base), le = le / this.base | 0;
    }
    let fe = "";
    for (let ae = 0; n[ae] === 0 && ae < n.length - 1; ++ae)
      fe += this._leader;
    for (let ae = ie.length - 1; ae >= 0; --ae)
      fe += this.alphabet[ie[ae]];
    return fe;
  }
  decode(t) {
    if (typeof t != "string")
      throw new TypeError("Expected String");
    let n = [];
    if (t.length === 0)
      return new Uint8Array(n);
    n.push(0);
    for (let ie = 0; ie < t.length; ie++) {
      let fe = this._alphabetMap[t[ie]];
      if (fe === void 0)
        throw new Error("Non-base" + this.base + " character");
      let ae = fe;
      for (let le = 0; le < n.length; ++le)
        ae += n[le] * this.base, n[le] = ae & 255, ae >>= 8;
      for (; ae > 0; )
        n.push(ae & 255), ae >>= 8;
    }
    for (let ie = 0; t[ie] === this._leader && ie < t.length - 1; ++ie)
      n.push(0);
    return arrayify(new Uint8Array(n.reverse()));
  }
}
const Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567"), Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), lib_esm$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Base32,
  Base58,
  BaseX
}, Symbol.toStringTag, { value: "Module" }));
var SupportedAlgorithm;
(function(c) {
  c.sha256 = "sha256", c.sha512 = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));
const version$h = "sha2/5.7.0", logger$e = new Logger(version$h);
function ripemd160$1(c) {
  return "0x" + hash$4.ripemd160().update(arrayify(c)).digest("hex");
}
function sha256$6(c) {
  return "0x" + hash$4.sha256().update(arrayify(c)).digest("hex");
}
function sha512$4(c) {
  return "0x" + hash$4.sha512().update(arrayify(c)).digest("hex");
}
function computeHmac(c, t, n) {
  return SupportedAlgorithm[c] || logger$e.throwError("unsupported algorithm " + c, Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "hmac",
    algorithm: c
  }), "0x" + hash$4.hmac(hash$4[c], arrayify(t)).update(arrayify(n)).digest("hex");
}
const lib_esm$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SupportedAlgorithm() {
    return SupportedAlgorithm;
  },
  computeHmac,
  ripemd160: ripemd160$1,
  sha256: sha256$6,
  sha512: sha512$4
}, Symbol.toStringTag, { value: "Module" }));
function pbkdf2$1(c, t, n, ie, fe) {
  c = arrayify(c), t = arrayify(t);
  let ae, le = 1;
  const he = new Uint8Array(ie), me = new Uint8Array(t.length + 4);
  me.set(t);
  let ye, be;
  for (let Ae = 1; Ae <= le; Ae++) {
    me[t.length] = Ae >> 24 & 255, me[t.length + 1] = Ae >> 16 & 255, me[t.length + 2] = Ae >> 8 & 255, me[t.length + 3] = Ae & 255;
    let Se = arrayify(computeHmac(fe, c, me));
    ae || (ae = Se.length, be = new Uint8Array(ae), le = Math.ceil(ie / ae), ye = ie - (le - 1) * ae), be.set(Se);
    for (let Me = 1; Me < n; Me++) {
      Se = arrayify(computeHmac(fe, c, Se));
      for (let ke = 0; ke < ae; ke++)
        be[ke] ^= Se[ke];
    }
    const $e = (Ae - 1) * ae, Re = Ae === le ? ye : ae;
    he.set(arrayify(be).slice(0, Re), $e);
  }
  return hexlify(he);
}
const version$g = "wordlists/5.7.0", logger$d = new Logger(version$g);
class Wordlist {
  constructor(t) {
    logger$d.checkAbstract(new.target, Wordlist), defineReadOnly(this, "locale", t);
  }
  // Subclasses may override this
  split(t) {
    return t.toLowerCase().split(/ +/g);
  }
  // Subclasses may override this
  join(t) {
    return t.join(" ");
  }
  static check(t) {
    const n = [];
    for (let ie = 0; ie < 2048; ie++) {
      const fe = t.getWord(ie);
      if (ie !== t.getWordIndex(fe))
        return "0x";
      n.push(fe);
    }
    return id(n.join(`
`) + `
`);
  }
  static register(t, n) {
    n || (n = t.locale);
  }
}
const words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let wordlist = null;
function loadWords(c) {
  if (wordlist == null && (wordlist = words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" "), Wordlist.check(c) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60"))
    throw wordlist = null, new Error("BIP39 Wordlist for en (English) FAILED");
}
class LangEn extends Wordlist {
  constructor() {
    super("en");
  }
  getWord(t) {
    return loadWords(this), wordlist[t];
  }
  getWordIndex(t) {
    return loadWords(this), wordlist.indexOf(t);
  }
}
const langEn = new LangEn();
Wordlist.register(langEn);
const wordlists = {
  en: langEn
}, version$f = "hdnode/5.7.0", logger$c = new Logger(version$f), N$3 = BigNumber.from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), MasterSecret = toUtf8Bytes("Bitcoin seed"), HardenedBit = 2147483648;
function getUpperMask(c) {
  return (1 << c) - 1 << 8 - c;
}
function getLowerMask(c) {
  return (1 << c) - 1;
}
function bytes32(c) {
  return hexZeroPad(hexlify(c), 32);
}
function base58check(c) {
  return Base58.encode(concat$1([c, hexDataSlice(sha256$6(sha256$6(c)), 0, 4)]));
}
function getWordlist(c) {
  if (c == null)
    return wordlists.en;
  if (typeof c == "string") {
    const t = wordlists[c];
    return t == null && logger$c.throwArgumentError("unknown locale", "wordlist", c), t;
  }
  return c;
}
const _constructorGuard$1 = {}, defaultPath = "m/44'/60'/0'/0/0";
class HDNode {
  /**
   *  This constructor should not be called directly.
   *
   *  Please use:
   *   - fromMnemonic
   *   - fromSeed
   */
  constructor(t, n, ie, fe, ae, le, he, me) {
    if (t !== _constructorGuard$1)
      throw new Error("HDNode constructor cannot be called directly");
    if (n) {
      const ye = new SigningKey(n);
      defineReadOnly(this, "privateKey", ye.privateKey), defineReadOnly(this, "publicKey", ye.compressedPublicKey);
    } else
      defineReadOnly(this, "privateKey", null), defineReadOnly(this, "publicKey", hexlify(ie));
    defineReadOnly(this, "parentFingerprint", fe), defineReadOnly(this, "fingerprint", hexDataSlice(ripemd160$1(sha256$6(this.publicKey)), 0, 4)), defineReadOnly(this, "address", computeAddress(this.publicKey)), defineReadOnly(this, "chainCode", ae), defineReadOnly(this, "index", le), defineReadOnly(this, "depth", he), me == null ? (defineReadOnly(this, "mnemonic", null), defineReadOnly(this, "path", null)) : typeof me == "string" ? (defineReadOnly(this, "mnemonic", null), defineReadOnly(this, "path", me)) : (defineReadOnly(this, "mnemonic", me), defineReadOnly(this, "path", me.path));
  }
  get extendedKey() {
    if (this.depth >= 256)
      throw new Error("Depth too large!");
    return base58check(concat$1([
      this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
      hexlify(this.depth),
      this.parentFingerprint,
      hexZeroPad(hexlify(this.index), 4),
      this.chainCode,
      this.privateKey != null ? concat$1(["0x00", this.privateKey]) : this.publicKey
    ]));
  }
  neuter() {
    return new HDNode(_constructorGuard$1, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
  }
  _derive(t) {
    if (t > 4294967295)
      throw new Error("invalid index - " + String(t));
    let n = this.path;
    n && (n += "/" + (t & ~HardenedBit));
    const ie = new Uint8Array(37);
    if (t & HardenedBit) {
      if (!this.privateKey)
        throw new Error("cannot derive child of neutered node");
      ie.set(arrayify(this.privateKey), 1), n && (n += "'");
    } else
      ie.set(arrayify(this.publicKey));
    for (let Ae = 24; Ae >= 0; Ae -= 8)
      ie[33 + (Ae >> 3)] = t >> 24 - Ae & 255;
    const fe = arrayify(computeHmac(SupportedAlgorithm.sha512, this.chainCode, ie)), ae = fe.slice(0, 32), le = fe.slice(32);
    let he = null, me = null;
    this.privateKey ? he = bytes32(BigNumber.from(ae).add(this.privateKey).mod(N$3)) : me = new SigningKey(hexlify(ae))._addPoint(this.publicKey);
    let ye = n;
    const be = this.mnemonic;
    return be && (ye = Object.freeze({
      phrase: be.phrase,
      path: n,
      locale: be.locale || "en"
    })), new HDNode(_constructorGuard$1, he, me, this.fingerprint, bytes32(le), t, this.depth + 1, ye);
  }
  derivePath(t) {
    const n = t.split("/");
    if (n.length === 0 || n[0] === "m" && this.depth !== 0)
      throw new Error("invalid path - " + t);
    n[0] === "m" && n.shift();
    let ie = this;
    for (let fe = 0; fe < n.length; fe++) {
      const ae = n[fe];
      if (ae.match(/^[0-9]+'$/)) {
        const le = parseInt(ae.substring(0, ae.length - 1));
        if (le >= HardenedBit)
          throw new Error("invalid path index - " + ae);
        ie = ie._derive(HardenedBit + le);
      } else if (ae.match(/^[0-9]+$/)) {
        const le = parseInt(ae);
        if (le >= HardenedBit)
          throw new Error("invalid path index - " + ae);
        ie = ie._derive(le);
      } else
        throw new Error("invalid path component - " + ae);
    }
    return ie;
  }
  static _fromSeed(t, n) {
    const ie = arrayify(t);
    if (ie.length < 16 || ie.length > 64)
      throw new Error("invalid seed");
    const fe = arrayify(computeHmac(SupportedAlgorithm.sha512, MasterSecret, ie));
    return new HDNode(_constructorGuard$1, bytes32(fe.slice(0, 32)), null, "0x00000000", bytes32(fe.slice(32)), 0, 0, n);
  }
  static fromMnemonic(t, n, ie) {
    return ie = getWordlist(ie), t = entropyToMnemonic(mnemonicToEntropy(t, ie), ie), HDNode._fromSeed(mnemonicToSeed(t, n), {
      phrase: t,
      path: "m",
      locale: ie.locale
    });
  }
  static fromSeed(t) {
    return HDNode._fromSeed(t, null);
  }
  static fromExtendedKey(t) {
    const n = Base58.decode(t);
    (n.length !== 82 || base58check(n.slice(0, 78)) !== t) && logger$c.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    const ie = n[4], fe = hexlify(n.slice(5, 9)), ae = parseInt(hexlify(n.slice(9, 13)).substring(2), 16), le = hexlify(n.slice(13, 45)), he = n.slice(45, 78);
    switch (hexlify(n.slice(0, 4))) {
      case "0x0488b21e":
      case "0x043587cf":
        return new HDNode(_constructorGuard$1, null, hexlify(he), fe, le, ae, ie, null);
      case "0x0488ade4":
      case "0x04358394 ":
        if (he[0] !== 0)
          break;
        return new HDNode(_constructorGuard$1, hexlify(he.slice(1)), null, fe, le, ae, ie, null);
    }
    return logger$c.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
  }
}
function mnemonicToSeed(c, t) {
  t || (t = "");
  const n = toUtf8Bytes("mnemonic" + t, UnicodeNormalizationForm.NFKD);
  return pbkdf2$1(toUtf8Bytes(c, UnicodeNormalizationForm.NFKD), n, 2048, 64, "sha512");
}
function mnemonicToEntropy(c, t) {
  t = getWordlist(t), logger$c.checkNormalize();
  const n = t.split(c);
  if (n.length % 3 !== 0)
    throw new Error("invalid mnemonic");
  const ie = arrayify(new Uint8Array(Math.ceil(11 * n.length / 8)));
  let fe = 0;
  for (let ye = 0; ye < n.length; ye++) {
    let be = t.getWordIndex(n[ye].normalize("NFKD"));
    if (be === -1)
      throw new Error("invalid mnemonic");
    for (let Ae = 0; Ae < 11; Ae++)
      be & 1 << 10 - Ae && (ie[fe >> 3] |= 1 << 7 - fe % 8), fe++;
  }
  const ae = 32 * n.length / 3, le = n.length / 3, he = getUpperMask(le);
  if ((arrayify(sha256$6(ie.slice(0, ae / 8)))[0] & he) !== (ie[ie.length - 1] & he))
    throw new Error("invalid checksum");
  return hexlify(ie.slice(0, ae / 8));
}
function entropyToMnemonic(c, t) {
  if (t = getWordlist(t), c = arrayify(c), c.length % 4 !== 0 || c.length < 16 || c.length > 32)
    throw new Error("invalid entropy");
  const n = [0];
  let ie = 11;
  for (let le = 0; le < c.length; le++)
    ie > 8 ? (n[n.length - 1] <<= 8, n[n.length - 1] |= c[le], ie -= 8) : (n[n.length - 1] <<= ie, n[n.length - 1] |= c[le] >> 8 - ie, n.push(c[le] & getLowerMask(8 - ie)), ie += 3);
  const fe = c.length / 4, ae = arrayify(sha256$6(c))[0] & getUpperMask(fe);
  return n[n.length - 1] <<= fe, n[n.length - 1] |= ae >> 8 - fe, t.join(n.map((le) => t.getWord(le)));
}
function isValidMnemonic(c, t) {
  try {
    return mnemonicToEntropy(c, t), !0;
  } catch {
  }
  return !1;
}
function getAccountPath(c) {
  return (typeof c != "number" || c < 0 || c >= HardenedBit || c % 1) && logger$c.throwArgumentError("invalid account index", "index", c), `m/44'/60'/${c}'/0/0`;
}
const lib_esm$6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HDNode,
  defaultPath,
  entropyToMnemonic,
  getAccountPath,
  isValidMnemonic,
  mnemonicToEntropy,
  mnemonicToSeed
}, Symbol.toStringTag, { value: "Module" })), version$e = "random/5.7.0", logger$b = new Logger(version$e);
function getGlobal() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof globalThis < "u")
    return globalThis;
  throw new Error("unable to locate global object");
}
const anyGlobal = getGlobal();
let crypto$3 = anyGlobal.crypto || anyGlobal.msCrypto;
(!crypto$3 || !crypto$3.getRandomValues) && (logger$b.warn("WARNING: Missing strong random number source"), crypto$3 = {
  getRandomValues: function(c) {
    return logger$b.throwError("no secure random source avaialble", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "crypto.getRandomValues"
    });
  }
});
function randomBytes$1(c) {
  (c <= 0 || c > 1024 || c % 1 || c != c) && logger$b.throwArgumentError("invalid length", "length", c);
  const t = new Uint8Array(c);
  return crypto$3.getRandomValues(t), arrayify(t);
}
function shuffled(c) {
  c = c.slice();
  for (let t = c.length - 1; t > 0; t--) {
    const n = Math.floor(Math.random() * (t + 1)), ie = c[t];
    c[t] = c[n], c[n] = ie;
  }
  return c;
}
const lib_esm$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  randomBytes: randomBytes$1,
  shuffled
}, Symbol.toStringTag, { value: "Module" }));
var aesJs = { exports: {} };
(function(c, t) {
  (function(n) {
    function ie(ge) {
      return parseInt(ge) === ge;
    }
    function fe(ge) {
      if (!ie(ge.length))
        return !1;
      for (var Be = 0; Be < ge.length; Be++)
        if (!ie(ge[Be]) || ge[Be] < 0 || ge[Be] > 255)
          return !1;
      return !0;
    }
    function ae(ge, Be) {
      if (ge.buffer && ArrayBuffer.isView(ge) && ge.name === "Uint8Array")
        return Be && (ge.slice ? ge = ge.slice() : ge = Array.prototype.slice.call(ge)), ge;
      if (Array.isArray(ge)) {
        if (!fe(ge))
          throw new Error("Array contains invalid value: " + ge);
        return new Uint8Array(ge);
      }
      if (ie(ge.length) && fe(ge))
        return new Uint8Array(ge);
      throw new Error("unsupported array-like object");
    }
    function le(ge) {
      return new Uint8Array(ge);
    }
    function he(ge, Be, Ne, Fe, Pe) {
      (Fe != null || Pe != null) && (ge.slice ? ge = ge.slice(Fe, Pe) : ge = Array.prototype.slice.call(ge, Fe, Pe)), Be.set(ge, Ne);
    }
    var me = /* @__PURE__ */ function() {
      function ge(Ne) {
        var Fe = [], Pe = 0;
        for (Ne = encodeURI(Ne); Pe < Ne.length; ) {
          var Je = Ne.charCodeAt(Pe++);
          Je === 37 ? (Fe.push(parseInt(Ne.substr(Pe, 2), 16)), Pe += 2) : Fe.push(Je);
        }
        return ae(Fe);
      }
      function Be(Ne) {
        for (var Fe = [], Pe = 0; Pe < Ne.length; ) {
          var Je = Ne[Pe];
          Je < 128 ? (Fe.push(String.fromCharCode(Je)), Pe++) : Je > 191 && Je < 224 ? (Fe.push(String.fromCharCode((Je & 31) << 6 | Ne[Pe + 1] & 63)), Pe += 2) : (Fe.push(String.fromCharCode((Je & 15) << 12 | (Ne[Pe + 1] & 63) << 6 | Ne[Pe + 2] & 63)), Pe += 3);
        }
        return Fe.join("");
      }
      return {
        toBytes: ge,
        fromBytes: Be
      };
    }(), ye = /* @__PURE__ */ function() {
      function ge(Fe) {
        for (var Pe = [], Je = 0; Je < Fe.length; Je += 2)
          Pe.push(parseInt(Fe.substr(Je, 2), 16));
        return Pe;
      }
      var Be = "0123456789abcdef";
      function Ne(Fe) {
        for (var Pe = [], Je = 0; Je < Fe.length; Je++) {
          var Ke = Fe[Je];
          Pe.push(Be[(Ke & 240) >> 4] + Be[Ke & 15]);
        }
        return Pe.join("");
      }
      return {
        toBytes: ge,
        fromBytes: Ne
      };
    }(), be = { 16: 10, 24: 12, 32: 14 }, Ae = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], Se = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], $e = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], Re = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], Me = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], ke = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], Te = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], Ie = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], qe = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], Ue = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], ze = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], Ve = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], Mt = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], Rt = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], je = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
    function jt(ge) {
      for (var Be = [], Ne = 0; Ne < ge.length; Ne += 4)
        Be.push(
          ge[Ne] << 24 | ge[Ne + 1] << 16 | ge[Ne + 2] << 8 | ge[Ne + 3]
        );
      return Be;
    }
    var _e = function(ge) {
      if (!(this instanceof _e))
        throw Error("AES must be instanitated with `new`");
      Object.defineProperty(this, "key", {
        value: ae(ge, !0)
      }), this._prepare();
    };
    _e.prototype._prepare = function() {
      var ge = be[this.key.length];
      if (ge == null)
        throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
      this._Ke = [], this._Kd = [];
      for (var Be = 0; Be <= ge; Be++)
        this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
      for (var Ne = (ge + 1) * 4, Fe = this.key.length / 4, Pe = jt(this.key), Je, Be = 0; Be < Fe; Be++)
        Je = Be >> 2, this._Ke[Je][Be % 4] = Pe[Be], this._Kd[ge - Je][Be % 4] = Pe[Be];
      for (var Ke = 0, Ze = Fe, Ye; Ze < Ne; ) {
        if (Ye = Pe[Fe - 1], Pe[0] ^= Se[Ye >> 16 & 255] << 24 ^ Se[Ye >> 8 & 255] << 16 ^ Se[Ye & 255] << 8 ^ Se[Ye >> 24 & 255] ^ Ae[Ke] << 24, Ke += 1, Fe != 8)
          for (var Be = 1; Be < Fe; Be++)
            Pe[Be] ^= Pe[Be - 1];
        else {
          for (var Be = 1; Be < Fe / 2; Be++)
            Pe[Be] ^= Pe[Be - 1];
          Ye = Pe[Fe / 2 - 1], Pe[Fe / 2] ^= Se[Ye & 255] ^ Se[Ye >> 8 & 255] << 8 ^ Se[Ye >> 16 & 255] << 16 ^ Se[Ye >> 24 & 255] << 24;
          for (var Be = Fe / 2 + 1; Be < Fe; Be++)
            Pe[Be] ^= Pe[Be - 1];
        }
        for (var Be = 0, Pt, Ft; Be < Fe && Ze < Ne; )
          Pt = Ze >> 2, Ft = Ze % 4, this._Ke[Pt][Ft] = Pe[Be], this._Kd[ge - Pt][Ft] = Pe[Be++], Ze++;
      }
      for (var Pt = 1; Pt < ge; Pt++)
        for (var Ft = 0; Ft < 4; Ft++)
          Ye = this._Kd[Pt][Ft], this._Kd[Pt][Ft] = Ve[Ye >> 24 & 255] ^ Mt[Ye >> 16 & 255] ^ Rt[Ye >> 8 & 255] ^ je[Ye & 255];
    }, _e.prototype.encrypt = function(ge) {
      if (ge.length != 16)
        throw new Error("invalid plaintext size (must be 16 bytes)");
      for (var Be = this._Ke.length - 1, Ne = [0, 0, 0, 0], Fe = jt(ge), Pe = 0; Pe < 4; Pe++)
        Fe[Pe] ^= this._Ke[0][Pe];
      for (var Je = 1; Je < Be; Je++) {
        for (var Pe = 0; Pe < 4; Pe++)
          Ne[Pe] = Re[Fe[Pe] >> 24 & 255] ^ Me[Fe[(Pe + 1) % 4] >> 16 & 255] ^ ke[Fe[(Pe + 2) % 4] >> 8 & 255] ^ Te[Fe[(Pe + 3) % 4] & 255] ^ this._Ke[Je][Pe];
        Fe = Ne.slice();
      }
      for (var Ke = le(16), Ze, Pe = 0; Pe < 4; Pe++)
        Ze = this._Ke[Be][Pe], Ke[4 * Pe] = (Se[Fe[Pe] >> 24 & 255] ^ Ze >> 24) & 255, Ke[4 * Pe + 1] = (Se[Fe[(Pe + 1) % 4] >> 16 & 255] ^ Ze >> 16) & 255, Ke[4 * Pe + 2] = (Se[Fe[(Pe + 2) % 4] >> 8 & 255] ^ Ze >> 8) & 255, Ke[4 * Pe + 3] = (Se[Fe[(Pe + 3) % 4] & 255] ^ Ze) & 255;
      return Ke;
    }, _e.prototype.decrypt = function(ge) {
      if (ge.length != 16)
        throw new Error("invalid ciphertext size (must be 16 bytes)");
      for (var Be = this._Kd.length - 1, Ne = [0, 0, 0, 0], Fe = jt(ge), Pe = 0; Pe < 4; Pe++)
        Fe[Pe] ^= this._Kd[0][Pe];
      for (var Je = 1; Je < Be; Je++) {
        for (var Pe = 0; Pe < 4; Pe++)
          Ne[Pe] = Ie[Fe[Pe] >> 24 & 255] ^ qe[Fe[(Pe + 3) % 4] >> 16 & 255] ^ Ue[Fe[(Pe + 2) % 4] >> 8 & 255] ^ ze[Fe[(Pe + 1) % 4] & 255] ^ this._Kd[Je][Pe];
        Fe = Ne.slice();
      }
      for (var Ke = le(16), Ze, Pe = 0; Pe < 4; Pe++)
        Ze = this._Kd[Be][Pe], Ke[4 * Pe] = ($e[Fe[Pe] >> 24 & 255] ^ Ze >> 24) & 255, Ke[4 * Pe + 1] = ($e[Fe[(Pe + 3) % 4] >> 16 & 255] ^ Ze >> 16) & 255, Ke[4 * Pe + 2] = ($e[Fe[(Pe + 2) % 4] >> 8 & 255] ^ Ze >> 8) & 255, Ke[4 * Pe + 3] = ($e[Fe[(Pe + 1) % 4] & 255] ^ Ze) & 255;
      return Ke;
    };
    var se = function(ge) {
      if (!(this instanceof se))
        throw Error("AES must be instanitated with `new`");
      this.description = "Electronic Code Block", this.name = "ecb", this._aes = new _e(ge);
    };
    se.prototype.encrypt = function(ge) {
      if (ge = ae(ge), ge.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var Be = le(ge.length), Ne = le(16), Fe = 0; Fe < ge.length; Fe += 16)
        he(ge, Ne, 0, Fe, Fe + 16), Ne = this._aes.encrypt(Ne), he(Ne, Be, Fe);
      return Be;
    }, se.prototype.decrypt = function(ge) {
      if (ge = ae(ge), ge.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var Be = le(ge.length), Ne = le(16), Fe = 0; Fe < ge.length; Fe += 16)
        he(ge, Ne, 0, Fe, Fe + 16), Ne = this._aes.decrypt(Ne), he(Ne, Be, Fe);
      return Be;
    };
    var ce = function(ge, Be) {
      if (!(this instanceof ce))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Block Chaining", this.name = "cbc", !Be)
        Be = le(16);
      else if (Be.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastCipherblock = ae(Be, !0), this._aes = new _e(ge);
    };
    ce.prototype.encrypt = function(ge) {
      if (ge = ae(ge), ge.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var Be = le(ge.length), Ne = le(16), Fe = 0; Fe < ge.length; Fe += 16) {
        he(ge, Ne, 0, Fe, Fe + 16);
        for (var Pe = 0; Pe < 16; Pe++)
          Ne[Pe] ^= this._lastCipherblock[Pe];
        this._lastCipherblock = this._aes.encrypt(Ne), he(this._lastCipherblock, Be, Fe);
      }
      return Be;
    }, ce.prototype.decrypt = function(ge) {
      if (ge = ae(ge), ge.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var Be = le(ge.length), Ne = le(16), Fe = 0; Fe < ge.length; Fe += 16) {
        he(ge, Ne, 0, Fe, Fe + 16), Ne = this._aes.decrypt(Ne);
        for (var Pe = 0; Pe < 16; Pe++)
          Be[Fe + Pe] = Ne[Pe] ^ this._lastCipherblock[Pe];
        he(ge, this._lastCipherblock, 0, Fe, Fe + 16);
      }
      return Be;
    };
    var de = function(ge, Be, Ne) {
      if (!(this instanceof de))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Feedback", this.name = "cfb", !Be)
        Be = le(16);
      else if (Be.length != 16)
        throw new Error("invalid initialation vector size (must be 16 size)");
      Ne || (Ne = 1), this.segmentSize = Ne, this._shiftRegister = ae(Be, !0), this._aes = new _e(ge);
    };
    de.prototype.encrypt = function(ge) {
      if (ge.length % this.segmentSize != 0)
        throw new Error("invalid plaintext size (must be segmentSize bytes)");
      for (var Be = ae(ge, !0), Ne, Fe = 0; Fe < Be.length; Fe += this.segmentSize) {
        Ne = this._aes.encrypt(this._shiftRegister);
        for (var Pe = 0; Pe < this.segmentSize; Pe++)
          Be[Fe + Pe] ^= Ne[Pe];
        he(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), he(Be, this._shiftRegister, 16 - this.segmentSize, Fe, Fe + this.segmentSize);
      }
      return Be;
    }, de.prototype.decrypt = function(ge) {
      if (ge.length % this.segmentSize != 0)
        throw new Error("invalid ciphertext size (must be segmentSize bytes)");
      for (var Be = ae(ge, !0), Ne, Fe = 0; Fe < Be.length; Fe += this.segmentSize) {
        Ne = this._aes.encrypt(this._shiftRegister);
        for (var Pe = 0; Pe < this.segmentSize; Pe++)
          Be[Fe + Pe] ^= Ne[Pe];
        he(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), he(ge, this._shiftRegister, 16 - this.segmentSize, Fe, Fe + this.segmentSize);
      }
      return Be;
    };
    var pe = function(ge, Be) {
      if (!(this instanceof pe))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Output Feedback", this.name = "ofb", !Be)
        Be = le(16);
      else if (Be.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastPrecipher = ae(Be, !0), this._lastPrecipherIndex = 16, this._aes = new _e(ge);
    };
    pe.prototype.encrypt = function(ge) {
      for (var Be = ae(ge, !0), Ne = 0; Ne < Be.length; Ne++)
        this._lastPrecipherIndex === 16 && (this._lastPrecipher = this._aes.encrypt(this._lastPrecipher), this._lastPrecipherIndex = 0), Be[Ne] ^= this._lastPrecipher[this._lastPrecipherIndex++];
      return Be;
    }, pe.prototype.decrypt = pe.prototype.encrypt;
    var ve = function(ge) {
      if (!(this instanceof ve))
        throw Error("Counter must be instanitated with `new`");
      ge !== 0 && !ge && (ge = 1), typeof ge == "number" ? (this._counter = le(16), this.setValue(ge)) : this.setBytes(ge);
    };
    ve.prototype.setValue = function(ge) {
      if (typeof ge != "number" || parseInt(ge) != ge)
        throw new Error("invalid counter value (must be an integer)");
      for (var Be = 15; Be >= 0; --Be)
        this._counter[Be] = ge % 256, ge = ge >> 8;
    }, ve.prototype.setBytes = function(ge) {
      if (ge = ae(ge, !0), ge.length != 16)
        throw new Error("invalid counter bytes size (must be 16 bytes)");
      this._counter = ge;
    }, ve.prototype.increment = function() {
      for (var ge = 15; ge >= 0; ge--)
        if (this._counter[ge] === 255)
          this._counter[ge] = 0;
        else {
          this._counter[ge]++;
          break;
        }
    };
    var we = function(ge, Be) {
      if (!(this instanceof we))
        throw Error("AES must be instanitated with `new`");
      this.description = "Counter", this.name = "ctr", Be instanceof ve || (Be = new ve(Be)), this._counter = Be, this._remainingCounter = null, this._remainingCounterIndex = 16, this._aes = new _e(ge);
    };
    we.prototype.encrypt = function(ge) {
      for (var Be = ae(ge, !0), Ne = 0; Ne < Be.length; Ne++)
        this._remainingCounterIndex === 16 && (this._remainingCounter = this._aes.encrypt(this._counter._counter), this._remainingCounterIndex = 0, this._counter.increment()), Be[Ne] ^= this._remainingCounter[this._remainingCounterIndex++];
      return Be;
    }, we.prototype.decrypt = we.prototype.encrypt;
    function Ee(ge) {
      ge = ae(ge, !0);
      var Be = 16 - ge.length % 16, Ne = le(ge.length + Be);
      he(ge, Ne);
      for (var Fe = ge.length; Fe < Ne.length; Fe++)
        Ne[Fe] = Be;
      return Ne;
    }
    function xe(ge) {
      if (ge = ae(ge, !0), ge.length < 16)
        throw new Error("PKCS#7 invalid length");
      var Be = ge[ge.length - 1];
      if (Be > 16)
        throw new Error("PKCS#7 padding byte out of range");
      for (var Ne = ge.length - Be, Fe = 0; Fe < Be; Fe++)
        if (ge[Ne + Fe] !== Be)
          throw new Error("PKCS#7 invalid padding byte");
      var Pe = le(Ne);
      return he(ge, Pe, 0, 0, Ne), Pe;
    }
    var ue = {
      AES: _e,
      Counter: ve,
      ModeOfOperation: {
        ecb: se,
        cbc: ce,
        cfb: de,
        ofb: pe,
        ctr: we
      },
      utils: {
        hex: ye,
        utf8: me
      },
      padding: {
        pkcs7: {
          pad: Ee,
          strip: xe
        }
      },
      _arrayTest: {
        coerceArray: ae,
        createArray: le,
        copyArray: he
      }
    };
    c.exports = ue;
  })();
})(aesJs);
var aesJsExports = aesJs.exports;
const aes$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(aesJsExports), version$d = "json-wallets/5.7.0";
function looseArrayify(c) {
  return typeof c == "string" && c.substring(0, 2) !== "0x" && (c = "0x" + c), arrayify(c);
}
function zpad(c, t) {
  for (c = String(c); c.length < t; )
    c = "0" + c;
  return c;
}
function getPassword(c) {
  return typeof c == "string" ? toUtf8Bytes(c, UnicodeNormalizationForm.NFKC) : arrayify(c);
}
function searchPath(c, t) {
  let n = c;
  const ie = t.toLowerCase().split("/");
  for (let fe = 0; fe < ie.length; fe++) {
    let ae = null;
    for (const le in n)
      if (le.toLowerCase() === ie[fe]) {
        ae = n[le];
        break;
      }
    if (ae === null)
      return null;
    n = ae;
  }
  return n;
}
function uuidV4(c) {
  const t = arrayify(c);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const n = hexlify(t);
  return [
    n.substring(2, 10),
    n.substring(10, 14),
    n.substring(14, 18),
    n.substring(18, 22),
    n.substring(22, 34)
  ].join("-");
}
const logger$a = new Logger(version$d);
class CrowdsaleAccount extends Description {
  isCrowdsaleAccount(t) {
    return !!(t && t._isCrowdsaleAccount);
  }
}
function decrypt$1(c, t) {
  const n = JSON.parse(c);
  t = getPassword(t);
  const ie = getAddress(searchPath(n, "ethaddr")), fe = looseArrayify(searchPath(n, "encseed"));
  (!fe || fe.length % 16 !== 0) && logger$a.throwArgumentError("invalid encseed", "json", c);
  const ae = arrayify(pbkdf2$1(t, t, 2e3, 32, "sha256")).slice(0, 16), le = fe.slice(0, 16), he = fe.slice(16), me = new aes$1.ModeOfOperation.cbc(ae, le), ye = aes$1.padding.pkcs7.strip(arrayify(me.decrypt(he)));
  let be = "";
  for (let $e = 0; $e < ye.length; $e++)
    be += String.fromCharCode(ye[$e]);
  const Ae = toUtf8Bytes(be), Se = keccak256$1(Ae);
  return new CrowdsaleAccount({
    _isCrowdsaleAccount: !0,
    address: ie,
    privateKey: Se
  });
}
function isCrowdsaleWallet(c) {
  let t = null;
  try {
    t = JSON.parse(c);
  } catch {
    return !1;
  }
  return t.encseed && t.ethaddr;
}
function isKeystoreWallet(c) {
  let t = null;
  try {
    t = JSON.parse(c);
  } catch {
    return !1;
  }
  return !(!t.version || parseInt(t.version) !== t.version || parseInt(t.version) !== 3);
}
function getJsonWalletAddress(c) {
  if (isCrowdsaleWallet(c))
    try {
      return getAddress(JSON.parse(c).ethaddr);
    } catch {
      return null;
    }
  if (isKeystoreWallet(c))
    try {
      return getAddress(JSON.parse(c).address);
    } catch {
      return null;
    }
  return null;
}
var scrypt$1 = { exports: {} };
(function(c, t) {
  (function(n) {
    function fe(Me) {
      const ke = new Uint32Array([
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
      ]);
      let Te = 1779033703, Ie = 3144134277, qe = 1013904242, Ue = 2773480762, ze = 1359893119, Ve = 2600822924, Mt = 528734635, Rt = 1541459225;
      const je = new Uint32Array(64);
      function jt(we) {
        let Ee = 0, xe = we.length;
        for (; xe >= 64; ) {
          let ue = Te, ge = Ie, Be = qe, Ne = Ue, Fe = ze, Pe = Ve, Je = Mt, Ke = Rt, Ze, Ye, Pt, Ft, Le;
          for (Ye = 0; Ye < 16; Ye++)
            Pt = Ee + Ye * 4, je[Ye] = (we[Pt] & 255) << 24 | (we[Pt + 1] & 255) << 16 | (we[Pt + 2] & 255) << 8 | we[Pt + 3] & 255;
          for (Ye = 16; Ye < 64; Ye++)
            Ze = je[Ye - 2], Ft = (Ze >>> 17 | Ze << 15) ^ (Ze >>> 19 | Ze << 13) ^ Ze >>> 10, Ze = je[Ye - 15], Le = (Ze >>> 7 | Ze << 25) ^ (Ze >>> 18 | Ze << 14) ^ Ze >>> 3, je[Ye] = (Ft + je[Ye - 7] | 0) + (Le + je[Ye - 16] | 0) | 0;
          for (Ye = 0; Ye < 64; Ye++)
            Ft = (((Fe >>> 6 | Fe << 26) ^ (Fe >>> 11 | Fe << 21) ^ (Fe >>> 25 | Fe << 7)) + (Fe & Pe ^ ~Fe & Je) | 0) + (Ke + (ke[Ye] + je[Ye] | 0) | 0) | 0, Le = ((ue >>> 2 | ue << 30) ^ (ue >>> 13 | ue << 19) ^ (ue >>> 22 | ue << 10)) + (ue & ge ^ ue & Be ^ ge & Be) | 0, Ke = Je, Je = Pe, Pe = Fe, Fe = Ne + Ft | 0, Ne = Be, Be = ge, ge = ue, ue = Ft + Le | 0;
          Te = Te + ue | 0, Ie = Ie + ge | 0, qe = qe + Be | 0, Ue = Ue + Ne | 0, ze = ze + Fe | 0, Ve = Ve + Pe | 0, Mt = Mt + Je | 0, Rt = Rt + Ke | 0, Ee += 64, xe -= 64;
        }
      }
      jt(Me);
      let _e, se = Me.length % 64, ce = Me.length / 536870912 | 0, de = Me.length << 3, pe = se < 56 ? 56 : 120, ve = Me.slice(Me.length - se, Me.length);
      for (ve.push(128), _e = se + 1; _e < pe; _e++)
        ve.push(0);
      return ve.push(ce >>> 24 & 255), ve.push(ce >>> 16 & 255), ve.push(ce >>> 8 & 255), ve.push(ce >>> 0 & 255), ve.push(de >>> 24 & 255), ve.push(de >>> 16 & 255), ve.push(de >>> 8 & 255), ve.push(de >>> 0 & 255), jt(ve), [
        Te >>> 24 & 255,
        Te >>> 16 & 255,
        Te >>> 8 & 255,
        Te >>> 0 & 255,
        Ie >>> 24 & 255,
        Ie >>> 16 & 255,
        Ie >>> 8 & 255,
        Ie >>> 0 & 255,
        qe >>> 24 & 255,
        qe >>> 16 & 255,
        qe >>> 8 & 255,
        qe >>> 0 & 255,
        Ue >>> 24 & 255,
        Ue >>> 16 & 255,
        Ue >>> 8 & 255,
        Ue >>> 0 & 255,
        ze >>> 24 & 255,
        ze >>> 16 & 255,
        ze >>> 8 & 255,
        ze >>> 0 & 255,
        Ve >>> 24 & 255,
        Ve >>> 16 & 255,
        Ve >>> 8 & 255,
        Ve >>> 0 & 255,
        Mt >>> 24 & 255,
        Mt >>> 16 & 255,
        Mt >>> 8 & 255,
        Mt >>> 0 & 255,
        Rt >>> 24 & 255,
        Rt >>> 16 & 255,
        Rt >>> 8 & 255,
        Rt >>> 0 & 255
      ];
    }
    function ae(Me, ke, Te) {
      Me = Me.length <= 64 ? Me : fe(Me);
      const Ie = 64 + ke.length + 4, qe = new Array(Ie), Ue = new Array(64);
      let ze, Ve = [];
      for (ze = 0; ze < 64; ze++)
        qe[ze] = 54;
      for (ze = 0; ze < Me.length; ze++)
        qe[ze] ^= Me[ze];
      for (ze = 0; ze < ke.length; ze++)
        qe[64 + ze] = ke[ze];
      for (ze = Ie - 4; ze < Ie; ze++)
        qe[ze] = 0;
      for (ze = 0; ze < 64; ze++) Ue[ze] = 92;
      for (ze = 0; ze < Me.length; ze++) Ue[ze] ^= Me[ze];
      function Mt() {
        for (let Rt = Ie - 1; Rt >= Ie - 4; Rt--) {
          if (qe[Rt]++, qe[Rt] <= 255) return;
          qe[Rt] = 0;
        }
      }
      for (; Te >= 32; )
        Mt(), Ve = Ve.concat(fe(Ue.concat(fe(qe)))), Te -= 32;
      return Te > 0 && (Mt(), Ve = Ve.concat(fe(Ue.concat(fe(qe))).slice(0, Te))), Ve;
    }
    function le(Me, ke, Te, Ie, qe) {
      let Ue;
      for (be(Me, (2 * Te - 1) * 16, qe, 0, 16), Ue = 0; Ue < 2 * Te; Ue++)
        ye(Me, Ue * 16, qe, 16), me(qe, Ie), be(qe, 0, Me, ke + Ue * 16, 16);
      for (Ue = 0; Ue < Te; Ue++)
        be(Me, ke + Ue * 2 * 16, Me, Ue * 16, 16);
      for (Ue = 0; Ue < Te; Ue++)
        be(Me, ke + (Ue * 2 + 1) * 16, Me, (Ue + Te) * 16, 16);
    }
    function he(Me, ke) {
      return Me << ke | Me >>> 32 - ke;
    }
    function me(Me, ke) {
      be(Me, 0, ke, 0, 16);
      for (let Te = 8; Te > 0; Te -= 2)
        ke[4] ^= he(ke[0] + ke[12], 7), ke[8] ^= he(ke[4] + ke[0], 9), ke[12] ^= he(ke[8] + ke[4], 13), ke[0] ^= he(ke[12] + ke[8], 18), ke[9] ^= he(ke[5] + ke[1], 7), ke[13] ^= he(ke[9] + ke[5], 9), ke[1] ^= he(ke[13] + ke[9], 13), ke[5] ^= he(ke[1] + ke[13], 18), ke[14] ^= he(ke[10] + ke[6], 7), ke[2] ^= he(ke[14] + ke[10], 9), ke[6] ^= he(ke[2] + ke[14], 13), ke[10] ^= he(ke[6] + ke[2], 18), ke[3] ^= he(ke[15] + ke[11], 7), ke[7] ^= he(ke[3] + ke[15], 9), ke[11] ^= he(ke[7] + ke[3], 13), ke[15] ^= he(ke[11] + ke[7], 18), ke[1] ^= he(ke[0] + ke[3], 7), ke[2] ^= he(ke[1] + ke[0], 9), ke[3] ^= he(ke[2] + ke[1], 13), ke[0] ^= he(ke[3] + ke[2], 18), ke[6] ^= he(ke[5] + ke[4], 7), ke[7] ^= he(ke[6] + ke[5], 9), ke[4] ^= he(ke[7] + ke[6], 13), ke[5] ^= he(ke[4] + ke[7], 18), ke[11] ^= he(ke[10] + ke[9], 7), ke[8] ^= he(ke[11] + ke[10], 9), ke[9] ^= he(ke[8] + ke[11], 13), ke[10] ^= he(ke[9] + ke[8], 18), ke[12] ^= he(ke[15] + ke[14], 7), ke[13] ^= he(ke[12] + ke[15], 9), ke[14] ^= he(ke[13] + ke[12], 13), ke[15] ^= he(ke[14] + ke[13], 18);
      for (let Te = 0; Te < 16; ++Te)
        Me[Te] += ke[Te];
    }
    function ye(Me, ke, Te, Ie) {
      for (let qe = 0; qe < Ie; qe++)
        Te[qe] ^= Me[ke + qe];
    }
    function be(Me, ke, Te, Ie, qe) {
      for (; qe--; )
        Te[Ie++] = Me[ke++];
    }
    function Ae(Me) {
      if (!Me || typeof Me.length != "number")
        return !1;
      for (let ke = 0; ke < Me.length; ke++) {
        const Te = Me[ke];
        if (typeof Te != "number" || Te % 1 || Te < 0 || Te >= 256)
          return !1;
      }
      return !0;
    }
    function Se(Me, ke) {
      if (typeof Me != "number" || Me % 1)
        throw new Error("invalid " + ke);
      return Me;
    }
    function $e(Me, ke, Te, Ie, qe, Ue, ze) {
      if (Te = Se(Te, "N"), Ie = Se(Ie, "r"), qe = Se(qe, "p"), Ue = Se(Ue, "dkLen"), Te === 0 || Te & Te - 1)
        throw new Error("N must be power of 2");
      if (Te > 2147483647 / 128 / Ie)
        throw new Error("N too large");
      if (Ie > 2147483647 / 128 / qe)
        throw new Error("r too large");
      if (!Ae(Me))
        throw new Error("password must be an array or buffer");
      if (Me = Array.prototype.slice.call(Me), !Ae(ke))
        throw new Error("salt must be an array or buffer");
      ke = Array.prototype.slice.call(ke);
      let Ve = ae(Me, ke, qe * 128 * Ie);
      const Mt = new Uint32Array(qe * 32 * Ie);
      for (let Fe = 0; Fe < Mt.length; Fe++) {
        const Pe = Fe * 4;
        Mt[Fe] = (Ve[Pe + 3] & 255) << 24 | (Ve[Pe + 2] & 255) << 16 | (Ve[Pe + 1] & 255) << 8 | (Ve[Pe + 0] & 255) << 0;
      }
      const Rt = new Uint32Array(64 * Ie), je = new Uint32Array(32 * Ie * Te), jt = 32 * Ie, _e = new Uint32Array(16), se = new Uint32Array(16), ce = qe * Te * 2;
      let de = 0, pe = null, ve = !1, we = 0, Ee = 0, xe, ue;
      const ge = ze ? parseInt(1e3 / Ie) : 4294967295, Be = typeof setImmediate < "u" ? setImmediate : setTimeout, Ne = function() {
        if (ve)
          return ze(new Error("cancelled"), de / ce);
        let Fe;
        switch (we) {
          case 0:
            ue = Ee * 32 * Ie, be(Mt, ue, Rt, 0, jt), we = 1, xe = 0;
          case 1:
            Fe = Te - xe, Fe > ge && (Fe = ge);
            for (let Je = 0; Je < Fe; Je++)
              be(Rt, 0, je, (xe + Je) * jt, jt), le(Rt, jt, Ie, _e, se);
            if (xe += Fe, de += Fe, ze) {
              const Je = parseInt(1e3 * de / ce);
              if (Je !== pe) {
                if (ve = ze(null, de / ce), ve)
                  break;
                pe = Je;
              }
            }
            if (xe < Te)
              break;
            xe = 0, we = 2;
          case 2:
            Fe = Te - xe, Fe > ge && (Fe = ge);
            for (let Je = 0; Je < Fe; Je++) {
              const Ke = (2 * Ie - 1) * 16, Ze = Rt[Ke] & Te - 1;
              ye(je, Ze * jt, Rt, jt), le(Rt, jt, Ie, _e, se);
            }
            if (xe += Fe, de += Fe, ze) {
              const Je = parseInt(1e3 * de / ce);
              if (Je !== pe) {
                if (ve = ze(null, de / ce), ve)
                  break;
                pe = Je;
              }
            }
            if (xe < Te)
              break;
            if (be(Rt, 0, Mt, ue, jt), Ee++, Ee < qe) {
              we = 0;
              break;
            }
            Ve = [];
            for (let Je = 0; Je < Mt.length; Je++)
              Ve.push(Mt[Je] >> 0 & 255), Ve.push(Mt[Je] >> 8 & 255), Ve.push(Mt[Je] >> 16 & 255), Ve.push(Mt[Je] >> 24 & 255);
            const Pe = ae(Me, Ve, Ue);
            return ze && ze(null, 1, Pe), Pe;
        }
        ze && Be(Ne);
      };
      if (!ze)
        for (; ; ) {
          const Fe = Ne();
          if (Fe != null)
            return Fe;
        }
      Ne();
    }
    const Re = {
      scrypt: function(Me, ke, Te, Ie, qe, Ue, ze) {
        return new Promise(function(Ve, Mt) {
          let Rt = 0;
          ze && ze(0), $e(Me, ke, Te, Ie, qe, Ue, function(je, jt, _e) {
            if (je)
              Mt(je);
            else if (_e)
              ze && Rt !== 1 && ze(1), Ve(new Uint8Array(_e));
            else if (ze && jt !== Rt)
              return Rt = jt, ze(jt);
          });
        });
      },
      syncScrypt: function(Me, ke, Te, Ie, qe, Ue) {
        return new Uint8Array($e(Me, ke, Te, Ie, qe, Ue));
      }
    };
    c.exports = Re;
  })();
})(scrypt$1);
var scryptExports = scrypt$1.exports;
const scrypt = /* @__PURE__ */ getDefaultExportFromCjs$2(scryptExports);
var __awaiter$g = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$9 = new Logger(version$d);
function hasMnemonic$1(c) {
  return c != null && c.mnemonic && c.mnemonic.phrase;
}
class KeystoreAccount extends Description {
  isKeystoreAccount(t) {
    return !!(t && t._isKeystoreAccount);
  }
}
function _decrypt(c, t, n) {
  if (searchPath(c, "crypto/cipher") === "aes-128-ctr") {
    const fe = looseArrayify(searchPath(c, "crypto/cipherparams/iv")), ae = new aes$1.Counter(fe), le = new aes$1.ModeOfOperation.ctr(t, ae);
    return arrayify(le.decrypt(n));
  }
  return null;
}
function _getAccount(c, t) {
  const n = looseArrayify(searchPath(c, "crypto/ciphertext"));
  if (hexlify(keccak256$1(concat$1([t.slice(16, 32), n]))).substring(2) !== searchPath(c, "crypto/mac").toLowerCase())
    throw new Error("invalid password");
  const fe = _decrypt(c, t.slice(0, 16), n);
  fe || logger$9.throwError("unsupported cipher", Logger.errors.UNSUPPORTED_OPERATION, {
    operation: "decrypt"
  });
  const ae = t.slice(32, 64), le = computeAddress(fe);
  if (c.address) {
    let me = c.address.toLowerCase();
    if (me.substring(0, 2) !== "0x" && (me = "0x" + me), getAddress(me) !== le)
      throw new Error("address mismatch");
  }
  const he = {
    _isKeystoreAccount: !0,
    address: le,
    privateKey: hexlify(fe)
  };
  if (searchPath(c, "x-ethers/version") === "0.1") {
    const me = looseArrayify(searchPath(c, "x-ethers/mnemonicCiphertext")), ye = looseArrayify(searchPath(c, "x-ethers/mnemonicCounter")), be = new aes$1.Counter(ye), Ae = new aes$1.ModeOfOperation.ctr(ae, be), Se = searchPath(c, "x-ethers/path") || defaultPath, $e = searchPath(c, "x-ethers/locale") || "en", Re = arrayify(Ae.decrypt(me));
    try {
      const Me = entropyToMnemonic(Re, $e), ke = HDNode.fromMnemonic(Me, null, $e).derivePath(Se);
      if (ke.privateKey != he.privateKey)
        throw new Error("mnemonic mismatch");
      he.mnemonic = ke.mnemonic;
    } catch (Me) {
      if (Me.code !== Logger.errors.INVALID_ARGUMENT || Me.argument !== "wordlist")
        throw Me;
    }
  }
  return new KeystoreAccount(he);
}
function pbkdf2Sync(c, t, n, ie, fe) {
  return arrayify(pbkdf2$1(c, t, n, ie, fe));
}
function pbkdf2(c, t, n, ie, fe) {
  return Promise.resolve(pbkdf2Sync(c, t, n, ie, fe));
}
function _computeKdfKey(c, t, n, ie, fe) {
  const ae = getPassword(t), le = searchPath(c, "crypto/kdf");
  if (le && typeof le == "string") {
    const he = function(me, ye) {
      return logger$9.throwArgumentError("invalid key-derivation function parameters", me, ye);
    };
    if (le.toLowerCase() === "scrypt") {
      const me = looseArrayify(searchPath(c, "crypto/kdfparams/salt")), ye = parseInt(searchPath(c, "crypto/kdfparams/n")), be = parseInt(searchPath(c, "crypto/kdfparams/r")), Ae = parseInt(searchPath(c, "crypto/kdfparams/p"));
      (!ye || !be || !Ae) && he("kdf", le), ye & ye - 1 && he("N", ye);
      const Se = parseInt(searchPath(c, "crypto/kdfparams/dklen"));
      return Se !== 32 && he("dklen", Se), ie(ae, me, ye, be, Ae, 64, fe);
    } else if (le.toLowerCase() === "pbkdf2") {
      const me = looseArrayify(searchPath(c, "crypto/kdfparams/salt"));
      let ye = null;
      const be = searchPath(c, "crypto/kdfparams/prf");
      be === "hmac-sha256" ? ye = "sha256" : be === "hmac-sha512" ? ye = "sha512" : he("prf", be);
      const Ae = parseInt(searchPath(c, "crypto/kdfparams/c")), Se = parseInt(searchPath(c, "crypto/kdfparams/dklen"));
      return Se !== 32 && he("dklen", Se), n(ae, me, Ae, Se, ye);
    }
  }
  return logger$9.throwArgumentError("unsupported key-derivation function", "kdf", le);
}
function decryptSync(c, t) {
  const n = JSON.parse(c), ie = _computeKdfKey(n, t, pbkdf2Sync, scrypt.syncScrypt);
  return _getAccount(n, ie);
}
function decrypt(c, t, n) {
  return __awaiter$g(this, void 0, void 0, function* () {
    const ie = JSON.parse(c), fe = yield _computeKdfKey(ie, t, pbkdf2, scrypt.scrypt, n);
    return _getAccount(ie, fe);
  });
}
function encrypt(c, t, n, ie) {
  try {
    if (getAddress(c.address) !== computeAddress(c.privateKey))
      throw new Error("address/privateKey mismatch");
    if (hasMnemonic$1(c)) {
      const ke = c.mnemonic;
      if (HDNode.fromMnemonic(ke.phrase, null, ke.locale).derivePath(ke.path || defaultPath).privateKey != c.privateKey)
        throw new Error("mnemonic mismatch");
    }
  } catch (ke) {
    return Promise.reject(ke);
  }
  typeof n == "function" && !ie && (ie = n, n = {}), n || (n = {});
  const fe = arrayify(c.privateKey), ae = getPassword(t);
  let le = null, he = null, me = null;
  if (hasMnemonic$1(c)) {
    const ke = c.mnemonic;
    le = arrayify(mnemonicToEntropy(ke.phrase, ke.locale || "en")), he = ke.path || defaultPath, me = ke.locale || "en";
  }
  let ye = n.client;
  ye || (ye = "ethers.js");
  let be = null;
  n.salt ? be = arrayify(n.salt) : be = randomBytes$1(32);
  let Ae = null;
  if (n.iv) {
    if (Ae = arrayify(n.iv), Ae.length !== 16)
      throw new Error("invalid iv");
  } else
    Ae = randomBytes$1(16);
  let Se = null;
  if (n.uuid) {
    if (Se = arrayify(n.uuid), Se.length !== 16)
      throw new Error("invalid uuid");
  } else
    Se = randomBytes$1(16);
  let $e = 1 << 17, Re = 8, Me = 1;
  return n.scrypt && (n.scrypt.N && ($e = n.scrypt.N), n.scrypt.r && (Re = n.scrypt.r), n.scrypt.p && (Me = n.scrypt.p)), scrypt.scrypt(ae, be, $e, Re, Me, 64, ie).then((ke) => {
    ke = arrayify(ke);
    const Te = ke.slice(0, 16), Ie = ke.slice(16, 32), qe = ke.slice(32, 64), Ue = new aes$1.Counter(Ae), ze = new aes$1.ModeOfOperation.ctr(Te, Ue), Ve = arrayify(ze.encrypt(fe)), Mt = keccak256$1(concat$1([Ie, Ve])), Rt = {
      address: c.address.substring(2).toLowerCase(),
      id: uuidV4(Se),
      version: 3,
      crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: hexlify(Ae).substring(2)
        },
        ciphertext: hexlify(Ve).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: hexlify(be).substring(2),
          n: $e,
          dklen: 32,
          p: Me,
          r: Re
        },
        mac: Mt.substring(2)
      }
    };
    if (le) {
      const je = randomBytes$1(16), jt = new aes$1.Counter(je), _e = new aes$1.ModeOfOperation.ctr(qe, jt), se = arrayify(_e.encrypt(le)), ce = /* @__PURE__ */ new Date(), de = ce.getUTCFullYear() + "-" + zpad(ce.getUTCMonth() + 1, 2) + "-" + zpad(ce.getUTCDate(), 2) + "T" + zpad(ce.getUTCHours(), 2) + "-" + zpad(ce.getUTCMinutes(), 2) + "-" + zpad(ce.getUTCSeconds(), 2) + ".0Z";
      Rt["x-ethers"] = {
        client: ye,
        gethFilename: "UTC--" + de + "--" + Rt.address,
        mnemonicCounter: hexlify(je).substring(2),
        mnemonicCiphertext: hexlify(se).substring(2),
        path: he,
        locale: me,
        version: "0.1"
      };
    }
    return JSON.stringify(Rt);
  });
}
function decryptJsonWallet(c, t, n) {
  if (isCrowdsaleWallet(c)) {
    n && n(0);
    const ie = decrypt$1(c, t);
    return n && n(1), Promise.resolve(ie);
  }
  return isKeystoreWallet(c) ? decrypt(c, t, n) : Promise.reject(new Error("invalid JSON wallet"));
}
function decryptJsonWalletSync(c, t) {
  if (isCrowdsaleWallet(c))
    return decrypt$1(c, t);
  if (isKeystoreWallet(c))
    return decryptSync(c, t);
  throw new Error("invalid JSON wallet");
}
const lib_esm$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decryptCrowdsale: decrypt$1,
  decryptJsonWallet,
  decryptJsonWalletSync,
  decryptKeystore: decrypt,
  decryptKeystoreSync: decryptSync,
  encryptKeystore: encrypt,
  getJsonWalletAddress,
  isCrowdsaleWallet,
  isKeystoreWallet
}, Symbol.toStringTag, { value: "Module" })), version$c = "wallet/5.7.0";
var __awaiter$f = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$8 = new Logger(version$c);
function isAccount$1(c) {
  return c != null && isHexString(c.privateKey, 32) && c.address != null;
}
function hasMnemonic(c) {
  const t = c.mnemonic;
  return t && t.phrase;
}
class Wallet extends Signer {
  constructor(t, n) {
    if (super(), isAccount$1(t)) {
      const ie = new SigningKey(t.privateKey);
      if (defineReadOnly(this, "_signingKey", () => ie), defineReadOnly(this, "address", computeAddress(this.publicKey)), this.address !== getAddress(t.address) && logger$8.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]"), hasMnemonic(t)) {
        const fe = t.mnemonic;
        defineReadOnly(this, "_mnemonic", () => ({
          phrase: fe.phrase,
          path: fe.path || defaultPath,
          locale: fe.locale || "en"
        }));
        const ae = this.mnemonic, le = HDNode.fromMnemonic(ae.phrase, null, ae.locale).derivePath(ae.path);
        computeAddress(le.privateKey) !== this.address && logger$8.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
      } else
        defineReadOnly(this, "_mnemonic", () => null);
    } else {
      if (SigningKey.isSigningKey(t))
        t.curve !== "secp256k1" && logger$8.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]"), defineReadOnly(this, "_signingKey", () => t);
      else {
        typeof t == "string" && t.match(/^[0-9a-f]*$/i) && t.length === 64 && (t = "0x" + t);
        const ie = new SigningKey(t);
        defineReadOnly(this, "_signingKey", () => ie);
      }
      defineReadOnly(this, "_mnemonic", () => null), defineReadOnly(this, "address", computeAddress(this.publicKey));
    }
    n && !Provider.isProvider(n) && logger$8.throwArgumentError("invalid provider", "provider", n), defineReadOnly(this, "provider", n || null);
  }
  get mnemonic() {
    return this._mnemonic();
  }
  get privateKey() {
    return this._signingKey().privateKey;
  }
  get publicKey() {
    return this._signingKey().publicKey;
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  connect(t) {
    return new Wallet(this, t);
  }
  signTransaction(t) {
    return resolveProperties(t).then((n) => {
      n.from != null && (getAddress(n.from) !== this.address && logger$8.throwArgumentError("transaction from address mismatch", "transaction.from", t.from), delete n.from);
      const ie = this._signingKey().signDigest(keccak256$1(serialize$1(n)));
      return serialize$1(n, ie);
    });
  }
  signMessage(t) {
    return __awaiter$f(this, void 0, void 0, function* () {
      return joinSignature(this._signingKey().signDigest(hashMessage(t)));
    });
  }
  _signTypedData(t, n, ie) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const fe = yield TypedDataEncoder.resolveNames(t, n, ie, (ae) => (this.provider == null && logger$8.throwError("cannot resolve ENS names without a provider", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "resolveName",
        value: ae
      }), this.provider.resolveName(ae)));
      return joinSignature(this._signingKey().signDigest(TypedDataEncoder.hash(fe.domain, n, fe.value)));
    });
  }
  encrypt(t, n, ie) {
    if (typeof n == "function" && !ie && (ie = n, n = {}), ie && typeof ie != "function")
      throw new Error("invalid callback");
    return n || (n = {}), encrypt(this, t, n, ie);
  }
  /**
   *  Static methods to create Wallet instances.
   */
  static createRandom(t) {
    let n = randomBytes$1(16);
    t || (t = {}), t.extraEntropy && (n = arrayify(hexDataSlice(keccak256$1(concat$1([n, t.extraEntropy])), 0, 16)));
    const ie = entropyToMnemonic(n, t.locale);
    return Wallet.fromMnemonic(ie, t.path, t.locale);
  }
  static fromEncryptedJson(t, n, ie) {
    return decryptJsonWallet(t, n, ie).then((fe) => new Wallet(fe));
  }
  static fromEncryptedJsonSync(t, n) {
    return new Wallet(decryptJsonWalletSync(t, n));
  }
  static fromMnemonic(t, n, ie) {
    return n || (n = defaultPath), new Wallet(HDNode.fromMnemonic(t, null, ie).derivePath(n));
  }
}
function verifyMessage(c, t) {
  return recoverAddress(hashMessage(c), t);
}
function verifyTypedData(c, t, n, ie) {
  return recoverAddress(TypedDataEncoder.hash(c, t, n), ie);
}
const lib_esm$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Wallet,
  verifyMessage,
  verifyTypedData
}, Symbol.toStringTag, { value: "Module" })), version$b = "networks/5.7.1", logger$7 = new Logger(version$b);
function isRenetworkable(c) {
  return c && typeof c.renetwork == "function";
}
function ethDefaultProvider(c) {
  const t = function(n, ie) {
    ie == null && (ie = {});
    const fe = [];
    if (n.InfuraProvider && ie.infura !== "-")
      try {
        fe.push(new n.InfuraProvider(c, ie.infura));
      } catch {
      }
    if (n.EtherscanProvider && ie.etherscan !== "-")
      try {
        fe.push(new n.EtherscanProvider(c, ie.etherscan));
      } catch {
      }
    if (n.AlchemyProvider && ie.alchemy !== "-")
      try {
        fe.push(new n.AlchemyProvider(c, ie.alchemy));
      } catch {
      }
    if (n.PocketProvider && ie.pocket !== "-") {
      const ae = ["goerli", "ropsten", "rinkeby", "sepolia"];
      try {
        const le = new n.PocketProvider(c, ie.pocket);
        le.network && ae.indexOf(le.network.name) === -1 && fe.push(le);
      } catch {
      }
    }
    if (n.CloudflareProvider && ie.cloudflare !== "-")
      try {
        fe.push(new n.CloudflareProvider(c));
      } catch {
      }
    if (n.AnkrProvider && ie.ankr !== "-")
      try {
        const ae = ["ropsten"], le = new n.AnkrProvider(c, ie.ankr);
        le.network && ae.indexOf(le.network.name) === -1 && fe.push(le);
      } catch {
      }
    if (fe.length === 0)
      return null;
    if (n.FallbackProvider) {
      let ae = 1;
      return ie.quorum != null ? ae = ie.quorum : c === "homestead" && (ae = 2), new n.FallbackProvider(fe, ae);
    }
    return fe[0];
  };
  return t.renetwork = function(n) {
    return ethDefaultProvider(n);
  }, t;
}
function etcDefaultProvider(c, t) {
  const n = function(ie, fe) {
    return ie.JsonRpcProvider ? new ie.JsonRpcProvider(c, t) : null;
  };
  return n.renetwork = function(ie) {
    return etcDefaultProvider(c, ie);
  }, n;
}
const homestead = {
  chainId: 1,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "homestead",
  _defaultProvider: ethDefaultProvider("homestead")
}, ropsten = {
  chainId: 3,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "ropsten",
  _defaultProvider: ethDefaultProvider("ropsten")
}, classicMordor = {
  chainId: 63,
  name: "classicMordor",
  _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
}, networks$2 = {
  unspecified: { chainId: 0, name: "unspecified" },
  homestead,
  mainnet: homestead,
  morden: { chainId: 2, name: "morden" },
  ropsten,
  testnet: ropsten,
  rinkeby: {
    chainId: 4,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "rinkeby",
    _defaultProvider: ethDefaultProvider("rinkeby")
  },
  kovan: {
    chainId: 42,
    name: "kovan",
    _defaultProvider: ethDefaultProvider("kovan")
  },
  goerli: {
    chainId: 5,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "goerli",
    _defaultProvider: ethDefaultProvider("goerli")
  },
  kintsugi: { chainId: 1337702, name: "kintsugi" },
  sepolia: {
    chainId: 11155111,
    name: "sepolia",
    _defaultProvider: ethDefaultProvider("sepolia")
  },
  // ETC (See: #351)
  classic: {
    chainId: 61,
    name: "classic",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
  },
  classicMorden: { chainId: 62, name: "classicMorden" },
  classicMordor,
  classicTestnet: classicMordor,
  classicKotti: {
    chainId: 6,
    name: "classicKotti",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
  },
  xdai: { chainId: 100, name: "xdai" },
  matic: {
    chainId: 137,
    name: "matic",
    _defaultProvider: ethDefaultProvider("matic")
  },
  maticmum: { chainId: 80001, name: "maticmum" },
  optimism: {
    chainId: 10,
    name: "optimism",
    _defaultProvider: ethDefaultProvider("optimism")
  },
  "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
  "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
  arbitrum: { chainId: 42161, name: "arbitrum" },
  "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
  "arbitrum-goerli": { chainId: 421613, name: "arbitrum-goerli" },
  bnb: { chainId: 56, name: "bnb" },
  bnbt: { chainId: 97, name: "bnbt" }
};
function getNetwork(c) {
  if (c == null)
    return null;
  if (typeof c == "number") {
    for (const ie in networks$2) {
      const fe = networks$2[ie];
      if (fe.chainId === c)
        return {
          name: fe.name,
          chainId: fe.chainId,
          ensAddress: fe.ensAddress || null,
          _defaultProvider: fe._defaultProvider || null
        };
    }
    return {
      chainId: c,
      name: "unknown"
    };
  }
  if (typeof c == "string") {
    const ie = networks$2[c];
    return ie == null ? null : {
      name: ie.name,
      chainId: ie.chainId,
      ensAddress: ie.ensAddress,
      _defaultProvider: ie._defaultProvider || null
    };
  }
  const t = networks$2[c.name];
  if (!t)
    return typeof c.chainId != "number" && logger$7.throwArgumentError("invalid network chainId", "network", c), c;
  c.chainId !== 0 && c.chainId !== t.chainId && logger$7.throwArgumentError("network chainId mismatch", "network", c);
  let n = c._defaultProvider || null;
  return n == null && t._defaultProvider && (isRenetworkable(t._defaultProvider) ? n = t._defaultProvider.renetwork(c) : n = t._defaultProvider), {
    name: c.name,
    chainId: t.chainId,
    ensAddress: c.ensAddress || t.ensAddress || null,
    _defaultProvider: n
  };
}
const version$a = "web/5.7.1";
var __awaiter$e = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
function getUrl(c, t) {
  return __awaiter$e(this, void 0, void 0, function* () {
    t == null && (t = {});
    const n = {
      method: t.method || "GET",
      headers: t.headers || {},
      body: t.body || void 0
    };
    if (t.skipFetchSetup !== !0 && (n.mode = "cors", n.cache = "no-cache", n.credentials = "same-origin", n.redirect = "follow", n.referrer = "client"), t.fetchOptions != null) {
      const le = t.fetchOptions;
      le.mode && (n.mode = le.mode), le.cache && (n.cache = le.cache), le.credentials && (n.credentials = le.credentials), le.redirect && (n.redirect = le.redirect), le.referrer && (n.referrer = le.referrer);
    }
    const ie = yield fetch(c, n), fe = yield ie.arrayBuffer(), ae = {};
    return ie.headers.forEach ? ie.headers.forEach((le, he) => {
      ae[he.toLowerCase()] = le;
    }) : ie.headers.keys().forEach((le) => {
      ae[le.toLowerCase()] = ie.headers.get(le);
    }), {
      headers: ae,
      statusCode: ie.status,
      statusMessage: ie.statusText,
      body: arrayify(new Uint8Array(fe))
    };
  });
}
var __awaiter$d = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$6 = new Logger(version$a);
function staller(c) {
  return new Promise((t) => {
    setTimeout(t, c);
  });
}
function bodyify(c, t) {
  if (c == null)
    return null;
  if (typeof c == "string")
    return c;
  if (isBytesLike(c)) {
    if (t && (t.split("/")[0] === "text" || t.split(";")[0].trim() === "application/json"))
      try {
        return toUtf8String(c);
      } catch {
      }
    return hexlify(c);
  }
  return c;
}
function unpercent(c) {
  return toUtf8Bytes(c.replace(/%([0-9a-f][0-9a-f])/gi, (t, n) => String.fromCharCode(parseInt(n, 16))));
}
function _fetchData(c, t, n) {
  const ie = typeof c == "object" && c.throttleLimit != null ? c.throttleLimit : 12;
  logger$6.assertArgument(ie > 0 && ie % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", ie);
  const fe = typeof c == "object" ? c.throttleCallback : null, ae = typeof c == "object" && typeof c.throttleSlotInterval == "number" ? c.throttleSlotInterval : 100;
  logger$6.assertArgument(ae > 0 && ae % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", ae);
  const le = typeof c == "object" ? !!c.errorPassThrough : !1, he = {};
  let me = null;
  const ye = {
    method: "GET"
  };
  let be = !1, Ae = 2 * 60 * 1e3;
  if (typeof c == "string")
    me = c;
  else if (typeof c == "object") {
    if ((c == null || c.url == null) && logger$6.throwArgumentError("missing URL", "connection.url", c), me = c.url, typeof c.timeout == "number" && c.timeout > 0 && (Ae = c.timeout), c.headers)
      for (const Te in c.headers)
        he[Te.toLowerCase()] = { key: Te, value: String(c.headers[Te]) }, ["if-none-match", "if-modified-since"].indexOf(Te.toLowerCase()) >= 0 && (be = !0);
    if (ye.allowGzip = !!c.allowGzip, c.user != null && c.password != null) {
      me.substring(0, 6) !== "https:" && c.allowInsecureAuthentication !== !0 && logger$6.throwError("basic authentication requires a secure https url", Logger.errors.INVALID_ARGUMENT, { argument: "url", url: me, user: c.user, password: "[REDACTED]" });
      const Te = c.user + ":" + c.password;
      he.authorization = {
        key: "Authorization",
        value: "Basic " + encode$5(toUtf8Bytes(Te))
      };
    }
    c.skipFetchSetup != null && (ye.skipFetchSetup = !!c.skipFetchSetup), c.fetchOptions != null && (ye.fetchOptions = shallowCopy(c.fetchOptions));
  }
  const Se = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), $e = me ? me.match(Se) : null;
  if ($e)
    try {
      const Te = {
        statusCode: 200,
        statusMessage: "OK",
        headers: { "content-type": $e[1] || "text/plain" },
        body: $e[2] ? decode$6($e[3]) : unpercent($e[3])
      };
      let Ie = Te.body;
      return n && (Ie = n(Te.body, Te)), Promise.resolve(Ie);
    } catch (Te) {
      logger$6.throwError("processing response error", Logger.errors.SERVER_ERROR, {
        body: bodyify($e[1], $e[2]),
        error: Te,
        requestBody: null,
        requestMethod: "GET",
        url: me
      });
    }
  t && (ye.method = "POST", ye.body = t, he["content-type"] == null && (he["content-type"] = { key: "Content-Type", value: "application/octet-stream" }), he["content-length"] == null && (he["content-length"] = { key: "Content-Length", value: String(t.length) }));
  const Re = {};
  Object.keys(he).forEach((Te) => {
    const Ie = he[Te];
    Re[Ie.key] = Ie.value;
  }), ye.headers = Re;
  const Me = function() {
    let Te = null;
    return { promise: new Promise(function(Ue, ze) {
      Ae && (Te = setTimeout(() => {
        Te != null && (Te = null, ze(logger$6.makeError("timeout", Logger.errors.TIMEOUT, {
          requestBody: bodyify(ye.body, Re["content-type"]),
          requestMethod: ye.method,
          timeout: Ae,
          url: me
        })));
      }, Ae));
    }), cancel: function() {
      Te != null && (clearTimeout(Te), Te = null);
    } };
  }(), ke = function() {
    return __awaiter$d(this, void 0, void 0, function* () {
      for (let Te = 0; Te < ie; Te++) {
        let Ie = null;
        try {
          if (Ie = yield getUrl(me, ye), Te < ie) {
            if (Ie.statusCode === 301 || Ie.statusCode === 302) {
              const Ue = Ie.headers.location || "";
              if (ye.method === "GET" && Ue.match(/^https:/)) {
                me = Ie.headers.location;
                continue;
              }
            } else if (Ie.statusCode === 429) {
              let Ue = !0;
              if (fe && (Ue = yield fe(Te, me)), Ue) {
                let ze = 0;
                const Ve = Ie.headers["retry-after"];
                typeof Ve == "string" && Ve.match(/^[1-9][0-9]*$/) ? ze = parseInt(Ve) * 1e3 : ze = ae * parseInt(String(Math.random() * Math.pow(2, Te))), yield staller(ze);
                continue;
              }
            }
          }
        } catch (Ue) {
          Ie = Ue.response, Ie == null && (Me.cancel(), logger$6.throwError("missing response", Logger.errors.SERVER_ERROR, {
            requestBody: bodyify(ye.body, Re["content-type"]),
            requestMethod: ye.method,
            serverError: Ue,
            url: me
          }));
        }
        let qe = Ie.body;
        if (be && Ie.statusCode === 304 ? qe = null : !le && (Ie.statusCode < 200 || Ie.statusCode >= 300) && (Me.cancel(), logger$6.throwError("bad response", Logger.errors.SERVER_ERROR, {
          status: Ie.statusCode,
          headers: Ie.headers,
          body: bodyify(qe, Ie.headers ? Ie.headers["content-type"] : null),
          requestBody: bodyify(ye.body, Re["content-type"]),
          requestMethod: ye.method,
          url: me
        })), n)
          try {
            const Ue = yield n(qe, Ie);
            return Me.cancel(), Ue;
          } catch (Ue) {
            if (Ue.throttleRetry && Te < ie) {
              let ze = !0;
              if (fe && (ze = yield fe(Te, me)), ze) {
                const Ve = ae * parseInt(String(Math.random() * Math.pow(2, Te)));
                yield staller(Ve);
                continue;
              }
            }
            Me.cancel(), logger$6.throwError("processing response error", Logger.errors.SERVER_ERROR, {
              body: bodyify(qe, Ie.headers ? Ie.headers["content-type"] : null),
              error: Ue,
              requestBody: bodyify(ye.body, Re["content-type"]),
              requestMethod: ye.method,
              url: me
            });
          }
        return Me.cancel(), qe;
      }
      return logger$6.throwError("failed response", Logger.errors.SERVER_ERROR, {
        requestBody: bodyify(ye.body, Re["content-type"]),
        requestMethod: ye.method,
        url: me
      });
    });
  }();
  return Promise.race([Me.promise, ke]);
}
function fetchJson(c, t, n) {
  let ie = (ae, le) => {
    let he = null;
    if (ae != null)
      try {
        he = JSON.parse(toUtf8String(ae));
      } catch (me) {
        logger$6.throwError("invalid JSON", Logger.errors.SERVER_ERROR, {
          body: ae,
          error: me
        });
      }
    return n && (he = n(he, le)), he;
  }, fe = null;
  if (t != null) {
    fe = toUtf8Bytes(t);
    const ae = typeof c == "string" ? { url: c } : shallowCopy(c);
    ae.headers ? Object.keys(ae.headers).filter((he) => he.toLowerCase() === "content-type").length !== 0 || (ae.headers = shallowCopy(ae.headers), ae.headers["content-type"] = "application/json") : ae.headers = { "content-type": "application/json" }, c = ae;
  }
  return _fetchData(c, fe, ie);
}
function poll(c, t) {
  return t || (t = {}), t = shallowCopy(t), t.floor == null && (t.floor = 0), t.ceiling == null && (t.ceiling = 1e4), t.interval == null && (t.interval = 250), new Promise(function(n, ie) {
    let fe = null, ae = !1;
    const le = () => ae ? !1 : (ae = !0, fe && clearTimeout(fe), !0);
    t.timeout && (fe = setTimeout(() => {
      le() && ie(new Error("timeout"));
    }, t.timeout));
    const he = t.retryLimit;
    let me = 0;
    function ye() {
      return c().then(function(be) {
        if (be !== void 0)
          le() && n(be);
        else if (t.oncePoll)
          t.oncePoll.once("poll", ye);
        else if (t.onceBlock)
          t.onceBlock.once("block", ye);
        else if (!ae) {
          if (me++, me > he) {
            le() && ie(new Error("retry limit reached"));
            return;
          }
          let Ae = t.interval * parseInt(String(Math.random() * Math.pow(2, me)));
          Ae < t.floor && (Ae = t.floor), Ae > t.ceiling && (Ae = t.ceiling), setTimeout(ye, Ae);
        }
        return null;
      }, function(be) {
        le() && ie(be);
      });
    }
    ye();
  });
}
const lib_esm$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _fetchData,
  fetchJson,
  poll
}, Symbol.toStringTag, { value: "Module" }));
var ALPHABET$2 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP$1 = {};
for (var z$3 = 0; z$3 < ALPHABET$2.length; z$3++) {
  var x$2 = ALPHABET$2.charAt(z$3);
  if (ALPHABET_MAP$1[x$2] !== void 0) throw new TypeError(x$2 + " is ambiguous");
  ALPHABET_MAP$1[x$2] = z$3;
}
function polymodStep$1(c) {
  var t = c >> 25;
  return (c & 33554431) << 5 ^ -(t >> 0 & 1) & 996825010 ^ -(t >> 1 & 1) & 642813549 ^ -(t >> 2 & 1) & 513874426 ^ -(t >> 3 & 1) & 1027748829 ^ -(t >> 4 & 1) & 705979059;
}
function prefixChk$1(c) {
  for (var t = 1, n = 0; n < c.length; ++n) {
    var ie = c.charCodeAt(n);
    if (ie < 33 || ie > 126) return "Invalid prefix (" + c + ")";
    t = polymodStep$1(t) ^ ie >> 5;
  }
  for (t = polymodStep$1(t), n = 0; n < c.length; ++n) {
    var fe = c.charCodeAt(n);
    t = polymodStep$1(t) ^ fe & 31;
  }
  return t;
}
function encode$4(c, t, n) {
  if (n = n || 90, c.length + 7 + t.length > n) throw new TypeError("Exceeds length limit");
  c = c.toLowerCase();
  var ie = prefixChk$1(c);
  if (typeof ie == "string") throw new Error(ie);
  for (var fe = c + "1", ae = 0; ae < t.length; ++ae) {
    var le = t[ae];
    if (le >> 5) throw new Error("Non 5-bit word");
    ie = polymodStep$1(ie) ^ le, fe += ALPHABET$2.charAt(le);
  }
  for (ae = 0; ae < 6; ++ae)
    ie = polymodStep$1(ie);
  for (ie ^= 1, ae = 0; ae < 6; ++ae) {
    var he = ie >> (5 - ae) * 5 & 31;
    fe += ALPHABET$2.charAt(he);
  }
  return fe;
}
function __decode(c, t) {
  if (t = t || 90, c.length < 8) return c + " too short";
  if (c.length > t) return "Exceeds length limit";
  var n = c.toLowerCase(), ie = c.toUpperCase();
  if (c !== n && c !== ie) return "Mixed-case string " + c;
  c = n;
  var fe = c.lastIndexOf("1");
  if (fe === -1) return "No separator character for " + c;
  if (fe === 0) return "Missing prefix for " + c;
  var ae = c.slice(0, fe), le = c.slice(fe + 1);
  if (le.length < 6) return "Data too short";
  var he = prefixChk$1(ae);
  if (typeof he == "string") return he;
  for (var me = [], ye = 0; ye < le.length; ++ye) {
    var be = le.charAt(ye), Ae = ALPHABET_MAP$1[be];
    if (Ae === void 0) return "Unknown character " + be;
    he = polymodStep$1(he) ^ Ae, !(ye + 6 >= le.length) && me.push(Ae);
  }
  return he !== 1 ? "Invalid checksum for " + c : { prefix: ae, words: me };
}
function decodeUnsafe() {
  var c = __decode.apply(null, arguments);
  if (typeof c == "object") return c;
}
function decode$5(c) {
  var t = __decode.apply(null, arguments);
  if (typeof t == "object") return t;
  throw new Error(t);
}
function convert$1(c, t, n, ie) {
  for (var fe = 0, ae = 0, le = (1 << n) - 1, he = [], me = 0; me < c.length; ++me)
    for (fe = fe << t | c[me], ae += t; ae >= n; )
      ae -= n, he.push(fe >> ae & le);
  if (ie)
    ae > 0 && he.push(fe << n - ae & le);
  else {
    if (ae >= t) return "Excess padding";
    if (fe << n - ae & le) return "Non-zero padding";
  }
  return he;
}
function toWordsUnsafe(c) {
  var t = convert$1(c, 8, 5, !0);
  if (Array.isArray(t)) return t;
}
function toWords$1(c) {
  var t = convert$1(c, 8, 5, !0);
  if (Array.isArray(t)) return t;
  throw new Error(t);
}
function fromWordsUnsafe$1(c) {
  var t = convert$1(c, 5, 8, !1);
  if (Array.isArray(t)) return t;
}
function fromWords$1(c) {
  var t = convert$1(c, 5, 8, !1);
  if (Array.isArray(t)) return t;
  throw new Error(t);
}
var bech32$1 = {
  decodeUnsafe,
  decode: decode$5,
  encode: encode$4,
  toWordsUnsafe,
  toWords: toWords$1,
  fromWordsUnsafe: fromWordsUnsafe$1,
  fromWords: fromWords$1
};
const bech32$2 = /* @__PURE__ */ getDefaultExportFromCjs$2(bech32$1), version$9 = "providers/5.7.2", logger$5 = new Logger(version$9);
class Formatter {
  constructor() {
    this.formats = this.getDefaultFormats();
  }
  getDefaultFormats() {
    const t = {}, n = this.address.bind(this), ie = this.bigNumber.bind(this), fe = this.blockTag.bind(this), ae = this.data.bind(this), le = this.hash.bind(this), he = this.hex.bind(this), me = this.number.bind(this), ye = this.type.bind(this), be = (Ae) => this.data(Ae, !0);
    return t.transaction = {
      hash: le,
      type: ye,
      accessList: Formatter.allowNull(this.accessList.bind(this), null),
      blockHash: Formatter.allowNull(le, null),
      blockNumber: Formatter.allowNull(me, null),
      transactionIndex: Formatter.allowNull(me, null),
      confirmations: Formatter.allowNull(me, null),
      from: n,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
      // must be set
      gasPrice: Formatter.allowNull(ie),
      maxPriorityFeePerGas: Formatter.allowNull(ie),
      maxFeePerGas: Formatter.allowNull(ie),
      gasLimit: ie,
      to: Formatter.allowNull(n, null),
      value: ie,
      nonce: me,
      data: ae,
      r: Formatter.allowNull(this.uint256),
      s: Formatter.allowNull(this.uint256),
      v: Formatter.allowNull(me),
      creates: Formatter.allowNull(n, null),
      raw: Formatter.allowNull(ae)
    }, t.transactionRequest = {
      from: Formatter.allowNull(n),
      nonce: Formatter.allowNull(me),
      gasLimit: Formatter.allowNull(ie),
      gasPrice: Formatter.allowNull(ie),
      maxPriorityFeePerGas: Formatter.allowNull(ie),
      maxFeePerGas: Formatter.allowNull(ie),
      to: Formatter.allowNull(n),
      value: Formatter.allowNull(ie),
      data: Formatter.allowNull(be),
      type: Formatter.allowNull(me),
      accessList: Formatter.allowNull(this.accessList.bind(this), null)
    }, t.receiptLog = {
      transactionIndex: me,
      blockNumber: me,
      transactionHash: le,
      address: n,
      topics: Formatter.arrayOf(le),
      data: ae,
      logIndex: me,
      blockHash: le
    }, t.receipt = {
      to: Formatter.allowNull(this.address, null),
      from: Formatter.allowNull(this.address, null),
      contractAddress: Formatter.allowNull(n, null),
      transactionIndex: me,
      // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
      root: Formatter.allowNull(he),
      gasUsed: ie,
      logsBloom: Formatter.allowNull(ae),
      blockHash: le,
      transactionHash: le,
      logs: Formatter.arrayOf(this.receiptLog.bind(this)),
      blockNumber: me,
      confirmations: Formatter.allowNull(me, null),
      cumulativeGasUsed: ie,
      effectiveGasPrice: Formatter.allowNull(ie),
      status: Formatter.allowNull(me),
      type: ye
    }, t.block = {
      hash: Formatter.allowNull(le),
      parentHash: le,
      number: me,
      timestamp: me,
      nonce: Formatter.allowNull(he),
      difficulty: this.difficulty.bind(this),
      gasLimit: ie,
      gasUsed: ie,
      miner: Formatter.allowNull(n),
      extraData: ae,
      transactions: Formatter.allowNull(Formatter.arrayOf(le)),
      baseFeePerGas: Formatter.allowNull(ie)
    }, t.blockWithTransactions = shallowCopy(t.block), t.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this))), t.filter = {
      fromBlock: Formatter.allowNull(fe, void 0),
      toBlock: Formatter.allowNull(fe, void 0),
      blockHash: Formatter.allowNull(le, void 0),
      address: Formatter.allowNull(n, void 0),
      topics: Formatter.allowNull(this.topics.bind(this), void 0)
    }, t.filterLog = {
      blockNumber: Formatter.allowNull(me),
      blockHash: Formatter.allowNull(le),
      transactionIndex: me,
      removed: Formatter.allowNull(this.boolean.bind(this)),
      address: n,
      data: Formatter.allowFalsish(ae, "0x"),
      topics: Formatter.arrayOf(le),
      transactionHash: le,
      logIndex: me
    }, t;
  }
  accessList(t) {
    return accessListify(t || []);
  }
  // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
  // Strict! Used on input.
  number(t) {
    return t === "0x" ? 0 : BigNumber.from(t).toNumber();
  }
  type(t) {
    return t === "0x" || t == null ? 0 : BigNumber.from(t).toNumber();
  }
  // Strict! Used on input.
  bigNumber(t) {
    return BigNumber.from(t);
  }
  // Requires a boolean, "true" or  "false"; returns a boolean
  boolean(t) {
    if (typeof t == "boolean")
      return t;
    if (typeof t == "string") {
      if (t = t.toLowerCase(), t === "true")
        return !0;
      if (t === "false")
        return !1;
    }
    throw new Error("invalid boolean - " + t);
  }
  hex(t, n) {
    return typeof t == "string" && (!n && t.substring(0, 2) !== "0x" && (t = "0x" + t), isHexString(t)) ? t.toLowerCase() : logger$5.throwArgumentError("invalid hash", "value", t);
  }
  data(t, n) {
    const ie = this.hex(t, n);
    if (ie.length % 2 !== 0)
      throw new Error("invalid data; odd-length - " + t);
    return ie;
  }
  // Requires an address
  // Strict! Used on input.
  address(t) {
    return getAddress(t);
  }
  callAddress(t) {
    if (!isHexString(t, 32))
      return null;
    const n = getAddress(hexDataSlice(t, 12));
    return n === AddressZero ? null : n;
  }
  contractAddress(t) {
    return getContractAddress(t);
  }
  // Strict! Used on input.
  blockTag(t) {
    if (t == null)
      return "latest";
    if (t === "earliest")
      return "0x0";
    switch (t) {
      case "earliest":
        return "0x0";
      case "latest":
      case "pending":
      case "safe":
      case "finalized":
        return t;
    }
    if (typeof t == "number" || isHexString(t))
      return hexValue(t);
    throw new Error("invalid blockTag");
  }
  // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
  hash(t, n) {
    const ie = this.hex(t, n);
    return hexDataLength(ie) !== 32 ? logger$5.throwArgumentError("invalid hash", "value", t) : ie;
  }
  // Returns the difficulty as a number, or if too large (i.e. PoA network) null
  difficulty(t) {
    if (t == null)
      return null;
    const n = BigNumber.from(t);
    try {
      return n.toNumber();
    } catch {
    }
    return null;
  }
  uint256(t) {
    if (!isHexString(t))
      throw new Error("invalid uint256");
    return hexZeroPad(t, 32);
  }
  _block(t, n) {
    t.author != null && t.miner == null && (t.miner = t.author);
    const ie = t._difficulty != null ? t._difficulty : t.difficulty, fe = Formatter.check(n, t);
    return fe._difficulty = ie == null ? null : BigNumber.from(ie), fe;
  }
  block(t) {
    return this._block(t, this.formats.block);
  }
  blockWithTransactions(t) {
    return this._block(t, this.formats.blockWithTransactions);
  }
  // Strict! Used on input.
  transactionRequest(t) {
    return Formatter.check(this.formats.transactionRequest, t);
  }
  transactionResponse(t) {
    t.gas != null && t.gasLimit == null && (t.gasLimit = t.gas), t.to && BigNumber.from(t.to).isZero() && (t.to = "0x0000000000000000000000000000000000000000"), t.input != null && t.data == null && (t.data = t.input), t.to == null && t.creates == null && (t.creates = this.contractAddress(t)), (t.type === 1 || t.type === 2) && t.accessList == null && (t.accessList = []);
    const n = Formatter.check(this.formats.transaction, t);
    if (t.chainId != null) {
      let ie = t.chainId;
      isHexString(ie) && (ie = BigNumber.from(ie).toNumber()), n.chainId = ie;
    } else {
      let ie = t.networkId;
      ie == null && n.v == null && (ie = t.chainId), isHexString(ie) && (ie = BigNumber.from(ie).toNumber()), typeof ie != "number" && n.v != null && (ie = (n.v - 35) / 2, ie < 0 && (ie = 0), ie = parseInt(ie)), typeof ie != "number" && (ie = 0), n.chainId = ie;
    }
    return n.blockHash && n.blockHash.replace(/0/g, "") === "x" && (n.blockHash = null), n;
  }
  transaction(t) {
    return parse$2(t);
  }
  receiptLog(t) {
    return Formatter.check(this.formats.receiptLog, t);
  }
  receipt(t) {
    const n = Formatter.check(this.formats.receipt, t);
    if (n.root != null)
      if (n.root.length <= 4) {
        const ie = BigNumber.from(n.root).toNumber();
        ie === 0 || ie === 1 ? (n.status != null && n.status !== ie && logger$5.throwArgumentError("alt-root-status/status mismatch", "value", { root: n.root, status: n.status }), n.status = ie, delete n.root) : logger$5.throwArgumentError("invalid alt-root-status", "value.root", n.root);
      } else n.root.length !== 66 && logger$5.throwArgumentError("invalid root hash", "value.root", n.root);
    return n.status != null && (n.byzantium = !0), n;
  }
  topics(t) {
    return Array.isArray(t) ? t.map((n) => this.topics(n)) : t != null ? this.hash(t, !0) : null;
  }
  filter(t) {
    return Formatter.check(this.formats.filter, t);
  }
  filterLog(t) {
    return Formatter.check(this.formats.filterLog, t);
  }
  static check(t, n) {
    const ie = {};
    for (const fe in t)
      try {
        const ae = t[fe](n[fe]);
        ae !== void 0 && (ie[fe] = ae);
      } catch (ae) {
        throw ae.checkKey = fe, ae.checkValue = n[fe], ae;
      }
    return ie;
  }
  // if value is null-ish, nullValue is returned
  static allowNull(t, n) {
    return function(ie) {
      return ie == null ? n : t(ie);
    };
  }
  // If value is false-ish, replaceValue is returned
  static allowFalsish(t, n) {
    return function(ie) {
      return ie ? t(ie) : n;
    };
  }
  // Requires an Array satisfying check
  static arrayOf(t) {
    return function(n) {
      if (!Array.isArray(n))
        throw new Error("not an array");
      const ie = [];
      return n.forEach(function(fe) {
        ie.push(t(fe));
      }), ie;
    };
  }
}
var __awaiter$c = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$4 = new Logger(version$9), MAX_CCIP_REDIRECTS = 10;
function checkTopic(c) {
  return c == null ? "null" : (hexDataLength(c) !== 32 && logger$4.throwArgumentError("invalid topic", "topic", c), c.toLowerCase());
}
function serializeTopics(c) {
  for (c = c.slice(); c.length > 0 && c[c.length - 1] == null; )
    c.pop();
  return c.map((t) => {
    if (Array.isArray(t)) {
      const n = {};
      t.forEach((fe) => {
        n[checkTopic(fe)] = !0;
      });
      const ie = Object.keys(n);
      return ie.sort(), ie.join("|");
    } else
      return checkTopic(t);
  }).join("&");
}
function deserializeTopics(c) {
  return c === "" ? [] : c.split(/&/g).map((t) => {
    if (t === "")
      return [];
    const n = t.split("|").map((ie) => ie === "null" ? null : ie);
    return n.length === 1 ? n[0] : n;
  });
}
function getEventTag(c) {
  if (typeof c == "string") {
    if (c = c.toLowerCase(), hexDataLength(c) === 32)
      return "tx:" + c;
    if (c.indexOf(":") === -1)
      return c;
  } else {
    if (Array.isArray(c))
      return "filter:*:" + serializeTopics(c);
    if (ForkEvent.isForkEvent(c))
      throw logger$4.warn("not implemented"), new Error("not implemented");
    if (c && typeof c == "object")
      return "filter:" + (c.address || "*") + ":" + serializeTopics(c.topics || []);
  }
  throw new Error("invalid event - " + c);
}
function getTime() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function stall(c) {
  return new Promise((t) => {
    setTimeout(t, c);
  });
}
const PollableEvents = ["block", "network", "pending", "poll"];
class Event {
  constructor(t, n, ie) {
    defineReadOnly(this, "tag", t), defineReadOnly(this, "listener", n), defineReadOnly(this, "once", ie), this._lastBlockNumber = -2, this._inflight = !1;
  }
  get event() {
    switch (this.type) {
      case "tx":
        return this.hash;
      case "filter":
        return this.filter;
    }
    return this.tag;
  }
  get type() {
    return this.tag.split(":")[0];
  }
  get hash() {
    const t = this.tag.split(":");
    return t[0] !== "tx" ? null : t[1];
  }
  get filter() {
    const t = this.tag.split(":");
    if (t[0] !== "filter")
      return null;
    const n = t[1], ie = deserializeTopics(t[2]), fe = {};
    return ie.length > 0 && (fe.topics = ie), n && n !== "*" && (fe.address = n), fe;
  }
  pollable() {
    return this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0;
  }
}
const coinInfos = {
  0: { symbol: "btc", p2pkh: 0, p2sh: 5, prefix: "bc" },
  2: { symbol: "ltc", p2pkh: 48, p2sh: 50, prefix: "ltc" },
  3: { symbol: "doge", p2pkh: 30, p2sh: 22 },
  60: { symbol: "eth", ilk: "eth" },
  61: { symbol: "etc", ilk: "eth" },
  700: { symbol: "xdai", ilk: "eth" }
};
function bytes32ify(c) {
  return hexZeroPad(BigNumber.from(c).toHexString(), 32);
}
function base58Encode(c) {
  return Base58.encode(concat$1([c, hexDataSlice(sha256$6(sha256$6(c)), 0, 4)]));
}
const matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i"), matchers = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  matcherIpfs,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function _parseString(c, t) {
  try {
    return toUtf8String(_parseBytes(c, t));
  } catch {
  }
  return null;
}
function _parseBytes(c, t) {
  if (c === "0x")
    return null;
  const n = BigNumber.from(hexDataSlice(c, t, t + 32)).toNumber(), ie = BigNumber.from(hexDataSlice(c, n, n + 32)).toNumber();
  return hexDataSlice(c, n + 32, n + 32 + ie);
}
function getIpfsLink(c) {
  return c.match(/^ipfs:\/\/ipfs\//i) ? c = c.substring(12) : c.match(/^ipfs:\/\//i) ? c = c.substring(7) : logger$4.throwArgumentError("unsupported IPFS format", "link", c), `https://gateway.ipfs.io/ipfs/${c}`;
}
function numPad(c) {
  const t = arrayify(c);
  if (t.length > 32)
    throw new Error("internal; should not happen");
  const n = new Uint8Array(32);
  return n.set(t, 32 - t.length), n;
}
function bytesPad(c) {
  if (c.length % 32 === 0)
    return c;
  const t = new Uint8Array(Math.ceil(c.length / 32) * 32);
  return t.set(c), t;
}
function encodeBytes(c) {
  const t = [];
  let n = 0;
  for (let ie = 0; ie < c.length; ie++)
    t.push(null), n += 32;
  for (let ie = 0; ie < c.length; ie++) {
    const fe = arrayify(c[ie]);
    t[ie] = numPad(n), t.push(numPad(fe.length)), t.push(bytesPad(fe)), n += 32 + Math.ceil(fe.length / 32) * 32;
  }
  return hexConcat(t);
}
class Resolver {
  // The resolvedAddress is only for creating a ReverseLookup resolver
  constructor(t, n, ie, fe) {
    defineReadOnly(this, "provider", t), defineReadOnly(this, "name", ie), defineReadOnly(this, "address", t.formatter.address(n)), defineReadOnly(this, "_resolvedAddress", fe);
  }
  supportsWildcard() {
    return this._supportsEip2544 || (this._supportsEip2544 = this.provider.call({
      to: this.address,
      data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
    }).then((t) => BigNumber.from(t).eq(1)).catch((t) => {
      if (t.code === Logger.errors.CALL_EXCEPTION)
        return !1;
      throw this._supportsEip2544 = null, t;
    })), this._supportsEip2544;
  }
  _fetch(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      const ie = {
        to: this.address,
        ccipReadEnabled: !0,
        data: hexConcat([t, namehash$1(this.name), n || "0x"])
      };
      let fe = !1;
      (yield this.supportsWildcard()) && (fe = !0, ie.data = hexConcat(["0x9061b923", encodeBytes([dnsEncode(this.name), ie.data])]));
      try {
        let ae = yield this.provider.call(ie);
        return arrayify(ae).length % 32 === 4 && logger$4.throwError("resolver threw error", Logger.errors.CALL_EXCEPTION, {
          transaction: ie,
          data: ae
        }), fe && (ae = _parseBytes(ae, 0)), ae;
      } catch (ae) {
        if (ae.code === Logger.errors.CALL_EXCEPTION)
          return null;
        throw ae;
      }
    });
  }
  _fetchBytes(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      const ie = yield this._fetch(t, n);
      return ie != null ? _parseBytes(ie, 0) : null;
    });
  }
  _getAddress(t, n) {
    const ie = coinInfos[String(t)];
    if (ie == null && logger$4.throwError(`unsupported coin type: ${t}`, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: `getAddress(${t})`
    }), ie.ilk === "eth")
      return this.provider.formatter.address(n);
    const fe = arrayify(n);
    if (ie.p2pkh != null) {
      const ae = n.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
      if (ae) {
        const le = parseInt(ae[1], 16);
        if (ae[2].length === le * 2 && le >= 1 && le <= 75)
          return base58Encode(concat$1([[ie.p2pkh], "0x" + ae[2]]));
      }
    }
    if (ie.p2sh != null) {
      const ae = n.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
      if (ae) {
        const le = parseInt(ae[1], 16);
        if (ae[2].length === le * 2 && le >= 1 && le <= 75)
          return base58Encode(concat$1([[ie.p2sh], "0x" + ae[2]]));
      }
    }
    if (ie.prefix != null) {
      const ae = fe[1];
      let le = fe[0];
      if (le === 0 ? ae !== 20 && ae !== 32 && (le = -1) : le = -1, le >= 0 && fe.length === 2 + ae && ae >= 1 && ae <= 75) {
        const he = bech32$2.toWords(fe.slice(2));
        return he.unshift(le), bech32$2.encode(ie.prefix, he);
      }
    }
    return null;
  }
  getAddress(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (t == null && (t = 60), t === 60)
        try {
          const fe = yield this._fetch("0x3b3b57de");
          return fe === "0x" || fe === HashZero ? null : this.provider.formatter.callAddress(fe);
        } catch (fe) {
          if (fe.code === Logger.errors.CALL_EXCEPTION)
            return null;
          throw fe;
        }
      const n = yield this._fetchBytes("0xf1cb7e06", bytes32ify(t));
      if (n == null || n === "0x")
        return null;
      const ie = this._getAddress(t, n);
      return ie == null && logger$4.throwError("invalid or unsupported coin data", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: `getAddress(${t})`,
        coinType: t,
        data: n
      }), ie;
    });
  }
  getAvatar() {
    return __awaiter$c(this, void 0, void 0, function* () {
      const t = [{ type: "name", content: this.name }];
      try {
        const n = yield this.getText("avatar");
        if (n == null)
          return null;
        for (let ie = 0; ie < matchers.length; ie++) {
          const fe = n.match(matchers[ie]);
          if (fe == null)
            continue;
          const ae = fe[1].toLowerCase();
          switch (ae) {
            case "https":
              return t.push({ type: "url", content: n }), { linkage: t, url: n };
            case "data":
              return t.push({ type: "data", content: n }), { linkage: t, url: n };
            case "ipfs":
              return t.push({ type: "ipfs", content: n }), { linkage: t, url: getIpfsLink(n) };
            case "erc721":
            case "erc1155": {
              const le = ae === "erc721" ? "0xc87b56dd" : "0x0e89341c";
              t.push({ type: ae, content: n });
              const he = this._resolvedAddress || (yield this.getAddress()), me = (fe[2] || "").split("/");
              if (me.length !== 2)
                return null;
              const ye = yield this.provider.formatter.address(me[0]), be = hexZeroPad(BigNumber.from(me[1]).toHexString(), 32);
              if (ae === "erc721") {
                const Me = this.provider.formatter.callAddress(yield this.provider.call({
                  to: ye,
                  data: hexConcat(["0x6352211e", be])
                }));
                if (he !== Me)
                  return null;
                t.push({ type: "owner", content: Me });
              } else if (ae === "erc1155") {
                const Me = BigNumber.from(yield this.provider.call({
                  to: ye,
                  data: hexConcat(["0x00fdd58e", hexZeroPad(he, 32), be])
                }));
                if (Me.isZero())
                  return null;
                t.push({ type: "balance", content: Me.toString() });
              }
              const Ae = {
                to: this.provider.formatter.address(me[0]),
                data: hexConcat([le, be])
              };
              let Se = _parseString(yield this.provider.call(Ae), 0);
              if (Se == null)
                return null;
              t.push({ type: "metadata-url-base", content: Se }), ae === "erc1155" && (Se = Se.replace("{id}", be.substring(2)), t.push({ type: "metadata-url-expanded", content: Se })), Se.match(/^ipfs:/i) && (Se = getIpfsLink(Se)), t.push({ type: "metadata-url", content: Se });
              const $e = yield fetchJson(Se);
              if (!$e)
                return null;
              t.push({ type: "metadata", content: JSON.stringify($e) });
              let Re = $e.image;
              if (typeof Re != "string")
                return null;
              if (!Re.match(/^(https:\/\/|data:)/i)) {
                if (Re.match(matcherIpfs) == null)
                  return null;
                t.push({ type: "url-ipfs", content: Re }), Re = getIpfsLink(Re);
              }
              return t.push({ type: "url", content: Re }), { linkage: t, url: Re };
            }
          }
        }
      } catch {
      }
      return null;
    });
  }
  getContentHash() {
    return __awaiter$c(this, void 0, void 0, function* () {
      const t = yield this._fetchBytes("0xbc1c58d1");
      if (t == null || t === "0x")
        return null;
      const n = t.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (n) {
        const le = parseInt(n[3], 16);
        if (n[4].length === le * 2)
          return "ipfs://" + Base58.encode("0x" + n[1]);
      }
      const ie = t.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (ie) {
        const le = parseInt(ie[3], 16);
        if (ie[4].length === le * 2)
          return "ipns://" + Base58.encode("0x" + ie[1]);
      }
      const fe = t.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (fe && fe[1].length === 32 * 2)
        return "bzz://" + fe[1];
      const ae = t.match(/^0x90b2c605([0-9a-f]*)$/);
      if (ae && ae[1].length === 34 * 2) {
        const le = { "=": "", "+": "-", "/": "_" };
        return "sia://" + encode$5("0x" + ae[1]).replace(/[=+\/]/g, (me) => le[me]);
      }
      return logger$4.throwError("invalid or unsupported content hash data", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "getContentHash()",
        data: t
      });
    });
  }
  getText(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      let n = toUtf8Bytes(t);
      n = concat$1([bytes32ify(64), bytes32ify(n.length), n]), n.length % 32 !== 0 && (n = concat$1([n, hexZeroPad("0x", 32 - t.length % 32)]));
      const ie = yield this._fetchBytes("0x59d1d43c", hexlify(n));
      return ie == null || ie === "0x" ? null : toUtf8String(ie);
    });
  }
}
let defaultFormatter = null, nextPollId = 1;
class BaseProvider extends Provider {
  /**
   *  ready
   *
   *  A Promise<Network> that resolves only once the provider is ready.
   *
   *  Sub-classes that call the super with a network without a chainId
   *  MUST set this. Standard named networks have a known chainId.
   *
   */
  constructor(t) {
    if (super(), this._events = [], this._emitted = { block: -2 }, this.disableCcipRead = !1, this.formatter = new.target.getFormatter(), defineReadOnly(this, "anyNetwork", t === "any"), this.anyNetwork && (t = this.detectNetwork()), t instanceof Promise)
      this._networkPromise = t, t.catch((n) => {
      }), this._ready().catch((n) => {
      });
    else {
      const n = getStatic(new.target, "getNetwork")(t);
      n ? (defineReadOnly(this, "_network", n), this.emit("network", n, null)) : logger$4.throwArgumentError("invalid network", "network", t);
    }
    this._maxInternalBlockNumber = -1024, this._lastBlockNumber = -2, this._maxFilterBlockRange = 10, this._pollingInterval = 4e3, this._fastQueryDate = 0;
  }
  _ready() {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (this._network == null) {
        let t = null;
        if (this._networkPromise)
          try {
            t = yield this._networkPromise;
          } catch {
          }
        t == null && (t = yield this.detectNetwork()), t || logger$4.throwError("no network detected", Logger.errors.UNKNOWN_ERROR, {}), this._network == null && (this.anyNetwork ? this._network = t : defineReadOnly(this, "_network", t), this.emit("network", t, null));
      }
      return this._network;
    });
  }
  // This will always return the most recently established network.
  // For "any", this can change (a "network" event is emitted before
  // any change is reflected); otherwise this cannot change
  get ready() {
    return poll(() => this._ready().then((t) => t, (t) => {
      if (!(t.code === Logger.errors.NETWORK_ERROR && t.event === "noNetwork"))
        throw t;
    }));
  }
  // @TODO: Remove this and just create a singleton formatter
  static getFormatter() {
    return defaultFormatter == null && (defaultFormatter = new Formatter()), defaultFormatter;
  }
  // @TODO: Remove this and just use getNetwork
  static getNetwork(t) {
    return getNetwork(t ?? "homestead");
  }
  ccipReadFetch(t, n, ie) {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (this.disableCcipRead || ie.length === 0)
        return null;
      const fe = t.to.toLowerCase(), ae = n.toLowerCase(), le = [];
      for (let he = 0; he < ie.length; he++) {
        const me = ie[he], ye = me.replace("{sender}", fe).replace("{data}", ae), be = me.indexOf("{data}") >= 0 ? null : JSON.stringify({ data: ae, sender: fe }), Ae = yield fetchJson({ url: ye, errorPassThrough: !0 }, be, ($e, Re) => ($e.status = Re.statusCode, $e));
        if (Ae.data)
          return Ae.data;
        const Se = Ae.message || "unknown error";
        if (Ae.status >= 400 && Ae.status < 500)
          return logger$4.throwError(`response not found during CCIP fetch: ${Se}`, Logger.errors.SERVER_ERROR, { url: me, errorMessage: Se });
        le.push(Se);
      }
      return logger$4.throwError(`error encountered during CCIP fetch: ${le.map((he) => JSON.stringify(he)).join(", ")}`, Logger.errors.SERVER_ERROR, {
        urls: ie,
        errorMessages: le
      });
    });
  }
  // Fetches the blockNumber, but will reuse any result that is less
  // than maxAge old or has been requested since the last request
  _getInternalBlockNumber(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (yield this._ready(), t > 0)
        for (; this._internalBlockNumber; ) {
          const fe = this._internalBlockNumber;
          try {
            const ae = yield fe;
            if (getTime() - ae.respTime <= t)
              return ae.blockNumber;
            break;
          } catch {
            if (this._internalBlockNumber === fe)
              break;
          }
        }
      const n = getTime(), ie = resolveProperties({
        blockNumber: this.perform("getBlockNumber", {}),
        networkError: this.getNetwork().then((fe) => null, (fe) => fe)
      }).then(({ blockNumber: fe, networkError: ae }) => {
        if (ae)
          throw this._internalBlockNumber === ie && (this._internalBlockNumber = null), ae;
        const le = getTime();
        return fe = BigNumber.from(fe).toNumber(), fe < this._maxInternalBlockNumber && (fe = this._maxInternalBlockNumber), this._maxInternalBlockNumber = fe, this._setFastBlockNumber(fe), { blockNumber: fe, reqTime: n, respTime: le };
      });
      return this._internalBlockNumber = ie, ie.catch((fe) => {
        this._internalBlockNumber === ie && (this._internalBlockNumber = null);
      }), (yield ie).blockNumber;
    });
  }
  poll() {
    return __awaiter$c(this, void 0, void 0, function* () {
      const t = nextPollId++, n = [];
      let ie = null;
      try {
        ie = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
      } catch (fe) {
        this.emit("error", fe);
        return;
      }
      if (this._setFastBlockNumber(ie), this.emit("poll", t, ie), ie === this._lastBlockNumber) {
        this.emit("didPoll", t);
        return;
      }
      if (this._emitted.block === -2 && (this._emitted.block = ie - 1), Math.abs(this._emitted.block - ie) > 1e3)
        logger$4.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${ie})`), this.emit("error", logger$4.makeError("network block skew detected", Logger.errors.NETWORK_ERROR, {
          blockNumber: ie,
          event: "blockSkew",
          previousBlockNumber: this._emitted.block
        })), this.emit("block", ie);
      else
        for (let fe = this._emitted.block + 1; fe <= ie; fe++)
          this.emit("block", fe);
      this._emitted.block !== ie && (this._emitted.block = ie, Object.keys(this._emitted).forEach((fe) => {
        if (fe === "block")
          return;
        const ae = this._emitted[fe];
        ae !== "pending" && ie - ae > 12 && delete this._emitted[fe];
      })), this._lastBlockNumber === -2 && (this._lastBlockNumber = ie - 1), this._events.forEach((fe) => {
        switch (fe.type) {
          case "tx": {
            const ae = fe.hash;
            let le = this.getTransactionReceipt(ae).then((he) => (!he || he.blockNumber == null || (this._emitted["t:" + ae] = he.blockNumber, this.emit(ae, he)), null)).catch((he) => {
              this.emit("error", he);
            });
            n.push(le);
            break;
          }
          case "filter": {
            if (!fe._inflight) {
              fe._inflight = !0, fe._lastBlockNumber === -2 && (fe._lastBlockNumber = ie - 1);
              const ae = fe.filter;
              ae.fromBlock = fe._lastBlockNumber + 1, ae.toBlock = ie;
              const le = ae.toBlock - this._maxFilterBlockRange;
              le > ae.fromBlock && (ae.fromBlock = le), ae.fromBlock < 0 && (ae.fromBlock = 0);
              const he = this.getLogs(ae).then((me) => {
                fe._inflight = !1, me.length !== 0 && me.forEach((ye) => {
                  ye.blockNumber > fe._lastBlockNumber && (fe._lastBlockNumber = ye.blockNumber), this._emitted["b:" + ye.blockHash] = ye.blockNumber, this._emitted["t:" + ye.transactionHash] = ye.blockNumber, this.emit(ae, ye);
                });
              }).catch((me) => {
                this.emit("error", me), fe._inflight = !1;
              });
              n.push(he);
            }
            break;
          }
        }
      }), this._lastBlockNumber = ie, Promise.all(n).then(() => {
        this.emit("didPoll", t);
      }).catch((fe) => {
        this.emit("error", fe);
      });
    });
  }
  // Deprecated; do not use this
  resetEventsBlock(t) {
    this._lastBlockNumber = t - 1, this.polling && this.poll();
  }
  get network() {
    return this._network;
  }
  // This method should query the network if the underlying network
  // can change, such as when connected to a JSON-RPC backend
  detectNetwork() {
    return __awaiter$c(this, void 0, void 0, function* () {
      return logger$4.throwError("provider does not support network detection", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "provider.detectNetwork"
      });
    });
  }
  getNetwork() {
    return __awaiter$c(this, void 0, void 0, function* () {
      const t = yield this._ready(), n = yield this.detectNetwork();
      if (t.chainId !== n.chainId) {
        if (this.anyNetwork)
          return this._network = n, this._lastBlockNumber = -2, this._fastBlockNumber = null, this._fastBlockNumberPromise = null, this._fastQueryDate = 0, this._emitted.block = -2, this._maxInternalBlockNumber = -1024, this._internalBlockNumber = null, this.emit("network", n, t), yield stall(0), this._network;
        const ie = logger$4.makeError("underlying network changed", Logger.errors.NETWORK_ERROR, {
          event: "changed",
          network: t,
          detectedNetwork: n
        });
        throw this.emit("error", ie), ie;
      }
      return t;
    });
  }
  get blockNumber() {
    return this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((t) => {
      this._setFastBlockNumber(t);
    }, (t) => {
    }), this._fastBlockNumber != null ? this._fastBlockNumber : -1;
  }
  get polling() {
    return this._poller != null;
  }
  set polling(t) {
    t && !this._poller ? (this._poller = setInterval(() => {
      this.poll();
    }, this.pollingInterval), this._bootstrapPoll || (this._bootstrapPoll = setTimeout(() => {
      this.poll(), this._bootstrapPoll = setTimeout(() => {
        this._poller || this.poll(), this._bootstrapPoll = null;
      }, this.pollingInterval);
    }, 0))) : !t && this._poller && (clearInterval(this._poller), this._poller = null);
  }
  get pollingInterval() {
    return this._pollingInterval;
  }
  set pollingInterval(t) {
    if (typeof t != "number" || t <= 0 || parseInt(String(t)) != t)
      throw new Error("invalid polling interval");
    this._pollingInterval = t, this._poller && (clearInterval(this._poller), this._poller = setInterval(() => {
      this.poll();
    }, this._pollingInterval));
  }
  _getFastBlockNumber() {
    const t = getTime();
    return t - this._fastQueryDate > 2 * this._pollingInterval && (this._fastQueryDate = t, this._fastBlockNumberPromise = this.getBlockNumber().then((n) => ((this._fastBlockNumber == null || n > this._fastBlockNumber) && (this._fastBlockNumber = n), this._fastBlockNumber))), this._fastBlockNumberPromise;
  }
  _setFastBlockNumber(t) {
    this._fastBlockNumber != null && t < this._fastBlockNumber || (this._fastQueryDate = getTime(), (this._fastBlockNumber == null || t > this._fastBlockNumber) && (this._fastBlockNumber = t, this._fastBlockNumberPromise = Promise.resolve(t)));
  }
  waitForTransaction(t, n, ie) {
    return __awaiter$c(this, void 0, void 0, function* () {
      return this._waitForTransaction(t, n ?? 1, ie || 0, null);
    });
  }
  _waitForTransaction(t, n, ie, fe) {
    return __awaiter$c(this, void 0, void 0, function* () {
      const ae = yield this.getTransactionReceipt(t);
      return (ae ? ae.confirmations : 0) >= n ? ae : new Promise((le, he) => {
        const me = [];
        let ye = !1;
        const be = function() {
          return ye ? !0 : (ye = !0, me.forEach((Se) => {
            Se();
          }), !1);
        }, Ae = (Se) => {
          Se.confirmations < n || be() || le(Se);
        };
        if (this.on(t, Ae), me.push(() => {
          this.removeListener(t, Ae);
        }), fe) {
          let Se = fe.startBlock, $e = null;
          const Re = (Me) => __awaiter$c(this, void 0, void 0, function* () {
            ye || (yield stall(1e3), this.getTransactionCount(fe.from).then((ke) => __awaiter$c(this, void 0, void 0, function* () {
              if (!ye) {
                if (ke <= fe.nonce)
                  Se = Me;
                else {
                  {
                    const Te = yield this.getTransaction(t);
                    if (Te && Te.blockNumber != null)
                      return;
                  }
                  for ($e == null && ($e = Se - 3, $e < fe.startBlock && ($e = fe.startBlock)); $e <= Me; ) {
                    if (ye)
                      return;
                    const Te = yield this.getBlockWithTransactions($e);
                    for (let Ie = 0; Ie < Te.transactions.length; Ie++) {
                      const qe = Te.transactions[Ie];
                      if (qe.hash === t)
                        return;
                      if (qe.from === fe.from && qe.nonce === fe.nonce) {
                        if (ye)
                          return;
                        const Ue = yield this.waitForTransaction(qe.hash, n);
                        if (be())
                          return;
                        let ze = "replaced";
                        qe.data === fe.data && qe.to === fe.to && qe.value.eq(fe.value) ? ze = "repriced" : qe.data === "0x" && qe.from === qe.to && qe.value.isZero() && (ze = "cancelled"), he(logger$4.makeError("transaction was replaced", Logger.errors.TRANSACTION_REPLACED, {
                          cancelled: ze === "replaced" || ze === "cancelled",
                          reason: ze,
                          replacement: this._wrapTransaction(qe),
                          hash: t,
                          receipt: Ue
                        }));
                        return;
                      }
                    }
                    $e++;
                  }
                }
                ye || this.once("block", Re);
              }
            }), (ke) => {
              ye || this.once("block", Re);
            }));
          });
          if (ye)
            return;
          this.once("block", Re), me.push(() => {
            this.removeListener("block", Re);
          });
        }
        if (typeof ie == "number" && ie > 0) {
          const Se = setTimeout(() => {
            be() || he(logger$4.makeError("timeout exceeded", Logger.errors.TIMEOUT, { timeout: ie }));
          }, ie);
          Se.unref && Se.unref(), me.push(() => {
            clearTimeout(Se);
          });
        }
      });
    });
  }
  getBlockNumber() {
    return __awaiter$c(this, void 0, void 0, function* () {
      return this._getInternalBlockNumber(0);
    });
  }
  getGasPrice() {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const t = yield this.perform("getGasPrice", {});
      try {
        return BigNumber.from(t);
      } catch (n) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getGasPrice",
          result: t,
          error: n
        });
      }
    });
  }
  getBalance(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const ie = yield resolveProperties({
        address: this._getAddress(t),
        blockTag: this._getBlockTag(n)
      }), fe = yield this.perform("getBalance", ie);
      try {
        return BigNumber.from(fe);
      } catch (ae) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getBalance",
          params: ie,
          result: fe,
          error: ae
        });
      }
    });
  }
  getTransactionCount(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const ie = yield resolveProperties({
        address: this._getAddress(t),
        blockTag: this._getBlockTag(n)
      }), fe = yield this.perform("getTransactionCount", ie);
      try {
        return BigNumber.from(fe).toNumber();
      } catch (ae) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getTransactionCount",
          params: ie,
          result: fe,
          error: ae
        });
      }
    });
  }
  getCode(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const ie = yield resolveProperties({
        address: this._getAddress(t),
        blockTag: this._getBlockTag(n)
      }), fe = yield this.perform("getCode", ie);
      try {
        return hexlify(fe);
      } catch (ae) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getCode",
          params: ie,
          result: fe,
          error: ae
        });
      }
    });
  }
  getStorageAt(t, n, ie) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const fe = yield resolveProperties({
        address: this._getAddress(t),
        blockTag: this._getBlockTag(ie),
        position: Promise.resolve(n).then((le) => hexValue(le))
      }), ae = yield this.perform("getStorageAt", fe);
      try {
        return hexlify(ae);
      } catch (le) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "getStorageAt",
          params: fe,
          result: ae,
          error: le
        });
      }
    });
  }
  // This should be called by any subclass wrapping a TransactionResponse
  _wrapTransaction(t, n, ie) {
    if (n != null && hexDataLength(n) !== 32)
      throw new Error("invalid response - sendTransaction");
    const fe = t;
    return n != null && t.hash !== n && logger$4.throwError("Transaction hash mismatch from Provider.sendTransaction.", Logger.errors.UNKNOWN_ERROR, { expectedHash: t.hash, returnedHash: n }), fe.wait = (ae, le) => __awaiter$c(this, void 0, void 0, function* () {
      ae == null && (ae = 1), le == null && (le = 0);
      let he;
      ae !== 0 && ie != null && (he = {
        data: t.data,
        from: t.from,
        nonce: t.nonce,
        to: t.to,
        value: t.value,
        startBlock: ie
      });
      const me = yield this._waitForTransaction(t.hash, ae, le, he);
      return me == null && ae === 0 ? null : (this._emitted["t:" + t.hash] = me.blockNumber, me.status === 0 && logger$4.throwError("transaction failed", Logger.errors.CALL_EXCEPTION, {
        transactionHash: t.hash,
        transaction: t,
        receipt: me
      }), me);
    }), fe;
  }
  sendTransaction(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield Promise.resolve(t).then((ae) => hexlify(ae)), ie = this.formatter.transaction(t);
      ie.confirmations == null && (ie.confirmations = 0);
      const fe = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
      try {
        const ae = yield this.perform("sendTransaction", { signedTransaction: n });
        return this._wrapTransaction(ie, ae, fe);
      } catch (ae) {
        throw ae.transaction = ie, ae.transactionHash = ie.hash, ae;
      }
    });
  }
  _getTransactionRequest(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      const n = yield t, ie = {};
      return ["from", "to"].forEach((fe) => {
        n[fe] != null && (ie[fe] = Promise.resolve(n[fe]).then((ae) => ae ? this._getAddress(ae) : null));
      }), ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((fe) => {
        n[fe] != null && (ie[fe] = Promise.resolve(n[fe]).then((ae) => ae ? BigNumber.from(ae) : null));
      }), ["type"].forEach((fe) => {
        n[fe] != null && (ie[fe] = Promise.resolve(n[fe]).then((ae) => ae ?? null));
      }), n.accessList && (ie.accessList = this.formatter.accessList(n.accessList)), ["data"].forEach((fe) => {
        n[fe] != null && (ie[fe] = Promise.resolve(n[fe]).then((ae) => ae ? hexlify(ae) : null));
      }), this.formatter.transactionRequest(yield resolveProperties(ie));
    });
  }
  _getFilter(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      t = yield t;
      const n = {};
      return t.address != null && (n.address = this._getAddress(t.address)), ["blockHash", "topics"].forEach((ie) => {
        t[ie] != null && (n[ie] = t[ie]);
      }), ["fromBlock", "toBlock"].forEach((ie) => {
        t[ie] != null && (n[ie] = this._getBlockTag(t[ie]));
      }), this.formatter.filter(yield resolveProperties(n));
    });
  }
  _call(t, n, ie) {
    return __awaiter$c(this, void 0, void 0, function* () {
      ie >= MAX_CCIP_REDIRECTS && logger$4.throwError("CCIP read exceeded maximum redirections", Logger.errors.SERVER_ERROR, {
        redirects: ie,
        transaction: t
      });
      const fe = t.to, ae = yield this.perform("call", { transaction: t, blockTag: n });
      if (ie >= 0 && n === "latest" && fe != null && ae.substring(0, 10) === "0x556f1830" && hexDataLength(ae) % 32 === 4)
        try {
          const le = hexDataSlice(ae, 4), he = hexDataSlice(le, 0, 32);
          BigNumber.from(he).eq(fe) || logger$4.throwError("CCIP Read sender did not match", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: t,
            data: ae
          });
          const me = [], ye = BigNumber.from(hexDataSlice(le, 32, 64)).toNumber(), be = BigNumber.from(hexDataSlice(le, ye, ye + 32)).toNumber(), Ae = hexDataSlice(le, ye + 32);
          for (let Te = 0; Te < be; Te++) {
            const Ie = _parseString(Ae, Te * 32);
            Ie == null && logger$4.throwError("CCIP Read contained corrupt URL string", Logger.errors.CALL_EXCEPTION, {
              name: "OffchainLookup",
              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
              transaction: t,
              data: ae
            }), me.push(Ie);
          }
          const Se = _parseBytes(le, 64);
          BigNumber.from(hexDataSlice(le, 100, 128)).isZero() || logger$4.throwError("CCIP Read callback selector included junk", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: t,
            data: ae
          });
          const $e = hexDataSlice(le, 96, 100), Re = _parseBytes(le, 128), Me = yield this.ccipReadFetch(t, Se, me);
          Me == null && logger$4.throwError("CCIP Read disabled or provided no URLs", Logger.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: t,
            data: ae
          });
          const ke = {
            to: fe,
            data: hexConcat([$e, encodeBytes([Me, Re])])
          };
          return this._call(ke, n, ie + 1);
        } catch (le) {
          if (le.code === Logger.errors.SERVER_ERROR)
            throw le;
        }
      try {
        return hexlify(ae);
      } catch (le) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "call",
          params: { transaction: t, blockTag: n },
          result: ae,
          error: le
        });
      }
    });
  }
  call(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const ie = yield resolveProperties({
        transaction: this._getTransactionRequest(t),
        blockTag: this._getBlockTag(n),
        ccipReadEnabled: Promise.resolve(t.ccipReadEnabled)
      });
      return this._call(ie.transaction, ie.blockTag, ie.ccipReadEnabled ? 0 : -1);
    });
  }
  estimateGas(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield resolveProperties({
        transaction: this._getTransactionRequest(t)
      }), ie = yield this.perform("estimateGas", n);
      try {
        return BigNumber.from(ie);
      } catch (fe) {
        return logger$4.throwError("bad result from backend", Logger.errors.SERVER_ERROR, {
          method: "estimateGas",
          params: n,
          result: ie,
          error: fe
        });
      }
    });
  }
  _getAddress(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      t = yield t, typeof t != "string" && logger$4.throwArgumentError("invalid address or ENS name", "name", t);
      const n = yield this.resolveName(t);
      return n == null && logger$4.throwError("ENS name not configured", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: `resolveName(${JSON.stringify(t)})`
      }), n;
    });
  }
  _getBlock(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork(), t = yield t;
      let ie = -128;
      const fe = {
        includeTransactions: !!n
      };
      if (isHexString(t, 32))
        fe.blockHash = t;
      else
        try {
          fe.blockTag = yield this._getBlockTag(t), isHexString(fe.blockTag) && (ie = parseInt(fe.blockTag.substring(2), 16));
        } catch {
          logger$4.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", t);
        }
      return poll(() => __awaiter$c(this, void 0, void 0, function* () {
        const ae = yield this.perform("getBlock", fe);
        if (ae == null)
          return fe.blockHash != null && this._emitted["b:" + fe.blockHash] == null || fe.blockTag != null && ie > this._emitted.block ? null : void 0;
        if (n) {
          let le = null;
          for (let me = 0; me < ae.transactions.length; me++) {
            const ye = ae.transactions[me];
            if (ye.blockNumber == null)
              ye.confirmations = 0;
            else if (ye.confirmations == null) {
              le == null && (le = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval));
              let be = le - ye.blockNumber + 1;
              be <= 0 && (be = 1), ye.confirmations = be;
            }
          }
          const he = this.formatter.blockWithTransactions(ae);
          return he.transactions = he.transactions.map((me) => this._wrapTransaction(me)), he;
        }
        return this.formatter.block(ae);
      }), { oncePoll: this });
    });
  }
  getBlock(t) {
    return this._getBlock(t, !1);
  }
  getBlockWithTransactions(t) {
    return this._getBlock(t, !0);
  }
  getTransaction(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork(), t = yield t;
      const n = { transactionHash: this.formatter.hash(t, !0) };
      return poll(() => __awaiter$c(this, void 0, void 0, function* () {
        const ie = yield this.perform("getTransaction", n);
        if (ie == null)
          return this._emitted["t:" + t] == null ? null : void 0;
        const fe = this.formatter.transactionResponse(ie);
        if (fe.blockNumber == null)
          fe.confirmations = 0;
        else if (fe.confirmations == null) {
          let le = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - fe.blockNumber + 1;
          le <= 0 && (le = 1), fe.confirmations = le;
        }
        return this._wrapTransaction(fe);
      }), { oncePoll: this });
    });
  }
  getTransactionReceipt(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork(), t = yield t;
      const n = { transactionHash: this.formatter.hash(t, !0) };
      return poll(() => __awaiter$c(this, void 0, void 0, function* () {
        const ie = yield this.perform("getTransactionReceipt", n);
        if (ie == null)
          return this._emitted["t:" + t] == null ? null : void 0;
        if (ie.blockHash == null)
          return;
        const fe = this.formatter.receipt(ie);
        if (fe.blockNumber == null)
          fe.confirmations = 0;
        else if (fe.confirmations == null) {
          let le = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - fe.blockNumber + 1;
          le <= 0 && (le = 1), fe.confirmations = le;
        }
        return fe;
      }), { oncePoll: this });
    });
  }
  getLogs(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield resolveProperties({ filter: this._getFilter(t) }), ie = yield this.perform("getLogs", n);
      return ie.forEach((fe) => {
        fe.removed == null && (fe.removed = !1);
      }), Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(ie);
    });
  }
  getEtherPrice() {
    return __awaiter$c(this, void 0, void 0, function* () {
      return yield this.getNetwork(), this.perform("getEtherPrice", {});
    });
  }
  _getBlockTag(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      if (t = yield t, typeof t == "number" && t < 0) {
        t % 1 && logger$4.throwArgumentError("invalid BlockTag", "blockTag", t);
        let n = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
        return n += t, n < 0 && (n = 0), this.formatter.blockTag(n);
      }
      return this.formatter.blockTag(t);
    });
  }
  getResolver(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      let n = t;
      for (; ; ) {
        if (n === "" || n === "." || t !== "eth" && n === "eth")
          return null;
        const ie = yield this._getResolver(n, "getResolver");
        if (ie != null) {
          const fe = new Resolver(this, ie, t);
          return n !== t && !(yield fe.supportsWildcard()) ? null : fe;
        }
        n = n.split(".").slice(1).join(".");
      }
    });
  }
  _getResolver(t, n) {
    return __awaiter$c(this, void 0, void 0, function* () {
      n == null && (n = "ENS");
      const ie = yield this.getNetwork();
      ie.ensAddress || logger$4.throwError("network does not support ENS", Logger.errors.UNSUPPORTED_OPERATION, { operation: n, network: ie.name });
      try {
        const fe = yield this.call({
          to: ie.ensAddress,
          data: "0x0178b8bf" + namehash$1(t).substring(2)
        });
        return this.formatter.callAddress(fe);
      } catch {
      }
      return null;
    });
  }
  resolveName(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      t = yield t;
      try {
        return Promise.resolve(this.formatter.address(t));
      } catch (ie) {
        if (isHexString(t))
          throw ie;
      }
      typeof t != "string" && logger$4.throwArgumentError("invalid ENS name", "name", t);
      const n = yield this.getResolver(t);
      return n ? yield n.getAddress() : null;
    });
  }
  lookupAddress(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      t = yield t, t = this.formatter.address(t);
      const n = t.substring(2).toLowerCase() + ".addr.reverse", ie = yield this._getResolver(n, "lookupAddress");
      if (ie == null)
        return null;
      const fe = _parseString(yield this.call({
        to: ie,
        data: "0x691f3431" + namehash$1(n).substring(2)
      }), 0);
      return (yield this.resolveName(fe)) != t ? null : fe;
    });
  }
  getAvatar(t) {
    return __awaiter$c(this, void 0, void 0, function* () {
      let n = null;
      if (isHexString(t)) {
        const ae = this.formatter.address(t).substring(2).toLowerCase() + ".addr.reverse", le = yield this._getResolver(ae, "getAvatar");
        if (!le)
          return null;
        n = new Resolver(this, le, ae);
        try {
          const he = yield n.getAvatar();
          if (he)
            return he.url;
        } catch (he) {
          if (he.code !== Logger.errors.CALL_EXCEPTION)
            throw he;
        }
        try {
          const he = _parseString(yield this.call({
            to: le,
            data: "0x691f3431" + namehash$1(ae).substring(2)
          }), 0);
          n = yield this.getResolver(he);
        } catch (he) {
          if (he.code !== Logger.errors.CALL_EXCEPTION)
            throw he;
          return null;
        }
      } else if (n = yield this.getResolver(t), !n)
        return null;
      const ie = yield n.getAvatar();
      return ie == null ? null : ie.url;
    });
  }
  perform(t, n) {
    return logger$4.throwError(t + " not implemented", Logger.errors.NOT_IMPLEMENTED, { operation: t });
  }
  _startEvent(t) {
    this.polling = this._events.filter((n) => n.pollable()).length > 0;
  }
  _stopEvent(t) {
    this.polling = this._events.filter((n) => n.pollable()).length > 0;
  }
  _addEventListener(t, n, ie) {
    const fe = new Event(getEventTag(t), n, ie);
    return this._events.push(fe), this._startEvent(fe), this;
  }
  on(t, n) {
    return this._addEventListener(t, n, !1);
  }
  once(t, n) {
    return this._addEventListener(t, n, !0);
  }
  emit(t, ...n) {
    let ie = !1, fe = [], ae = getEventTag(t);
    return this._events = this._events.filter((le) => le.tag !== ae ? !0 : (setTimeout(() => {
      le.listener.apply(this, n);
    }, 0), ie = !0, le.once ? (fe.push(le), !1) : !0)), fe.forEach((le) => {
      this._stopEvent(le);
    }), ie;
  }
  listenerCount(t) {
    if (!t)
      return this._events.length;
    let n = getEventTag(t);
    return this._events.filter((ie) => ie.tag === n).length;
  }
  listeners(t) {
    if (t == null)
      return this._events.map((ie) => ie.listener);
    let n = getEventTag(t);
    return this._events.filter((ie) => ie.tag === n).map((ie) => ie.listener);
  }
  off(t, n) {
    if (n == null)
      return this.removeAllListeners(t);
    const ie = [];
    let fe = !1, ae = getEventTag(t);
    return this._events = this._events.filter((le) => le.tag !== ae || le.listener != n || fe ? !0 : (fe = !0, ie.push(le), !1)), ie.forEach((le) => {
      this._stopEvent(le);
    }), this;
  }
  removeAllListeners(t) {
    let n = [];
    if (t == null)
      n = this._events, this._events = [];
    else {
      const ie = getEventTag(t);
      this._events = this._events.filter((fe) => fe.tag !== ie ? !0 : (n.push(fe), !1));
    }
    return n.forEach((ie) => {
      this._stopEvent(ie);
    }), this;
  }
}
var __awaiter$b = function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
};
const logger$3 = new Logger(version$9), errorGas = ["call", "estimateGas"];
function spelunk(c, t) {
  if (c == null)
    return null;
  if (typeof c.message == "string" && c.message.match("reverted")) {
    const n = isHexString(c.data) ? c.data : null;
    if (!t || n)
      return { message: c.message, data: n };
  }
  if (typeof c == "object") {
    for (const n in c) {
      const ie = spelunk(c[n], t);
      if (ie)
        return ie;
    }
    return null;
  }
  if (typeof c == "string")
    try {
      return spelunk(JSON.parse(c), t);
    } catch {
    }
  return null;
}
function checkError(c, t, n) {
  const ie = n.transaction || n.signedTransaction;
  if (c === "call") {
    const ae = spelunk(t, !0);
    if (ae)
      return ae.data;
    logger$3.throwError("missing revert data in call exception; Transaction reverted without a reason string", Logger.errors.CALL_EXCEPTION, {
      data: "0x",
      transaction: ie,
      error: t
    });
  }
  if (c === "estimateGas") {
    let ae = spelunk(t.body, !1);
    ae == null && (ae = spelunk(t, !1)), ae && logger$3.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
      reason: ae.message,
      method: c,
      transaction: ie,
      error: t
    });
  }
  let fe = t.message;
  throw t.code === Logger.errors.SERVER_ERROR && t.error && typeof t.error.message == "string" ? fe = t.error.message : typeof t.body == "string" ? fe = t.body : typeof t.responseText == "string" && (fe = t.responseText), fe = (fe || "").toLowerCase(), fe.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i) && logger$3.throwError("insufficient funds for intrinsic transaction cost", Logger.errors.INSUFFICIENT_FUNDS, {
    error: t,
    method: c,
    transaction: ie
  }), fe.match(/nonce (is )?too low/i) && logger$3.throwError("nonce has already been used", Logger.errors.NONCE_EXPIRED, {
    error: t,
    method: c,
    transaction: ie
  }), fe.match(/replacement transaction underpriced|transaction gas price.*too low/i) && logger$3.throwError("replacement fee too low", Logger.errors.REPLACEMENT_UNDERPRICED, {
    error: t,
    method: c,
    transaction: ie
  }), fe.match(/only replay-protected/i) && logger$3.throwError("legacy pre-eip-155 transactions not supported", Logger.errors.UNSUPPORTED_OPERATION, {
    error: t,
    method: c,
    transaction: ie
  }), errorGas.indexOf(c) >= 0 && fe.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/) && logger$3.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
    error: t,
    method: c,
    transaction: ie
  }), t;
}
function timer(c) {
  return new Promise(function(t) {
    setTimeout(t, c);
  });
}
function getResult(c) {
  if (c.error) {
    const t = new Error(c.error.message);
    throw t.code = c.error.code, t.data = c.error.data, t;
  }
  return c.result;
}
function getLowerCase(c) {
  return c && c.toLowerCase();
}
const _constructorGuard = {};
class JsonRpcSigner extends Signer {
  constructor(t, n, ie) {
    if (super(), t !== _constructorGuard)
      throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
    defineReadOnly(this, "provider", n), ie == null && (ie = 0), typeof ie == "string" ? (defineReadOnly(this, "_address", this.provider.formatter.address(ie)), defineReadOnly(this, "_index", null)) : typeof ie == "number" ? (defineReadOnly(this, "_index", ie), defineReadOnly(this, "_address", null)) : logger$3.throwArgumentError("invalid address or index", "addressOrIndex", ie);
  }
  connect(t) {
    return logger$3.throwError("cannot alter JSON-RPC Signer connection", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "connect"
    });
  }
  connectUnchecked() {
    return new UncheckedJsonRpcSigner(_constructorGuard, this.provider, this._address || this._index);
  }
  getAddress() {
    return this._address ? Promise.resolve(this._address) : this.provider.send("eth_accounts", []).then((t) => (t.length <= this._index && logger$3.throwError("unknown account #" + this._index, Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "getAddress"
    }), this.provider.formatter.address(t[this._index])));
  }
  sendUncheckedTransaction(t) {
    t = shallowCopy(t);
    const n = this.getAddress().then((ie) => (ie && (ie = ie.toLowerCase()), ie));
    if (t.gasLimit == null) {
      const ie = shallowCopy(t);
      ie.from = n, t.gasLimit = this.provider.estimateGas(ie);
    }
    return t.to != null && (t.to = Promise.resolve(t.to).then((ie) => __awaiter$b(this, void 0, void 0, function* () {
      if (ie == null)
        return null;
      const fe = yield this.provider.resolveName(ie);
      return fe == null && logger$3.throwArgumentError("provided ENS name resolves to null", "tx.to", ie), fe;
    }))), resolveProperties({
      tx: resolveProperties(t),
      sender: n
    }).then(({ tx: ie, sender: fe }) => {
      ie.from != null ? ie.from.toLowerCase() !== fe && logger$3.throwArgumentError("from address mismatch", "transaction", t) : ie.from = fe;
      const ae = this.provider.constructor.hexlifyTransaction(ie, { from: !0 });
      return this.provider.send("eth_sendTransaction", [ae]).then((le) => le, (le) => (typeof le.message == "string" && le.message.match(/user denied/i) && logger$3.throwError("user rejected transaction", Logger.errors.ACTION_REJECTED, {
        action: "sendTransaction",
        transaction: ie
      }), checkError("sendTransaction", le, ae)));
    });
  }
  signTransaction(t) {
    return logger$3.throwError("signing transactions is unsupported", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "signTransaction"
    });
  }
  sendTransaction(t) {
    return __awaiter$b(this, void 0, void 0, function* () {
      const n = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval), ie = yield this.sendUncheckedTransaction(t);
      try {
        return yield poll(() => __awaiter$b(this, void 0, void 0, function* () {
          const fe = yield this.provider.getTransaction(ie);
          if (fe !== null)
            return this.provider._wrapTransaction(fe, ie, n);
        }), { oncePoll: this.provider });
      } catch (fe) {
        throw fe.transactionHash = ie, fe;
      }
    });
  }
  signMessage(t) {
    return __awaiter$b(this, void 0, void 0, function* () {
      const n = typeof t == "string" ? toUtf8Bytes(t) : t, ie = yield this.getAddress();
      try {
        return yield this.provider.send("personal_sign", [hexlify(n), ie.toLowerCase()]);
      } catch (fe) {
        throw typeof fe.message == "string" && fe.message.match(/user denied/i) && logger$3.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "signMessage",
          from: ie,
          messageData: t
        }), fe;
      }
    });
  }
  _legacySignMessage(t) {
    return __awaiter$b(this, void 0, void 0, function* () {
      const n = typeof t == "string" ? toUtf8Bytes(t) : t, ie = yield this.getAddress();
      try {
        return yield this.provider.send("eth_sign", [ie.toLowerCase(), hexlify(n)]);
      } catch (fe) {
        throw typeof fe.message == "string" && fe.message.match(/user denied/i) && logger$3.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "_legacySignMessage",
          from: ie,
          messageData: t
        }), fe;
      }
    });
  }
  _signTypedData(t, n, ie) {
    return __awaiter$b(this, void 0, void 0, function* () {
      const fe = yield TypedDataEncoder.resolveNames(t, n, ie, (le) => this.provider.resolveName(le)), ae = yield this.getAddress();
      try {
        return yield this.provider.send("eth_signTypedData_v4", [
          ae.toLowerCase(),
          JSON.stringify(TypedDataEncoder.getPayload(fe.domain, n, fe.value))
        ]);
      } catch (le) {
        throw typeof le.message == "string" && le.message.match(/user denied/i) && logger$3.throwError("user rejected signing", Logger.errors.ACTION_REJECTED, {
          action: "_signTypedData",
          from: ae,
          messageData: { domain: fe.domain, types: n, value: fe.value }
        }), le;
      }
    });
  }
  unlock(t) {
    return __awaiter$b(this, void 0, void 0, function* () {
      const n = this.provider, ie = yield this.getAddress();
      return n.send("personal_unlockAccount", [ie.toLowerCase(), t, null]);
    });
  }
}
class UncheckedJsonRpcSigner extends JsonRpcSigner {
  sendTransaction(t) {
    return this.sendUncheckedTransaction(t).then((n) => ({
      hash: n,
      nonce: null,
      gasLimit: null,
      gasPrice: null,
      data: null,
      value: null,
      chainId: null,
      confirmations: 0,
      from: null,
      wait: (ie) => this.provider.waitForTransaction(n, ie)
    }));
  }
}
const allowedTransactionKeys = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0
};
class JsonRpcProvider extends BaseProvider {
  constructor(t, n) {
    let ie = n;
    ie == null && (ie = new Promise((fe, ae) => {
      setTimeout(() => {
        this.detectNetwork().then((le) => {
          fe(le);
        }, (le) => {
          ae(le);
        });
      }, 0);
    })), super(ie), t || (t = getStatic(this.constructor, "defaultUrl")()), typeof t == "string" ? defineReadOnly(this, "connection", Object.freeze({
      url: t
    })) : defineReadOnly(this, "connection", Object.freeze(shallowCopy(t))), this._nextId = 42;
  }
  get _cache() {
    return this._eventLoopCache == null && (this._eventLoopCache = {}), this._eventLoopCache;
  }
  static defaultUrl() {
    return "http://localhost:8545";
  }
  detectNetwork() {
    return this._cache.detectNetwork || (this._cache.detectNetwork = this._uncachedDetectNetwork(), setTimeout(() => {
      this._cache.detectNetwork = null;
    }, 0)), this._cache.detectNetwork;
  }
  _uncachedDetectNetwork() {
    return __awaiter$b(this, void 0, void 0, function* () {
      yield timer(0);
      let t = null;
      try {
        t = yield this.send("eth_chainId", []);
      } catch {
        try {
          t = yield this.send("net_version", []);
        } catch {
        }
      }
      if (t != null) {
        const n = getStatic(this.constructor, "getNetwork");
        try {
          return n(BigNumber.from(t).toNumber());
        } catch (ie) {
          return logger$3.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
            chainId: t,
            event: "invalidNetwork",
            serverError: ie
          });
        }
      }
      return logger$3.throwError("could not detect network", Logger.errors.NETWORK_ERROR, {
        event: "noNetwork"
      });
    });
  }
  getSigner(t) {
    return new JsonRpcSigner(_constructorGuard, this, t);
  }
  getUncheckedSigner(t) {
    return this.getSigner(t).connectUnchecked();
  }
  listAccounts() {
    return this.send("eth_accounts", []).then((t) => t.map((n) => this.formatter.address(n)));
  }
  send(t, n) {
    const ie = {
      method: t,
      params: n,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    this.emit("debug", {
      action: "request",
      request: deepCopy(ie),
      provider: this
    });
    const fe = ["eth_chainId", "eth_blockNumber"].indexOf(t) >= 0;
    if (fe && this._cache[t])
      return this._cache[t];
    const ae = fetchJson(this.connection, JSON.stringify(ie), getResult).then((le) => (this.emit("debug", {
      action: "response",
      request: ie,
      response: le,
      provider: this
    }), le), (le) => {
      throw this.emit("debug", {
        action: "response",
        error: le,
        request: ie,
        provider: this
      }), le;
    });
    return fe && (this._cache[t] = ae, setTimeout(() => {
      this._cache[t] = null;
    }, 0)), ae;
  }
  prepareRequest(t, n) {
    switch (t) {
      case "getBlockNumber":
        return ["eth_blockNumber", []];
      case "getGasPrice":
        return ["eth_gasPrice", []];
      case "getBalance":
        return ["eth_getBalance", [getLowerCase(n.address), n.blockTag]];
      case "getTransactionCount":
        return ["eth_getTransactionCount", [getLowerCase(n.address), n.blockTag]];
      case "getCode":
        return ["eth_getCode", [getLowerCase(n.address), n.blockTag]];
      case "getStorageAt":
        return ["eth_getStorageAt", [getLowerCase(n.address), hexZeroPad(n.position, 32), n.blockTag]];
      case "sendTransaction":
        return ["eth_sendRawTransaction", [n.signedTransaction]];
      case "getBlock":
        return n.blockTag ? ["eth_getBlockByNumber", [n.blockTag, !!n.includeTransactions]] : n.blockHash ? ["eth_getBlockByHash", [n.blockHash, !!n.includeTransactions]] : null;
      case "getTransaction":
        return ["eth_getTransactionByHash", [n.transactionHash]];
      case "getTransactionReceipt":
        return ["eth_getTransactionReceipt", [n.transactionHash]];
      case "call":
        return ["eth_call", [getStatic(this.constructor, "hexlifyTransaction")(n.transaction, { from: !0 }), n.blockTag]];
      case "estimateGas":
        return ["eth_estimateGas", [getStatic(this.constructor, "hexlifyTransaction")(n.transaction, { from: !0 })]];
      case "getLogs":
        return n.filter && n.filter.address != null && (n.filter.address = getLowerCase(n.filter.address)), ["eth_getLogs", [n.filter]];
    }
    return null;
  }
  perform(t, n) {
    return __awaiter$b(this, void 0, void 0, function* () {
      if (t === "call" || t === "estimateGas") {
        const fe = n.transaction;
        if (fe && fe.type != null && BigNumber.from(fe.type).isZero() && fe.maxFeePerGas == null && fe.maxPriorityFeePerGas == null) {
          const ae = yield this.getFeeData();
          ae.maxFeePerGas == null && ae.maxPriorityFeePerGas == null && (n = shallowCopy(n), n.transaction = shallowCopy(fe), delete n.transaction.type);
        }
      }
      const ie = this.prepareRequest(t, n);
      ie == null && logger$3.throwError(t + " not implemented", Logger.errors.NOT_IMPLEMENTED, { operation: t });
      try {
        return yield this.send(ie[0], ie[1]);
      } catch (fe) {
        return checkError(t, fe, n);
      }
    });
  }
  _startEvent(t) {
    t.tag === "pending" && this._startPending(), super._startEvent(t);
  }
  _startPending() {
    if (this._pendingFilter != null)
      return;
    const t = this, n = this.send("eth_newPendingTransactionFilter", []);
    this._pendingFilter = n, n.then(function(ie) {
      function fe() {
        t.send("eth_getFilterChanges", [ie]).then(function(ae) {
          if (t._pendingFilter != n)
            return null;
          let le = Promise.resolve();
          return ae.forEach(function(he) {
            t._emitted["t:" + he.toLowerCase()] = "pending", le = le.then(function() {
              return t.getTransaction(he).then(function(me) {
                return t.emit("pending", me), null;
              });
            });
          }), le.then(function() {
            return timer(1e3);
          });
        }).then(function() {
          if (t._pendingFilter != n) {
            t.send("eth_uninstallFilter", [ie]);
            return;
          }
          return setTimeout(function() {
            fe();
          }, 0), null;
        }).catch((ae) => {
        });
      }
      return fe(), ie;
    }).catch((ie) => {
    });
  }
  _stopEvent(t) {
    t.tag === "pending" && this.listenerCount("pending") === 0 && (this._pendingFilter = null), super._stopEvent(t);
  }
  // Convert an ethers.js transaction into a JSON-RPC transaction
  //  - gasLimit => gas
  //  - All values hexlified
  //  - All numeric values zero-striped
  //  - All addresses are lowercased
  // NOTE: This allows a TransactionRequest, but all values should be resolved
  //       before this is called
  // @TODO: This will likely be removed in future versions and prepareRequest
  //        will be the preferred method for this.
  static hexlifyTransaction(t, n) {
    const ie = shallowCopy(allowedTransactionKeys);
    if (n)
      for (const ae in n)
        n[ae] && (ie[ae] = !0);
    checkProperties(t, ie);
    const fe = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function(ae) {
      if (t[ae] == null)
        return;
      const le = hexValue(BigNumber.from(t[ae]));
      ae === "gasLimit" && (ae = "gas"), fe[ae] = le;
    }), ["from", "to", "data"].forEach(function(ae) {
      t[ae] != null && (fe[ae] = hexlify(t[ae]));
    }), t.accessList && (fe.accessList = accessListify(t.accessList)), fe;
  }
}
const logger$2 = new Logger(version$9);
let _nextId = 1;
function buildWeb3LegacyFetcher(c, t) {
  const n = "Web3LegacyFetcher";
  return function(ie, fe) {
    const ae = {
      method: ie,
      params: fe,
      id: _nextId++,
      jsonrpc: "2.0"
    };
    return new Promise((le, he) => {
      this.emit("debug", {
        action: "request",
        fetcher: n,
        request: deepCopy(ae),
        provider: this
      }), t(ae, (me, ye) => {
        if (me)
          return this.emit("debug", {
            action: "response",
            fetcher: n,
            error: me,
            request: ae,
            provider: this
          }), he(me);
        if (this.emit("debug", {
          action: "response",
          fetcher: n,
          request: ae,
          response: ye,
          provider: this
        }), ye.error) {
          const be = new Error(ye.error.message);
          return be.code = ye.error.code, be.data = ye.error.data, he(be);
        }
        le(ye.result);
      });
    });
  };
}
function buildEip1193Fetcher(c) {
  return function(t, n) {
    n == null && (n = []);
    const ie = { method: t, params: n };
    return this.emit("debug", {
      action: "request",
      fetcher: "Eip1193Fetcher",
      request: deepCopy(ie),
      provider: this
    }), c.request(ie).then((fe) => (this.emit("debug", {
      action: "response",
      fetcher: "Eip1193Fetcher",
      request: ie,
      response: fe,
      provider: this
    }), fe), (fe) => {
      throw this.emit("debug", {
        action: "response",
        fetcher: "Eip1193Fetcher",
        request: ie,
        error: fe,
        provider: this
      }), fe;
    });
  };
}
class Web3Provider extends JsonRpcProvider {
  constructor(t, n) {
    t == null && logger$2.throwArgumentError("missing provider", "provider", t);
    let ie = null, fe = null, ae = null;
    typeof t == "function" ? (ie = "unknown:", fe = t) : (ie = t.host || t.path || "", !ie && t.isMetaMask && (ie = "metamask"), ae = t, t.request ? (ie === "" && (ie = "eip-1193:"), fe = buildEip1193Fetcher(t)) : t.sendAsync ? fe = buildWeb3LegacyFetcher(t, t.sendAsync.bind(t)) : t.send ? fe = buildWeb3LegacyFetcher(t, t.send.bind(t)) : logger$2.throwArgumentError("unsupported provider", "provider", t), ie || (ie = "unknown:")), super(ie, n), defineReadOnly(this, "jsonRpcFetchFunc", fe), defineReadOnly(this, "provider", ae);
  }
  send(t, n) {
    return this.jsonRpcFetchFunc(t, n);
  }
}
const version$8 = "solidity/5.7.0", regexBytes = new RegExp("^bytes([0-9]+)$"), regexNumber = new RegExp("^(u?int)([0-9]*)$"), regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$"), Zeros = "0000000000000000000000000000000000000000000000000000000000000000", logger$1 = new Logger(version$8);
function _pack(c, t, n) {
  switch (c) {
    case "address":
      return n ? zeroPad(t, 32) : arrayify(t);
    case "string":
      return toUtf8Bytes(t);
    case "bytes":
      return arrayify(t);
    case "bool":
      return t = t ? "0x01" : "0x00", n ? zeroPad(t, 32) : arrayify(t);
  }
  let ie = c.match(regexNumber);
  if (ie) {
    let fe = parseInt(ie[2] || "256");
    return (ie[2] && String(fe) !== ie[2] || fe % 8 !== 0 || fe === 0 || fe > 256) && logger$1.throwArgumentError("invalid number type", "type", c), n && (fe = 256), t = BigNumber.from(t).toTwos(fe), zeroPad(t, fe / 8);
  }
  if (ie = c.match(regexBytes), ie) {
    const fe = parseInt(ie[1]);
    return (String(fe) !== ie[1] || fe === 0 || fe > 32) && logger$1.throwArgumentError("invalid bytes type", "type", c), arrayify(t).byteLength !== fe && logger$1.throwArgumentError(`invalid value for ${c}`, "value", t), n ? arrayify((t + Zeros).substring(0, 66)) : t;
  }
  if (ie = c.match(regexArray), ie && Array.isArray(t)) {
    const fe = ie[1];
    parseInt(ie[2] || String(t.length)) != t.length && logger$1.throwArgumentError(`invalid array length for ${c}`, "value", t);
    const le = [];
    return t.forEach(function(he) {
      le.push(_pack(fe, he, !0));
    }), concat$1(le);
  }
  return logger$1.throwArgumentError("invalid type", "type", c);
}
function pack(c, t) {
  c.length != t.length && logger$1.throwArgumentError("wrong number of values; expected ${ types.length }", "values", t);
  const n = [];
  return c.forEach(function(ie, fe) {
    n.push(_pack(ie, t[fe]));
  }), hexlify(concat$1(n));
}
function keccak256(c, t) {
  return keccak256$1(pack(c, t));
}
function sha256$5(c, t) {
  return sha256$6(pack(c, t));
}
const lib_esm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  keccak256,
  pack,
  sha256: sha256$5
}, Symbol.toStringTag, { value: "Module" })), version$7 = "units/5.7.0", logger = new Logger(version$7), names$2 = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function commify(c) {
  const t = String(c).split(".");
  (t.length > 2 || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || c === "." || c === "-.") && logger.throwArgumentError("invalid value", "value", c);
  let n = t[0], ie = "";
  for (n.substring(0, 1) === "-" && (ie = "-", n = n.substring(1)); n.substring(0, 1) === "0"; )
    n = n.substring(1);
  n === "" && (n = "0");
  let fe = "";
  for (t.length === 2 && (fe = "." + (t[1] || "0")); fe.length > 2 && fe[fe.length - 1] === "0"; )
    fe = fe.substring(0, fe.length - 1);
  const ae = [];
  for (; n.length; )
    if (n.length <= 3) {
      ae.unshift(n);
      break;
    } else {
      const le = n.length - 3;
      ae.unshift(n.substring(le)), n = n.substring(0, le);
    }
  return ie + ae.join(",") + fe;
}
function formatUnits(c, t) {
  if (typeof t == "string") {
    const n = names$2.indexOf(t);
    n !== -1 && (t = 3 * n);
  }
  return formatFixed(c, t ?? 18);
}
function parseUnits(c, t) {
  if (typeof c != "string" && logger.throwArgumentError("value must be a string", "value", c), typeof t == "string") {
    const n = names$2.indexOf(t);
    n !== -1 && (t = 3 * n);
  }
  return parseFixed(c, t ?? 18);
}
function formatEther(c) {
  return formatUnits(c, 18);
}
function parseEther(c) {
  return parseUnits(c, 18);
}
const lib_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commify,
  formatEther,
  formatUnits,
  parseEther,
  parseUnits
}, Symbol.toStringTag, { value: "Module" }));
class defaultModal {
  waiting(t) {
    console.log(`Waiting: ${t}`);
  }
  success(t) {
    console.log(`Success: ${t}`);
  }
  error(t) {
    console.log(`Error: ${t}`);
  }
  close() {
    console.log("Close");
  }
}
const deployerABI = [
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "newFee",
        type: "uint256"
      }
    ],
    name: "DroplinkedFeeUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "newHeartBeat",
        type: "uint256"
      }
    ],
    name: "HeartBeatUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "shop",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "nftContract",
        type: "address"
      }
    ],
    name: "ShopDeployed",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes"
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32"
      }
    ],
    name: "deployShop",
    outputs: [
      {
        internalType: "address",
        name: "shop",
        type: "address"
      },
      {
        internalType: "address",
        name: "nftContract",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "droplinkedFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "droplinkedWallet",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getDroplinkedFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getHeartBeat",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "heartBeat",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_heartBeat",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_droplinkedWallet",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_droplinkedFee",
        type: "uint256"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "nftContracts",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shopOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "nftOwners",
    outputs: [
      {
        internalType: "address",
        name: "nftContracts",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256"
      }
    ],
    name: "setDroplinkedFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newHeartBeat",
        type: "uint256"
      }
    ],
    name: "setHeartBeat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "shopAddresses",
    outputs: [
      {
        internalType: "contract IDropShop",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "shopCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shopOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "shopOwners",
    outputs: [
      {
        internalType: "address",
        name: "shops",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], shopABI = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_shopName",
        type: "string"
      },
      {
        internalType: "string",
        name: "_shopAddress",
        type: "string"
      },
      {
        internalType: "address",
        name: "_shopOwner",
        type: "address"
      },
      {
        internalType: "string",
        name: "_shopLogo",
        type: "string"
      },
      {
        internalType: "string",
        name: "_shopDescription",
        type: "string"
      },
      {
        internalType: "address",
        name: "_deployer",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "AccessDenied",
    type: "error"
  },
  {
    inputs: [],
    name: "AffiliatePOD",
    type: "error"
  },
  {
    inputs: [],
    name: "AlreadyClaimed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "AlreadyRequested",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "producer",
        type: "address"
      }
    ],
    name: "NotEnoughTokens",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "ProductDoesntExist",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "ProductExists",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestAlreadyConfirmed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestDoesntExist",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestNotConfirmed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "nftAddress",
        type: "address"
      }
    ],
    name: "ShopDoesNotOwnToken",
    type: "error"
  },
  {
    inputs: [],
    name: "oldPrice",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approver",
        type: "address"
      }
    ],
    name: "AffiliateRequestApproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "disapprover",
        type: "address"
      }
    ],
    name: "AffiliateRequestDisapproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "AffiliateRequested",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "claimer",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ProductClaimed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "ProductRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "ProductUnregistered",
    type: "event"
  },
  {
    inputs: [],
    name: "_shopInfo",
    outputs: [
      {
        internalType: "string",
        name: "shopName",
        type: "string"
      },
      {
        internalType: "string",
        name: "shopAddress",
        type: "string"
      },
      {
        internalType: "string",
        name: "shopLogo",
        type: "string"
      },
      {
        internalType: "string",
        name: "shopDescription",
        type: "string"
      },
      {
        internalType: "address",
        name: "shopOwner",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "affiliateRequestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "affiliateRequests",
    outputs: [
      {
        internalType: "address",
        name: "publisher",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "isConfirmed",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "approveRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "productId",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "nullifier",
                type: "uint256"
              }
            ],
            internalType: "struct PurchasedItem[]",
            name: "cart",
            type: "tuple[]"
          },
          {
            internalType: "address",
            name: "shop",
            type: "address"
          }
        ],
        internalType: "struct PurchaseSignature",
        name: "purchaseSignature",
        type: "tuple"
      }
    ],
    name: "claimPurchase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "deployer",
    outputs: [
      {
        internalType: "contract Deployer",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "disapproveRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "getAffiliate",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "publisher",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "productId",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "isConfirmed",
            type: "bool"
          }
        ],
        internalType: "struct AffiliateRequest",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getAffiliateRequestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "messageHash",
        type: "bytes32"
      }
    ],
    name: "getEthSignedMessageHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "productId",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "nullifier",
                type: "uint256"
              }
            ],
            internalType: "struct PurchasedItem[]",
            name: "cart",
            type: "tuple[]"
          },
          {
            internalType: "address",
            name: "shop",
            type: "address"
          }
        ],
        internalType: "struct PurchaseSignature",
        name: "data",
        type: "tuple"
      }
    ],
    name: "getMessageHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "getProduct",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "nftAddress",
            type: "address"
          },
          {
            internalType: "enum NFTType",
            name: "nftType",
            type: "uint8"
          },
          {
            internalType: "enum ProductType",
            name: "productType",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "affiliatePercentage",
            type: "uint256"
          }
        ],
        internalType: "struct Product",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getProductCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "nftAddress",
            type: "address"
          },
          {
            internalType: "enum NFTType",
            name: "nftType",
            type: "uint8"
          },
          {
            internalType: "enum ProductType",
            name: "productType",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "affiliatePercentage",
            type: "uint256"
          }
        ],
        internalType: "struct Product",
        name: "product",
        type: "tuple"
      }
    ],
    name: "getProductId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getProductIdV2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "affiliateId",
        type: "uint256"
      }
    ],
    name: "getProductViaAffiliateId",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "nftAddress",
            type: "address"
          },
          {
            internalType: "enum NFTType",
            name: "nftType",
            type: "uint8"
          },
          {
            internalType: "enum ProductType",
            name: "productType",
            type: "uint8"
          },
          {
            internalType: "uint256",
            name: "affiliatePercentage",
            type: "uint256"
          }
        ],
        internalType: "struct Product",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getShopAddress",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getShopDescription",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getShopLogo",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getShopName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getShopOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "isRequestSubmited",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "managers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "nftAddress",
            type: "address"
          },
          {
            internalType: "string",
            name: "uri",
            type: "string"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool"
          },
          {
            internalType: "uint256",
            name: "affiliatePercentage",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "royalty",
            type: "uint256"
          },
          {
            internalType: "enum NFTType",
            name: "nftType",
            type: "uint8"
          },
          {
            internalType: "enum ProductType",
            name: "productType",
            type: "uint8"
          }
        ],
        internalType: "struct RecordData",
        name: "mintData",
        type: "tuple"
      }
    ],
    name: "mintAndRegister",
    outputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "nftAddress",
            type: "address"
          },
          {
            internalType: "string",
            name: "uri",
            type: "string"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool"
          },
          {
            internalType: "uint256",
            name: "affiliatePercentage",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "royalty",
            type: "uint256"
          },
          {
            internalType: "enum NFTType",
            name: "nftType",
            type: "uint8"
          },
          {
            internalType: "enum ProductType",
            name: "productType",
            type: "uint8"
          }
        ],
        internalType: "struct RecordData[]",
        name: "recordData",
        type: "tuple[]"
      }
    ],
    name: "mintAndRegisterBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "nullifiers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "productCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "products",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        internalType: "enum NFTType",
        name: "nftType",
        type: "uint8"
      },
      {
        internalType: "enum ProductType",
        name: "productType",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "affiliatePercentage",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "ethSignedMessageHash",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "recoverSigner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_affiliatePercentage",
        type: "uint256"
      },
      {
        internalType: "enum NFTType",
        name: "_nftType",
        type: "uint8"
      },
      {
        internalType: "enum ProductType",
        name: "_productType",
        type: "uint8"
      }
    ],
    name: "registerProduct",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "requestAffiliate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address"
      }
    ],
    name: "revokeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address"
      }
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "splitSignature",
    outputs: [
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newManager",
        type: "address"
      }
    ],
    name: "transferManagerShip",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256"
      }
    ],
    name: "unregisterProduct",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "signer",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "productId",
                type: "uint256"
              },
              {
                internalType: "uint256",
                name: "nullifier",
                type: "uint256"
              }
            ],
            internalType: "struct PurchasedItem[]",
            name: "cart",
            type: "tuple[]"
          },
          {
            internalType: "address",
            name: "shop",
            type: "address"
          }
        ],
        internalType: "struct PurchaseSignature",
        name: "data",
        type: "tuple"
      }
    ],
    name: "verifyPurchase",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  }
], erc20ABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256"
      }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256"
      }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address"
      }
    ],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      }
    ],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
], paymentProxyABI = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_heartBeat",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chainLinkProvider",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "priceTimestamp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "currentTimestamp",
        type: "uint256"
      }
    ],
    name: "oldPrice",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "newHeartBeat",
        type: "uint256"
      }
    ],
    name: "HeartBeatChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "ProductPurchased",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_heartBeat",
        type: "uint256"
      }
    ],
    name: "changeHeartBeat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tbdValues",
        type: "uint256[]"
      },
      {
        internalType: "address[]",
        name: "tbdReceivers",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "currency",
        type: "address"
      },
      {
        internalType: "uint80",
        name: "roundId",
        type: "uint80"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "droplinkedPurchase",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "heartBeat",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
function getShopABI() {
  return shopABI;
}
function getPaymentProxyABI() {
  return paymentProxyABI;
}
class ChainError extends Error {
  constructor(t) {
    super(t), this.name = new.target.name;
  }
}
class WalletError extends ChainError {
}
class AlreadyRequested extends ChainError {
  constructor(t, n) {
    super(`Request for ${t} from ${n} already exists`), this.requestId = t, this.publisher = n;
  }
}
class Unauthorized extends ChainError {
  constructor(t, n, ie) {
    super(`Unauthorized access to ${t} from ${n} to ${ie}`), this.method = t, this.from = n, this.to = ie;
  }
}
class RequestDoesntExist extends ChainError {
  constructor(t, n) {
    super(`Request ${t} does not exist for shop ${n}`), this.requestId = t, this.shopAddress = n;
  }
}
class RequestAlreadyConfirmed extends ChainError {
  constructor(t, n) {
    super(`Request ${t} already confirmed for shop ${n}`), this.requestId = t, this.shopAddress = n;
  }
}
class RequestDoesNotExist extends ChainError {
  constructor(t, n) {
    super(`Request ${t} does not exist for shop ${n}`), this.requestId = t, this.shopAddress = n;
  }
}
class RequestNotConfirmed extends ChainError {
  constructor(t, n) {
    super(`Request ${t} not confirmed by publisher ${n}`), this.requestId = t, this.publisher = n;
  }
}
class AccountChangedException extends ChainError {
  constructor(t) {
    super(`Account changed: ${t}`);
  }
}
class ChainNotImplementedException extends ChainError {
  constructor(t) {
    super(`Chain not implemented: ${t}`);
  }
}
class MetadataUploadFailedException extends ChainError {
  constructor(t) {
    super(`Metadata upload failed: ${t}`);
  }
}
class WalletNotFoundException extends WalletError {
  constructor() {
    super("EVM Wallet not found");
  }
}
class MetaMaskNotFoundException extends WalletError {
  constructor() {
    super("MetaMask is not installed");
  }
}
class AccountAccessDeniedException extends WalletError {
  constructor() {
    super("Account access request denied by the user");
  }
}
class NoAccountsFoundException extends WalletError {
  constructor() {
    super("No accounts were found in the wallet");
  }
}
class SignatureRequestDeniedException extends WalletError {
  constructor() {
    super("Signature request was denied by the user");
  }
}
class ChainSwitchException extends WalletError {
  constructor() {
    super("Failed to switch chains");
  }
}
class UserDeniedException extends WalletError {
  constructor() {
    super("User denied the request");
  }
}
class InsufficientBalanceException extends WalletError {
  constructor() {
    super("Insufficient balance to cover the transaction cost");
  }
}
class InsufficientTokenBalanceException extends WalletError {
  constructor() {
    super("Insufficient token balance");
  }
}
class InvalidParametersException extends ChainError {
  constructor(t) {
    super(`Invalid parameters: ${t}`);
  }
}
const EVMApproveRequest = async function(c, t, n, ie, fe, ae) {
  const le = c.getSigner();
  if ((await le.getAddress()).toLocaleLowerCase() !== n.toLocaleLowerCase())
    throw new Error("Address does not match signer address");
  ae.waiting("Approving request...");
  const he = new Contract(
    fe,
    getShopABI(),
    le
  );
  try {
    await he.callStatic.approveRequest(ie);
    const me = (await he.estimateGas.approveRequest(ie)).toBigInt().valueOf();
    ae.waiting("Approving...");
    const ye = await he.approveRequest(ie, {
      gasLimit: me * BigInt(105) / BigInt(100),
      gasPrice: getGasPrice(c)
    });
    return ae.success("Request Approved."), ye.hash;
  } catch (me) {
    if (me.code.toString() === "ACTION_REJECTED")
      throw new Error("Transaction Rejected");
    const ye = he.interface.parseError(me.data);
    throw ye.name === "RequestAlreadyConfirmed" ? new RequestAlreadyConfirmed(ie, fe) : ye.name === "RequestDoesntExist" ? new RequestDoesntExist(ie, fe) : ye.name === "OwnableUnauthorizedAccount" ? new Unauthorized("Approve", n, fe) : me;
  }
}, EVMDisapproveRequest = async function(c, t, n, ie, fe, ae) {
  const le = c.getSigner();
  if ((await le.getAddress()).toLocaleLowerCase() !== n.toLocaleLowerCase())
    throw new Error("Address does not match signer address");
  ae.waiting("Disapproving request...");
  const he = new Contract(
    fe,
    getShopABI(),
    le
  );
  try {
    await he.callStatic.disapprove(ie);
    const me = (await he.estimateGas.disapprove(ie)).toBigInt().valueOf();
    ae.waiting("Disapproving...");
    const ye = await he.disapprove(ie, {
      gasLimit: me * BigInt(105) / BigInt(100),
      gasPrice: getGasPrice(c)
    });
    return ae.success("Request Disapproved."), ye.hash;
  } catch (me) {
    if (me.code.toString() === "ACTION_REJECTED")
      throw new Error("Transaction Rejected");
    const ye = he.interface.parseError(me.data);
    throw ye.name === "OwnableUnauthorizedAccount" ? new Unauthorized("Disapprove", n, fe) : ye.name === "RequestDoesntExist" ? new RequestDoesntExist(ie, fe) : ye.name === "RequestNotConfirmed" ? new RequestNotConfirmed(ie, fe) : me;
  }
};
async function uploadMetadata(c, t, n) {
  return (typeof c == typeof {} || typeof c == typeof []) && (c = JSON.stringify(c)), (await (await n.patch(`sku/metadata/${t}`, {
    json: {
      metadata: c
    }
  })).json()).data;
}
async function getCartData(c, t, n, ie, fe) {
  const ae = (await (await fe.get(
    `checkout/order/crypto-payment-data/${c}/${t}/${n}/${ie}`
  )).json()).data;
  return {
    paymentData: ae.paymentData,
    orderID: ae.orderID
  };
}
async function getAirdropData(c, t) {
  return await (await t.get(`nfts/airdrop/${c}`)).json();
}
async function getNonce(c, t) {
  return (await (await t.get(`auth/nonce?wallet=${c}`)).json()).data;
}
async function checkWallet(c, t) {
  if ((await c.getAddress()).toLocaleLowerCase() !== t.toLocaleLowerCase())
    throw new Error("Address does not match signer address");
}
const sixify = (c) => c.toString().padStart(6, "0");
async function getConstructorArgs(c, t, n) {
  return [
    c.shopName || "",
    c.shopAddress || "",
    n,
    c.shopLogo || "",
    c.shopDescription || "",
    t
  ];
}
async function deployEVMShop(c, t, n) {
  console.log({
    ...c,
    ...t,
    ...n
  });
  const { modalInterface: ie } = t, { address: fe, chain: ae, network: le, provider: he } = c, me = he.getSigner();
  ie.waiting("got the signer: " + await me.getAddress()), await checkWallet(me, fe);
  const ye = await getDeployerAddress(ae, le);
  ie.waiting("Got deployer contract address");
  const be = new Contract(ye, deployerABI, me);
  ie.waiting("Getting shop bytecode");
  const Ae = await getShopByteCode();
  ie.waiting("got bytecode");
  const Se = "0x" + fe.split("0x")[1] + "000000000000000000" + sixify(Math.floor(Math.random() * 1e6) + 1);
  ie.waiting("created salt"), console.log(Se);
  const $e = await getConstructorArgs(
    n,
    ye,
    fe
  );
  ie.waiting("created constructor args"), console.log($e);
  const Re = defaultAbiCoder.encode(
    [
      "string",
      "string",
      "address",
      "string",
      "string",
      "address"
    ],
    $e
  );
  ie.waiting("Created bytecodeWithArgs"), console.log(Re);
  try {
    let Me;
    const ke = Ae + Re.split("0x")[1];
    console.log({ fullBytecode: ke }), c.gasPredictable ? (ie.waiting("CallStatic to estimate gas"), await be.callStatic.deployShop(ke, Se), ie.waiting("Sending transaction"), Me = await be.deployShop(ke, Se, {})) : (ie.waiting("Sending transaction"), Me = await be.deployShop(ke, Se)), ie.waiting("Waiting for confirmation...");
    const Te = await Me.wait();
    ie.waiting("Transaction confirmed, extracting data...");
    const qe = Te.logs.map((Ve) => {
      try {
        return be.interface.parseLog(Ve);
      } catch {
        return null;
      }
    }).filter((Ve) => Ve != null).find((Ve) => Ve.name === "ShopDeployed"), Ue = qe.args.shop, ze = qe.args.nftContract;
    return ie.success("Deployment successful!"), {
      transactionHash: Me.hash,
      deployedShopAddress: Ue,
      deployedNFTAddress: ze
    };
  } catch (Me) {
    if (ie.error("Error during deployment."), Me.code.toString() === "ACTION_REJECTED")
      throw ie.error("Transaction Rejected"), new UserDeniedException();
    try {
      const ke = be.interface.parseError(Me.data);
      throw ie.error(`Contract error: ${ke}`), ke;
    } catch (ke) {
      throw ie.error("Unhandled error during deployment."), new Error(ke || "Unknown error occurred.");
    }
  }
}
const chainNames = {
  [Chain.BINANCE]: {
    [Network.TESTNET]: {
      chainName: "Smart Chain - Testnet",
      chainId: "0x61",
      nativeCurrency: { name: "TBNB", decimals: 18, symbol: "tBNB" },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"]
    },
    [Network.MAINNET]: {
      chainName: "Smart Chain",
      chainId: "0x38",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      rpcUrls: ["https://bsc-dataseed.binance.org/"]
    }
  },
  [Chain.POLYGON]: {
    [Network.TESTNET]: {
      chainName: "Polygon Amoy Testnet",
      chainId: "0x13882",
      nativeCurrency: { name: "MATIC", decimals: 18, symbol: "MATIC" },
      rpcUrls: ["https://rpc-amoy.polygon.technology"]
    },
    [Network.MAINNET]: {
      chainName: "Polygon Mainnet",
      chainId: "0x89",
      nativeCurrency: { name: "MATIC", decimals: 18, symbol: "MATIC" },
      rpcUrls: ["https://polygon-rpc.com/"]
    }
  },
  [Chain.XRPLSIDECHAIN]: {
    [Network.TESTNET]: {
      chainName: "XRPL EVM Sidechain",
      chainId: "0x15f902",
      nativeCurrency: { name: "XRP", decimals: 18, symbol: "XRP" },
      rpcUrls: ["https://rpc-evm-sidechain.xrpl.org"]
    },
    [Network.MAINNET]: {
      chainName: "XRPL EVM Sidechain",
      chainId: "0x15f902",
      nativeCurrency: { name: "XRP", decimals: 18, symbol: "XRP" },
      rpcUrls: ["https://rpc-evm-sidechain.xrpl.org"]
    }
  },
  [Chain.CASPER]: {
    [Network.TESTNET]: {
      chainName: "Smart Chain - Testnet",
      chainId: "0x38",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"]
    },
    [Network.MAINNET]: {
      chainName: "Smart Chain",
      chainId: "0x61",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"]
    }
  },
  [Chain.STACKS]: {
    [Network.TESTNET]: {
      chainName: "Smart Chain - Testnet",
      chainId: "0x38",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"]
    },
    [Network.MAINNET]: {
      chainName: "Smart Chain",
      chainId: "0x61",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"]
    }
  },
  [Chain.NEAR]: {
    [Network.TESTNET]: {
      chainName: "Aurora Testnet",
      chainId: "0x4e454153",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://testnet.aurora.dev"]
    },
    [Network.MAINNET]: {
      chainName: "Aurora Mainnet",
      chainId: "0x4e454152",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://mainnet.aurora.dev"]
    }
  },
  [Chain.SKALE]: {
    [Network.TESTNET]: {
      chainName: "SKALE Testnet Calypso Hub",
      chainId: "0x3A14269B",
      nativeCurrency: { name: "sFUEL", decimals: 18, symbol: "sFUEL" },
      rpcUrls: ["https://testnet.skalenodes.com/v1/giant-half-dual-testnet"]
    },
    [Network.MAINNET]: {
      chainName: "SKALE Calypso Hub",
      chainId: "0x5D456C62",
      nativeCurrency: { name: "sFUEL", decimals: 18, symbol: "sFUEL" },
      rpcUrls: ["https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague"]
    }
  },
  [Chain.BASE]: {
    [Network.TESTNET]: {
      chainName: "Base Sepolia",
      chainId: "0x14a34",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://sepolia.base.org"]
    },
    [Network.MAINNET]: {
      chainName: "Base Mainnet",
      chainId: "0x2105",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://mainnet.base.org/"]
    }
  },
  [Chain.LINEA]: {
    [Network.MAINNET]: {
      chainName: "Linea",
      chainId: "0xe708",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "LineaETH" },
      rpcUrls: ["https://rpc.linea.build"]
    },
    [Network.TESTNET]: {
      chainName: "Linea",
      chainId: "0xe704",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "LineaETH" },
      rpcUrls: ["https://rpc.sepolia.linea.build"]
    }
  },
  [Chain.ETH]: {
    [Network.MAINNET]: {
      chainName: "Ethereum",
      chainId: "0x1",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://mainnet.infura.io/v3/"]
    },
    [Network.TESTNET]: {
      chainName: "Sepolia",
      chainId: "0xaa36a7",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      rpcUrls: ["https://eth-sepolia.public.blastapi.io/"]
    }
  },
  [Chain.REDBELLY]: {
    [Network.TESTNET]: {
      chainName: "Redbelly Network Testnet",
      chainId: "0x99",
      nativeCurrency: { name: "RBNT", decimals: 18, symbol: "RBNT" },
      rpcUrls: ["https://governors.testnet.redbelly.network"]
    },
    [Network.MAINNET]: {
      chainName: "Redbelly Network Mainnet",
      chainId: "0x97",
      nativeCurrency: { name: "RBNT", decimals: 18, symbol: "RBNT" },
      rpcUrls: ["https://governors.mainnet.redbelly.network"]
    }
  },
  [Chain.BITLAYER]: {
    [Network.MAINNET]: {
      chainName: "Bitlayer Mainnet",
      chainId: "0x310C5",
      nativeCurrency: { name: "BTC", decimals: 18, symbol: "BTC" },
      rpcUrls: ["https://rpc.bitlayer.org"]
    },
    [Network.TESTNET]: {
      chainName: "Bitlayer Testnet",
      chainId: "0x3106A",
      nativeCurrency: { name: "BTC", decimals: 18, symbol: "BTC" },
      rpcUrls: ["https://testnet-rpc.bitlayer.org"]
    }
  }
}, isMetamaskInstalled = () => {
  const { ethereum: c } = window;
  return !!(c && c.isMetaMask);
}, isCoinBaseInstalled = () => {
  var t;
  const { ethereum: c } = window;
  return !!(c && ((t = c.providers) != null && t.some((n) => n.isCoinbaseWallet)));
};
async function getAccounts(c) {
  try {
    const t = await c.request({ method: "eth_accounts" });
    return !t || t.length === 0 ? [] : t;
  } catch (t) {
    throw new WalletError(`Failed to retrieve accounts: ${t}`);
  }
}
function isWalletInstalled(c) {
  var t, n;
  if ([
    "POLYGON",
    "XRPLSIDECHAIN",
    "NEAR",
    "BINANCE",
    "BASE",
    "LINEA",
    "ETH",
    "REDBELLY",
    "SKALE",
    "BITLAYER"
  ].includes(c.toUpperCase()))
    return {
      installed: isMetamaskInstalled(),
      walletName: "MetaMask wallet"
    };
  if (c === "SOLANA")
    return {
      installed: (n = (t = window.phantom) == null ? void 0 : t.solana) == null ? void 0 : n.isPhantom,
      walletName: "Phantom wallet"
    };
  throw c === "CASPER" ? new WalletNotFoundException() : new WalletNotFoundException();
}
async function isWalletConnected(c) {
  const t = await getAccounts(c);
  return t && t.length > 0;
}
async function isChainCorrect(c, t, n) {
  try {
    const ie = await c.request({ method: "eth_chainId" });
    return String(ie).toLowerCase() === chainNames[t][n].chainId.toLowerCase();
  } catch (ie) {
    throw console.error(`Failed to verify the correct chain: ${ie.message}`), new ChainSwitchException();
  }
}
async function changeChain(c, t, n) {
  try {
    await c.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: chainNames[t][n].chainId }]
    });
  } catch (ie) {
    throw console.error(`Failed to switch chain: ${ie.message}`), new ChainSwitchException();
  }
}
async function requestAccounts(c) {
  try {
    return await c.request({ method: "eth_requestAccounts" });
  } catch (t) {
    throw console.error(t), new UserDeniedException();
  }
}
async function getBalance(c, t) {
  return Number(
    await c.provider.request({
      method: "eth_getBalance",
      params: [t, "latest"]
    })
  );
}
async function addChain(c, t, n, ie) {
  try {
    const fe = c.provider;
    if (ie.waiting("Adding chain..."), !isWalletInstalled(t))
      throw new WalletNotFoundException();
    await isWalletConnected(fe) || (ie.waiting("Requesting account access..."), await requestAccounts(fe));
    const ae = chainNames[t][n];
    await fe.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainName: ae.chainName,
          chainId: ae.chainId,
          nativeCurrency: ae.nativeCurrency,
          rpcUrls: ae.rpcUrls
        }
      ]
    });
  } catch (fe) {
    console.warn(
      "Chain already added or error occurred while adding chain:",
      fe
    );
  }
}
async function evmLogin(c, t, n, ie, fe) {
  const ae = c.provider;
  try {
    if (ie.waiting("Connecting to wallet..."), !isWalletInstalled(t))
      throw new WalletNotFoundException();
    await isWalletConnected(ae) || (ie.waiting("Requesting account access..."), await requestAccounts(ae));
    const le = (await getAccounts(ae))[0], he = chainNames[t][n];
    try {
      ie.waiting("Adding chain..."), await ae.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainName: he.chainName,
            chainId: he.chainId,
            nativeCurrency: he.nativeCurrency,
            rpcUrls: he.rpcUrls
          }
        ]
      });
    } catch (Re) {
      console.warn(
        "Chain already added or error occurred while adding chain:",
        Re
      );
    }
    const me = await (await fe.post("shop/sFuelDistribution", {
      json: {
        wallet: le,
        isTestnet: n === Network.TESTNET
      }
    })).json();
    console.log(me), ie.waiting("Signing message...");
    const ye = await getNonce(le, fe), be = (/* @__PURE__ */ new Date()).toLocaleString(), Ae = `Welcome to Droplinked! Please sign this message to verify your ownership over your wallet and log in. - Nonce: ${ye} - Date: ${be}`, $e = await c.getSigner().signMessage(Ae);
    return { address: le, signature: $e, nonce: ye, date: be };
  } catch (le) {
    throw ie.error(
      le instanceof UserDeniedException ? "User denied the request" : "An error occurred while connecting to the wallet"
    ), le;
  }
}
const EVMPublishRequest = async function({
  provider: c,
  chain: t,
  address: n,
  productId: ie,
  shopAddress: fe,
  modalInterface: ae
}) {
  const le = c.getSigner();
  if ((await le.getAddress()).toLocaleLowerCase() !== n.toLocaleLowerCase())
    throw new Error("Address does not match signer address");
  ae.waiting("Requesting affiliate...");
  const he = new Contract(
    fe,
    getShopABI(),
    le
  );
  try {
    await he.callStatic.requestAffiliate(ie);
    const me = (await he.estimateGas.requestAffiliate(ie)).toBigInt().valueOf();
    ae.waiting("Sending request...");
    const ye = await he.requestAffiliate(ie, {
      gasLimit: me * BigInt(105) / BigInt(100),
      gasPrice: getGasPrice(c)
    });
    ae.waiting("Confirming...");
    const Se = (await ye.wait()).logs.map((Me) => {
      try {
        return he.interface.parseLog(Me);
      } catch {
        return null;
      }
    }).filter((Me) => Me != null).find(
      (Me) => Me.name === "AffiliateRequested"
    ), $e = Se.args.requestId, Re = Se.args.requester;
    return ae.success("Request Sent."), {
      transactionHash: ye.hash,
      requestId: $e,
      publisher: Re
    };
  } catch (me) {
    throw me.code.toString() === "ACTION_REJECTED" ? (ae.error("Transaction Rejected"), new Error("Transaction Rejected")) : he.interface.parseError(me.data).name === "AlreadyRequested" ? (ae.error("Request Already Sent!"), new AlreadyRequested(ie, n)) : me;
  }
};
function getRecordData(c, t, n) {
  const {
    acceptsManageWallet: ie,
    amount: fe,
    royalty: ae,
    type: le
  } = c;
  return {
    nftAddress: n,
    uri: t,
    amount: fe,
    accepted: ie,
    affiliatePercentage: ae,
    royalty: ae,
    nftType: NFTType.ERC1155,
    productType: le
  };
}
async function prepareRecordData(c, t, n, ie) {
  const { nftContract: fe, modalInterface: ae } = ie;
  if (!fe)
    throw new Unauthorized(
      "Missing required fields: nftContract",
      c.address,
      c.address
    );
  const { description: le } = n, { skuID: he } = t, me = { ...t, ...n };
  ae.waiting("Uploading metadata...");
  const ye = {
    _id: me.skuProperties._id,
    ownerID: me.skuProperties.ownerID,
    price: me.skuProperties.price,
    quantity: me.skuProperties.quantity,
    externalID: me.skuProperties.externalID,
    options: me.skuProperties.options,
    royalty: me.skuProperties.royalty,
    createdAt: me.skuProperties.createdAt
  }, be = {
    name: me.productTitle,
    description: le,
    image: me.imageUrl,
    properties: ye
  }, Ae = await uploadMetadata(
    be,
    he,
    ie.axiosInstance
  );
  ae.waiting(`Metadata uploaded: ${Ae}`), ae.waiting("Getting recordData");
  const Se = getRecordData(
    me,
    Ae,
    fe
  );
  return ae.waiting("Got recordData"), Se;
}
async function recordProduct(c, t, n, ie) {
  const { modalInterface: fe, nftContract: ae, shopContractAddress: le } = t;
  if (!ae || !le)
    throw new Unauthorized(
      "Missing required fields: nftContract or shopContractAddress",
      c.address,
      c.address
    );
  const he = c.provider.getSigner();
  fe.waiting("Connecting to wallet..."), await checkWallet(he, c.address), fe.waiting("Getting shop contract...");
  const me = new Contract(
    le,
    getShopABI(),
    he
  );
  try {
    const ye = await Promise.all(
      ie.map((Ae) => prepareRecordData(c, Ae, n, t))
    );
    console.log({ products: ye });
    let be;
    if (c.gasPredictable) {
      fe.waiting("CallStatic..."), await me.callStatic.mintAndRegisterBatch(ye), fe.waiting("Estimating gas...");
      const Ae = (await me.estimateGas.mintAndRegisterBatch(ye)).toBigInt();
      fe.waiting("Got gas estimation: " + Ae), fe.waiting("Getting the gasPrice of the network...");
      const Se = (await getGasPrice(c.provider)).valueOf();
      fe.waiting("Got gas price: " + Se), fe.waiting("Sending transaction..."), be = await me.mintAndRegisterBatch(ye);
    } else
      fe.waiting("Sending transaction..."), be = await me.mintAndRegisterBatch(ye);
    return await be.wait(), fe.success("Transaction successful"), { transactionHash: be.hash };
  } catch (ye) {
    if (ye.code && ye.code.toString() === "ACTION_REJECTED")
      throw t.modalInterface.error("Transaction Rejected"), new Error("Transaction Rejected");
    try {
      const be = me.interface.parseError(ye.data);
      throw be.name === "OwnableUnauthorizedAccount" ? (t.modalInterface.error("You are not the owner of the shop"), new Unauthorized(
        "record",
        c.address,
        le
      )) : (t.modalInterface.error(be.name), t.modalInterface.error(ye), ye);
    } catch (be) {
      throw fe.error(`Unexpected error: ${be}`), be;
    }
  }
}
function getERC20TokenTransferABI() {
  return [
    {
      constant: !1,
      inputs: [
        {
          name: "_to",
          type: "address"
        },
        {
          name: "_value",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          name: "",
          type: "bool"
        }
      ],
      payable: !1,
      stateMutability: "nonpayable",
      type: "function"
    }
  ];
}
const SkaleUsdcAddressForTestnet = "0x2aebcdc4f9f9149a50422fff86198cb0939ea165", SkaleUsdcAddressForMainnet = "0x7Cf76E740Cb23b99337b21F392F22c47Ad910c67";
var utils$g = {};
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$b), require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$f), require$$2$3 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$d), require$$3 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$8), require$$4$3 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$j), require$$5 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$c), require$$6$2 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$6), require$$7 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$4), require$$8 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$h), require$$9 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$k), require$$10 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$7), require$$11$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$1), require$$12 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$5), require$$13 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$i), require$$14 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$g), require$$15 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$a), require$$16 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$e), require$$17$1 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$9), require$$18 = /* @__PURE__ */ getAugmentedNamespace(lib_esm), require$$19 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$3), require$$20 = /* @__PURE__ */ getAugmentedNamespace(lib_esm$2);
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(_e, se, ce, de) {
    de === void 0 && (de = ce), Object.defineProperty(_e, de, { enumerable: !0, get: function() {
      return se[ce];
    } });
  } : function(_e, se, ce, de) {
    de === void 0 && (de = ce), _e[de] = se[ce];
  }), n = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(_e, se) {
    Object.defineProperty(_e, "default", { enumerable: !0, value: se });
  } : function(_e, se) {
    _e.default = se;
  }), ie = commonjsGlobal && commonjsGlobal.__importStar || function(_e) {
    if (_e && _e.__esModule) return _e;
    var se = {};
    if (_e != null) for (var ce in _e) ce !== "default" && Object.prototype.hasOwnProperty.call(_e, ce) && t(se, _e, ce);
    return n(se, _e), se;
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.formatBytes32String = c.Utf8ErrorFuncs = c.toUtf8String = c.toUtf8CodePoints = c.toUtf8Bytes = c._toEscapedUtf8String = c.nameprep = c.hexDataSlice = c.hexDataLength = c.hexZeroPad = c.hexValue = c.hexStripZeros = c.hexConcat = c.isHexString = c.hexlify = c.base64 = c.base58 = c.TransactionDescription = c.LogDescription = c.Interface = c.SigningKey = c.HDNode = c.defaultPath = c.isBytesLike = c.isBytes = c.zeroPad = c.stripZeros = c.concat = c.arrayify = c.shallowCopy = c.resolveProperties = c.getStatic = c.defineReadOnly = c.deepCopy = c.checkProperties = c.poll = c.fetchJson = c._fetchData = c.RLP = c.Logger = c.checkResultErrors = c.FormatTypes = c.ParamType = c.FunctionFragment = c.EventFragment = c.ErrorFragment = c.ConstructorFragment = c.Fragment = c.defaultAbiCoder = c.AbiCoder = void 0, c.Indexed = c.Utf8ErrorReason = c.UnicodeNormalizationForm = c.SupportedAlgorithm = c.mnemonicToSeed = c.isValidMnemonic = c.entropyToMnemonic = c.mnemonicToEntropy = c.getAccountPath = c.verifyTypedData = c.verifyMessage = c.recoverPublicKey = c.computePublicKey = c.recoverAddress = c.computeAddress = c.getJsonWalletAddress = c.TransactionTypes = c.serializeTransaction = c.parseTransaction = c.accessListify = c.joinSignature = c.splitSignature = c.soliditySha256 = c.solidityKeccak256 = c.solidityPack = c.shuffled = c.randomBytes = c.sha512 = c.sha256 = c.ripemd160 = c.keccak256 = c.computeHmac = c.commify = c.parseUnits = c.formatUnits = c.parseEther = c.formatEther = c.isAddress = c.getCreate2Address = c.getContractAddress = c.getIcapAddress = c.getAddress = c._TypedDataEncoder = c.id = c.isValidName = c.namehash = c.hashMessage = c.dnsEncode = c.parseBytes32String = void 0;
  var fe = require$$0$4;
  Object.defineProperty(c, "AbiCoder", { enumerable: !0, get: function() {
    return fe.AbiCoder;
  } }), Object.defineProperty(c, "checkResultErrors", { enumerable: !0, get: function() {
    return fe.checkResultErrors;
  } }), Object.defineProperty(c, "ConstructorFragment", { enumerable: !0, get: function() {
    return fe.ConstructorFragment;
  } }), Object.defineProperty(c, "defaultAbiCoder", { enumerable: !0, get: function() {
    return fe.defaultAbiCoder;
  } }), Object.defineProperty(c, "ErrorFragment", { enumerable: !0, get: function() {
    return fe.ErrorFragment;
  } }), Object.defineProperty(c, "EventFragment", { enumerable: !0, get: function() {
    return fe.EventFragment;
  } }), Object.defineProperty(c, "FormatTypes", { enumerable: !0, get: function() {
    return fe.FormatTypes;
  } }), Object.defineProperty(c, "Fragment", { enumerable: !0, get: function() {
    return fe.Fragment;
  } }), Object.defineProperty(c, "FunctionFragment", { enumerable: !0, get: function() {
    return fe.FunctionFragment;
  } }), Object.defineProperty(c, "Indexed", { enumerable: !0, get: function() {
    return fe.Indexed;
  } }), Object.defineProperty(c, "Interface", { enumerable: !0, get: function() {
    return fe.Interface;
  } }), Object.defineProperty(c, "LogDescription", { enumerable: !0, get: function() {
    return fe.LogDescription;
  } }), Object.defineProperty(c, "ParamType", { enumerable: !0, get: function() {
    return fe.ParamType;
  } }), Object.defineProperty(c, "TransactionDescription", { enumerable: !0, get: function() {
    return fe.TransactionDescription;
  } });
  var ae = require$$1$2;
  Object.defineProperty(c, "getAddress", { enumerable: !0, get: function() {
    return ae.getAddress;
  } }), Object.defineProperty(c, "getCreate2Address", { enumerable: !0, get: function() {
    return ae.getCreate2Address;
  } }), Object.defineProperty(c, "getContractAddress", { enumerable: !0, get: function() {
    return ae.getContractAddress;
  } }), Object.defineProperty(c, "getIcapAddress", { enumerable: !0, get: function() {
    return ae.getIcapAddress;
  } }), Object.defineProperty(c, "isAddress", { enumerable: !0, get: function() {
    return ae.isAddress;
  } });
  var le = ie(require$$2$3);
  c.base64 = le;
  var he = require$$3;
  Object.defineProperty(c, "base58", { enumerable: !0, get: function() {
    return he.Base58;
  } });
  var me = require$$4$3;
  Object.defineProperty(c, "arrayify", { enumerable: !0, get: function() {
    return me.arrayify;
  } }), Object.defineProperty(c, "concat", { enumerable: !0, get: function() {
    return me.concat;
  } }), Object.defineProperty(c, "hexConcat", { enumerable: !0, get: function() {
    return me.hexConcat;
  } }), Object.defineProperty(c, "hexDataSlice", { enumerable: !0, get: function() {
    return me.hexDataSlice;
  } }), Object.defineProperty(c, "hexDataLength", { enumerable: !0, get: function() {
    return me.hexDataLength;
  } }), Object.defineProperty(c, "hexlify", { enumerable: !0, get: function() {
    return me.hexlify;
  } }), Object.defineProperty(c, "hexStripZeros", { enumerable: !0, get: function() {
    return me.hexStripZeros;
  } }), Object.defineProperty(c, "hexValue", { enumerable: !0, get: function() {
    return me.hexValue;
  } }), Object.defineProperty(c, "hexZeroPad", { enumerable: !0, get: function() {
    return me.hexZeroPad;
  } }), Object.defineProperty(c, "isBytes", { enumerable: !0, get: function() {
    return me.isBytes;
  } }), Object.defineProperty(c, "isBytesLike", { enumerable: !0, get: function() {
    return me.isBytesLike;
  } }), Object.defineProperty(c, "isHexString", { enumerable: !0, get: function() {
    return me.isHexString;
  } }), Object.defineProperty(c, "joinSignature", { enumerable: !0, get: function() {
    return me.joinSignature;
  } }), Object.defineProperty(c, "zeroPad", { enumerable: !0, get: function() {
    return me.zeroPad;
  } }), Object.defineProperty(c, "splitSignature", { enumerable: !0, get: function() {
    return me.splitSignature;
  } }), Object.defineProperty(c, "stripZeros", { enumerable: !0, get: function() {
    return me.stripZeros;
  } });
  var ye = require$$5;
  Object.defineProperty(c, "_TypedDataEncoder", { enumerable: !0, get: function() {
    return ye._TypedDataEncoder;
  } }), Object.defineProperty(c, "dnsEncode", { enumerable: !0, get: function() {
    return ye.dnsEncode;
  } }), Object.defineProperty(c, "hashMessage", { enumerable: !0, get: function() {
    return ye.hashMessage;
  } }), Object.defineProperty(c, "id", { enumerable: !0, get: function() {
    return ye.id;
  } }), Object.defineProperty(c, "isValidName", { enumerable: !0, get: function() {
    return ye.isValidName;
  } }), Object.defineProperty(c, "namehash", { enumerable: !0, get: function() {
    return ye.namehash;
  } });
  var be = require$$6$2;
  Object.defineProperty(c, "defaultPath", { enumerable: !0, get: function() {
    return be.defaultPath;
  } }), Object.defineProperty(c, "entropyToMnemonic", { enumerable: !0, get: function() {
    return be.entropyToMnemonic;
  } }), Object.defineProperty(c, "getAccountPath", { enumerable: !0, get: function() {
    return be.getAccountPath;
  } }), Object.defineProperty(c, "HDNode", { enumerable: !0, get: function() {
    return be.HDNode;
  } }), Object.defineProperty(c, "isValidMnemonic", { enumerable: !0, get: function() {
    return be.isValidMnemonic;
  } }), Object.defineProperty(c, "mnemonicToEntropy", { enumerable: !0, get: function() {
    return be.mnemonicToEntropy;
  } }), Object.defineProperty(c, "mnemonicToSeed", { enumerable: !0, get: function() {
    return be.mnemonicToSeed;
  } });
  var Ae = require$$7;
  Object.defineProperty(c, "getJsonWalletAddress", { enumerable: !0, get: function() {
    return Ae.getJsonWalletAddress;
  } });
  var Se = require$$8;
  Object.defineProperty(c, "keccak256", { enumerable: !0, get: function() {
    return Se.keccak256;
  } });
  var $e = require$$9;
  Object.defineProperty(c, "Logger", { enumerable: !0, get: function() {
    return $e.Logger;
  } });
  var Re = require$$10;
  Object.defineProperty(c, "computeHmac", { enumerable: !0, get: function() {
    return Re.computeHmac;
  } }), Object.defineProperty(c, "ripemd160", { enumerable: !0, get: function() {
    return Re.ripemd160;
  } }), Object.defineProperty(c, "sha256", { enumerable: !0, get: function() {
    return Re.sha256;
  } }), Object.defineProperty(c, "sha512", { enumerable: !0, get: function() {
    return Re.sha512;
  } });
  var Me = require$$11$1;
  Object.defineProperty(c, "solidityKeccak256", { enumerable: !0, get: function() {
    return Me.keccak256;
  } }), Object.defineProperty(c, "solidityPack", { enumerable: !0, get: function() {
    return Me.pack;
  } }), Object.defineProperty(c, "soliditySha256", { enumerable: !0, get: function() {
    return Me.sha256;
  } });
  var ke = require$$12;
  Object.defineProperty(c, "randomBytes", { enumerable: !0, get: function() {
    return ke.randomBytes;
  } }), Object.defineProperty(c, "shuffled", { enumerable: !0, get: function() {
    return ke.shuffled;
  } });
  var Te = require$$13;
  Object.defineProperty(c, "checkProperties", { enumerable: !0, get: function() {
    return Te.checkProperties;
  } }), Object.defineProperty(c, "deepCopy", { enumerable: !0, get: function() {
    return Te.deepCopy;
  } }), Object.defineProperty(c, "defineReadOnly", { enumerable: !0, get: function() {
    return Te.defineReadOnly;
  } }), Object.defineProperty(c, "getStatic", { enumerable: !0, get: function() {
    return Te.getStatic;
  } }), Object.defineProperty(c, "resolveProperties", { enumerable: !0, get: function() {
    return Te.resolveProperties;
  } }), Object.defineProperty(c, "shallowCopy", { enumerable: !0, get: function() {
    return Te.shallowCopy;
  } });
  var Ie = ie(require$$14);
  c.RLP = Ie;
  var qe = require$$15;
  Object.defineProperty(c, "computePublicKey", { enumerable: !0, get: function() {
    return qe.computePublicKey;
  } }), Object.defineProperty(c, "recoverPublicKey", { enumerable: !0, get: function() {
    return qe.recoverPublicKey;
  } }), Object.defineProperty(c, "SigningKey", { enumerable: !0, get: function() {
    return qe.SigningKey;
  } });
  var Ue = require$$16;
  Object.defineProperty(c, "formatBytes32String", { enumerable: !0, get: function() {
    return Ue.formatBytes32String;
  } }), Object.defineProperty(c, "nameprep", { enumerable: !0, get: function() {
    return Ue.nameprep;
  } }), Object.defineProperty(c, "parseBytes32String", { enumerable: !0, get: function() {
    return Ue.parseBytes32String;
  } }), Object.defineProperty(c, "_toEscapedUtf8String", { enumerable: !0, get: function() {
    return Ue._toEscapedUtf8String;
  } }), Object.defineProperty(c, "toUtf8Bytes", { enumerable: !0, get: function() {
    return Ue.toUtf8Bytes;
  } }), Object.defineProperty(c, "toUtf8CodePoints", { enumerable: !0, get: function() {
    return Ue.toUtf8CodePoints;
  } }), Object.defineProperty(c, "toUtf8String", { enumerable: !0, get: function() {
    return Ue.toUtf8String;
  } }), Object.defineProperty(c, "Utf8ErrorFuncs", { enumerable: !0, get: function() {
    return Ue.Utf8ErrorFuncs;
  } });
  var ze = require$$17$1;
  Object.defineProperty(c, "accessListify", { enumerable: !0, get: function() {
    return ze.accessListify;
  } }), Object.defineProperty(c, "computeAddress", { enumerable: !0, get: function() {
    return ze.computeAddress;
  } }), Object.defineProperty(c, "parseTransaction", { enumerable: !0, get: function() {
    return ze.parse;
  } }), Object.defineProperty(c, "recoverAddress", { enumerable: !0, get: function() {
    return ze.recoverAddress;
  } }), Object.defineProperty(c, "serializeTransaction", { enumerable: !0, get: function() {
    return ze.serialize;
  } }), Object.defineProperty(c, "TransactionTypes", { enumerable: !0, get: function() {
    return ze.TransactionTypes;
  } });
  var Ve = require$$18;
  Object.defineProperty(c, "commify", { enumerable: !0, get: function() {
    return Ve.commify;
  } }), Object.defineProperty(c, "formatEther", { enumerable: !0, get: function() {
    return Ve.formatEther;
  } }), Object.defineProperty(c, "parseEther", { enumerable: !0, get: function() {
    return Ve.parseEther;
  } }), Object.defineProperty(c, "formatUnits", { enumerable: !0, get: function() {
    return Ve.formatUnits;
  } }), Object.defineProperty(c, "parseUnits", { enumerable: !0, get: function() {
    return Ve.parseUnits;
  } });
  var Mt = require$$19;
  Object.defineProperty(c, "verifyMessage", { enumerable: !0, get: function() {
    return Mt.verifyMessage;
  } }), Object.defineProperty(c, "verifyTypedData", { enumerable: !0, get: function() {
    return Mt.verifyTypedData;
  } });
  var Rt = require$$20;
  Object.defineProperty(c, "_fetchData", { enumerable: !0, get: function() {
    return Rt._fetchData;
  } }), Object.defineProperty(c, "fetchJson", { enumerable: !0, get: function() {
    return Rt.fetchJson;
  } }), Object.defineProperty(c, "poll", { enumerable: !0, get: function() {
    return Rt.poll;
  } });
  var je = require$$10;
  Object.defineProperty(c, "SupportedAlgorithm", { enumerable: !0, get: function() {
    return je.SupportedAlgorithm;
  } });
  var jt = require$$16;
  Object.defineProperty(c, "UnicodeNormalizationForm", { enumerable: !0, get: function() {
    return jt.UnicodeNormalizationForm;
  } }), Object.defineProperty(c, "Utf8ErrorReason", { enumerable: !0, get: function() {
    return jt.Utf8ErrorReason;
  } });
})(utils$g);
async function handleCustomTokenApproval(c, t, n, ie, fe) {
  if (fe.waiting("Initiating token approval..."), !c.tokenAddress)
    throw new InvalidParametersException("Token address is not set");
  try {
    const ae = new Contract(
      c.tokenAddress,
      erc20ABI,
      n
    );
    console.log({ signerAddress: ie, customTokenContract: ae });
    const le = await ae.balanceOf(
      ie
    );
    fe.waiting("Calculating total sum...");
    const he = c.tbdValues.reduce(
      (ye, be) => ye.add(BigNumber.from(be)),
      BigNumber.from(0)
    );
    if (fe.waiting("Checking token balance..."), le.lt(he))
      throw new InsufficientTokenBalanceException();
    fe.waiting("Approving tokens...");
    const me = await ae.approve(
      t,
      MaxUint256$1
    );
    fe.waiting("Waiting for approval confirmation..."), await me.wait(), fe.waiting("Token approval confirmed");
  } catch (ae) {
    handleError(ae);
  }
}
const droplinked_payment = async function(c, t, n) {
  const { modalInterface: ie } = t, { provider: fe, chain: ae, network: le, address: he } = c;
  if (!n.tbdReceivers.every(utils$g.isAddress))
    throw new InvalidParametersException("Invalid receiver address found");
  if (!n.tbdValues.every((Se) => BigNumber.from(Se).gt(0)))
    throw new InvalidParametersException("tbdValues must be positive numbers");
  n.chainLinkRoundId = n.chainLinkRoundId || "0";
  const me = fe.getSigner();
  if (ie.waiting("Got signer..."), !n.tbdValues)
    throw new InvalidParametersException(
      `Invalid tbdValues: ${n.tbdValues}`
    );
  if (!n.tbdReceivers)
    throw new InvalidParametersException(
      `Invalid tbdReceivers: ${n.tbdReceivers}`
    );
  if (!n.memo)
    throw new InvalidParametersException(
      `Memo is required for payment, current memo: ${n.memo}`
    );
  if (n.tbdReceivers.length !== n.tbdValues.length)
    throw new InvalidParametersException(
      "tbdReceivers and tbdValues must be the same length"
    );
  const ye = (await me.getAddress()).toLowerCase();
  if (ye !== he.toLowerCase())
    throw new Unauthorized("droplinked_payment", ye, he);
  ie.waiting("Initial checks done...");
  let be;
  try {
    be = await getProxyAddress(ae, le);
  } catch (Se) {
    throw new Error("Failed to get contract address: " + Se.message);
  }
  let Ae;
  try {
    Ae = new Contract(
      be,
      getPaymentProxyABI(),
      me
    );
  } catch (Se) {
    throw new Error("Failed to create contract instance: " + Se.message);
  }
  ie.waiting("Got contract...");
  try {
    if (ie.waiting(`
        Purchase Details:
			data.tbdValues: ${n.tbdValues}
			data.tbdReceivers: ${n.tbdReceivers}
			currency: ${n.tokenAddress},
			data.chainLinkRoundId: ${n.chainLinkRoundId}
			data.memo: ${n.memo}
			data.totalPrice: ${Number(n.totalPrice)}
			`), ae === Chain.SKALE)
      return await skalePayment(
        n,
        le,
        me,
        Ae,
        he,
        be,
        ie
      );
    const Se = n.tokenAddress && n.tokenAddress !== ZERO_ADDRESS;
    ie.waiting(`The payment is custom? ${Se}`), Se ? await handleCustomTokenApproval(
      n,
      be,
      me,
      ye,
      ie
    ) : n.tbdValues = n.tbdValues.map(
      (Ue) => parseInt(Ue.toString(), 10)
    ), ie.waiting("Performing static call...");
    try {
      await Ae.callStatic.droplinkedPurchase(
        n.tbdValues,
        n.tbdReceivers,
        n.tokenAddress,
        n.chainLinkRoundId,
        n.memo,
        {
          value: Se ? BigNumber.from(0) : n.totalPrice
        }
      );
    } catch (Ue) {
      throw new Error("Transaction will fail: " + Ue.message);
    }
    ie.waiting("Static Call done");
    let $e;
    try {
      $e = await getGasPrice$1(fe);
    } catch (Ue) {
      throw new Error("Failed to get gas price: " + Ue.message);
    }
    ie.waiting(`Got gas price: ${$e}`), ie.waiting("Calling estimate gas...");
    let Re;
    try {
      Re = await Ae.estimateGas.droplinkedPurchase(
        n.tbdValues,
        n.tbdReceivers,
        n.tokenAddress,
        n.chainLinkRoundId,
        n.memo,
        {
          value: Se ? BigNumber.from(0) : n.totalPrice
        }
      );
    } catch (Ue) {
      throw new Error(
        `Gas estimation failed: ${Ue.message}. Please check the transaction parameters.`
      );
    }
    ie.waiting(`gas estimation done: ${Re.toString()}`);
    const Me = Re.mul(105).div(100), ke = Se ? BigNumber.from(0) : BigNumber.from(n.totalPrice);
    ie.waiting(
      `Gas limit: ${Me.toString()}, gas price: ${$e.toString()}, base: ${ke.toString()}`
    );
    let Te;
    try {
      Te = await fe.getBalance(he);
    } catch (Ue) {
      throw new Error("Failed to get user balance: " + Ue.message);
    }
    ie.waiting(`User balance: ${Te}`);
    const Ie = ke.add(Me.mul($e));
    if (Te.lt(Ie))
      throw new InsufficientBalanceException();
    ie.waiting("Calling purchase...");
    const qe = await Ae.droplinkedPurchase(
      n.tbdValues,
      n.tbdReceivers,
      n.tokenAddress,
      n.chainLinkRoundId,
      n.memo,
      {
        gasLimit: Me,
        value: Se ? BigNumber.from(0) : n.totalPrice
      }
    );
    return ie.waiting("Waiting for transaction..."), await qe.wait(), ie.waiting("Transaction done"), { transactionHash: qe.hash, cryptoAmount: n.totalPrice };
  } catch (Se) {
    handleError(Se);
  }
}, skalePayment = async function(c, t, n, ie, fe, ae, le) {
  try {
    const he = t === Network.TESTNET ? SkaleUsdcAddressForTestnet : SkaleUsdcAddressForMainnet;
    return c.tokenAddress = he, await handleCustomTokenApproval(
      c,
      ae,
      n,
      fe,
      le
    ), { transactionHash: (await ie.droplinkedPurchase(
      c.tbdValues,
      c.tbdReceivers,
      he,
      "0",
      c.memo
    )).hash, cryptoAmount: c.totalPrice };
  } catch (he) {
    handleError(he);
  }
};
function handleError(c) {
  var t;
  throw c instanceof Error ? ((t = c.code) == null ? void 0 : t.toString()) === "ACTION_REJECTED" || c.message.includes("User denied") || c.message.includes("User cancelled transaction") ? new UserDeniedException() : c : new Error("An unknown error occurred");
}
async function claimNFT(c, t, n) {
  console.log({ data: c, chainConfig: t, context: n });
  const { modalInterface: ie } = n, fe = t.provider.getSigner(), ae = getShopABI();
  ie.waiting("Claiming NFTs...");
  const le = new Contract(
    n.shopContractAddress,
    ae,
    fe
  );
  try {
    ie.waiting("Claiming NFTs..."), console.log(DROPLINKED_MANAGER, c.signature.signature, {
      cart: c.signature.purchaseData.map((ye) => ({
        amount: ye.amount,
        productId: ye.productId,
        nullifier: ye.nullifier
      })),
      shop: n.shopContractAddress
    });
    const he = c.signature.purchaseData.map((ye) => ({
      amount: ye.amount,
      productId: BigNumber.from(ye.productId),
      nullifier: BigNumber.from(ye.nullifier)
    })), me = await le.claimPurchase(
      DROPLINKED_MANAGER,
      c.signature.signature,
      {
        cart: he,
        shop: n.shopContractAddress
      }
    );
    return ie.waiting("Waiting for transaction..."), await me.wait(), ie.success("Claimed NFTs!"), {
      transactionHash: me.hash
    };
  } catch (he) {
    if (console.error(he), he.code && he.code.toString() === "ACTION_REJECTED")
      throw n.modalInterface.error("Transaction Rejected"), new Error("Transaction Rejected");
    try {
      const me = le.interface.parseError(he.data);
      throw me.name === "OwnableUnauthorizedAccount" && n.modalInterface.error(me.name), n.modalInterface.error(he), he;
    } catch (me) {
      throw ie.error(`Unexpected error: ${me}`), me;
    }
  }
}
var TokenStandard = /* @__PURE__ */ ((c) => (c.ERC721 = "ERC721", c.ERC1155 = "ERC1155", c.ERC20 = "ERC20", c))(TokenStandard || {});
const airdropABI = [
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "airdropId",
        type: "string"
      }
    ],
    name: "AirdropDone",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "distributeERC1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "distributeERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "distributeERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
async function sendTransaction(c, t, n, ie, fe) {
  try {
    return await c.callStatic[t](...n), await c[t](...n);
  } catch (ae) {
    throw fe.error(
      `Error simulating ${t} transaction ${ie + 1}: ${ae.message}`
    ), ae;
  }
}
async function approveTokenForAirdrop(c, t, n, ie, fe) {
  if (n !== TokenStandard.ERC1155)
    throw new Error("Only ERC1155 tokens are supported right now");
  const ae = ["function setApprovalForAll(address, bool) public"], le = new Contract(t, ae, ie);
  fe.waiting("Approving token for airdrop..."), await (await le.setApprovalForAll(c, !0)).wait(), fe.waiting("Token approved for airdrop");
}
async function airdrop(c, t, n) {
  const ie = t.modalInterface, fe = c.provider.getSigner();
  ie.waiting("Connecting to wallet..."), await checkWallet(fe, c.address), ie.waiting("Getting airdrop contract address...");
  const ae = await getAirdropAddress(
    c.chain,
    c.network
  ), le = new Contract(
    ae,
    airdropABI,
    fe
  );
  await approveTokenForAirdrop(
    ae,
    n.tokenAddress,
    n.type,
    fe,
    ie
  ), ie.waiting("Initializing airdrop");
  const he = (ye) => {
    const be = [], Ae = [];
    for (const Se of ye)
      be.push(Se.receiver), Ae.push(Se.amount);
    return { receivers: be, amounts: Ae };
  }, me = (ye, be, Ae = 300) => {
    const Se = [];
    for (let $e = 0; $e < ye.length; $e += Ae)
      Se.push({
        receivers: ye.slice($e, $e + Ae),
        amounts: be.slice($e, $e + Ae)
      });
    return Se;
  };
  try {
    let ye;
    const { receivers: be, amounts: Ae } = he(n.receivers), Se = n.chunkSize || 300, $e = me(be, Ae, Se), Re = [];
    for (const [Me, ke] of $e.entries())
      ie.waiting(
        `Processing transaction ${Me + 1} of ${$e.length}`
      ), n.type === TokenStandard.ERC1155 ? ye = await sendTransaction(
        le,
        "distributeERC1155",
        [
          n.tokenAddress,
          n.tokenId,
          ke.receivers,
          ke.amounts,
          n.airdropId
        ],
        Me,
        ie
      ) : n.type === TokenStandard.ERC20 ? ye = await sendTransaction(
        le,
        "distributeERC20",
        [n.tokenAddress, ke.receivers, ke.amounts, n.airdropId],
        Me,
        ie
      ) : n.type === TokenStandard.ERC721 && (ye = await sendTransaction(
        le,
        "distributeERC721",
        [n.tokenAddress, ke.receivers, ke.amounts, n.airdropId],
        Me,
        ie
      )), ie.waiting(`Transaction ${Me + 1} sent: ${ye.hash}`), Re.push(ye.hash), await ye.wait(), ie.waiting(`Transaction ${Me + 1} confirmed`);
    return { transactionHashes: Re };
  } catch (ye) {
    if (ye.code && ye.code.toString() === "ACTION_REJECTED")
      throw t.modalInterface.error("Transaction Rejected"), new Error("Transaction Rejected");
    try {
      const be = le.interface.parseError(ye.data);
      throw t.modalInterface.error(be.name), t.modalInterface.error(ye), ye;
    } catch (be) {
      throw t.modalInterface.error(`Unexpected error: ${be}`), be;
    }
  }
}
class EVMProvider {
  constructor(t, n, ie) {
    this.chain = Chain.BINANCE, this.network = Network.TESTNET, this.modalInterface = new defaultModal(), this.wallet = ChainWallet.Metamask, this.chain = t, this.network = n, this.gasPredictable = ie, this.address = ZERO_ADDRESS, this.axiosInstance = ky.create({
      prefixUrl: this.network === Network.MAINNET ? "https://apiv3.droplinked.com" : "https://apiv3dev.droplinked.com"
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  unstoppableLogin(t, n) {
    throw new Error("Method not implemented.");
  }
  setAxiosInstance(t) {
    return this.axiosInstance = t, this;
  }
  setNFTContractAddress(t) {
    return this.nftContractAddress = t, this;
  }
  setShopContractAddress(t) {
    return this.shopContractAddress = t, this;
  }
  setWallet(t) {
    return this.wallet = t, this;
  }
  setModal(t) {
    return this.modalInterface = t, this;
  }
  async customPayment(t) {
    return await this.handleChain(), await droplinked_payment(
      this.getChainConfig(),
      this.getContext(),
      t
    );
  }
  async claimNFTs(t) {
    return await this.handleWallet(this.address), await this.handleChain(), (await claimNFT(
      t,
      this.getChainConfig(),
      this.getContext()
    )).transactionHash;
  }
  getWalletProvider() {
    const t = window.ethereum;
    if (!t) throw new WalletNotFoundException();
    if (t.providerMap)
      if (this.wallet === ChainWallet.Metamask) {
        if (!t.providerMap.get("MetaMask"))
          throw new WalletNotFoundException();
        return new Web3Provider(
          t.providers.find((n) => n.isMetaMask)
        );
      } else if (this.wallet === ChainWallet.CoinBase) {
        if (!t.providerMap.get("CoinbaseWallet"))
          throw new WalletNotFoundException();
        return new Web3Provider(
          t.providers.find((n) => n.isCoinbaseWallet)
        );
      } else if (this.wallet === ChainWallet.Phantom) {
        if (!t.providerMap.get("CoinbaseWallet"))
          throw new WalletNotFoundException();
        return new Web3Provider(
          t.providers.find((n) => n.isCoinbaseWallet)
        );
      } else
        throw new Error("Wallet not implemented");
    else {
      if (this.wallet === ChainWallet.CoinBase) {
        if (!window.ethereum.isCoinbaseWallet)
          throw new WalletNotFoundException();
      } else if (this.wallet === ChainWallet.Metamask && !window.ethereum.isMetaMask)
        throw new WalletNotFoundException();
      return new Web3Provider(window.ethereum);
    }
  }
  async deployShop(t) {
    return await this.handleWallet(this.address), await this.handleChain(), await deployEVMShop(
      this.getChainConfig(),
      {
        axiosInstance: this.axiosInstance,
        modalInterface: this.modalInterface
      },
      t
    );
  }
  setAddress(t) {
    return this.address = t, this;
  }
  async handleChain() {
    const t = this.getWalletProvider();
    await addChain(t, this.chain, this.network, this.modalInterface), await isChainCorrect(t.provider, this.chain, this.network) || (console.log("Changing chain..."), await changeChain(t.provider, this.chain, this.network));
  }
  async handleWallet(t) {
    if (!isMetamaskInstalled())
      throw this.modalInterface.error("Metamask is not installed"), new WalletNotFoundException();
    this.modalInterface.waiting("Getting accounts...");
    const ie = this.getWalletProvider().provider, fe = await getAccounts(ie);
    if (!isWalletConnected(ie) || fe.length === 0) {
      this.modalInterface.waiting("Please connect your wallet");
      const { address: ae } = await this.walletLogin();
      t.toLocaleLowerCase() !== ae.toLocaleLowerCase() && (await window.ethereum.request({
        method: "wallet_requestPermissions",
        params: [
          {
            eth_accounts: {}
          }
        ]
      }), await this.handleWallet(t));
    }
    if (String(fe[0]).toLocaleLowerCase() !== t.toLocaleLowerCase() && (this.modalInterface.waiting(
      "Change your account based on the one you used to login..."
    ), await window.ethereum.request({
      method: "wallet_requestPermissions",
      params: [
        {
          eth_accounts: {}
        }
      ]
    }), this.handleWallet(t)), this.chain === Chain.SKALE) {
      const ae = await (await this.axiosInstance.post("shop/sFuelDistribution", {
        json: {
          wallet: this.address,
          isTestnet: this.network === Network.TESTNET
        }
      })).json();
      console.log(ae);
    }
    this.modalInterface.success("Wallet connected");
  }
  getChainConfig() {
    return {
      address: this.address,
      chain: this.chain,
      network: this.network,
      provider: this.getWalletProvider(),
      gasPredictable: this.gasPredictable
    };
  }
  getContext() {
    return {
      axiosInstance: this.axiosInstance,
      modalInterface: this.modalInterface,
      nftContract: this.nftContractAddress,
      shopContractAddress: this.shopContractAddress
    };
  }
  async walletLogin() {
    const { address: t, signature: n, date: ie, nonce: fe } = await evmLogin(
      this.getWalletProvider(),
      this.chain,
      this.network,
      this.modalInterface,
      this.axiosInstance
    );
    return this.address = t, { address: t, signature: n, date: ie, nonce: fe };
  }
  checkDeployment() {
    if (!this.nftContractAddress)
      throw new Error("NFT contract address not set");
    if (!this.shopContractAddress)
      throw new Error("Shop contract address not set");
  }
  async recordProduct(t, n) {
    return this.checkDeployment(), await this.handleWallet(this.address), await this.handleChain(), await recordProduct(
      this.getChainConfig(),
      this.getContext(),
      t,
      n
    );
  }
  async executeAirdrop(t) {
    console.log({ airdropId: t });
    const n = await getAirdropData(t, this.axiosInstance);
    return await this.handleWallet(this.address), await this.handleChain(), await airdrop(this.getChainConfig(), this.getContext(), {
      type: TokenStandard.ERC1155,
      airdropId: t,
      receivers: n.receivers,
      tokenAddress: n.tokenAddress,
      tokenId: n.tokenId,
      chunkSize: 300
    });
  }
  async publishRequest(t, n) {
    return await this.handleWallet(this.address), await this.handleChain(), await EVMPublishRequest({
      provider: this.getWalletProvider(),
      chain: this.chain,
      address: this.address,
      productId: t,
      shopAddress: n,
      modalInterface: this.modalInterface
    });
  }
  async approveRequest(t, n) {
    return this.checkDeployment(), await this.handleWallet(this.address), await this.handleChain(), await EVMApproveRequest(
      this.getWalletProvider(),
      this.chain,
      this.address,
      t,
      n,
      this.modalInterface
    );
  }
  async disapproveRequest(t, n) {
    return this.checkDeployment(), await this.handleWallet(this.address), await this.handleChain(), await EVMDisapproveRequest(
      this.getWalletProvider(),
      this.chain,
      this.address,
      t,
      n,
      this.modalInterface
    );
  }
  async payment(t) {
    await this.handleWallet(this.address), await this.handleChain();
    const { cartID: n, paymentToken: ie, paymentType: fe } = t, ae = await getCartData(
      n,
      ie,
      fe,
      this.address,
      this.axiosInstance
    ), le = ae.paymentData;
    return console.log({ paymentData: le }), { ...await droplinked_payment(
      this.getChainConfig(),
      this.getContext(),
      le
    ), orderID: ae.orderID };
  }
  async getPaymentData(t, n, ie) {
    return await getCartData(
      t,
      ie,
      n,
      this.address,
      this.axiosInstance
    );
  }
  async paymentWithToken(t, n, ie) {
    await this.handleWallet(this.address), await this.handleChain();
    const fe = getERC20TokenTransferABI(), ae = this.getWalletProvider().getSigner(), le = new Contract(ie, fe, ae);
    try {
      await le.callStatic.transfer(
        t,
        BigInt(Math.floor(n * 1e6)) * BigInt(1e12)
      );
      const he = (await le.estimateGas.transfer(
        t,
        BigInt(Math.floor(n * 1e6)) * BigInt(1e12)
      )).toBigInt().valueOf(), me = (await getGasPrice$1(this.getWalletProvider())).valueOf();
      return (await le.transfer(
        t,
        BigInt(Math.floor(n * 1e6)) * BigInt(1e12),
        {
          gasPrice: me * BigInt(105) / BigInt(100),
          gasLimit: he * BigInt(105) / BigInt(100)
        }
      )).hash;
    } catch (he) {
      throw he.reason ? he.reason === "ERC20: transfer amount exceeds balance" ? new Error("Insufficient token balance") : he.reason === "insufficient funds for gas * price + value" ? new Error("Insufficient ETH balance") : he.reason === "bad result from backend" ? new Error(
        "Something went wrong, check your eth and token balance"
      ) : new Error(he.reason) : he;
    }
  }
}
var Web3Actions = /* @__PURE__ */ ((c) => (c.LOGIN = "LOGIN", c.DEPLOY = "DEPLOY", c.RECORD_AFFILIATE = "RECORD_AFFILIATE", c.PAYMENT = "PAYMENT", c.CLAIM = "CLAIM", c.AIRDROP = "AIRDROP", c))(Web3Actions || {});
function number$2(c) {
  if (!Number.isSafeInteger(c) || c < 0)
    throw new Error(`positive integer expected, not ${c}`);
}
function isBytes$1(c) {
  return c instanceof Uint8Array || c != null && typeof c == "object" && c.constructor.name === "Uint8Array";
}
function bytes(c, ...t) {
  if (!isBytes$1(c))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(c.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${c.length}`);
}
function hash$3(c) {
  if (typeof c != "function" || typeof c.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$2(c.outputLen), number$2(c.blockLen);
}
function exists(c, t = !0) {
  if (c.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && c.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(c, t) {
  bytes(c);
  const n = t.outputLen;
  if (c.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const crypto$2 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const createView = (c) => new DataView(c.buffer, c.byteOffset, c.byteLength), rotr = (c, t) => c << 32 - t | c >>> t;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
function utf8ToBytes$1(c) {
  if (typeof c != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof c}`);
  return new Uint8Array(new TextEncoder().encode(c));
}
function toBytes(c) {
  return typeof c == "string" && (c = utf8ToBytes$1(c)), bytes(c), c;
}
function concatBytes$1(...c) {
  let t = 0;
  for (let ie = 0; ie < c.length; ie++) {
    const fe = c[ie];
    bytes(fe), t += fe.length;
  }
  const n = new Uint8Array(t);
  for (let ie = 0, fe = 0; ie < c.length; ie++) {
    const ae = c[ie];
    n.set(ae, fe), fe += ae.length;
  }
  return n;
}
class Hash {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function wrapConstructor(c) {
  const t = (ie) => c().update(toBytes(ie)).digest(), n = c();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => c(), t;
}
function randomBytes(c = 32) {
  if (crypto$2 && typeof crypto$2.getRandomValues == "function")
    return crypto$2.getRandomValues(new Uint8Array(c));
  if (crypto$2 && typeof crypto$2.randomBytes == "function")
    return crypto$2.randomBytes(c);
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64(c, t, n, ie) {
  if (typeof c.setBigUint64 == "function")
    return c.setBigUint64(t, n, ie);
  const fe = BigInt(32), ae = BigInt(4294967295), le = Number(n >> fe & ae), he = Number(n & ae), me = ie ? 4 : 0, ye = ie ? 0 : 4;
  c.setUint32(t + me, le, ie), c.setUint32(t + ye, he, ie);
}
const Chi = (c, t, n) => c & t ^ ~c & n, Maj = (c, t, n) => c & t ^ c & n ^ t & n;
class HashMD extends Hash {
  constructor(t, n, ie, fe) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = ie, this.isLE = fe, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = createView(this.buffer);
  }
  update(t) {
    exists(this);
    const { view: n, buffer: ie, blockLen: fe } = this;
    t = toBytes(t);
    const ae = t.length;
    for (let le = 0; le < ae; ) {
      const he = Math.min(fe - this.pos, ae - le);
      if (he === fe) {
        const me = createView(t);
        for (; fe <= ae - le; le += fe)
          this.process(me, le);
        continue;
      }
      ie.set(t.subarray(le, le + he), this.pos), this.pos += he, le += he, this.pos === fe && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    exists(this), output(t, this), this.finished = !0;
    const { buffer: n, view: ie, blockLen: fe, isLE: ae } = this;
    let { pos: le } = this;
    n[le++] = 128, this.buffer.subarray(le).fill(0), this.padOffset > fe - le && (this.process(ie, 0), le = 0);
    for (let Ae = le; Ae < fe; Ae++)
      n[Ae] = 0;
    setBigUint64(ie, fe - 8, BigInt(this.length * 8), ae), this.process(ie, 0);
    const he = createView(t), me = this.outputLen;
    if (me % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const ye = me / 4, be = this.get();
    if (ye > be.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let Ae = 0; Ae < ye; Ae++)
      he.setUint32(4 * Ae, be[Ae], ae);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const ie = t.slice(0, n);
    return this.destroy(), ie;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: ie, length: fe, finished: ae, destroyed: le, pos: he } = this;
    return t.length = fe, t.pos = he, t.finished = ae, t.destroyed = le, fe % n && t.buffer.set(ie), t;
  }
}
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(c, t = !1) {
  return t ? { h: Number(c & U32_MASK64), l: Number(c >> _32n & U32_MASK64) } : { h: Number(c >> _32n & U32_MASK64) | 0, l: Number(c & U32_MASK64) | 0 };
}
function split(c, t = !1) {
  let n = new Uint32Array(c.length), ie = new Uint32Array(c.length);
  for (let fe = 0; fe < c.length; fe++) {
    const { h: ae, l: le } = fromBig(c[fe], t);
    [n[fe], ie[fe]] = [ae, le];
  }
  return [n, ie];
}
const toBig = (c, t) => BigInt(c >>> 0) << _32n | BigInt(t >>> 0), shrSH = (c, t, n) => c >>> n, shrSL = (c, t, n) => c << 32 - n | t >>> n, rotrSH = (c, t, n) => c >>> n | t << 32 - n, rotrSL = (c, t, n) => c << 32 - n | t >>> n, rotrBH = (c, t, n) => c << 64 - n | t >>> n - 32, rotrBL = (c, t, n) => c >>> n - 32 | t << 64 - n, rotr32H = (c, t) => t, rotr32L = (c, t) => c, rotlSH = (c, t, n) => c << n | t >>> 32 - n, rotlSL = (c, t, n) => t << n | c >>> 32 - n, rotlBH = (c, t, n) => t << n - 32 | c >>> 64 - n, rotlBL = (c, t, n) => c << n - 32 | t >>> 64 - n;
function add(c, t, n, ie) {
  const fe = (t >>> 0) + (ie >>> 0);
  return { h: c + n + (fe / 2 ** 32 | 0) | 0, l: fe | 0 };
}
const add3L = (c, t, n) => (c >>> 0) + (t >>> 0) + (n >>> 0), add3H = (c, t, n, ie) => t + n + ie + (c / 2 ** 32 | 0) | 0, add4L = (c, t, n, ie) => (c >>> 0) + (t >>> 0) + (n >>> 0) + (ie >>> 0), add4H = (c, t, n, ie, fe) => t + n + ie + fe + (c / 2 ** 32 | 0) | 0, add5L = (c, t, n, ie, fe) => (c >>> 0) + (t >>> 0) + (n >>> 0) + (ie >>> 0) + (fe >>> 0), add5H = (c, t, n, ie, fe, ae) => t + n + ie + fe + ae + (c / 2 ** 32 | 0) | 0, u64$3 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
}, [SHA512_Kh, SHA512_Kl] = u64$3.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((c) => BigInt(c))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends HashMD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: ie, Bl: fe, Ch: ae, Cl: le, Dh: he, Dl: me, Eh: ye, El: be, Fh: Ae, Fl: Se, Gh: $e, Gl: Re, Hh: Me, Hl: ke } = this;
    return [t, n, ie, fe, ae, le, he, me, ye, be, Ae, Se, $e, Re, Me, ke];
  }
  // prettier-ignore
  set(t, n, ie, fe, ae, le, he, me, ye, be, Ae, Se, $e, Re, Me, ke) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = ie | 0, this.Bl = fe | 0, this.Ch = ae | 0, this.Cl = le | 0, this.Dh = he | 0, this.Dl = me | 0, this.Eh = ye | 0, this.El = be | 0, this.Fh = Ae | 0, this.Fl = Se | 0, this.Gh = $e | 0, this.Gl = Re | 0, this.Hh = Me | 0, this.Hl = ke | 0;
  }
  process(t, n) {
    for (let qe = 0; qe < 16; qe++, n += 4)
      SHA512_W_H[qe] = t.getUint32(n), SHA512_W_L[qe] = t.getUint32(n += 4);
    for (let qe = 16; qe < 80; qe++) {
      const Ue = SHA512_W_H[qe - 15] | 0, ze = SHA512_W_L[qe - 15] | 0, Ve = u64$3.rotrSH(Ue, ze, 1) ^ u64$3.rotrSH(Ue, ze, 8) ^ u64$3.shrSH(Ue, ze, 7), Mt = u64$3.rotrSL(Ue, ze, 1) ^ u64$3.rotrSL(Ue, ze, 8) ^ u64$3.shrSL(Ue, ze, 7), Rt = SHA512_W_H[qe - 2] | 0, je = SHA512_W_L[qe - 2] | 0, jt = u64$3.rotrSH(Rt, je, 19) ^ u64$3.rotrBH(Rt, je, 61) ^ u64$3.shrSH(Rt, je, 6), _e = u64$3.rotrSL(Rt, je, 19) ^ u64$3.rotrBL(Rt, je, 61) ^ u64$3.shrSL(Rt, je, 6), se = u64$3.add4L(Mt, _e, SHA512_W_L[qe - 7], SHA512_W_L[qe - 16]), ce = u64$3.add4H(se, Ve, jt, SHA512_W_H[qe - 7], SHA512_W_H[qe - 16]);
      SHA512_W_H[qe] = ce | 0, SHA512_W_L[qe] = se | 0;
    }
    let { Ah: ie, Al: fe, Bh: ae, Bl: le, Ch: he, Cl: me, Dh: ye, Dl: be, Eh: Ae, El: Se, Fh: $e, Fl: Re, Gh: Me, Gl: ke, Hh: Te, Hl: Ie } = this;
    for (let qe = 0; qe < 80; qe++) {
      const Ue = u64$3.rotrSH(Ae, Se, 14) ^ u64$3.rotrSH(Ae, Se, 18) ^ u64$3.rotrBH(Ae, Se, 41), ze = u64$3.rotrSL(Ae, Se, 14) ^ u64$3.rotrSL(Ae, Se, 18) ^ u64$3.rotrBL(Ae, Se, 41), Ve = Ae & $e ^ ~Ae & Me, Mt = Se & Re ^ ~Se & ke, Rt = u64$3.add5L(Ie, ze, Mt, SHA512_Kl[qe], SHA512_W_L[qe]), je = u64$3.add5H(Rt, Te, Ue, Ve, SHA512_Kh[qe], SHA512_W_H[qe]), jt = Rt | 0, _e = u64$3.rotrSH(ie, fe, 28) ^ u64$3.rotrBH(ie, fe, 34) ^ u64$3.rotrBH(ie, fe, 39), se = u64$3.rotrSL(ie, fe, 28) ^ u64$3.rotrBL(ie, fe, 34) ^ u64$3.rotrBL(ie, fe, 39), ce = ie & ae ^ ie & he ^ ae & he, de = fe & le ^ fe & me ^ le & me;
      Te = Me | 0, Ie = ke | 0, Me = $e | 0, ke = Re | 0, $e = Ae | 0, Re = Se | 0, { h: Ae, l: Se } = u64$3.add(ye | 0, be | 0, je | 0, jt | 0), ye = he | 0, be = me | 0, he = ae | 0, me = le | 0, ae = ie | 0, le = fe | 0;
      const pe = u64$3.add3L(jt, se, de);
      ie = u64$3.add3H(pe, je, _e, ce), fe = pe | 0;
    }
    ({ h: ie, l: fe } = u64$3.add(this.Ah | 0, this.Al | 0, ie | 0, fe | 0)), { h: ae, l: le } = u64$3.add(this.Bh | 0, this.Bl | 0, ae | 0, le | 0), { h: he, l: me } = u64$3.add(this.Ch | 0, this.Cl | 0, he | 0, me | 0), { h: ye, l: be } = u64$3.add(this.Dh | 0, this.Dl | 0, ye | 0, be | 0), { h: Ae, l: Se } = u64$3.add(this.Eh | 0, this.El | 0, Ae | 0, Se | 0), { h: $e, l: Re } = u64$3.add(this.Fh | 0, this.Fl | 0, $e | 0, Re | 0), { h: Me, l: ke } = u64$3.add(this.Gh | 0, this.Gl | 0, Me | 0, ke | 0), { h: Te, l: Ie } = u64$3.add(this.Hh | 0, this.Hl | 0, Te | 0, Ie | 0), this.set(ie, fe, ae, le, he, me, ye, be, Ae, Se, $e, Re, Me, ke, Te, Ie);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const sha512$3 = /* @__PURE__ */ wrapConstructor(() => new SHA512());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$4 = /* @__PURE__ */ BigInt(0), _1n$6 = /* @__PURE__ */ BigInt(1), _2n$4 = /* @__PURE__ */ BigInt(2);
function isBytes(c) {
  return c instanceof Uint8Array || c != null && typeof c == "object" && c.constructor.name === "Uint8Array";
}
function abytes(c) {
  if (!isBytes(c))
    throw new Error("Uint8Array expected");
}
function abool(c, t) {
  if (typeof t != "boolean")
    throw new Error(`${c} must be valid boolean, got "${t}".`);
}
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (c, t) => t.toString(16).padStart(2, "0"));
function bytesToHex(c) {
  abytes(c);
  let t = "";
  for (let n = 0; n < c.length; n++)
    t += hexes[c[n]];
  return t;
}
function numberToHexUnpadded(c) {
  const t = c.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function hexToNumber(c) {
  if (typeof c != "string")
    throw new Error("hex string expected, got " + typeof c);
  return BigInt(c === "" ? "0" : `0x${c}`);
}
const asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(c) {
  if (c >= asciis._0 && c <= asciis._9)
    return c - asciis._0;
  if (c >= asciis._A && c <= asciis._F)
    return c - (asciis._A - 10);
  if (c >= asciis._a && c <= asciis._f)
    return c - (asciis._a - 10);
}
function hexToBytes(c) {
  if (typeof c != "string")
    throw new Error("hex string expected, got " + typeof c);
  const t = c.length, n = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const ie = new Uint8Array(n);
  for (let fe = 0, ae = 0; fe < n; fe++, ae += 2) {
    const le = asciiToBase16(c.charCodeAt(ae)), he = asciiToBase16(c.charCodeAt(ae + 1));
    if (le === void 0 || he === void 0) {
      const me = c[ae] + c[ae + 1];
      throw new Error('hex string expected, got non-hex character "' + me + '" at index ' + ae);
    }
    ie[fe] = le * 16 + he;
  }
  return ie;
}
function bytesToNumberBE(c) {
  return hexToNumber(bytesToHex(c));
}
function bytesToNumberLE(c) {
  return abytes(c), hexToNumber(bytesToHex(Uint8Array.from(c).reverse()));
}
function numberToBytesBE(c, t) {
  return hexToBytes(c.toString(16).padStart(t * 2, "0"));
}
function numberToBytesLE(c, t) {
  return numberToBytesBE(c, t).reverse();
}
function numberToVarBytesBE(c) {
  return hexToBytes(numberToHexUnpadded(c));
}
function ensureBytes(c, t, n) {
  let ie;
  if (typeof t == "string")
    try {
      ie = hexToBytes(t);
    } catch (ae) {
      throw new Error(`${c} must be valid hex string, got "${t}". Cause: ${ae}`);
    }
  else if (isBytes(t))
    ie = Uint8Array.from(t);
  else
    throw new Error(`${c} must be hex string or Uint8Array`);
  const fe = ie.length;
  if (typeof n == "number" && fe !== n)
    throw new Error(`${c} expected ${n} bytes, got ${fe}`);
  return ie;
}
function concatBytes(...c) {
  let t = 0;
  for (let ie = 0; ie < c.length; ie++) {
    const fe = c[ie];
    abytes(fe), t += fe.length;
  }
  const n = new Uint8Array(t);
  for (let ie = 0, fe = 0; ie < c.length; ie++) {
    const ae = c[ie];
    n.set(ae, fe), fe += ae.length;
  }
  return n;
}
function equalBytes(c, t) {
  if (c.length !== t.length)
    return !1;
  let n = 0;
  for (let ie = 0; ie < c.length; ie++)
    n |= c[ie] ^ t[ie];
  return n === 0;
}
function utf8ToBytes(c) {
  if (typeof c != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof c}`);
  return new Uint8Array(new TextEncoder().encode(c));
}
const isPosBig = (c) => typeof c == "bigint" && _0n$4 <= c;
function inRange$1(c, t, n) {
  return isPosBig(c) && isPosBig(t) && isPosBig(n) && t <= c && c < n;
}
function aInRange(c, t, n, ie) {
  if (!inRange$1(t, n, ie))
    throw new Error(`expected valid ${c}: ${n} <= n < ${ie}, got ${typeof t} ${t}`);
}
function bitLen(c) {
  let t;
  for (t = 0; c > _0n$4; c >>= _1n$6, t += 1)
    ;
  return t;
}
function bitGet(c, t) {
  return c >> BigInt(t) & _1n$6;
}
function bitSet(c, t, n) {
  return c | (n ? _1n$6 : _0n$4) << BigInt(t);
}
const bitMask = (c) => (_2n$4 << BigInt(c - 1)) - _1n$6, u8n = (c) => new Uint8Array(c), u8fr = (c) => Uint8Array.from(c);
function createHmacDrbg(c, t, n) {
  if (typeof c != "number" || c < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let ie = u8n(c), fe = u8n(c), ae = 0;
  const le = () => {
    ie.fill(1), fe.fill(0), ae = 0;
  }, he = (...Ae) => n(fe, ie, ...Ae), me = (Ae = u8n()) => {
    fe = he(u8fr([0]), Ae), ie = he(), Ae.length !== 0 && (fe = he(u8fr([1]), Ae), ie = he());
  }, ye = () => {
    if (ae++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let Ae = 0;
    const Se = [];
    for (; Ae < t; ) {
      ie = he();
      const $e = ie.slice();
      Se.push($e), Ae += ie.length;
    }
    return concatBytes(...Se);
  };
  return (Ae, Se) => {
    le(), me(Ae);
    let $e;
    for (; !($e = Se(ye())); )
      me();
    return le(), $e;
  };
}
const validatorFns = {
  bigint: (c) => typeof c == "bigint",
  function: (c) => typeof c == "function",
  boolean: (c) => typeof c == "boolean",
  string: (c) => typeof c == "string",
  stringOrUint8Array: (c) => typeof c == "string" || isBytes(c),
  isSafeInteger: (c) => Number.isSafeInteger(c),
  array: (c) => Array.isArray(c),
  field: (c, t) => t.Fp.isValid(c),
  hash: (c) => typeof c == "function" && Number.isSafeInteger(c.outputLen)
};
function validateObject(c, t, n = {}) {
  const ie = (fe, ae, le) => {
    const he = validatorFns[ae];
    if (typeof he != "function")
      throw new Error(`Invalid validator "${ae}", expected function`);
    const me = c[fe];
    if (!(le && me === void 0) && !he(me, c))
      throw new Error(`Invalid param ${String(fe)}=${me} (${typeof me}), expected ${ae}`);
  };
  for (const [fe, ae] of Object.entries(t))
    ie(fe, ae, !1);
  for (const [fe, ae] of Object.entries(n))
    ie(fe, ae, !0);
  return c;
}
const notImplemented = () => {
  throw new Error("not implemented");
};
function memoized(c) {
  const t = /* @__PURE__ */ new WeakMap();
  return (n, ...ie) => {
    const fe = t.get(n);
    if (fe !== void 0)
      return fe;
    const ae = c(n, ...ie);
    return t.set(n, ae), ae;
  };
}
const ut$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange,
  abool,
  abytes,
  bitGet,
  bitLen,
  bitMask,
  bitSet,
  bytesToHex,
  bytesToNumberBE,
  bytesToNumberLE,
  concatBytes,
  createHmacDrbg,
  ensureBytes,
  equalBytes,
  hexToBytes,
  hexToNumber,
  inRange: inRange$1,
  isBytes,
  memoized,
  notImplemented,
  numberToBytesBE,
  numberToBytesLE,
  numberToHexUnpadded,
  numberToVarBytesBE,
  utf8ToBytes,
  validateObject
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$3 = BigInt(0), _1n$5 = BigInt(1), _2n$3 = BigInt(2), _3n$1 = BigInt(3), _4n = BigInt(4), _5n$1 = BigInt(5), _8n$2 = BigInt(8);
BigInt(9);
BigInt(16);
function mod(c, t) {
  const n = c % t;
  return n >= _0n$3 ? n : t + n;
}
function pow(c, t, n) {
  if (n <= _0n$3 || t < _0n$3)
    throw new Error("Expected power/modulo > 0");
  if (n === _1n$5)
    return _0n$3;
  let ie = _1n$5;
  for (; t > _0n$3; )
    t & _1n$5 && (ie = ie * c % n), c = c * c % n, t >>= _1n$5;
  return ie;
}
function pow2(c, t, n) {
  let ie = c;
  for (; t-- > _0n$3; )
    ie *= ie, ie %= n;
  return ie;
}
function invert(c, t) {
  if (c === _0n$3 || t <= _0n$3)
    throw new Error(`invert: expected positive integers, got n=${c} mod=${t}`);
  let n = mod(c, t), ie = t, fe = _0n$3, ae = _1n$5;
  for (; n !== _0n$3; ) {
    const he = ie / n, me = ie % n, ye = fe - ae * he;
    ie = n, n = me, fe = ae, ae = ye;
  }
  if (ie !== _1n$5)
    throw new Error("invert: does not exist");
  return mod(fe, t);
}
function tonelliShanks(c) {
  const t = (c - _1n$5) / _2n$3;
  let n, ie, fe;
  for (n = c - _1n$5, ie = 0; n % _2n$3 === _0n$3; n /= _2n$3, ie++)
    ;
  for (fe = _2n$3; fe < c && pow(fe, t, c) !== c - _1n$5; fe++)
    ;
  if (ie === 1) {
    const le = (c + _1n$5) / _4n;
    return function(me, ye) {
      const be = me.pow(ye, le);
      if (!me.eql(me.sqr(be), ye))
        throw new Error("Cannot find square root");
      return be;
    };
  }
  const ae = (n + _1n$5) / _2n$3;
  return function(he, me) {
    if (he.pow(me, t) === he.neg(he.ONE))
      throw new Error("Cannot find square root");
    let ye = ie, be = he.pow(he.mul(he.ONE, fe), n), Ae = he.pow(me, ae), Se = he.pow(me, n);
    for (; !he.eql(Se, he.ONE); ) {
      if (he.eql(Se, he.ZERO))
        return he.ZERO;
      let $e = 1;
      for (let Me = he.sqr(Se); $e < ye && !he.eql(Me, he.ONE); $e++)
        Me = he.sqr(Me);
      const Re = he.pow(be, _1n$5 << BigInt(ye - $e - 1));
      be = he.sqr(Re), Ae = he.mul(Ae, Re), Se = he.mul(Se, be), ye = $e;
    }
    return Ae;
  };
}
function FpSqrt(c) {
  if (c % _4n === _3n$1) {
    const t = (c + _1n$5) / _4n;
    return function(ie, fe) {
      const ae = ie.pow(fe, t);
      if (!ie.eql(ie.sqr(ae), fe))
        throw new Error("Cannot find square root");
      return ae;
    };
  }
  if (c % _8n$2 === _5n$1) {
    const t = (c - _5n$1) / _8n$2;
    return function(ie, fe) {
      const ae = ie.mul(fe, _2n$3), le = ie.pow(ae, t), he = ie.mul(fe, le), me = ie.mul(ie.mul(he, _2n$3), le), ye = ie.mul(he, ie.sub(me, ie.ONE));
      if (!ie.eql(ie.sqr(ye), fe))
        throw new Error("Cannot find square root");
      return ye;
    };
  }
  return tonelliShanks(c);
}
const isNegativeLE = (c, t) => (mod(c, t) & _1n$5) === _1n$5, FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(c) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = FIELD_FIELDS.reduce((ie, fe) => (ie[fe] = "function", ie), t);
  return validateObject(c, n);
}
function FpPow(c, t, n) {
  if (n < _0n$3)
    throw new Error("Expected power > 0");
  if (n === _0n$3)
    return c.ONE;
  if (n === _1n$5)
    return t;
  let ie = c.ONE, fe = t;
  for (; n > _0n$3; )
    n & _1n$5 && (ie = c.mul(ie, fe)), fe = c.sqr(fe), n >>= _1n$5;
  return ie;
}
function FpInvertBatch(c, t) {
  const n = new Array(t.length), ie = t.reduce((ae, le, he) => c.is0(le) ? ae : (n[he] = ae, c.mul(ae, le)), c.ONE), fe = c.inv(ie);
  return t.reduceRight((ae, le, he) => c.is0(le) ? ae : (n[he] = c.mul(ae, n[he]), c.mul(ae, le)), fe), n;
}
function nLength(c, t) {
  const n = t !== void 0 ? t : c.toString(2).length, ie = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: ie };
}
function Field(c, t, n = !1, ie = {}) {
  if (c <= _0n$3)
    throw new Error(`Expected Field ORDER > 0, got ${c}`);
  const { nBitLength: fe, nByteLength: ae } = nLength(c, t);
  if (ae > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const le = FpSqrt(c), he = Object.freeze({
    ORDER: c,
    BITS: fe,
    BYTES: ae,
    MASK: bitMask(fe),
    ZERO: _0n$3,
    ONE: _1n$5,
    create: (me) => mod(me, c),
    isValid: (me) => {
      if (typeof me != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof me}`);
      return _0n$3 <= me && me < c;
    },
    is0: (me) => me === _0n$3,
    isOdd: (me) => (me & _1n$5) === _1n$5,
    neg: (me) => mod(-me, c),
    eql: (me, ye) => me === ye,
    sqr: (me) => mod(me * me, c),
    add: (me, ye) => mod(me + ye, c),
    sub: (me, ye) => mod(me - ye, c),
    mul: (me, ye) => mod(me * ye, c),
    pow: (me, ye) => FpPow(he, me, ye),
    div: (me, ye) => mod(me * invert(ye, c), c),
    // Same as above, but doesn't normalize
    sqrN: (me) => me * me,
    addN: (me, ye) => me + ye,
    subN: (me, ye) => me - ye,
    mulN: (me, ye) => me * ye,
    inv: (me) => invert(me, c),
    sqrt: ie.sqrt || ((me) => le(he, me)),
    invertBatch: (me) => FpInvertBatch(he, me),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (me, ye, be) => be ? ye : me,
    toBytes: (me) => n ? numberToBytesLE(me, ae) : numberToBytesBE(me, ae),
    fromBytes: (me) => {
      if (me.length !== ae)
        throw new Error(`Fp.fromBytes: expected ${ae}, got ${me.length}`);
      return n ? bytesToNumberLE(me) : bytesToNumberBE(me);
    }
  });
  return Object.freeze(he);
}
function getFieldBytesLength(c) {
  if (typeof c != "bigint")
    throw new Error("field order must be bigint");
  const t = c.toString(2).length;
  return Math.ceil(t / 8);
}
function getMinHashLength(c) {
  const t = getFieldBytesLength(c);
  return t + Math.ceil(t / 2);
}
function mapHashToField(c, t, n = !1) {
  const ie = c.length, fe = getFieldBytesLength(t), ae = getMinHashLength(t);
  if (ie < 16 || ie < ae || ie > 1024)
    throw new Error(`expected ${ae}-1024 bytes of input, got ${ie}`);
  const le = n ? bytesToNumberBE(c) : bytesToNumberLE(c), he = mod(le, t - _1n$5) + _1n$5;
  return n ? numberToBytesLE(he, fe) : numberToBytesBE(he, fe);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$2 = BigInt(0), _1n$4 = BigInt(1), pointPrecomputes = /* @__PURE__ */ new WeakMap(), pointWindowSizes = /* @__PURE__ */ new WeakMap();
function wNAF(c, t) {
  const n = (ae, le) => {
    const he = le.negate();
    return ae ? he : le;
  }, ie = (ae) => {
    if (!Number.isSafeInteger(ae) || ae <= 0 || ae > t)
      throw new Error(`Wrong window size=${ae}, should be [1..${t}]`);
  }, fe = (ae) => {
    ie(ae);
    const le = Math.ceil(t / ae) + 1, he = 2 ** (ae - 1);
    return { windows: le, windowSize: he };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(ae, le) {
      let he = c.ZERO, me = ae;
      for (; le > _0n$2; )
        le & _1n$4 && (he = he.add(me)), me = me.double(), le >>= _1n$4;
      return he;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(ae, le) {
      const { windows: he, windowSize: me } = fe(le), ye = [];
      let be = ae, Ae = be;
      for (let Se = 0; Se < he; Se++) {
        Ae = be, ye.push(Ae);
        for (let $e = 1; $e < me; $e++)
          Ae = Ae.add(be), ye.push(Ae);
        be = Ae.double();
      }
      return ye;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(ae, le, he) {
      const { windows: me, windowSize: ye } = fe(ae);
      let be = c.ZERO, Ae = c.BASE;
      const Se = BigInt(2 ** ae - 1), $e = 2 ** ae, Re = BigInt(ae);
      for (let Me = 0; Me < me; Me++) {
        const ke = Me * ye;
        let Te = Number(he & Se);
        he >>= Re, Te > ye && (Te -= $e, he += _1n$4);
        const Ie = ke, qe = ke + Math.abs(Te) - 1, Ue = Me % 2 !== 0, ze = Te < 0;
        Te === 0 ? Ae = Ae.add(n(Ue, le[Ie])) : be = be.add(n(ze, le[qe]));
      }
      return { p: be, f: Ae };
    },
    wNAFCached(ae, le, he) {
      const me = pointWindowSizes.get(ae) || 1;
      let ye = pointPrecomputes.get(ae);
      return ye || (ye = this.precomputeWindow(ae, me), me !== 1 && pointPrecomputes.set(ae, he(ye))), this.wNAF(me, ye, le);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(ae, le) {
      ie(le), pointWindowSizes.set(ae, le), pointPrecomputes.delete(ae);
    }
  };
}
function pippenger(c, t, n, ie) {
  if (!Array.isArray(n) || !Array.isArray(ie) || ie.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  ie.forEach((be, Ae) => {
    if (!t.isValid(be))
      throw new Error(`wrong scalar at index ${Ae}`);
  }), n.forEach((be, Ae) => {
    if (!(be instanceof c))
      throw new Error(`wrong point at index ${Ae}`);
  });
  const fe = bitLen(BigInt(n.length)), ae = fe > 12 ? fe - 3 : fe > 4 ? fe - 2 : fe ? 2 : 1, le = (1 << ae) - 1, he = new Array(le + 1).fill(c.ZERO), me = Math.floor((t.BITS - 1) / ae) * ae;
  let ye = c.ZERO;
  for (let be = me; be >= 0; be -= ae) {
    he.fill(c.ZERO);
    for (let Se = 0; Se < ie.length; Se++) {
      const $e = ie[Se], Re = Number($e >> BigInt(be) & BigInt(le));
      he[Re] = he[Re].add(n[Se]);
    }
    let Ae = c.ZERO;
    for (let Se = he.length - 1, $e = c.ZERO; Se > 0; Se--)
      $e = $e.add(he[Se]), Ae = Ae.add($e);
    if (ye = ye.add(Ae), be !== 0)
      for (let Se = 0; Se < ae; Se++)
        ye = ye.double();
  }
  return ye;
}
function validateBasic(c) {
  return validateField(c.Fp), validateObject(c, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength(c.n, c.nBitLength),
    ...c,
    p: c.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$1 = BigInt(0), _1n$3 = BigInt(1), _2n$2 = BigInt(2), _8n$1 = BigInt(8), VERIFY_DEFAULT = { zip215: !0 };
function validateOpts$1(c) {
  const t = validateBasic(c);
  return validateObject(c, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...t });
}
function twistedEdwards(c) {
  const t = validateOpts$1(c), { Fp: n, n: ie, prehash: fe, hash: ae, randomBytes: le, nByteLength: he, h: me } = t, ye = _2n$2 << BigInt(he * 8) - _1n$3, be = n.create, Ae = Field(t.n, t.nBitLength), Se = t.uvRatio || ((ve, we) => {
    try {
      return { isValid: !0, value: n.sqrt(ve * n.inv(we)) };
    } catch {
      return { isValid: !1, value: _0n$1 };
    }
  }), $e = t.adjustScalarBytes || ((ve) => ve), Re = t.domain || ((ve, we, Ee) => {
    if (abool("phflag", Ee), we.length || Ee)
      throw new Error("Contexts/pre-hash are not supported");
    return ve;
  });
  function Me(ve, we) {
    aInRange("coordinate " + ve, we, _0n$1, ye);
  }
  function ke(ve) {
    if (!(ve instanceof qe))
      throw new Error("ExtendedPoint expected");
  }
  const Te = memoized((ve, we) => {
    const { ex: Ee, ey: xe, ez: ue } = ve, ge = ve.is0();
    we == null && (we = ge ? _8n$1 : n.inv(ue));
    const Be = be(Ee * we), Ne = be(xe * we), Fe = be(ue * we);
    if (ge)
      return { x: _0n$1, y: _1n$3 };
    if (Fe !== _1n$3)
      throw new Error("invZ was invalid");
    return { x: Be, y: Ne };
  }), Ie = memoized((ve) => {
    const { a: we, d: Ee } = t;
    if (ve.is0())
      throw new Error("bad point: ZERO");
    const { ex: xe, ey: ue, ez: ge, et: Be } = ve, Ne = be(xe * xe), Fe = be(ue * ue), Pe = be(ge * ge), Je = be(Pe * Pe), Ke = be(Ne * we), Ze = be(Pe * be(Ke + Fe)), Ye = be(Je + be(Ee * be(Ne * Fe)));
    if (Ze !== Ye)
      throw new Error("bad point: equation left != right (1)");
    const Pt = be(xe * ue), Ft = be(ge * Be);
    if (Pt !== Ft)
      throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class qe {
    constructor(we, Ee, xe, ue) {
      this.ex = we, this.ey = Ee, this.ez = xe, this.et = ue, Me("x", we), Me("y", Ee), Me("z", xe), Me("t", ue), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(we) {
      if (we instanceof qe)
        throw new Error("extended point not allowed");
      const { x: Ee, y: xe } = we || {};
      return Me("x", Ee), Me("y", xe), new qe(Ee, xe, _1n$3, be(Ee * xe));
    }
    static normalizeZ(we) {
      const Ee = n.invertBatch(we.map((xe) => xe.ez));
      return we.map((xe, ue) => xe.toAffine(Ee[ue])).map(qe.fromAffine);
    }
    // Multiscalar Multiplication
    static msm(we, Ee) {
      return pippenger(qe, Ae, we, Ee);
    }
    // "Private method", don't use it directly
    _setWindowSize(we) {
      Ve.setWindowSize(this, we);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      Ie(this);
    }
    // Compare one point to another.
    equals(we) {
      ke(we);
      const { ex: Ee, ey: xe, ez: ue } = this, { ex: ge, ey: Be, ez: Ne } = we, Fe = be(Ee * Ne), Pe = be(ge * ue), Je = be(xe * Ne), Ke = be(Be * ue);
      return Fe === Pe && Je === Ke;
    }
    is0() {
      return this.equals(qe.ZERO);
    }
    negate() {
      return new qe(be(-this.ex), this.ey, this.ez, be(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: we } = t, { ex: Ee, ey: xe, ez: ue } = this, ge = be(Ee * Ee), Be = be(xe * xe), Ne = be(_2n$2 * be(ue * ue)), Fe = be(we * ge), Pe = Ee + xe, Je = be(be(Pe * Pe) - ge - Be), Ke = Fe + Be, Ze = Ke - Ne, Ye = Fe - Be, Pt = be(Je * Ze), Ft = be(Ke * Ye), Le = be(Je * Ye), $t = be(Ze * Ke);
      return new qe(Pt, Ft, $t, Le);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(we) {
      ke(we);
      const { a: Ee, d: xe } = t, { ex: ue, ey: ge, ez: Be, et: Ne } = this, { ex: Fe, ey: Pe, ez: Je, et: Ke } = we;
      if (Ee === BigInt(-1)) {
        const An = be((ge - ue) * (Pe + Fe)), Qt = be((ge + ue) * (Pe - Fe)), Xt = be(Qt - An);
        if (Xt === _0n$1)
          return this.double();
        const wn = be(Be * _2n$2 * Ke), Qe = be(Ne * _2n$2 * Je), Dt = Qe + wn, en = Qt + An, We = Qe - wn, De = be(Dt * Xt), Ge = be(en * We), Oe = be(Dt * We), Ce = be(Xt * en);
        return new qe(De, Ge, Ce, Oe);
      }
      const Ze = be(ue * Fe), Ye = be(ge * Pe), Pt = be(Ne * xe * Ke), Ft = be(Be * Je), Le = be((ue + ge) * (Fe + Pe) - Ze - Ye), $t = Ft - Pt, Jt = Ft + Pt, Ht = be(Ye - Ee * Ze), Vt = be(Le * $t), xn = be(Jt * Ht), Zt = be(Le * Ht), Gt = be($t * Jt);
      return new qe(Vt, xn, Gt, Zt);
    }
    subtract(we) {
      return this.add(we.negate());
    }
    wNAF(we) {
      return Ve.wNAFCached(this, we, qe.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(we) {
      const Ee = we;
      aInRange("scalar", Ee, _1n$3, ie);
      const { p: xe, f: ue } = this.wNAF(Ee);
      return qe.normalizeZ([xe, ue])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(we) {
      const Ee = we;
      return aInRange("scalar", Ee, _0n$1, ie), Ee === _0n$1 ? ze : this.equals(ze) || Ee === _1n$3 ? this : this.equals(Ue) ? this.wNAF(Ee).p : Ve.unsafeLadder(this, Ee);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(me).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return Ve.unsafeLadder(this, ie).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(we) {
      return Te(this, we);
    }
    clearCofactor() {
      const { h: we } = t;
      return we === _1n$3 ? this : this.multiplyUnsafe(we);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(we, Ee = !1) {
      const { d: xe, a: ue } = t, ge = n.BYTES;
      we = ensureBytes("pointHex", we, ge), abool("zip215", Ee);
      const Be = we.slice(), Ne = we[ge - 1];
      Be[ge - 1] = Ne & -129;
      const Fe = bytesToNumberLE(Be), Pe = Ee ? ye : n.ORDER;
      aInRange("pointHex.y", Fe, _0n$1, Pe);
      const Je = be(Fe * Fe), Ke = be(Je - _1n$3), Ze = be(xe * Je - ue);
      let { isValid: Ye, value: Pt } = Se(Ke, Ze);
      if (!Ye)
        throw new Error("Point.fromHex: invalid y coordinate");
      const Ft = (Pt & _1n$3) === _1n$3, Le = (Ne & 128) !== 0;
      if (!Ee && Pt === _0n$1 && Le)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return Le !== Ft && (Pt = be(-Pt)), qe.fromAffine({ x: Pt, y: Fe });
    }
    static fromPrivateKey(we) {
      return je(we).point;
    }
    toRawBytes() {
      const { x: we, y: Ee } = this.toAffine(), xe = numberToBytesLE(Ee, n.BYTES);
      return xe[xe.length - 1] |= we & _1n$3 ? 128 : 0, xe;
    }
    toHex() {
      return bytesToHex(this.toRawBytes());
    }
  }
  qe.BASE = new qe(t.Gx, t.Gy, _1n$3, be(t.Gx * t.Gy)), qe.ZERO = new qe(_0n$1, _1n$3, _1n$3, _0n$1);
  const { BASE: Ue, ZERO: ze } = qe, Ve = wNAF(qe, he * 8);
  function Mt(ve) {
    return mod(ve, ie);
  }
  function Rt(ve) {
    return Mt(bytesToNumberLE(ve));
  }
  function je(ve) {
    const we = he;
    ve = ensureBytes("private key", ve, we);
    const Ee = ensureBytes("hashed private key", ae(ve), 2 * we), xe = $e(Ee.slice(0, we)), ue = Ee.slice(we, 2 * we), ge = Rt(xe), Be = Ue.multiply(ge), Ne = Be.toRawBytes();
    return { head: xe, prefix: ue, scalar: ge, point: Be, pointBytes: Ne };
  }
  function jt(ve) {
    return je(ve).pointBytes;
  }
  function _e(ve = new Uint8Array(), ...we) {
    const Ee = concatBytes(...we);
    return Rt(ae(Re(Ee, ensureBytes("context", ve), !!fe)));
  }
  function se(ve, we, Ee = {}) {
    ve = ensureBytes("message", ve), fe && (ve = fe(ve));
    const { prefix: xe, scalar: ue, pointBytes: ge } = je(we), Be = _e(Ee.context, xe, ve), Ne = Ue.multiply(Be).toRawBytes(), Fe = _e(Ee.context, Ne, ge, ve), Pe = Mt(Be + Fe * ue);
    aInRange("signature.s", Pe, _0n$1, ie);
    const Je = concatBytes(Ne, numberToBytesLE(Pe, n.BYTES));
    return ensureBytes("result", Je, he * 2);
  }
  const ce = VERIFY_DEFAULT;
  function de(ve, we, Ee, xe = ce) {
    const { context: ue, zip215: ge } = xe, Be = n.BYTES;
    ve = ensureBytes("signature", ve, 2 * Be), we = ensureBytes("message", we), ge !== void 0 && abool("zip215", ge), fe && (we = fe(we));
    const Ne = bytesToNumberLE(ve.slice(Be, 2 * Be));
    let Fe, Pe, Je;
    try {
      Fe = qe.fromHex(Ee, ge), Pe = qe.fromHex(ve.slice(0, Be), ge), Je = Ue.multiplyUnsafe(Ne);
    } catch {
      return !1;
    }
    if (!ge && Fe.isSmallOrder())
      return !1;
    const Ke = _e(ue, Pe.toRawBytes(), Fe.toRawBytes(), we);
    return Pe.add(Fe.multiplyUnsafe(Ke)).subtract(Je).clearCofactor().equals(qe.ZERO);
  }
  return Ue._setWindowSize(8), {
    CURVE: t,
    getPublicKey: jt,
    sign: se,
    verify: de,
    ExtendedPoint: qe,
    utils: {
      getExtendedPublicKey: je,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => le(n.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(ve = 8, we = qe.BASE) {
        return we._setWindowSize(ve), we.multiply(BigInt(3)), we;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const _1n$2 = BigInt(1), _2n$1 = BigInt(2);
BigInt(3);
const _5n = BigInt(5), _8n = BigInt(8);
function ed25519_pow_2_252_3(c) {
  const t = BigInt(10), n = BigInt(20), ie = BigInt(40), fe = BigInt(80), ae = ED25519_P, he = c * c % ae * c % ae, me = pow2(he, _2n$1, ae) * he % ae, ye = pow2(me, _1n$2, ae) * c % ae, be = pow2(ye, _5n, ae) * ye % ae, Ae = pow2(be, t, ae) * be % ae, Se = pow2(Ae, n, ae) * Ae % ae, $e = pow2(Se, ie, ae) * Se % ae, Re = pow2($e, fe, ae) * $e % ae, Me = pow2(Re, fe, ae) * $e % ae, ke = pow2(Me, t, ae) * be % ae;
  return { pow_p_5_8: pow2(ke, _2n$1, ae) * c % ae, b2: he };
}
function adjustScalarBytes(c) {
  return c[0] &= 248, c[31] &= 127, c[31] |= 64, c;
}
function uvRatio(c, t) {
  const n = ED25519_P, ie = mod(t * t * t, n), fe = mod(ie * ie * t, n), ae = ed25519_pow_2_252_3(c * fe).pow_p_5_8;
  let le = mod(c * ie * ae, n);
  const he = mod(t * le * le, n), me = le, ye = mod(le * ED25519_SQRT_M1, n), be = he === c, Ae = he === mod(-c, n), Se = he === mod(-c * ED25519_SQRT_M1, n);
  return be && (le = me), (Ae || Se) && (le = ye), isNegativeLE(le, n) && (le = mod(-le, n)), { isValid: be || Ae, value: le };
}
const Fp$1 = Field(ED25519_P, void 0, !0), ed25519Defaults = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: Fp$1,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: _8n,
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: sha512$3,
  randomBytes,
  adjustScalarBytes,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio
}, ed25519 = twistedEdwards(ed25519Defaults);
var safeBuffer$1 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(c, t) {
  var n = require$$0$5, ie = n.Buffer;
  function fe(le, he) {
    for (var me in le)
      he[me] = le[me];
  }
  ie.from && ie.alloc && ie.allocUnsafe && ie.allocUnsafeSlow ? c.exports = n : (fe(n, t), t.Buffer = ae);
  function ae(le, he, me) {
    return ie(le, he, me);
  }
  ae.prototype = Object.create(ie.prototype), fe(ie, ae), ae.from = function(le, he, me) {
    if (typeof le == "number")
      throw new TypeError("Argument must not be a number");
    return ie(le, he, me);
  }, ae.alloc = function(le, he, me) {
    if (typeof le != "number")
      throw new TypeError("Argument must be a number");
    var ye = ie(le);
    return he !== void 0 ? typeof me == "string" ? ye.fill(he, me) : ye.fill(he) : ye.fill(0), ye;
  }, ae.allocUnsafe = function(le) {
    if (typeof le != "number")
      throw new TypeError("Argument must be a number");
    return ie(le);
  }, ae.allocUnsafeSlow = function(le) {
    if (typeof le != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(le);
  };
})(safeBuffer$1, safeBuffer$1.exports);
var safeBufferExports = safeBuffer$1.exports, _Buffer = safeBufferExports.Buffer;
function base$5(c) {
  if (c.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), n = 0; n < t.length; n++)
    t[n] = 255;
  for (var ie = 0; ie < c.length; ie++) {
    var fe = c.charAt(ie), ae = fe.charCodeAt(0);
    if (t[ae] !== 255)
      throw new TypeError(fe + " is ambiguous");
    t[ae] = ie;
  }
  var le = c.length, he = c.charAt(0), me = Math.log(le) / Math.log(256), ye = Math.log(256) / Math.log(le);
  function be($e) {
    if ((Array.isArray($e) || $e instanceof Uint8Array) && ($e = _Buffer.from($e)), !_Buffer.isBuffer($e))
      throw new TypeError("Expected Buffer");
    if ($e.length === 0)
      return "";
    for (var Re = 0, Me = 0, ke = 0, Te = $e.length; ke !== Te && $e[ke] === 0; )
      ke++, Re++;
    for (var Ie = (Te - ke) * ye + 1 >>> 0, qe = new Uint8Array(Ie); ke !== Te; ) {
      for (var Ue = $e[ke], ze = 0, Ve = Ie - 1; (Ue !== 0 || ze < Me) && Ve !== -1; Ve--, ze++)
        Ue += 256 * qe[Ve] >>> 0, qe[Ve] = Ue % le >>> 0, Ue = Ue / le >>> 0;
      if (Ue !== 0)
        throw new Error("Non-zero carry");
      Me = ze, ke++;
    }
    for (var Mt = Ie - Me; Mt !== Ie && qe[Mt] === 0; )
      Mt++;
    for (var Rt = he.repeat(Re); Mt < Ie; ++Mt)
      Rt += c.charAt(qe[Mt]);
    return Rt;
  }
  function Ae($e) {
    if (typeof $e != "string")
      throw new TypeError("Expected String");
    if ($e.length === 0)
      return _Buffer.alloc(0);
    for (var Re = 0, Me = 0, ke = 0; $e[Re] === he; )
      Me++, Re++;
    for (var Te = ($e.length - Re) * me + 1 >>> 0, Ie = new Uint8Array(Te); Re < $e.length; ) {
      var qe = t[$e.charCodeAt(Re)];
      if (qe === 255)
        return;
      for (var Ue = 0, ze = Te - 1; (qe !== 0 || Ue < ke) && ze !== -1; ze--, Ue++)
        qe += le * Ie[ze] >>> 0, Ie[ze] = qe % 256 >>> 0, qe = qe / 256 >>> 0;
      if (qe !== 0)
        throw new Error("Non-zero carry");
      ke = Ue, Re++;
    }
    for (var Ve = Te - ke; Ve !== Te && Ie[Ve] === 0; )
      Ve++;
    var Mt = _Buffer.allocUnsafe(Me + (Te - Ve));
    Mt.fill(0, 0, Me);
    for (var Rt = Me; Ve !== Te; )
      Mt[Rt++] = Ie[Ve++];
    return Mt;
  }
  function Se($e) {
    var Re = Ae($e);
    if (Re)
      return Re;
    throw new Error("Non-base" + le + " character");
  }
  return {
    encode: be,
    decodeUnsafe: Ae,
    decode: Se
  };
}
var src$7 = base$5;
const e$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(src$7);
var basex = src$7, ALPHABET$1 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", bs58 = basex(ALPHABET$1);
const o$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(bs58), SHA256_K = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A: t, B: n, C: ie, D: fe, E: ae, F: le, G: he, H: me } = this;
    return [t, n, ie, fe, ae, le, he, me];
  }
  // prettier-ignore
  set(t, n, ie, fe, ae, le, he, me) {
    this.A = t | 0, this.B = n | 0, this.C = ie | 0, this.D = fe | 0, this.E = ae | 0, this.F = le | 0, this.G = he | 0, this.H = me | 0;
  }
  process(t, n) {
    for (let Ae = 0; Ae < 16; Ae++, n += 4)
      SHA256_W[Ae] = t.getUint32(n, !1);
    for (let Ae = 16; Ae < 64; Ae++) {
      const Se = SHA256_W[Ae - 15], $e = SHA256_W[Ae - 2], Re = rotr(Se, 7) ^ rotr(Se, 18) ^ Se >>> 3, Me = rotr($e, 17) ^ rotr($e, 19) ^ $e >>> 10;
      SHA256_W[Ae] = Me + SHA256_W[Ae - 7] + Re + SHA256_W[Ae - 16] | 0;
    }
    let { A: ie, B: fe, C: ae, D: le, E: he, F: me, G: ye, H: be } = this;
    for (let Ae = 0; Ae < 64; Ae++) {
      const Se = rotr(he, 6) ^ rotr(he, 11) ^ rotr(he, 25), $e = be + Se + Chi(he, me, ye) + SHA256_K[Ae] + SHA256_W[Ae] | 0, Me = (rotr(ie, 2) ^ rotr(ie, 13) ^ rotr(ie, 22)) + Maj(ie, fe, ae) | 0;
      be = ye, ye = me, me = he, he = le + $e | 0, le = ae, ae = fe, fe = ie, ie = $e + Me | 0;
    }
    ie = ie + this.A | 0, fe = fe + this.B | 0, ae = ae + this.C | 0, le = le + this.D | 0, he = he + this.E | 0, me = me + this.F | 0, ye = ye + this.G | 0, be = be + this.H | 0, this.set(ie, fe, ae, le, he, me, ye, be);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const sha256$4 = /* @__PURE__ */ wrapConstructor(() => new SHA256());
var lib = {};
function inRange(c, t, n) {
  return t <= c && c <= n;
}
function ToDictionary(c) {
  if (c === void 0) return {};
  if (c === Object(c)) return c;
  throw TypeError("Could not convert argument to dictionary");
}
function stringToCodePoints(c) {
  for (var t = String(c), n = t.length, ie = 0, fe = []; ie < n; ) {
    var ae = t.charCodeAt(ie);
    if (ae < 55296 || ae > 57343)
      fe.push(ae);
    else if (56320 <= ae && ae <= 57343)
      fe.push(65533);
    else if (55296 <= ae && ae <= 56319)
      if (ie === n - 1)
        fe.push(65533);
      else {
        var le = c.charCodeAt(ie + 1);
        if (56320 <= le && le <= 57343) {
          var he = ae & 1023, me = le & 1023;
          fe.push(65536 + (he << 10) + me), ie += 1;
        } else
          fe.push(65533);
      }
    ie += 1;
  }
  return fe;
}
function codePointsToString(c) {
  for (var t = "", n = 0; n < c.length; ++n) {
    var ie = c[n];
    ie <= 65535 ? t += String.fromCharCode(ie) : (ie -= 65536, t += String.fromCharCode(
      (ie >> 10) + 55296,
      (ie & 1023) + 56320
    ));
  }
  return t;
}
var end_of_stream = -1;
function Stream(c) {
  this.tokens = [].slice.call(c);
}
Stream.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : end_of_stream;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(c) {
    if (Array.isArray(c))
      for (var t = (
        /**@type {!Array.<number>}*/
        c
      ); t.length; )
        this.tokens.unshift(t.pop());
    else
      this.tokens.unshift(c);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(c) {
    if (Array.isArray(c))
      for (var t = (
        /**@type {!Array.<number>}*/
        c
      ); t.length; )
        this.tokens.push(t.shift());
    else
      this.tokens.push(c);
  }
};
var finished = -1;
function decoderError(c, t) {
  if (c)
    throw TypeError("Decoder error");
  return t || 65533;
}
var DEFAULT_ENCODING = "utf-8";
function TextDecoder$1(c, t) {
  if (!(this instanceof TextDecoder$1))
    return new TextDecoder$1(c, t);
  if (c = c !== void 0 ? String(c).toLowerCase() : DEFAULT_ENCODING, c !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = ToDictionary(t), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!t.fatal, this._ignoreBOM = !!t.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
TextDecoder$1.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(t, n) {
    var ie;
    typeof t == "object" && t instanceof ArrayBuffer ? ie = new Uint8Array(t) : typeof t == "object" && "buffer" in t && t.buffer instanceof ArrayBuffer ? ie = new Uint8Array(
      t.buffer,
      t.byteOffset,
      t.byteLength
    ) : ie = new Uint8Array(0), n = ToDictionary(n), this._streaming || (this._decoder = new UTF8Decoder({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!n.stream;
    for (var fe = new Stream(ie), ae = [], le; !fe.endOfStream() && (le = this._decoder.handler(fe, fe.read()), le !== finished); )
      le !== null && (Array.isArray(le) ? ae.push.apply(
        ae,
        /**@type {!Array.<number>}*/
        le
      ) : ae.push(le));
    if (!this._streaming) {
      do {
        if (le = this._decoder.handler(fe, fe.read()), le === finished)
          break;
        le !== null && (Array.isArray(le) ? ae.push.apply(
          ae,
          /**@type {!Array.<number>}*/
          le
        ) : ae.push(le));
      } while (!fe.endOfStream());
      this._decoder = null;
    }
    return ae.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (ae[0] === 65279 ? (this._BOMseen = !0, ae.shift()) : this._BOMseen = !0), codePointsToString(ae);
  }
};
function TextEncoder$1(c, t) {
  if (!(this instanceof TextEncoder$1))
    return new TextEncoder$1(c, t);
  if (c = c !== void 0 ? String(c).toLowerCase() : DEFAULT_ENCODING, c !== DEFAULT_ENCODING)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = ToDictionary(t), this._streaming = !1, this._encoder = null, this._options = { fatal: !!t.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
TextEncoder$1.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(t, n) {
    t = t ? String(t) : "", n = ToDictionary(n), this._streaming || (this._encoder = new UTF8Encoder(this._options)), this._streaming = !!n.stream;
    for (var ie = [], fe = new Stream(stringToCodePoints(t)), ae; !fe.endOfStream() && (ae = this._encoder.handler(fe, fe.read()), ae !== finished); )
      Array.isArray(ae) ? ie.push.apply(
        ie,
        /**@type {!Array.<number>}*/
        ae
      ) : ie.push(ae);
    if (!this._streaming) {
      for (; ae = this._encoder.handler(fe, fe.read()), ae !== finished; )
        Array.isArray(ae) ? ie.push.apply(
          ie,
          /**@type {!Array.<number>}*/
          ae
        ) : ie.push(ae);
      this._encoder = null;
    }
    return new Uint8Array(ie);
  }
};
function UTF8Decoder(c) {
  var t = c.fatal, n = 0, ie = 0, fe = 0, ae = 128, le = 191;
  this.handler = function(he, me) {
    if (me === end_of_stream && fe !== 0)
      return fe = 0, decoderError(t);
    if (me === end_of_stream)
      return finished;
    if (fe === 0) {
      if (inRange(me, 0, 127))
        return me;
      if (inRange(me, 194, 223))
        fe = 1, n = me - 192;
      else if (inRange(me, 224, 239))
        me === 224 && (ae = 160), me === 237 && (le = 159), fe = 2, n = me - 224;
      else if (inRange(me, 240, 244))
        me === 240 && (ae = 144), me === 244 && (le = 143), fe = 3, n = me - 240;
      else
        return decoderError(t);
      return n = n << 6 * fe, null;
    }
    if (!inRange(me, ae, le))
      return n = fe = ie = 0, ae = 128, le = 191, he.prepend(me), decoderError(t);
    if (ae = 128, le = 191, ie += 1, n += me - 128 << 6 * (fe - ie), ie !== fe)
      return null;
    var ye = n;
    return n = fe = ie = 0, ye;
  };
}
function UTF8Encoder(c) {
  c.fatal, this.handler = function(t, n) {
    if (n === end_of_stream)
      return finished;
    if (inRange(n, 0, 127))
      return n;
    var ie, fe;
    inRange(n, 128, 2047) ? (ie = 1, fe = 192) : inRange(n, 2048, 65535) ? (ie = 2, fe = 224) : inRange(n, 65536, 1114111) && (ie = 3, fe = 240);
    for (var ae = [(n >> 6 * ie) + fe]; ie > 0; ) {
      var le = n >> 6 * (ie - 1);
      ae.push(128 | le & 63), ie -= 1;
    }
    return ae;
  };
}
const encoding$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: TextDecoder$1,
  TextEncoder: TextEncoder$1
}, Symbol.toStringTag, { value: "Module" })), require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(encoding$1);
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n), Object.defineProperty(c, ie, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __decorate = commonjsGlobal && commonjsGlobal.__decorate || function(c, t, n, ie) {
  var fe = arguments.length, ae = fe < 3 ? t : ie === null ? ie = Object.getOwnPropertyDescriptor(t, n) : ie, le;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") ae = Reflect.decorate(c, t, n, ie);
  else for (var he = c.length - 1; he >= 0; he--) (le = c[he]) && (ae = (fe < 3 ? le(ae) : fe > 3 ? le(t, n, ae) : le(t, n)) || ae);
  return fe > 3 && ae && Object.defineProperty(t, n, ae), ae;
}, __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.hasOwnProperty.call(c, n) && __createBinding$9(t, c, n);
  return __setModuleDefault$9(t, c), t;
}, __importDefault$9 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(lib, "__esModule", { value: !0 });
var deserializeUnchecked_1 = lib.deserializeUnchecked = deserialize_1 = lib.deserialize = serialize_1 = lib.serialize = lib.BinaryReader = lib.BinaryWriter = lib.BorshError = lib.baseDecode = lib.baseEncode = void 0;
const bn_js_1$1 = __importDefault$9(bnExports$3), bs58_1 = __importDefault$9(bs58), encoding = __importStar$9(require$$2$2), ResolvedTextDecoder = typeof TextDecoder != "function" ? encoding.TextDecoder : TextDecoder, textDecoder = new ResolvedTextDecoder("utf-8", { fatal: !0 });
function baseEncode(c) {
  return typeof c == "string" && (c = Buffer$7.from(c, "utf8")), bs58_1.default.encode(Buffer$7.from(c));
}
lib.baseEncode = baseEncode;
function baseDecode(c) {
  return Buffer$7.from(bs58_1.default.decode(c));
}
lib.baseDecode = baseDecode;
const INITIAL_LENGTH = 1024;
class BorshError extends Error {
  constructor(t) {
    super(t), this.fieldPath = [], this.originalMessage = t;
  }
  addToFieldPath(t) {
    this.fieldPath.splice(0, 0, t), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
lib.BorshError = BorshError;
class BinaryWriter {
  constructor() {
    this.buf = Buffer$7.alloc(INITIAL_LENGTH), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Buffer$7.concat([this.buf, Buffer$7.alloc(INITIAL_LENGTH)]));
  }
  writeU8(t) {
    this.maybeResize(), this.buf.writeUInt8(t, this.length), this.length += 1;
  }
  writeU16(t) {
    this.maybeResize(), this.buf.writeUInt16LE(t, this.length), this.length += 2;
  }
  writeU32(t) {
    this.maybeResize(), this.buf.writeUInt32LE(t, this.length), this.length += 4;
  }
  writeU64(t) {
    this.maybeResize(), this.writeBuffer(Buffer$7.from(new bn_js_1$1.default(t).toArray("le", 8)));
  }
  writeU128(t) {
    this.maybeResize(), this.writeBuffer(Buffer$7.from(new bn_js_1$1.default(t).toArray("le", 16)));
  }
  writeU256(t) {
    this.maybeResize(), this.writeBuffer(Buffer$7.from(new bn_js_1$1.default(t).toArray("le", 32)));
  }
  writeU512(t) {
    this.maybeResize(), this.writeBuffer(Buffer$7.from(new bn_js_1$1.default(t).toArray("le", 64)));
  }
  writeBuffer(t) {
    this.buf = Buffer$7.concat([
      Buffer$7.from(this.buf.subarray(0, this.length)),
      t,
      Buffer$7.alloc(INITIAL_LENGTH)
    ]), this.length += t.length;
  }
  writeString(t) {
    this.maybeResize();
    const n = Buffer$7.from(t, "utf8");
    this.writeU32(n.length), this.writeBuffer(n);
  }
  writeFixedArray(t) {
    this.writeBuffer(Buffer$7.from(t));
  }
  writeArray(t, n) {
    this.maybeResize(), this.writeU32(t.length);
    for (const ie of t)
      this.maybeResize(), n(ie);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
lib.BinaryWriter = BinaryWriter;
function handlingRangeError(c, t, n) {
  const ie = n.value;
  n.value = function(...fe) {
    try {
      return ie.apply(this, fe);
    } catch (ae) {
      if (ae instanceof RangeError) {
        const le = ae.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(le) >= 0)
          throw new BorshError("Reached the end of buffer when deserializing");
      }
      throw ae;
    }
  };
}
class BinaryReader {
  constructor(t) {
    this.buf = t, this.offset = 0;
  }
  readU8() {
    const t = this.buf.readUInt8(this.offset);
    return this.offset += 1, t;
  }
  readU16() {
    const t = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, t;
  }
  readU32() {
    const t = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readU64() {
    const t = this.readBuffer(8);
    return new bn_js_1$1.default(t, "le");
  }
  readU128() {
    const t = this.readBuffer(16);
    return new bn_js_1$1.default(t, "le");
  }
  readU256() {
    const t = this.readBuffer(32);
    return new bn_js_1$1.default(t, "le");
  }
  readU512() {
    const t = this.readBuffer(64);
    return new bn_js_1$1.default(t, "le");
  }
  readBuffer(t) {
    if (this.offset + t > this.buf.length)
      throw new BorshError(`Expected buffer length ${t} isn't within bounds`);
    const n = this.buf.slice(this.offset, this.offset + t);
    return this.offset += t, n;
  }
  readString() {
    const t = this.readU32(), n = this.readBuffer(t);
    try {
      return textDecoder.decode(n);
    } catch (ie) {
      throw new BorshError(`Error decoding UTF-8 string: ${ie}`);
    }
  }
  readFixedArray(t) {
    return new Uint8Array(this.readBuffer(t));
  }
  readArray(t) {
    const n = this.readU32(), ie = Array();
    for (let fe = 0; fe < n; ++fe)
      ie.push(t());
    return ie;
  }
}
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU8", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU16", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU32", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU64", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU128", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU256", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readU512", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readString", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readFixedArray", null);
__decorate([
  handlingRangeError
], BinaryReader.prototype, "readArray", null);
lib.BinaryReader = BinaryReader;
function capitalizeFirstLetter(c) {
  return c.charAt(0).toUpperCase() + c.slice(1);
}
function serializeField(c, t, n, ie, fe) {
  try {
    if (typeof ie == "string")
      fe[`write${capitalizeFirstLetter(ie)}`](n);
    else if (ie instanceof Array)
      if (typeof ie[0] == "number") {
        if (n.length !== ie[0])
          throw new BorshError(`Expecting byte array of length ${ie[0]}, but got ${n.length} bytes`);
        fe.writeFixedArray(n);
      } else if (ie.length === 2 && typeof ie[1] == "number") {
        if (n.length !== ie[1])
          throw new BorshError(`Expecting byte array of length ${ie[1]}, but got ${n.length} bytes`);
        for (let ae = 0; ae < ie[1]; ae++)
          serializeField(c, null, n[ae], ie[0], fe);
      } else
        fe.writeArray(n, (ae) => {
          serializeField(c, t, ae, ie[0], fe);
        });
    else if (ie.kind !== void 0)
      switch (ie.kind) {
        case "option": {
          n == null ? fe.writeU8(0) : (fe.writeU8(1), serializeField(c, t, n, ie.type, fe));
          break;
        }
        case "map": {
          fe.writeU32(n.size), n.forEach((ae, le) => {
            serializeField(c, t, le, ie.key, fe), serializeField(c, t, ae, ie.value, fe);
          });
          break;
        }
        default:
          throw new BorshError(`FieldType ${ie} unrecognized`);
      }
    else
      serializeStruct(c, n, fe);
  } catch (ae) {
    throw ae instanceof BorshError && ae.addToFieldPath(t), ae;
  }
}
function serializeStruct(c, t, n) {
  if (typeof t.borshSerialize == "function") {
    t.borshSerialize(n);
    return;
  }
  const ie = c.get(t.constructor);
  if (!ie)
    throw new BorshError(`Class ${t.constructor.name} is missing in schema`);
  if (ie.kind === "struct")
    ie.fields.map(([fe, ae]) => {
      serializeField(c, fe, t[fe], ae, n);
    });
  else if (ie.kind === "enum") {
    const fe = t[ie.field];
    for (let ae = 0; ae < ie.values.length; ++ae) {
      const [le, he] = ie.values[ae];
      if (le === fe) {
        n.writeU8(ae), serializeField(c, le, t[le], he, n);
        break;
      }
    }
  } else
    throw new BorshError(`Unexpected schema kind: ${ie.kind} for ${t.constructor.name}`);
}
function serialize(c, t, n = BinaryWriter) {
  const ie = new n();
  return serializeStruct(c, t, ie), ie.toArray();
}
var serialize_1 = lib.serialize = serialize;
function deserializeField(c, t, n, ie) {
  try {
    if (typeof n == "string")
      return ie[`read${capitalizeFirstLetter(n)}`]();
    if (n instanceof Array) {
      if (typeof n[0] == "number")
        return ie.readFixedArray(n[0]);
      if (typeof n[1] == "number") {
        const fe = [];
        for (let ae = 0; ae < n[1]; ae++)
          fe.push(deserializeField(c, null, n[0], ie));
        return fe;
      } else
        return ie.readArray(() => deserializeField(c, t, n[0], ie));
    }
    if (n.kind === "option")
      return ie.readU8() ? deserializeField(c, t, n.type, ie) : void 0;
    if (n.kind === "map") {
      let fe = /* @__PURE__ */ new Map();
      const ae = ie.readU32();
      for (let le = 0; le < ae; le++) {
        const he = deserializeField(c, t, n.key, ie), me = deserializeField(c, t, n.value, ie);
        fe.set(he, me);
      }
      return fe;
    }
    return deserializeStruct(c, n, ie);
  } catch (fe) {
    throw fe instanceof BorshError && fe.addToFieldPath(t), fe;
  }
}
function deserializeStruct(c, t, n) {
  if (typeof t.borshDeserialize == "function")
    return t.borshDeserialize(n);
  const ie = c.get(t);
  if (!ie)
    throw new BorshError(`Class ${t.name} is missing in schema`);
  if (ie.kind === "struct") {
    const fe = {};
    for (const [ae, le] of c.get(t).fields)
      fe[ae] = deserializeField(c, ae, le, n);
    return new t(fe);
  }
  if (ie.kind === "enum") {
    const fe = n.readU8();
    if (fe >= ie.values.length)
      throw new BorshError(`Enum index: ${fe} is out of range`);
    const [ae, le] = ie.values[fe], he = deserializeField(c, ae, le, n);
    return new t({ [ae]: he });
  }
  throw new BorshError(`Unexpected schema kind: ${ie.kind} for ${t.constructor.name}`);
}
function deserialize(c, t, n, ie = BinaryReader) {
  const fe = new ie(n), ae = deserializeStruct(c, t, fe);
  if (fe.offset < n.length)
    throw new BorshError(`Unexpected ${n.length - fe.offset} bytes after deserialized data`);
  return ae;
}
var deserialize_1 = lib.deserialize = deserialize;
function deserializeUnchecked(c, t, n, ie = BinaryReader) {
  const fe = new ie(n);
  return deserializeStruct(c, t, fe);
}
deserializeUnchecked_1 = lib.deserializeUnchecked = deserializeUnchecked;
var Layout$2 = {};
Object.defineProperty(Layout$2, "__esModule", { value: !0 });
Layout$2.s16 = Layout$2.s8 = Layout$2.nu64be = Layout$2.u48be = Layout$2.u40be = Layout$2.u32be = Layout$2.u24be = Layout$2.u16be = nu64 = Layout$2.nu64 = Layout$2.u48 = Layout$2.u40 = u32$1 = Layout$2.u32 = Layout$2.u24 = u16 = Layout$2.u16 = u8$1 = Layout$2.u8 = offset = Layout$2.offset = Layout$2.greedy = Layout$2.Constant = Layout$2.UTF8 = Layout$2.CString = Layout$2.Blob = Layout$2.Boolean = Layout$2.BitField = Layout$2.BitStructure = Layout$2.VariantLayout = Layout$2.Union = Layout$2.UnionLayoutDiscriminator = Layout$2.UnionDiscriminator = Layout$2.Structure = Layout$2.Sequence = Layout$2.DoubleBE = Layout$2.Double = Layout$2.FloatBE = Layout$2.Float = Layout$2.NearInt64BE = Layout$2.NearInt64 = Layout$2.NearUInt64BE = Layout$2.NearUInt64 = Layout$2.IntBE = Layout$2.Int = Layout$2.UIntBE = Layout$2.UInt = Layout$2.OffsetLayout = Layout$2.GreedyCount = Layout$2.ExternalLayout = Layout$2.bindConstructorLayout = Layout$2.nameWithProperty = Layout$2.Layout = Layout$2.uint8ArrayToBuffer = Layout$2.checkUint8Array = void 0;
Layout$2.constant = Layout$2.utf8 = Layout$2.cstr = blob$1 = Layout$2.blob = Layout$2.unionLayoutDiscriminator = Layout$2.union = seq = Layout$2.seq = Layout$2.bits = struct$1 = Layout$2.struct = Layout$2.f64be = Layout$2.f64 = Layout$2.f32be = Layout$2.f32 = Layout$2.ns64be = Layout$2.s48be = Layout$2.s40be = Layout$2.s32be = Layout$2.s24be = Layout$2.s16be = ns64 = Layout$2.ns64 = Layout$2.s48 = Layout$2.s40 = Layout$2.s32 = Layout$2.s24 = void 0;
const buffer_1 = require$$0$5;
function checkUint8Array(c) {
  if (!(c instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
Layout$2.checkUint8Array = checkUint8Array;
function uint8ArrayToBuffer(c) {
  return checkUint8Array(c), buffer_1.Buffer.from(c.buffer, c.byteOffset, c.length);
}
Layout$2.uint8ArrayToBuffer = uint8ArrayToBuffer;
let Layout$1 = class {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
};
Layout$2.Layout = Layout$1;
function nameWithProperty$1(c, t) {
  return t.property ? c + "[" + t.property + "]" : c;
}
Layout$2.nameWithProperty = nameWithProperty$1;
function bindConstructorLayout(c, t) {
  if (typeof c != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(c, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(t && t instanceof Layout$1))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(t, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  c.layout_ = t, t.boundConstructor_ = c, t.makeDestinationObject = () => new c(), Object.defineProperty(c.prototype, "encode", {
    value(n, ie) {
      return t.encode(this, n, ie);
    },
    writable: !0
  }), Object.defineProperty(c, "decode", {
    value(n, ie) {
      return t.decode(n, ie);
    },
    writable: !0
  });
}
Layout$2.bindConstructorLayout = bindConstructorLayout;
let ExternalLayout$1 = class extends Layout$1 {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
Layout$2.ExternalLayout = ExternalLayout$1;
class GreedyCount extends ExternalLayout$1 {
  constructor(t = 1, n) {
    if (!Number.isInteger(t) || 0 >= t)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, n), this.elementSpan = t;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(t, n = 0) {
    checkUint8Array(t);
    const ie = t.length - n;
    return Math.floor(ie / this.elementSpan);
  }
  /** @override */
  encode(t, n, ie) {
    return 0;
  }
}
Layout$2.GreedyCount = GreedyCount;
class OffsetLayout extends ExternalLayout$1 {
  constructor(t, n = 0, ie) {
    if (!(t instanceof Layout$1))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(n))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, ie || t.property), this.layout = t, this.offset = n;
  }
  /** @override */
  isCount() {
    return this.layout instanceof UInt$1 || this.layout instanceof UIntBE;
  }
  /** @override */
  decode(t, n = 0) {
    return this.layout.decode(t, n + this.offset);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return this.layout.encode(t, n, ie + this.offset);
  }
}
Layout$2.OffsetLayout = OffsetLayout;
let UInt$1 = class extends Layout$1 {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeUIntLE(t, ie, this.span), this.span;
  }
};
Layout$2.UInt = UInt$1;
class UIntBE extends Layout$1 {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readUIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeUIntBE(t, ie, this.span), this.span;
  }
}
Layout$2.UIntBE = UIntBE;
class Int extends Layout$1 {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeIntLE(t, ie, this.span), this.span;
  }
}
Layout$2.Int = Int;
class IntBE extends Layout$1 {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeIntBE(t, ie, this.span), this.span;
  }
}
Layout$2.IntBE = IntBE;
const V2E32 = Math.pow(2, 32);
function divmodInt64(c) {
  const t = Math.floor(c / V2E32), n = c - t * V2E32;
  return { hi32: t, lo32: n };
}
function roundedInt64(c, t) {
  return c * V2E32 + t;
}
class NearUInt64 extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const ie = uint8ArrayToBuffer(t), fe = ie.readUInt32LE(n), ae = ie.readUInt32LE(n + 4);
    return roundedInt64(ae, fe);
  }
  /** @override */
  encode(t, n, ie = 0) {
    const fe = divmodInt64(t), ae = uint8ArrayToBuffer(n);
    return ae.writeUInt32LE(fe.lo32, ie), ae.writeUInt32LE(fe.hi32, ie + 4), 8;
  }
}
Layout$2.NearUInt64 = NearUInt64;
class NearUInt64BE extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const ie = uint8ArrayToBuffer(t), fe = ie.readUInt32BE(n), ae = ie.readUInt32BE(n + 4);
    return roundedInt64(fe, ae);
  }
  /** @override */
  encode(t, n, ie = 0) {
    const fe = divmodInt64(t), ae = uint8ArrayToBuffer(n);
    return ae.writeUInt32BE(fe.hi32, ie), ae.writeUInt32BE(fe.lo32, ie + 4), 8;
  }
}
Layout$2.NearUInt64BE = NearUInt64BE;
class NearInt64 extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const ie = uint8ArrayToBuffer(t), fe = ie.readUInt32LE(n), ae = ie.readInt32LE(n + 4);
    return roundedInt64(ae, fe);
  }
  /** @override */
  encode(t, n, ie = 0) {
    const fe = divmodInt64(t), ae = uint8ArrayToBuffer(n);
    return ae.writeUInt32LE(fe.lo32, ie), ae.writeInt32LE(fe.hi32, ie + 4), 8;
  }
}
Layout$2.NearInt64 = NearInt64;
class NearInt64BE extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const ie = uint8ArrayToBuffer(t), fe = ie.readInt32BE(n), ae = ie.readUInt32BE(n + 4);
    return roundedInt64(fe, ae);
  }
  /** @override */
  encode(t, n, ie = 0) {
    const fe = divmodInt64(t), ae = uint8ArrayToBuffer(n);
    return ae.writeInt32BE(fe.hi32, ie), ae.writeUInt32BE(fe.lo32, ie + 4), 8;
  }
}
Layout$2.NearInt64BE = NearInt64BE;
class Float extends Layout$1 {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readFloatLE(n);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeFloatLE(t, ie), 4;
  }
}
Layout$2.Float = Float;
class FloatBE extends Layout$1 {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readFloatBE(n);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeFloatBE(t, ie), 4;
  }
}
Layout$2.FloatBE = FloatBE;
class Double extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readDoubleLE(n);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeDoubleLE(t, ie), 8;
  }
}
Layout$2.Double = Double;
class DoubleBE extends Layout$1 {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return uint8ArrayToBuffer(t).readDoubleBE(n);
  }
  /** @override */
  encode(t, n, ie = 0) {
    return uint8ArrayToBuffer(n).writeDoubleBE(t, ie), 8;
  }
}
Layout$2.DoubleBE = DoubleBE;
class Sequence extends Layout$1 {
  constructor(t, n, ie) {
    if (!(t instanceof Layout$1))
      throw new TypeError("elementLayout must be a Layout");
    if (!(n instanceof ExternalLayout$1 && n.isCount() || Number.isInteger(n) && 0 <= n))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let fe = -1;
    !(n instanceof ExternalLayout$1) && 0 < t.span && (fe = n * t.span), super(fe, ie), this.elementLayout = t, this.count = n;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let ie = 0, fe = this.count;
    if (fe instanceof ExternalLayout$1 && (fe = fe.decode(t, n)), 0 < this.elementLayout.span)
      ie = fe * this.elementLayout.span;
    else {
      let ae = 0;
      for (; ae < fe; )
        ie += this.elementLayout.getSpan(t, n + ie), ++ae;
    }
    return ie;
  }
  /** @override */
  decode(t, n = 0) {
    const ie = [];
    let fe = 0, ae = this.count;
    for (ae instanceof ExternalLayout$1 && (ae = ae.decode(t, n)); fe < ae; )
      ie.push(this.elementLayout.decode(t, n)), n += this.elementLayout.getSpan(t, n), fe += 1;
    return ie;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, ie = 0) {
    const fe = this.elementLayout, ae = t.reduce((le, he) => le + fe.encode(he, n, ie + le), 0);
    return this.count instanceof ExternalLayout$1 && this.count.encode(t.length, n, ie), ae;
  }
}
Layout$2.Sequence = Sequence;
let Structure$1 = class extends Layout$1 {
  constructor(t, n, ie) {
    if (!(Array.isArray(t) && t.reduce((ae, le) => ae && le instanceof Layout$1, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && ie === void 0 && (ie = n, n = void 0);
    for (const ae of t)
      if (0 > ae.span && ae.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let fe = -1;
    try {
      fe = t.reduce((ae, le) => ae + le.getSpan(), 0);
    } catch {
    }
    super(fe, n), this.fields = t, this.decodePrefixes = !!ie;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let ie = 0;
    try {
      ie = this.fields.reduce((fe, ae) => {
        const le = ae.getSpan(t, n);
        return n += le, fe + le;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return ie;
  }
  /** @override */
  decode(t, n = 0) {
    checkUint8Array(t);
    const ie = this.makeDestinationObject();
    for (const fe of this.fields)
      if (fe.property !== void 0 && (ie[fe.property] = fe.decode(t, n)), n += fe.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return ie;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, ie = 0) {
    const fe = ie;
    let ae = 0, le = 0;
    for (const he of this.fields) {
      let me = he.span;
      if (le = 0 < me ? me : 0, he.property !== void 0) {
        const ye = t[he.property];
        ye !== void 0 && (le = he.encode(ye, n, ie), 0 > me && (me = he.getSpan(n, ie)));
      }
      ae = ie, ie += me;
    }
    return ae + le - fe;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const ie of this.fields)
      ie.property !== void 0 && 0 < t.length && (n[ie.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const ie of this.fields) {
      if (ie.property === t)
        return n;
      0 > ie.span ? n = -1 : 0 <= n && (n += ie.span);
    }
  }
};
Layout$2.Structure = Structure$1;
class UnionDiscriminator {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(t, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(t, n, ie) {
    throw new Error("UnionDiscriminator is abstract");
  }
}
Layout$2.UnionDiscriminator = UnionDiscriminator;
class UnionLayoutDiscriminator extends UnionDiscriminator {
  constructor(t, n) {
    if (!(t instanceof ExternalLayout$1 && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(n || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, n) {
    return this.layout.decode(t, n);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, n, ie) {
    return this.layout.encode(t, n, ie);
  }
}
Layout$2.UnionLayoutDiscriminator = UnionLayoutDiscriminator;
class Union extends Layout$1 {
  constructor(t, n, ie) {
    let fe;
    if (t instanceof UInt$1 || t instanceof UIntBE)
      fe = new UnionLayoutDiscriminator(new OffsetLayout(t));
    else if (t instanceof ExternalLayout$1 && t.isCount())
      fe = new UnionLayoutDiscriminator(t);
    else if (t instanceof UnionDiscriminator)
      fe = t;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (n === void 0 && (n = null), !(n === null || n instanceof Layout$1))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (n !== null) {
      if (0 > n.span)
        throw new Error("defaultLayout must have constant span");
      n.property === void 0 && (n = n.replicate("content"));
    }
    let ae = -1;
    n && (ae = n.span, 0 <= ae && (t instanceof UInt$1 || t instanceof UIntBE) && (ae += fe.layout.span)), super(ae, ie), this.discriminator = fe, this.usesPrefixDiscriminator = t instanceof UInt$1 || t instanceof UIntBE, this.defaultLayout = n, this.registry = {};
    let le = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(he) {
      return le(he);
    }, this.configGetSourceVariant = function(he) {
      le = he.bind(this);
    };
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    const ie = this.getVariant(t, n);
    if (!ie)
      throw new Error("unable to determine span for unrecognized variant");
    return ie.getSpan(t, n);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (Object.prototype.hasOwnProperty.call(t, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(t, this.defaultLayout.property))
        return;
      const n = this.registry[t[this.discriminator.property]];
      if (n && (!n.layout || n.property && Object.prototype.hasOwnProperty.call(t, n.property)))
        return n;
    } else
      for (const n in this.registry) {
        const ie = this.registry[n];
        if (ie.property && Object.prototype.hasOwnProperty.call(t, ie.property))
          return ie;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, n = 0) {
    let ie;
    const fe = this.discriminator, ae = fe.decode(t, n), le = this.registry[ae];
    if (le === void 0) {
      const he = this.defaultLayout;
      let me = 0;
      this.usesPrefixDiscriminator && (me = fe.layout.span), ie = this.makeDestinationObject(), ie[fe.property] = ae, ie[he.property] = he.decode(t, n + me);
    } else
      ie = le.decode(t, n);
    return ie;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, n, ie = 0) {
    const fe = this.getSourceVariant(t);
    if (fe === void 0) {
      const ae = this.discriminator, le = this.defaultLayout;
      let he = 0;
      return this.usesPrefixDiscriminator && (he = ae.layout.span), ae.encode(t[ae.property], n, ie), he + le.encode(t[le.property], n, ie + he);
    }
    return fe.encode(t, n, ie);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, n, ie) {
    const fe = new VariantLayout(this, t, n, ie);
    return this.registry[t] = fe, fe;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, n = 0) {
    let ie;
    return t instanceof Uint8Array ? ie = this.discriminator.decode(t, n) : ie = t, this.registry[ie];
  }
}
Layout$2.Union = Union;
class VariantLayout extends Layout$1 {
  constructor(t, n, ie, fe) {
    if (!(t instanceof Union))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(n) || 0 > n)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof ie == "string" && fe === void 0 && (fe = ie, ie = null), ie) {
      if (!(ie instanceof Layout$1))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= ie.span && ie.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof fe != "string")
        throw new TypeError("variant must have a String property");
    }
    let ae = t.span;
    0 > t.span && (ae = ie ? ie.span : 0, 0 <= ae && t.usesPrefixDiscriminator && (ae += t.discriminator.layout.span)), super(ae, fe), this.union = t, this.variant = n, this.layout = ie || null;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let ie = 0;
    this.union.usesPrefixDiscriminator && (ie = this.union.discriminator.layout.span);
    let fe = 0;
    return this.layout && (fe = this.layout.getSpan(t, n + ie)), ie + fe;
  }
  /** @override */
  decode(t, n = 0) {
    const ie = this.makeDestinationObject();
    if (this !== this.union.getVariant(t, n))
      throw new Error("variant mismatch");
    let fe = 0;
    return this.union.usesPrefixDiscriminator && (fe = this.union.discriminator.layout.span), this.layout ? ie[this.property] = this.layout.decode(t, n + fe) : this.property ? ie[this.property] = !0 : this.union.usesPrefixDiscriminator && (ie[this.union.discriminator.property] = this.variant), ie;
  }
  /** @override */
  encode(t, n, ie = 0) {
    let fe = 0;
    if (this.union.usesPrefixDiscriminator && (fe = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(t, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, n, ie);
    let ae = fe;
    if (this.layout && (this.layout.encode(t[this.property], n, ie + fe), ae += this.layout.getSpan(n, ie + fe), 0 <= this.union.span && ae > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return ae;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
}
Layout$2.VariantLayout = VariantLayout;
function fixBitwiseResult(c) {
  return 0 > c && (c += 4294967296), c;
}
class BitStructure extends Layout$1 {
  constructor(t, n, ie) {
    if (!(t instanceof UInt$1 || t instanceof UIntBE))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof n == "string" && ie === void 0 && (ie = n, n = !1), 4 < t.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(t.span, ie), this.word = t, this.msb = !!n, this.fields = [];
    let fe = 0;
    this._packedSetValue = function(ae) {
      return fe = fixBitwiseResult(ae), this;
    }, this._packedGetValue = function() {
      return fe;
    };
  }
  /** @override */
  decode(t, n = 0) {
    const ie = this.makeDestinationObject(), fe = this.word.decode(t, n);
    this._packedSetValue(fe);
    for (const ae of this.fields)
      ae.property !== void 0 && (ie[ae.property] = ae.decode(t));
    return ie;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(t, n, ie = 0) {
    const fe = this.word.decode(n, ie);
    this._packedSetValue(fe);
    for (const ae of this.fields)
      if (ae.property !== void 0) {
        const le = t[ae.property];
        le !== void 0 && ae.encode(le);
      }
    return this.word.encode(this._packedGetValue(), n, ie);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(t, n) {
    const ie = new BitField(this, t, n);
    return this.fields.push(ie), ie;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(t) {
    const n = new Boolean$1(this, t);
    return this.fields.push(n), n;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
}
Layout$2.BitStructure = BitStructure;
class BitField {
  constructor(t, n, ie) {
    if (!(t instanceof BitStructure))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(n) || 0 >= n)
      throw new TypeError("bits must be positive integer");
    const fe = 8 * t.span, ae = t.fields.reduce((le, he) => le + he.bits, 0);
    if (n + ae > fe)
      throw new Error("bits too long for span remainder (" + (fe - ae) + " of " + fe + " remain)");
    this.container = t, this.bits = n, this.valueMask = (1 << n) - 1, n === 32 && (this.valueMask = 4294967295), this.start = ae, this.container.msb && (this.start = fe - ae - n), this.wordMask = fixBitwiseResult(this.valueMask << this.start), this.property = ie;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(t, n) {
    const ie = this.container._packedGetValue();
    return fixBitwiseResult(ie & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(t) {
    if (typeof t != "number" || !Number.isInteger(t) || t !== fixBitwiseResult(t & this.valueMask))
      throw new TypeError(nameWithProperty$1("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const n = this.container._packedGetValue(), ie = fixBitwiseResult(t << this.start);
    this.container._packedSetValue(fixBitwiseResult(n & ~this.wordMask) | ie);
  }
}
Layout$2.BitField = BitField;
let Boolean$1 = class extends BitField {
  constructor(t, n) {
    super(t, 1, n);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(t, n) {
    return !!super.decode(t, n);
  }
  /** @override */
  encode(t) {
    typeof t == "boolean" && (t = +t), super.encode(t);
  }
};
Layout$2.Boolean = Boolean$1;
let Blob$2 = class extends Layout$1 {
  constructor(t, n) {
    if (!(t instanceof ExternalLayout$1 && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let ie = -1;
    t instanceof ExternalLayout$1 || (ie = t), super(ie, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let ie = this.span;
    return 0 > ie && (ie = this.length.decode(t, n)), ie;
  }
  /** @override */
  decode(t, n = 0) {
    let ie = this.span;
    return 0 > ie && (ie = this.length.decode(t, n)), uint8ArrayToBuffer(t).slice(n, n + ie);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, ie) {
    let fe = this.length;
    if (this.length instanceof ExternalLayout$1 && (fe = t.length), !(t instanceof Uint8Array && fe === t.length))
      throw new TypeError(nameWithProperty$1("Blob.encode", this) + " requires (length " + fe + ") Uint8Array as src");
    if (ie + fe > n.length)
      throw new RangeError("encoding overruns Uint8Array");
    const ae = uint8ArrayToBuffer(t);
    return uint8ArrayToBuffer(n).write(ae.toString("hex"), ie, fe, "hex"), this.length instanceof ExternalLayout$1 && this.length.encode(fe, n, ie), fe;
  }
};
Layout$2.Blob = Blob$2;
class CString extends Layout$1 {
  constructor(t) {
    super(-1, t);
  }
  /** @override */
  getSpan(t, n = 0) {
    checkUint8Array(t);
    let ie = n;
    for (; ie < t.length && t[ie] !== 0; )
      ie += 1;
    return 1 + ie - n;
  }
  /** @override */
  decode(t, n = 0) {
    const ie = this.getSpan(t, n);
    return uint8ArrayToBuffer(t).slice(n, n + ie - 1).toString("utf-8");
  }
  /** @override */
  encode(t, n, ie = 0) {
    typeof t != "string" && (t = String(t));
    const fe = buffer_1.Buffer.from(t, "utf8"), ae = fe.length;
    if (ie + ae > n.length)
      throw new RangeError("encoding overruns Buffer");
    const le = uint8ArrayToBuffer(n);
    return fe.copy(le, ie), le[ie + ae] = 0, ae + 1;
  }
}
Layout$2.CString = CString;
class UTF8 extends Layout$1 {
  constructor(t, n) {
    if (typeof t == "string" && n === void 0 && (n = t, t = void 0), t === void 0)
      t = -1;
    else if (!Number.isInteger(t))
      throw new TypeError("maxSpan must be an integer");
    super(-1, n), this.maxSpan = t;
  }
  /** @override */
  getSpan(t, n = 0) {
    return checkUint8Array(t), t.length - n;
  }
  /** @override */
  decode(t, n = 0) {
    const ie = this.getSpan(t, n);
    if (0 <= this.maxSpan && this.maxSpan < ie)
      throw new RangeError("text length exceeds maxSpan");
    return uint8ArrayToBuffer(t).slice(n, n + ie).toString("utf-8");
  }
  /** @override */
  encode(t, n, ie = 0) {
    typeof t != "string" && (t = String(t));
    const fe = buffer_1.Buffer.from(t, "utf8"), ae = fe.length;
    if (0 <= this.maxSpan && this.maxSpan < ae)
      throw new RangeError("text length exceeds maxSpan");
    if (ie + ae > n.length)
      throw new RangeError("encoding overruns Buffer");
    return fe.copy(uint8ArrayToBuffer(n), ie), ae;
  }
}
Layout$2.UTF8 = UTF8;
class Constant extends Layout$1 {
  constructor(t, n) {
    super(0, n), this.value = t;
  }
  /** @override */
  decode(t, n) {
    return this.value;
  }
  /** @override */
  encode(t, n, ie) {
    return 0;
  }
}
Layout$2.Constant = Constant;
Layout$2.greedy = (c, t) => new GreedyCount(c, t);
var offset = Layout$2.offset = (c, t, n) => new OffsetLayout(c, t, n), u8$1 = Layout$2.u8 = (c) => new UInt$1(1, c), u16 = Layout$2.u16 = (c) => new UInt$1(2, c);
Layout$2.u24 = (c) => new UInt$1(3, c);
var u32$1 = Layout$2.u32 = (c) => new UInt$1(4, c);
Layout$2.u40 = (c) => new UInt$1(5, c);
Layout$2.u48 = (c) => new UInt$1(6, c);
var nu64 = Layout$2.nu64 = (c) => new NearUInt64(c);
Layout$2.u16be = (c) => new UIntBE(2, c);
Layout$2.u24be = (c) => new UIntBE(3, c);
Layout$2.u32be = (c) => new UIntBE(4, c);
Layout$2.u40be = (c) => new UIntBE(5, c);
Layout$2.u48be = (c) => new UIntBE(6, c);
Layout$2.nu64be = (c) => new NearUInt64BE(c);
Layout$2.s8 = (c) => new Int(1, c);
Layout$2.s16 = (c) => new Int(2, c);
Layout$2.s24 = (c) => new Int(3, c);
Layout$2.s32 = (c) => new Int(4, c);
Layout$2.s40 = (c) => new Int(5, c);
Layout$2.s48 = (c) => new Int(6, c);
var ns64 = Layout$2.ns64 = (c) => new NearInt64(c);
Layout$2.s16be = (c) => new IntBE(2, c);
Layout$2.s24be = (c) => new IntBE(3, c);
Layout$2.s32be = (c) => new IntBE(4, c);
Layout$2.s40be = (c) => new IntBE(5, c);
Layout$2.s48be = (c) => new IntBE(6, c);
Layout$2.ns64be = (c) => new NearInt64BE(c);
Layout$2.f32 = (c) => new Float(c);
Layout$2.f32be = (c) => new FloatBE(c);
Layout$2.f64 = (c) => new Double(c);
Layout$2.f64be = (c) => new DoubleBE(c);
var struct$1 = Layout$2.struct = (c, t, n) => new Structure$1(c, t, n);
Layout$2.bits = (c, t, n) => new BitStructure(c, t, n);
var seq = Layout$2.seq = (c, t, n) => new Sequence(c, t, n);
Layout$2.union = (c, t, n) => new Union(c, t, n);
Layout$2.unionLayoutDiscriminator = (c, t) => new UnionLayoutDiscriminator(c, t);
var blob$1 = Layout$2.blob = (c, t) => new Blob$2(c, t);
Layout$2.cstr = (c) => new CString(c);
Layout$2.utf8 = (c, t) => new UTF8(c, t);
Layout$2.constant = (c, t) => new Constant(c, t);
var browser$d = {};
Object.defineProperty(browser$d, "__esModule", { value: !0 });
function toBigIntLE(c) {
  {
    const t = Buffer$7.from(c);
    t.reverse();
    const n = t.toString("hex");
    return n.length === 0 ? BigInt(0) : BigInt(`0x${n}`);
  }
}
var toBigIntLE_1 = browser$d.toBigIntLE = toBigIntLE;
function toBigIntBE(c) {
  {
    const t = c.toString("hex");
    return t.length === 0 ? BigInt(0) : BigInt(`0x${t}`);
  }
}
browser$d.toBigIntBE = toBigIntBE;
function toBufferLE(c, t) {
  {
    const n = c.toString(16), ie = Buffer$7.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
    return ie.reverse(), ie;
  }
}
var toBufferLE_1 = browser$d.toBufferLE = toBufferLE;
function toBufferBE(c, t) {
  {
    const n = c.toString(16);
    return Buffer$7.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
  }
}
browser$d.toBufferBE = toBufferBE;
let StructError$1 = class extends TypeError {
  constructor(t, n) {
    let ie;
    const {
      message: fe,
      ...ae
    } = t, {
      path: le
    } = t, he = le.length === 0 ? fe : "At path: " + le.join(".") + " -- " + fe;
    super(he), Object.assign(this, ae), this.name = this.constructor.name, this.failures = () => {
      var me;
      return (me = ie) != null ? me : ie = [t, ...n()];
    };
  }
};
function isIterable$1(c) {
  return isObject$3(c) && typeof c[Symbol.iterator] == "function";
}
function isObject$3(c) {
  return typeof c == "object" && c != null;
}
function print$3(c) {
  return typeof c == "string" ? JSON.stringify(c) : "" + c;
}
function shiftIterator$1(c) {
  const {
    done: t,
    value: n
  } = c.next();
  return t ? void 0 : n;
}
function toFailure$1(c, t, n, ie) {
  if (c === !0)
    return;
  c === !1 ? c = {} : typeof c == "string" && (c = {
    message: c
  });
  const {
    path: fe,
    branch: ae
  } = t, {
    type: le
  } = n, {
    refinement: he,
    message: me = "Expected a value of type `" + le + "`" + (he ? " with refinement `" + he + "`" : "") + ", but received: `" + print$3(ie) + "`"
  } = c;
  return {
    value: ie,
    type: le,
    refinement: he,
    key: fe[fe.length - 1],
    path: fe,
    branch: ae,
    ...c,
    message: me
  };
}
function* toFailures$1(c, t, n, ie) {
  isIterable$1(c) || (c = [c]);
  for (const fe of c) {
    const ae = toFailure$1(fe, t, n, ie);
    ae && (yield ae);
  }
}
function* run$1(c, t, n = {}) {
  const {
    path: ie = [],
    branch: fe = [c],
    coerce: ae = !1,
    mask: le = !1
  } = n, he = {
    path: ie,
    branch: fe
  };
  if (ae && (c = t.coercer(c, he), le && t.type !== "type" && isObject$3(t.schema) && isObject$3(c) && !Array.isArray(c)))
    for (const ye in c)
      t.schema[ye] === void 0 && delete c[ye];
  let me = !0;
  for (const ye of t.validator(c, he))
    me = !1, yield [ye, void 0];
  for (let [ye, be, Ae] of t.entries(c, he)) {
    const Se = run$1(be, Ae, {
      path: ye === void 0 ? ie : [...ie, ye],
      branch: ye === void 0 ? fe : [...fe, be],
      coerce: ae,
      mask: le
    });
    for (const $e of Se)
      $e[0] ? (me = !1, yield [$e[0], void 0]) : ae && (be = $e[1], ye === void 0 ? c = be : c instanceof Map ? c.set(ye, be) : c instanceof Set ? c.add(be) : isObject$3(c) && (c[ye] = be));
  }
  if (me)
    for (const ye of t.refiner(c, he))
      me = !1, yield [ye, void 0];
  me && (yield [void 0, c]);
}
let Struct$3 = class {
  constructor(t) {
    const {
      type: n,
      schema: ie,
      validator: fe,
      refiner: ae,
      coercer: le = (me) => me,
      entries: he = function* () {
      }
    } = t;
    this.type = n, this.schema = ie, this.entries = he, this.coercer = le, fe ? this.validator = (me, ye) => {
      const be = fe(me, ye);
      return toFailures$1(be, ye, this, me);
    } : this.validator = () => [], ae ? this.refiner = (me, ye) => {
      const be = ae(me, ye);
      return toFailures$1(be, ye, this, me);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t) {
    return assert$d(t, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t) {
    return create$1(t, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return is$1(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t) {
    return mask$1(t, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, n = {}) {
    return validate$2(t, this, n);
  }
};
function assert$d(c, t) {
  const n = validate$2(c, t);
  if (n[0])
    throw n[0];
}
function create$1(c, t) {
  const n = validate$2(c, t, {
    coerce: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function mask$1(c, t) {
  const n = validate$2(c, t, {
    coerce: !0,
    mask: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function is$1(c, t) {
  return !validate$2(c, t)[0];
}
function validate$2(c, t, n = {}) {
  const ie = run$1(c, t, n), fe = shiftIterator$1(ie);
  return fe[0] ? [new StructError$1(fe[0], function* () {
    for (const le of ie)
      le[0] && (yield le[0]);
  }), void 0] : [void 0, fe[1]];
}
function define$1(c, t) {
  return new Struct$3({
    type: c,
    schema: null,
    validator: t
  });
}
function any$1() {
  return define$1("any", () => !0);
}
function array$1(c) {
  return new Struct$3({
    type: "array",
    schema: c,
    *entries(t) {
      if (c && Array.isArray(t))
        for (const [n, ie] of t.entries())
          yield [n, ie, c];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || "Expected an array value, but received: " + print$3(t);
    }
  });
}
function boolean$1() {
  return define$1("boolean", (c) => typeof c == "boolean");
}
function instance$1(c) {
  return define$1("instance", (t) => t instanceof c || "Expected a `" + c.name + "` instance, but received: " + print$3(t));
}
function literal$1(c) {
  const t = print$3(c), n = typeof c;
  return new Struct$3({
    type: "literal",
    schema: n === "string" || n === "number" || n === "boolean" ? c : null,
    validator(ie) {
      return ie === c || "Expected the literal `" + t + "`, but received: " + print$3(ie);
    }
  });
}
function never$1() {
  return define$1("never", () => !1);
}
function nullable$1(c) {
  return new Struct$3({
    ...c,
    validator: (t, n) => t === null || c.validator(t, n),
    refiner: (t, n) => t === null || c.refiner(t, n)
  });
}
function number$1() {
  return define$1("number", (c) => typeof c == "number" && !isNaN(c) || "Expected a number, but received: " + print$3(c));
}
function optional$1(c) {
  return new Struct$3({
    ...c,
    validator: (t, n) => t === void 0 || c.validator(t, n),
    refiner: (t, n) => t === void 0 || c.refiner(t, n)
  });
}
function record$1(c, t) {
  return new Struct$3({
    type: "record",
    schema: null,
    *entries(n) {
      if (isObject$3(n))
        for (const ie in n) {
          const fe = n[ie];
          yield [ie, ie, c], yield [ie, fe, t];
        }
    },
    validator(n) {
      return isObject$3(n) || "Expected an object, but received: " + print$3(n);
    }
  });
}
function string$1() {
  return define$1("string", (c) => typeof c == "string" || "Expected a string, but received: " + print$3(c));
}
function tuple$1(c) {
  const t = never$1();
  return new Struct$3({
    type: "tuple",
    schema: null,
    *entries(n) {
      if (Array.isArray(n)) {
        const ie = Math.max(c.length, n.length);
        for (let fe = 0; fe < ie; fe++)
          yield [fe, n[fe], c[fe] || t];
      }
    },
    validator(n) {
      return Array.isArray(n) || "Expected an array, but received: " + print$3(n);
    }
  });
}
function type$2(c) {
  const t = Object.keys(c);
  return new Struct$3({
    type: "type",
    schema: c,
    *entries(n) {
      if (isObject$3(n))
        for (const ie of t)
          yield [ie, n[ie], c[ie]];
    },
    validator(n) {
      return isObject$3(n) || "Expected an object, but received: " + print$3(n);
    }
  });
}
function union$1(c) {
  const t = c.map((n) => n.type).join(" | ");
  return new Struct$3({
    type: "union",
    schema: null,
    validator(n, ie) {
      const fe = [];
      for (const ae of c) {
        const [...le] = run$1(n, ae, ie), [he] = le;
        if (he[0])
          for (const [me] of le)
            me && fe.push(me);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + t + "`, but received: " + print$3(n), ...fe];
    }
  });
}
function unknown$1() {
  return define$1("unknown", () => !0);
}
function coerce$1(c, t, n) {
  return new Struct$3({
    ...c,
    coercer: (ie, fe) => is$1(ie, t) ? c.coercer(n(ie, fe), fe) : c.coercer(ie, fe)
  });
}
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX$1 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$1(c) {
  return typeof c == "string" && REGEX$1.test(c);
}
var byteToHex = [];
for (var i$3 = 0; i$3 < 256; ++i$3)
  byteToHex.push((i$3 + 256).toString(16).substr(1));
function stringify$1(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (byteToHex[c[t + 0]] + byteToHex[c[t + 1]] + byteToHex[c[t + 2]] + byteToHex[c[t + 3]] + "-" + byteToHex[c[t + 4]] + byteToHex[c[t + 5]] + "-" + byteToHex[c[t + 6]] + byteToHex[c[t + 7]] + "-" + byteToHex[c[t + 8]] + byteToHex[c[t + 9]] + "-" + byteToHex[c[t + 10]] + byteToHex[c[t + 11]] + byteToHex[c[t + 12]] + byteToHex[c[t + 13]] + byteToHex[c[t + 14]] + byteToHex[c[t + 15]]).toLowerCase();
  if (!validate$1(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(c, t, n) {
  var ie = t && n || 0, fe = t || new Array(16);
  c = c || {};
  var ae = c.node || _nodeId, le = c.clockseq !== void 0 ? c.clockseq : _clockseq;
  if (ae == null || le == null) {
    var he = c.random || (c.rng || rng)();
    ae == null && (ae = _nodeId = [he[0] | 1, he[1], he[2], he[3], he[4], he[5]]), le == null && (le = _clockseq = (he[6] << 8 | he[7]) & 16383);
  }
  var me = c.msecs !== void 0 ? c.msecs : Date.now(), ye = c.nsecs !== void 0 ? c.nsecs : _lastNSecs + 1, be = me - _lastMSecs + (ye - _lastNSecs) / 1e4;
  if (be < 0 && c.clockseq === void 0 && (le = le + 1 & 16383), (be < 0 || me > _lastMSecs) && c.nsecs === void 0 && (ye = 0), ye >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = me, _lastNSecs = ye, _clockseq = le, me += 122192928e5;
  var Ae = ((me & 268435455) * 1e4 + ye) % 4294967296;
  fe[ie++] = Ae >>> 24 & 255, fe[ie++] = Ae >>> 16 & 255, fe[ie++] = Ae >>> 8 & 255, fe[ie++] = Ae & 255;
  var Se = me / 4294967296 * 1e4 & 268435455;
  fe[ie++] = Se >>> 8 & 255, fe[ie++] = Se & 255, fe[ie++] = Se >>> 24 & 15 | 16, fe[ie++] = Se >>> 16 & 255, fe[ie++] = le >>> 8 | 128, fe[ie++] = le & 255;
  for (var $e = 0; $e < 6; ++$e)
    fe[ie + $e] = ae[$e];
  return t || stringify$1(fe);
}
function parse$1(c) {
  if (!validate$1(c))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(c.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = t & 255, n[4] = (t = parseInt(c.slice(9, 13), 16)) >>> 8, n[5] = t & 255, n[6] = (t = parseInt(c.slice(14, 18), 16)) >>> 8, n[7] = t & 255, n[8] = (t = parseInt(c.slice(19, 23), 16)) >>> 8, n[9] = t & 255, n[10] = (t = parseInt(c.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = t & 255, n;
}
function stringToBytes(c) {
  c = unescape(encodeURIComponent(c));
  for (var t = [], n = 0; n < c.length; ++n)
    t.push(c.charCodeAt(n));
  return t;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(c, t, n) {
  function ie(fe, ae, le, he) {
    if (typeof fe == "string" && (fe = stringToBytes(fe)), typeof ae == "string" && (ae = parse$1(ae)), ae.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var me = new Uint8Array(16 + fe.length);
    if (me.set(ae), me.set(fe, ae.length), me = n(me), me[6] = me[6] & 15 | t, me[8] = me[8] & 63 | 128, le) {
      he = he || 0;
      for (var ye = 0; ye < 16; ++ye)
        le[he + ye] = me[ye];
      return le;
    }
    return stringify$1(me);
  }
  try {
    ie.name = c;
  } catch {
  }
  return ie.DNS = DNS, ie.URL = URL$1, ie;
}
function md5$3(c) {
  if (typeof c == "string") {
    var t = unescape(encodeURIComponent(c));
    c = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      c[n] = t.charCodeAt(n);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(c), c.length * 8));
}
function md5ToHexEncodedArray(c) {
  for (var t = [], n = c.length * 32, ie = "0123456789abcdef", fe = 0; fe < n; fe += 8) {
    var ae = c[fe >> 5] >>> fe % 32 & 255, le = parseInt(ie.charAt(ae >>> 4 & 15) + ie.charAt(ae & 15), 16);
    t.push(le);
  }
  return t;
}
function getOutputLength(c) {
  return (c + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(c, t) {
  c[t >> 5] |= 128 << t % 32, c[getOutputLength(t) - 1] = t;
  for (var n = 1732584193, ie = -271733879, fe = -1732584194, ae = 271733878, le = 0; le < c.length; le += 16) {
    var he = n, me = ie, ye = fe, be = ae;
    n = md5ff(n, ie, fe, ae, c[le], 7, -680876936), ae = md5ff(ae, n, ie, fe, c[le + 1], 12, -389564586), fe = md5ff(fe, ae, n, ie, c[le + 2], 17, 606105819), ie = md5ff(ie, fe, ae, n, c[le + 3], 22, -1044525330), n = md5ff(n, ie, fe, ae, c[le + 4], 7, -176418897), ae = md5ff(ae, n, ie, fe, c[le + 5], 12, 1200080426), fe = md5ff(fe, ae, n, ie, c[le + 6], 17, -1473231341), ie = md5ff(ie, fe, ae, n, c[le + 7], 22, -45705983), n = md5ff(n, ie, fe, ae, c[le + 8], 7, 1770035416), ae = md5ff(ae, n, ie, fe, c[le + 9], 12, -1958414417), fe = md5ff(fe, ae, n, ie, c[le + 10], 17, -42063), ie = md5ff(ie, fe, ae, n, c[le + 11], 22, -1990404162), n = md5ff(n, ie, fe, ae, c[le + 12], 7, 1804603682), ae = md5ff(ae, n, ie, fe, c[le + 13], 12, -40341101), fe = md5ff(fe, ae, n, ie, c[le + 14], 17, -1502002290), ie = md5ff(ie, fe, ae, n, c[le + 15], 22, 1236535329), n = md5gg(n, ie, fe, ae, c[le + 1], 5, -165796510), ae = md5gg(ae, n, ie, fe, c[le + 6], 9, -1069501632), fe = md5gg(fe, ae, n, ie, c[le + 11], 14, 643717713), ie = md5gg(ie, fe, ae, n, c[le], 20, -373897302), n = md5gg(n, ie, fe, ae, c[le + 5], 5, -701558691), ae = md5gg(ae, n, ie, fe, c[le + 10], 9, 38016083), fe = md5gg(fe, ae, n, ie, c[le + 15], 14, -660478335), ie = md5gg(ie, fe, ae, n, c[le + 4], 20, -405537848), n = md5gg(n, ie, fe, ae, c[le + 9], 5, 568446438), ae = md5gg(ae, n, ie, fe, c[le + 14], 9, -1019803690), fe = md5gg(fe, ae, n, ie, c[le + 3], 14, -187363961), ie = md5gg(ie, fe, ae, n, c[le + 8], 20, 1163531501), n = md5gg(n, ie, fe, ae, c[le + 13], 5, -1444681467), ae = md5gg(ae, n, ie, fe, c[le + 2], 9, -51403784), fe = md5gg(fe, ae, n, ie, c[le + 7], 14, 1735328473), ie = md5gg(ie, fe, ae, n, c[le + 12], 20, -1926607734), n = md5hh(n, ie, fe, ae, c[le + 5], 4, -378558), ae = md5hh(ae, n, ie, fe, c[le + 8], 11, -2022574463), fe = md5hh(fe, ae, n, ie, c[le + 11], 16, 1839030562), ie = md5hh(ie, fe, ae, n, c[le + 14], 23, -35309556), n = md5hh(n, ie, fe, ae, c[le + 1], 4, -1530992060), ae = md5hh(ae, n, ie, fe, c[le + 4], 11, 1272893353), fe = md5hh(fe, ae, n, ie, c[le + 7], 16, -155497632), ie = md5hh(ie, fe, ae, n, c[le + 10], 23, -1094730640), n = md5hh(n, ie, fe, ae, c[le + 13], 4, 681279174), ae = md5hh(ae, n, ie, fe, c[le], 11, -358537222), fe = md5hh(fe, ae, n, ie, c[le + 3], 16, -722521979), ie = md5hh(ie, fe, ae, n, c[le + 6], 23, 76029189), n = md5hh(n, ie, fe, ae, c[le + 9], 4, -640364487), ae = md5hh(ae, n, ie, fe, c[le + 12], 11, -421815835), fe = md5hh(fe, ae, n, ie, c[le + 15], 16, 530742520), ie = md5hh(ie, fe, ae, n, c[le + 2], 23, -995338651), n = md5ii(n, ie, fe, ae, c[le], 6, -198630844), ae = md5ii(ae, n, ie, fe, c[le + 7], 10, 1126891415), fe = md5ii(fe, ae, n, ie, c[le + 14], 15, -1416354905), ie = md5ii(ie, fe, ae, n, c[le + 5], 21, -57434055), n = md5ii(n, ie, fe, ae, c[le + 12], 6, 1700485571), ae = md5ii(ae, n, ie, fe, c[le + 3], 10, -1894986606), fe = md5ii(fe, ae, n, ie, c[le + 10], 15, -1051523), ie = md5ii(ie, fe, ae, n, c[le + 1], 21, -2054922799), n = md5ii(n, ie, fe, ae, c[le + 8], 6, 1873313359), ae = md5ii(ae, n, ie, fe, c[le + 15], 10, -30611744), fe = md5ii(fe, ae, n, ie, c[le + 6], 15, -1560198380), ie = md5ii(ie, fe, ae, n, c[le + 13], 21, 1309151649), n = md5ii(n, ie, fe, ae, c[le + 4], 6, -145523070), ae = md5ii(ae, n, ie, fe, c[le + 11], 10, -1120210379), fe = md5ii(fe, ae, n, ie, c[le + 2], 15, 718787259), ie = md5ii(ie, fe, ae, n, c[le + 9], 21, -343485551), n = safeAdd(n, he), ie = safeAdd(ie, me), fe = safeAdd(fe, ye), ae = safeAdd(ae, be);
  }
  return [n, ie, fe, ae];
}
function bytesToWords(c) {
  if (c.length === 0)
    return [];
  for (var t = c.length * 8, n = new Uint32Array(getOutputLength(t)), ie = 0; ie < t; ie += 8)
    n[ie >> 5] |= (c[ie / 8] & 255) << ie % 32;
  return n;
}
function safeAdd(c, t) {
  var n = (c & 65535) + (t & 65535), ie = (c >> 16) + (t >> 16) + (n >> 16);
  return ie << 16 | n & 65535;
}
function bitRotateLeft(c, t) {
  return c << t | c >>> 32 - t;
}
function md5cmn(c, t, n, ie, fe, ae) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(t, c), safeAdd(ie, ae)), fe), n);
}
function md5ff(c, t, n, ie, fe, ae, le) {
  return md5cmn(t & n | ~t & ie, c, t, fe, ae, le);
}
function md5gg(c, t, n, ie, fe, ae, le) {
  return md5cmn(t & ie | n & ~ie, c, t, fe, ae, le);
}
function md5hh(c, t, n, ie, fe, ae, le) {
  return md5cmn(t ^ n ^ ie, c, t, fe, ae, le);
}
function md5ii(c, t, n, ie, fe, ae, le) {
  return md5cmn(n ^ (t | ~ie), c, t, fe, ae, le);
}
var v3 = v35("v3", 48, md5$3);
function v4(c, t, n) {
  c = c || {};
  var ie = c.random || (c.rng || rng)();
  if (ie[6] = ie[6] & 15 | 64, ie[8] = ie[8] & 63 | 128, t) {
    n = n || 0;
    for (var fe = 0; fe < 16; ++fe)
      t[n + fe] = ie[fe];
    return t;
  }
  return stringify$1(ie);
}
function f$1(c, t, n, ie) {
  switch (c) {
    case 0:
      return t & n ^ ~t & ie;
    case 1:
      return t ^ n ^ ie;
    case 2:
      return t & n ^ t & ie ^ n & ie;
    case 3:
      return t ^ n ^ ie;
  }
}
function ROTL(c, t) {
  return c << t | c >>> 32 - t;
}
function sha1$3(c) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof c == "string") {
    var ie = unescape(encodeURIComponent(c));
    c = [];
    for (var fe = 0; fe < ie.length; ++fe)
      c.push(ie.charCodeAt(fe));
  } else Array.isArray(c) || (c = Array.prototype.slice.call(c));
  c.push(128);
  for (var ae = c.length / 4 + 2, le = Math.ceil(ae / 16), he = new Array(le), me = 0; me < le; ++me) {
    for (var ye = new Uint32Array(16), be = 0; be < 16; ++be)
      ye[be] = c[me * 64 + be * 4] << 24 | c[me * 64 + be * 4 + 1] << 16 | c[me * 64 + be * 4 + 2] << 8 | c[me * 64 + be * 4 + 3];
    he[me] = ye;
  }
  he[le - 1][14] = (c.length - 1) * 8 / Math.pow(2, 32), he[le - 1][14] = Math.floor(he[le - 1][14]), he[le - 1][15] = (c.length - 1) * 8 & 4294967295;
  for (var Ae = 0; Ae < le; ++Ae) {
    for (var Se = new Uint32Array(80), $e = 0; $e < 16; ++$e)
      Se[$e] = he[Ae][$e];
    for (var Re = 16; Re < 80; ++Re)
      Se[Re] = ROTL(Se[Re - 3] ^ Se[Re - 8] ^ Se[Re - 14] ^ Se[Re - 16], 1);
    for (var Me = n[0], ke = n[1], Te = n[2], Ie = n[3], qe = n[4], Ue = 0; Ue < 80; ++Ue) {
      var ze = Math.floor(Ue / 20), Ve = ROTL(Me, 5) + f$1(ze, ke, Te, Ie) + qe + t[ze] + Se[Ue] >>> 0;
      qe = Ie, Ie = Te, Te = ROTL(ke, 30) >>> 0, ke = Me, Me = Ve;
    }
    n[0] = n[0] + Me >>> 0, n[1] = n[1] + ke >>> 0, n[2] = n[2] + Te >>> 0, n[3] = n[3] + Ie >>> 0, n[4] = n[4] + qe >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var v5 = v35("v5", 80, sha1$3);
const nil = "00000000-0000-0000-0000-000000000000";
function version$6(c) {
  if (!validate$1(c))
    throw TypeError("Invalid UUID");
  return parseInt(c.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$1,
  stringify: stringify$1,
  v1,
  v3,
  v4,
  v5,
  validate: validate$1,
  version: version$6
}, Symbol.toStringTag, { value: "Module" })), require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser), uuid$1 = require$$0$3.v4, generateRequest$1 = function(c, t, n, ie) {
  if (typeof c != "string")
    throw new TypeError(c + " must be a string");
  ie = ie || {};
  const fe = typeof ie.version == "number" ? ie.version : 2;
  if (fe !== 1 && fe !== 2)
    throw new TypeError(fe + " must be 1 or 2");
  const ae = {
    method: c
  };
  if (fe === 2 && (ae.jsonrpc = "2.0"), t) {
    if (typeof t != "object" && !Array.isArray(t))
      throw new TypeError(t + " must be an object, array or omitted");
    ae.params = t;
  }
  if (typeof n > "u") {
    const le = typeof ie.generator == "function" ? ie.generator : function() {
      return uuid$1();
    };
    ae.id = le(ae, ie);
  } else fe === 2 && n === null ? ie.notificationIdNull && (ae.id = null) : ae.id = n;
  return ae;
};
var generateRequest_1 = generateRequest$1;
const uuid = require$$0$3.v4, generateRequest = generateRequest_1, ClientBrowser = function(c, t) {
  if (!(this instanceof ClientBrowser))
    return new ClientBrowser(c, t);
  t || (t = {}), this.options = {
    reviver: typeof t.reviver < "u" ? t.reviver : null,
    replacer: typeof t.replacer < "u" ? t.replacer : null,
    generator: typeof t.generator < "u" ? t.generator : function() {
      return uuid();
    },
    version: typeof t.version < "u" ? t.version : 2,
    notificationIdNull: typeof t.notificationIdNull == "boolean" ? t.notificationIdNull : !1
  }, this.callServer = c;
};
var browser$c = ClientBrowser;
ClientBrowser.prototype.request = function(c, t, n, ie) {
  const fe = this;
  let ae = null;
  const le = Array.isArray(c) && typeof t == "function";
  if (this.options.version === 1 && le)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (le || !le && c && typeof c == "object" && typeof t == "function")
    ie = t, ae = c;
  else {
    typeof n == "function" && (ie = n, n = void 0);
    const ye = typeof ie == "function";
    try {
      ae = generateRequest(c, t, n, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (be) {
      if (ye)
        return ie(be);
      throw be;
    }
    if (!ye)
      return ae;
  }
  let me;
  try {
    me = JSON.stringify(ae, this.options.replacer);
  } catch (ye) {
    return ie(ye);
  }
  return this.callServer(me, function(ye, be) {
    fe._parseResponse(ye, be, ie);
  }), ae;
};
ClientBrowser.prototype._parseResponse = function(c, t, n) {
  if (c) {
    n(c);
    return;
  }
  if (!t)
    return n();
  let ie;
  try {
    ie = JSON.parse(t, this.options.reviver);
  } catch (fe) {
    return n(fe);
  }
  if (n.length === 3)
    if (Array.isArray(ie)) {
      const fe = function(le) {
        return typeof le.error < "u";
      }, ae = function(le) {
        return !fe(le);
      };
      return n(null, ie.filter(fe), ie.filter(ae));
    } else
      return n(null, ie.error, ie.result);
  n(null, ie);
};
const RpcClient = /* @__PURE__ */ getDefaultExportFromCjs$2(browser$c);
var client = {}, eventemitter3$1 = { exports: {} };
(function(c) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function ie() {
  }
  Object.create && (ie.prototype = /* @__PURE__ */ Object.create(null), new ie().__proto__ || (n = !1));
  function fe(me, ye, be) {
    this.fn = me, this.context = ye, this.once = be || !1;
  }
  function ae(me, ye, be, Ae, Se) {
    if (typeof be != "function")
      throw new TypeError("The listener must be a function");
    var $e = new fe(be, Ae || me, Se), Re = n ? n + ye : ye;
    return me._events[Re] ? me._events[Re].fn ? me._events[Re] = [me._events[Re], $e] : me._events[Re].push($e) : (me._events[Re] = $e, me._eventsCount++), me;
  }
  function le(me, ye) {
    --me._eventsCount === 0 ? me._events = new ie() : delete me._events[ye];
  }
  function he() {
    this._events = new ie(), this._eventsCount = 0;
  }
  he.prototype.eventNames = function() {
    var ye = [], be, Ae;
    if (this._eventsCount === 0) return ye;
    for (Ae in be = this._events)
      t.call(be, Ae) && ye.push(n ? Ae.slice(1) : Ae);
    return Object.getOwnPropertySymbols ? ye.concat(Object.getOwnPropertySymbols(be)) : ye;
  }, he.prototype.listeners = function(ye) {
    var be = n ? n + ye : ye, Ae = this._events[be];
    if (!Ae) return [];
    if (Ae.fn) return [Ae.fn];
    for (var Se = 0, $e = Ae.length, Re = new Array($e); Se < $e; Se++)
      Re[Se] = Ae[Se].fn;
    return Re;
  }, he.prototype.listenerCount = function(ye) {
    var be = n ? n + ye : ye, Ae = this._events[be];
    return Ae ? Ae.fn ? 1 : Ae.length : 0;
  }, he.prototype.emit = function(ye, be, Ae, Se, $e, Re) {
    var Me = n ? n + ye : ye;
    if (!this._events[Me]) return !1;
    var ke = this._events[Me], Te = arguments.length, Ie, qe;
    if (ke.fn) {
      switch (ke.once && this.removeListener(ye, ke.fn, void 0, !0), Te) {
        case 1:
          return ke.fn.call(ke.context), !0;
        case 2:
          return ke.fn.call(ke.context, be), !0;
        case 3:
          return ke.fn.call(ke.context, be, Ae), !0;
        case 4:
          return ke.fn.call(ke.context, be, Ae, Se), !0;
        case 5:
          return ke.fn.call(ke.context, be, Ae, Se, $e), !0;
        case 6:
          return ke.fn.call(ke.context, be, Ae, Se, $e, Re), !0;
      }
      for (qe = 1, Ie = new Array(Te - 1); qe < Te; qe++)
        Ie[qe - 1] = arguments[qe];
      ke.fn.apply(ke.context, Ie);
    } else {
      var Ue = ke.length, ze;
      for (qe = 0; qe < Ue; qe++)
        switch (ke[qe].once && this.removeListener(ye, ke[qe].fn, void 0, !0), Te) {
          case 1:
            ke[qe].fn.call(ke[qe].context);
            break;
          case 2:
            ke[qe].fn.call(ke[qe].context, be);
            break;
          case 3:
            ke[qe].fn.call(ke[qe].context, be, Ae);
            break;
          case 4:
            ke[qe].fn.call(ke[qe].context, be, Ae, Se);
            break;
          default:
            if (!Ie) for (ze = 1, Ie = new Array(Te - 1); ze < Te; ze++)
              Ie[ze - 1] = arguments[ze];
            ke[qe].fn.apply(ke[qe].context, Ie);
        }
    }
    return !0;
  }, he.prototype.on = function(ye, be, Ae) {
    return ae(this, ye, be, Ae, !1);
  }, he.prototype.once = function(ye, be, Ae) {
    return ae(this, ye, be, Ae, !0);
  }, he.prototype.removeListener = function(ye, be, Ae, Se) {
    var $e = n ? n + ye : ye;
    if (!this._events[$e]) return this;
    if (!be)
      return le(this, $e), this;
    var Re = this._events[$e];
    if (Re.fn)
      Re.fn === be && (!Se || Re.once) && (!Ae || Re.context === Ae) && le(this, $e);
    else {
      for (var Me = 0, ke = [], Te = Re.length; Me < Te; Me++)
        (Re[Me].fn !== be || Se && !Re[Me].once || Ae && Re[Me].context !== Ae) && ke.push(Re[Me]);
      ke.length ? this._events[$e] = ke.length === 1 ? ke[0] : ke : le(this, $e);
    }
    return this;
  }, he.prototype.removeAllListeners = function(ye) {
    var be;
    return ye ? (be = n ? n + ye : ye, this._events[be] && le(this, be)) : (this._events = new ie(), this._eventsCount = 0), this;
  }, he.prototype.off = he.prototype.removeListener, he.prototype.addListener = he.prototype.on, he.prefixed = n, he.EventEmitter = he, c.exports = he;
})(eventemitter3$1);
var eventemitter3Exports = eventemitter3$1.exports, utils$f = {};
Object.defineProperty(utils$f, "__esModule", { value: !0 });
utils$f.createError = utils$f.DefaultDataPack = void 0;
const errors = /* @__PURE__ */ new Map([
  [-32e3, "Event not provided"],
  [-32600, "Invalid Request"],
  [-32601, "Method not found"],
  [-32602, "Invalid params"],
  [-32603, "Internal error"],
  [-32604, "Params not found"],
  [-32605, "Method forbidden"],
  [-32606, "Event forbidden"],
  [-32700, "Parse error"]
]);
class DefaultDataPack {
  encode(t) {
    return JSON.stringify(t);
  }
  decode(t) {
    return JSON.parse(t);
  }
}
utils$f.DefaultDataPack = DefaultDataPack;
function createError(c, t) {
  const n = {
    code: c,
    message: errors.get(c) || "Internal Server Error"
  };
  return t && (n.data = t), n;
}
utils$f.createError = createError;
Object.defineProperty(client, "__esModule", { value: !0 });
const eventemitter3_1$1 = eventemitter3Exports, utils_1$7 = utils$f;
class CommonClient extends eventemitter3_1$1.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */
  constructor(n, ie = "ws://localhost:8080", { autoconnect: fe = !0, reconnect: ae = !0, reconnect_interval: le = 1e3, max_reconnects: he = 5, ...me } = {}, ye, be) {
    super();
    Zn(this, "address");
    Zn(this, "rpc_id");
    Zn(this, "queue");
    Zn(this, "options");
    Zn(this, "autoconnect");
    Zn(this, "ready");
    Zn(this, "reconnect");
    Zn(this, "reconnect_timer_id");
    Zn(this, "reconnect_interval");
    Zn(this, "max_reconnects");
    Zn(this, "rest_options");
    Zn(this, "current_reconnects");
    Zn(this, "generate_request_id");
    Zn(this, "socket");
    Zn(this, "webSocketFactory");
    Zn(this, "dataPack");
    this.webSocketFactory = n, this.queue = {}, this.rpc_id = 0, this.address = ie, this.autoconnect = fe, this.ready = !1, this.reconnect = ae, this.reconnect_timer_id = void 0, this.reconnect_interval = le, this.max_reconnects = he, this.rest_options = me, this.current_reconnects = 0, this.generate_request_id = ye || (() => ++this.rpc_id), be ? this.dataPack = be : this.dataPack = new utils_1$7.DefaultDataPack(), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(n, ie, fe, ae) {
    return !ae && typeof fe == "object" && (ae = fe, fe = null), new Promise((le, he) => {
      if (!this.ready)
        return he(new Error("socket not ready"));
      const me = this.generate_request_id(n, ie), ye = {
        jsonrpc: "2.0",
        method: n,
        params: ie || void 0,
        id: me
      };
      this.socket.send(this.dataPack.encode(ye), ae, (be) => {
        if (be)
          return he(be);
        this.queue[me] = { promise: [le, he] }, fe && (this.queue[me].timeout = setTimeout(() => {
          delete this.queue[me], he(new Error("reply timeout"));
        }, fe));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(n) {
    const ie = await this.call("rpc.login", n);
    if (!ie)
      throw new Error("authentication failed");
    return ie;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(n, ie) {
    return new Promise((fe, ae) => {
      if (!this.ready)
        return ae(new Error("socket not ready"));
      const le = {
        jsonrpc: "2.0",
        method: n,
        params: ie
      };
      this.socket.send(this.dataPack.encode(le), (he) => {
        if (he)
          return ae(he);
        fe();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(n) {
    typeof n == "string" && (n = [n]);
    const ie = await this.call("rpc.on", n);
    if (typeof n == "string" && ie[n] !== "ok")
      throw new Error("Failed subscribing to an event '" + n + "' with: " + ie[n]);
    return ie;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(n) {
    typeof n == "string" && (n = [n]);
    const ie = await this.call("rpc.off", n);
    if (typeof n == "string" && ie[n] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + ie);
    return ie;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(n, ie) {
    this.socket.close(n || 1e3, ie);
  }
  /**
   * Enable / disable automatic reconnection.
   * @method
   * @param {Boolean} reconnect - enable / disable reconnection
   * @return {Undefined}
   */
  setAutoReconnect(n) {
    this.reconnect = n;
  }
  /**
   * Set the interval between reconnection attempts.
   * @method
   * @param {Number} interval - reconnection interval in milliseconds
   * @return {Undefined}
   */
  setReconnectInterval(n) {
    this.reconnect_interval = n;
  }
  /**
   * Set the maximum number of reconnection attempts.
   * @method
   * @param {Number} max_reconnects - maximum reconnection attempts
   * @return {Undefined}
   */
  setMaxReconnects(n) {
    this.max_reconnects = n;
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(n, ie) {
    clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(n, ie), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({ data: fe }) => {
      fe instanceof ArrayBuffer && (fe = Buffer$7.from(fe).toString());
      try {
        fe = this.dataPack.decode(fe);
      } catch {
        return;
      }
      if (fe.notification && this.listeners(fe.notification).length) {
        if (!Object.keys(fe.params).length)
          return this.emit(fe.notification);
        const ae = [fe.notification];
        if (fe.params.constructor === Object)
          ae.push(fe.params);
        else
          for (let le = 0; le < fe.params.length; le++)
            ae.push(fe.params[le]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, ae);
        });
      }
      if (!this.queue[fe.id])
        return fe.method ? Promise.resolve().then(() => {
          this.emit(fe.method, fe == null ? void 0 : fe.params);
        }) : void 0;
      "error" in fe == "result" in fe && this.queue[fe.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue[fe.id].timeout && clearTimeout(this.queue[fe.id].timeout), fe.error ? this.queue[fe.id].promise[1](fe.error) : this.queue[fe.id].promise[0](fe.result), delete this.queue[fe.id];
    }), this.socket.addEventListener("error", (fe) => this.emit("error", fe)), this.socket.addEventListener("close", ({ code: fe, reason: ae }) => {
      this.ready && setTimeout(() => this.emit("close", fe, ae), 0), this.ready = !1, this.socket = void 0, fe !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && (this.reconnect_timer_id = setTimeout(() => this._connect(n, ie), this.reconnect_interval)));
    });
  }
}
var _default$1 = client.default = CommonClient, websocket_browser = {};
Object.defineProperty(websocket_browser, "__esModule", { value: !0 });
const eventemitter3_1 = eventemitter3Exports;
class WebSocketBrowserImpl extends eventemitter3_1.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(n, ie, fe) {
    super();
    Zn(this, "socket");
    this.socket = new window.WebSocket(n, fe), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (ae) => this.emit("message", ae.data), this.socket.onerror = (ae) => this.emit("error", ae), this.socket.onclose = (ae) => {
      this.emit("close", ae.code, ae.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(n, ie, fe) {
    const ae = fe || ie;
    try {
      this.socket.send(n), ae();
    } catch (le) {
      ae(le);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(n, ie) {
    this.socket.close(n, ie);
  }
  addEventListener(n, ie, fe) {
    this.socket.addEventListener(n, ie, fe);
  }
}
function default_1(c, t) {
  return new WebSocketBrowserImpl(c, t);
}
var _default = websocket_browser.default = default_1;
class HMAC extends Hash {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, hash$3(t);
    const ie = toBytes(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const fe = this.blockLen, ae = new Uint8Array(fe);
    ae.set(ie.length > fe ? t.create().update(ie).digest() : ie);
    for (let le = 0; le < ae.length; le++)
      ae[le] ^= 54;
    this.iHash.update(ae), this.oHash = t.create();
    for (let le = 0; le < ae.length; le++)
      ae[le] ^= 106;
    this.oHash.update(ae), ae.fill(0);
  }
  update(t) {
    return exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    exists(this), bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: ie, finished: fe, destroyed: ae, blockLen: le, outputLen: he } = this;
    return t = t, t.finished = fe, t.destroyed = ae, t.blockLen = le, t.outputLen = he, t.oHash = n._cloneInto(t.oHash), t.iHash = ie._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac = (c, t, n) => new HMAC(c, t).update(n).digest();
hmac.create = (c, t) => new HMAC(c, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function validateSigVerOpts(c) {
  c.lowS !== void 0 && abool("lowS", c.lowS), c.prehash !== void 0 && abool("prehash", c.prehash);
}
function validatePointOpts(c) {
  const t = validateBasic(c);
  validateObject(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: ie, a: fe } = t;
  if (n) {
    if (!ie.eql(fe, ie.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut$2, DER = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (c, t) => {
      const { Err: n } = DER;
      if (c < 0 || c > 256)
        throw new n("tlv.encode: wrong tag");
      if (t.length & 1)
        throw new n("tlv.encode: unpadded data");
      const ie = t.length / 2, fe = numberToHexUnpadded(ie);
      if (fe.length / 2 & 128)
        throw new n("tlv.encode: long form length too big");
      const ae = ie > 127 ? numberToHexUnpadded(fe.length / 2 | 128) : "";
      return `${numberToHexUnpadded(c)}${ae}${fe}${t}`;
    },
    // v - value, l - left bytes (unparsed)
    decode(c, t) {
      const { Err: n } = DER;
      let ie = 0;
      if (c < 0 || c > 256)
        throw new n("tlv.encode: wrong tag");
      if (t.length < 2 || t[ie++] !== c)
        throw new n("tlv.decode: wrong tlv");
      const fe = t[ie++], ae = !!(fe & 128);
      let le = 0;
      if (!ae)
        le = fe;
      else {
        const me = fe & 127;
        if (!me)
          throw new n("tlv.decode(long): indefinite length not supported");
        if (me > 4)
          throw new n("tlv.decode(long): byte length is too big");
        const ye = t.subarray(ie, ie + me);
        if (ye.length !== me)
          throw new n("tlv.decode: length bytes not complete");
        if (ye[0] === 0)
          throw new n("tlv.decode(long): zero leftmost byte");
        for (const be of ye)
          le = le << 8 | be;
        if (ie += me, le < 128)
          throw new n("tlv.decode(long): not minimal encoding");
      }
      const he = t.subarray(ie, ie + le);
      if (he.length !== le)
        throw new n("tlv.decode: wrong value length");
      return { v: he, l: t.subarray(ie + le) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(c) {
      const { Err: t } = DER;
      if (c < _0n)
        throw new t("integer: negative integers are not allowed");
      let n = numberToHexUnpadded(c);
      if (Number.parseInt(n[0], 16) & 8 && (n = "00" + n), n.length & 1)
        throw new t("unexpected assertion");
      return n;
    },
    decode(c) {
      const { Err: t } = DER;
      if (c[0] & 128)
        throw new t("Invalid signature integer: negative");
      if (c[0] === 0 && !(c[1] & 128))
        throw new t("Invalid signature integer: unnecessary leading zero");
      return b2n(c);
    }
  },
  toSig(c) {
    const { Err: t, _int: n, _tlv: ie } = DER, fe = typeof c == "string" ? h2b(c) : c;
    abytes(fe);
    const { v: ae, l: le } = ie.decode(48, fe);
    if (le.length)
      throw new t("Invalid signature: left bytes after parsing");
    const { v: he, l: me } = ie.decode(2, ae), { v: ye, l: be } = ie.decode(2, me);
    if (be.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: n.decode(he), s: n.decode(ye) };
  },
  hexFromSig(c) {
    const { _tlv: t, _int: n } = DER, ie = `${t.encode(2, n.encode(c.r))}${t.encode(2, n.encode(c.s))}`;
    return t.encode(48, ie);
  }
}, _0n = BigInt(0), _1n$1 = BigInt(1);
BigInt(2);
const _3n = BigInt(3);
BigInt(4);
function weierstrassPoints(c) {
  const t = validatePointOpts(c), { Fp: n } = t, ie = Field(t.n, t.nBitLength), fe = t.toBytes || ((Me, ke, Te) => {
    const Ie = ke.toAffine();
    return concatBytes(Uint8Array.from([4]), n.toBytes(Ie.x), n.toBytes(Ie.y));
  }), ae = t.fromBytes || ((Me) => {
    const ke = Me.subarray(1), Te = n.fromBytes(ke.subarray(0, n.BYTES)), Ie = n.fromBytes(ke.subarray(n.BYTES, 2 * n.BYTES));
    return { x: Te, y: Ie };
  });
  function le(Me) {
    const { a: ke, b: Te } = t, Ie = n.sqr(Me), qe = n.mul(Ie, Me);
    return n.add(n.add(qe, n.mul(Me, ke)), Te);
  }
  if (!n.eql(n.sqr(t.Gy), le(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function he(Me) {
    return inRange$1(Me, _1n$1, t.n);
  }
  function me(Me) {
    const { allowedPrivateKeyLengths: ke, nByteLength: Te, wrapPrivateKey: Ie, n: qe } = t;
    if (ke && typeof Me != "bigint") {
      if (isBytes(Me) && (Me = bytesToHex(Me)), typeof Me != "string" || !ke.includes(Me.length))
        throw new Error("Invalid key");
      Me = Me.padStart(Te * 2, "0");
    }
    let Ue;
    try {
      Ue = typeof Me == "bigint" ? Me : bytesToNumberBE(ensureBytes("private key", Me, Te));
    } catch {
      throw new Error(`private key must be ${Te} bytes, hex or bigint, not ${typeof Me}`);
    }
    return Ie && (Ue = mod(Ue, qe)), aInRange("private key", Ue, _1n$1, qe), Ue;
  }
  function ye(Me) {
    if (!(Me instanceof Se))
      throw new Error("ProjectivePoint expected");
  }
  const be = memoized((Me, ke) => {
    const { px: Te, py: Ie, pz: qe } = Me;
    if (n.eql(qe, n.ONE))
      return { x: Te, y: Ie };
    const Ue = Me.is0();
    ke == null && (ke = Ue ? n.ONE : n.inv(qe));
    const ze = n.mul(Te, ke), Ve = n.mul(Ie, ke), Mt = n.mul(qe, ke);
    if (Ue)
      return { x: n.ZERO, y: n.ZERO };
    if (!n.eql(Mt, n.ONE))
      throw new Error("invZ was invalid");
    return { x: ze, y: Ve };
  }), Ae = memoized((Me) => {
    if (Me.is0()) {
      if (t.allowInfinityPoint && !n.is0(Me.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: ke, y: Te } = Me.toAffine();
    if (!n.isValid(ke) || !n.isValid(Te))
      throw new Error("bad point: x or y not FE");
    const Ie = n.sqr(Te), qe = le(ke);
    if (!n.eql(Ie, qe))
      throw new Error("bad point: equation left != right");
    if (!Me.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class Se {
    constructor(ke, Te, Ie) {
      if (this.px = ke, this.py = Te, this.pz = Ie, ke == null || !n.isValid(ke))
        throw new Error("x required");
      if (Te == null || !n.isValid(Te))
        throw new Error("y required");
      if (Ie == null || !n.isValid(Ie))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(ke) {
      const { x: Te, y: Ie } = ke || {};
      if (!ke || !n.isValid(Te) || !n.isValid(Ie))
        throw new Error("invalid affine point");
      if (ke instanceof Se)
        throw new Error("projective point not allowed");
      const qe = (Ue) => n.eql(Ue, n.ZERO);
      return qe(Te) && qe(Ie) ? Se.ZERO : new Se(Te, Ie, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(ke) {
      const Te = n.invertBatch(ke.map((Ie) => Ie.pz));
      return ke.map((Ie, qe) => Ie.toAffine(Te[qe])).map(Se.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(ke) {
      const Te = Se.fromAffine(ae(ensureBytes("pointHex", ke)));
      return Te.assertValidity(), Te;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(ke) {
      return Se.BASE.multiply(me(ke));
    }
    // Multiscalar Multiplication
    static msm(ke, Te) {
      return pippenger(Se, ie, ke, Te);
    }
    // "Private method", don't use it directly
    _setWindowSize(ke) {
      Re.setWindowSize(this, ke);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      Ae(this);
    }
    hasEvenY() {
      const { y: ke } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(ke);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(ke) {
      ye(ke);
      const { px: Te, py: Ie, pz: qe } = this, { px: Ue, py: ze, pz: Ve } = ke, Mt = n.eql(n.mul(Te, Ve), n.mul(Ue, qe)), Rt = n.eql(n.mul(Ie, Ve), n.mul(ze, qe));
      return Mt && Rt;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new Se(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: ke, b: Te } = t, Ie = n.mul(Te, _3n), { px: qe, py: Ue, pz: ze } = this;
      let Ve = n.ZERO, Mt = n.ZERO, Rt = n.ZERO, je = n.mul(qe, qe), jt = n.mul(Ue, Ue), _e = n.mul(ze, ze), se = n.mul(qe, Ue);
      return se = n.add(se, se), Rt = n.mul(qe, ze), Rt = n.add(Rt, Rt), Ve = n.mul(ke, Rt), Mt = n.mul(Ie, _e), Mt = n.add(Ve, Mt), Ve = n.sub(jt, Mt), Mt = n.add(jt, Mt), Mt = n.mul(Ve, Mt), Ve = n.mul(se, Ve), Rt = n.mul(Ie, Rt), _e = n.mul(ke, _e), se = n.sub(je, _e), se = n.mul(ke, se), se = n.add(se, Rt), Rt = n.add(je, je), je = n.add(Rt, je), je = n.add(je, _e), je = n.mul(je, se), Mt = n.add(Mt, je), _e = n.mul(Ue, ze), _e = n.add(_e, _e), je = n.mul(_e, se), Ve = n.sub(Ve, je), Rt = n.mul(_e, jt), Rt = n.add(Rt, Rt), Rt = n.add(Rt, Rt), new Se(Ve, Mt, Rt);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(ke) {
      ye(ke);
      const { px: Te, py: Ie, pz: qe } = this, { px: Ue, py: ze, pz: Ve } = ke;
      let Mt = n.ZERO, Rt = n.ZERO, je = n.ZERO;
      const jt = t.a, _e = n.mul(t.b, _3n);
      let se = n.mul(Te, Ue), ce = n.mul(Ie, ze), de = n.mul(qe, Ve), pe = n.add(Te, Ie), ve = n.add(Ue, ze);
      pe = n.mul(pe, ve), ve = n.add(se, ce), pe = n.sub(pe, ve), ve = n.add(Te, qe);
      let we = n.add(Ue, Ve);
      return ve = n.mul(ve, we), we = n.add(se, de), ve = n.sub(ve, we), we = n.add(Ie, qe), Mt = n.add(ze, Ve), we = n.mul(we, Mt), Mt = n.add(ce, de), we = n.sub(we, Mt), je = n.mul(jt, ve), Mt = n.mul(_e, de), je = n.add(Mt, je), Mt = n.sub(ce, je), je = n.add(ce, je), Rt = n.mul(Mt, je), ce = n.add(se, se), ce = n.add(ce, se), de = n.mul(jt, de), ve = n.mul(_e, ve), ce = n.add(ce, de), de = n.sub(se, de), de = n.mul(jt, de), ve = n.add(ve, de), se = n.mul(ce, ve), Rt = n.add(Rt, se), se = n.mul(we, ve), Mt = n.mul(pe, Mt), Mt = n.sub(Mt, se), se = n.mul(pe, ce), je = n.mul(we, je), je = n.add(je, se), new Se(Mt, Rt, je);
    }
    subtract(ke) {
      return this.add(ke.negate());
    }
    is0() {
      return this.equals(Se.ZERO);
    }
    wNAF(ke) {
      return Re.wNAFCached(this, ke, Se.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(ke) {
      aInRange("scalar", ke, _0n, t.n);
      const Te = Se.ZERO;
      if (ke === _0n)
        return Te;
      if (ke === _1n$1)
        return this;
      const { endo: Ie } = t;
      if (!Ie)
        return Re.unsafeLadder(this, ke);
      let { k1neg: qe, k1: Ue, k2neg: ze, k2: Ve } = Ie.splitScalar(ke), Mt = Te, Rt = Te, je = this;
      for (; Ue > _0n || Ve > _0n; )
        Ue & _1n$1 && (Mt = Mt.add(je)), Ve & _1n$1 && (Rt = Rt.add(je)), je = je.double(), Ue >>= _1n$1, Ve >>= _1n$1;
      return qe && (Mt = Mt.negate()), ze && (Rt = Rt.negate()), Rt = new Se(n.mul(Rt.px, Ie.beta), Rt.py, Rt.pz), Mt.add(Rt);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(ke) {
      const { endo: Te, n: Ie } = t;
      aInRange("scalar", ke, _1n$1, Ie);
      let qe, Ue;
      if (Te) {
        const { k1neg: ze, k1: Ve, k2neg: Mt, k2: Rt } = Te.splitScalar(ke);
        let { p: je, f: jt } = this.wNAF(Ve), { p: _e, f: se } = this.wNAF(Rt);
        je = Re.constTimeNegate(ze, je), _e = Re.constTimeNegate(Mt, _e), _e = new Se(n.mul(_e.px, Te.beta), _e.py, _e.pz), qe = je.add(_e), Ue = jt.add(se);
      } else {
        const { p: ze, f: Ve } = this.wNAF(ke);
        qe = ze, Ue = Ve;
      }
      return Se.normalizeZ([qe, Ue])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(ke, Te, Ie) {
      const qe = Se.BASE, Ue = (Ve, Mt) => Mt === _0n || Mt === _1n$1 || !Ve.equals(qe) ? Ve.multiplyUnsafe(Mt) : Ve.multiply(Mt), ze = Ue(this, Te).add(Ue(ke, Ie));
      return ze.is0() ? void 0 : ze;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(ke) {
      return be(this, ke);
    }
    isTorsionFree() {
      const { h: ke, isTorsionFree: Te } = t;
      if (ke === _1n$1)
        return !0;
      if (Te)
        return Te(Se, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: ke, clearCofactor: Te } = t;
      return ke === _1n$1 ? this : Te ? Te(Se, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(ke = !0) {
      return abool("isCompressed", ke), this.assertValidity(), fe(Se, this, ke);
    }
    toHex(ke = !0) {
      return abool("isCompressed", ke), bytesToHex(this.toRawBytes(ke));
    }
  }
  Se.BASE = new Se(t.Gx, t.Gy, n.ONE), Se.ZERO = new Se(n.ZERO, n.ONE, n.ZERO);
  const $e = t.nBitLength, Re = wNAF(Se, t.endo ? Math.ceil($e / 2) : $e);
  return {
    CURVE: t,
    ProjectivePoint: Se,
    normPrivateKeyToScalar: me,
    weierstrassEquation: le,
    isWithinCurveOrder: he
  };
}
function validateOpts(c) {
  const t = validateBasic(c);
  return validateObject(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function weierstrass(c) {
  const t = validateOpts(c), { Fp: n, n: ie } = t, fe = n.BYTES + 1, ae = 2 * n.BYTES + 1;
  function le(de) {
    return mod(de, ie);
  }
  function he(de) {
    return invert(de, ie);
  }
  const { ProjectivePoint: me, normPrivateKeyToScalar: ye, weierstrassEquation: be, isWithinCurveOrder: Ae } = weierstrassPoints({
    ...t,
    toBytes(de, pe, ve) {
      const we = pe.toAffine(), Ee = n.toBytes(we.x), xe = concatBytes;
      return abool("isCompressed", ve), ve ? xe(Uint8Array.from([pe.hasEvenY() ? 2 : 3]), Ee) : xe(Uint8Array.from([4]), Ee, n.toBytes(we.y));
    },
    fromBytes(de) {
      const pe = de.length, ve = de[0], we = de.subarray(1);
      if (pe === fe && (ve === 2 || ve === 3)) {
        const Ee = bytesToNumberBE(we);
        if (!inRange$1(Ee, _1n$1, n.ORDER))
          throw new Error("Point is not on curve");
        const xe = be(Ee);
        let ue;
        try {
          ue = n.sqrt(xe);
        } catch (Ne) {
          const Fe = Ne instanceof Error ? ": " + Ne.message : "";
          throw new Error("Point is not on curve" + Fe);
        }
        const ge = (ue & _1n$1) === _1n$1;
        return (ve & 1) === 1 !== ge && (ue = n.neg(ue)), { x: Ee, y: ue };
      } else if (pe === ae && ve === 4) {
        const Ee = n.fromBytes(we.subarray(0, n.BYTES)), xe = n.fromBytes(we.subarray(n.BYTES, 2 * n.BYTES));
        return { x: Ee, y: xe };
      } else
        throw new Error(`Point of length ${pe} was invalid. Expected ${fe} compressed bytes or ${ae} uncompressed bytes`);
    }
  }), Se = (de) => bytesToHex(numberToBytesBE(de, t.nByteLength));
  function $e(de) {
    const pe = ie >> _1n$1;
    return de > pe;
  }
  function Re(de) {
    return $e(de) ? le(-de) : de;
  }
  const Me = (de, pe, ve) => bytesToNumberBE(de.slice(pe, ve));
  class ke {
    constructor(pe, ve, we) {
      this.r = pe, this.s = ve, this.recovery = we, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(pe) {
      const ve = t.nByteLength;
      return pe = ensureBytes("compactSignature", pe, ve * 2), new ke(Me(pe, 0, ve), Me(pe, ve, 2 * ve));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(pe) {
      const { r: ve, s: we } = DER.toSig(ensureBytes("DER", pe));
      return new ke(ve, we);
    }
    assertValidity() {
      aInRange("r", this.r, _1n$1, ie), aInRange("s", this.s, _1n$1, ie);
    }
    addRecoveryBit(pe) {
      return new ke(this.r, this.s, pe);
    }
    recoverPublicKey(pe) {
      const { r: ve, s: we, recovery: Ee } = this, xe = Ve(ensureBytes("msgHash", pe));
      if (Ee == null || ![0, 1, 2, 3].includes(Ee))
        throw new Error("recovery id invalid");
      const ue = Ee === 2 || Ee === 3 ? ve + t.n : ve;
      if (ue >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const ge = Ee & 1 ? "03" : "02", Be = me.fromHex(ge + Se(ue)), Ne = he(ue), Fe = le(-xe * Ne), Pe = le(we * Ne), Je = me.BASE.multiplyAndAddUnsafe(Be, Fe, Pe);
      if (!Je)
        throw new Error("point at infinify");
      return Je.assertValidity(), Je;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return $e(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ke(this.r, le(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes(this.toDERHex());
    }
    toDERHex() {
      return DER.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
      return Se(this.r) + Se(this.s);
    }
  }
  const Te = {
    isValidPrivateKey(de) {
      try {
        return ye(de), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: ye,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const de = getMinHashLength(t.n);
      return mapHashToField(t.randomBytes(de), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(de = 8, pe = me.BASE) {
      return pe._setWindowSize(de), pe.multiply(BigInt(3)), pe;
    }
  };
  function Ie(de, pe = !0) {
    return me.fromPrivateKey(de).toRawBytes(pe);
  }
  function qe(de) {
    const pe = isBytes(de), ve = typeof de == "string", we = (pe || ve) && de.length;
    return pe ? we === fe || we === ae : ve ? we === 2 * fe || we === 2 * ae : de instanceof me;
  }
  function Ue(de, pe, ve = !0) {
    if (qe(de))
      throw new Error("first arg must be private key");
    if (!qe(pe))
      throw new Error("second arg must be public key");
    return me.fromHex(pe).multiply(ye(de)).toRawBytes(ve);
  }
  const ze = t.bits2int || function(de) {
    const pe = bytesToNumberBE(de), ve = de.length * 8 - t.nBitLength;
    return ve > 0 ? pe >> BigInt(ve) : pe;
  }, Ve = t.bits2int_modN || function(de) {
    return le(ze(de));
  }, Mt = bitMask(t.nBitLength);
  function Rt(de) {
    return aInRange(`num < 2^${t.nBitLength}`, de, _0n, Mt), numberToBytesBE(de, t.nByteLength);
  }
  function je(de, pe, ve = jt) {
    if (["recovered", "canonical"].some((Ze) => Ze in ve))
      throw new Error("sign() legacy options not supported");
    const { hash: we, randomBytes: Ee } = t;
    let { lowS: xe, prehash: ue, extraEntropy: ge } = ve;
    xe == null && (xe = !0), de = ensureBytes("msgHash", de), validateSigVerOpts(ve), ue && (de = ensureBytes("prehashed msgHash", we(de)));
    const Be = Ve(de), Ne = ye(pe), Fe = [Rt(Ne), Rt(Be)];
    if (ge != null && ge !== !1) {
      const Ze = ge === !0 ? Ee(n.BYTES) : ge;
      Fe.push(ensureBytes("extraEntropy", Ze));
    }
    const Pe = concatBytes(...Fe), Je = Be;
    function Ke(Ze) {
      const Ye = ze(Ze);
      if (!Ae(Ye))
        return;
      const Pt = he(Ye), Ft = me.BASE.multiply(Ye).toAffine(), Le = le(Ft.x);
      if (Le === _0n)
        return;
      const $t = le(Pt * le(Je + Le * Ne));
      if ($t === _0n)
        return;
      let Jt = (Ft.x === Le ? 0 : 2) | Number(Ft.y & _1n$1), Ht = $t;
      return xe && $e($t) && (Ht = Re($t), Jt ^= 1), new ke(Le, Ht, Jt);
    }
    return { seed: Pe, k2sig: Ke };
  }
  const jt = { lowS: t.lowS, prehash: !1 }, _e = { lowS: t.lowS, prehash: !1 };
  function se(de, pe, ve = jt) {
    const { seed: we, k2sig: Ee } = je(de, pe, ve), xe = t;
    return createHmacDrbg(xe.hash.outputLen, xe.nByteLength, xe.hmac)(we, Ee);
  }
  me.BASE._setWindowSize(8);
  function ce(de, pe, ve, we = _e) {
    var Ft;
    const Ee = de;
    if (pe = ensureBytes("msgHash", pe), ve = ensureBytes("publicKey", ve), "strict" in we)
      throw new Error("options.strict was renamed to lowS");
    validateSigVerOpts(we);
    const { lowS: xe, prehash: ue } = we;
    let ge, Be;
    try {
      if (typeof Ee == "string" || isBytes(Ee))
        try {
          ge = ke.fromDER(Ee);
        } catch (Le) {
          if (!(Le instanceof DER.Err))
            throw Le;
          ge = ke.fromCompact(Ee);
        }
      else if (typeof Ee == "object" && typeof Ee.r == "bigint" && typeof Ee.s == "bigint") {
        const { r: Le, s: $t } = Ee;
        ge = new ke(Le, $t);
      } else
        throw new Error("PARSE");
      Be = me.fromHex(ve);
    } catch (Le) {
      if (Le.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (xe && ge.hasHighS())
      return !1;
    ue && (pe = t.hash(pe));
    const { r: Ne, s: Fe } = ge, Pe = Ve(pe), Je = he(Fe), Ke = le(Pe * Je), Ze = le(Ne * Je), Ye = (Ft = me.BASE.multiplyAndAddUnsafe(Be, Ke, Ze)) == null ? void 0 : Ft.toAffine();
    return Ye ? le(Ye.x) === Ne : !1;
  }
  return {
    CURVE: t,
    getPublicKey: Ie,
    getSharedSecret: Ue,
    sign: se,
    verify: ce,
    ProjectivePoint: me,
    Signature: ke,
    utils: Te
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function getHash(c) {
  return {
    hash: c,
    hmac: (t, ...n) => hmac(c, t, concatBytes$1(...n)),
    randomBytes
  };
}
function createCurve(c, t) {
  const n = (ie) => weierstrass({ ...c, ...getHash(ie) });
  return Object.freeze({ ...n(t), create: n });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n = BigInt(1), _2n = BigInt(2), divNearest = (c, t) => (c + t / _2n) / t;
function sqrtMod(c) {
  const t = secp256k1P, n = BigInt(3), ie = BigInt(6), fe = BigInt(11), ae = BigInt(22), le = BigInt(23), he = BigInt(44), me = BigInt(88), ye = c * c * c % t, be = ye * ye * c % t, Ae = pow2(be, n, t) * be % t, Se = pow2(Ae, n, t) * be % t, $e = pow2(Se, _2n, t) * ye % t, Re = pow2($e, fe, t) * $e % t, Me = pow2(Re, ae, t) * Re % t, ke = pow2(Me, he, t) * Me % t, Te = pow2(ke, me, t) * ke % t, Ie = pow2(Te, he, t) * Me % t, qe = pow2(Ie, n, t) * be % t, Ue = pow2(qe, le, t) * Re % t, ze = pow2(Ue, ie, t) * ye % t, Ve = pow2(ze, _2n, t);
  if (!Fp.eql(Fp.sqr(Ve), c))
    throw new Error("Cannot find square root");
  return Ve;
}
const Fp = Field(secp256k1P, void 0, void 0, { sqrt: sqrtMod }), secp256k1$2 = createCurve({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: secp256k1N,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (c) => {
      const t = secp256k1N, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), ie = -_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), fe = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), ae = n, le = BigInt("0x100000000000000000000000000000000"), he = divNearest(ae * c, t), me = divNearest(-ie * c, t);
      let ye = mod(c - he * n - me * fe, t), be = mod(-he * ie - me * ae, t);
      const Ae = ye > le, Se = be > le;
      if (Ae && (ye = t - ye), Se && (be = t - be), ye > le || be > le)
        throw new Error("splitScalar: Endomorphism failed, k=" + c);
      return { k1neg: Ae, k1: ye, k2neg: Se, k2: be };
    }
  }
}, sha256$4);
BigInt(0);
secp256k1$2.ProjectivePoint;
function isOnCurve$1(c) {
  try {
    return ed25519.ExtendedPoint.fromHex(c), !0;
  } catch {
    return !1;
  }
}
const sign$2 = (c, t) => ed25519.sign(c, t.slice(0, 32)), verify$2 = ed25519.verify, toBuffer$2 = (c) => Buffer$1$1.isBuffer(c) ? c : c instanceof Uint8Array ? Buffer$1$1.from(c.buffer, c.byteOffset, c.byteLength) : Buffer$1$1.from(c);
let Struct$2 = class {
  constructor(t) {
    Object.assign(this, t);
  }
  encode() {
    return Buffer$1$1.from(serialize_1(SOLANA_SCHEMA$1, this));
  }
  static decode(t) {
    return deserialize_1(SOLANA_SCHEMA$1, this, t);
  }
  static decodeUnchecked(t) {
    return deserializeUnchecked_1(SOLANA_SCHEMA$1, this, t);
  }
};
const SOLANA_SCHEMA$1 = /* @__PURE__ */ new Map();
var _class;
let _Symbol$toStringTag;
const MAX_SEED_LENGTH$1 = 32, PUBLIC_KEY_LENGTH$1 = 32;
function isPublicKeyData$1(c) {
  return c._bn !== void 0;
}
let uniquePublicKeyCounter$1 = 1;
_Symbol$toStringTag = Symbol.toStringTag;
let PublicKey$1 = class Xn extends Struct$2 {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(t) {
    if (super({}), this._bn = void 0, isPublicKeyData$1(t))
      this._bn = t._bn;
    else {
      if (typeof t == "string") {
        const n = o$1.decode(t);
        if (n.length != PUBLIC_KEY_LENGTH$1)
          throw new Error("Invalid public key input");
        this._bn = new BN$8(n);
      } else
        this._bn = new BN$8(t);
      if (this._bn.byteLength() > PUBLIC_KEY_LENGTH$1)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const t = new Xn(uniquePublicKeyCounter$1);
    return uniquePublicKeyCounter$1 += 1, new Xn(t.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(t) {
    return this._bn.eq(t._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return o$1.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const t = this.toBuffer();
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const t = this._bn.toArrayLike(Buffer$1$1);
    if (t.length === PUBLIC_KEY_LENGTH$1)
      return t;
    const n = Buffer$1$1.alloc(32);
    return t.copy(n, 32 - t.length), n;
  }
  get [_Symbol$toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(t, n, ie) {
    const fe = Buffer$1$1.concat([t.toBuffer(), Buffer$1$1.from(n), ie.toBuffer()]), ae = sha256$4(fe);
    return new Xn(ae);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(t, n) {
    let ie = Buffer$1$1.alloc(0);
    t.forEach(function(ae) {
      if (ae.length > MAX_SEED_LENGTH$1)
        throw new TypeError("Max seed length exceeded");
      ie = Buffer$1$1.concat([ie, toBuffer$2(ae)]);
    }), ie = Buffer$1$1.concat([ie, n.toBuffer(), Buffer$1$1.from("ProgramDerivedAddress")]);
    const fe = sha256$4(ie);
    if (isOnCurve$1(fe))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new Xn(fe);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(t, n) {
    return this.createProgramAddressSync(t, n);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(t, n) {
    let ie = 255, fe;
    for (; ie != 0; ) {
      try {
        const ae = t.concat(Buffer$1$1.from([ie]));
        fe = this.createProgramAddressSync(ae, n);
      } catch (ae) {
        if (ae instanceof TypeError)
          throw ae;
        ie--;
        continue;
      }
      return [fe, ie];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(t, n) {
    return this.findProgramAddressSync(t, n);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(t) {
    const n = new Xn(t);
    return isOnCurve$1(n.toBytes());
  }
};
_class = PublicKey$1;
PublicKey$1.default = new _class("11111111111111111111111111111111");
SOLANA_SCHEMA$1.set(PublicKey$1, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new PublicKey$1("BPFLoader1111111111111111111111111111111111");
const PACKET_DATA_SIZE$1 = 1232, VERSION_PREFIX_MASK$1 = 127, SIGNATURE_LENGTH_IN_BYTES$1 = 64;
class TransactionExpiredBlockheightExceededError extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: block height exceeded.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(TransactionExpiredBlockheightExceededError.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class TransactionExpiredTimeoutError extends Error {
  constructor(t, n) {
    super(`Transaction was not confirmed in ${n.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${t} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(TransactionExpiredTimeoutError.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class TransactionExpiredNonceInvalidError extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(TransactionExpiredNonceInvalidError.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
let MessageAccountKeys$1 = class {
  constructor(t, n) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = t, this.accountKeysFromLookups = n;
  }
  keySegments() {
    const t = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (t.push(this.accountKeysFromLookups.writable), t.push(this.accountKeysFromLookups.readonly)), t;
  }
  get(t) {
    for (const n of this.keySegments()) {
      if (t < n.length)
        return n[t];
      t -= n.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(t) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const ie = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((ae, le) => {
      ie.set(ae.toBase58(), le);
    });
    const fe = (ae) => {
      const le = ie.get(ae.toBase58());
      if (le === void 0) throw new Error("Encountered an unknown instruction account key during compilation");
      return le;
    };
    return t.map((ae) => ({
      programIdIndex: fe(ae.programId),
      accountKeyIndexes: ae.keys.map((le) => fe(le.pubkey)),
      data: ae.data
    }));
  }
};
const publicKey$2 = (c = "publicKey") => blob$1(32, c), rustString$1 = (c = "string") => {
  const t = struct$1([u32$1("length"), u32$1("lengthPadding"), blob$1(offset(u32$1(), -8), "chars")], c), n = t.decode.bind(t), ie = t.encode.bind(t), fe = t;
  return fe.decode = (ae, le) => n(ae, le).chars.toString(), fe.encode = (ae, le, he) => {
    const me = {
      chars: Buffer$1$1.from(ae, "utf8")
    };
    return ie(me, le, he);
  }, fe.alloc = (ae) => u32$1().span + u32$1().span + Buffer$1$1.from(ae, "utf8").length, fe;
}, authorized$1 = (c = "authorized") => struct$1([publicKey$2("staker"), publicKey$2("withdrawer")], c), lockup$1 = (c = "lockup") => struct$1([ns64("unixTimestamp"), ns64("epoch"), publicKey$2("custodian")], c), voteInit$1 = (c = "voteInit") => struct$1([publicKey$2("nodePubkey"), publicKey$2("authorizedVoter"), publicKey$2("authorizedWithdrawer"), u8$1("commission")], c), voteAuthorizeWithSeedArgs$1 = (c = "voteAuthorizeWithSeedArgs") => struct$1([u32$1("voteAuthorizationType"), publicKey$2("currentAuthorityDerivedKeyOwnerPubkey"), rustString$1("currentAuthorityDerivedKeySeed"), publicKey$2("newAuthorized")], c);
function decodeLength$1(c) {
  let t = 0, n = 0;
  for (; ; ) {
    let ie = c.shift();
    if (t |= (ie & 127) << n * 7, n += 1, !(ie & 128))
      break;
  }
  return t;
}
function encodeLength$1(c, t) {
  let n = t;
  for (; ; ) {
    let ie = n & 127;
    if (n >>= 7, n == 0) {
      c.push(ie);
      break;
    } else
      ie |= 128, c.push(ie);
  }
}
function assert$c(c, t) {
  if (!c)
    throw new Error(t || "Assertion failed");
}
let CompiledKeys$1 = class ni {
  constructor(t, n) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = t, this.keyMetaMap = n;
  }
  static compile(t, n) {
    const ie = /* @__PURE__ */ new Map(), fe = (le) => {
      const he = le.toBase58();
      let me = ie.get(he);
      return me === void 0 && (me = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, ie.set(he, me)), me;
    }, ae = fe(n);
    ae.isSigner = !0, ae.isWritable = !0;
    for (const le of t) {
      fe(le.programId).isInvoked = !0;
      for (const he of le.keys) {
        const me = fe(he.pubkey);
        me.isSigner || (me.isSigner = he.isSigner), me.isWritable || (me.isWritable = he.isWritable);
      }
    }
    return new ni(n, ie);
  }
  getMessageComponents() {
    const t = [...this.keyMetaMap.entries()];
    assert$c(t.length <= 256, "Max static account keys length exceeded");
    const n = t.filter(([, me]) => me.isSigner && me.isWritable), ie = t.filter(([, me]) => me.isSigner && !me.isWritable), fe = t.filter(([, me]) => !me.isSigner && me.isWritable), ae = t.filter(([, me]) => !me.isSigner && !me.isWritable), le = {
      numRequiredSignatures: n.length + ie.length,
      numReadonlySignedAccounts: ie.length,
      numReadonlyUnsignedAccounts: ae.length
    };
    {
      assert$c(n.length > 0, "Expected at least one writable signer key");
      const [me] = n[0];
      assert$c(me === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const he = [...n.map(([me]) => new PublicKey$1(me)), ...ie.map(([me]) => new PublicKey$1(me)), ...fe.map(([me]) => new PublicKey$1(me)), ...ae.map(([me]) => new PublicKey$1(me))];
    return [le, he];
  }
  extractTableLookup(t) {
    const [n, ie] = this.drainKeysFoundInLookupTable(t.state.addresses, (le) => !le.isSigner && !le.isInvoked && le.isWritable), [fe, ae] = this.drainKeysFoundInLookupTable(t.state.addresses, (le) => !le.isSigner && !le.isInvoked && !le.isWritable);
    if (!(n.length === 0 && fe.length === 0))
      return [{
        accountKey: t.key,
        writableIndexes: n,
        readonlyIndexes: fe
      }, {
        writable: ie,
        readonly: ae
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(t, n) {
    const ie = new Array(), fe = new Array();
    for (const [ae, le] of this.keyMetaMap.entries())
      if (n(le)) {
        const he = new PublicKey$1(ae), me = t.findIndex((ye) => ye.equals(he));
        me >= 0 && (assert$c(me < 256, "Max lookup table index exceeded"), ie.push(me), fe.push(he), this.keyMetaMap.delete(ae));
      }
    return [ie, fe];
  }
}, Message$1 = class ti {
  constructor(t) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = t.header, this.accountKeys = t.accountKeys.map((n) => new PublicKey$1(n)), this.recentBlockhash = t.recentBlockhash, this.instructions = t.instructions, this.instructions.forEach((n) => this.indexToProgramIds.set(n.programIdIndex, this.accountKeys[n.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((t) => ({
      programIdIndex: t.programIdIndex,
      accountKeyIndexes: t.accounts,
      data: o$1.decode(t.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new MessageAccountKeys$1(this.staticAccountKeys);
  }
  static compile(t) {
    const n = CompiledKeys$1.compile(t.instructions, t.payerKey), [ie, fe] = n.getMessageComponents(), le = new MessageAccountKeys$1(fe).compileInstructions(t.instructions).map((he) => ({
      programIdIndex: he.programIdIndex,
      accounts: he.accountKeyIndexes,
      data: o$1.encode(he.data)
    }));
    return new ti({
      header: ie,
      accountKeys: fe,
      recentBlockhash: t.recentBlockhash,
      instructions: le
    });
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const n = this.header.numRequiredSignatures;
    if (t >= this.header.numRequiredSignatures) {
      const ie = t - n, ae = this.accountKeys.length - n - this.header.numReadonlyUnsignedAccounts;
      return ie < ae;
    } else {
      const ie = n - this.header.numReadonlySignedAccounts;
      return t < ie;
    }
  }
  isProgramId(t) {
    return this.indexToProgramIds.has(t);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((t, n) => !this.isProgramId(n));
  }
  serialize() {
    const t = this.accountKeys.length;
    let n = [];
    encodeLength$1(n, t);
    const ie = this.instructions.map((Ae) => {
      const {
        accounts: Se,
        programIdIndex: $e
      } = Ae, Re = Array.from(o$1.decode(Ae.data));
      let Me = [];
      encodeLength$1(Me, Se.length);
      let ke = [];
      return encodeLength$1(ke, Re.length), {
        programIdIndex: $e,
        keyIndicesCount: Buffer$1$1.from(Me),
        keyIndices: Se,
        dataLength: Buffer$1$1.from(ke),
        data: Re
      };
    });
    let fe = [];
    encodeLength$1(fe, ie.length);
    let ae = Buffer$1$1.alloc(PACKET_DATA_SIZE$1);
    Buffer$1$1.from(fe).copy(ae);
    let le = fe.length;
    ie.forEach((Ae) => {
      const $e = struct$1([u8$1("programIdIndex"), blob$1(Ae.keyIndicesCount.length, "keyIndicesCount"), seq(u8$1("keyIndex"), Ae.keyIndices.length, "keyIndices"), blob$1(Ae.dataLength.length, "dataLength"), seq(u8$1("userdatum"), Ae.data.length, "data")]).encode(Ae, ae, le);
      le += $e;
    }), ae = ae.slice(0, le);
    const he = struct$1([blob$1(1, "numRequiredSignatures"), blob$1(1, "numReadonlySignedAccounts"), blob$1(1, "numReadonlyUnsignedAccounts"), blob$1(n.length, "keyCount"), seq(publicKey$2("key"), t, "keys"), publicKey$2("recentBlockhash")]), me = {
      numRequiredSignatures: Buffer$1$1.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: Buffer$1$1.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: Buffer$1$1.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: Buffer$1$1.from(n),
      keys: this.accountKeys.map((Ae) => toBuffer$2(Ae.toBytes())),
      recentBlockhash: o$1.decode(this.recentBlockhash)
    };
    let ye = Buffer$1$1.alloc(2048);
    const be = he.encode(me, ye);
    return ae.copy(ye, be), ye.slice(0, be + ae.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(t) {
    let n = [...t];
    const ie = n.shift();
    if (ie !== (ie & VERSION_PREFIX_MASK$1))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const fe = n.shift(), ae = n.shift(), le = decodeLength$1(n);
    let he = [];
    for (let Se = 0; Se < le; Se++) {
      const $e = n.slice(0, PUBLIC_KEY_LENGTH$1);
      n = n.slice(PUBLIC_KEY_LENGTH$1), he.push(new PublicKey$1(Buffer$1$1.from($e)));
    }
    const me = n.slice(0, PUBLIC_KEY_LENGTH$1);
    n = n.slice(PUBLIC_KEY_LENGTH$1);
    const ye = decodeLength$1(n);
    let be = [];
    for (let Se = 0; Se < ye; Se++) {
      const $e = n.shift(), Re = decodeLength$1(n), Me = n.slice(0, Re);
      n = n.slice(Re);
      const ke = decodeLength$1(n), Te = n.slice(0, ke), Ie = o$1.encode(Buffer$1$1.from(Te));
      n = n.slice(ke), be.push({
        programIdIndex: $e,
        accounts: Me,
        data: Ie
      });
    }
    const Ae = {
      header: {
        numRequiredSignatures: ie,
        numReadonlySignedAccounts: fe,
        numReadonlyUnsignedAccounts: ae
      },
      recentBlockhash: o$1.encode(Buffer$1$1.from(me)),
      accountKeys: he,
      instructions: be
    };
    return new ti(Ae);
  }
};
class MessageV0 {
  constructor(t) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = t.header, this.staticAccountKeys = t.staticAccountKeys, this.recentBlockhash = t.recentBlockhash, this.compiledInstructions = t.compiledInstructions, this.addressTableLookups = t.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let t = 0;
    for (const n of this.addressTableLookups)
      t += n.readonlyIndexes.length + n.writableIndexes.length;
    return t;
  }
  getAccountKeys(t) {
    let n;
    if (t && "accountKeysFromLookups" in t && t.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != t.accountKeysFromLookups.writable.length + t.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      n = t.accountKeysFromLookups;
    } else if (t && "addressLookupTableAccounts" in t && t.addressLookupTableAccounts)
      n = this.resolveAddressTableLookups(t.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new MessageAccountKeys$1(this.staticAccountKeys, n);
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const n = this.header.numRequiredSignatures, ie = this.staticAccountKeys.length;
    if (t >= ie) {
      const fe = t - ie, ae = this.addressTableLookups.reduce((le, he) => le + he.writableIndexes.length, 0);
      return fe < ae;
    } else if (t >= this.header.numRequiredSignatures) {
      const fe = t - n, le = ie - n - this.header.numReadonlyUnsignedAccounts;
      return fe < le;
    } else {
      const fe = n - this.header.numReadonlySignedAccounts;
      return t < fe;
    }
  }
  resolveAddressTableLookups(t) {
    const n = {
      writable: [],
      readonly: []
    };
    for (const ie of this.addressTableLookups) {
      const fe = t.find((ae) => ae.key.equals(ie.accountKey));
      if (!fe)
        throw new Error(`Failed to find address lookup table account for table key ${ie.accountKey.toBase58()}`);
      for (const ae of ie.writableIndexes)
        if (ae < fe.state.addresses.length)
          n.writable.push(fe.state.addresses[ae]);
        else
          throw new Error(`Failed to find address for index ${ae} in address lookup table ${ie.accountKey.toBase58()}`);
      for (const ae of ie.readonlyIndexes)
        if (ae < fe.state.addresses.length)
          n.readonly.push(fe.state.addresses[ae]);
        else
          throw new Error(`Failed to find address for index ${ae} in address lookup table ${ie.accountKey.toBase58()}`);
    }
    return n;
  }
  static compile(t) {
    const n = CompiledKeys$1.compile(t.instructions, t.payerKey), ie = new Array(), fe = {
      writable: new Array(),
      readonly: new Array()
    }, ae = t.addressLookupTableAccounts || [];
    for (const be of ae) {
      const Ae = n.extractTableLookup(be);
      if (Ae !== void 0) {
        const [Se, {
          writable: $e,
          readonly: Re
        }] = Ae;
        ie.push(Se), fe.writable.push(...$e), fe.readonly.push(...Re);
      }
    }
    const [le, he] = n.getMessageComponents(), ye = new MessageAccountKeys$1(he, fe).compileInstructions(t.instructions);
    return new MessageV0({
      header: le,
      staticAccountKeys: he,
      recentBlockhash: t.recentBlockhash,
      compiledInstructions: ye,
      addressTableLookups: ie
    });
  }
  serialize() {
    const t = Array();
    encodeLength$1(t, this.staticAccountKeys.length);
    const n = this.serializeInstructions(), ie = Array();
    encodeLength$1(ie, this.compiledInstructions.length);
    const fe = this.serializeAddressTableLookups(), ae = Array();
    encodeLength$1(ae, this.addressTableLookups.length);
    const le = struct$1([u8$1("prefix"), struct$1([u8$1("numRequiredSignatures"), u8$1("numReadonlySignedAccounts"), u8$1("numReadonlyUnsignedAccounts")], "header"), blob$1(t.length, "staticAccountKeysLength"), seq(publicKey$2(), this.staticAccountKeys.length, "staticAccountKeys"), publicKey$2("recentBlockhash"), blob$1(ie.length, "instructionsLength"), blob$1(n.length, "serializedInstructions"), blob$1(ae.length, "addressTableLookupsLength"), blob$1(fe.length, "serializedAddressTableLookups")]), he = new Uint8Array(PACKET_DATA_SIZE$1), ye = le.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(t),
      staticAccountKeys: this.staticAccountKeys.map((be) => be.toBytes()),
      recentBlockhash: o$1.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(ie),
      serializedInstructions: n,
      addressTableLookupsLength: new Uint8Array(ae),
      serializedAddressTableLookups: fe
    }, he);
    return he.slice(0, ye);
  }
  serializeInstructions() {
    let t = 0;
    const n = new Uint8Array(PACKET_DATA_SIZE$1);
    for (const ie of this.compiledInstructions) {
      const fe = Array();
      encodeLength$1(fe, ie.accountKeyIndexes.length);
      const ae = Array();
      encodeLength$1(ae, ie.data.length);
      const le = struct$1([u8$1("programIdIndex"), blob$1(fe.length, "encodedAccountKeyIndexesLength"), seq(u8$1(), ie.accountKeyIndexes.length, "accountKeyIndexes"), blob$1(ae.length, "encodedDataLength"), blob$1(ie.data.length, "data")]);
      t += le.encode({
        programIdIndex: ie.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(fe),
        accountKeyIndexes: ie.accountKeyIndexes,
        encodedDataLength: new Uint8Array(ae),
        data: ie.data
      }, n, t);
    }
    return n.slice(0, t);
  }
  serializeAddressTableLookups() {
    let t = 0;
    const n = new Uint8Array(PACKET_DATA_SIZE$1);
    for (const ie of this.addressTableLookups) {
      const fe = Array();
      encodeLength$1(fe, ie.writableIndexes.length);
      const ae = Array();
      encodeLength$1(ae, ie.readonlyIndexes.length);
      const le = struct$1([publicKey$2("accountKey"), blob$1(fe.length, "encodedWritableIndexesLength"), seq(u8$1(), ie.writableIndexes.length, "writableIndexes"), blob$1(ae.length, "encodedReadonlyIndexesLength"), seq(u8$1(), ie.readonlyIndexes.length, "readonlyIndexes")]);
      t += le.encode({
        accountKey: ie.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(fe),
        writableIndexes: ie.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(ae),
        readonlyIndexes: ie.readonlyIndexes
      }, n, t);
    }
    return n.slice(0, t);
  }
  static deserialize(t) {
    let n = [...t];
    const ie = n.shift(), fe = ie & VERSION_PREFIX_MASK$1;
    assert$c(ie !== fe, "Expected versioned message but received legacy message");
    const ae = fe;
    assert$c(ae === 0, `Expected versioned message with version 0 but found version ${ae}`);
    const le = {
      numRequiredSignatures: n.shift(),
      numReadonlySignedAccounts: n.shift(),
      numReadonlyUnsignedAccounts: n.shift()
    }, he = [], me = decodeLength$1(n);
    for (let Re = 0; Re < me; Re++)
      he.push(new PublicKey$1(n.splice(0, PUBLIC_KEY_LENGTH$1)));
    const ye = o$1.encode(n.splice(0, PUBLIC_KEY_LENGTH$1)), be = decodeLength$1(n), Ae = [];
    for (let Re = 0; Re < be; Re++) {
      const Me = n.shift(), ke = decodeLength$1(n), Te = n.splice(0, ke), Ie = decodeLength$1(n), qe = new Uint8Array(n.splice(0, Ie));
      Ae.push({
        programIdIndex: Me,
        accountKeyIndexes: Te,
        data: qe
      });
    }
    const Se = decodeLength$1(n), $e = [];
    for (let Re = 0; Re < Se; Re++) {
      const Me = new PublicKey$1(n.splice(0, PUBLIC_KEY_LENGTH$1)), ke = decodeLength$1(n), Te = n.splice(0, ke), Ie = decodeLength$1(n), qe = n.splice(0, Ie);
      $e.push({
        accountKey: Me,
        writableIndexes: Te,
        readonlyIndexes: qe
      });
    }
    return new MessageV0({
      header: le,
      staticAccountKeys: he,
      recentBlockhash: ye,
      compiledInstructions: Ae,
      addressTableLookups: $e
    });
  }
}
let TransactionStatus = /* @__PURE__ */ function(c) {
  return c[c.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", c[c.PROCESSED = 1] = "PROCESSED", c[c.TIMED_OUT = 2] = "TIMED_OUT", c[c.NONCE_INVALID = 3] = "NONCE_INVALID", c;
}({});
const DEFAULT_SIGNATURE$1 = Buffer$1$1.alloc(SIGNATURE_LENGTH_IN_BYTES$1).fill(0);
let TransactionInstruction$1 = class {
  constructor(t) {
    this.keys = void 0, this.programId = void 0, this.data = Buffer$1$1.alloc(0), this.programId = t.programId, this.keys = t.keys, t.data && (this.data = t.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: t,
        isSigner: n,
        isWritable: ie
      }) => ({
        pubkey: t.toJSON(),
        isSigner: n,
        isWritable: ie
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}, Transaction$1 = class ri {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(t) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!t)
      if (t.feePayer && (this.feePayer = t.feePayer), t.signatures && (this.signatures = t.signatures), Object.prototype.hasOwnProperty.call(t, "nonceInfo")) {
        const {
          minContextSlot: n,
          nonceInfo: ie
        } = t;
        this.minNonceContextSlot = n, this.nonceInfo = ie;
      } else if (Object.prototype.hasOwnProperty.call(t, "lastValidBlockHeight")) {
        const {
          blockhash: n,
          lastValidBlockHeight: ie
        } = t;
        this.recentBlockhash = n, this.lastValidBlockHeight = ie;
      } else {
        const {
          recentBlockhash: n,
          nonceInfo: ie
        } = t;
        ie && (this.nonceInfo = ie), this.recentBlockhash = n;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((t) => t.toJSON()),
      signers: this.signatures.map(({
        publicKey: t
      }) => t.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...t) {
    if (t.length === 0)
      throw new Error("No instructions");
    return t.forEach((n) => {
      "instructions" in n ? this.instructions = this.instructions.concat(n.instructions) : "data" in n && "programId" in n && "keys" in n ? this.instructions.push(n) : this.instructions.push(new TransactionInstruction$1(n));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let t, n;
    if (this.nonceInfo ? (t = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? n = [this.nonceInfo.nonceInstruction, ...this.instructions] : n = this.instructions) : (t = this.recentBlockhash, n = this.instructions), !t)
      throw new Error("Transaction recentBlockhash required");
    n.length < 1 && console.warn("No instructions provided");
    let ie;
    if (this.feePayer)
      ie = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      ie = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let Me = 0; Me < n.length; Me++)
      if (n[Me].programId === void 0)
        throw new Error(`Transaction instruction index ${Me} has undefined program id`);
    const fe = [], ae = [];
    n.forEach((Me) => {
      Me.keys.forEach((Te) => {
        ae.push({
          ...Te
        });
      });
      const ke = Me.programId.toString();
      fe.includes(ke) || fe.push(ke);
    }), fe.forEach((Me) => {
      ae.push({
        pubkey: new PublicKey$1(Me),
        isSigner: !1,
        isWritable: !1
      });
    });
    const le = [];
    ae.forEach((Me) => {
      const ke = Me.pubkey.toString(), Te = le.findIndex((Ie) => Ie.pubkey.toString() === ke);
      Te > -1 ? (le[Te].isWritable = le[Te].isWritable || Me.isWritable, le[Te].isSigner = le[Te].isSigner || Me.isSigner) : le.push(Me);
    }), le.sort(function(Me, ke) {
      if (Me.isSigner !== ke.isSigner)
        return Me.isSigner ? -1 : 1;
      if (Me.isWritable !== ke.isWritable)
        return Me.isWritable ? -1 : 1;
      const Te = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return Me.pubkey.toBase58().localeCompare(ke.pubkey.toBase58(), "en", Te);
    });
    const he = le.findIndex((Me) => Me.pubkey.equals(ie));
    if (he > -1) {
      const [Me] = le.splice(he, 1);
      Me.isSigner = !0, Me.isWritable = !0, le.unshift(Me);
    } else
      le.unshift({
        pubkey: ie,
        isSigner: !0,
        isWritable: !0
      });
    for (const Me of this.signatures) {
      const ke = le.findIndex((Te) => Te.pubkey.equals(Me.publicKey));
      if (ke > -1)
        le[ke].isSigner || (le[ke].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${Me.publicKey.toString()}`);
    }
    let me = 0, ye = 0, be = 0;
    const Ae = [], Se = [];
    le.forEach(({
      pubkey: Me,
      isSigner: ke,
      isWritable: Te
    }) => {
      ke ? (Ae.push(Me.toString()), me += 1, Te || (ye += 1)) : (Se.push(Me.toString()), Te || (be += 1));
    });
    const $e = Ae.concat(Se), Re = n.map((Me) => {
      const {
        data: ke,
        programId: Te
      } = Me;
      return {
        programIdIndex: $e.indexOf(Te.toString()),
        accounts: Me.keys.map((Ie) => $e.indexOf(Ie.pubkey.toString())),
        data: o$1.encode(ke)
      };
    });
    return Re.forEach((Me) => {
      assert$c(Me.programIdIndex >= 0), Me.accounts.forEach((ke) => assert$c(ke >= 0));
    }), new Message$1({
      header: {
        numRequiredSignatures: me,
        numReadonlySignedAccounts: ye,
        numReadonlyUnsignedAccounts: be
      },
      accountKeys: $e,
      recentBlockhash: t,
      instructions: Re
    });
  }
  /**
   * @internal
   */
  _compile() {
    const t = this.compileMessage(), n = t.accountKeys.slice(0, t.header.numRequiredSignatures);
    return this.signatures.length === n.length && this.signatures.every((fe, ae) => n[ae].equals(fe.publicKey)) || (this.signatures = n.map((ie) => ({
      signature: null,
      publicKey: ie
    }))), t;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(t) {
    return (await t.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set();
    this.signatures = t.filter((ie) => {
      const fe = ie.toString();
      return n.has(fe) ? !1 : (n.add(fe), !0);
    }).map((ie) => ({
      signature: null,
      publicKey: ie
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), ie = [];
    for (const ae of t) {
      const le = ae.publicKey.toString();
      n.has(le) || (n.add(le), ie.push(ae));
    }
    this.signatures = ie.map((ae) => ({
      signature: null,
      publicKey: ae.publicKey
    }));
    const fe = this._compile();
    this._partialSign(fe, ...ie);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), ie = [];
    for (const ae of t) {
      const le = ae.publicKey.toString();
      n.has(le) || (n.add(le), ie.push(ae));
    }
    const fe = this._compile();
    this._partialSign(fe, ...ie);
  }
  /**
   * @internal
   */
  _partialSign(t, ...n) {
    const ie = t.serialize();
    n.forEach((fe) => {
      const ae = sign$2(ie, fe.secretKey);
      this._addSignature(fe.publicKey, toBuffer$2(ae));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(t, n) {
    this._compile(), this._addSignature(t, n);
  }
  /**
   * @internal
   */
  _addSignature(t, n) {
    assert$c(n.length === 64);
    const ie = this.signatures.findIndex((fe) => t.equals(fe.publicKey));
    if (ie < 0)
      throw new Error(`unknown signer: ${t.toString()}`);
    this.signatures[ie].signature = Buffer$1$1.from(n);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(t = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), t);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(t, n) {
    const ie = {};
    for (const {
      signature: fe,
      publicKey: ae
    } of this.signatures)
      fe === null ? n && (ie.missing || (ie.missing = [])).push(ae) : verify$2(fe, t, ae.toBytes()) || (ie.invalid || (ie.invalid = [])).push(ae);
    return ie.invalid || ie.missing ? ie : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(t) {
    const {
      requireAllSignatures: n,
      verifySignatures: ie
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, t), fe = this.serializeMessage();
    if (ie) {
      const ae = this._getMessageSignednessErrors(fe, n);
      if (ae) {
        let le = "Signature verification failed.";
        throw ae.invalid && (le += `
Invalid signature for public key${ae.invalid.length === 1 ? "" : "(s)"} [\`${ae.invalid.map((he) => he.toBase58()).join("`, `")}\`].`), ae.missing && (le += `
Missing signature for public key${ae.missing.length === 1 ? "" : "(s)"} [\`${ae.missing.map((he) => he.toBase58()).join("`, `")}\`].`), new Error(le);
      }
    }
    return this._serialize(fe);
  }
  /**
   * @internal
   */
  _serialize(t) {
    const {
      signatures: n
    } = this, ie = [];
    encodeLength$1(ie, n.length);
    const fe = ie.length + n.length * 64 + t.length, ae = Buffer$1$1.alloc(fe);
    return assert$c(n.length < 256), Buffer$1$1.from(ie).copy(ae, 0), n.forEach(({
      signature: le
    }, he) => {
      le !== null && (assert$c(le.length === 64, "signature has invalid length"), Buffer$1$1.from(le).copy(ae, ie.length + he * 64));
    }), t.copy(ae, ie.length + n.length * 64), assert$c(ae.length <= PACKET_DATA_SIZE$1, `Transaction too large: ${ae.length} > ${PACKET_DATA_SIZE$1}`), ae;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return assert$c(this.instructions.length === 1), this.instructions[0].keys.map((t) => t.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return assert$c(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return assert$c(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(t) {
    let n = [...t];
    const ie = decodeLength$1(n);
    let fe = [];
    for (let ae = 0; ae < ie; ae++) {
      const le = n.slice(0, SIGNATURE_LENGTH_IN_BYTES$1);
      n = n.slice(SIGNATURE_LENGTH_IN_BYTES$1), fe.push(o$1.encode(Buffer$1$1.from(le)));
    }
    return ri.populate(Message$1.from(n), fe);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(t, n = []) {
    const ie = new ri();
    return ie.recentBlockhash = t.recentBlockhash, t.header.numRequiredSignatures > 0 && (ie.feePayer = t.accountKeys[0]), n.forEach((fe, ae) => {
      const le = {
        signature: fe == o$1.encode(DEFAULT_SIGNATURE$1) ? null : o$1.decode(fe),
        publicKey: t.accountKeys[ae]
      };
      ie.signatures.push(le);
    }), t.instructions.forEach((fe) => {
      const ae = fe.accounts.map((le) => {
        const he = t.accountKeys[le];
        return {
          pubkey: he,
          isSigner: ie.signatures.some((me) => me.publicKey.toString() === he.toString()) || t.isAccountSigner(le),
          isWritable: t.isAccountWritable(le)
        };
      });
      ie.instructions.push(new TransactionInstruction$1({
        keys: ae,
        programId: t.accountKeys[fe.programIdIndex],
        data: o$1.decode(fe.data)
      }));
    }), ie._message = t, ie._json = ie.toJSON(), ie;
  }
};
const NUM_TICKS_PER_SECOND = 160, DEFAULT_TICKS_PER_SLOT = 64, NUM_SLOTS_PER_SECOND = NUM_TICKS_PER_SECOND / DEFAULT_TICKS_PER_SLOT, MS_PER_SLOT = 1e3 / NUM_SLOTS_PER_SECOND;
new PublicKey$1("SysvarC1ock11111111111111111111111111111111");
new PublicKey$1("SysvarEpochSchedu1e111111111111111111111111");
new PublicKey$1("Sysvar1nstructions1111111111111111111111111");
new PublicKey$1("SysvarRecentB1ockHashes11111111111111111111");
new PublicKey$1("SysvarRent111111111111111111111111111111111");
new PublicKey$1("SysvarRewards111111111111111111111111111111");
new PublicKey$1("SysvarS1otHashes111111111111111111111111111");
new PublicKey$1("SysvarS1otHistory11111111111111111111111111");
new PublicKey$1("SysvarStakeHistory1111111111111111111111111");
function sleep(c) {
  return new Promise((t) => setTimeout(t, c));
}
const FeeCalculatorLayout$1 = nu64("lamportsPerSignature"), NonceAccountLayout$1 = struct$1([u32$1("version"), u32$1("state"), publicKey$2("authorizedPubkey"), publicKey$2("nonce"), struct$1([FeeCalculatorLayout$1], "feeCalculator")]);
NonceAccountLayout$1.span;
class NonceAccount {
  /**
   * @internal
   */
  constructor(t) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = t.authorizedPubkey, this.nonce = t.nonce, this.feeCalculator = t.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(t) {
    const n = NonceAccountLayout$1.decode(toBuffer$2(t), 0);
    return new NonceAccount({
      authorizedPubkey: new PublicKey$1(n.authorizedPubkey),
      nonce: new PublicKey$1(n.nonce).toString(),
      feeCalculator: n.feeCalculator
    });
  }
}
const encodeDecode$1 = (c) => {
  const t = c.decode.bind(c), n = c.encode.bind(c);
  return {
    decode: t,
    encode: n
  };
}, bigInt$1 = (c) => (t) => {
  const n = blob$1(c, t), {
    encode: ie,
    decode: fe
  } = encodeDecode$1(n), ae = n;
  return ae.decode = (le, he) => {
    const me = fe(le, he);
    return toBigIntLE_1(Buffer$1$1.from(me));
  }, ae.encode = (le, he, me) => {
    const ye = toBufferLE_1(le, c);
    return ie(ye, he, me);
  }, ae;
}, u64$2 = bigInt$1(8);
Object.freeze({
  Create: {
    index: 0,
    layout: struct$1([u32$1("instruction"), ns64("lamports"), ns64("space"), publicKey$2("programId")])
  },
  Assign: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$2("programId")])
  },
  Transfer: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$2("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: struct$1([u32$1("instruction"), publicKey$2("base"), rustString$1("seed"), ns64("lamports"), ns64("space"), publicKey$2("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: struct$1([u32$1("instruction"), publicKey$2("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: struct$1([u32$1("instruction"), publicKey$2("authorized")])
  },
  Allocate: {
    index: 8,
    layout: struct$1([u32$1("instruction"), ns64("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: struct$1([u32$1("instruction"), publicKey$2("base"), rustString$1("seed"), ns64("space"), publicKey$2("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), publicKey$2("base"), rustString$1("seed"), publicKey$2("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: struct$1([u32$1("instruction"), u64$2("lamports"), rustString$1("seed"), publicKey$2("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: struct$1([u32$1("instruction")])
  }
});
new PublicKey$1("11111111111111111111111111111111");
new PublicKey$1("BPFLoader2111111111111111111111111111111111");
function getDefaultExportFromCjs(c) {
  return c && c.__esModule && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c;
}
var objToString = Object.prototype.toString, objKeys = Object.keys || function(c) {
  var t = [];
  for (var n in c)
    t.push(n);
  return t;
};
function stringify(c, t) {
  var n, ie, fe, ae, le, he, me;
  if (c === !0)
    return "true";
  if (c === !1)
    return "false";
  switch (typeof c) {
    case "object":
      if (c === null)
        return null;
      if (c.toJSON && typeof c.toJSON == "function")
        return stringify(c.toJSON(), t);
      if (me = objToString.call(c), me === "[object Array]") {
        for (fe = "[", ie = c.length - 1, n = 0; n < ie; n++)
          fe += stringify(c[n], !0) + ",";
        return ie > -1 && (fe += stringify(c[n], !0)), fe + "]";
      } else if (me === "[object Object]") {
        for (ae = objKeys(c).sort(), ie = ae.length, fe = "", n = 0; n < ie; )
          le = ae[n], he = stringify(c[le], !1), he !== void 0 && (fe && (fe += ","), fe += JSON.stringify(le) + ":" + he), n++;
        return "{" + fe + "}";
      } else
        return JSON.stringify(c);
    case "function":
    case "undefined":
      return t ? null : void 0;
    case "string":
      return JSON.stringify(c);
    default:
      return isFinite(c) ? c : null;
  }
}
var fastStableStringify = function(c) {
  var t = stringify(c, !1);
  if (t !== void 0)
    return "" + t;
}, fastStableStringify$1 = /* @__PURE__ */ getDefaultExportFromCjs(fastStableStringify);
const MINIMUM_SLOT_PER_EPOCH = 32;
function trailingZeros(c) {
  let t = 0;
  for (; c > 1; )
    c /= 2, t++;
  return t;
}
function nextPowerOfTwo(c) {
  return c === 0 ? 1 : (c--, c |= c >> 1, c |= c >> 2, c |= c >> 4, c |= c >> 8, c |= c >> 16, c |= c >> 32, c + 1);
}
class EpochSchedule {
  constructor(t, n, ie, fe, ae) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = t, this.leaderScheduleSlotOffset = n, this.warmup = ie, this.firstNormalEpoch = fe, this.firstNormalSlot = ae;
  }
  getEpoch(t) {
    return this.getEpochAndSlotIndex(t)[0];
  }
  getEpochAndSlotIndex(t) {
    if (t < this.firstNormalSlot) {
      const n = trailingZeros(nextPowerOfTwo(t + MINIMUM_SLOT_PER_EPOCH + 1)) - trailingZeros(MINIMUM_SLOT_PER_EPOCH) - 1, ie = this.getSlotsInEpoch(n), fe = t - (ie - MINIMUM_SLOT_PER_EPOCH);
      return [n, fe];
    } else {
      const n = t - this.firstNormalSlot, ie = Math.floor(n / this.slotsPerEpoch), fe = this.firstNormalEpoch + ie, ae = n % this.slotsPerEpoch;
      return [fe, ae];
    }
  }
  getFirstSlotInEpoch(t) {
    return t <= this.firstNormalEpoch ? (Math.pow(2, t) - 1) * MINIMUM_SLOT_PER_EPOCH : (t - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(t) {
    return this.getFirstSlotInEpoch(t) + this.getSlotsInEpoch(t) - 1;
  }
  getSlotsInEpoch(t) {
    return t < this.firstNormalEpoch ? Math.pow(2, t + trailingZeros(MINIMUM_SLOT_PER_EPOCH)) : this.slotsPerEpoch;
  }
}
let SendTransactionError$1 = class extends Error {
  constructor(t, n) {
    super(t), this.logs = void 0, this.logs = n;
  }
};
class SolanaJSONRPCError extends Error {
  constructor({
    code: t,
    message: n,
    data: ie
  }, fe) {
    super(fe != null ? `${fe}: ${n}` : n), this.code = void 0, this.data = void 0, this.code = t, this.data = ie, this.name = "SolanaJSONRPCError";
  }
}
var fetchImpl = globalThis.fetch;
class RpcWebSocketClient extends _default$1 {
  constructor(t, n, ie) {
    const fe = (ae) => {
      const le = _default(ae, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...n
      });
      return "socket" in le ? this.underlyingSocket = le.socket : this.underlyingSocket = le, le;
    };
    super(fe, t, n, ie), this.underlyingSocket = void 0;
  }
  call(...t) {
    var ie;
    const n = (ie = this.underlyingSocket) == null ? void 0 : ie.readyState;
    return n === 1 ? super.call(...t) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + n + ")"));
  }
  notify(...t) {
    var ie;
    const n = (ie = this.underlyingSocket) == null ? void 0 : ie.readyState;
    return n === 1 ? super.notify(...t) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + n + ")"));
  }
}
function decodeData(c, t) {
  let n;
  try {
    n = c.layout.decode(t);
  } catch (ie) {
    throw new Error("invalid instruction; " + ie);
  }
  if (n.typeIndex !== c.index)
    throw new Error(`invalid account data; account type mismatch ${n.typeIndex} != ${c.index}`);
  return n;
}
const LOOKUP_TABLE_META_SIZE = 56;
class AddressLookupTableAccount {
  constructor(t) {
    this.key = void 0, this.state = void 0, this.key = t.key, this.state = t.state;
  }
  isActive() {
    const t = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === t;
  }
  static deserialize(t) {
    const n = decodeData(LookupTableMetaLayout, t), ie = t.length - LOOKUP_TABLE_META_SIZE;
    assert$c(ie >= 0, "lookup table is invalid"), assert$c(ie % 32 === 0, "lookup table is invalid");
    const fe = ie / 32, {
      addresses: ae
    } = struct$1([seq(publicKey$2(), fe, "addresses")]).decode(t.slice(LOOKUP_TABLE_META_SIZE));
    return {
      deactivationSlot: n.deactivationSlot,
      lastExtendedSlot: n.lastExtendedSlot,
      lastExtendedSlotStartIndex: n.lastExtendedStartIndex,
      authority: n.authority.length !== 0 ? new PublicKey$1(n.authority[0]) : void 0,
      addresses: ae.map((le) => new PublicKey$1(le))
    };
  }
}
const LookupTableMetaLayout = {
  index: 1,
  layout: struct$1([
    u32$1("typeIndex"),
    u64$2("deactivationSlot"),
    nu64("lastExtendedSlot"),
    u8$1("lastExtendedStartIndex"),
    u8$1(),
    // option
    seq(publicKey$2(), offset(u8$1(), -1), "authority")
  ])
}, URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function makeWebsocketUrl(c) {
  const t = c.match(URL_RE);
  if (t == null)
    throw TypeError(`Failed to validate endpoint URL \`${c}\``);
  const [
    n,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    ie,
    fe,
    ae
  ] = t, le = c.startsWith("https:") ? "wss:" : "ws:", he = fe == null ? null : parseInt(fe.slice(1), 10), me = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    he == null ? "" : `:${he + 1}`
  );
  return `${le}//${ie}${me}${ae}`;
}
const PublicKeyFromString$1 = coerce$1(instance$1(PublicKey$1), string$1(), (c) => new PublicKey$1(c)), RawAccountDataResult$1 = tuple$1([string$1(), literal$1("base64")]), BufferFromRawAccountData$1 = coerce$1(instance$1(Buffer$1$1), RawAccountDataResult$1, (c) => Buffer$1$1.from(c[0], "base64")), BLOCKHASH_CACHE_TIMEOUT_MS = 30 * 1e3;
function assertEndpointUrl(c) {
  if (/^https?:/.test(c) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return c;
}
function extractCommitmentFromConfig(c) {
  let t, n;
  if (typeof c == "string")
    t = c;
  else if (c) {
    const {
      commitment: ie,
      ...fe
    } = c;
    t = ie, n = fe;
  }
  return {
    commitment: t,
    config: n
  };
}
function createRpcResult$1(c) {
  return union$1([type$2({
    jsonrpc: literal$1("2.0"),
    id: string$1(),
    result: c
  }), type$2({
    jsonrpc: literal$1("2.0"),
    id: string$1(),
    error: type$2({
      code: unknown$1(),
      message: string$1(),
      data: optional$1(any$1())
    })
  })]);
}
const UnknownRpcResult$1 = createRpcResult$1(unknown$1());
function jsonRpcResult$1(c) {
  return coerce$1(createRpcResult$1(c), UnknownRpcResult$1, (t) => "error" in t ? t : {
    ...t,
    result: create$1(t.result, c)
  });
}
function jsonRpcResultAndContext$1(c) {
  return jsonRpcResult$1(type$2({
    context: type$2({
      slot: number$1()
    }),
    value: c
  }));
}
function notificationResultAndContext$1(c) {
  return type$2({
    context: type$2({
      slot: number$1()
    }),
    value: c
  });
}
function versionedMessageFromResponse(c, t) {
  return c === 0 ? new MessageV0({
    header: t.header,
    staticAccountKeys: t.accountKeys.map((n) => new PublicKey$1(n)),
    recentBlockhash: t.recentBlockhash,
    compiledInstructions: t.instructions.map((n) => ({
      programIdIndex: n.programIdIndex,
      accountKeyIndexes: n.accounts,
      data: o$1.decode(n.data)
    })),
    addressTableLookups: t.addressTableLookups
  }) : new Message$1(t);
}
const GetInflationGovernorResult$1 = type$2({
  foundation: number$1(),
  foundationTerm: number$1(),
  initial: number$1(),
  taper: number$1(),
  terminal: number$1()
}), GetInflationRewardResult = jsonRpcResult$1(array$1(nullable$1(type$2({
  epoch: number$1(),
  effectiveSlot: number$1(),
  amount: number$1(),
  postBalance: number$1(),
  commission: optional$1(nullable$1(number$1()))
})))), GetRecentPrioritizationFeesResult$1 = array$1(type$2({
  slot: number$1(),
  prioritizationFee: number$1()
})), GetInflationRateResult$1 = type$2({
  total: number$1(),
  validator: number$1(),
  foundation: number$1(),
  epoch: number$1()
}), GetEpochInfoResult$1 = type$2({
  epoch: number$1(),
  slotIndex: number$1(),
  slotsInEpoch: number$1(),
  absoluteSlot: number$1(),
  blockHeight: optional$1(number$1()),
  transactionCount: optional$1(number$1())
}), GetEpochScheduleResult$1 = type$2({
  slotsPerEpoch: number$1(),
  leaderScheduleSlotOffset: number$1(),
  warmup: boolean$1(),
  firstNormalEpoch: number$1(),
  firstNormalSlot: number$1()
}), GetLeaderScheduleResult$1 = record$1(string$1(), array$1(number$1())), TransactionErrorResult$1 = nullable$1(union$1([type$2({}), string$1()])), SignatureStatusResult$1 = type$2({
  err: TransactionErrorResult$1
}), SignatureReceivedResult$1 = literal$1("receivedSignature"), VersionResult = type$2({
  "solana-core": string$1(),
  "feature-set": optional$1(number$1())
}), SimulatedTransactionResponseStruct = jsonRpcResultAndContext$1(type$2({
  err: nullable$1(union$1([type$2({}), string$1()])),
  logs: nullable$1(array$1(string$1())),
  accounts: optional$1(nullable$1(array$1(nullable$1(type$2({
    executable: boolean$1(),
    owner: string$1(),
    lamports: number$1(),
    data: array$1(string$1()),
    rentEpoch: optional$1(number$1())
  }))))),
  unitsConsumed: optional$1(number$1()),
  returnData: optional$1(nullable$1(type$2({
    programId: string$1(),
    data: tuple$1([string$1(), literal$1("base64")])
  })))
})), BlockProductionResponseStruct = jsonRpcResultAndContext$1(type$2({
  byIdentity: record$1(string$1(), array$1(number$1())),
  range: type$2({
    firstSlot: number$1(),
    lastSlot: number$1()
  })
}));
function createRpcClient(c, t, n, ie, fe, ae) {
  const le = n || fetchImpl;
  let he;
  ae != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let me;
  return ie && (me = async (be, Ae) => {
    const Se = await new Promise(($e, Re) => {
      try {
        ie(be, Ae, (Me, ke) => $e([Me, ke]));
      } catch (Me) {
        Re(Me);
      }
    });
    return await le(...Se);
  }), new RpcClient(async (be, Ae) => {
    const Se = {
      method: "POST",
      body: be,
      agent: he,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, t || {}, COMMON_HTTP_HEADERS)
    };
    try {
      let $e = 5, Re, Me = 500;
      for (; me ? Re = await me(c, Se) : Re = await le(c, Se), !(Re.status !== 429 || fe === !0 || ($e -= 1, $e === 0)); )
        console.log(`Server responded with ${Re.status} ${Re.statusText}.  Retrying after ${Me}ms delay...`), await sleep(Me), Me *= 2;
      const ke = await Re.text();
      Re.ok ? Ae(null, ke) : Ae(new Error(`${Re.status} ${Re.statusText}: ${ke}`));
    } catch ($e) {
      $e instanceof Error && Ae($e);
    }
  }, {});
}
function createRpcRequest(c) {
  return (t, n) => new Promise((ie, fe) => {
    c.request(t, n, (ae, le) => {
      if (ae) {
        fe(ae);
        return;
      }
      ie(le);
    });
  });
}
function createRpcBatchRequest(c) {
  return (t) => new Promise((n, ie) => {
    t.length === 0 && n([]);
    const fe = t.map((ae) => c.request(ae.methodName, ae.args));
    c.request(fe, (ae, le) => {
      if (ae) {
        ie(ae);
        return;
      }
      n(le);
    });
  });
}
const GetInflationGovernorRpcResult = jsonRpcResult$1(GetInflationGovernorResult$1), GetInflationRateRpcResult = jsonRpcResult$1(GetInflationRateResult$1), GetRecentPrioritizationFeesRpcResult = jsonRpcResult$1(GetRecentPrioritizationFeesResult$1), GetEpochInfoRpcResult = jsonRpcResult$1(GetEpochInfoResult$1), GetEpochScheduleRpcResult = jsonRpcResult$1(GetEpochScheduleResult$1), GetLeaderScheduleRpcResult = jsonRpcResult$1(GetLeaderScheduleResult$1), SlotRpcResult = jsonRpcResult$1(number$1()), GetSupplyRpcResult = jsonRpcResultAndContext$1(type$2({
  total: number$1(),
  circulating: number$1(),
  nonCirculating: number$1(),
  nonCirculatingAccounts: array$1(PublicKeyFromString$1)
})), TokenAmountResult$1 = type$2({
  amount: string$1(),
  uiAmount: nullable$1(number$1()),
  decimals: number$1(),
  uiAmountString: optional$1(string$1())
}), GetTokenLargestAccountsResult = jsonRpcResultAndContext$1(array$1(type$2({
  address: PublicKeyFromString$1,
  amount: string$1(),
  uiAmount: nullable$1(number$1()),
  decimals: number$1(),
  uiAmountString: optional$1(string$1())
}))), GetTokenAccountsByOwner = jsonRpcResultAndContext$1(array$1(type$2({
  pubkey: PublicKeyFromString$1,
  account: type$2({
    executable: boolean$1(),
    owner: PublicKeyFromString$1,
    lamports: number$1(),
    data: BufferFromRawAccountData$1,
    rentEpoch: number$1()
  })
}))), ParsedAccountDataResult$1 = type$2({
  program: string$1(),
  parsed: unknown$1(),
  space: number$1()
}), GetParsedTokenAccountsByOwner = jsonRpcResultAndContext$1(array$1(type$2({
  pubkey: PublicKeyFromString$1,
  account: type$2({
    executable: boolean$1(),
    owner: PublicKeyFromString$1,
    lamports: number$1(),
    data: ParsedAccountDataResult$1,
    rentEpoch: number$1()
  })
}))), GetLargestAccountsRpcResult = jsonRpcResultAndContext$1(array$1(type$2({
  lamports: number$1(),
  address: PublicKeyFromString$1
}))), AccountInfoResult$1 = type$2({
  executable: boolean$1(),
  owner: PublicKeyFromString$1,
  lamports: number$1(),
  data: BufferFromRawAccountData$1,
  rentEpoch: number$1()
}), KeyedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString$1,
  account: AccountInfoResult$1
}), ParsedOrRawAccountData$1 = coerce$1(union$1([instance$1(Buffer$1$1), ParsedAccountDataResult$1]), union$1([RawAccountDataResult$1, ParsedAccountDataResult$1]), (c) => Array.isArray(c) ? create$1(c, BufferFromRawAccountData$1) : c), ParsedAccountInfoResult$1 = type$2({
  executable: boolean$1(),
  owner: PublicKeyFromString$1,
  lamports: number$1(),
  data: ParsedOrRawAccountData$1,
  rentEpoch: number$1()
}), KeyedParsedAccountInfoResult = type$2({
  pubkey: PublicKeyFromString$1,
  account: ParsedAccountInfoResult$1
}), StakeActivationResult = type$2({
  state: union$1([literal$1("active"), literal$1("inactive"), literal$1("activating"), literal$1("deactivating")]),
  active: number$1(),
  inactive: number$1()
}), GetConfirmedSignaturesForAddress2RpcResult = jsonRpcResult$1(array$1(type$2({
  signature: string$1(),
  slot: number$1(),
  err: TransactionErrorResult$1,
  memo: nullable$1(string$1()),
  blockTime: optional$1(nullable$1(number$1()))
}))), GetSignaturesForAddressRpcResult = jsonRpcResult$1(array$1(type$2({
  signature: string$1(),
  slot: number$1(),
  err: TransactionErrorResult$1,
  memo: nullable$1(string$1()),
  blockTime: optional$1(nullable$1(number$1()))
}))), AccountNotificationResult = type$2({
  subscription: number$1(),
  result: notificationResultAndContext$1(AccountInfoResult$1)
}), ProgramAccountInfoResult$1 = type$2({
  pubkey: PublicKeyFromString$1,
  account: AccountInfoResult$1
}), ProgramAccountNotificationResult = type$2({
  subscription: number$1(),
  result: notificationResultAndContext$1(ProgramAccountInfoResult$1)
}), SlotInfoResult$1 = type$2({
  parent: number$1(),
  slot: number$1(),
  root: number$1()
}), SlotNotificationResult = type$2({
  subscription: number$1(),
  result: SlotInfoResult$1
}), SlotUpdateResult$1 = union$1([type$2({
  type: union$1([literal$1("firstShredReceived"), literal$1("completed"), literal$1("optimisticConfirmation"), literal$1("root")]),
  slot: number$1(),
  timestamp: number$1()
}), type$2({
  type: literal$1("createdBank"),
  parent: number$1(),
  slot: number$1(),
  timestamp: number$1()
}), type$2({
  type: literal$1("frozen"),
  slot: number$1(),
  timestamp: number$1(),
  stats: type$2({
    numTransactionEntries: number$1(),
    numSuccessfulTransactions: number$1(),
    numFailedTransactions: number$1(),
    maxTransactionsPerEntry: number$1()
  })
}), type$2({
  type: literal$1("dead"),
  slot: number$1(),
  timestamp: number$1(),
  err: string$1()
})]), SlotUpdateNotificationResult = type$2({
  subscription: number$1(),
  result: SlotUpdateResult$1
}), SignatureNotificationResult = type$2({
  subscription: number$1(),
  result: notificationResultAndContext$1(union$1([SignatureStatusResult$1, SignatureReceivedResult$1]))
}), RootNotificationResult = type$2({
  subscription: number$1(),
  result: number$1()
}), ContactInfoResult = type$2({
  pubkey: string$1(),
  gossip: nullable$1(string$1()),
  tpu: nullable$1(string$1()),
  rpc: nullable$1(string$1()),
  version: nullable$1(string$1())
}), VoteAccountInfoResult$1 = type$2({
  votePubkey: string$1(),
  nodePubkey: string$1(),
  activatedStake: number$1(),
  epochVoteAccount: boolean$1(),
  epochCredits: array$1(tuple$1([number$1(), number$1(), number$1()])),
  commission: number$1(),
  lastVote: number$1(),
  rootSlot: nullable$1(number$1())
}), GetVoteAccounts = jsonRpcResult$1(type$2({
  current: array$1(VoteAccountInfoResult$1),
  delinquent: array$1(VoteAccountInfoResult$1)
})), ConfirmationStatus$1 = union$1([literal$1("processed"), literal$1("confirmed"), literal$1("finalized")]), SignatureStatusResponse$1 = type$2({
  slot: number$1(),
  confirmations: nullable$1(number$1()),
  err: TransactionErrorResult$1,
  confirmationStatus: optional$1(ConfirmationStatus$1)
}), GetSignatureStatusesRpcResult = jsonRpcResultAndContext$1(array$1(nullable$1(SignatureStatusResponse$1))), GetMinimumBalanceForRentExemptionRpcResult = jsonRpcResult$1(number$1()), AddressTableLookupStruct$1 = type$2({
  accountKey: PublicKeyFromString$1,
  writableIndexes: array$1(number$1()),
  readonlyIndexes: array$1(number$1())
}), ConfirmedTransactionResult$1 = type$2({
  signatures: array$1(string$1()),
  message: type$2({
    accountKeys: array$1(string$1()),
    header: type$2({
      numRequiredSignatures: number$1(),
      numReadonlySignedAccounts: number$1(),
      numReadonlyUnsignedAccounts: number$1()
    }),
    instructions: array$1(type$2({
      accounts: array$1(number$1()),
      data: string$1(),
      programIdIndex: number$1()
    })),
    recentBlockhash: string$1(),
    addressTableLookups: optional$1(array$1(AddressTableLookupStruct$1))
  })
}), AnnotatedAccountKey$1 = type$2({
  pubkey: PublicKeyFromString$1,
  signer: boolean$1(),
  writable: boolean$1(),
  source: optional$1(union$1([literal$1("transaction"), literal$1("lookupTable")]))
}), ConfirmedTransactionAccountsModeResult$1 = type$2({
  accountKeys: array$1(AnnotatedAccountKey$1),
  signatures: array$1(string$1())
}), ParsedInstructionResult$1 = type$2({
  parsed: unknown$1(),
  program: string$1(),
  programId: PublicKeyFromString$1
}), RawInstructionResult$1 = type$2({
  accounts: array$1(PublicKeyFromString$1),
  data: string$1(),
  programId: PublicKeyFromString$1
}), InstructionResult$1 = union$1([RawInstructionResult$1, ParsedInstructionResult$1]), UnknownInstructionResult$1 = union$1([type$2({
  parsed: unknown$1(),
  program: string$1(),
  programId: string$1()
}), type$2({
  accounts: array$1(string$1()),
  data: string$1(),
  programId: string$1()
})]), ParsedOrRawInstruction$1 = coerce$1(InstructionResult$1, UnknownInstructionResult$1, (c) => "accounts" in c ? create$1(c, RawInstructionResult$1) : create$1(c, ParsedInstructionResult$1)), ParsedConfirmedTransactionResult$1 = type$2({
  signatures: array$1(string$1()),
  message: type$2({
    accountKeys: array$1(AnnotatedAccountKey$1),
    instructions: array$1(ParsedOrRawInstruction$1),
    recentBlockhash: string$1(),
    addressTableLookups: optional$1(nullable$1(array$1(AddressTableLookupStruct$1)))
  })
}), TokenBalanceResult$1 = type$2({
  accountIndex: number$1(),
  mint: string$1(),
  owner: optional$1(string$1()),
  uiTokenAmount: TokenAmountResult$1
}), LoadedAddressesResult$1 = type$2({
  writable: array$1(PublicKeyFromString$1),
  readonly: array$1(PublicKeyFromString$1)
}), ConfirmedTransactionMetaResult$1 = type$2({
  err: TransactionErrorResult$1,
  fee: number$1(),
  innerInstructions: optional$1(nullable$1(array$1(type$2({
    index: number$1(),
    instructions: array$1(type$2({
      accounts: array$1(number$1()),
      data: string$1(),
      programIdIndex: number$1()
    }))
  })))),
  preBalances: array$1(number$1()),
  postBalances: array$1(number$1()),
  logMessages: optional$1(nullable$1(array$1(string$1()))),
  preTokenBalances: optional$1(nullable$1(array$1(TokenBalanceResult$1))),
  postTokenBalances: optional$1(nullable$1(array$1(TokenBalanceResult$1))),
  loadedAddresses: optional$1(LoadedAddressesResult$1),
  computeUnitsConsumed: optional$1(number$1())
}), ParsedConfirmedTransactionMetaResult$1 = type$2({
  err: TransactionErrorResult$1,
  fee: number$1(),
  innerInstructions: optional$1(nullable$1(array$1(type$2({
    index: number$1(),
    instructions: array$1(ParsedOrRawInstruction$1)
  })))),
  preBalances: array$1(number$1()),
  postBalances: array$1(number$1()),
  logMessages: optional$1(nullable$1(array$1(string$1()))),
  preTokenBalances: optional$1(nullable$1(array$1(TokenBalanceResult$1))),
  postTokenBalances: optional$1(nullable$1(array$1(TokenBalanceResult$1))),
  loadedAddresses: optional$1(LoadedAddressesResult$1),
  computeUnitsConsumed: optional$1(number$1())
}), TransactionVersionStruct$1 = union$1([literal$1(0), literal$1("legacy")]), RewardsResult$1 = type$2({
  pubkey: string$1(),
  lamports: number$1(),
  postBalance: nullable$1(number$1()),
  rewardType: nullable$1(string$1()),
  commission: optional$1(nullable$1(number$1()))
}), GetBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  transactions: array$1(type$2({
    transaction: ConfirmedTransactionResult$1,
    meta: nullable$1(ConfirmedTransactionMetaResult$1),
    version: optional$1(TransactionVersionStruct$1)
  })),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetNoneModeBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  transactions: array$1(type$2({
    transaction: ConfirmedTransactionAccountsModeResult$1,
    meta: nullable$1(ConfirmedTransactionMetaResult$1),
    version: optional$1(TransactionVersionStruct$1)
  })),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetParsedBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  transactions: array$1(type$2({
    transaction: ParsedConfirmedTransactionResult$1,
    meta: nullable$1(ParsedConfirmedTransactionMetaResult$1),
    version: optional$1(TransactionVersionStruct$1)
  })),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetParsedAccountsModeBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  transactions: array$1(type$2({
    transaction: ConfirmedTransactionAccountsModeResult$1,
    meta: nullable$1(ParsedConfirmedTransactionMetaResult$1),
    version: optional$1(TransactionVersionStruct$1)
  })),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetParsedNoneModeBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1()),
  blockHeight: nullable$1(number$1())
}))), GetConfirmedBlockRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  transactions: array$1(type$2({
    transaction: ConfirmedTransactionResult$1,
    meta: nullable$1(ConfirmedTransactionMetaResult$1)
  })),
  rewards: optional$1(array$1(RewardsResult$1)),
  blockTime: nullable$1(number$1())
}))), GetBlockSignaturesRpcResult = jsonRpcResult$1(nullable$1(type$2({
  blockhash: string$1(),
  previousBlockhash: string$1(),
  parentSlot: number$1(),
  signatures: array$1(string$1()),
  blockTime: nullable$1(number$1())
}))), GetTransactionRpcResult = jsonRpcResult$1(nullable$1(type$2({
  slot: number$1(),
  meta: nullable$1(ConfirmedTransactionMetaResult$1),
  blockTime: optional$1(nullable$1(number$1())),
  transaction: ConfirmedTransactionResult$1,
  version: optional$1(TransactionVersionStruct$1)
}))), GetParsedTransactionRpcResult = jsonRpcResult$1(nullable$1(type$2({
  slot: number$1(),
  transaction: ParsedConfirmedTransactionResult$1,
  meta: nullable$1(ParsedConfirmedTransactionMetaResult$1),
  blockTime: optional$1(nullable$1(number$1())),
  version: optional$1(TransactionVersionStruct$1)
}))), GetRecentBlockhashAndContextRpcResult = jsonRpcResultAndContext$1(type$2({
  blockhash: string$1(),
  feeCalculator: type$2({
    lamportsPerSignature: number$1()
  })
})), GetLatestBlockhashRpcResult = jsonRpcResultAndContext$1(type$2({
  blockhash: string$1(),
  lastValidBlockHeight: number$1()
})), IsBlockhashValidRpcResult = jsonRpcResultAndContext$1(boolean$1()), PerfSampleResult$1 = type$2({
  slot: number$1(),
  numTransactions: number$1(),
  numSlots: number$1(),
  samplePeriodSecs: number$1()
}), GetRecentPerformanceSamplesRpcResult = jsonRpcResult$1(array$1(PerfSampleResult$1)), GetFeeCalculatorRpcResult = jsonRpcResultAndContext$1(nullable$1(type$2({
  feeCalculator: type$2({
    lamportsPerSignature: number$1()
  })
}))), RequestAirdropRpcResult = jsonRpcResult$1(string$1()), SendTransactionRpcResult = jsonRpcResult$1(string$1()), LogsResult$1 = type$2({
  err: TransactionErrorResult$1,
  logs: array$1(string$1()),
  signature: string$1()
}), LogsNotificationResult = type$2({
  result: notificationResultAndContext$1(LogsResult$1),
  subscription: number$1()
}), COMMON_HTTP_HEADERS = {
  "solana-client": "js/0.0.0-development"
};
class Connection {
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(t, n) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = /* @__PURE__ */ (() => {
      const ye = {};
      return async (be) => {
        const {
          commitment: Ae,
          config: Se
        } = extractCommitmentFromConfig(be), $e = this._buildArgs([], Ae, void 0, Se), Re = fastStableStringify$1($e);
        return ye[Re] = ye[Re] ?? (async () => {
          try {
            const Me = await this._rpcRequest("getBlockHeight", $e), ke = create$1(Me, jsonRpcResult$1(number$1()));
            if ("error" in ke)
              throw new SolanaJSONRPCError(ke.error, "failed to get block height information");
            return ke.result;
          } finally {
            delete ye[Re];
          }
        })(), await ye[Re];
      };
    })();
    let ie, fe, ae, le, he, me;
    n && typeof n == "string" ? this._commitment = n : n && (this._commitment = n.commitment, this._confirmTransactionInitialTimeout = n.confirmTransactionInitialTimeout, ie = n.wsEndpoint, fe = n.httpHeaders, ae = n.fetch, le = n.fetchMiddleware, he = n.disableRetryOnRateLimit, me = n.httpAgent), this._rpcEndpoint = assertEndpointUrl(t), this._rpcWsEndpoint = ie || makeWebsocketUrl(t), this._rpcClient = createRpcClient(t, fe, ae, le, he, me), this._rpcRequest = createRpcRequest(this._rpcClient), this._rpcBatchRequest = createRpcBatchRequest(this._rpcClient), this._rpcWebSocket = new RpcWebSocketClient(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgs([t.toBase58()], ie, void 0, fe), le = await this._rpcRequest("getBalance", ae), he = create$1(le, jsonRpcResultAndContext$1(number$1()));
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, `failed to get balance for ${t.toBase58()}`);
    return he.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(t, n) {
    return await this.getBalanceAndContext(t, n).then((ie) => ie.value).catch((ie) => {
      throw new Error("failed to get balance of account " + t.toBase58() + ": " + ie);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(t) {
    const n = await this._rpcRequest("getBlockTime", [t]), ie = create$1(n, jsonRpcResult$1(nullable$1(number$1())));
    if ("error" in ie)
      throw new SolanaJSONRPCError(ie.error, `failed to get block time for slot ${t}`);
    return ie.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const t = await this._rpcRequest("minimumLedgerSlot", []), n = create$1(t, jsonRpcResult$1(number$1()));
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get minimum ledger slot");
    return n.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const t = await this._rpcRequest("getFirstAvailableBlock", []), n = create$1(t, SlotRpcResult);
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get first available block");
    return n.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(t) {
    let n = {};
    typeof t == "string" ? n = {
      commitment: t
    } : t ? n = {
      ...t,
      commitment: t && t.commitment || this.commitment
    } : n = {
      commitment: this.commitment
    };
    const ie = await this._rpcRequest("getSupply", [n]), fe = create$1(ie, GetSupplyRpcResult);
    if ("error" in fe)
      throw new SolanaJSONRPCError(fe.error, "failed to get supply");
    return fe.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(t, n) {
    const ie = this._buildArgs([t.toBase58()], n), fe = await this._rpcRequest("getTokenSupply", ie), ae = create$1(fe, jsonRpcResultAndContext$1(TokenAmountResult$1));
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get token supply");
    return ae.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(t, n) {
    const ie = this._buildArgs([t.toBase58()], n), fe = await this._rpcRequest("getTokenAccountBalance", ie), ae = create$1(fe, jsonRpcResultAndContext$1(TokenAmountResult$1));
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get token account balance");
    return ae.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */
  async getTokenAccountsByOwner(t, n, ie) {
    const {
      commitment: fe,
      config: ae
    } = extractCommitmentFromConfig(ie);
    let le = [t.toBase58()];
    "mint" in n ? le.push({
      mint: n.mint.toBase58()
    }) : le.push({
      programId: n.programId.toBase58()
    });
    const he = this._buildArgs(le, fe, "base64", ae), me = await this._rpcRequest("getTokenAccountsByOwner", he), ye = create$1(me, GetTokenAccountsByOwner);
    if ("error" in ye)
      throw new SolanaJSONRPCError(ye.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return ye.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(t, n, ie) {
    let fe = [t.toBase58()];
    "mint" in n ? fe.push({
      mint: n.mint.toBase58()
    }) : fe.push({
      programId: n.programId.toBase58()
    });
    const ae = this._buildArgs(fe, ie, "jsonParsed"), le = await this._rpcRequest("getTokenAccountsByOwner", ae), he = create$1(le, GetParsedTokenAccountsByOwner);
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return he.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(t) {
    const n = {
      ...t,
      commitment: t && t.commitment || this.commitment
    }, ie = n.filter || n.commitment ? [n] : [], fe = await this._rpcRequest("getLargestAccounts", ie), ae = create$1(fe, GetLargestAccountsRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get largest accounts");
    return ae.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(t, n) {
    const ie = this._buildArgs([t.toBase58()], n), fe = await this._rpcRequest("getTokenLargestAccounts", ie), ae = create$1(fe, GetTokenLargestAccountsResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get token largest accounts");
    return ae.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgs([t.toBase58()], ie, "base64", fe), le = await this._rpcRequest("getAccountInfo", ae), he = create$1(le, jsonRpcResultAndContext$1(nullable$1(AccountInfoResult$1)));
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, `failed to get info about account ${t.toBase58()}`);
    return he.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgs([t.toBase58()], ie, "jsonParsed", fe), le = await this._rpcRequest("getAccountInfo", ae), he = create$1(le, jsonRpcResultAndContext$1(nullable$1(ParsedAccountInfoResult$1)));
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, `failed to get info about account ${t.toBase58()}`);
    return he.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(t, n) {
    try {
      return (await this.getAccountInfoAndContext(t, n)).value;
    } catch (ie) {
      throw new Error("failed to get info about account " + t.toBase58() + ": " + ie);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = t.map((ye) => ye.toBase58()), le = this._buildArgs([ae], ie, "jsonParsed", fe), he = await this._rpcRequest("getMultipleAccounts", le), me = create$1(he, jsonRpcResultAndContext$1(array$1(nullable$1(ParsedAccountInfoResult$1))));
    if ("error" in me)
      throw new SolanaJSONRPCError(me.error, `failed to get info for accounts ${ae}`);
    return me.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = t.map((ye) => ye.toBase58()), le = this._buildArgs([ae], ie, "base64", fe), he = await this._rpcRequest("getMultipleAccounts", le), me = create$1(he, jsonRpcResultAndContext$1(array$1(nullable$1(AccountInfoResult$1))));
    if ("error" in me)
      throw new SolanaJSONRPCError(me.error, `failed to get info for accounts ${ae}`);
    return me.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(t, n) {
    return (await this.getMultipleAccountsInfoAndContext(t, n)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   */
  async getStakeActivation(t, n, ie) {
    const {
      commitment: fe,
      config: ae
    } = extractCommitmentFromConfig(n), le = this._buildArgs([t.toBase58()], fe, void 0, {
      ...ae,
      epoch: ie ?? (ae == null ? void 0 : ae.epoch)
    }), he = await this._rpcRequest("getStakeActivation", le), me = create$1(he, jsonRpcResult$1(StakeActivationResult));
    if ("error" in me)
      throw new SolanaJSONRPCError(me.error, `failed to get Stake Activation ${t.toBase58()}`);
    return me.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getProgramAccounts(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), {
      encoding: ae,
      ...le
    } = fe || {}, he = this._buildArgs([t.toBase58()], ie, ae || "base64", le), me = await this._rpcRequest("getProgramAccounts", he), ye = array$1(KeyedAccountInfoResult), be = le.withContext === !0 ? create$1(me, jsonRpcResultAndContext$1(ye)) : create$1(me, jsonRpcResult$1(ye));
    if ("error" in be)
      throw new SolanaJSONRPCError(be.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return be.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgs([t.toBase58()], ie, "jsonParsed", fe), le = await this._rpcRequest("getProgramAccounts", ae), he = create$1(le, jsonRpcResult$1(array$1(KeyedParsedAccountInfoResult)));
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return he.result;
  }
  /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(t, n) {
    var ae;
    let ie;
    if (typeof t == "string")
      ie = t;
    else {
      const le = t;
      if ((ae = le.abortSignal) != null && ae.aborted)
        return Promise.reject(le.abortSignal.reason);
      ie = le.signature;
    }
    let fe;
    try {
      fe = o$1.decode(ie);
    } catch {
      throw new Error("signature must be base58 encoded: " + ie);
    }
    return assert$c(fe.length === 64, "signature has invalid length"), typeof t == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: n || this.commitment,
      signature: ie
    }) : "lastValidBlockHeight" in t ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: n || this.commitment,
      strategy: t
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: n || this.commitment,
      strategy: t
    });
  }
  getCancellationPromise(t) {
    return new Promise((n, ie) => {
      t != null && (t.aborted ? ie(t.reason) : t.addEventListener("abort", () => {
        ie(t.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: t,
    signature: n
  }) {
    let ie, fe, ae = !1;
    const le = new Promise((me, ye) => {
      try {
        ie = this.onSignature(n, (Ae, Se) => {
          ie = void 0;
          const $e = {
            context: Se,
            value: Ae
          };
          me({
            __type: TransactionStatus.PROCESSED,
            response: $e
          });
        }, t);
        const be = new Promise((Ae) => {
          ie == null ? Ae() : fe = this._onSubscriptionStateChange(ie, (Se) => {
            Se === "subscribed" && Ae();
          });
        });
        (async () => {
          if (await be, ae) return;
          const Ae = await this.getSignatureStatus(n);
          if (ae || Ae == null)
            return;
          const {
            context: Se,
            value: $e
          } = Ae;
          if ($e != null)
            if ($e != null && $e.err)
              ye($e.err);
            else {
              switch (t) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if ($e.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if ($e.confirmationStatus === "processed" || $e.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              ae = !0, me({
                __type: TransactionStatus.PROCESSED,
                response: {
                  context: Se,
                  value: $e
                }
              });
            }
        })();
      } catch (be) {
        ye(be);
      }
    });
    return {
      abortConfirmation: () => {
        fe && (fe(), fe = void 0), ie != null && (this.removeSignatureListener(ie), ie = void 0);
      },
      confirmationPromise: le
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: t,
    strategy: {
      abortSignal: n,
      lastValidBlockHeight: ie,
      signature: fe
    }
  }) {
    let ae = !1;
    const le = new Promise((Ae) => {
      const Se = async () => {
        try {
          return await this.getBlockHeight(t);
        } catch {
          return -1;
        }
      };
      (async () => {
        let $e = await Se();
        if (!ae) {
          for (; $e <= ie; )
            if (await sleep(1e3), ae || ($e = await Se(), ae)) return;
          Ae({
            __type: TransactionStatus.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: he,
      confirmationPromise: me
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: fe
    }), ye = this.getCancellationPromise(n);
    let be;
    try {
      const Ae = await Promise.race([ye, me, le]);
      if (Ae.__type === TransactionStatus.PROCESSED)
        be = Ae.response;
      else
        throw new TransactionExpiredBlockheightExceededError(fe);
    } finally {
      ae = !0, he();
    }
    return be;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: t,
    strategy: {
      abortSignal: n,
      minContextSlot: ie,
      nonceAccountPubkey: fe,
      nonceValue: ae,
      signature: le
    }
  }) {
    let he = !1;
    const me = new Promise(($e) => {
      let Re = ae, Me = null;
      const ke = async () => {
        try {
          const {
            context: Te,
            value: Ie
          } = await this.getNonceAndContext(fe, {
            commitment: t,
            minContextSlot: ie
          });
          return Me = Te.slot, Ie == null ? void 0 : Ie.nonce;
        } catch {
          return Re;
        }
      };
      (async () => {
        if (Re = await ke(), !he)
          for (; ; ) {
            if (ae !== Re) {
              $e({
                __type: TransactionStatus.NONCE_INVALID,
                slotInWhichNonceDidAdvance: Me
              });
              return;
            }
            if (await sleep(2e3), he || (Re = await ke(), he)) return;
          }
      })();
    }), {
      abortConfirmation: ye,
      confirmationPromise: be
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: le
    }), Ae = this.getCancellationPromise(n);
    let Se;
    try {
      const $e = await Promise.race([Ae, be, me]);
      if ($e.__type === TransactionStatus.PROCESSED)
        Se = $e.response;
      else {
        let Re;
        for (; ; ) {
          const Me = await this.getSignatureStatus(le);
          if (Me == null)
            break;
          if (Me.context.slot < ($e.slotInWhichNonceDidAdvance ?? ie)) {
            await sleep(400);
            continue;
          }
          Re = Me;
          break;
        }
        if (Re != null && Re.value) {
          const Me = t || "finalized", {
            confirmationStatus: ke
          } = Re.value;
          switch (Me) {
            case "processed":
            case "recent":
              if (ke !== "processed" && ke !== "confirmed" && ke !== "finalized")
                throw new TransactionExpiredNonceInvalidError(le);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (ke !== "confirmed" && ke !== "finalized")
                throw new TransactionExpiredNonceInvalidError(le);
              break;
            case "finalized":
            case "max":
            case "root":
              if (ke !== "finalized")
                throw new TransactionExpiredNonceInvalidError(le);
              break;
            default:
          }
          Se = {
            context: Re.context,
            value: {
              err: Re.value.err
            }
          };
        } else
          throw new TransactionExpiredNonceInvalidError(le);
      }
    } finally {
      he = !0, ye();
    }
    return Se;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: t,
    signature: n
  }) {
    let ie;
    const fe = new Promise((me) => {
      let ye = this._confirmTransactionInitialTimeout || 6e4;
      switch (t) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          ye = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      ie = setTimeout(() => me({
        __type: TransactionStatus.TIMED_OUT,
        timeoutMs: ye
      }), ye);
    }), {
      abortConfirmation: ae,
      confirmationPromise: le
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: n
    });
    let he;
    try {
      const me = await Promise.race([le, fe]);
      if (me.__type === TransactionStatus.PROCESSED)
        he = me.response;
      else
        throw new TransactionExpiredTimeoutError(n, me.timeoutMs / 1e3);
    } finally {
      clearTimeout(ie), ae();
    }
    return he;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const t = await this._rpcRequest("getClusterNodes", []), n = create$1(t, jsonRpcResult$1(array$1(ContactInfoResult)));
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get cluster nodes");
    return n.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(t) {
    const n = this._buildArgs([], t), ie = await this._rpcRequest("getVoteAccounts", n), fe = create$1(ie, GetVoteAccounts);
    if ("error" in fe)
      throw new SolanaJSONRPCError(fe.error, "failed to get vote accounts");
    return fe.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, void 0, ie), ae = await this._rpcRequest("getSlot", fe), le = create$1(ae, jsonRpcResult$1(number$1()));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get slot");
    return le.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, void 0, ie), ae = await this._rpcRequest("getSlotLeader", fe), le = create$1(ae, jsonRpcResult$1(string$1()));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get slot leader");
    return le.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(t, n) {
    const ie = [t, n], fe = await this._rpcRequest("getSlotLeaders", ie), ae = create$1(fe, jsonRpcResult$1(array$1(PublicKeyFromString$1)));
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get slot leaders");
    return ae.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(t, n) {
    const {
      context: ie,
      value: fe
    } = await this.getSignatureStatuses([t], n);
    assert$c(fe.length === 1);
    const ae = fe[0];
    return {
      context: ie,
      value: ae
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(t, n) {
    const ie = [t];
    n && ie.push(n);
    const fe = await this._rpcRequest("getSignatureStatuses", ie), ae = create$1(fe, GetSignatureStatusesRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get signature status");
    return ae.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, void 0, ie), ae = await this._rpcRequest("getTransactionCount", fe), le = create$1(ae, jsonRpcResult$1(number$1()));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get transaction count");
    return le.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(t) {
    return (await this.getSupply({
      commitment: t,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(t) {
    const n = this._buildArgs([], t), ie = await this._rpcRequest("getInflationGovernor", n), fe = create$1(ie, GetInflationGovernorRpcResult);
    if ("error" in fe)
      throw new SolanaJSONRPCError(fe.error, "failed to get inflation");
    return fe.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(t, n, ie) {
    const {
      commitment: fe,
      config: ae
    } = extractCommitmentFromConfig(ie), le = this._buildArgs([t.map((ye) => ye.toBase58())], fe, void 0, {
      ...ae,
      epoch: n ?? (ae == null ? void 0 : ae.epoch)
    }), he = await this._rpcRequest("getInflationReward", le), me = create$1(he, GetInflationRewardResult);
    if ("error" in me)
      throw new SolanaJSONRPCError(me.error, "failed to get inflation reward");
    return me.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const t = await this._rpcRequest("getInflationRate", []), n = create$1(t, GetInflationRateRpcResult);
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get inflation rate");
    return n.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, void 0, ie), ae = await this._rpcRequest("getEpochInfo", fe), le = create$1(ae, GetEpochInfoRpcResult);
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get epoch info");
    return le.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const t = await this._rpcRequest("getEpochSchedule", []), n = create$1(t, GetEpochScheduleRpcResult);
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get epoch schedule");
    const ie = n.result;
    return new EpochSchedule(ie.slotsPerEpoch, ie.leaderScheduleSlotOffset, ie.warmup, ie.firstNormalEpoch, ie.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const t = await this._rpcRequest("getLeaderSchedule", []), n = create$1(t, GetLeaderScheduleRpcResult);
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get leader schedule");
    return n.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(t, n) {
    const ie = this._buildArgs([t], n), fe = await this._rpcRequest("getMinimumBalanceForRentExemption", ie), ae = create$1(fe, GetMinimumBalanceForRentExemptionRpcResult);
    return "error" in ae ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : ae.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(t) {
    const n = this._buildArgs([], t), ie = await this._rpcRequest("getRecentBlockhash", n), fe = create$1(ie, GetRecentBlockhashAndContextRpcResult);
    if ("error" in fe)
      throw new SolanaJSONRPCError(fe.error, "failed to get recent blockhash");
    return fe.result;
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(t) {
    const n = await this._rpcRequest("getRecentPerformanceSamples", t ? [t] : []), ie = create$1(n, GetRecentPerformanceSamplesRpcResult);
    if ("error" in ie)
      throw new SolanaJSONRPCError(ie.error, "failed to get recent performance samples");
    return ie.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(t, n) {
    const ie = this._buildArgs([t], n), fe = await this._rpcRequest("getFeeCalculatorForBlockhash", ie), ae = create$1(fe, GetFeeCalculatorRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get fee calculator");
    const {
      context: le,
      value: he
    } = ae.result;
    return {
      context: le,
      value: he !== null ? he.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(t, n) {
    const ie = toBuffer$2(t.serialize()).toString("base64"), fe = this._buildArgs([ie], n), ae = await this._rpcRequest("getFeeForMessage", fe), le = create$1(ae, jsonRpcResultAndContext$1(nullable$1(number$1())));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get fee for message");
    if (le.result === null)
      throw new Error("invalid blockhash");
    return le.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(t) {
    var le;
    const n = (le = t == null ? void 0 : t.lockedWritableAccounts) == null ? void 0 : le.map((he) => he.toBase58()), ie = n != null && n.length ? [n] : [], fe = await this._rpcRequest("getRecentPrioritizationFees", ie), ae = create$1(fe, GetRecentPrioritizationFeesRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get recent prioritization fees");
    return ae.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(t) {
    try {
      return (await this.getRecentBlockhashAndContext(t)).value;
    } catch (n) {
      throw new Error("failed to get recent blockhash: " + n);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(t) {
    try {
      return (await this.getLatestBlockhashAndContext(t)).value;
    } catch (n) {
      throw new Error("failed to get recent blockhash: " + n);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, void 0, ie), ae = await this._rpcRequest("getLatestBlockhash", fe), le = create$1(ae, GetLatestBlockhashRpcResult);
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get latest blockhash");
    return le.result;
  }
  /**
   * Returns whether a blockhash is still valid or not
   */
  async isBlockhashValid(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgs([t], ie, void 0, fe), le = await this._rpcRequest("isBlockhashValid", ae), he = create$1(le, IsBlockhashValidRpcResult);
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, "failed to determine if the blockhash `" + t + "`is valid");
    return he.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const t = await this._rpcRequest("getVersion", []), n = create$1(t, jsonRpcResult$1(VersionResult));
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get version");
    return n.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const t = await this._rpcRequest("getGenesisHash", []), n = create$1(t, jsonRpcResult$1(string$1()));
    if ("error" in n)
      throw new SolanaJSONRPCError(n.error, "failed to get genesis hash");
    return n.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgsAtLeastConfirmed([t], ie, void 0, fe), le = await this._rpcRequest("getBlock", ae);
    try {
      switch (fe == null ? void 0 : fe.transactionDetails) {
        case "accounts": {
          const he = create$1(le, GetAccountsModeBlockRpcResult);
          if ("error" in he)
            throw he.error;
          return he.result;
        }
        case "none": {
          const he = create$1(le, GetNoneModeBlockRpcResult);
          if ("error" in he)
            throw he.error;
          return he.result;
        }
        default: {
          const he = create$1(le, GetBlockRpcResult);
          if ("error" in he)
            throw he.error;
          const {
            result: me
          } = he;
          return me ? {
            ...me,
            transactions: me.transactions.map(({
              transaction: ye,
              meta: be,
              version: Ae
            }) => ({
              meta: be,
              transaction: {
                ...ye,
                message: versionedMessageFromResponse(Ae, ye.message)
              },
              version: Ae
            }))
          } : null;
        }
      }
    } catch (he) {
      throw new SolanaJSONRPCError(he, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgsAtLeastConfirmed([t], ie, "jsonParsed", fe), le = await this._rpcRequest("getBlock", ae);
    try {
      switch (fe == null ? void 0 : fe.transactionDetails) {
        case "accounts": {
          const he = create$1(le, GetParsedAccountsModeBlockRpcResult);
          if ("error" in he)
            throw he.error;
          return he.result;
        }
        case "none": {
          const he = create$1(le, GetParsedNoneModeBlockRpcResult);
          if ("error" in he)
            throw he.error;
          return he.result;
        }
        default: {
          const he = create$1(le, GetParsedBlockRpcResult);
          if ("error" in he)
            throw he.error;
          return he.result;
        }
      }
    } catch (he) {
      throw new SolanaJSONRPCError(he, "failed to get block");
    }
  }
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(t) {
    let n, ie;
    if (typeof t == "string")
      ie = t;
    else if (t) {
      const {
        commitment: he,
        ...me
      } = t;
      ie = he, n = me;
    }
    const fe = this._buildArgs([], ie, "base64", n), ae = await this._rpcRequest("getBlockProduction", fe), le = create$1(ae, BlockProductionResponseStruct);
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get block production information");
    return le.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgsAtLeastConfirmed([t], ie, void 0, fe), le = await this._rpcRequest("getTransaction", ae), he = create$1(le, GetTransactionRpcResult);
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, "failed to get transaction");
    const me = he.result;
    return me && {
      ...me,
      transaction: {
        ...me.transaction,
        message: versionedMessageFromResponse(me.version, me.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = this._buildArgsAtLeastConfirmed([t], ie, "jsonParsed", fe), le = await this._rpcRequest("getTransaction", ae), he = create$1(le, GetParsedTransactionRpcResult);
    if ("error" in he)
      throw new SolanaJSONRPCError(he.error, "failed to get transaction");
    return he.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = t.map((me) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([me], ie, "jsonParsed", fe)
    }));
    return (await this._rpcBatchRequest(ae)).map((me) => {
      const ye = create$1(me, GetParsedTransactionRpcResult);
      if ("error" in ye)
        throw new SolanaJSONRPCError(ye.error, "failed to get transactions");
      return ye.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(t, n) {
    const {
      commitment: ie,
      config: fe
    } = extractCommitmentFromConfig(n), ae = t.map((me) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([me], ie, void 0, fe)
    }));
    return (await this._rpcBatchRequest(ae)).map((me) => {
      const ye = create$1(me, GetTransactionRpcResult);
      if ("error" in ye)
        throw new SolanaJSONRPCError(ye.error, "failed to get transactions");
      const be = ye.result;
      return be && {
        ...be,
        transaction: {
          ...be.transaction,
          message: versionedMessageFromResponse(be.version, be.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(t, n) {
    const ie = this._buildArgsAtLeastConfirmed([t], n), fe = await this._rpcRequest("getConfirmedBlock", ie), ae = create$1(fe, GetConfirmedBlockRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get confirmed block");
    const le = ae.result;
    if (!le)
      throw new Error("Confirmed block " + t + " not found");
    const he = {
      ...le,
      transactions: le.transactions.map(({
        transaction: me,
        meta: ye
      }) => {
        const be = new Message$1(me.message);
        return {
          meta: ye,
          transaction: {
            ...me,
            message: be
          }
        };
      })
    };
    return {
      ...he,
      transactions: he.transactions.map(({
        transaction: me,
        meta: ye
      }) => ({
        meta: ye,
        transaction: Transaction$1.populate(me.message, me.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(t, n, ie) {
    const fe = this._buildArgsAtLeastConfirmed(n !== void 0 ? [t, n] : [t], ie), ae = await this._rpcRequest("getBlocks", fe), le = create$1(ae, jsonRpcResult$1(array$1(number$1())));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get blocks");
    return le.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(t, n) {
    const ie = this._buildArgsAtLeastConfirmed([t], n, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), fe = await this._rpcRequest("getBlock", ie), ae = create$1(fe, GetBlockSignaturesRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get block");
    const le = ae.result;
    if (!le)
      throw new Error("Block " + t + " not found");
    return le;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(t, n) {
    const ie = this._buildArgsAtLeastConfirmed([t], n, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), fe = await this._rpcRequest("getConfirmedBlock", ie), ae = create$1(fe, GetBlockSignaturesRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get confirmed block");
    const le = ae.result;
    if (!le)
      throw new Error("Confirmed block " + t + " not found");
    return le;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(t, n) {
    const ie = this._buildArgsAtLeastConfirmed([t], n), fe = await this._rpcRequest("getConfirmedTransaction", ie), ae = create$1(fe, GetTransactionRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get transaction");
    const le = ae.result;
    if (!le) return le;
    const he = new Message$1(le.transaction.message), me = le.transaction.signatures;
    return {
      ...le,
      transaction: Transaction$1.populate(he, me)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(t, n) {
    const ie = this._buildArgsAtLeastConfirmed([t], n, "jsonParsed"), fe = await this._rpcRequest("getConfirmedTransaction", ie), ae = create$1(fe, GetParsedTransactionRpcResult);
    if ("error" in ae)
      throw new SolanaJSONRPCError(ae.error, "failed to get confirmed transaction");
    return ae.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(t, n) {
    const ie = t.map((le) => ({
      methodName: "getConfirmedTransaction",
      args: this._buildArgsAtLeastConfirmed([le], n, "jsonParsed")
    }));
    return (await this._rpcBatchRequest(ie)).map((le) => {
      const he = create$1(le, GetParsedTransactionRpcResult);
      if ("error" in he)
        throw new SolanaJSONRPCError(he.error, "failed to get confirmed transactions");
      return he.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(t, n, ie) {
    let fe = {}, ae = await this.getFirstAvailableBlock();
    for (; !("until" in fe) && (n--, !(n <= 0 || n < ae)); )
      try {
        const me = await this.getConfirmedBlockSignatures(n, "finalized");
        me.signatures.length > 0 && (fe.until = me.signatures[me.signatures.length - 1].toString());
      } catch (me) {
        if (me instanceof Error && me.message.includes("skipped"))
          continue;
        throw me;
      }
    let le = await this.getSlot("finalized");
    for (; !("before" in fe) && (ie++, !(ie > le)); )
      try {
        const me = await this.getConfirmedBlockSignatures(ie);
        me.signatures.length > 0 && (fe.before = me.signatures[me.signatures.length - 1].toString());
      } catch (me) {
        if (me instanceof Error && me.message.includes("skipped"))
          continue;
        throw me;
      }
    return (await this.getConfirmedSignaturesForAddress2(t, fe)).map((me) => me.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getConfirmedSignaturesForAddress2(t, n, ie) {
    const fe = this._buildArgsAtLeastConfirmed([t.toBase58()], ie, void 0, n), ae = await this._rpcRequest("getConfirmedSignaturesForAddress2", fe), le = create$1(ae, GetConfirmedSignaturesForAddress2RpcResult);
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get confirmed signatures for address");
    return le.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(t, n, ie) {
    const fe = this._buildArgsAtLeastConfirmed([t.toBase58()], ie, void 0, n), ae = await this._rpcRequest("getSignaturesForAddress", fe), le = create$1(ae, GetSignaturesForAddressRpcResult);
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get signatures for address");
    return le.result;
  }
  async getAddressLookupTable(t, n) {
    const {
      context: ie,
      value: fe
    } = await this.getAccountInfoAndContext(t, n);
    let ae = null;
    return fe !== null && (ae = new AddressLookupTableAccount({
      key: t,
      state: AddressLookupTableAccount.deserialize(fe.data)
    })), {
      context: ie,
      value: ae
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(t, n) {
    const {
      context: ie,
      value: fe
    } = await this.getAccountInfoAndContext(t, n);
    let ae = null;
    return fe !== null && (ae = NonceAccount.fromAccountData(fe.data)), {
      context: ie,
      value: ae
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(t, n) {
    return await this.getNonceAndContext(t, n).then((ie) => ie.value).catch((ie) => {
      throw new Error("failed to get nonce for account " + t.toBase58() + ": " + ie);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(t, n) {
    const ie = await this._rpcRequest("requestAirdrop", [t.toBase58(), n]), fe = create$1(ie, RequestAirdropRpcResult);
    if ("error" in fe)
      throw new SolanaJSONRPCError(fe.error, `airdrop to ${t.toBase58()} failed`);
    return fe.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(t) {
    if (!t) {
      for (; this._pollingBlockhash; )
        await sleep(100);
      const ie = Date.now() - this._blockhashInfo.lastFetch >= BLOCKHASH_CACHE_TIMEOUT_MS;
      if (this._blockhashInfo.latestBlockhash !== null && !ie)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const t = Date.now(), n = this._blockhashInfo.latestBlockhash, ie = n ? n.blockhash : null;
      for (let fe = 0; fe < 50; fe++) {
        const ae = await this.getLatestBlockhash("finalized");
        if (ie !== ae.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: ae,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, ae;
        await sleep(MS_PER_SLOT / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - t}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(t) {
    const {
      commitment: n,
      config: ie
    } = extractCommitmentFromConfig(t), fe = this._buildArgs([], n, "base64", ie), ae = await this._rpcRequest("getStakeMinimumDelegation", fe), le = create$1(ae, jsonRpcResultAndContext$1(number$1()));
    if ("error" in le)
      throw new SolanaJSONRPCError(le.error, "failed to get stake minimum delegation");
    return le.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(t, n, ie) {
    if ("message" in t) {
      const Me = t.serialize(), ke = Buffer$1$1.from(Me).toString("base64");
      if (Array.isArray(n) || ie !== void 0)
        throw new Error("Invalid arguments");
      const Te = n || {};
      Te.encoding = "base64", "commitment" in Te || (Te.commitment = this.commitment);
      const Ie = [ke, Te], qe = await this._rpcRequest("simulateTransaction", Ie), Ue = create$1(qe, SimulatedTransactionResponseStruct);
      if ("error" in Ue)
        throw new Error("failed to simulate transaction: " + Ue.error.message);
      return Ue.result;
    }
    let fe;
    if (t instanceof Transaction$1) {
      let Re = t;
      fe = new Transaction$1(), fe.feePayer = Re.feePayer, fe.instructions = t.instructions, fe.nonceInfo = Re.nonceInfo, fe.signatures = Re.signatures;
    } else
      fe = Transaction$1.populate(t), fe._message = fe._json = void 0;
    if (n !== void 0 && !Array.isArray(n))
      throw new Error("Invalid arguments");
    const ae = n;
    if (fe.nonceInfo && ae)
      fe.sign(...ae);
    else {
      let Re = this._disableBlockhashCaching;
      for (; ; ) {
        const Me = await this._blockhashWithExpiryBlockHeight(Re);
        if (fe.lastValidBlockHeight = Me.lastValidBlockHeight, fe.recentBlockhash = Me.blockhash, !ae) break;
        if (fe.sign(...ae), !fe.signature)
          throw new Error("!signature");
        const ke = fe.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(ke) && !this._blockhashInfo.transactionSignatures.includes(ke)) {
          this._blockhashInfo.simulatedSignatures.push(ke);
          break;
        } else
          Re = !0;
      }
    }
    const le = fe._compile(), he = le.serialize(), ye = fe._serialize(he).toString("base64"), be = {
      encoding: "base64",
      commitment: this.commitment
    };
    if (ie) {
      const Re = (Array.isArray(ie) ? ie : le.nonProgramIds()).map((Me) => Me.toBase58());
      be.accounts = {
        encoding: "base64",
        addresses: Re
      };
    }
    ae && (be.sigVerify = !0);
    const Ae = [ye, be], Se = await this._rpcRequest("simulateTransaction", Ae), $e = create$1(Se, SimulatedTransactionResponseStruct);
    if ("error" in $e) {
      let Re;
      if ("data" in $e.error && (Re = $e.error.data.logs, Re && Array.isArray(Re))) {
        const Me = `
    `, ke = Me + Re.join(Me);
        console.error($e.error.message, ke);
      }
      throw new SendTransactionError$1("failed to simulate transaction: " + $e.error.message, Re);
    }
    return $e.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Send a signed transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(t, n, ie) {
    if ("version" in t) {
      if (n && Array.isArray(n))
        throw new Error("Invalid arguments");
      const le = t.serialize();
      return await this.sendRawTransaction(le, n);
    }
    if (n === void 0 || !Array.isArray(n))
      throw new Error("Invalid arguments");
    const fe = n;
    if (t.nonceInfo)
      t.sign(...fe);
    else {
      let le = this._disableBlockhashCaching;
      for (; ; ) {
        const he = await this._blockhashWithExpiryBlockHeight(le);
        if (t.lastValidBlockHeight = he.lastValidBlockHeight, t.recentBlockhash = he.blockhash, t.sign(...fe), !t.signature)
          throw new Error("!signature");
        const me = t.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(me))
          le = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(me);
          break;
        }
      }
    }
    const ae = t.serialize();
    return await this.sendRawTransaction(ae, ie);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(t, n) {
    const ie = toBuffer$2(t).toString("base64");
    return await this.sendEncodedTransaction(ie, n);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(t, n) {
    const ie = {
      encoding: "base64"
    }, fe = n && n.skipPreflight, ae = n && n.preflightCommitment || this.commitment;
    n && n.maxRetries != null && (ie.maxRetries = n.maxRetries), n && n.minContextSlot != null && (ie.minContextSlot = n.minContextSlot), fe && (ie.skipPreflight = fe), ae && (ie.preflightCommitment = ae);
    const le = [t, ie], he = await this._rpcRequest("sendTransaction", le), me = create$1(he, SendTransactionRpcResult);
    if ("error" in me) {
      let ye;
      throw "data" in me.error && (ye = me.error.data.logs), new SendTransactionError$1("failed to send transaction: " + me.error.message, ye);
    }
    return me.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(t) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", t.message);
  }
  /**
   * @internal
   */
  _wsOnClose(t) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), t === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([n, ie]) => {
      this._setSubscription(n, {
        ...ie,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(t, n) {
    var fe;
    const ie = (fe = this._subscriptionsByHash[t]) == null ? void 0 : fe.state;
    if (this._subscriptionsByHash[t] = n, ie !== n.state) {
      const ae = this._subscriptionStateChangeCallbacksByHash[t];
      ae && ae.forEach((le) => {
        try {
          le(n.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(t, n) {
    var ae;
    const ie = this._subscriptionHashByClientSubscriptionId[t];
    if (ie == null)
      return () => {
      };
    const fe = (ae = this._subscriptionStateChangeCallbacksByHash)[ie] || (ae[ie] = /* @__PURE__ */ new Set());
    return fe.add(n), () => {
      fe.delete(n), fe.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[ie];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch (ie) {
          ie instanceof Error && console.log(`Error when closing socket connection: ${ie.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const t = this._rpcWebSocketGeneration, n = () => t === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async (ie) => {
        const fe = this._subscriptionsByHash[ie];
        if (fe !== void 0)
          switch (fe.state) {
            case "pending":
            case "unsubscribed":
              if (fe.callbacks.size === 0) {
                delete this._subscriptionsByHash[ie], fe.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[fe.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: ae,
                  method: le
                } = fe;
                try {
                  this._setSubscription(ie, {
                    ...fe,
                    state: "subscribing"
                  });
                  const he = await this._rpcWebSocket.call(le, ae);
                  this._setSubscription(ie, {
                    ...fe,
                    serverSubscriptionId: he,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[he] = fe.callbacks, await this._updateSubscriptions();
                } catch (he) {
                  if (he instanceof Error && console.error(`${le} error for argument`, ae, he.message), !n())
                    return;
                  this._setSubscription(ie, {
                    ...fe,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              fe.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: ae,
                  unsubscribeMethod: le
                } = fe;
                if (this._subscriptionsAutoDisposedByRpc.has(ae))
                  this._subscriptionsAutoDisposedByRpc.delete(ae);
                else {
                  this._setSubscription(ie, {
                    ...fe,
                    state: "unsubscribing"
                  }), this._setSubscription(ie, {
                    ...fe,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(le, [ae]);
                  } catch (he) {
                    if (he instanceof Error && console.error(`${le} error:`, he.message), !n())
                      return;
                    this._setSubscription(ie, {
                      ...fe,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription(ie, {
                  ...fe,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(t, n) {
    const ie = this._subscriptionCallbacksByServerSubscriptionId[t];
    ie !== void 0 && ie.forEach((fe) => {
      try {
        fe(
          ...n
        );
      } catch (ae) {
        console.error(ae);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, AccountNotificationResult);
    this._handleServerNotification(ie, [n.value, n.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(t, n) {
    const ie = this._nextClientSubscriptionId++, fe = fastStableStringify$1(
      [t.method, n],
      !0
      /* isArrayProp */
    ), ae = this._subscriptionsByHash[fe];
    return ae === void 0 ? this._subscriptionsByHash[fe] = {
      ...t,
      args: n,
      callbacks: /* @__PURE__ */ new Set([t.callback]),
      state: "pending"
    } : ae.callbacks.add(t.callback), this._subscriptionHashByClientSubscriptionId[ie] = fe, this._subscriptionDisposeFunctionsByClientSubscriptionId[ie] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[ie], delete this._subscriptionHashByClientSubscriptionId[ie];
      const le = this._subscriptionsByHash[fe];
      assert$c(le !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${ie}`), le.callbacks.delete(t.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), ie;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */
  onAccountChange(t, n, ie) {
    const fe = this._buildArgs(
      [t.toBase58()],
      ie || this._commitment || "finalized",
      // Apply connection/server default.
      "base64"
    );
    return this._makeSubscription({
      callback: n,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, fe);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, ProgramAccountNotificationResult);
    this._handleServerNotification(ie, [{
      accountId: n.value.pubkey,
      accountInfo: n.value.account
    }, n.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */
  onProgramAccountChange(t, n, ie, fe) {
    const ae = this._buildArgs(
      [t.toBase58()],
      ie || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      fe ? {
        filters: fe
      } : void 0
      /* extra */
    );
    return this._makeSubscription({
      callback: n,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, ae);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeProgramAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(t, n, ie) {
    const fe = this._buildArgs(
      [typeof t == "object" ? {
        mentions: [t.toString()]
      } : t],
      ie || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: n,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, fe);
  }
  /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */
  async removeOnLogsListener(t) {
    await this._unsubscribeClientSubscription(t, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, LogsNotificationResult);
    this._handleServerNotification(ie, [n.value, n.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, SlotNotificationResult);
    this._handleServerNotification(ie, [n]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, SlotUpdateNotificationResult);
    this._handleServerNotification(ie, [n]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotUpdateListener(t) {
    await this._unsubscribeClientSubscription(t, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(t, n) {
    const ie = this._subscriptionDisposeFunctionsByClientSubscriptionId[t];
    ie ? await ie() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${t}\` for '${n}' events could not be found.`);
  }
  _buildArgs(t, n, ie, fe) {
    const ae = n || this._commitment;
    if (ae || ie || fe) {
      let le = {};
      ie && (le.encoding = ie), ae && (le.commitment = ae), fe && (le = Object.assign(le, fe)), t.push(le);
    }
    return t;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(t, n, ie, fe) {
    const ae = n || this._commitment;
    if (ae && !["confirmed", "finalized"].includes(ae))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(t, n, ie, fe);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, SignatureNotificationResult);
    n.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add(ie), this._handleServerNotification(ie, n.value === "receivedSignature" ? [{
      type: "received"
    }, n.context] : [{
      type: "status",
      result: n.value
    }, n.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(t, n, ie) {
    const fe = this._buildArgs(
      [t],
      ie || this._commitment || "finalized"
      // Apply connection/server default.
    ), ae = this._makeSubscription({
      callback: (le, he) => {
        if (le.type === "status") {
          n(le.result, he);
          try {
            this.removeSignatureListener(ae);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, fe);
    return ae;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(t, n, ie) {
    const {
      commitment: fe,
      ...ae
    } = {
      ...ie,
      commitment: ie && ie.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, le = this._buildArgs([t], fe, void 0, ae), he = this._makeSubscription({
      callback: (me, ye) => {
        n(me, ye);
        try {
          this.removeSignatureListener(he);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, le);
    return he;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSignatureListener(t) {
    await this._unsubscribeClientSubscription(t, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(t) {
    const {
      result: n,
      subscription: ie
    } = create$1(t, RootNotificationResult);
    this._handleServerNotification(ie, [n]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeRootChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "root change");
  }
}
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: struct$1([u32$1("instruction"), u64$2("recentSlot"), u8$1("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: struct$1([u32$1("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$2(), seq(publicKey$2(), offset(u32$1(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: struct$1([u32$1("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  }
});
new PublicKey$1("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: struct$1([u8$1("instruction"), u32$1("units"), u32$1("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: struct$1([u8$1("instruction"), u32$1("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: struct$1([u8$1("instruction"), u32$1("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: struct$1([u8$1("instruction"), u64$2("microLamports")])
  }
});
new PublicKey$1("ComputeBudget111111111111111111111111111111");
struct$1([u8$1("numSignatures"), u8$1("padding"), u16("signatureOffset"), u16("signatureInstructionIndex"), u16("publicKeyOffset"), u16("publicKeyInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u16("messageInstructionIndex")]);
new PublicKey$1("Ed25519SigVerify111111111111111111111111111");
secp256k1$2.utils.isValidPrivateKey;
secp256k1$2.getPublicKey;
struct$1([u8$1("numSignatures"), u16("signatureOffset"), u8$1("signatureInstructionIndex"), u16("ethAddressOffset"), u8$1("ethAddressInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u8$1("messageInstructionIndex"), blob$1(20, "ethAddress"), blob$1(64, "signature"), u8$1("recoveryId")]);
new PublicKey$1("KeccakSecp256k11111111111111111111111111111");
var _class2;
new PublicKey$1("StakeConfig11111111111111111111111111111111");
let Lockup$1 = class {
  /**
   * Create a new Lockup object
   */
  constructor(t, n, ie) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = t, this.epoch = n, this.custodian = ie;
  }
  /**
   * Default, inactive Lockup value
   */
};
_class2 = Lockup$1;
Lockup$1.default = new _class2(0, 0, PublicKey$1.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: struct$1([u32$1("instruction"), authorized$1(), lockup$1()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$2("newAuthorized"), u32$1("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: struct$1([u32$1("instruction")])
  },
  Split: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: struct$1([u32$1("instruction")])
  },
  Merge: {
    index: 7,
    layout: struct$1([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: struct$1([u32$1("instruction"), publicKey$2("newAuthorized"), u32$1("stakeAuthorizationType"), rustString$1("authoritySeed"), publicKey$2("authorityOwner")])
  }
});
new PublicKey$1("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: struct$1([u32$1("instruction"), voteInit$1()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$2("newAuthorized"), u32$1("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), voteAuthorizeWithSeedArgs$1()])
  }
});
new PublicKey$1("Vote111111111111111111111111111111111111111");
new PublicKey$1("Va1idator1nfo111111111111111111111111111111");
type$2({
  name: string$1(),
  website: optional$1(string$1()),
  details: optional$1(string$1()),
  keybaseUsername: optional$1(string$1())
});
new PublicKey$1("Vote111111111111111111111111111111111111111");
struct$1([
  publicKey$2("nodePubkey"),
  publicKey$2("authorizedWithdrawer"),
  u8$1("commission"),
  nu64(),
  // votes.length
  seq(struct$1([nu64("slot"), u32$1("confirmationCount")]), offset(u32$1(), -8), "votes"),
  u8$1("rootSlotValid"),
  nu64("rootSlot"),
  nu64(),
  // authorizedVoters.length
  seq(struct$1([nu64("epoch"), publicKey$2("authorizedVoter")]), offset(u32$1(), -8), "authorizedVoters"),
  struct$1([seq(struct$1([publicKey$2("authorizedPubkey"), nu64("epochOfLastAuthorizedSwitch"), nu64("targetEpoch")]), 32, "buf"), nu64("idx"), u8$1("isEmpty")], "priorVoters"),
  nu64(),
  // epochCredits.length
  seq(struct$1([nu64("epoch"), nu64("credits"), nu64("prevCredits")]), offset(u32$1(), -8), "epochCredits"),
  struct$1([nu64("slot"), nu64("timestamp")], "lastTimestamp")
]);
const endpoint = {
  http: {
    devnet: "http://api.devnet.solana.com",
    testnet: "http://api.testnet.solana.com",
    "mainnet-beta": "http://api.mainnet-beta.solana.com/"
  },
  https: {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com",
    "mainnet-beta": "https://api.mainnet-beta.solana.com/"
  }
};
function clusterApiUrl(c, t) {
  const n = "https";
  if (!c)
    return endpoint[n].devnet;
  const ie = endpoint[n][c];
  if (!ie)
    throw new Error(`Unknown ${n} cluster: ${c}`);
  return ie;
}
function _typeof(c) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof(c);
}
function toPrimitive(c, t) {
  if (_typeof(c) != "object" || !c) return c;
  var n = c[Symbol.toPrimitive];
  if (n !== void 0) {
    var ie = n.call(c, t || "default");
    if (_typeof(ie) != "object") return ie;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(c);
}
function toPropertyKey(c) {
  var t = toPrimitive(c, "string");
  return _typeof(t) == "symbol" ? t : t + "";
}
function _defineProperty(c, t, n) {
  return (t = toPropertyKey(t)) in c ? Object.defineProperty(c, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : c[t] = n, c;
}
class StructError extends TypeError {
  constructor(t, n) {
    let ie;
    const { message: fe, explanation: ae, ...le } = t, { path: he } = t, me = he.length === 0 ? fe : `At path: ${he.join(".")} -- ${fe}`;
    super(ae ?? me), ae != null && (this.cause = me), Object.assign(this, le), this.name = this.constructor.name, this.failures = () => ie ?? (ie = [t, ...n()]);
  }
}
function isIterable(c) {
  return isObject$2(c) && typeof c[Symbol.iterator] == "function";
}
function isObject$2(c) {
  return typeof c == "object" && c != null;
}
function isNonArrayObject(c) {
  return isObject$2(c) && !Array.isArray(c);
}
function print$2(c) {
  return typeof c == "symbol" ? c.toString() : typeof c == "string" ? JSON.stringify(c) : `${c}`;
}
function shiftIterator(c) {
  const { done: t, value: n } = c.next();
  return t ? void 0 : n;
}
function toFailure(c, t, n, ie) {
  if (c === !0)
    return;
  c === !1 ? c = {} : typeof c == "string" && (c = { message: c });
  const { path: fe, branch: ae } = t, { type: le } = n, { refinement: he, message: me = `Expected a value of type \`${le}\`${he ? ` with refinement \`${he}\`` : ""}, but received: \`${print$2(ie)}\`` } = c;
  return {
    value: ie,
    type: le,
    refinement: he,
    key: fe[fe.length - 1],
    path: fe,
    branch: ae,
    ...c,
    message: me
  };
}
function* toFailures(c, t, n, ie) {
  isIterable(c) || (c = [c]);
  for (const fe of c) {
    const ae = toFailure(fe, t, n, ie);
    ae && (yield ae);
  }
}
function* run(c, t, n = {}) {
  const { path: ie = [], branch: fe = [c], coerce: ae = !1, mask: le = !1 } = n, he = { path: ie, branch: fe, mask: le };
  ae && (c = t.coercer(c, he));
  let me = "valid";
  for (const ye of t.validator(c, he))
    ye.explanation = n.message, me = "not_valid", yield [ye, void 0];
  for (let [ye, be, Ae] of t.entries(c, he)) {
    const Se = run(be, Ae, {
      path: ye === void 0 ? ie : [...ie, ye],
      branch: ye === void 0 ? fe : [...fe, be],
      coerce: ae,
      mask: le,
      message: n.message
    });
    for (const $e of Se)
      $e[0] ? (me = $e[0].refinement != null ? "not_refined" : "not_valid", yield [$e[0], void 0]) : ae && (be = $e[1], ye === void 0 ? c = be : c instanceof Map ? c.set(ye, be) : c instanceof Set ? c.add(be) : isObject$2(c) && (be !== void 0 || ye in c) && (c[ye] = be));
  }
  if (me !== "not_valid")
    for (const ye of t.refiner(c, he))
      ye.explanation = n.message, me = "not_refined", yield [ye, void 0];
  me === "valid" && (yield [void 0, c]);
}
let Struct$1 = class {
  constructor(t) {
    const { type: n, schema: ie, validator: fe, refiner: ae, coercer: le = (me) => me, entries: he = function* () {
    } } = t;
    this.type = n, this.schema = ie, this.entries = he, this.coercer = le, fe ? this.validator = (me, ye) => {
      const be = fe(me, ye);
      return toFailures(be, ye, this, me);
    } : this.validator = () => [], ae ? this.refiner = (me, ye) => {
      const be = ae(me, ye);
      return toFailures(be, ye, this, me);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t, n) {
    return assert$b(t, this, n);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t, n) {
    return create(t, this, n);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return is(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema. Masking applies recursively to
   * props of `object` structs only.
   */
  mask(t, n) {
    return mask(t, this, n);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `coerce` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful. Also, `mask` will turn on
   * masking of the unknown `object` props recursively if passed.
   */
  validate(t, n = {}) {
    return validate(t, this, n);
  }
};
function assert$b(c, t, n) {
  const ie = validate(c, t, { message: n });
  if (ie[0])
    throw ie[0];
}
function create(c, t, n) {
  const ie = validate(c, t, { coerce: !0, message: n });
  if (ie[0])
    throw ie[0];
  return ie[1];
}
function mask(c, t, n) {
  const ie = validate(c, t, { coerce: !0, mask: !0, message: n });
  if (ie[0])
    throw ie[0];
  return ie[1];
}
function is(c, t) {
  return !validate(c, t)[0];
}
function validate(c, t, n = {}) {
  const ie = run(c, t, n), fe = shiftIterator(ie);
  return fe[0] ? [new StructError(fe[0], function* () {
    for (const le of ie)
      le[0] && (yield le[0]);
  }), void 0] : [void 0, fe[1]];
}
function define(c, t) {
  return new Struct$1({ type: c, schema: null, validator: t });
}
function any() {
  return define("any", () => !0);
}
function array(c) {
  return new Struct$1({
    type: "array",
    schema: c,
    *entries(t) {
      if (c && Array.isArray(t))
        for (const [n, ie] of t.entries())
          yield [n, ie, c];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || `Expected an array value, but received: ${print$2(t)}`;
    }
  });
}
function boolean() {
  return define("boolean", (c) => typeof c == "boolean");
}
function instance(c) {
  return define("instance", (t) => t instanceof c || `Expected a \`${c.name}\` instance, but received: ${print$2(t)}`);
}
function literal(c) {
  const t = print$2(c), n = typeof c;
  return new Struct$1({
    type: "literal",
    schema: n === "string" || n === "number" || n === "boolean" ? c : null,
    validator(ie) {
      return ie === c || `Expected the literal \`${t}\`, but received: ${print$2(ie)}`;
    }
  });
}
function never() {
  return define("never", () => !1);
}
function nullable(c) {
  return new Struct$1({
    ...c,
    validator: (t, n) => t === null || c.validator(t, n),
    refiner: (t, n) => t === null || c.refiner(t, n)
  });
}
function number() {
  return define("number", (c) => typeof c == "number" && !isNaN(c) || `Expected a number, but received: ${print$2(c)}`);
}
function optional(c) {
  return new Struct$1({
    ...c,
    validator: (t, n) => t === void 0 || c.validator(t, n),
    refiner: (t, n) => t === void 0 || c.refiner(t, n)
  });
}
function record(c, t) {
  return new Struct$1({
    type: "record",
    schema: null,
    *entries(n) {
      if (isObject$2(n))
        for (const ie in n) {
          const fe = n[ie];
          yield [ie, ie, c], yield [ie, fe, t];
        }
    },
    validator(n) {
      return isNonArrayObject(n) || `Expected an object, but received: ${print$2(n)}`;
    },
    coercer(n) {
      return isNonArrayObject(n) ? { ...n } : n;
    }
  });
}
function string() {
  return define("string", (c) => typeof c == "string" || `Expected a string, but received: ${print$2(c)}`);
}
function tuple(c) {
  const t = never();
  return new Struct$1({
    type: "tuple",
    schema: null,
    *entries(n) {
      if (Array.isArray(n)) {
        const ie = Math.max(c.length, n.length);
        for (let fe = 0; fe < ie; fe++)
          yield [fe, n[fe], c[fe] || t];
      }
    },
    validator(n) {
      return Array.isArray(n) || `Expected an array, but received: ${print$2(n)}`;
    },
    coercer(n) {
      return Array.isArray(n) ? n.slice() : n;
    }
  });
}
function type$1(c) {
  const t = Object.keys(c);
  return new Struct$1({
    type: "type",
    schema: c,
    *entries(n) {
      if (isObject$2(n))
        for (const ie of t)
          yield [ie, n[ie], c[ie]];
    },
    validator(n) {
      return isNonArrayObject(n) || `Expected an object, but received: ${print$2(n)}`;
    },
    coercer(n) {
      return isNonArrayObject(n) ? { ...n } : n;
    }
  });
}
function union(c) {
  const t = c.map((n) => n.type).join(" | ");
  return new Struct$1({
    type: "union",
    schema: null,
    coercer(n, ie) {
      for (const fe of c) {
        const [ae, le] = fe.validate(n, {
          coerce: !0,
          mask: ie.mask
        });
        if (!ae)
          return le;
      }
      return n;
    },
    validator(n, ie) {
      const fe = [];
      for (const ae of c) {
        const [...le] = run(n, ae, ie), [he] = le;
        if (he[0])
          for (const [me] of le)
            me && fe.push(me);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${t}\`, but received: ${print$2(n)}`,
        ...fe
      ];
    }
  });
}
function unknown() {
  return define("unknown", () => !0);
}
function coerce(c, t, n) {
  return new Struct$1({
    ...c,
    coercer: (ie, fe) => is(ie, t) ? c.coercer(n(ie, fe), fe) : c.coercer(ie, fe)
  });
}
var eventemitter3 = { exports: {} };
(function(c) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function ie() {
  }
  Object.create && (ie.prototype = /* @__PURE__ */ Object.create(null), new ie().__proto__ || (n = !1));
  function fe(me, ye, be) {
    this.fn = me, this.context = ye, this.once = be || !1;
  }
  function ae(me, ye, be, Ae, Se) {
    if (typeof be != "function")
      throw new TypeError("The listener must be a function");
    var $e = new fe(be, Ae || me, Se), Re = n ? n + ye : ye;
    return me._events[Re] ? me._events[Re].fn ? me._events[Re] = [me._events[Re], $e] : me._events[Re].push($e) : (me._events[Re] = $e, me._eventsCount++), me;
  }
  function le(me, ye) {
    --me._eventsCount === 0 ? me._events = new ie() : delete me._events[ye];
  }
  function he() {
    this._events = new ie(), this._eventsCount = 0;
  }
  he.prototype.eventNames = function() {
    var ye = [], be, Ae;
    if (this._eventsCount === 0) return ye;
    for (Ae in be = this._events)
      t.call(be, Ae) && ye.push(n ? Ae.slice(1) : Ae);
    return Object.getOwnPropertySymbols ? ye.concat(Object.getOwnPropertySymbols(be)) : ye;
  }, he.prototype.listeners = function(ye) {
    var be = n ? n + ye : ye, Ae = this._events[be];
    if (!Ae) return [];
    if (Ae.fn) return [Ae.fn];
    for (var Se = 0, $e = Ae.length, Re = new Array($e); Se < $e; Se++)
      Re[Se] = Ae[Se].fn;
    return Re;
  }, he.prototype.listenerCount = function(ye) {
    var be = n ? n + ye : ye, Ae = this._events[be];
    return Ae ? Ae.fn ? 1 : Ae.length : 0;
  }, he.prototype.emit = function(ye, be, Ae, Se, $e, Re) {
    var Me = n ? n + ye : ye;
    if (!this._events[Me]) return !1;
    var ke = this._events[Me], Te = arguments.length, Ie, qe;
    if (ke.fn) {
      switch (ke.once && this.removeListener(ye, ke.fn, void 0, !0), Te) {
        case 1:
          return ke.fn.call(ke.context), !0;
        case 2:
          return ke.fn.call(ke.context, be), !0;
        case 3:
          return ke.fn.call(ke.context, be, Ae), !0;
        case 4:
          return ke.fn.call(ke.context, be, Ae, Se), !0;
        case 5:
          return ke.fn.call(ke.context, be, Ae, Se, $e), !0;
        case 6:
          return ke.fn.call(ke.context, be, Ae, Se, $e, Re), !0;
      }
      for (qe = 1, Ie = new Array(Te - 1); qe < Te; qe++)
        Ie[qe - 1] = arguments[qe];
      ke.fn.apply(ke.context, Ie);
    } else {
      var Ue = ke.length, ze;
      for (qe = 0; qe < Ue; qe++)
        switch (ke[qe].once && this.removeListener(ye, ke[qe].fn, void 0, !0), Te) {
          case 1:
            ke[qe].fn.call(ke[qe].context);
            break;
          case 2:
            ke[qe].fn.call(ke[qe].context, be);
            break;
          case 3:
            ke[qe].fn.call(ke[qe].context, be, Ae);
            break;
          case 4:
            ke[qe].fn.call(ke[qe].context, be, Ae, Se);
            break;
          default:
            if (!Ie) for (ze = 1, Ie = new Array(Te - 1); ze < Te; ze++)
              Ie[ze - 1] = arguments[ze];
            ke[qe].fn.apply(ke[qe].context, Ie);
        }
    }
    return !0;
  }, he.prototype.on = function(ye, be, Ae) {
    return ae(this, ye, be, Ae, !1);
  }, he.prototype.once = function(ye, be, Ae) {
    return ae(this, ye, be, Ae, !0);
  }, he.prototype.removeListener = function(ye, be, Ae, Se) {
    var $e = n ? n + ye : ye;
    if (!this._events[$e]) return this;
    if (!be)
      return le(this, $e), this;
    var Re = this._events[$e];
    if (Re.fn)
      Re.fn === be && (!Se || Re.once) && (!Ae || Re.context === Ae) && le(this, $e);
    else {
      for (var Me = 0, ke = [], Te = Re.length; Me < Te; Me++)
        (Re[Me].fn !== be || Se && !Re[Me].once || Ae && Re[Me].context !== Ae) && ke.push(Re[Me]);
      ke.length ? this._events[$e] = ke.length === 1 ? ke[0] : ke : le(this, $e);
    }
    return this;
  }, he.prototype.removeAllListeners = function(ye) {
    var be;
    return ye ? (be = n ? n + ye : ye, this._events[be] && le(this, be)) : (this._events = new ie(), this._eventsCount = 0), this;
  }, he.prototype.off = he.prototype.removeListener, he.prototype.addListener = he.prototype.on, he.prefixed = n, he.EventEmitter = he, c.exports = he;
})(eventemitter3);
const generateKeypair = () => {
  const c = ed25519.utils.randomPrivateKey(), t = getPublicKey(c), n = new Uint8Array(64);
  return n.set(c), n.set(t, 32), {
    publicKey: t,
    secretKey: n
  };
}, getPublicKey = ed25519.getPublicKey;
function isOnCurve(c) {
  try {
    return ed25519.ExtendedPoint.fromHex(c), !0;
  } catch {
    return !1;
  }
}
const sign$1 = (c, t) => ed25519.sign(c, t.slice(0, 32)), verify$1 = ed25519.verify, toBuffer$1 = (c) => Buffer$1$1.isBuffer(c) ? c : c instanceof Uint8Array ? Buffer$1$1.from(c.buffer, c.byteOffset, c.byteLength) : Buffer$1$1.from(c);
class Struct {
  constructor(t) {
    Object.assign(this, t);
  }
  encode() {
    return Buffer$1$1.from(serialize_1(SOLANA_SCHEMA, this));
  }
  static decode(t) {
    return deserialize_1(SOLANA_SCHEMA, this, t);
  }
  static decodeUnchecked(t) {
    return deserializeUnchecked_1(SOLANA_SCHEMA, this, t);
  }
}
const SOLANA_SCHEMA = /* @__PURE__ */ new Map();
var _PublicKey;
const MAX_SEED_LENGTH = 32, PUBLIC_KEY_LENGTH = 32;
function isPublicKeyData(c) {
  return c._bn !== void 0;
}
let uniquePublicKeyCounter = 1;
class PublicKey extends Struct {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(t) {
    if (super({}), this._bn = void 0, isPublicKeyData(t))
      this._bn = t._bn;
    else {
      if (typeof t == "string") {
        const n = o$1.decode(t);
        if (n.length != PUBLIC_KEY_LENGTH)
          throw new Error("Invalid public key input");
        this._bn = new BN$8(n);
      } else
        this._bn = new BN$8(t);
      if (this._bn.byteLength() > PUBLIC_KEY_LENGTH)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const t = new PublicKey(uniquePublicKeyCounter);
    return uniquePublicKeyCounter += 1, new PublicKey(t.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(t) {
    return this._bn.eq(t._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return o$1.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const t = this.toBuffer();
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const t = this._bn.toArrayLike(Buffer$1$1);
    if (t.length === PUBLIC_KEY_LENGTH)
      return t;
    const n = Buffer$1$1.alloc(32);
    return t.copy(n, 32 - t.length), n;
  }
  get [Symbol.toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(t, n, ie) {
    const fe = Buffer$1$1.concat([t.toBuffer(), Buffer$1$1.from(n), ie.toBuffer()]), ae = sha256$4(fe);
    return new PublicKey(ae);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(t, n) {
    let ie = Buffer$1$1.alloc(0);
    t.forEach(function(ae) {
      if (ae.length > MAX_SEED_LENGTH)
        throw new TypeError("Max seed length exceeded");
      ie = Buffer$1$1.concat([ie, toBuffer$1(ae)]);
    }), ie = Buffer$1$1.concat([ie, n.toBuffer(), Buffer$1$1.from("ProgramDerivedAddress")]);
    const fe = sha256$4(ie);
    if (isOnCurve(fe))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new PublicKey(fe);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(t, n) {
    return this.createProgramAddressSync(t, n);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(t, n) {
    let ie = 255, fe;
    for (; ie != 0; ) {
      try {
        const ae = t.concat(Buffer$1$1.from([ie]));
        fe = this.createProgramAddressSync(ae, n);
      } catch (ae) {
        if (ae instanceof TypeError)
          throw ae;
        ie--;
        continue;
      }
      return [fe, ie];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(t, n) {
    return this.findProgramAddressSync(t, n);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(t) {
    const n = new PublicKey(t);
    return isOnCurve(n.toBytes());
  }
}
_PublicKey = PublicKey;
PublicKey.default = new _PublicKey("11111111111111111111111111111111");
SOLANA_SCHEMA.set(PublicKey, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new PublicKey("BPFLoader1111111111111111111111111111111111");
const PACKET_DATA_SIZE = 1232, VERSION_PREFIX_MASK = 127, SIGNATURE_LENGTH_IN_BYTES = 64;
class MessageAccountKeys {
  constructor(t, n) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = t, this.accountKeysFromLookups = n;
  }
  keySegments() {
    const t = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (t.push(this.accountKeysFromLookups.writable), t.push(this.accountKeysFromLookups.readonly)), t;
  }
  get(t) {
    for (const n of this.keySegments()) {
      if (t < n.length)
        return n[t];
      t -= n.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(t) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const ie = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((ae, le) => {
      ie.set(ae.toBase58(), le);
    });
    const fe = (ae) => {
      const le = ie.get(ae.toBase58());
      if (le === void 0) throw new Error("Encountered an unknown instruction account key during compilation");
      return le;
    };
    return t.map((ae) => ({
      programIdIndex: fe(ae.programId),
      accountKeyIndexes: ae.keys.map((le) => fe(le.pubkey)),
      data: ae.data
    }));
  }
}
const publicKey$1 = (c = "publicKey") => blob$1(32, c), rustString = (c = "string") => {
  const t = struct$1([u32$1("length"), u32$1("lengthPadding"), blob$1(offset(u32$1(), -8), "chars")], c), n = t.decode.bind(t), ie = t.encode.bind(t), fe = t;
  return fe.decode = (ae, le) => n(ae, le).chars.toString(), fe.encode = (ae, le, he) => {
    const me = {
      chars: Buffer$1$1.from(ae, "utf8")
    };
    return ie(me, le, he);
  }, fe.alloc = (ae) => u32$1().span + u32$1().span + Buffer$1$1.from(ae, "utf8").length, fe;
}, authorized = (c = "authorized") => struct$1([publicKey$1("staker"), publicKey$1("withdrawer")], c), lockup = (c = "lockup") => struct$1([ns64("unixTimestamp"), ns64("epoch"), publicKey$1("custodian")], c), voteInit = (c = "voteInit") => struct$1([publicKey$1("nodePubkey"), publicKey$1("authorizedVoter"), publicKey$1("authorizedWithdrawer"), u8$1("commission")], c), voteAuthorizeWithSeedArgs = (c = "voteAuthorizeWithSeedArgs") => struct$1([u32$1("voteAuthorizationType"), publicKey$1("currentAuthorityDerivedKeyOwnerPubkey"), rustString("currentAuthorityDerivedKeySeed"), publicKey$1("newAuthorized")], c);
function getAlloc(c, t) {
  const n = (fe) => {
    if (fe.span >= 0)
      return fe.span;
    if (typeof fe.alloc == "function")
      return fe.alloc(t[fe.property]);
    if ("count" in fe && "elementLayout" in fe) {
      const ae = t[fe.property];
      if (Array.isArray(ae))
        return ae.length * n(fe.elementLayout);
    } else if ("fields" in fe)
      return getAlloc({
        layout: fe
      }, t[fe.property]);
    return 0;
  };
  let ie = 0;
  return c.layout.fields.forEach((fe) => {
    ie += n(fe);
  }), ie;
}
function decodeLength(c) {
  let t = 0, n = 0;
  for (; ; ) {
    let ie = c.shift();
    if (t |= (ie & 127) << n * 7, n += 1, !(ie & 128))
      break;
  }
  return t;
}
function encodeLength(c, t) {
  let n = t;
  for (; ; ) {
    let ie = n & 127;
    if (n >>= 7, n == 0) {
      c.push(ie);
      break;
    } else
      ie |= 128, c.push(ie);
  }
}
function assert$a(c, t) {
  if (!c)
    throw new Error(t || "Assertion failed");
}
class CompiledKeys {
  constructor(t, n) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = t, this.keyMetaMap = n;
  }
  static compile(t, n) {
    const ie = /* @__PURE__ */ new Map(), fe = (le) => {
      const he = le.toBase58();
      let me = ie.get(he);
      return me === void 0 && (me = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, ie.set(he, me)), me;
    }, ae = fe(n);
    ae.isSigner = !0, ae.isWritable = !0;
    for (const le of t) {
      fe(le.programId).isInvoked = !0;
      for (const he of le.keys) {
        const me = fe(he.pubkey);
        me.isSigner || (me.isSigner = he.isSigner), me.isWritable || (me.isWritable = he.isWritable);
      }
    }
    return new CompiledKeys(n, ie);
  }
  getMessageComponents() {
    const t = [...this.keyMetaMap.entries()];
    assert$a(t.length <= 256, "Max static account keys length exceeded");
    const n = t.filter(([, me]) => me.isSigner && me.isWritable), ie = t.filter(([, me]) => me.isSigner && !me.isWritable), fe = t.filter(([, me]) => !me.isSigner && me.isWritable), ae = t.filter(([, me]) => !me.isSigner && !me.isWritable), le = {
      numRequiredSignatures: n.length + ie.length,
      numReadonlySignedAccounts: ie.length,
      numReadonlyUnsignedAccounts: ae.length
    };
    {
      assert$a(n.length > 0, "Expected at least one writable signer key");
      const [me] = n[0];
      assert$a(me === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const he = [...n.map(([me]) => new PublicKey(me)), ...ie.map(([me]) => new PublicKey(me)), ...fe.map(([me]) => new PublicKey(me)), ...ae.map(([me]) => new PublicKey(me))];
    return [le, he];
  }
  extractTableLookup(t) {
    const [n, ie] = this.drainKeysFoundInLookupTable(t.state.addresses, (le) => !le.isSigner && !le.isInvoked && le.isWritable), [fe, ae] = this.drainKeysFoundInLookupTable(t.state.addresses, (le) => !le.isSigner && !le.isInvoked && !le.isWritable);
    if (!(n.length === 0 && fe.length === 0))
      return [{
        accountKey: t.key,
        writableIndexes: n,
        readonlyIndexes: fe
      }, {
        writable: ie,
        readonly: ae
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(t, n) {
    const ie = new Array(), fe = new Array();
    for (const [ae, le] of this.keyMetaMap.entries())
      if (n(le)) {
        const he = new PublicKey(ae), me = t.findIndex((ye) => ye.equals(he));
        me >= 0 && (assert$a(me < 256, "Max lookup table index exceeded"), ie.push(me), fe.push(he), this.keyMetaMap.delete(ae));
      }
    return [ie, fe];
  }
}
const END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
function guardedShift(c) {
  if (c.length === 0)
    throw new Error(END_OF_BUFFER_ERROR_MESSAGE);
  return c.shift();
}
function guardedSplice(c, ...t) {
  const [n] = t;
  if (t.length === 2 ? n + (t[1] ?? 0) > c.length : n >= c.length)
    throw new Error(END_OF_BUFFER_ERROR_MESSAGE);
  return c.splice(...t);
}
class Message {
  constructor(t) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = t.header, this.accountKeys = t.accountKeys.map((n) => new PublicKey(n)), this.recentBlockhash = t.recentBlockhash, this.instructions = t.instructions, this.instructions.forEach((n) => this.indexToProgramIds.set(n.programIdIndex, this.accountKeys[n.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((t) => ({
      programIdIndex: t.programIdIndex,
      accountKeyIndexes: t.accounts,
      data: o$1.decode(t.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new MessageAccountKeys(this.staticAccountKeys);
  }
  static compile(t) {
    const n = CompiledKeys.compile(t.instructions, t.payerKey), [ie, fe] = n.getMessageComponents(), le = new MessageAccountKeys(fe).compileInstructions(t.instructions).map((he) => ({
      programIdIndex: he.programIdIndex,
      accounts: he.accountKeyIndexes,
      data: o$1.encode(he.data)
    }));
    return new Message({
      header: ie,
      accountKeys: fe,
      recentBlockhash: t.recentBlockhash,
      instructions: le
    });
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const n = this.header.numRequiredSignatures;
    if (t >= this.header.numRequiredSignatures) {
      const ie = t - n, ae = this.accountKeys.length - n - this.header.numReadonlyUnsignedAccounts;
      return ie < ae;
    } else {
      const ie = n - this.header.numReadonlySignedAccounts;
      return t < ie;
    }
  }
  isProgramId(t) {
    return this.indexToProgramIds.has(t);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((t, n) => !this.isProgramId(n));
  }
  serialize() {
    const t = this.accountKeys.length;
    let n = [];
    encodeLength(n, t);
    const ie = this.instructions.map((Ae) => {
      const {
        accounts: Se,
        programIdIndex: $e
      } = Ae, Re = Array.from(o$1.decode(Ae.data));
      let Me = [];
      encodeLength(Me, Se.length);
      let ke = [];
      return encodeLength(ke, Re.length), {
        programIdIndex: $e,
        keyIndicesCount: Buffer$1$1.from(Me),
        keyIndices: Se,
        dataLength: Buffer$1$1.from(ke),
        data: Re
      };
    });
    let fe = [];
    encodeLength(fe, ie.length);
    let ae = Buffer$1$1.alloc(PACKET_DATA_SIZE);
    Buffer$1$1.from(fe).copy(ae);
    let le = fe.length;
    ie.forEach((Ae) => {
      const $e = struct$1([u8$1("programIdIndex"), blob$1(Ae.keyIndicesCount.length, "keyIndicesCount"), seq(u8$1("keyIndex"), Ae.keyIndices.length, "keyIndices"), blob$1(Ae.dataLength.length, "dataLength"), seq(u8$1("userdatum"), Ae.data.length, "data")]).encode(Ae, ae, le);
      le += $e;
    }), ae = ae.slice(0, le);
    const he = struct$1([blob$1(1, "numRequiredSignatures"), blob$1(1, "numReadonlySignedAccounts"), blob$1(1, "numReadonlyUnsignedAccounts"), blob$1(n.length, "keyCount"), seq(publicKey$1("key"), t, "keys"), publicKey$1("recentBlockhash")]), me = {
      numRequiredSignatures: Buffer$1$1.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: Buffer$1$1.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: Buffer$1$1.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: Buffer$1$1.from(n),
      keys: this.accountKeys.map((Ae) => toBuffer$1(Ae.toBytes())),
      recentBlockhash: o$1.decode(this.recentBlockhash)
    };
    let ye = Buffer$1$1.alloc(2048);
    const be = he.encode(me, ye);
    return ae.copy(ye, be), ye.slice(0, be + ae.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(t) {
    let n = [...t];
    const ie = guardedShift(n);
    if (ie !== (ie & VERSION_PREFIX_MASK))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const fe = guardedShift(n), ae = guardedShift(n), le = decodeLength(n);
    let he = [];
    for (let Se = 0; Se < le; Se++) {
      const $e = guardedSplice(n, 0, PUBLIC_KEY_LENGTH);
      he.push(new PublicKey(Buffer$1$1.from($e)));
    }
    const me = guardedSplice(n, 0, PUBLIC_KEY_LENGTH), ye = decodeLength(n);
    let be = [];
    for (let Se = 0; Se < ye; Se++) {
      const $e = guardedShift(n), Re = decodeLength(n), Me = guardedSplice(n, 0, Re), ke = decodeLength(n), Te = guardedSplice(n, 0, ke), Ie = o$1.encode(Buffer$1$1.from(Te));
      be.push({
        programIdIndex: $e,
        accounts: Me,
        data: Ie
      });
    }
    const Ae = {
      header: {
        numRequiredSignatures: ie,
        numReadonlySignedAccounts: fe,
        numReadonlyUnsignedAccounts: ae
      },
      recentBlockhash: o$1.encode(Buffer$1$1.from(me)),
      accountKeys: he,
      instructions: be
    };
    return new Message(Ae);
  }
}
const DEFAULT_SIGNATURE = Buffer$1$1.alloc(SIGNATURE_LENGTH_IN_BYTES).fill(0);
class TransactionInstruction {
  constructor(t) {
    this.keys = void 0, this.programId = void 0, this.data = Buffer$1$1.alloc(0), this.programId = t.programId, this.keys = t.keys, t.data && (this.data = t.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: t,
        isSigner: n,
        isWritable: ie
      }) => ({
        pubkey: t.toJSON(),
        isSigner: n,
        isWritable: ie
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class Transaction {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(t) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!t)
      if (t.feePayer && (this.feePayer = t.feePayer), t.signatures && (this.signatures = t.signatures), Object.prototype.hasOwnProperty.call(t, "nonceInfo")) {
        const {
          minContextSlot: n,
          nonceInfo: ie
        } = t;
        this.minNonceContextSlot = n, this.nonceInfo = ie;
      } else if (Object.prototype.hasOwnProperty.call(t, "lastValidBlockHeight")) {
        const {
          blockhash: n,
          lastValidBlockHeight: ie
        } = t;
        this.recentBlockhash = n, this.lastValidBlockHeight = ie;
      } else {
        const {
          recentBlockhash: n,
          nonceInfo: ie
        } = t;
        ie && (this.nonceInfo = ie), this.recentBlockhash = n;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((t) => t.toJSON()),
      signers: this.signatures.map(({
        publicKey: t
      }) => t.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...t) {
    if (t.length === 0)
      throw new Error("No instructions");
    return t.forEach((n) => {
      "instructions" in n ? this.instructions = this.instructions.concat(n.instructions) : "data" in n && "programId" in n && "keys" in n ? this.instructions.push(n) : this.instructions.push(new TransactionInstruction(n));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let t, n;
    if (this.nonceInfo ? (t = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? n = [this.nonceInfo.nonceInstruction, ...this.instructions] : n = this.instructions) : (t = this.recentBlockhash, n = this.instructions), !t)
      throw new Error("Transaction recentBlockhash required");
    n.length < 1 && console.warn("No instructions provided");
    let ie;
    if (this.feePayer)
      ie = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      ie = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let Me = 0; Me < n.length; Me++)
      if (n[Me].programId === void 0)
        throw new Error(`Transaction instruction index ${Me} has undefined program id`);
    const fe = [], ae = [];
    n.forEach((Me) => {
      Me.keys.forEach((Te) => {
        ae.push({
          ...Te
        });
      });
      const ke = Me.programId.toString();
      fe.includes(ke) || fe.push(ke);
    }), fe.forEach((Me) => {
      ae.push({
        pubkey: new PublicKey(Me),
        isSigner: !1,
        isWritable: !1
      });
    });
    const le = [];
    ae.forEach((Me) => {
      const ke = Me.pubkey.toString(), Te = le.findIndex((Ie) => Ie.pubkey.toString() === ke);
      Te > -1 ? (le[Te].isWritable = le[Te].isWritable || Me.isWritable, le[Te].isSigner = le[Te].isSigner || Me.isSigner) : le.push(Me);
    }), le.sort(function(Me, ke) {
      if (Me.isSigner !== ke.isSigner)
        return Me.isSigner ? -1 : 1;
      if (Me.isWritable !== ke.isWritable)
        return Me.isWritable ? -1 : 1;
      const Te = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return Me.pubkey.toBase58().localeCompare(ke.pubkey.toBase58(), "en", Te);
    });
    const he = le.findIndex((Me) => Me.pubkey.equals(ie));
    if (he > -1) {
      const [Me] = le.splice(he, 1);
      Me.isSigner = !0, Me.isWritable = !0, le.unshift(Me);
    } else
      le.unshift({
        pubkey: ie,
        isSigner: !0,
        isWritable: !0
      });
    for (const Me of this.signatures) {
      const ke = le.findIndex((Te) => Te.pubkey.equals(Me.publicKey));
      if (ke > -1)
        le[ke].isSigner || (le[ke].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${Me.publicKey.toString()}`);
    }
    let me = 0, ye = 0, be = 0;
    const Ae = [], Se = [];
    le.forEach(({
      pubkey: Me,
      isSigner: ke,
      isWritable: Te
    }) => {
      ke ? (Ae.push(Me.toString()), me += 1, Te || (ye += 1)) : (Se.push(Me.toString()), Te || (be += 1));
    });
    const $e = Ae.concat(Se), Re = n.map((Me) => {
      const {
        data: ke,
        programId: Te
      } = Me;
      return {
        programIdIndex: $e.indexOf(Te.toString()),
        accounts: Me.keys.map((Ie) => $e.indexOf(Ie.pubkey.toString())),
        data: o$1.encode(ke)
      };
    });
    return Re.forEach((Me) => {
      assert$a(Me.programIdIndex >= 0), Me.accounts.forEach((ke) => assert$a(ke >= 0));
    }), new Message({
      header: {
        numRequiredSignatures: me,
        numReadonlySignedAccounts: ye,
        numReadonlyUnsignedAccounts: be
      },
      accountKeys: $e,
      recentBlockhash: t,
      instructions: Re
    });
  }
  /**
   * @internal
   */
  _compile() {
    const t = this.compileMessage(), n = t.accountKeys.slice(0, t.header.numRequiredSignatures);
    return this.signatures.length === n.length && this.signatures.every((fe, ae) => n[ae].equals(fe.publicKey)) || (this.signatures = n.map((ie) => ({
      signature: null,
      publicKey: ie
    }))), t;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(t) {
    return (await t.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set();
    this.signatures = t.filter((ie) => {
      const fe = ie.toString();
      return n.has(fe) ? !1 : (n.add(fe), !0);
    }).map((ie) => ({
      signature: null,
      publicKey: ie
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), ie = [];
    for (const ae of t) {
      const le = ae.publicKey.toString();
      n.has(le) || (n.add(le), ie.push(ae));
    }
    this.signatures = ie.map((ae) => ({
      signature: null,
      publicKey: ae.publicKey
    }));
    const fe = this._compile();
    this._partialSign(fe, ...ie);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), ie = [];
    for (const ae of t) {
      const le = ae.publicKey.toString();
      n.has(le) || (n.add(le), ie.push(ae));
    }
    const fe = this._compile();
    this._partialSign(fe, ...ie);
  }
  /**
   * @internal
   */
  _partialSign(t, ...n) {
    const ie = t.serialize();
    n.forEach((fe) => {
      const ae = sign$1(ie, fe.secretKey);
      this._addSignature(fe.publicKey, toBuffer$1(ae));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(t, n) {
    this._compile(), this._addSignature(t, n);
  }
  /**
   * @internal
   */
  _addSignature(t, n) {
    assert$a(n.length === 64);
    const ie = this.signatures.findIndex((fe) => t.equals(fe.publicKey));
    if (ie < 0)
      throw new Error(`unknown signer: ${t.toString()}`);
    this.signatures[ie].signature = Buffer$1$1.from(n);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(t = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), t);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(t, n) {
    const ie = {};
    for (const {
      signature: fe,
      publicKey: ae
    } of this.signatures)
      fe === null ? n && (ie.missing || (ie.missing = [])).push(ae) : verify$1(fe, t, ae.toBytes()) || (ie.invalid || (ie.invalid = [])).push(ae);
    return ie.invalid || ie.missing ? ie : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(t) {
    const {
      requireAllSignatures: n,
      verifySignatures: ie
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, t), fe = this.serializeMessage();
    if (ie) {
      const ae = this._getMessageSignednessErrors(fe, n);
      if (ae) {
        let le = "Signature verification failed.";
        throw ae.invalid && (le += `
Invalid signature for public key${ae.invalid.length === 1 ? "" : "(s)"} [\`${ae.invalid.map((he) => he.toBase58()).join("`, `")}\`].`), ae.missing && (le += `
Missing signature for public key${ae.missing.length === 1 ? "" : "(s)"} [\`${ae.missing.map((he) => he.toBase58()).join("`, `")}\`].`), new Error(le);
      }
    }
    return this._serialize(fe);
  }
  /**
   * @internal
   */
  _serialize(t) {
    const {
      signatures: n
    } = this, ie = [];
    encodeLength(ie, n.length);
    const fe = ie.length + n.length * 64 + t.length, ae = Buffer$1$1.alloc(fe);
    return assert$a(n.length < 256), Buffer$1$1.from(ie).copy(ae, 0), n.forEach(({
      signature: le
    }, he) => {
      le !== null && (assert$a(le.length === 64, "signature has invalid length"), Buffer$1$1.from(le).copy(ae, ie.length + he * 64));
    }), t.copy(ae, ie.length + n.length * 64), assert$a(ae.length <= PACKET_DATA_SIZE, `Transaction too large: ${ae.length} > ${PACKET_DATA_SIZE}`), ae;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return assert$a(this.instructions.length === 1), this.instructions[0].keys.map((t) => t.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return assert$a(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return assert$a(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(t) {
    let n = [...t];
    const ie = decodeLength(n);
    let fe = [];
    for (let ae = 0; ae < ie; ae++) {
      const le = guardedSplice(n, 0, SIGNATURE_LENGTH_IN_BYTES);
      fe.push(o$1.encode(Buffer$1$1.from(le)));
    }
    return Transaction.populate(Message.from(n), fe);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(t, n = []) {
    const ie = new Transaction();
    return ie.recentBlockhash = t.recentBlockhash, t.header.numRequiredSignatures > 0 && (ie.feePayer = t.accountKeys[0]), n.forEach((fe, ae) => {
      const le = {
        signature: fe == o$1.encode(DEFAULT_SIGNATURE) ? null : o$1.decode(fe),
        publicKey: t.accountKeys[ae]
      };
      ie.signatures.push(le);
    }), t.instructions.forEach((fe) => {
      const ae = fe.accounts.map((le) => {
        const he = t.accountKeys[le];
        return {
          pubkey: he,
          isSigner: ie.signatures.some((me) => me.publicKey.toString() === he.toString()) || t.isAccountSigner(le),
          isWritable: t.isAccountWritable(le)
        };
      });
      ie.instructions.push(new TransactionInstruction({
        keys: ae,
        programId: t.accountKeys[fe.programIdIndex],
        data: o$1.decode(fe.data)
      }));
    }), ie._message = t, ie._json = ie.toJSON(), ie;
  }
}
new PublicKey("SysvarC1ock11111111111111111111111111111111");
new PublicKey("SysvarEpochSchedu1e111111111111111111111111");
new PublicKey("Sysvar1nstructions1111111111111111111111111");
const SYSVAR_RECENT_BLOCKHASHES_PUBKEY = new PublicKey("SysvarRecentB1ockHashes11111111111111111111"), SYSVAR_RENT_PUBKEY = new PublicKey("SysvarRent111111111111111111111111111111111");
new PublicKey("SysvarRewards111111111111111111111111111111");
new PublicKey("SysvarS1otHashes111111111111111111111111111");
new PublicKey("SysvarS1otHistory11111111111111111111111111");
new PublicKey("SysvarStakeHistory1111111111111111111111111");
class SendTransactionError extends Error {
  constructor({
    action: t,
    signature: n,
    transactionMessage: ie,
    logs: fe
  }) {
    const ae = fe ? `Logs: 
${JSON.stringify(fe.slice(-10), null, 2)}. ` : "", le = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
    let he;
    switch (t) {
      case "send":
        he = `Transaction ${n} resulted in an error. 
${ie}. ` + ae + le;
        break;
      case "simulate":
        he = `Simulation failed. 
Message: ${ie}. 
` + ae + le;
        break;
      default:
        he = `Unknown action '${/* @__PURE__ */ ((me) => me)(t)}'`;
    }
    super(he), this.signature = void 0, this.transactionMessage = void 0, this.transactionLogs = void 0, this.signature = n, this.transactionMessage = ie, this.transactionLogs = fe || void 0;
  }
  get transactionError() {
    return {
      message: this.transactionMessage,
      logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : void 0
    };
  }
  /* @deprecated Use `await getLogs()` instead */
  get logs() {
    const t = this.transactionLogs;
    if (!(t != null && typeof t == "object" && "then" in t))
      return t;
  }
  async getLogs(t) {
    return Array.isArray(this.transactionLogs) || (this.transactionLogs = new Promise((n, ie) => {
      t.getTransaction(this.signature).then((fe) => {
        if (fe && fe.meta && fe.meta.logMessages) {
          const ae = fe.meta.logMessages;
          this.transactionLogs = ae, n(ae);
        } else
          ie(new Error("Log messages not found"));
      }).catch(ie);
    })), await this.transactionLogs;
  }
}
async function sendAndConfirmTransaction$1(c, t, n, ie) {
  const fe = ie && {
    skipPreflight: ie.skipPreflight,
    preflightCommitment: ie.preflightCommitment || ie.commitment,
    maxRetries: ie.maxRetries,
    minContextSlot: ie.minContextSlot
  }, ae = await c.sendTransaction(t, n, fe);
  let le;
  if (t.recentBlockhash != null && t.lastValidBlockHeight != null)
    le = (await c.confirmTransaction({
      abortSignal: ie == null ? void 0 : ie.abortSignal,
      signature: ae,
      blockhash: t.recentBlockhash,
      lastValidBlockHeight: t.lastValidBlockHeight
    }, ie && ie.commitment)).value;
  else if (t.minNonceContextSlot != null && t.nonceInfo != null) {
    const {
      nonceInstruction: he
    } = t.nonceInfo, me = he.keys[0].pubkey;
    le = (await c.confirmTransaction({
      abortSignal: ie == null ? void 0 : ie.abortSignal,
      minContextSlot: t.minNonceContextSlot,
      nonceAccountPubkey: me,
      nonceValue: t.nonceInfo.nonce,
      signature: ae
    }, ie && ie.commitment)).value;
  } else
    (ie == null ? void 0 : ie.abortSignal) != null && console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable."), le = (await c.confirmTransaction(ae, ie && ie.commitment)).value;
  if (le.err)
    throw ae != null ? new SendTransactionError({
      action: "send",
      signature: ae,
      transactionMessage: `Status: (${JSON.stringify(le)})`
    }) : new Error(`Transaction ${ae} failed (${JSON.stringify(le)})`);
  return ae;
}
function encodeData(c, t) {
  const n = c.layout.span >= 0 ? c.layout.span : getAlloc(c, t), ie = Buffer$1$1.alloc(n), fe = Object.assign({
    instruction: c.index
  }, t);
  return c.layout.encode(fe, ie), ie;
}
const FeeCalculatorLayout = nu64("lamportsPerSignature"), NonceAccountLayout = struct$1([u32$1("version"), u32$1("state"), publicKey$1("authorizedPubkey"), publicKey$1("nonce"), struct$1([FeeCalculatorLayout], "feeCalculator")]), NONCE_ACCOUNT_LENGTH = NonceAccountLayout.span, encodeDecode = (c) => {
  const t = c.decode.bind(c), n = c.encode.bind(c);
  return {
    decode: t,
    encode: n
  };
}, bigInt = (c) => (t) => {
  const n = blob$1(c, t), {
    encode: ie,
    decode: fe
  } = encodeDecode(n), ae = n;
  return ae.decode = (le, he) => {
    const me = fe(le, he);
    return toBigIntLE_1(Buffer$1$1.from(me));
  }, ae.encode = (le, he, me) => {
    const ye = toBufferLE_1(le, c);
    return ie(ye, he, me);
  }, ae;
}, u64$1 = bigInt(8), SYSTEM_INSTRUCTION_LAYOUTS = Object.freeze({
  Create: {
    index: 0,
    layout: struct$1([u32$1("instruction"), ns64("lamports"), ns64("space"), publicKey$1("programId")])
  },
  Assign: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$1("programId")])
  },
  Transfer: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$1("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: struct$1([u32$1("instruction"), publicKey$1("base"), rustString("seed"), ns64("lamports"), ns64("space"), publicKey$1("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: struct$1([u32$1("instruction"), publicKey$1("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: struct$1([u32$1("instruction"), publicKey$1("authorized")])
  },
  Allocate: {
    index: 8,
    layout: struct$1([u32$1("instruction"), ns64("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: struct$1([u32$1("instruction"), publicKey$1("base"), rustString("seed"), ns64("space"), publicKey$1("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), publicKey$1("base"), rustString("seed"), publicKey$1("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: struct$1([u32$1("instruction"), u64$1("lamports"), rustString("seed"), publicKey$1("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: struct$1([u32$1("instruction")])
  }
});
class SystemProgram {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the System program
   */
  /**
   * Generate a transaction instruction that creates a new account
   */
  static createAccount(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.Create, ie = encodeData(n, {
      lamports: t.lamports,
      space: t.space,
      programId: toBuffer$1(t.programId.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: t.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: t.newAccountPubkey,
        isSigner: !0,
        isWritable: !0
      }],
      programId: this.programId,
      data: ie
    });
  }
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  static transfer(t) {
    let n, ie;
    if ("basePubkey" in t) {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.TransferWithSeed;
      n = encodeData(fe, {
        lamports: BigInt(t.lamports),
        seed: t.seed,
        programId: toBuffer$1(t.programId.toBuffer())
      }), ie = [{
        pubkey: t.fromPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    } else {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.Transfer;
      n = encodeData(fe, {
        lamports: BigInt(t.lamports)
      }), ie = [{
        pubkey: t.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: ie,
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  static assign(t) {
    let n, ie;
    if ("basePubkey" in t) {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.AssignWithSeed;
      n = encodeData(fe, {
        base: toBuffer$1(t.basePubkey.toBuffer()),
        seed: t.seed,
        programId: toBuffer$1(t.programId.toBuffer())
      }), ie = [{
        pubkey: t.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.Assign;
      n = encodeData(fe, {
        programId: toBuffer$1(t.programId.toBuffer())
      }), ie = [{
        pubkey: t.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: ie,
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  static createAccountWithSeed(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.CreateWithSeed, ie = encodeData(n, {
      base: toBuffer$1(t.basePubkey.toBuffer()),
      seed: t.seed,
      lamports: t.lamports,
      space: t.space,
      programId: toBuffer$1(t.programId.toBuffer())
    });
    let fe = [{
      pubkey: t.fromPubkey,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: t.newAccountPubkey,
      isSigner: !1,
      isWritable: !0
    }];
    return t.basePubkey.equals(t.fromPubkey) || fe.push({
      pubkey: t.basePubkey,
      isSigner: !0,
      isWritable: !1
    }), new TransactionInstruction({
      keys: fe,
      programId: this.programId,
      data: ie
    });
  }
  /**
   * Generate a transaction that creates a new Nonce account
   */
  static createNonceAccount(t) {
    const n = new Transaction();
    "basePubkey" in t && "seed" in t ? n.add(SystemProgram.createAccountWithSeed({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.noncePubkey,
      basePubkey: t.basePubkey,
      seed: t.seed,
      lamports: t.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    })) : n.add(SystemProgram.createAccount({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.noncePubkey,
      lamports: t.lamports,
      space: NONCE_ACCOUNT_LENGTH,
      programId: this.programId
    }));
    const ie = {
      noncePubkey: t.noncePubkey,
      authorizedPubkey: t.authorizedPubkey
    };
    return n.add(this.nonceInitialize(ie)), n;
  }
  /**
   * Generate an instruction to initialize a Nonce account
   */
  static nonceInitialize(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.InitializeNonceAccount, ie = encodeData(n, {
      authorized: toBuffer$1(t.authorizedPubkey.toBuffer())
    }), fe = {
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: ie
    };
    return new TransactionInstruction(fe);
  }
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  static nonceAdvance(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.AdvanceNonceAccount, ie = encodeData(n), fe = {
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ie
    };
    return new TransactionInstruction(fe);
  }
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  static nonceWithdraw(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.WithdrawNonceAccount, ie = encodeData(n, {
      lamports: t.lamports
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: SYSVAR_RECENT_BLOCKHASHES_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: SYSVAR_RENT_PUBKEY,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ie
    });
  }
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  static nonceAuthorize(t) {
    const n = SYSTEM_INSTRUCTION_LAYOUTS.AuthorizeNonceAccount, ie = encodeData(n, {
      authorized: toBuffer$1(t.newAuthorizedPubkey.toBuffer())
    });
    return new TransactionInstruction({
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: ie
    });
  }
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  static allocate(t) {
    let n, ie;
    if ("basePubkey" in t) {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.AllocateWithSeed;
      n = encodeData(fe, {
        base: toBuffer$1(t.basePubkey.toBuffer()),
        seed: t.seed,
        space: t.space,
        programId: toBuffer$1(t.programId.toBuffer())
      }), ie = [{
        pubkey: t.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const fe = SYSTEM_INSTRUCTION_LAYOUTS.Allocate;
      n = encodeData(fe, {
        space: t.space
      }), ie = [{
        pubkey: t.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new TransactionInstruction({
      keys: ie,
      programId: this.programId,
      data: n
    });
  }
}
SystemProgram.programId = new PublicKey("11111111111111111111111111111111");
new PublicKey("BPFLoader2111111111111111111111111111111111");
struct$1([
  u32$1("typeIndex"),
  u64$1("deactivationSlot"),
  nu64("lastExtendedSlot"),
  u8$1("lastExtendedStartIndex"),
  u8$1(),
  // option
  seq(publicKey$1(), offset(u8$1(), -1), "authority")
]);
const PublicKeyFromString = coerce(instance(PublicKey), string(), (c) => new PublicKey(c)), RawAccountDataResult = tuple([string(), literal("base64")]), BufferFromRawAccountData = coerce(instance(Buffer$1$1), RawAccountDataResult, (c) => Buffer$1$1.from(c[0], "base64"));
function createRpcResult(c) {
  return union([type$1({
    jsonrpc: literal("2.0"),
    id: string(),
    result: c
  }), type$1({
    jsonrpc: literal("2.0"),
    id: string(),
    error: type$1({
      code: unknown(),
      message: string(),
      data: optional(any())
    })
  })]);
}
const UnknownRpcResult = createRpcResult(unknown());
function jsonRpcResult(c) {
  return coerce(createRpcResult(c), UnknownRpcResult, (t) => "error" in t ? t : {
    ...t,
    result: create(t.result, c)
  });
}
function jsonRpcResultAndContext(c) {
  return jsonRpcResult(type$1({
    context: type$1({
      slot: number()
    }),
    value: c
  }));
}
function notificationResultAndContext(c) {
  return type$1({
    context: type$1({
      slot: number()
    }),
    value: c
  });
}
const GetInflationGovernorResult = type$1({
  foundation: number(),
  foundationTerm: number(),
  initial: number(),
  taper: number(),
  terminal: number()
});
jsonRpcResult(array(nullable(type$1({
  epoch: number(),
  effectiveSlot: number(),
  amount: number(),
  postBalance: number(),
  commission: optional(nullable(number()))
}))));
const GetRecentPrioritizationFeesResult = array(type$1({
  slot: number(),
  prioritizationFee: number()
})), GetInflationRateResult = type$1({
  total: number(),
  validator: number(),
  foundation: number(),
  epoch: number()
}), GetEpochInfoResult = type$1({
  epoch: number(),
  slotIndex: number(),
  slotsInEpoch: number(),
  absoluteSlot: number(),
  blockHeight: optional(number()),
  transactionCount: optional(number())
}), GetEpochScheduleResult = type$1({
  slotsPerEpoch: number(),
  leaderScheduleSlotOffset: number(),
  warmup: boolean(),
  firstNormalEpoch: number(),
  firstNormalSlot: number()
}), GetLeaderScheduleResult = record(string(), array(number())), TransactionErrorResult = nullable(union([type$1({}), string()])), SignatureStatusResult = type$1({
  err: TransactionErrorResult
}), SignatureReceivedResult = literal("receivedSignature");
type$1({
  "solana-core": string(),
  "feature-set": optional(number())
});
const ParsedInstructionStruct = type$1({
  program: string(),
  programId: PublicKeyFromString,
  parsed: unknown()
}), PartiallyDecodedInstructionStruct = type$1({
  programId: PublicKeyFromString,
  accounts: array(PublicKeyFromString),
  data: string()
});
jsonRpcResultAndContext(type$1({
  err: nullable(union([type$1({}), string()])),
  logs: nullable(array(string())),
  accounts: optional(nullable(array(nullable(type$1({
    executable: boolean(),
    owner: string(),
    lamports: number(),
    data: array(string()),
    rentEpoch: optional(number())
  }))))),
  unitsConsumed: optional(number()),
  returnData: optional(nullable(type$1({
    programId: string(),
    data: tuple([string(), literal("base64")])
  }))),
  innerInstructions: optional(nullable(array(type$1({
    index: number(),
    instructions: array(union([ParsedInstructionStruct, PartiallyDecodedInstructionStruct]))
  }))))
}));
jsonRpcResultAndContext(type$1({
  byIdentity: record(string(), array(number())),
  range: type$1({
    firstSlot: number(),
    lastSlot: number()
  })
}));
jsonRpcResult(GetInflationGovernorResult);
jsonRpcResult(GetInflationRateResult);
jsonRpcResult(GetRecentPrioritizationFeesResult);
jsonRpcResult(GetEpochInfoResult);
jsonRpcResult(GetEpochScheduleResult);
jsonRpcResult(GetLeaderScheduleResult);
jsonRpcResult(number());
jsonRpcResultAndContext(type$1({
  total: number(),
  circulating: number(),
  nonCirculating: number(),
  nonCirculatingAccounts: array(PublicKeyFromString)
}));
const TokenAmountResult = type$1({
  amount: string(),
  uiAmount: nullable(number()),
  decimals: number(),
  uiAmountString: optional(string())
});
jsonRpcResultAndContext(array(type$1({
  address: PublicKeyFromString,
  amount: string(),
  uiAmount: nullable(number()),
  decimals: number(),
  uiAmountString: optional(string())
})));
jsonRpcResultAndContext(array(type$1({
  pubkey: PublicKeyFromString,
  account: type$1({
    executable: boolean(),
    owner: PublicKeyFromString,
    lamports: number(),
    data: BufferFromRawAccountData,
    rentEpoch: number()
  })
})));
const ParsedAccountDataResult = type$1({
  program: string(),
  parsed: unknown(),
  space: number()
});
jsonRpcResultAndContext(array(type$1({
  pubkey: PublicKeyFromString,
  account: type$1({
    executable: boolean(),
    owner: PublicKeyFromString,
    lamports: number(),
    data: ParsedAccountDataResult,
    rentEpoch: number()
  })
})));
jsonRpcResultAndContext(array(type$1({
  lamports: number(),
  address: PublicKeyFromString
})));
const AccountInfoResult = type$1({
  executable: boolean(),
  owner: PublicKeyFromString,
  lamports: number(),
  data: BufferFromRawAccountData,
  rentEpoch: number()
});
type$1({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
});
const ParsedOrRawAccountData = coerce(union([instance(Buffer$1$1), ParsedAccountDataResult]), union([RawAccountDataResult, ParsedAccountDataResult]), (c) => Array.isArray(c) ? create(c, BufferFromRawAccountData) : c), ParsedAccountInfoResult = type$1({
  executable: boolean(),
  owner: PublicKeyFromString,
  lamports: number(),
  data: ParsedOrRawAccountData,
  rentEpoch: number()
});
type$1({
  pubkey: PublicKeyFromString,
  account: ParsedAccountInfoResult
});
type$1({
  state: union([literal("active"), literal("inactive"), literal("activating"), literal("deactivating")]),
  active: number(),
  inactive: number()
});
jsonRpcResult(array(type$1({
  signature: string(),
  slot: number(),
  err: TransactionErrorResult,
  memo: nullable(string()),
  blockTime: optional(nullable(number()))
})));
jsonRpcResult(array(type$1({
  signature: string(),
  slot: number(),
  err: TransactionErrorResult,
  memo: nullable(string()),
  blockTime: optional(nullable(number()))
})));
type$1({
  subscription: number(),
  result: notificationResultAndContext(AccountInfoResult)
});
const ProgramAccountInfoResult = type$1({
  pubkey: PublicKeyFromString,
  account: AccountInfoResult
});
type$1({
  subscription: number(),
  result: notificationResultAndContext(ProgramAccountInfoResult)
});
const SlotInfoResult = type$1({
  parent: number(),
  slot: number(),
  root: number()
});
type$1({
  subscription: number(),
  result: SlotInfoResult
});
const SlotUpdateResult = union([type$1({
  type: union([literal("firstShredReceived"), literal("completed"), literal("optimisticConfirmation"), literal("root")]),
  slot: number(),
  timestamp: number()
}), type$1({
  type: literal("createdBank"),
  parent: number(),
  slot: number(),
  timestamp: number()
}), type$1({
  type: literal("frozen"),
  slot: number(),
  timestamp: number(),
  stats: type$1({
    numTransactionEntries: number(),
    numSuccessfulTransactions: number(),
    numFailedTransactions: number(),
    maxTransactionsPerEntry: number()
  })
}), type$1({
  type: literal("dead"),
  slot: number(),
  timestamp: number(),
  err: string()
})]);
type$1({
  subscription: number(),
  result: SlotUpdateResult
});
type$1({
  subscription: number(),
  result: notificationResultAndContext(union([SignatureStatusResult, SignatureReceivedResult]))
});
type$1({
  subscription: number(),
  result: number()
});
type$1({
  pubkey: string(),
  gossip: nullable(string()),
  tpu: nullable(string()),
  rpc: nullable(string()),
  version: nullable(string())
});
const VoteAccountInfoResult = type$1({
  votePubkey: string(),
  nodePubkey: string(),
  activatedStake: number(),
  epochVoteAccount: boolean(),
  epochCredits: array(tuple([number(), number(), number()])),
  commission: number(),
  lastVote: number(),
  rootSlot: nullable(number())
});
jsonRpcResult(type$1({
  current: array(VoteAccountInfoResult),
  delinquent: array(VoteAccountInfoResult)
}));
const ConfirmationStatus = union([literal("processed"), literal("confirmed"), literal("finalized")]), SignatureStatusResponse = type$1({
  slot: number(),
  confirmations: nullable(number()),
  err: TransactionErrorResult,
  confirmationStatus: optional(ConfirmationStatus)
});
jsonRpcResultAndContext(array(nullable(SignatureStatusResponse)));
jsonRpcResult(number());
const AddressTableLookupStruct = type$1({
  accountKey: PublicKeyFromString,
  writableIndexes: array(number()),
  readonlyIndexes: array(number())
}), ConfirmedTransactionResult = type$1({
  signatures: array(string()),
  message: type$1({
    accountKeys: array(string()),
    header: type$1({
      numRequiredSignatures: number(),
      numReadonlySignedAccounts: number(),
      numReadonlyUnsignedAccounts: number()
    }),
    instructions: array(type$1({
      accounts: array(number()),
      data: string(),
      programIdIndex: number()
    })),
    recentBlockhash: string(),
    addressTableLookups: optional(array(AddressTableLookupStruct))
  })
}), AnnotatedAccountKey = type$1({
  pubkey: PublicKeyFromString,
  signer: boolean(),
  writable: boolean(),
  source: optional(union([literal("transaction"), literal("lookupTable")]))
}), ConfirmedTransactionAccountsModeResult = type$1({
  accountKeys: array(AnnotatedAccountKey),
  signatures: array(string())
}), ParsedInstructionResult = type$1({
  parsed: unknown(),
  program: string(),
  programId: PublicKeyFromString
}), RawInstructionResult = type$1({
  accounts: array(PublicKeyFromString),
  data: string(),
  programId: PublicKeyFromString
}), InstructionResult = union([RawInstructionResult, ParsedInstructionResult]), UnknownInstructionResult = union([type$1({
  parsed: unknown(),
  program: string(),
  programId: string()
}), type$1({
  accounts: array(string()),
  data: string(),
  programId: string()
})]), ParsedOrRawInstruction = coerce(InstructionResult, UnknownInstructionResult, (c) => "accounts" in c ? create(c, RawInstructionResult) : create(c, ParsedInstructionResult)), ParsedConfirmedTransactionResult = type$1({
  signatures: array(string()),
  message: type$1({
    accountKeys: array(AnnotatedAccountKey),
    instructions: array(ParsedOrRawInstruction),
    recentBlockhash: string(),
    addressTableLookups: optional(nullable(array(AddressTableLookupStruct)))
  })
}), TokenBalanceResult = type$1({
  accountIndex: number(),
  mint: string(),
  owner: optional(string()),
  uiTokenAmount: TokenAmountResult
}), LoadedAddressesResult = type$1({
  writable: array(PublicKeyFromString),
  readonly: array(PublicKeyFromString)
}), ConfirmedTransactionMetaResult = type$1({
  err: TransactionErrorResult,
  fee: number(),
  innerInstructions: optional(nullable(array(type$1({
    index: number(),
    instructions: array(type$1({
      accounts: array(number()),
      data: string(),
      programIdIndex: number()
    }))
  })))),
  preBalances: array(number()),
  postBalances: array(number()),
  logMessages: optional(nullable(array(string()))),
  preTokenBalances: optional(nullable(array(TokenBalanceResult))),
  postTokenBalances: optional(nullable(array(TokenBalanceResult))),
  loadedAddresses: optional(LoadedAddressesResult),
  computeUnitsConsumed: optional(number())
}), ParsedConfirmedTransactionMetaResult = type$1({
  err: TransactionErrorResult,
  fee: number(),
  innerInstructions: optional(nullable(array(type$1({
    index: number(),
    instructions: array(ParsedOrRawInstruction)
  })))),
  preBalances: array(number()),
  postBalances: array(number()),
  logMessages: optional(nullable(array(string()))),
  preTokenBalances: optional(nullable(array(TokenBalanceResult))),
  postTokenBalances: optional(nullable(array(TokenBalanceResult))),
  loadedAddresses: optional(LoadedAddressesResult),
  computeUnitsConsumed: optional(number())
}), TransactionVersionStruct = union([literal(0), literal("legacy")]), RewardsResult = type$1({
  pubkey: string(),
  lamports: number(),
  postBalance: nullable(number()),
  rewardType: nullable(string()),
  commission: optional(nullable(number()))
});
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  transactions: array(type$1({
    transaction: ConfirmedTransactionResult,
    meta: nullable(ConfirmedTransactionMetaResult),
    version: optional(TransactionVersionStruct)
  })),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  transactions: array(type$1({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable(ConfirmedTransactionMetaResult),
    version: optional(TransactionVersionStruct)
  })),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  transactions: array(type$1({
    transaction: ParsedConfirmedTransactionResult,
    meta: nullable(ParsedConfirmedTransactionMetaResult),
    version: optional(TransactionVersionStruct)
  })),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  transactions: array(type$1({
    transaction: ConfirmedTransactionAccountsModeResult,
    meta: nullable(ParsedConfirmedTransactionMetaResult),
    version: optional(TransactionVersionStruct)
  })),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number()),
  blockHeight: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  transactions: array(type$1({
    transaction: ConfirmedTransactionResult,
    meta: nullable(ConfirmedTransactionMetaResult)
  })),
  rewards: optional(array(RewardsResult)),
  blockTime: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  blockhash: string(),
  previousBlockhash: string(),
  parentSlot: number(),
  signatures: array(string()),
  blockTime: nullable(number())
})));
jsonRpcResult(nullable(type$1({
  slot: number(),
  meta: nullable(ConfirmedTransactionMetaResult),
  blockTime: optional(nullable(number())),
  transaction: ConfirmedTransactionResult,
  version: optional(TransactionVersionStruct)
})));
jsonRpcResult(nullable(type$1({
  slot: number(),
  transaction: ParsedConfirmedTransactionResult,
  meta: nullable(ParsedConfirmedTransactionMetaResult),
  blockTime: optional(nullable(number())),
  version: optional(TransactionVersionStruct)
})));
jsonRpcResultAndContext(type$1({
  blockhash: string(),
  feeCalculator: type$1({
    lamportsPerSignature: number()
  })
}));
jsonRpcResultAndContext(type$1({
  blockhash: string(),
  lastValidBlockHeight: number()
}));
jsonRpcResultAndContext(boolean());
const PerfSampleResult = type$1({
  slot: number(),
  numTransactions: number(),
  numSlots: number(),
  samplePeriodSecs: number()
});
jsonRpcResult(array(PerfSampleResult));
jsonRpcResultAndContext(nullable(type$1({
  feeCalculator: type$1({
    lamportsPerSignature: number()
  })
})));
jsonRpcResult(string());
jsonRpcResult(string());
const LogsResult = type$1({
  err: TransactionErrorResult,
  logs: array(string()),
  signature: string()
});
type$1({
  result: notificationResultAndContext(LogsResult),
  subscription: number()
});
class Keypair {
  /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */
  constructor(t) {
    this._keypair = void 0, this._keypair = t ?? generateKeypair();
  }
  /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */
  static generate() {
    return new Keypair(generateKeypair());
  }
  /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */
  static fromSecretKey(t, n) {
    if (t.byteLength !== 64)
      throw new Error("bad secret key size");
    const ie = t.slice(32, 64);
    if (!n || !n.skipValidation) {
      const fe = t.slice(0, 32), ae = getPublicKey(fe);
      for (let le = 0; le < 32; le++)
        if (ie[le] !== ae[le])
          throw new Error("provided secretKey is invalid");
    }
    return new Keypair({
      publicKey: ie,
      secretKey: t
    });
  }
  /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */
  static fromSeed(t) {
    const n = getPublicKey(t), ie = new Uint8Array(64);
    return ie.set(t), ie.set(n, 32), new Keypair({
      publicKey: n,
      secretKey: ie
    });
  }
  /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */
  get publicKey() {
    return new PublicKey(this._keypair.publicKey);
  }
  /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */
  get secretKey() {
    return new Uint8Array(this._keypair.secretKey);
  }
}
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: struct$1([u32$1("instruction"), u64$1("recentSlot"), u8$1("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: struct$1([u32$1("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: struct$1([u32$1("instruction"), u64$1(), seq(publicKey$1(), offset(u32$1(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: struct$1([u32$1("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  }
});
new PublicKey("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: struct$1([u8$1("instruction"), u32$1("units"), u32$1("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: struct$1([u8$1("instruction"), u32$1("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: struct$1([u8$1("instruction"), u32$1("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: struct$1([u8$1("instruction"), u64$1("microLamports")])
  }
});
new PublicKey("ComputeBudget111111111111111111111111111111");
struct$1([u8$1("numSignatures"), u8$1("padding"), u16("signatureOffset"), u16("signatureInstructionIndex"), u16("publicKeyOffset"), u16("publicKeyInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u16("messageInstructionIndex")]);
new PublicKey("Ed25519SigVerify111111111111111111111111111");
secp256k1$2.utils.isValidPrivateKey;
secp256k1$2.getPublicKey;
struct$1([u8$1("numSignatures"), u16("signatureOffset"), u8$1("signatureInstructionIndex"), u16("ethAddressOffset"), u8$1("ethAddressInstructionIndex"), u16("messageDataOffset"), u16("messageDataSize"), u8$1("messageInstructionIndex"), blob$1(20, "ethAddress"), blob$1(64, "signature"), u8$1("recoveryId")]);
new PublicKey("KeccakSecp256k11111111111111111111111111111");
var _Lockup;
new PublicKey("StakeConfig11111111111111111111111111111111");
class Lockup {
  /**
   * Create a new Lockup object
   */
  constructor(t, n, ie) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = t, this.epoch = n, this.custodian = ie;
  }
  /**
   * Default, inactive Lockup value
   */
}
_Lockup = Lockup;
Lockup.default = new _Lockup(0, 0, PublicKey.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: struct$1([u32$1("instruction"), authorized(), lockup()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$1("newAuthorized"), u32$1("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: struct$1([u32$1("instruction")])
  },
  Split: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: struct$1([u32$1("instruction")])
  },
  Merge: {
    index: 7,
    layout: struct$1([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: struct$1([u32$1("instruction"), publicKey$1("newAuthorized"), u32$1("stakeAuthorizationType"), rustString("authoritySeed"), publicKey$1("authorityOwner")])
  }
});
new PublicKey("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: struct$1([u32$1("instruction"), voteInit()])
  },
  Authorize: {
    index: 1,
    layout: struct$1([u32$1("instruction"), publicKey$1("newAuthorized"), u32$1("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: struct$1([u32$1("instruction"), ns64("lamports")])
  },
  UpdateValidatorIdentity: {
    index: 4,
    layout: struct$1([u32$1("instruction")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: struct$1([u32$1("instruction"), voteAuthorizeWithSeedArgs()])
  }
});
new PublicKey("Vote111111111111111111111111111111111111111");
new PublicKey("Va1idator1nfo111111111111111111111111111111");
type$1({
  name: string(),
  website: optional(string()),
  details: optional(string()),
  iconUrl: optional(string()),
  keybaseUsername: optional(string())
});
new PublicKey("Vote111111111111111111111111111111111111111");
struct$1([
  publicKey$1("nodePubkey"),
  publicKey$1("authorizedWithdrawer"),
  u8$1("commission"),
  nu64(),
  // votes.length
  seq(struct$1([nu64("slot"), u32$1("confirmationCount")]), offset(u32$1(), -8), "votes"),
  u8$1("rootSlotValid"),
  nu64("rootSlot"),
  nu64(),
  // authorizedVoters.length
  seq(struct$1([nu64("epoch"), publicKey$1("authorizedVoter")]), offset(u32$1(), -8), "authorizedVoters"),
  struct$1([seq(struct$1([publicKey$1("authorizedPubkey"), nu64("epochOfLastAuthorizedSwitch"), nu64("targetEpoch")]), 32, "buf"), nu64("idx"), u8$1("isEmpty")], "priorVoters"),
  nu64(),
  // epochCredits.length
  seq(struct$1([nu64("epoch"), nu64("credits"), nu64("prevCredits")]), offset(u32$1(), -8), "epochCredits"),
  struct$1([nu64("slot"), nu64("timestamp")], "lastTimestamp")
]);
var buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len = code.length; i$2 < len; ++i$2)
  lookup[i$2] = code[i$2], revLookup[code.charCodeAt(i$2)] = i$2;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(c) {
  var t = c.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = c.indexOf("=");
  n === -1 && (n = t);
  var ie = n === t ? 0 : 4 - n % 4;
  return [n, ie];
}
function byteLength(c) {
  var t = getLens(c), n = t[0], ie = t[1];
  return (n + ie) * 3 / 4 - ie;
}
function _byteLength(c, t, n) {
  return (t + n) * 3 / 4 - n;
}
function toByteArray(c) {
  var t, n = getLens(c), ie = n[0], fe = n[1], ae = new Arr(_byteLength(c, ie, fe)), le = 0, he = fe > 0 ? ie - 4 : ie, me;
  for (me = 0; me < he; me += 4)
    t = revLookup[c.charCodeAt(me)] << 18 | revLookup[c.charCodeAt(me + 1)] << 12 | revLookup[c.charCodeAt(me + 2)] << 6 | revLookup[c.charCodeAt(me + 3)], ae[le++] = t >> 16 & 255, ae[le++] = t >> 8 & 255, ae[le++] = t & 255;
  return fe === 2 && (t = revLookup[c.charCodeAt(me)] << 2 | revLookup[c.charCodeAt(me + 1)] >> 4, ae[le++] = t & 255), fe === 1 && (t = revLookup[c.charCodeAt(me)] << 10 | revLookup[c.charCodeAt(me + 1)] << 4 | revLookup[c.charCodeAt(me + 2)] >> 2, ae[le++] = t >> 8 & 255, ae[le++] = t & 255), ae;
}
function tripletToBase64(c) {
  return lookup[c >> 18 & 63] + lookup[c >> 12 & 63] + lookup[c >> 6 & 63] + lookup[c & 63];
}
function encodeChunk(c, t, n) {
  for (var ie, fe = [], ae = t; ae < n; ae += 3)
    ie = (c[ae] << 16 & 16711680) + (c[ae + 1] << 8 & 65280) + (c[ae + 2] & 255), fe.push(tripletToBase64(ie));
  return fe.join("");
}
function fromByteArray(c) {
  for (var t, n = c.length, ie = n % 3, fe = [], ae = 16383, le = 0, he = n - ie; le < he; le += ae)
    fe.push(encodeChunk(c, le, le + ae > he ? he : le + ae));
  return ie === 1 ? (t = c[n - 1], fe.push(
    lookup[t >> 2] + lookup[t << 4 & 63] + "=="
  )) : ie === 2 && (t = (c[n - 2] << 8) + c[n - 1], fe.push(
    lookup[t >> 10] + lookup[t >> 4 & 63] + lookup[t << 2 & 63] + "="
  )), fe.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(c, t, n, ie, fe) {
  var ae, le, he = fe * 8 - ie - 1, me = (1 << he) - 1, ye = me >> 1, be = -7, Ae = n ? fe - 1 : 0, Se = n ? -1 : 1, $e = c[t + Ae];
  for (Ae += Se, ae = $e & (1 << -be) - 1, $e >>= -be, be += he; be > 0; ae = ae * 256 + c[t + Ae], Ae += Se, be -= 8)
    ;
  for (le = ae & (1 << -be) - 1, ae >>= -be, be += ie; be > 0; le = le * 256 + c[t + Ae], Ae += Se, be -= 8)
    ;
  if (ae === 0)
    ae = 1 - ye;
  else {
    if (ae === me)
      return le ? NaN : ($e ? -1 : 1) * (1 / 0);
    le = le + Math.pow(2, ie), ae = ae - ye;
  }
  return ($e ? -1 : 1) * le * Math.pow(2, ae - ie);
};
ieee754.write = function(c, t, n, ie, fe, ae) {
  var le, he, me, ye = ae * 8 - fe - 1, be = (1 << ye) - 1, Ae = be >> 1, Se = fe === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, $e = ie ? 0 : ae - 1, Re = ie ? 1 : -1, Me = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (he = isNaN(t) ? 1 : 0, le = be) : (le = Math.floor(Math.log(t) / Math.LN2), t * (me = Math.pow(2, -le)) < 1 && (le--, me *= 2), le + Ae >= 1 ? t += Se / me : t += Se * Math.pow(2, 1 - Ae), t * me >= 2 && (le++, me /= 2), le + Ae >= be ? (he = 0, le = be) : le + Ae >= 1 ? (he = (t * me - 1) * Math.pow(2, fe), le = le + Ae) : (he = t * Math.pow(2, Ae - 1) * Math.pow(2, fe), le = 0)); fe >= 8; c[n + $e] = he & 255, $e += Re, he /= 256, fe -= 8)
    ;
  for (le = le << fe | he, ye += fe; ye > 0; c[n + $e] = le & 255, $e += Re, le /= 256, ye -= 8)
    ;
  c[n + $e - Re] |= Me * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(c) {
  const t = base64Js, n = ieee754, ie = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  c.Buffer = he, c.SlowBuffer = Ie, c.INSPECT_MAX_BYTES = 50;
  const fe = 2147483647;
  c.kMaxLength = fe, he.TYPED_ARRAY_SUPPORT = ae(), !he.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function ae() {
    try {
      const We = new Uint8Array(1), De = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(De, Uint8Array.prototype), Object.setPrototypeOf(We, De), We.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(he.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (he.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(he.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (he.isBuffer(this))
        return this.byteOffset;
    }
  });
  function le(We) {
    if (We > fe)
      throw new RangeError('The value "' + We + '" is invalid for option "size"');
    const De = new Uint8Array(We);
    return Object.setPrototypeOf(De, he.prototype), De;
  }
  function he(We, De, Ge) {
    if (typeof We == "number") {
      if (typeof De == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Ae(We);
    }
    return me(We, De, Ge);
  }
  he.poolSize = 8192;
  function me(We, De, Ge) {
    if (typeof We == "string")
      return Se(We, De);
    if (ArrayBuffer.isView(We))
      return Re(We);
    if (We == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof We
      );
    if (Xt(We, ArrayBuffer) || We && Xt(We.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Xt(We, SharedArrayBuffer) || We && Xt(We.buffer, SharedArrayBuffer)))
      return Me(We, De, Ge);
    if (typeof We == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Oe = We.valueOf && We.valueOf();
    if (Oe != null && Oe !== We)
      return he.from(Oe, De, Ge);
    const Ce = ke(We);
    if (Ce) return Ce;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof We[Symbol.toPrimitive] == "function")
      return he.from(We[Symbol.toPrimitive]("string"), De, Ge);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof We
    );
  }
  he.from = function(We, De, Ge) {
    return me(We, De, Ge);
  }, Object.setPrototypeOf(he.prototype, Uint8Array.prototype), Object.setPrototypeOf(he, Uint8Array);
  function ye(We) {
    if (typeof We != "number")
      throw new TypeError('"size" argument must be of type number');
    if (We < 0)
      throw new RangeError('The value "' + We + '" is invalid for option "size"');
  }
  function be(We, De, Ge) {
    return ye(We), We <= 0 ? le(We) : De !== void 0 ? typeof Ge == "string" ? le(We).fill(De, Ge) : le(We).fill(De) : le(We);
  }
  he.alloc = function(We, De, Ge) {
    return be(We, De, Ge);
  };
  function Ae(We) {
    return ye(We), le(We < 0 ? 0 : Te(We) | 0);
  }
  he.allocUnsafe = function(We) {
    return Ae(We);
  }, he.allocUnsafeSlow = function(We) {
    return Ae(We);
  };
  function Se(We, De) {
    if ((typeof De != "string" || De === "") && (De = "utf8"), !he.isEncoding(De))
      throw new TypeError("Unknown encoding: " + De);
    const Ge = qe(We, De) | 0;
    let Oe = le(Ge);
    const Ce = Oe.write(We, De);
    return Ce !== Ge && (Oe = Oe.slice(0, Ce)), Oe;
  }
  function $e(We) {
    const De = We.length < 0 ? 0 : Te(We.length) | 0, Ge = le(De);
    for (let Oe = 0; Oe < De; Oe += 1)
      Ge[Oe] = We[Oe] & 255;
    return Ge;
  }
  function Re(We) {
    if (Xt(We, Uint8Array)) {
      const De = new Uint8Array(We);
      return Me(De.buffer, De.byteOffset, De.byteLength);
    }
    return $e(We);
  }
  function Me(We, De, Ge) {
    if (De < 0 || We.byteLength < De)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (We.byteLength < De + (Ge || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Oe;
    return De === void 0 && Ge === void 0 ? Oe = new Uint8Array(We) : Ge === void 0 ? Oe = new Uint8Array(We, De) : Oe = new Uint8Array(We, De, Ge), Object.setPrototypeOf(Oe, he.prototype), Oe;
  }
  function ke(We) {
    if (he.isBuffer(We)) {
      const De = Te(We.length) | 0, Ge = le(De);
      return Ge.length === 0 || We.copy(Ge, 0, 0, De), Ge;
    }
    if (We.length !== void 0)
      return typeof We.length != "number" || wn(We.length) ? le(0) : $e(We);
    if (We.type === "Buffer" && Array.isArray(We.data))
      return $e(We.data);
  }
  function Te(We) {
    if (We >= fe)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + fe.toString(16) + " bytes");
    return We | 0;
  }
  function Ie(We) {
    return +We != We && (We = 0), he.alloc(+We);
  }
  he.isBuffer = function(De) {
    return De != null && De._isBuffer === !0 && De !== he.prototype;
  }, he.compare = function(De, Ge) {
    if (Xt(De, Uint8Array) && (De = he.from(De, De.offset, De.byteLength)), Xt(Ge, Uint8Array) && (Ge = he.from(Ge, Ge.offset, Ge.byteLength)), !he.isBuffer(De) || !he.isBuffer(Ge))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (De === Ge) return 0;
    let Oe = De.length, Ce = Ge.length;
    for (let He = 0, Xe = Math.min(Oe, Ce); He < Xe; ++He)
      if (De[He] !== Ge[He]) {
        Oe = De[He], Ce = Ge[He];
        break;
      }
    return Oe < Ce ? -1 : Ce < Oe ? 1 : 0;
  }, he.isEncoding = function(De) {
    switch (String(De).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, he.concat = function(De, Ge) {
    if (!Array.isArray(De))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (De.length === 0)
      return he.alloc(0);
    let Oe;
    if (Ge === void 0)
      for (Ge = 0, Oe = 0; Oe < De.length; ++Oe)
        Ge += De[Oe].length;
    const Ce = he.allocUnsafe(Ge);
    let He = 0;
    for (Oe = 0; Oe < De.length; ++Oe) {
      let Xe = De[Oe];
      if (Xt(Xe, Uint8Array))
        He + Xe.length > Ce.length ? (he.isBuffer(Xe) || (Xe = he.from(Xe)), Xe.copy(Ce, He)) : Uint8Array.prototype.set.call(
          Ce,
          Xe,
          He
        );
      else if (he.isBuffer(Xe))
        Xe.copy(Ce, He);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      He += Xe.length;
    }
    return Ce;
  };
  function qe(We, De) {
    if (he.isBuffer(We))
      return We.length;
    if (ArrayBuffer.isView(We) || Xt(We, ArrayBuffer))
      return We.byteLength;
    if (typeof We != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof We
      );
    const Ge = We.length, Oe = arguments.length > 2 && arguments[2] === !0;
    if (!Oe && Ge === 0) return 0;
    let Ce = !1;
    for (; ; )
      switch (De) {
        case "ascii":
        case "latin1":
        case "binary":
          return Ge;
        case "utf8":
        case "utf-8":
          return xn(We).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ge * 2;
        case "hex":
          return Ge >>> 1;
        case "base64":
          return An(We).length;
        default:
          if (Ce)
            return Oe ? -1 : xn(We).length;
          De = ("" + De).toLowerCase(), Ce = !0;
      }
  }
  he.byteLength = qe;
  function Ue(We, De, Ge) {
    let Oe = !1;
    if ((De === void 0 || De < 0) && (De = 0), De > this.length || ((Ge === void 0 || Ge > this.length) && (Ge = this.length), Ge <= 0) || (Ge >>>= 0, De >>>= 0, Ge <= De))
      return "";
    for (We || (We = "utf8"); ; )
      switch (We) {
        case "hex":
          return xe(this, De, Ge);
        case "utf8":
        case "utf-8":
          return de(this, De, Ge);
        case "ascii":
          return we(this, De, Ge);
        case "latin1":
        case "binary":
          return Ee(this, De, Ge);
        case "base64":
          return ce(this, De, Ge);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ue(this, De, Ge);
        default:
          if (Oe) throw new TypeError("Unknown encoding: " + We);
          We = (We + "").toLowerCase(), Oe = !0;
      }
  }
  he.prototype._isBuffer = !0;
  function ze(We, De, Ge) {
    const Oe = We[De];
    We[De] = We[Ge], We[Ge] = Oe;
  }
  he.prototype.swap16 = function() {
    const De = this.length;
    if (De % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Ge = 0; Ge < De; Ge += 2)
      ze(this, Ge, Ge + 1);
    return this;
  }, he.prototype.swap32 = function() {
    const De = this.length;
    if (De % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Ge = 0; Ge < De; Ge += 4)
      ze(this, Ge, Ge + 3), ze(this, Ge + 1, Ge + 2);
    return this;
  }, he.prototype.swap64 = function() {
    const De = this.length;
    if (De % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Ge = 0; Ge < De; Ge += 8)
      ze(this, Ge, Ge + 7), ze(this, Ge + 1, Ge + 6), ze(this, Ge + 2, Ge + 5), ze(this, Ge + 3, Ge + 4);
    return this;
  }, he.prototype.toString = function() {
    const De = this.length;
    return De === 0 ? "" : arguments.length === 0 ? de(this, 0, De) : Ue.apply(this, arguments);
  }, he.prototype.toLocaleString = he.prototype.toString, he.prototype.equals = function(De) {
    if (!he.isBuffer(De)) throw new TypeError("Argument must be a Buffer");
    return this === De ? !0 : he.compare(this, De) === 0;
  }, he.prototype.inspect = function() {
    let De = "";
    const Ge = c.INSPECT_MAX_BYTES;
    return De = this.toString("hex", 0, Ge).replace(/(.{2})/g, "$1 ").trim(), this.length > Ge && (De += " ... "), "<Buffer " + De + ">";
  }, ie && (he.prototype[ie] = he.prototype.inspect), he.prototype.compare = function(De, Ge, Oe, Ce, He) {
    if (Xt(De, Uint8Array) && (De = he.from(De, De.offset, De.byteLength)), !he.isBuffer(De))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof De
      );
    if (Ge === void 0 && (Ge = 0), Oe === void 0 && (Oe = De ? De.length : 0), Ce === void 0 && (Ce = 0), He === void 0 && (He = this.length), Ge < 0 || Oe > De.length || Ce < 0 || He > this.length)
      throw new RangeError("out of range index");
    if (Ce >= He && Ge >= Oe)
      return 0;
    if (Ce >= He)
      return -1;
    if (Ge >= Oe)
      return 1;
    if (Ge >>>= 0, Oe >>>= 0, Ce >>>= 0, He >>>= 0, this === De) return 0;
    let Xe = He - Ce, Kt = Oe - Ge;
    const tn = Math.min(Xe, Kt), Wt = this.slice(Ce, He), Yt = De.slice(Ge, Oe);
    for (let _n = 0; _n < tn; ++_n)
      if (Wt[_n] !== Yt[_n]) {
        Xe = Wt[_n], Kt = Yt[_n];
        break;
      }
    return Xe < Kt ? -1 : Kt < Xe ? 1 : 0;
  };
  function Ve(We, De, Ge, Oe, Ce) {
    if (We.length === 0) return -1;
    if (typeof Ge == "string" ? (Oe = Ge, Ge = 0) : Ge > 2147483647 ? Ge = 2147483647 : Ge < -2147483648 && (Ge = -2147483648), Ge = +Ge, wn(Ge) && (Ge = Ce ? 0 : We.length - 1), Ge < 0 && (Ge = We.length + Ge), Ge >= We.length) {
      if (Ce) return -1;
      Ge = We.length - 1;
    } else if (Ge < 0)
      if (Ce) Ge = 0;
      else return -1;
    if (typeof De == "string" && (De = he.from(De, Oe)), he.isBuffer(De))
      return De.length === 0 ? -1 : Mt(We, De, Ge, Oe, Ce);
    if (typeof De == "number")
      return De = De & 255, typeof Uint8Array.prototype.indexOf == "function" ? Ce ? Uint8Array.prototype.indexOf.call(We, De, Ge) : Uint8Array.prototype.lastIndexOf.call(We, De, Ge) : Mt(We, [De], Ge, Oe, Ce);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Mt(We, De, Ge, Oe, Ce) {
    let He = 1, Xe = We.length, Kt = De.length;
    if (Oe !== void 0 && (Oe = String(Oe).toLowerCase(), Oe === "ucs2" || Oe === "ucs-2" || Oe === "utf16le" || Oe === "utf-16le")) {
      if (We.length < 2 || De.length < 2)
        return -1;
      He = 2, Xe /= 2, Kt /= 2, Ge /= 2;
    }
    function tn(Yt, _n) {
      return He === 1 ? Yt[_n] : Yt.readUInt16BE(_n * He);
    }
    let Wt;
    if (Ce) {
      let Yt = -1;
      for (Wt = Ge; Wt < Xe; Wt++)
        if (tn(We, Wt) === tn(De, Yt === -1 ? 0 : Wt - Yt)) {
          if (Yt === -1 && (Yt = Wt), Wt - Yt + 1 === Kt) return Yt * He;
        } else
          Yt !== -1 && (Wt -= Wt - Yt), Yt = -1;
    } else
      for (Ge + Kt > Xe && (Ge = Xe - Kt), Wt = Ge; Wt >= 0; Wt--) {
        let Yt = !0;
        for (let _n = 0; _n < Kt; _n++)
          if (tn(We, Wt + _n) !== tn(De, _n)) {
            Yt = !1;
            break;
          }
        if (Yt) return Wt;
      }
    return -1;
  }
  he.prototype.includes = function(De, Ge, Oe) {
    return this.indexOf(De, Ge, Oe) !== -1;
  }, he.prototype.indexOf = function(De, Ge, Oe) {
    return Ve(this, De, Ge, Oe, !0);
  }, he.prototype.lastIndexOf = function(De, Ge, Oe) {
    return Ve(this, De, Ge, Oe, !1);
  };
  function Rt(We, De, Ge, Oe) {
    Ge = Number(Ge) || 0;
    const Ce = We.length - Ge;
    Oe ? (Oe = Number(Oe), Oe > Ce && (Oe = Ce)) : Oe = Ce;
    const He = De.length;
    Oe > He / 2 && (Oe = He / 2);
    let Xe;
    for (Xe = 0; Xe < Oe; ++Xe) {
      const Kt = parseInt(De.substr(Xe * 2, 2), 16);
      if (wn(Kt)) return Xe;
      We[Ge + Xe] = Kt;
    }
    return Xe;
  }
  function je(We, De, Ge, Oe) {
    return Qt(xn(De, We.length - Ge), We, Ge, Oe);
  }
  function jt(We, De, Ge, Oe) {
    return Qt(Zt(De), We, Ge, Oe);
  }
  function _e(We, De, Ge, Oe) {
    return Qt(An(De), We, Ge, Oe);
  }
  function se(We, De, Ge, Oe) {
    return Qt(Gt(De, We.length - Ge), We, Ge, Oe);
  }
  he.prototype.write = function(De, Ge, Oe, Ce) {
    if (Ge === void 0)
      Ce = "utf8", Oe = this.length, Ge = 0;
    else if (Oe === void 0 && typeof Ge == "string")
      Ce = Ge, Oe = this.length, Ge = 0;
    else if (isFinite(Ge))
      Ge = Ge >>> 0, isFinite(Oe) ? (Oe = Oe >>> 0, Ce === void 0 && (Ce = "utf8")) : (Ce = Oe, Oe = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const He = this.length - Ge;
    if ((Oe === void 0 || Oe > He) && (Oe = He), De.length > 0 && (Oe < 0 || Ge < 0) || Ge > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Ce || (Ce = "utf8");
    let Xe = !1;
    for (; ; )
      switch (Ce) {
        case "hex":
          return Rt(this, De, Ge, Oe);
        case "utf8":
        case "utf-8":
          return je(this, De, Ge, Oe);
        case "ascii":
        case "latin1":
        case "binary":
          return jt(this, De, Ge, Oe);
        case "base64":
          return _e(this, De, Ge, Oe);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return se(this, De, Ge, Oe);
        default:
          if (Xe) throw new TypeError("Unknown encoding: " + Ce);
          Ce = ("" + Ce).toLowerCase(), Xe = !0;
      }
  }, he.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ce(We, De, Ge) {
    return De === 0 && Ge === We.length ? t.fromByteArray(We) : t.fromByteArray(We.slice(De, Ge));
  }
  function de(We, De, Ge) {
    Ge = Math.min(We.length, Ge);
    const Oe = [];
    let Ce = De;
    for (; Ce < Ge; ) {
      const He = We[Ce];
      let Xe = null, Kt = He > 239 ? 4 : He > 223 ? 3 : He > 191 ? 2 : 1;
      if (Ce + Kt <= Ge) {
        let tn, Wt, Yt, _n;
        switch (Kt) {
          case 1:
            He < 128 && (Xe = He);
            break;
          case 2:
            tn = We[Ce + 1], (tn & 192) === 128 && (_n = (He & 31) << 6 | tn & 63, _n > 127 && (Xe = _n));
            break;
          case 3:
            tn = We[Ce + 1], Wt = We[Ce + 2], (tn & 192) === 128 && (Wt & 192) === 128 && (_n = (He & 15) << 12 | (tn & 63) << 6 | Wt & 63, _n > 2047 && (_n < 55296 || _n > 57343) && (Xe = _n));
            break;
          case 4:
            tn = We[Ce + 1], Wt = We[Ce + 2], Yt = We[Ce + 3], (tn & 192) === 128 && (Wt & 192) === 128 && (Yt & 192) === 128 && (_n = (He & 15) << 18 | (tn & 63) << 12 | (Wt & 63) << 6 | Yt & 63, _n > 65535 && _n < 1114112 && (Xe = _n));
        }
      }
      Xe === null ? (Xe = 65533, Kt = 1) : Xe > 65535 && (Xe -= 65536, Oe.push(Xe >>> 10 & 1023 | 55296), Xe = 56320 | Xe & 1023), Oe.push(Xe), Ce += Kt;
    }
    return ve(Oe);
  }
  const pe = 4096;
  function ve(We) {
    const De = We.length;
    if (De <= pe)
      return String.fromCharCode.apply(String, We);
    let Ge = "", Oe = 0;
    for (; Oe < De; )
      Ge += String.fromCharCode.apply(
        String,
        We.slice(Oe, Oe += pe)
      );
    return Ge;
  }
  function we(We, De, Ge) {
    let Oe = "";
    Ge = Math.min(We.length, Ge);
    for (let Ce = De; Ce < Ge; ++Ce)
      Oe += String.fromCharCode(We[Ce] & 127);
    return Oe;
  }
  function Ee(We, De, Ge) {
    let Oe = "";
    Ge = Math.min(We.length, Ge);
    for (let Ce = De; Ce < Ge; ++Ce)
      Oe += String.fromCharCode(We[Ce]);
    return Oe;
  }
  function xe(We, De, Ge) {
    const Oe = We.length;
    (!De || De < 0) && (De = 0), (!Ge || Ge < 0 || Ge > Oe) && (Ge = Oe);
    let Ce = "";
    for (let He = De; He < Ge; ++He)
      Ce += Qe[We[He]];
    return Ce;
  }
  function ue(We, De, Ge) {
    const Oe = We.slice(De, Ge);
    let Ce = "";
    for (let He = 0; He < Oe.length - 1; He += 2)
      Ce += String.fromCharCode(Oe[He] + Oe[He + 1] * 256);
    return Ce;
  }
  he.prototype.slice = function(De, Ge) {
    const Oe = this.length;
    De = ~~De, Ge = Ge === void 0 ? Oe : ~~Ge, De < 0 ? (De += Oe, De < 0 && (De = 0)) : De > Oe && (De = Oe), Ge < 0 ? (Ge += Oe, Ge < 0 && (Ge = 0)) : Ge > Oe && (Ge = Oe), Ge < De && (Ge = De);
    const Ce = this.subarray(De, Ge);
    return Object.setPrototypeOf(Ce, he.prototype), Ce;
  };
  function ge(We, De, Ge) {
    if (We % 1 !== 0 || We < 0) throw new RangeError("offset is not uint");
    if (We + De > Ge) throw new RangeError("Trying to access beyond buffer length");
  }
  he.prototype.readUintLE = he.prototype.readUIntLE = function(De, Ge, Oe) {
    De = De >>> 0, Ge = Ge >>> 0, Oe || ge(De, Ge, this.length);
    let Ce = this[De], He = 1, Xe = 0;
    for (; ++Xe < Ge && (He *= 256); )
      Ce += this[De + Xe] * He;
    return Ce;
  }, he.prototype.readUintBE = he.prototype.readUIntBE = function(De, Ge, Oe) {
    De = De >>> 0, Ge = Ge >>> 0, Oe || ge(De, Ge, this.length);
    let Ce = this[De + --Ge], He = 1;
    for (; Ge > 0 && (He *= 256); )
      Ce += this[De + --Ge] * He;
    return Ce;
  }, he.prototype.readUint8 = he.prototype.readUInt8 = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 1, this.length), this[De];
  }, he.prototype.readUint16LE = he.prototype.readUInt16LE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 2, this.length), this[De] | this[De + 1] << 8;
  }, he.prototype.readUint16BE = he.prototype.readUInt16BE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 2, this.length), this[De] << 8 | this[De + 1];
  }, he.prototype.readUint32LE = he.prototype.readUInt32LE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), (this[De] | this[De + 1] << 8 | this[De + 2] << 16) + this[De + 3] * 16777216;
  }, he.prototype.readUint32BE = he.prototype.readUInt32BE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), this[De] * 16777216 + (this[De + 1] << 16 | this[De + 2] << 8 | this[De + 3]);
  }, he.prototype.readBigUInt64LE = Dt(function(De) {
    De = De >>> 0, $t(De, "offset");
    const Ge = this[De], Oe = this[De + 7];
    (Ge === void 0 || Oe === void 0) && Jt(De, this.length - 8);
    const Ce = Ge + this[++De] * 2 ** 8 + this[++De] * 2 ** 16 + this[++De] * 2 ** 24, He = this[++De] + this[++De] * 2 ** 8 + this[++De] * 2 ** 16 + Oe * 2 ** 24;
    return BigInt(Ce) + (BigInt(He) << BigInt(32));
  }), he.prototype.readBigUInt64BE = Dt(function(De) {
    De = De >>> 0, $t(De, "offset");
    const Ge = this[De], Oe = this[De + 7];
    (Ge === void 0 || Oe === void 0) && Jt(De, this.length - 8);
    const Ce = Ge * 2 ** 24 + this[++De] * 2 ** 16 + this[++De] * 2 ** 8 + this[++De], He = this[++De] * 2 ** 24 + this[++De] * 2 ** 16 + this[++De] * 2 ** 8 + Oe;
    return (BigInt(Ce) << BigInt(32)) + BigInt(He);
  }), he.prototype.readIntLE = function(De, Ge, Oe) {
    De = De >>> 0, Ge = Ge >>> 0, Oe || ge(De, Ge, this.length);
    let Ce = this[De], He = 1, Xe = 0;
    for (; ++Xe < Ge && (He *= 256); )
      Ce += this[De + Xe] * He;
    return He *= 128, Ce >= He && (Ce -= Math.pow(2, 8 * Ge)), Ce;
  }, he.prototype.readIntBE = function(De, Ge, Oe) {
    De = De >>> 0, Ge = Ge >>> 0, Oe || ge(De, Ge, this.length);
    let Ce = Ge, He = 1, Xe = this[De + --Ce];
    for (; Ce > 0 && (He *= 256); )
      Xe += this[De + --Ce] * He;
    return He *= 128, Xe >= He && (Xe -= Math.pow(2, 8 * Ge)), Xe;
  }, he.prototype.readInt8 = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 1, this.length), this[De] & 128 ? (255 - this[De] + 1) * -1 : this[De];
  }, he.prototype.readInt16LE = function(De, Ge) {
    De = De >>> 0, Ge || ge(De, 2, this.length);
    const Oe = this[De] | this[De + 1] << 8;
    return Oe & 32768 ? Oe | 4294901760 : Oe;
  }, he.prototype.readInt16BE = function(De, Ge) {
    De = De >>> 0, Ge || ge(De, 2, this.length);
    const Oe = this[De + 1] | this[De] << 8;
    return Oe & 32768 ? Oe | 4294901760 : Oe;
  }, he.prototype.readInt32LE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), this[De] | this[De + 1] << 8 | this[De + 2] << 16 | this[De + 3] << 24;
  }, he.prototype.readInt32BE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), this[De] << 24 | this[De + 1] << 16 | this[De + 2] << 8 | this[De + 3];
  }, he.prototype.readBigInt64LE = Dt(function(De) {
    De = De >>> 0, $t(De, "offset");
    const Ge = this[De], Oe = this[De + 7];
    (Ge === void 0 || Oe === void 0) && Jt(De, this.length - 8);
    const Ce = this[De + 4] + this[De + 5] * 2 ** 8 + this[De + 6] * 2 ** 16 + (Oe << 24);
    return (BigInt(Ce) << BigInt(32)) + BigInt(Ge + this[++De] * 2 ** 8 + this[++De] * 2 ** 16 + this[++De] * 2 ** 24);
  }), he.prototype.readBigInt64BE = Dt(function(De) {
    De = De >>> 0, $t(De, "offset");
    const Ge = this[De], Oe = this[De + 7];
    (Ge === void 0 || Oe === void 0) && Jt(De, this.length - 8);
    const Ce = (Ge << 24) + // Overflow
    this[++De] * 2 ** 16 + this[++De] * 2 ** 8 + this[++De];
    return (BigInt(Ce) << BigInt(32)) + BigInt(this[++De] * 2 ** 24 + this[++De] * 2 ** 16 + this[++De] * 2 ** 8 + Oe);
  }), he.prototype.readFloatLE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), n.read(this, De, !0, 23, 4);
  }, he.prototype.readFloatBE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 4, this.length), n.read(this, De, !1, 23, 4);
  }, he.prototype.readDoubleLE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 8, this.length), n.read(this, De, !0, 52, 8);
  }, he.prototype.readDoubleBE = function(De, Ge) {
    return De = De >>> 0, Ge || ge(De, 8, this.length), n.read(this, De, !1, 52, 8);
  };
  function Be(We, De, Ge, Oe, Ce, He) {
    if (!he.isBuffer(We)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (De > Ce || De < He) throw new RangeError('"value" argument is out of bounds');
    if (Ge + Oe > We.length) throw new RangeError("Index out of range");
  }
  he.prototype.writeUintLE = he.prototype.writeUIntLE = function(De, Ge, Oe, Ce) {
    if (De = +De, Ge = Ge >>> 0, Oe = Oe >>> 0, !Ce) {
      const Kt = Math.pow(2, 8 * Oe) - 1;
      Be(this, De, Ge, Oe, Kt, 0);
    }
    let He = 1, Xe = 0;
    for (this[Ge] = De & 255; ++Xe < Oe && (He *= 256); )
      this[Ge + Xe] = De / He & 255;
    return Ge + Oe;
  }, he.prototype.writeUintBE = he.prototype.writeUIntBE = function(De, Ge, Oe, Ce) {
    if (De = +De, Ge = Ge >>> 0, Oe = Oe >>> 0, !Ce) {
      const Kt = Math.pow(2, 8 * Oe) - 1;
      Be(this, De, Ge, Oe, Kt, 0);
    }
    let He = Oe - 1, Xe = 1;
    for (this[Ge + He] = De & 255; --He >= 0 && (Xe *= 256); )
      this[Ge + He] = De / Xe & 255;
    return Ge + Oe;
  }, he.prototype.writeUint8 = he.prototype.writeUInt8 = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 1, 255, 0), this[Ge] = De & 255, Ge + 1;
  }, he.prototype.writeUint16LE = he.prototype.writeUInt16LE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 2, 65535, 0), this[Ge] = De & 255, this[Ge + 1] = De >>> 8, Ge + 2;
  }, he.prototype.writeUint16BE = he.prototype.writeUInt16BE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 2, 65535, 0), this[Ge] = De >>> 8, this[Ge + 1] = De & 255, Ge + 2;
  }, he.prototype.writeUint32LE = he.prototype.writeUInt32LE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 4, 4294967295, 0), this[Ge + 3] = De >>> 24, this[Ge + 2] = De >>> 16, this[Ge + 1] = De >>> 8, this[Ge] = De & 255, Ge + 4;
  }, he.prototype.writeUint32BE = he.prototype.writeUInt32BE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 4, 4294967295, 0), this[Ge] = De >>> 24, this[Ge + 1] = De >>> 16, this[Ge + 2] = De >>> 8, this[Ge + 3] = De & 255, Ge + 4;
  };
  function Ne(We, De, Ge, Oe, Ce) {
    Le(De, Oe, Ce, We, Ge, 7);
    let He = Number(De & BigInt(4294967295));
    We[Ge++] = He, He = He >> 8, We[Ge++] = He, He = He >> 8, We[Ge++] = He, He = He >> 8, We[Ge++] = He;
    let Xe = Number(De >> BigInt(32) & BigInt(4294967295));
    return We[Ge++] = Xe, Xe = Xe >> 8, We[Ge++] = Xe, Xe = Xe >> 8, We[Ge++] = Xe, Xe = Xe >> 8, We[Ge++] = Xe, Ge;
  }
  function Fe(We, De, Ge, Oe, Ce) {
    Le(De, Oe, Ce, We, Ge, 7);
    let He = Number(De & BigInt(4294967295));
    We[Ge + 7] = He, He = He >> 8, We[Ge + 6] = He, He = He >> 8, We[Ge + 5] = He, He = He >> 8, We[Ge + 4] = He;
    let Xe = Number(De >> BigInt(32) & BigInt(4294967295));
    return We[Ge + 3] = Xe, Xe = Xe >> 8, We[Ge + 2] = Xe, Xe = Xe >> 8, We[Ge + 1] = Xe, Xe = Xe >> 8, We[Ge] = Xe, Ge + 8;
  }
  he.prototype.writeBigUInt64LE = Dt(function(De, Ge = 0) {
    return Ne(this, De, Ge, BigInt(0), BigInt("0xffffffffffffffff"));
  }), he.prototype.writeBigUInt64BE = Dt(function(De, Ge = 0) {
    return Fe(this, De, Ge, BigInt(0), BigInt("0xffffffffffffffff"));
  }), he.prototype.writeIntLE = function(De, Ge, Oe, Ce) {
    if (De = +De, Ge = Ge >>> 0, !Ce) {
      const tn = Math.pow(2, 8 * Oe - 1);
      Be(this, De, Ge, Oe, tn - 1, -tn);
    }
    let He = 0, Xe = 1, Kt = 0;
    for (this[Ge] = De & 255; ++He < Oe && (Xe *= 256); )
      De < 0 && Kt === 0 && this[Ge + He - 1] !== 0 && (Kt = 1), this[Ge + He] = (De / Xe >> 0) - Kt & 255;
    return Ge + Oe;
  }, he.prototype.writeIntBE = function(De, Ge, Oe, Ce) {
    if (De = +De, Ge = Ge >>> 0, !Ce) {
      const tn = Math.pow(2, 8 * Oe - 1);
      Be(this, De, Ge, Oe, tn - 1, -tn);
    }
    let He = Oe - 1, Xe = 1, Kt = 0;
    for (this[Ge + He] = De & 255; --He >= 0 && (Xe *= 256); )
      De < 0 && Kt === 0 && this[Ge + He + 1] !== 0 && (Kt = 1), this[Ge + He] = (De / Xe >> 0) - Kt & 255;
    return Ge + Oe;
  }, he.prototype.writeInt8 = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 1, 127, -128), De < 0 && (De = 255 + De + 1), this[Ge] = De & 255, Ge + 1;
  }, he.prototype.writeInt16LE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 2, 32767, -32768), this[Ge] = De & 255, this[Ge + 1] = De >>> 8, Ge + 2;
  }, he.prototype.writeInt16BE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 2, 32767, -32768), this[Ge] = De >>> 8, this[Ge + 1] = De & 255, Ge + 2;
  }, he.prototype.writeInt32LE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 4, 2147483647, -2147483648), this[Ge] = De & 255, this[Ge + 1] = De >>> 8, this[Ge + 2] = De >>> 16, this[Ge + 3] = De >>> 24, Ge + 4;
  }, he.prototype.writeInt32BE = function(De, Ge, Oe) {
    return De = +De, Ge = Ge >>> 0, Oe || Be(this, De, Ge, 4, 2147483647, -2147483648), De < 0 && (De = 4294967295 + De + 1), this[Ge] = De >>> 24, this[Ge + 1] = De >>> 16, this[Ge + 2] = De >>> 8, this[Ge + 3] = De & 255, Ge + 4;
  }, he.prototype.writeBigInt64LE = Dt(function(De, Ge = 0) {
    return Ne(this, De, Ge, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), he.prototype.writeBigInt64BE = Dt(function(De, Ge = 0) {
    return Fe(this, De, Ge, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Pe(We, De, Ge, Oe, Ce, He) {
    if (Ge + Oe > We.length) throw new RangeError("Index out of range");
    if (Ge < 0) throw new RangeError("Index out of range");
  }
  function Je(We, De, Ge, Oe, Ce) {
    return De = +De, Ge = Ge >>> 0, Ce || Pe(We, De, Ge, 4), n.write(We, De, Ge, Oe, 23, 4), Ge + 4;
  }
  he.prototype.writeFloatLE = function(De, Ge, Oe) {
    return Je(this, De, Ge, !0, Oe);
  }, he.prototype.writeFloatBE = function(De, Ge, Oe) {
    return Je(this, De, Ge, !1, Oe);
  };
  function Ke(We, De, Ge, Oe, Ce) {
    return De = +De, Ge = Ge >>> 0, Ce || Pe(We, De, Ge, 8), n.write(We, De, Ge, Oe, 52, 8), Ge + 8;
  }
  he.prototype.writeDoubleLE = function(De, Ge, Oe) {
    return Ke(this, De, Ge, !0, Oe);
  }, he.prototype.writeDoubleBE = function(De, Ge, Oe) {
    return Ke(this, De, Ge, !1, Oe);
  }, he.prototype.copy = function(De, Ge, Oe, Ce) {
    if (!he.isBuffer(De)) throw new TypeError("argument should be a Buffer");
    if (Oe || (Oe = 0), !Ce && Ce !== 0 && (Ce = this.length), Ge >= De.length && (Ge = De.length), Ge || (Ge = 0), Ce > 0 && Ce < Oe && (Ce = Oe), Ce === Oe || De.length === 0 || this.length === 0) return 0;
    if (Ge < 0)
      throw new RangeError("targetStart out of bounds");
    if (Oe < 0 || Oe >= this.length) throw new RangeError("Index out of range");
    if (Ce < 0) throw new RangeError("sourceEnd out of bounds");
    Ce > this.length && (Ce = this.length), De.length - Ge < Ce - Oe && (Ce = De.length - Ge + Oe);
    const He = Ce - Oe;
    return this === De && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Ge, Oe, Ce) : Uint8Array.prototype.set.call(
      De,
      this.subarray(Oe, Ce),
      Ge
    ), He;
  }, he.prototype.fill = function(De, Ge, Oe, Ce) {
    if (typeof De == "string") {
      if (typeof Ge == "string" ? (Ce = Ge, Ge = 0, Oe = this.length) : typeof Oe == "string" && (Ce = Oe, Oe = this.length), Ce !== void 0 && typeof Ce != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Ce == "string" && !he.isEncoding(Ce))
        throw new TypeError("Unknown encoding: " + Ce);
      if (De.length === 1) {
        const Xe = De.charCodeAt(0);
        (Ce === "utf8" && Xe < 128 || Ce === "latin1") && (De = Xe);
      }
    } else typeof De == "number" ? De = De & 255 : typeof De == "boolean" && (De = Number(De));
    if (Ge < 0 || this.length < Ge || this.length < Oe)
      throw new RangeError("Out of range index");
    if (Oe <= Ge)
      return this;
    Ge = Ge >>> 0, Oe = Oe === void 0 ? this.length : Oe >>> 0, De || (De = 0);
    let He;
    if (typeof De == "number")
      for (He = Ge; He < Oe; ++He)
        this[He] = De;
    else {
      const Xe = he.isBuffer(De) ? De : he.from(De, Ce), Kt = Xe.length;
      if (Kt === 0)
        throw new TypeError('The value "' + De + '" is invalid for argument "value"');
      for (He = 0; He < Oe - Ge; ++He)
        this[He + Ge] = Xe[He % Kt];
    }
    return this;
  };
  const Ze = {};
  function Ye(We, De, Ge) {
    Ze[We] = class extends Ge {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: De.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${We}]`, this.stack, delete this.name;
      }
      get code() {
        return We;
      }
      set code(Ce) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Ce,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${We}]: ${this.message}`;
      }
    };
  }
  Ye(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(We) {
      return We ? `${We} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Ye(
    "ERR_INVALID_ARG_TYPE",
    function(We, De) {
      return `The "${We}" argument must be of type number. Received type ${typeof De}`;
    },
    TypeError
  ), Ye(
    "ERR_OUT_OF_RANGE",
    function(We, De, Ge) {
      let Oe = `The value of "${We}" is out of range.`, Ce = Ge;
      return Number.isInteger(Ge) && Math.abs(Ge) > 2 ** 32 ? Ce = Pt(String(Ge)) : typeof Ge == "bigint" && (Ce = String(Ge), (Ge > BigInt(2) ** BigInt(32) || Ge < -(BigInt(2) ** BigInt(32))) && (Ce = Pt(Ce)), Ce += "n"), Oe += ` It must be ${De}. Received ${Ce}`, Oe;
    },
    RangeError
  );
  function Pt(We) {
    let De = "", Ge = We.length;
    const Oe = We[0] === "-" ? 1 : 0;
    for (; Ge >= Oe + 4; Ge -= 3)
      De = `_${We.slice(Ge - 3, Ge)}${De}`;
    return `${We.slice(0, Ge)}${De}`;
  }
  function Ft(We, De, Ge) {
    $t(De, "offset"), (We[De] === void 0 || We[De + Ge] === void 0) && Jt(De, We.length - (Ge + 1));
  }
  function Le(We, De, Ge, Oe, Ce, He) {
    if (We > Ge || We < De) {
      const Xe = typeof De == "bigint" ? "n" : "";
      let Kt;
      throw De === 0 || De === BigInt(0) ? Kt = `>= 0${Xe} and < 2${Xe} ** ${(He + 1) * 8}${Xe}` : Kt = `>= -(2${Xe} ** ${(He + 1) * 8 - 1}${Xe}) and < 2 ** ${(He + 1) * 8 - 1}${Xe}`, new Ze.ERR_OUT_OF_RANGE("value", Kt, We);
    }
    Ft(Oe, Ce, He);
  }
  function $t(We, De) {
    if (typeof We != "number")
      throw new Ze.ERR_INVALID_ARG_TYPE(De, "number", We);
  }
  function Jt(We, De, Ge) {
    throw Math.floor(We) !== We ? ($t(We, Ge), new Ze.ERR_OUT_OF_RANGE("offset", "an integer", We)) : De < 0 ? new Ze.ERR_BUFFER_OUT_OF_BOUNDS() : new Ze.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${De}`,
      We
    );
  }
  const Ht = /[^+/0-9A-Za-z-_]/g;
  function Vt(We) {
    if (We = We.split("=")[0], We = We.trim().replace(Ht, ""), We.length < 2) return "";
    for (; We.length % 4 !== 0; )
      We = We + "=";
    return We;
  }
  function xn(We, De) {
    De = De || 1 / 0;
    let Ge;
    const Oe = We.length;
    let Ce = null;
    const He = [];
    for (let Xe = 0; Xe < Oe; ++Xe) {
      if (Ge = We.charCodeAt(Xe), Ge > 55295 && Ge < 57344) {
        if (!Ce) {
          if (Ge > 56319) {
            (De -= 3) > -1 && He.push(239, 191, 189);
            continue;
          } else if (Xe + 1 === Oe) {
            (De -= 3) > -1 && He.push(239, 191, 189);
            continue;
          }
          Ce = Ge;
          continue;
        }
        if (Ge < 56320) {
          (De -= 3) > -1 && He.push(239, 191, 189), Ce = Ge;
          continue;
        }
        Ge = (Ce - 55296 << 10 | Ge - 56320) + 65536;
      } else Ce && (De -= 3) > -1 && He.push(239, 191, 189);
      if (Ce = null, Ge < 128) {
        if ((De -= 1) < 0) break;
        He.push(Ge);
      } else if (Ge < 2048) {
        if ((De -= 2) < 0) break;
        He.push(
          Ge >> 6 | 192,
          Ge & 63 | 128
        );
      } else if (Ge < 65536) {
        if ((De -= 3) < 0) break;
        He.push(
          Ge >> 12 | 224,
          Ge >> 6 & 63 | 128,
          Ge & 63 | 128
        );
      } else if (Ge < 1114112) {
        if ((De -= 4) < 0) break;
        He.push(
          Ge >> 18 | 240,
          Ge >> 12 & 63 | 128,
          Ge >> 6 & 63 | 128,
          Ge & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return He;
  }
  function Zt(We) {
    const De = [];
    for (let Ge = 0; Ge < We.length; ++Ge)
      De.push(We.charCodeAt(Ge) & 255);
    return De;
  }
  function Gt(We, De) {
    let Ge, Oe, Ce;
    const He = [];
    for (let Xe = 0; Xe < We.length && !((De -= 2) < 0); ++Xe)
      Ge = We.charCodeAt(Xe), Oe = Ge >> 8, Ce = Ge % 256, He.push(Ce), He.push(Oe);
    return He;
  }
  function An(We) {
    return t.toByteArray(Vt(We));
  }
  function Qt(We, De, Ge, Oe) {
    let Ce;
    for (Ce = 0; Ce < Oe && !(Ce + Ge >= De.length || Ce >= We.length); ++Ce)
      De[Ce + Ge] = We[Ce];
    return Ce;
  }
  function Xt(We, De) {
    return We instanceof De || We != null && We.constructor != null && We.constructor.name != null && We.constructor.name === De.name;
  }
  function wn(We) {
    return We !== We;
  }
  const Qe = function() {
    const We = "0123456789abcdef", De = new Array(256);
    for (let Ge = 0; Ge < 16; ++Ge) {
      const Oe = Ge * 16;
      for (let Ce = 0; Ce < 16; ++Ce)
        De[Oe + Ce] = We[Ge] + We[Ce];
    }
    return De;
  }();
  function Dt(We) {
    return typeof BigInt > "u" ? en : We;
  }
  function en() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
var global$1 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : {}, inherits$3;
typeof Object.create == "function" ? inherits$3 = function(t, n) {
  t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : inherits$3 = function(t, n) {
  t.super_ = n;
  var ie = function() {
  };
  ie.prototype = n.prototype, t.prototype = new ie(), t.prototype.constructor = t;
};
var inherits$1$1 = inherits$3;
function inspect$1(c, t) {
  var n = {
    seen: [],
    stylize: stylizeNoColor
  };
  return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), isBoolean(t) ? n.showHidden = t : t && _extend(n, t), isUndefined(n.showHidden) && (n.showHidden = !1), isUndefined(n.depth) && (n.depth = 2), isUndefined(n.colors) && (n.colors = !1), isUndefined(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = stylizeWithColor), formatValue(n, c, n.depth);
}
inspect$1.colors = {
  bold: [1, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  white: [37, 39],
  grey: [90, 39],
  black: [30, 39],
  blue: [34, 39],
  cyan: [36, 39],
  green: [32, 39],
  magenta: [35, 39],
  red: [31, 39],
  yellow: [33, 39]
};
inspect$1.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  // "name": intentionally not styling
  regexp: "red"
};
function stylizeWithColor(c, t) {
  var n = inspect$1.styles[t];
  return n ? "\x1B[" + inspect$1.colors[n][0] + "m" + c + "\x1B[" + inspect$1.colors[n][1] + "m" : c;
}
function stylizeNoColor(c, t) {
  return c;
}
function arrayToHash(c) {
  var t = {};
  return c.forEach(function(n, ie) {
    t[n] = !0;
  }), t;
}
function formatValue(c, t, n) {
  if (c.customInspect && t && isFunction(t.inspect) && // Filter out the util module, it's inspect function is special
  t.inspect !== inspect$1 && // Also filter out any prototype objects using the circular check.
  !(t.constructor && t.constructor.prototype === t)) {
    var ie = t.inspect(n, c);
    return isString(ie) || (ie = formatValue(c, ie, n)), ie;
  }
  var fe = formatPrimitive(c, t);
  if (fe)
    return fe;
  var ae = Object.keys(t), le = arrayToHash(ae);
  if (c.showHidden && (ae = Object.getOwnPropertyNames(t)), isError(t) && (ae.indexOf("message") >= 0 || ae.indexOf("description") >= 0))
    return formatError(t);
  if (ae.length === 0) {
    if (isFunction(t)) {
      var he = t.name ? ": " + t.name : "";
      return c.stylize("[Function" + he + "]", "special");
    }
    if (isRegExp(t))
      return c.stylize(RegExp.prototype.toString.call(t), "regexp");
    if (isDate(t))
      return c.stylize(Date.prototype.toString.call(t), "date");
    if (isError(t))
      return formatError(t);
  }
  var me = "", ye = !1, be = ["{", "}"];
  if (isArray(t) && (ye = !0, be = ["[", "]"]), isFunction(t)) {
    var Ae = t.name ? ": " + t.name : "";
    me = " [Function" + Ae + "]";
  }
  if (isRegExp(t) && (me = " " + RegExp.prototype.toString.call(t)), isDate(t) && (me = " " + Date.prototype.toUTCString.call(t)), isError(t) && (me = " " + formatError(t)), ae.length === 0 && (!ye || t.length == 0))
    return be[0] + me + be[1];
  if (n < 0)
    return isRegExp(t) ? c.stylize(RegExp.prototype.toString.call(t), "regexp") : c.stylize("[Object]", "special");
  c.seen.push(t);
  var Se;
  return ye ? Se = formatArray(c, t, n, le, ae) : Se = ae.map(function($e) {
    return formatProperty(c, t, n, le, $e, ye);
  }), c.seen.pop(), reduceToSingleString(Se, me, be);
}
function formatPrimitive(c, t) {
  if (isUndefined(t))
    return c.stylize("undefined", "undefined");
  if (isString(t)) {
    var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
    return c.stylize(n, "string");
  }
  if (isNumber(t))
    return c.stylize("" + t, "number");
  if (isBoolean(t))
    return c.stylize("" + t, "boolean");
  if (isNull(t))
    return c.stylize("null", "null");
}
function formatError(c) {
  return "[" + Error.prototype.toString.call(c) + "]";
}
function formatArray(c, t, n, ie, fe) {
  for (var ae = [], le = 0, he = t.length; le < he; ++le)
    hasOwnProperty(t, String(le)) ? ae.push(formatProperty(
      c,
      t,
      n,
      ie,
      String(le),
      !0
    )) : ae.push("");
  return fe.forEach(function(me) {
    me.match(/^\d+$/) || ae.push(formatProperty(
      c,
      t,
      n,
      ie,
      me,
      !0
    ));
  }), ae;
}
function formatProperty(c, t, n, ie, fe, ae) {
  var le, he, me;
  if (me = Object.getOwnPropertyDescriptor(t, fe) || { value: t[fe] }, me.get ? me.set ? he = c.stylize("[Getter/Setter]", "special") : he = c.stylize("[Getter]", "special") : me.set && (he = c.stylize("[Setter]", "special")), hasOwnProperty(ie, fe) || (le = "[" + fe + "]"), he || (c.seen.indexOf(me.value) < 0 ? (isNull(n) ? he = formatValue(c, me.value, null) : he = formatValue(c, me.value, n - 1), he.indexOf(`
`) > -1 && (ae ? he = he.split(`
`).map(function(ye) {
    return "  " + ye;
  }).join(`
`).substr(2) : he = `
` + he.split(`
`).map(function(ye) {
    return "   " + ye;
  }).join(`
`))) : he = c.stylize("[Circular]", "special")), isUndefined(le)) {
    if (ae && fe.match(/^\d+$/))
      return he;
    le = JSON.stringify("" + fe), le.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (le = le.substr(1, le.length - 2), le = c.stylize(le, "name")) : (le = le.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), le = c.stylize(le, "string"));
  }
  return le + ": " + he;
}
function reduceToSingleString(c, t, n) {
  var ie = c.reduce(function(fe, ae) {
    return ae.indexOf(`
`) >= 0, fe + ae.replace(/\u001b\[\d\d?m/g, "").length + 1;
  }, 0);
  return ie > 60 ? n[0] + (t === "" ? "" : t + `
 `) + " " + c.join(`,
  `) + " " + n[1] : n[0] + t + " " + c.join(", ") + " " + n[1];
}
function isArray(c) {
  return Array.isArray(c);
}
function isBoolean(c) {
  return typeof c == "boolean";
}
function isNull(c) {
  return c === null;
}
function isNumber(c) {
  return typeof c == "number";
}
function isString(c) {
  return typeof c == "string";
}
function isUndefined(c) {
  return c === void 0;
}
function isRegExp(c) {
  return isObject$1(c) && objectToString(c) === "[object RegExp]";
}
function isObject$1(c) {
  return typeof c == "object" && c !== null;
}
function isDate(c) {
  return isObject$1(c) && objectToString(c) === "[object Date]";
}
function isError(c) {
  return isObject$1(c) && (objectToString(c) === "[object Error]" || c instanceof Error);
}
function isFunction(c) {
  return typeof c == "function";
}
function isPrimitive(c) {
  return c === null || typeof c == "boolean" || typeof c == "number" || typeof c == "string" || typeof c == "symbol" || // ES6 symbol
  typeof c > "u";
}
function objectToString(c) {
  return Object.prototype.toString.call(c);
}
function _extend(c, t) {
  if (!t || !isObject$1(t)) return c;
  for (var n = Object.keys(t), ie = n.length; ie--; )
    c[n[ie]] = t[n[ie]];
  return c;
}
function hasOwnProperty(c, t) {
  return Object.prototype.hasOwnProperty.call(c, t);
}
function compare(c, t) {
  if (c === t)
    return 0;
  for (var n = c.length, ie = t.length, fe = 0, ae = Math.min(n, ie); fe < ae; ++fe)
    if (c[fe] !== t[fe]) {
      n = c[fe], ie = t[fe];
      break;
    }
  return n < ie ? -1 : ie < n ? 1 : 0;
}
var hasOwn = Object.prototype.hasOwnProperty, objectKeys = Object.keys || function(c) {
  var t = [];
  for (var n in c)
    hasOwn.call(c, n) && t.push(n);
  return t;
}, pSlice = Array.prototype.slice, _functionsHaveNames;
function functionsHaveNames() {
  return typeof _functionsHaveNames < "u" ? _functionsHaveNames : _functionsHaveNames = function() {
    return (function() {
    }).name === "foo";
  }();
}
function pToString(c) {
  return Object.prototype.toString.call(c);
}
function isView(c) {
  return buffer$1.isBuffer(c) || typeof global$1.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(c) : c ? !!(c instanceof DataView || c.buffer && c.buffer instanceof ArrayBuffer) : !1;
}
function assert$9(c, t) {
  c || fail(c, !0, t, "==", ok);
}
var regex = /\s*function\s+([^\(\s]*)\s*/;
function getName(c) {
  if (isFunction(c)) {
    if (functionsHaveNames())
      return c.name;
    var t = c.toString(), n = t.match(regex);
    return n && n[1];
  }
}
assert$9.AssertionError = AssertionError;
function AssertionError(c) {
  this.name = "AssertionError", this.actual = c.actual, this.expected = c.expected, this.operator = c.operator, c.message ? (this.message = c.message, this.generatedMessage = !1) : (this.message = getMessage(this), this.generatedMessage = !0);
  var t = c.stackStartFunction || fail;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, t);
  else {
    var n = new Error();
    if (n.stack) {
      var ie = n.stack, fe = getName(t), ae = ie.indexOf(`
` + fe);
      if (ae >= 0) {
        var le = ie.indexOf(`
`, ae + 1);
        ie = ie.substring(le + 1);
      }
      this.stack = ie;
    }
  }
}
inherits$1$1(AssertionError, Error);
function truncate(c, t) {
  return typeof c == "string" ? c.length < t ? c : c.slice(0, t) : c;
}
function inspect(c) {
  if (functionsHaveNames() || !isFunction(c))
    return inspect$1(c);
  var t = getName(c), n = t ? ": " + t : "";
  return "[Function" + n + "]";
}
function getMessage(c) {
  return truncate(inspect(c.actual), 128) + " " + c.operator + " " + truncate(inspect(c.expected), 128);
}
function fail(c, t, n, ie, fe) {
  throw new AssertionError({
    message: n,
    actual: c,
    expected: t,
    operator: ie,
    stackStartFunction: fe
  });
}
assert$9.fail = fail;
function ok(c, t) {
  c || fail(c, !0, t, "==", ok);
}
assert$9.ok = ok;
assert$9.equal = equal;
function equal(c, t, n) {
  c != t && fail(c, t, n, "==", equal);
}
assert$9.notEqual = notEqual;
function notEqual(c, t, n) {
  c == t && fail(c, t, n, "!=", notEqual);
}
assert$9.deepEqual = deepEqual;
function deepEqual(c, t, n) {
  _deepEqual(c, t, !1) || fail(c, t, n, "deepEqual", deepEqual);
}
assert$9.deepStrictEqual = deepStrictEqual;
function deepStrictEqual(c, t, n) {
  _deepEqual(c, t, !0) || fail(c, t, n, "deepStrictEqual", deepStrictEqual);
}
function _deepEqual(c, t, n, ie) {
  if (c === t)
    return !0;
  if (buffer$1.isBuffer(c) && buffer$1.isBuffer(t))
    return compare(c, t) === 0;
  if (isDate(c) && isDate(t))
    return c.getTime() === t.getTime();
  if (isRegExp(c) && isRegExp(t))
    return c.source === t.source && c.global === t.global && c.multiline === t.multiline && c.lastIndex === t.lastIndex && c.ignoreCase === t.ignoreCase;
  if ((c === null || typeof c != "object") && (t === null || typeof t != "object"))
    return n ? c === t : c == t;
  if (isView(c) && isView(t) && pToString(c) === pToString(t) && !(c instanceof Float32Array || c instanceof Float64Array))
    return compare(
      new Uint8Array(c.buffer),
      new Uint8Array(t.buffer)
    ) === 0;
  if (buffer$1.isBuffer(c) !== buffer$1.isBuffer(t))
    return !1;
  ie = ie || { actual: [], expected: [] };
  var fe = ie.actual.indexOf(c);
  return fe !== -1 && fe === ie.expected.indexOf(t) ? !0 : (ie.actual.push(c), ie.expected.push(t), objEquiv(c, t, n, ie));
}
function isArguments$1(c) {
  return Object.prototype.toString.call(c) == "[object Arguments]";
}
function objEquiv(c, t, n, ie) {
  if (c == null || t === null || t === void 0)
    return !1;
  if (isPrimitive(c) || isPrimitive(t))
    return c === t;
  if (n && Object.getPrototypeOf(c) !== Object.getPrototypeOf(t))
    return !1;
  var fe = isArguments$1(c), ae = isArguments$1(t);
  if (fe && !ae || !fe && ae)
    return !1;
  if (fe)
    return c = pSlice.call(c), t = pSlice.call(t), _deepEqual(c, t, n);
  var le = objectKeys(c), he = objectKeys(t), me, ye;
  if (le.length !== he.length)
    return !1;
  for (le.sort(), he.sort(), ye = le.length - 1; ye >= 0; ye--)
    if (le[ye] !== he[ye])
      return !1;
  for (ye = le.length - 1; ye >= 0; ye--)
    if (me = le[ye], !_deepEqual(c[me], t[me], n, ie))
      return !1;
  return !0;
}
assert$9.notDeepEqual = notDeepEqual;
function notDeepEqual(c, t, n) {
  _deepEqual(c, t, !1) && fail(c, t, n, "notDeepEqual", notDeepEqual);
}
assert$9.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(c, t, n) {
  _deepEqual(c, t, !0) && fail(c, t, n, "notDeepStrictEqual", notDeepStrictEqual);
}
assert$9.strictEqual = strictEqual;
function strictEqual(c, t, n) {
  c !== t && fail(c, t, n, "===", strictEqual);
}
assert$9.notStrictEqual = notStrictEqual;
function notStrictEqual(c, t, n) {
  c === t && fail(c, t, n, "!==", notStrictEqual);
}
function expectedException(c, t) {
  if (!c || !t)
    return !1;
  if (Object.prototype.toString.call(t) == "[object RegExp]")
    return t.test(c);
  try {
    if (c instanceof t)
      return !0;
  } catch {
  }
  return Error.isPrototypeOf(t) ? !1 : t.call({}, c) === !0;
}
function _tryBlock(c) {
  var t;
  try {
    c();
  } catch (n) {
    t = n;
  }
  return t;
}
function _throws(c, t, n, ie) {
  var fe;
  if (typeof t != "function")
    throw new TypeError('"block" argument must be a function');
  typeof n == "string" && (ie = n, n = null), fe = _tryBlock(t), ie = (n && n.name ? " (" + n.name + ")." : ".") + (ie ? " " + ie : "."), c && !fe && fail(fe, n, "Missing expected exception" + ie);
  var ae = typeof ie == "string", le = !c && isError(fe), he = !c && fe && !n;
  if ((le && ae && expectedException(fe, n) || he) && fail(fe, n, "Got unwanted exception" + ie), c && fe && n && !expectedException(fe, n) || !c && fe)
    throw fe;
}
assert$9.throws = throws;
function throws(c, t, n) {
  _throws(!0, c, t, n);
}
assert$9.doesNotThrow = doesNotThrow;
function doesNotThrow(c, t, n) {
  _throws(!1, c, t, n);
}
assert$9.ifError = ifError;
function ifError(c) {
  if (c) throw c;
}
class Layout {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(t, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(t, n, ie) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
}
function nameWithProperty(c, t) {
  return t.property ? c + "[" + t.property + "]" : c;
}
class ExternalLayout extends Layout {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class UInt extends Layout {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, ie) {
    return ie === void 0 && (ie = 0), n.writeUIntLE(t, ie, this.span), this.span;
  }
}
class Structure extends Layout {
  constructor(t, n, ie) {
    if (!(Array.isArray(t) && t.reduce((ae, le) => ae && le instanceof Layout, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && ie === void 0 && (ie = n, n = void 0);
    for (const ae of t)
      if (0 > ae.span && ae.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let fe = -1;
    try {
      fe = t.reduce((ae, le) => ae + le.getSpan(), 0);
    } catch {
    }
    super(fe, n), this.fields = t, this.decodePrefixes = !!ie;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let ie = 0;
    try {
      ie = this.fields.reduce((fe, ae) => {
        const le = ae.getSpan(t, n);
        return n += le, fe + le;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return ie;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const ie = this.makeDestinationObject();
    for (const fe of this.fields)
      if (fe.property !== void 0 && (ie[fe.property] = fe.decode(t, n)), n += fe.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return ie;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, ie) {
    ie === void 0 && (ie = 0);
    const fe = ie;
    let ae = 0, le = 0;
    for (const he of this.fields) {
      let me = he.span;
      if (le = 0 < me ? me : 0, he.property !== void 0) {
        const ye = t[he.property];
        ye !== void 0 && (le = he.encode(ye, n, ie), 0 > me && (me = he.getSpan(n, ie)));
      }
      ae = ie, ie += me;
    }
    return ae + le - fe;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const ie of this.fields)
      ie.property !== void 0 && 0 < t.length && (n[ie.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const ie of this.fields) {
      if (ie.property === t)
        return n;
      0 > ie.span ? n = -1 : 0 <= n && (n += ie.span);
    }
  }
}
let Blob$1 = class extends Layout {
  constructor(t, n) {
    if (!(t instanceof ExternalLayout && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let ie = -1;
    t instanceof ExternalLayout || (ie = t), super(ie, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let ie = this.span;
    return 0 > ie && (ie = this.length.decode(t, n)), ie;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    let ie = this.span;
    return 0 > ie && (ie = this.length.decode(t, n)), t.slice(n, n + ie);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, ie) {
    let fe = this.length;
    if (this.length instanceof ExternalLayout && (fe = t.length), !(buffer$1.Buffer.isBuffer(t) && fe === t.length))
      throw new TypeError(nameWithProperty("Blob.encode", this) + " requires (length " + fe + ") Buffer as src");
    if (ie + fe > n.length)
      throw new RangeError("encoding overruns Buffer");
    return n.write(t.toString("hex"), ie, fe, "hex"), this.length instanceof ExternalLayout && this.length.encode(fe, n, ie), fe;
  }
};
var u8 = (c) => new UInt(1, c), u32 = (c) => new UInt(4, c), struct = (c, t, n) => new Structure(c, t, n), blob = (c, t) => new Blob$1(c, t);
const publicKey = (c = "publicKey") => blob(32, c), uint64 = (c = "uint64") => blob(8, c);
function sendAndConfirmTransaction(c, t, n, ...ie) {
  return sendAndConfirmTransaction$1(t, n, ie, {
    skipPreflight: !1
  });
}
const TOKEN_PROGRAM_ID = new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"), FAILED_TO_FIND_ACCOUNT = "Failed to find account", INVALID_ACCOUNT_OWNER = "Invalid account owner";
function pubkeyToBuffer(c) {
  return buffer$1.Buffer.from(c.toBuffer());
}
class u64 extends BN$8 {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const t = super.toArray().reverse(), n = buffer$1.Buffer.from(t);
    if (n.length === 8)
      return n;
    assert$9(n.length < 8, "u64 too large");
    const ie = buffer$1.Buffer.alloc(8);
    return n.copy(ie), ie;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(t) {
    return assert$9(t.length === 8, `Invalid buffer length: ${t.length}`), new u64([...t].reverse().map((n) => `00${n.toString(16)}`.slice(-2)).join(""), 16);
  }
}
function isAccount(c) {
  return "publicKey" in c;
}
const AuthorityTypeCodes = {
  MintTokens: 0,
  FreezeAccount: 1,
  AccountOwner: 2,
  CloseAccount: 3
}, NATIVE_MINT = new PublicKey("So11111111111111111111111111111111111111112"), MintLayout = struct([u32("mintAuthorityOption"), publicKey("mintAuthority"), uint64("supply"), u8("decimals"), u8("isInitialized"), u32("freezeAuthorityOption"), publicKey("freezeAuthority")]), AccountLayout = struct([publicKey("mint"), publicKey("owner"), uint64("amount"), u32("delegateOption"), publicKey("delegate"), u8("state"), u32("isNativeOption"), uint64("isNative"), uint64("delegatedAmount"), u32("closeAuthorityOption"), publicKey("closeAuthority")]), MultisigLayout = struct([u8("m"), u8("n"), u8("is_initialized"), publicKey("signer1"), publicKey("signer2"), publicKey("signer3"), publicKey("signer4"), publicKey("signer5"), publicKey("signer6"), publicKey("signer7"), publicKey("signer8"), publicKey("signer9"), publicKey("signer10"), publicKey("signer11")]);
class Token {
  /**
   * @private
   */
  /**
   * The public key identifying this mint
   */
  /**
   * Program Identifier for the Token program
   */
  /**
   * Program Identifier for the Associated Token program
   */
  /**
   * Fee payer
   */
  /**
   * Create a Token object attached to the specific mint
   *
   * @param connection The connection to use
   * @param token Public key of the mint
   * @param programId token programId
   * @param payer Payer of fees
   */
  constructor(t, n, ie, fe) {
    _defineProperty(this, "connection", void 0), _defineProperty(this, "publicKey", void 0), _defineProperty(this, "programId", void 0), _defineProperty(this, "associatedProgramId", void 0), _defineProperty(this, "payer", void 0), Object.assign(this, {
      connection: t,
      publicKey: n,
      programId: ie,
      payer: fe,
      // Hard code is ok; Overriding is needed only for tests
      associatedProgramId: ASSOCIATED_TOKEN_PROGRAM_ID
    });
  }
  /**
   * Get the minimum balance for the mint to be rent exempt
   *
   * @return Number of lamports required
   */
  static async getMinBalanceRentForExemptMint(t) {
    return await t.getMinimumBalanceForRentExemption(MintLayout.span);
  }
  /**
   * Get the minimum balance for the account to be rent exempt
   *
   * @return Number of lamports required
   */
  static async getMinBalanceRentForExemptAccount(t) {
    return await t.getMinimumBalanceForRentExemption(AccountLayout.span);
  }
  /**
   * Get the minimum balance for the multsig to be rent exempt
   *
   * @return Number of lamports required
   */
  static async getMinBalanceRentForExemptMultisig(t) {
    return await t.getMinimumBalanceForRentExemption(MultisigLayout.span);
  }
  /**
   * Create and initialize a token.
   *
   * @param connection The connection to use
   * @param payer Fee payer for transaction
   * @param mintAuthority Account or multisig that will control minting
   * @param freezeAuthority Optional account or multisig that can freeze token accounts
   * @param decimals Location of the decimal place
   * @param programId Optional token programId, uses the system programId by default
   * @return Token object for the newly minted token
   */
  static async createMint(t, n, ie, fe, ae, le) {
    const he = Keypair.generate(), me = new Token(t, he.publicKey, le, n), ye = await Token.getMinBalanceRentForExemptMint(t), be = new Transaction();
    return be.add(SystemProgram.createAccount({
      fromPubkey: n.publicKey,
      newAccountPubkey: he.publicKey,
      lamports: ye,
      space: MintLayout.span,
      programId: le
    })), be.add(Token.createInitMintInstruction(le, he.publicKey, ae, ie, fe)), await sendAndConfirmTransaction("createAccount and InitializeMint", t, be, n, he), me;
  }
  /**
   * Create and initialize a new account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new empty account
   */
  async createAccount(t) {
    const n = await Token.getMinBalanceRentForExemptAccount(this.connection), ie = Keypair.generate(), fe = new Transaction();
    fe.add(SystemProgram.createAccount({
      fromPubkey: this.payer.publicKey,
      newAccountPubkey: ie.publicKey,
      lamports: n,
      space: AccountLayout.span,
      programId: this.programId
    }));
    const ae = this.publicKey;
    return fe.add(Token.createInitAccountInstruction(this.programId, ae, ie.publicKey, t)), await sendAndConfirmTransaction("createAccount and InitializeAccount", this.connection, fe, this.payer, ie), ie.publicKey;
  }
  /**
   * Create and initialize the associated account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new associated account
   */
  async createAssociatedTokenAccount(t) {
    const n = await Token.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, t);
    return this.createAssociatedTokenAccountInternal(t, n);
  }
  async createAssociatedTokenAccountInternal(t, n) {
    return await sendAndConfirmTransaction("CreateAssociatedTokenAccount", this.connection, new Transaction().add(Token.createAssociatedTokenAccountInstruction(this.associatedProgramId, this.programId, this.publicKey, n, t, this.payer.publicKey)), this.payer), n;
  }
  /**
   * Retrieve the associated account or create one if not found.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return The new associated account
   */
  async getOrCreateAssociatedAccountInfo(t) {
    const n = await Token.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, t);
    try {
      return await this.getAccountInfo(n);
    } catch (ie) {
      if (ie.message === FAILED_TO_FIND_ACCOUNT || ie.message === INVALID_ACCOUNT_OWNER) {
        try {
          await this.createAssociatedTokenAccountInternal(t, n);
        } catch {
        }
        return await this.getAccountInfo(n);
      } else
        throw ie;
    }
  }
  /**
   * Create and initialize a new account on the special native token mint.
   *
   * In order to be wrapped, the account must have a balance of native tokens
   * when it is initialized with the token program.
   *
   * This function sends lamports to the new account before initializing it.
   *
   * @param connection A solana web3 connection
   * @param programId The token program ID
   * @param owner The owner of the new token account
   * @param payer The source of the lamports to initialize, and payer of the initialization fees.
   * @param amount The amount of lamports to wrap
   * @return {Promise<PublicKey>} The new token account
   */
  static async createWrappedNativeAccount(t, n, ie, fe, ae) {
    const le = await Token.getMinBalanceRentForExemptAccount(t), he = Keypair.generate(), me = new Transaction();
    return me.add(SystemProgram.createAccount({
      fromPubkey: fe.publicKey,
      newAccountPubkey: he.publicKey,
      lamports: le,
      space: AccountLayout.span,
      programId: n
    })), me.add(SystemProgram.transfer({
      fromPubkey: fe.publicKey,
      toPubkey: he.publicKey,
      lamports: ae
    })), me.add(Token.createInitAccountInstruction(n, NATIVE_MINT, he.publicKey, ie)), await sendAndConfirmTransaction("createAccount, transfer, and initializeAccount", t, me, fe, he), he.publicKey;
  }
  /**
   * Create and initialize a new multisig.
   *
   * This account may then be used for multisignature verification
   *
   * @param m Number of required signatures
   * @param signers Full set of signers
   * @return Public key of the new multisig account
   */
  async createMultisig(t, n) {
    const ie = Keypair.generate(), fe = await Token.getMinBalanceRentForExemptMultisig(this.connection), ae = new Transaction();
    ae.add(SystemProgram.createAccount({
      fromPubkey: this.payer.publicKey,
      newAccountPubkey: ie.publicKey,
      lamports: fe,
      space: MultisigLayout.span,
      programId: this.programId
    }));
    let le = [{
      pubkey: ie.publicKey,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_RENT_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }];
    n.forEach((ye) => le.push({
      pubkey: ye,
      isSigner: !1,
      isWritable: !1
    }));
    const he = struct([u8("instruction"), u8("m")]), me = buffer$1.Buffer.alloc(he.span);
    return he.encode({
      instruction: 2,
      // InitializeMultisig instruction
      m: t
    }, me), ae.add({
      keys: le,
      programId: this.programId,
      data: me
    }), await sendAndConfirmTransaction("createAccount and InitializeMultisig", this.connection, ae, this.payer, ie), ie.publicKey;
  }
  /**
   * Retrieve mint information
   */
  async getMintInfo() {
    const t = await this.connection.getAccountInfo(this.publicKey);
    if (t === null)
      throw new Error("Failed to find mint account");
    if (!t.owner.equals(this.programId))
      throw new Error(`Invalid mint owner: ${JSON.stringify(t.owner)}`);
    if (t.data.length != MintLayout.span)
      throw new Error("Invalid mint size");
    const n = buffer$1.Buffer.from(t.data), ie = MintLayout.decode(n);
    return ie.mintAuthorityOption === 0 ? ie.mintAuthority = null : ie.mintAuthority = new PublicKey(ie.mintAuthority), ie.supply = u64.fromBuffer(ie.supply), ie.isInitialized = ie.isInitialized != 0, ie.freezeAuthorityOption === 0 ? ie.freezeAuthority = null : ie.freezeAuthority = new PublicKey(ie.freezeAuthority), ie;
  }
  /**
   * Retrieve account information
   *
   * @param account Public key of the account
   */
  async getAccountInfo(t, n) {
    const ie = await this.connection.getAccountInfo(t, n);
    if (ie === null)
      throw new Error(FAILED_TO_FIND_ACCOUNT);
    if (!ie.owner.equals(this.programId))
      throw new Error(INVALID_ACCOUNT_OWNER);
    if (ie.data.length != AccountLayout.span)
      throw new Error("Invalid account size");
    const fe = buffer$1.Buffer.from(ie.data), ae = AccountLayout.decode(fe);
    if (ae.address = t, ae.mint = new PublicKey(ae.mint), ae.owner = new PublicKey(ae.owner), ae.amount = u64.fromBuffer(ae.amount), ae.delegateOption === 0 ? (ae.delegate = null, ae.delegatedAmount = new u64()) : (ae.delegate = new PublicKey(ae.delegate), ae.delegatedAmount = u64.fromBuffer(ae.delegatedAmount)), ae.isInitialized = ae.state !== 0, ae.isFrozen = ae.state === 2, ae.isNativeOption === 1 ? (ae.rentExemptReserve = u64.fromBuffer(ae.isNative), ae.isNative = !0) : (ae.rentExemptReserve = null, ae.isNative = !1), ae.closeAuthorityOption === 0 ? ae.closeAuthority = null : ae.closeAuthority = new PublicKey(ae.closeAuthority), !ae.mint.equals(this.publicKey))
      throw new Error(`Invalid account mint: ${JSON.stringify(ae.mint)} !== ${JSON.stringify(this.publicKey)}`);
    return ae;
  }
  /**
   * Retrieve Multisig information
   *
   * @param multisig Public key of the account
   */
  async getMultisigInfo(t) {
    const n = await this.connection.getAccountInfo(t);
    if (n === null)
      throw new Error("Failed to find multisig");
    if (!n.owner.equals(this.programId))
      throw new Error("Invalid multisig owner");
    if (n.data.length != MultisigLayout.span)
      throw new Error("Invalid multisig size");
    const ie = buffer$1.Buffer.from(n.data), fe = MultisigLayout.decode(ie);
    return fe.signer1 = new PublicKey(fe.signer1), fe.signer2 = new PublicKey(fe.signer2), fe.signer3 = new PublicKey(fe.signer3), fe.signer4 = new PublicKey(fe.signer4), fe.signer5 = new PublicKey(fe.signer5), fe.signer6 = new PublicKey(fe.signer6), fe.signer7 = new PublicKey(fe.signer7), fe.signer8 = new PublicKey(fe.signer8), fe.signer9 = new PublicKey(fe.signer9), fe.signer10 = new PublicKey(fe.signer10), fe.signer11 = new PublicKey(fe.signer11), fe;
  }
  /**
   * Transfer tokens to another account
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   */
  async transfer(t, n, ie, fe, ae) {
    let le, he;
    return isAccount(ie) ? (le = ie.publicKey, he = [ie]) : (le = ie, he = fe), await sendAndConfirmTransaction("Transfer", this.connection, new Transaction().add(Token.createTransferInstruction(this.programId, t, n, le, fe, ae)), this.payer, ...he);
  }
  /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */
  async approve(t, n, ie, fe, ae) {
    let le, he;
    isAccount(ie) ? (le = ie.publicKey, he = [ie]) : (le = ie, he = fe), await sendAndConfirmTransaction("Approve", this.connection, new Transaction().add(Token.createApproveInstruction(this.programId, t, n, le, fe, ae)), this.payer, ...he);
  }
  /**
   * Remove approval for the transfer of any remaining tokens
   *
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  async revoke(t, n, ie) {
    let fe, ae;
    isAccount(n) ? (fe = n.publicKey, ae = [n]) : (fe = n, ae = ie), await sendAndConfirmTransaction("Revoke", this.connection, new Transaction().add(Token.createRevokeInstruction(this.programId, t, fe, ie)), this.payer, ...ae);
  }
  /**
   * Assign a new authority to the account
   *
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the account
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */
  async setAuthority(t, n, ie, fe, ae) {
    let le, he;
    isAccount(fe) ? (le = fe.publicKey, he = [fe]) : (le = fe, he = ae), await sendAndConfirmTransaction("SetAuthority", this.connection, new Transaction().add(Token.createSetAuthorityInstruction(this.programId, t, n, ie, le, ae)), this.payer, ...he);
  }
  /**
   * Mint new tokens
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */
  async mintTo(t, n, ie, fe) {
    let ae, le;
    isAccount(n) ? (ae = n.publicKey, le = [n]) : (ae = n, le = ie), await sendAndConfirmTransaction("MintTo", this.connection, new Transaction().add(Token.createMintToInstruction(this.programId, this.publicKey, t, ae, ie, fe)), this.payer, ...le);
  }
  /**
   * Burn tokens
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   */
  async burn(t, n, ie, fe) {
    let ae, le;
    isAccount(n) ? (ae = n.publicKey, le = [n]) : (ae = n, le = ie), await sendAndConfirmTransaction("Burn", this.connection, new Transaction().add(Token.createBurnInstruction(this.programId, this.publicKey, t, ae, ie, fe)), this.payer, ...le);
  }
  /**
   * Close account
   *
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Authority which is allowed to close the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */
  async closeAccount(t, n, ie, fe) {
    let ae, le;
    isAccount(ie) ? (ae = ie.publicKey, le = [ie]) : (ae = ie, le = fe), await sendAndConfirmTransaction("CloseAccount", this.connection, new Transaction().add(Token.createCloseAccountInstruction(this.programId, t, n, ae, fe)), this.payer, ...le);
  }
  /**
   * Freeze account
   *
   * @param account Account to freeze
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */
  async freezeAccount(t, n, ie) {
    let fe, ae;
    isAccount(n) ? (fe = n.publicKey, ae = [n]) : (fe = n, ae = ie), await sendAndConfirmTransaction("FreezeAccount", this.connection, new Transaction().add(Token.createFreezeAccountInstruction(this.programId, t, this.publicKey, fe, ie)), this.payer, ...ae);
  }
  /**
   * Thaw account
   *
   * @param account Account to thaw
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */
  async thawAccount(t, n, ie) {
    let fe, ae;
    isAccount(n) ? (fe = n.publicKey, ae = [n]) : (fe = n, ae = ie), await sendAndConfirmTransaction("ThawAccount", this.connection, new Transaction().add(Token.createThawAccountInstruction(this.programId, t, this.publicKey, fe, ie)), this.payer, ...ae);
  }
  /**
   * Transfer tokens to another account, asserting the token mint and decimals
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */
  async transferChecked(t, n, ie, fe, ae, le) {
    let he, me;
    return isAccount(ie) ? (he = ie.publicKey, me = [ie]) : (he = ie, me = fe), await sendAndConfirmTransaction("TransferChecked", this.connection, new Transaction().add(Token.createTransferCheckedInstruction(this.programId, t, this.publicKey, n, he, fe, ae, le)), this.payer, ...me);
  }
  /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account,
   * asserting the token mint and decimals
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */
  async approveChecked(t, n, ie, fe, ae, le) {
    let he, me;
    isAccount(ie) ? (he = ie.publicKey, me = [ie]) : (he = ie, me = fe), await sendAndConfirmTransaction("ApproveChecked", this.connection, new Transaction().add(Token.createApproveCheckedInstruction(this.programId, t, this.publicKey, n, he, fe, ae, le)), this.payer, ...me);
  }
  /**
   * Mint new tokens, asserting the token mint and decimals
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */
  async mintToChecked(t, n, ie, fe, ae) {
    let le, he;
    isAccount(n) ? (le = n.publicKey, he = [n]) : (le = n, he = ie), await sendAndConfirmTransaction("MintToChecked", this.connection, new Transaction().add(Token.createMintToCheckedInstruction(this.programId, this.publicKey, t, le, ie, fe, ae)), this.payer, ...he);
  }
  /**
   * Burn tokens, asserting the token mint and decimals
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   * @param decimals Number of decimals in amount to burn
   */
  async burnChecked(t, n, ie, fe, ae) {
    let le, he;
    isAccount(n) ? (le = n.publicKey, he = [n]) : (le = n, he = ie), await sendAndConfirmTransaction("BurnChecked", this.connection, new Transaction().add(Token.createBurnCheckedInstruction(this.programId, this.publicKey, t, le, ie, fe, ae)), this.payer, ...he);
  }
  /**
   * Sync amount in native SPL token account to underlying lamports
   *
   * @param nativeAccount Account to sync
   */
  async syncNative(t) {
    await sendAndConfirmTransaction("SyncNative", this.connection, new Transaction().add(Token.createSyncNativeInstruction(this.programId, t)), this.payer);
  }
  /**
   * Construct an InitializeMint instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param decimals Number of decimals in token account amounts
   * @param mintAuthority Minting authority
   * @param freezeAuthority Optional authority that can freeze token accounts
   */
  static createInitMintInstruction(t, n, ie, fe, ae) {
    let le = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: SYSVAR_RENT_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }];
    const he = struct([u8("instruction"), u8("decimals"), publicKey("mintAuthority"), u8("option"), publicKey("freezeAuthority")]);
    let me = buffer$1.Buffer.alloc(1024);
    {
      const ye = he.encode({
        instruction: 0,
        // InitializeMint instruction
        decimals: ie,
        mintAuthority: pubkeyToBuffer(fe),
        option: ae === null ? 0 : 1,
        freezeAuthority: pubkeyToBuffer(ae || new PublicKey(0))
      }, me);
      me = me.slice(0, ye);
    }
    return new TransactionInstruction({
      keys: le,
      programId: t,
      data: me
    });
  }
  /**
   * Construct an InitializeAccount instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param account New account
   * @param owner Owner of the new account
   */
  static createInitAccountInstruction(t, n, ie, fe) {
    const ae = [{
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: SYSVAR_RENT_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }], le = struct([u8("instruction")]), he = buffer$1.Buffer.alloc(le.span);
    return le.encode({
      instruction: 1
      // InitializeAccount instruction
    }, he), new TransactionInstruction({
      keys: ae,
      programId: t,
      data: he
    });
  }
  /**
   * Construct a Transfer instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   */
  static createTransferInstruction(t, n, ie, fe, ae, le) {
    const he = struct([u8("instruction"), uint64("amount")]), me = buffer$1.Buffer.alloc(he.span);
    he.encode({
      instruction: 3,
      // Transfer instruction
      amount: new u64(le).toBuffer()
    }, me);
    let ye = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? ye.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (ye.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((be) => ye.push({
      pubkey: be.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: ye,
      programId: t,
      data: me
    });
  }
  /**
   * Construct an Approve instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */
  static createApproveInstruction(t, n, ie, fe, ae, le) {
    const he = struct([u8("instruction"), uint64("amount")]), me = buffer$1.Buffer.alloc(he.span);
    he.encode({
      instruction: 4,
      // Approve instruction
      amount: new u64(le).toBuffer()
    }, me);
    let ye = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }];
    return ae.length === 0 ? ye.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (ye.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((be) => ye.push({
      pubkey: be.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: ye,
      programId: t,
      data: me
    });
  }
  /**
   * Construct a Revoke instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  static createRevokeInstruction(t, n, ie, fe) {
    const ae = struct([u8("instruction")]), le = buffer$1.Buffer.alloc(ae.span);
    ae.encode({
      instruction: 5
      // Approve instruction
    }, le);
    let he = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }];
    return fe.length === 0 ? he.push({
      pubkey: ie,
      isSigner: !0,
      isWritable: !1
    }) : (he.push({
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }), fe.forEach((me) => he.push({
      pubkey: me.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: he,
      programId: t,
      data: le
    });
  }
  /**
   * Construct a SetAuthority instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the specified type
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */
  static createSetAuthorityInstruction(t, n, ie, fe, ae, le) {
    const he = struct([u8("instruction"), u8("authorityType"), u8("option"), publicKey("newAuthority")]);
    let me = buffer$1.Buffer.alloc(1024);
    {
      const be = he.encode({
        instruction: 6,
        // SetAuthority instruction
        authorityType: AuthorityTypeCodes[fe],
        option: ie === null ? 0 : 1,
        newAuthority: pubkeyToBuffer(ie || new PublicKey(0))
      }, me);
      me = me.slice(0, be);
    }
    let ye = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }];
    return le.length === 0 ? ye.push({
      pubkey: ae,
      isSigner: !0,
      isWritable: !1
    }) : (ye.push({
      pubkey: ae,
      isSigner: !1,
      isWritable: !1
    }), le.forEach((be) => ye.push({
      pubkey: be.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: ye,
      programId: t,
      data: me
    });
  }
  /**
   * Construct a MintTo instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */
  static createMintToInstruction(t, n, ie, fe, ae, le) {
    const he = struct([u8("instruction"), uint64("amount")]), me = buffer$1.Buffer.alloc(he.span);
    he.encode({
      instruction: 7,
      // MintTo instruction
      amount: new u64(le).toBuffer()
    }, me);
    let ye = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? ye.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (ye.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((be) => ye.push({
      pubkey: be.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: ye,
      programId: t,
      data: me
    });
  }
  /**
   * Construct a Burn instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */
  static createBurnInstruction(t, n, ie, fe, ae, le) {
    const he = struct([u8("instruction"), uint64("amount")]), me = buffer$1.Buffer.alloc(he.span);
    he.encode({
      instruction: 8,
      // Burn instruction
      amount: new u64(le).toBuffer()
    }, me);
    let ye = [{
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? ye.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (ye.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((be) => ye.push({
      pubkey: be.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: ye,
      programId: t,
      data: me
    });
  }
  /**
   * Construct a Close instruction
   *
   * @param programId SPL Token program account
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Account Close authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  static createCloseAccountInstruction(t, n, ie, fe, ae) {
    const le = struct([u8("instruction")]), he = buffer$1.Buffer.alloc(le.span);
    le.encode({
      instruction: 9
      // CloseAccount instruction
    }, he);
    let me = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? me.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (me.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((ye) => me.push({
      pubkey: ye.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: me,
      programId: t,
      data: he
    });
  }
  /**
   * Construct a Freeze instruction
   *
   * @param programId SPL Token program account
   * @param account Account to freeze
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  static createFreezeAccountInstruction(t, n, ie, fe, ae) {
    const le = struct([u8("instruction")]), he = buffer$1.Buffer.alloc(le.span);
    le.encode({
      instruction: 10
      // FreezeAccount instruction
    }, he);
    let me = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }];
    return ae.length === 0 ? me.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (me.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((ye) => me.push({
      pubkey: ye.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: me,
      programId: t,
      data: he
    });
  }
  /**
   * Construct a Thaw instruction
   *
   * @param programId SPL Token program account
   * @param account Account to thaw
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  static createThawAccountInstruction(t, n, ie, fe, ae) {
    const le = struct([u8("instruction")]), he = buffer$1.Buffer.alloc(le.span);
    le.encode({
      instruction: 11
      // ThawAccount instruction
    }, he);
    let me = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }];
    return ae.length === 0 ? me.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (me.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((ye) => me.push({
      pubkey: ye.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: me,
      programId: t,
      data: he
    });
  }
  /**
   * Construct a TransferChecked instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param mint Mint account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */
  static createTransferCheckedInstruction(t, n, ie, fe, ae, le, he, me) {
    const ye = struct([u8("instruction"), uint64("amount"), u8("decimals")]), be = buffer$1.Buffer.alloc(ye.span);
    ye.encode({
      instruction: 12,
      // TransferChecked instruction
      amount: new u64(he).toBuffer(),
      decimals: me
    }, be);
    let Ae = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: fe,
      isSigner: !1,
      isWritable: !0
    }];
    return le.length === 0 ? Ae.push({
      pubkey: ae,
      isSigner: !0,
      isWritable: !1
    }) : (Ae.push({
      pubkey: ae,
      isSigner: !1,
      isWritable: !1
    }), le.forEach((Se) => Ae.push({
      pubkey: Se.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: Ae,
      programId: t,
      data: be
    });
  }
  /**
   * Construct an ApproveChecked instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param mint Mint account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */
  static createApproveCheckedInstruction(t, n, ie, fe, ae, le, he, me) {
    const ye = struct([u8("instruction"), uint64("amount"), u8("decimals")]), be = buffer$1.Buffer.alloc(ye.span);
    ye.encode({
      instruction: 13,
      // ApproveChecked instruction
      amount: new u64(he).toBuffer(),
      decimals: me
    }, be);
    let Ae = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }];
    return le.length === 0 ? Ae.push({
      pubkey: ae,
      isSigner: !0,
      isWritable: !1
    }) : (Ae.push({
      pubkey: ae,
      isSigner: !1,
      isWritable: !1
    }), le.forEach((Se) => Ae.push({
      pubkey: Se.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: Ae,
      programId: t,
      data: be
    });
  }
  /**
   * Construct a MintToChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */
  static createMintToCheckedInstruction(t, n, ie, fe, ae, le, he) {
    const me = struct([u8("instruction"), uint64("amount"), u8("decimals")]), ye = buffer$1.Buffer.alloc(me.span);
    me.encode({
      instruction: 14,
      // MintToChecked instruction
      amount: new u64(le).toBuffer(),
      decimals: he
    }, ye);
    let be = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? be.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (be.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((Ae) => be.push({
      pubkey: Ae.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: be,
      programId: t,
      data: ye
    });
  }
  /**
   * Construct a BurnChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */
  static createBurnCheckedInstruction(t, n, ie, fe, ae, le, he) {
    const me = struct([u8("instruction"), uint64("amount"), u8("decimals")]), ye = buffer$1.Buffer.alloc(me.span);
    me.encode({
      instruction: 15,
      // BurnChecked instruction
      amount: new u64(le).toBuffer(),
      decimals: he
    }, ye);
    let be = [{
      pubkey: ie,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }];
    return ae.length === 0 ? be.push({
      pubkey: fe,
      isSigner: !0,
      isWritable: !1
    }) : (be.push({
      pubkey: fe,
      isSigner: !1,
      isWritable: !1
    }), ae.forEach((Ae) => be.push({
      pubkey: Ae.publicKey,
      isSigner: !0,
      isWritable: !1
    }))), new TransactionInstruction({
      keys: be,
      programId: t,
      data: ye
    });
  }
  /**
   * Construct a SyncNative instruction
   *
   * @param programId SPL Token program account
   * @param nativeAccount Account to sync lamports from
   */
  static createSyncNativeInstruction(t, n) {
    const ie = struct([u8("instruction")]), fe = buffer$1.Buffer.alloc(ie.span);
    ie.encode({
      instruction: 17
      // SyncNative instruction
    }, fe);
    let ae = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }];
    return new TransactionInstruction({
      keys: ae,
      programId: t,
      data: fe
    });
  }
  /**
   * Get the address for the associated token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param owner Owner of the new account
   * @return Public key of the associated token account
   */
  static async getAssociatedTokenAddress(t, n, ie, fe, ae = !1) {
    if (!ae && !PublicKey.isOnCurve(fe.toBuffer()))
      throw new Error(`Owner cannot sign: ${fe.toString()}`);
    return (await PublicKey.findProgramAddress([fe.toBuffer(), n.toBuffer(), ie.toBuffer()], t))[0];
  }
  /**
   * Construct the AssociatedTokenProgram instruction to create the associated
   * token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param associatedAccount New associated account
   * @param owner Owner of the new account
   * @param payer Payer of fees
   */
  static createAssociatedTokenAccountInstruction(t, n, ie, fe, ae, le) {
    const he = buffer$1.Buffer.alloc(0);
    let me = [{
      pubkey: le,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: fe,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: ae,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: ie,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: SystemProgram.programId,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: SYSVAR_RENT_PUBKEY,
      isSigner: !1,
      isWritable: !1
    }];
    return new TransactionInstruction({
      keys: me,
      programId: t,
      data: he
    });
  }
}
class SolanaProvider {
  constructor(t) {
    this.modalInterface = new defaultModal(), this.wallet = ChainWallet.Phantom, this.network = t, this.axiosInstance = ky.create({
      prefixUrl: this.network === Network.MAINNET ? "https://apiv3.droplinked.com" : "https://apiv3dev.droplinked.com"
    }), this.address = "";
  }
  executeAirdrop(t) {
    throw new Error("Method not implemented.");
  }
  customPayment(t) {
    throw new Error("Method not implemented.");
  }
  unstoppableLogin(t, n) {
    throw new Error("Method not implemented.");
  }
  claimNFTs(t) {
    throw new Error("Method not implemented.");
  }
  setAxiosInstance(t) {
    return this.axiosInstance = t, this;
  }
  async walletLogin() {
    if (!window.solana || !window.solana.isPhantom)
      throw window.open("https://phantom.app/", "_blank"), new WalletNotFoundException();
    const t = window.solana, n = await t.connect(), ie = await getNonce(n.publicKey.toString(), this.axiosInstance), fe = (/* @__PURE__ */ new Date()).toLocaleString(), ae = `Welcome to Droplinked! Please sign this message to verify your ownership over your wallet and log in. - Nonce: ${ie} - Date: ${fe}`, le = new TextEncoder().encode(ae), he = utils$g.base58.encode(
      (await t.signMessage(le, "utf8")).signature
    );
    return {
      address: n.publicKey.toString(),
      signature: he,
      nonce: ie,
      date: fe
    };
  }
  deployShop(t) {
    throw new Error("Method not implemented.");
  }
  recordProduct(t, n) {
    throw new Error("Method not implemented.");
  }
  publishRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  approveRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  disapproveRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  async payment(t) {
    const { paymentData: n, orderID: ie } = await getCartData(
      t.cartID,
      t.paymentToken,
      t.paymentType,
      this.address,
      this.axiosInstance
    ), { tbdReceivers: fe, tbdValues: ae, totalPrice: le, tokenAddress: he } = n;
    if (!window.solana || !window.solana.isPhantom)
      throw window.open("https://phantom.app/", "_blank"), new WalletNotFoundException();
    try {
      const me = window.solana;
      await me.connect();
      const ye = me.publicKey, be = new Connection(
        this.network === Network.MAINNET ? "https://multi-greatest-voice.solana-mainnet.quiknode.pro/908c9dd72998ac69ec2205d5cdb2eccd654dfd0b" : clusterApiUrl("devnet")
      ), Ae = new PublicKey$1(he), Se = new Token(
        be,
        Ae,
        TOKEN_PROGRAM_ID,
        me
        // the wallet owner will pay to transfer and to create recipients associated token account if it does not yet exist.
      );
      console.log({ tbdReceivers: fe, tbdValues: ae });
      const $e = fe.map(
        (Rt) => new PublicKey$1(Rt)
      );
      console.log({ recipientPublicKeys: $e });
      const Re = $e.map(
        (Rt) => Token.getAssociatedTokenAddress(
          Se.associatedProgramId,
          Se.programId,
          Ae,
          Rt
        )
      ), Me = await Token.getAssociatedTokenAddress(
        Se.associatedProgramId,
        Se.programId,
        Ae,
        ye
      ), ke = await be.getAccountInfo(
        Me
      ), Te = await Promise.all(
        Re.map(
          async (Rt) => be.getAccountInfo(await Rt)
        )
      ), Ie = [];
      for (let Rt = 0; Rt < Te.length; Rt++)
        Te[Rt] === null && Ie.push(
          Token.createAssociatedTokenAccountInstruction(
            Se.associatedProgramId,
            Se.programId,
            Ae,
            await Re[Rt],
            $e[Rt],
            ye
          )
        );
      ke === null && Ie.push(
        Token.createAssociatedTokenAccountInstruction(
          Se.associatedProgramId,
          Se.programId,
          Ae,
          Me,
          ye,
          ye
        )
      );
      for (let Rt = 0; Rt < Re.length; Rt++)
        Ie.push(
          Token.createTransferInstruction(
            TOKEN_PROGRAM_ID,
            Me,
            await Re[Rt],
            ye,
            [],
            BigNumber.from(ae[Rt]).div(BigNumber.from(10).pow(13)).toNumber()
          )
        );
      const qe = new Transaction$1().add(...Ie);
      qe.feePayer = ye, qe.recentBlockhash = (await be.getLatestBlockhash()).blockhash;
      const Ue = await me.signTransaction(qe), ze = await be.sendRawTransaction(
        Ue.serialize(),
        { skipPreflight: !0 }
      ), Ve = await be.getLatestBlockhash();
      await be.confirmTransaction({
        blockhash: Ve.blockhash,
        lastValidBlockHeight: Ve.lastValidBlockHeight,
        signature: ze
      });
      const Mt = (Rt) => new Promise((je) => setTimeout(je, Rt));
      for (; ; ) {
        await Mt(1500), console.log("Checking transaction status...");
        try {
          if (await be.getParsedTransaction(ze))
            break;
        } catch (Rt) {
          console.log(Rt);
        }
      }
      return await Mt(1e3), {
        transactionHash: ze,
        cryptoAmount: le,
        orderID: ie
      };
    } catch (me) {
      throw console.log(me), me;
    }
  }
  async paymentWithToken(t, n, ie) {
    if (!window.solana || !window.solana.isPhantom)
      throw window.open("https://phantom.app/", "_blank"), new WalletNotFoundException();
    try {
      const fe = window.solana;
      await fe.connect();
      const ae = fe.publicKey, le = new Connection(
        this.network === Network.MAINNET ? "https://multi-greatest-voice.solana-mainnet.quiknode.pro/908c9dd72998ac69ec2205d5cdb2eccd654dfd0b" : clusterApiUrl("devnet")
      ), he = new PublicKey$1(ie), me = new PublicKey$1(t), ye = new Token(
        le,
        he,
        TOKEN_PROGRAM_ID,
        fe
        // the wallet owner will pay to transfer and to create recipients associated token account if it does not yet exist.
      ), be = await Token.getAssociatedTokenAddress(
        ye.associatedProgramId,
        ye.programId,
        he,
        me
      ), Ae = await Token.getAssociatedTokenAddress(
        ye.associatedProgramId,
        ye.programId,
        he,
        ae
      ), Se = await le.getAccountInfo(
        Ae
      ), $e = await le.getAccountInfo(
        be
      ), Re = [];
      $e === null && Re.push(
        Token.createAssociatedTokenAccountInstruction(
          ye.associatedProgramId,
          ye.programId,
          he,
          be,
          me,
          ae
        )
      ), Se === null && Re.push(
        Token.createAssociatedTokenAccountInstruction(
          ye.associatedProgramId,
          ye.programId,
          he,
          Ae,
          ae,
          ae
        )
      ), Re.push(
        Token.createTransferInstruction(
          TOKEN_PROGRAM_ID,
          Ae,
          be,
          ae,
          [],
          Math.floor(n * 1e9)
        )
      );
      const Me = new Transaction$1().add(...Re);
      Me.feePayer = ae, Me.recentBlockhash = (await le.getLatestBlockhash()).blockhash;
      const ke = await fe.signTransaction(Me), Te = await le.sendRawTransaction(
        ke.serialize(),
        { skipPreflight: !0 }
      ), Ie = await le.getLatestBlockhash();
      await le.confirmTransaction({
        blockhash: Ie.blockhash,
        lastValidBlockHeight: Ie.lastValidBlockHeight,
        signature: Te
      });
      const qe = (Ue) => new Promise((ze) => setTimeout(ze, Ue));
      for (; ; ) {
        await qe(1500), console.log("Checking transaction status...");
        try {
          if (await le.getParsedTransaction(Te))
            break;
        } catch (Ue) {
          console.log(Ue);
        }
      }
      return await qe(1e3), Te;
    } catch (fe) {
      throw console.log(fe), fe;
    }
  }
  setAddress(t) {
    return this.address = t, this;
  }
  setWallet(t) {
    return this.wallet = t, this;
  }
  setModal(t) {
    return this.modalInterface = t, this;
  }
  setNFTContractAddress(t) {
    return this.nftContractAddress = t, this;
  }
  setShopContractAddress(t) {
    return this.shopContractAddress = t, this;
  }
  getPaymentData(t, n, ie) {
    throw new Error("Method not implemented.");
  }
}
var r = /* @__PURE__ */ function() {
  function c(t) {
    t === void 0 && (t = c.defaultCreateUrl), this.createURL = void 0, this.createURL = t;
  }
  return c.defaultCreateUrl = function(t, n) {
    return "https://" + t + ".ipns.dweb.link" + n.replace(/^\/?/, "/");
  }, c.prototype.resolve = function(t) {
    try {
      var n, ie, fe;
      if (t.startsWith("/ipfs/") || t.startsWith("/ipns/")) fe = t.substring(1, 5), n = t.substring(6).split("/")[0], ie = t.substring(6 + n.length);
      else {
        var ae = new URL(t);
        if (ae.hash !== "" || ae.password !== "" || ae.port !== "" || ae.search !== "" || ae.username !== "") throw new Error("invalid ipfs uri");
        fe = ae.protocol.substring(0, 4), n = ae.hostname, ie = ae.pathname;
      }
      if (fe !== "ipfs") throw new Error("only ipfs is supported, (not ipns)");
      return Promise.resolve(fetch(this.createURL(n, ie)).then(function(le) {
        return le.ok ? le.text() : Promise.reject(new Error("bad response"));
      }));
    } catch (le) {
      return Promise.reject(le);
    }
  }, c;
}(), e = /* @__PURE__ */ function() {
  function c(t) {
    this.options = void 0, this.options = t;
  }
  return c.prototype.resolve = function(t, n) {
    try {
      var ie, fe = "";
      if (t.includes("@")) {
        var ae = t.split("@", 1);
        fe = ae[0], ie = ae[1];
      } else ie = t;
      var le = "http://openid.net/specs/connect/1.0/issuer";
      return Promise.resolve(this.options.webfingerResolver.resolve(ie, fe, le, n)).then(function(he) {
        var me, ye = (me = he.links) == null ? void 0 : me.find(function(be) {
          return be.rel === le;
        });
        if (!ye || !ye.href) throw new Error("bad jrd");
        return Promise.resolve(fetch(ye.href + "/.well-known/openid-configuration").then(function(be) {
          return be.ok ? be.json() : Promise.reject(new Error("bad openid-configuration response"));
        }));
      });
    } catch (he) {
      return Promise.reject(he);
    }
  }, c;
}();
function o(c, t, n) {
  if (!c.s) {
    if (n instanceof i$1) {
      if (!n.s) return void (n.o = o.bind(null, c, t));
      1 & t && (t = n.s), n = n.v;
    }
    if (n && n.then) return void n.then(o.bind(null, c, t), o.bind(null, c, 2));
    c.s = t, c.v = n;
    const ie = c.o;
    ie && ie(c);
  }
}
var i$1 = /* @__PURE__ */ function() {
  function c() {
  }
  return c.prototype.then = function(t, n) {
    var ie = new c(), fe = this.s;
    if (fe) {
      var ae = 1 & fe ? t : n;
      if (ae) {
        try {
          o(ie, 1, ae(this.v));
        } catch (le) {
          o(ie, 2, le);
        }
        return ie;
      }
      return this;
    }
    return this.o = function(le) {
      try {
        var he = le.v;
        1 & le.s ? o(ie, 1, t ? t(he) : he) : n ? o(ie, 1, n(he)) : o(ie, 2, he);
      } catch (me) {
        o(ie, 2, me);
      }
    }, ie;
  }, c;
}();
if (typeof window < "u") {
  var s$1 = window;
  s$1.UAUTH_VERSION = s$1.UAUTH_VERSION || {}, s$1.UAUTH_VERSION.COMMON = "3.0.1";
}
var u$1 = /* @__PURE__ */ function() {
  function c(t) {
    this.options = void 0, this.options = t;
  }
  return c.prototype.resolve = function(t, n, ie, fe) {
    try {
      var ae = this, le = "webfinger." + n + "." + ie;
      return Promise.resolve(ae.options.domainResolver.records(t, [le])).then(function(he) {
        function me($e) {
          if (be.subject !== ye) throw new Error("resource invalid");
          return be;
        }
        var ye = n ? "acct:" + n + "@" + t : "" + t;
        if (!he[le]) return { subject: ye, links: [{ rel: ie, href: fe }] };
        var be, Ae = JSON.parse(he[le]), Se = typeof Ae.host == "string" ? Promise.resolve(fetch("/.well-known/webfinger?" + new URLSearchParams({ resource: ye, rel: ie }).toString(), { headers: { Host: Ae.host } }).then(function($e) {
          return $e.ok ? $e.json() : Promise.reject(new Error("bad webfinger response"));
        })).then(function($e) {
          be = $e;
        }) : function() {
          if (typeof Ae.uri == "string") {
            var $e = new URL(Ae.uri);
            return function(Re, Me) {
              var ke, Te = -1;
              e: {
                for (var Ie = 0; Ie < Me.length; Ie++) {
                  var qe = Me[Ie][0];
                  if (qe) {
                    var Ue = qe();
                    if (Ue && Ue.then) break e;
                    if (Ue === Re) {
                      Te = Ie;
                      break;
                    }
                  } else Te = Ie;
                }
                if (Te !== -1) {
                  do {
                    for (var ze = Me[Te][1]; !ze; ) Te++, ze = Me[Te][1];
                    var Ve = ze();
                    if (Ve && Ve.then) {
                      ke = !0;
                      break e;
                    }
                    var Mt = Me[Te][2];
                    Te++;
                  } while (Mt && !Mt());
                  return Ve;
                }
              }
              var Rt = new i$1(), je = o.bind(null, Rt, 2);
              return (ke ? Ve.then(jt) : Ue.then(function _e(se) {
                for (; ; ) {
                  if (se === Re) {
                    Te = Ie;
                    break;
                  }
                  if (++Ie === Me.length) {
                    if (Te !== -1) break;
                    return void o(Rt, 1, de);
                  }
                  if (qe = Me[Ie][0]) {
                    if ((se = qe()) && se.then) return void se.then(_e).then(void 0, je);
                  } else Te = Ie;
                }
                do {
                  for (var ce = Me[Te][1]; !ce; ) Te++, ce = Me[Te][1];
                  var de = ce();
                  if (de && de.then) return void de.then(jt).then(void 0, je);
                  var pe = Me[Te][2];
                  Te++;
                } while (pe && !pe());
                o(Rt, 1, de);
              })).then(void 0, je), Rt;
              function jt(_e) {
                for (; ; ) {
                  var se = Me[Te][2];
                  if (!se || se()) break;
                  Te++;
                  for (var ce = Me[Te][1]; !ce; ) Te++, ce = Me[Te][1];
                  if ((_e = ce()) && _e.then) return void _e.then(jt).then(void 0, je);
                }
                o(Rt, 1, _e);
              }
            }($e.protocol, [[function() {
              return "http:";
            }], [function() {
              return "https:";
            }, function() {
              return Promise.resolve(fetch($e.toString()).then(function(Re) {
                return Re.ok ? Re.json() : Promise.reject(new Error("bad webfinger response"));
              })).then(function(Re) {
                be = Re;
              });
            }], [function() {
              return "ipfs:";
            }, function() {
              return Promise.resolve(ae.options.ipfsResolver.resolve(Ae.uri)).then(function(Re) {
                be = JSON.parse(Re);
              });
            }], [function() {
              return "ipns:";
            }], [function() {
              return "swarm:";
            }], [void 0, function() {
              throw new Error("uri scheme not supported");
            }]]);
          }
          if (typeof Ae.value != "string") throw new Error("bad webfinger record");
          be = JSON.parse(Ae.value);
        }();
        return Se && Se.then ? Se.then(me) : me();
      });
    } catch (he) {
      return Promise.reject(he);
    }
  }, c;
}(), build = {}, Resolution$1 = {}, bn$8 = { exports: {} };
bn$8.exports;
(function(c) {
  (function(t, n) {
    function ie(_e, se) {
      if (!_e) throw new Error(se || "Assertion failed");
    }
    function fe(_e, se) {
      _e.super_ = se;
      var ce = function() {
      };
      ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
    }
    function ae(_e, se, ce) {
      if (ae.isBN(_e))
        return _e;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
    }
    typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
    var le;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
    } catch {
    }
    ae.isBN = function(se) {
      return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
    }, ae.max = function(se, ce) {
      return se.cmp(ce) > 0 ? se : ce;
    }, ae.min = function(se, ce) {
      return se.cmp(ce) < 0 ? se : ce;
    }, ae.prototype._init = function(se, ce, de) {
      if (typeof se == "number")
        return this._initNumber(se, ce, de);
      if (typeof se == "object")
        return this._initArray(se, ce, de);
      ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
      var pe = 0;
      se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
    }, ae.prototype._initNumber = function(se, ce, de) {
      se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
        se & 67108863,
        se / 67108864 & 67108863
      ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
        se & 67108863,
        se / 67108864 & 67108863,
        1
      ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
    }, ae.prototype._initArray = function(se, ce, de) {
      if (ie(typeof se.length == "number"), se.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve, we, Ee = 0;
      if (de === "be")
        for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
          we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      else if (de === "le")
        for (pe = 0, ve = 0; pe < se.length; pe += 3)
          we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      return this.strip();
    };
    function he(_e, se) {
      var ce = _e.charCodeAt(se);
      return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
    }
    function me(_e, se, ce) {
      var de = he(_e, ce);
      return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
    }
    ae.prototype._parseHex = function(se, ce, de) {
      this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve = 0, we = 0, Ee;
      if (de === "be")
        for (pe = se.length - 1; pe >= ce; pe -= 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      else {
        var xe = se.length - ce;
        for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      }
      this.strip();
    };
    function ye(_e, se, ce, de) {
      for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
        var Ee = _e.charCodeAt(we) - 48;
        pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
      }
      return pe;
    }
    ae.prototype._parseBase = function(se, ce, de) {
      this.words = [0], this.length = 1;
      for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
        pe++;
      pe--, ve = ve / ce | 0;
      for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
        ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      if (Ee !== 0) {
        var Be = 1;
        for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
          Be *= ce;
        this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      }
      this.strip();
    }, ae.prototype.copy = function(se) {
      se.words = new Array(this.length);
      for (var ce = 0; ce < this.length; ce++)
        se.words[ce] = this.words[ce];
      se.length = this.length, se.negative = this.negative, se.red = this.red;
    }, ae.prototype.clone = function() {
      var se = new ae(null);
      return this.copy(se), se;
    }, ae.prototype._expand = function(se) {
      for (; this.length < se; )
        this.words[this.length++] = 0;
      return this;
    }, ae.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, ae.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, ae.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var be = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Ae = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Se = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    ae.prototype.toString = function(se, ce) {
      se = se || 10, ce = ce | 0 || 1;
      var de;
      if (se === 16 || se === "hex") {
        de = "";
        for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
          var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
          ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
        }
        for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      if (se === (se | 0) && se >= 2 && se <= 36) {
        var ue = Ae[se], ge = Se[se];
        de = "";
        var Be = this.clone();
        for (Be.negative = 0; !Be.isZero(); ) {
          var Ne = Be.modn(ge).toString(se);
          Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
        }
        for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      ie(!1, "Base should be between 2 and 36");
    }, ae.prototype.toNumber = function() {
      var se = this.words[0];
      return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
    }, ae.prototype.toJSON = function() {
      return this.toString(16);
    }, ae.prototype.toBuffer = function(se, ce) {
      return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
    }, ae.prototype.toArray = function(se, ce) {
      return this.toArrayLike(Array, se, ce);
    }, ae.prototype.toArrayLike = function(se, ce, de) {
      var pe = this.byteLength(), ve = de || Math.max(1, pe);
      ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
      var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
      if (we) {
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
        for (; ue < ve; ue++)
          Ee[ue] = 0;
      } else {
        for (ue = 0; ue < ve - pe; ue++)
          Ee[ue] = 0;
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
      }
      return Ee;
    }, Math.clz32 ? ae.prototype._countBits = function(se) {
      return 32 - Math.clz32(se);
    } : ae.prototype._countBits = function(se) {
      var ce = se, de = 0;
      return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
    }, ae.prototype._zeroBits = function(se) {
      if (se === 0) return 26;
      var ce = se, de = 0;
      return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
    }, ae.prototype.bitLength = function() {
      var se = this.words[this.length - 1], ce = this._countBits(se);
      return (this.length - 1) * 26 + ce;
    };
    function $e(_e) {
      for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
        var de = ce / 26 | 0, pe = ce % 26;
        se[ce] = (_e.words[de] & 1 << pe) >>> pe;
      }
      return se;
    }
    ae.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var se = 0, ce = 0; ce < this.length; ce++) {
        var de = this._zeroBits(this.words[ce]);
        if (se += de, de !== 26) break;
      }
      return se;
    }, ae.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, ae.prototype.toTwos = function(se) {
      return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
    }, ae.prototype.fromTwos = function(se) {
      return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
    }, ae.prototype.isNeg = function() {
      return this.negative !== 0;
    }, ae.prototype.neg = function() {
      return this.clone().ineg();
    }, ae.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, ae.prototype.iuor = function(se) {
      for (; this.length < se.length; )
        this.words[this.length++] = 0;
      for (var ce = 0; ce < se.length; ce++)
        this.words[ce] = this.words[ce] | se.words[ce];
      return this.strip();
    }, ae.prototype.ior = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuor(se);
    }, ae.prototype.or = function(se) {
      return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
    }, ae.prototype.uor = function(se) {
      return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
    }, ae.prototype.iuand = function(se) {
      var ce;
      this.length > se.length ? ce = se : ce = this;
      for (var de = 0; de < ce.length; de++)
        this.words[de] = this.words[de] & se.words[de];
      return this.length = ce.length, this.strip();
    }, ae.prototype.iand = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuand(se);
    }, ae.prototype.and = function(se) {
      return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
    }, ae.prototype.uand = function(se) {
      return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
    }, ae.prototype.iuxor = function(se) {
      var ce, de;
      this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
      for (var pe = 0; pe < de.length; pe++)
        this.words[pe] = ce.words[pe] ^ de.words[pe];
      if (this !== ce)
        for (; pe < ce.length; pe++)
          this.words[pe] = ce.words[pe];
      return this.length = ce.length, this.strip();
    }, ae.prototype.ixor = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuxor(se);
    }, ae.prototype.xor = function(se) {
      return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
    }, ae.prototype.uxor = function(se) {
      return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
    }, ae.prototype.inotn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = Math.ceil(se / 26) | 0, de = se % 26;
      this._expand(ce), de > 0 && ce--;
      for (var pe = 0; pe < ce; pe++)
        this.words[pe] = ~this.words[pe] & 67108863;
      return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
    }, ae.prototype.notn = function(se) {
      return this.clone().inotn(se);
    }, ae.prototype.setn = function(se, ce) {
      ie(typeof se == "number" && se >= 0);
      var de = se / 26 | 0, pe = se % 26;
      return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
    }, ae.prototype.iadd = function(se) {
      var ce;
      if (this.negative !== 0 && se.negative === 0)
        return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && se.negative !== 0)
        return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
      var de, pe;
      this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
      for (var ve = 0, we = 0; we < pe.length; we++)
        ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      for (; ve !== 0 && we < de.length; we++)
        ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      if (this.length = de.length, ve !== 0)
        this.words[this.length] = ve, this.length++;
      else if (de !== this)
        for (; we < de.length; we++)
          this.words[we] = de.words[we];
      return this;
    }, ae.prototype.add = function(se) {
      var ce;
      return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
    }, ae.prototype.isub = function(se) {
      if (se.negative !== 0) {
        se.negative = 0;
        var ce = this.iadd(se);
        return se.negative = 1, ce._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
      var de = this.cmp(se);
      if (de === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pe, ve;
      de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
      for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
        ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      for (; we !== 0 && Ee < pe.length; Ee++)
        ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      if (we === 0 && Ee < pe.length && pe !== this)
        for (; Ee < pe.length; Ee++)
          this.words[Ee] = pe.words[Ee];
      return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
    }, ae.prototype.sub = function(se) {
      return this.clone().isub(se);
    };
    function Re(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative;
      var de = _e.length + se.length | 0;
      ce.length = de, de = de - 1 | 0;
      var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
      ce.words[0] = Ee;
      for (var ue = 1; ue < de; ue++) {
        for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
          var Pe = ue - Fe | 0;
          pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
        }
        ce.words[ue] = Be | 0, xe = ge | 0;
      }
      return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
    }
    var Me = function(se, ce, de) {
      var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
      de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
      var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
      var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
      var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
      var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
      var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
      var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
      var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
      var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
      var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
      var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
      var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
      var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
      var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
      var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
      var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
      var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
      var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
      var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
      var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
    };
    Math.imul || (Me = Re);
    function ke(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
      for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
        var we = pe;
        pe = 0;
        for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
          var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
          we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
        }
        ce.words[ve] = Ee, de = we, we = pe;
      }
      return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
    }
    function Te(_e, se, ce) {
      var de = new Ie();
      return de.mulp(_e, se, ce);
    }
    ae.prototype.mulTo = function(se, ce) {
      var de, pe = this.length + se.length;
      return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
    };
    function Ie(_e, se) {
      this.x = _e, this.y = se;
    }
    Ie.prototype.makeRBT = function(se) {
      for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
        ce[pe] = this.revBin(pe, de, se);
      return ce;
    }, Ie.prototype.revBin = function(se, ce, de) {
      if (se === 0 || se === de - 1) return se;
      for (var pe = 0, ve = 0; ve < ce; ve++)
        pe |= (se & 1) << ce - ve - 1, se >>= 1;
      return pe;
    }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
      for (var Ee = 0; Ee < we; Ee++)
        pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
    }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
      this.permute(we, se, ce, de, pe, ve);
      for (var Ee = 1; Ee < ve; Ee <<= 1)
        for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
          for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
            var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
            Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
          }
    }, Ie.prototype.guessLen13b = function(se, ce) {
      var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
      for (de = de / 2 | 0; de; de = de >>> 1)
        ve++;
      return 1 << ve + 1 + pe;
    }, Ie.prototype.conjugate = function(se, ce, de) {
      if (!(de <= 1))
        for (var pe = 0; pe < de / 2; pe++) {
          var ve = se[pe];
          se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
        }
    }, Ie.prototype.normalize13b = function(se, ce) {
      for (var de = 0, pe = 0; pe < ce / 2; pe++) {
        var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
        se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
      }
      return se;
    }, Ie.prototype.convert13b = function(se, ce, de, pe) {
      for (var ve = 0, we = 0; we < ce; we++)
        ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
      for (we = 2 * ce; we < pe; ++we)
        de[we] = 0;
      ie(ve === 0), ie((ve & -8192) === 0);
    }, Ie.prototype.stub = function(se) {
      for (var ce = new Array(se), de = 0; de < se; de++)
        ce[de] = 0;
      return ce;
    }, Ie.prototype.mulp = function(se, ce, de) {
      var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
      Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
      for (var Pe = 0; Pe < pe; Pe++) {
        var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
        ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
      }
      return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
    }, ae.prototype.mul = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
    }, ae.prototype.mulf = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), Te(this, se, ce);
    }, ae.prototype.imul = function(se) {
      return this.clone().mulTo(se, this);
    }, ae.prototype.imuln = function(se) {
      ie(typeof se == "number"), ie(se < 67108864);
      for (var ce = 0, de = 0; de < this.length; de++) {
        var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
        ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
      }
      return ce !== 0 && (this.words[de] = ce, this.length++), this;
    }, ae.prototype.muln = function(se) {
      return this.clone().imuln(se);
    }, ae.prototype.sqr = function() {
      return this.mul(this);
    }, ae.prototype.isqr = function() {
      return this.imul(this.clone());
    }, ae.prototype.pow = function(se) {
      var ce = $e(se);
      if (ce.length === 0) return new ae(1);
      for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
        ;
      if (++pe < ce.length)
        for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
          ce[pe] !== 0 && (de = de.mul(ve));
      return de;
    }, ae.prototype.iushln = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
      if (ce !== 0) {
        var we = 0;
        for (ve = 0; ve < this.length; ve++) {
          var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
          this.words[ve] = xe | we, we = Ee >>> 26 - ce;
        }
        we && (this.words[ve] = we, this.length++);
      }
      if (de !== 0) {
        for (ve = this.length - 1; ve >= 0; ve--)
          this.words[ve + de] = this.words[ve];
        for (ve = 0; ve < de; ve++)
          this.words[ve] = 0;
        this.length += de;
      }
      return this.strip();
    }, ae.prototype.ishln = function(se) {
      return ie(this.negative === 0), this.iushln(se);
    }, ae.prototype.iushrn = function(se, ce, de) {
      ie(typeof se == "number" && se >= 0);
      var pe;
      ce ? pe = (ce - ce % 26) / 26 : pe = 0;
      var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
      if (pe -= we, pe = Math.max(0, pe), xe) {
        for (var ue = 0; ue < we; ue++)
          xe.words[ue] = this.words[ue];
        xe.length = we;
      }
      if (we !== 0) if (this.length > we)
        for (this.length -= we, ue = 0; ue < this.length; ue++)
          this.words[ue] = this.words[ue + we];
      else
        this.words[0] = 0, this.length = 1;
      var ge = 0;
      for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
        var Be = this.words[ue] | 0;
        this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
      }
      return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, ae.prototype.ishrn = function(se, ce, de) {
      return ie(this.negative === 0), this.iushrn(se, ce, de);
    }, ae.prototype.shln = function(se) {
      return this.clone().ishln(se);
    }, ae.prototype.ushln = function(se) {
      return this.clone().iushln(se);
    }, ae.prototype.shrn = function(se) {
      return this.clone().ishrn(se);
    }, ae.prototype.ushrn = function(se) {
      return this.clone().iushrn(se);
    }, ae.prototype.testn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de) return !1;
      var ve = this.words[de];
      return !!(ve & pe);
    }, ae.prototype.imaskn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
        return this;
      if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
        var pe = 67108863 ^ 67108863 >>> ce << ce;
        this.words[this.length - 1] &= pe;
      }
      return this.strip();
    }, ae.prototype.maskn = function(se) {
      return this.clone().imaskn(se);
    }, ae.prototype.iaddn = function(se) {
      return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
    }, ae.prototype._iaddn = function(se) {
      this.words[0] += se;
      for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
        this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
      return this.length = Math.max(this.length, ce + 1), this;
    }, ae.prototype.isubn = function(se) {
      if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(se), this.negative = 1, this;
      if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
          this.words[ce] += 67108864, this.words[ce + 1] -= 1;
      return this.strip();
    }, ae.prototype.addn = function(se) {
      return this.clone().iaddn(se);
    }, ae.prototype.subn = function(se) {
      return this.clone().isubn(se);
    }, ae.prototype.iabs = function() {
      return this.negative = 0, this;
    }, ae.prototype.abs = function() {
      return this.clone().iabs();
    }, ae.prototype._ishlnsubmul = function(se, ce, de) {
      var pe = se.length + de, ve;
      this._expand(pe);
      var we, Ee = 0;
      for (ve = 0; ve < se.length; ve++) {
        we = (this.words[ve + de] | 0) + Ee;
        var xe = (se.words[ve] | 0) * ce;
        we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
      }
      for (; ve < this.length - de; ve++)
        we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
      if (Ee === 0) return this.strip();
      for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
        we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
      return this.negative = 1, this.strip();
    }, ae.prototype._wordDiv = function(se, ce) {
      var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
      de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
      var xe = pe.length - ve.length, ue;
      if (ce !== "mod") {
        ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
        for (var ge = 0; ge < ue.length; ge++)
          ue.words[ge] = 0;
      }
      var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
      Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
      for (var Ne = xe - 1; Ne >= 0; Ne--) {
        var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
        for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
          Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
        ue && (ue.words[Ne] = Fe);
      }
      return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
        div: ue || null,
        mod: pe
      };
    }, ae.prototype.divmod = function(se, ce, de) {
      if (ie(!se.isZero()), this.isZero())
        return {
          div: new ae(0),
          mod: new ae(0)
        };
      var pe, ve, we;
      return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
        div: pe,
        mod: ve
      }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
        div: pe,
        mod: we.mod
      }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
        div: we.div,
        mod: ve
      }) : se.length > this.length || this.cmp(se) < 0 ? {
        div: new ae(0),
        mod: this
      } : se.length === 1 ? ce === "div" ? {
        div: this.divn(se.words[0]),
        mod: null
      } : ce === "mod" ? {
        div: null,
        mod: new ae(this.modn(se.words[0]))
      } : {
        div: this.divn(se.words[0]),
        mod: new ae(this.modn(se.words[0]))
      } : this._wordDiv(se, ce);
    }, ae.prototype.div = function(se) {
      return this.divmod(se, "div", !1).div;
    }, ae.prototype.mod = function(se) {
      return this.divmod(se, "mod", !1).mod;
    }, ae.prototype.umod = function(se) {
      return this.divmod(se, "mod", !0).mod;
    }, ae.prototype.divRound = function(se) {
      var ce = this.divmod(se);
      if (ce.mod.isZero()) return ce.div;
      var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
      return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
    }, ae.prototype.modn = function(se) {
      ie(se <= 67108863);
      for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
        de = (ce * de + (this.words[pe] | 0)) % se;
      return de;
    }, ae.prototype.idivn = function(se) {
      ie(se <= 67108863);
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = (this.words[de] | 0) + ce * 67108864;
        this.words[de] = pe / se | 0, ce = pe % se;
      }
      return this.strip();
    }, ae.prototype.divn = function(se) {
      return this.clone().idivn(se);
    }, ae.prototype.egcd = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
        ce.iushrn(1), de.iushrn(1), ++xe;
      for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
        for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
        if (Be > 0)
          for (ce.iushrn(Be); Be-- > 0; )
            (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
        for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
        if (Fe > 0)
          for (de.iushrn(Fe); Fe-- > 0; )
            (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
      }
      return {
        a: we,
        b: Ee,
        gcd: de.iushln(xe)
      };
    }, ae.prototype._invmp = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
        for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
        if (Ee > 0)
          for (ce.iushrn(Ee); Ee-- > 0; )
            pe.isOdd() && pe.iadd(we), pe.iushrn(1);
        for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
        if (ue > 0)
          for (de.iushrn(ue); ue-- > 0; )
            ve.isOdd() && ve.iadd(we), ve.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
      }
      var Be;
      return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
    }, ae.prototype.gcd = function(se) {
      if (this.isZero()) return se.abs();
      if (se.isZero()) return this.abs();
      var ce = this.clone(), de = se.clone();
      ce.negative = 0, de.negative = 0;
      for (var pe = 0; ce.isEven() && de.isEven(); pe++)
        ce.iushrn(1), de.iushrn(1);
      do {
        for (; ce.isEven(); )
          ce.iushrn(1);
        for (; de.isEven(); )
          de.iushrn(1);
        var ve = ce.cmp(de);
        if (ve < 0) {
          var we = ce;
          ce = de, de = we;
        } else if (ve === 0 || de.cmpn(1) === 0)
          break;
        ce.isub(de);
      } while (!0);
      return de.iushln(pe);
    }, ae.prototype.invm = function(se) {
      return this.egcd(se).a.umod(se);
    }, ae.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, ae.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, ae.prototype.andln = function(se) {
      return this.words[0] & se;
    }, ae.prototype.bincn = function(se) {
      ie(typeof se == "number");
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de)
        return this._expand(de + 1), this.words[de] |= pe, this;
      for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
        var Ee = this.words[we] | 0;
        Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
      }
      return ve !== 0 && (this.words[we] = ve, this.length++), this;
    }, ae.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, ae.prototype.cmpn = function(se) {
      var ce = se < 0;
      if (this.negative !== 0 && !ce) return -1;
      if (this.negative === 0 && ce) return 1;
      this.strip();
      var de;
      if (this.length > 1)
        de = 1;
      else {
        ce && (se = -se), ie(se <= 67108863, "Number is too big");
        var pe = this.words[0] | 0;
        de = pe === se ? 0 : pe < se ? -1 : 1;
      }
      return this.negative !== 0 ? -de | 0 : de;
    }, ae.prototype.cmp = function(se) {
      if (this.negative !== 0 && se.negative === 0) return -1;
      if (this.negative === 0 && se.negative !== 0) return 1;
      var ce = this.ucmp(se);
      return this.negative !== 0 ? -ce | 0 : ce;
    }, ae.prototype.ucmp = function(se) {
      if (this.length > se.length) return 1;
      if (this.length < se.length) return -1;
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = this.words[de] | 0, ve = se.words[de] | 0;
        if (pe !== ve) {
          pe < ve ? ce = -1 : pe > ve && (ce = 1);
          break;
        }
      }
      return ce;
    }, ae.prototype.gtn = function(se) {
      return this.cmpn(se) === 1;
    }, ae.prototype.gt = function(se) {
      return this.cmp(se) === 1;
    }, ae.prototype.gten = function(se) {
      return this.cmpn(se) >= 0;
    }, ae.prototype.gte = function(se) {
      return this.cmp(se) >= 0;
    }, ae.prototype.ltn = function(se) {
      return this.cmpn(se) === -1;
    }, ae.prototype.lt = function(se) {
      return this.cmp(se) === -1;
    }, ae.prototype.lten = function(se) {
      return this.cmpn(se) <= 0;
    }, ae.prototype.lte = function(se) {
      return this.cmp(se) <= 0;
    }, ae.prototype.eqn = function(se) {
      return this.cmpn(se) === 0;
    }, ae.prototype.eq = function(se) {
      return this.cmp(se) === 0;
    }, ae.red = function(se) {
      return new je(se);
    }, ae.prototype.toRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
    }, ae.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, ae.prototype._forceRed = function(se) {
      return this.red = se, this;
    }, ae.prototype.forceRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
    }, ae.prototype.redAdd = function(se) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
    }, ae.prototype.redIAdd = function(se) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
    }, ae.prototype.redSub = function(se) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
    }, ae.prototype.redISub = function(se) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
    }, ae.prototype.redShl = function(se) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
    }, ae.prototype.redMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
    }, ae.prototype.redIMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
    }, ae.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, ae.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, ae.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, ae.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, ae.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, ae.prototype.redPow = function(se) {
      return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
    };
    var qe = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ue(_e, se) {
      this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ue.prototype._tmp = function() {
      var se = new ae(null);
      return se.words = new Array(Math.ceil(this.n / 13)), se;
    }, Ue.prototype.ireduce = function(se) {
      var ce = se, de;
      do
        this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
      while (de > this.n);
      var pe = de < this.n ? -1 : ce.ucmp(this.p);
      return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
    }, Ue.prototype.split = function(se, ce) {
      se.iushrn(this.n, 0, ce);
    }, Ue.prototype.imulK = function(se) {
      return se.imul(this.k);
    };
    function ze() {
      Ue.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    fe(ze, Ue), ze.prototype.split = function(se, ce) {
      for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
        ce.words[ve] = se.words[ve];
      if (ce.length = pe, se.length <= 9) {
        se.words[0] = 0, se.length = 1;
        return;
      }
      var we = se.words[9];
      for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
        var Ee = se.words[ve] | 0;
        se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
      }
      we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
    }, ze.prototype.imulK = function(se) {
      se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = se.words[de] | 0;
        ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
      }
      return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
    };
    function Ve() {
      Ue.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    fe(Ve, Ue);
    function Mt() {
      Ue.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    fe(Mt, Ue);
    function Rt() {
      Ue.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    fe(Rt, Ue), Rt.prototype.imulK = function(se) {
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
        pe >>>= 26, se.words[de] = ve, ce = pe;
      }
      return ce !== 0 && (se.words[se.length++] = ce), se;
    }, ae._prime = function(se) {
      if (qe[se]) return qe[se];
      var ce;
      if (se === "k256")
        ce = new ze();
      else if (se === "p224")
        ce = new Ve();
      else if (se === "p192")
        ce = new Mt();
      else if (se === "p25519")
        ce = new Rt();
      else
        throw new Error("Unknown prime " + se);
      return qe[se] = ce, ce;
    };
    function je(_e) {
      if (typeof _e == "string") {
        var se = ae._prime(_e);
        this.m = se.p, this.prime = se;
      } else
        ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
    }
    je.prototype._verify1 = function(se) {
      ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
    }, je.prototype._verify2 = function(se, ce) {
      ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
        se.red && se.red === ce.red,
        "red works only with red numbers"
      );
    }, je.prototype.imod = function(se) {
      return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
    }, je.prototype.neg = function(se) {
      return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
    }, je.prototype.add = function(se, ce) {
      this._verify2(se, ce);
      var de = se.add(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
    }, je.prototype.iadd = function(se, ce) {
      this._verify2(se, ce);
      var de = se.iadd(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de;
    }, je.prototype.sub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.sub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
    }, je.prototype.isub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.isub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de;
    }, je.prototype.shl = function(se, ce) {
      return this._verify1(se), this.imod(se.ushln(ce));
    }, je.prototype.imul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.imul(ce));
    }, je.prototype.mul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.mul(ce));
    }, je.prototype.isqr = function(se) {
      return this.imul(se, se.clone());
    }, je.prototype.sqr = function(se) {
      return this.mul(se, se);
    }, je.prototype.sqrt = function(se) {
      if (se.isZero()) return se.clone();
      var ce = this.m.andln(3);
      if (ie(ce % 2 === 1), ce === 3) {
        var de = this.m.add(new ae(1)).iushrn(2);
        return this.pow(se, de);
      }
      for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
        ve++, pe.iushrn(1);
      ie(!pe.isZero());
      var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
      for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
        ue.redIAdd(Ee);
      for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
        for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
          Pe = Pe.redSqr();
        ie(Je < Fe);
        var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
        Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
      }
      return Be;
    }, je.prototype.invm = function(se) {
      var ce = se._invmp(this.m);
      return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
    }, je.prototype.pow = function(se, ce) {
      if (ce.isZero()) return new ae(1).toRed(this);
      if (ce.cmpn(1) === 0) return se.clone();
      var de = 4, pe = new Array(1 << de);
      pe[0] = new ae(1).toRed(this), pe[1] = se;
      for (var ve = 2; ve < pe.length; ve++)
        pe[ve] = this.mul(pe[ve - 1], se);
      var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
      for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
        for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
          var Ne = ge >> Be & 1;
          if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
            xe = 0;
            continue;
          }
          Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
        }
        ue = 26;
      }
      return we;
    }, je.prototype.convertTo = function(se) {
      var ce = se.umod(this.m);
      return ce === se ? ce.clone() : ce;
    }, je.prototype.convertFrom = function(se) {
      var ce = se.clone();
      return ce.red = null, ce;
    }, ae.mont = function(se) {
      return new jt(se);
    };
    function jt(_e) {
      je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    fe(jt, je), jt.prototype.convertTo = function(se) {
      return this.imod(se.ushln(this.shift));
    }, jt.prototype.convertFrom = function(se) {
      var ce = this.imod(se.mul(this.rinv));
      return ce.red = null, ce;
    }, jt.prototype.imul = function(se, ce) {
      if (se.isZero() || ce.isZero())
        return se.words[0] = 0, se.length = 1, se;
      var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.mul = function(se, ce) {
      if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
      var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.invm = function(se) {
      var ce = this.imod(se._invmp(this.m).mul(this.r2));
      return ce._forceRed(this);
    };
  })(c, commonjsGlobal);
})(bn$8);
var bnExports$2 = bn$8.exports, Ens$1 = {}, src$6 = { exports: {} }, encode_1 = encode$3, MSB$1 = 128, REST$1 = 127, MSBALL = ~REST$1, INT = Math.pow(2, 31);
function encode$3(c, t, n) {
  t = t || [], n = n || 0;
  for (var ie = n; c >= INT; )
    t[n++] = c & 255 | MSB$1, c /= 128;
  for (; c & MSBALL; )
    t[n++] = c & 255 | MSB$1, c >>>= 7;
  return t[n] = c | 0, encode$3.bytes = n - ie + 1, t;
}
var decode$4 = read, MSB = 128, REST = 127;
function read(c, ie) {
  var n = 0, ie = ie || 0, fe = 0, ae = ie, le, he = c.length;
  do {
    if (ae >= he)
      throw read.bytes = 0, new RangeError("Could not decode varint");
    le = c[ae++], n += fe < 28 ? (le & REST) << fe : (le & REST) * Math.pow(2, fe), fe += 7;
  } while (le >= MSB);
  return read.bytes = ae - ie, n;
}
var N1 = Math.pow(2, 7), N2 = Math.pow(2, 14), N3 = Math.pow(2, 21), N4 = Math.pow(2, 28), N5 = Math.pow(2, 35), N6 = Math.pow(2, 42), N7 = Math.pow(2, 49), N8 = Math.pow(2, 56), N9 = Math.pow(2, 63), length = function(c) {
  return c < N1 ? 1 : c < N2 ? 2 : c < N3 ? 3 : c < N4 ? 4 : c < N5 ? 5 : c < N6 ? 6 : c < N7 ? 7 : c < N8 ? 8 : c < N9 ? 9 : 10;
}, varint$2 = {
  encode: encode_1,
  decode: decode$4,
  encodingLength: length
};
const identity$1 = 0, ip4$1 = 4, tcp$1 = 6, sha1$2 = 17, dccp$1 = 33, ip6$1 = 41, ip6zone$1 = 42, path$1 = 47, multicodec$2 = 48, multihash$1 = 49, multiaddr$1 = 50, multibase$2 = 51, dns$1 = 53, dns4$1 = 54, dns6$1 = 55, dnsaddr$1 = 56, protobuf$1 = 80, cbor$1 = 81, raw$1 = 85, rlp$1 = 96, bencode$1 = 99, sctp$1 = 132, md4$1 = 212, md5$2 = 213, bmt$1 = 214, zeronet$1 = 230, udp$1 = 273, udt$1 = 301, utp$1 = 302, unix$1 = 400, p2p$1 = 421, ipfs$1 = 421, https$1 = 443, onion$1 = 444, onion3$1 = 445, garlic64$1 = 446, garlic32$1 = 447, tls$1 = 448, quic$1 = 460, ws$1 = 477, wss$1 = 478, http$1 = 480, json$1 = 512, messagepack$1 = 513, x11$1 = 4352, require$$0$2 = {
  identity: identity$1,
  ip4: ip4$1,
  tcp: tcp$1,
  sha1: sha1$2,
  "sha2-256": 18,
  "sha2-512": 19,
  "sha3-512": 20,
  "sha3-384": 21,
  "sha3-256": 22,
  "sha3-224": 23,
  "shake-128": 24,
  "shake-256": 25,
  "keccak-224": 26,
  "keccak-256": 27,
  "keccak-384": 28,
  "keccak-512": 29,
  dccp: dccp$1,
  "murmur3-128": 34,
  "murmur3-32": 35,
  ip6: ip6$1,
  ip6zone: ip6zone$1,
  path: path$1,
  multicodec: multicodec$2,
  multihash: multihash$1,
  multiaddr: multiaddr$1,
  multibase: multibase$2,
  dns: dns$1,
  dns4: dns4$1,
  dns6: dns6$1,
  dnsaddr: dnsaddr$1,
  protobuf: protobuf$1,
  cbor: cbor$1,
  raw: raw$1,
  "dbl-sha2-256": 86,
  rlp: rlp$1,
  bencode: bencode$1,
  "dag-pb": 112,
  "dag-cbor": 113,
  "libp2p-key": 114,
  "git-raw": 120,
  "torrent-info": 123,
  "torrent-file": 124,
  "leofcoin-block": 129,
  "leofcoin-tx": 130,
  "leofcoin-pr": 131,
  sctp: sctp$1,
  "eth-block": 144,
  "eth-block-list": 145,
  "eth-tx-trie": 146,
  "eth-tx": 147,
  "eth-tx-receipt-trie": 148,
  "eth-tx-receipt": 149,
  "eth-state-trie": 150,
  "eth-account-snapshot": 151,
  "eth-storage-trie": 152,
  "bitcoin-block": 176,
  "bitcoin-tx": 177,
  "zcash-block": 192,
  "zcash-tx": 193,
  "stellar-block": 208,
  "stellar-tx": 209,
  md4: md4$1,
  md5: md5$2,
  bmt: bmt$1,
  "decred-block": 224,
  "decred-tx": 225,
  "ipld-ns": 226,
  "ipfs-ns": 227,
  "swarm-ns": 228,
  "ipns-ns": 229,
  zeronet: zeronet$1,
  "ed25519-pub": 237,
  "dash-block": 240,
  "dash-tx": 241,
  "swarm-manifest": 250,
  "swarm-feed": 251,
  udp: udp$1,
  "p2p-webrtc-star": 275,
  "p2p-webrtc-direct": 276,
  "p2p-stardust": 277,
  "p2p-circuit": 290,
  "dag-json": 297,
  udt: udt$1,
  utp: utp$1,
  unix: unix$1,
  p2p: p2p$1,
  ipfs: ipfs$1,
  https: https$1,
  onion: onion$1,
  onion3: onion3$1,
  garlic64: garlic64$1,
  garlic32: garlic32$1,
  tls: tls$1,
  quic: quic$1,
  ws: ws$1,
  wss: wss$1,
  "p2p-websocket-star": 479,
  http: http$1,
  json: json$1,
  messagepack: messagepack$1,
  x11: x11$1,
  "blake2b-8": 45569,
  "blake2b-16": 45570,
  "blake2b-24": 45571,
  "blake2b-32": 45572,
  "blake2b-40": 45573,
  "blake2b-48": 45574,
  "blake2b-56": 45575,
  "blake2b-64": 45576,
  "blake2b-72": 45577,
  "blake2b-80": 45578,
  "blake2b-88": 45579,
  "blake2b-96": 45580,
  "blake2b-104": 45581,
  "blake2b-112": 45582,
  "blake2b-120": 45583,
  "blake2b-128": 45584,
  "blake2b-136": 45585,
  "blake2b-144": 45586,
  "blake2b-152": 45587,
  "blake2b-160": 45588,
  "blake2b-168": 45589,
  "blake2b-176": 45590,
  "blake2b-184": 45591,
  "blake2b-192": 45592,
  "blake2b-200": 45593,
  "blake2b-208": 45594,
  "blake2b-216": 45595,
  "blake2b-224": 45596,
  "blake2b-232": 45597,
  "blake2b-240": 45598,
  "blake2b-248": 45599,
  "blake2b-256": 45600,
  "blake2b-264": 45601,
  "blake2b-272": 45602,
  "blake2b-280": 45603,
  "blake2b-288": 45604,
  "blake2b-296": 45605,
  "blake2b-304": 45606,
  "blake2b-312": 45607,
  "blake2b-320": 45608,
  "blake2b-328": 45609,
  "blake2b-336": 45610,
  "blake2b-344": 45611,
  "blake2b-352": 45612,
  "blake2b-360": 45613,
  "blake2b-368": 45614,
  "blake2b-376": 45615,
  "blake2b-384": 45616,
  "blake2b-392": 45617,
  "blake2b-400": 45618,
  "blake2b-408": 45619,
  "blake2b-416": 45620,
  "blake2b-424": 45621,
  "blake2b-432": 45622,
  "blake2b-440": 45623,
  "blake2b-448": 45624,
  "blake2b-456": 45625,
  "blake2b-464": 45626,
  "blake2b-472": 45627,
  "blake2b-480": 45628,
  "blake2b-488": 45629,
  "blake2b-496": 45630,
  "blake2b-504": 45631,
  "blake2b-512": 45632,
  "blake2s-8": 45633,
  "blake2s-16": 45634,
  "blake2s-24": 45635,
  "blake2s-32": 45636,
  "blake2s-40": 45637,
  "blake2s-48": 45638,
  "blake2s-56": 45639,
  "blake2s-64": 45640,
  "blake2s-72": 45641,
  "blake2s-80": 45642,
  "blake2s-88": 45643,
  "blake2s-96": 45644,
  "blake2s-104": 45645,
  "blake2s-112": 45646,
  "blake2s-120": 45647,
  "blake2s-128": 45648,
  "blake2s-136": 45649,
  "blake2s-144": 45650,
  "blake2s-152": 45651,
  "blake2s-160": 45652,
  "blake2s-168": 45653,
  "blake2s-176": 45654,
  "blake2s-184": 45655,
  "blake2s-192": 45656,
  "blake2s-200": 45657,
  "blake2s-208": 45658,
  "blake2s-216": 45659,
  "blake2s-224": 45660,
  "blake2s-232": 45661,
  "blake2s-240": 45662,
  "blake2s-248": 45663,
  "blake2s-256": 45664,
  "skein256-8": 45825,
  "skein256-16": 45826,
  "skein256-24": 45827,
  "skein256-32": 45828,
  "skein256-40": 45829,
  "skein256-48": 45830,
  "skein256-56": 45831,
  "skein256-64": 45832,
  "skein256-72": 45833,
  "skein256-80": 45834,
  "skein256-88": 45835,
  "skein256-96": 45836,
  "skein256-104": 45837,
  "skein256-112": 45838,
  "skein256-120": 45839,
  "skein256-128": 45840,
  "skein256-136": 45841,
  "skein256-144": 45842,
  "skein256-152": 45843,
  "skein256-160": 45844,
  "skein256-168": 45845,
  "skein256-176": 45846,
  "skein256-184": 45847,
  "skein256-192": 45848,
  "skein256-200": 45849,
  "skein256-208": 45850,
  "skein256-216": 45851,
  "skein256-224": 45852,
  "skein256-232": 45853,
  "skein256-240": 45854,
  "skein256-248": 45855,
  "skein256-256": 45856,
  "skein512-8": 45857,
  "skein512-16": 45858,
  "skein512-24": 45859,
  "skein512-32": 45860,
  "skein512-40": 45861,
  "skein512-48": 45862,
  "skein512-56": 45863,
  "skein512-64": 45864,
  "skein512-72": 45865,
  "skein512-80": 45866,
  "skein512-88": 45867,
  "skein512-96": 45868,
  "skein512-104": 45869,
  "skein512-112": 45870,
  "skein512-120": 45871,
  "skein512-128": 45872,
  "skein512-136": 45873,
  "skein512-144": 45874,
  "skein512-152": 45875,
  "skein512-160": 45876,
  "skein512-168": 45877,
  "skein512-176": 45878,
  "skein512-184": 45879,
  "skein512-192": 45880,
  "skein512-200": 45881,
  "skein512-208": 45882,
  "skein512-216": 45883,
  "skein512-224": 45884,
  "skein512-232": 45885,
  "skein512-240": 45886,
  "skein512-248": 45887,
  "skein512-256": 45888,
  "skein512-264": 45889,
  "skein512-272": 45890,
  "skein512-280": 45891,
  "skein512-288": 45892,
  "skein512-296": 45893,
  "skein512-304": 45894,
  "skein512-312": 45895,
  "skein512-320": 45896,
  "skein512-328": 45897,
  "skein512-336": 45898,
  "skein512-344": 45899,
  "skein512-352": 45900,
  "skein512-360": 45901,
  "skein512-368": 45902,
  "skein512-376": 45903,
  "skein512-384": 45904,
  "skein512-392": 45905,
  "skein512-400": 45906,
  "skein512-408": 45907,
  "skein512-416": 45908,
  "skein512-424": 45909,
  "skein512-432": 45910,
  "skein512-440": 45911,
  "skein512-448": 45912,
  "skein512-456": 45913,
  "skein512-464": 45914,
  "skein512-472": 45915,
  "skein512-480": 45916,
  "skein512-488": 45917,
  "skein512-496": 45918,
  "skein512-504": 45919,
  "skein512-512": 45920,
  "skein1024-8": 45921,
  "skein1024-16": 45922,
  "skein1024-24": 45923,
  "skein1024-32": 45924,
  "skein1024-40": 45925,
  "skein1024-48": 45926,
  "skein1024-56": 45927,
  "skein1024-64": 45928,
  "skein1024-72": 45929,
  "skein1024-80": 45930,
  "skein1024-88": 45931,
  "skein1024-96": 45932,
  "skein1024-104": 45933,
  "skein1024-112": 45934,
  "skein1024-120": 45935,
  "skein1024-128": 45936,
  "skein1024-136": 45937,
  "skein1024-144": 45938,
  "skein1024-152": 45939,
  "skein1024-160": 45940,
  "skein1024-168": 45941,
  "skein1024-176": 45942,
  "skein1024-184": 45943,
  "skein1024-192": 45944,
  "skein1024-200": 45945,
  "skein1024-208": 45946,
  "skein1024-216": 45947,
  "skein1024-224": 45948,
  "skein1024-232": 45949,
  "skein1024-240": 45950,
  "skein1024-248": 45951,
  "skein1024-256": 45952,
  "skein1024-264": 45953,
  "skein1024-272": 45954,
  "skein1024-280": 45955,
  "skein1024-288": 45956,
  "skein1024-296": 45957,
  "skein1024-304": 45958,
  "skein1024-312": 45959,
  "skein1024-320": 45960,
  "skein1024-328": 45961,
  "skein1024-336": 45962,
  "skein1024-344": 45963,
  "skein1024-352": 45964,
  "skein1024-360": 45965,
  "skein1024-368": 45966,
  "skein1024-376": 45967,
  "skein1024-384": 45968,
  "skein1024-392": 45969,
  "skein1024-400": 45970,
  "skein1024-408": 45971,
  "skein1024-416": 45972,
  "skein1024-424": 45973,
  "skein1024-432": 45974,
  "skein1024-440": 45975,
  "skein1024-448": 45976,
  "skein1024-456": 45977,
  "skein1024-464": 45978,
  "skein1024-472": 45979,
  "skein1024-480": 45980,
  "skein1024-488": 45981,
  "skein1024-496": 45982,
  "skein1024-504": 45983,
  "skein1024-512": 45984,
  "skein1024-520": 45985,
  "skein1024-528": 45986,
  "skein1024-536": 45987,
  "skein1024-544": 45988,
  "skein1024-552": 45989,
  "skein1024-560": 45990,
  "skein1024-568": 45991,
  "skein1024-576": 45992,
  "skein1024-584": 45993,
  "skein1024-592": 45994,
  "skein1024-600": 45995,
  "skein1024-608": 45996,
  "skein1024-616": 45997,
  "skein1024-624": 45998,
  "skein1024-632": 45999,
  "skein1024-640": 46e3,
  "skein1024-648": 46001,
  "skein1024-656": 46002,
  "skein1024-664": 46003,
  "skein1024-672": 46004,
  "skein1024-680": 46005,
  "skein1024-688": 46006,
  "skein1024-696": 46007,
  "skein1024-704": 46008,
  "skein1024-712": 46009,
  "skein1024-720": 46010,
  "skein1024-728": 46011,
  "skein1024-736": 46012,
  "skein1024-744": 46013,
  "skein1024-752": 46014,
  "skein1024-760": 46015,
  "skein1024-768": 46016,
  "skein1024-776": 46017,
  "skein1024-784": 46018,
  "skein1024-792": 46019,
  "skein1024-800": 46020,
  "skein1024-808": 46021,
  "skein1024-816": 46022,
  "skein1024-824": 46023,
  "skein1024-832": 46024,
  "skein1024-840": 46025,
  "skein1024-848": 46026,
  "skein1024-856": 46027,
  "skein1024-864": 46028,
  "skein1024-872": 46029,
  "skein1024-880": 46030,
  "skein1024-888": 46031,
  "skein1024-896": 46032,
  "skein1024-904": 46033,
  "skein1024-912": 46034,
  "skein1024-920": 46035,
  "skein1024-928": 46036,
  "skein1024-936": 46037,
  "skein1024-944": 46038,
  "skein1024-952": 46039,
  "skein1024-960": 46040,
  "skein1024-968": 46041,
  "skein1024-976": 46042,
  "skein1024-984": 46043,
  "skein1024-992": 46044,
  "skein1024-1000": 46045,
  "skein1024-1008": 46046,
  "skein1024-1016": 46047,
  "skein1024-1024": 46048,
  "holochain-adr-v0": 8417572,
  "holochain-adr-v1": 8483108,
  "holochain-key-v0": 9728292,
  "holochain-key-v1": 9793828,
  "holochain-sig-v0": 10645796,
  "holochain-sig-v1": 10711332
}, baseTable$3 = require$$0$2, nameTable$1 = /* @__PURE__ */ new Map();
for (const c in baseTable$3) {
  const t = baseTable$3[c];
  nameTable$1.set(t, c);
}
var intTable$1 = Object.freeze(nameTable$1);
const varint$1 = varint$2;
var util$6 = {
  numberToBuffer: numberToBuffer$1,
  bufferToNumber: bufferToNumber$1,
  varintBufferEncode: varintBufferEncode$1,
  varintBufferDecode: varintBufferDecode$1,
  varintEncode: varintEncode$3
};
function bufferToNumber$1(c) {
  return parseInt(c.toString("hex"), 16);
}
function numberToBuffer$1(c) {
  let t = c.toString(16);
  return t.length % 2 === 1 && (t = "0" + t), Buffer$7.from(t, "hex");
}
function varintBufferEncode$1(c) {
  return Buffer$7.from(varint$1.encode(bufferToNumber$1(c)));
}
function varintBufferDecode$1(c) {
  return numberToBuffer$1(varint$1.decode(c));
}
function varintEncode$3(c) {
  return Buffer$7.from(varint$1.encode(c));
}
const baseTable$2 = require$$0$2, varintEncode$2 = util$6.varintEncode, varintTable$1 = {};
for (const c in baseTable$2) {
  const t = baseTable$2[c];
  varintTable$1[c] = varintEncode$2(t);
}
var varintTable_1$1 = Object.freeze(varintTable$1), constants_1$3, hasRequiredConstants$2;
function requireConstants$2() {
  if (hasRequiredConstants$2) return constants_1$3;
  hasRequiredConstants$2 = 1;
  const c = require$$0$2, t = {};
  for (const [n, ie] of Object.entries(c))
    t[n.toUpperCase().replace(/-/g, "_")] = ie;
  return constants_1$3 = Object.freeze(t), constants_1$3;
}
var print$1, hasRequiredPrint$1;
function requirePrint$1() {
  if (hasRequiredPrint$1) return print$1;
  hasRequiredPrint$1 = 1;
  const c = require$$0$2, t = {};
  for (const [n, ie] of Object.entries(c))
    t[ie] === void 0 && (t[ie] = n);
  return print$1 = Object.freeze(t), print$1;
}
(function(c, t) {
  const n = varint$2, ie = intTable$1, fe = varintTable_1$1, ae = util$6;
  t = c.exports, t.addPrefix = (he, me) => {
    let ye;
    if (Buffer$7.isBuffer(he))
      ye = ae.varintBufferEncode(he);
    else if (fe[he])
      ye = fe[he];
    else
      throw new Error("multicodec not recognized");
    return Buffer$7.concat([ye, me]);
  }, t.rmPrefix = (he) => (n.decode(he), he.slice(n.decode.bytes)), t.getCodec = (he) => {
    const me = n.decode(he), ye = ie.get(me);
    if (ye === void 0)
      throw new Error(`Code ${me} not found`);
    return ye;
  }, t.getName = (he) => ie.get(he), t.getNumber = (he) => {
    const me = fe[he];
    if (me === void 0)
      throw new Error("Codec `" + he + "` not found");
    return ae.varintBufferDecode(me)[0];
  }, t.getCode = (he) => n.decode(he), t.getCodeVarint = (he) => {
    const me = fe[he];
    if (me === void 0)
      throw new Error("Codec `" + he + "` not found");
    return me;
  }, t.getVarint = (he) => n.encode(he);
  const le = requireConstants$2();
  Object.assign(t, le), t.print = requirePrint$1();
})(src$6, src$6.exports);
var srcExports$3 = src$6.exports, profiles$2 = {}, src$5 = {}, src$4 = { exports: {} };
let Base$6 = class {
  constructor(t, n, ie, fe) {
    this.name = t, this.code = n, this.alphabet = fe, ie && fe && (this.engine = ie(fe));
  }
  encode(t) {
    return this.engine.encode(t);
  }
  decode(t) {
    return this.engine.decode(t);
  }
  isImplemented() {
    return this.engine;
  }
};
var base$4 = Base$6;
const { Buffer: Buffer$6 } = require$$0$5;
var base16$3 = function(t) {
  return {
    encode(n) {
      return typeof n == "string" ? Buffer$6.from(n).toString("hex") : n.toString("hex");
    },
    decode(n) {
      for (const ie of n)
        if (t.indexOf(ie) < 0)
          throw new Error("invalid base16 character");
      return Buffer$6.from(n, "hex");
    }
  };
};
function decode$3(c, t) {
  c = c.replace(new RegExp("=", "g"), "");
  const n = c.length;
  let ie = 0, fe = 0, ae = 0;
  const le = new Uint8Array(n * 5 / 8 | 0);
  for (let he = 0; he < n; he++)
    fe = fe << 5 | t.indexOf(c[he]), ie += 5, ie >= 8 && (le[ae++] = fe >>> ie - 8 & 255, ie -= 8);
  return le.buffer;
}
function encode$2(c, t) {
  const n = c.byteLength, ie = new Uint8Array(c), fe = t.indexOf("=") === t.length - 1;
  fe && (t = t.substring(0, t.length - 1));
  let ae = 0, le = 0, he = "";
  for (let me = 0; me < n; me++)
    for (le = le << 8 | ie[me], ae += 8; ae >= 5; )
      he += t[le >>> ae - 5 & 31], ae -= 5;
  if (ae > 0 && (he += t[le << 5 - ae & 31]), fe)
    for (; he.length % 8 !== 0; )
      he += "=";
  return he;
}
var base32$3 = function(t) {
  return {
    encode(n) {
      return encode$2(typeof n == "string" ? Uint8Array.from(n) : n, t);
    },
    decode(n) {
      for (const ie of n)
        if (t.indexOf(ie) < 0)
          throw new Error("invalid base32 character");
      return decode$3(n, t);
    }
  };
};
const { Buffer: Buffer$5 } = require$$0$5;
var base64$3 = function(t) {
  const n = t.indexOf("=") > -1, ie = t.indexOf("-") > -1 && t.indexOf("_") > -1;
  return {
    encode(fe) {
      let ae = "";
      typeof fe == "string" ? ae = Buffer$5.from(fe).toString("base64") : ae = fe.toString("base64"), ie && (ae = ae.replace(/\+/g, "-").replace(/\//g, "_"));
      const le = ae.indexOf("=");
      return le > 0 && !n && (ae = ae.substring(0, le)), ae;
    },
    decode(fe) {
      for (const ae of fe)
        if (t.indexOf(ae) < 0)
          throw new Error("invalid base64 character");
      return Buffer$5.from(fe, "base64");
    }
  };
};
const Base$5 = base$4, baseX$1 = src$7, base16$2 = base16$3, base32$2 = base32$3, base64$2 = base64$3, constants$3 = [
  ["base1", "1", "", "1"],
  ["base2", "0", baseX$1, "01"],
  ["base8", "7", baseX$1, "01234567"],
  ["base10", "9", baseX$1, "0123456789"],
  ["base16", "f", base16$2, "0123456789abcdef"],
  ["base32", "b", base32$2, "abcdefghijklmnopqrstuvwxyz234567"],
  ["base32pad", "c", base32$2, "abcdefghijklmnopqrstuvwxyz234567="],
  ["base32hex", "v", base32$2, "0123456789abcdefghijklmnopqrstuv"],
  ["base32hexpad", "t", base32$2, "0123456789abcdefghijklmnopqrstuv="],
  ["base32z", "h", base32$2, "ybndrfg8ejkmcpqxot1uwisza345h769"],
  ["base58flickr", "Z", baseX$1, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"],
  ["base58btc", "z", baseX$1, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"],
  ["base64", "m", base64$2, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"],
  ["base64pad", "M", base64$2, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="],
  ["base64url", "u", base64$2, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"],
  ["base64urlpad", "U", base64$2, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]
], names$1 = constants$3.reduce((c, t) => (c[t[0]] = new Base$5(t[0], t[1], t[2], t[3]), c), {}), codes$1 = constants$3.reduce((c, t) => (c[t[1]] = names$1[t[0]], c), {});
var constants_1$2 = {
  names: names$1,
  codes: codes$1
};
(function(c, t) {
  const { Buffer: n } = require$$0$5, ie = constants_1$2;
  t = c.exports = fe, t.encode = ae, t.decode = le, t.isEncoded = he, t.names = Object.freeze(Object.keys(ie.names)), t.codes = Object.freeze(Object.keys(ie.codes));
  function fe(be, Ae) {
    if (!Ae)
      throw new Error("requires an encoded buffer");
    const Se = ye(be), $e = n.from(Se.code), Re = Se.name;
    return me(Re, Ae), n.concat([$e, Ae]);
  }
  function ae(be, Ae) {
    const Se = ye(be), $e = Se.name;
    return fe($e, n.from(Se.encode(Ae)));
  }
  function le(be) {
    n.isBuffer(be) && (be = be.toString());
    const Ae = be.substring(0, 1);
    be = be.substring(1, be.length), typeof be == "string" && (be = n.from(be));
    const Se = ye(Ae);
    return n.from(Se.decode(be.toString()));
  }
  function he(be) {
    if (n.isBuffer(be) && (be = be.toString()), Object.prototype.toString.call(be) !== "[object String]")
      return !1;
    const Ae = be.substring(0, 1);
    try {
      return ye(Ae).name;
    } catch {
      return !1;
    }
  }
  function me(be, Ae) {
    ye(be).decode(Ae.toString());
  }
  function ye(be) {
    let Ae;
    if (ie.names[be])
      Ae = ie.names[be];
    else if (ie.codes[be])
      Ae = ie.codes[be];
    else
      throw new Error("Unsupported encoding");
    if (!Ae.isImplemented())
      throw new Error("Base " + be + " is not implemented yet");
    return Ae;
  }
})(src$4, src$4.exports);
var srcExports$2 = src$4.exports, constants$2 = {};
constants$2.names = Object.freeze({
  identity: 0,
  sha1: 17,
  "sha2-256": 18,
  "sha2-512": 19,
  "dbl-sha2-256": 86,
  "sha3-224": 23,
  "sha3-256": 22,
  "sha3-384": 21,
  "sha3-512": 20,
  "shake-128": 24,
  "shake-256": 25,
  "keccak-224": 26,
  "keccak-256": 27,
  "keccak-384": 28,
  "keccak-512": 29,
  "murmur3-128": 34,
  "murmur3-32": 35,
  md4: 212,
  md5: 213,
  "blake2b-8": 45569,
  "blake2b-16": 45570,
  "blake2b-24": 45571,
  "blake2b-32": 45572,
  "blake2b-40": 45573,
  "blake2b-48": 45574,
  "blake2b-56": 45575,
  "blake2b-64": 45576,
  "blake2b-72": 45577,
  "blake2b-80": 45578,
  "blake2b-88": 45579,
  "blake2b-96": 45580,
  "blake2b-104": 45581,
  "blake2b-112": 45582,
  "blake2b-120": 45583,
  "blake2b-128": 45584,
  "blake2b-136": 45585,
  "blake2b-144": 45586,
  "blake2b-152": 45587,
  "blake2b-160": 45588,
  "blake2b-168": 45589,
  "blake2b-176": 45590,
  "blake2b-184": 45591,
  "blake2b-192": 45592,
  "blake2b-200": 45593,
  "blake2b-208": 45594,
  "blake2b-216": 45595,
  "blake2b-224": 45596,
  "blake2b-232": 45597,
  "blake2b-240": 45598,
  "blake2b-248": 45599,
  "blake2b-256": 45600,
  "blake2b-264": 45601,
  "blake2b-272": 45602,
  "blake2b-280": 45603,
  "blake2b-288": 45604,
  "blake2b-296": 45605,
  "blake2b-304": 45606,
  "blake2b-312": 45607,
  "blake2b-320": 45608,
  "blake2b-328": 45609,
  "blake2b-336": 45610,
  "blake2b-344": 45611,
  "blake2b-352": 45612,
  "blake2b-360": 45613,
  "blake2b-368": 45614,
  "blake2b-376": 45615,
  "blake2b-384": 45616,
  "blake2b-392": 45617,
  "blake2b-400": 45618,
  "blake2b-408": 45619,
  "blake2b-416": 45620,
  "blake2b-424": 45621,
  "blake2b-432": 45622,
  "blake2b-440": 45623,
  "blake2b-448": 45624,
  "blake2b-456": 45625,
  "blake2b-464": 45626,
  "blake2b-472": 45627,
  "blake2b-480": 45628,
  "blake2b-488": 45629,
  "blake2b-496": 45630,
  "blake2b-504": 45631,
  "blake2b-512": 45632,
  "blake2s-8": 45633,
  "blake2s-16": 45634,
  "blake2s-24": 45635,
  "blake2s-32": 45636,
  "blake2s-40": 45637,
  "blake2s-48": 45638,
  "blake2s-56": 45639,
  "blake2s-64": 45640,
  "blake2s-72": 45641,
  "blake2s-80": 45642,
  "blake2s-88": 45643,
  "blake2s-96": 45644,
  "blake2s-104": 45645,
  "blake2s-112": 45646,
  "blake2s-120": 45647,
  "blake2s-128": 45648,
  "blake2s-136": 45649,
  "blake2s-144": 45650,
  "blake2s-152": 45651,
  "blake2s-160": 45652,
  "blake2s-168": 45653,
  "blake2s-176": 45654,
  "blake2s-184": 45655,
  "blake2s-192": 45656,
  "blake2s-200": 45657,
  "blake2s-208": 45658,
  "blake2s-216": 45659,
  "blake2s-224": 45660,
  "blake2s-232": 45661,
  "blake2s-240": 45662,
  "blake2s-248": 45663,
  "blake2s-256": 45664,
  "Skein256-8": 45825,
  "Skein256-16": 45826,
  "Skein256-24": 45827,
  "Skein256-32": 45828,
  "Skein256-40": 45829,
  "Skein256-48": 45830,
  "Skein256-56": 45831,
  "Skein256-64": 45832,
  "Skein256-72": 45833,
  "Skein256-80": 45834,
  "Skein256-88": 45835,
  "Skein256-96": 45836,
  "Skein256-104": 45837,
  "Skein256-112": 45838,
  "Skein256-120": 45839,
  "Skein256-128": 45840,
  "Skein256-136": 45841,
  "Skein256-144": 45842,
  "Skein256-152": 45843,
  "Skein256-160": 45844,
  "Skein256-168": 45845,
  "Skein256-176": 45846,
  "Skein256-184": 45847,
  "Skein256-192": 45848,
  "Skein256-200": 45849,
  "Skein256-208": 45850,
  "Skein256-216": 45851,
  "Skein256-224": 45852,
  "Skein256-232": 45853,
  "Skein256-240": 45854,
  "Skein256-248": 45855,
  "Skein256-256": 45856,
  "Skein512-8": 45857,
  "Skein512-16": 45858,
  "Skein512-24": 45859,
  "Skein512-32": 45860,
  "Skein512-40": 45861,
  "Skein512-48": 45862,
  "Skein512-56": 45863,
  "Skein512-64": 45864,
  "Skein512-72": 45865,
  "Skein512-80": 45866,
  "Skein512-88": 45867,
  "Skein512-96": 45868,
  "Skein512-104": 45869,
  "Skein512-112": 45870,
  "Skein512-120": 45871,
  "Skein512-128": 45872,
  "Skein512-136": 45873,
  "Skein512-144": 45874,
  "Skein512-152": 45875,
  "Skein512-160": 45876,
  "Skein512-168": 45877,
  "Skein512-176": 45878,
  "Skein512-184": 45879,
  "Skein512-192": 45880,
  "Skein512-200": 45881,
  "Skein512-208": 45882,
  "Skein512-216": 45883,
  "Skein512-224": 45884,
  "Skein512-232": 45885,
  "Skein512-240": 45886,
  "Skein512-248": 45887,
  "Skein512-256": 45888,
  "Skein512-264": 45889,
  "Skein512-272": 45890,
  "Skein512-280": 45891,
  "Skein512-288": 45892,
  "Skein512-296": 45893,
  "Skein512-304": 45894,
  "Skein512-312": 45895,
  "Skein512-320": 45896,
  "Skein512-328": 45897,
  "Skein512-336": 45898,
  "Skein512-344": 45899,
  "Skein512-352": 45900,
  "Skein512-360": 45901,
  "Skein512-368": 45902,
  "Skein512-376": 45903,
  "Skein512-384": 45904,
  "Skein512-392": 45905,
  "Skein512-400": 45906,
  "Skein512-408": 45907,
  "Skein512-416": 45908,
  "Skein512-424": 45909,
  "Skein512-432": 45910,
  "Skein512-440": 45911,
  "Skein512-448": 45912,
  "Skein512-456": 45913,
  "Skein512-464": 45914,
  "Skein512-472": 45915,
  "Skein512-480": 45916,
  "Skein512-488": 45917,
  "Skein512-496": 45918,
  "Skein512-504": 45919,
  "Skein512-512": 45920,
  "Skein1024-8": 45921,
  "Skein1024-16": 45922,
  "Skein1024-24": 45923,
  "Skein1024-32": 45924,
  "Skein1024-40": 45925,
  "Skein1024-48": 45926,
  "Skein1024-56": 45927,
  "Skein1024-64": 45928,
  "Skein1024-72": 45929,
  "Skein1024-80": 45930,
  "Skein1024-88": 45931,
  "Skein1024-96": 45932,
  "Skein1024-104": 45933,
  "Skein1024-112": 45934,
  "Skein1024-120": 45935,
  "Skein1024-128": 45936,
  "Skein1024-136": 45937,
  "Skein1024-144": 45938,
  "Skein1024-152": 45939,
  "Skein1024-160": 45940,
  "Skein1024-168": 45941,
  "Skein1024-176": 45942,
  "Skein1024-184": 45943,
  "Skein1024-192": 45944,
  "Skein1024-200": 45945,
  "Skein1024-208": 45946,
  "Skein1024-216": 45947,
  "Skein1024-224": 45948,
  "Skein1024-232": 45949,
  "Skein1024-240": 45950,
  "Skein1024-248": 45951,
  "Skein1024-256": 45952,
  "Skein1024-264": 45953,
  "Skein1024-272": 45954,
  "Skein1024-280": 45955,
  "Skein1024-288": 45956,
  "Skein1024-296": 45957,
  "Skein1024-304": 45958,
  "Skein1024-312": 45959,
  "Skein1024-320": 45960,
  "Skein1024-328": 45961,
  "Skein1024-336": 45962,
  "Skein1024-344": 45963,
  "Skein1024-352": 45964,
  "Skein1024-360": 45965,
  "Skein1024-368": 45966,
  "Skein1024-376": 45967,
  "Skein1024-384": 45968,
  "Skein1024-392": 45969,
  "Skein1024-400": 45970,
  "Skein1024-408": 45971,
  "Skein1024-416": 45972,
  "Skein1024-424": 45973,
  "Skein1024-432": 45974,
  "Skein1024-440": 45975,
  "Skein1024-448": 45976,
  "Skein1024-456": 45977,
  "Skein1024-464": 45978,
  "Skein1024-472": 45979,
  "Skein1024-480": 45980,
  "Skein1024-488": 45981,
  "Skein1024-496": 45982,
  "Skein1024-504": 45983,
  "Skein1024-512": 45984,
  "Skein1024-520": 45985,
  "Skein1024-528": 45986,
  "Skein1024-536": 45987,
  "Skein1024-544": 45988,
  "Skein1024-552": 45989,
  "Skein1024-560": 45990,
  "Skein1024-568": 45991,
  "Skein1024-576": 45992,
  "Skein1024-584": 45993,
  "Skein1024-592": 45994,
  "Skein1024-600": 45995,
  "Skein1024-608": 45996,
  "Skein1024-616": 45997,
  "Skein1024-624": 45998,
  "Skein1024-632": 45999,
  "Skein1024-640": 46e3,
  "Skein1024-648": 46001,
  "Skein1024-656": 46002,
  "Skein1024-664": 46003,
  "Skein1024-672": 46004,
  "Skein1024-680": 46005,
  "Skein1024-688": 46006,
  "Skein1024-696": 46007,
  "Skein1024-704": 46008,
  "Skein1024-712": 46009,
  "Skein1024-720": 46010,
  "Skein1024-728": 46011,
  "Skein1024-736": 46012,
  "Skein1024-744": 46013,
  "Skein1024-752": 46014,
  "Skein1024-760": 46015,
  "Skein1024-768": 46016,
  "Skein1024-776": 46017,
  "Skein1024-784": 46018,
  "Skein1024-792": 46019,
  "Skein1024-800": 46020,
  "Skein1024-808": 46021,
  "Skein1024-816": 46022,
  "Skein1024-824": 46023,
  "Skein1024-832": 46024,
  "Skein1024-840": 46025,
  "Skein1024-848": 46026,
  "Skein1024-856": 46027,
  "Skein1024-864": 46028,
  "Skein1024-872": 46029,
  "Skein1024-880": 46030,
  "Skein1024-888": 46031,
  "Skein1024-896": 46032,
  "Skein1024-904": 46033,
  "Skein1024-912": 46034,
  "Skein1024-920": 46035,
  "Skein1024-928": 46036,
  "Skein1024-936": 46037,
  "Skein1024-944": 46038,
  "Skein1024-952": 46039,
  "Skein1024-960": 46040,
  "Skein1024-968": 46041,
  "Skein1024-976": 46042,
  "Skein1024-984": 46043,
  "Skein1024-992": 46044,
  "Skein1024-1000": 46045,
  "Skein1024-1008": 46046,
  "Skein1024-1016": 46047,
  "Skein1024-1024": 46048
});
constants$2.codes = Object.freeze({
  0: "identity",
  // sha family
  17: "sha1",
  18: "sha2-256",
  19: "sha2-512",
  86: "dbl-sha2-256",
  23: "sha3-224",
  22: "sha3-256",
  21: "sha3-384",
  20: "sha3-512",
  24: "shake-128",
  25: "shake-256",
  26: "keccak-224",
  27: "keccak-256",
  28: "keccak-384",
  29: "keccak-512",
  34: "murmur3-128",
  35: "murmur3-32",
  212: "md4",
  213: "md5",
  // blake2
  45569: "blake2b-8",
  45570: "blake2b-16",
  45571: "blake2b-24",
  45572: "blake2b-32",
  45573: "blake2b-40",
  45574: "blake2b-48",
  45575: "blake2b-56",
  45576: "blake2b-64",
  45577: "blake2b-72",
  45578: "blake2b-80",
  45579: "blake2b-88",
  45580: "blake2b-96",
  45581: "blake2b-104",
  45582: "blake2b-112",
  45583: "blake2b-120",
  45584: "blake2b-128",
  45585: "blake2b-136",
  45586: "blake2b-144",
  45587: "blake2b-152",
  45588: "blake2b-160",
  45589: "blake2b-168",
  45590: "blake2b-176",
  45591: "blake2b-184",
  45592: "blake2b-192",
  45593: "blake2b-200",
  45594: "blake2b-208",
  45595: "blake2b-216",
  45596: "blake2b-224",
  45597: "blake2b-232",
  45598: "blake2b-240",
  45599: "blake2b-248",
  45600: "blake2b-256",
  45601: "blake2b-264",
  45602: "blake2b-272",
  45603: "blake2b-280",
  45604: "blake2b-288",
  45605: "blake2b-296",
  45606: "blake2b-304",
  45607: "blake2b-312",
  45608: "blake2b-320",
  45609: "blake2b-328",
  45610: "blake2b-336",
  45611: "blake2b-344",
  45612: "blake2b-352",
  45613: "blake2b-360",
  45614: "blake2b-368",
  45615: "blake2b-376",
  45616: "blake2b-384",
  45617: "blake2b-392",
  45618: "blake2b-400",
  45619: "blake2b-408",
  45620: "blake2b-416",
  45621: "blake2b-424",
  45622: "blake2b-432",
  45623: "blake2b-440",
  45624: "blake2b-448",
  45625: "blake2b-456",
  45626: "blake2b-464",
  45627: "blake2b-472",
  45628: "blake2b-480",
  45629: "blake2b-488",
  45630: "blake2b-496",
  45631: "blake2b-504",
  45632: "blake2b-512",
  45633: "blake2s-8",
  45634: "blake2s-16",
  45635: "blake2s-24",
  45636: "blake2s-32",
  45637: "blake2s-40",
  45638: "blake2s-48",
  45639: "blake2s-56",
  45640: "blake2s-64",
  45641: "blake2s-72",
  45642: "blake2s-80",
  45643: "blake2s-88",
  45644: "blake2s-96",
  45645: "blake2s-104",
  45646: "blake2s-112",
  45647: "blake2s-120",
  45648: "blake2s-128",
  45649: "blake2s-136",
  45650: "blake2s-144",
  45651: "blake2s-152",
  45652: "blake2s-160",
  45653: "blake2s-168",
  45654: "blake2s-176",
  45655: "blake2s-184",
  45656: "blake2s-192",
  45657: "blake2s-200",
  45658: "blake2s-208",
  45659: "blake2s-216",
  45660: "blake2s-224",
  45661: "blake2s-232",
  45662: "blake2s-240",
  45663: "blake2s-248",
  45664: "blake2s-256",
  // skein
  45825: "Skein256-8",
  45826: "Skein256-16",
  45827: "Skein256-24",
  45828: "Skein256-32",
  45829: "Skein256-40",
  45830: "Skein256-48",
  45831: "Skein256-56",
  45832: "Skein256-64",
  45833: "Skein256-72",
  45834: "Skein256-80",
  45835: "Skein256-88",
  45836: "Skein256-96",
  45837: "Skein256-104",
  45838: "Skein256-112",
  45839: "Skein256-120",
  45840: "Skein256-128",
  45841: "Skein256-136",
  45842: "Skein256-144",
  45843: "Skein256-152",
  45844: "Skein256-160",
  45845: "Skein256-168",
  45846: "Skein256-176",
  45847: "Skein256-184",
  45848: "Skein256-192",
  45849: "Skein256-200",
  45850: "Skein256-208",
  45851: "Skein256-216",
  45852: "Skein256-224",
  45853: "Skein256-232",
  45854: "Skein256-240",
  45855: "Skein256-248",
  45856: "Skein256-256",
  45857: "Skein512-8",
  45858: "Skein512-16",
  45859: "Skein512-24",
  45860: "Skein512-32",
  45861: "Skein512-40",
  45862: "Skein512-48",
  45863: "Skein512-56",
  45864: "Skein512-64",
  45865: "Skein512-72",
  45866: "Skein512-80",
  45867: "Skein512-88",
  45868: "Skein512-96",
  45869: "Skein512-104",
  45870: "Skein512-112",
  45871: "Skein512-120",
  45872: "Skein512-128",
  45873: "Skein512-136",
  45874: "Skein512-144",
  45875: "Skein512-152",
  45876: "Skein512-160",
  45877: "Skein512-168",
  45878: "Skein512-176",
  45879: "Skein512-184",
  45880: "Skein512-192",
  45881: "Skein512-200",
  45882: "Skein512-208",
  45883: "Skein512-216",
  45884: "Skein512-224",
  45885: "Skein512-232",
  45886: "Skein512-240",
  45887: "Skein512-248",
  45888: "Skein512-256",
  45889: "Skein512-264",
  45890: "Skein512-272",
  45891: "Skein512-280",
  45892: "Skein512-288",
  45893: "Skein512-296",
  45894: "Skein512-304",
  45895: "Skein512-312",
  45896: "Skein512-320",
  45897: "Skein512-328",
  45898: "Skein512-336",
  45899: "Skein512-344",
  45900: "Skein512-352",
  45901: "Skein512-360",
  45902: "Skein512-368",
  45903: "Skein512-376",
  45904: "Skein512-384",
  45905: "Skein512-392",
  45906: "Skein512-400",
  45907: "Skein512-408",
  45908: "Skein512-416",
  45909: "Skein512-424",
  45910: "Skein512-432",
  45911: "Skein512-440",
  45912: "Skein512-448",
  45913: "Skein512-456",
  45914: "Skein512-464",
  45915: "Skein512-472",
  45916: "Skein512-480",
  45917: "Skein512-488",
  45918: "Skein512-496",
  45919: "Skein512-504",
  45920: "Skein512-512",
  45921: "Skein1024-8",
  45922: "Skein1024-16",
  45923: "Skein1024-24",
  45924: "Skein1024-32",
  45925: "Skein1024-40",
  45926: "Skein1024-48",
  45927: "Skein1024-56",
  45928: "Skein1024-64",
  45929: "Skein1024-72",
  45930: "Skein1024-80",
  45931: "Skein1024-88",
  45932: "Skein1024-96",
  45933: "Skein1024-104",
  45934: "Skein1024-112",
  45935: "Skein1024-120",
  45936: "Skein1024-128",
  45937: "Skein1024-136",
  45938: "Skein1024-144",
  45939: "Skein1024-152",
  45940: "Skein1024-160",
  45941: "Skein1024-168",
  45942: "Skein1024-176",
  45943: "Skein1024-184",
  45944: "Skein1024-192",
  45945: "Skein1024-200",
  45946: "Skein1024-208",
  45947: "Skein1024-216",
  45948: "Skein1024-224",
  45949: "Skein1024-232",
  45950: "Skein1024-240",
  45951: "Skein1024-248",
  45952: "Skein1024-256",
  45953: "Skein1024-264",
  45954: "Skein1024-272",
  45955: "Skein1024-280",
  45956: "Skein1024-288",
  45957: "Skein1024-296",
  45958: "Skein1024-304",
  45959: "Skein1024-312",
  45960: "Skein1024-320",
  45961: "Skein1024-328",
  45962: "Skein1024-336",
  45963: "Skein1024-344",
  45964: "Skein1024-352",
  45965: "Skein1024-360",
  45966: "Skein1024-368",
  45967: "Skein1024-376",
  45968: "Skein1024-384",
  45969: "Skein1024-392",
  45970: "Skein1024-400",
  45971: "Skein1024-408",
  45972: "Skein1024-416",
  45973: "Skein1024-424",
  45974: "Skein1024-432",
  45975: "Skein1024-440",
  45976: "Skein1024-448",
  45977: "Skein1024-456",
  45978: "Skein1024-464",
  45979: "Skein1024-472",
  45980: "Skein1024-480",
  45981: "Skein1024-488",
  45982: "Skein1024-496",
  45983: "Skein1024-504",
  45984: "Skein1024-512",
  45985: "Skein1024-520",
  45986: "Skein1024-528",
  45987: "Skein1024-536",
  45988: "Skein1024-544",
  45989: "Skein1024-552",
  45990: "Skein1024-560",
  45991: "Skein1024-568",
  45992: "Skein1024-576",
  45993: "Skein1024-584",
  45994: "Skein1024-592",
  45995: "Skein1024-600",
  45996: "Skein1024-608",
  45997: "Skein1024-616",
  45998: "Skein1024-624",
  45999: "Skein1024-632",
  46e3: "Skein1024-640",
  46001: "Skein1024-648",
  46002: "Skein1024-656",
  46003: "Skein1024-664",
  46004: "Skein1024-672",
  46005: "Skein1024-680",
  46006: "Skein1024-688",
  46007: "Skein1024-696",
  46008: "Skein1024-704",
  46009: "Skein1024-712",
  46010: "Skein1024-720",
  46011: "Skein1024-728",
  46012: "Skein1024-736",
  46013: "Skein1024-744",
  46014: "Skein1024-752",
  46015: "Skein1024-760",
  46016: "Skein1024-768",
  46017: "Skein1024-776",
  46018: "Skein1024-784",
  46019: "Skein1024-792",
  46020: "Skein1024-800",
  46021: "Skein1024-808",
  46022: "Skein1024-816",
  46023: "Skein1024-824",
  46024: "Skein1024-832",
  46025: "Skein1024-840",
  46026: "Skein1024-848",
  46027: "Skein1024-856",
  46028: "Skein1024-864",
  46029: "Skein1024-872",
  46030: "Skein1024-880",
  46031: "Skein1024-888",
  46032: "Skein1024-896",
  46033: "Skein1024-904",
  46034: "Skein1024-912",
  46035: "Skein1024-920",
  46036: "Skein1024-928",
  46037: "Skein1024-936",
  46038: "Skein1024-944",
  46039: "Skein1024-952",
  46040: "Skein1024-960",
  46041: "Skein1024-968",
  46042: "Skein1024-976",
  46043: "Skein1024-984",
  46044: "Skein1024-992",
  46045: "Skein1024-1000",
  46046: "Skein1024-1008",
  46047: "Skein1024-1016",
  46048: "Skein1024-1024"
});
constants$2.defaultLengths = Object.freeze({
  17: 20,
  18: 32,
  19: 64,
  86: 32,
  23: 28,
  22: 32,
  21: 48,
  20: 64,
  24: 32,
  25: 64,
  26: 28,
  27: 32,
  28: 48,
  29: 64,
  34: 32,
  45569: 1,
  45570: 2,
  45571: 3,
  45572: 4,
  45573: 5,
  45574: 6,
  45575: 7,
  45576: 8,
  45577: 9,
  45578: 10,
  45579: 11,
  45580: 12,
  45581: 13,
  45582: 14,
  45583: 15,
  45584: 16,
  45585: 17,
  45586: 18,
  45587: 19,
  45588: 20,
  45589: 21,
  45590: 22,
  45591: 23,
  45592: 24,
  45593: 25,
  45594: 26,
  45595: 27,
  45596: 28,
  45597: 29,
  45598: 30,
  45599: 31,
  45600: 32,
  45601: 33,
  45602: 34,
  45603: 35,
  45604: 36,
  45605: 37,
  45606: 38,
  45607: 39,
  45608: 40,
  45609: 41,
  45610: 42,
  45611: 43,
  45612: 44,
  45613: 45,
  45614: 46,
  45615: 47,
  45616: 48,
  45617: 49,
  45618: 50,
  45619: 51,
  45620: 52,
  45621: 53,
  45622: 54,
  45623: 55,
  45624: 56,
  45625: 57,
  45626: 58,
  45627: 59,
  45628: 60,
  45629: 61,
  45630: 62,
  45631: 63,
  45632: 64,
  45633: 1,
  45634: 2,
  45635: 3,
  45636: 4,
  45637: 5,
  45638: 6,
  45639: 7,
  45640: 8,
  45641: 9,
  45642: 10,
  45643: 11,
  45644: 12,
  45645: 13,
  45646: 14,
  45647: 15,
  45648: 16,
  45649: 17,
  45650: 18,
  45651: 19,
  45652: 20,
  45653: 21,
  45654: 22,
  45655: 23,
  45656: 24,
  45657: 25,
  45658: 26,
  45659: 27,
  45660: 28,
  45661: 29,
  45662: 30,
  45663: 31,
  45664: 32,
  45825: 1,
  45826: 2,
  45827: 3,
  45828: 4,
  45829: 5,
  45830: 6,
  45831: 7,
  45832: 8,
  45833: 9,
  45834: 10,
  45835: 11,
  45836: 12,
  45837: 13,
  45838: 14,
  45839: 15,
  45840: 16,
  45841: 17,
  45842: 18,
  45843: 19,
  45844: 20,
  45845: 21,
  45846: 22,
  45847: 23,
  45848: 24,
  45849: 25,
  45850: 26,
  45851: 27,
  45852: 28,
  45853: 29,
  45854: 30,
  45855: 31,
  45856: 32,
  45857: 1,
  45858: 2,
  45859: 3,
  45860: 4,
  45861: 5,
  45862: 6,
  45863: 7,
  45864: 8,
  45865: 9,
  45866: 10,
  45867: 11,
  45868: 12,
  45869: 13,
  45870: 14,
  45871: 15,
  45872: 16,
  45873: 17,
  45874: 18,
  45875: 19,
  45876: 20,
  45877: 21,
  45878: 22,
  45879: 23,
  45880: 24,
  45881: 25,
  45882: 26,
  45883: 27,
  45884: 28,
  45885: 29,
  45886: 30,
  45887: 31,
  45888: 32,
  45889: 33,
  45890: 34,
  45891: 35,
  45892: 36,
  45893: 37,
  45894: 38,
  45895: 39,
  45896: 40,
  45897: 41,
  45898: 42,
  45899: 43,
  45900: 44,
  45901: 45,
  45902: 46,
  45903: 47,
  45904: 48,
  45905: 49,
  45906: 50,
  45907: 51,
  45908: 52,
  45909: 53,
  45910: 54,
  45911: 55,
  45912: 56,
  45913: 57,
  45914: 58,
  45915: 59,
  45916: 60,
  45917: 61,
  45918: 62,
  45919: 63,
  45920: 64,
  45921: 1,
  45922: 2,
  45923: 3,
  45924: 4,
  45925: 5,
  45926: 6,
  45927: 7,
  45928: 8,
  45929: 9,
  45930: 10,
  45931: 11,
  45932: 12,
  45933: 13,
  45934: 14,
  45935: 15,
  45936: 16,
  45937: 17,
  45938: 18,
  45939: 19,
  45940: 20,
  45941: 21,
  45942: 22,
  45943: 23,
  45944: 24,
  45945: 25,
  45946: 26,
  45947: 27,
  45948: 28,
  45949: 29,
  45950: 30,
  45951: 31,
  45952: 32,
  45953: 33,
  45954: 34,
  45955: 35,
  45956: 36,
  45957: 37,
  45958: 38,
  45959: 39,
  45960: 40,
  45961: 41,
  45962: 42,
  45963: 43,
  45964: 44,
  45965: 45,
  45966: 46,
  45967: 47,
  45968: 48,
  45969: 49,
  45970: 50,
  45971: 51,
  45972: 52,
  45973: 53,
  45974: 54,
  45975: 55,
  45976: 56,
  45977: 57,
  45978: 58,
  45979: 59,
  45980: 60,
  45981: 61,
  45982: 62,
  45983: 63,
  45984: 64,
  45985: 65,
  45986: 66,
  45987: 67,
  45988: 68,
  45989: 69,
  45990: 70,
  45991: 71,
  45992: 72,
  45993: 73,
  45994: 74,
  45995: 75,
  45996: 76,
  45997: 77,
  45998: 78,
  45999: 79,
  46e3: 80,
  46001: 81,
  46002: 82,
  46003: 83,
  46004: 84,
  46005: 85,
  46006: 86,
  46007: 87,
  46008: 88,
  46009: 89,
  46010: 90,
  46011: 91,
  46012: 92,
  46013: 93,
  46014: 94,
  46015: 95,
  46016: 96,
  46017: 97,
  46018: 98,
  46019: 99,
  46020: 100,
  46021: 101,
  46022: 102,
  46023: 103,
  46024: 104,
  46025: 105,
  46026: 106,
  46027: 107,
  46028: 108,
  46029: 109,
  46030: 110,
  46031: 111,
  46032: 112,
  46033: 113,
  46034: 114,
  46035: 115,
  46036: 116,
  46037: 117,
  46038: 118,
  46039: 119,
  46040: 120,
  46041: 121,
  46042: 122,
  46043: 123,
  46044: 124,
  46045: 125,
  46046: 126,
  46047: 127,
  46048: 128
});
(function(c) {
  const { Buffer: t } = require$$0$5, n = srcExports$2, ie = varint$2, fe = constants$2;
  c.names = fe.names, c.codes = fe.codes, c.defaultLengths = fe.defaultLengths, c.toHexString = function(he) {
    if (!t.isBuffer(he))
      throw new Error("must be passed a buffer");
    return he.toString("hex");
  }, c.fromHexString = function(he) {
    return t.from(he, "hex");
  }, c.toB58String = function(he) {
    if (!t.isBuffer(he))
      throw new Error("must be passed a buffer");
    return n.encode("base58btc", he).toString().slice(1);
  }, c.fromB58String = function(he) {
    let me = he;
    return t.isBuffer(he) && (me = he.toString()), n.decode("z" + me);
  }, c.decode = function(he) {
    if (!t.isBuffer(he))
      throw new Error("multihash must be a Buffer");
    if (he.length < 2)
      throw new Error("multihash too short. must be > 2 bytes.");
    const me = ie.decode(he);
    if (!c.isValidCode(me))
      throw new Error(`multihash unknown function code: 0x${me.toString(16)}`);
    he = he.slice(ie.decode.bytes);
    const ye = ie.decode(he);
    if (ye < 0)
      throw new Error(`multihash invalid length: ${ye}`);
    if (he = he.slice(ie.decode.bytes), he.length !== ye)
      throw new Error(`multihash length inconsistent: 0x${he.toString("hex")}`);
    return {
      code: me,
      name: fe.codes[me],
      length: ye,
      digest: he
    };
  }, c.encode = function(he, me, ye) {
    if (!he || me === void 0)
      throw new Error("multihash encode requires at least two args: digest, code");
    const be = c.coerceCode(me);
    if (!t.isBuffer(he))
      throw new Error("digest should be a Buffer");
    if (ye == null && (ye = he.length), ye && he.length !== ye)
      throw new Error("digest length should be equal to specified length.");
    return t.concat([
      t.from(ie.encode(be)),
      t.from(ie.encode(ye)),
      he
    ]);
  }, c.coerceCode = function(he) {
    let me = he;
    if (typeof he == "string") {
      if (fe.names[he] === void 0)
        throw new Error(`Unrecognized hash function named: ${he}`);
      me = fe.names[he];
    }
    if (typeof me != "number")
      throw new Error(`Hash function code should be a number. Got: ${me}`);
    if (fe.codes[me] === void 0 && !c.isAppCode(me))
      throw new Error(`Unrecognized function code: ${me}`);
    return me;
  }, c.isAppCode = function(he) {
    return he > 0 && he < 16;
  }, c.isValidCode = function(he) {
    return !!(c.isAppCode(he) || fe.codes[he]);
  };
  function ae(le) {
    c.decode(le);
  }
  c.validate = ae, c.prefix = function(he) {
    return ae(he), he.slice(0, 2);
  };
})(src$5);
var src$3 = { exports: {} };
let Base$4 = class {
  constructor(t, n, ie, fe) {
    this.name = t, this.code = n, this.alphabet = fe, ie && fe && (this.engine = ie(fe));
  }
  encode(t) {
    return this.engine.encode(t);
  }
  decode(t) {
    return this.engine.decode(t);
  }
  isImplemented() {
    return this.engine;
  }
};
var base$3 = Base$4;
const { Buffer: Buffer$4 } = require$$0$5;
var base16$1 = function(t) {
  return {
    encode(n) {
      return typeof n == "string" ? Buffer$4.from(n).toString("hex") : n.toString("hex");
    },
    decode(n) {
      for (const ie of n)
        if (t.indexOf(ie) < 0)
          throw new Error("invalid base16 character");
      return Buffer$4.from(n, "hex");
    }
  };
};
function decode$2(c, t) {
  c = c.replace(new RegExp("=", "g"), "");
  const n = c.length;
  let ie = 0, fe = 0, ae = 0;
  const le = new Uint8Array(n * 5 / 8 | 0);
  for (let he = 0; he < n; he++)
    fe = fe << 5 | t.indexOf(c[he]), ie += 5, ie >= 8 && (le[ae++] = fe >>> ie - 8 & 255, ie -= 8);
  return le.buffer;
}
function encode$1(c, t) {
  const n = c.byteLength, ie = new Uint8Array(c), fe = t.indexOf("=") === t.length - 1;
  fe && (t = t.substring(0, t.length - 1));
  let ae = 0, le = 0, he = "";
  for (let me = 0; me < n; me++)
    for (le = le << 8 | ie[me], ae += 8; ae >= 5; )
      he += t[le >>> ae - 5 & 31], ae -= 5;
  if (ae > 0 && (he += t[le << 5 - ae & 31]), fe)
    for (; he.length % 8 !== 0; )
      he += "=";
  return he;
}
var base32$1 = function(t) {
  return {
    encode(n) {
      return encode$1(typeof n == "string" ? Uint8Array.from(n) : n, t);
    },
    decode(n) {
      for (const ie of n)
        if (t.indexOf(ie) < 0)
          throw new Error("invalid base32 character");
      return decode$2(n, t);
    }
  };
};
const { Buffer: Buffer$3 } = require$$0$5;
var base64$1 = function(t) {
  const n = t.indexOf("=") > -1, ie = t.indexOf("-") > -1 && t.indexOf("_") > -1;
  return {
    encode(fe) {
      let ae = "";
      typeof fe == "string" ? ae = Buffer$3.from(fe).toString("base64") : ae = fe.toString("base64"), ie && (ae = ae.replace(/\+/g, "-").replace(/\//g, "_"));
      const le = ae.indexOf("=");
      return le > 0 && !n && (ae = ae.substring(0, le)), ae;
    },
    decode(fe) {
      for (const ae of fe)
        if (t.indexOf(ae) < 0)
          throw new Error("invalid base64 character");
      return Buffer$3.from(fe, "base64");
    }
  };
};
const Base$3 = base$3, baseX = src$7, base16 = base16$1, base32 = base32$1, base64 = base64$1, constants$1 = [
  ["base1", "1", "", "1"],
  ["base2", "0", baseX, "01"],
  ["base8", "7", baseX, "01234567"],
  ["base10", "9", baseX, "0123456789"],
  ["base16", "f", base16, "0123456789abcdef"],
  ["base32", "b", base32, "abcdefghijklmnopqrstuvwxyz234567"],
  ["base32pad", "c", base32, "abcdefghijklmnopqrstuvwxyz234567="],
  ["base32hex", "v", base32, "0123456789abcdefghijklmnopqrstuv"],
  ["base32hexpad", "t", base32, "0123456789abcdefghijklmnopqrstuv="],
  ["base32z", "h", base32, "ybndrfg8ejkmcpqxot1uwisza345h769"],
  ["base58flickr", "Z", baseX, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"],
  ["base58btc", "z", baseX, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"],
  ["base64", "m", base64, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"],
  ["base64pad", "M", base64, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="],
  ["base64url", "u", base64, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"],
  ["base64urlpad", "U", base64, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]
], names = constants$1.reduce((c, t) => (c[t[0]] = new Base$3(t[0], t[1], t[2], t[3]), c), {}), codes = constants$1.reduce((c, t) => (c[t[1]] = names[t[0]], c), {});
var constants_1$1 = {
  names,
  codes
};
(function(c, t) {
  const { Buffer: n } = require$$0$5, ie = constants_1$1;
  t = c.exports = ae, t.encode = le, t.decode = he, t.isEncoded = me, t.names = Object.freeze(Object.keys(ie.names)), t.codes = Object.freeze(Object.keys(ie.codes));
  const fe = new Error("Unsupported encoding");
  function ae(Ae, Se) {
    if (!Se)
      throw new Error("requires an encoded buffer");
    const $e = be(Ae), Re = n.from($e.code), Me = $e.name;
    return ye(Me, Se), n.concat([Re, Se]);
  }
  function le(Ae, Se) {
    const $e = be(Ae), Re = $e.name;
    return ae(Re, n.from($e.encode(Se)));
  }
  function he(Ae) {
    n.isBuffer(Ae) && (Ae = Ae.toString());
    const Se = Ae.substring(0, 1);
    Ae = Ae.substring(1, Ae.length), typeof Ae == "string" && (Ae = n.from(Ae));
    const $e = be(Se);
    return n.from($e.decode(Ae.toString()));
  }
  function me(Ae) {
    if (n.isBuffer(Ae) && (Ae = Ae.toString()), Object.prototype.toString.call(Ae) !== "[object String]")
      return !1;
    const Se = Ae.substring(0, 1);
    try {
      return be(Se).name;
    } catch {
      return !1;
    }
  }
  function ye(Ae, Se) {
    be(Ae).decode(Se.toString());
  }
  function be(Ae) {
    let Se;
    if (ie.names[Ae])
      Se = ie.names[Ae];
    else if (ie.codes[Ae])
      Se = ie.codes[Ae];
    else
      throw fe;
    if (!Se.isImplemented())
      throw new Error("Base " + Ae + " is not implemented yet");
    return Se;
  }
})(src$3, src$3.exports);
var srcExports$1 = src$3.exports, src$2 = { exports: {} };
const identity = 0, ip4 = 4, tcp = 6, sha1$1 = 17, blake3 = 30, dccp = 33, ip6 = 41, ip6zone = 42, path = 47, multicodec$1 = 48, multihash = 49, multiaddr = 50, multibase$1 = 51, dns = 53, dns4 = 54, dns6 = 55, dnsaddr = 56, protobuf = 80, cbor = 81, raw = 85, rlp = 96, bencode = 99, sctp = 132, md4 = 212, md5$1 = 213, bmt = 214, zeronet = 230, udp = 273, udt = 301, utp = 302, unix = 400, p2p = 421, ipfs = 421, https = 443, onion = 444, onion3 = 445, garlic64 = 446, garlic32 = 447, tls = 448, quic = 460, ws = 477, wss = 478, http = 480, json = 512, messagepack = 513, x11 = 4352, require$$4$2 = {
  identity,
  ip4,
  tcp,
  sha1: sha1$1,
  "sha2-256": 18,
  "sha2-512": 19,
  "sha3-512": 20,
  "sha3-384": 21,
  "sha3-256": 22,
  "sha3-224": 23,
  "shake-128": 24,
  "shake-256": 25,
  "keccak-224": 26,
  "keccak-256": 27,
  "keccak-384": 28,
  "keccak-512": 29,
  blake3,
  dccp,
  "murmur3-128": 34,
  "murmur3-32": 35,
  ip6,
  ip6zone,
  path,
  multicodec: multicodec$1,
  multihash,
  multiaddr,
  multibase: multibase$1,
  dns,
  dns4,
  dns6,
  dnsaddr,
  protobuf,
  cbor,
  raw,
  "dbl-sha2-256": 86,
  rlp,
  bencode,
  "dag-pb": 112,
  "dag-cbor": 113,
  "libp2p-key": 114,
  "git-raw": 120,
  "torrent-info": 123,
  "torrent-file": 124,
  "leofcoin-block": 129,
  "leofcoin-tx": 130,
  "leofcoin-pr": 131,
  sctp,
  "dag-jose": 133,
  "dag-cose": 134,
  "eth-block": 144,
  "eth-block-list": 145,
  "eth-tx-trie": 146,
  "eth-tx": 147,
  "eth-tx-receipt-trie": 148,
  "eth-tx-receipt": 149,
  "eth-state-trie": 150,
  "eth-account-snapshot": 151,
  "eth-storage-trie": 152,
  "bitcoin-block": 176,
  "bitcoin-tx": 177,
  "bitcoin-witness-commitment": 178,
  "zcash-block": 192,
  "zcash-tx": 193,
  "stellar-block": 208,
  "stellar-tx": 209,
  md4,
  md5: md5$1,
  bmt,
  "decred-block": 224,
  "decred-tx": 225,
  "ipld-ns": 226,
  "ipfs-ns": 227,
  "swarm-ns": 228,
  "ipns-ns": 229,
  zeronet,
  "secp256k1-pub": 231,
  "bls12_381-g1-pub": 234,
  "bls12_381-g2-pub": 235,
  "x25519-pub": 236,
  "ed25519-pub": 237,
  "dash-block": 240,
  "dash-tx": 241,
  "swarm-manifest": 250,
  "swarm-feed": 251,
  udp,
  "p2p-webrtc-star": 275,
  "p2p-webrtc-direct": 276,
  "p2p-stardust": 277,
  "p2p-circuit": 290,
  "dag-json": 297,
  udt,
  utp,
  unix,
  p2p,
  ipfs,
  https,
  onion,
  onion3,
  garlic64,
  garlic32,
  tls,
  quic,
  ws,
  wss,
  "p2p-websocket-star": 479,
  http,
  json,
  messagepack,
  "libp2p-peer-record": 769,
  "sha2-256-trunc254-padded": 4114,
  "ripemd-128": 4178,
  "ripemd-160": 4179,
  "ripemd-256": 4180,
  "ripemd-320": 4181,
  x11,
  "sm3-256": 21325,
  "blake2b-8": 45569,
  "blake2b-16": 45570,
  "blake2b-24": 45571,
  "blake2b-32": 45572,
  "blake2b-40": 45573,
  "blake2b-48": 45574,
  "blake2b-56": 45575,
  "blake2b-64": 45576,
  "blake2b-72": 45577,
  "blake2b-80": 45578,
  "blake2b-88": 45579,
  "blake2b-96": 45580,
  "blake2b-104": 45581,
  "blake2b-112": 45582,
  "blake2b-120": 45583,
  "blake2b-128": 45584,
  "blake2b-136": 45585,
  "blake2b-144": 45586,
  "blake2b-152": 45587,
  "blake2b-160": 45588,
  "blake2b-168": 45589,
  "blake2b-176": 45590,
  "blake2b-184": 45591,
  "blake2b-192": 45592,
  "blake2b-200": 45593,
  "blake2b-208": 45594,
  "blake2b-216": 45595,
  "blake2b-224": 45596,
  "blake2b-232": 45597,
  "blake2b-240": 45598,
  "blake2b-248": 45599,
  "blake2b-256": 45600,
  "blake2b-264": 45601,
  "blake2b-272": 45602,
  "blake2b-280": 45603,
  "blake2b-288": 45604,
  "blake2b-296": 45605,
  "blake2b-304": 45606,
  "blake2b-312": 45607,
  "blake2b-320": 45608,
  "blake2b-328": 45609,
  "blake2b-336": 45610,
  "blake2b-344": 45611,
  "blake2b-352": 45612,
  "blake2b-360": 45613,
  "blake2b-368": 45614,
  "blake2b-376": 45615,
  "blake2b-384": 45616,
  "blake2b-392": 45617,
  "blake2b-400": 45618,
  "blake2b-408": 45619,
  "blake2b-416": 45620,
  "blake2b-424": 45621,
  "blake2b-432": 45622,
  "blake2b-440": 45623,
  "blake2b-448": 45624,
  "blake2b-456": 45625,
  "blake2b-464": 45626,
  "blake2b-472": 45627,
  "blake2b-480": 45628,
  "blake2b-488": 45629,
  "blake2b-496": 45630,
  "blake2b-504": 45631,
  "blake2b-512": 45632,
  "blake2s-8": 45633,
  "blake2s-16": 45634,
  "blake2s-24": 45635,
  "blake2s-32": 45636,
  "blake2s-40": 45637,
  "blake2s-48": 45638,
  "blake2s-56": 45639,
  "blake2s-64": 45640,
  "blake2s-72": 45641,
  "blake2s-80": 45642,
  "blake2s-88": 45643,
  "blake2s-96": 45644,
  "blake2s-104": 45645,
  "blake2s-112": 45646,
  "blake2s-120": 45647,
  "blake2s-128": 45648,
  "blake2s-136": 45649,
  "blake2s-144": 45650,
  "blake2s-152": 45651,
  "blake2s-160": 45652,
  "blake2s-168": 45653,
  "blake2s-176": 45654,
  "blake2s-184": 45655,
  "blake2s-192": 45656,
  "blake2s-200": 45657,
  "blake2s-208": 45658,
  "blake2s-216": 45659,
  "blake2s-224": 45660,
  "blake2s-232": 45661,
  "blake2s-240": 45662,
  "blake2s-248": 45663,
  "blake2s-256": 45664,
  "skein256-8": 45825,
  "skein256-16": 45826,
  "skein256-24": 45827,
  "skein256-32": 45828,
  "skein256-40": 45829,
  "skein256-48": 45830,
  "skein256-56": 45831,
  "skein256-64": 45832,
  "skein256-72": 45833,
  "skein256-80": 45834,
  "skein256-88": 45835,
  "skein256-96": 45836,
  "skein256-104": 45837,
  "skein256-112": 45838,
  "skein256-120": 45839,
  "skein256-128": 45840,
  "skein256-136": 45841,
  "skein256-144": 45842,
  "skein256-152": 45843,
  "skein256-160": 45844,
  "skein256-168": 45845,
  "skein256-176": 45846,
  "skein256-184": 45847,
  "skein256-192": 45848,
  "skein256-200": 45849,
  "skein256-208": 45850,
  "skein256-216": 45851,
  "skein256-224": 45852,
  "skein256-232": 45853,
  "skein256-240": 45854,
  "skein256-248": 45855,
  "skein256-256": 45856,
  "skein512-8": 45857,
  "skein512-16": 45858,
  "skein512-24": 45859,
  "skein512-32": 45860,
  "skein512-40": 45861,
  "skein512-48": 45862,
  "skein512-56": 45863,
  "skein512-64": 45864,
  "skein512-72": 45865,
  "skein512-80": 45866,
  "skein512-88": 45867,
  "skein512-96": 45868,
  "skein512-104": 45869,
  "skein512-112": 45870,
  "skein512-120": 45871,
  "skein512-128": 45872,
  "skein512-136": 45873,
  "skein512-144": 45874,
  "skein512-152": 45875,
  "skein512-160": 45876,
  "skein512-168": 45877,
  "skein512-176": 45878,
  "skein512-184": 45879,
  "skein512-192": 45880,
  "skein512-200": 45881,
  "skein512-208": 45882,
  "skein512-216": 45883,
  "skein512-224": 45884,
  "skein512-232": 45885,
  "skein512-240": 45886,
  "skein512-248": 45887,
  "skein512-256": 45888,
  "skein512-264": 45889,
  "skein512-272": 45890,
  "skein512-280": 45891,
  "skein512-288": 45892,
  "skein512-296": 45893,
  "skein512-304": 45894,
  "skein512-312": 45895,
  "skein512-320": 45896,
  "skein512-328": 45897,
  "skein512-336": 45898,
  "skein512-344": 45899,
  "skein512-352": 45900,
  "skein512-360": 45901,
  "skein512-368": 45902,
  "skein512-376": 45903,
  "skein512-384": 45904,
  "skein512-392": 45905,
  "skein512-400": 45906,
  "skein512-408": 45907,
  "skein512-416": 45908,
  "skein512-424": 45909,
  "skein512-432": 45910,
  "skein512-440": 45911,
  "skein512-448": 45912,
  "skein512-456": 45913,
  "skein512-464": 45914,
  "skein512-472": 45915,
  "skein512-480": 45916,
  "skein512-488": 45917,
  "skein512-496": 45918,
  "skein512-504": 45919,
  "skein512-512": 45920,
  "skein1024-8": 45921,
  "skein1024-16": 45922,
  "skein1024-24": 45923,
  "skein1024-32": 45924,
  "skein1024-40": 45925,
  "skein1024-48": 45926,
  "skein1024-56": 45927,
  "skein1024-64": 45928,
  "skein1024-72": 45929,
  "skein1024-80": 45930,
  "skein1024-88": 45931,
  "skein1024-96": 45932,
  "skein1024-104": 45933,
  "skein1024-112": 45934,
  "skein1024-120": 45935,
  "skein1024-128": 45936,
  "skein1024-136": 45937,
  "skein1024-144": 45938,
  "skein1024-152": 45939,
  "skein1024-160": 45940,
  "skein1024-168": 45941,
  "skein1024-176": 45942,
  "skein1024-184": 45943,
  "skein1024-192": 45944,
  "skein1024-200": 45945,
  "skein1024-208": 45946,
  "skein1024-216": 45947,
  "skein1024-224": 45948,
  "skein1024-232": 45949,
  "skein1024-240": 45950,
  "skein1024-248": 45951,
  "skein1024-256": 45952,
  "skein1024-264": 45953,
  "skein1024-272": 45954,
  "skein1024-280": 45955,
  "skein1024-288": 45956,
  "skein1024-296": 45957,
  "skein1024-304": 45958,
  "skein1024-312": 45959,
  "skein1024-320": 45960,
  "skein1024-328": 45961,
  "skein1024-336": 45962,
  "skein1024-344": 45963,
  "skein1024-352": 45964,
  "skein1024-360": 45965,
  "skein1024-368": 45966,
  "skein1024-376": 45967,
  "skein1024-384": 45968,
  "skein1024-392": 45969,
  "skein1024-400": 45970,
  "skein1024-408": 45971,
  "skein1024-416": 45972,
  "skein1024-424": 45973,
  "skein1024-432": 45974,
  "skein1024-440": 45975,
  "skein1024-448": 45976,
  "skein1024-456": 45977,
  "skein1024-464": 45978,
  "skein1024-472": 45979,
  "skein1024-480": 45980,
  "skein1024-488": 45981,
  "skein1024-496": 45982,
  "skein1024-504": 45983,
  "skein1024-512": 45984,
  "skein1024-520": 45985,
  "skein1024-528": 45986,
  "skein1024-536": 45987,
  "skein1024-544": 45988,
  "skein1024-552": 45989,
  "skein1024-560": 45990,
  "skein1024-568": 45991,
  "skein1024-576": 45992,
  "skein1024-584": 45993,
  "skein1024-592": 45994,
  "skein1024-600": 45995,
  "skein1024-608": 45996,
  "skein1024-616": 45997,
  "skein1024-624": 45998,
  "skein1024-632": 45999,
  "skein1024-640": 46e3,
  "skein1024-648": 46001,
  "skein1024-656": 46002,
  "skein1024-664": 46003,
  "skein1024-672": 46004,
  "skein1024-680": 46005,
  "skein1024-688": 46006,
  "skein1024-696": 46007,
  "skein1024-704": 46008,
  "skein1024-712": 46009,
  "skein1024-720": 46010,
  "skein1024-728": 46011,
  "skein1024-736": 46012,
  "skein1024-744": 46013,
  "skein1024-752": 46014,
  "skein1024-760": 46015,
  "skein1024-768": 46016,
  "skein1024-776": 46017,
  "skein1024-784": 46018,
  "skein1024-792": 46019,
  "skein1024-800": 46020,
  "skein1024-808": 46021,
  "skein1024-816": 46022,
  "skein1024-824": 46023,
  "skein1024-832": 46024,
  "skein1024-840": 46025,
  "skein1024-848": 46026,
  "skein1024-856": 46027,
  "skein1024-864": 46028,
  "skein1024-872": 46029,
  "skein1024-880": 46030,
  "skein1024-888": 46031,
  "skein1024-896": 46032,
  "skein1024-904": 46033,
  "skein1024-912": 46034,
  "skein1024-920": 46035,
  "skein1024-928": 46036,
  "skein1024-936": 46037,
  "skein1024-944": 46038,
  "skein1024-952": 46039,
  "skein1024-960": 46040,
  "skein1024-968": 46041,
  "skein1024-976": 46042,
  "skein1024-984": 46043,
  "skein1024-992": 46044,
  "skein1024-1000": 46045,
  "skein1024-1008": 46046,
  "skein1024-1016": 46047,
  "skein1024-1024": 46048,
  "poseidon-bls12_381-a2-fc1": 46081,
  "poseidon-bls12_381-a2-fc1-sc": 46082,
  "zeroxcert-imprint-256": 52753,
  "fil-commitment-unsealed": 61697,
  "fil-commitment-sealed": 61698,
  "holochain-adr-v0": 8417572,
  "holochain-adr-v1": 8483108,
  "holochain-key-v0": 9728292,
  "holochain-key-v1": 9793828,
  "holochain-sig-v0": 10645796,
  "holochain-sig-v1": 10711332
}, baseTable$1 = require$$4$2, nameTable = /* @__PURE__ */ new Map();
for (const c in baseTable$1) {
  const t = baseTable$1[c];
  nameTable.set(t, c);
}
var intTable = Object.freeze(nameTable);
const varint = varint$2, { Buffer: Buffer$2 } = require$$0$5;
var util$5 = {
  numberToBuffer,
  bufferToNumber,
  varintBufferEncode,
  varintBufferDecode,
  varintEncode: varintEncode$1
};
function bufferToNumber(c) {
  return parseInt(c.toString("hex"), 16);
}
function numberToBuffer(c) {
  let t = c.toString(16);
  return t.length % 2 === 1 && (t = "0" + t), Buffer$2.from(t, "hex");
}
function varintBufferEncode(c) {
  return Buffer$2.from(varint.encode(bufferToNumber(c)));
}
function varintBufferDecode(c) {
  return numberToBuffer(varint.decode(c));
}
function varintEncode$1(c) {
  return Buffer$2.from(varint.encode(c));
}
const baseTable = require$$4$2, varintEncode = util$5.varintEncode, varintTable = {};
for (const c in baseTable) {
  const t = baseTable[c];
  varintTable[c] = varintEncode(t);
}
var varintTable_1 = Object.freeze(varintTable), constants_1, hasRequiredConstants$1;
function requireConstants$1() {
  if (hasRequiredConstants$1) return constants_1;
  hasRequiredConstants$1 = 1;
  const c = require$$4$2, t = {};
  for (const [n, ie] of Object.entries(c))
    t[n.toUpperCase().replace(/-/g, "_")] = ie;
  return constants_1 = Object.freeze(t), constants_1;
}
var print, hasRequiredPrint;
function requirePrint() {
  if (hasRequiredPrint) return print;
  hasRequiredPrint = 1;
  const c = require$$4$2, t = {};
  for (const [n, ie] of Object.entries(c))
    t[ie] === void 0 && (t[ie] = n);
  return print = Object.freeze(t), print;
}
(function(c, t) {
  const { Buffer: n } = require$$0$5, ie = varint$2, fe = intTable, ae = varintTable_1, le = util$5;
  t = c.exports, t.addPrefix = (me, ye) => {
    let be;
    if (n.isBuffer(me))
      be = le.varintBufferEncode(me);
    else if (ae[me])
      be = ae[me];
    else
      throw new Error("multicodec not recognized");
    return n.concat([be, ye]);
  }, t.rmPrefix = (me) => (ie.decode(me), me.slice(ie.decode.bytes)), t.getCodec = (me) => {
    const ye = ie.decode(me), be = fe.get(ye);
    if (be === void 0)
      throw new Error(`Code ${ye} not found`);
    return be;
  }, t.getName = (me) => fe.get(me), t.getNumber = (me) => {
    const ye = ae[me];
    if (ye === void 0)
      throw new Error("Codec `" + me + "` not found");
    return le.varintBufferDecode(ye)[0];
  }, t.getCode = (me) => ie.decode(me), t.getCodeVarint = (me) => {
    const ye = ae[me];
    if (ye === void 0)
      throw new Error("Codec `" + me + "` not found");
    return ye;
  }, t.getVarint = (me) => ie.encode(me);
  const he = requireConstants$1();
  Object.assign(t, he), t.print = requirePrint();
})(src$2, src$2.exports);
var srcExports = src$2.exports;
const mh$1 = src$5, { Buffer: Buffer$1 } = require$$0$5;
var CIDUtil$1 = {
  /**
   * Test if the given input is a valid CID object.
   * Returns an error message if it is not.
   * Returns undefined if it is a valid CID.
   *
   * @param {any} other
   * @returns {string}
   */
  checkCIDComponents: function(c) {
    if (c == null)
      return "null values are not valid CIDs";
    if (!(c.version === 0 || c.version === 1))
      return "Invalid version, must be a number equal to 1 or 0";
    if (typeof c.codec != "string")
      return "codec must be string";
    if (c.version === 0) {
      if (c.codec !== "dag-pb")
        return "codec must be 'dag-pb' for CIDv0";
      if (c.multibaseName !== "base58btc")
        return "multibaseName must be 'base58btc' for CIDv0";
    }
    if (!Buffer$1.isBuffer(c.multihash))
      return "multihash must be a Buffer";
    try {
      mh$1.validate(c.multihash);
    } catch (t) {
      let n = t.message;
      return n || (n = "Multihash validation failed"), n;
    }
  }
}, cidUtil = CIDUtil$1, classIs = { exports: {} };
function withIs$1(c, { className: t, symbolName: n }) {
  const ie = Symbol.for(n), fe = {
    // The code below assigns the class wrapper to an object to trick
    // JavaScript engines to show the name of the extended class when
    // logging an instances.
    // We are assigning an anonymous class (class wrapper) to the object
    // with key `className` to keep the correct name.
    // If this is not supported it falls back to logging `ClassIsWrapper`.
    [t]: class extends c {
      constructor(...ae) {
        super(...ae), Object.defineProperty(this, ie, { value: !0 });
      }
      get [Symbol.toStringTag]() {
        return t;
      }
    }
  }[t];
  return fe[`is${t}`] = (ae) => !!(ae && ae[ie]), fe;
}
function withIsProto(c, { className: t, symbolName: n, withoutNew: ie }) {
  const fe = Symbol.for(n), ae = {
    [t]: function(...le) {
      if (ie && !(this instanceof ae))
        return new ae(...le);
      const he = c.call(this, ...le) || this;
      return he && !he[fe] && Object.defineProperty(he, fe, { value: !0 }), he;
    }
  }[t];
  return ae.prototype = Object.create(c.prototype), ae.prototype.constructor = ae, Object.defineProperty(ae.prototype, Symbol.toStringTag, {
    get() {
      return t;
    }
  }), ae[`is${t}`] = (le) => !!(le && le[fe]), ae;
}
classIs.exports = withIs$1;
classIs.exports.proto = withIsProto;
var classIsExports = classIs.exports;
const { Buffer } = require$$0$5, mh = src$5, multibase = srcExports$1, multicodec = srcExports, codecs = require$$4$2, CIDUtil = cidUtil, withIs = classIsExports;
let CID$2 = class Yn {
  /**
   * Create a new CID.
   *
   * The algorithm for argument input is roughly:
   * ```
   * if (cid)
   *   -> create a copy
   * else if (str)
   *   if (1st char is on multibase table) -> CID String
   *   else -> bs58 encoded multihash
   * else if (Buffer)
   *   if (1st byte is 0 or 1) -> CID
   *   else -> multihash
   * else if (Number)
   *   -> construct CID by parts
   * ```
   *
   * @param {string|Buffer|CID} version
   * @param {string} [codec]
   * @param {Buffer} [multihash]
   * @param {string} [multibaseName]
   *
   * @example
   * new CID(<version>, <codec>, <multihash>, <multibaseName>)
   * new CID(<cidStr>)
   * new CID(<cid.buffer>)
   * new CID(<multihash>)
   * new CID(<bs58 encoded multihash>)
   * new CID(<cid>)
   */
  constructor(t, n, ie, fe) {
    if (_CID.isCID(t)) {
      const ae = t;
      this.version = ae.version, this.codec = ae.codec, this.multihash = Buffer.from(ae.multihash), this.multibaseName = ae.multibaseName || (ae.version === 0 ? "base58btc" : "base32");
      return;
    }
    if (typeof t == "string") {
      const ae = multibase.isEncoded(t);
      if (ae) {
        const le = multibase.decode(t);
        this.version = parseInt(le.slice(0, 1).toString("hex"), 16), this.codec = multicodec.getCodec(le.slice(1)), this.multihash = multicodec.rmPrefix(le.slice(1)), this.multibaseName = ae;
      } else
        this.version = 0, this.codec = "dag-pb", this.multihash = mh.fromB58String(t), this.multibaseName = "base58btc";
      Yn.validateCID(this), Object.defineProperty(this, "string", { value: t });
      return;
    }
    if (Buffer.isBuffer(t)) {
      const ae = t.slice(0, 1), le = parseInt(ae.toString("hex"), 16);
      if (le === 1) {
        const he = t;
        this.version = le, this.codec = multicodec.getCodec(he.slice(1)), this.multihash = multicodec.rmPrefix(he.slice(1)), this.multibaseName = "base32";
      } else
        this.version = 0, this.codec = "dag-pb", this.multihash = t, this.multibaseName = "base58btc";
      Yn.validateCID(this);
      return;
    }
    this.version = t, this.codec = n, this.multihash = ie, this.multibaseName = fe || (t === 0 ? "base58btc" : "base32"), Yn.validateCID(this);
  }
  /**
   * The CID as a `Buffer`
   *
   * @return {Buffer}
   * @readonly
   *
   * @memberOf CID
   */
  get buffer() {
    let t = this._buffer;
    if (!t) {
      if (this.version === 0)
        t = this.multihash;
      else if (this.version === 1)
        t = Buffer.concat([
          Buffer.from("01", "hex"),
          multicodec.getCodeVarint(this.codec),
          this.multihash
        ]);
      else
        throw new Error("unsupported version");
      Object.defineProperty(this, "_buffer", { value: t });
    }
    return t;
  }
  /**
   * Get the prefix of the CID.
   *
   * @returns {Buffer}
   * @readonly
   */
  get prefix() {
    return Buffer.concat([
      Buffer.from(`0${this.version}`, "hex"),
      multicodec.getCodeVarint(this.codec),
      mh.prefix(this.multihash)
    ]);
  }
  /**
   * Convert to a CID of version `0`.
   *
   * @returns {CID}
   */
  toV0() {
    if (this.codec !== "dag-pb")
      throw new Error("Cannot convert a non dag-pb CID to CIDv0");
    const { name: t, length: n } = mh.decode(this.multihash);
    if (t !== "sha2-256")
      throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
    if (n !== 32)
      throw new Error("Cannot convert non 32 byte multihash CID to CIDv0");
    return new _CID(0, this.codec, this.multihash);
  }
  /**
   * Convert to a CID of version `1`.
   *
   * @returns {CID}
   */
  toV1() {
    return new _CID(1, this.codec, this.multihash);
  }
  /**
   * Encode the CID into a string.
   *
   * @param {string} [base=this.multibaseName] - Base encoding to use.
   * @returns {string}
   */
  toBaseEncodedString(t = this.multibaseName) {
    if (this.string && t === this.multibaseName)
      return this.string;
    let n = null;
    if (this.version === 0) {
      if (t !== "base58btc")
        throw new Error("not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()");
      n = mh.toB58String(this.multihash);
    } else if (this.version === 1)
      n = multibase.encode(t, this.buffer).toString();
    else
      throw new Error("unsupported version");
    return t === this.multibaseName && Object.defineProperty(this, "string", { value: n }), n;
  }
  /**
   * CID(QmdfTbBqBPQ7VNxZEYEj14VmRuZBkqFbiwReogJgS1zR1n)
   *
   * @returns {String}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return "CID(" + this.toString() + ")";
  }
  toString(t) {
    return this.toBaseEncodedString(t);
  }
  /**
   * Serialize to a plain object.
   *
   * @returns {SerializedCID}
   */
  toJSON() {
    return {
      codec: this.codec,
      version: this.version,
      hash: this.multihash
    };
  }
  /**
   * Compare equality with another CID.
   *
   * @param {CID} other
   * @returns {bool}
   */
  equals(t) {
    return this.codec === t.codec && this.version === t.version && this.multihash.equals(t.multihash);
  }
  /**
   * Test if the given input is a valid CID object.
   * Throws if it is not.
   *
   * @param {any} other
   * @returns {void}
   */
  static validateCID(t) {
    const n = CIDUtil.checkCIDComponents(t);
    if (n)
      throw new Error(n);
  }
};
const _CID = withIs(CID$2, {
  className: "CID",
  symbolName: "@ipld/js-cid/CID"
});
_CID.codecs = codecs;
var src$1 = _CID;
const CID$1 = src$1, multiH = src$5, hexStringToBuffer$1 = (c) => {
  let t = c.slice(0, 2), n = c.slice(2), ie = "";
  return t === "0x" ? ie = n : ie = c, multiH.fromHexString(ie);
}, encodes = {
  /**
  * @param {string} value
  * @return {Buffer}
  */
  swarm: (c) => {
    const t = multiH.encode(hexStringToBuffer$1(c), "keccak-256");
    return new CID$1(1, "swarm-manifest", t).buffer;
  },
  /**
  * @param {string} value
  * @return {Buffer}
  */
  ipfs: (c) => {
    const t = multiH.fromB58String(c);
    return new CID$1(1, "dag-pb", t).buffer;
  },
  /**
  * @param {string} value
  * @return {Buffer}
  */
  utf8: (c) => Buffer$7.from(c, "utf8")
}, decodes = {
  /**
  * @param {Buffer} value 
  */
  hexMultiHash: (c) => {
    const t = new CID$1(c);
    return multiH.decode(t.multihash).digest.toString("hex");
  },
  /**
  * @param {Buffer} value 
  */
  b58MultiHash: (c) => {
    const t = new CID$1(c);
    return multiH.toB58String(t.multihash);
  },
  /**
  * @param {Buffer} value 
  */
  utf8: (c) => c.toString("utf8")
}, profiles$1 = {
  "swarm-ns": {
    encode: encodes.swarm,
    decode: decodes.hexMultiHash
  },
  "ipfs-ns": {
    encode: encodes.ipfs,
    decode: decodes.b58MultiHash
  },
  "ipns-ns": {
    encode: encodes.ipfs,
    decode: decodes.b58MultiHash
  },
  default: {
    encode: encodes.utf8,
    decode: decodes.utf8
  }
};
profiles$2.hexStringToBuffer = hexStringToBuffer$1;
profiles$2.profiles = profiles$1;
var helpers = {};
const CID = src$1, cidV0ToV1Base32$1 = (c) => {
  let t = new CID(c);
  return t.version === 0 && (t = t.toV1()), t.toString("base32");
};
helpers.cidV0ToV1Base32 = cidV0ToV1Base32$1;
const multiC = srcExports$3, { hexStringToBuffer, profiles } = profiles$2, { cidV0ToV1Base32 } = helpers;
var src = {
  //export some helpers functions
  helpers: {
    cidV0ToV1Base32
  },
  /**
  * Decode a Content Hash.
  * @param {string} hash an hex string containing a content hash
  * @return {string} the decoded content
  */
  decode: function(c) {
    const t = hexStringToBuffer(c), n = multiC.getCodec(t), ie = multiC.rmPrefix(t);
    let fe = profiles[n];
    return fe || (fe = profiles.default), fe.decode(ie);
  },
  /**
  * Encode an IPFS address into a content hash
  * @param {string} ipfsHash string containing an IPFS address
  * @return {string} the resulting content hash
  */
  fromIpfs: function(c) {
    return this.encode("ipfs-ns", c);
  },
  /**
  * Encode a Swarm address into a content hash
  * @param {string} swarmHash string containing a Swarm address
  * @return {string} the resulting content hash
  */
  fromSwarm: function(c) {
    return this.encode("swarm-ns", c);
  },
  /**
  * General purpose encoding function
   * @param {string} codec 
   * @param {string} value 
   */
  encode: function(c, t) {
    let n = profiles[c];
    n || (n = profiles.default);
    const ie = n.encode(t);
    return multiC.addPrefix(c, ie).toString("hex");
  },
  /**
  * Extract the codec of a content hash
  * @param {string} hash hex string containing a content hash
  * @return {string} the extracted codec
  */
  getCodec: function(c) {
    let t = hexStringToBuffer(c);
    return multiC.getCodec(t);
  }
}, bip44Constants = [
  [2147483648, "BTC", "Bitcoin"],
  [2147483649, "", "Testnet (all coins)"],
  [2147483650, "LTC", "Litecoin"],
  [2147483651, "DOGE", "Dogecoin"],
  [2147483652, "RDD", "Reddcoin"],
  [2147483653, "DASH", "Dash (ex Darkcoin)"],
  [2147483654, "PPC", "Peercoin"],
  [2147483655, "NMC", "Namecoin"],
  [2147483656, "FTC", "Feathercoin"],
  [2147483657, "XCP", "Counterparty"],
  [2147483658, "BLK", "Blackcoin"],
  [2147483659, "NSR", "NuShares"],
  [2147483660, "NBT", "NuBits"],
  [2147483661, "MZC", "Mazacoin"],
  [2147483662, "VIA", "Viacoin"],
  [2147483663, "XCH", "ClearingHouse"],
  [2147483664, "RBY", "Rubycoin"],
  [2147483665, "GRS", "Groestlcoin"],
  [2147483666, "DGC", "Digitalcoin"],
  [2147483667, "CCN", "Cannacoin"],
  [2147483668, "DGB", "DigiByte"],
  [2147483669, "", "Open Assets"],
  [2147483670, "MONA", "Monacoin"],
  [2147483671, "CLAM", "Clams"],
  [2147483672, "XPM", "Primecoin"],
  [2147483673, "NEOS", "Neoscoin"],
  [2147483674, "JBS", "Jumbucks"],
  [2147483675, "ZRC", "ziftrCOIN"],
  [2147483676, "VTC", "Vertcoin"],
  [2147483677, "NXT", "NXT"],
  [2147483678, "BURST", "Burst"],
  [2147483679, "MUE", "MonetaryUnit"],
  [2147483680, "ZOOM", "Zoom"],
  [2147483681, "VASH", "Virtual Cash also known as VPNcoin"],
  [2147483682, "CDN", "Canada eCoin"],
  [2147483683, "SDC", "ShadowCash"],
  [2147483684, "PKB", "ParkByte"],
  [2147483685, "PND", "Pandacoin"],
  [2147483686, "START", "StartCOIN"],
  [2147483687, "MOIN", "MOIN"],
  [2147483688, "EXP", "Expanse"],
  [2147483689, "EMC2", "Einsteinium"],
  [2147483690, "DCR", "Decred"],
  [2147483691, "XEM", "NEM"],
  [2147483692, "PART", "Particl"],
  [2147483693, "ARG", "Argentum (dead)"],
  [2147483694, "", "Libertas"],
  [2147483695, "", "Posw coin"],
  [2147483696, "SHR", "Shreeji"],
  [2147483697, "GCR", "Global Currency Reserve (GCRcoin)"],
  [2147483698, "NVC", "Novacoin"],
  [2147483699, "AC", "Asiacoin"],
  [2147483700, "BTCD", "BitcoinDark"],
  [2147483701, "DOPE", "Dopecoin"],
  [2147483702, "TPC", "Templecoin"],
  [2147483703, "AIB", "AIB"],
  [2147483704, "EDRC", "EDRCoin"],
  [2147483705, "SYS", "Syscoin"],
  [2147483706, "SLR", "Solarcoin"],
  [2147483707, "SMLY", "Smileycoin"],
  [2147483708, "ETH", "Ether"],
  [2147483709, "ETC", "Ether Classic"],
  [2147483710, "PSB", "Pesobit"],
  [2147483711, "LDCN", "Landcoin (dead)"],
  [2147483712, "", "Open Chain"],
  [2147483713, "XBC", "Bitcoinplus"],
  [2147483714, "IOP", "Internet of People"],
  [2147483715, "NXS", "Nexus"],
  [2147483716, "INSN", "InsaneCoin"],
  [2147483717, "OK", "OKCash"],
  [2147483718, "BRIT", "BritCoin"],
  [2147483719, "CMP", "Compcoin"],
  [2147483720, "CRW", "Crown"],
  [2147483721, "BELA", "BelaCoin"],
  [2147483722, "ICX", "ICON"],
  [2147483723, "FJC", "FujiCoin"],
  [2147483724, "MIX", "MIX"],
  [2147483725, "XVG", "Verge Currency"],
  [2147483726, "EFL", "Electronic Gulden"],
  [2147483727, "CLUB", "ClubCoin"],
  [2147483728, "RICHX", "RichCoin"],
  [2147483729, "POT", "Potcoin"],
  [2147483730, "QRK", "Quarkcoin"],
  [2147483731, "TRC", "Terracoin"],
  [2147483732, "GRC", "Gridcoin"],
  [2147483733, "AUR", "Auroracoin"],
  [2147483734, "IXC", "IXCoin"],
  [2147483735, "NLG", "Gulden"],
  [2147483736, "BITB", "BitBean"],
  [2147483737, "BTA", "Bata"],
  [2147483738, "XMY", "Myriadcoin"],
  [2147483739, "BSD", "BitSend"],
  [2147483740, "UNO", "Unobtanium"],
  [2147483741, "MTR", "MasterTrader"],
  [2147483742, "GB", "GoldBlocks"],
  [2147483743, "SHM", "Saham"],
  [2147483744, "CRX", "Chronos"],
  [2147483745, "BIQ", "Ubiquoin"],
  [2147483746, "EVO", "Evotion"],
  [2147483747, "STO", "SaveTheOcean"],
  [2147483748, "BIGUP", "BigUp"],
  [2147483749, "GAME", "GameCredits"],
  [2147483750, "DLC", "Dollarcoins"],
  [2147483751, "ZYD", "Zayedcoin"],
  [2147483752, "DBIC", "Dubaicoin"],
  [2147483753, "STRAT", "Stratis"],
  [2147483754, "SH", "Shilling"],
  [2147483755, "MARS", "MarsCoin"],
  [2147483756, "UBQ", "Ubiq"],
  [2147483757, "PTC", "Pesetacoin"],
  [2147483758, "NRO", "Neurocoin"],
  [2147483759, "ARK", "ARK"],
  [2147483760, "USC", "UltimateSecureCashMain"],
  [2147483761, "THC", "Hempcoin"],
  [2147483762, "LINX", "Linx"],
  [2147483763, "ECN", "Ecoin"],
  [2147483764, "DNR", "Denarius"],
  [2147483765, "PINK", "Pinkcoin"],
  [2147483766, "ATOM", "Atom"],
  [2147483767, "PIVX", "Pivx"],
  [2147483768, "FLASH", "Flashcoin"],
  [2147483769, "ZEN", "Zencash"],
  [2147483770, "PUT", "Putincoin"],
  [2147483771, "ZNY", "BitZeny"],
  [2147483772, "UNIFY", "Unify"],
  [2147483773, "XST", "StealthCoin"],
  [2147483774, "BRK", "Breakout Coin"],
  [2147483775, "VC", "Vcash"],
  [2147483776, "XMR", "Monero"],
  [2147483777, "VOX", "Voxels"],
  [2147483778, "NAV", "NavCoin"],
  [2147483779, "FCT", "Factom Factoids"],
  [2147483780, "EC", "Factom Entry Credits"],
  [2147483781, "ZEC", "Zcash"],
  [2147483782, "LSK", "Lisk"],
  [2147483783, "STEEM", "Steem"],
  [2147483784, "XZC", "ZCoin"],
  [2147483785, "RBTC", "RSK"],
  [2147483786, "", "Giftblock"],
  [2147483787, "RPT", "RealPointCoin"],
  [2147483788, "LBC", "LBRY Credits"],
  [2147483789, "KMD", "Komodo"],
  [2147483790, "BSQ", "bisq Token"],
  [2147483791, "RIC", "Riecoin"],
  [2147483792, "XRP", "Ripple"],
  [2147483793, "BCH", "Bitcoin Cash"],
  [2147483794, "NEBL", "Neblio"],
  [2147483795, "ZCL", "ZClassic"],
  [2147483796, "XLM", "Stellar Lumens"],
  [2147483797, "NLC2", "NoLimitCoin2"],
  [2147483798, "WHL", "WhaleCoin"],
  [2147483799, "ERC", "EuropeCoin"],
  [2147483800, "DMD", "Diamond"],
  [2147483801, "BTM", "Bytom"],
  [2147483802, "BIO", "Biocoin"],
  [2147483803, "XWCC", "Whitecoin Classic"],
  [2147483804, "BTG", "Bitcoin Gold"],
  [2147483805, "BTC2X", "Bitcoin 2x"],
  [2147483806, "SSN", "SuperSkynet"],
  [2147483807, "TOA", "TOACoin"],
  [2147483808, "BTX", "Bitcore"],
  [2147483809, "ACC", "Adcoin"],
  [2147483810, "BCO", "Bridgecoin"],
  [2147483811, "ELLA", "Ellaism"],
  [2147483812, "PIRL", "Pirl"],
  [2147483813, "NANO", "Nano"],
  [2147483814, "VIVO", "Vivo"],
  [2147483815, "FRST", "Firstcoin"],
  [2147483816, "HNC", "Helleniccoin"],
  [2147483817, "BUZZ", "BUZZ"],
  [2147483818, "MBRS", "Ember"],
  [2147483819, "HC", "Hcash"],
  [2147483820, "HTML", "HTMLCOIN"],
  [2147483821, "ODN", "Obsidian"],
  [2147483822, "ONX", "OnixCoin"],
  [2147483823, "RVN", "Ravencoin"],
  [2147483824, "GBX", "GoByte"],
  [2147483825, "BTCZ", "BitcoinZ"],
  [2147483826, "POA", "Poa"],
  [2147483827, "NYC", "NewYorkCoin"],
  [2147483828, "MXT", "MarteXcoin"],
  [2147483829, "WC", "Wincoin"],
  [2147483830, "MNX", "Minexcoin"],
  [2147483831, "BTCP", "Bitcoin Private"],
  [2147483832, "MUSIC", "Musicoin"],
  [2147483833, "BCA", "Bitcoin Atom"],
  [2147483834, "CRAVE", "Crave"],
  [2147483835, "STAK", "STRAKS"],
  [2147483836, "WBTC", "World Bitcoin"],
  [2147483837, "LCH", "LiteCash"],
  [2147483838, "EXCL", "ExclusiveCoin"],
  [2147483839, "", "Lynx"],
  [2147483840, "LCC", "LitecoinCash"],
  [2147483841, "XFE", "Feirm"],
  [2147483842, "EOS", "EOS"],
  [2147483843, "TRX", "Tron"],
  [2147483844, "KOBO", "Kobocoin"],
  [2147483845, "HUSH", "HUSH"],
  [2147483846, "BANANO", "Bananos"],
  [2147483847, "ETF", "ETF"],
  [2147483848, "OMNI", "Omni"],
  [2147483849, "BIFI", "BitcoinFile"],
  [2147483850, "UFO", "Uniform Fiscal Object"],
  [2147483851, "CNMC", "Cryptonodes"],
  [2147483852, "BCN", "Bytecoin"],
  [2147483853, "RIN", "Ringo"],
  [2147483854, "ATP", "PlatON"],
  [2147483855, "EVT", "everiToken"],
  [2147483856, "ATN", "ATN"],
  [2147483857, "BIS", "Bismuth"],
  [2147483858, "NEET", "NEETCOIN"],
  [2147483859, "BOPO", "BopoChain"],
  [2147483860, "OOT", "Utrum"],
  [2147483861, "ALIAS", "Alias"],
  [2147483862, "MONK", "Monkey Project"],
  [2147483863, "BOXY", "BoxyCoin"],
  [2147483864, "FLO", "Flo"],
  [2147483865, "MEC", "Megacoin"],
  [2147483866, "BTDX", "BitCloud"],
  [2147483867, "XAX", "Artax"],
  [2147483868, "ANON", "ANON"],
  [2147483869, "LTZ", "LitecoinZ"],
  [2147483870, "BITG", "Bitcoin Green"],
  [2147483871, "ICP", "Internet Computer (DFINITY)"],
  [2147483872, "SMART", "Smartcash"],
  [2147483873, "XUEZ", "XUEZ"],
  [2147483874, "HLM", "Helium"],
  [2147483875, "WEB", "Webchain"],
  [2147483876, "ACM", "Actinium"],
  [2147483877, "NOS", "NOS Stable Coins"],
  [2147483878, "BITC", "BitCash"],
  [2147483879, "HTH", "Help The Homeless Coin"],
  [2147483880, "TZC", "Trezarcoin"],
  [2147483881, "VAR", "Varda"],
  [2147483882, "IOV", "IOV"],
  [2147483883, "FIO", "FIO"],
  [2147483884, "BSV", "BitcoinSV"],
  [2147483885, "DXN", "DEXON"],
  [2147483886, "QRL", "Quantum Resistant Ledger"],
  [2147483887, "PCX", "ChainX"],
  [2147483888, "LOKI", "Loki"],
  [2147483889, "", "Imagewallet"],
  [2147483890, "NIM", "Nimiq"],
  [2147483891, "SOV", "Sovereign Coin"],
  [2147483892, "JCT", "Jibital Coin"],
  [2147483893, "SLP", "Simple Ledger Protocol"],
  [2147483894, "EWT", "Energy Web"],
  [2147483895, "UC", "Ulord"],
  [2147483896, "EXOS", "EXOS"],
  [2147483897, "ECA", "Electra"],
  [2147483898, "SOOM", "Soom"],
  [2147483899, "XRD", "Redstone"],
  [2147483900, "FREE", "FreeCoin"],
  [2147483901, "NPW", "NewPowerCoin"],
  [2147483902, "BST", "BlockStamp"],
  [2147483903, "", "SmartHoldem"],
  [2147483904, "NANO", "Bitcoin Nano"],
  [2147483905, "BTCC", "Bitcoin Core"],
  [2147483906, "", "Zen Protocol"],
  [2147483907, "ZEST", "Zest"],
  [2147483908, "ABT", "ArcBlock"],
  [2147483909, "PION", "Pion"],
  [2147483910, "DT3", "DreamTeam3"],
  [2147483911, "ZBUX", "Zbux"],
  [2147483912, "KPL", "Kepler"],
  [2147483913, "TPAY", "TokenPay"],
  [2147483914, "ZILLA", "ChainZilla"],
  [2147483915, "ANK", "Anker"],
  [2147483916, "BCC", "BCChain"],
  [2147483917, "HPB", "HPB"],
  [2147483918, "ONE", "ONE"],
  [2147483919, "SBC", "SBC"],
  [2147483920, "IPC", "IPChain"],
  [2147483921, "DMTC", "Dominantchain"],
  [2147483922, "OGC", "Onegram"],
  [2147483923, "SHIT", "Shitcoin"],
  [2147483924, "ANDES", "Andescoin"],
  [2147483925, "AREPA", "Arepacoin"],
  [2147483926, "BOLI", "Bolivarcoin"],
  [2147483927, "RIL", "Rilcoin"],
  [2147483928, "HTR", "Hathor Network"],
  [2147483929, "FCTID", "Factom ID"],
  [2147483930, "BRAVO", "BRAVO"],
  [2147483931, "ALGO", "Algorand"],
  [2147483932, "BZX", "Bitcoinzero"],
  [2147483933, "GXX", "GravityCoin"],
  [2147483934, "HEAT", "HEAT"],
  [2147483935, "XDN", "DigitalNote"],
  [2147483936, "FSN", "FUSION"],
  [2147483937, "CPC", "Capricoin"],
  [2147483938, "BOLD", "Bold"],
  [2147483939, "IOST", "IOST"],
  [2147483940, "TKEY", "Tkeycoin"],
  [2147483941, "USE", "Usechain"],
  [2147483942, "BCZ", "BitcoinCZ"],
  [2147483943, "IOC", "Iocoin"],
  [2147483944, "ASF", "Asofe"],
  [2147483945, "MASS", "MASS"],
  [2147483946, "FAIR", "FairCoin"],
  [2147483947, "NUKO", "Nekonium"],
  [2147483948, "GNX", "Genaro Network"],
  [2147483949, "DIVI", "Divi Project"],
  [2147483950, "CMT", "Community"],
  [2147483951, "EUNO", "EUNO"],
  [2147483952, "IOTX", "IoTeX"],
  [2147483953, "ONION", "DeepOnion"],
  [2147483954, "8BIT", "8Bit"],
  [2147483955, "ATC", "AToken Coin"],
  [2147483956, "BTS", "Bitshares"],
  [2147483957, "CKB", "Nervos CKB"],
  [2147483958, "UGAS", "Ultrain"],
  [2147483959, "ADS", "Adshares"],
  [2147483960, "ARA", "Aura"],
  [2147483961, "ZIL", "Zilliqa"],
  [2147483962, "MOAC", "MOAC"],
  [2147483963, "SWTC", "SWTC"],
  [2147483964, "VNSC", "vnscoin"],
  [2147483965, "PLUG", "Pl^g"],
  [2147483966, "MAN", "Matrix AI Network"],
  [2147483967, "ECC", "ECCoin"],
  [2147483968, "RPD", "Rapids"],
  [2147483969, "RAP", "Rapture"],
  [2147483970, "GARD", "Hashgard"],
  [2147483971, "ZER", "Zero"],
  [2147483972, "EBST", "eBoost"],
  [2147483973, "SHARD", "Shard"],
  [2147483974, "LINDA", "Linda Coin"],
  [2147483975, "CMM", "Commercium"],
  [2147483976, "BLOCK", "Blocknet"],
  [2147483977, "AUDAX", "AUDAX"],
  [2147483978, "LUNA", "Terra"],
  [2147483979, "ZPM", "zPrime"],
  [2147483980, "KUVA", "Kuva Utility Note"],
  [2147483981, "MEM", "MemCoin"],
  [2147483982, "CS", "Credits"],
  [2147483983, "SWIFT", "SwiftCash"],
  [2147483984, "FIX", "FIX"],
  [2147483985, "CPC", "CPChain"],
  [2147483986, "VGO", "VirtualGoodsToken"],
  [2147483987, "DVT", "DeVault"],
  [2147483988, "N8V", "N8VCoin"],
  [2147483989, "MTNS", "OmotenashiCoin"],
  [2147483990, "BLAST", "BLAST"],
  [2147483991, "DCT", "DECENT"],
  [2147483992, "AUX", "Auxilium"],
  [2147483993, "USDP", "USDP"],
  [2147483994, "HTDF", "HTDF"],
  [2147483995, "YEC", "Ycash"],
  [2147483996, "QLC", "QLC Chain"],
  [2147483997, "TEA", "Icetea Blockchain"],
  [2147483998, "ARW", "ArrowChain"],
  [2147483999, "MDM", "Medium"],
  [2147484e3, "CYB", "Cybex"],
  [2147484001, "LTO", "LTO Network"],
  [2147484002, "DOT", "Polkadot"],
  [2147484003, "AEON", "Aeon"],
  [2147484004, "RES", "Resistance"],
  [2147484005, "AYA", "Aryacoin"],
  [2147484006, "DAPS", "Dapscoin"],
  [2147484007, "CSC", "CasinoCoin"],
  [2147484008, "VSYS", "V Systems"],
  [2147484009, "NOLLAR", "Nollar"],
  [2147484010, "XNOS", "NOS"],
  [2147484011, "CPU", "CPUchain"],
  [2147484012, "LAMB", "Lambda Storage Chain"],
  [2147484013, "VCT", "ValueCyber"],
  [2147484014, "CZR", "Canonchain"],
  [2147484015, "ABBC", "ABBC"],
  [2147484016, "HET", "HET"],
  [2147484017, "XAS", "Asch"],
  [2147484018, "VDL", "Vidulum"],
  [2147484019, "MED", "MediBloc"],
  [2147484020, "ZVC", "ZVChain"],
  [2147484021, "VESTX", "Vestx"],
  [2147484022, "DBT", "DarkBit"],
  [2147484023, "SEOS", "SuperEOS"],
  [2147484024, "MXW", "Maxonrow"],
  [2147484025, "ZNZ", "ZENZO"],
  [2147484026, "XCX", "XChain"],
  [2147484027, "SOX", "SonicX"],
  [2147484028, "NYZO", "Nyzo"],
  [2147484029, "ULC", "ULCoin"],
  [2147484030, "RYO", "Ryo Currency"],
  [2147484031, "KAL", "Kaleidochain"],
  [2147484032, "XSN", "Stakenet"],
  [2147484033, "DOGEC", "DogeCash"],
  [2147484034, "BMV", "Bitcoin Matteo's Vision"],
  [2147484035, "QBC", "Quebecoin"],
  [2147484036, "IMG", "ImageCoin"],
  [2147484037, "QOS", "QOS"],
  [2147484038, "PKT", "PKT"],
  [2147484039, "LHD", "LitecoinHD"],
  [2147484040, "CENNZ", "CENNZnet"],
  [2147484041, "HSN", "Hyper Speed Network"],
  [2147484042, "CRO", "Crypto.com Chain"],
  [2147484043, "UMBRU", "Umbru"],
  [2147484044, "TON", "Free TON"],
  [2147484045, "NEAR", "NEAR Protocol"],
  [2147484046, "XPC", "XPChain"],
  [2147484047, "ZOC", "01coin"],
  [2147484048, "NIX", "NIX"],
  [2147484049, "UC", "Utopiacoin"],
  [2147484050, "GALI", "Galilel"],
  [2147484051, "OLT", "Oneledger"],
  [2147484052, "XBI", "XBI"],
  [2147484053, "DONU", "DONU"],
  [2147484054, "EARTHS", "Earths"],
  [2147484055, "HDD", "HDDCash"],
  [2147484056, "SUGAR", "Sugarchain"],
  [2147484057, "AILE", "AileCoin"],
  [2147484058, "TENT", "TENT"],
  [2147484059, "TAN", "Tangerine Network"],
  [2147484060, "AIN", "AIN"],
  [2147484061, "MSR", "Masari"],
  [2147484062, "SUMO", "Sumokoin"],
  [2147484063, "ETN", "Electroneum"],
  [2147484064, "BYTZ", "BYTZ"],
  [2147484065, "WOW", "Wownero"],
  [2147484066, "XTNC", "XtendCash"],
  [2147484067, "LTHN", "Lethean"],
  [2147484068, "NODE", "NodeHost"],
  [2147484069, "AGM", "Argoneum"],
  [2147484070, "CCX", "Conceal Network"],
  [2147484071, "TNET", "Title Network"],
  [2147484072, "TELOS", "TelosCoin"],
  [2147484073, "AION", "Aion"],
  [2147484074, "BC", "Bitcoin Confidential"],
  [2147484075, "KTV", "KmushiCoin"],
  [2147484076, "ZCR", "ZCore"],
  [2147484077, "ERG", "Ergo"],
  [2147484078, "PESO", "Criptopeso"],
  [2147484079, "BTC2", "Bitcoin 2"],
  [2147484080, "XRPHD", "XRPHD"],
  [2147484081, "WE", "WE Coin"],
  [2147484082, "KSM", "Kusama"],
  [2147484083, "PCN", "Peepcoin"],
  [2147484084, "NCH", "NetCloth"],
  [2147484085, "ICU", "CHIPO"],
  [2147484086, "LN", "LINK"],
  [2147484087, "DTP", "DeVault Token Protocol"],
  [2147484088, "BTCR", "Bitcoin Royale"],
  [2147484089, "AERGO", "AERGO"],
  [2147484090, "XTH", "Dothereum"],
  [2147484091, "LV", "Lava"],
  [2147484092, "PHR", "Phore"],
  [2147484093, "VITAE", "Vitae"],
  [2147484094, "COCOS", "Cocos-BCX"],
  [2147484095, "DIN", "Dinero"],
  [2147484096, "SPL", "Simplicity"],
  [2147484097, "YCE", "MYCE"],
  [2147484098, "XLR", "Solaris"],
  [2147484099, "KTS", "Klimatas"],
  [2147484100, "DGLD", "DGLD"],
  [2147484101, "XNS", "Insolar"],
  [2147484102, "EM", "EMPOW"],
  [2147484103, "SHN", "ShineBlocks"],
  [2147484104, "SEELE", "Seele"],
  [2147484105, "AE", "æternity"],
  [2147484106, "ODX", "ObsidianX"],
  [2147484107, "KAVA", "Kava"],
  [2147484108, "GLEEC", "GLEEC"],
  [2147484109, "FIL", "Filecoin"],
  [2147484110, "RUTA", "Rutanio"],
  [2147484111, "CSDT", "CSDT"],
  [2147484112, "ETI", "EtherInc"],
  [2147484113, "ZSLP", "Zclassic Simple Ledger Protocol"],
  [2147484114, "ERE", "EtherCore"],
  [2147484115, "DX", "DxChain Token"],
  [2147484116, "CPS", "Capricoin+"],
  [2147484117, "BTH", "Bithereum"],
  [2147484118, "MESG", "MESG"],
  [2147484119, "FIMK", "FIMK"],
  [2147484120, "AR", "Arweave"],
  [2147484121, "OGO", "Origo"],
  [2147484122, "ROSE", "Oasis Network"],
  [2147484123, "BARE", "BARE Network"],
  [2147484124, "GLEEC", "GleecBTC"],
  [2147484125, "CLR", "Color Coin"],
  [2147484126, "RNG", "Ring"],
  [2147484127, "OLO", "Tool Global"],
  [2147484128, "PEXA", "Pexa"],
  [2147484129, "MOON", "Mooncoin"],
  [2147484130, "OCEAN", "Ocean Protocol"],
  [2147484131, "BNT", "Bluzelle Native"],
  [2147484132, "AMO", "AMO Blockchain"],
  [2147484133, "FCH", "FreeCash"],
  [2147484134, "LAT", "LatticeX"],
  [2147484135, "COIN", "Bitcoin Bank"],
  [2147484136, "VEO", "Amoveo"],
  [2147484137, "CCA", "Counos Coin"],
  [2147484138, "GFN", "Graphene"],
  [2147484139, "BIP", "Minter Network"],
  [2147484140, "KPG", "Kunpeng Network"],
  [2147484141, "FIN", "FINL Chain"],
  [2147484142, "BAND", "Band"],
  [2147484143, "DROP", "Dropil"],
  [2147484144, "BHT", "Bluehelix Chain"],
  [2147484145, "LYRA", "Scrypta"],
  [2147484146, "CS", "Credits"],
  [2147484147, "RUPX", "Rupaya"],
  [2147484148, "THETA", "Theta"],
  [2147484149, "SOL", "Solana"],
  [2147484150, "THT", "ThoughtAI"],
  [2147484151, "CFX", "Conflux"],
  [2147484152, "KUMA", "Kumacoin"],
  [2147484153, "HASH", "Provenance"],
  [2147484154, "CLX", "CasperLabs"],
  [2147484155, "EARTH", "EARTH"],
  [2147484156, "ERD", "Elrond"],
  [2147484157, "CHI", "Xaya"],
  [2147484158, "KOTO", "Koto"],
  [2147484159, "OTC", "θ"],
  [2147484160, "XRD", "Radiant"],
  [2147484161, "SEELEN", "Seele-N"],
  [2147484162, "AETH", "AETH"],
  [2147484163, "DNA", "Idena"],
  [2147484164, "VEE", "Virtual Economy Era"],
  [2147484165, "SIERRA", "SierraCoin"],
  [2147484166, "LET", "Linkeye"],
  [2147484167, "BSC", "Bitcoin Smart Contract"],
  [2147484168, "BTCV", "BitcoinVIP"],
  [2147484169, "ABA", "Dabacus"],
  [2147484170, "SCC", "StakeCubeCoin"],
  [2147484171, "EDG", "Edgeware"],
  [2147484172, "AMS", "AmsterdamCoin"],
  [2147484173, "GOSS", "GOSSIP Coin"],
  [2147484174, "BU", "BUMO"],
  [2147484175, "GRAM", "GRAM"],
  [2147484176, "YAP", "Yapstone"],
  [2147484177, "SCRT", "Secret Network"],
  [2147484178, "NOVO", "Novo"],
  [2147484179, "GHOST", "Ghost"],
  [2147484180, "HST", "HST"],
  [2147484181, "PRJ", "ProjectCoin"],
  [2147484182, "YOU", "YOUChain"],
  [2147484183, "XHV", "Haven Protocol"],
  [2147484184, "BYND", "Beyondcoin"],
  [2147484185, "JOYS", "Joys Digital"],
  [2147484186, "VAL", "Valorbit"],
  [2147484187, "FLOW", "Flow"],
  [2147484188, "SMESH", "Spacemesh Coin"],
  [2147484189, "SCDO", "SCDO"],
  [2147484190, "IQS", "IQ-Cash"],
  [2147484191, "BIND", "Compendia"],
  [2147484192, "COINEVO", "Coinevo"],
  [2147484193, "SCRIBE", "Scribe"],
  [2147484194, "HYN", "Hyperion"],
  [2147484195, "BHP", "BHP"],
  [2147484196, "BBC", "BigBang Core"],
  [2147484197, "MKF", "MarketFinance"],
  [2147484198, "XDC", "XinFin.Network"],
  [2147484199, "STR", "Straightedge"],
  [2147484200, "SUM", "Sumcoin"],
  [2147484201, "HBC", "HuobiChain"],
  [2147484202, "FLR", "Flare Spark"],
  [2147484203, "BCS", "Bitcoin Smart"],
  [2147484204, "KTS", "Kratos"],
  [2147484205, "LKR", "Lkrcoin"],
  [2147484206, "TAO", "Tao"],
  [2147484207, "XWC", "Whitecoin"],
  [2147484208, "DEAL", "DEAL"],
  [2147484209, "NTY", "Nexty"],
  [2147484210, "TOP", "TOP NetWork"],
  [2147484211, "STARS", "Stargaze"],
  [2147484212, "AG", "Agoric"],
  [2147484213, "CICO", "Coinicles"],
  [2147484214, "IRIS", "Irisnet"],
  [2147484215, "NCG", "Nine Chronicles"],
  [2147484216, "LRG", "Large Coin"],
  [2147484217, "SERO", "Super Zero Protocol"],
  [2147484218, "BDX", "Beldex"],
  [2147484219, "CCXX", "Counos X"],
  [2147484220, "SLS", "Saluscoin"],
  [2147484221, "SRM", "Serum"],
  [2147484222, "VLX", "Velas"],
  [2147484223, "VIVT", "VIDT Datalink"],
  [2147484224, "BPS", "BitcoinPoS"],
  [2147484225, "NKN", "NKN"],
  [2147484226, "ICL", "ILCOIN"],
  [2147484227, "BONO", "Bonorum"],
  [2147484228, "PLC", "PLATINCOIN"],
  [2147484229, "DUN", "Dune"],
  [2147484230, "DMCH", "Darmacash"],
  [2147484231, "CTC", "Creditcoin"],
  [2147484232, "KELP", "Haidai Network"],
  [2147484233, "GBCR", "GoldBCR"],
  [2147484234, "XDAG", "XDAG"],
  [2147484235, "PRV", "Incognito Privacy"],
  [2147484236, "SCAP", "SafeCapital"],
  [2147484237, "TFUEL", "Theta Fuel"],
  [2147484238, "GTM", "Gentarium"],
  [2147484239, "RNL", "RentalChain"],
  [2147484240, "GRIN", "Grin"],
  [2147484241, "MWC", "MimbleWimbleCoin"],
  [2147484242, "DOCK", "[Dock][https://dock.io]"],
  [2147484243, "POLYX", "Polymesh"],
  [2147484244, "DIVER", "Divergenti"],
  [2147484245, "XEP", "Electra Protocol"],
  [2147484246, "APN", "Apron"],
  [2147484247, "TFC", "Turbo File Coin"],
  [2147484248, "UTE", "Unit-e"],
  [2147484249, "MTC", "Metacoin"],
  [2147484250, "NC", "NobodyCash"],
  [2147484258, "NOR", "Noir"],
  [2147484266, "SSP", "SmartShare"],
  [2147484273, "EAST", "Eastcoin"],
  [2147484287, "BTSG", "BitSong"],
  [2147484288, "LFC", "Leofcoin"],
  [2147484311, "SFRX", "EtherGem Sapphire"],
  [2147484314, "ACT", "Achain"],
  [2147484315, "PRKL", "Perkle"],
  [2147484316, "SSC", "SelfSell"],
  [2147484317, "GC", "GateChain"],
  [2147484326, "Voken", "Voken"],
  [2147484328, "Evrynet", "Evrynet"],
  [2147484334, "KAR", "Karura Network"],
  [2147484336, "CET", "CoinEx Chain"],
  [2147484346, "VEIL", "Veil"],
  [2147484348, "XDAI", "xDai"],
  [2147484359, "CHC", "Chaincoin"],
  [2147484361, "XTL", "Katal Chain"],
  [2147484362, "BNB", "Binance"],
  [2147484363, "SIN", "Sinovate"],
  [2147484373, "MCX", "MultiCash"],
  [2147484379, "BMK", "Bitmark"],
  [2147484395, "RAD", "Centrifuge"],
  [2147484398, "XPRT", "Persistence"],
  [2147484416, "BALLZ", "Ballzcoin"],
  [2147484419, "BR", "BR"],
  [2147484425, "BTW", "Bitcoin World"],
  [2147484435, "ACA", "Acala"],
  [2147484437, "TAU", "Lamden"],
  [2147484448, "BEET", "Beetle Coin"],
  [2147484449, "DST", "DSTRA"],
  [2147484456, "QVT", "Qvolta"],
  [2147484466, "VET", "VeChain Token"],
  [2147484468, "CLO", "Callisto"],
  [2147484479, "CRUZ", "cruzbit"],
  [2147484500, "DSM", "Desmos"],
  [2147484501, "PRCY", "PRCY Coin"],
  [2147484516, "IF", "Infinitefuture"],
  [2147484531, "ZBC", "ZooBC"],
  [2147484534, "ADF", "AD Token"],
  [2147484536, "NEO", "NEO"],
  [2147484537, "TOMO", "TOMO"],
  [2147484538, "XSEL", "Seln"],
  [2147484547, "BCHA", "BCHA"],
  [2147484548, "LMO", "Lumeneo"],
  [2147484552, "", "Helium"],
  [2147484555, "FIS", "StaFi"],
  [2147484564, "META", "Metadium"],
  [2147484565, "FRA", "Findora"],
  [2147484573, "DIP", "Dipper Network"],
  [2147484579, "RUNE", "THORChain (RUNE)"],
  [2147484603, "LTP", "LifetionCoin"],
  [2147484614, "MATIC", "Matic"],
  [2147484618, "TWINS", "TWINS"],
  [2147484636, "XAZAB", "Xazab core"],
  [2147484637, "AIOZ", "AIOZ"],
  [2147484644, "OKT", "OKChain Token"],
  [2147484645, "SUM", "Solidum"],
  [2147484646, "LBTC", "Lightning Bitcoin"],
  [2147484647, "BCD", "Bitcoin Diamond"],
  [2147484648, "BTN", "Bitcoin New"],
  [2147484649, "TT", "ThunderCore"],
  [2147484650, "BKT", "BanKitt"],
  [2147484658, "HT", "Huobi ECO Chain"],
  [2147484671, "ONE", "HARMONY-ONE"],
  [2147484672, "ONT", "Ontology"],
  [2147484674, "KEX", "Kira Exchange Token"],
  [2147484675, "MCM", "Mochimo"],
  [2147484680, "BTCR", "BTCR"],
  [2147484759, "BBC", "Big Bitcoin"],
  [2147484768, "RISE", "RISE"],
  [2147484770, "CMT", "CyberMiles Token"],
  [2147484776, "ETSC", "Ethereum Social"],
  [2147484777, "DFI", "DeFiChain"],
  [2147484785, "$DAG", "Constellation Labs"],
  [2147484793, "CDY", "Bitcoin Candy"],
  [2147484985, "DFC", "Defcoin"],
  [2147485045, "HYC", "Hycon"],
  [2147485172, "", "Taler"],
  [2147485181, "BEAM", "Beam"],
  [2147485264, "ELF", "AELF"],
  [2147485266, "AUDL", "AUDL"],
  [2147485268, "ATH", "Atheios"],
  [2147485290, "NEW", "Newton"],
  [2147485336, "BCX", "BitcoinX"],
  [2147485377, "XTZ", "Tezos"],
  [2147485424, "LBTC", "Liquid BTC"],
  [2147485432, "JPYS", "JPY Stablecoin"],
  [2147485463, "ADA", "Cardano"],
  [2147485507, "TES", "Teslacoin"],
  [2147485547, "SLPA", "BCHA token"],
  [2147485549, "CLC", "Classica"],
  [2147485567, "VIPS", "VIPSTARCOIN"],
  [2147485574, "CITY", "City Coin"],
  [2147485625, "XMX", "Xuma"],
  [2147485632, "TRTL", "TurtleCoin"],
  [2147485635, "EGEM", "EtherGem"],
  [2147485637, "HODL", "HOdlcoin"],
  [2147485638, "PHL", "Placeholders"],
  [2147485639, "SC", "Sia"],
  [2147485645, "POLIS", "Polis"],
  [2147485646, "XMCC", "Monoeci"],
  [2147485647, "COLX", "ColossusXT"],
  [2147485648, "GIN", "GinCoin"],
  [2147485649, "MNP", "MNPCoin"],
  [2147485665, "KIN", "Kin"],
  [2147485666, "EOSC", "EOSClassic"],
  [2147485667, "GBT", "GoldBean Token"],
  [2147485668, "PKC", "PKC"],
  [2147485669, "SKT", "Sukhavati"],
  [2147485696, "MCASH", "MCashChain"],
  [2147485697, "TRUE", "TrueChain"],
  [2147485760, "IoTE", "IoTE"],
  [2147485869, "ASK", "ASK"],
  [2147485949, "QTUM", "QTUM"],
  [2147485950, "ETP", "Metaverse"],
  [2147485951, "GXC", "GXChain"],
  [2147485952, "CRP", "CranePay"],
  [2147485953, "ELA", "Elastos"],
  [2147485986, "SNOW", "Snowblossom"],
  [2147486218, "AOA", "Aurora"],
  [2147486542, "REOSC", "REOSC Ecosystem"],
  [2147486651, "LUX", "LUX"],
  [2147486678, "XHB", "Hedera HBAR"],
  [2147486725, "COS", "Contentos"],
  [2147487029, "DYN", "Dynamic"],
  [2147487031, "SEQ", "Sequence"],
  [2147487200, "DEO", "Destocoin"],
  [2147487212, "DST", "DeStream"],
  [2147486366, "NAS", "Nebulas"],
  [2147486589, "BND", "Blocknode"],
  [2147486924, "CCC", "CodeChain"],
  [2147487025, "ROI", "ROIcoin"],
  [2147487688, "FC8", "FCH Network"],
  [2147487744, "YEE", "YeeCo"],
  [2147487866, "IOTA", "IOTA"],
  [2147487890, "AXE", "Axe"],
  [2147487991, "XYM", "Symbol"],
  [2147488896, "FIC", "FIC"],
  [2147489001, "HNS", "Handshake"],
  [2147489203, "FUND", "Unification"],
  [2147489405, "STX", "Blockstack"],
  [2147489568, "SLU", "SILUBIUM"],
  [2147489708, "GO", "GoChain GO"],
  [2147490314, "BPA", "Bitcoin Pizza"],
  [2147490336, "SAFE", "SAFE"],
  [2147490617, "ROGER", "TheHolyrogerCoin"],
  [2147491425, "BTV", "Bitvote"],
  [2147491648, "SKY", "Skycoin"],
  [2147491865, "KLAY", "KLAY"],
  [2147491987, "BTQ", "BitcoinQuark"],
  [2147492092, "XCH", "Chia"],
  [2147492536, "SBTC", "Super Bitcoin"],
  [2147492612, "NULS", "NULS"],
  [2147492647, "BTP", "Bitcoin Pay"],
  [2147492648, "AVAX", "Avalanche"],
  [2147493445, "NRG", "Energi"],
  [2147493536, "BTF", "Bitcoin Faith"],
  [2147493647, "GOD", "Bitcoin God"],
  [2147493648, "FO", "FIBOS"],
  [2147493939, "BTR", "Bitcoin Rhodium"],
  [2147494759, "ESS", "Essentia One"],
  [2147495993, "IPOS", "IPOS"],
  [2147496234, "MINA", "Mina"],
  [2147496755, "BTY", "BitYuan"],
  [2147496756, "YCC", "Yuan Chain Coin"],
  [2147499493, "SDGO", "SanDeGo"],
  [2147499829, "XTX", "Totem Live Network"],
  [2147500402, "ARDR", "Ardor"],
  [2147502813, "SAFE", "Safecoin"],
  [2147502815, "ZEL", "ZelCash"],
  [2147502817, "RITO", "Ritocoin"],
  [2147503684, "XND", "ndau"],
  [2147506152, "PWR", "PWRcoin"],
  [2147508900, "BELL", "Bellcoin"],
  [2147509366, "CHX", "Own"],
  [2147514750, "ESN", "EtherSocial Network"],
  [2147514985, "", "ThePower.io"],
  [2147517064, "TEO", "Trust Eth reOrigin"],
  [2147517526, "BTCS", "Bitcoin Stake"],
  [2147518600, "BTT", "ByteTrade"],
  [2147521640, "FXTC", "FixedTradeCoin"],
  [2147522969, "AMA", "Amabig"],
  [2147532910, "EVE", "evan.network"],
  [2147532992, "STASH", "STASH"],
  [2147536400, "CELO", "Celo"],
  [2147549184, "KETH", "Krypton World"],
  [2147561425, "ZYN", "Wethio"],
  [2147572536, "RYO", "c0ban"],
  [2147583647, "WICC", "Waykichain"],
  [2147588753, "STRAX", "Strax"],
  [2147684273, "AKA", "Akroma"],
  [2147553280, "GENOM", "GENOM"],
  [2147730177, "ATS", "ARTIS sigma1"],
  [2147907890, "X42", "x42"],
  [2148150314, "VITE", "Vite"],
  [2148372536, "SEA", "Second Exchange Alliance"],
  [2148654985, "ILT", "iOlite"],
  [2148796762, "ETHO", "Ether-1"],
  [2148797148, "XERO", "Xerom"],
  [2149195792, "LAX", "LAPO"],
  [2151407659, "EPK", "EPIK Protocol"],
  [2152225092, "HYD", "Hydra Token"],
  [2152733001, "BCO", "BitcoinOre"],
  [2152733002, "BHD", "BitcoinHD"],
  [2152748110, "PTN", "PalletOne"],
  [2153201998, "WAN", "Wanchain"],
  [2153225212, "WAVES", "Waves"],
  [2155046253, "SEM", "Semux"],
  [2155051384, "ION", "ION"],
  [2155308914, "WGR", "WGR"],
  [2155308915, "OBSR", "OBServer"],
  [2162602624, "XDS", "XDS"],
  [2209201209, "AQUA", "Aquachain"],
  [2236372536, "HATCH", "Hatch"],
  [2239410657, "kUSD", "kUSD"],
  [2247483645, "EQ", "EQ"],
  [2247483646, "FLUID", "Fluid Chains"],
  [2247483647, "QKC", "QuarkChain"]
], bn$7 = { exports: {} };
bn$7.exports;
(function(c) {
  (function(t, n) {
    function ie(_e, se) {
      if (!_e) throw new Error(se || "Assertion failed");
    }
    function fe(_e, se) {
      _e.super_ = se;
      var ce = function() {
      };
      ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
    }
    function ae(_e, se, ce) {
      if (ae.isBN(_e))
        return _e;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
    }
    typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
    var le;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
    } catch {
    }
    ae.isBN = function(se) {
      return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
    }, ae.max = function(se, ce) {
      return se.cmp(ce) > 0 ? se : ce;
    }, ae.min = function(se, ce) {
      return se.cmp(ce) < 0 ? se : ce;
    }, ae.prototype._init = function(se, ce, de) {
      if (typeof se == "number")
        return this._initNumber(se, ce, de);
      if (typeof se == "object")
        return this._initArray(se, ce, de);
      ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
      var pe = 0;
      se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
    }, ae.prototype._initNumber = function(se, ce, de) {
      se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
        se & 67108863,
        se / 67108864 & 67108863
      ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
        se & 67108863,
        se / 67108864 & 67108863,
        1
      ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
    }, ae.prototype._initArray = function(se, ce, de) {
      if (ie(typeof se.length == "number"), se.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve, we, Ee = 0;
      if (de === "be")
        for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
          we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      else if (de === "le")
        for (pe = 0, ve = 0; pe < se.length; pe += 3)
          we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      return this.strip();
    };
    function he(_e, se) {
      var ce = _e.charCodeAt(se);
      return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
    }
    function me(_e, se, ce) {
      var de = he(_e, ce);
      return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
    }
    ae.prototype._parseHex = function(se, ce, de) {
      this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve = 0, we = 0, Ee;
      if (de === "be")
        for (pe = se.length - 1; pe >= ce; pe -= 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      else {
        var xe = se.length - ce;
        for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      }
      this.strip();
    };
    function ye(_e, se, ce, de) {
      for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
        var Ee = _e.charCodeAt(we) - 48;
        pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
      }
      return pe;
    }
    ae.prototype._parseBase = function(se, ce, de) {
      this.words = [0], this.length = 1;
      for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
        pe++;
      pe--, ve = ve / ce | 0;
      for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
        ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      if (Ee !== 0) {
        var Be = 1;
        for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
          Be *= ce;
        this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      }
      this.strip();
    }, ae.prototype.copy = function(se) {
      se.words = new Array(this.length);
      for (var ce = 0; ce < this.length; ce++)
        se.words[ce] = this.words[ce];
      se.length = this.length, se.negative = this.negative, se.red = this.red;
    }, ae.prototype.clone = function() {
      var se = new ae(null);
      return this.copy(se), se;
    }, ae.prototype._expand = function(se) {
      for (; this.length < se; )
        this.words[this.length++] = 0;
      return this;
    }, ae.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, ae.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, ae.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var be = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Ae = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Se = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    ae.prototype.toString = function(se, ce) {
      se = se || 10, ce = ce | 0 || 1;
      var de;
      if (se === 16 || se === "hex") {
        de = "";
        for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
          var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
          ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
        }
        for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      if (se === (se | 0) && se >= 2 && se <= 36) {
        var ue = Ae[se], ge = Se[se];
        de = "";
        var Be = this.clone();
        for (Be.negative = 0; !Be.isZero(); ) {
          var Ne = Be.modn(ge).toString(se);
          Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
        }
        for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      ie(!1, "Base should be between 2 and 36");
    }, ae.prototype.toNumber = function() {
      var se = this.words[0];
      return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
    }, ae.prototype.toJSON = function() {
      return this.toString(16);
    }, ae.prototype.toBuffer = function(se, ce) {
      return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
    }, ae.prototype.toArray = function(se, ce) {
      return this.toArrayLike(Array, se, ce);
    }, ae.prototype.toArrayLike = function(se, ce, de) {
      var pe = this.byteLength(), ve = de || Math.max(1, pe);
      ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
      var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
      if (we) {
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
        for (; ue < ve; ue++)
          Ee[ue] = 0;
      } else {
        for (ue = 0; ue < ve - pe; ue++)
          Ee[ue] = 0;
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
      }
      return Ee;
    }, Math.clz32 ? ae.prototype._countBits = function(se) {
      return 32 - Math.clz32(se);
    } : ae.prototype._countBits = function(se) {
      var ce = se, de = 0;
      return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
    }, ae.prototype._zeroBits = function(se) {
      if (se === 0) return 26;
      var ce = se, de = 0;
      return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
    }, ae.prototype.bitLength = function() {
      var se = this.words[this.length - 1], ce = this._countBits(se);
      return (this.length - 1) * 26 + ce;
    };
    function $e(_e) {
      for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
        var de = ce / 26 | 0, pe = ce % 26;
        se[ce] = (_e.words[de] & 1 << pe) >>> pe;
      }
      return se;
    }
    ae.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var se = 0, ce = 0; ce < this.length; ce++) {
        var de = this._zeroBits(this.words[ce]);
        if (se += de, de !== 26) break;
      }
      return se;
    }, ae.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, ae.prototype.toTwos = function(se) {
      return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
    }, ae.prototype.fromTwos = function(se) {
      return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
    }, ae.prototype.isNeg = function() {
      return this.negative !== 0;
    }, ae.prototype.neg = function() {
      return this.clone().ineg();
    }, ae.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, ae.prototype.iuor = function(se) {
      for (; this.length < se.length; )
        this.words[this.length++] = 0;
      for (var ce = 0; ce < se.length; ce++)
        this.words[ce] = this.words[ce] | se.words[ce];
      return this.strip();
    }, ae.prototype.ior = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuor(se);
    }, ae.prototype.or = function(se) {
      return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
    }, ae.prototype.uor = function(se) {
      return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
    }, ae.prototype.iuand = function(se) {
      var ce;
      this.length > se.length ? ce = se : ce = this;
      for (var de = 0; de < ce.length; de++)
        this.words[de] = this.words[de] & se.words[de];
      return this.length = ce.length, this.strip();
    }, ae.prototype.iand = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuand(se);
    }, ae.prototype.and = function(se) {
      return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
    }, ae.prototype.uand = function(se) {
      return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
    }, ae.prototype.iuxor = function(se) {
      var ce, de;
      this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
      for (var pe = 0; pe < de.length; pe++)
        this.words[pe] = ce.words[pe] ^ de.words[pe];
      if (this !== ce)
        for (; pe < ce.length; pe++)
          this.words[pe] = ce.words[pe];
      return this.length = ce.length, this.strip();
    }, ae.prototype.ixor = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuxor(se);
    }, ae.prototype.xor = function(se) {
      return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
    }, ae.prototype.uxor = function(se) {
      return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
    }, ae.prototype.inotn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = Math.ceil(se / 26) | 0, de = se % 26;
      this._expand(ce), de > 0 && ce--;
      for (var pe = 0; pe < ce; pe++)
        this.words[pe] = ~this.words[pe] & 67108863;
      return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
    }, ae.prototype.notn = function(se) {
      return this.clone().inotn(se);
    }, ae.prototype.setn = function(se, ce) {
      ie(typeof se == "number" && se >= 0);
      var de = se / 26 | 0, pe = se % 26;
      return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
    }, ae.prototype.iadd = function(se) {
      var ce;
      if (this.negative !== 0 && se.negative === 0)
        return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && se.negative !== 0)
        return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
      var de, pe;
      this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
      for (var ve = 0, we = 0; we < pe.length; we++)
        ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      for (; ve !== 0 && we < de.length; we++)
        ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      if (this.length = de.length, ve !== 0)
        this.words[this.length] = ve, this.length++;
      else if (de !== this)
        for (; we < de.length; we++)
          this.words[we] = de.words[we];
      return this;
    }, ae.prototype.add = function(se) {
      var ce;
      return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
    }, ae.prototype.isub = function(se) {
      if (se.negative !== 0) {
        se.negative = 0;
        var ce = this.iadd(se);
        return se.negative = 1, ce._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
      var de = this.cmp(se);
      if (de === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pe, ve;
      de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
      for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
        ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      for (; we !== 0 && Ee < pe.length; Ee++)
        ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      if (we === 0 && Ee < pe.length && pe !== this)
        for (; Ee < pe.length; Ee++)
          this.words[Ee] = pe.words[Ee];
      return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
    }, ae.prototype.sub = function(se) {
      return this.clone().isub(se);
    };
    function Re(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative;
      var de = _e.length + se.length | 0;
      ce.length = de, de = de - 1 | 0;
      var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
      ce.words[0] = Ee;
      for (var ue = 1; ue < de; ue++) {
        for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
          var Pe = ue - Fe | 0;
          pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
        }
        ce.words[ue] = Be | 0, xe = ge | 0;
      }
      return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
    }
    var Me = function(se, ce, de) {
      var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
      de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
      var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
      var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
      var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
      var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
      var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
      var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
      var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
      var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
      var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
      var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
      var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
      var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
      var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
      var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
      var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
      var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
      var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
      var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
      var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
    };
    Math.imul || (Me = Re);
    function ke(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
      for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
        var we = pe;
        pe = 0;
        for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
          var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
          we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
        }
        ce.words[ve] = Ee, de = we, we = pe;
      }
      return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
    }
    function Te(_e, se, ce) {
      var de = new Ie();
      return de.mulp(_e, se, ce);
    }
    ae.prototype.mulTo = function(se, ce) {
      var de, pe = this.length + se.length;
      return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
    };
    function Ie(_e, se) {
      this.x = _e, this.y = se;
    }
    Ie.prototype.makeRBT = function(se) {
      for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
        ce[pe] = this.revBin(pe, de, se);
      return ce;
    }, Ie.prototype.revBin = function(se, ce, de) {
      if (se === 0 || se === de - 1) return se;
      for (var pe = 0, ve = 0; ve < ce; ve++)
        pe |= (se & 1) << ce - ve - 1, se >>= 1;
      return pe;
    }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
      for (var Ee = 0; Ee < we; Ee++)
        pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
    }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
      this.permute(we, se, ce, de, pe, ve);
      for (var Ee = 1; Ee < ve; Ee <<= 1)
        for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
          for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
            var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
            Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
          }
    }, Ie.prototype.guessLen13b = function(se, ce) {
      var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
      for (de = de / 2 | 0; de; de = de >>> 1)
        ve++;
      return 1 << ve + 1 + pe;
    }, Ie.prototype.conjugate = function(se, ce, de) {
      if (!(de <= 1))
        for (var pe = 0; pe < de / 2; pe++) {
          var ve = se[pe];
          se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
        }
    }, Ie.prototype.normalize13b = function(se, ce) {
      for (var de = 0, pe = 0; pe < ce / 2; pe++) {
        var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
        se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
      }
      return se;
    }, Ie.prototype.convert13b = function(se, ce, de, pe) {
      for (var ve = 0, we = 0; we < ce; we++)
        ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
      for (we = 2 * ce; we < pe; ++we)
        de[we] = 0;
      ie(ve === 0), ie((ve & -8192) === 0);
    }, Ie.prototype.stub = function(se) {
      for (var ce = new Array(se), de = 0; de < se; de++)
        ce[de] = 0;
      return ce;
    }, Ie.prototype.mulp = function(se, ce, de) {
      var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
      Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
      for (var Pe = 0; Pe < pe; Pe++) {
        var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
        ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
      }
      return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
    }, ae.prototype.mul = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
    }, ae.prototype.mulf = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), Te(this, se, ce);
    }, ae.prototype.imul = function(se) {
      return this.clone().mulTo(se, this);
    }, ae.prototype.imuln = function(se) {
      ie(typeof se == "number"), ie(se < 67108864);
      for (var ce = 0, de = 0; de < this.length; de++) {
        var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
        ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
      }
      return ce !== 0 && (this.words[de] = ce, this.length++), this;
    }, ae.prototype.muln = function(se) {
      return this.clone().imuln(se);
    }, ae.prototype.sqr = function() {
      return this.mul(this);
    }, ae.prototype.isqr = function() {
      return this.imul(this.clone());
    }, ae.prototype.pow = function(se) {
      var ce = $e(se);
      if (ce.length === 0) return new ae(1);
      for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
        ;
      if (++pe < ce.length)
        for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
          ce[pe] !== 0 && (de = de.mul(ve));
      return de;
    }, ae.prototype.iushln = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
      if (ce !== 0) {
        var we = 0;
        for (ve = 0; ve < this.length; ve++) {
          var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
          this.words[ve] = xe | we, we = Ee >>> 26 - ce;
        }
        we && (this.words[ve] = we, this.length++);
      }
      if (de !== 0) {
        for (ve = this.length - 1; ve >= 0; ve--)
          this.words[ve + de] = this.words[ve];
        for (ve = 0; ve < de; ve++)
          this.words[ve] = 0;
        this.length += de;
      }
      return this.strip();
    }, ae.prototype.ishln = function(se) {
      return ie(this.negative === 0), this.iushln(se);
    }, ae.prototype.iushrn = function(se, ce, de) {
      ie(typeof se == "number" && se >= 0);
      var pe;
      ce ? pe = (ce - ce % 26) / 26 : pe = 0;
      var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
      if (pe -= we, pe = Math.max(0, pe), xe) {
        for (var ue = 0; ue < we; ue++)
          xe.words[ue] = this.words[ue];
        xe.length = we;
      }
      if (we !== 0) if (this.length > we)
        for (this.length -= we, ue = 0; ue < this.length; ue++)
          this.words[ue] = this.words[ue + we];
      else
        this.words[0] = 0, this.length = 1;
      var ge = 0;
      for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
        var Be = this.words[ue] | 0;
        this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
      }
      return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, ae.prototype.ishrn = function(se, ce, de) {
      return ie(this.negative === 0), this.iushrn(se, ce, de);
    }, ae.prototype.shln = function(se) {
      return this.clone().ishln(se);
    }, ae.prototype.ushln = function(se) {
      return this.clone().iushln(se);
    }, ae.prototype.shrn = function(se) {
      return this.clone().ishrn(se);
    }, ae.prototype.ushrn = function(se) {
      return this.clone().iushrn(se);
    }, ae.prototype.testn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de) return !1;
      var ve = this.words[de];
      return !!(ve & pe);
    }, ae.prototype.imaskn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
        return this;
      if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
        var pe = 67108863 ^ 67108863 >>> ce << ce;
        this.words[this.length - 1] &= pe;
      }
      return this.strip();
    }, ae.prototype.maskn = function(se) {
      return this.clone().imaskn(se);
    }, ae.prototype.iaddn = function(se) {
      return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
    }, ae.prototype._iaddn = function(se) {
      this.words[0] += se;
      for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
        this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
      return this.length = Math.max(this.length, ce + 1), this;
    }, ae.prototype.isubn = function(se) {
      if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(se), this.negative = 1, this;
      if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
          this.words[ce] += 67108864, this.words[ce + 1] -= 1;
      return this.strip();
    }, ae.prototype.addn = function(se) {
      return this.clone().iaddn(se);
    }, ae.prototype.subn = function(se) {
      return this.clone().isubn(se);
    }, ae.prototype.iabs = function() {
      return this.negative = 0, this;
    }, ae.prototype.abs = function() {
      return this.clone().iabs();
    }, ae.prototype._ishlnsubmul = function(se, ce, de) {
      var pe = se.length + de, ve;
      this._expand(pe);
      var we, Ee = 0;
      for (ve = 0; ve < se.length; ve++) {
        we = (this.words[ve + de] | 0) + Ee;
        var xe = (se.words[ve] | 0) * ce;
        we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
      }
      for (; ve < this.length - de; ve++)
        we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
      if (Ee === 0) return this.strip();
      for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
        we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
      return this.negative = 1, this.strip();
    }, ae.prototype._wordDiv = function(se, ce) {
      var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
      de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
      var xe = pe.length - ve.length, ue;
      if (ce !== "mod") {
        ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
        for (var ge = 0; ge < ue.length; ge++)
          ue.words[ge] = 0;
      }
      var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
      Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
      for (var Ne = xe - 1; Ne >= 0; Ne--) {
        var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
        for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
          Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
        ue && (ue.words[Ne] = Fe);
      }
      return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
        div: ue || null,
        mod: pe
      };
    }, ae.prototype.divmod = function(se, ce, de) {
      if (ie(!se.isZero()), this.isZero())
        return {
          div: new ae(0),
          mod: new ae(0)
        };
      var pe, ve, we;
      return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
        div: pe,
        mod: ve
      }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
        div: pe,
        mod: we.mod
      }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
        div: we.div,
        mod: ve
      }) : se.length > this.length || this.cmp(se) < 0 ? {
        div: new ae(0),
        mod: this
      } : se.length === 1 ? ce === "div" ? {
        div: this.divn(se.words[0]),
        mod: null
      } : ce === "mod" ? {
        div: null,
        mod: new ae(this.modn(se.words[0]))
      } : {
        div: this.divn(se.words[0]),
        mod: new ae(this.modn(se.words[0]))
      } : this._wordDiv(se, ce);
    }, ae.prototype.div = function(se) {
      return this.divmod(se, "div", !1).div;
    }, ae.prototype.mod = function(se) {
      return this.divmod(se, "mod", !1).mod;
    }, ae.prototype.umod = function(se) {
      return this.divmod(se, "mod", !0).mod;
    }, ae.prototype.divRound = function(se) {
      var ce = this.divmod(se);
      if (ce.mod.isZero()) return ce.div;
      var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
      return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
    }, ae.prototype.modn = function(se) {
      ie(se <= 67108863);
      for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
        de = (ce * de + (this.words[pe] | 0)) % se;
      return de;
    }, ae.prototype.idivn = function(se) {
      ie(se <= 67108863);
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = (this.words[de] | 0) + ce * 67108864;
        this.words[de] = pe / se | 0, ce = pe % se;
      }
      return this.strip();
    }, ae.prototype.divn = function(se) {
      return this.clone().idivn(se);
    }, ae.prototype.egcd = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
        ce.iushrn(1), de.iushrn(1), ++xe;
      for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
        for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
        if (Be > 0)
          for (ce.iushrn(Be); Be-- > 0; )
            (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
        for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
        if (Fe > 0)
          for (de.iushrn(Fe); Fe-- > 0; )
            (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
      }
      return {
        a: we,
        b: Ee,
        gcd: de.iushln(xe)
      };
    }, ae.prototype._invmp = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
        for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
        if (Ee > 0)
          for (ce.iushrn(Ee); Ee-- > 0; )
            pe.isOdd() && pe.iadd(we), pe.iushrn(1);
        for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
        if (ue > 0)
          for (de.iushrn(ue); ue-- > 0; )
            ve.isOdd() && ve.iadd(we), ve.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
      }
      var Be;
      return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
    }, ae.prototype.gcd = function(se) {
      if (this.isZero()) return se.abs();
      if (se.isZero()) return this.abs();
      var ce = this.clone(), de = se.clone();
      ce.negative = 0, de.negative = 0;
      for (var pe = 0; ce.isEven() && de.isEven(); pe++)
        ce.iushrn(1), de.iushrn(1);
      do {
        for (; ce.isEven(); )
          ce.iushrn(1);
        for (; de.isEven(); )
          de.iushrn(1);
        var ve = ce.cmp(de);
        if (ve < 0) {
          var we = ce;
          ce = de, de = we;
        } else if (ve === 0 || de.cmpn(1) === 0)
          break;
        ce.isub(de);
      } while (!0);
      return de.iushln(pe);
    }, ae.prototype.invm = function(se) {
      return this.egcd(se).a.umod(se);
    }, ae.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, ae.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, ae.prototype.andln = function(se) {
      return this.words[0] & se;
    }, ae.prototype.bincn = function(se) {
      ie(typeof se == "number");
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de)
        return this._expand(de + 1), this.words[de] |= pe, this;
      for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
        var Ee = this.words[we] | 0;
        Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
      }
      return ve !== 0 && (this.words[we] = ve, this.length++), this;
    }, ae.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, ae.prototype.cmpn = function(se) {
      var ce = se < 0;
      if (this.negative !== 0 && !ce) return -1;
      if (this.negative === 0 && ce) return 1;
      this.strip();
      var de;
      if (this.length > 1)
        de = 1;
      else {
        ce && (se = -se), ie(se <= 67108863, "Number is too big");
        var pe = this.words[0] | 0;
        de = pe === se ? 0 : pe < se ? -1 : 1;
      }
      return this.negative !== 0 ? -de | 0 : de;
    }, ae.prototype.cmp = function(se) {
      if (this.negative !== 0 && se.negative === 0) return -1;
      if (this.negative === 0 && se.negative !== 0) return 1;
      var ce = this.ucmp(se);
      return this.negative !== 0 ? -ce | 0 : ce;
    }, ae.prototype.ucmp = function(se) {
      if (this.length > se.length) return 1;
      if (this.length < se.length) return -1;
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = this.words[de] | 0, ve = se.words[de] | 0;
        if (pe !== ve) {
          pe < ve ? ce = -1 : pe > ve && (ce = 1);
          break;
        }
      }
      return ce;
    }, ae.prototype.gtn = function(se) {
      return this.cmpn(se) === 1;
    }, ae.prototype.gt = function(se) {
      return this.cmp(se) === 1;
    }, ae.prototype.gten = function(se) {
      return this.cmpn(se) >= 0;
    }, ae.prototype.gte = function(se) {
      return this.cmp(se) >= 0;
    }, ae.prototype.ltn = function(se) {
      return this.cmpn(se) === -1;
    }, ae.prototype.lt = function(se) {
      return this.cmp(se) === -1;
    }, ae.prototype.lten = function(se) {
      return this.cmpn(se) <= 0;
    }, ae.prototype.lte = function(se) {
      return this.cmp(se) <= 0;
    }, ae.prototype.eqn = function(se) {
      return this.cmpn(se) === 0;
    }, ae.prototype.eq = function(se) {
      return this.cmp(se) === 0;
    }, ae.red = function(se) {
      return new je(se);
    }, ae.prototype.toRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
    }, ae.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, ae.prototype._forceRed = function(se) {
      return this.red = se, this;
    }, ae.prototype.forceRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
    }, ae.prototype.redAdd = function(se) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
    }, ae.prototype.redIAdd = function(se) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
    }, ae.prototype.redSub = function(se) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
    }, ae.prototype.redISub = function(se) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
    }, ae.prototype.redShl = function(se) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
    }, ae.prototype.redMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
    }, ae.prototype.redIMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
    }, ae.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, ae.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, ae.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, ae.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, ae.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, ae.prototype.redPow = function(se) {
      return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
    };
    var qe = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ue(_e, se) {
      this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ue.prototype._tmp = function() {
      var se = new ae(null);
      return se.words = new Array(Math.ceil(this.n / 13)), se;
    }, Ue.prototype.ireduce = function(se) {
      var ce = se, de;
      do
        this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
      while (de > this.n);
      var pe = de < this.n ? -1 : ce.ucmp(this.p);
      return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
    }, Ue.prototype.split = function(se, ce) {
      se.iushrn(this.n, 0, ce);
    }, Ue.prototype.imulK = function(se) {
      return se.imul(this.k);
    };
    function ze() {
      Ue.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    fe(ze, Ue), ze.prototype.split = function(se, ce) {
      for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
        ce.words[ve] = se.words[ve];
      if (ce.length = pe, se.length <= 9) {
        se.words[0] = 0, se.length = 1;
        return;
      }
      var we = se.words[9];
      for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
        var Ee = se.words[ve] | 0;
        se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
      }
      we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
    }, ze.prototype.imulK = function(se) {
      se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = se.words[de] | 0;
        ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
      }
      return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
    };
    function Ve() {
      Ue.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    fe(Ve, Ue);
    function Mt() {
      Ue.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    fe(Mt, Ue);
    function Rt() {
      Ue.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    fe(Rt, Ue), Rt.prototype.imulK = function(se) {
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
        pe >>>= 26, se.words[de] = ve, ce = pe;
      }
      return ce !== 0 && (se.words[se.length++] = ce), se;
    }, ae._prime = function(se) {
      if (qe[se]) return qe[se];
      var ce;
      if (se === "k256")
        ce = new ze();
      else if (se === "p224")
        ce = new Ve();
      else if (se === "p192")
        ce = new Mt();
      else if (se === "p25519")
        ce = new Rt();
      else
        throw new Error("Unknown prime " + se);
      return qe[se] = ce, ce;
    };
    function je(_e) {
      if (typeof _e == "string") {
        var se = ae._prime(_e);
        this.m = se.p, this.prime = se;
      } else
        ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
    }
    je.prototype._verify1 = function(se) {
      ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
    }, je.prototype._verify2 = function(se, ce) {
      ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
        se.red && se.red === ce.red,
        "red works only with red numbers"
      );
    }, je.prototype.imod = function(se) {
      return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
    }, je.prototype.neg = function(se) {
      return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
    }, je.prototype.add = function(se, ce) {
      this._verify2(se, ce);
      var de = se.add(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
    }, je.prototype.iadd = function(se, ce) {
      this._verify2(se, ce);
      var de = se.iadd(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de;
    }, je.prototype.sub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.sub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
    }, je.prototype.isub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.isub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de;
    }, je.prototype.shl = function(se, ce) {
      return this._verify1(se), this.imod(se.ushln(ce));
    }, je.prototype.imul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.imul(ce));
    }, je.prototype.mul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.mul(ce));
    }, je.prototype.isqr = function(se) {
      return this.imul(se, se.clone());
    }, je.prototype.sqr = function(se) {
      return this.mul(se, se);
    }, je.prototype.sqrt = function(se) {
      if (se.isZero()) return se.clone();
      var ce = this.m.andln(3);
      if (ie(ce % 2 === 1), ce === 3) {
        var de = this.m.add(new ae(1)).iushrn(2);
        return this.pow(se, de);
      }
      for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
        ve++, pe.iushrn(1);
      ie(!pe.isZero());
      var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
      for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
        ue.redIAdd(Ee);
      for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
        for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
          Pe = Pe.redSqr();
        ie(Je < Fe);
        var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
        Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
      }
      return Be;
    }, je.prototype.invm = function(se) {
      var ce = se._invmp(this.m);
      return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
    }, je.prototype.pow = function(se, ce) {
      if (ce.isZero()) return new ae(1).toRed(this);
      if (ce.cmpn(1) === 0) return se.clone();
      var de = 4, pe = new Array(1 << de);
      pe[0] = new ae(1).toRed(this), pe[1] = se;
      for (var ve = 2; ve < pe.length; ve++)
        pe[ve] = this.mul(pe[ve - 1], se);
      var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
      for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
        for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
          var Ne = ge >> Be & 1;
          if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
            xe = 0;
            continue;
          }
          Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
        }
        ue = 26;
      }
      return we;
    }, je.prototype.convertTo = function(se) {
      var ce = se.umod(this.m);
      return ce === se ? ce.clone() : ce;
    }, je.prototype.convertFrom = function(se) {
      var ce = se.clone();
      return ce.red = null, ce;
    }, ae.mont = function(se) {
      return new jt(se);
    };
    function jt(_e) {
      je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    fe(jt, je), jt.prototype.convertTo = function(se) {
      return this.imod(se.ushln(this.shift));
    }, jt.prototype.convertFrom = function(se) {
      var ce = this.imod(se.mul(this.rinv));
      return ce.red = null, ce;
    }, jt.prototype.imul = function(se, ce) {
      if (se.isZero() || ce.isZero())
        return se.words[0] = 0, se.length = 1, se;
      var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.mul = function(se, ce) {
      if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
      var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.invm = function(se) {
      var ce = this.imod(se._invmp(this.m).mul(this.r2));
      return ce._forceRed(this);
    };
  })(c, commonjsGlobal);
})(bn$7);
var bnExports$1 = bn$7.exports, dist = {};
Object.defineProperty(dist, "__esModule", { value: !0 });
var bech32m = dist.bech32m = bech32 = dist.bech32 = void 0;
const ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", ALPHABET_MAP = {};
for (let c = 0; c < ALPHABET.length; c++) {
  const t = ALPHABET.charAt(c);
  ALPHABET_MAP[t] = c;
}
function polymodStep(c) {
  const t = c >> 25;
  return (c & 33554431) << 5 ^ -(t >> 0 & 1) & 996825010 ^ -(t >> 1 & 1) & 642813549 ^ -(t >> 2 & 1) & 513874426 ^ -(t >> 3 & 1) & 1027748829 ^ -(t >> 4 & 1) & 705979059;
}
function prefixChk(c) {
  let t = 1;
  for (let n = 0; n < c.length; ++n) {
    const ie = c.charCodeAt(n);
    if (ie < 33 || ie > 126)
      return "Invalid prefix (" + c + ")";
    t = polymodStep(t) ^ ie >> 5;
  }
  t = polymodStep(t);
  for (let n = 0; n < c.length; ++n) {
    const ie = c.charCodeAt(n);
    t = polymodStep(t) ^ ie & 31;
  }
  return t;
}
function convert(c, t, n, ie) {
  let fe = 0, ae = 0;
  const le = (1 << n) - 1, he = [];
  for (let me = 0; me < c.length; ++me)
    for (fe = fe << t | c[me], ae += t; ae >= n; )
      ae -= n, he.push(fe >> ae & le);
  if (ie)
    ae > 0 && he.push(fe << n - ae & le);
  else {
    if (ae >= t)
      return "Excess padding";
    if (fe << n - ae & le)
      return "Non-zero padding";
  }
  return he;
}
function toWords(c) {
  return convert(c, 8, 5, !0);
}
function fromWordsUnsafe(c) {
  const t = convert(c, 5, 8, !1);
  if (Array.isArray(t))
    return t;
}
function fromWords(c) {
  const t = convert(c, 5, 8, !1);
  if (Array.isArray(t))
    return t;
  throw new Error(t);
}
function getLibraryFromEncoding(c) {
  let t;
  c === "bech32" ? t = 1 : t = 734539939;
  function n(le, he, me) {
    if (me = me || 90, le.length + 7 + he.length > me)
      throw new TypeError("Exceeds length limit");
    le = le.toLowerCase();
    let ye = prefixChk(le);
    if (typeof ye == "string")
      throw new Error(ye);
    let be = le + "1";
    for (let Ae = 0; Ae < he.length; ++Ae) {
      const Se = he[Ae];
      if (Se >> 5)
        throw new Error("Non 5-bit word");
      ye = polymodStep(ye) ^ Se, be += ALPHABET.charAt(Se);
    }
    for (let Ae = 0; Ae < 6; ++Ae)
      ye = polymodStep(ye);
    ye ^= t;
    for (let Ae = 0; Ae < 6; ++Ae) {
      const Se = ye >> (5 - Ae) * 5 & 31;
      be += ALPHABET.charAt(Se);
    }
    return be;
  }
  function ie(le, he) {
    if (he = he || 90, le.length < 8)
      return le + " too short";
    if (le.length > he)
      return "Exceeds length limit";
    const me = le.toLowerCase(), ye = le.toUpperCase();
    if (le !== me && le !== ye)
      return "Mixed-case string " + le;
    le = me;
    const be = le.lastIndexOf("1");
    if (be === -1)
      return "No separator character for " + le;
    if (be === 0)
      return "Missing prefix for " + le;
    const Ae = le.slice(0, be), Se = le.slice(be + 1);
    if (Se.length < 6)
      return "Data too short";
    let $e = prefixChk(Ae);
    if (typeof $e == "string")
      return $e;
    const Re = [];
    for (let Me = 0; Me < Se.length; ++Me) {
      const ke = Se.charAt(Me), Te = ALPHABET_MAP[ke];
      if (Te === void 0)
        return "Unknown character " + ke;
      $e = polymodStep($e) ^ Te, !(Me + 6 >= Se.length) && Re.push(Te);
    }
    return $e !== t ? "Invalid checksum for " + le : { prefix: Ae, words: Re };
  }
  function fe(le, he) {
    const me = ie(le, he);
    if (typeof me == "object")
      return me;
  }
  function ae(le, he) {
    const me = ie(le, he);
    if (typeof me == "object")
      return me;
    throw new Error(me);
  }
  return {
    decodeUnsafe: fe,
    decode: ae,
    encode: n,
    toWords,
    fromWordsUnsafe,
    fromWords
  };
}
var bech32 = dist.bech32 = getLibraryFromEncoding("bech32");
bech32m = dist.bech32m = getLibraryFromEncoding("bech32m");
const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
function normalizeInput(c) {
  let t;
  if (c instanceof Uint8Array)
    t = c;
  else if (typeof c == "string")
    t = new TextEncoder().encode(c);
  else
    throw new Error(ERROR_MSG_INPUT);
  return t;
}
function toHex(c) {
  return Array.prototype.map.call(c, function(t) {
    return (t < 16 ? "0" : "") + t.toString(16);
  }).join("");
}
function uint32ToHex(c) {
  return (4294967296 + c).toString(16).substring(1);
}
function debugPrint(c, t, n) {
  let ie = `
` + c + " = ";
  for (let fe = 0; fe < t.length; fe += 2) {
    if (n === 32)
      ie += uint32ToHex(t[fe]).toUpperCase(), ie += " ", ie += uint32ToHex(t[fe + 1]).toUpperCase();
    else if (n === 64)
      ie += uint32ToHex(t[fe + 1]).toUpperCase(), ie += uint32ToHex(t[fe]).toUpperCase();
    else throw new Error("Invalid size " + n);
    fe % 6 === 4 ? ie += `
` + new Array(c.length + 4).join(" ") : fe < t.length - 2 && (ie += " ");
  }
  console.log(ie);
}
function testSpeed(c, t, n) {
  let ie = (/* @__PURE__ */ new Date()).getTime();
  const fe = new Uint8Array(t);
  for (let le = 0; le < t; le++)
    fe[le] = le % 256;
  const ae = (/* @__PURE__ */ new Date()).getTime();
  console.log("Generated random input in " + (ae - ie) + "ms"), ie = ae;
  for (let le = 0; le < n; le++) {
    const he = c(fe), me = (/* @__PURE__ */ new Date()).getTime(), ye = me - ie;
    ie = me, console.log("Hashed in " + ye + "ms: " + he.substring(0, 20) + "..."), console.log(
      Math.round(t / (1 << 20) / (ye / 1e3) * 100) / 100 + " MB PER SECOND"
    );
  }
}
var util$4 = {
  normalizeInput,
  toHex,
  debugPrint,
  testSpeed
};
const util$3 = util$4;
function ADD64AA(c, t, n) {
  const ie = c[t] + c[n];
  let fe = c[t + 1] + c[n + 1];
  ie >= 4294967296 && fe++, c[t] = ie, c[t + 1] = fe;
}
function ADD64AC(c, t, n, ie) {
  let fe = c[t] + n;
  n < 0 && (fe += 4294967296);
  let ae = c[t + 1] + ie;
  fe >= 4294967296 && ae++, c[t] = fe, c[t + 1] = ae;
}
function B2B_GET32(c, t) {
  return c[t] ^ c[t + 1] << 8 ^ c[t + 2] << 16 ^ c[t + 3] << 24;
}
function B2B_G(c, t, n, ie, fe, ae) {
  const le = m$3[fe], he = m$3[fe + 1], me = m$3[ae], ye = m$3[ae + 1];
  ADD64AA(v$3, c, t), ADD64AC(v$3, c, le, he);
  let be = v$3[ie] ^ v$3[c], Ae = v$3[ie + 1] ^ v$3[c + 1];
  v$3[ie] = Ae, v$3[ie + 1] = be, ADD64AA(v$3, n, ie), be = v$3[t] ^ v$3[n], Ae = v$3[t + 1] ^ v$3[n + 1], v$3[t] = be >>> 24 ^ Ae << 8, v$3[t + 1] = Ae >>> 24 ^ be << 8, ADD64AA(v$3, c, t), ADD64AC(v$3, c, me, ye), be = v$3[ie] ^ v$3[c], Ae = v$3[ie + 1] ^ v$3[c + 1], v$3[ie] = be >>> 16 ^ Ae << 16, v$3[ie + 1] = Ae >>> 16 ^ be << 16, ADD64AA(v$3, n, ie), be = v$3[t] ^ v$3[n], Ae = v$3[t + 1] ^ v$3[n + 1], v$3[t] = Ae >>> 31 ^ be << 1, v$3[t + 1] = be >>> 31 ^ Ae << 1;
}
const BLAKE2B_IV32 = new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), SIGMA8 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
], SIGMA82 = new Uint8Array(
  SIGMA8.map(function(c) {
    return c * 2;
  })
), v$3 = new Uint32Array(32), m$3 = new Uint32Array(32);
function blake2bCompress(c, t) {
  let n = 0;
  for (n = 0; n < 16; n++)
    v$3[n] = c.h[n], v$3[n + 16] = BLAKE2B_IV32[n];
  for (v$3[24] = v$3[24] ^ c.t, v$3[25] = v$3[25] ^ c.t / 4294967296, t && (v$3[28] = ~v$3[28], v$3[29] = ~v$3[29]), n = 0; n < 32; n++)
    m$3[n] = B2B_GET32(c.b, 4 * n);
  for (n = 0; n < 12; n++)
    B2B_G(0, 8, 16, 24, SIGMA82[n * 16 + 0], SIGMA82[n * 16 + 1]), B2B_G(2, 10, 18, 26, SIGMA82[n * 16 + 2], SIGMA82[n * 16 + 3]), B2B_G(4, 12, 20, 28, SIGMA82[n * 16 + 4], SIGMA82[n * 16 + 5]), B2B_G(6, 14, 22, 30, SIGMA82[n * 16 + 6], SIGMA82[n * 16 + 7]), B2B_G(0, 10, 20, 30, SIGMA82[n * 16 + 8], SIGMA82[n * 16 + 9]), B2B_G(2, 12, 22, 24, SIGMA82[n * 16 + 10], SIGMA82[n * 16 + 11]), B2B_G(4, 14, 16, 26, SIGMA82[n * 16 + 12], SIGMA82[n * 16 + 13]), B2B_G(6, 8, 18, 28, SIGMA82[n * 16 + 14], SIGMA82[n * 16 + 15]);
  for (n = 0; n < 16; n++)
    c.h[n] = c.h[n] ^ v$3[n] ^ v$3[n + 16];
}
const parameterBlock = new Uint8Array([
  0,
  0,
  0,
  0,
  //  0: outlen, keylen, fanout, depth
  0,
  0,
  0,
  0,
  //  4: leaf length, sequential mode
  0,
  0,
  0,
  0,
  //  8: node offset
  0,
  0,
  0,
  0,
  // 12: node offset
  0,
  0,
  0,
  0,
  // 16: node depth, inner length, rfu
  0,
  0,
  0,
  0,
  // 20: rfu
  0,
  0,
  0,
  0,
  // 24: rfu
  0,
  0,
  0,
  0,
  // 28: rfu
  0,
  0,
  0,
  0,
  // 32: salt
  0,
  0,
  0,
  0,
  // 36: salt
  0,
  0,
  0,
  0,
  // 40: salt
  0,
  0,
  0,
  0,
  // 44: salt
  0,
  0,
  0,
  0,
  // 48: personal
  0,
  0,
  0,
  0,
  // 52: personal
  0,
  0,
  0,
  0,
  // 56: personal
  0,
  0,
  0,
  0
  // 60: personal
]);
function blake2bInit(c, t, n, ie) {
  if (c === 0 || c > 64)
    throw new Error("Illegal output length, expected 0 < length <= 64");
  if (t && t.length > 64)
    throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
  if (n && n.length !== 16)
    throw new Error("Illegal salt, expected Uint8Array with length is 16");
  if (ie && ie.length !== 16)
    throw new Error("Illegal personal, expected Uint8Array with length is 16");
  const fe = {
    b: new Uint8Array(128),
    h: new Uint32Array(16),
    t: 0,
    // input count
    c: 0,
    // pointer within buffer
    outlen: c
    // output length in bytes
  };
  parameterBlock.fill(0), parameterBlock[0] = c, t && (parameterBlock[1] = t.length), parameterBlock[2] = 1, parameterBlock[3] = 1, n && parameterBlock.set(n, 32), ie && parameterBlock.set(ie, 48);
  for (let ae = 0; ae < 16; ae++)
    fe.h[ae] = BLAKE2B_IV32[ae] ^ B2B_GET32(parameterBlock, ae * 4);
  return t && (blake2bUpdate(fe, t), fe.c = 128), fe;
}
function blake2bUpdate(c, t) {
  for (let n = 0; n < t.length; n++)
    c.c === 128 && (c.t += c.c, blake2bCompress(c, !1), c.c = 0), c.b[c.c++] = t[n];
}
function blake2bFinal(c) {
  for (c.t += c.c; c.c < 128; )
    c.b[c.c++] = 0;
  blake2bCompress(c, !0);
  const t = new Uint8Array(c.outlen);
  for (let n = 0; n < c.outlen; n++)
    t[n] = c.h[n >> 2] >> 8 * (n & 3);
  return t;
}
function blake2b(c, t, n, ie, fe) {
  n = n || 64, c = util$3.normalizeInput(c), ie && (ie = util$3.normalizeInput(ie)), fe && (fe = util$3.normalizeInput(fe));
  const ae = blake2bInit(n, t, ie, fe);
  return blake2bUpdate(ae, c), blake2bFinal(ae);
}
function blake2bHex(c, t, n, ie, fe) {
  const ae = blake2b(c, t, n, ie, fe);
  return util$3.toHex(ae);
}
var blake2b_1 = {
  blake2b,
  blake2bHex,
  blake2bInit,
  blake2bUpdate,
  blake2bFinal
};
const util$2 = util$4;
function B2S_GET32(c, t) {
  return c[t] ^ c[t + 1] << 8 ^ c[t + 2] << 16 ^ c[t + 3] << 24;
}
function B2S_G(c, t, n, ie, fe, ae) {
  v$2[c] = v$2[c] + v$2[t] + fe, v$2[ie] = ROTR32(v$2[ie] ^ v$2[c], 16), v$2[n] = v$2[n] + v$2[ie], v$2[t] = ROTR32(v$2[t] ^ v$2[n], 12), v$2[c] = v$2[c] + v$2[t] + ae, v$2[ie] = ROTR32(v$2[ie] ^ v$2[c], 8), v$2[n] = v$2[n] + v$2[ie], v$2[t] = ROTR32(v$2[t] ^ v$2[n], 7);
}
function ROTR32(c, t) {
  return c >>> t ^ c << 32 - t;
}
const BLAKE2S_IV = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SIGMA = new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0
]), v$2 = new Uint32Array(16), m$2 = new Uint32Array(16);
function blake2sCompress(c, t) {
  let n = 0;
  for (n = 0; n < 8; n++)
    v$2[n] = c.h[n], v$2[n + 8] = BLAKE2S_IV[n];
  for (v$2[12] ^= c.t, v$2[13] ^= c.t / 4294967296, t && (v$2[14] = ~v$2[14]), n = 0; n < 16; n++)
    m$2[n] = B2S_GET32(c.b, 4 * n);
  for (n = 0; n < 10; n++)
    B2S_G(0, 4, 8, 12, m$2[SIGMA[n * 16 + 0]], m$2[SIGMA[n * 16 + 1]]), B2S_G(1, 5, 9, 13, m$2[SIGMA[n * 16 + 2]], m$2[SIGMA[n * 16 + 3]]), B2S_G(2, 6, 10, 14, m$2[SIGMA[n * 16 + 4]], m$2[SIGMA[n * 16 + 5]]), B2S_G(3, 7, 11, 15, m$2[SIGMA[n * 16 + 6]], m$2[SIGMA[n * 16 + 7]]), B2S_G(0, 5, 10, 15, m$2[SIGMA[n * 16 + 8]], m$2[SIGMA[n * 16 + 9]]), B2S_G(1, 6, 11, 12, m$2[SIGMA[n * 16 + 10]], m$2[SIGMA[n * 16 + 11]]), B2S_G(2, 7, 8, 13, m$2[SIGMA[n * 16 + 12]], m$2[SIGMA[n * 16 + 13]]), B2S_G(3, 4, 9, 14, m$2[SIGMA[n * 16 + 14]], m$2[SIGMA[n * 16 + 15]]);
  for (n = 0; n < 8; n++)
    c.h[n] ^= v$2[n] ^ v$2[n + 8];
}
function blake2sInit(c, t) {
  if (!(c > 0 && c <= 32))
    throw new Error("Incorrect output length, should be in [1, 32]");
  const n = t ? t.length : 0;
  if (t && !(n > 0 && n <= 32))
    throw new Error("Incorrect key length, should be in [1, 32]");
  const ie = {
    h: new Uint32Array(BLAKE2S_IV),
    // hash state
    b: new Uint8Array(64),
    // input block
    c: 0,
    // pointer within block
    t: 0,
    // input count
    outlen: c
    // output length in bytes
  };
  return ie.h[0] ^= 16842752 ^ n << 8 ^ c, n > 0 && (blake2sUpdate(ie, t), ie.c = 64), ie;
}
function blake2sUpdate(c, t) {
  for (let n = 0; n < t.length; n++)
    c.c === 64 && (c.t += c.c, blake2sCompress(c, !1), c.c = 0), c.b[c.c++] = t[n];
}
function blake2sFinal(c) {
  for (c.t += c.c; c.c < 64; )
    c.b[c.c++] = 0;
  blake2sCompress(c, !0);
  const t = new Uint8Array(c.outlen);
  for (let n = 0; n < c.outlen; n++)
    t[n] = c.h[n >> 2] >> 8 * (n & 3) & 255;
  return t;
}
function blake2s(c, t, n) {
  n = n || 32, c = util$2.normalizeInput(c);
  const ie = blake2sInit(n, t);
  return blake2sUpdate(ie, c), blake2sFinal(ie);
}
function blake2sHex(c, t, n) {
  const ie = blake2s(c, t, n);
  return util$2.toHex(ie);
}
var blake2s_1 = {
  blake2s,
  blake2sHex,
  blake2sInit,
  blake2sUpdate,
  blake2sFinal
};
const b2b = blake2b_1, b2s = blake2s_1;
var blakejs = {
  blake2b: b2b.blake2b,
  blake2bHex: b2b.blake2bHex,
  blake2bInit: b2b.blake2bInit,
  blake2bUpdate: b2b.blake2bUpdate,
  blake2bFinal: b2b.blake2bFinal,
  blake2s: b2s.blake2s,
  blake2sHex: b2s.blake2sHex,
  blake2sInit: b2s.blake2sInit,
  blake2sUpdate: b2s.blake2sUpdate,
  blake2sFinal: b2s.blake2sFinal
}, sha3$1 = {}, sponge = {}, permute = {}, chi = {}, copy = function(t, n) {
  return function(ie, fe) {
    var ae = fe * 2, le = n * 2;
    ie[ae] = t[le], ie[ae + 1] = t[le + 1];
  };
}, copy_1 = copy;
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = n(copy_1);
  function n(ae) {
    return ae && ae.__esModule ? ae : { default: ae };
  }
  var ie = function(le) {
    for (var he = le.A, me = le.C, ye = 0; ye < 25; ye += 5) {
      for (var be = 0; be < 5; be++)
        (0, t.default)(he, ye + be)(me, be);
      for (var Ae = 0; Ae < 5; Ae++) {
        var Se = (ye + Ae) * 2, $e = (Ae + 1) % 5 * 2, Re = (Ae + 2) % 5 * 2;
        he[Se] ^= ~me[$e] & me[Re], he[Se + 1] ^= ~me[$e + 1] & me[Re + 1];
      }
    }
  }, fe = ie;
  c.default = fe;
})(chi);
var iota = {}, roundConstants = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = new Uint32Array([0, 1, 0, 32898, 2147483648, 32906, 2147483648, 2147516416, 0, 32907, 0, 2147483649, 2147483648, 2147516545, 2147483648, 32777, 0, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 2147483648, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 0, 32778, 2147483648, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 0, 2147483649, 2147483648, 2147516424]), n = t;
  c.default = n;
})(roundConstants);
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = n(roundConstants);
  function n(ae) {
    return ae && ae.__esModule ? ae : { default: ae };
  }
  var ie = function(le) {
    var he = le.A, me = le.roundIndex, ye = me * 2;
    he[0] ^= t.default[ye], he[1] ^= t.default[ye + 1];
  }, fe = ie;
  c.default = fe;
})(iota);
var rhoPi = {}, piShuffles = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = [10, 7, 11, 17, 18, 3, 5, 16, 8, 21, 24, 4, 15, 23, 19, 13, 12, 2, 20, 14, 22, 9, 6, 1], n = t;
  c.default = n;
})(piShuffles);
var rhoOffsets = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = [1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 2, 14, 27, 41, 56, 8, 25, 43, 62, 18, 39, 61, 20, 44], n = t;
  c.default = n;
})(rhoOffsets);
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = fe(piShuffles), n = fe(rhoOffsets), ie = fe(copy_1);
  function fe(he) {
    return he && he.__esModule ? he : { default: he };
  }
  var ae = function(me) {
    var ye = me.A, be = me.C, Ae = me.W;
    (0, ie.default)(ye, 1)(Ae, 0);
    for (var Se = 0, $e = 0, Re = 0, Me = 32, ke = 0; ke < 24; ke++) {
      var Te = t.default[ke], Ie = n.default[ke];
      (0, ie.default)(ye, Te)(be, 0), Se = Ae[0], $e = Ae[1], Me = 32 - Ie, Re = Ie < 32 ? 0 : 1, Ae[Re] = Se << Ie | $e >>> Me, Ae[(Re + 1) % 2] = $e << Ie | Se >>> Me, (0, ie.default)(Ae, 0)(ye, Te), (0, ie.default)(be, 0)(Ae, 0);
    }
  }, le = ae;
  c.default = le;
})(rhoPi);
var theta = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = n(copy_1);
  function n(ae) {
    return ae && ae.__esModule ? ae : { default: ae };
  }
  var ie = function(le) {
    for (var he = le.A, me = le.C, ye = le.D, be = le.W, Ae = 0, Se = 0, $e = 0; $e < 5; $e++) {
      var Re = $e * 2, Me = ($e + 5) * 2, ke = ($e + 10) * 2, Te = ($e + 15) * 2, Ie = ($e + 20) * 2;
      me[Re] = he[Re] ^ he[Me] ^ he[ke] ^ he[Te] ^ he[Ie], me[Re + 1] = he[Re + 1] ^ he[Me + 1] ^ he[ke + 1] ^ he[Te + 1] ^ he[Ie + 1];
    }
    for (var qe = 0; qe < 5; qe++) {
      (0, t.default)(me, (qe + 1) % 5)(be, 0), Ae = be[0], Se = be[1], be[0] = Ae << 1 | Se >>> 31, be[1] = Se << 1 | Ae >>> 31, ye[qe * 2] = me[(qe + 4) % 5 * 2] ^ be[0], ye[qe * 2 + 1] = me[(qe + 4) % 5 * 2 + 1] ^ be[1];
      for (var Ue = 0; Ue < 25; Ue += 5)
        he[(Ue + qe) * 2] ^= ye[qe * 2], he[(Ue + qe) * 2 + 1] ^= ye[qe * 2 + 1];
    }
  }, fe = ie;
  c.default = fe;
})(theta);
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = ae(chi), n = ae(iota), ie = ae(rhoPi), fe = ae(theta);
  function ae(me) {
    return me && me.__esModule ? me : { default: me };
  }
  var le = function() {
    var ye = new Uint32Array(10), be = new Uint32Array(10), Ae = new Uint32Array(2);
    return function(Se) {
      for (var $e = 0; $e < 24; $e++)
        (0, fe.default)({ A: Se, C: ye, D: be, W: Ae }), (0, ie.default)({ A: Se, C: ye, W: Ae }), (0, t.default)({ A: Se, C: ye }), (0, n.default)({ A: Se, roundIndex: $e });
      ye.fill(0), be.fill(0), Ae.fill(0);
    };
  }, he = le;
  c.default = he;
})(permute);
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = void 0;
  var t = require$$0$5, n = ie(permute);
  function ie(me) {
    return me && me.__esModule ? me : { default: me };
  }
  var fe = function(ye, be) {
    for (var Ae = 0; Ae < ye.length; Ae += 8) {
      var Se = Ae / 4;
      be[Se] ^= ye[Ae + 7] << 24 | ye[Ae + 6] << 16 | ye[Ae + 5] << 8 | ye[Ae + 4], be[Se + 1] ^= ye[Ae + 3] << 24 | ye[Ae + 2] << 16 | ye[Ae + 1] << 8 | ye[Ae];
    }
    return be;
  }, ae = function(ye, be) {
    for (var Ae = 0; Ae < be.length; Ae += 8) {
      var Se = Ae / 4;
      be[Ae] = ye[Se + 1], be[Ae + 1] = ye[Se + 1] >>> 8, be[Ae + 2] = ye[Se + 1] >>> 16, be[Ae + 3] = ye[Se + 1] >>> 24, be[Ae + 4] = ye[Se], be[Ae + 5] = ye[Se] >>> 8, be[Ae + 6] = ye[Se] >>> 16, be[Ae + 7] = ye[Se] >>> 24;
    }
    return be;
  }, le = function(ye) {
    var be = this, Ae = ye.capacity, Se = ye.padding, $e = (0, n.default)(), Re = 200, Me = Ae / 8, ke = Re - Ae / 4, Te = 0, Ie = new Uint32Array(Re / 4), qe = t.Buffer.allocUnsafe(ke);
    return this.absorb = function(Ue) {
      for (var ze = 0; ze < Ue.length; ze++)
        qe[Te] = Ue[ze], Te += 1, Te >= ke && (fe(qe, Ie), $e(Ie), Te = 0);
      return be;
    }, this.squeeze = function() {
      var Ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ze = { buffer: Ue.buffer || t.Buffer.allocUnsafe(Me), padding: Ue.padding || Se, queue: t.Buffer.allocUnsafe(qe.length), state: new Uint32Array(Ie.length) };
      qe.copy(ze.queue);
      for (var Ve = 0; Ve < Ie.length; Ve++)
        ze.state[Ve] = Ie[Ve];
      ze.queue.fill(0, Te), ze.queue[Te] |= ze.padding, ze.queue[ke - 1] |= 128, fe(ze.queue, ze.state);
      for (var Mt = 0; Mt < ze.buffer.length; Mt += ke)
        $e(ze.state), ae(ze.state, ze.buffer.slice(Mt, Mt + ke));
      return ze.buffer;
    }, this.reset = function() {
      return qe.fill(0), Ie.fill(0), Te = 0, be;
    }, this;
  }, he = le;
  c.default = he;
})(sponge);
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = c.SHAKE = c.SHA3Hash = c.SHA3 = c.Keccak = void 0;
  var t = require$$0$5, n = ie(sponge);
  function ie(be) {
    return be && be.__esModule ? be : { default: be };
  }
  var fe = function(Ae) {
    var Se = Ae.allowedSizes, $e = Ae.defaultSize, Re = Ae.padding;
    return function Me() {
      var ke = this, Te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $e;
      if (!this || this.constructor !== Me)
        return new Me(Te);
      if (Se && !Se.includes(Te))
        throw new Error("Unsupported hash length");
      var Ie = new n.default({ capacity: Te });
      return this.update = function(qe) {
        var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
        if (t.Buffer.isBuffer(qe))
          return Ie.absorb(qe), ke;
        if (typeof qe == "string")
          return ke.update(t.Buffer.from(qe, Ue));
        throw new TypeError("Not a string or buffer");
      }, this.digest = function() {
        var qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "binary", Ue = typeof qe == "string" ? { format: qe } : qe, ze = Ie.squeeze({ buffer: Ue.buffer, padding: Ue.padding || Re });
        return Ue.format && Ue.format !== "binary" ? ze.toString(Ue.format) : ze;
      }, this.reset = function() {
        return Ie.reset(), ke;
      }, this;
    };
  }, ae = fe({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 1 });
  c.Keccak = ae;
  var le = fe({ allowedSizes: [224, 256, 384, 512], defaultSize: 512, padding: 6 });
  c.SHA3 = le;
  var he = fe({ allowedSizes: [128, 256], defaultSize: 256, padding: 31 });
  c.SHAKE = he;
  var me = ae;
  c.SHA3Hash = me, le.SHA3Hash = me;
  var ye = le;
  c.default = ye;
})(sha3$1);
var BigInteger = { exports: {} };
(function(c) {
  var t = function(n) {
    var ie = 1e7, fe = 7, ae = 9007199254740992, le = Se(ae), he = Math.log(ae);
    function me(Qe, Dt) {
      return typeof Qe > "u" ? me[0] : typeof Dt < "u" ? +Dt == 10 ? Xt(Qe) : Ht(Qe, Dt) : Xt(Qe);
    }
    function ye(Qe, Dt) {
      this.value = Qe, this.sign = Dt, this.isSmall = !1;
    }
    ye.prototype = Object.create(me.prototype);
    function be(Qe) {
      this.value = Qe, this.sign = Qe < 0, this.isSmall = !0;
    }
    be.prototype = Object.create(me.prototype);
    function Ae(Qe) {
      return -ae < Qe && Qe < ae;
    }
    function Se(Qe) {
      return Qe < 1e7 ? [Qe] : Qe < 1e14 ? [Qe % 1e7, Math.floor(Qe / 1e7)] : [Qe % 1e7, Math.floor(Qe / 1e7) % 1e7, Math.floor(Qe / 1e14)];
    }
    function $e(Qe) {
      Re(Qe);
      var Dt = Qe.length;
      if (Dt < 4 && Ee(Qe, le) < 0)
        switch (Dt) {
          case 0:
            return 0;
          case 1:
            return Qe[0];
          case 2:
            return Qe[0] + Qe[1] * ie;
          default:
            return Qe[0] + (Qe[1] + Qe[2] * ie) * ie;
        }
      return Qe;
    }
    function Re(Qe) {
      for (var Dt = Qe.length; Qe[--Dt] === 0; ) ;
      Qe.length = Dt + 1;
    }
    function Me(Qe) {
      for (var Dt = new Array(Qe), en = -1; ++en < Qe; )
        Dt[en] = 0;
      return Dt;
    }
    function ke(Qe) {
      return Qe > 0 ? Math.floor(Qe) : Math.ceil(Qe);
    }
    function Te(Qe, Dt) {
      var en = Qe.length, We = Dt.length, De = new Array(en), Ge = 0, Oe = ie, Ce, He;
      for (He = 0; He < We; He++)
        Ce = Qe[He] + Dt[He] + Ge, Ge = Ce >= Oe ? 1 : 0, De[He] = Ce - Ge * Oe;
      for (; He < en; )
        Ce = Qe[He] + Ge, Ge = Ce === Oe ? 1 : 0, De[He++] = Ce - Ge * Oe;
      return Ge > 0 && De.push(Ge), De;
    }
    function Ie(Qe, Dt) {
      return Qe.length >= Dt.length ? Te(Qe, Dt) : Te(Dt, Qe);
    }
    function qe(Qe, Dt) {
      var en = Qe.length, We = new Array(en), De = ie, Ge, Oe;
      for (Oe = 0; Oe < en; Oe++)
        Ge = Qe[Oe] - De + Dt, Dt = Math.floor(Ge / De), We[Oe] = Ge - Dt * De, Dt += 1;
      for (; Dt > 0; )
        We[Oe++] = Dt % De, Dt = Math.floor(Dt / De);
      return We;
    }
    ye.prototype.add = function(Qe) {
      var Dt = Xt(Qe);
      if (this.sign !== Dt.sign)
        return this.subtract(Dt.negate());
      var en = this.value, We = Dt.value;
      return Dt.isSmall ? new ye(qe(en, Math.abs(We)), this.sign) : new ye(Ie(en, We), this.sign);
    }, ye.prototype.plus = ye.prototype.add, be.prototype.add = function(Qe) {
      var Dt = Xt(Qe), en = this.value;
      if (en < 0 !== Dt.sign)
        return this.subtract(Dt.negate());
      var We = Dt.value;
      if (Dt.isSmall) {
        if (Ae(en + We)) return new be(en + We);
        We = Se(Math.abs(We));
      }
      return new ye(qe(We, Math.abs(en)), en < 0);
    }, be.prototype.plus = be.prototype.add;
    function Ue(Qe, Dt) {
      var en = Qe.length, We = Dt.length, De = new Array(en), Ge = 0, Oe = ie, Ce, He;
      for (Ce = 0; Ce < We; Ce++)
        He = Qe[Ce] - Ge - Dt[Ce], He < 0 ? (He += Oe, Ge = 1) : Ge = 0, De[Ce] = He;
      for (Ce = We; Ce < en; Ce++) {
        if (He = Qe[Ce] - Ge, He < 0) He += Oe;
        else {
          De[Ce++] = He;
          break;
        }
        De[Ce] = He;
      }
      for (; Ce < en; Ce++)
        De[Ce] = Qe[Ce];
      return Re(De), De;
    }
    function ze(Qe, Dt, en) {
      var We;
      return Ee(Qe, Dt) >= 0 ? We = Ue(Qe, Dt) : (We = Ue(Dt, Qe), en = !en), We = $e(We), typeof We == "number" ? (en && (We = -We), new be(We)) : new ye(We, en);
    }
    function Ve(Qe, Dt, en) {
      var We = Qe.length, De = new Array(We), Ge = -Dt, Oe = ie, Ce, He;
      for (Ce = 0; Ce < We; Ce++)
        He = Qe[Ce] + Ge, Ge = Math.floor(He / Oe), He %= Oe, De[Ce] = He < 0 ? He + Oe : He;
      return De = $e(De), typeof De == "number" ? (en && (De = -De), new be(De)) : new ye(De, en);
    }
    ye.prototype.subtract = function(Qe) {
      var Dt = Xt(Qe);
      if (this.sign !== Dt.sign)
        return this.add(Dt.negate());
      var en = this.value, We = Dt.value;
      return Dt.isSmall ? Ve(en, Math.abs(We), this.sign) : ze(en, We, this.sign);
    }, ye.prototype.minus = ye.prototype.subtract, be.prototype.subtract = function(Qe) {
      var Dt = Xt(Qe), en = this.value;
      if (en < 0 !== Dt.sign)
        return this.add(Dt.negate());
      var We = Dt.value;
      return Dt.isSmall ? new be(en - We) : Ve(We, Math.abs(en), en >= 0);
    }, be.prototype.minus = be.prototype.subtract, ye.prototype.negate = function() {
      return new ye(this.value, !this.sign);
    }, be.prototype.negate = function() {
      var Qe = this.sign, Dt = new be(-this.value);
      return Dt.sign = !Qe, Dt;
    }, ye.prototype.abs = function() {
      return new ye(this.value, !1);
    }, be.prototype.abs = function() {
      return new be(Math.abs(this.value));
    };
    function Mt(Qe, Dt) {
      var en = Qe.length, We = Dt.length, De = en + We, Ge = Me(De), Oe = ie, Ce, He, Xe, Kt, tn;
      for (Xe = 0; Xe < en; ++Xe) {
        Kt = Qe[Xe];
        for (var Wt = 0; Wt < We; ++Wt)
          tn = Dt[Wt], Ce = Kt * tn + Ge[Xe + Wt], He = Math.floor(Ce / Oe), Ge[Xe + Wt] = Ce - He * Oe, Ge[Xe + Wt + 1] += He;
      }
      return Re(Ge), Ge;
    }
    function Rt(Qe, Dt) {
      var en = Qe.length, We = new Array(en), De = ie, Ge = 0, Oe, Ce;
      for (Ce = 0; Ce < en; Ce++)
        Oe = Qe[Ce] * Dt + Ge, Ge = Math.floor(Oe / De), We[Ce] = Oe - Ge * De;
      for (; Ge > 0; )
        We[Ce++] = Ge % De, Ge = Math.floor(Ge / De);
      return We;
    }
    function je(Qe, Dt) {
      for (var en = []; Dt-- > 0; ) en.push(0);
      return en.concat(Qe);
    }
    function jt(Qe, Dt) {
      var en = Math.max(Qe.length, Dt.length);
      if (en <= 30) return Mt(Qe, Dt);
      en = Math.ceil(en / 2);
      var We = Qe.slice(en), De = Qe.slice(0, en), Ge = Dt.slice(en), Oe = Dt.slice(0, en), Ce = jt(De, Oe), He = jt(We, Ge), Xe = jt(Ie(De, We), Ie(Oe, Ge)), Kt = Ie(Ie(Ce, je(Ue(Ue(Xe, Ce), He), en)), je(He, 2 * en));
      return Re(Kt), Kt;
    }
    function _e(Qe, Dt) {
      return -0.012 * Qe - 0.012 * Dt + 15e-6 * Qe * Dt > 0;
    }
    ye.prototype.multiply = function(Qe) {
      var Dt = Xt(Qe), en = this.value, We = Dt.value, De = this.sign !== Dt.sign, Ge;
      if (Dt.isSmall) {
        if (We === 0) return me[0];
        if (We === 1) return this;
        if (We === -1) return this.negate();
        if (Ge = Math.abs(We), Ge < ie)
          return new ye(Rt(en, Ge), De);
        We = Se(Ge);
      }
      return _e(en.length, We.length) ? new ye(jt(en, We), De) : new ye(Mt(en, We), De);
    }, ye.prototype.times = ye.prototype.multiply;
    function se(Qe, Dt, en) {
      return Qe < ie ? new ye(Rt(Dt, Qe), en) : new ye(Mt(Dt, Se(Qe)), en);
    }
    be.prototype._multiplyBySmall = function(Qe) {
      return Ae(Qe.value * this.value) ? new be(Qe.value * this.value) : se(Math.abs(Qe.value), Se(Math.abs(this.value)), this.sign !== Qe.sign);
    }, ye.prototype._multiplyBySmall = function(Qe) {
      return Qe.value === 0 ? me[0] : Qe.value === 1 ? this : Qe.value === -1 ? this.negate() : se(Math.abs(Qe.value), this.value, this.sign !== Qe.sign);
    }, be.prototype.multiply = function(Qe) {
      return Xt(Qe)._multiplyBySmall(this);
    }, be.prototype.times = be.prototype.multiply;
    function ce(Qe) {
      var Dt = Qe.length, en = Me(Dt + Dt), We = ie, De, Ge, Oe, Ce, He;
      for (Oe = 0; Oe < Dt; Oe++) {
        Ce = Qe[Oe], Ge = 0 - Ce * Ce;
        for (var Xe = Oe; Xe < Dt; Xe++)
          He = Qe[Xe], De = 2 * (Ce * He) + en[Oe + Xe] + Ge, Ge = Math.floor(De / We), en[Oe + Xe] = De - Ge * We;
        en[Oe + Dt] = Ge;
      }
      return Re(en), en;
    }
    ye.prototype.square = function() {
      return new ye(ce(this.value), !1);
    }, be.prototype.square = function() {
      var Qe = this.value * this.value;
      return Ae(Qe) ? new be(Qe) : new ye(ce(Se(Math.abs(this.value))), !1);
    };
    function de(Qe, Dt) {
      var en = Qe.length, We = Dt.length, De = ie, Ge = Me(Dt.length), Oe = Dt[We - 1], Ce = Math.ceil(De / (2 * Oe)), He = Rt(Qe, Ce), Xe = Rt(Dt, Ce), Kt, tn, Wt, Yt, _n, rn, nn;
      for (He.length <= en && He.push(0), Xe.push(0), Oe = Xe[We - 1], tn = en - We; tn >= 0; tn--) {
        for (Kt = De - 1, He[tn + We] !== Oe && (Kt = Math.floor((He[tn + We] * De + He[tn + We - 1]) / Oe)), Wt = 0, Yt = 0, rn = Xe.length, _n = 0; _n < rn; _n++)
          Wt += Kt * Xe[_n], nn = Math.floor(Wt / De), Yt += He[tn + _n] - (Wt - nn * De), Wt = nn, Yt < 0 ? (He[tn + _n] = Yt + De, Yt = -1) : (He[tn + _n] = Yt, Yt = 0);
        for (; Yt !== 0; ) {
          for (Kt -= 1, Wt = 0, _n = 0; _n < rn; _n++)
            Wt += He[tn + _n] - De + Xe[_n], Wt < 0 ? (He[tn + _n] = Wt + De, Wt = 0) : (He[tn + _n] = Wt, Wt = 1);
          Yt += Wt;
        }
        Ge[tn] = Kt;
      }
      return He = ve(He, Ce)[0], [$e(Ge), $e(He)];
    }
    function pe(Qe, Dt) {
      for (var en = Qe.length, We = Dt.length, De = [], Ge = [], Oe = ie, Ce, He, Xe, Kt, tn; en; ) {
        if (Ge.unshift(Qe[--en]), Re(Ge), Ee(Ge, Dt) < 0) {
          De.push(0);
          continue;
        }
        He = Ge.length, Xe = Ge[He - 1] * Oe + Ge[He - 2], Kt = Dt[We - 1] * Oe + Dt[We - 2], He > We && (Xe = (Xe + 1) * Oe), Ce = Math.ceil(Xe / Kt);
        do {
          if (tn = Rt(Dt, Ce), Ee(tn, Ge) <= 0) break;
          Ce--;
        } while (Ce);
        De.push(Ce), Ge = Ue(Ge, tn);
      }
      return De.reverse(), [$e(De), $e(Ge)];
    }
    function ve(Qe, Dt) {
      var en = Qe.length, We = Me(en), De = ie, Ge, Oe, Ce, He;
      for (Ce = 0, Ge = en - 1; Ge >= 0; --Ge)
        He = Ce * De + Qe[Ge], Oe = ke(He / Dt), Ce = He - Oe * Dt, We[Ge] = Oe | 0;
      return [We, Ce | 0];
    }
    function we(Qe, Dt) {
      var en, We = Xt(Dt), De = Qe.value, Ge = We.value, Oe;
      if (Ge === 0) throw new Error("Cannot divide by zero");
      if (Qe.isSmall)
        return We.isSmall ? [new be(ke(De / Ge)), new be(De % Ge)] : [me[0], Qe];
      if (We.isSmall) {
        if (Ge === 1) return [Qe, me[0]];
        if (Ge == -1) return [Qe.negate(), me[0]];
        var Ce = Math.abs(Ge);
        if (Ce < ie) {
          en = ve(De, Ce), Oe = $e(en[0]);
          var He = en[1];
          return Qe.sign && (He = -He), typeof Oe == "number" ? (Qe.sign !== We.sign && (Oe = -Oe), [new be(Oe), new be(He)]) : [new ye(Oe, Qe.sign !== We.sign), new be(He)];
        }
        Ge = Se(Ce);
      }
      var Xe = Ee(De, Ge);
      if (Xe === -1) return [me[0], Qe];
      if (Xe === 0) return [me[Qe.sign === We.sign ? 1 : -1], me[0]];
      De.length + Ge.length <= 200 ? en = de(De, Ge) : en = pe(De, Ge), Oe = en[0];
      var Kt = Qe.sign !== We.sign, tn = en[1], Wt = Qe.sign;
      return typeof Oe == "number" ? (Kt && (Oe = -Oe), Oe = new be(Oe)) : Oe = new ye(Oe, Kt), typeof tn == "number" ? (Wt && (tn = -tn), tn = new be(tn)) : tn = new ye(tn, Wt), [Oe, tn];
    }
    ye.prototype.divmod = function(Qe) {
      var Dt = we(this, Qe);
      return {
        quotient: Dt[0],
        remainder: Dt[1]
      };
    }, be.prototype.divmod = ye.prototype.divmod, ye.prototype.divide = function(Qe) {
      return we(this, Qe)[0];
    }, be.prototype.over = be.prototype.divide = ye.prototype.over = ye.prototype.divide, ye.prototype.mod = function(Qe) {
      return we(this, Qe)[1];
    }, be.prototype.remainder = be.prototype.mod = ye.prototype.remainder = ye.prototype.mod, ye.prototype.pow = function(Qe) {
      var Dt = Xt(Qe), en = this.value, We = Dt.value, De, Ge, Oe;
      if (We === 0) return me[1];
      if (en === 0) return me[0];
      if (en === 1) return me[1];
      if (en === -1) return Dt.isEven() ? me[1] : me[-1];
      if (Dt.sign)
        return me[0];
      if (!Dt.isSmall) throw new Error("The exponent " + Dt.toString() + " is too large.");
      if (this.isSmall && Ae(De = Math.pow(en, We)))
        return new be(ke(De));
      for (Ge = this, Oe = me[1]; We & !0 && (Oe = Oe.times(Ge), --We), We !== 0; )
        We /= 2, Ge = Ge.square();
      return Oe;
    }, be.prototype.pow = ye.prototype.pow, ye.prototype.modPow = function(Qe, Dt) {
      if (Qe = Xt(Qe), Dt = Xt(Dt), Dt.isZero()) throw new Error("Cannot take modPow with modulus 0");
      for (var en = me[1], We = this.mod(Dt); Qe.isPositive(); ) {
        if (We.isZero()) return me[0];
        Qe.isOdd() && (en = en.multiply(We).mod(Dt)), Qe = Qe.divide(2), We = We.square().mod(Dt);
      }
      return en;
    }, be.prototype.modPow = ye.prototype.modPow;
    function Ee(Qe, Dt) {
      if (Qe.length !== Dt.length)
        return Qe.length > Dt.length ? 1 : -1;
      for (var en = Qe.length - 1; en >= 0; en--)
        if (Qe[en] !== Dt[en]) return Qe[en] > Dt[en] ? 1 : -1;
      return 0;
    }
    ye.prototype.compareAbs = function(Qe) {
      var Dt = Xt(Qe), en = this.value, We = Dt.value;
      return Dt.isSmall ? 1 : Ee(en, We);
    }, be.prototype.compareAbs = function(Qe) {
      var Dt = Xt(Qe), en = Math.abs(this.value), We = Dt.value;
      return Dt.isSmall ? (We = Math.abs(We), en === We ? 0 : en > We ? 1 : -1) : -1;
    }, ye.prototype.compare = function(Qe) {
      if (Qe === 1 / 0)
        return -1;
      if (Qe === -1 / 0)
        return 1;
      var Dt = Xt(Qe), en = this.value, We = Dt.value;
      return this.sign !== Dt.sign ? Dt.sign ? 1 : -1 : Dt.isSmall ? this.sign ? -1 : 1 : Ee(en, We) * (this.sign ? -1 : 1);
    }, ye.prototype.compareTo = ye.prototype.compare, be.prototype.compare = function(Qe) {
      if (Qe === 1 / 0)
        return -1;
      if (Qe === -1 / 0)
        return 1;
      var Dt = Xt(Qe), en = this.value, We = Dt.value;
      return Dt.isSmall ? en == We ? 0 : en > We ? 1 : -1 : en < 0 !== Dt.sign ? en < 0 ? -1 : 1 : en < 0 ? 1 : -1;
    }, be.prototype.compareTo = be.prototype.compare, ye.prototype.equals = function(Qe) {
      return this.compare(Qe) === 0;
    }, be.prototype.eq = be.prototype.equals = ye.prototype.eq = ye.prototype.equals, ye.prototype.notEquals = function(Qe) {
      return this.compare(Qe) !== 0;
    }, be.prototype.neq = be.prototype.notEquals = ye.prototype.neq = ye.prototype.notEquals, ye.prototype.greater = function(Qe) {
      return this.compare(Qe) > 0;
    }, be.prototype.gt = be.prototype.greater = ye.prototype.gt = ye.prototype.greater, ye.prototype.lesser = function(Qe) {
      return this.compare(Qe) < 0;
    }, be.prototype.lt = be.prototype.lesser = ye.prototype.lt = ye.prototype.lesser, ye.prototype.greaterOrEquals = function(Qe) {
      return this.compare(Qe) >= 0;
    }, be.prototype.geq = be.prototype.greaterOrEquals = ye.prototype.geq = ye.prototype.greaterOrEquals, ye.prototype.lesserOrEquals = function(Qe) {
      return this.compare(Qe) <= 0;
    }, be.prototype.leq = be.prototype.lesserOrEquals = ye.prototype.leq = ye.prototype.lesserOrEquals, ye.prototype.isEven = function() {
      return (this.value[0] & 1) === 0;
    }, be.prototype.isEven = function() {
      return (this.value & 1) === 0;
    }, ye.prototype.isOdd = function() {
      return (this.value[0] & 1) === 1;
    }, be.prototype.isOdd = function() {
      return (this.value & 1) === 1;
    }, ye.prototype.isPositive = function() {
      return !this.sign;
    }, be.prototype.isPositive = function() {
      return this.value > 0;
    }, ye.prototype.isNegative = function() {
      return this.sign;
    }, be.prototype.isNegative = function() {
      return this.value < 0;
    }, ye.prototype.isUnit = function() {
      return !1;
    }, be.prototype.isUnit = function() {
      return Math.abs(this.value) === 1;
    }, ye.prototype.isZero = function() {
      return !1;
    }, be.prototype.isZero = function() {
      return this.value === 0;
    }, ye.prototype.isDivisibleBy = function(Qe) {
      var Dt = Xt(Qe), en = Dt.value;
      return en === 0 ? !1 : en === 1 ? !0 : en === 2 ? this.isEven() : this.mod(Dt).equals(me[0]);
    }, be.prototype.isDivisibleBy = ye.prototype.isDivisibleBy;
    function xe(Qe) {
      var Dt = Qe.abs();
      if (Dt.isUnit()) return !1;
      if (Dt.equals(2) || Dt.equals(3) || Dt.equals(5)) return !0;
      if (Dt.isEven() || Dt.isDivisibleBy(3) || Dt.isDivisibleBy(5)) return !1;
      if (Dt.lesser(49)) return !0;
    }
    function ue(Qe, Dt) {
      for (var en = Qe.prev(), We = en, De = 0, Ge, Oe, Ce; We.isEven(); ) We = We.divide(2), De++;
      e: for (Oe = 0; Oe < Dt.length; Oe++)
        if (!Qe.lesser(Dt[Oe]) && (Ce = t(Dt[Oe]).modPow(We, Qe), !(Ce.equals(me[1]) || Ce.equals(en)))) {
          for (Ge = De - 1; Ge != 0; Ge--) {
            if (Ce = Ce.square().mod(Qe), Ce.isUnit()) return !1;
            if (Ce.equals(en)) continue e;
          }
          return !1;
        }
      return !0;
    }
    ye.prototype.isPrime = function(Qe) {
      var Dt = xe(this);
      if (Dt !== n) return Dt;
      var en = this.abs(), We = en.bitLength();
      if (We <= 64)
        return ue(en, [2, 325, 9375, 28178, 450775, 9780504, 1795265022]);
      for (var De = Math.log(2) * We, Ge = Math.ceil(Qe === !0 ? 2 * Math.pow(De, 2) : De), Oe = [], Ce = 0; Ce < Ge; Ce++)
        Oe.push(t(Ce + 2));
      return ue(en, Oe);
    }, be.prototype.isPrime = ye.prototype.isPrime, ye.prototype.isProbablePrime = function(Qe) {
      var Dt = xe(this);
      if (Dt !== n) return Dt;
      for (var en = this.abs(), We = Qe === n ? 5 : Qe, De = [], Ge = 0; Ge < We; Ge++)
        De.push(t.randBetween(2, en.minus(2)));
      return ue(en, De);
    }, be.prototype.isProbablePrime = ye.prototype.isProbablePrime, ye.prototype.modInv = function(Qe) {
      for (var Dt = t.zero, en = t.one, We = Xt(Qe), De = this.abs(), Ge, Oe, Ce; !De.equals(t.zero); )
        Ge = We.divide(De), Oe = Dt, Ce = We, Dt = en, We = De, en = Oe.subtract(Ge.multiply(en)), De = Ce.subtract(Ge.multiply(De));
      if (!We.equals(1)) throw new Error(this.toString() + " and " + Qe.toString() + " are not co-prime");
      return Dt.compare(0) === -1 && (Dt = Dt.add(Qe)), this.isNegative() ? Dt.negate() : Dt;
    }, be.prototype.modInv = ye.prototype.modInv, ye.prototype.next = function() {
      var Qe = this.value;
      return this.sign ? Ve(Qe, 1, this.sign) : new ye(qe(Qe, 1), this.sign);
    }, be.prototype.next = function() {
      var Qe = this.value;
      return Qe + 1 < ae ? new be(Qe + 1) : new ye(le, !1);
    }, ye.prototype.prev = function() {
      var Qe = this.value;
      return this.sign ? new ye(qe(Qe, 1), !0) : Ve(Qe, 1, this.sign);
    }, be.prototype.prev = function() {
      var Qe = this.value;
      return Qe - 1 > -ae ? new be(Qe - 1) : new ye(le, !0);
    };
    for (var ge = [1]; 2 * ge[ge.length - 1] <= ie; ) ge.push(2 * ge[ge.length - 1]);
    var Be = ge.length, Ne = ge[Be - 1];
    function Fe(Qe) {
      return (typeof Qe == "number" || typeof Qe == "string") && +Math.abs(Qe) <= ie || Qe instanceof ye && Qe.value.length <= 1;
    }
    ye.prototype.shiftLeft = function(Qe) {
      if (!Fe(Qe))
        throw new Error(String(Qe) + " is too large for shifting.");
      if (Qe = +Qe, Qe < 0) return this.shiftRight(-Qe);
      var Dt = this;
      if (Dt.isZero()) return Dt;
      for (; Qe >= Be; )
        Dt = Dt.multiply(Ne), Qe -= Be - 1;
      return Dt.multiply(ge[Qe]);
    }, be.prototype.shiftLeft = ye.prototype.shiftLeft, ye.prototype.shiftRight = function(Qe) {
      var Dt;
      if (!Fe(Qe))
        throw new Error(String(Qe) + " is too large for shifting.");
      if (Qe = +Qe, Qe < 0) return this.shiftLeft(-Qe);
      for (var en = this; Qe >= Be; ) {
        if (en.isZero() || en.isNegative() && en.isUnit()) return en;
        Dt = we(en, Ne), en = Dt[1].isNegative() ? Dt[0].prev() : Dt[0], Qe -= Be - 1;
      }
      return Dt = we(en, ge[Qe]), Dt[1].isNegative() ? Dt[0].prev() : Dt[0];
    }, be.prototype.shiftRight = ye.prototype.shiftRight;
    function Pe(Qe, Dt, en) {
      Dt = Xt(Dt);
      for (var We = Qe.isNegative(), De = Dt.isNegative(), Ge = We ? Qe.not() : Qe, Oe = De ? Dt.not() : Dt, Ce = 0, He = 0, Xe = null, Kt = null, tn = []; !Ge.isZero() || !Oe.isZero(); )
        Xe = we(Ge, Ne), Ce = Xe[1].toJSNumber(), We && (Ce = Ne - 1 - Ce), Kt = we(Oe, Ne), He = Kt[1].toJSNumber(), De && (He = Ne - 1 - He), Ge = Xe[0], Oe = Kt[0], tn.push(en(Ce, He));
      for (var Wt = en(We ? 1 : 0, De ? 1 : 0) !== 0 ? t(-1) : t(0), Yt = tn.length - 1; Yt >= 0; Yt -= 1)
        Wt = Wt.multiply(Ne).add(t(tn[Yt]));
      return Wt;
    }
    ye.prototype.not = function() {
      return this.negate().prev();
    }, be.prototype.not = ye.prototype.not, ye.prototype.and = function(Qe) {
      return Pe(this, Qe, function(Dt, en) {
        return Dt & en;
      });
    }, be.prototype.and = ye.prototype.and, ye.prototype.or = function(Qe) {
      return Pe(this, Qe, function(Dt, en) {
        return Dt | en;
      });
    }, be.prototype.or = ye.prototype.or, ye.prototype.xor = function(Qe) {
      return Pe(this, Qe, function(Dt, en) {
        return Dt ^ en;
      });
    }, be.prototype.xor = ye.prototype.xor;
    var Je = 1 << 30, Ke = (ie & -ie) * (ie & -ie) | Je;
    function Ze(Qe) {
      var Dt = Qe.value, en = typeof Dt == "number" ? Dt | Je : Dt[0] + Dt[1] * ie | Ke;
      return en & -en;
    }
    function Ye(Qe, Dt) {
      if (Dt.compareTo(Qe) <= 0) {
        var en = Ye(Qe, Dt.square(Dt)), We = en.p, De = en.e, Ge = We.multiply(Dt);
        return Ge.compareTo(Qe) <= 0 ? { p: Ge, e: De * 2 + 1 } : { p: We, e: De * 2 };
      }
      return { p: t(1), e: 0 };
    }
    ye.prototype.bitLength = function() {
      var Qe = this;
      return Qe.compareTo(t(0)) < 0 && (Qe = Qe.negate().subtract(t(1))), Qe.compareTo(t(0)) === 0 ? t(0) : t(Ye(Qe, t(2)).e).add(t(1));
    }, be.prototype.bitLength = ye.prototype.bitLength;
    function Pt(Qe, Dt) {
      return Qe = Xt(Qe), Dt = Xt(Dt), Qe.greater(Dt) ? Qe : Dt;
    }
    function Ft(Qe, Dt) {
      return Qe = Xt(Qe), Dt = Xt(Dt), Qe.lesser(Dt) ? Qe : Dt;
    }
    function Le(Qe, Dt) {
      if (Qe = Xt(Qe).abs(), Dt = Xt(Dt).abs(), Qe.equals(Dt)) return Qe;
      if (Qe.isZero()) return Dt;
      if (Dt.isZero()) return Qe;
      for (var en = me[1], We, De; Qe.isEven() && Dt.isEven(); )
        We = Math.min(Ze(Qe), Ze(Dt)), Qe = Qe.divide(We), Dt = Dt.divide(We), en = en.multiply(We);
      for (; Qe.isEven(); )
        Qe = Qe.divide(Ze(Qe));
      do {
        for (; Dt.isEven(); )
          Dt = Dt.divide(Ze(Dt));
        Qe.greater(Dt) && (De = Dt, Dt = Qe, Qe = De), Dt = Dt.subtract(Qe);
      } while (!Dt.isZero());
      return en.isUnit() ? Qe : Qe.multiply(en);
    }
    function $t(Qe, Dt) {
      return Qe = Xt(Qe).abs(), Dt = Xt(Dt).abs(), Qe.divide(Le(Qe, Dt)).multiply(Dt);
    }
    function Jt(Qe, Dt) {
      Qe = Xt(Qe), Dt = Xt(Dt);
      var en = Ft(Qe, Dt), We = Pt(Qe, Dt), De = We.subtract(en).add(1);
      if (De.isSmall) return en.add(Math.floor(Math.random() * De));
      for (var Ge = De.value.length - 1, Oe = [], Ce = !0, He = Ge; He >= 0; He--) {
        var Xe = Ce ? De.value[He] : ie, Kt = ke(Math.random() * Xe);
        Oe.unshift(Kt), Kt < Xe && (Ce = !1);
      }
      return Oe = $e(Oe), en.add(typeof Oe == "number" ? new be(Oe) : new ye(Oe, !1));
    }
    var Ht = function(Qe, Dt) {
      for (var en = Qe.length, We, De = Math.abs(Dt), We = 0; We < en; We++) {
        var Ge = Qe[We].toLowerCase();
        if (Ge !== "-" && /[a-z0-9]/.test(Ge)) {
          if (/[0-9]/.test(Ge) && +Ge >= De) {
            if (Ge === "1" && De === 1) continue;
            throw new Error(Ge + " is not a valid digit in base " + Dt + ".");
          } else if (Ge.charCodeAt(0) - 87 >= De)
            throw new Error(Ge + " is not a valid digit in base " + Dt + ".");
        }
      }
      if (2 <= Dt && Dt <= 36 && en <= he / Math.log(Dt)) {
        var Oe = parseInt(Qe, Dt);
        if (isNaN(Oe))
          throw new Error(Ge + " is not a valid digit in base " + Dt + ".");
        return new be(parseInt(Qe, Dt));
      }
      Dt = Xt(Dt);
      var Ce = [], He = Qe[0] === "-";
      for (We = He ? 1 : 0; We < Qe.length; We++) {
        var Ge = Qe[We].toLowerCase(), Xe = Ge.charCodeAt(0);
        if (48 <= Xe && Xe <= 57) Ce.push(Xt(Ge));
        else if (97 <= Xe && Xe <= 122) Ce.push(Xt(Ge.charCodeAt(0) - 87));
        else if (Ge === "<") {
          var Kt = We;
          do
            We++;
          while (Qe[We] !== ">");
          Ce.push(Xt(Qe.slice(Kt + 1, We)));
        } else throw new Error(Ge + " is not a valid character");
      }
      return Vt(Ce, Dt, He);
    };
    function Vt(Qe, Dt, en) {
      var We = me[0], De = me[1], Ge;
      for (Ge = Qe.length - 1; Ge >= 0; Ge--)
        We = We.add(Qe[Ge].times(De)), De = De.times(Dt);
      return en ? We.negate() : We;
    }
    function xn(Qe) {
      return Qe <= 35 ? "0123456789abcdefghijklmnopqrstuvwxyz".charAt(Qe) : "<" + Qe + ">";
    }
    function Zt(Qe, Dt) {
      if (Dt = t(Dt), Dt.isZero()) {
        if (Qe.isZero()) return { value: [0], isNegative: !1 };
        throw new Error("Cannot convert nonzero numbers to base 0.");
      }
      if (Dt.equals(-1)) {
        if (Qe.isZero()) return { value: [0], isNegative: !1 };
        if (Qe.isNegative())
          return {
            value: [].concat.apply(
              [],
              Array.apply(null, Array(-Qe)).map(Array.prototype.valueOf, [1, 0])
            ),
            isNegative: !1
          };
        var en = Array.apply(null, Array(+Qe - 1)).map(Array.prototype.valueOf, [0, 1]);
        return en.unshift([1]), {
          value: [].concat.apply([], en),
          isNegative: !1
        };
      }
      var We = !1;
      if (Qe.isNegative() && Dt.isPositive() && (We = !0, Qe = Qe.abs()), Dt.equals(1))
        return Qe.isZero() ? { value: [0], isNegative: !1 } : {
          value: Array.apply(null, Array(+Qe)).map(Number.prototype.valueOf, 1),
          isNegative: We
        };
      for (var De = [], Ge = Qe, Oe; Ge.isNegative() || Ge.compareAbs(Dt) >= 0; ) {
        Oe = Ge.divmod(Dt), Ge = Oe.quotient;
        var Ce = Oe.remainder;
        Ce.isNegative() && (Ce = Dt.minus(Ce).abs(), Ge = Ge.next()), De.push(Ce.toJSNumber());
      }
      return De.push(Ge.toJSNumber()), { value: De.reverse(), isNegative: We };
    }
    function Gt(Qe, Dt) {
      var en = Zt(Qe, Dt);
      return (en.isNegative ? "-" : "") + en.value.map(xn).join("");
    }
    ye.prototype.toArray = function(Qe) {
      return Zt(this, Qe);
    }, be.prototype.toArray = function(Qe) {
      return Zt(this, Qe);
    }, ye.prototype.toString = function(Qe) {
      if (Qe === n && (Qe = 10), Qe !== 10) return Gt(this, Qe);
      for (var Dt = this.value, en = Dt.length, We = String(Dt[--en]), De = "0000000", Ge; --en >= 0; )
        Ge = String(Dt[en]), We += De.slice(Ge.length) + Ge;
      var Oe = this.sign ? "-" : "";
      return Oe + We;
    }, be.prototype.toString = function(Qe) {
      return Qe === n && (Qe = 10), Qe != 10 ? Gt(this, Qe) : String(this.value);
    }, ye.prototype.toJSON = be.prototype.toJSON = function() {
      return this.toString();
    }, ye.prototype.valueOf = function() {
      return parseInt(this.toString(), 10);
    }, ye.prototype.toJSNumber = ye.prototype.valueOf, be.prototype.valueOf = function() {
      return this.value;
    }, be.prototype.toJSNumber = be.prototype.valueOf;
    function An(Qe) {
      if (Ae(+Qe)) {
        var Dt = +Qe;
        if (Dt === ke(Dt))
          return new be(Dt);
        throw new Error("Invalid integer: " + Qe);
      }
      var en = Qe[0] === "-";
      en && (Qe = Qe.slice(1));
      var We = Qe.split(/e/i);
      if (We.length > 2) throw new Error("Invalid integer: " + We.join("e"));
      if (We.length === 2) {
        var De = We[1];
        if (De[0] === "+" && (De = De.slice(1)), De = +De, De !== ke(De) || !Ae(De)) throw new Error("Invalid integer: " + De + " is not a valid exponent.");
        var Ge = We[0], Oe = Ge.indexOf(".");
        if (Oe >= 0 && (De -= Ge.length - Oe - 1, Ge = Ge.slice(0, Oe) + Ge.slice(Oe + 1)), De < 0) throw new Error("Cannot include negative exponent part for integers");
        Ge += new Array(De + 1).join("0"), Qe = Ge;
      }
      var Ce = /^([0-9][0-9]*)$/.test(Qe);
      if (!Ce) throw new Error("Invalid integer: " + Qe);
      for (var He = [], Xe = Qe.length, Kt = fe, tn = Xe - Kt; Xe > 0; )
        He.push(+Qe.slice(tn, Xe)), tn -= Kt, tn < 0 && (tn = 0), Xe -= Kt;
      return Re(He), new ye(He, en);
    }
    function Qt(Qe) {
      if (Ae(Qe)) {
        if (Qe !== ke(Qe)) throw new Error(Qe + " is not an integer.");
        return new be(Qe);
      }
      return An(Qe.toString());
    }
    function Xt(Qe) {
      return typeof Qe == "number" ? Qt(Qe) : typeof Qe == "string" ? An(Qe) : Qe;
    }
    for (var wn = 0; wn < 1e3; wn++)
      me[wn] = new be(wn), wn > 0 && (me[-wn] = new be(-wn));
    return me.one = me[1], me.zero = me[0], me.minusOne = me[-1], me.max = Pt, me.min = Ft, me.gcd = Le, me.lcm = $t, me.isInstance = function(Qe) {
      return Qe instanceof ye || Qe instanceof be;
    }, me.randBetween = Jt, me.fromArray = function(Qe, Dt, en) {
      return Vt(Qe.map(Xt), Xt(Dt || 10), en);
    }, me;
  }();
  c.hasOwnProperty("exports") && (c.exports = t);
})(BigInteger);
var BigIntegerExports = BigInteger.exports;
const i = /* @__PURE__ */ getDefaultExportFromCjs$2(BigIntegerExports), ARRAY16 = new Array(16), zl = initU8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
]), zr$1 = initU8Array([
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
]), sl = initU8Array([
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
]), sr$1 = initU8Array([
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
]), hl = initU32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), hr$1 = initU32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]);
function rotl(c, t) {
  return c << t | c >>> 32 - t;
}
function fn1(c, t, n, ie, fe, ae, le, he) {
  return rotl(c + (t ^ n ^ ie) + ae + le | 0, he) + fe | 0;
}
function fn2(c, t, n, ie, fe, ae, le, he) {
  return rotl(c + (t & n | ~t & ie) + ae + le | 0, he) + fe | 0;
}
function fn3(c, t, n, ie, fe, ae, le, he) {
  return rotl(c + ((t | ~n) ^ ie) + ae + le | 0, he) + fe | 0;
}
function fn4(c, t, n, ie, fe, ae, le, he) {
  return rotl(c + (t & ie | n & ~ie) + ae + le | 0, he) + fe | 0;
}
function fn5(c, t, n, ie, fe, ae, le, he) {
  return rotl(c + (t ^ (n | ~ie)) + ae + le | 0, he) + fe | 0;
}
function readInt32LE(c, t) {
  return t >>>= 0, c[t] | c[t + 1] << 8 | c[t + 2] << 16 | c[t + 3] << 24;
}
function writeUInt32LE(c, t, n) {
  return t = +t, n >>>= 0, c[n + 3] = t >>> 24, c[n + 2] = t >>> 16, c[n + 1] = t >>> 8, c[n] = t & 255, n + 4;
}
function writeInt32LE(c, t, n) {
  return t = +t, n >>>= 0, c[n] = t & 255, c[n + 1] = t >>> 8, c[n + 2] = t >>> 16, c[n + 3] = t >>> 24, n + 4;
}
function initU32Array(c) {
  return typeof Uint32Array < "u" ? new Uint32Array(c) : c;
}
function initU8Array(c) {
  return typeof Uint8Array < "u" ? new Uint8Array(c) : c;
}
function createU8Array(c) {
  return typeof Uint8Array < "u" ? new Uint8Array(c) : new Array(c);
}
class RIPEMD160 {
  constructor() {
    this._block = createU8Array(64), this._blockSize = 64, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1, this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  update(t) {
    if (this._finalized)
      throw new Error("Digest already called");
    const n = this._block;
    let ie = 0;
    for (; this._blockOffset + t.length - ie >= this._blockSize; ) {
      for (let fe = this._blockOffset; fe < this._blockSize; )
        n[fe++] = t[ie++];
      this._update(), this._blockOffset = 0;
    }
    for (; ie < t.length; )
      n[this._blockOffset++] = t[ie++];
    for (let fe = 0, ae = t.length * 8; ae > 0; ++fe)
      this._length[fe] += ae, ae = this._length[fe] / 4294967296 | 0, ae > 0 && (this._length[fe] -= 4294967296 * ae);
    return this;
  }
  _update() {
    const t = ARRAY16;
    for (let $e = 0; $e < 16; ++$e)
      t[$e] = readInt32LE(this._block, $e * 4);
    let n = this._a | 0, ie = this._b | 0, fe = this._c | 0, ae = this._d | 0, le = this._e | 0, he = this._a | 0, me = this._b | 0, ye = this._c | 0, be = this._d | 0, Ae = this._e | 0;
    for (let $e = 0; $e < 80; $e += 1) {
      let Re, Me;
      $e < 16 ? (Re = fn1(n, ie, fe, ae, le, t[zl[$e]], hl[0], sl[$e]), Me = fn5(he, me, ye, be, Ae, t[zr$1[$e]], hr$1[0], sr$1[$e])) : $e < 32 ? (Re = fn2(n, ie, fe, ae, le, t[zl[$e]], hl[1], sl[$e]), Me = fn4(he, me, ye, be, Ae, t[zr$1[$e]], hr$1[1], sr$1[$e])) : $e < 48 ? (Re = fn3(n, ie, fe, ae, le, t[zl[$e]], hl[2], sl[$e]), Me = fn3(he, me, ye, be, Ae, t[zr$1[$e]], hr$1[2], sr$1[$e])) : $e < 64 ? (Re = fn4(n, ie, fe, ae, le, t[zl[$e]], hl[3], sl[$e]), Me = fn2(he, me, ye, be, Ae, t[zr$1[$e]], hr$1[3], sr$1[$e])) : (Re = fn5(n, ie, fe, ae, le, t[zl[$e]], hl[4], sl[$e]), Me = fn1(he, me, ye, be, Ae, t[zr$1[$e]], hr$1[4], sr$1[$e])), n = le, le = ae, ae = rotl(fe, 10), fe = ie, ie = Re, he = Ae, Ae = be, be = rotl(ye, 10), ye = me, me = Me;
    }
    const Se = this._b + fe + be | 0;
    this._b = this._c + ae + Ae | 0, this._c = this._d + le + he | 0, this._d = this._e + n + me | 0, this._e = this._a + ie + ye | 0, this._a = Se;
  }
  digest() {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0, this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), writeUInt32LE(this._block, this._length[0], 56), writeUInt32LE(this._block, this._length[1], 60), this._update();
    const t = createU8Array(20);
    writeInt32LE(t, this._a, 0), writeInt32LE(t, this._b, 4), writeInt32LE(t, this._c, 8), writeInt32LE(t, this._d, 12), writeInt32LE(t, this._e, 16), this._block.fill(0), this._blockOffset = 0;
    for (let n = 0; n < 4; ++n)
      this._length[n] = 0;
    return t;
  }
}
var a$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", s = function(c) {
  for (var t = c.toString(), n = "", ie = 0; ie < t.length; ie += 2) n += String.fromCharCode(parseInt(t.substr(ie, 2), 16));
  return n;
}, l$1 = function(c) {
  for (var t = new ArrayBuffer(5 * c.length / 8), n = new Uint8Array(t), ie = 0; ie < c.length / 8; ie++) {
    for (var fe = [0, 0, 0, 0, 0, 0, 0, 0], ae = 0; ae < 8; ++ae) fe[ae] = a$1.indexOf(c[8 * ie + ae]);
    n[5 * ie + 0] = fe[0] << 3 | fe[1] >> 2, n[5 * ie + 1] = (3 & fe[1]) << 6 | fe[2] << 1 | fe[3] >> 4, n[5 * ie + 2] = (15 & fe[3]) << 4 | fe[4] >> 1, n[5 * ie + 3] = (1 & fe[4]) << 7 | fe[5] << 2 | fe[6] >> 3, n[5 * ie + 4] = (7 & fe[6]) << 5 | fe[7];
  }
  return n;
}, d$1 = function(c) {
  var t = [], n = Math.floor(c.length / 5), ie = c.length % 5;
  if (ie != 0) {
    for (var fe = 0; fe < 5 - ie; fe++) c += "\0";
    n += 1;
  }
  for (var ae = 0; ae < n; ae++) t.push(a$1.charAt(c.charCodeAt(5 * ae) >> 3)), t.push(a$1.charAt((7 & c.charCodeAt(5 * ae)) << 2 | c.charCodeAt(5 * ae + 1) >> 6)), t.push(a$1.charAt((63 & c.charCodeAt(5 * ae + 1)) >> 1)), t.push(a$1.charAt((1 & c.charCodeAt(5 * ae + 1)) << 4 | c.charCodeAt(5 * ae + 2) >> 4)), t.push(a$1.charAt((15 & c.charCodeAt(5 * ae + 2)) << 1 | c.charCodeAt(5 * ae + 3) >> 7)), t.push(a$1.charAt((127 & c.charCodeAt(5 * ae + 3)) >> 2)), t.push(a$1.charAt((3 & c.charCodeAt(5 * ae + 3)) << 3 | c.charCodeAt(5 * ae + 4) >> 5)), t.push(a$1.charAt(31 & c.charCodeAt(5 * ae + 4)));
  var le = 0;
  ie == 1 ? le = 6 : ie == 2 ? le = 4 : ie == 3 ? le = 3 : ie == 4 && (le = 1);
  for (var he = 0; he < le; he++) t.pop();
  for (var me = 0; me < le; me++) t.push("=");
  return t.join("");
}, p$1 = function(c) {
  var t = c.toString().toUpperCase().replace(/-/g, "");
  if (!t || t.length !== 40) return !1;
  var n = v$1(l$1(t));
  return y$1(Buffer$7.from(n.slice(0, 42), "hex")) === n.slice(42);
}, v$1 = function(c) {
  for (var t = "", n = 0; n < c.length; n++) {
    var ie = Math.round(c[n]).toString(16);
    ie.length === 1 && (ie = "0" + ie), t += ie;
  }
  return t;
}, y$1 = function(c) {
  return new sha3$1.Keccak(256).update(c).digest("hex").toString().substr(0, 8);
};
function g$1(c, t) {
  this._block = safeBufferExports.Buffer.alloc(c), this._finalSize = t, this._blockSize = c, this._len = 0;
}
g$1.prototype.update = function(c, t) {
  typeof c == "string" && (c = safeBufferExports.Buffer.from(c, t = t || "utf8"));
  for (var n = this._block, ie = this._blockSize, fe = c.length, ae = this._len, le = 0; le < fe; ) {
    for (var he = ae % ie, me = Math.min(fe - le, ie - he), ye = 0; ye < me; ye++) n[he + ye] = c[le + ye];
    le += me, (ae += me) % ie == 0 && this._update(n);
  }
  return this._len += fe, this;
}, g$1.prototype.digest = function(c) {
  var t = this._len % this._blockSize;
  this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var n = 8 * this._len;
  if (n <= 4294967295) this._block.writeUInt32BE(n, this._blockSize - 4);
  else {
    var ie = (4294967295 & n) >>> 0;
    this._block.writeUInt32BE((n - ie) / 4294967296, this._blockSize - 8), this._block.writeUInt32BE(ie, this._blockSize - 4);
  }
  this._update(this._block);
  var fe = this._hash();
  return c ? fe.toString(c) : fe;
}, g$1.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var m$1, w$1, b$1 = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], _$2 = new Array(64);
function B$1() {
  this.init(), this._w = _$2, g$1.call(this, 64, 56);
}
function E$1(c, t, n) {
  return n ^ c & (t ^ n);
}
function I$1(c, t, n) {
  return c & t | n & (c | t);
}
function x$1(c) {
  return (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
}
function S$1(c) {
  return (c >>> 6 | c << 26) ^ (c >>> 11 | c << 21) ^ (c >>> 25 | c << 7);
}
function A$1(c) {
  return (c >>> 7 | c << 25) ^ (c >>> 18 | c << 14) ^ c >>> 3;
}
function z$2(c) {
  return c.length !== void 0;
}
m$1 = B$1, (w$1 = g$1) && (m$1.super_ = w$1, m$1.prototype = Object.create(w$1.prototype, { constructor: { value: m$1, enumerable: !1, writable: !0, configurable: !0 } })), B$1.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
}, B$1.prototype._update = function(c) {
  for (var t, n = this._w, ie = 0 | this._a, fe = 0 | this._b, ae = 0 | this._c, le = 0 | this._d, he = 0 | this._e, me = 0 | this._f, ye = 0 | this._g, be = 0 | this._h, Ae = 0; Ae < 16; ++Ae) n[Ae] = c.readInt32BE(4 * Ae);
  for (; Ae < 64; ++Ae) n[Ae] = 0 | (((t = n[Ae - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + n[Ae - 7] + A$1(n[Ae - 15]) + n[Ae - 16];
  for (var Se = 0; Se < 64; ++Se) {
    var $e = be + S$1(he) + E$1(he, me, ye) + b$1[Se] + n[Se] | 0, Re = x$1(ie) + I$1(ie, fe, ae) | 0;
    be = ye, ye = me, me = he, he = le + $e | 0, le = ae, ae = fe, fe = ie, ie = $e + Re | 0;
  }
  this._a = ie + this._a | 0, this._b = fe + this._b | 0, this._c = ae + this._c | 0, this._d = le + this._d | 0, this._e = he + this._e | 0, this._f = me + this._f | 0, this._g = ye + this._g | 0, this._h = be + this._h | 0;
}, B$1.prototype._hash = function() {
  var c = safeBufferExports.Buffer.allocUnsafe(32);
  return c.writeInt32BE(this._a, 0), c.writeInt32BE(this._b, 4), c.writeInt32BE(this._c, 8), c.writeInt32BE(this._d, 12), c.writeInt32BE(this._e, 16), c.writeInt32BE(this._f, 20), c.writeInt32BE(this._g, 24), c.writeInt32BE(this._h, 28), c;
};
var k$2 = new (function() {
  function c(n) {
    this.sha256 = n.sha256, this.alphabet = n.alphabet, this.codec = e$1(this.alphabet), this.base = this.alphabet.length;
  }
  var t = c.prototype;
  return t.encodeChecked = function(n) {
    var ie = this.sha256(this.sha256(n)).slice(0, 4);
    return this.encodeRaw(Buffer$7.from(function() {
      var fe = [];
      return [].slice.call(arguments).forEach(function(ae) {
        if (z$2(ae)) for (var le = 0; le < ae.length; le++) fe.push(ae[le]);
        else fe.push(ae);
      }), fe;
    }(n, ie)));
  }, t.encodeRaw = function(n) {
    return this.codec.encode(n);
  }, t.decodeChecked = function(n) {
    var ie = this.decodeRaw(n);
    if (ie.length < 5) throw new Error("invalid_input_size: decoded data must have length >= 5");
    if (!this.verifyCheckSum(ie)) throw new Error("checksum_invalid");
    return ie.slice(0, -4);
  }, t.decodeRaw = function(n) {
    return this.codec.decode(n);
  }, t.verifyCheckSum = function(n) {
    return function(ie, fe) {
      if (ie.length !== fe.length) return !1;
      for (var ae = 0; ae < ie.length; ae++) if (ie[ae] !== fe[ae]) return !1;
      return !0;
    }(this.sha256(this.sha256(n.slice(0, -4))).slice(0, 4), n.slice(-4));
  }, c;
}())({ sha256: function(c) {
  return new B$1().update(Buffer$7.from(c)).digest();
}, alphabet: "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz" }), O$1 = function(c) {
  return c.slice(0, 2) === "0x" ? c.slice(2) : c;
}, C$1 = function(c, t) {
  if (t === void 0 && (t = null), typeof c != "string") throw new Error("stripHexPrefix param must be type 'string', is currently type " + typeof c + ".");
  for (var n, ie = O$1(c).toLowerCase(), fe = (n = (t != null ? t.toString() + "0x" : "") + ie, new sha3$1.Keccak(256).update(n).digest()).toString("hex"), ae = "0x", le = 0; le < ie.length; le++) ae += parseInt(fe[le], 16) >= 8 ? ie[le].toUpperCase() : ie[le];
  return ae;
};
function U$1(c, t) {
  return function(n) {
    return /^0x[0-9a-fA-F]{40}$/.test(n);
  }(c) && C$1(c, t) === c;
}
var P$2 = function(c, t) {
  if (!c) throw t;
}, L$2 = function(c, t) {
  if (!Buffer$7.isBuffer(c)) throw t;
}, j$2 = i.one, R$2 = i.zero, q$2 = i(3);
function M$2(c, t) {
  return c.and(j$2.shiftLeft(t)).notEquals(R$2);
}
function F$2(c) {
  return i.fromArray(Array.prototype.slice.call(c, 0), 256);
}
function T$2(c, t) {
  var n = c.toArray(256).value, ie = t ? Math.max(t - n.length, 0) : 0;
  return Buffer$7.from([].concat(Array(ie).fill(0), n));
}
function G$2(c, t, n, ie) {
  P$2(ie !== void 0, "Missing Z coordinate"), this.curve = c, this.x = t, this.y = n, this.z = ie, this._zInv = null, this.compressed = !0;
}
Object.defineProperty(G$2.prototype, "zInv", { get: function() {
  return this._zInv === null && (this._zInv = this.z.modInv(this.curve.p)), this._zInv;
} }), Object.defineProperty(G$2.prototype, "affineX", { get: function() {
  return this.x.multiply(this.zInv).mod(this.curve.p);
} }), Object.defineProperty(G$2.prototype, "affineY", { get: function() {
  return this.y.multiply(this.zInv).mod(this.curve.p);
} }), G$2.fromAffine = function(c, t, n) {
  return new G$2(c, t, n, j$2);
}, G$2.prototype.equals = function(c) {
  return c === this || (this.curve.isInfinity(this) ? this.curve.isInfinity(c) : this.curve.isInfinity(c) ? this.curve.isInfinity(this) : c.y.multiply(this.z).subtract(this.y.multiply(c.z)).mod(this.curve.p).compare(R$2) === 0 && c.x.multiply(this.z).subtract(this.x.multiply(c.z)).mod(this.curve.p).compare(R$2) === 0);
}, G$2.prototype.negate = function() {
  var c = this.curve.p.subtract(this.y);
  return new G$2(this.curve, this.x, c, this.z);
}, G$2.prototype.add = function(c) {
  if (this.curve.isInfinity(this)) return c;
  if (this.curve.isInfinity(c)) return this;
  var t = this.x, n = this.y, ie = c.x, fe = c.y.multiply(this.z).subtract(n.multiply(c.z)).mod(this.curve.p), ae = ie.multiply(this.z).subtract(t.multiply(c.z)).mod(this.curve.p);
  if (ae.compare(R$2) === 0) return fe.compare(R$2) === 0 ? this.twice() : this.curve.infinity;
  var le = ae.square(), he = le.multiply(ae), me = t.multiply(le), ye = fe.square().multiply(this.z), be = ye.subtract(me.shiftLeft(1)).multiply(c.z).subtract(he).multiply(ae).mod(this.curve.p), Ae = me.multiply(q$2).multiply(fe).subtract(n.multiply(he)).subtract(ye.multiply(fe)).multiply(c.z).add(fe.multiply(he)).mod(this.curve.p), Se = he.multiply(this.z).multiply(c.z).mod(this.curve.p);
  return new G$2(this.curve, be, Ae, Se);
}, G$2.prototype.twice = function() {
  if (this.curve.isInfinity(this)) return this;
  if (this.y.compare(R$2) === 0) return this.curve.infinity;
  var c = this.x, t = this.y, n = t.multiply(this.z).mod(this.curve.p), ie = n.multiply(t).mod(this.curve.p), fe = this.curve.a, ae = c.square().multiply(q$2);
  fe.compare(R$2) !== 0 && (ae = ae.add(this.z.square().multiply(fe)));
  var le = (ae = ae.mod(this.curve.p)).square().subtract(c.shiftLeft(3).multiply(ie)).shiftLeft(1).multiply(n).mod(this.curve.p), he = ae.multiply(q$2).multiply(c).subtract(ie.shiftLeft(1)).shiftLeft(2).multiply(ie).subtract(ae.pow(3)).mod(this.curve.p), me = n.pow(3).shiftLeft(3).mod(this.curve.p);
  return new G$2(this.curve, le, he, me);
}, G$2.prototype.multiply = function(c) {
  if (this.curve.isInfinity(this)) return this;
  if (c.compare(R$2) === 0) return this.curve.infinity;
  for (var t = c, n = t.multiply(q$2), ie = this.negate(), fe = this, ae = n.bitLength() - 2; ae > 0; --ae) {
    var le = M$2(n, ae), he = M$2(t, ae);
    fe = fe.twice(), le !== he && (fe = fe.add(le ? this : ie));
  }
  return fe;
}, G$2.prototype.multiplyTwo = function(c, t, n) {
  for (var ie = Math.max(c.bitLength(), n.bitLength()) - 1, fe = this.curve.infinity, ae = this.add(t); ie >= 0; ) {
    var le = M$2(c, ie), he = M$2(n, ie);
    fe = fe.twice(), le ? fe = fe.add(he ? ae : this) : he && (fe = fe.add(t)), --ie;
  }
  return fe;
}, G$2.prototype.getEncoded = function(c) {
  if (c == null && (c = this.compressed), this.curve.isInfinity(this)) return new Buffer$7("00", "hex");
  var t, n = this.affineX, ie = this.affineY, fe = this.curve.pLength;
  return c ? (t = new Buffer$7(1 + fe)).writeUInt8(ie.isEven() ? 2 : 3, 0) : ((t = new Buffer$7(1 + fe + fe)).writeUInt8(4, 0), T$2(ie, fe).copy(t, 1 + fe)), T$2(n, fe).copy(t, 1), t;
}, G$2.decodeFrom = function(c, t) {
  var n, ie = t.readUInt8(0), fe = ie !== 4, ae = Math.floor((c.p.bitLength() + 7) / 8), le = F$2(t.slice(1, 1 + ae));
  if (fe) P$2(t.length === ae + 1, "Invalid sequence length"), P$2(ie === 2 || ie === 3, "Invalid sequence tag"), n = c.pointFromX(ie === 3, le);
  else {
    P$2(t.length === 1 + ae + ae, "Invalid sequence length");
    var he = F$2(t.slice(1 + ae));
    n = G$2.fromAffine(c, le, he);
  }
  return n.compressed = fe, n;
}, G$2.prototype.toString = function() {
  return this.curve.isInfinity(this) ? "(INFINITY)" : "(" + this.affineX.toString() + "," + this.affineY.toString() + ")";
};
var H$2 = i.zero, N$2 = i.one;
function X$2(c, t, n, ie, fe, ae, le) {
  this.p = c, this.a = t, this.b = n, this.G = G$2.fromAffine(this, ie, fe), this.n = ae, this.h = le, this.infinity = new G$2(this, null, null, H$2), this.pOverFour = c.add(N$2).shiftRight(2), this.pLength = Math.floor((this.p.bitLength() + 7) / 8);
}
X$2.prototype.pointFromX = function(c, t) {
  var n = t.pow(3).add(this.a.multiply(t)).add(this.b).mod(this.p).modPow(this.pOverFour, this.p), ie = n;
  return n.isEven() ^ !c && (ie = this.p.subtract(ie)), G$2.fromAffine(this, t, ie);
}, X$2.prototype.isInfinity = function(c) {
  return c === this.infinity || c.z.compare(H$2) === 0 && c.y.compare(H$2) !== 0;
}, X$2.prototype.isOnCurve = function(c) {
  if (this.isInfinity(c)) return !0;
  var t = c.affineX, n = c.affineY, ie = this.a, fe = this.b, ae = this.p;
  if (t.compare(H$2) < 0 || t.compareTo(ae) >= 0 || n.compare(H$2) < 0 || n.compareTo(ae) >= 0) return !1;
  var le = n.square().mod(ae), he = t.pow(3).add(ie.multiply(t)).add(fe).mod(ae);
  return le.equals(he);
}, X$2.prototype.validate = function(c) {
  P$2(!this.isInfinity(c), "Point is at infinity"), P$2(this.isOnCurve(c), "Point is not on the curve");
  var t = c.multiply(this.n);
  return P$2(this.isInfinity(t), "Point is not a scalar multiple of G"), !0;
};
var Y$2 = { p: "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", a: "00", b: "07", n: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", h: "01", Gx: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", Gy: "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8" };
function K$2(c, t) {
  return new sha3$1.SHA3(256).update(c).digest(t);
}
function Q$2(c) {
  return Buffer$7.from(new RIPEMD160().update(c).digest());
}
function Z$2(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (L$2(c, "expecting keyBuffer<Buffer>"), t === "sha256x2") {
    var n = K$2(K$2(c)).slice(0, 4);
    return o$1.encode(Buffer$7.concat([c, n]));
  }
  var ie = [c];
  t && ie.push(Buffer$7.from(t));
  var fe = Q$2(Buffer$7.concat(ie)).slice(0, 4);
  return o$1.encode(Buffer$7.concat([c, fe]));
}
function D$2(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  P$2(c, "private key expected");
  var n, ie = new Buffer$7(o$1.decode(c)), fe = ie.slice(-4), ae = ie.slice(0, -4);
  if (t === "sha256x2") n = K$2(K$2(ae)).slice(0, 4);
  else {
    var le = [ae];
    t && le.push(Buffer$7.from(t)), n = Q$2(Buffer$7.concat(le)).slice(0, 4);
  }
  if (fe.toString("hex") !== n.toString("hex")) throw new Error("Invalid checksum, " + "".concat(fe.toString("hex"), " != ").concat(n.toString("hex")));
  return ae;
}
var V$2 = function(c) {
  var t = Y$2;
  if (!t) return null;
  var n = i(t.p, 16), ie = i(t.a, 16), fe = i(t.b, 16), ae = i(t.n, 16), le = i(t.h, 16);
  return new X$2(n, ie, fe, i(t.Gx, 16), i(t.Gy, 16), ae, le);
}();
function J$2(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "EOS";
  if (typeof c == "string") return J$2.fromString(c, t);
  if (Buffer$7.isBuffer(c)) return J$2.fromBuffer(c);
  if (typeof c == "object" && c.Q) return J$2(c.Q);
  function n() {
    var ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : c.compressed;
    return c.getEncoded(ae);
  }
  function ie() {
    var ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "EOS";
    return ae + Z$2(n());
  }
  function fe() {
    return n().toString("hex");
  }
  return { Q: c, toString: ie, toBuffer: n, toHex: fe };
}
J$2.isValid = function(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "EOS";
  try {
    return J$2(c, t), !0;
  } catch {
    return !1;
  }
}, J$2.fromBuffer = function(c) {
  return J$2(G$2.decodeFrom(V$2, c));
}, J$2.fromString = function(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "EOS";
  try {
    return J$2.fromStringOrThrow(c, t);
  } catch {
    return null;
  }
}, J$2.fromStringOrThrow = function(c) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "EOS", n = c.match(/^PUB_([A-Za-z0-9]+)_([A-Za-z0-9]+)$/);
  if (n === null) {
    var ie = new RegExp("^" + t);
    return ie.test(c) && (c = c.substring(t.length)), J$2.fromBuffer(D$2(c));
  }
  var fe = n[1], ae = n[2];
  return J$2.fromBuffer(D$2(ae, fe));
}, J$2.fromHex = function(c) {
  return J$2.fromBuffer(new Buffer$7(c, "hex"));
}, J$2.fromStringHex = function(c) {
  return J$2.fromString(new Buffer$7(c, "hex"));
};
var W$2 = e$1("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $$2 = W$2.encode, tt$1 = W$2.decode, rt$1 = function(c) {
  return c === void 0;
}, et$1 = { ed25519PublicKey: 48, ed25519SecretSeed: 144, preAuthTx: 152, sha256Hash: 184 }, nt$1 = function(c, t) {
  if (typeof t != "string") throw new TypeError("encoded argument must be of type String");
  var n = tt$1(t), ie = n[0], fe = n.slice(0, -2), ae = fe.slice(1), le = n.slice(-2);
  if (t !== $$2(n)) throw new Error("invalid encoded string");
  var he = et$1[c];
  if (rt$1(he)) throw new Error(c + ' is not a valid version byte name.  expected one of "accountId" or "seed"');
  if (ie !== he) throw new Error("invalid version byte. expected " + he + ", got " + ie);
  var me = ot$1(fe);
  if (!ft$1(me, le)) throw new Error("invalid checksum");
  return Buffer$7.from(ae);
}, it$1 = function(c, t) {
  if (t === null || rt$1(t)) throw new Error("cannot encode null data");
  var n = et$1[c];
  if (rt$1(n)) throw new Error(c + ' is not a valid version byte name.  expected one of "ed25519PublicKey", "ed25519SecretSeed", "preAuthTx", "sha256Hash"');
  t = Buffer$7.from(t);
  var ie = Buffer$7.from([n]), fe = Buffer$7.concat([ie, t]), ae = ot$1(fe), le = Buffer$7.concat([fe, ae]);
  return $$2(le);
}, ot$1 = function(c) {
  var t = Buffer$7.alloc(2);
  return t.writeUInt16LE(function(n, ie) {
    Buffer$7.isBuffer(n) || (n = new Buffer$7());
    for (var fe = 0, ae = 0; ae < n.length; ae++) {
      var le = fe >>> 8 & 255;
      le ^= 255 & n[ae], fe = fe << 8 & 65535, fe ^= le ^= le >>> 4, fe ^= le = le << 5 & 65535, fe ^= le = le << 7 & 65535;
    }
    return fe;
  }(c), 0), t;
}, ft$1 = function(c, t) {
  if (c.length !== t.length) return !1;
  if (c.length === 0) return !0;
  for (var n = 0; n < c.length; n += 1) if (c[n] !== t[n]) return !1;
  return !0;
};
function ut$1(c) {
  return (ut$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(c);
}
function at$1(c, t) {
  return (at$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, ie) {
    return n.__proto__ = ie, n;
  })(c, t);
}
function st$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ht$1(c, t, n) {
  return (ht$1 = st$1() ? Reflect.construct.bind() : function(ie, fe, ae) {
    var le = [null];
    le.push.apply(le, fe);
    var he = new (Function.bind.apply(ie, le))();
    return ae && at$1(he, ae.prototype), he;
  }).apply(null, arguments);
}
function ct$1(c) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return (ct$1 = function(n) {
    if (n === null || Function.toString.call(n).indexOf("[native code]") === -1) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, ie);
    }
    function ie() {
      return ht$1(n, arguments, ut$1(this).constructor);
    }
    return ie.prototype = Object.create(n.prototype, { constructor: { value: ie, enumerable: !1, writable: !0, configurable: !0 } }), at$1(ie, n);
  })(c);
}
var lt$1 = [0, 1, 2, 42, 43, 68, 69], dt$1 = function(c) {
  for (var t = new Uint8Array(c.length), n = 0; n < c.length; n++) t[n] = c.charCodeAt(n);
  return t;
}("SS58PRE"), pt$1 = function(c) {
  var t, n;
  function ie() {
    return c.apply(this, arguments) || this;
  }
  return n = c, (t = ie).prototype = Object.create(n.prototype), t.prototype.constructor = t, at$1(t, n), ie.prototype.toJSON = function() {
    return { _type: "AccountIndex", data: this + 0 };
  }, ie;
}(ct$1(Number));
function vt$1(c, t) {
  c.length || (c = [c]), t.length || (t = [t]);
  var n = new Uint8Array(c.length + t.length);
  return n.set(c), n.set(t, c.length), n;
}
function yt$1(c, t, n, ie, fe) {
  var ae;
  if (t === void 0 && (t = 42), n === void 0 && (n = null), ie === void 0 && (ie = null), lt$1.indexOf(t) === -1) throw new Error("Unknown ss58 address type", t);
  if (typeof c == "number" || c instanceof pt$1) {
    var le = c < 256 ? 1 : c < 65536 ? 2 : c < 1 ? 4 : 8;
    if ([1, 2, 4, 8].indexOf(ie = ie || le) === -1) throw new Error("Invalid length");
    if (ie = Math.max(le, ie), n && typeof n != "number") throw new Error("Invalid checksum length");
    switch (ie) {
      case 1:
        n = 1;
        break;
      case 2:
        n = [1, 2].indexOf(n) + 1 || 1;
        break;
      case 4:
        n = [1, 2, 3, 4].indexOf(n) + 1 || 1;
        break;
      case 8:
        n = [1, 2, 3, 4, 5, 6, 7, 8].indexOf(n) + 1 || 1;
    }
    ae = function(ye, be) {
      var Ae = !1;
      ye < 0 && (ye = -ye - 1, Ae = !0);
      for (var Se = new Uint8Array(be), $e = 0; $e < be; ++$e) Se[$e] = ye % 256, Ae && (Se[$e] = 255 & ~Se[$e]), ye /= 256;
      return Se;
    }(c, ie);
  } else {
    if (!(c instanceof Uint8Array) || c.length !== 32 && c.length !== 35) throw new Error("Unknown item to encode as ss58. Passing back.", c);
    n = 2, fe = ae = c.length === 35 ? c.slice(1, 33) : c;
  }
  var he = blake2b_1.blake2b(vt$1(dt$1, 1 & t ? fe : vt$1(t, ae))), me = vt$1(vt$1(t, ae), he.slice(0, n));
  return o$1.encode(Buffer$7.from(me));
}
function gt$1(c, t) {
  var n;
  t === void 0 && (t = 0);
  try {
    n = o$1.decode(c);
  } catch {
    return null;
  }
  if (lt$1.indexOf(n[0]) === -1 || n.length < 3) return null;
  var ie, fe = n.length <= 3 ? 1 : n.length <= 5 ? 2 : n.length <= 9 ? 4 : n.length <= 17 ? 8 : 32, ae = n.length - 1 - fe, le = n.slice(1, 1 + fe);
  n.slice(1 + n.length), fe === 32 && (ie = le);
  var he = fe < 32 ? new pt$1(function(be) {
    var Ae = 0, Se = 1;
    return be.forEach(function($e) {
      Ae += $e * Se, Se *= 256;
    }), Ae;
  }(le)) : new Buffer$7.from(le);
  if (n[0] % 1 && !ie && !t) return null;
  for (var me = blake2b_1.blake2b(vt$1(dt$1, n[0] % 1 ? ie || t(he) : n.slice(0, 1 + fe))), ye = 0; ye < ae; ++ye) if (me[ye] !== n[1 + fe + ye]) return null;
  return he;
}
function mt$1(c) {
  var t = new Error();
  this.name = t.name = "ValidationError", this.message = t.message = c, this.stack = t.stack;
}
function wt$1(c, t) {
  if (t == null && (t = "Assertion failed."), !c) throw new mt$1(t);
}
mt$1.prototype = Object.create(Error.prototype);
var bt$1 = function() {
  function c(t, n) {
    this.hi = 0 | t, this.lo = 0 | n;
  }
  return c.prototype.ushrn32 = function(t) {
    var n = this.lo;
    return (t &= 63) == 0 || (t < 32 ? (n >>>= t, n |= this.hi << 32 - t) : n = this.hi >>> t - 32), n;
  }, c;
}(), _t = Buffer$7.allocUnsafe(105), Bt$1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Et$1 = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 15, -1, 10, 17, 21, 20, 26, 30, 7, 5, -1, -1, -1, -1, -1, -1, -1, 29, -1, 24, 13, 25, 9, 8, 23, -1, 18, 22, 31, 27, 19, -1, 1, 0, 3, 16, 11, 28, 12, 14, 6, 4, 2, -1, -1, -1, -1, -1, -1, 29, -1, 24, 13, 25, 9, 8, 23, -1, 18, 22, 31, 27, 19, -1, 1, 0, 3, 16, 11, 28, 12, 14, 6, 4, 2, -1, -1, -1, -1, -1], It$1 = new bt$1(7, 4294967295), xt$1 = [new bt$1(152, 4072443489), new bt$1(121, 3077413346), new bt$1(243, 1046459332), new bt$1(174, 783016616), new bt$1(30, 1329849456)];
function St$1(c, t) {
  var n = c, ie = n.hi >>> 3;
  n.hi &= It$1.hi, n.lo &= It$1.lo, n.hi <<= 5, n.hi |= n.lo >>> 27, n.lo <<= 5;
  for (var fe = 0; fe < xt$1.length; fe++) ie >>> fe & 1 && (n.hi ^= xt$1[fe].hi, n.lo ^= xt$1[fe].lo);
  return n.lo ^= t, n;
}
function At$1(c, t, n, ie, fe, ae, le) {
  wt$1(Buffer$7.isBuffer(c)), wt$1(t >>> 0 === t), wt$1(Buffer$7.isBuffer(n)), wt$1(ie >>> 0 === ie), wt$1((255 & fe) === fe), wt$1((255 & ae) === ae), wt$1(typeof le == "boolean");
  for (var he = (1 << ae) - 1, me = 0, ye = 0; t < c.length; t++) {
    var be = c[t];
    if (be >>> fe) throw new Error("Invalid bits.");
    for (me = me << fe | be, ye += fe; ye >= ae; ) n[ie++] = me >>> (ye -= ae) & he;
  }
  if (le) ye && (n[ie++] = me << ae - ye & he);
  else if (ye >= fe || me << ae - ye & he) throw new Error("Invalid bits.");
  return wt$1(ie <= n.length), n.slice(0, ie);
}
function zt(c, t, n) {
  if (wt$1(typeof c == "string"), wt$1((15 & t) === t, "Invalid cashaddr type."), wt$1(Buffer$7.isBuffer(n)), c.length === 0 || c.length > 83) throw new Error("Invalid cashaddr prefix.");
  var ie = function(ae) {
    switch (wt$1(ae >>> 0 === ae), ae) {
      case 20:
        return 0;
      case 24:
        return 1;
      case 28:
        return 2;
      case 32:
        return 3;
      case 40:
        return 4;
      case 48:
        return 5;
      case 56:
        return 6;
      case 64:
        return 7;
      default:
        throw new Error("Non standard length.");
    }
  }(n.length), fe = Buffer$7.allocUnsafe(n.length + 1);
  return fe[0] = t << 3 | ie, n.copy(fe, 1), function(ae, le) {
    wt$1(typeof ae == "string"), wt$1(Buffer$7.isBuffer(le));
    for (var he = new bt$1(0, 1), me = "", ye = !1, be = !1, Ae = 0; Ae < ae.length; Ae++) {
      var Se = ae.charCodeAt(Ae);
      if (65280 & Se || !(Se >>> 5)) throw new Error("Invalid cashaddr character.");
      if (Se >= 97 && Se <= 122) be = !0;
      else if (Se >= 65 && Se <= 90) ye = !0, Se = Se - 65 + 97;
      else if (Se >= 48 && Se <= 57) throw new Error("Invalid cashaddr prefix.");
      St$1(he, 31 & Se), me += String.fromCharCode(Se);
    }
    if (be && ye) throw new Error("Invalid cashaddr prefix.");
    St$1(he, 0), me += ":";
    for (var $e = 0; $e < le.length; $e++) {
      var Re = le[$e];
      if (Re >>> 5) throw new Error("Invalid cashaddr value.");
      St$1(he, Re), me += Bt$1[Re];
    }
    for (var Me = 0; Me < 8; Me++) St$1(he, 0);
    he.lo ^= 1;
    for (var ke = 0; ke < 8; ke++) {
      var Te = 31 & he.ushrn32(5 * (7 - ke));
      me += Bt$1[Te];
    }
    return me;
  }(c, At$1(fe, 0, _t, 0, 8, 5, !0));
}
function kt(c, t) {
  t === void 0 && (t = "bitcoincash"), wt$1(typeof c == "string"), wt$1(typeof t == "string");
  var n = function(be, Ae) {
    if (wt$1(typeof be == "string"), be.length < 8 || be.length > 196) throw new Error("Invalid cashaddr data length.");
    for (var Se = !1, $e = !1, Re = !1, Me = 0, ke = 0; ke < be.length; ke++) {
      var Te = be.charCodeAt(ke);
      if (Te >= 97 && Te <= 122) Se = !0;
      else if (Te >= 65 && Te <= 90) $e = !0;
      else if (Te >= 48 && Te <= 57) Re = !0;
      else {
        if (Te !== 58) throw new Error("Invalid cashaddr character.");
        if (Re || ke === 0 || ke > 83) throw new Error("Invalid cashaddr prefix.");
        if (Me !== 0) throw new Error("Invalid cashaddr separators.");
        Me = ke;
      }
    }
    if ($e && Se) throw new Error("Invalid cashaddr casing.");
    var Ie, qe = new bt$1(0, 1);
    Me === 0 ? Ie = Ae.toLowerCase() : (Ie = be.substring(0, Me).toLowerCase(), Me += 1);
    for (var Ue = 0; Ue < Ie.length; Ue++) St$1(qe, 31 & (32 | Ie.charCodeAt(Ue)));
    St$1(qe, 0);
    var ze = be.length - Me;
    if (ze <= 8 || ze > 112) throw new Error("Invalid cashaddr data length.");
    for (var Ve = Buffer$7.allocUnsafe(ze), Mt = Me; Mt < be.length; Mt++) {
      var Rt = be.charCodeAt(Mt), je = 65408 & Rt ? -1 : Et$1[Rt];
      if (je === -1) throw new Error("Invalid cashaddr character.");
      St$1(qe, je), Mt + 8 < be.length && (Ve[Mt - Me] = je);
    }
    if (qe.hi !== 0 || qe.lo !== 1 || Ie !== Ae) throw new Error("Invalid cashaddr checksum.");
    return [Ie, Ve.slice(0, -8)];
  }(c, t), ie = n[0], fe = n[1], ae = 5 * fe.length & 7;
  if (ae >= 5) throw new Error("Invalid padding in data.");
  if (fe[fe.length - 1] & (1 << ae) - 1) throw new Error("Non zero padding.");
  var le = At$1(fe, 0, fe, 0, 5, 8, !1), he = le[0] >>> 3 & 31, me = le.slice(1), ye = 20 + 4 * (3 & le[0]);
  if (4 & le[0] && (ye *= 2), ye !== me.length) throw new Error("Invalid cashaddr data length.");
  return { prefix: ie, type: he, hash: me };
}
var Ot$1 = /* @__PURE__ */ function(c) {
  function t(n) {
    var ie = n.slice(0, -4), fe = n.slice(-4), ae = c(ie);
    if (!(fe[0] ^ ae[0] | fe[1] ^ ae[1] | fe[2] ^ ae[2] | fe[3] ^ ae[3])) return ie;
  }
  return { bs58Encode: function(n) {
    var ie = c(n);
    return o$1.encode(Buffer$7.concat([n, ie], n.length + 4));
  }, bs58Decode: function(n) {
    var ie = t(o$1.decode(n));
    if (!ie) throw new Error("Invalid checksum");
    return ie;
  }, decodeUnsafe: function(n) {
    var ie = o$1.decodeUnsafe(n);
    if (ie) return t(ie);
  } };
}(function(c) {
  var t = new B$1().update(c).digest();
  return new B$1().update(t).digest();
}), Ct$1 = Ot$1.bs58Decode, Ut$1 = Ot$1.bs58Encode, crc = { exports: {} };
(function(c) {
  (function() {
    var t = typeof window == "object" ? window : {}, n = !t.JS_CRC_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    n && (t = globalThis);
    var ie = !t.JS_CRC_NO_COMMON_JS && !0 && c.exports, fe = !t.JS_CRC_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", ae = "0123456789abcdef".split(""), le = [
      {
        name: "crc32",
        polynom: 3988292384,
        initValue: -1,
        bytes: 4
      },
      {
        name: "crc16",
        polynom: 40961,
        initValue: 0,
        bytes: 2
      }
    ], he, me, ye, be;
    for (he = 0; he < le.length; ++he) {
      var Ae = le[he];
      for (Ae.method = /* @__PURE__ */ function(Re) {
        return function(Me) {
          return Se(Me, Re);
        };
      }(Ae), Ae.table = [], me = 0; me < 256; ++me) {
        for (be = me, ye = 0; ye < 8; ++ye)
          be = be & 1 ? Ae.polynom ^ be >>> 1 : be >>> 1;
        Ae.table[me] = be >>> 0;
      }
    }
    var Se = function(Re, Me) {
      var ke = typeof Re != "string";
      ke && fe && Re instanceof ArrayBuffer && (Re = new Uint8Array(Re));
      var Te = Me.initValue, Ie, qe, Ue = Re.length, ze = Me.table;
      if (ke)
        for (qe = 0; qe < Ue; ++qe)
          Te = ze[(Te ^ Re[qe]) & 255] ^ Te >>> 8;
      else
        for (qe = 0; qe < Ue; ++qe)
          Ie = Re.charCodeAt(qe), Ie < 128 ? Te = ze[(Te ^ Ie) & 255] ^ Te >>> 8 : Ie < 2048 ? (Te = ze[(Te ^ (192 | Ie >> 6)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie & 63)) & 255] ^ Te >>> 8) : Ie < 55296 || Ie >= 57344 ? (Te = ze[(Te ^ (224 | Ie >> 12)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie >> 6 & 63)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie & 63)) & 255] ^ Te >>> 8) : (Ie = 65536 + ((Ie & 1023) << 10 | Re.charCodeAt(++qe) & 1023), Te = ze[(Te ^ (240 | Ie >> 18)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie >> 12 & 63)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie >> 6 & 63)) & 255] ^ Te >>> 8, Te = ze[(Te ^ (128 | Ie & 63)) & 255] ^ Te >>> 8);
      Te ^= Me.initValue;
      var Ve = "";
      return Me.bytes > 2 && (Ve += ae[Te >> 28 & 15] + ae[Te >> 24 & 15] + ae[Te >> 20 & 15] + ae[Te >> 16 & 15]), Ve += ae[Te >> 12 & 15] + ae[Te >> 8 & 15] + ae[Te >> 4 & 15] + ae[Te & 15], Ve;
    }, $e = {};
    for (he = 0; he < le.length; ++he) {
      var Ae = le[he];
      $e[Ae.name] = Ae.method;
    }
    if (ie)
      c.exports = $e;
    else
      for (he = 0; he < le.length; ++he) {
        var Ae = le[he];
        t[Ae.name] = Ae.method;
      }
  })();
})(crc);
var crcExports = crc.exports, sha512$2 = { exports: {} };
(function(c) {
  (function() {
    var t = "input is invalid type", n = "finalize already called", ie = typeof window == "object", fe = ie ? window : {};
    fe.JS_SHA512_NO_WINDOW && (ie = !1);
    var ae = !ie && typeof self == "object", le = !fe.JS_SHA512_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    le ? fe = globalThis : ae && (fe = self);
    var he = !fe.JS_SHA512_NO_COMMON_JS && !0 && c.exports, me = !fe.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", ye = "0123456789abcdef".split(""), be = [-2147483648, 8388608, 32768, 128], Ae = [24, 16, 8, 0], Se = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ], $e = ["hex", "array", "digest", "arrayBuffer"], Re = [];
    (fe.JS_SHA512_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Ve) {
      return Object.prototype.toString.call(Ve) === "[object Array]";
    }), me && (fe.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Ve) {
      return typeof Ve == "object" && Ve.buffer && Ve.buffer.constructor === ArrayBuffer;
    });
    var Me = function(Ve, Mt) {
      return function(Rt) {
        return new qe(Mt, !0).update(Rt)[Ve]();
      };
    }, ke = function(Ve) {
      var Mt = Me("hex", Ve);
      Mt.create = function() {
        return new qe(Ve);
      }, Mt.update = function(jt) {
        return Mt.create().update(jt);
      };
      for (var Rt = 0; Rt < $e.length; ++Rt) {
        var je = $e[Rt];
        Mt[je] = Me(je, Ve);
      }
      return Mt;
    }, Te = function(Ve, Mt) {
      return function(Rt, je) {
        return new Ue(Rt, Mt, !0).update(je)[Ve]();
      };
    }, Ie = function(Ve) {
      var Mt = Te("hex", Ve);
      Mt.create = function(jt) {
        return new Ue(jt, Ve);
      }, Mt.update = function(jt, _e) {
        return Mt.create(jt).update(_e);
      };
      for (var Rt = 0; Rt < $e.length; ++Rt) {
        var je = $e[Rt];
        Mt[je] = Te(je, Ve);
      }
      return Mt;
    };
    function qe(Ve, Mt) {
      Mt ? (Re[0] = Re[1] = Re[2] = Re[3] = Re[4] = Re[5] = Re[6] = Re[7] = Re[8] = Re[9] = Re[10] = Re[11] = Re[12] = Re[13] = Re[14] = Re[15] = Re[16] = Re[17] = Re[18] = Re[19] = Re[20] = Re[21] = Re[22] = Re[23] = Re[24] = Re[25] = Re[26] = Re[27] = Re[28] = Re[29] = Re[30] = Re[31] = Re[32] = 0, this.blocks = Re) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], Ve == 384 ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : Ve == 256 ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : Ve == 224 ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = Ve, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
    }
    qe.prototype.update = function(Ve) {
      if (this.finalized)
        throw new Error(n);
      var Mt, Rt = typeof Ve;
      if (Rt !== "string") {
        if (Rt === "object") {
          if (Ve === null)
            throw new Error(t);
          if (me && Ve.constructor === ArrayBuffer)
            Ve = new Uint8Array(Ve);
          else if (!Array.isArray(Ve) && (!me || !ArrayBuffer.isView(Ve)))
            throw new Error(t);
        } else
          throw new Error(t);
        Mt = !0;
      }
      for (var je, jt = 0, _e, se = Ve.length, ce = this.blocks; jt < se; ) {
        if (this.hashed && (this.hashed = !1, ce[0] = this.block, ce[1] = ce[2] = ce[3] = ce[4] = ce[5] = ce[6] = ce[7] = ce[8] = ce[9] = ce[10] = ce[11] = ce[12] = ce[13] = ce[14] = ce[15] = ce[16] = ce[17] = ce[18] = ce[19] = ce[20] = ce[21] = ce[22] = ce[23] = ce[24] = ce[25] = ce[26] = ce[27] = ce[28] = ce[29] = ce[30] = ce[31] = ce[32] = 0), Mt)
          for (_e = this.start; jt < se && _e < 128; ++jt)
            ce[_e >> 2] |= Ve[jt] << Ae[_e++ & 3];
        else
          for (_e = this.start; jt < se && _e < 128; ++jt)
            je = Ve.charCodeAt(jt), je < 128 ? ce[_e >> 2] |= je << Ae[_e++ & 3] : je < 2048 ? (ce[_e >> 2] |= (192 | je >> 6) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je & 63) << Ae[_e++ & 3]) : je < 55296 || je >= 57344 ? (ce[_e >> 2] |= (224 | je >> 12) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je >> 6 & 63) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je & 63) << Ae[_e++ & 3]) : (je = 65536 + ((je & 1023) << 10 | Ve.charCodeAt(++jt) & 1023), ce[_e >> 2] |= (240 | je >> 18) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je >> 12 & 63) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je >> 6 & 63) << Ae[_e++ & 3], ce[_e >> 2] |= (128 | je & 63) << Ae[_e++ & 3]);
        this.lastByteIndex = _e, this.bytes += _e - this.start, _e >= 128 ? (this.block = ce[32], this.start = _e - 128, this.hash(), this.hashed = !0) : this.start = _e;
      }
      return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
    }, qe.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Ve = this.blocks, Mt = this.lastByteIndex;
        Ve[32] = this.block, Ve[Mt >> 2] |= be[Mt & 3], this.block = Ve[32], Mt >= 112 && (this.hashed || this.hash(), Ve[0] = this.block, Ve[1] = Ve[2] = Ve[3] = Ve[4] = Ve[5] = Ve[6] = Ve[7] = Ve[8] = Ve[9] = Ve[10] = Ve[11] = Ve[12] = Ve[13] = Ve[14] = Ve[15] = Ve[16] = Ve[17] = Ve[18] = Ve[19] = Ve[20] = Ve[21] = Ve[22] = Ve[23] = Ve[24] = Ve[25] = Ve[26] = Ve[27] = Ve[28] = Ve[29] = Ve[30] = Ve[31] = Ve[32] = 0), Ve[30] = this.hBytes << 3 | this.bytes >>> 29, Ve[31] = this.bytes << 3, this.hash();
      }
    }, qe.prototype.hash = function() {
      var Ve = this.h0h, Mt = this.h0l, Rt = this.h1h, je = this.h1l, jt = this.h2h, _e = this.h2l, se = this.h3h, ce = this.h3l, de = this.h4h, pe = this.h4l, ve = this.h5h, we = this.h5l, Ee = this.h6h, xe = this.h6l, ue = this.h7h, ge = this.h7l, Be = this.blocks, Ne, Fe, Pe, Je, Ke, Ze, Ye, Pt, Ft, Le, $t, Jt, Ht, Vt, xn, Zt, Gt, An, Qt, Xt, wn, Qe, Dt, en, We;
      for (Ne = 32; Ne < 160; Ne += 2)
        Xt = Be[Ne - 30], wn = Be[Ne - 29], Fe = (Xt >>> 1 | wn << 31) ^ (Xt >>> 8 | wn << 24) ^ Xt >>> 7, Pe = (wn >>> 1 | Xt << 31) ^ (wn >>> 8 | Xt << 24) ^ (wn >>> 7 | Xt << 25), Xt = Be[Ne - 4], wn = Be[Ne - 3], Je = (Xt >>> 19 | wn << 13) ^ (wn >>> 29 | Xt << 3) ^ Xt >>> 6, Ke = (wn >>> 19 | Xt << 13) ^ (Xt >>> 29 | wn << 3) ^ (wn >>> 6 | Xt << 26), Xt = Be[Ne - 32], wn = Be[Ne - 31], Qe = Be[Ne - 14], Dt = Be[Ne - 13], Ze = (Dt & 65535) + (wn & 65535) + (Pe & 65535) + (Ke & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (Pe >>> 16) + (Ke >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (Fe & 65535) + (Je & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (Fe >>> 16) + (Je >>> 16) + (Pt >>> 16), Be[Ne] = Ft << 16 | Pt & 65535, Be[Ne + 1] = Ye << 16 | Ze & 65535;
      var De = Ve, Ge = Mt, Oe = Rt, Ce = je, He = jt, Xe = _e, Kt = se, tn = ce, Wt = de, Yt = pe, _n = ve, rn = we, nn = Ee, En = xe, an = ue, dn = ge;
      for (Zt = Oe & He, Gt = Ce & Xe, Ne = 0; Ne < 160; Ne += 8)
        Fe = (De >>> 28 | Ge << 4) ^ (Ge >>> 2 | De << 30) ^ (Ge >>> 7 | De << 25), Pe = (Ge >>> 28 | De << 4) ^ (De >>> 2 | Ge << 30) ^ (De >>> 7 | Ge << 25), Je = (Wt >>> 14 | Yt << 18) ^ (Wt >>> 18 | Yt << 14) ^ (Yt >>> 9 | Wt << 23), Ke = (Yt >>> 14 | Wt << 18) ^ (Yt >>> 18 | Wt << 14) ^ (Wt >>> 9 | Yt << 23), Le = De & Oe, $t = Ge & Ce, An = Le ^ De & He ^ Zt, Qt = $t ^ Ge & Xe ^ Gt, en = Wt & _n ^ ~Wt & nn, We = Yt & rn ^ ~Yt & En, Xt = Be[Ne], wn = Be[Ne + 1], Qe = Se[Ne], Dt = Se[Ne + 1], Ze = (Dt & 65535) + (wn & 65535) + (We & 65535) + (Ke & 65535) + (dn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (We >>> 16) + (Ke >>> 16) + (dn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (en & 65535) + (Je & 65535) + (an & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (en >>> 16) + (Je >>> 16) + (an >>> 16) + (Pt >>> 16), Xt = Ft << 16 | Pt & 65535, wn = Ye << 16 | Ze & 65535, Ze = (Qt & 65535) + (Pe & 65535), Ye = (Qt >>> 16) + (Pe >>> 16) + (Ze >>> 16), Pt = (An & 65535) + (Fe & 65535) + (Ye >>> 16), Ft = (An >>> 16) + (Fe >>> 16) + (Pt >>> 16), Qe = Ft << 16 | Pt & 65535, Dt = Ye << 16 | Ze & 65535, Ze = (tn & 65535) + (wn & 65535), Ye = (tn >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Kt & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Kt >>> 16) + (Xt >>> 16) + (Pt >>> 16), an = Ft << 16 | Pt & 65535, dn = Ye << 16 | Ze & 65535, Ze = (Dt & 65535) + (wn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (Pt >>> 16), Kt = Ft << 16 | Pt & 65535, tn = Ye << 16 | Ze & 65535, Fe = (Kt >>> 28 | tn << 4) ^ (tn >>> 2 | Kt << 30) ^ (tn >>> 7 | Kt << 25), Pe = (tn >>> 28 | Kt << 4) ^ (Kt >>> 2 | tn << 30) ^ (Kt >>> 7 | tn << 25), Je = (an >>> 14 | dn << 18) ^ (an >>> 18 | dn << 14) ^ (dn >>> 9 | an << 23), Ke = (dn >>> 14 | an << 18) ^ (dn >>> 18 | an << 14) ^ (an >>> 9 | dn << 23), Jt = Kt & De, Ht = tn & Ge, An = Jt ^ Kt & Oe ^ Le, Qt = Ht ^ tn & Ce ^ $t, en = an & Wt ^ ~an & _n, We = dn & Yt ^ ~dn & rn, Xt = Be[Ne + 2], wn = Be[Ne + 3], Qe = Se[Ne + 2], Dt = Se[Ne + 3], Ze = (Dt & 65535) + (wn & 65535) + (We & 65535) + (Ke & 65535) + (En & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (We >>> 16) + (Ke >>> 16) + (En >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (en & 65535) + (Je & 65535) + (nn & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (en >>> 16) + (Je >>> 16) + (nn >>> 16) + (Pt >>> 16), Xt = Ft << 16 | Pt & 65535, wn = Ye << 16 | Ze & 65535, Ze = (Qt & 65535) + (Pe & 65535), Ye = (Qt >>> 16) + (Pe >>> 16) + (Ze >>> 16), Pt = (An & 65535) + (Fe & 65535) + (Ye >>> 16), Ft = (An >>> 16) + (Fe >>> 16) + (Pt >>> 16), Qe = Ft << 16 | Pt & 65535, Dt = Ye << 16 | Ze & 65535, Ze = (Xe & 65535) + (wn & 65535), Ye = (Xe >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (He & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (He >>> 16) + (Xt >>> 16) + (Pt >>> 16), nn = Ft << 16 | Pt & 65535, En = Ye << 16 | Ze & 65535, Ze = (Dt & 65535) + (wn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (Pt >>> 16), He = Ft << 16 | Pt & 65535, Xe = Ye << 16 | Ze & 65535, Fe = (He >>> 28 | Xe << 4) ^ (Xe >>> 2 | He << 30) ^ (Xe >>> 7 | He << 25), Pe = (Xe >>> 28 | He << 4) ^ (He >>> 2 | Xe << 30) ^ (He >>> 7 | Xe << 25), Je = (nn >>> 14 | En << 18) ^ (nn >>> 18 | En << 14) ^ (En >>> 9 | nn << 23), Ke = (En >>> 14 | nn << 18) ^ (En >>> 18 | nn << 14) ^ (nn >>> 9 | En << 23), Vt = He & Kt, xn = Xe & tn, An = Vt ^ He & De ^ Jt, Qt = xn ^ Xe & Ge ^ Ht, en = nn & an ^ ~nn & Wt, We = En & dn ^ ~En & Yt, Xt = Be[Ne + 4], wn = Be[Ne + 5], Qe = Se[Ne + 4], Dt = Se[Ne + 5], Ze = (Dt & 65535) + (wn & 65535) + (We & 65535) + (Ke & 65535) + (rn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (We >>> 16) + (Ke >>> 16) + (rn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (en & 65535) + (Je & 65535) + (_n & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (en >>> 16) + (Je >>> 16) + (_n >>> 16) + (Pt >>> 16), Xt = Ft << 16 | Pt & 65535, wn = Ye << 16 | Ze & 65535, Ze = (Qt & 65535) + (Pe & 65535), Ye = (Qt >>> 16) + (Pe >>> 16) + (Ze >>> 16), Pt = (An & 65535) + (Fe & 65535) + (Ye >>> 16), Ft = (An >>> 16) + (Fe >>> 16) + (Pt >>> 16), Qe = Ft << 16 | Pt & 65535, Dt = Ye << 16 | Ze & 65535, Ze = (Ce & 65535) + (wn & 65535), Ye = (Ce >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Oe & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Oe >>> 16) + (Xt >>> 16) + (Pt >>> 16), _n = Ft << 16 | Pt & 65535, rn = Ye << 16 | Ze & 65535, Ze = (Dt & 65535) + (wn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (Pt >>> 16), Oe = Ft << 16 | Pt & 65535, Ce = Ye << 16 | Ze & 65535, Fe = (Oe >>> 28 | Ce << 4) ^ (Ce >>> 2 | Oe << 30) ^ (Ce >>> 7 | Oe << 25), Pe = (Ce >>> 28 | Oe << 4) ^ (Oe >>> 2 | Ce << 30) ^ (Oe >>> 7 | Ce << 25), Je = (_n >>> 14 | rn << 18) ^ (_n >>> 18 | rn << 14) ^ (rn >>> 9 | _n << 23), Ke = (rn >>> 14 | _n << 18) ^ (rn >>> 18 | _n << 14) ^ (_n >>> 9 | rn << 23), Zt = Oe & He, Gt = Ce & Xe, An = Zt ^ Oe & Kt ^ Vt, Qt = Gt ^ Ce & tn ^ xn, en = _n & nn ^ ~_n & an, We = rn & En ^ ~rn & dn, Xt = Be[Ne + 6], wn = Be[Ne + 7], Qe = Se[Ne + 6], Dt = Se[Ne + 7], Ze = (Dt & 65535) + (wn & 65535) + (We & 65535) + (Ke & 65535) + (Yt & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (We >>> 16) + (Ke >>> 16) + (Yt >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (en & 65535) + (Je & 65535) + (Wt & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (en >>> 16) + (Je >>> 16) + (Wt >>> 16) + (Pt >>> 16), Xt = Ft << 16 | Pt & 65535, wn = Ye << 16 | Ze & 65535, Ze = (Qt & 65535) + (Pe & 65535), Ye = (Qt >>> 16) + (Pe >>> 16) + (Ze >>> 16), Pt = (An & 65535) + (Fe & 65535) + (Ye >>> 16), Ft = (An >>> 16) + (Fe >>> 16) + (Pt >>> 16), Qe = Ft << 16 | Pt & 65535, Dt = Ye << 16 | Ze & 65535, Ze = (Ge & 65535) + (wn & 65535), Ye = (Ge >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (De & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (De >>> 16) + (Xt >>> 16) + (Pt >>> 16), Wt = Ft << 16 | Pt & 65535, Yt = Ye << 16 | Ze & 65535, Ze = (Dt & 65535) + (wn & 65535), Ye = (Dt >>> 16) + (wn >>> 16) + (Ze >>> 16), Pt = (Qe & 65535) + (Xt & 65535) + (Ye >>> 16), Ft = (Qe >>> 16) + (Xt >>> 16) + (Pt >>> 16), De = Ft << 16 | Pt & 65535, Ge = Ye << 16 | Ze & 65535;
      Ze = (Mt & 65535) + (Ge & 65535), Ye = (Mt >>> 16) + (Ge >>> 16) + (Ze >>> 16), Pt = (Ve & 65535) + (De & 65535) + (Ye >>> 16), Ft = (Ve >>> 16) + (De >>> 16) + (Pt >>> 16), this.h0h = Ft << 16 | Pt & 65535, this.h0l = Ye << 16 | Ze & 65535, Ze = (je & 65535) + (Ce & 65535), Ye = (je >>> 16) + (Ce >>> 16) + (Ze >>> 16), Pt = (Rt & 65535) + (Oe & 65535) + (Ye >>> 16), Ft = (Rt >>> 16) + (Oe >>> 16) + (Pt >>> 16), this.h1h = Ft << 16 | Pt & 65535, this.h1l = Ye << 16 | Ze & 65535, Ze = (_e & 65535) + (Xe & 65535), Ye = (_e >>> 16) + (Xe >>> 16) + (Ze >>> 16), Pt = (jt & 65535) + (He & 65535) + (Ye >>> 16), Ft = (jt >>> 16) + (He >>> 16) + (Pt >>> 16), this.h2h = Ft << 16 | Pt & 65535, this.h2l = Ye << 16 | Ze & 65535, Ze = (ce & 65535) + (tn & 65535), Ye = (ce >>> 16) + (tn >>> 16) + (Ze >>> 16), Pt = (se & 65535) + (Kt & 65535) + (Ye >>> 16), Ft = (se >>> 16) + (Kt >>> 16) + (Pt >>> 16), this.h3h = Ft << 16 | Pt & 65535, this.h3l = Ye << 16 | Ze & 65535, Ze = (pe & 65535) + (Yt & 65535), Ye = (pe >>> 16) + (Yt >>> 16) + (Ze >>> 16), Pt = (de & 65535) + (Wt & 65535) + (Ye >>> 16), Ft = (de >>> 16) + (Wt >>> 16) + (Pt >>> 16), this.h4h = Ft << 16 | Pt & 65535, this.h4l = Ye << 16 | Ze & 65535, Ze = (we & 65535) + (rn & 65535), Ye = (we >>> 16) + (rn >>> 16) + (Ze >>> 16), Pt = (ve & 65535) + (_n & 65535) + (Ye >>> 16), Ft = (ve >>> 16) + (_n >>> 16) + (Pt >>> 16), this.h5h = Ft << 16 | Pt & 65535, this.h5l = Ye << 16 | Ze & 65535, Ze = (xe & 65535) + (En & 65535), Ye = (xe >>> 16) + (En >>> 16) + (Ze >>> 16), Pt = (Ee & 65535) + (nn & 65535) + (Ye >>> 16), Ft = (Ee >>> 16) + (nn >>> 16) + (Pt >>> 16), this.h6h = Ft << 16 | Pt & 65535, this.h6l = Ye << 16 | Ze & 65535, Ze = (ge & 65535) + (dn & 65535), Ye = (ge >>> 16) + (dn >>> 16) + (Ze >>> 16), Pt = (ue & 65535) + (an & 65535) + (Ye >>> 16), Ft = (ue >>> 16) + (an >>> 16) + (Pt >>> 16), this.h7h = Ft << 16 | Pt & 65535, this.h7l = Ye << 16 | Ze & 65535;
    }, qe.prototype.hex = function() {
      this.finalize();
      var Ve = this.h0h, Mt = this.h0l, Rt = this.h1h, je = this.h1l, jt = this.h2h, _e = this.h2l, se = this.h3h, ce = this.h3l, de = this.h4h, pe = this.h4l, ve = this.h5h, we = this.h5l, Ee = this.h6h, xe = this.h6l, ue = this.h7h, ge = this.h7l, Be = this.bits, Ne = ye[Ve >> 28 & 15] + ye[Ve >> 24 & 15] + ye[Ve >> 20 & 15] + ye[Ve >> 16 & 15] + ye[Ve >> 12 & 15] + ye[Ve >> 8 & 15] + ye[Ve >> 4 & 15] + ye[Ve & 15] + ye[Mt >> 28 & 15] + ye[Mt >> 24 & 15] + ye[Mt >> 20 & 15] + ye[Mt >> 16 & 15] + ye[Mt >> 12 & 15] + ye[Mt >> 8 & 15] + ye[Mt >> 4 & 15] + ye[Mt & 15] + ye[Rt >> 28 & 15] + ye[Rt >> 24 & 15] + ye[Rt >> 20 & 15] + ye[Rt >> 16 & 15] + ye[Rt >> 12 & 15] + ye[Rt >> 8 & 15] + ye[Rt >> 4 & 15] + ye[Rt & 15] + ye[je >> 28 & 15] + ye[je >> 24 & 15] + ye[je >> 20 & 15] + ye[je >> 16 & 15] + ye[je >> 12 & 15] + ye[je >> 8 & 15] + ye[je >> 4 & 15] + ye[je & 15] + ye[jt >> 28 & 15] + ye[jt >> 24 & 15] + ye[jt >> 20 & 15] + ye[jt >> 16 & 15] + ye[jt >> 12 & 15] + ye[jt >> 8 & 15] + ye[jt >> 4 & 15] + ye[jt & 15] + ye[_e >> 28 & 15] + ye[_e >> 24 & 15] + ye[_e >> 20 & 15] + ye[_e >> 16 & 15] + ye[_e >> 12 & 15] + ye[_e >> 8 & 15] + ye[_e >> 4 & 15] + ye[_e & 15] + ye[se >> 28 & 15] + ye[se >> 24 & 15] + ye[se >> 20 & 15] + ye[se >> 16 & 15] + ye[se >> 12 & 15] + ye[se >> 8 & 15] + ye[se >> 4 & 15] + ye[se & 15];
      return Be >= 256 && (Ne += ye[ce >> 28 & 15] + ye[ce >> 24 & 15] + ye[ce >> 20 & 15] + ye[ce >> 16 & 15] + ye[ce >> 12 & 15] + ye[ce >> 8 & 15] + ye[ce >> 4 & 15] + ye[ce & 15]), Be >= 384 && (Ne += ye[de >> 28 & 15] + ye[de >> 24 & 15] + ye[de >> 20 & 15] + ye[de >> 16 & 15] + ye[de >> 12 & 15] + ye[de >> 8 & 15] + ye[de >> 4 & 15] + ye[de & 15] + ye[pe >> 28 & 15] + ye[pe >> 24 & 15] + ye[pe >> 20 & 15] + ye[pe >> 16 & 15] + ye[pe >> 12 & 15] + ye[pe >> 8 & 15] + ye[pe >> 4 & 15] + ye[pe & 15] + ye[ve >> 28 & 15] + ye[ve >> 24 & 15] + ye[ve >> 20 & 15] + ye[ve >> 16 & 15] + ye[ve >> 12 & 15] + ye[ve >> 8 & 15] + ye[ve >> 4 & 15] + ye[ve & 15] + ye[we >> 28 & 15] + ye[we >> 24 & 15] + ye[we >> 20 & 15] + ye[we >> 16 & 15] + ye[we >> 12 & 15] + ye[we >> 8 & 15] + ye[we >> 4 & 15] + ye[we & 15]), Be == 512 && (Ne += ye[Ee >> 28 & 15] + ye[Ee >> 24 & 15] + ye[Ee >> 20 & 15] + ye[Ee >> 16 & 15] + ye[Ee >> 12 & 15] + ye[Ee >> 8 & 15] + ye[Ee >> 4 & 15] + ye[Ee & 15] + ye[xe >> 28 & 15] + ye[xe >> 24 & 15] + ye[xe >> 20 & 15] + ye[xe >> 16 & 15] + ye[xe >> 12 & 15] + ye[xe >> 8 & 15] + ye[xe >> 4 & 15] + ye[xe & 15] + ye[ue >> 28 & 15] + ye[ue >> 24 & 15] + ye[ue >> 20 & 15] + ye[ue >> 16 & 15] + ye[ue >> 12 & 15] + ye[ue >> 8 & 15] + ye[ue >> 4 & 15] + ye[ue & 15] + ye[ge >> 28 & 15] + ye[ge >> 24 & 15] + ye[ge >> 20 & 15] + ye[ge >> 16 & 15] + ye[ge >> 12 & 15] + ye[ge >> 8 & 15] + ye[ge >> 4 & 15] + ye[ge & 15]), Ne;
    }, qe.prototype.toString = qe.prototype.hex, qe.prototype.digest = function() {
      this.finalize();
      var Ve = this.h0h, Mt = this.h0l, Rt = this.h1h, je = this.h1l, jt = this.h2h, _e = this.h2l, se = this.h3h, ce = this.h3l, de = this.h4h, pe = this.h4l, ve = this.h5h, we = this.h5l, Ee = this.h6h, xe = this.h6l, ue = this.h7h, ge = this.h7l, Be = this.bits, Ne = [
        Ve >> 24 & 255,
        Ve >> 16 & 255,
        Ve >> 8 & 255,
        Ve & 255,
        Mt >> 24 & 255,
        Mt >> 16 & 255,
        Mt >> 8 & 255,
        Mt & 255,
        Rt >> 24 & 255,
        Rt >> 16 & 255,
        Rt >> 8 & 255,
        Rt & 255,
        je >> 24 & 255,
        je >> 16 & 255,
        je >> 8 & 255,
        je & 255,
        jt >> 24 & 255,
        jt >> 16 & 255,
        jt >> 8 & 255,
        jt & 255,
        _e >> 24 & 255,
        _e >> 16 & 255,
        _e >> 8 & 255,
        _e & 255,
        se >> 24 & 255,
        se >> 16 & 255,
        se >> 8 & 255,
        se & 255
      ];
      return Be >= 256 && Ne.push(ce >> 24 & 255, ce >> 16 & 255, ce >> 8 & 255, ce & 255), Be >= 384 && Ne.push(
        de >> 24 & 255,
        de >> 16 & 255,
        de >> 8 & 255,
        de & 255,
        pe >> 24 & 255,
        pe >> 16 & 255,
        pe >> 8 & 255,
        pe & 255,
        ve >> 24 & 255,
        ve >> 16 & 255,
        ve >> 8 & 255,
        ve & 255,
        we >> 24 & 255,
        we >> 16 & 255,
        we >> 8 & 255,
        we & 255
      ), Be == 512 && Ne.push(
        Ee >> 24 & 255,
        Ee >> 16 & 255,
        Ee >> 8 & 255,
        Ee & 255,
        xe >> 24 & 255,
        xe >> 16 & 255,
        xe >> 8 & 255,
        xe & 255,
        ue >> 24 & 255,
        ue >> 16 & 255,
        ue >> 8 & 255,
        ue & 255,
        ge >> 24 & 255,
        ge >> 16 & 255,
        ge >> 8 & 255,
        ge & 255
      ), Ne;
    }, qe.prototype.array = qe.prototype.digest, qe.prototype.arrayBuffer = function() {
      this.finalize();
      var Ve = this.bits, Mt = new ArrayBuffer(Ve / 8), Rt = new DataView(Mt);
      return Rt.setUint32(0, this.h0h), Rt.setUint32(4, this.h0l), Rt.setUint32(8, this.h1h), Rt.setUint32(12, this.h1l), Rt.setUint32(16, this.h2h), Rt.setUint32(20, this.h2l), Rt.setUint32(24, this.h3h), Ve >= 256 && Rt.setUint32(28, this.h3l), Ve >= 384 && (Rt.setUint32(32, this.h4h), Rt.setUint32(36, this.h4l), Rt.setUint32(40, this.h5h), Rt.setUint32(44, this.h5l)), Ve == 512 && (Rt.setUint32(48, this.h6h), Rt.setUint32(52, this.h6l), Rt.setUint32(56, this.h7h), Rt.setUint32(60, this.h7l)), Mt;
    }, qe.prototype.clone = function() {
      var Ve = new qe(this.bits, !1);
      return this.copyTo(Ve), Ve;
    }, qe.prototype.copyTo = function(Ve) {
      var Mt = 0, Rt = [
        "h0h",
        "h0l",
        "h1h",
        "h1l",
        "h2h",
        "h2l",
        "h3h",
        "h3l",
        "h4h",
        "h4l",
        "h5h",
        "h5l",
        "h6h",
        "h6l",
        "h7h",
        "h7l",
        "start",
        "bytes",
        "hBytes",
        "finalized",
        "hashed",
        "lastByteIndex"
      ];
      for (Mt = 0; Mt < Rt.length; ++Mt)
        Ve[Rt[Mt]] = this[Rt[Mt]];
      for (Mt = 0; Mt < this.blocks.length; ++Mt)
        Ve.blocks[Mt] = this.blocks[Mt];
    };
    function Ue(Ve, Mt, Rt) {
      var je, jt = typeof Ve;
      if (jt !== "string") {
        if (jt === "object") {
          if (Ve === null)
            throw new Error(t);
          if (me && Ve.constructor === ArrayBuffer)
            Ve = new Uint8Array(Ve);
          else if (!Array.isArray(Ve) && (!me || !ArrayBuffer.isView(Ve)))
            throw new Error(t);
        } else
          throw new Error(t);
        je = !0;
      }
      var _e = Ve.length;
      if (!je) {
        for (var se = [], _e = Ve.length, ce = 0, de, pe = 0; pe < _e; ++pe)
          de = Ve.charCodeAt(pe), de < 128 ? se[ce++] = de : de < 2048 ? (se[ce++] = 192 | de >> 6, se[ce++] = 128 | de & 63) : de < 55296 || de >= 57344 ? (se[ce++] = 224 | de >> 12, se[ce++] = 128 | de >> 6 & 63, se[ce++] = 128 | de & 63) : (de = 65536 + ((de & 1023) << 10 | Ve.charCodeAt(++pe) & 1023), se[ce++] = 240 | de >> 18, se[ce++] = 128 | de >> 12 & 63, se[ce++] = 128 | de >> 6 & 63, se[ce++] = 128 | de & 63);
        Ve = se;
      }
      Ve.length > 128 && (Ve = new qe(Mt, !0).update(Ve).array());
      for (var ve = [], we = [], pe = 0; pe < 128; ++pe) {
        var Ee = Ve[pe] || 0;
        ve[pe] = 92 ^ Ee, we[pe] = 54 ^ Ee;
      }
      qe.call(this, Mt, Rt), this.update(we), this.oKeyPad = ve, this.inner = !0, this.sharedMemory = Rt;
    }
    Ue.prototype = new qe(), Ue.prototype.finalize = function() {
      if (qe.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var Ve = this.array();
        qe.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(Ve), qe.prototype.finalize.call(this);
      }
    }, Ue.prototype.clone = function() {
      var Ve = new Ue([], this.bits, !1);
      this.copyTo(Ve), Ve.inner = this.inner;
      for (var Mt = 0; Mt < this.oKeyPad.length; ++Mt)
        Ve.oKeyPad[Mt] = this.oKeyPad[Mt];
      return Ve;
    };
    var ze = ke(512);
    ze.sha512 = ze, ze.sha384 = ke(384), ze.sha512_256 = ke(256), ze.sha512_224 = ke(224), ze.sha512.hmac = Ie(512), ze.sha384.hmac = Ie(384), ze.sha512_256.hmac = Ie(256), ze.sha512_224.hmac = Ie(224), he ? c.exports = ze : (fe.sha512 = ze.sha512, fe.sha384 = ze.sha384, fe.sha512_256 = ze.sha512_256, fe.sha512_224 = ze.sha512_224);
  })();
})(sha512$2);
var sha512Exports = sha512$2.exports;
const alphabet = "13456789abcdefghijkmnopqrstuwxyz";
function encode(c) {
  if (c.constructor !== Uint8Array)
    throw new Error("View must be a Uint8Array!");
  const t = c.length, n = t * 8 % 5, ie = n === 0 ? 0 : 5 - n;
  let fe = 0, ae = "", le = 0;
  for (var he = 0; he < t; he++)
    for (fe = fe << 8 | c[he], le += 8; le >= 5; )
      ae += alphabet[fe >>> le + ie - 5 & 31], le -= 5;
  return le > 0 && (ae += alphabet[fe << 5 - (le + ie) & 31]), ae;
}
function readChar(c) {
  var t = alphabet.indexOf(c);
  if (t === -1)
    throw new Error("Invalid character found: " + c);
  return t;
}
function decode$1(c) {
  if (typeof c != "string")
    throw new Error("Input must be a string!");
  var t = c.length;
  const n = t * 5 % 8, ie = n === 0 ? 0 : 8 - n;
  for (var fe = 0, ae = 0, le = 0, he = new Uint8Array(Math.ceil(t * 5 / 8)), me = 0; me < t; me++)
    ae = ae << 5 | readChar(c[me]), fe += 5, fe >= 8 && (he[le++] = ae >>> fe + ie - 8 & 255, fe -= 8);
  return fe > 0 && (he[le++] = ae << fe + ie - 8 & 255), n !== 0 && (he = he.slice(1)), he;
}
var nanoBase32 = {
  encode,
  decode: decode$1
}, sha256$3 = { exports: {} };
(function(module) {
  (function() {
    var ERROR = "input is invalid type", WINDOW = typeof window == "object", root = WINDOW ? window : {};
    root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && typeof self == "object", NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    NODE_JS ? root = globalThis : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && !0 && module.exports, ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", HEX_CHARS = "0123456789abcdef".split(""), EXTRA = [-2147483648, 8388608, 32768, 128], SHIFT = [24, 16, 8, 0], K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"], blocks = [];
    (root.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(c) {
      return Object.prototype.toString.call(c) === "[object Array]";
    }), ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(c) {
      return typeof c == "object" && c.buffer && c.buffer.constructor === ArrayBuffer;
    });
    var createOutputMethod = function(c, t) {
      return function(n) {
        return new Sha256(t, !0).update(n)[c]();
      };
    }, createMethod = function(c) {
      var t = createOutputMethod("hex", c);
      NODE_JS && (t = nodeWrap(t, c)), t.create = function() {
        return new Sha256(c);
      }, t.update = function(fe) {
        return t.create().update(fe);
      };
      for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
        var ie = OUTPUT_TYPES[n];
        t[ie] = createOutputMethod(ie, c);
      }
      return t;
    }, nodeWrap = function(method, is224) {
      var crypto = eval("require('crypto')"), Buffer = eval("require('buffer').Buffer"), algorithm = is224 ? "sha224" : "sha256", nodeMethod = function(c) {
        if (typeof c == "string")
          return crypto.createHash(algorithm).update(c, "utf8").digest("hex");
        if (c == null)
          throw new Error(ERROR);
        return c.constructor === ArrayBuffer && (c = new Uint8Array(c)), Array.isArray(c) || ArrayBuffer.isView(c) || c.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(c)).digest("hex") : method(c);
      };
      return nodeMethod;
    }, createHmacOutputMethod = function(c, t) {
      return function(n, ie) {
        return new HmacSha256(n, t, !0).update(ie)[c]();
      };
    }, createHmacMethod = function(c) {
      var t = createHmacOutputMethod("hex", c);
      t.create = function(fe) {
        return new HmacSha256(fe, c);
      }, t.update = function(fe, ae) {
        return t.create(fe).update(ae);
      };
      for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
        var ie = OUTPUT_TYPES[n];
        t[ie] = createHmacOutputMethod(ie, c);
      }
      return t;
    };
    function Sha256(c, t) {
      t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], c ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = c;
    }
    Sha256.prototype.update = function(c) {
      if (!this.finalized) {
        var t, n = typeof c;
        if (n !== "string") {
          if (n === "object") {
            if (c === null)
              throw new Error(ERROR);
            if (ARRAY_BUFFER && c.constructor === ArrayBuffer)
              c = new Uint8Array(c);
            else if (!Array.isArray(c) && (!ARRAY_BUFFER || !ArrayBuffer.isView(c)))
              throw new Error(ERROR);
          } else
            throw new Error(ERROR);
          t = !0;
        }
        for (var ie, fe = 0, ae, le = c.length, he = this.blocks; fe < le; ) {
          if (this.hashed && (this.hashed = !1, he[0] = this.block, he[16] = he[1] = he[2] = he[3] = he[4] = he[5] = he[6] = he[7] = he[8] = he[9] = he[10] = he[11] = he[12] = he[13] = he[14] = he[15] = 0), t)
            for (ae = this.start; fe < le && ae < 64; ++fe)
              he[ae >> 2] |= c[fe] << SHIFT[ae++ & 3];
          else
            for (ae = this.start; fe < le && ae < 64; ++fe)
              ie = c.charCodeAt(fe), ie < 128 ? he[ae >> 2] |= ie << SHIFT[ae++ & 3] : ie < 2048 ? (he[ae >> 2] |= (192 | ie >> 6) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie & 63) << SHIFT[ae++ & 3]) : ie < 55296 || ie >= 57344 ? (he[ae >> 2] |= (224 | ie >> 12) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie >> 6 & 63) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie & 63) << SHIFT[ae++ & 3]) : (ie = 65536 + ((ie & 1023) << 10 | c.charCodeAt(++fe) & 1023), he[ae >> 2] |= (240 | ie >> 18) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie >> 12 & 63) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie >> 6 & 63) << SHIFT[ae++ & 3], he[ae >> 2] |= (128 | ie & 63) << SHIFT[ae++ & 3]);
          this.lastByteIndex = ae, this.bytes += ae - this.start, ae >= 64 ? (this.block = he[16], this.start = ae - 64, this.hash(), this.hashed = !0) : this.start = ae;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha256.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var c = this.blocks, t = this.lastByteIndex;
        c[16] = this.block, c[t >> 2] |= EXTRA[t & 3], this.block = c[16], t >= 56 && (this.hashed || this.hash(), c[0] = this.block, c[16] = c[1] = c[2] = c[3] = c[4] = c[5] = c[6] = c[7] = c[8] = c[9] = c[10] = c[11] = c[12] = c[13] = c[14] = c[15] = 0), c[14] = this.hBytes << 3 | this.bytes >>> 29, c[15] = this.bytes << 3, this.hash();
      }
    }, Sha256.prototype.hash = function() {
      var c = this.h0, t = this.h1, n = this.h2, ie = this.h3, fe = this.h4, ae = this.h5, le = this.h6, he = this.h7, me = this.blocks, ye, be, Ae, Se, $e, Re, Me, ke, Te, Ie, qe;
      for (ye = 16; ye < 64; ++ye)
        $e = me[ye - 15], be = ($e >>> 7 | $e << 25) ^ ($e >>> 18 | $e << 14) ^ $e >>> 3, $e = me[ye - 2], Ae = ($e >>> 17 | $e << 15) ^ ($e >>> 19 | $e << 13) ^ $e >>> 10, me[ye] = me[ye - 16] + be + me[ye - 7] + Ae << 0;
      for (qe = t & n, ye = 0; ye < 64; ye += 4)
        this.first ? (this.is224 ? (ke = 300032, $e = me[0] - 1413257819, he = $e - 150054599 << 0, ie = $e + 24177077 << 0) : (ke = 704751109, $e = me[0] - 210244248, he = $e - 1521486534 << 0, ie = $e + 143694565 << 0), this.first = !1) : (be = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), Ae = (fe >>> 6 | fe << 26) ^ (fe >>> 11 | fe << 21) ^ (fe >>> 25 | fe << 7), ke = c & t, Se = ke ^ c & n ^ qe, Me = fe & ae ^ ~fe & le, $e = he + Ae + Me + K[ye] + me[ye], Re = be + Se, he = ie + $e << 0, ie = $e + Re << 0), be = (ie >>> 2 | ie << 30) ^ (ie >>> 13 | ie << 19) ^ (ie >>> 22 | ie << 10), Ae = (he >>> 6 | he << 26) ^ (he >>> 11 | he << 21) ^ (he >>> 25 | he << 7), Te = ie & c, Se = Te ^ ie & t ^ ke, Me = he & fe ^ ~he & ae, $e = le + Ae + Me + K[ye + 1] + me[ye + 1], Re = be + Se, le = n + $e << 0, n = $e + Re << 0, be = (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10), Ae = (le >>> 6 | le << 26) ^ (le >>> 11 | le << 21) ^ (le >>> 25 | le << 7), Ie = n & ie, Se = Ie ^ n & c ^ Te, Me = le & he ^ ~le & fe, $e = ae + Ae + Me + K[ye + 2] + me[ye + 2], Re = be + Se, ae = t + $e << 0, t = $e + Re << 0, be = (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10), Ae = (ae >>> 6 | ae << 26) ^ (ae >>> 11 | ae << 21) ^ (ae >>> 25 | ae << 7), qe = t & n, Se = qe ^ t & ie ^ Ie, Me = ae & le ^ ~ae & he, $e = fe + Ae + Me + K[ye + 3] + me[ye + 3], Re = be + Se, fe = c + $e << 0, c = $e + Re << 0;
      this.h0 = this.h0 + c << 0, this.h1 = this.h1 + t << 0, this.h2 = this.h2 + n << 0, this.h3 = this.h3 + ie << 0, this.h4 = this.h4 + fe << 0, this.h5 = this.h5 + ae << 0, this.h6 = this.h6 + le << 0, this.h7 = this.h7 + he << 0;
    }, Sha256.prototype.hex = function() {
      this.finalize();
      var c = this.h0, t = this.h1, n = this.h2, ie = this.h3, fe = this.h4, ae = this.h5, le = this.h6, he = this.h7, me = HEX_CHARS[c >> 28 & 15] + HEX_CHARS[c >> 24 & 15] + HEX_CHARS[c >> 20 & 15] + HEX_CHARS[c >> 16 & 15] + HEX_CHARS[c >> 12 & 15] + HEX_CHARS[c >> 8 & 15] + HEX_CHARS[c >> 4 & 15] + HEX_CHARS[c & 15] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[t & 15] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[n & 15] + HEX_CHARS[ie >> 28 & 15] + HEX_CHARS[ie >> 24 & 15] + HEX_CHARS[ie >> 20 & 15] + HEX_CHARS[ie >> 16 & 15] + HEX_CHARS[ie >> 12 & 15] + HEX_CHARS[ie >> 8 & 15] + HEX_CHARS[ie >> 4 & 15] + HEX_CHARS[ie & 15] + HEX_CHARS[fe >> 28 & 15] + HEX_CHARS[fe >> 24 & 15] + HEX_CHARS[fe >> 20 & 15] + HEX_CHARS[fe >> 16 & 15] + HEX_CHARS[fe >> 12 & 15] + HEX_CHARS[fe >> 8 & 15] + HEX_CHARS[fe >> 4 & 15] + HEX_CHARS[fe & 15] + HEX_CHARS[ae >> 28 & 15] + HEX_CHARS[ae >> 24 & 15] + HEX_CHARS[ae >> 20 & 15] + HEX_CHARS[ae >> 16 & 15] + HEX_CHARS[ae >> 12 & 15] + HEX_CHARS[ae >> 8 & 15] + HEX_CHARS[ae >> 4 & 15] + HEX_CHARS[ae & 15] + HEX_CHARS[le >> 28 & 15] + HEX_CHARS[le >> 24 & 15] + HEX_CHARS[le >> 20 & 15] + HEX_CHARS[le >> 16 & 15] + HEX_CHARS[le >> 12 & 15] + HEX_CHARS[le >> 8 & 15] + HEX_CHARS[le >> 4 & 15] + HEX_CHARS[le & 15];
      return this.is224 || (me += HEX_CHARS[he >> 28 & 15] + HEX_CHARS[he >> 24 & 15] + HEX_CHARS[he >> 20 & 15] + HEX_CHARS[he >> 16 & 15] + HEX_CHARS[he >> 12 & 15] + HEX_CHARS[he >> 8 & 15] + HEX_CHARS[he >> 4 & 15] + HEX_CHARS[he & 15]), me;
    }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function() {
      this.finalize();
      var c = this.h0, t = this.h1, n = this.h2, ie = this.h3, fe = this.h4, ae = this.h5, le = this.h6, he = this.h7, me = [
        c >> 24 & 255,
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        t >> 24 & 255,
        t >> 16 & 255,
        t >> 8 & 255,
        t & 255,
        n >> 24 & 255,
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255,
        ie >> 24 & 255,
        ie >> 16 & 255,
        ie >> 8 & 255,
        ie & 255,
        fe >> 24 & 255,
        fe >> 16 & 255,
        fe >> 8 & 255,
        fe & 255,
        ae >> 24 & 255,
        ae >> 16 & 255,
        ae >> 8 & 255,
        ae & 255,
        le >> 24 & 255,
        le >> 16 & 255,
        le >> 8 & 255,
        le & 255
      ];
      return this.is224 || me.push(he >> 24 & 255, he >> 16 & 255, he >> 8 & 255, he & 255), me;
    }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function() {
      this.finalize();
      var c = new ArrayBuffer(this.is224 ? 28 : 32), t = new DataView(c);
      return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), c;
    };
    function HmacSha256(c, t, n) {
      var ie, fe = typeof c;
      if (fe === "string") {
        var ae = [], le = c.length, he = 0, me;
        for (ie = 0; ie < le; ++ie)
          me = c.charCodeAt(ie), me < 128 ? ae[he++] = me : me < 2048 ? (ae[he++] = 192 | me >> 6, ae[he++] = 128 | me & 63) : me < 55296 || me >= 57344 ? (ae[he++] = 224 | me >> 12, ae[he++] = 128 | me >> 6 & 63, ae[he++] = 128 | me & 63) : (me = 65536 + ((me & 1023) << 10 | c.charCodeAt(++ie) & 1023), ae[he++] = 240 | me >> 18, ae[he++] = 128 | me >> 12 & 63, ae[he++] = 128 | me >> 6 & 63, ae[he++] = 128 | me & 63);
        c = ae;
      } else if (fe === "object") {
        if (c === null)
          throw new Error(ERROR);
        if (ARRAY_BUFFER && c.constructor === ArrayBuffer)
          c = new Uint8Array(c);
        else if (!Array.isArray(c) && (!ARRAY_BUFFER || !ArrayBuffer.isView(c)))
          throw new Error(ERROR);
      } else
        throw new Error(ERROR);
      c.length > 64 && (c = new Sha256(t, !0).update(c).array());
      var ye = [], be = [];
      for (ie = 0; ie < 64; ++ie) {
        var Ae = c[ie] || 0;
        ye[ie] = 92 ^ Ae, be[ie] = 54 ^ Ae;
      }
      Sha256.call(this, t, n), this.update(be), this.oKeyPad = ye, this.inner = !0, this.sharedMemory = n;
    }
    HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function() {
      if (Sha256.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var c = this.array();
        Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(c), Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224);
  })();
})(sha256$3);
var sha256Exports$1 = sha256$3.exports;
function N$1(c, t) {
  (t == null || t > c.length) && (t = c.length);
  for (var n = 0, ie = new Array(t); n < t; n++) ie[n] = c[n];
  return ie;
}
function q$1(c, t) {
  var n = typeof Symbol < "u" && c[Symbol.iterator] || c["@@iterator"];
  if (n) return (n = n.call(c)).next.bind(n);
  if (Array.isArray(c) || (n = function(fe, ae) {
    if (fe) {
      if (typeof fe == "string") return N$1(fe, void 0);
      var le = Object.prototype.toString.call(fe).slice(8, -1);
      return le === "Object" && fe.constructor && (le = fe.constructor.name), le === "Map" || le === "Set" ? Array.from(fe) : le === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(le) ? N$1(fe, void 0) : void 0;
    }
  }(c)) || t) {
    n && (c = n);
    var ie = 0;
    return function() {
      return ie >= c.length ? { done: !0 } : { done: !1, value: c[ie++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var T$1, L$1 = (function(c) {
  var t = function(n) {
    var ie = 1e7, fe = 9007199254740992, ae = Ae(fe), le = Math.log(fe);
    function he(Le, $t) {
      return Le === void 0 ? he[0] : $t !== void 0 ? +$t == 10 ? Pt(Le) : Fe(Le, $t) : Pt(Le);
    }
    function me(Le, $t) {
      this.value = Le, this.sign = $t, this.isSmall = !1;
    }
    function ye(Le) {
      this.value = Le, this.sign = Le < 0, this.isSmall = !0;
    }
    function be(Le) {
      return -fe < Le && Le < fe;
    }
    function Ae(Le) {
      return Le < 1e7 ? [Le] : Le < 1e14 ? [Le % 1e7, Math.floor(Le / 1e7)] : [Le % 1e7, Math.floor(Le / 1e7) % 1e7, Math.floor(Le / 1e14)];
    }
    function Se(Le) {
      $e(Le);
      var $t = Le.length;
      if ($t < 4 && se(Le, ae) < 0) switch ($t) {
        case 0:
          return 0;
        case 1:
          return Le[0];
        case 2:
          return Le[0] + Le[1] * ie;
        default:
          return Le[0] + (Le[1] + Le[2] * ie) * ie;
      }
      return Le;
    }
    function $e(Le) {
      for (var $t = Le.length; Le[--$t] === 0; ) ;
      Le.length = $t + 1;
    }
    function Re(Le) {
      for (var $t = new Array(Le), Jt = -1; ++Jt < Le; ) $t[Jt] = 0;
      return $t;
    }
    function Me(Le) {
      return Le > 0 ? Math.floor(Le) : Math.ceil(Le);
    }
    function ke(Le, $t) {
      var Jt, Ht, Vt = Le.length, xn = $t.length, Zt = new Array(Vt), Gt = 0, An = ie;
      for (Ht = 0; Ht < xn; Ht++) Zt[Ht] = (Jt = Le[Ht] + $t[Ht] + Gt) - (Gt = Jt >= An ? 1 : 0) * An;
      for (; Ht < Vt; ) Jt = Le[Ht] + Gt, Zt[Ht++] = Jt - (Gt = Jt === An ? 1 : 0) * An;
      return Gt > 0 && Zt.push(Gt), Zt;
    }
    function Te(Le, $t) {
      return Le.length >= $t.length ? ke(Le, $t) : ke($t, Le);
    }
    function Ie(Le, $t) {
      var Jt, Ht, Vt = Le.length, xn = new Array(Vt), Zt = ie;
      for (Ht = 0; Ht < Vt; Ht++) Jt = Le[Ht] - Zt + $t, $t = Math.floor(Jt / Zt), xn[Ht] = Jt - $t * Zt, $t += 1;
      for (; $t > 0; ) xn[Ht++] = $t % Zt, $t = Math.floor($t / Zt);
      return xn;
    }
    function qe(Le, $t) {
      var Jt, Ht, Vt = Le.length, xn = $t.length, Zt = new Array(Vt), Gt = 0;
      for (Jt = 0; Jt < xn; Jt++) (Ht = Le[Jt] - Gt - $t[Jt]) < 0 ? (Ht += 1e7, Gt = 1) : Gt = 0, Zt[Jt] = Ht;
      for (Jt = xn; Jt < Vt; Jt++) {
        if (!((Ht = Le[Jt] - Gt) < 0)) {
          Zt[Jt++] = Ht;
          break;
        }
        Zt[Jt] = Ht += 1e7;
      }
      for (; Jt < Vt; Jt++) Zt[Jt] = Le[Jt];
      return $e(Zt), Zt;
    }
    function Ue(Le, $t, Jt) {
      var Ht, Vt, xn = Le.length, Zt = new Array(xn), Gt = -$t;
      for (Ht = 0; Ht < xn; Ht++) Vt = Le[Ht] + Gt, Gt = Math.floor(Vt / 1e7), Zt[Ht] = (Vt %= 1e7) < 0 ? Vt + 1e7 : Vt;
      return typeof (Zt = Se(Zt)) == "number" ? (Jt && (Zt = -Zt), new ye(Zt)) : new me(Zt, Jt);
    }
    function ze(Le, $t) {
      var Jt, Ht, Vt, xn, Zt = Le.length, Gt = $t.length, An = Re(Zt + Gt);
      for (Vt = 0; Vt < Zt; ++Vt) {
        xn = Le[Vt];
        for (var Qt = 0; Qt < Gt; ++Qt) Jt = xn * $t[Qt] + An[Vt + Qt], Ht = Math.floor(Jt / 1e7), An[Vt + Qt] = Jt - 1e7 * Ht, An[Vt + Qt + 1] += Ht;
      }
      return $e(An), An;
    }
    function Ve(Le, $t) {
      var Jt, Ht, Vt = Le.length, xn = new Array(Vt), Zt = ie, Gt = 0;
      for (Ht = 0; Ht < Vt; Ht++) Jt = Le[Ht] * $t + Gt, Gt = Math.floor(Jt / Zt), xn[Ht] = Jt - Gt * Zt;
      for (; Gt > 0; ) xn[Ht++] = Gt % Zt, Gt = Math.floor(Gt / Zt);
      return xn;
    }
    function Mt(Le, $t) {
      for (var Jt = []; $t-- > 0; ) Jt.push(0);
      return Jt.concat(Le);
    }
    function Rt(Le, $t, Jt) {
      return new me(Le < ie ? Ve($t, Le) : ze($t, Ae(Le)), Jt);
    }
    function je(Le) {
      var $t, Jt, Ht, Vt, xn = Le.length, Zt = Re(xn + xn);
      for (Ht = 0; Ht < xn; Ht++) {
        Jt = 0 - (Vt = Le[Ht]) * Vt;
        for (var Gt = Ht; Gt < xn; Gt++) $t = Vt * Le[Gt] * 2 + Zt[Ht + Gt] + Jt, Jt = Math.floor($t / 1e7), Zt[Ht + Gt] = $t - 1e7 * Jt;
        Zt[Ht + xn] = Jt;
      }
      return $e(Zt), Zt;
    }
    function jt(Le, $t) {
      var Jt, Ht, Vt, xn, Zt = Le.length, Gt = Re(Zt);
      for (Vt = 0, Jt = Zt - 1; Jt >= 0; --Jt) Vt = (xn = 1e7 * Vt + Le[Jt]) - (Ht = Me(xn / $t)) * $t, Gt[Jt] = 0 | Ht;
      return [Gt, 0 | Vt];
    }
    function _e(Le, $t) {
      var Jt, Ht, Vt = Pt($t), xn = Le.value, Zt = Vt.value;
      if (Zt === 0) throw new Error("Cannot divide by zero");
      if (Le.isSmall) return Vt.isSmall ? [new ye(Me(xn / Zt)), new ye(xn % Zt)] : [he[0], Le];
      if (Vt.isSmall) {
        if (Zt === 1) return [Le, he[0]];
        if (Zt == -1) return [Le.negate(), he[0]];
        var Gt = Math.abs(Zt);
        if (Gt < ie) {
          Ht = Se((Jt = jt(xn, Gt))[0]);
          var An = Jt[1];
          return Le.sign && (An = -An), typeof Ht == "number" ? (Le.sign !== Vt.sign && (Ht = -Ht), [new ye(Ht), new ye(An)]) : [new me(Ht, Le.sign !== Vt.sign), new ye(An)];
        }
        Zt = Ae(Gt);
      }
      var Qt = se(xn, Zt);
      if (Qt === -1) return [he[0], Le];
      if (Qt === 0) return [he[Le.sign === Vt.sign ? 1 : -1], he[0]];
      Jt = xn.length + Zt.length <= 200 ? function(Dt, en) {
        var We, De, Ge, Oe, Ce, He, Xe, Kt = Dt.length, tn = en.length, Wt = ie, Yt = Re(en.length), _n = en[tn - 1], rn = Math.ceil(Wt / (2 * _n)), nn = Ve(Dt, rn), En = Ve(en, rn);
        for (nn.length <= Kt && nn.push(0), En.push(0), _n = En[tn - 1], De = Kt - tn; De >= 0; De--) {
          for (We = Wt - 1, nn[De + tn] !== _n && (We = Math.floor((nn[De + tn] * Wt + nn[De + tn - 1]) / _n)), Ge = 0, Oe = 0, He = En.length, Ce = 0; Ce < He; Ce++) Ge += We * En[Ce], Xe = Math.floor(Ge / Wt), Oe += nn[De + Ce] - (Ge - Xe * Wt), Ge = Xe, Oe < 0 ? (nn[De + Ce] = Oe + Wt, Oe = -1) : (nn[De + Ce] = Oe, Oe = 0);
          for (; Oe !== 0; ) {
            for (We -= 1, Ge = 0, Ce = 0; Ce < He; Ce++) (Ge += nn[De + Ce] - Wt + En[Ce]) < 0 ? (nn[De + Ce] = Ge + Wt, Ge = 0) : (nn[De + Ce] = Ge, Ge = 1);
            Oe += Ge;
          }
          Yt[De] = We;
        }
        return nn = jt(nn, rn)[0], [Se(Yt), Se(nn)];
      }(xn, Zt) : function(Dt, en) {
        for (var We, De, Ge, Oe, Ce = Dt.length, He = en.length, Xe = [], Kt = []; Ce; ) if (Kt.unshift(Dt[--Ce]), $e(Kt), se(Kt, en) < 0) Xe.push(0);
        else {
          Ge = 1e7 * Kt[(De = Kt.length) - 1] + Kt[De - 2], De > He && (Ge = 1e7 * (Ge + 1)), We = Math.ceil(Ge / (1e7 * en[He - 1] + en[He - 2]));
          do {
            if (se(Oe = Ve(en, We), Kt) <= 0) break;
            We--;
          } while (We);
          Xe.push(We), Kt = qe(Kt, Oe);
        }
        return Xe.reverse(), [Se(Xe), Se(Kt)];
      }(xn, Zt);
      var Xt = Le.sign !== Vt.sign, wn = Jt[1], Qe = Le.sign;
      return typeof (Ht = Jt[0]) == "number" ? (Xt && (Ht = -Ht), Ht = new ye(Ht)) : Ht = new me(Ht, Xt), typeof wn == "number" ? (Qe && (wn = -wn), wn = new ye(wn)) : wn = new me(wn, Qe), [Ht, wn];
    }
    function se(Le, $t) {
      if (Le.length !== $t.length) return Le.length > $t.length ? 1 : -1;
      for (var Jt = Le.length - 1; Jt >= 0; Jt--) if (Le[Jt] !== $t[Jt]) return Le[Jt] > $t[Jt] ? 1 : -1;
      return 0;
    }
    function ce(Le) {
      var $t = Le.abs();
      return !$t.isUnit() && (!!($t.equals(2) || $t.equals(3) || $t.equals(5)) || !($t.isEven() || $t.isDivisibleBy(3) || $t.isDivisibleBy(5)) && (!!$t.lesser(49) || void 0));
    }
    function de(Le, $t) {
      for (var Jt, Ht, Vt, xn = Le.prev(), Zt = xn, Gt = 0; Zt.isEven(); ) Zt = Zt.divide(2), Gt++;
      e: for (Ht = 0; Ht < $t.length; Ht++) if (!Le.lesser($t[Ht]) && !(Vt = t($t[Ht]).modPow(Zt, Le)).equals(he[1]) && !Vt.equals(xn)) {
        for (Jt = Gt - 1; Jt != 0; Jt--) {
          if ((Vt = Vt.square().mod(Le)).isUnit()) return !1;
          if (Vt.equals(xn)) continue e;
        }
        return !1;
      }
      return !0;
    }
    me.prototype = Object.create(he.prototype), ye.prototype = Object.create(he.prototype), me.prototype.add = function(Le) {
      var $t = Pt(Le);
      if (this.sign !== $t.sign) return this.subtract($t.negate());
      var Jt = this.value, Ht = $t.value;
      return new me($t.isSmall ? Ie(Jt, Math.abs(Ht)) : Te(Jt, Ht), this.sign);
    }, me.prototype.plus = me.prototype.add, ye.prototype.add = function(Le) {
      var $t = Pt(Le), Jt = this.value;
      if (Jt < 0 !== $t.sign) return this.subtract($t.negate());
      var Ht = $t.value;
      if ($t.isSmall) {
        if (be(Jt + Ht)) return new ye(Jt + Ht);
        Ht = Ae(Math.abs(Ht));
      }
      return new me(Ie(Ht, Math.abs(Jt)), Jt < 0);
    }, ye.prototype.plus = ye.prototype.add, me.prototype.subtract = function(Le) {
      var $t = Pt(Le);
      if (this.sign !== $t.sign) return this.add($t.negate());
      var Jt = this.value, Ht = $t.value;
      return $t.isSmall ? Ue(Jt, Math.abs(Ht), this.sign) : function(Vt, xn, Zt) {
        var Gt;
        return se(Vt, xn) >= 0 ? Gt = qe(Vt, xn) : (Gt = qe(xn, Vt), Zt = !Zt), typeof (Gt = Se(Gt)) == "number" ? (Zt && (Gt = -Gt), new ye(Gt)) : new me(Gt, Zt);
      }(Jt, Ht, this.sign);
    }, me.prototype.minus = me.prototype.subtract, ye.prototype.subtract = function(Le) {
      var $t = Pt(Le), Jt = this.value;
      if (Jt < 0 !== $t.sign) return this.add($t.negate());
      var Ht = $t.value;
      return $t.isSmall ? new ye(Jt - Ht) : Ue(Ht, Math.abs(Jt), Jt >= 0);
    }, ye.prototype.minus = ye.prototype.subtract, me.prototype.negate = function() {
      return new me(this.value, !this.sign);
    }, ye.prototype.negate = function() {
      var Le = this.sign, $t = new ye(-this.value);
      return $t.sign = !Le, $t;
    }, me.prototype.abs = function() {
      return new me(this.value, !1);
    }, ye.prototype.abs = function() {
      return new ye(Math.abs(this.value));
    }, me.prototype.multiply = function(Le) {
      var $t, Jt, Ht, Vt = Pt(Le), xn = this.value, Zt = Vt.value, Gt = this.sign !== Vt.sign;
      if (Vt.isSmall) {
        if (Zt === 0) return he[0];
        if (Zt === 1) return this;
        if (Zt === -1) return this.negate();
        if (($t = Math.abs(Zt)) < ie) return new me(Ve(xn, $t), Gt);
        Zt = Ae($t);
      }
      return -0.012 * (Jt = xn.length) - 0.012 * (Ht = Zt.length) + 15e-6 * Jt * Ht > 0 ? new me(function An(Qt, Xt) {
        var wn = Math.max(Qt.length, Xt.length);
        if (wn <= 30) return ze(Qt, Xt);
        wn = Math.ceil(wn / 2);
        var Qe = Qt.slice(wn), Dt = Qt.slice(0, wn), en = Xt.slice(wn), We = Xt.slice(0, wn), De = An(Dt, We), Ge = An(Qe, en), Oe = An(Te(Dt, Qe), Te(We, en)), Ce = Te(Te(De, Mt(qe(qe(Oe, De), Ge), wn)), Mt(Ge, 2 * wn));
        return $e(Ce), Ce;
      }(xn, Zt), Gt) : new me(ze(xn, Zt), Gt);
    }, me.prototype.times = me.prototype.multiply, ye.prototype._multiplyBySmall = function(Le) {
      return be(Le.value * this.value) ? new ye(Le.value * this.value) : Rt(Math.abs(Le.value), Ae(Math.abs(this.value)), this.sign !== Le.sign);
    }, me.prototype._multiplyBySmall = function(Le) {
      return Le.value === 0 ? he[0] : Le.value === 1 ? this : Le.value === -1 ? this.negate() : Rt(Math.abs(Le.value), this.value, this.sign !== Le.sign);
    }, ye.prototype.times = ye.prototype.multiply = function(Le) {
      return Pt(Le)._multiplyBySmall(this);
    }, me.prototype.square = function() {
      return new me(je(this.value), !1);
    }, ye.prototype.square = function() {
      var Le = this.value * this.value;
      return be(Le) ? new ye(Le) : new me(je(Ae(Math.abs(this.value))), !1);
    }, ye.prototype.divmod = me.prototype.divmod = function(Le) {
      var $t = _e(this, Le);
      return { quotient: $t[0], remainder: $t[1] };
    }, ye.prototype.over = ye.prototype.divide = me.prototype.over = me.prototype.divide = function(Le) {
      return _e(this, Le)[0];
    }, ye.prototype.remainder = ye.prototype.mod = me.prototype.remainder = me.prototype.mod = function(Le) {
      return _e(this, Le)[1];
    }, me.prototype.pow = function(Le) {
      var $t, Jt, Ht, Vt = Pt(Le), xn = this.value, Zt = Vt.value;
      if (Zt === 0) return he[1];
      if (xn === 0) return he[0];
      if (xn === 1) return he[1];
      if (xn === -1) return Vt.isEven() ? he[1] : he[-1];
      if (Vt.sign) return he[0];
      if (!Vt.isSmall) throw new Error("The exponent " + Vt.toString() + " is too large.");
      if (this.isSmall && be($t = Math.pow(xn, Zt))) return new ye(Me($t));
      for (Jt = this, Ht = he[1]; !0 & Zt && (Ht = Ht.times(Jt), --Zt), Zt !== 0; ) Zt /= 2, Jt = Jt.square();
      return Ht;
    }, ye.prototype.pow = me.prototype.pow, ye.prototype.modPow = me.prototype.modPow = function(Le, $t) {
      if (Le = Pt(Le), ($t = Pt($t)).isZero()) throw new Error("Cannot take modPow with modulus 0");
      for (var Jt = he[1], Ht = this.mod($t); Le.isPositive(); ) {
        if (Ht.isZero()) return he[0];
        Le.isOdd() && (Jt = Jt.multiply(Ht).mod($t)), Le = Le.divide(2), Ht = Ht.square().mod($t);
      }
      return Jt;
    }, me.prototype.compareAbs = function(Le) {
      var $t = Pt(Le);
      return $t.isSmall ? 1 : se(this.value, $t.value);
    }, ye.prototype.compareAbs = function(Le) {
      var $t = Pt(Le), Jt = Math.abs(this.value), Ht = $t.value;
      return $t.isSmall ? Jt === (Ht = Math.abs(Ht)) ? 0 : Jt > Ht ? 1 : -1 : -1;
    }, me.prototype.compareTo = me.prototype.compare = function(Le) {
      if (Le === 1 / 0) return -1;
      if (Le === -1 / 0) return 1;
      var $t = Pt(Le);
      return this.sign !== $t.sign ? $t.sign ? 1 : -1 : $t.isSmall ? this.sign ? -1 : 1 : se(this.value, $t.value) * (this.sign ? -1 : 1);
    }, ye.prototype.compareTo = ye.prototype.compare = function(Le) {
      if (Le === 1 / 0) return -1;
      if (Le === -1 / 0) return 1;
      var $t = Pt(Le), Jt = this.value, Ht = $t.value;
      return $t.isSmall ? Jt == Ht ? 0 : Jt > Ht ? 1 : -1 : Jt < 0 !== $t.sign ? Jt < 0 ? -1 : 1 : Jt < 0 ? 1 : -1;
    }, ye.prototype.eq = ye.prototype.equals = me.prototype.eq = me.prototype.equals = function(Le) {
      return this.compare(Le) === 0;
    }, ye.prototype.neq = ye.prototype.notEquals = me.prototype.neq = me.prototype.notEquals = function(Le) {
      return this.compare(Le) !== 0;
    }, ye.prototype.gt = ye.prototype.greater = me.prototype.gt = me.prototype.greater = function(Le) {
      return this.compare(Le) > 0;
    }, ye.prototype.lt = ye.prototype.lesser = me.prototype.lt = me.prototype.lesser = function(Le) {
      return this.compare(Le) < 0;
    }, ye.prototype.geq = ye.prototype.greaterOrEquals = me.prototype.geq = me.prototype.greaterOrEquals = function(Le) {
      return this.compare(Le) >= 0;
    }, ye.prototype.leq = ye.prototype.lesserOrEquals = me.prototype.leq = me.prototype.lesserOrEquals = function(Le) {
      return this.compare(Le) <= 0;
    }, me.prototype.isEven = function() {
      return (1 & this.value[0]) == 0;
    }, ye.prototype.isEven = function() {
      return (1 & this.value) == 0;
    }, me.prototype.isOdd = function() {
      return (1 & this.value[0]) == 1;
    }, ye.prototype.isOdd = function() {
      return (1 & this.value) == 1;
    }, me.prototype.isPositive = function() {
      return !this.sign;
    }, ye.prototype.isPositive = function() {
      return this.value > 0;
    }, me.prototype.isNegative = function() {
      return this.sign;
    }, ye.prototype.isNegative = function() {
      return this.value < 0;
    }, me.prototype.isUnit = function() {
      return !1;
    }, ye.prototype.isUnit = function() {
      return Math.abs(this.value) === 1;
    }, me.prototype.isZero = function() {
      return !1;
    }, ye.prototype.isZero = function() {
      return this.value === 0;
    }, ye.prototype.isDivisibleBy = me.prototype.isDivisibleBy = function(Le) {
      var $t = Pt(Le), Jt = $t.value;
      return Jt !== 0 && (Jt === 1 || (Jt === 2 ? this.isEven() : this.mod($t).equals(he[0])));
    }, ye.prototype.isPrime = me.prototype.isPrime = function(Le) {
      var $t = ce(this);
      if ($t !== void 0) return $t;
      var Jt = this.abs(), Ht = Jt.bitLength();
      if (Ht <= 64) return de(Jt, [2, 325, 9375, 28178, 450775, 9780504, 1795265022]);
      for (var Vt = Math.log(2) * Ht, xn = Math.ceil(Le === !0 ? 2 * Math.pow(Vt, 2) : Vt), Zt = [], Gt = 0; Gt < xn; Gt++) Zt.push(t(Gt + 2));
      return de(Jt, Zt);
    }, ye.prototype.isProbablePrime = me.prototype.isProbablePrime = function(Le) {
      var $t = ce(this);
      if ($t !== void 0) return $t;
      for (var Jt = this.abs(), Ht = Le === void 0 ? 5 : Le, Vt = [], xn = 0; xn < Ht; xn++) Vt.push(t.randBetween(2, Jt.minus(2)));
      return de(Jt, Vt);
    }, ye.prototype.modInv = me.prototype.modInv = function(Le) {
      for (var $t, Jt, Ht, Vt = t.zero, xn = t.one, Zt = Pt(Le), Gt = this.abs(); !Gt.equals(t.zero); ) $t = Zt.divide(Gt), Jt = Vt, Ht = Zt, Vt = xn, Zt = Gt, xn = Jt.subtract($t.multiply(xn)), Gt = Ht.subtract($t.multiply(Gt));
      if (!Zt.equals(1)) throw new Error(this.toString() + " and " + Le.toString() + " are not co-prime");
      return Vt.compare(0) === -1 && (Vt = Vt.add(Le)), this.isNegative() ? Vt.negate() : Vt;
    }, me.prototype.next = function() {
      var Le = this.value;
      return this.sign ? Ue(Le, 1, this.sign) : new me(Ie(Le, 1), this.sign);
    }, ye.prototype.next = function() {
      var Le = this.value;
      return Le + 1 < fe ? new ye(Le + 1) : new me(ae, !1);
    }, me.prototype.prev = function() {
      var Le = this.value;
      return this.sign ? new me(Ie(Le, 1), !0) : Ue(Le, 1, this.sign);
    }, ye.prototype.prev = function() {
      var Le = this.value;
      return Le - 1 > -fe ? new ye(Le - 1) : new me(ae, !0);
    };
    for (var pe = [1]; 2 * pe[pe.length - 1] <= ie; ) pe.push(2 * pe[pe.length - 1]);
    var ve = pe.length, we = pe[ve - 1];
    function Ee(Le) {
      return (typeof Le == "number" || typeof Le == "string") && +Math.abs(Le) <= ie || Le instanceof me && Le.value.length <= 1;
    }
    function xe(Le, $t, Jt) {
      $t = Pt($t);
      for (var Ht = Le.isNegative(), Vt = $t.isNegative(), xn = Ht ? Le.not() : Le, Zt = Vt ? $t.not() : $t, Gt = 0, An = 0, Qt = null, Xt = null, wn = []; !xn.isZero() || !Zt.isZero(); ) Gt = (Qt = _e(xn, we))[1].toJSNumber(), Ht && (Gt = we - 1 - Gt), An = (Xt = _e(Zt, we))[1].toJSNumber(), Vt && (An = we - 1 - An), xn = Qt[0], Zt = Xt[0], wn.push(Jt(Gt, An));
      for (var Qe = Jt(Ht ? 1 : 0, Vt ? 1 : 0) !== 0 ? t(-1) : t(0), Dt = wn.length - 1; Dt >= 0; Dt -= 1) Qe = Qe.multiply(we).add(t(wn[Dt]));
      return Qe;
    }
    function ue(Le) {
      var $t = Le.value, Jt = typeof $t == "number" ? $t | 1 << 30 : $t[0] + $t[1] * ie | 1073758208;
      return Jt & -Jt;
    }
    function ge(Le, $t) {
      return Le = Pt(Le), $t = Pt($t), Le.greater($t) ? Le : $t;
    }
    function Be(Le, $t) {
      return Le = Pt(Le), $t = Pt($t), Le.lesser($t) ? Le : $t;
    }
    function Ne(Le, $t) {
      if (Le = Pt(Le).abs(), $t = Pt($t).abs(), Le.equals($t)) return Le;
      if (Le.isZero()) return $t;
      if ($t.isZero()) return Le;
      for (var Jt, Ht, Vt = he[1]; Le.isEven() && $t.isEven(); ) Jt = Math.min(ue(Le), ue($t)), Le = Le.divide(Jt), $t = $t.divide(Jt), Vt = Vt.multiply(Jt);
      for (; Le.isEven(); ) Le = Le.divide(ue(Le));
      do {
        for (; $t.isEven(); ) $t = $t.divide(ue($t));
        Le.greater($t) && (Ht = $t, $t = Le, Le = Ht), $t = $t.subtract(Le);
      } while (!$t.isZero());
      return Vt.isUnit() ? Le : Le.multiply(Vt);
    }
    ye.prototype.shiftLeft = me.prototype.shiftLeft = function(Le) {
      if (!Ee(Le)) throw new Error(String(Le) + " is too large for shifting.");
      if ((Le = +Le) < 0) return this.shiftRight(-Le);
      var $t = this;
      if ($t.isZero()) return $t;
      for (; Le >= ve; ) $t = $t.multiply(we), Le -= ve - 1;
      return $t.multiply(pe[Le]);
    }, ye.prototype.shiftRight = me.prototype.shiftRight = function(Le) {
      var $t;
      if (!Ee(Le)) throw new Error(String(Le) + " is too large for shifting.");
      if ((Le = +Le) < 0) return this.shiftLeft(-Le);
      for (var Jt = this; Le >= ve; ) {
        if (Jt.isZero() || Jt.isNegative() && Jt.isUnit()) return Jt;
        Jt = ($t = _e(Jt, we))[1].isNegative() ? $t[0].prev() : $t[0], Le -= ve - 1;
      }
      return ($t = _e(Jt, pe[Le]))[1].isNegative() ? $t[0].prev() : $t[0];
    }, ye.prototype.not = me.prototype.not = function() {
      return this.negate().prev();
    }, ye.prototype.and = me.prototype.and = function(Le) {
      return xe(this, Le, function($t, Jt) {
        return $t & Jt;
      });
    }, ye.prototype.or = me.prototype.or = function(Le) {
      return xe(this, Le, function($t, Jt) {
        return $t | Jt;
      });
    }, ye.prototype.xor = me.prototype.xor = function(Le) {
      return xe(this, Le, function($t, Jt) {
        return $t ^ Jt;
      });
    }, ye.prototype.bitLength = me.prototype.bitLength = function() {
      var Le = this;
      return Le.compareTo(t(0)) < 0 && (Le = Le.negate().subtract(t(1))), Le.compareTo(t(0)) === 0 ? t(0) : t(function $t(Jt, Ht) {
        if (Ht.compareTo(Jt) <= 0) {
          var Vt = $t(Jt, Ht.square(Ht)), xn = Vt.p, Zt = Vt.e, Gt = xn.multiply(Ht);
          return Gt.compareTo(Jt) <= 0 ? { p: Gt, e: 2 * Zt + 1 } : { p: xn, e: 2 * Zt };
        }
        return { p: t(1), e: 0 };
      }(Le, t(2)).e).add(t(1));
    };
    var Fe = function(Le, $t) {
      for (var Jt = Le.length, Ht = Math.abs($t), Vt = 0; Vt < Jt; Vt++) if ((An = Le[Vt].toLowerCase()) !== "-" && /[a-z0-9]/.test(An)) {
        if (/[0-9]/.test(An) && +An >= Ht) {
          if (An === "1" && Ht === 1) continue;
          throw new Error(An + " is not a valid digit in base " + $t + ".");
        }
        if (An.charCodeAt(0) - 87 >= Ht) throw new Error(An + " is not a valid digit in base " + $t + ".");
      }
      if (2 <= $t && $t <= 36 && Jt <= le / Math.log($t)) {
        var xn = parseInt(Le, $t);
        if (isNaN(xn)) throw new Error(An + " is not a valid digit in base " + $t + ".");
        return new ye(parseInt(Le, $t));
      }
      $t = Pt($t);
      var Zt = [], Gt = Le[0] === "-";
      for (Vt = Gt ? 1 : 0; Vt < Le.length; Vt++) {
        var An, Qt = (An = Le[Vt].toLowerCase()).charCodeAt(0);
        if (48 <= Qt && Qt <= 57) Zt.push(Pt(An));
        else if (97 <= Qt && Qt <= 122) Zt.push(Pt(An.charCodeAt(0) - 87));
        else {
          if (An !== "<") throw new Error(An + " is not a valid character");
          var Xt = Vt;
          do
            Vt++;
          while (Le[Vt] !== ">");
          Zt.push(Pt(Le.slice(Xt + 1, Vt)));
        }
      }
      return Pe(Zt, $t, Gt);
    };
    function Pe(Le, $t, Jt) {
      var Ht, Vt = he[0], xn = he[1];
      for (Ht = Le.length - 1; Ht >= 0; Ht--) Vt = Vt.add(Le[Ht].times(xn)), xn = xn.times($t);
      return Jt ? Vt.negate() : Vt;
    }
    function Je(Le) {
      return Le <= 35 ? "0123456789abcdefghijklmnopqrstuvwxyz".charAt(Le) : "<" + Le + ">";
    }
    function Ke(Le, $t) {
      if (($t = t($t)).isZero()) {
        if (Le.isZero()) return { value: [0], isNegative: !1 };
        throw new Error("Cannot convert nonzero numbers to base 0.");
      }
      if ($t.equals(-1)) {
        if (Le.isZero()) return { value: [0], isNegative: !1 };
        if (Le.isNegative()) return { value: [].concat.apply([], Array.apply(null, Array(-Le)).map(Array.prototype.valueOf, [1, 0])), isNegative: !1 };
        var Jt = Array.apply(null, Array(+Le - 1)).map(Array.prototype.valueOf, [0, 1]);
        return Jt.unshift([1]), { value: [].concat.apply([], Jt), isNegative: !1 };
      }
      var Ht = !1;
      if (Le.isNegative() && $t.isPositive() && (Ht = !0, Le = Le.abs()), $t.equals(1)) return Le.isZero() ? { value: [0], isNegative: !1 } : { value: Array.apply(null, Array(+Le)).map(Number.prototype.valueOf, 1), isNegative: Ht };
      for (var Vt, xn = [], Zt = Le; Zt.isNegative() || Zt.compareAbs($t) >= 0; ) {
        Vt = Zt.divmod($t), Zt = Vt.quotient;
        var Gt = Vt.remainder;
        Gt.isNegative() && (Gt = $t.minus(Gt).abs(), Zt = Zt.next()), xn.push(Gt.toJSNumber());
      }
      return xn.push(Zt.toJSNumber()), { value: xn.reverse(), isNegative: Ht };
    }
    function Ze(Le, $t) {
      var Jt = Ke(Le, $t);
      return (Jt.isNegative ? "-" : "") + Jt.value.map(Je).join("");
    }
    function Ye(Le) {
      if (be(+Le)) {
        var $t = +Le;
        if ($t === Me($t)) return new ye($t);
        throw new Error("Invalid integer: " + Le);
      }
      var Jt = Le[0] === "-";
      Jt && (Le = Le.slice(1));
      var Ht = Le.split(/e/i);
      if (Ht.length > 2) throw new Error("Invalid integer: " + Ht.join("e"));
      if (Ht.length === 2) {
        var Vt = Ht[1];
        if (Vt[0] === "+" && (Vt = Vt.slice(1)), (Vt = +Vt) !== Me(Vt) || !be(Vt)) throw new Error("Invalid integer: " + Vt + " is not a valid exponent.");
        var xn = Ht[0], Zt = xn.indexOf(".");
        if (Zt >= 0 && (Vt -= xn.length - Zt - 1, xn = xn.slice(0, Zt) + xn.slice(Zt + 1)), Vt < 0) throw new Error("Cannot include negative exponent part for integers");
        Le = xn += new Array(Vt + 1).join("0");
      }
      if (!/^([0-9][0-9]*)$/.test(Le)) throw new Error("Invalid integer: " + Le);
      for (var Gt = [], An = Le.length, Qt = An - 7; An > 0; ) Gt.push(+Le.slice(Qt, An)), (Qt -= 7) < 0 && (Qt = 0), An -= 7;
      return $e(Gt), new me(Gt, Jt);
    }
    function Pt(Le) {
      return typeof Le == "number" ? function($t) {
        if (be($t)) {
          if ($t !== Me($t)) throw new Error($t + " is not an integer.");
          return new ye($t);
        }
        return Ye($t.toString());
      }(Le) : typeof Le == "string" ? Ye(Le) : Le;
    }
    me.prototype.toArray = function(Le) {
      return Ke(this, Le);
    }, ye.prototype.toArray = function(Le) {
      return Ke(this, Le);
    }, me.prototype.toString = function(Le) {
      if (Le === void 0 && (Le = 10), Le !== 10) return Ze(this, Le);
      for (var $t, Jt = this.value, Ht = Jt.length, Vt = String(Jt[--Ht]); --Ht >= 0; ) $t = String(Jt[Ht]), Vt += "0000000".slice($t.length) + $t;
      return (this.sign ? "-" : "") + Vt;
    }, ye.prototype.toString = function(Le) {
      return Le === void 0 && (Le = 10), Le != 10 ? Ze(this, Le) : String(this.value);
    }, me.prototype.toJSON = ye.prototype.toJSON = function() {
      return this.toString();
    }, me.prototype.toJSNumber = me.prototype.valueOf = function() {
      return parseInt(this.toString(), 10);
    }, ye.prototype.toJSNumber = ye.prototype.valueOf = function() {
      return this.value;
    };
    for (var Ft = 0; Ft < 1e3; Ft++) he[Ft] = new ye(Ft), Ft > 0 && (he[-Ft] = new ye(-Ft));
    return he.one = he[1], he.zero = he[0], he.minusOne = he[-1], he.max = ge, he.min = Be, he.gcd = Ne, he.lcm = function(Le, $t) {
      return Le = Pt(Le).abs(), $t = Pt($t).abs(), Le.divide(Ne(Le, $t)).multiply($t);
    }, he.isInstance = function(Le) {
      return Le instanceof me || Le instanceof ye;
    }, he.randBetween = function(Le, $t) {
      var Jt = Be(Le = Pt(Le), $t = Pt($t)), Ht = ge(Le, $t).subtract(Jt).add(1);
      if (Ht.isSmall) return Jt.add(Math.floor(Math.random() * Ht));
      for (var Vt = [], xn = !0, Zt = Ht.value.length - 1; Zt >= 0; Zt--) {
        var Gt = xn ? Ht.value[Zt] : ie, An = Me(Math.random() * Gt);
        Vt.unshift(An), An < Gt && (xn = !1);
      }
      return Vt = Se(Vt), Jt.add(typeof Vt == "number" ? new ye(Vt) : new me(Vt, !1));
    }, he.fromArray = function(Le, $t, Jt) {
      return Pe(Le.map(Pt), Pt($t || 10), Jt);
    }, he;
  }();
  c.hasOwnProperty("exports") && (c.exports = t);
}(T$1 = { path: void 0, exports: {}, require: function(c, t) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }();
} }), T$1.exports), R$1 = "0123456789ABCDEFGHJKMNPQRSTVWXYZ", k$1 = "0123456789abcdef";
function F$1(c) {
  return Buffer$7.from(sha256Exports$1.sha256.update(c).digest());
}
function M$1(c) {
  return F$1(F$1(Buffer$7.from(c, "hex"))).slice(0, 4).toString("hex");
}
function D$1(c) {
  if (!c.match(/^[0-9a-fA-F]*$/)) throw new Error("Not a hex-encoded string");
  c.length % 2 != 0 && (c = "0" + c);
  for (var t = [], n = 0, ie = (c = c.toLowerCase()).length - 1; ie >= 0; ie--) if (n < 4) {
    var fe = k$1.indexOf(c[ie]) >> n, ae = 0;
    ie !== 0 && (ae = k$1.indexOf(c[ie - 1]));
    var le = 1 + n;
    n = le, t.unshift(R$1[fe + (ae % (1 << le) << 5 - le)]);
  } else n = 0;
  for (var he = 0, me = 0; me < t.length && t[me] === "0"; me++) he++;
  t = t.slice(he);
  for (var ye = Buffer$7.from(c, "hex").toString().match(/^\u0000*/), be = ye ? ye[0].length : 0, Ae = 0; Ae < be; Ae++) t.unshift(R$1[0]);
  return t.join("");
}
function X$1(c) {
  return c.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1");
}
var G$1 = function(c, t) {
  this.value = c, this.tag = t;
}, V$1 = function(c) {
  this.value = c;
}, Q$1 = bnExports$1, W$1 = function() {
  function c(n) {
    n === void 0 && (n = Buffer$7.from([])), this.buffer = n, this.bytesRead = 0;
  }
  var t = c.prototype;
  return t.read = function(n) {
    var ie = this.buffer.slice(0, n);
    return this.buffer = this.buffer.slice(n), this.bytesRead += n, ie;
  }, t.write = function(n) {
    this.buffer = Buffer$7.concat([this.buffer, Buffer$7.from(n)]);
  }, c;
}(), P$1 = function() {
  function c(n) {
    if (!n || n.length < 1) throw new Error("Missing str in address");
    this.str = n;
  }
  var t = c.prototype;
  return t.protocol = function() {
    if (this.str.length < 1) throw Error("No address found.");
    return this.str[0];
  }, t.payload = function() {
    if (this.str.length < 1) throw Error("No address found.");
    return this.str.slice(1, this.str.length);
  }, c;
}();
function z$1(c) {
  return blakejs.blake2b(Uint8Array.from(c), null, 4);
}
function K$1(c, t) {
  if (!t || !t.str) throw Error("Invalid address");
  var n = "", ie = t.payload(), fe = t.protocol();
  switch (fe) {
    case 0:
      var ae = function(Ae) {
        for (var Se, $e = new Q$1(0), Re = 0; Se = Ae.read(1)[0], $e.ior(new Q$1(127 & Se).shln(Re)), Se >> 7 != 0; ) Re += 7;
        return $e;
      }(new W$1(ie)).toString();
      n = c + String(fe) + ae;
      break;
    default:
      var le = Buffer$7.from([fe]), he = z$1(Buffer$7.concat([le, ie])), me = Buffer$7.concat([ie, Buffer$7.from(he)]), ye = s(me.toString("hex")), be = d$1(ye).replace(/=/g, "").toLowerCase();
      n = String(c) + String(fe) + be;
  }
  return n;
}
function H$1(c, t) {
  var n = Buffer$7.from([c]), ie = Buffer$7.concat([n, t]);
  return new P$1(ie);
}
var Z$1 = [BigInt(1), BigInt(2), BigInt(4), BigInt(8), BigInt(16), BigInt(32), BigInt(64), BigInt(128), BigInt(256), BigInt(512), BigInt(1024), BigInt(2048), BigInt(4096), BigInt(8192), BigInt(16384), BigInt(32768), BigInt(65536), BigInt(131072), BigInt(262144), BigInt(471693), BigInt(419994), BigInt(397615), BigInt(395339), BigInt(275453), BigInt(273067), BigInt(268625), BigInt(144334), BigInt(141953), BigInt(137544), BigInt(126816), BigInt(122570), BigInt(116281), BigInt(114136), BigInt(107829), BigInt(103596), BigInt(101446), BigInt(90923), BigInt(86683), BigInt(84547), BigInt(78212), BigInt(76098), BigInt(71873), BigInt(63506), BigInt(57383), BigInt(53262), BigInt(51260), BigInt(45085), BigInt(43057), BigInt(38955), BigInt(28724), BigInt(26666), BigInt(22553), BigInt(14343), BigInt(2002), BigInt(1831), BigInt(1678), BigInt(1660), BigInt(1437), BigInt(1259), BigInt(948), BigInt(874), BigInt(729), BigInt(455), BigInt(63)], Y$1 = function(c) {
  this.codeword = c;
};
function j$1(c, t) {
  this.hi = c >>> 0, this.lo = t >>> 0;
}
function J$1(c, t) {
  return new j$1(c, t);
}
function _$1() {
  var c = arguments, t = c[0].hi, n = c[0].lo, ie = c.length - 1;
  do
    t ^= c[ie].hi, n ^= c[ie].lo, ie--;
  while (ie > 0);
  return new this.u64(t, n);
}
function $$1(c, t, n, ie, fe) {
  fe |= 0;
  for (var ae = 0; ae < ie; ) c[ae + t] = n[ae + fe], ae++;
}
function rr(c) {
  if (!c) return [];
  for (var t = c.length ? 1 + (c.length - 1 >>> 3) : 0, n = new Array(t), ie = 0; ie < t; ) n[ie] = new j$1(c[8 * ie] << 24 | c[8 * ie + 1] << 16 | c[8 * ie + 2] << 8 | c[8 * ie + 3], c[8 * ie + 4] << 24 | c[8 * ie + 5] << 16 | c[8 * ie + 6] << 8 | c[8 * ie + 7]), ie++;
  return n;
}
function tr(c) {
  for (var t = new Array(c.length), n = c.length, ie = 0; ie < n; ) t[4 * ie] = (4278190080 & c[ie]) >>> 24, t[4 * ie + 1] = (16711680 & c[ie]) >>> 16, t[4 * ie + 2] = (65280 & c[ie]) >>> 8, t[4 * ie + 3] = 255 & c[ie], ie++;
  return t;
}
Y$1.mainnet = new Y$1(BigInt(0)), Y$1.testnet = new Y$1(BigInt(7508831227132511e3)), Y$1.emulator = new Y$1(BigInt(2067532133767848e3)), j$1.prototype.set = function(c) {
  this.lo = c.lo, this.hi = c.hi;
}, j$1.prototype.add = function(c) {
  var t, n, ie, fe;
  return fe = (this.hi >>> 16) + (c.hi >>> 16) + ((ie = (65535 & this.hi) + (65535 & c.hi) + ((n = (this.lo >>> 16) + (c.lo >>> 16) + ((t = (65535 & this.lo) + (65535 & c.lo)) >>> 16)) >>> 16)) >>> 16), this.lo = n << 16 | 65535 & t, this.hi = fe << 16 | 65535 & ie, this;
}, j$1.prototype.addOne = function() {
  this.lo === -1 || this.lo === 4294967295 ? (this.lo = 0, this.hi++) : this.lo++;
}, j$1.prototype.plus = function(c) {
  var t, n, ie, fe, ae = new j$1(0, 0);
  return fe = (this.hi >>> 16) + (c.hi >>> 16) + ((ie = (65535 & this.hi) + (65535 & c.hi) + ((n = (this.lo >>> 16) + (c.lo >>> 16) + ((t = (65535 & this.lo) + (65535 & c.lo)) >>> 16)) >>> 16)) >>> 16), ae.lo = n << 16 | 65535 & t, ae.hi = fe << 16 | 65535 & ie, ae;
}, j$1.prototype.not = function() {
  return new j$1(~this.hi, ~this.lo);
}, j$1.prototype.one = function() {
  return new j$1(0, 1);
}, j$1.prototype.zero = function() {
  return new j$1(0, 0);
}, j$1.prototype.neg = function() {
  return this.not().plus(this.one());
}, j$1.prototype.minus = function(c) {
  return this.plus(c.neg());
}, j$1.prototype.isZero = function() {
  return this.lo === 0 && this.hi === 0;
}, j$1.prototype.multiply = function(c) {
  if (this.isZero()) return this.zero();
  var t;
  if (((t = c) && t.__isLong__) !== !0 && (c = function(Se) {
    return isNaN(Se) || !isFinite(Se) ? this.zero() : new j$1(Se % 1 | 0, Se / 1 | 0);
  }(c)), c.isZero()) return this.zero();
  var n = 65535 & this.hi, ie = this.lo >>> 16, fe = 65535 & this.lo, ae = 65535 & c.hi, le = c.lo >>> 16, he = 65535 & c.lo, me = 0, ye = 0, be = 0, Ae = 0;
  return be += (Ae += fe * he) >>> 16, ye += (be += ie * he) >>> 16, be &= 65535, ye += (be += fe * le) >>> 16, me += (ye += n * he) >>> 16, ye &= 65535, me += (ye += ie * le) >>> 16, ye &= 65535, me += (ye += fe * ae) >>> 16, me += (this.hi >>> 16) * he + n * le + ie * ae + fe * (c.hi >>> 16), new j$1((me &= 65535) << 16 | (ye &= 65535), (be &= 65535) << 16 | (Ae &= 65535));
}, j$1.prototype.shiftLeft = function(c) {
  c %= 64;
  var t = new j$1(0, 0);
  if (c === 0) return this.clone();
  if (c > 31) t.lo = 0, t.hi = this.lo << c - 32;
  else {
    var n = this.lo >>> 32 - c;
    t.lo = this.lo << c, t.hi = this.hi << c | n;
  }
  return t;
}, j$1.prototype.setShiftLeft = function(c) {
  if (c === 0) return this;
  if (c > 63 && (c %= 64), c > 31) this.hi = this.lo << c - 32, this.lo = 0;
  else {
    var t = this.lo >>> 32 - c;
    this.lo <<= c, this.hi = this.hi << c | t;
  }
  return this;
}, j$1.prototype.shiftRight = function(c) {
  c %= 64;
  var t = new j$1(0, 0);
  if (c === 0) return this.clone();
  if (c >= 32) t.hi = 0, t.lo = this.hi >>> c - 32;
  else {
    var n = 32 - c, ie = this.hi << n >>> n;
    t.hi = this.hi >>> c, t.lo = this.lo >>> c | ie << n;
  }
  return t;
}, j$1.prototype.rotateLeft = function(c) {
  if (c > 32) return this.rotateRight(64 - c);
  var t = new j$1(0, 0);
  return c === 0 ? (t.lo = this.lo >>> 0, t.hi = this.hi >>> 0) : c === 32 ? (t.lo = this.hi, t.hi = this.lo) : (t.lo = this.lo << c | this.hi >>> 32 - c, t.hi = this.hi << c | this.lo >>> 32 - c), t;
}, j$1.prototype.setRotateLeft = function(c) {
  return c > 32 ? this.setRotateRight(64 - c) : (c === 0 || (c === 32 ? (t = this.lo, this.lo = this.hi, this.hi = t) : (t = this.hi << c | this.lo >>> 32 - c, this.lo = this.lo << c | this.hi >>> 32 - c, this.hi = t)), this);
  var t;
}, j$1.prototype.rotateRight = function(c) {
  if (c > 32) return this.rotateLeft(64 - c);
  var t = new j$1(0, 0);
  return c === 0 ? (t.lo = this.lo >>> 0, t.hi = this.hi >>> 0) : c === 32 ? (t.lo = this.hi, t.hi = this.lo) : (t.lo = this.hi << 32 - c | this.lo >>> c, t.hi = this.lo << 32 - c | this.hi >>> c), t;
}, j$1.prototype.setFlip = function() {
  var c;
  return c = this.lo, this.lo = this.hi, this.hi = c, this;
}, j$1.prototype.setRotateRight = function(c) {
  return c > 32 ? this.setRotateLeft(64 - c) : (c === 0 || (c === 32 ? (t = this.lo, this.lo = this.hi, this.hi = t) : (newHigh = this.lo << 32 - c | this.hi >>> c, this.lo = this.hi << 32 - c | this.lo >>> c, this.hi = newHigh)), this);
  var t;
}, j$1.prototype.xor = function(c) {
  var t = new j$1(0, 0);
  return t.hi = this.hi ^ c.hi, t.lo = this.lo ^ c.lo, t;
}, j$1.prototype.setxorOne = function(c) {
  return this.hi ^= c.hi, this.lo ^= c.lo, this;
}, j$1.prototype.and = function(c) {
  var t = new j$1(0, 0);
  return t.hi = this.hi & c.hi, t.lo = this.lo & c.lo, t;
}, j$1.prototype.clone = function() {
  return new j$1(this.hi, this.lo);
}, j$1.prototype.setxor64 = function() {
  for (var c = arguments, t = c.length; t--; ) this.hi ^= c[t].hi, this.lo ^= c[t].lo;
  return this;
};
var er = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function nr(c) {
  var t, n, ie, fe, ae, le, he = [], me = 0;
  for (c = c.replace(/[^A-Za-z0-9\+\/\=]/g, ""); me < c.length; ) ie = er.indexOf(c.charAt(me++)), t = (15 & (fe = er.indexOf(c.charAt(me++)))) << 4 | (ae = er.indexOf(c.charAt(me++))) >> 2, n = (3 & ae) << 6 | (le = er.indexOf(c.charAt(me++))), he.push(ie << 2 | fe >> 4), ae !== 64 && he.push(t), le !== 64 && he.push(n);
  return he;
}
var or = rr(nr("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")), ir = rr(nr("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")), ar = rr(nr("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")), ur = rr(nr("l6XGxjL0pfTrhPj4b5eEl8eZ7u5esJmw94329nqMjYzlDf//6BcNF7e91tYK3L3cp7He3hbIscg5VJGRbfxU/MBQYGCQ8FDwBAMCAgcFAwWHqc7OLuCp4Kx9VlbRh32H1Rnn58wrGStxYrW1E6ZipprmTU18MeYxw5rs7Fm1mrUFRY+PQM9Fzz6dHx+jvJ28CUCJiUnAQMDvh/r6aJKHksUV7+/QPxU/f+uyspQm6yYHyY6OzkDJQO0L+/vmHQsdguxBQW4v7C99Z7OzGqlnqb79X19DHP0ciupFRWAl6iVGvyMj+dq/2qb3U1NRAvcC05bk5EWhlqEtW5ubdu1b7erCdXUoXcJd2Rzh4cUkHCR6rj091Omu6ZhqTEzyvmq+2FpsbILuWu78QX5+vcNBw/EC9fXzBgIGHU+Dg1LRT9HQXGhojORc5KL0UVFWB/QHuTTR0Y1cNFzpCPn54RgIGN+T4uJMrpOuTXOrqz6Vc5XEU2Jil/VT9VQ/KiprQT9BEAwICBwUDBQxUpWVY/ZS9oxlRkbpr2WvIV6dnX/iXuJgKDAwSHgoeG6hNzfP+KH4FA8KChsRDxFetS8v68S1xBwJDg4VGwkbSDYkJH5aNlo2mxsbrbabtqU939+YRz1HgSbNzadqJmqcaU5O9btpu/7Nf38zTM1Mz5/q6lC6n7okGxISPy0bLTqeHR2kuZ65sHRYWMScdJxoLjQ0RnIucmwtNjZBdy13o7Lc3BHNss1z7rS0nSnuKbb7W1tNFvsWU/akpKUB9gHsTXZ2oddN13Vht7cUo2Gj+s59fTRJzkmke1JS3417jaE+3d2fQj5CvHFeXs2TcZMmlxMTsaKXolf1pqaiBPUEaWi5uQG4aLgAAAAAAAAAAJkswcG1dCx0gGBAQOCgYKDdH+PjwiEfIfLIeXk6Q8hDd+22tpos7SyzvtTUDdm+2QFGjY1HykbKztlnZxdw2XDkS3Jyr91L3TPelJTted55K9SYmP9n1Gd76LCwkyPoIxFKhYVb3krebWu7uwa9a72RKsXFu34qfp7lT097NOU0wRbt7dc6FjoXxYaG0lTFVC/Xmpr4YtdizFVmZpn/Vf8ilBERtqeUpw/PiorASs9KyRDp6dkwEDAIBgQEDgoGCueB/v5mmIGYW/CgoKsL8AvwRHh4tMxEzEq6JSXw1brVluNLS3U+4z5f86KirA7zDrr+XV1EGf4ZG8CAgNtbwFsKigUFgIWKhX6tPz/T7K3sQrwhIf7fvN/gSHBwqNhI2PkE8fH9DAQMxt9jYxl633ruwXd3L1jBWEV1r68wn3WfhGNCQuelY6VAMCAgcFAwUNEa5eXLLhou4Q79/e8SDhJlbb+/CLdttxlMgYFV1EzUMBQYGCQ8FDxMNSYmeV81X50vw8OycS9xZ+G+voY44ThqojU1yP2i/QvMiIjHT8xPXDkuLmVLOUs9V5OTavlX+aryVVVYDfIN44L8/GGdgp30R3p6s8lHyYusyMgn76zvb+e6uogy5zJkKzIyT30rfdeV5uZCpJWkm6DAwDv7oPsymBkZqrOYsyfRnp72aNFoXX+joyKBf4GIZkRE7qpmqqh+VFTWgn6Cdqs7O93mq+YWgwsLlZ6DngPKjIzJRcpFlSnHx7x7KXvW02trBW7TblA8KChsRDxEVXmnpyyLeYtj4ry8gT3iPSwdFhYxJx0nQXatrTeadpqtO9vblk07TchWZGSe+lb66E50dKbSTtIoHhQUNiIeIj/bkpLkdtt2GAoMDBIeCh6QbEhI/LRstGvkuLiPN+Q3JV2fn3jnXedhbr29D7JusobvQ0NpKu8qk6bExDXxpvFyqDk52uOo42KkMTHG96T3vTfT04pZN1n/i/LydIaLhrEy1dWDVjJWDUOLi07FQ8XcWW5uhetZ66+32toYwrfCAowBAY6PjI95ZLGxHaxkrCPSnJzxbdJtkuBJSXI74DurtNjYH8e0x0P6rKy5FfoV/Qfz8/oJBwmFJc/PoG8lb4+vysog6q/q84709H2JjomO6UdHZyDpICAYEBA4KBgo3tVvbwtk1WT7iPDwc4OIg5RvSkr7sW+xuHJcXMqWcpZwJDg4VGwkbK7xV1dfCPEI5sdzcyFSx1I1UZeXZPNR840jy8uuZSNlWXyhoSWEfITLnOjoV7+cv3whPj5dYyFjN92Wlup83XzC3GFhHn/cfxqGDQ2ckYaRHoUPD5uUhZTbkODgS6uQq/hCfHy6xkLG4sRxcSZXxFeDqszMKeWq5TvYkJDjc9hzDAUGBgkPBQ/1Aff39AMBAzgSHBwqNhI2n6PCwjz+o/7UX2pqi+Ff4Uf5rq6+EPkQ0tBpaQJr0GsukRcXv6iRqClYmZlx6FjodCc6OlNpJ2lOuScn99C50Kk42dmRSDhIzRPr6941EzVWsysr5c6zzkQzIiJ3VTNVv7vS0gTWu9ZJcKmpOZBwkA6JBweHgImAZqczM8Hyp/Jati0t7MG2wXgiPDxaZiJmKpIVFbitkq2JIMnJqWAgYBVJh4dc20nbT/+qqrAa/xqgeFBQ2Ih4iFF6paUrjnqOBo8DA4mKj4qy+FlZShP4ExKACQmSm4CbNBcaGiM5FznK2mVlEHXadbUx19eEUzFTE8aEhNVRxlG7uNDQA9O40x/DgoLcXsNeUrApKeLLsMu0d1paw5l3mTwRHh4tMxEz9st7ez1Gy0ZL/Kiotx/8H9rWbW0MYdZhWDosLGJOOk4=")), fr = rr(nr("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")), sr = rr(nr("pfSXpcbGMvSEl+uE+Phvl5mwx5nu7l6wjYz3jfb2eowNF+UN///oF73ct73W1grcscinsd7eFshU/DlUkZFt/FDwwFBgYJDwAwUEAwICBwWp4Iepzs4u4H2HrH1WVtGHGSvVGefnzCtipnFitbUTpuYxmuZNTXwxmrXDmuzsWbVFzwVFj49Az528Pp0fH6O8QMAJQImJScCHku+H+vpokhU/xRXv79A/6yZ/67KylCbJQAfJjo7OQAsd7Qv7++Yd7C+C7EFBbi9nqX1ns7Maqf0cvv1fX0Mc6iWK6kVFYCW/2ka/IyP52vcCpvdTU1EClqHTluTkRaFb7S1bm5t27cJd6sJ1dShdHCTZHOHhxSSu6XquPT3U6Wq+mGpMTPK+Wu7YWmxsgu5Bw/xBfn69wwIG8QL19fMGT9EdT4ODUtFc5NBcaGiM5PQHovRRUVYHNFy5NNHRjVwIGOkI+fnhGJOu35Pi4kyuc5VNc6urPpVT9cRTYmKX9T9BVD8qKmtBDBQQDAgIHBRS9jFSlZVj9mWvjGVGRumvXuIhXp2df+IoeGAoMDBIeKH4bqE3N8/4DxEUDwoKGxG1xF61Ly/rxAkbHAkODhUbNlpINiQkflqbtjabGxuttj1HpT3f35hHJmqBJs3Np2ppu5xpTk71u81M/s1/fzNMn7rPn+rqULobLSQbEhI/LZ65Op4dHaS5dJywdFhYxJwucmguNDRGci13bC02NkF3ss2jstzcEc3uKXPutLSdKfsWtvtbW00W9gFT9qSkpQFN1+xNdnah12GjdWG3txSjzkn6zn19NEl7jaR7UlLfjT5CoT7d3Z9CcZO8cV5ezZOXoiaXExOxovUEV/WmpqIEaLhpaLm5AbgAAAAAAAAAACx0mSzBwbV0YKCAYEBA4KAfId0f4+PCIchD8sh5eTpD7Sx37ba2miy+2bO+1NQN2UbKAUaNjUfK2XDO2WdnF3BL3eRLcnKv3d55M96UlO151Gcr1JiY/2foI3vosLCTI0reEUqFhVvea71ta7u7Br0qfpEqxcW7fuU0nuVPT3s0FjrBFu3t1zrFVBfFhobSVNdiL9eamvhiVf/MVWZmmf+UpyKUERG2p89KD8+KisBKEDDJEOnp2TAGCggGBAQOCoGY54H+/maY8Atb8KCgqwtEzPBEeHi0zLrVSrolJfDV4z6W40tLdT7zDl/zoqKsDv4Zuv5dXUQZwFsbwICA21uKhQqKBQWAha3sfq0/P9PsvN9CvCEh/t9I2OBIcHCo2AQM+QTx8f0M33rG32NjGXrBWO7Bd3cvWHWfRXWvrzCfY6WEY0JC56UwUEAwICBwUBou0Rrl5csuDhLhDv397xJtt2Vtv78It0zUGUyBgVXUFDwwFBgYJDw1X0w1JiZ5Xy9xnS/Dw7Jx4Thn4b6+hjii/WqiNTXI/cxPC8yIiMdPOUtcOS4uZUtX+T1Xk5Nq+fINqvJVVVgNgp3jgvz8YZ1HyfRHenqzyazvi6zIyCfv5zJv57q6iDIrfWQrMjJPfZWk15Xm5kKkoPuboMDAO/uYszKYGRmqs9FoJ9GenvZof4Fdf6OjIoFmqohmRETuqn6CqH5UVNaCq+Z2qzs73eaDnhaDCwuVnspFA8qMjMlFKXuVKcfHvHvTbtbTa2sFbjxEUDwoKGxEeYtVeaenLIviPWPivLyBPR0nLB0WFjEndppBdq2tN5o7Ta0729uWTVb6yFZkZJ76TtLoTnR0ptIeIigeFBQ2Itt2P9uSkuR2Ch4YCgwMEh5stJBsSEj8tOQ3a+S4uI83XeclXZ+feOdusmFuvb0Psu8qhu9DQ2kqpvGTpsTENfGo43KoOTna46T3YqQxMcb3N1m9N9PTilmLhv+L8vJ0hjJWsTLV1YNWQ8UNQ4uLTsVZ69xZbm6F67fCr7fa2hjCjI8CjAEBjo9krHlksbEdrNJtI9KcnPFt4DuS4ElJcju0x6u02Ngfx/oVQ/qsrLkVBwn9B/Pz+gklb4Ulz8+gb6/qj6/KyiDqjonzjvT0fYnpII7pR0dnIBgoIBgQEDgo1WTe1W9vC2SIg/uI8PBzg2+xlG9KSvuxcpa4clxcypYkbHAkODhUbPEIrvFXV18Ix1Lmx3NzIVJR8zVRl5dk8yNljSPLy65lfIRZfKGhJYScv8uc6OhXvyFjfCE+Pl1j3Xw33ZaW6nzcf8LcYWEef4aRGoYNDZyRhZQehQ8Pm5SQq9uQ4OBLq0LG+EJ8fLrGxFfixHFxJleq5YOqzMwp5dhzO9iQkONzBQ8MBQYGCQ8BA/UB9/f0AxI2OBIcHCo2o/6fo8LCPP5f4dRfamqL4fkQR/murr4Q0GvS0GlpAmuRqC6RFxe/qFjoKViZmXHoJ2l0Jzo6U2m50E65Jyf30DhIqTjZ2ZFIEzXNE+vr3jWzzlazKyvlzjNVRDMiIndVu9a/u9LSBNZwkElwqak5kImADokHB4eAp/JmpzMzwfK2wVq2LS3swSJmeCI8PFpmkq0qkhUVuK0gYIkgycmpYEnbFUmHh1zb/xpP/6qqsBp4iKB4UFDYiHqOUXqlpSuOj4oGjwMDiYr4E7L4WVlKE4CbEoAJCZKbFzk0FxoaIznadcraZWUQdTFTtTHX14RTxlETxoSE1VG407u40NAD08NeH8OCgtxesMtSsCkp4st3mbR3WlrDmREzPBEeHi0zy0b2y3t7PUb8H0v8qKi3H9Zh2tZtbQxhOk5YOiwsYk4=")), cr = rr(nr("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")), hr = rr(nr("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")), lr = function(c, t) {
  if (c === 7) return 255 & t.lo;
  var n = 8 * (7 - c);
  if (n >= 32) return t.hi >>> n - 32 & 255;
  var ie = 32 - n;
  return 255 & (t.lo >>> n | t.hi << ie >>> ie << ie);
}, dr = [J$1(0, 0), J$1(0, 16), J$1(0, 32), J$1(0, 48), J$1(0, 64), J$1(0, 80), J$1(0, 96), J$1(0, 112), J$1(0, 128), J$1(0, 144), J$1(0, 160), J$1(0, 176), J$1(0, 192), J$1(0, 208), J$1(0, 224), J$1(0, 240)], gr = [J$1(4294967295, 4294967295), J$1(4294967295, 4294967279), J$1(4294967295, 4294967263), J$1(4294967295, 4294967247), J$1(4294967295, 4294967231), J$1(4294967295, 4294967215), J$1(4294967295, 4294967199), J$1(4294967295, 4294967183), J$1(4294967295, 4294967167), J$1(4294967295, 4294967151), J$1(4294967295, 4294967135), J$1(4294967295, 4294967119), J$1(4294967295, 4294967103), J$1(4294967295, 4294967087), J$1(4294967295, 4294967071), J$1(4294967295, 4294967055)], pr = [J$1(0, 0), J$1(0, 1), J$1(0, 2), J$1(0, 3), J$1(0, 4), J$1(0, 5), J$1(0, 6), J$1(0, 7), J$1(0, 8), J$1(0, 9), J$1(0, 10), J$1(0, 11), J$1(0, 12), J$1(0, 13)], vr = function(c, t) {
  for (var n = new Array(16), ie = new Array(16), fe = 0; fe < 16; fe++) ie[fe] = c[fe], n[fe] = ie[fe].xor(t[fe]);
  for (var ae = new Array(16), le = 0; le < 14; le++) {
    for (var he = 0; he < 16; he++) n[he].setxor64(dr[he].plus(pr[le]).setShiftLeft(56));
    for (var me = 0; me < 16; me++) ae[me] = _$1(or[lr(0, n[me])], ir[lr(1, n[me + 1 & 15])], ar[lr(2, n[me + 2 & 15])], ur[lr(3, n[me + 3 & 15])], fr[lr(4, n[me + 4 & 15])], sr[lr(5, n[me + 5 & 15])], cr[lr(6, n[me + 6 & 15])], hr[lr(7, n[me + 11 & 15])]);
    var ye = n;
    n = ae, ae = ye;
  }
  for (var be = 0; be < 14; be++) {
    for (var Ae = 0; Ae < 16; Ae++) ie[Ae].setxor64(pr[be], gr[Ae]);
    for (var Se = 0; Se < 16; Se++) ae[Se] = _$1(or[lr(0, ie[Se + 1 & 15])], ir[lr(1, ie[Se + 3 & 15])], ar[lr(2, ie[Se + 5 & 15])], ur[lr(3, ie[Se + 11 & 15])], fr[lr(4, ie[Se + 0 & 15])], sr[lr(5, ie[Se + 2 & 15])], cr[lr(6, ie[Se + 4 & 15])], hr[lr(7, ie[Se + 6 & 15])]);
    var $e = ie;
    ie = ae, ae = $e;
  }
  for (var Re = 0; Re < 16; Re++) t[Re].setxor64(n[Re], ie[Re]);
}, wr = function(c, t, n) {
  var ie, fe, ae = new Array(16);
  if (ie = c.buffer, n < c.buffer.length - (fe = c.ptr)) return $$1(ie, fe, t, t.length), void (c.ptr = fe += t.length);
  for ($$1(ae, 0, c.state, 16); n > 0; ) {
    var le = c.buffer.length - fe;
    if (le > n && (le = n), $$1(ie, fe, t, le), fe += le, t = t.slice(le), n -= le, fe === c.buffer.length) {
      var he = rr(ie);
      vr(he, ae), c.count.addOne(), fe = 0;
    }
  }
  c.state = ae, c.ptr = fe;
};
function mr$1(c, t, n) {
  var ie;
  ie = t === 1 ? c : t === 2 ? tr(c) : function(he) {
    for (var me = he.length, ye = new Array(me), be = 0; be < me; ) ye[be] = he.charCodeAt(be), be++;
    return ye;
  }(c);
  var fe = {};
  fe.state = new Array(16);
  for (var ae = 0; ae < 15; ae++) fe.state[ae] = new j$1(0, 0);
  fe.state[15] = new j$1(0, 512), fe.ptr = 0, fe.count = new j$1(0, 0), fe.buffer = new Array(128), wr(fe, ie, ie.length);
  var le = function(he) {
    var me, ye, be, Ae, Se, $e = he.ptr, Re = new Array(136);
    Re[0] = 128, $e < 120 ? (me = 128 - $e, ye = he.count.plus(J$1(0, 1))) : (me = 256 - $e, ye = he.count.plus(J$1(0, 2))), function(Ie, qe, Ue, ze) {
      for (var Ve = 0; Ve < ze; ) Ie[Ve + 1] = 0, Ve++;
    }(Re, 0, 0, me - 9), (be = Re)[Ae = me - 8] = (Se = ye).hi >>> 24, be[Ae + 1] = Se.hi >>> 16 & 255, be[Ae + 2] = Se.hi >>> 8 & 255, be[Ae + 3] = 255 & Se.hi, be[Ae + 4] = Se.lo >>> 24, be[Ae + 5] = Se.lo >>> 16 & 255, be[Ae + 6] = Se.lo >>> 8 & 255, be[Ae + 7] = 255 & Se.lo, wr(he, Re, me), function(Ie) {
      var qe = new Array(16);
      (function(jt, _e, se, ce) {
        for (var de = 0; de < 16; ) jt[de + 0] = se[de].clone(), de++;
      })(qe, 0, Ie);
      for (var Ue = new Array(16), ze = 0; ze < 14; ze++) {
        for (var Ve = 0; Ve < 16; Ve++) qe[Ve].setxor64(dr[Ve].plus(pr[ze]).setShiftLeft(56));
        for (var Mt = 0; Mt < 16; Mt++) Ue[Mt] = _$1(or[lr(0, qe[Mt])], ir[lr(1, qe[Mt + 1 & 15])], ar[lr(2, qe[Mt + 2 & 15])], ur[lr(3, qe[Mt + 3 & 15])], fr[lr(4, qe[Mt + 4 & 15])], sr[lr(5, qe[Mt + 5 & 15])], cr[lr(6, qe[Mt + 6 & 15])], hr[lr(7, qe[Mt + 11 & 15])]);
        var Rt = qe;
        qe = Ue, Ue = Rt;
      }
      for (var je = 0; je < 16; je++) Ie[je].setxor64(qe[je]);
    }(he.state);
    for (var Me = new Array(16), ke = 0, Te = 8; ke < 8; ke++, Te++) Me[2 * ke] = he.state[Te].hi, Me[2 * ke + 1] = he.state[Te].lo;
    return Me;
  }(fe);
  return n === 2 ? le : n === 1 ? tr(le) : function(he) {
    for (var me = "", ye = he.length, be = 0; be < ye; be++) {
      var Ae = he[be];
      Ae < 0 && (Ae = 4294967295 + he[be] + 1);
      for (var Se = Ae.toString(16); Se.length < 8; ) Se = "0" + Se;
      me += Se;
    }
    return me;
  }(le);
}
for (var yr = {}, Br = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Er = [], br = 0; br < Br.length; br++) Er.push(Br.charCodeAt(br));
var Ir = [0, 2, 3, 5, 6, 7, 9, 10, 11], Ar = Er.length;
function Ur(c) {
  var t = function(he) {
    if (he.length % 2 != 0) throw Error("Hex string has invalid length!");
    for (var me = new Uint8Array(he.length / 2), ye = 0; ye < he.length / 2; ++ye) me[ye] = parseInt(he.slice(2 * ye, 2 * ye + 2), 16);
    return me;
  }(c.toString("hex"));
  if (t.length === 0) throw Error("Unrecognised address format");
  var n, ie = Math.floor(t.length / 8), fe = t.length % 8, ae = 11 * ie + Ir[fe], le = new Uint8Array(ae);
  for (n = 0; n < ae; ++n) le[n] = Er[0];
  for (n = 0; n < ie; n++) le = yr.encodeBlock(t.subarray(8 * n, 8 * n + 8), le, 11 * n);
  return fe > 0 && (le = yr.encodeBlock(t.subarray(8 * ie, 8 * ie + fe), le, 11 * ie)), function(he) {
    for (var me = [], ye = 0, be = Object.keys(he); ye < be.length; ye++) me.push(String.fromCharCode(he[Number(be[ye])]));
    return me.join("");
  }(le);
}
function Sr(c) {
  var t = function(he) {
    for (var me = new Uint8Array(he.length), ye = 0; ye < he.length; ye++) me[ye] = he.charCodeAt(ye);
    return me;
  }(c);
  if (t.length === 0) throw Error("Unrecognised address format");
  var n = Math.floor(t.length / 11), ie = t.length % 11, fe = Ir.indexOf(ie);
  if (fe < 0) throw Error("Invalid encoded length");
  for (var ae = new Uint8Array(8 * n + fe), le = 0; le < n; le++) ae = yr.decodeBlock(t.subarray(11 * le, 11 * le + 11), ae, 8 * le);
  return ie > 0 && (ae = yr.decodeBlock(t.subarray(11 * n, 11 * n + ie), ae, 8 * n)), Buffer$7.from(function(he) {
    for (var me = [], ye = 0, be = Object.keys(he); ye < be.length; ye++) me.push(("0" + he[Number(be[ye])].toString(16)).slice(-2));
    return me.join("");
  }(ae), "hex");
}
function xr(c, t) {
  return ("00" + (98 - function(n) {
    for (var ie = n.split("").map(function(le) {
      var he = le.toUpperCase().charCodeAt(0);
      return he >= 48 && he <= 57 ? le : (he - 55).toString();
    }).join(""), fe = "", ae = 0; ae < Math.ceil(ie.length / 6); ae++) fe = (parseInt(fe + ie.substr(6 * ae, 6), 10) % 97).toString();
    return parseInt(fe, 10);
  }(c + t + "00"))).slice(-2);
}
function Cr(c) {
  return c.replace(/^0x/, "");
}
function Or(c) {
  return "0x" + Cr(c);
}
yr.encodeBlock = function(c, t, n) {
  if (c.length < 1 || c.length > 11) throw Error("Invalid block length: " + c.length);
  for (var ie = function(le) {
    if (le.length < 1 || le.length > 8) throw Error("Invalid input length");
    var he = L$1.zero, me = L$1(2).pow(8), ye = 0;
    switch (9 - le.length) {
      case 1:
        he = he.add(le[ye++]);
      case 2:
        he = he.multiply(me).add(le[ye++]);
      case 3:
        he = he.multiply(me).add(le[ye++]);
      case 4:
        he = he.multiply(me).add(le[ye++]);
      case 5:
        he = he.multiply(me).add(le[ye++]);
      case 6:
        he = he.multiply(me).add(le[ye++]);
      case 7:
        he = he.multiply(me).add(le[ye++]);
      case 8:
        he = he.multiply(me).add(le[ye++]);
        break;
      default:
        throw Error("Impossible condition");
    }
    return he;
  }(c), fe = Ir[c.length] - 1; ie.compare(0) === 1; ) {
    var ae = ie.divmod(Ar);
    ie = ae.quotient, t[n + fe] = Er[parseInt(ae.remainder.toString(), 10)], fe--;
  }
  return t;
}, yr.decodeBlock = function(c, t, n) {
  if (c.length < 1 || c.length > 11) throw Error("Invalid block length: " + c.length);
  var ie = Ir.indexOf(c.length);
  if (ie <= 0) throw Error("Invalid block size");
  for (var fe = L$1(0), ae = L$1(1), le = c.length - 1; le >= 0; le--) {
    var he = Er.indexOf(c[le]);
    if (he < 0) throw Error("Invalid symbol");
    var me = ae.multiply(he).add(fe);
    if (me.compare(L$1(2).pow(64)) === 1) throw Error("Overflow");
    fe = me, ae = ae.multiply(Ar);
  }
  if (ie < 8 && L$1(2).pow(8 * ie).compare(fe) <= 0) throw Error("Overflow 2");
  return t.set(function(ye, be) {
    var Ae = new Uint8Array(be);
    if (be < 1 || be > 8) throw Error("Invalid input length");
    for (var Se = L$1(2).pow(8), $e = be - 1; $e >= 0; $e--) Ae[$e] = parseInt(ye.remainder(Se).toString(), 10), ye = ye.divide(Se);
    return Ae;
  }(fe, ie), n), t;
};
var Nr = bnExports$1;
function qr(c, t) {
  return typeof c == "string" && (c = c.toLowerCase()), typeof c == "string" && function(n) {
    return /^0x[0-9a-f]*$/i.test(n);
  }(c) && !t ? new Nr(Cr(c), "hex") : new Nr(c, t);
}
function Tr(c) {
  return Or(c.toString("hex"));
}
var Lr = qr(0), Rr = qr(2).pow(qr(251));
function kr(c) {
  return typeof c == "number" && c == c && c % 1 == 0;
}
function Fr(c) {
  var t, n, ie = Cr(function(le) {
    (function(me, ye, be, Ae) {
      var Se = "invalid " + Ae + " length", $e = qr(me);
      (function(Re, Me) {
        if (!Re) throw new Error(Me);
      })($e.gte(qr(ye)) && $e.lt(qr(be)), "Message not signable, " + Se + ".");
    })(le, Lr, Rr, "Starknet Address");
    var he = function(me) {
      return Or(Cr(Tr(qr(me))).padStart(64, "0"));
    }(le);
    if (!he.match(/^(0x)?[0-9a-fA-F]{64}$/)) throw new Error("Invalid Address Format");
    return he;
  }(c)).toLowerCase().split(""), fe = function(le, he) {
    if (he || (he = {}), typeof le == "number") {
      (function(Se, $e) {
        if (typeof Se == "number" && (Se < 0 || Se >= 9007199254740991 || Se % 1))
          throw $e;
      })(le, "invalid arrayify value");
      for (var me = []; le; ) me.unshift(255 & le), le = parseInt(String(le / 256), 10);
      return me.length === 0 && me.push(0), new Uint8Array(me);
    }
    if (he.allowMissingPrefix && typeof le == "string" && le.substring(0, 2) !== "0x" && (le = "0x" + le), function(Se) {
      return !!Se.toHexString;
    }(le) && (le = le.toHexString()), function(Se, $e) {
      return !(typeof Se != "string" || !Se.match(/^0x[0-9A-Fa-f]*$/));
    }(le)) {
      var ye = le.substring(2);
      if (ye.length % 2) if (he.hexPad === "left") ye = "0" + ye;
      else {
        if (he.hexPad !== "right") throw Error("hex data is odd-lengthvalue" + le);
        ye += "0";
      }
      for (var be = [], Ae = 0; Ae < ye.length; Ae += 2) be.push(parseInt(ye.substring(Ae, Ae + 2), 16));
      return new Uint8Array(be);
    }
    if (function(Se) {
      if (Se == null) return !1;
      if (Se.constructor === Uint8Array) return !0;
      if (typeof Se == "string" || !kr(Se.length) || Se.length < 0) return !1;
      for (var $e, Re = q$1(Se); !($e = Re()).done; ) {
        var Me = $e.value;
        if (!kr(Me) || Me < 0 || Me >= 256) return !1;
      }
      return !0;
    }(le)) return new Uint8Array(le);
  }((n = (t = Cr(Tr(qr(c)))).length % 2 == 0 ? t : "0" + t, Or(new sha3$1.Keccak(256).update(Buffer$7.from(function(le) {
    if (typeof le != "string") throw new TypeError("hexToBytes: expected string, got " + typeof le);
    if (le.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    for (var he = new Uint8Array(le.length / 2), me = 0; me < he.length; me++) {
      var ye = 2 * me, be = le.slice(ye, ye + 2), Ae = Number.parseInt(be, 16);
      if (Number.isNaN(Ae) || Ae < 0) throw new Error("Invalid byte sequence");
      he[me] = Ae;
    }
    return he;
  }(n))).digest().toString("hex"))), { hexPad: "left" });
  if (fe === void 0) throw Error("hashed is undefined");
  for (var ae = 0; ae < ie.length; ae += 2) fe[ae >> 1] >> 4 >= 8 && (ie[ae] = ie[ae].toUpperCase()), (15 & fe[ae >> 1]) >= 8 && (ie[ae + 1] = ie[ae + 1].toUpperCase());
  return Or(ie.join(""));
}
qr(2).pow(qr(128)).add(qr(1));
var Mr = bech32.decode, Dr = bech32.encode, Xr = bech32.fromWords, Gr = bech32.toWords, Vr = 2147483648;
function Qr(c, t) {
  return function(n) {
    var ie;
    switch (n.readUInt8(0)) {
      case 118:
        if (n.readUInt8(1) !== 169 || n.readUInt8(n.length - 2) !== 136 || n.readUInt8(n.length - 1) !== 172) throw Error("Unrecognised address format");
        return ie = Buffer$7.concat([Buffer$7.from(c), n.slice(3, 3 + n.readUInt8(2))]), Ut$1(ie);
      case 169:
        if (n.readUInt8(n.length - 1) !== 135) throw Error("Unrecognised address format");
        return ie = Buffer$7.concat([Buffer$7.from(t), n.slice(2, 2 + n.readUInt8(1))]), Ut$1(ie);
      default:
        throw Error("Unrecognised address format");
    }
  };
}
function Wr(c, t) {
  return function(n) {
    var ie = Ct$1(n), fe = function(ae) {
      return ae.every(function(le, he) {
        return he < ie.length && le === ie.readUInt8(he);
      });
    };
    if (c.some(fe)) return Buffer$7.concat([Buffer$7.from([118, 169, 20]), ie.slice(c[0].length), Buffer$7.from([136, 172])]);
    if (t.some(fe)) return Buffer$7.concat([Buffer$7.from([169, 20]), ie.slice(t[0].length), Buffer$7.from([135])]);
    throw Error("Unrecognised address format");
  };
}
var Pr = function(c, t, n, ie) {
  return { coinType: t, decoder: Wr(n, ie), encoder: Qr(n[0], ie[0]), name: c };
};
function zr(c) {
  return function(t) {
    var n = t.readUInt8(0);
    if (n >= 81 && n <= 96) n -= 80;
    else if (n !== 0) throw Error("Unrecognised address format");
    var ie = [n].concat(Gr(t.slice(2, t.readUInt8(1) + 2)));
    return Dr(c, ie);
  };
}
function Kr(c) {
  return function(t) {
    var n = Mr(t), ie = n.words;
    if (n.prefix !== c) throw Error("Unexpected human-readable part in bech32 encoded address");
    var fe = Xr(ie.slice(1)), ae = ie[0];
    return ae > 0 && (ae += 80), Buffer$7.concat([Buffer$7.from([ae, fe.length]), Buffer$7.from(fe)]);
  };
}
function Hr(c, t, n) {
  var ie = zr(c), fe = Qr(t, n);
  return function(ae) {
    try {
      return fe(ae);
    } catch {
      return ie(ae);
    }
  };
}
function Zr(c, t, n) {
  var ie = Kr(c), fe = Wr(t, n);
  return function(ae) {
    return ae.toLowerCase().startsWith(c + "1") ? ie(ae) : fe(ae);
  };
}
var Yr = function(c, t, n, ie, fe) {
  return { coinType: t, decoder: Zr(n, ie, fe), encoder: Hr(n, ie[0], fe[0]), name: c };
};
function jr(c, t, n) {
  var ie = ut(c), fe = Qr(t, n);
  return function(ae) {
    try {
      return fe(ae);
    } catch {
      return ie(ae);
    }
  };
}
function Jr(c, t, n) {
  var ie = Wr(t, n), fe = ft(c);
  return function(ae) {
    return ae.toLowerCase().startsWith(c) ? fe(ae) : ie(ae);
  };
}
var _r = function(c, t, n, ie, fe) {
  return { coinType: t, decoder: Jr(n, ie, fe), encoder: jr(n, ie[0], fe[0]), name: c };
};
function $r(c) {
  var t, n = (t = mr$1(c, 1, 2), tr(t = (t = mr$1(t, 2, 2)).slice(0, 8)));
  return Buffer$7.from(n);
}
function rt(c) {
  var t = $r(c);
  return bs58.encode(Buffer$7.concat([c, t], c.length + 4));
}
function tt(c) {
  return function(t) {
    return C$1(t.toString("hex"), c || null);
  };
}
function et(c) {
  return function(t) {
    var n = O$1(t);
    if (!U$1(t, c || null) && n !== n.toLowerCase() && n !== n.toUpperCase()) throw Error("Invalid address checksum");
    return Buffer$7.from(O$1(t), "hex");
  };
}
var nt = function(c, t, n) {
  return { coinType: t, decoder: et(n), encoder: tt(n), name: c };
}, ot = function(c) {
  if (c >= 2147483648) throw Error("chainId " + c + " must be less than 2147483648");
  return (2147483648 | c) >>> 0;
}, it = function(c) {
  if (!(2147483648 & c)) throw Error("coinType " + c + " is not an EVM chain");
  return (2147483647 & c) >> 0;
}, at = function(c, t) {
  return { coinType: ot(t), decoder: et(), encoder: tt(), name: c };
};
function ut(c, t) {
  return function(n) {
    return Dr(c, Gr(n), t);
  };
}
function ft(c, t) {
  return function(n) {
    var ie = Mr(n, t), fe = ie.words;
    if (ie.prefix !== c) throw Error("Unrecognised address format");
    return Buffer$7.from(Xr(fe));
  };
}
var st = function(c, t, n, ie) {
  return { coinType: t, decoder: ft(n, ie), encoder: ut(n, ie), name: c };
};
function ct(c) {
  return function(t) {
    if (!J$2.isValid(t)) throw Error("Unrecognised address format");
    return J$2.fromHex(t).toString().replace(/^.{3}/g, c);
  };
}
function ht(c) {
  return function(t) {
    if (!J$2.isValid(t)) throw Error("Unrecognised address format");
    var n = new RegExp("^.{" + c.length + "}", "g"), ie = t.replace(n, "EOS");
    return J$2(ie).toBuffer();
  };
}
var lt = function(c, t, n) {
  return { coinType: t, decoder: ht(n), encoder: ct(n), name: c };
};
function dt(c) {
  return Buffer$7.from(gt$1(c));
}
function gt(c) {
  for (var t, n = O$1(c).toLowerCase(), ie = new sha3$1.Keccak(256).update(Buffer$7.from(n)).digest(), fe = "0x", ae = n.length, le = 0; le < ae; le++) t = ie[Math.floor(le / 2)], le % 2 == 0 ? t >>= 4 : t &= 15, fe += n[le] > "9" && t <= 7 ? n[le].toUpperCase() : n[le];
  return fe;
}
function pt(c) {
  if (c.readInt8(0) !== 5 || c.readInt8(1) !== 77 || c.length !== 26) return !1;
  var t, n = c.slice(-4), ie = (t = c.slice(0, -4), new sha3$1.Keccak(256).update(Buffer$7.from(blakejs.blake2b(Uint8Array.from(t), null, 32))).digest().slice(0, 4));
  return n.equals(ie);
}
var vt = [0, 0, 1, 18, 2, 5, 19, 11, 3, 29, 6, 27, 20, 8, 12, 23, 4, 10, 30, 17, 7, 22, 28, 26, 21, 25, 9, 16, 13, 14, 24, 15], wt = [1, 2, 4, 8, 16, 5, 10, 20, 13, 26, 17, 7, 14, 28, 29, 31, 27, 19, 3, 6, 12, 24, 21, 15, 30, 25, 23, 11, 22, 9, 18, 1], mt = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ", yt = [3, 2, 1, 0, 7, 6, 5, 4, 13, 14, 15, 16, 12, 8, 9, 10, 11];
function Bt(c) {
  return sha512Exports.sha512_256.update(c).hex().substr(-8);
}
var Et, bt, It, At, Ut, St, xt, Ct, Ot = function(c, t, n, ie) {
  return { coinType: t, decoder: ie, encoder: n, name: c };
}, Nt = [Yr("BTC", 0, "bc", [[0]], [[5]]), Yr("LTC", 2, "ltc", [[48]], [[50], [5]]), Pr("DOGE", 3, [[30]], [[22]]), Pr("RDD", 4, [[61]], [[5]]), Pr("DASH", 5, [[76]], [[16]]), Pr("PPC", 6, [[55]], [[117]]), Ot("NMC", 7, Ut$1, Ct$1), Pr("VIA", 14, [[71]], [[33]]), (Et = [[36]], bt = [[5]], { coinType: 17, decoder: function(c, t, n) {
  var ie = Kr("grs"), fe = /* @__PURE__ */ function(ae, le) {
    return function(he) {
      var me = function(be) {
        var Ae = function(Se) {
          var $e = Se.slice(0, -4), Re = Se.slice(-4), Me = $r($e);
          return Re[0] ^ Me[0] | Re[1] ^ Me[1] | Re[2] ^ Me[2] | Re[3] ^ Me[3] ? Buffer$7.from([]) : $e;
        }(bs58.decode(be));
        if (Ae.length === 0) throw new Error("Invalid checksum");
        return Ae;
      }(he), ye = function(be) {
        return be.every(function(Ae, Se) {
          return Se < me.length && Ae === me.readUInt8(Se);
        });
      };
      if (ae.some(ye)) return Buffer$7.concat([Buffer$7.from([118, 169, 20]), me.slice(ae[0].length), Buffer$7.from([136, 172])]);
      if (le.some(ye)) return Buffer$7.concat([Buffer$7.from([169, 20]), me.slice(le[0].length), Buffer$7.from([135])]);
      throw Error("Unrecognised address format");
    };
  }(t, n);
  return function(ae) {
    return ae.toLowerCase().startsWith("grs1") ? ie(ae) : fe(ae);
  };
}(0, Et, bt), encoder: (At = Et[0], Ut = bt[0], St = zr("grs"), xt = /* @__PURE__ */ function(c, t) {
  return function(n) {
    switch (n.readUInt8(0)) {
      case 118:
        if (n.readUInt8(1) !== 169 || n.readUInt8(n.length - 2) !== 136 || n.readUInt8(n.length - 1) !== 172) throw Error("Unrecognised address format");
        return rt(Buffer$7.concat([Buffer$7.from(c), n.slice(3, 3 + n.readUInt8(2))]));
      case 169:
        if (n.readUInt8(n.length - 1) !== 135) throw Error("Unrecognised address format");
        return rt(Buffer$7.concat([Buffer$7.from(t), n.slice(2, 2 + n.readUInt8(1))]));
      default:
        throw Error("Unrecognised address format");
    }
  };
}(At, Ut), function(c) {
  try {
    return xt(c);
  } catch {
    return St(c);
  }
}), name: "GRS" }), Yr("DGB", 20, "dgb", [[30]], [[63]]), Yr("MONA", 22, "mona", [[50]], [[55], [5]]), Ot("DCR", 42, bs58.encode, bs58.decode), Ot("XEM", 43, function(c) {
  return d$1(s(c.toString("hex")));
}, function(c) {
  if (!p$1(c)) throw Error("Unrecognised address format");
  var t = c.toString().toUpperCase().replace(/-/g, "");
  return l$1(t);
}), Pr("AIB", 55, [[23]], [[5]]), Yr("SYS", 57, "sys", [[63]], [[5]]), nt("ETH", 60), nt("ETC_LEGACY", 61), Ot("ICX", 74, function(c) {
  if (c.length !== 21) throw Error("Unrecognised address format");
  switch (c.readUInt8(0)) {
    case 0:
      return "hx" + c.slice(1).toString("hex");
    case 1:
      return "cx" + c.slice(1).toString("hex");
    default:
      throw Error("Unrecognised address format");
  }
}, function(c) {
  var t = c.slice(0, 2), n = c.slice(2);
  switch (t) {
    case "hx":
      return Buffer$7.concat([Buffer$7.from([0]), Buffer$7.from(n, "hex")]);
    case "cx":
      return Buffer$7.concat([Buffer$7.from([1]), Buffer$7.from(n, "hex")]);
    default:
      throw Error("Unrecognised address format");
  }
}), Pr("XVG", 77, [[30]], [[33]]), Pr("STRAT", 105, [[63]], [[125]]), Ot("ARK", 111, Ut$1, function(c) {
  var t = Ct$1(c);
  if (t[0] !== 23) throw Error("Unrecognised address format");
  return t;
}), st("ATOM", 118, "cosmos"), st("ZIL", 119, "zil"), st("EGLD", 120, "erd"), Ot("ZEN", 121, function(c) {
  if (!(c.slice(0, 2).equals(Buffer$7.from([32, 137])) || c.slice(0, 2).equals(Buffer$7.from([28, 184])) || c.slice(0, 2).equals(Buffer$7.from([32, 150])) || c.slice(0, 2).equals(Buffer$7.from([28, 189])) || c.slice(0, 2).equals(Buffer$7.from([22, 154])))) throw Error("Unrecognised address format");
  return Ut$1(c);
}, function(c) {
  if (!(c.startsWith("zn") || c.startsWith("zs") || c.startsWith("zc") || c.startsWith("t1") || c.startsWith("t3"))) throw Error("Unrecognised address format");
  return Ct$1(c);
}), Ot("XMR", 128, Ur, Sr), _r("ZEC", 133, "zs", [[28, 184]], [[28, 189]]), Ot("LSK", 134, function(c) {
  return L$1(c.toString("hex"), 16).toString(10) + "L";
}, function(c) {
  return function(t) {
    if (t.length < 2 || t.length > 22) throw new Error("Address length does not match requirements. Expected between 2 and 22 characters.");
    if (t[t.length - 1] !== "L") throw new Error('Address format does not match requirements. Expected "L" at the end.');
    if (t.includes(".")) throw new Error("Address format does not match requirements. Address includes invalid character: `.`.");
  }(c), Buffer$7.from(L$1(c.slice(0, -1)).toString(16), "hex");
}), lt("STEEM", 135, "STM"), Pr("FIRO", 136, [[82]], [[7]]), nt("RSK", 137, 30), Pr("KMD", 141, [[60]], [[85]]), Ot("XRP", 144, function(c) {
  return k$2.encodeChecked(c);
}, function(c) {
  return k$2.decodeChecked(c);
}), Ot("BCH", 145, function(c) {
  switch (c.readUInt8(0)) {
    case 118:
      if (c.readUInt8(1) !== 169 || c.readUInt8(c.length - 2) !== 136 || c.readUInt8(c.length - 1) !== 172) throw Error("Unrecognised address format");
      return zt("bitcoincash", 0, c.slice(3, 3 + c.readUInt8(2)));
    case 169:
      if (c.readUInt8(c.length - 1) !== 135) throw Error("Unrecognised address format");
      return zt("bitcoincash", 1, c.slice(2, 2 + c.readUInt8(1)));
    default:
      throw Error("Unrecognised address format");
  }
}, function(c) {
  var t = Wr([[0]], [[5]]);
  try {
    return t(c);
  } catch {
    return function(ie) {
      var fe = kt(ie), ae = fe.type, le = fe.hash;
      if (ae === 0) return Buffer$7.concat([Buffer$7.from([118, 169, 20]), Buffer$7.from(le), Buffer$7.from([136, 172])]);
      if (ae === 1) return Buffer$7.concat([Buffer$7.from([169, 20]), Buffer$7.from(le), Buffer$7.from([135])]);
      throw Error("Unrecognised address format");
    }(c);
  }
}), Ot("XLM", 148, function(c) {
  return it$1("ed25519PublicKey", c);
}, function(c) {
  return nt$1("ed25519PublicKey", c);
}), Ot("BTM", 153, zr("bm"), Kr("bm")), Yr("BTG", 156, "btg", [[38]], [[23]]), Ot("NANO", 165, function(c) {
  var t = nanoBase32.encode(Uint8Array.from(c)), n = blakejs.blake2b(Uint8Array.from(c), null, 5).reverse();
  return "nano_" + t + nanoBase32.encode(n);
}, function(c) {
  var t = nanoBase32.decode(c.slice(5));
  return Buffer$7.from(t).slice(0, -5);
}), Pr("RVN", 175, [[60]], [[122]]), nt("POA_LEGACY", 178), Yr("LCC", 192, "lcc", [[28]], [[50], [5]]), lt("EOS", 194, "EOS"), Ot("TRX", 195, Ut$1, Ct$1), Ot("BCN", 204, function(c) {
  var t = new sha3$1.Keccak(256).update(c).digest().slice(0, 4);
  return Ur(Buffer$7.concat([c, t]));
}, function(c) {
  var t = Sr(c), n = t.slice(0, -68).toString("hex");
  if (t.length < 68 || n !== "06" && n !== "cef622") throw Error("Unrecognised address format");
  var ie = t.slice(-4);
  if (!new sha3$1.Keccak(256).update(t.slice(0, -4)).digest().slice(0, 4).equals(ie)) throw Error("Invalid checksum");
  return t.slice(0, -4);
}), lt("FIO", 235, "FIO"), Ot("BSV", 236, function(c) {
  var t = Buffer$7.concat([Buffer$7.from([0]), c]);
  return Ut$1(t);
}, function(c) {
  var t = Ct$1(c);
  if (t.length !== 21) throw Error("Unrecognised address format");
  if (t[0] !== 0) throw Error("Invalid version byte");
  return t.slice(1);
}), Ot("NEO", 239, Ut$1, Ct$1), Ot("NIM", 242, function(c) {
  var t = function(n, ie) {
    ie === void 0 && (ie = "0123456789ABCDEFGHJKLMNPQRSTUVXY");
    var fe, ae, le = 3, he = 0, me = "";
    for (ae = 0; ae < n.length; ae++) me += ie[31 & (he | (fe = n[ae]) >> le)], le > 5 && (me += ie[31 & fe >> (le -= 5)]), he = fe << (le = 5 - le), le = 8 - le;
    for (le !== 3 && (me += ie[31 & he]); me.length % 8 != 0 && ie.length === 33; ) me += ie[32];
    return me;
  }(c);
  return ("NQ" + xr(t, "NQ") + t).replace(/.{4}/g, "$& ").trim();
}, function(c) {
  if (!c.startsWith("NQ")) throw Error("Unrecognised address format");
  var t = c.replace(/ /g, ""), n = t.slice(2, 4), ie = t.slice(4);
  if (n !== xr(ie, "NQ")) throw Error("Unrecognised address format");
  return function(fe, ae) {
    ae === void 0 && (ae = "0123456789ABCDEFGHJKLMNPQRSTUVXY");
    var le, he = {};
    ae.toUpperCase().split("").forEach(function(Ae, Se) {
      Ae in he || (he[Ae] = Se);
    });
    var me = 8, ye = 0, be = [];
    return fe.toUpperCase().split("").forEach(function(Ae) {
      ae.length === 33 && Ae === ae[32] || (le = 255 & he[Ae], (me -= 5) > 0 ? ye |= le << me : me < 0 ? (be.push(ye | le >> -me), ye = le << (me += 8) & 255) : (be.push(ye | le), me = 8, ye = 0));
    }), me !== 8 && ye !== 0 && be.push(ye), Buffer$7.from(be);
  }(ie);
}), nt("EWT_LEGACY", 246), Ot("ALGO", 283, function(c) {
  var t = Bt(c);
  return d$1(s(c.toString("hex").concat(t))).replace(/=/g, "");
}, function(c) {
  var t = l$1(c);
  if (t.length !== 36) throw Error("Unrecognised address format");
  var n = t.slice(0, -4), ie = t.slice(-4), fe = Bt(n);
  if (ie.toString("hex") !== fe) throw Error("Unrecognised address format");
  return n;
}), Ot("IOST", 291, bs58.encode, bs58.decode), Pr("DIVI", 301, [[30]], [[13]]), st("IOTX", 304, "io"), lt("BTS", 308, "BTS"), st("CKB", 309, "ckb"), Ot("MRX", 326, Ut$1, Ct$1), st("LUNA", 330, "terra"), Ot("DOT", 354, function(c) {
  return yt$1(Uint8Array.from(c), 0);
}, dt), Ot("VSYS", 360, function(c) {
  if (!pt(c)) throw new Error("VSYS: Invalid checksum");
  return bs58.encode(c);
}, function(c) {
  var t = c;
  if (c.startsWith("address:") && (t = c.substr(c.length)), t.length > 36) throw new Error("VSYS: Address length should not be more than 36");
  var n = bs58.decode(t);
  if (!pt(n)) throw new Error("VSYS: Invalid checksum");
  return n;
}), lt("ABBC", 367, "ABBC"), Ot("NEAR", 397, function(c) {
  var t = c.toString();
  if (t.length > 64 || t.length < 2) throw Error("Invalid address format");
  return t;
}, function(c) {
  if (/(^(([a-z\d]+[\-_])*[a-z\d]+\.)*([a-z\d]+[\-_])*[a-z\d]+$)/g.test(c)) {
    if (c.length > 64 || c.length < 2) throw Error("Invalid address format");
    return Buffer$7.from(c);
  }
  throw Error("Invalid address string");
}), Ot("ETN", 415, function(c) {
  var t = Buffer$7.concat([Buffer$7.from([18]), c]), n = new sha3$1.Keccak(256).update(t).digest().slice(0, 4);
  return Ur(Buffer$7.concat([t, n]));
}, function(c) {
  var t = Sr(c);
  if (t[0] !== 18) throw Error("Unrecognised address format");
  var n = t.slice(65, 69);
  if (!new sha3$1.Keccak(256).update(t.slice(0, 65)).digest().slice(0, 4).equals(n)) throw Error("Invalid checksum");
  return t.slice(1, 65);
}), Ot("AION", 425, function(c) {
  return "0x".concat(c.toString("hex"));
}, function(c) {
  var t = c;
  if (t == null || t.length === 0 || t.length < 64 || (t.startsWith("0x") && (t = t.slice(2)), t.startsWith("a0") && (t.length !== 64 || !t.substring(2).match("^[0-9A-Fa-f]+$")))) throw Error("Unrecognised address format");
  return Buffer$7.from(t, "hex");
}), Ot("KSM", 434, function(c) {
  return yt$1(Uint8Array.from(c), 2);
}, dt), Ot("AE", 457, function(c) {
  return "ak_" + Ut$1(c.slice(2));
}, function(c) {
  return Buffer$7.concat([Buffer$7.from("0x"), Ct$1(c.split("_")[1])]);
}), st("KAVA", 459, "kava"), Ot("FIL", 461, function(c) {
  return K$1("f", H$1(c[0], c.slice(1))).toString();
}, function(c) {
  return function(t) {
    (function($e) {
      if (!$e) throw Error("No bytes to validate.");
      if ($e.length < 3) throw Error("Address is too short to validate.");
      if ($e[0] !== "f" && $e[0] !== "t") throw Error("Unknown address network.");
      switch ($e[1]) {
        case "0":
          if ($e.length > 22) throw Error("Invalid ID address length.");
          break;
        case "1":
          if ($e.length !== 41) throw Error("Invalid secp256k1 address length.");
          break;
        case "2":
          if ($e.length !== 41) throw Error("Invalid Actor address length.");
          break;
        case "3":
          if ($e.length !== 86) throw Error("Invalid BLS address length.");
          break;
        default:
          throw new Error("Invalid address protocol.");
      }
    })(t);
    var n, ie = t[0], fe = parseInt(t[1], 10), ae = Buffer$7.from([fe]), le = t.slice(2);
    if (fe === 0) return H$1(fe, Buffer$7.from((function($e, Re) {
      for (var Me = new Q$1($e); ; ) {
        var ke = Me.maskn(7).toNumber();
        if (Me.ishrn(7), Me.isZero()) {
          Re.write([ke]);
          break;
        }
        Re.write([128 | ke]);
      }
    }(le, n = new W$1()), n.buffer)));
    var he, me, ye = Buffer$7.from(l$1(le.toUpperCase())), be = ye.length, Ae = ye.slice(0, be - 4);
    if (he = ye.slice(be - 4, be), me = z$1(Buffer$7.concat([ae, Ae])), Buffer$7.compare(Buffer$7.from(me), he)) throw Error("Checksums don't match");
    var Se = H$1(fe, Ae);
    if (K$1(ie, Se) !== t) throw Error("Did not encode this address properly: " + t);
    return Se;
  }(c).str;
}), Ot("AR", 472, function(c) {
  return c.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
}, function(c) {
  return c = (c = c.replace(/\-/g, "+").replace(/\_/g, "/")).concat("=".repeat(c.length % 4 == 0 ? 0 : 4 - c.length % 4)), Buffer$7.from(c, "base64");
}), Pr("CCA", 489, [[11]], [[5]]), nt("THETA_LEGACY", 500), Ot("SOL", 501, bs58.encode, bs58.decode), Ot("XHV", 535, Ur, Sr), Ot("FLOW", 539, function(c) {
  var t = Buffer$7.alloc(8, 0);
  return c.length > 8 && (t = c.slice(-8)), c.copy(t, 8 - c.length), "0x" + t.toString("hex").toLowerCase();
}, function(c) {
  if (!function(t, n) {
    var ie = t;
    if ((ie = BigInt(ie) ^ BigInt(n.codeword)) === BigInt(0)) return !1;
    for (var fe = BigInt(0), ae = 0; ae < 64; ae++) (BigInt(ie) & BigInt(1)) === BigInt(1) && (fe = BigInt(fe) ^ BigInt(Z$1[ae])), ie = BigInt(ie) >> BigInt(1);
    return fe === BigInt(0) && ie === BigInt(0);
  }(BigInt(c), Y$1.mainnet)) throw Error("Unrecognised address format");
  return Buffer$7.from(O$1(c).replace(/^0+/, ""), "hex");
}), st("IRIS", 566, "iaa"), Pr("LRG", 568, [[30]], [[13]]), Ot("SERO", 569, function(c) {
  return bs58.encode(c);
}, function(c) {
  var t = bs58.decode(c);
  if (t.length === 96) return t;
  throw Error("Unrecognised address format");
}), Ot("BDX", 570, Ur, Sr), Yr("CCXX", 571, "ccx", [[137]], [[75], [5]]), Ot("SRM", 573, bs58.encode, bs58.decode), Ot("VLX", 574, bs58.encode, bs58.decode), Pr("BPS", 576, [[0]], [[5]]), nt("TFUEL", 589), st("GRIN", 592, "grin"), nt("GNO_LEGACY", 700), nt("VET", 703), st("BNB", 714, "bnb"), nt("CLO_LEGACY", 820), lt("HIVE", 825, "STM"), nt("TOMO_LEGACY", 889), Ot("HNT", 904, function(c) {
  var t = Buffer$7.concat([Buffer$7.from([0]), c]);
  return Ut$1(t);
}, function(c) {
  var t = Ct$1(c);
  if (t[0] !== 0) throw Error("Invalid version byte");
  return t.slice(1);
}), st("RUNE", 931, "thor"), Yr("BCD", 999, "bcd", [[0]], [[5]]), nt("TT_LEGACY", 1001), nt("FTM_LEGACY", 1007), st("ONE", 1023, "one"), Ot("ONT", 1024, function(c) {
  return Ut$1(Buffer$7.concat([Buffer$7.from([23]), c]));
}, function(c) {
  var t = Ct$1(c);
  switch (t.readUInt8(0)) {
    case 23:
      return t.slice(1);
    default:
      throw Error("Unrecognised address format");
  }
}), st("NOSTR", 1237, "npub"), { coinType: 1729, decoder: function(c) {
  var t = Ct$1(c).slice(3);
  switch (c.substring(0, 3)) {
    case "tz1":
      return Buffer$7.concat([Buffer$7.from([0, 0]), t]);
    case "tz2":
      return Buffer$7.concat([Buffer$7.from([0, 1]), t]);
    case "tz3":
      return Buffer$7.concat([Buffer$7.from([0, 2]), t]);
    case "KT1":
      return Buffer$7.concat([Buffer$7.from([1]), t, Buffer$7.from([0])]);
    default:
      throw Error("Unrecognised address format");
  }
}, encoder: function(c) {
  if (c.length !== 22 && c.length !== 21) throw Error("Unrecognised address format");
  var t;
  switch (c.readUInt8(0)) {
    case 0:
      if (c.readUInt8(1) === 0) t = Buffer$7.from([6, 161, 159]);
      else if (c.readUInt8(1) === 1) t = Buffer$7.from([6, 161, 161]);
      else {
        if (c.readUInt8(1) !== 2) throw Error("Unrecognised address format");
        t = Buffer$7.from([6, 161, 164]);
      }
      return Ut$1(Buffer$7.concat([t, c.slice(2)]));
    case 1:
      return t = Buffer$7.from([2, 90, 121]), Ut$1(Buffer$7.concat([t, c.slice(1, 21)]));
    default:
      throw Error("Unrecognised address format");
  }
}, name: "XTZ" }, { coinType: 1815, decoder: function(c) {
  var t = ft("addr", 104);
  return function(n) {
    return n.toLowerCase().startsWith("addr") ? t(n) : function(ie) {
      var fe = bs58.decode(ie), ae = function(ye, be, Ae) {
        var Se = new DataView(ye), $e = new Uint8Array(ye), Re = 0;
        function Me(je, jt) {
          return Re += je, jt;
        }
        function ke(je) {
          return Me(je, new Uint8Array(ye, Re, je));
        }
        function Te() {
          return Me(1, $e[Re]);
        }
        function Ie() {
          return Me(2, Se.getUint16(Re));
        }
        function qe() {
          return Me(4, Se.getUint32(Re));
        }
        function Ue() {
          return $e[Re] === 255 && (Re += 1, !0);
        }
        function ze(je) {
          if (je < 24) return je;
          if (je === 24) return Te();
          if (je === 25) return Ie();
          if (je === 26) return qe();
          if (je === 27) return 4294967296 * qe() + qe();
          if (je === 31) return -1;
          throw new Error("Invalid length encoding");
        }
        function Ve(je) {
          var jt = Te();
          if (jt === 255) return -1;
          var _e = ze(31 & jt);
          if (_e < 0 || jt >> 5 !== je) throw new Error("Invalid indefinite length element");
          return _e;
        }
        function Mt(je, jt) {
          for (var _e = 0; _e < jt; ++_e) {
            var se = Te();
            128 & se && (se < 224 ? (se = (31 & se) << 6 | 63 & Te(), jt -= 1) : se < 240 ? (se = (15 & se) << 12 | (63 & Te()) << 6 | 63 & Te(), jt -= 2) : (se = (15 & se) << 18 | (63 & Te()) << 12 | (63 & Te()) << 6 | 63 & Te(), jt -= 3)), se < 65536 ? je.push(se) : (je.push(55296 | (se -= 65536) >> 10), je.push(56320 | 1023 & se));
          }
        }
        var Rt = function je() {
          var jt, _e, se, ce = Te(), de = ce >> 5, pe = 31 & ce;
          if (de === 7) switch (pe) {
            case 25:
              return function() {
                var Fe = new ArrayBuffer(4), Pe = new DataView(Fe), Je = Ie(), Ke = 32768 & Je, Ze = 31744 & Je, Ye = 1023 & Je;
                if (Ze === 31744) Ze = 261120;
                else if (Ze !== 0) Ze += 114688;
                else if (Ye !== 0) return (Ke ? -1 : 1) * Ye * 5960464477539063e-23;
                return Pe.setUint32(0, Ke << 16 | Ze << 13 | Ye << 13), Pe.getFloat32(0);
              }();
            case 26:
              return Me(4, Se.getFloat32(Re));
            case 27:
              return Me(8, Se.getFloat64(Re));
          }
          if ((_e = ze(pe)) < 0 && (de < 2 || 6 < de)) throw new Error("Invalid length");
          switch (de) {
            case 0:
              return _e;
            case 1:
              return -1 - _e;
            case 2:
              if (_e < 0) {
                var ve = [], we = 0;
                for (_e = Ve(de); _e >= 0; ) we += _e, ve.push(ke(_e));
                var Ee = new Uint8Array(we), xe = 0;
                for (jt = 0; jt < ve.length; ++jt) Ee.set(ve[jt], xe), xe += ve[jt].length;
                return Ee;
              }
              return ke(_e);
            case 3:
              var ue = [];
              if (_e < 0) for (_e = Ve(de); _e >= 0; ) Mt(ue, _e);
              else Mt(ue, _e);
              var ge = "";
              for (jt = 0; jt < ue.length; jt += 8192) ge += String.fromCharCode.apply(null, ue.slice(jt, jt + 8192));
              return ge;
            case 4:
              var Be;
              if (_e < 0) for (Be = []; !Ue(); ) Be.push(je());
              else for (Be = new Array(_e), jt = 0; jt < _e; ++jt) Be[jt] = je();
              return Be;
            case 5:
              var Ne = {};
              for (jt = 0; jt < _e || _e < 0 && !Ue(); ++jt) Ne[je()] = je();
              return Ne;
            case 6:
              return se = je(), new G$1(se, _e);
            case 7:
              switch (_e) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                default:
                  return function(Fe) {
                    return new V$1(Fe);
                  }(_e);
              }
          }
        }();
        if (Re !== ye.byteLength) throw new Error("Remaining bytes");
        return Rt;
      }(fe.buffer.slice(fe.byteOffset, fe.byteOffset + fe.byteLength)), le = ae[0];
      if (le === void 0) throw Error("Unrecognised address format");
      var he = ae[1], me = crcExports.crc32(le.value);
      if (parseInt(me, 16) !== he) throw Error("Unrecognised address format");
      return Buffer$7.from(le.value);
    }(n);
  };
}(), encoder: function(c) {
  var t = ut("addr", 104);
  return function(n) {
    try {
      return function(ie) {
        var fe = crcExports.crc32(ie), ae = function(he) {
          var me, ye = new ArrayBuffer(256), be = new DataView(ye), Ae = new Uint8Array(ye), Se = 0;
          function $e(Rt) {
            for (var je = ye.byteLength, jt = Se + Rt; je < jt; ) je <<= 1;
            if (je !== ye.byteLength) {
              var _e = be;
              ye = new ArrayBuffer(je), be = new DataView(ye), Ae = new Uint8Array(ye);
              for (var se = Se + 3 >> 2, ce = 0; ce < se; ++ce) be.setUint32(ce << 2, _e.getUint32(ce << 2));
            }
            return me = Rt, be;
          }
          function Re() {
            Se += me;
          }
          function Me(Rt) {
            Re($e(1).setUint8(Se, Rt));
          }
          function ke(Rt) {
            $e(Rt.length), Ae.set(Rt, Se), Re();
          }
          function Te(Rt) {
            Re($e(2).setUint16(Se, Rt));
          }
          function Ie(Rt) {
            Re($e(4).setUint32(Se, Rt));
          }
          function qe(Rt) {
            var je = Rt % 4294967296, jt = (Rt - je) / 4294967296, _e = $e(8);
            _e.setUint32(Se, jt), _e.setUint32(Se + 4, je), Re();
          }
          function Ue(Rt, je) {
            je < 24 ? Me(Rt << 5 | je) : je < 256 ? (Me(Rt << 5 | 24), Me(je)) : je < 65536 ? (Me(Rt << 5 | 25), Te(je)) : je < 4294967296 ? (Me(Rt << 5 | 26), Ie(je)) : (Me(Rt << 5 | 27), qe(je));
          }
          if (function Rt(je) {
            var jt, _e;
            if (je === !1) return Me(244);
            if (je === !0) return Me(245);
            if (je === null) return Me(246);
            if (je === void 0) return Me(247);
            if (_e = je, typeof Object.is == "function" ? Object.is(_e, -0) : _e === -0 && (_e !== 0 || 1 / _e == -1 / 0)) return ke([249, 128, 0]);
            switch (typeof je) {
              case "number":
                if (Math.floor(je) === je) {
                  if (0 <= je && je <= 9007199254740992) return Ue(0, je);
                  if (-9007199254740992 <= je && je < 0) return Ue(1, -(je + 1));
                }
                return Me(251), function(Ee) {
                  Re($e(8).setFloat64(Se, Ee));
                }(je);
              case "string":
                var se = [];
                for (jt = 0; jt < je.length; jt++) {
                  var ce = je.charCodeAt(jt);
                  ce < 128 ? se.push(ce) : ce < 2048 ? (se.push(192 | ce >> 6), se.push(128 | 63 & ce)) : (ce = (1023 & ce) << 10, ce |= 1023 & je.charCodeAt(++jt), se.push(240 | (ce += 65536) >> 18), se.push(128 | ce >> 12 & 63), se.push(128 | ce >> 6 & 63), se.push(128 | 63 & ce));
                }
                return Ue(3, se.length), ke(se);
              default:
                var de, pe;
                if (Array.isArray(je)) for (Ue(4, de = je.length), jt = 0; jt < de; jt++) Rt(je[jt]);
                else if (je instanceof Uint8Array) Ue(2, je.length), ke(je);
                else if (ArrayBuffer.isView(je)) Ue(2, (pe = new Uint8Array(je.buffer)).length), ke(pe);
                else if (je instanceof ArrayBuffer || typeof SharedArrayBuffer == "function" && je instanceof SharedArrayBuffer) Ue(2, (pe = new Uint8Array(je)).length), ke(pe);
                else if (je instanceof G$1) (function(Ee, xe) {
                  Ee <= 255 ? Ee < 24 ? Me(192 | Ee) : (Me(216), Me(Ee)) : Ee <= 65535 ? (Me(217), Te(Ee)) : Ee <= 4294967295 ? (Me(218), Ie(Ee)) : (Me(219), qe(Ee));
                })(je.tag), Rt(je.value);
                else {
                  var ve = Object.keys(je);
                  for (Ue(5, de = ve.length), jt = 0; jt < de; jt++) {
                    var we = ve[jt];
                    Rt(we), Rt(je[we]);
                  }
                }
            }
          }(he), "slice" in ye) return ye.slice(0, Se);
          for (var ze = new ArrayBuffer(Se), Ve = new DataView(ze), Mt = 0; Mt < Se; ++Mt) Ve.setUint8(Mt, be.getUint8(Mt));
          return ze;
        }([new G$1(ie.buffer.slice(ie.byteOffset, ie.byteOffset + ie.byteLength), 24), parseInt(fe, 16)]), le = bs58.encode(Buffer$7.from(ae));
        if (!le.startsWith("Ae2") && !le.startsWith("Ddz")) throw Error("Unrecognised address format");
        return le;
      }(n);
    } catch {
      return t(n);
    }
  };
}(), name: "ADA" }, Ot("SC", 1991, function(c) {
  var t = blakejs.blake2bHex(Uint8Array.from(c), null, 32).slice(0, 12);
  return c.toString("hex") + t;
}, function(c) {
  if (c.length !== 76) throw Error("Unrecognised address format");
  var t = Buffer$7.from(c.slice(0, 64), "hex");
  if (c.slice(64) !== blakejs.blake2bHex(Uint8Array.from(t), null, 32).slice(0, 12)) throw Error("Unrecognised address format");
  return t;
}), Ot("QTUM", 2301, Ut$1, Ct$1), lt("GXC", 2303, "GXC"), Ot("ELA", 2305, bs58.encode, bs58.decode), Ot("NAS", 2718, function(c) {
  var t = new sha3$1.SHA3(256).update(c).digest().slice(0, 4);
  return bs58.encode(Buffer$7.concat([c, t]));
}, function(c) {
  var t = bs58.decode(c);
  if (t.length !== 26 || t[0] !== 25 || t[1] !== 87 && t[1] !== 88) throw Error("Unrecognised address format");
  var n = t.slice(0, 22), ie = t.slice(-4);
  if (!new sha3$1.SHA3(256).update(n).digest().slice(0, 4).equals(ie)) throw Error("Invalid checksum");
  return n;
}), { coinType: 3030, decoder: function(c) {
  var t = Buffer$7.alloc(20), n = new DataView(t.buffer, 0, 20), ie = c.split(".");
  if (ie.length !== 3) throw Error("Unrecognised address format");
  var fe = Number(ie[0]), ae = BigInt(ie[1]), le = BigInt(ie[2]);
  return n.setUint32(0, fe), n.setBigUint64(4, ae), n.setBigUint64(12, le), t;
}, encoder: function(c) {
  if (c.length !== 20) throw Error("Unrecognised address format");
  var t = new DataView(c.buffer, 0);
  return [t.getUint32(0), t.getBigUint64(4), t.getBigUint64(12)].join(".");
}, name: "HBAR" }, { coinType: 4218, decoder: function(c) {
  var t = Mr(c, void 0), n = t.words;
  if (t.prefix !== "iota") throw Error("Unrecognised address format");
  return Buffer$7.from(Xr(n)).slice(1);
}, encoder: (Ct = Buffer$7.from([0]), function(c) {
  return Dr("iota", Gr(Buffer$7.concat([Ct, c])), void 0);
}), name: "IOTA" }, Ot("HNS", 5353, function(c) {
  if (c.length !== 20) throw Error("P2WPKH must be 20 bytes");
  var t = [0].concat(Gr(c));
  return Dr("hs", t);
}, function(c) {
  var t = Mr(c), n = t.words;
  if (t.prefix !== "hs") throw Error("Unrecognised address format");
  var ie = n[0], fe = Xr(n.slice(1));
  if (ie !== 0) throw Error("Bad program version");
  if (fe.length !== 20) throw Error("Witness program hash is the wrong size");
  return Buffer$7.from(fe);
}), Ot("STX", 5757, function(c) {
  var t = c.toString("hex"), n = t.substring(0, t.length - 8);
  if (!n.match(/^[0-9a-fA-F]{40}$/)) throw new Error("Invalid argument: not a hash160 hex string");
  (n = n.toLowerCase()).length % 2 != 0 && (n = "0" + n);
  var ie = { p2pkh: 22, p2sh: 20 }, fe = t.slice(-8), ae = "", le = "";
  return fe === M$1("" + ie.p2pkh.toString(16) + n) ? (le = "P", ae = D$1("" + n + fe)) : fe === M$1("" + ie.p2sh.toString(16) + n) && (le = "M", ae = D$1("" + n + fe)), "S" + le + ae;
}, function(c) {
  if (c.length <= 5) throw new Error("Invalid c32 address: invalid length");
  if (c[0] !== "S") throw new Error('Invalid c32 address: must start with "S"');
  var t = X$1(c.slice(1)), n = R$1.indexOf(t[0]).toString(16);
  n.length === 1 && (n = "0" + n);
  var ie = function(ae) {
    if (!(ae = X$1(ae)).match("^[" + R$1 + "]*$")) throw new Error("Not a c32-encoded string");
    for (var le = ae.match("^" + R$1[0] + "*"), he = le ? le[0].length : 0, me = [], ye = 0, be = 0, Ae = ae.length - 1; Ae >= 0; Ae--) {
      be === 4 && (me.unshift(k$1[ye]), be = 0, ye = 0);
      var Se = (R$1.indexOf(ae[Ae]) << be) + ye, $e = k$1[Se % 16];
      if ((ye = Se >> 4) > 1 << (be += 1)) throw new Error("Panic error in decoding.");
      me.unshift($e);
    }
    me.unshift(k$1[ye]), me.length % 2 == 1 && me.unshift("0");
    for (var Re = 0, Me = 0; Me < me.length && me[Me] === "0"; Me++) Re++;
    for (var ke = (me = me.slice(Re - Re % 2)).join(""), Te = 0; Te < he; Te++) ke = "00" + ke;
    return ke;
  }(t.slice(1)), fe = ie.slice(-8);
  if (M$1("" + n + ie.substring(0, ie.length - 8)) !== fe) throw new Error("Invalid c32check string: checksum mismatch");
  return Buffer$7.from(ie, "hex");
}), nt("GO_LEGACY", 6060), { coinType: 8444, decoder: function(c) {
  var t = bech32m.decode(c, 90), n = t.words;
  if (t.prefix !== "xch") throw Error("Unrecognised address format");
  return Buffer$7.from(bech32m.fromWords(n));
}, encoder: function(c) {
  return bech32m.encode("xch", bech32m.toWords(c), 90);
}, name: "XCH" }, Ot("NULS", 8964, function(c) {
  for (var t = 255 & c[0] | (255 & c[1]) << 8, n = Buffer$7.allocUnsafe(c.length + 1), ie = 0, fe = 0, ae = 0; ae < c.length; ae++) n[ae] = ie = (ie = c[ae]) > 127 ? ie - 256 : ie, fe ^= ie;
  n[c.length] = fe;
  var le = "";
  if (t === 1) le = "NULS";
  else if (t === 2) le = "tNULS";
  else {
    var he = Buffer$7.concat([Buffer$7.from([255 & t >> 0]), Buffer$7.from([255 & t >> 8])]);
    le = bs58.encode(he).toUpperCase();
  }
  return le + ["a", "b", "c", "d", "e"][le.length - 1] + bs58.encode(n);
}, function(c) {
  if (c.startsWith("NULS")) c = c.substring(5);
  else if (c.startsWith("tNULS")) c = c.substring(6);
  else for (var t = 0; t < c.length; t++) if (c.charAt(t).charCodeAt(0) >= 97) {
    c = c.substring(t + 1);
    break;
  }
  for (var n = bs58.decode(c), ie = 0, fe = 0, ae = 0; ae < n.length - 1; ae++) n[ae] = ie = (ie = n[ae]) > 127 ? ie - 256 : ie, fe ^= ie;
  if (fe < 0 && (fe = 256 + fe), fe !== n[n.length - 1]) throw Error("Unrecognised address format");
  return n.slice(0, -1);
}), Ot("AVAX", 9e3, ut("avax"), (It = ft("avax"), function(c) {
  var t = c.split("-");
  return It(t[1] || t[0]);
})), Ot("STRK", 9004, function(c) {
  return Fr("0x" + c.toString("hex"));
}, function(c) {
  if (Fr(t = c) !== t) throw Error("Invalid checksum");
  var t;
  return Buffer$7.from(O$1(c), "hex");
}), nt("NRG_LEGACY", 9797), Ot("ARDR", 16754, function(c) {
  for (var t = c.toString("hex"), n = [], ie = 0, fe = 0; ie < t.length; ie += 2) n[yt[fe++]] = 16 * parseInt(t[ie], 16) + parseInt(t[ie + 1], 16);
  for (var ae = "", le = [], he = 0; he < 17; he++) {
    if (n[he] >= mt.length || n.length !== 17) throw Error("Unrecognised address format");
    ae += mt[n[he]], (he < 12 && (he + 1) % 4 == 0 || he === 16) && (le.push(ae), ae = "");
  }
  return "ARDOR-" + le.join("-");
}, function(c) {
  var t = [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  if ((c = c.replace(/(^\s+)|(\s+$)/g, "").toUpperCase()).slice(0, 5) !== "ARDOR" || c.split("-").length !== 5) throw Error("Unrecognised address format");
  for (var n, ie = [], fe = 0, ae = q$1(c = c.substr(c.indexOf("-"))); !(n = ae()).done; ) {
    var le = mt.indexOf(n.value);
    if (le >= 0 && (ie[fe++] = le, fe > 17)) throw Error("Unrecognised address format");
  }
  for (var he = 0, me = 0; he < fe; he++) t[yt[me++]] = ie[he];
  if (!function(ye) {
    for (var be, Ae, Se = 0, $e = 1; $e < 5; $e++) {
      for (var Re = 0, Me = 0; Me < 31; Me++) if (!(Me > 12 && Me < 27)) {
        var ke = Me;
        Me > 26 && (ke -= 14), Re ^= (Ae = wt[$e * Me % 31], (be = ye[ke]) === 0 || Ae === 0 ? 0 : wt[(vt[be] + vt[Ae]) % 31]);
      }
      Se |= Re;
    }
    return Se === 0;
  }(t)) throw Error("Unrecognised address format");
  return Buffer$7.from(t);
}), _r("ZEL", 19167, "za", [[28, 184]], [[28, 189]]), nt("CELO_LEGACY", 52752), Pr("WICC", 99999, [[73]], [[51]]), Ot("WAN", 5718350, function(c) {
  return gt("0x" + c.toString("hex"));
}, function(c) {
  if (/^0x[0-9a-fA-F]{40}$/.test(t = c) && gt(t) === t) return Buffer$7.from(O$1(c), "hex");
  throw Error("Invalid address checksum");
  var t;
}), Ot("WAVES", 5741564, bs58.encode, function(c) {
  var t = bs58.decode(c);
  if (t[0] !== 1) throw Error("Bad program version");
  if (t[1] !== 87 || t.length !== 26) throw Error("Unrecognised address format");
  var n = t.slice(0, 22), ie = t.slice(22, 26);
  if (!new sha3$1.Keccak(256).update(Buffer$7.from(blakejs.blake2b(Uint8Array.from(n), null, 32))).digest().slice(0, 4).equals(ie)) throw Error("Invalid checksum");
  return t;
}), at("OP", 10), at("CRO", 25), at("BSC", 56), at("GO", 60), at("ETC", 61), at("TOMO", 88), at("POA", 99), at("GNO", 100), at("TT", 108), at("MATIC", 137), at("EWT", 246), at("FTM", 250), at("THETA", 361), at("CLO", 820), at("NRG", 39797), at("ARB1", 42161), at("CELO", 42220), at("AVAXC", 43114)], qt = Object.assign.apply(Object, [{}].concat(Nt.map(function(c) {
  var t;
  return (t = {})[c.name] = c, t;
}))), Tt = Object.assign.apply(Object, [{}].concat(Nt.map(function(c) {
  var t;
  return (t = {})[c.coinType] = c, t;
}))), Lt = new Proxy(Tt, { get: function(c, t) {
  var n = parseInt(t, 10);
  if (c[t]) return c[t];
  if (2147483648 & n) {
    var ie = c[60];
    return { coinType: n, decoder: ie.decoder, encoder: ie.encoder, name: "" };
  }
} });
const index_module = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SLIP44_MSB: Vr,
  convertCoinTypeToEVMChainId: it,
  convertEVMChainIdToCoinType: ot,
  formats: Nt,
  formatsByCoinType: Lt,
  formatsByName: qt
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(index_module);
var ens = {};
Object.defineProperty(ens, "__esModule", { value: !0 });
ens.default = [
  {
    constant: !0,
    inputs: [{ name: "node", type: "bytes32" }],
    name: "resolver",
    outputs: [{ name: "", type: "address" }],
    payable: !1,
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "node", type: "bytes32" }],
    name: "owner",
    outputs: [{ name: "", type: "address" }],
    payable: !1,
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "node", type: "bytes32" },
      { name: "label", type: "bytes32" },
      { name: "owner", type: "address" }
    ],
    name: "setSubnodeOwner",
    outputs: [],
    payable: !1,
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "node", type: "bytes32" },
      { name: "ttl", type: "uint64" }
    ],
    name: "setTTL",
    outputs: [],
    payable: !1,
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "node", type: "bytes32" }],
    name: "ttl",
    outputs: [{ name: "", type: "uint64" }],
    payable: !1,
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "node", type: "bytes32" },
      { name: "resolver", type: "address" }
    ],
    name: "setResolver",
    outputs: [],
    payable: !1,
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "node", type: "bytes32" },
      { name: "owner", type: "address" }
    ],
    name: "setOwner",
    outputs: [],
    payable: !1,
    type: "function"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "node", type: "bytes32" },
      { indexed: !1, name: "owner", type: "address" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "node", type: "bytes32" },
      { indexed: !0, name: "label", type: "bytes32" },
      { indexed: !1, name: "owner", type: "address" }
    ],
    name: "NewOwner",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "node", type: "bytes32" },
      { indexed: !1, name: "resolver", type: "address" }
    ],
    name: "NewResolver",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "node", type: "bytes32" },
      { indexed: !1, name: "ttl", type: "uint64" }
    ],
    name: "NewTTL",
    type: "event"
  }
];
var resolver = {}, resolutionError = {};
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var le = function(he, me) {
      return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ye, be) {
        ye.__proto__ = be;
      } || function(ye, be) {
        for (var Ae in be) Object.prototype.hasOwnProperty.call(be, Ae) && (ye[Ae] = be[Ae]);
      }, le(he, me);
    };
    return function(he, me) {
      if (typeof me != "function" && me !== null)
        throw new TypeError("Class extends value " + String(me) + " is not a constructor or null");
      le(he, me);
      function ye() {
        this.constructor = he;
      }
      he.prototype = me === null ? Object.create(me) : (ye.prototype = me.prototype, new ye());
    };
  }(), n;
  Object.defineProperty(c, "__esModule", { value: !0 }), c.ResolutionError = c.ResolutionErrorCode = void 0;
  var ie;
  (function(le) {
    le.UnregisteredDomain = "UnregisteredDomain", le.UnspecifiedResolver = "UnspecifiedResolver", le.UnsupportedDomain = "UnsupportedDomain", le.UnsupportedService = "UnsupportedService", le.UnsupportedMethod = "UnsupportedMethod", le.UnspecifiedCurrency = "UnspecifiedCurrency", le.UnsupportedCurrency = "UnsupportedCurrency", le.IncorrectResolverInterface = "IncorrectResolverInterface", le.RecordNotFound = "RecordNotFound", le.MetadataEndpointError = "MetadataEndpointError", le.ServiceProviderError = "ServiceProviderError", le.InvalidTwitterVerification = "InvalidTwitterVerification", le.InconsistentDomainArray = "InconsistentDomainArray", le.InvalidDomainAddress = "InvalidDomainAddress", le.InvalidUnsResolutionConfiguration = "InvalidResolutionConfiguration";
  })(ie = c.ResolutionErrorCode || (c.ResolutionErrorCode = {}));
  var fe = (n = {}, n[ie.UnregisteredDomain] = function(le) {
    return "Domain ".concat(le.domain, " is not registered");
  }, n[ie.UnspecifiedResolver] = function(le) {
    return "".concat(le.location ? "".concat(le.location, ": ") : "", "Domain ").concat(le.domain, " is not configured");
  }, n[ie.UnsupportedDomain] = function(le) {
    return "Domain ".concat(le.domain, " is not supported");
  }, n[ie.UnsupportedMethod] = function(le) {
    var he, me = !((he = le.domain) === null || he === void 0) && he.endsWith(".zil") ? " (if this method was called via the Resolution class with both UNS and ZNS providers configured not in the API mode, this error also means that the domain doesn't exist in UNS)" : "";
    return "Method ".concat(le.methodName, " is not supported for ").concat(le.domain).concat(me);
  }, n[ie.InvalidTwitterVerification] = function(le) {
    return "".concat(le.location ? "".concat(le.location, ": ") : "", "Domain ").concat(le.domain, " has invalid Twitter signature verification");
  }, n[ie.UnsupportedCurrency] = function(le) {
    return "".concat(le.currencyTicker, " is not supported");
  }, n[ie.IncorrectResolverInterface] = function(le) {
    return "Domain resolver is configured incorrectly for ".concat(le.method);
  }, n[ie.RecordNotFound] = function(le) {
    return "".concat(le.location ? "".concat(le.location, ": ") : "", "No ").concat(le.recordName, " record found for ").concat(le.domain);
  }, n[ie.ServiceProviderError] = function(le) {
    return "< ".concat(le.providerMessage, " >");
  }, n[ie.MetadataEndpointError] = function(le) {
    return "Failed to query tokenUri ".concat(le.tokenUri, ". Error: ").concat(le.errorMessage);
  }, n[ie.UnsupportedService] = function(le) {
    return "Naming service ".concat(le.namingService, " is not supported");
  }, n[ie.InvalidDomainAddress] = function(le) {
    return "Domain address ".concat(le.domain, " is invalid");
  }, n[ie.InvalidUnsResolutionConfiguration] = function(le) {
    return "Resolution ";
  }, n), ae = (
    /** @class */
    function(le) {
      t(he, le);
      function he(me, ye) {
        ye === void 0 && (ye = {});
        var be = this, Ae = fe[me], Se = ye.domain, $e = ye.method, Re = ye.currencyTicker, Me = ye.methodName, ke = ye.recordName, Te = Ae(ye);
        return be = le.call(this, Te) || this, be.code = me, be.domain = Se, be.method = $e, be.currencyTicker = Re, be.name = "ResolutionError", be.methodName = Me, be.recordName = ke, Object.setPrototypeOf(be, he.prototype), be;
      }
      return he;
    }(Error)
  );
  c.ResolutionError = ae, c.default = ae;
})(resolutionError);
var newResolver = {};
Object.defineProperty(newResolver, "__esModule", { value: !0 });
newResolver.default = [
  {
    constant: !0,
    inputs: [{ internalType: "bytes4", name: "interfaceID", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" }
    ],
    name: "setText",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes4", name: "interfaceID", type: "bytes4" }
    ],
    name: "interfaceImplementer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "contentTypes", type: "uint256" }
    ],
    name: "ABI",
    outputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes32", name: "x", type: "bytes32" },
      { internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    name: "setPubkey",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes", name: "hash", type: "bytes" }
    ],
    name: "setContenthash",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  // This funciton is defined, however there is other version with 2 arguments
  // that we prefer to use all the time to be consistent
  // {
  // constant: true,
  // inputs: [{ internalType: 'bytes32', name: 'node', type: 'bytes32' }],
  // name: 'addr',
  // outputs: [{ internalType: 'address', name: '', type: 'address' }],
  // payable: false,
  // stateMutability: 'view',
  // type: 'function',
  // },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "address", name: "target", type: "address" },
      { internalType: "bool", name: "isAuthorised", type: "bool" }
    ],
    name: "setAuthorisation",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "key", type: "string" }
    ],
    name: "text",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "contentType", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "setABI",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "name", type: "string" }
    ],
    name: "setName",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "coinType", type: "uint256" },
      { internalType: "bytes", name: "a", type: "bytes" }
    ],
    name: "setAddr",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "contenthash",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "pubkey",
    outputs: [
      { internalType: "bytes32", name: "x", type: "bytes32" },
      { internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "address", name: "a", type: "address" }
    ],
    name: "setAddr",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes4", name: "interfaceID", type: "bytes4" },
      { internalType: "address", name: "implementer", type: "address" }
    ],
    name: "setInterface",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "coinType", type: "uint256" }
    ],
    name: "addr",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "bytes32", name: "", type: "bytes32" },
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" }
    ],
    name: "authorisations",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "contract ENS", name: "_ens", type: "address" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isAuthorised",
        type: "bool"
      }
    ],
    name: "AuthorisationChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      {
        indexed: !1,
        internalType: "string",
        name: "indexedKey",
        type: "string"
      },
      { indexed: !1, internalType: "string", name: "key", type: "string" }
    ],
    name: "TextChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: !1, internalType: "bytes32", name: "x", type: "bytes32" },
      { indexed: !1, internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    name: "PubkeyChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: !1, internalType: "string", name: "name", type: "string" }
    ],
    name: "NameChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      {
        indexed: !0,
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "implementer",
        type: "address"
      }
    ],
    name: "InterfaceChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: !1, internalType: "bytes", name: "hash", type: "bytes" }
    ],
    name: "ContenthashChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: !1, internalType: "address", name: "a", type: "address" }
    ],
    name: "AddrChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      {
        indexed: !1,
        internalType: "uint256",
        name: "coinType",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "newAddress",
        type: "bytes"
      }
    ],
    name: "AddressChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "node", type: "bytes32" },
      {
        indexed: !0,
        internalType: "uint256",
        name: "contentType",
        type: "uint256"
      }
    ],
    name: "ABIChanged",
    type: "event"
  }
];
var oldResolver = {};
Object.defineProperty(oldResolver, "__esModule", { value: !0 });
oldResolver.default = [
  {
    inputs: [{ name: "ensAddr", type: "address" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "a",
        type: "address"
      }
    ],
    name: "AddrChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "name",
        type: "string"
      }
    ],
    name: "NameChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !0,
        name: "contentType",
        type: "uint256"
      }
    ],
    name: "ABIChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "x",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "y",
        type: "bytes32"
      }
    ],
    name: "PubkeyChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "indexedKey",
        type: "string"
      },
      {
        indexed: !1,
        name: "key",
        type: "string"
      }
    ],
    name: "TextChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        name: "hash",
        type: "bytes"
      }
    ],
    name: "ContenthashChanged",
    type: "event"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "addr",
        type: "address"
      }
    ],
    name: "setAddr",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "hash",
        type: "bytes"
      }
    ],
    name: "setContenthash",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "name",
        type: "string"
      }
    ],
    name: "setName",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "contentType",
        type: "uint256"
      },
      {
        name: "data",
        type: "bytes"
      }
    ],
    name: "setABI",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "x",
        type: "bytes32"
      },
      {
        name: "y",
        type: "bytes32"
      }
    ],
    name: "setPubkey",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "key",
        type: "string"
      },
      {
        name: "value",
        type: "string"
      }
    ],
    name: "setText",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "key",
        type: "string"
      }
    ],
    name: "text",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      }
    ],
    name: "pubkey",
    outputs: [
      {
        name: "x",
        type: "bytes32"
      },
      {
        name: "y",
        type: "bytes32"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      },
      {
        name: "contentTypes",
        type: "uint256"
      }
    ],
    name: "ABI",
    outputs: [
      {
        name: "",
        type: "uint256"
      },
      {
        name: "",
        type: "bytes"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      }
    ],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      }
    ],
    name: "addr",
    outputs: [
      {
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "node",
        type: "bytes32"
      }
    ],
    name: "contenthash",
    outputs: [
      {
        name: "",
        type: "bytes"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "interfaceID",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "pure",
    type: "function"
  }
];
var types$3 = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.hasProvider = c.ZnsSupportedNetwork = c.EnsSupportedNetwork = c.UnsSupportedNetwork = c.EthCoinIndex = c.NullAddresses = c.NullAddress = void 0, c.NullAddress = "0x0000000000000000000000000000000000000000", function(ie) {
    ie[ie["0x"] = 0] = "0x", ie[ie["0x0000000000000000000000000000000000000000"] = 1] = "0x0000000000000000000000000000000000000000", ie[ie["0x0000000000000000000000000000000000000000000000000000000000000000"] = 2] = "0x0000000000000000000000000000000000000000000000000000000000000000";
  }(c.NullAddresses || (c.NullAddresses = {})), c.EthCoinIndex = "60";
  var t = function() {
    for (var ie = [], fe = 0; fe < arguments.length; fe++)
      ie[fe] = arguments[fe];
    Object.freeze(ie);
    var ae = new Set(ie), le = function(ye) {
      return ae.has(ye);
    }, he = function(ye) {
      if (!le(ye)) {
        var be = JSON.stringify(ye), Ae = ie.map(function(Se) {
          return JSON.stringify(Se);
        }).join(" | ");
        throw new TypeError("Value '".concat(be, "' is not assignable to type '").concat(Ae, "'."));
      }
      return ye;
    }, me = { guard: le, check: he, values: ie };
    return Object.freeze(me);
  };
  c.UnsSupportedNetwork = t("mainnet", "sepolia", "polygon-mainnet", "polygon-amoy", "base-mainnet", "base-sepolia"), c.EnsSupportedNetwork = t("mainnet", "sepolia"), c.ZnsSupportedNetwork = t("mainnet", "testnet");
  function n(ie) {
    return ie && !!ie.provider;
  }
  c.hasProvider = n;
})(types$3);
var publicTypes = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.BlockchainType = c.DnsRecordType = c.NamehashOptionsDefault = c.UnclaimedDomainResponse = c.NamingServiceName = c.UnsLocation = void 0, function(t) {
    t.Layer1 = "UNSLayer1", t.Layer2 = "UNSLayer2";
  }(c.UnsLocation || (c.UnsLocation = {})), function(t) {
    t.UNS = "UNS", t.UNS_BASE = "UNS_BASE", t.ENS = "ENS", t.ZNS = "ZNS";
  }(c.NamingServiceName || (c.NamingServiceName = {})), c.UnclaimedDomainResponse = {
    addresses: {},
    meta: {
      domain: "",
      namehash: "",
      resolver: "",
      owner: null,
      type: "",
      ttl: 0,
      blockchain: null
    },
    records: {}
  }, c.NamehashOptionsDefault = {
    format: "hex",
    prefix: !0,
    zns: !1
  }, function(t) {
    t.A = "A", t.AAAA = "AAAA", t.AFSDB = "AFSDB", t.APL = "APL", t.CAA = "CAA", t.CDNSKEY = "CDNSKEY", t.CDS = "CDS", t.CERT = "CERT", t.CNAME = "CNAME", t.CSYNC = "CSYNC", t.DHCID = "DHCID", t.DLV = "DLV", t.DNAME = "DNAME", t.DNSKEY = "DNSKEY", t.DS = "DS", t.EUI48 = "EUI48", t.EUI64 = "EUI64", t.HINFO = "HINFO", t.HIP = "HIP", t.HTTPS = "HTTPS", t.IPSECKEY = "IPSECKEY", t.KEY = "KEY", t.KX = "KX", t.LOC = "LOC", t.MX = "MX", t.NAPTR = "NAPTR", t.NS = "NS", t.NSEC = "NSEC", t.NSEC3 = "NSEC3", t.NSEC3PARAM = "NSEC3PARAM", t.OPENPGPKEY = "OPENPGPKEY", t.PTR = "PTR", t.RP = "RP", t.RRSIG = "RRSIG", t.SIG = "SIG", t.SMIMEA = "SMIMEA", t.SOA = "SOA", t.SRV = "SRV", t.SSHFP = "SSHFP", t.SVCB = "SVCB", t.TA = "TA", t.TKEY = "TKEY", t.TLSA = "TLSA", t.TSIG = "TSIG", t.TXT = "TXT", t.URI = "URI", t.ZONEMD = "ZONEMD";
  }(c.DnsRecordType || (c.DnsRecordType = {})), function(t) {
    t.ETH = "ETH", t.POL = "POL", t.ZIL = "ZIL", t.BASE = "BASE";
  }(c.BlockchainType || (c.BlockchainType = {}));
})(publicTypes);
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__importDefault || function(he) {
    return he && he.__esModule ? he : { default: he };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.OldResolverAddresses = void 0;
  var n = resolutionError, ie = t(newResolver), fe = t(oldResolver), ae = types$3, le = publicTypes;
  c.OldResolverAddresses = [
    "0x5ffc014343cd971b7eb70732021e26c35b744cc4",
    "0x1da022710df5002339274aadee8d58218e9d6ab5",
    "0xda1756bb923af5d1a05e277cb1e54f1d0a127890"
  ], c.default = function(he, me) {
    if (me === void 0 || me === ae.EthCoinIndex)
      return fe.default;
    if (c.OldResolverAddresses.includes(he.toLowerCase()))
      throw new n.ResolutionError(n.ResolutionErrorCode.IncorrectResolverInterface, { method: le.NamingServiceName.ENS });
    return ie.default;
  };
})(resolver);
var nameWrapper = {};
Object.defineProperty(nameWrapper, "__esModule", { value: !0 });
nameWrapper.default = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "_ens",
        type: "address"
      },
      {
        internalType: "contract IBaseRegistrar",
        name: "_registrar",
        type: "address"
      },
      {
        internalType: "contract IMetadataService",
        name: "_metadataService",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "CannotUpgrade",
    type: "error"
  },
  {
    inputs: [],
    name: "IncompatibleParent",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "IncorrectTargetOwner",
    type: "error"
  },
  {
    inputs: [],
    name: "IncorrectTokenType",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "labelHash",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "expectedLabelhash",
        type: "bytes32"
      }
    ],
    name: "LabelMismatch",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "label",
        type: "string"
      }
    ],
    name: "LabelTooLong",
    type: "error"
  },
  {
    inputs: [],
    name: "LabelTooShort",
    type: "error"
  },
  {
    inputs: [],
    name: "NameIsNotWrapped",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "OperationProhibited",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "Unauthorised",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "controller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "active",
        type: "bool"
      }
    ],
    name: "ControllerChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "ExpiryExtended",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      }
    ],
    name: "FusesSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "NameUnwrapped",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "name",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "NameWrapped",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "_tokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "fuseMask",
        type: "uint32"
      }
    ],
    name: "allFusesBurned",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canExtendSubnames",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canModifyName",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "controllers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ens",
    outputs: [
      {
        internalType: "contract ENS",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "parentNode",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "labelhash",
        type: "bytes32"
      },
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "extendExpiry",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getData",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      },
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  // NOTE: prefer to use the other isWrapped abi function
  // {
  //   "inputs": [
  //     {
  //       "internalType": "bytes32",
  //       "name": "parentNode",
  //       "type": "bytes32"
  //     },
  //     {
  //       "internalType": "bytes32",
  //       "name": "labelhash",
  //       "type": "bytes32"
  //     }
  //   ],
  //   "name": "isWrapped",
  //   "outputs": [
  //     {
  //       "internalType": "bool",
  //       "name": "",
  //       "type": "bool"
  //     }
  //   ],
  //   "stateMutability": "view",
  //   "type": "function"
  // },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "isWrapped",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "metadataService",
    outputs: [
      {
        internalType: "contract IMetadataService",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "names",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "recoverFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "label",
        type: "string"
      },
      {
        internalType: "address",
        name: "wrappedOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "ownerControlledFuses",
        type: "uint16"
      }
    ],
    name: "registerAndWrapETH2LD",
    outputs: [
      {
        internalType: "uint256",
        name: "registrarExpiry",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "registrar",
    outputs: [
      {
        internalType: "contract IBaseRegistrar",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "renew",
    outputs: [
      {
        internalType: "uint256",
        name: "expires",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "parentNode",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "labelhash",
        type: "bytes32"
      },
      {
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      },
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "setChildFuses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address"
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool"
      }
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint16",
        name: "ownerControlledFuses",
        type: "uint16"
      }
    ],
    name: "setFuses",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetadataService",
        name: "_metadataService",
        type: "address"
      }
    ],
    name: "setMetadataService",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "setRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "parentNode",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "label",
        type: "string"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      },
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "setSubnodeOwner",
    outputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "parentNode",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "label",
        type: "string"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      },
      {
        internalType: "uint32",
        name: "fuses",
        type: "uint32"
      },
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    name: "setSubnodeRecord",
    outputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "setTTL",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract INameWrapperUpgrade",
        name: "_upgradeAddress",
        type: "address"
      }
    ],
    name: "setUpgradeContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "parentNode",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "labelhash",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "labelhash",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "registrant",
        type: "address"
      },
      {
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "unwrapETH2LD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "name",
        type: "bytes"
      },
      {
        internalType: "bytes",
        name: "extraData",
        type: "bytes"
      }
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "upgradeContract",
    outputs: [
      {
        internalType: "contract INameWrapperUpgrade",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "name",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "wrappedOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "wrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "label",
        type: "string"
      },
      {
        internalType: "address",
        name: "wrappedOwner",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "ownerControlledFuses",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "wrapETH2LD",
    outputs: [
      {
        internalType: "uint64",
        name: "expiry",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var baseRegistrar = {};
Object.defineProperty(baseRegistrar, "__esModule", { value: !0 });
baseRegistrar.default = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "_ens",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_baseNode",
        type: "bytes32"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "ControllerAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "ControllerRemoved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "expires",
        type: "uint256"
      }
    ],
    name: "NameMigrated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "expires",
        type: "uint256"
      }
    ],
    name: "NameRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "expires",
        type: "uint256"
      }
    ],
    name: "NameRenewed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: !0,
    inputs: [],
    name: "GRACE_PERIOD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "addController",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "available",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "baseNode",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "controllers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "ens",
    outputs: [
      {
        internalType: "contract ENS",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "nameExpires",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "reclaim",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "register",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "registerOnly",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address"
      }
    ],
    name: "removeController",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "renew",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "setResolver",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var reverseRegistrar = {};
Object.defineProperty(reverseRegistrar, "__esModule", { value: !0 });
reverseRegistrar.default = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "ensAddr",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "controller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "ControllerChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "contract NameResolver",
        name: "resolver",
        type: "address"
      }
    ],
    name: "DefaultResolverChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "ReverseClaimed",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "claim",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "claimForAddr",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "claimWithResolver",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "controllers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultResolver",
    outputs: [
      {
        internalType: "contract NameResolver",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ens",
    outputs: [
      {
        internalType: "contract ENS",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "node",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address"
      },
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "setDefaultResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "setName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "setNameForAddr",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var EthereumContract$1 = {}, __awaiter$a = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$a = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
};
Object.defineProperty(EthereumContract$1, "__esModule", { value: !0 });
var abi_1 = require$$0$4, EthereumContract = (
  /** @class */
  function() {
    function c(t, n, ie, fe) {
      this.abi = t, this.address = n, this.provider = ie, this.coder = new abi_1.Interface(this.abi), this.apiKey = fe;
    }
    return c.prototype.call = function(t, n) {
      return __awaiter$a(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$a(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.coder.encodeFunctionData(t, n), [4, this.callEth(ie)];
            case 1:
              return fe = ae.sent(), !fe || fe === "0x" ? [2, []] : [2, this.coder.decodeFunctionResult(t, fe)];
          }
        });
      });
    }, c.prototype.multicall = function(t) {
      return __awaiter$a(this, void 0, void 0, function() {
        var n, ie, fe, ae, le, he, me, ye, be;
        return __generator$a(this, function(Ae) {
          switch (Ae.label) {
            case 0:
              for (n = [], ie = 0, fe = t; ie < fe.length; ie++)
                ae = fe[ie], n.push(this.coder.encodeFunctionData(ae.method, ae.args));
              return le = this.coder.encodeFunctionData("multicall", [n]), [4, this.callEth(le)];
            case 1:
              if (he = Ae.sent(), !he || he === "0x")
                return [2, []];
              for (me = this.coder.decodeFunctionResult("multicall", he), ye = [], be = 0; be < me.results.length; be++)
                ye.push(this.coder.decodeFunctionResult(t[be].method, me.results[be]));
              return [2, ye];
          }
        });
      });
    }, c.prototype.fetchLogs = function(t, n, ie) {
      return ie === void 0 && (ie = "earliest"), __awaiter$a(this, void 0, void 0, function() {
        var fe, ae, le;
        return __generator$a(this, function(he) {
          switch (he.label) {
            case 0:
              return fe = this.coder.getEventTopic(t), ae = [
                {
                  fromBlock: ie,
                  toBlock: "latest",
                  address: this.address,
                  topics: [fe, n]
                }
              ], le = {
                method: "eth_getLogs",
                params: ae,
                apiKey: this.apiKey
              }, [4, this.provider.request(le)];
            case 1:
              return [2, he.sent()];
          }
        });
      });
    }, c.prototype.callEth = function(t) {
      return __awaiter$a(this, void 0, void 0, function() {
        var n, ie;
        return __generator$a(this, function(fe) {
          switch (fe.label) {
            case 0:
              return n = [
                {
                  data: t,
                  to: this.address
                },
                "latest"
              ], ie = {
                method: "eth_call",
                params: n,
                apiKey: this.apiKey
              }, [4, this.provider.request(ie)];
            case 1:
              return [2, fe.sent()];
          }
        });
      });
    }, c;
  }()
);
EthereumContract$1.default = EthereumContract;
var utils$e = {}, Tlds$1 = {}, Networking$1 = {}, browserPonyfill = { exports: {} };
(function(c, t) {
  var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof globalThis < "u" && globalThis, ie = function() {
    function ae() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }
    return ae.prototype = n, new ae();
  }();
  (function(ae) {
    (function(le) {
      var he = typeof ae < "u" && ae || typeof self < "u" && self || typeof he < "u" && he, me = {
        searchParams: "URLSearchParams" in he,
        iterable: "Symbol" in he && "iterator" in Symbol,
        blob: "FileReader" in he && "Blob" in he && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in he,
        arrayBuffer: "ArrayBuffer" in he
      };
      function ye(pe) {
        return pe && DataView.prototype.isPrototypeOf(pe);
      }
      if (me.arrayBuffer)
        var be = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], Ae = ArrayBuffer.isView || function(pe) {
          return pe && be.indexOf(Object.prototype.toString.call(pe)) > -1;
        };
      function Se(pe) {
        if (typeof pe != "string" && (pe = String(pe)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(pe) || pe === "")
          throw new TypeError('Invalid character in header field name: "' + pe + '"');
        return pe.toLowerCase();
      }
      function $e(pe) {
        return typeof pe != "string" && (pe = String(pe)), pe;
      }
      function Re(pe) {
        var ve = {
          next: function() {
            var we = pe.shift();
            return { done: we === void 0, value: we };
          }
        };
        return me.iterable && (ve[Symbol.iterator] = function() {
          return ve;
        }), ve;
      }
      function Me(pe) {
        this.map = {}, pe instanceof Me ? pe.forEach(function(ve, we) {
          this.append(we, ve);
        }, this) : Array.isArray(pe) ? pe.forEach(function(ve) {
          this.append(ve[0], ve[1]);
        }, this) : pe && Object.getOwnPropertyNames(pe).forEach(function(ve) {
          this.append(ve, pe[ve]);
        }, this);
      }
      Me.prototype.append = function(pe, ve) {
        pe = Se(pe), ve = $e(ve);
        var we = this.map[pe];
        this.map[pe] = we ? we + ", " + ve : ve;
      }, Me.prototype.delete = function(pe) {
        delete this.map[Se(pe)];
      }, Me.prototype.get = function(pe) {
        return pe = Se(pe), this.has(pe) ? this.map[pe] : null;
      }, Me.prototype.has = function(pe) {
        return this.map.hasOwnProperty(Se(pe));
      }, Me.prototype.set = function(pe, ve) {
        this.map[Se(pe)] = $e(ve);
      }, Me.prototype.forEach = function(pe, ve) {
        for (var we in this.map)
          this.map.hasOwnProperty(we) && pe.call(ve, this.map[we], we, this);
      }, Me.prototype.keys = function() {
        var pe = [];
        return this.forEach(function(ve, we) {
          pe.push(we);
        }), Re(pe);
      }, Me.prototype.values = function() {
        var pe = [];
        return this.forEach(function(ve) {
          pe.push(ve);
        }), Re(pe);
      }, Me.prototype.entries = function() {
        var pe = [];
        return this.forEach(function(ve, we) {
          pe.push([we, ve]);
        }), Re(pe);
      }, me.iterable && (Me.prototype[Symbol.iterator] = Me.prototype.entries);
      function ke(pe) {
        if (pe.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        pe.bodyUsed = !0;
      }
      function Te(pe) {
        return new Promise(function(ve, we) {
          pe.onload = function() {
            ve(pe.result);
          }, pe.onerror = function() {
            we(pe.error);
          };
        });
      }
      function Ie(pe) {
        var ve = new FileReader(), we = Te(ve);
        return ve.readAsArrayBuffer(pe), we;
      }
      function qe(pe) {
        var ve = new FileReader(), we = Te(ve);
        return ve.readAsText(pe), we;
      }
      function Ue(pe) {
        for (var ve = new Uint8Array(pe), we = new Array(ve.length), Ee = 0; Ee < ve.length; Ee++)
          we[Ee] = String.fromCharCode(ve[Ee]);
        return we.join("");
      }
      function ze(pe) {
        if (pe.slice)
          return pe.slice(0);
        var ve = new Uint8Array(pe.byteLength);
        return ve.set(new Uint8Array(pe)), ve.buffer;
      }
      function Ve() {
        return this.bodyUsed = !1, this._initBody = function(pe) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = pe, pe ? typeof pe == "string" ? this._bodyText = pe : me.blob && Blob.prototype.isPrototypeOf(pe) ? this._bodyBlob = pe : me.formData && FormData.prototype.isPrototypeOf(pe) ? this._bodyFormData = pe : me.searchParams && URLSearchParams.prototype.isPrototypeOf(pe) ? this._bodyText = pe.toString() : me.arrayBuffer && me.blob && ye(pe) ? (this._bodyArrayBuffer = ze(pe.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : me.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(pe) || Ae(pe)) ? this._bodyArrayBuffer = ze(pe) : this._bodyText = pe = Object.prototype.toString.call(pe) : this._bodyText = "", this.headers.get("content-type") || (typeof pe == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : me.searchParams && URLSearchParams.prototype.isPrototypeOf(pe) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, me.blob && (this.blob = function() {
          var pe = ke(this);
          if (pe)
            return pe;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var pe = ke(this);
            return pe || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else
            return this.blob().then(Ie);
        }), this.text = function() {
          var pe = ke(this);
          if (pe)
            return pe;
          if (this._bodyBlob)
            return qe(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(Ue(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, me.formData && (this.formData = function() {
          return this.text().then(jt);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Mt = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function Rt(pe) {
        var ve = pe.toUpperCase();
        return Mt.indexOf(ve) > -1 ? ve : pe;
      }
      function je(pe, ve) {
        if (!(this instanceof je))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        ve = ve || {};
        var we = ve.body;
        if (pe instanceof je) {
          if (pe.bodyUsed)
            throw new TypeError("Already read");
          this.url = pe.url, this.credentials = pe.credentials, ve.headers || (this.headers = new Me(pe.headers)), this.method = pe.method, this.mode = pe.mode, this.signal = pe.signal, !we && pe._bodyInit != null && (we = pe._bodyInit, pe.bodyUsed = !0);
        } else
          this.url = String(pe);
        if (this.credentials = ve.credentials || this.credentials || "same-origin", (ve.headers || !this.headers) && (this.headers = new Me(ve.headers)), this.method = Rt(ve.method || this.method || "GET"), this.mode = ve.mode || this.mode || null, this.signal = ve.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && we)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(we), (this.method === "GET" || this.method === "HEAD") && (ve.cache === "no-store" || ve.cache === "no-cache")) {
          var Ee = /([?&])_=[^&]*/;
          if (Ee.test(this.url))
            this.url = this.url.replace(Ee, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var xe = /\?/;
            this.url += (xe.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      je.prototype.clone = function() {
        return new je(this, { body: this._bodyInit });
      };
      function jt(pe) {
        var ve = new FormData();
        return pe.trim().split("&").forEach(function(we) {
          if (we) {
            var Ee = we.split("="), xe = Ee.shift().replace(/\+/g, " "), ue = Ee.join("=").replace(/\+/g, " ");
            ve.append(decodeURIComponent(xe), decodeURIComponent(ue));
          }
        }), ve;
      }
      function _e(pe) {
        var ve = new Me(), we = pe.replace(/\r?\n[\t ]+/g, " ");
        return we.split("\r").map(function(Ee) {
          return Ee.indexOf(`
`) === 0 ? Ee.substr(1, Ee.length) : Ee;
        }).forEach(function(Ee) {
          var xe = Ee.split(":"), ue = xe.shift().trim();
          if (ue) {
            var ge = xe.join(":").trim();
            ve.append(ue, ge);
          }
        }), ve;
      }
      Ve.call(je.prototype);
      function se(pe, ve) {
        if (!(this instanceof se))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        ve || (ve = {}), this.type = "default", this.status = ve.status === void 0 ? 200 : ve.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = ve.statusText === void 0 ? "" : "" + ve.statusText, this.headers = new Me(ve.headers), this.url = ve.url || "", this._initBody(pe);
      }
      Ve.call(se.prototype), se.prototype.clone = function() {
        return new se(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Me(this.headers),
          url: this.url
        });
      }, se.error = function() {
        var pe = new se(null, { status: 0, statusText: "" });
        return pe.type = "error", pe;
      };
      var ce = [301, 302, 303, 307, 308];
      se.redirect = function(pe, ve) {
        if (ce.indexOf(ve) === -1)
          throw new RangeError("Invalid status code");
        return new se(null, { status: ve, headers: { location: pe } });
      }, le.DOMException = he.DOMException;
      try {
        new le.DOMException();
      } catch {
        le.DOMException = function(ve, we) {
          this.message = ve, this.name = we;
          var Ee = Error(ve);
          this.stack = Ee.stack;
        }, le.DOMException.prototype = Object.create(Error.prototype), le.DOMException.prototype.constructor = le.DOMException;
      }
      function de(pe, ve) {
        return new Promise(function(we, Ee) {
          var xe = new je(pe, ve);
          if (xe.signal && xe.signal.aborted)
            return Ee(new le.DOMException("Aborted", "AbortError"));
          var ue = new XMLHttpRequest();
          function ge() {
            ue.abort();
          }
          ue.onload = function() {
            var Ne = {
              status: ue.status,
              statusText: ue.statusText,
              headers: _e(ue.getAllResponseHeaders() || "")
            };
            Ne.url = "responseURL" in ue ? ue.responseURL : Ne.headers.get("X-Request-URL");
            var Fe = "response" in ue ? ue.response : ue.responseText;
            setTimeout(function() {
              we(new se(Fe, Ne));
            }, 0);
          }, ue.onerror = function() {
            setTimeout(function() {
              Ee(new TypeError("Network request failed"));
            }, 0);
          }, ue.ontimeout = function() {
            setTimeout(function() {
              Ee(new TypeError("Network request failed"));
            }, 0);
          }, ue.onabort = function() {
            setTimeout(function() {
              Ee(new le.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function Be(Ne) {
            try {
              return Ne === "" && he.location.href ? he.location.href : Ne;
            } catch {
              return Ne;
            }
          }
          ue.open(xe.method, Be(xe.url), !0), xe.credentials === "include" ? ue.withCredentials = !0 : xe.credentials === "omit" && (ue.withCredentials = !1), "responseType" in ue && (me.blob ? ue.responseType = "blob" : me.arrayBuffer && xe.headers.get("Content-Type") && xe.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (ue.responseType = "arraybuffer")), ve && typeof ve.headers == "object" && !(ve.headers instanceof Me) ? Object.getOwnPropertyNames(ve.headers).forEach(function(Ne) {
            ue.setRequestHeader(Ne, $e(ve.headers[Ne]));
          }) : xe.headers.forEach(function(Ne, Fe) {
            ue.setRequestHeader(Fe, Ne);
          }), xe.signal && (xe.signal.addEventListener("abort", ge), ue.onreadystatechange = function() {
            ue.readyState === 4 && xe.signal.removeEventListener("abort", ge);
          }), ue.send(typeof xe._bodyInit > "u" ? null : xe._bodyInit);
        });
      }
      return de.polyfill = !0, he.fetch || (he.fetch = de, he.Headers = Me, he.Request = je, he.Response = se), le.Headers = Me, le.Request = je, le.Response = se, le.fetch = de, le;
    })({});
  })(ie), ie.fetch.ponyfill = !0, delete ie.fetch.polyfill;
  var fe = n.fetch ? n : ie;
  t = fe.fetch, t.default = fe.fetch, t.fetch = fe.fetch, t.Headers = fe.Headers, t.Request = fe.Request, t.Response = fe.Response, c.exports = t;
})(browserPonyfill, browserPonyfill.exports);
var browserPonyfillExports = browserPonyfill.exports, __awaiter$9 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$9 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Networking$1, "__esModule", { value: !0 });
var cross_fetch_1 = __importDefault$8(browserPonyfillExports), Networking = (
  /** @class */
  function() {
    function c() {
    }
    return c.fetch = function(t, n) {
      return __awaiter$9(this, void 0, void 0, function() {
        return __generator$9(this, function(ie) {
          return [2, (0, cross_fetch_1.default)(t, n)];
        });
      });
    }, c;
  }()
);
Networking$1.default = Networking;
var __awaiter$8 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$8 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Tlds$1, "__esModule", { value: !0 });
var Networking_1$5 = __importDefault$7(Networking$1), Tlds = (
  /** @class */
  function() {
    function c() {
    }
    return c.loadSupportedTldsData = function() {
      return __awaiter$8(this, void 0, void 0, function() {
        var t, n, ie;
        return __generator$8(this, function(fe) {
          switch (fe.label) {
            case 0:
              return fe.trys.push([0, 3, , 4]), [4, Networking_1$5.default.fetch("https://api.unstoppabledomains.com/resolve/supported_tlds")];
            case 1:
              return t = fe.sent(), [4, t.json()];
            case 2:
              return n = fe.sent(), c.supportedTlds = n.tlds, c.tldsMeta = n.meta, [3, 4];
            case 3:
              throw ie = fe.sent(), new Error("Failed to load supported TLDs data: ".concat(ie));
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, c.getSupportedTlds = function() {
      return __awaiter$8(this, void 0, void 0, function() {
        return __generator$8(this, function(t) {
          switch (t.label) {
            case 0:
              return c.supportedTlds ? [3, 2] : [4, c.loadSupportedTldsData()];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [2, c.supportedTlds];
          }
        });
      });
    }, c.getTldsMeta = function() {
      return __awaiter$8(this, void 0, void 0, function() {
        return __generator$8(this, function(t) {
          switch (t.label) {
            case 0:
              return c.tldsMeta ? [3, 2] : [4, c.loadSupportedTldsData()];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [2, c.tldsMeta];
          }
        });
      });
    }, c;
  }()
);
Tlds$1.default = Tlds;
const name$2 = "@unstoppabledomains/resolution", version$5 = "9.3.2", description$2 = "Domain Resolution for blockchain domains", main$2 = "./build/index.js", directories = {
  doc: "docs"
}, types$2 = "./build/index.d.ts", scripts$2 = {
  release: "RELEASE=patch yarn release:run",
  "release:minor": "RELEASE=minor yarn release:run",
  "release:major": "RELEASE=major yarn release:run",
  "release:run": "yarn build && yarn size && yarn publish --$RELEASE && yarn release:tag && yarn docs:deploy",
  "release:tag": "git push origin v$npm_package_version",
  fix: "yarn prettier:fix && yarn lint:fix --ext ts src",
  lint: "eslint --ext ts src",
  "lint:fix": "eslint --fix --ext ts src",
  prettier: 'prettier -l "src/**/*.{ts,tsx,js,jsx,json,md}"',
  "prettier:fix": 'prettier --write -l "src/**/*.{ts,tsx,js,jsx,json,md}"',
  test: "jest",
  "test:live:win": "set LIVE=1 && yarn test",
  start: "npm run build:live",
  build: "rm -rf build && tsc -p .",
  "build:live": "nodemon --watch 'src/**/*.ts' --exec yarn build",
  docs: "yarn docs:clone && yarn docs:generate && yarn docs:readme",
  "docs:clone": "([ -d ./docs ] || git clone --branch gh-pages git@github.com:unstoppabledomains/resolution.git docs) && git -C ./docs pull",
  "docs:generate": 'yarn run typedoc --out "./docs/v$npm_package_version"',
  "docs:readme": "./docs-readme.sh",
  "docs:deploy": "yarn docs && ./deploy-docs.sh",
  size: "yarn run sizecheck -p ./package.json -l 500 -v",
  "config:pull": "yarn network-config:pull && yarn resolver-keys:pull",
  "network-config:pull": "curl https://raw.githubusercontent.com/unstoppabledomains/uns/main/uns-config.json -o src/config/uns-config.json",
  "resolver-keys:pull": "curl https://raw.githubusercontent.com/unstoppabledomains/uns/main/resolver-keys.json -o src/config/resolver-keys.json",
  prepare: '([ -d ./.git ] && husky install) || echo "Skip husky install since package does not have .git folder"'
}, files$2 = [
  "build"
], author$2 = "Unstoppable Domains", repository$2 = {
  type: "git",
  url: "https://github.com/unstoppabledomains/resolution.git"
}, keywords$2 = [
  ".crypto",
  "zns",
  "ens",
  "ethereum",
  "zilliqa",
  "blockchain",
  "resolution",
  "name",
  "domain",
  "unstoppable"
], license$2 = "MIT", bugs$2 = {
  url: "https://github.com/unstoppabledomains/resolution.git"
}, homepage$2 = "https://github.com/unstoppabledomains/resolution.git#readme", devDependencies$2 = {
  "@types/bn.js": "^4.11.6",
  "@types/crypto-js": "^4.1.1",
  "@types/elliptic": "^6.4.13",
  "@types/jest": "27.0.2",
  "@types/lodash": "^4.14.158",
  "@types/node": "11.15.3",
  "@typescript-eslint/eslint-plugin": "^3.9.0",
  "@typescript-eslint/parser": "^3.9.0",
  "@unstoppabledomains/sizecheck": "^4.0.4",
  "@zilliqa-js/core": "^3.3.4",
  "audit-ci": "^3.1.1",
  dotenv: "^8.2.0",
  eslint: "^7.7.0",
  "eslint-config-prettier": "^8.3.0",
  "eslint-plugin-jest": "^24.1.0",
  ethers: "^6.13.4",
  husky: "^6.0.0",
  jest: "^27.0.4",
  "lint-staged": "11.0.0",
  lodash: "^4.17.19",
  nock: "10.0.6",
  nodemon: "^2.0.7",
  prettier: "2.3.0",
  "pretty-quick": "^3.1.0",
  "ts-jest": "^27.0.3",
  "ts-loader": "6.2.1",
  "ts-node": "^8.6.2",
  typedoc: "0.18.0",
  typescript: "^4.2.0",
  "web3-providers-http": "^1.3.6",
  "web3-providers-ws": "^1.3.6"
}, publicConfig = {
  access: "public"
}, dependencies$2 = {
  "@ensdomains/address-encoder": "^0.2.22",
  "@ethersproject/abi": "^5.0.1",
  "bip44-constants": "^8.0.103",
  "bn.js": "^4.4.0",
  "content-hash": "^2.5.2",
  "cross-fetch": "4.0.0",
  "crypto-js": "^4.1.1",
  elliptic: "^6.5.4",
  "js-sha256": "^0.9.0",
  "js-sha3": "^0.8.0"
}, require$$4$1 = {
  name: name$2,
  version: version$5,
  description: description$2,
  main: main$2,
  directories,
  types: types$2,
  scripts: scripts$2,
  files: files$2,
  author: author$2,
  repository: repository$2,
  keywords: keywords$2,
  license: license$2,
  bugs: bugs$2,
  homepage: homepage$2,
  devDependencies: devDependencies$2,
  publicConfig,
  dependencies: dependencies$2,
  "lint-staged": {
    "src/**/*.ts": "eslint --fix",
    "src/**/*.{ts,tsx,js,jsx,json,md}": "prettier --write -l"
  }
};
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__assign || function() {
    return t = Object.assign || function(Mt) {
      for (var Rt, je = 1, jt = arguments.length; je < jt; je++) {
        Rt = arguments[je];
        for (var _e in Rt) Object.prototype.hasOwnProperty.call(Rt, _e) && (Mt[_e] = Rt[_e]);
      }
      return Mt;
    }, t.apply(this, arguments);
  }, n = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Mt, Rt, je, jt) {
    jt === void 0 && (jt = je);
    var _e = Object.getOwnPropertyDescriptor(Rt, je);
    (!_e || ("get" in _e ? !Rt.__esModule : _e.writable || _e.configurable)) && (_e = { enumerable: !0, get: function() {
      return Rt[je];
    } }), Object.defineProperty(Mt, jt, _e);
  } : function(Mt, Rt, je, jt) {
    jt === void 0 && (jt = je), Mt[jt] = Rt[je];
  }), ie = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Mt, Rt) {
    Object.defineProperty(Mt, "default", { enumerable: !0, value: Rt });
  } : function(Mt, Rt) {
    Mt.default = Rt;
  }), fe = commonjsGlobal && commonjsGlobal.__importStar || function(Mt) {
    if (Mt && Mt.__esModule) return Mt;
    var Rt = {};
    if (Mt != null) for (var je in Mt) je !== "default" && Object.prototype.hasOwnProperty.call(Mt, je) && n(Rt, Mt, je);
    return ie(Rt, Mt), Rt;
  }, ae = commonjsGlobal && commonjsGlobal.__awaiter || function(Mt, Rt, je, jt) {
    function _e(se) {
      return se instanceof je ? se : new je(function(ce) {
        ce(se);
      });
    }
    return new (je || (je = Promise))(function(se, ce) {
      function de(we) {
        try {
          ve(jt.next(we));
        } catch (Ee) {
          ce(Ee);
        }
      }
      function pe(we) {
        try {
          ve(jt.throw(we));
        } catch (Ee) {
          ce(Ee);
        }
      }
      function ve(we) {
        we.done ? se(we.value) : _e(we.value).then(de, pe);
      }
      ve((jt = jt.apply(Mt, Rt || [])).next());
    });
  }, le = commonjsGlobal && commonjsGlobal.__generator || function(Mt, Rt) {
    var je = { label: 0, sent: function() {
      if (se[0] & 1) throw se[1];
      return se[1];
    }, trys: [], ops: [] }, jt, _e, se, ce;
    return ce = { next: de(0), throw: de(1), return: de(2) }, typeof Symbol == "function" && (ce[Symbol.iterator] = function() {
      return this;
    }), ce;
    function de(ve) {
      return function(we) {
        return pe([ve, we]);
      };
    }
    function pe(ve) {
      if (jt) throw new TypeError("Generator is already executing.");
      for (; je; ) try {
        if (jt = 1, _e && (se = ve[0] & 2 ? _e.return : ve[0] ? _e.throw || ((se = _e.return) && se.call(_e), 0) : _e.next) && !(se = se.call(_e, ve[1])).done) return se;
        switch (_e = 0, se && (ve = [ve[0] & 2, se.value]), ve[0]) {
          case 0:
          case 1:
            se = ve;
            break;
          case 4:
            return je.label++, { value: ve[1], done: !1 };
          case 5:
            je.label++, _e = ve[1], ve = [0];
            continue;
          case 7:
            ve = je.ops.pop(), je.trys.pop();
            continue;
          default:
            if (se = je.trys, !(se = se.length > 0 && se[se.length - 1]) && (ve[0] === 6 || ve[0] === 2)) {
              je = 0;
              continue;
            }
            if (ve[0] === 3 && (!se || ve[1] > se[0] && ve[1] < se[3])) {
              je.label = ve[1];
              break;
            }
            if (ve[0] === 6 && je.label < se[1]) {
              je.label = se[1], se = ve;
              break;
            }
            if (se && je.label < se[2]) {
              je.label = se[2], je.ops.push(ve);
              break;
            }
            se[2] && je.ops.pop(), je.trys.pop();
            continue;
        }
        ve = Rt.call(Mt, je);
      } catch (we) {
        ve = [6, we], _e = 0;
      } finally {
        jt = se = 0;
      }
      if (ve[0] & 5) throw ve[1];
      return { value: ve[0] ? ve[1] : void 0, done: !0 };
    }
  }, he = commonjsGlobal && commonjsGlobal.__importDefault || function(Mt) {
    return Mt && Mt.__esModule ? Mt : { default: Mt };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.unwrapResult = c.wrapResult = c.EthereumNetworksInverted = c.EthereumNetworks = c.findNamingServiceName = c.constructRecords = c.isNullAddress = c.hexToBytes = c.signedLink = c.signedInfuraLink = c.getLibAgent = void 0;
  var me = publicTypes, ye = types$3, be = he(Tlds$1), Ae = fe(resolutionError), Se = {
    infura: {
      mainnet: "https://mainnet.infura.io/v3/",
      sepolia: "https://sepolia.infura.io/v3/",
      "polygon-mainnet": "https://polygon-mainnet.infura.io/v3/",
      "polygon-amoy": "https://polygon-amoy.infura.io/v3/",
      "base-mainnet": "https://base-mainnet.infura.io/v3/",
      "base-sepolia": "https://base-sepolia.infura.io/v3/"
    },
    alchemy: {
      mainnet: "https://eth-mainnet.g.alchemy.com/v2/",
      sepolia: "https://eth-sepolia.g.alchemy.com/v2/",
      "polygon-mainnet": "https://polygon-mainnet.g.alchemy.com/v2/",
      "polygon-amoy": "https://polygon-amoy.g.alchemy.com/v2/",
      "base-mainnet": "https://base-mainnet.g.alchemy.com/v2/",
      "base-sepolia": "https://base-sepolia.g.alchemy.com/v2/"
    }
  };
  function $e() {
    var Mt = "UnstoppableDomains/resolution-js";
    try {
      var Rt = require$$4$1;
      return Mt += "/" + Rt.version, Mt;
    } catch {
      return Mt;
    }
  }
  c.getLibAgent = $e;
  function Re(Mt, Rt) {
    return Rt === void 0 && (Rt = "mainnet"), "https://".concat(Rt, ".infura.io/v3/").concat(Mt);
  }
  c.signedInfuraLink = Re;
  function Me(Mt, Rt, je) {
    Rt === void 0 && (Rt = "mainnet"), je === void 0 && (je = "alchemy");
    var jt = Se[je][Rt];
    return "".concat(jt).concat(Mt);
  }
  c.signedLink = Me;
  function ke(Mt) {
    for (var Rt = Mt.replace(/^0x/i, ""), je = [], jt = 0; jt < Rt.length; jt += 2)
      je.push(parseInt(Rt.substr(jt, 2), 16));
    return je;
  }
  c.hexToBytes = ke;
  function Te(Mt) {
    return Mt ? Object.values(ye.NullAddresses).includes(Mt) : !0;
  }
  c.isNullAddress = Te;
  function Ie(Mt, Rt) {
    var je = {};
    return Mt.forEach(function(jt, _e) {
      je[jt] = (Rt instanceof Array ? Rt[_e] : Rt == null ? void 0 : Rt[jt]) || "";
    }), je;
  }
  c.constructRecords = Ie;
  var qe = ["eth", "reverse"], Ue = function(Mt) {
    return ae(void 0, void 0, void 0, function() {
      var Rt, je, jt, _e, se;
      return le(this, function(ce) {
        switch (ce.label) {
          case 0:
            return Rt = Mt.split(".").pop(), Rt ? qe.includes(Rt) ? [2, me.NamingServiceName.ENS] : [4, be.default.getTldsMeta()] : [2, null];
          case 1:
            if (je = ce.sent(), !je)
              throw new Ae.default(Ae.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: "TLD meta is not available. Possibly failed to load supported TLDs data"
              });
            if (Rt in je)
              switch (jt = je[Rt], _e = jt.namingService, se = jt.registrationBlockchain, _e) {
                case "UNS":
                  switch (se) {
                    case me.BlockchainType.BASE:
                      return [2, me.NamingServiceName.UNS_BASE];
                    default:
                      return [2, me.NamingServiceName.UNS];
                  }
                case "ENS":
                  return [2, me.NamingServiceName.ENS];
                case "ZNS":
                  return [2, me.NamingServiceName.ZNS];
              }
            return [2, null];
        }
      });
    });
  };
  c.findNamingServiceName = Ue, c.EthereumNetworks = {
    mainnet: 1,
    sepolia: 11155111,
    "polygon-mainnet": 137,
    "polygon-amoy": 80002,
    "base-mainnet": 8453,
    "base-sepolia": 84532
  }, c.EthereumNetworksInverted = Object.entries(c.EthereumNetworks).reduce(function(Mt, Rt) {
    var je, jt = Rt[0], _e = Rt[1];
    return t(t({}, Mt), (je = {}, je[_e] = jt, je));
  }, {});
  var ze = function(Mt) {
    var Rt;
    try {
      Rt = Mt();
    } catch (jt) {
      return Promise.resolve({ result: null, error: jt });
    }
    var je = Rt instanceof Promise ? Rt : Promise.resolve(Rt);
    return je.then(function(jt) {
      return { result: jt, error: null };
    }, function(jt) {
      return { result: null, error: jt };
    });
  };
  c.wrapResult = ze;
  var Ve = function(Mt) {
    if (Mt.error !== null)
      throw Mt.error;
    return Mt.result;
  };
  c.unwrapResult = Ve;
})(utils$e);
var FetchProvider$1 = {}, __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$8(t, c, n);
  return __setModuleDefault$8(t, c), t;
}, __awaiter$7 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$7 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(FetchProvider$1, "__esModule", { value: !0 });
var resolutionError_1$8 = __importStar$8(resolutionError), Networking_1$4 = __importDefault$6(Networking$1), utils_1$6 = utils$e, FetchProvider = (
  /** @class */
  function() {
    function c(t, n) {
      this.url = n, this.name = t;
    }
    return c.factory = function(t, n) {
      return new this(t, n);
    }, c.prototype.request = function(t) {
      return __awaiter$7(this, void 0, void 0, function() {
        var n;
        return __generator$7(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.fetchJson(t)];
            case 1:
              if (n = ie.sent(), n.error)
                throw new resolutionError_1$8.default(resolutionError_1$8.ResolutionErrorCode.ServiceProviderError, {
                  providerMessage: n.error.message
                });
              return [2, n.result];
          }
        });
      });
    }, c.prototype.fetchJson = function(t) {
      return __awaiter$7(this, void 0, void 0, function() {
        var n, ie;
        return __generator$7(this, function(fe) {
          switch (fe.label) {
            case 0:
              return n = {
                method: "POST",
                body: JSON.stringify({
                  jsonrpc: "2.0",
                  id: "1",
                  method: t.method,
                  params: t.params || []
                }),
                headers: {
                  "Content-Type": "application/json"
                }
              }, t.apiKey && (n.headers.Authorization = "Bearer ".concat(t.apiKey), n.headers["X-Lib-Agent"] = (0, utils_1$6.getLibAgent)()), [4, Networking_1$4.default.fetch(this.url, n)];
            case 1:
              if (ie = fe.sent(), ie.status !== 200)
                throw new resolutionError_1$8.default(resolutionError_1$8.ResolutionErrorCode.ServiceProviderError, {
                  providerMessage: "Request to ".concat(this.url, " failed with response status ").concat(ie.status)
                });
              return [2, ie.json()];
          }
        });
      });
    }, c;
  }()
);
FetchProvider$1.default = FetchProvider;
var namehash = {}, sha256$2 = { exports: {} };
function commonjsRequire(c) {
  throw new Error('Could not dynamically require "' + c + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var core = { exports: {} }, cryptoBrowserify = {}, browser$b = { exports: {} }, hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b) return browser$b.exports;
  hasRequiredBrowser$b = 1;
  var c = 65536, t = 4294967295;
  function n() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var ie = safeBufferExports.Buffer, fe = globalThis.crypto || globalThis.msCrypto;
  fe && fe.getRandomValues ? browser$b.exports = ae : browser$b.exports = n;
  function ae(le, he) {
    if (le > t) throw new RangeError("requested too many random bytes");
    var me = ie.allocUnsafe(le);
    if (le > 0)
      if (le > c)
        for (var ye = 0; ye < le; ye += c)
          fe.getRandomValues(me.slice(ye, ye + c));
      else
        fe.getRandomValues(me);
    return typeof he == "function" ? process$1.nextTick(function() {
      he(null, me);
    }) : me;
  }
  return browser$b.exports;
}
var readableBrowser$1 = { exports: {} }, events = { exports: {} }, hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events.exports;
  hasRequiredEvents = 1;
  var c = typeof Reflect == "object" ? Reflect : null, t = c && typeof c.apply == "function" ? c.apply : function(ze, Ve, Mt) {
    return Function.prototype.apply.call(ze, Ve, Mt);
  }, n;
  c && typeof c.ownKeys == "function" ? n = c.ownKeys : Object.getOwnPropertySymbols ? n = function(ze) {
    return Object.getOwnPropertyNames(ze).concat(Object.getOwnPropertySymbols(ze));
  } : n = function(ze) {
    return Object.getOwnPropertyNames(ze);
  };
  function ie(Ue) {
    console && console.warn && console.warn(Ue);
  }
  var fe = Number.isNaN || function(ze) {
    return ze !== ze;
  };
  function ae() {
    ae.init.call(this);
  }
  events.exports = ae, events.exports.once = Te, ae.EventEmitter = ae, ae.prototype._events = void 0, ae.prototype._eventsCount = 0, ae.prototype._maxListeners = void 0;
  var le = 10;
  function he(Ue) {
    if (typeof Ue != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof Ue);
  }
  Object.defineProperty(ae, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return le;
    },
    set: function(Ue) {
      if (typeof Ue != "number" || Ue < 0 || fe(Ue))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + Ue + ".");
      le = Ue;
    }
  }), ae.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, ae.prototype.setMaxListeners = function(ze) {
    if (typeof ze != "number" || ze < 0 || fe(ze))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + ze + ".");
    return this._maxListeners = ze, this;
  };
  function me(Ue) {
    return Ue._maxListeners === void 0 ? ae.defaultMaxListeners : Ue._maxListeners;
  }
  ae.prototype.getMaxListeners = function() {
    return me(this);
  }, ae.prototype.emit = function(ze) {
    for (var Ve = [], Mt = 1; Mt < arguments.length; Mt++) Ve.push(arguments[Mt]);
    var Rt = ze === "error", je = this._events;
    if (je !== void 0)
      Rt = Rt && je.error === void 0;
    else if (!Rt)
      return !1;
    if (Rt) {
      var jt;
      if (Ve.length > 0 && (jt = Ve[0]), jt instanceof Error)
        throw jt;
      var _e = new Error("Unhandled error." + (jt ? " (" + jt.message + ")" : ""));
      throw _e.context = jt, _e;
    }
    var se = je[ze];
    if (se === void 0)
      return !1;
    if (typeof se == "function")
      t(se, this, Ve);
    else
      for (var ce = se.length, de = Re(se, ce), Mt = 0; Mt < ce; ++Mt)
        t(de[Mt], this, Ve);
    return !0;
  };
  function ye(Ue, ze, Ve, Mt) {
    var Rt, je, jt;
    if (he(Ve), je = Ue._events, je === void 0 ? (je = Ue._events = /* @__PURE__ */ Object.create(null), Ue._eventsCount = 0) : (je.newListener !== void 0 && (Ue.emit(
      "newListener",
      ze,
      Ve.listener ? Ve.listener : Ve
    ), je = Ue._events), jt = je[ze]), jt === void 0)
      jt = je[ze] = Ve, ++Ue._eventsCount;
    else if (typeof jt == "function" ? jt = je[ze] = Mt ? [Ve, jt] : [jt, Ve] : Mt ? jt.unshift(Ve) : jt.push(Ve), Rt = me(Ue), Rt > 0 && jt.length > Rt && !jt.warned) {
      jt.warned = !0;
      var _e = new Error("Possible EventEmitter memory leak detected. " + jt.length + " " + String(ze) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      _e.name = "MaxListenersExceededWarning", _e.emitter = Ue, _e.type = ze, _e.count = jt.length, ie(_e);
    }
    return Ue;
  }
  ae.prototype.addListener = function(ze, Ve) {
    return ye(this, ze, Ve, !1);
  }, ae.prototype.on = ae.prototype.addListener, ae.prototype.prependListener = function(ze, Ve) {
    return ye(this, ze, Ve, !0);
  };
  function be() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function Ae(Ue, ze, Ve) {
    var Mt = { fired: !1, wrapFn: void 0, target: Ue, type: ze, listener: Ve }, Rt = be.bind(Mt);
    return Rt.listener = Ve, Mt.wrapFn = Rt, Rt;
  }
  ae.prototype.once = function(ze, Ve) {
    return he(Ve), this.on(ze, Ae(this, ze, Ve)), this;
  }, ae.prototype.prependOnceListener = function(ze, Ve) {
    return he(Ve), this.prependListener(ze, Ae(this, ze, Ve)), this;
  }, ae.prototype.removeListener = function(ze, Ve) {
    var Mt, Rt, je, jt, _e;
    if (he(Ve), Rt = this._events, Rt === void 0)
      return this;
    if (Mt = Rt[ze], Mt === void 0)
      return this;
    if (Mt === Ve || Mt.listener === Ve)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Rt[ze], Rt.removeListener && this.emit("removeListener", ze, Mt.listener || Ve));
    else if (typeof Mt != "function") {
      for (je = -1, jt = Mt.length - 1; jt >= 0; jt--)
        if (Mt[jt] === Ve || Mt[jt].listener === Ve) {
          _e = Mt[jt].listener, je = jt;
          break;
        }
      if (je < 0)
        return this;
      je === 0 ? Mt.shift() : Me(Mt, je), Mt.length === 1 && (Rt[ze] = Mt[0]), Rt.removeListener !== void 0 && this.emit("removeListener", ze, _e || Ve);
    }
    return this;
  }, ae.prototype.off = ae.prototype.removeListener, ae.prototype.removeAllListeners = function(ze) {
    var Ve, Mt, Rt;
    if (Mt = this._events, Mt === void 0)
      return this;
    if (Mt.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Mt[ze] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Mt[ze]), this;
    if (arguments.length === 0) {
      var je = Object.keys(Mt), jt;
      for (Rt = 0; Rt < je.length; ++Rt)
        jt = je[Rt], jt !== "removeListener" && this.removeAllListeners(jt);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (Ve = Mt[ze], typeof Ve == "function")
      this.removeListener(ze, Ve);
    else if (Ve !== void 0)
      for (Rt = Ve.length - 1; Rt >= 0; Rt--)
        this.removeListener(ze, Ve[Rt]);
    return this;
  };
  function Se(Ue, ze, Ve) {
    var Mt = Ue._events;
    if (Mt === void 0)
      return [];
    var Rt = Mt[ze];
    return Rt === void 0 ? [] : typeof Rt == "function" ? Ve ? [Rt.listener || Rt] : [Rt] : Ve ? ke(Rt) : Re(Rt, Rt.length);
  }
  ae.prototype.listeners = function(ze) {
    return Se(this, ze, !0);
  }, ae.prototype.rawListeners = function(ze) {
    return Se(this, ze, !1);
  }, ae.listenerCount = function(Ue, ze) {
    return typeof Ue.listenerCount == "function" ? Ue.listenerCount(ze) : $e.call(Ue, ze);
  }, ae.prototype.listenerCount = $e;
  function $e(Ue) {
    var ze = this._events;
    if (ze !== void 0) {
      var Ve = ze[Ue];
      if (typeof Ve == "function")
        return 1;
      if (Ve !== void 0)
        return Ve.length;
    }
    return 0;
  }
  ae.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function Re(Ue, ze) {
    for (var Ve = new Array(ze), Mt = 0; Mt < ze; ++Mt)
      Ve[Mt] = Ue[Mt];
    return Ve;
  }
  function Me(Ue, ze) {
    for (; ze + 1 < Ue.length; ze++)
      Ue[ze] = Ue[ze + 1];
    Ue.pop();
  }
  function ke(Ue) {
    for (var ze = new Array(Ue.length), Ve = 0; Ve < ze.length; ++Ve)
      ze[Ve] = Ue[Ve].listener || Ue[Ve];
    return ze;
  }
  function Te(Ue, ze) {
    return new Promise(function(Ve, Mt) {
      function Rt(jt) {
        Ue.removeListener(ze, je), Mt(jt);
      }
      function je() {
        typeof Ue.removeListener == "function" && Ue.removeListener("error", Rt), Ve([].slice.call(arguments));
      }
      qe(Ue, ze, je, { once: !0 }), ze !== "error" && Ie(Ue, Rt, { once: !0 });
    });
  }
  function Ie(Ue, ze, Ve) {
    typeof Ue.on == "function" && qe(Ue, "error", ze, Ve);
  }
  function qe(Ue, ze, Ve, Mt) {
    if (typeof Ue.on == "function")
      Mt.once ? Ue.once(ze, Ve) : Ue.on(ze, Ve);
    else if (typeof Ue.addEventListener == "function")
      Ue.addEventListener(ze, function Rt(je) {
        Mt.once && Ue.removeEventListener(ze, Rt), Ve(je);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof Ue);
  }
  return events.exports;
}
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = requireEvents().EventEmitter), streamBrowser$1;
}
var util$1 = {}, types$1 = {}, shams$1, hasRequiredShams$1;
function requireShams$1() {
  return hasRequiredShams$1 || (hasRequiredShams$1 = 1, shams$1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), ie = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(ie) !== "[object Symbol]")
      return !1;
    var fe = 42;
    t[n] = fe;
    for (n in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var ae = Object.getOwnPropertySymbols(t);
    if (ae.length !== 1 || ae[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var le = Object.getOwnPropertyDescriptor(t, n);
      if (le.value !== fe || le.enumerable !== !0)
        return !1;
    }
    return !0;
  }), shams$1;
}
var shams, hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var c = requireShams$1();
  return shams = function() {
    return c() && !!Symbol.toStringTag;
  }, shams;
}
var esErrors, hasRequiredEsErrors;
function requireEsErrors() {
  return hasRequiredEsErrors || (hasRequiredEsErrors = 1, esErrors = Error), esErrors;
}
var _eval, hasRequired_eval;
function require_eval() {
  return hasRequired_eval || (hasRequired_eval = 1, _eval = EvalError), _eval;
}
var range, hasRequiredRange;
function requireRange() {
  return hasRequiredRange || (hasRequiredRange = 1, range = RangeError), range;
}
var ref, hasRequiredRef;
function requireRef() {
  return hasRequiredRef || (hasRequiredRef = 1, ref = ReferenceError), ref;
}
var syntax, hasRequiredSyntax;
function requireSyntax() {
  return hasRequiredSyntax || (hasRequiredSyntax = 1, syntax = SyntaxError), syntax;
}
var type, hasRequiredType;
function requireType() {
  return hasRequiredType || (hasRequiredType = 1, type = TypeError), type;
}
var uri, hasRequiredUri;
function requireUri() {
  return hasRequiredUri || (hasRequiredUri = 1, uri = URIError), uri;
}
var hasSymbols, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var c = typeof Symbol < "u" && Symbol, t = requireShams$1();
  return hasSymbols = function() {
    return typeof c != "function" || typeof Symbol != "function" || typeof c("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, hasSymbols;
}
var hasProto, hasRequiredHasProto;
function requireHasProto() {
  if (hasRequiredHasProto) return hasProto;
  hasRequiredHasProto = 1;
  var c = {
    __proto__: null,
    foo: {}
  }, t = Object;
  return hasProto = function() {
    return { __proto__: c }.foo === c.foo && !(c instanceof t);
  }, hasProto;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation;
  hasRequiredImplementation = 1;
  var c = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, ie = "[object Function]", fe = function(me, ye) {
    for (var be = [], Ae = 0; Ae < me.length; Ae += 1)
      be[Ae] = me[Ae];
    for (var Se = 0; Se < ye.length; Se += 1)
      be[Se + me.length] = ye[Se];
    return be;
  }, ae = function(me, ye) {
    for (var be = [], Ae = ye, Se = 0; Ae < me.length; Ae += 1, Se += 1)
      be[Se] = me[Ae];
    return be;
  }, le = function(he, me) {
    for (var ye = "", be = 0; be < he.length; be += 1)
      ye += he[be], be + 1 < he.length && (ye += me);
    return ye;
  };
  return implementation = function(me) {
    var ye = this;
    if (typeof ye != "function" || t.apply(ye) !== ie)
      throw new TypeError(c + ye);
    for (var be = ae(arguments, 1), Ae, Se = function() {
      if (this instanceof Ae) {
        var Te = ye.apply(
          this,
          fe(be, arguments)
        );
        return Object(Te) === Te ? Te : this;
      }
      return ye.apply(
        me,
        fe(be, arguments)
      );
    }, $e = n(0, ye.length - be.length), Re = [], Me = 0; Me < $e; Me++)
      Re[Me] = "$" + Me;
    if (Ae = Function("binder", "return function (" + le(Re, ",") + "){ return binder.apply(this,arguments); }")(Se), ye.prototype) {
      var ke = function() {
      };
      ke.prototype = ye.prototype, Ae.prototype = new ke(), ke.prototype = null;
    }
    return Ae;
  }, implementation;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var c = requireImplementation();
  return functionBind = Function.prototype.bind || c, functionBind;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var c = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = requireFunctionBind();
  return hasown = n.call(c, t), hasown;
}
var getIntrinsic, hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var c, t = requireEsErrors(), n = require_eval(), ie = requireRange(), fe = requireRef(), ae = requireSyntax(), le = requireType(), he = requireUri(), me = Function, ye = function(we) {
    try {
      return me('"use strict"; return (' + we + ").constructor;")();
    } catch {
    }
  }, be = Object.getOwnPropertyDescriptor;
  if (be)
    try {
      be({}, "");
    } catch {
      be = null;
    }
  var Ae = function() {
    throw new le();
  }, Se = be ? function() {
    try {
      return arguments.callee, Ae;
    } catch {
      try {
        return be(arguments, "callee").get;
      } catch {
        return Ae;
      }
    }
  }() : Ae, $e = requireHasSymbols()(), Re = requireHasProto()(), Me = Object.getPrototypeOf || (Re ? function(we) {
    return we.__proto__;
  } : null), ke = {}, Te = typeof Uint8Array > "u" || !Me ? c : Me(Uint8Array), Ie = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? c : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? c : ArrayBuffer,
    "%ArrayIteratorPrototype%": $e && Me ? Me([][Symbol.iterator]()) : c,
    "%AsyncFromSyncIteratorPrototype%": c,
    "%AsyncFunction%": ke,
    "%AsyncGenerator%": ke,
    "%AsyncGeneratorFunction%": ke,
    "%AsyncIteratorPrototype%": ke,
    "%Atomics%": typeof Atomics > "u" ? c : Atomics,
    "%BigInt%": typeof BigInt > "u" ? c : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? c : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? c : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? c : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? c : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? c : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? c : FinalizationRegistry,
    "%Function%": me,
    "%GeneratorFunction%": ke,
    "%Int8Array%": typeof Int8Array > "u" ? c : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? c : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? c : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $e && Me ? Me(Me([][Symbol.iterator]())) : c,
    "%JSON%": typeof JSON == "object" ? JSON : c,
    "%Map%": typeof Map > "u" ? c : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !$e || !Me ? c : Me((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? c : Promise,
    "%Proxy%": typeof Proxy > "u" ? c : Proxy,
    "%RangeError%": ie,
    "%ReferenceError%": fe,
    "%Reflect%": typeof Reflect > "u" ? c : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? c : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !$e || !Me ? c : Me((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? c : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $e && Me ? Me(""[Symbol.iterator]()) : c,
    "%Symbol%": $e ? Symbol : c,
    "%SyntaxError%": ae,
    "%ThrowTypeError%": Se,
    "%TypedArray%": Te,
    "%TypeError%": le,
    "%Uint8Array%": typeof Uint8Array > "u" ? c : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? c : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? c : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? c : Uint32Array,
    "%URIError%": he,
    "%WeakMap%": typeof WeakMap > "u" ? c : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? c : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? c : WeakSet
  };
  if (Me)
    try {
      null.error;
    } catch (we) {
      var qe = Me(Me(we));
      Ie["%Error.prototype%"] = qe;
    }
  var Ue = function we(Ee) {
    var xe;
    if (Ee === "%AsyncFunction%")
      xe = ye("async function () {}");
    else if (Ee === "%GeneratorFunction%")
      xe = ye("function* () {}");
    else if (Ee === "%AsyncGeneratorFunction%")
      xe = ye("async function* () {}");
    else if (Ee === "%AsyncGenerator%") {
      var ue = we("%AsyncGeneratorFunction%");
      ue && (xe = ue.prototype);
    } else if (Ee === "%AsyncIteratorPrototype%") {
      var ge = we("%AsyncGenerator%");
      ge && Me && (xe = Me(ge.prototype));
    }
    return Ie[Ee] = xe, xe;
  }, ze = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Ve = requireFunctionBind(), Mt = requireHasown(), Rt = Ve.call(Function.call, Array.prototype.concat), je = Ve.call(Function.apply, Array.prototype.splice), jt = Ve.call(Function.call, String.prototype.replace), _e = Ve.call(Function.call, String.prototype.slice), se = Ve.call(Function.call, RegExp.prototype.exec), ce = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, de = /\\(\\)?/g, pe = function(Ee) {
    var xe = _e(Ee, 0, 1), ue = _e(Ee, -1);
    if (xe === "%" && ue !== "%")
      throw new ae("invalid intrinsic syntax, expected closing `%`");
    if (ue === "%" && xe !== "%")
      throw new ae("invalid intrinsic syntax, expected opening `%`");
    var ge = [];
    return jt(Ee, ce, function(Be, Ne, Fe, Pe) {
      ge[ge.length] = Fe ? jt(Pe, de, "$1") : Ne || Be;
    }), ge;
  }, ve = function(Ee, xe) {
    var ue = Ee, ge;
    if (Mt(ze, ue) && (ge = ze[ue], ue = "%" + ge[0] + "%"), Mt(Ie, ue)) {
      var Be = Ie[ue];
      if (Be === ke && (Be = Ue(ue)), typeof Be > "u" && !xe)
        throw new le("intrinsic " + Ee + " exists, but is not available. Please file an issue!");
      return {
        alias: ge,
        name: ue,
        value: Be
      };
    }
    throw new ae("intrinsic " + Ee + " does not exist!");
  };
  return getIntrinsic = function(Ee, xe) {
    if (typeof Ee != "string" || Ee.length === 0)
      throw new le("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof xe != "boolean")
      throw new le('"allowMissing" argument must be a boolean');
    if (se(/^%?[^%]*%?$/, Ee) === null)
      throw new ae("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var ue = pe(Ee), ge = ue.length > 0 ? ue[0] : "", Be = ve("%" + ge + "%", xe), Ne = Be.name, Fe = Be.value, Pe = !1, Je = Be.alias;
    Je && (ge = Je[0], je(ue, Rt([0, 1], Je)));
    for (var Ke = 1, Ze = !0; Ke < ue.length; Ke += 1) {
      var Ye = ue[Ke], Pt = _e(Ye, 0, 1), Ft = _e(Ye, -1);
      if ((Pt === '"' || Pt === "'" || Pt === "`" || Ft === '"' || Ft === "'" || Ft === "`") && Pt !== Ft)
        throw new ae("property names with quotes must have matching quotes");
      if ((Ye === "constructor" || !Ze) && (Pe = !0), ge += "." + Ye, Ne = "%" + ge + "%", Mt(Ie, Ne))
        Fe = Ie[Ne];
      else if (Fe != null) {
        if (!(Ye in Fe)) {
          if (!xe)
            throw new le("base intrinsic for " + Ee + " exists, but the property is not available.");
          return;
        }
        if (be && Ke + 1 >= ue.length) {
          var Le = be(Fe, Ye);
          Ze = !!Le, Ze && "get" in Le && !("originalValue" in Le.get) ? Fe = Le.get : Fe = Fe[Ye];
        } else
          Ze = Mt(Fe, Ye), Fe = Fe[Ye];
        Ze && !Pe && (Ie[Ne] = Fe);
      }
    }
    return Fe;
  }, getIntrinsic;
}
var callBind = { exports: {} }, esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var c = requireGetIntrinsic(), t = c("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return esDefineProperty = t, esDefineProperty;
}
var gopd, hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var c = requireGetIntrinsic(), t = c("%Object.getOwnPropertyDescriptor%", !0);
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return gopd = t, gopd;
}
var defineDataProperty, hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var c = requireEsDefineProperty(), t = requireSyntax(), n = requireType(), ie = requireGopd();
  return defineDataProperty = function(ae, le, he) {
    if (!ae || typeof ae != "object" && typeof ae != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof le != "string" && typeof le != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var me = arguments.length > 3 ? arguments[3] : null, ye = arguments.length > 4 ? arguments[4] : null, be = arguments.length > 5 ? arguments[5] : null, Ae = arguments.length > 6 ? arguments[6] : !1, Se = !!ie && ie(ae, le);
    if (c)
      c(ae, le, {
        configurable: be === null && Se ? Se.configurable : !be,
        enumerable: me === null && Se ? Se.enumerable : !me,
        value: he,
        writable: ye === null && Se ? Se.writable : !ye
      });
    else if (Ae || !me && !ye && !be)
      ae[le] = he;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, defineDataProperty;
}
var hasPropertyDescriptors_1, hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var c = requireEsDefineProperty(), t = function() {
    return !!c;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!c)
      return null;
    try {
      return c([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, hasPropertyDescriptors_1 = t, hasPropertyDescriptors_1;
}
var setFunctionLength, hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var c = requireGetIntrinsic(), t = requireDefineDataProperty(), n = requireHasPropertyDescriptors()(), ie = requireGopd(), fe = requireType(), ae = c("%Math.floor%");
  return setFunctionLength = function(he, me) {
    if (typeof he != "function")
      throw new fe("`fn` is not a function");
    if (typeof me != "number" || me < 0 || me > 4294967295 || ae(me) !== me)
      throw new fe("`length` must be a positive 32-bit integer");
    var ye = arguments.length > 2 && !!arguments[2], be = !0, Ae = !0;
    if ("length" in he && ie) {
      var Se = ie(he, "length");
      Se && !Se.configurable && (be = !1), Se && !Se.writable && (Ae = !1);
    }
    return (be || Ae || !ye) && (n ? t(
      /** @type {Parameters<define>[0]} */
      he,
      "length",
      me,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      he,
      "length",
      me
    )), he;
  }, setFunctionLength;
}
var hasRequiredCallBind;
function requireCallBind() {
  return hasRequiredCallBind || (hasRequiredCallBind = 1, function(c) {
    var t = requireFunctionBind(), n = requireGetIntrinsic(), ie = requireSetFunctionLength(), fe = requireType(), ae = n("%Function.prototype.apply%"), le = n("%Function.prototype.call%"), he = n("%Reflect.apply%", !0) || t.call(le, ae), me = requireEsDefineProperty(), ye = n("%Math.max%");
    c.exports = function(Se) {
      if (typeof Se != "function")
        throw new fe("a function is required");
      var $e = he(t, le, arguments);
      return ie(
        $e,
        1 + ye(0, Se.length - (arguments.length - 1)),
        !0
      );
    };
    var be = function() {
      return he(t, ae, arguments);
    };
    me ? me(c.exports, "apply", { value: be }) : c.exports.apply = be;
  }(callBind)), callBind.exports;
}
var callBound, hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var c = requireGetIntrinsic(), t = requireCallBind(), n = t(c("String.prototype.indexOf"));
  return callBound = function(fe, ae) {
    var le = c(fe, !!ae);
    return typeof le == "function" && n(fe, ".prototype.") > -1 ? t(le) : le;
  }, callBound;
}
var isArguments, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments;
  hasRequiredIsArguments = 1;
  var c = requireShams()(), t = requireCallBound(), n = t("Object.prototype.toString"), ie = function(he) {
    return c && he && typeof he == "object" && Symbol.toStringTag in he ? !1 : n(he) === "[object Arguments]";
  }, fe = function(he) {
    return ie(he) ? !0 : he !== null && typeof he == "object" && typeof he.length == "number" && he.length >= 0 && n(he) !== "[object Array]" && n(he.callee) === "[object Function]";
  }, ae = function() {
    return ie(arguments);
  }();
  return ie.isLegacyArguments = fe, isArguments = ae ? ie : fe, isArguments;
}
var isGeneratorFunction, hasRequiredIsGeneratorFunction;
function requireIsGeneratorFunction() {
  if (hasRequiredIsGeneratorFunction) return isGeneratorFunction;
  hasRequiredIsGeneratorFunction = 1;
  var c = Object.prototype.toString, t = Function.prototype.toString, n = /^\s*(?:function)?\*/, ie = requireShams()(), fe = Object.getPrototypeOf, ae = function() {
    if (!ie)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, le;
  return isGeneratorFunction = function(me) {
    if (typeof me != "function")
      return !1;
    if (n.test(t.call(me)))
      return !0;
    if (!ie) {
      var ye = c.call(me);
      return ye === "[object GeneratorFunction]";
    }
    if (!fe)
      return !1;
    if (typeof le > "u") {
      var be = ae();
      le = be ? fe(be) : !1;
    }
    return fe(me) === le;
  }, isGeneratorFunction;
}
var isCallable, hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return isCallable;
  hasRequiredIsCallable = 1;
  var c = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, ie;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw ie;
        }
      }), ie = {}, t(function() {
        throw 42;
      }, null, n);
    } catch (Ie) {
      Ie !== ie && (t = null);
    }
  else
    t = null;
  var fe = /^\s*class\b/, ae = function(qe) {
    try {
      var Ue = c.call(qe);
      return fe.test(Ue);
    } catch {
      return !1;
    }
  }, le = function(qe) {
    try {
      return ae(qe) ? !1 : (c.call(qe), !0);
    } catch {
      return !1;
    }
  }, he = Object.prototype.toString, me = "[object Object]", ye = "[object Function]", be = "[object GeneratorFunction]", Ae = "[object HTMLAllCollection]", Se = "[object HTML document.all class]", $e = "[object HTMLCollection]", Re = typeof Symbol == "function" && !!Symbol.toStringTag, Me = !(0 in [,]), ke = function() {
    return !1;
  };
  if (typeof document == "object") {
    var Te = document.all;
    he.call(Te) === he.call(document.all) && (ke = function(qe) {
      if ((Me || !qe) && (typeof qe > "u" || typeof qe == "object"))
        try {
          var Ue = he.call(qe);
          return (Ue === Ae || Ue === Se || Ue === $e || Ue === me) && qe("") == null;
        } catch {
        }
      return !1;
    });
  }
  return isCallable = t ? function(qe) {
    if (ke(qe))
      return !0;
    if (!qe || typeof qe != "function" && typeof qe != "object")
      return !1;
    try {
      t(qe, null, n);
    } catch (Ue) {
      if (Ue !== ie)
        return !1;
    }
    return !ae(qe) && le(qe);
  } : function(qe) {
    if (ke(qe))
      return !0;
    if (!qe || typeof qe != "function" && typeof qe != "object")
      return !1;
    if (Re)
      return le(qe);
    if (ae(qe))
      return !1;
    var Ue = he.call(qe);
    return Ue !== ye && Ue !== be && !/^\[object HTML/.test(Ue) ? !1 : le(qe);
  }, isCallable;
}
var forEach_1, hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach) return forEach_1;
  hasRequiredForEach = 1;
  var c = requireIsCallable(), t = Object.prototype.toString, n = Object.prototype.hasOwnProperty, ie = function(me, ye, be) {
    for (var Ae = 0, Se = me.length; Ae < Se; Ae++)
      n.call(me, Ae) && (be == null ? ye(me[Ae], Ae, me) : ye.call(be, me[Ae], Ae, me));
  }, fe = function(me, ye, be) {
    for (var Ae = 0, Se = me.length; Ae < Se; Ae++)
      be == null ? ye(me.charAt(Ae), Ae, me) : ye.call(be, me.charAt(Ae), Ae, me);
  }, ae = function(me, ye, be) {
    for (var Ae in me)
      n.call(me, Ae) && (be == null ? ye(me[Ae], Ae, me) : ye.call(be, me[Ae], Ae, me));
  }, le = function(me, ye, be) {
    if (!c(ye))
      throw new TypeError("iterator must be a function");
    var Ae;
    arguments.length >= 3 && (Ae = be), t.call(me) === "[object Array]" ? ie(me, ye, Ae) : typeof me == "string" ? fe(me, ye, Ae) : ae(me, ye, Ae);
  };
  return forEach_1 = le, forEach_1;
}
var possibleTypedArrayNames, hasRequiredPossibleTypedArrayNames;
function requirePossibleTypedArrayNames() {
  return hasRequiredPossibleTypedArrayNames || (hasRequiredPossibleTypedArrayNames = 1, possibleTypedArrayNames = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), possibleTypedArrayNames;
}
var availableTypedArrays, hasRequiredAvailableTypedArrays;
function requireAvailableTypedArrays() {
  if (hasRequiredAvailableTypedArrays) return availableTypedArrays;
  hasRequiredAvailableTypedArrays = 1;
  var c = requirePossibleTypedArrayNames(), t = globalThis;
  return availableTypedArrays = function() {
    for (var ie = [], fe = 0; fe < c.length; fe++)
      typeof t[c[fe]] == "function" && (ie[ie.length] = c[fe]);
    return ie;
  }, availableTypedArrays;
}
var whichTypedArray, hasRequiredWhichTypedArray;
function requireWhichTypedArray() {
  if (hasRequiredWhichTypedArray) return whichTypedArray;
  hasRequiredWhichTypedArray = 1;
  var c = requireForEach(), t = requireAvailableTypedArrays(), n = requireCallBind(), ie = requireCallBound(), fe = requireGopd(), ae = ie("Object.prototype.toString"), le = requireShams()(), he = globalThis, me = t(), ye = ie("String.prototype.slice"), be = Object.getPrototypeOf, Ae = ie("Array.prototype.indexOf", !0) || function(ke, Te) {
    for (var Ie = 0; Ie < ke.length; Ie += 1)
      if (ke[Ie] === Te)
        return Ie;
    return -1;
  }, Se = { __proto__: null };
  le && fe && be ? c(me, function(Me) {
    var ke = new he[Me]();
    if (Symbol.toStringTag in ke) {
      var Te = be(ke), Ie = fe(Te, Symbol.toStringTag);
      if (!Ie) {
        var qe = be(Te);
        Ie = fe(qe, Symbol.toStringTag);
      }
      Se["$" + Me] = n(Ie.get);
    }
  }) : c(me, function(Me) {
    var ke = new he[Me](), Te = ke.slice || ke.set;
    Te && (Se["$" + Me] = n(Te));
  });
  var $e = function(ke) {
    var Te = !1;
    return c(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      Se,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(Ie, qe) {
        if (!Te)
          try {
            "$" + Ie(ke) === qe && (Te = ye(qe, 1));
          } catch {
          }
      }
    ), Te;
  }, Re = function(ke) {
    var Te = !1;
    return c(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      Se,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(Ie, qe) {
        if (!Te)
          try {
            Ie(ke), Te = ye(qe, 1);
          } catch {
          }
      }
    ), Te;
  };
  return whichTypedArray = function(ke) {
    if (!ke || typeof ke != "object")
      return !1;
    if (!le) {
      var Te = ye(ae(ke), 8, -1);
      return Ae(me, Te) > -1 ? Te : Te !== "Object" ? !1 : Re(ke);
    }
    return fe ? $e(ke) : null;
  }, whichTypedArray;
}
var isTypedArray, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray;
  hasRequiredIsTypedArray = 1;
  var c = requireWhichTypedArray();
  return isTypedArray = function(n) {
    return !!c(n);
  }, isTypedArray;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(c) {
    var t = requireIsArguments(), n = requireIsGeneratorFunction(), ie = requireWhichTypedArray(), fe = requireIsTypedArray();
    function ae(Gt) {
      return Gt.call.bind(Gt);
    }
    var le = typeof BigInt < "u", he = typeof Symbol < "u", me = ae(Object.prototype.toString), ye = ae(Number.prototype.valueOf), be = ae(String.prototype.valueOf), Ae = ae(Boolean.prototype.valueOf);
    if (le)
      var Se = ae(BigInt.prototype.valueOf);
    if (he)
      var $e = ae(Symbol.prototype.valueOf);
    function Re(Gt, An) {
      if (typeof Gt != "object")
        return !1;
      try {
        return An(Gt), !0;
      } catch {
        return !1;
      }
    }
    c.isArgumentsObject = t, c.isGeneratorFunction = n, c.isTypedArray = fe;
    function Me(Gt) {
      return typeof Promise < "u" && Gt instanceof Promise || Gt !== null && typeof Gt == "object" && typeof Gt.then == "function" && typeof Gt.catch == "function";
    }
    c.isPromise = Me;
    function ke(Gt) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Gt) : fe(Gt) || Ne(Gt);
    }
    c.isArrayBufferView = ke;
    function Te(Gt) {
      return ie(Gt) === "Uint8Array";
    }
    c.isUint8Array = Te;
    function Ie(Gt) {
      return ie(Gt) === "Uint8ClampedArray";
    }
    c.isUint8ClampedArray = Ie;
    function qe(Gt) {
      return ie(Gt) === "Uint16Array";
    }
    c.isUint16Array = qe;
    function Ue(Gt) {
      return ie(Gt) === "Uint32Array";
    }
    c.isUint32Array = Ue;
    function ze(Gt) {
      return ie(Gt) === "Int8Array";
    }
    c.isInt8Array = ze;
    function Ve(Gt) {
      return ie(Gt) === "Int16Array";
    }
    c.isInt16Array = Ve;
    function Mt(Gt) {
      return ie(Gt) === "Int32Array";
    }
    c.isInt32Array = Mt;
    function Rt(Gt) {
      return ie(Gt) === "Float32Array";
    }
    c.isFloat32Array = Rt;
    function je(Gt) {
      return ie(Gt) === "Float64Array";
    }
    c.isFloat64Array = je;
    function jt(Gt) {
      return ie(Gt) === "BigInt64Array";
    }
    c.isBigInt64Array = jt;
    function _e(Gt) {
      return ie(Gt) === "BigUint64Array";
    }
    c.isBigUint64Array = _e;
    function se(Gt) {
      return me(Gt) === "[object Map]";
    }
    se.working = typeof Map < "u" && se(/* @__PURE__ */ new Map());
    function ce(Gt) {
      return typeof Map > "u" ? !1 : se.working ? se(Gt) : Gt instanceof Map;
    }
    c.isMap = ce;
    function de(Gt) {
      return me(Gt) === "[object Set]";
    }
    de.working = typeof Set < "u" && de(/* @__PURE__ */ new Set());
    function pe(Gt) {
      return typeof Set > "u" ? !1 : de.working ? de(Gt) : Gt instanceof Set;
    }
    c.isSet = pe;
    function ve(Gt) {
      return me(Gt) === "[object WeakMap]";
    }
    ve.working = typeof WeakMap < "u" && ve(/* @__PURE__ */ new WeakMap());
    function we(Gt) {
      return typeof WeakMap > "u" ? !1 : ve.working ? ve(Gt) : Gt instanceof WeakMap;
    }
    c.isWeakMap = we;
    function Ee(Gt) {
      return me(Gt) === "[object WeakSet]";
    }
    Ee.working = typeof WeakSet < "u" && Ee(/* @__PURE__ */ new WeakSet());
    function xe(Gt) {
      return Ee(Gt);
    }
    c.isWeakSet = xe;
    function ue(Gt) {
      return me(Gt) === "[object ArrayBuffer]";
    }
    ue.working = typeof ArrayBuffer < "u" && ue(new ArrayBuffer());
    function ge(Gt) {
      return typeof ArrayBuffer > "u" ? !1 : ue.working ? ue(Gt) : Gt instanceof ArrayBuffer;
    }
    c.isArrayBuffer = ge;
    function Be(Gt) {
      return me(Gt) === "[object DataView]";
    }
    Be.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Be(new DataView(new ArrayBuffer(1), 0, 1));
    function Ne(Gt) {
      return typeof DataView > "u" ? !1 : Be.working ? Be(Gt) : Gt instanceof DataView;
    }
    c.isDataView = Ne;
    var Fe = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function Pe(Gt) {
      return me(Gt) === "[object SharedArrayBuffer]";
    }
    function Je(Gt) {
      return typeof Fe > "u" ? !1 : (typeof Pe.working > "u" && (Pe.working = Pe(new Fe())), Pe.working ? Pe(Gt) : Gt instanceof Fe);
    }
    c.isSharedArrayBuffer = Je;
    function Ke(Gt) {
      return me(Gt) === "[object AsyncFunction]";
    }
    c.isAsyncFunction = Ke;
    function Ze(Gt) {
      return me(Gt) === "[object Map Iterator]";
    }
    c.isMapIterator = Ze;
    function Ye(Gt) {
      return me(Gt) === "[object Set Iterator]";
    }
    c.isSetIterator = Ye;
    function Pt(Gt) {
      return me(Gt) === "[object Generator]";
    }
    c.isGeneratorObject = Pt;
    function Ft(Gt) {
      return me(Gt) === "[object WebAssembly.Module]";
    }
    c.isWebAssemblyCompiledModule = Ft;
    function Le(Gt) {
      return Re(Gt, ye);
    }
    c.isNumberObject = Le;
    function $t(Gt) {
      return Re(Gt, be);
    }
    c.isStringObject = $t;
    function Jt(Gt) {
      return Re(Gt, Ae);
    }
    c.isBooleanObject = Jt;
    function Ht(Gt) {
      return le && Re(Gt, Se);
    }
    c.isBigIntObject = Ht;
    function Vt(Gt) {
      return he && Re(Gt, $e);
    }
    c.isSymbolObject = Vt;
    function xn(Gt) {
      return Le(Gt) || $t(Gt) || Jt(Gt) || Ht(Gt) || Vt(Gt);
    }
    c.isBoxedPrimitive = xn;
    function Zt(Gt) {
      return typeof Uint8Array < "u" && (ge(Gt) || Je(Gt));
    }
    c.isAnyArrayBuffer = Zt, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Gt) {
      Object.defineProperty(c, Gt, {
        enumerable: !1,
        value: function() {
          throw new Error(Gt + " is not supported in userland");
        }
      });
    });
  }(types$1)), types$1;
}
var isBufferBrowser, hasRequiredIsBufferBrowser;
function requireIsBufferBrowser() {
  return hasRequiredIsBufferBrowser || (hasRequiredIsBufferBrowser = 1, isBufferBrowser = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), isBufferBrowser;
}
var hasRequiredUtil$1;
function requireUtil$1() {
  return hasRequiredUtil$1 || (hasRequiredUtil$1 = 1, function(c) {
    var t = Object.getOwnPropertyDescriptors || function(Ne) {
      for (var Fe = Object.keys(Ne), Pe = {}, Je = 0; Je < Fe.length; Je++)
        Pe[Fe[Je]] = Object.getOwnPropertyDescriptor(Ne, Fe[Je]);
      return Pe;
    }, n = /%[sdj%]/g;
    c.format = function(Be) {
      if (!ze(Be)) {
        for (var Ne = [], Fe = 0; Fe < arguments.length; Fe++)
          Ne.push(le(arguments[Fe]));
        return Ne.join(" ");
      }
      for (var Fe = 1, Pe = arguments, Je = Pe.length, Ke = String(Be).replace(n, function(Ye) {
        if (Ye === "%%") return "%";
        if (Fe >= Je) return Ye;
        switch (Ye) {
          case "%s":
            return String(Pe[Fe++]);
          case "%d":
            return Number(Pe[Fe++]);
          case "%j":
            try {
              return JSON.stringify(Pe[Fe++]);
            } catch {
              return "[Circular]";
            }
          default:
            return Ye;
        }
      }), Ze = Pe[Fe]; Fe < Je; Ze = Pe[++Fe])
        Ie(Ze) || !je(Ze) ? Ke += " " + Ze : Ke += " " + le(Ze);
      return Ke;
    }, c.deprecate = function(Be, Ne) {
      if (typeof process$1 < "u" && process$1.noDeprecation === !0)
        return Be;
      if (typeof process$1 > "u")
        return function() {
          return c.deprecate(Be, Ne).apply(this, arguments);
        };
      var Fe = !1;
      function Pe() {
        if (!Fe) {
          if (process$1.throwDeprecation)
            throw new Error(Ne);
          process$1.traceDeprecation ? console.trace(Ne) : console.error(Ne), Fe = !0;
        }
        return Be.apply(this, arguments);
      }
      return Pe;
    };
    var ie = {}, fe = /^$/;
    if (process$1.env.NODE_DEBUG) {
      var ae = process$1.env.NODE_DEBUG;
      ae = ae.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), fe = new RegExp("^" + ae + "$", "i");
    }
    c.debuglog = function(Be) {
      if (Be = Be.toUpperCase(), !ie[Be])
        if (fe.test(Be)) {
          var Ne = process$1.pid;
          ie[Be] = function() {
            var Fe = c.format.apply(c, arguments);
            console.error("%s %d: %s", Be, Ne, Fe);
          };
        } else
          ie[Be] = function() {
          };
      return ie[Be];
    };
    function le(Be, Ne) {
      var Fe = {
        seen: [],
        stylize: me
      };
      return arguments.length >= 3 && (Fe.depth = arguments[2]), arguments.length >= 4 && (Fe.colors = arguments[3]), Te(Ne) ? Fe.showHidden = Ne : Ne && c._extend(Fe, Ne), Mt(Fe.showHidden) && (Fe.showHidden = !1), Mt(Fe.depth) && (Fe.depth = 2), Mt(Fe.colors) && (Fe.colors = !1), Mt(Fe.customInspect) && (Fe.customInspect = !0), Fe.colors && (Fe.stylize = he), be(Fe, Be, Fe.depth);
    }
    c.inspect = le, le.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, le.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function he(Be, Ne) {
      var Fe = le.styles[Ne];
      return Fe ? "\x1B[" + le.colors[Fe][0] + "m" + Be + "\x1B[" + le.colors[Fe][1] + "m" : Be;
    }
    function me(Be, Ne) {
      return Be;
    }
    function ye(Be) {
      var Ne = {};
      return Be.forEach(function(Fe, Pe) {
        Ne[Fe] = !0;
      }), Ne;
    }
    function be(Be, Ne, Fe) {
      if (Be.customInspect && Ne && se(Ne.inspect) && // Filter out the util module, it's inspect function is special
      Ne.inspect !== c.inspect && // Also filter out any prototype objects using the circular check.
      !(Ne.constructor && Ne.constructor.prototype === Ne)) {
        var Pe = Ne.inspect(Fe, Be);
        return ze(Pe) || (Pe = be(Be, Pe, Fe)), Pe;
      }
      var Je = Ae(Be, Ne);
      if (Je)
        return Je;
      var Ke = Object.keys(Ne), Ze = ye(Ke);
      if (Be.showHidden && (Ke = Object.getOwnPropertyNames(Ne)), _e(Ne) && (Ke.indexOf("message") >= 0 || Ke.indexOf("description") >= 0))
        return Se(Ne);
      if (Ke.length === 0) {
        if (se(Ne)) {
          var Ye = Ne.name ? ": " + Ne.name : "";
          return Be.stylize("[Function" + Ye + "]", "special");
        }
        if (Rt(Ne))
          return Be.stylize(RegExp.prototype.toString.call(Ne), "regexp");
        if (jt(Ne))
          return Be.stylize(Date.prototype.toString.call(Ne), "date");
        if (_e(Ne))
          return Se(Ne);
      }
      var Pt = "", Ft = !1, Le = ["{", "}"];
      if (ke(Ne) && (Ft = !0, Le = ["[", "]"]), se(Ne)) {
        var $t = Ne.name ? ": " + Ne.name : "";
        Pt = " [Function" + $t + "]";
      }
      if (Rt(Ne) && (Pt = " " + RegExp.prototype.toString.call(Ne)), jt(Ne) && (Pt = " " + Date.prototype.toUTCString.call(Ne)), _e(Ne) && (Pt = " " + Se(Ne)), Ke.length === 0 && (!Ft || Ne.length == 0))
        return Le[0] + Pt + Le[1];
      if (Fe < 0)
        return Rt(Ne) ? Be.stylize(RegExp.prototype.toString.call(Ne), "regexp") : Be.stylize("[Object]", "special");
      Be.seen.push(Ne);
      var Jt;
      return Ft ? Jt = $e(Be, Ne, Fe, Ze, Ke) : Jt = Ke.map(function(Ht) {
        return Re(Be, Ne, Fe, Ze, Ht, Ft);
      }), Be.seen.pop(), Me(Jt, Pt, Le);
    }
    function Ae(Be, Ne) {
      if (Mt(Ne))
        return Be.stylize("undefined", "undefined");
      if (ze(Ne)) {
        var Fe = "'" + JSON.stringify(Ne).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return Be.stylize(Fe, "string");
      }
      if (Ue(Ne))
        return Be.stylize("" + Ne, "number");
      if (Te(Ne))
        return Be.stylize("" + Ne, "boolean");
      if (Ie(Ne))
        return Be.stylize("null", "null");
    }
    function Se(Be) {
      return "[" + Error.prototype.toString.call(Be) + "]";
    }
    function $e(Be, Ne, Fe, Pe, Je) {
      for (var Ke = [], Ze = 0, Ye = Ne.length; Ze < Ye; ++Ze)
        Ee(Ne, String(Ze)) ? Ke.push(Re(
          Be,
          Ne,
          Fe,
          Pe,
          String(Ze),
          !0
        )) : Ke.push("");
      return Je.forEach(function(Pt) {
        Pt.match(/^\d+$/) || Ke.push(Re(
          Be,
          Ne,
          Fe,
          Pe,
          Pt,
          !0
        ));
      }), Ke;
    }
    function Re(Be, Ne, Fe, Pe, Je, Ke) {
      var Ze, Ye, Pt;
      if (Pt = Object.getOwnPropertyDescriptor(Ne, Je) || { value: Ne[Je] }, Pt.get ? Pt.set ? Ye = Be.stylize("[Getter/Setter]", "special") : Ye = Be.stylize("[Getter]", "special") : Pt.set && (Ye = Be.stylize("[Setter]", "special")), Ee(Pe, Je) || (Ze = "[" + Je + "]"), Ye || (Be.seen.indexOf(Pt.value) < 0 ? (Ie(Fe) ? Ye = be(Be, Pt.value, null) : Ye = be(Be, Pt.value, Fe - 1), Ye.indexOf(`
`) > -1 && (Ke ? Ye = Ye.split(`
`).map(function(Ft) {
        return "  " + Ft;
      }).join(`
`).slice(2) : Ye = `
` + Ye.split(`
`).map(function(Ft) {
        return "   " + Ft;
      }).join(`
`))) : Ye = Be.stylize("[Circular]", "special")), Mt(Ze)) {
        if (Ke && Je.match(/^\d+$/))
          return Ye;
        Ze = JSON.stringify("" + Je), Ze.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Ze = Ze.slice(1, -1), Ze = Be.stylize(Ze, "name")) : (Ze = Ze.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Ze = Be.stylize(Ze, "string"));
      }
      return Ze + ": " + Ye;
    }
    function Me(Be, Ne, Fe) {
      var Pe = Be.reduce(function(Je, Ke) {
        return Ke.indexOf(`
`) >= 0, Je + Ke.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return Pe > 60 ? Fe[0] + (Ne === "" ? "" : Ne + `
 `) + " " + Be.join(`,
  `) + " " + Fe[1] : Fe[0] + Ne + " " + Be.join(", ") + " " + Fe[1];
    }
    c.types = requireTypes();
    function ke(Be) {
      return Array.isArray(Be);
    }
    c.isArray = ke;
    function Te(Be) {
      return typeof Be == "boolean";
    }
    c.isBoolean = Te;
    function Ie(Be) {
      return Be === null;
    }
    c.isNull = Ie;
    function qe(Be) {
      return Be == null;
    }
    c.isNullOrUndefined = qe;
    function Ue(Be) {
      return typeof Be == "number";
    }
    c.isNumber = Ue;
    function ze(Be) {
      return typeof Be == "string";
    }
    c.isString = ze;
    function Ve(Be) {
      return typeof Be == "symbol";
    }
    c.isSymbol = Ve;
    function Mt(Be) {
      return Be === void 0;
    }
    c.isUndefined = Mt;
    function Rt(Be) {
      return je(Be) && de(Be) === "[object RegExp]";
    }
    c.isRegExp = Rt, c.types.isRegExp = Rt;
    function je(Be) {
      return typeof Be == "object" && Be !== null;
    }
    c.isObject = je;
    function jt(Be) {
      return je(Be) && de(Be) === "[object Date]";
    }
    c.isDate = jt, c.types.isDate = jt;
    function _e(Be) {
      return je(Be) && (de(Be) === "[object Error]" || Be instanceof Error);
    }
    c.isError = _e, c.types.isNativeError = _e;
    function se(Be) {
      return typeof Be == "function";
    }
    c.isFunction = se;
    function ce(Be) {
      return Be === null || typeof Be == "boolean" || typeof Be == "number" || typeof Be == "string" || typeof Be == "symbol" || // ES6 symbol
      typeof Be > "u";
    }
    c.isPrimitive = ce, c.isBuffer = requireIsBufferBrowser();
    function de(Be) {
      return Object.prototype.toString.call(Be);
    }
    function pe(Be) {
      return Be < 10 ? "0" + Be.toString(10) : Be.toString(10);
    }
    var ve = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function we() {
      var Be = /* @__PURE__ */ new Date(), Ne = [
        pe(Be.getHours()),
        pe(Be.getMinutes()),
        pe(Be.getSeconds())
      ].join(":");
      return [Be.getDate(), ve[Be.getMonth()], Ne].join(" ");
    }
    c.log = function() {
      console.log("%s - %s", we(), c.format.apply(c, arguments));
    }, c.inherits = inherits_browserExports, c._extend = function(Be, Ne) {
      if (!Ne || !je(Ne)) return Be;
      for (var Fe = Object.keys(Ne), Pe = Fe.length; Pe--; )
        Be[Fe[Pe]] = Ne[Fe[Pe]];
      return Be;
    };
    function Ee(Be, Ne) {
      return Object.prototype.hasOwnProperty.call(Be, Ne);
    }
    var xe = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    c.promisify = function(Ne) {
      if (typeof Ne != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (xe && Ne[xe]) {
        var Fe = Ne[xe];
        if (typeof Fe != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(Fe, xe, {
          value: Fe,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Fe;
      }
      function Fe() {
        for (var Pe, Je, Ke = new Promise(function(Pt, Ft) {
          Pe = Pt, Je = Ft;
        }), Ze = [], Ye = 0; Ye < arguments.length; Ye++)
          Ze.push(arguments[Ye]);
        Ze.push(function(Pt, Ft) {
          Pt ? Je(Pt) : Pe(Ft);
        });
        try {
          Ne.apply(this, Ze);
        } catch (Pt) {
          Je(Pt);
        }
        return Ke;
      }
      return Object.setPrototypeOf(Fe, Object.getPrototypeOf(Ne)), xe && Object.defineProperty(Fe, xe, {
        value: Fe,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        Fe,
        t(Ne)
      );
    }, c.promisify.custom = xe;
    function ue(Be, Ne) {
      if (!Be) {
        var Fe = new Error("Promise was rejected with a falsy value");
        Fe.reason = Be, Be = Fe;
      }
      return Ne(Be);
    }
    function ge(Be) {
      if (typeof Be != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function Ne() {
        for (var Fe = [], Pe = 0; Pe < arguments.length; Pe++)
          Fe.push(arguments[Pe]);
        var Je = Fe.pop();
        if (typeof Je != "function")
          throw new TypeError("The last argument must be of type Function");
        var Ke = this, Ze = function() {
          return Je.apply(Ke, arguments);
        };
        Be.apply(this, Fe).then(
          function(Ye) {
            process$1.nextTick(Ze.bind(null, null, Ye));
          },
          function(Ye) {
            process$1.nextTick(ue.bind(null, Ye, Ze));
          }
        );
      }
      return Object.setPrototypeOf(Ne, Object.getPrototypeOf(Be)), Object.defineProperties(
        Ne,
        t(Be)
      ), Ne;
    }
    c.callbackify = ge;
  }(util$1)), util$1;
}
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function c(Re, Me) {
    var ke = Object.keys(Re);
    if (Object.getOwnPropertySymbols) {
      var Te = Object.getOwnPropertySymbols(Re);
      Me && (Te = Te.filter(function(Ie) {
        return Object.getOwnPropertyDescriptor(Re, Ie).enumerable;
      })), ke.push.apply(ke, Te);
    }
    return ke;
  }
  function t(Re) {
    for (var Me = 1; Me < arguments.length; Me++) {
      var ke = arguments[Me] != null ? arguments[Me] : {};
      Me % 2 ? c(Object(ke), !0).forEach(function(Te) {
        n(Re, Te, ke[Te]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Re, Object.getOwnPropertyDescriptors(ke)) : c(Object(ke)).forEach(function(Te) {
        Object.defineProperty(Re, Te, Object.getOwnPropertyDescriptor(ke, Te));
      });
    }
    return Re;
  }
  function n(Re, Me, ke) {
    return Me = le(Me), Me in Re ? Object.defineProperty(Re, Me, { value: ke, enumerable: !0, configurable: !0, writable: !0 }) : Re[Me] = ke, Re;
  }
  function ie(Re, Me) {
    if (!(Re instanceof Me))
      throw new TypeError("Cannot call a class as a function");
  }
  function fe(Re, Me) {
    for (var ke = 0; ke < Me.length; ke++) {
      var Te = Me[ke];
      Te.enumerable = Te.enumerable || !1, Te.configurable = !0, "value" in Te && (Te.writable = !0), Object.defineProperty(Re, le(Te.key), Te);
    }
  }
  function ae(Re, Me, ke) {
    return Me && fe(Re.prototype, Me), Object.defineProperty(Re, "prototype", { writable: !1 }), Re;
  }
  function le(Re) {
    var Me = he(Re, "string");
    return typeof Me == "symbol" ? Me : String(Me);
  }
  function he(Re, Me) {
    if (typeof Re != "object" || Re === null) return Re;
    var ke = Re[Symbol.toPrimitive];
    if (ke !== void 0) {
      var Te = ke.call(Re, Me || "default");
      if (typeof Te != "object") return Te;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Me === "string" ? String : Number)(Re);
  }
  var me = require$$0$5, ye = me.Buffer, be = requireUtil$1(), Ae = be.inspect, Se = Ae && Ae.custom || "inspect";
  function $e(Re, Me, ke) {
    ye.prototype.copy.call(Re, Me, ke);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Re() {
      ie(this, Re), this.head = null, this.tail = null, this.length = 0;
    }
    return ae(Re, [{
      key: "push",
      value: function(ke) {
        var Te = {
          data: ke,
          next: null
        };
        this.length > 0 ? this.tail.next = Te : this.head = Te, this.tail = Te, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(ke) {
        var Te = {
          data: ke,
          next: this.head
        };
        this.length === 0 && (this.tail = Te), this.head = Te, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var ke = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ke;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(ke) {
        if (this.length === 0) return "";
        for (var Te = this.head, Ie = "" + Te.data; Te = Te.next; ) Ie += ke + Te.data;
        return Ie;
      }
    }, {
      key: "concat",
      value: function(ke) {
        if (this.length === 0) return ye.alloc(0);
        for (var Te = ye.allocUnsafe(ke >>> 0), Ie = this.head, qe = 0; Ie; )
          $e(Ie.data, Te, qe), qe += Ie.data.length, Ie = Ie.next;
        return Te;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(ke, Te) {
        var Ie;
        return ke < this.head.data.length ? (Ie = this.head.data.slice(0, ke), this.head.data = this.head.data.slice(ke)) : ke === this.head.data.length ? Ie = this.shift() : Ie = Te ? this._getString(ke) : this._getBuffer(ke), Ie;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(ke) {
        var Te = this.head, Ie = 1, qe = Te.data;
        for (ke -= qe.length; Te = Te.next; ) {
          var Ue = Te.data, ze = ke > Ue.length ? Ue.length : ke;
          if (ze === Ue.length ? qe += Ue : qe += Ue.slice(0, ke), ke -= ze, ke === 0) {
            ze === Ue.length ? (++Ie, Te.next ? this.head = Te.next : this.head = this.tail = null) : (this.head = Te, Te.data = Ue.slice(ze));
            break;
          }
          ++Ie;
        }
        return this.length -= Ie, qe;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(ke) {
        var Te = ye.allocUnsafe(ke), Ie = this.head, qe = 1;
        for (Ie.data.copy(Te), ke -= Ie.data.length; Ie = Ie.next; ) {
          var Ue = Ie.data, ze = ke > Ue.length ? Ue.length : ke;
          if (Ue.copy(Te, Te.length - ke, 0, ze), ke -= ze, ke === 0) {
            ze === Ue.length ? (++qe, Ie.next ? this.head = Ie.next : this.head = this.tail = null) : (this.head = Ie, Ie.data = Ue.slice(ze));
            break;
          }
          ++qe;
        }
        return this.length -= qe, Te;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: Se,
      value: function(ke, Te) {
        return Ae(this, t(t({}, Te), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), Re;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1) return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function c(le, he) {
    var me = this, ye = this._readableState && this._readableState.destroyed, be = this._writableState && this._writableState.destroyed;
    return ye || be ? (he ? he(le) : le && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(fe, this, le)) : process$1.nextTick(fe, this, le)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(le || null, function(Ae) {
      !he && Ae ? me._writableState ? me._writableState.errorEmitted ? process$1.nextTick(n, me) : (me._writableState.errorEmitted = !0, process$1.nextTick(t, me, Ae)) : process$1.nextTick(t, me, Ae) : he ? (process$1.nextTick(n, me), he(Ae)) : process$1.nextTick(n, me);
    }), this);
  }
  function t(le, he) {
    fe(le, he), n(le);
  }
  function n(le) {
    le._writableState && !le._writableState.emitClose || le._readableState && !le._readableState.emitClose || le.emit("close");
  }
  function ie() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function fe(le, he) {
    le.emit("error", he);
  }
  function ae(le, he) {
    var me = le._readableState, ye = le._writableState;
    me && me.autoDestroy || ye && ye.autoDestroy ? le.destroy(he) : le.emit("error", he);
  }
  return destroy_1$1 = {
    destroy: c,
    undestroy: ie,
    errorOrDestroy: ae
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser) return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function c(he, me) {
    he.prototype = Object.create(me.prototype), he.prototype.constructor = he, he.__proto__ = me;
  }
  var t = {};
  function n(he, me, ye) {
    ye || (ye = Error);
    function be(Se, $e, Re) {
      return typeof me == "string" ? me : me(Se, $e, Re);
    }
    var Ae = /* @__PURE__ */ function(Se) {
      c($e, Se);
      function $e(Re, Me, ke) {
        return Se.call(this, be(Re, Me, ke)) || this;
      }
      return $e;
    }(ye);
    Ae.prototype.name = ye.name, Ae.prototype.code = he, t[he] = Ae;
  }
  function ie(he, me) {
    if (Array.isArray(he)) {
      var ye = he.length;
      return he = he.map(function(be) {
        return String(be);
      }), ye > 2 ? "one of ".concat(me, " ").concat(he.slice(0, ye - 1).join(", "), ", or ") + he[ye - 1] : ye === 2 ? "one of ".concat(me, " ").concat(he[0], " or ").concat(he[1]) : "of ".concat(me, " ").concat(he[0]);
    } else
      return "of ".concat(me, " ").concat(String(he));
  }
  function fe(he, me, ye) {
    return he.substr(0, me.length) === me;
  }
  function ae(he, me, ye) {
    return (ye === void 0 || ye > he.length) && (ye = he.length), he.substring(ye - me.length, ye) === me;
  }
  function le(he, me, ye) {
    return typeof ye != "number" && (ye = 0), ye + me.length > he.length ? !1 : he.indexOf(me, ye) !== -1;
  }
  return n("ERR_INVALID_OPT_VALUE", function(he, me) {
    return 'The value "' + me + '" is invalid for option "' + he + '"';
  }, TypeError), n("ERR_INVALID_ARG_TYPE", function(he, me, ye) {
    var be;
    typeof me == "string" && fe(me, "not ") ? (be = "must not be", me = me.replace(/^not /, "")) : be = "must be";
    var Ae;
    if (ae(he, " argument"))
      Ae = "The ".concat(he, " ").concat(be, " ").concat(ie(me, "type"));
    else {
      var Se = le(he, ".") ? "property" : "argument";
      Ae = 'The "'.concat(he, '" ').concat(Se, " ").concat(be, " ").concat(ie(me, "type"));
    }
    return Ae += ". Received type ".concat(typeof ye), Ae;
  }, TypeError), n("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), n("ERR_METHOD_NOT_IMPLEMENTED", function(he) {
    return "The " + he + " method is not implemented";
  }), n("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), n("ERR_STREAM_DESTROYED", function(he) {
    return "Cannot call " + he + " after a stream was destroyed";
  }), n("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), n("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), n("ERR_STREAM_WRITE_AFTER_END", "write after end"), n("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), n("ERR_UNKNOWN_ENCODING", function(he) {
    return "Unknown encoding: " + he;
  }, TypeError), n("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = t, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState) return state;
  hasRequiredState = 1;
  var c = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function t(ie, fe, ae) {
    return ie.highWaterMark != null ? ie.highWaterMark : fe ? ie[ae] : null;
  }
  function n(ie, fe, ae, le) {
    var he = t(fe, le, ae);
    if (he != null) {
      if (!(isFinite(he) && Math.floor(he) === he) || he < 0) {
        var me = le ? ae : "highWaterMark";
        throw new c(me, he);
      }
      return Math.floor(he);
    }
    return ie.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: n
  }, state;
}
var browser$a, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a) return browser$a;
  hasRequiredBrowser$a = 1, browser$a = c;
  function c(n, ie) {
    if (t("noDeprecation"))
      return n;
    var fe = !1;
    function ae() {
      if (!fe) {
        if (t("throwDeprecation"))
          throw new Error(ie);
        t("traceDeprecation") ? console.trace(ie) : console.warn(ie), fe = !0;
      }
      return n.apply(this, arguments);
    }
    return ae;
  }
  function t(n) {
    try {
      if (!globalThis.localStorage) return !1;
    } catch {
      return !1;
    }
    var ie = globalThis.localStorage[n];
    return ie == null ? !1 : String(ie).toLowerCase() === "true";
  }
  return browser$a;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = Rt;
  function c(Je) {
    var Ke = this;
    this.next = null, this.entry = null, this.finish = function() {
      Pe(Ke, Je);
    };
  }
  var t;
  Rt.WritableState = Ve;
  var n = {
    deprecate: requireBrowser$a()
  }, ie = requireStreamBrowser$1(), fe = require$$0$5.Buffer, ae = (typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function le(Je) {
    return fe.from(Je);
  }
  function he(Je) {
    return fe.isBuffer(Je) || Je instanceof ae;
  }
  var me = requireDestroy$1(), ye = requireState(), be = ye.getHighWaterMark, Ae = requireErrorsBrowser().codes, Se = Ae.ERR_INVALID_ARG_TYPE, $e = Ae.ERR_METHOD_NOT_IMPLEMENTED, Re = Ae.ERR_MULTIPLE_CALLBACK, Me = Ae.ERR_STREAM_CANNOT_PIPE, ke = Ae.ERR_STREAM_DESTROYED, Te = Ae.ERR_STREAM_NULL_VALUES, Ie = Ae.ERR_STREAM_WRITE_AFTER_END, qe = Ae.ERR_UNKNOWN_ENCODING, Ue = me.errorOrDestroy;
  inherits_browserExports(Rt, ie);
  function ze() {
  }
  function Ve(Je, Ke, Ze) {
    t = t || require_stream_duplex$1(), Je = Je || {}, typeof Ze != "boolean" && (Ze = Ke instanceof t), this.objectMode = !!Je.objectMode, Ze && (this.objectMode = this.objectMode || !!Je.writableObjectMode), this.highWaterMark = be(this, Je, "writableHighWaterMark", Ze), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Ye = Je.decodeStrings === !1;
    this.decodeStrings = !Ye, this.defaultEncoding = Je.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Pt) {
      ve(Ke, Pt);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Je.emitClose !== !1, this.autoDestroy = !!Je.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new c(this);
  }
  Ve.prototype.getBuffer = function() {
    for (var Ke = this.bufferedRequest, Ze = []; Ke; )
      Ze.push(Ke), Ke = Ke.next;
    return Ze;
  }, function() {
    try {
      Object.defineProperty(Ve.prototype, "buffer", {
        get: n.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Mt;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Mt = Function.prototype[Symbol.hasInstance], Object.defineProperty(Rt, Symbol.hasInstance, {
    value: function(Ke) {
      return Mt.call(this, Ke) ? !0 : this !== Rt ? !1 : Ke && Ke._writableState instanceof Ve;
    }
  })) : Mt = function(Ke) {
    return Ke instanceof this;
  };
  function Rt(Je) {
    t = t || require_stream_duplex$1();
    var Ke = this instanceof t;
    if (!Ke && !Mt.call(Rt, this)) return new Rt(Je);
    this._writableState = new Ve(Je, this, Ke), this.writable = !0, Je && (typeof Je.write == "function" && (this._write = Je.write), typeof Je.writev == "function" && (this._writev = Je.writev), typeof Je.destroy == "function" && (this._destroy = Je.destroy), typeof Je.final == "function" && (this._final = Je.final)), ie.call(this);
  }
  Rt.prototype.pipe = function() {
    Ue(this, new Me());
  };
  function je(Je, Ke) {
    var Ze = new Ie();
    Ue(Je, Ze), process$1.nextTick(Ke, Ze);
  }
  function jt(Je, Ke, Ze, Ye) {
    var Pt;
    return Ze === null ? Pt = new Te() : typeof Ze != "string" && !Ke.objectMode && (Pt = new Se("chunk", ["string", "Buffer"], Ze)), Pt ? (Ue(Je, Pt), process$1.nextTick(Ye, Pt), !1) : !0;
  }
  Rt.prototype.write = function(Je, Ke, Ze) {
    var Ye = this._writableState, Pt = !1, Ft = !Ye.objectMode && he(Je);
    return Ft && !fe.isBuffer(Je) && (Je = le(Je)), typeof Ke == "function" && (Ze = Ke, Ke = null), Ft ? Ke = "buffer" : Ke || (Ke = Ye.defaultEncoding), typeof Ze != "function" && (Ze = ze), Ye.ending ? je(this, Ze) : (Ft || jt(this, Ye, Je, Ze)) && (Ye.pendingcb++, Pt = se(this, Ye, Ft, Je, Ke, Ze)), Pt;
  }, Rt.prototype.cork = function() {
    this._writableState.corked++;
  }, Rt.prototype.uncork = function() {
    var Je = this._writableState;
    Je.corked && (Je.corked--, !Je.writing && !Je.corked && !Je.bufferProcessing && Je.bufferedRequest && xe(this, Je));
  }, Rt.prototype.setDefaultEncoding = function(Ke) {
    if (typeof Ke == "string" && (Ke = Ke.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ke + "").toLowerCase()) > -1)) throw new qe(Ke);
    return this._writableState.defaultEncoding = Ke, this;
  }, Object.defineProperty(Rt.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function _e(Je, Ke, Ze) {
    return !Je.objectMode && Je.decodeStrings !== !1 && typeof Ke == "string" && (Ke = fe.from(Ke, Ze)), Ke;
  }
  Object.defineProperty(Rt.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function se(Je, Ke, Ze, Ye, Pt, Ft) {
    if (!Ze) {
      var Le = _e(Ke, Ye, Pt);
      Ye !== Le && (Ze = !0, Pt = "buffer", Ye = Le);
    }
    var $t = Ke.objectMode ? 1 : Ye.length;
    Ke.length += $t;
    var Jt = Ke.length < Ke.highWaterMark;
    if (Jt || (Ke.needDrain = !0), Ke.writing || Ke.corked) {
      var Ht = Ke.lastBufferedRequest;
      Ke.lastBufferedRequest = {
        chunk: Ye,
        encoding: Pt,
        isBuf: Ze,
        callback: Ft,
        next: null
      }, Ht ? Ht.next = Ke.lastBufferedRequest : Ke.bufferedRequest = Ke.lastBufferedRequest, Ke.bufferedRequestCount += 1;
    } else
      ce(Je, Ke, !1, $t, Ye, Pt, Ft);
    return Jt;
  }
  function ce(Je, Ke, Ze, Ye, Pt, Ft, Le) {
    Ke.writelen = Ye, Ke.writecb = Le, Ke.writing = !0, Ke.sync = !0, Ke.destroyed ? Ke.onwrite(new ke("write")) : Ze ? Je._writev(Pt, Ke.onwrite) : Je._write(Pt, Ft, Ke.onwrite), Ke.sync = !1;
  }
  function de(Je, Ke, Ze, Ye, Pt) {
    --Ke.pendingcb, Ze ? (process$1.nextTick(Pt, Ye), process$1.nextTick(Ne, Je, Ke), Je._writableState.errorEmitted = !0, Ue(Je, Ye)) : (Pt(Ye), Je._writableState.errorEmitted = !0, Ue(Je, Ye), Ne(Je, Ke));
  }
  function pe(Je) {
    Je.writing = !1, Je.writecb = null, Je.length -= Je.writelen, Je.writelen = 0;
  }
  function ve(Je, Ke) {
    var Ze = Je._writableState, Ye = Ze.sync, Pt = Ze.writecb;
    if (typeof Pt != "function") throw new Re();
    if (pe(Ze), Ke) de(Je, Ze, Ye, Ke, Pt);
    else {
      var Ft = ue(Ze) || Je.destroyed;
      !Ft && !Ze.corked && !Ze.bufferProcessing && Ze.bufferedRequest && xe(Je, Ze), Ye ? process$1.nextTick(we, Je, Ze, Ft, Pt) : we(Je, Ze, Ft, Pt);
    }
  }
  function we(Je, Ke, Ze, Ye) {
    Ze || Ee(Je, Ke), Ke.pendingcb--, Ye(), Ne(Je, Ke);
  }
  function Ee(Je, Ke) {
    Ke.length === 0 && Ke.needDrain && (Ke.needDrain = !1, Je.emit("drain"));
  }
  function xe(Je, Ke) {
    Ke.bufferProcessing = !0;
    var Ze = Ke.bufferedRequest;
    if (Je._writev && Ze && Ze.next) {
      var Ye = Ke.bufferedRequestCount, Pt = new Array(Ye), Ft = Ke.corkedRequestsFree;
      Ft.entry = Ze;
      for (var Le = 0, $t = !0; Ze; )
        Pt[Le] = Ze, Ze.isBuf || ($t = !1), Ze = Ze.next, Le += 1;
      Pt.allBuffers = $t, ce(Je, Ke, !0, Ke.length, Pt, "", Ft.finish), Ke.pendingcb++, Ke.lastBufferedRequest = null, Ft.next ? (Ke.corkedRequestsFree = Ft.next, Ft.next = null) : Ke.corkedRequestsFree = new c(Ke), Ke.bufferedRequestCount = 0;
    } else {
      for (; Ze; ) {
        var Jt = Ze.chunk, Ht = Ze.encoding, Vt = Ze.callback, xn = Ke.objectMode ? 1 : Jt.length;
        if (ce(Je, Ke, !1, xn, Jt, Ht, Vt), Ze = Ze.next, Ke.bufferedRequestCount--, Ke.writing)
          break;
      }
      Ze === null && (Ke.lastBufferedRequest = null);
    }
    Ke.bufferedRequest = Ze, Ke.bufferProcessing = !1;
  }
  Rt.prototype._write = function(Je, Ke, Ze) {
    Ze(new $e("_write()"));
  }, Rt.prototype._writev = null, Rt.prototype.end = function(Je, Ke, Ze) {
    var Ye = this._writableState;
    return typeof Je == "function" ? (Ze = Je, Je = null, Ke = null) : typeof Ke == "function" && (Ze = Ke, Ke = null), Je != null && this.write(Je, Ke), Ye.corked && (Ye.corked = 1, this.uncork()), Ye.ending || Fe(this, Ye, Ze), this;
  }, Object.defineProperty(Rt.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ue(Je) {
    return Je.ending && Je.length === 0 && Je.bufferedRequest === null && !Je.finished && !Je.writing;
  }
  function ge(Je, Ke) {
    Je._final(function(Ze) {
      Ke.pendingcb--, Ze && Ue(Je, Ze), Ke.prefinished = !0, Je.emit("prefinish"), Ne(Je, Ke);
    });
  }
  function Be(Je, Ke) {
    !Ke.prefinished && !Ke.finalCalled && (typeof Je._final == "function" && !Ke.destroyed ? (Ke.pendingcb++, Ke.finalCalled = !0, process$1.nextTick(ge, Je, Ke)) : (Ke.prefinished = !0, Je.emit("prefinish")));
  }
  function Ne(Je, Ke) {
    var Ze = ue(Ke);
    if (Ze && (Be(Je, Ke), Ke.pendingcb === 0 && (Ke.finished = !0, Je.emit("finish"), Ke.autoDestroy))) {
      var Ye = Je._readableState;
      (!Ye || Ye.autoDestroy && Ye.endEmitted) && Je.destroy();
    }
    return Ze;
  }
  function Fe(Je, Ke, Ze) {
    Ke.ending = !0, Ne(Je, Ke), Ze && (Ke.finished ? process$1.nextTick(Ze) : Je.once("finish", Ze)), Ke.ended = !0, Je.writable = !1;
  }
  function Pe(Je, Ke, Ze) {
    var Ye = Je.entry;
    for (Je.entry = null; Ye; ) {
      var Pt = Ye.callback;
      Ke.pendingcb--, Pt(Ze), Ye = Ye.next;
    }
    Ke.corkedRequestsFree.next = Je;
  }
  return Object.defineProperty(Rt.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(Ke) {
      this._writableState && (this._writableState.destroyed = Ke);
    }
  }), Rt.prototype.destroy = me.destroy, Rt.prototype._undestroy = me.undestroy, Rt.prototype._destroy = function(Je, Ke) {
    Ke(Je);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var c = Object.keys || function(ye) {
    var be = [];
    for (var Ae in ye) be.push(Ae);
    return be;
  };
  _stream_duplex$1 = le;
  var t = require_stream_readable$1(), n = require_stream_writable$1();
  inherits_browserExports(le, t);
  for (var ie = c(n.prototype), fe = 0; fe < ie.length; fe++) {
    var ae = ie[fe];
    le.prototype[ae] || (le.prototype[ae] = n.prototype[ae]);
  }
  function le(ye) {
    if (!(this instanceof le)) return new le(ye);
    t.call(this, ye), n.call(this, ye), this.allowHalfOpen = !0, ye && (ye.readable === !1 && (this.readable = !1), ye.writable === !1 && (this.writable = !1), ye.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", he)));
  }
  Object.defineProperty(le.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(le.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(le.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function he() {
    this._writableState.ended || process$1.nextTick(me, this);
  }
  function me(ye) {
    ye.end();
  }
  return Object.defineProperty(le.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(be) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = be, this._writableState.destroyed = be);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder) return string_decoder;
  hasRequiredString_decoder = 1;
  var c = safeBufferExports.Buffer, t = c.isEncoding || function(Te) {
    switch (Te = "" + Te, Te && Te.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function n(Te) {
    if (!Te) return "utf8";
    for (var Ie; ; )
      switch (Te) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return Te;
        default:
          if (Ie) return;
          Te = ("" + Te).toLowerCase(), Ie = !0;
      }
  }
  function ie(Te) {
    var Ie = n(Te);
    if (typeof Ie != "string" && (c.isEncoding === t || !t(Te))) throw new Error("Unknown encoding: " + Te);
    return Ie || Te;
  }
  string_decoder.StringDecoder = fe;
  function fe(Te) {
    this.encoding = ie(Te);
    var Ie;
    switch (this.encoding) {
      case "utf16le":
        this.text = Ae, this.end = Se, Ie = 4;
        break;
      case "utf8":
        this.fillLast = me, Ie = 4;
        break;
      case "base64":
        this.text = $e, this.end = Re, Ie = 3;
        break;
      default:
        this.write = Me, this.end = ke;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = c.allocUnsafe(Ie);
  }
  fe.prototype.write = function(Te) {
    if (Te.length === 0) return "";
    var Ie, qe;
    if (this.lastNeed) {
      if (Ie = this.fillLast(Te), Ie === void 0) return "";
      qe = this.lastNeed, this.lastNeed = 0;
    } else
      qe = 0;
    return qe < Te.length ? Ie ? Ie + this.text(Te, qe) : this.text(Te, qe) : Ie || "";
  }, fe.prototype.end = be, fe.prototype.text = ye, fe.prototype.fillLast = function(Te) {
    if (this.lastNeed <= Te.length)
      return Te.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Te.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, Te.length), this.lastNeed -= Te.length;
  };
  function ae(Te) {
    return Te <= 127 ? 0 : Te >> 5 === 6 ? 2 : Te >> 4 === 14 ? 3 : Te >> 3 === 30 ? 4 : Te >> 6 === 2 ? -1 : -2;
  }
  function le(Te, Ie, qe) {
    var Ue = Ie.length - 1;
    if (Ue < qe) return 0;
    var ze = ae(Ie[Ue]);
    return ze >= 0 ? (ze > 0 && (Te.lastNeed = ze - 1), ze) : --Ue < qe || ze === -2 ? 0 : (ze = ae(Ie[Ue]), ze >= 0 ? (ze > 0 && (Te.lastNeed = ze - 2), ze) : --Ue < qe || ze === -2 ? 0 : (ze = ae(Ie[Ue]), ze >= 0 ? (ze > 0 && (ze === 2 ? ze = 0 : Te.lastNeed = ze - 3), ze) : 0));
  }
  function he(Te, Ie, qe) {
    if ((Ie[0] & 192) !== 128)
      return Te.lastNeed = 0, "�";
    if (Te.lastNeed > 1 && Ie.length > 1) {
      if ((Ie[1] & 192) !== 128)
        return Te.lastNeed = 1, "�";
      if (Te.lastNeed > 2 && Ie.length > 2 && (Ie[2] & 192) !== 128)
        return Te.lastNeed = 2, "�";
    }
  }
  function me(Te) {
    var Ie = this.lastTotal - this.lastNeed, qe = he(this, Te);
    if (qe !== void 0) return qe;
    if (this.lastNeed <= Te.length)
      return Te.copy(this.lastChar, Ie, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Te.copy(this.lastChar, Ie, 0, Te.length), this.lastNeed -= Te.length;
  }
  function ye(Te, Ie) {
    var qe = le(this, Te, Ie);
    if (!this.lastNeed) return Te.toString("utf8", Ie);
    this.lastTotal = qe;
    var Ue = Te.length - (qe - this.lastNeed);
    return Te.copy(this.lastChar, 0, Ue), Te.toString("utf8", Ie, Ue);
  }
  function be(Te) {
    var Ie = Te && Te.length ? this.write(Te) : "";
    return this.lastNeed ? Ie + "�" : Ie;
  }
  function Ae(Te, Ie) {
    if ((Te.length - Ie) % 2 === 0) {
      var qe = Te.toString("utf16le", Ie);
      if (qe) {
        var Ue = qe.charCodeAt(qe.length - 1);
        if (Ue >= 55296 && Ue <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = Te[Te.length - 2], this.lastChar[1] = Te[Te.length - 1], qe.slice(0, -1);
      }
      return qe;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = Te[Te.length - 1], Te.toString("utf16le", Ie, Te.length - 1);
  }
  function Se(Te) {
    var Ie = Te && Te.length ? this.write(Te) : "";
    if (this.lastNeed) {
      var qe = this.lastTotal - this.lastNeed;
      return Ie + this.lastChar.toString("utf16le", 0, qe);
    }
    return Ie;
  }
  function $e(Te, Ie) {
    var qe = (Te.length - Ie) % 3;
    return qe === 0 ? Te.toString("base64", Ie) : (this.lastNeed = 3 - qe, this.lastTotal = 3, qe === 1 ? this.lastChar[0] = Te[Te.length - 1] : (this.lastChar[0] = Te[Te.length - 2], this.lastChar[1] = Te[Te.length - 1]), Te.toString("base64", Ie, Te.length - qe));
  }
  function Re(Te) {
    var Ie = Te && Te.length ? this.write(Te) : "";
    return this.lastNeed ? Ie + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Ie;
  }
  function Me(Te) {
    return Te.toString(this.encoding);
  }
  function ke(Te) {
    return Te && Te.length ? this.write(Te) : "";
  }
  return string_decoder;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream) return endOfStream;
  hasRequiredEndOfStream = 1;
  var c = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function t(ae) {
    var le = !1;
    return function() {
      if (!le) {
        le = !0;
        for (var he = arguments.length, me = new Array(he), ye = 0; ye < he; ye++)
          me[ye] = arguments[ye];
        ae.apply(this, me);
      }
    };
  }
  function n() {
  }
  function ie(ae) {
    return ae.setHeader && typeof ae.abort == "function";
  }
  function fe(ae, le, he) {
    if (typeof le == "function") return fe(ae, null, le);
    le || (le = {}), he = t(he || n);
    var me = le.readable || le.readable !== !1 && ae.readable, ye = le.writable || le.writable !== !1 && ae.writable, be = function() {
      ae.writable || Se();
    }, Ae = ae._writableState && ae._writableState.finished, Se = function() {
      ye = !1, Ae = !0, me || he.call(ae);
    }, $e = ae._readableState && ae._readableState.endEmitted, Re = function() {
      me = !1, $e = !0, ye || he.call(ae);
    }, Me = function(qe) {
      he.call(ae, qe);
    }, ke = function() {
      var qe;
      if (me && !$e)
        return (!ae._readableState || !ae._readableState.ended) && (qe = new c()), he.call(ae, qe);
      if (ye && !Ae)
        return (!ae._writableState || !ae._writableState.ended) && (qe = new c()), he.call(ae, qe);
    }, Te = function() {
      ae.req.on("finish", Se);
    };
    return ie(ae) ? (ae.on("complete", Se), ae.on("abort", ke), ae.req ? Te() : ae.on("request", Te)) : ye && !ae._writableState && (ae.on("end", be), ae.on("close", be)), ae.on("end", Re), ae.on("finish", Se), le.error !== !1 && ae.on("error", Me), ae.on("close", ke), function() {
      ae.removeListener("complete", Se), ae.removeListener("abort", ke), ae.removeListener("request", Te), ae.req && ae.req.removeListener("finish", Se), ae.removeListener("end", be), ae.removeListener("close", be), ae.removeListener("finish", Se), ae.removeListener("end", Re), ae.removeListener("error", Me), ae.removeListener("close", ke);
    };
  }
  return endOfStream = fe, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var c;
  function t(qe, Ue, ze) {
    return Ue = n(Ue), Ue in qe ? Object.defineProperty(qe, Ue, { value: ze, enumerable: !0, configurable: !0, writable: !0 }) : qe[Ue] = ze, qe;
  }
  function n(qe) {
    var Ue = ie(qe, "string");
    return typeof Ue == "symbol" ? Ue : String(Ue);
  }
  function ie(qe, Ue) {
    if (typeof qe != "object" || qe === null) return qe;
    var ze = qe[Symbol.toPrimitive];
    if (ze !== void 0) {
      var Ve = ze.call(qe, Ue || "default");
      if (typeof Ve != "object") return Ve;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Ue === "string" ? String : Number)(qe);
  }
  var fe = requireEndOfStream(), ae = Symbol("lastResolve"), le = Symbol("lastReject"), he = Symbol("error"), me = Symbol("ended"), ye = Symbol("lastPromise"), be = Symbol("handlePromise"), Ae = Symbol("stream");
  function Se(qe, Ue) {
    return {
      value: qe,
      done: Ue
    };
  }
  function $e(qe) {
    var Ue = qe[ae];
    if (Ue !== null) {
      var ze = qe[Ae].read();
      ze !== null && (qe[ye] = null, qe[ae] = null, qe[le] = null, Ue(Se(ze, !1)));
    }
  }
  function Re(qe) {
    process$1.nextTick($e, qe);
  }
  function Me(qe, Ue) {
    return function(ze, Ve) {
      qe.then(function() {
        if (Ue[me]) {
          ze(Se(void 0, !0));
          return;
        }
        Ue[be](ze, Ve);
      }, Ve);
    };
  }
  var ke = Object.getPrototypeOf(function() {
  }), Te = Object.setPrototypeOf((c = {
    get stream() {
      return this[Ae];
    },
    next: function() {
      var Ue = this, ze = this[he];
      if (ze !== null)
        return Promise.reject(ze);
      if (this[me])
        return Promise.resolve(Se(void 0, !0));
      if (this[Ae].destroyed)
        return new Promise(function(je, jt) {
          process$1.nextTick(function() {
            Ue[he] ? jt(Ue[he]) : je(Se(void 0, !0));
          });
        });
      var Ve = this[ye], Mt;
      if (Ve)
        Mt = new Promise(Me(Ve, this));
      else {
        var Rt = this[Ae].read();
        if (Rt !== null)
          return Promise.resolve(Se(Rt, !1));
        Mt = new Promise(this[be]);
      }
      return this[ye] = Mt, Mt;
    }
  }, t(c, Symbol.asyncIterator, function() {
    return this;
  }), t(c, "return", function() {
    var Ue = this;
    return new Promise(function(ze, Ve) {
      Ue[Ae].destroy(null, function(Mt) {
        if (Mt) {
          Ve(Mt);
          return;
        }
        ze(Se(void 0, !0));
      });
    });
  }), c), ke), Ie = function(Ue) {
    var ze, Ve = Object.create(Te, (ze = {}, t(ze, Ae, {
      value: Ue,
      writable: !0
    }), t(ze, ae, {
      value: null,
      writable: !0
    }), t(ze, le, {
      value: null,
      writable: !0
    }), t(ze, he, {
      value: null,
      writable: !0
    }), t(ze, me, {
      value: Ue._readableState.endEmitted,
      writable: !0
    }), t(ze, be, {
      value: function(Rt, je) {
        var jt = Ve[Ae].read();
        jt ? (Ve[ye] = null, Ve[ae] = null, Ve[le] = null, Rt(Se(jt, !1))) : (Ve[ae] = Rt, Ve[le] = je);
      },
      writable: !0
    }), ze));
    return Ve[ye] = null, fe(Ue, function(Mt) {
      if (Mt && Mt.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Rt = Ve[le];
        Rt !== null && (Ve[ye] = null, Ve[ae] = null, Ve[le] = null, Rt(Mt)), Ve[he] = Mt;
        return;
      }
      var je = Ve[ae];
      je !== null && (Ve[ye] = null, Ve[ae] = null, Ve[le] = null, je(Se(void 0, !0))), Ve[me] = !0;
    }), Ue.on("readable", Re.bind(null, Ve)), Ve;
  };
  return async_iterator = Ie, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = je;
  var c;
  je.ReadableState = Rt, requireEvents().EventEmitter;
  var t = function(Le, $t) {
    return Le.listeners($t).length;
  }, n = requireStreamBrowser$1(), ie = require$$0$5.Buffer, fe = (typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ae(Ft) {
    return ie.from(Ft);
  }
  function le(Ft) {
    return ie.isBuffer(Ft) || Ft instanceof fe;
  }
  var he = requireUtil$1(), me;
  he && he.debuglog ? me = he.debuglog("stream") : me = function() {
  };
  var ye = requireBuffer_list(), be = requireDestroy$1(), Ae = requireState(), Se = Ae.getHighWaterMark, $e = requireErrorsBrowser().codes, Re = $e.ERR_INVALID_ARG_TYPE, Me = $e.ERR_STREAM_PUSH_AFTER_EOF, ke = $e.ERR_METHOD_NOT_IMPLEMENTED, Te = $e.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Ie, qe, Ue;
  inherits_browserExports(je, n);
  var ze = be.errorOrDestroy, Ve = ["error", "close", "destroy", "pause", "resume"];
  function Mt(Ft, Le, $t) {
    if (typeof Ft.prependListener == "function") return Ft.prependListener(Le, $t);
    !Ft._events || !Ft._events[Le] ? Ft.on(Le, $t) : Array.isArray(Ft._events[Le]) ? Ft._events[Le].unshift($t) : Ft._events[Le] = [$t, Ft._events[Le]];
  }
  function Rt(Ft, Le, $t) {
    c = c || require_stream_duplex$1(), Ft = Ft || {}, typeof $t != "boolean" && ($t = Le instanceof c), this.objectMode = !!Ft.objectMode, $t && (this.objectMode = this.objectMode || !!Ft.readableObjectMode), this.highWaterMark = Se(this, Ft, "readableHighWaterMark", $t), this.buffer = new ye(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Ft.emitClose !== !1, this.autoDestroy = !!Ft.autoDestroy, this.destroyed = !1, this.defaultEncoding = Ft.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ft.encoding && (Ie || (Ie = requireString_decoder().StringDecoder), this.decoder = new Ie(Ft.encoding), this.encoding = Ft.encoding);
  }
  function je(Ft) {
    if (c = c || require_stream_duplex$1(), !(this instanceof je)) return new je(Ft);
    var Le = this instanceof c;
    this._readableState = new Rt(Ft, this, Le), this.readable = !0, Ft && (typeof Ft.read == "function" && (this._read = Ft.read), typeof Ft.destroy == "function" && (this._destroy = Ft.destroy)), n.call(this);
  }
  Object.defineProperty(je.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Le) {
      this._readableState && (this._readableState.destroyed = Le);
    }
  }), je.prototype.destroy = be.destroy, je.prototype._undestroy = be.undestroy, je.prototype._destroy = function(Ft, Le) {
    Le(Ft);
  }, je.prototype.push = function(Ft, Le) {
    var $t = this._readableState, Jt;
    return $t.objectMode ? Jt = !0 : typeof Ft == "string" && (Le = Le || $t.defaultEncoding, Le !== $t.encoding && (Ft = ie.from(Ft, Le), Le = ""), Jt = !0), jt(this, Ft, Le, !1, Jt);
  }, je.prototype.unshift = function(Ft) {
    return jt(this, Ft, null, !0, !1);
  };
  function jt(Ft, Le, $t, Jt, Ht) {
    me("readableAddChunk", Le);
    var Vt = Ft._readableState;
    if (Le === null)
      Vt.reading = !1, ve(Ft, Vt);
    else {
      var xn;
      if (Ht || (xn = se(Vt, Le)), xn)
        ze(Ft, xn);
      else if (Vt.objectMode || Le && Le.length > 0)
        if (typeof Le != "string" && !Vt.objectMode && Object.getPrototypeOf(Le) !== ie.prototype && (Le = ae(Le)), Jt)
          Vt.endEmitted ? ze(Ft, new Te()) : _e(Ft, Vt, Le, !0);
        else if (Vt.ended)
          ze(Ft, new Me());
        else {
          if (Vt.destroyed)
            return !1;
          Vt.reading = !1, Vt.decoder && !$t ? (Le = Vt.decoder.write(Le), Vt.objectMode || Le.length !== 0 ? _e(Ft, Vt, Le, !1) : xe(Ft, Vt)) : _e(Ft, Vt, Le, !1);
        }
      else Jt || (Vt.reading = !1, xe(Ft, Vt));
    }
    return !Vt.ended && (Vt.length < Vt.highWaterMark || Vt.length === 0);
  }
  function _e(Ft, Le, $t, Jt) {
    Le.flowing && Le.length === 0 && !Le.sync ? (Le.awaitDrain = 0, Ft.emit("data", $t)) : (Le.length += Le.objectMode ? 1 : $t.length, Jt ? Le.buffer.unshift($t) : Le.buffer.push($t), Le.needReadable && we(Ft)), xe(Ft, Le);
  }
  function se(Ft, Le) {
    var $t;
    return !le(Le) && typeof Le != "string" && Le !== void 0 && !Ft.objectMode && ($t = new Re("chunk", ["string", "Buffer", "Uint8Array"], Le)), $t;
  }
  je.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, je.prototype.setEncoding = function(Ft) {
    Ie || (Ie = requireString_decoder().StringDecoder);
    var Le = new Ie(Ft);
    this._readableState.decoder = Le, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var $t = this._readableState.buffer.head, Jt = ""; $t !== null; )
      Jt += Le.write($t.data), $t = $t.next;
    return this._readableState.buffer.clear(), Jt !== "" && this._readableState.buffer.push(Jt), this._readableState.length = Jt.length, this;
  };
  var ce = 1073741824;
  function de(Ft) {
    return Ft >= ce ? Ft = ce : (Ft--, Ft |= Ft >>> 1, Ft |= Ft >>> 2, Ft |= Ft >>> 4, Ft |= Ft >>> 8, Ft |= Ft >>> 16, Ft++), Ft;
  }
  function pe(Ft, Le) {
    return Ft <= 0 || Le.length === 0 && Le.ended ? 0 : Le.objectMode ? 1 : Ft !== Ft ? Le.flowing && Le.length ? Le.buffer.head.data.length : Le.length : (Ft > Le.highWaterMark && (Le.highWaterMark = de(Ft)), Ft <= Le.length ? Ft : Le.ended ? Le.length : (Le.needReadable = !0, 0));
  }
  je.prototype.read = function(Ft) {
    me("read", Ft), Ft = parseInt(Ft, 10);
    var Le = this._readableState, $t = Ft;
    if (Ft !== 0 && (Le.emittedReadable = !1), Ft === 0 && Le.needReadable && ((Le.highWaterMark !== 0 ? Le.length >= Le.highWaterMark : Le.length > 0) || Le.ended))
      return me("read: emitReadable", Le.length, Le.ended), Le.length === 0 && Le.ended ? Ze(this) : we(this), null;
    if (Ft = pe(Ft, Le), Ft === 0 && Le.ended)
      return Le.length === 0 && Ze(this), null;
    var Jt = Le.needReadable;
    me("need readable", Jt), (Le.length === 0 || Le.length - Ft < Le.highWaterMark) && (Jt = !0, me("length less than watermark", Jt)), Le.ended || Le.reading ? (Jt = !1, me("reading or ended", Jt)) : Jt && (me("do read"), Le.reading = !0, Le.sync = !0, Le.length === 0 && (Le.needReadable = !0), this._read(Le.highWaterMark), Le.sync = !1, Le.reading || (Ft = pe($t, Le)));
    var Ht;
    return Ft > 0 ? Ht = Ke(Ft, Le) : Ht = null, Ht === null ? (Le.needReadable = Le.length <= Le.highWaterMark, Ft = 0) : (Le.length -= Ft, Le.awaitDrain = 0), Le.length === 0 && (Le.ended || (Le.needReadable = !0), $t !== Ft && Le.ended && Ze(this)), Ht !== null && this.emit("data", Ht), Ht;
  };
  function ve(Ft, Le) {
    if (me("onEofChunk"), !Le.ended) {
      if (Le.decoder) {
        var $t = Le.decoder.end();
        $t && $t.length && (Le.buffer.push($t), Le.length += Le.objectMode ? 1 : $t.length);
      }
      Le.ended = !0, Le.sync ? we(Ft) : (Le.needReadable = !1, Le.emittedReadable || (Le.emittedReadable = !0, Ee(Ft)));
    }
  }
  function we(Ft) {
    var Le = Ft._readableState;
    me("emitReadable", Le.needReadable, Le.emittedReadable), Le.needReadable = !1, Le.emittedReadable || (me("emitReadable", Le.flowing), Le.emittedReadable = !0, process$1.nextTick(Ee, Ft));
  }
  function Ee(Ft) {
    var Le = Ft._readableState;
    me("emitReadable_", Le.destroyed, Le.length, Le.ended), !Le.destroyed && (Le.length || Le.ended) && (Ft.emit("readable"), Le.emittedReadable = !1), Le.needReadable = !Le.flowing && !Le.ended && Le.length <= Le.highWaterMark, Je(Ft);
  }
  function xe(Ft, Le) {
    Le.readingMore || (Le.readingMore = !0, process$1.nextTick(ue, Ft, Le));
  }
  function ue(Ft, Le) {
    for (; !Le.reading && !Le.ended && (Le.length < Le.highWaterMark || Le.flowing && Le.length === 0); ) {
      var $t = Le.length;
      if (me("maybeReadMore read 0"), Ft.read(0), $t === Le.length)
        break;
    }
    Le.readingMore = !1;
  }
  je.prototype._read = function(Ft) {
    ze(this, new ke("_read()"));
  }, je.prototype.pipe = function(Ft, Le) {
    var $t = this, Jt = this._readableState;
    switch (Jt.pipesCount) {
      case 0:
        Jt.pipes = Ft;
        break;
      case 1:
        Jt.pipes = [Jt.pipes, Ft];
        break;
      default:
        Jt.pipes.push(Ft);
        break;
    }
    Jt.pipesCount += 1, me("pipe count=%d opts=%j", Jt.pipesCount, Le);
    var Ht = (!Le || Le.end !== !1) && Ft !== process$1.stdout && Ft !== process$1.stderr, Vt = Ht ? Zt : en;
    Jt.endEmitted ? process$1.nextTick(Vt) : $t.once("end", Vt), Ft.on("unpipe", xn);
    function xn(We, De) {
      me("onunpipe"), We === $t && De && De.hasUnpiped === !1 && (De.hasUnpiped = !0, Qt());
    }
    function Zt() {
      me("onend"), Ft.end();
    }
    var Gt = ge($t);
    Ft.on("drain", Gt);
    var An = !1;
    function Qt() {
      me("cleanup"), Ft.removeListener("close", Qe), Ft.removeListener("finish", Dt), Ft.removeListener("drain", Gt), Ft.removeListener("error", wn), Ft.removeListener("unpipe", xn), $t.removeListener("end", Zt), $t.removeListener("end", en), $t.removeListener("data", Xt), An = !0, Jt.awaitDrain && (!Ft._writableState || Ft._writableState.needDrain) && Gt();
    }
    $t.on("data", Xt);
    function Xt(We) {
      me("ondata");
      var De = Ft.write(We);
      me("dest.write", De), De === !1 && ((Jt.pipesCount === 1 && Jt.pipes === Ft || Jt.pipesCount > 1 && Pt(Jt.pipes, Ft) !== -1) && !An && (me("false write response, pause", Jt.awaitDrain), Jt.awaitDrain++), $t.pause());
    }
    function wn(We) {
      me("onerror", We), en(), Ft.removeListener("error", wn), t(Ft, "error") === 0 && ze(Ft, We);
    }
    Mt(Ft, "error", wn);
    function Qe() {
      Ft.removeListener("finish", Dt), en();
    }
    Ft.once("close", Qe);
    function Dt() {
      me("onfinish"), Ft.removeListener("close", Qe), en();
    }
    Ft.once("finish", Dt);
    function en() {
      me("unpipe"), $t.unpipe(Ft);
    }
    return Ft.emit("pipe", $t), Jt.flowing || (me("pipe resume"), $t.resume()), Ft;
  };
  function ge(Ft) {
    return function() {
      var $t = Ft._readableState;
      me("pipeOnDrain", $t.awaitDrain), $t.awaitDrain && $t.awaitDrain--, $t.awaitDrain === 0 && t(Ft, "data") && ($t.flowing = !0, Je(Ft));
    };
  }
  je.prototype.unpipe = function(Ft) {
    var Le = this._readableState, $t = {
      hasUnpiped: !1
    };
    if (Le.pipesCount === 0) return this;
    if (Le.pipesCount === 1)
      return Ft && Ft !== Le.pipes ? this : (Ft || (Ft = Le.pipes), Le.pipes = null, Le.pipesCount = 0, Le.flowing = !1, Ft && Ft.emit("unpipe", this, $t), this);
    if (!Ft) {
      var Jt = Le.pipes, Ht = Le.pipesCount;
      Le.pipes = null, Le.pipesCount = 0, Le.flowing = !1;
      for (var Vt = 0; Vt < Ht; Vt++) Jt[Vt].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var xn = Pt(Le.pipes, Ft);
    return xn === -1 ? this : (Le.pipes.splice(xn, 1), Le.pipesCount -= 1, Le.pipesCount === 1 && (Le.pipes = Le.pipes[0]), Ft.emit("unpipe", this, $t), this);
  }, je.prototype.on = function(Ft, Le) {
    var $t = n.prototype.on.call(this, Ft, Le), Jt = this._readableState;
    return Ft === "data" ? (Jt.readableListening = this.listenerCount("readable") > 0, Jt.flowing !== !1 && this.resume()) : Ft === "readable" && !Jt.endEmitted && !Jt.readableListening && (Jt.readableListening = Jt.needReadable = !0, Jt.flowing = !1, Jt.emittedReadable = !1, me("on readable", Jt.length, Jt.reading), Jt.length ? we(this) : Jt.reading || process$1.nextTick(Ne, this)), $t;
  }, je.prototype.addListener = je.prototype.on, je.prototype.removeListener = function(Ft, Le) {
    var $t = n.prototype.removeListener.call(this, Ft, Le);
    return Ft === "readable" && process$1.nextTick(Be, this), $t;
  }, je.prototype.removeAllListeners = function(Ft) {
    var Le = n.prototype.removeAllListeners.apply(this, arguments);
    return (Ft === "readable" || Ft === void 0) && process$1.nextTick(Be, this), Le;
  };
  function Be(Ft) {
    var Le = Ft._readableState;
    Le.readableListening = Ft.listenerCount("readable") > 0, Le.resumeScheduled && !Le.paused ? Le.flowing = !0 : Ft.listenerCount("data") > 0 && Ft.resume();
  }
  function Ne(Ft) {
    me("readable nexttick read 0"), Ft.read(0);
  }
  je.prototype.resume = function() {
    var Ft = this._readableState;
    return Ft.flowing || (me("resume"), Ft.flowing = !Ft.readableListening, Fe(this, Ft)), Ft.paused = !1, this;
  };
  function Fe(Ft, Le) {
    Le.resumeScheduled || (Le.resumeScheduled = !0, process$1.nextTick(Pe, Ft, Le));
  }
  function Pe(Ft, Le) {
    me("resume", Le.reading), Le.reading || Ft.read(0), Le.resumeScheduled = !1, Ft.emit("resume"), Je(Ft), Le.flowing && !Le.reading && Ft.read(0);
  }
  je.prototype.pause = function() {
    return me("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (me("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Je(Ft) {
    var Le = Ft._readableState;
    for (me("flow", Le.flowing); Le.flowing && Ft.read() !== null; ) ;
  }
  je.prototype.wrap = function(Ft) {
    var Le = this, $t = this._readableState, Jt = !1;
    Ft.on("end", function() {
      if (me("wrapped end"), $t.decoder && !$t.ended) {
        var xn = $t.decoder.end();
        xn && xn.length && Le.push(xn);
      }
      Le.push(null);
    }), Ft.on("data", function(xn) {
      if (me("wrapped data"), $t.decoder && (xn = $t.decoder.write(xn)), !($t.objectMode && xn == null) && !(!$t.objectMode && (!xn || !xn.length))) {
        var Zt = Le.push(xn);
        Zt || (Jt = !0, Ft.pause());
      }
    });
    for (var Ht in Ft)
      this[Ht] === void 0 && typeof Ft[Ht] == "function" && (this[Ht] = /* @__PURE__ */ function(Zt) {
        return function() {
          return Ft[Zt].apply(Ft, arguments);
        };
      }(Ht));
    for (var Vt = 0; Vt < Ve.length; Vt++)
      Ft.on(Ve[Vt], this.emit.bind(this, Ve[Vt]));
    return this._read = function(xn) {
      me("wrapped _read", xn), Jt && (Jt = !1, Ft.resume());
    }, this;
  }, typeof Symbol == "function" && (je.prototype[Symbol.asyncIterator] = function() {
    return qe === void 0 && (qe = requireAsync_iterator()), qe(this);
  }), Object.defineProperty(je.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(je.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(je.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Le) {
      this._readableState && (this._readableState.flowing = Le);
    }
  }), je._fromList = Ke, Object.defineProperty(je.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function Ke(Ft, Le) {
    if (Le.length === 0) return null;
    var $t;
    return Le.objectMode ? $t = Le.buffer.shift() : !Ft || Ft >= Le.length ? (Le.decoder ? $t = Le.buffer.join("") : Le.buffer.length === 1 ? $t = Le.buffer.first() : $t = Le.buffer.concat(Le.length), Le.buffer.clear()) : $t = Le.buffer.consume(Ft, Le.decoder), $t;
  }
  function Ze(Ft) {
    var Le = Ft._readableState;
    me("endReadable", Le.endEmitted), Le.endEmitted || (Le.ended = !0, process$1.nextTick(Ye, Le, Ft));
  }
  function Ye(Ft, Le) {
    if (me("endReadableNT", Ft.endEmitted, Ft.length), !Ft.endEmitted && Ft.length === 0 && (Ft.endEmitted = !0, Le.readable = !1, Le.emit("end"), Ft.autoDestroy)) {
      var $t = Le._writableState;
      (!$t || $t.autoDestroy && $t.finished) && Le.destroy();
    }
  }
  typeof Symbol == "function" && (je.from = function(Ft, Le) {
    return Ue === void 0 && (Ue = requireFromBrowser()), Ue(je, Ft, Le);
  });
  function Pt(Ft, Le) {
    for (var $t = 0, Jt = Ft.length; $t < Jt; $t++)
      if (Ft[$t] === Le) return $t;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1) return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = he;
  var c = requireErrorsBrowser().codes, t = c.ERR_METHOD_NOT_IMPLEMENTED, n = c.ERR_MULTIPLE_CALLBACK, ie = c.ERR_TRANSFORM_ALREADY_TRANSFORMING, fe = c.ERR_TRANSFORM_WITH_LENGTH_0, ae = require_stream_duplex$1();
  inherits_browserExports(he, ae);
  function le(be, Ae) {
    var Se = this._transformState;
    Se.transforming = !1;
    var $e = Se.writecb;
    if ($e === null)
      return this.emit("error", new n());
    Se.writechunk = null, Se.writecb = null, Ae != null && this.push(Ae), $e(be);
    var Re = this._readableState;
    Re.reading = !1, (Re.needReadable || Re.length < Re.highWaterMark) && this._read(Re.highWaterMark);
  }
  function he(be) {
    if (!(this instanceof he)) return new he(be);
    ae.call(this, be), this._transformState = {
      afterTransform: le.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, be && (typeof be.transform == "function" && (this._transform = be.transform), typeof be.flush == "function" && (this._flush = be.flush)), this.on("prefinish", me);
  }
  function me() {
    var be = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(Ae, Se) {
      ye(be, Ae, Se);
    }) : ye(this, null, null);
  }
  he.prototype.push = function(be, Ae) {
    return this._transformState.needTransform = !1, ae.prototype.push.call(this, be, Ae);
  }, he.prototype._transform = function(be, Ae, Se) {
    Se(new t("_transform()"));
  }, he.prototype._write = function(be, Ae, Se) {
    var $e = this._transformState;
    if ($e.writecb = Se, $e.writechunk = be, $e.writeencoding = Ae, !$e.transforming) {
      var Re = this._readableState;
      ($e.needTransform || Re.needReadable || Re.length < Re.highWaterMark) && this._read(Re.highWaterMark);
    }
  }, he.prototype._read = function(be) {
    var Ae = this._transformState;
    Ae.writechunk !== null && !Ae.transforming ? (Ae.transforming = !0, this._transform(Ae.writechunk, Ae.writeencoding, Ae.afterTransform)) : Ae.needTransform = !0;
  }, he.prototype._destroy = function(be, Ae) {
    ae.prototype._destroy.call(this, be, function(Se) {
      Ae(Se);
    });
  };
  function ye(be, Ae, Se) {
    if (Ae) return be.emit("error", Ae);
    if (Se != null && be.push(Se), be._writableState.length) throw new fe();
    if (be._transformState.transforming) throw new ie();
    return be.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1) return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = t;
  var c = require_stream_transform$1();
  inherits_browserExports(t, c);
  function t(n) {
    if (!(this instanceof t)) return new t(n);
    c.call(this, n);
  }
  return t.prototype._transform = function(n, ie, fe) {
    fe(null, n);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline) return pipeline_1;
  hasRequiredPipeline = 1;
  var c;
  function t(Se) {
    var $e = !1;
    return function() {
      $e || ($e = !0, Se.apply(void 0, arguments));
    };
  }
  var n = requireErrorsBrowser().codes, ie = n.ERR_MISSING_ARGS, fe = n.ERR_STREAM_DESTROYED;
  function ae(Se) {
    if (Se) throw Se;
  }
  function le(Se) {
    return Se.setHeader && typeof Se.abort == "function";
  }
  function he(Se, $e, Re, Me) {
    Me = t(Me);
    var ke = !1;
    Se.on("close", function() {
      ke = !0;
    }), c === void 0 && (c = requireEndOfStream()), c(Se, {
      readable: $e,
      writable: Re
    }, function(Ie) {
      if (Ie) return Me(Ie);
      ke = !0, Me();
    });
    var Te = !1;
    return function(Ie) {
      if (!ke && !Te) {
        if (Te = !0, le(Se)) return Se.abort();
        if (typeof Se.destroy == "function") return Se.destroy();
        Me(Ie || new fe("pipe"));
      }
    };
  }
  function me(Se) {
    Se();
  }
  function ye(Se, $e) {
    return Se.pipe($e);
  }
  function be(Se) {
    return !Se.length || typeof Se[Se.length - 1] != "function" ? ae : Se.pop();
  }
  function Ae() {
    for (var Se = arguments.length, $e = new Array(Se), Re = 0; Re < Se; Re++)
      $e[Re] = arguments[Re];
    var Me = be($e);
    if (Array.isArray($e[0]) && ($e = $e[0]), $e.length < 2)
      throw new ie("streams");
    var ke, Te = $e.map(function(Ie, qe) {
      var Ue = qe < $e.length - 1, ze = qe > 0;
      return he(Ie, Ue, ze, function(Ve) {
        ke || (ke = Ve), Ve && Te.forEach(me), !Ue && (Te.forEach(me), Me(ke));
      });
    });
    return $e.reduce(ye);
  }
  return pipeline_1 = Ae, pipeline_1;
}
var hasRequiredReadableBrowser$1;
function requireReadableBrowser$1() {
  return hasRequiredReadableBrowser$1 || (hasRequiredReadableBrowser$1 = 1, function(c, t) {
    t = c.exports = require_stream_readable$1(), t.Stream = t, t.Readable = t, t.Writable = require_stream_writable$1(), t.Duplex = require_stream_duplex$1(), t.Transform = require_stream_transform$1(), t.PassThrough = require_stream_passthrough$1(), t.finished = requireEndOfStream(), t.pipeline = requirePipeline();
  }(readableBrowser$1, readableBrowser$1.exports)), readableBrowser$1.exports;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var c = safeBufferExports.Buffer, t = requireReadableBrowser$1().Transform, n = inherits_browserExports;
  function ie(ae, le) {
    if (!c.isBuffer(ae) && typeof ae != "string")
      throw new TypeError(le + " must be a string or a buffer");
  }
  function fe(ae) {
    t.call(this), this._block = c.allocUnsafe(ae), this._blockSize = ae, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return n(fe, t), fe.prototype._transform = function(ae, le, he) {
    var me = null;
    try {
      this.update(ae, le);
    } catch (ye) {
      me = ye;
    }
    he(me);
  }, fe.prototype._flush = function(ae) {
    var le = null;
    try {
      this.push(this.digest());
    } catch (he) {
      le = he;
    }
    ae(le);
  }, fe.prototype.update = function(ae, le) {
    if (ie(ae, "Data"), this._finalized) throw new Error("Digest already called");
    c.isBuffer(ae) || (ae = c.from(ae, le));
    for (var he = this._block, me = 0; this._blockOffset + ae.length - me >= this._blockSize; ) {
      for (var ye = this._blockOffset; ye < this._blockSize; ) he[ye++] = ae[me++];
      this._update(), this._blockOffset = 0;
    }
    for (; me < ae.length; ) he[this._blockOffset++] = ae[me++];
    for (var be = 0, Ae = ae.length * 8; Ae > 0; ++be)
      this._length[be] += Ae, Ae = this._length[be] / 4294967296 | 0, Ae > 0 && (this._length[be] -= 4294967296 * Ae);
    return this;
  }, fe.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, fe.prototype.digest = function(ae) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var le = this._digest();
    ae !== void 0 && (le = le.toString(ae)), this._block.fill(0), this._blockOffset = 0;
    for (var he = 0; he < 4; ++he) this._length[he] = 0;
    return le;
  }, fe.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = fe, hashBase;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js) return md5_js;
  hasRequiredMd5_js = 1;
  var c = inherits_browserExports, t = requireHashBase(), n = safeBufferExports.Buffer, ie = new Array(16);
  function fe() {
    t.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  c(fe, t), fe.prototype._update = function() {
    for (var be = ie, Ae = 0; Ae < 16; ++Ae) be[Ae] = this._block.readInt32LE(Ae * 4);
    var Se = this._a, $e = this._b, Re = this._c, Me = this._d;
    Se = le(Se, $e, Re, Me, be[0], 3614090360, 7), Me = le(Me, Se, $e, Re, be[1], 3905402710, 12), Re = le(Re, Me, Se, $e, be[2], 606105819, 17), $e = le($e, Re, Me, Se, be[3], 3250441966, 22), Se = le(Se, $e, Re, Me, be[4], 4118548399, 7), Me = le(Me, Se, $e, Re, be[5], 1200080426, 12), Re = le(Re, Me, Se, $e, be[6], 2821735955, 17), $e = le($e, Re, Me, Se, be[7], 4249261313, 22), Se = le(Se, $e, Re, Me, be[8], 1770035416, 7), Me = le(Me, Se, $e, Re, be[9], 2336552879, 12), Re = le(Re, Me, Se, $e, be[10], 4294925233, 17), $e = le($e, Re, Me, Se, be[11], 2304563134, 22), Se = le(Se, $e, Re, Me, be[12], 1804603682, 7), Me = le(Me, Se, $e, Re, be[13], 4254626195, 12), Re = le(Re, Me, Se, $e, be[14], 2792965006, 17), $e = le($e, Re, Me, Se, be[15], 1236535329, 22), Se = he(Se, $e, Re, Me, be[1], 4129170786, 5), Me = he(Me, Se, $e, Re, be[6], 3225465664, 9), Re = he(Re, Me, Se, $e, be[11], 643717713, 14), $e = he($e, Re, Me, Se, be[0], 3921069994, 20), Se = he(Se, $e, Re, Me, be[5], 3593408605, 5), Me = he(Me, Se, $e, Re, be[10], 38016083, 9), Re = he(Re, Me, Se, $e, be[15], 3634488961, 14), $e = he($e, Re, Me, Se, be[4], 3889429448, 20), Se = he(Se, $e, Re, Me, be[9], 568446438, 5), Me = he(Me, Se, $e, Re, be[14], 3275163606, 9), Re = he(Re, Me, Se, $e, be[3], 4107603335, 14), $e = he($e, Re, Me, Se, be[8], 1163531501, 20), Se = he(Se, $e, Re, Me, be[13], 2850285829, 5), Me = he(Me, Se, $e, Re, be[2], 4243563512, 9), Re = he(Re, Me, Se, $e, be[7], 1735328473, 14), $e = he($e, Re, Me, Se, be[12], 2368359562, 20), Se = me(Se, $e, Re, Me, be[5], 4294588738, 4), Me = me(Me, Se, $e, Re, be[8], 2272392833, 11), Re = me(Re, Me, Se, $e, be[11], 1839030562, 16), $e = me($e, Re, Me, Se, be[14], 4259657740, 23), Se = me(Se, $e, Re, Me, be[1], 2763975236, 4), Me = me(Me, Se, $e, Re, be[4], 1272893353, 11), Re = me(Re, Me, Se, $e, be[7], 4139469664, 16), $e = me($e, Re, Me, Se, be[10], 3200236656, 23), Se = me(Se, $e, Re, Me, be[13], 681279174, 4), Me = me(Me, Se, $e, Re, be[0], 3936430074, 11), Re = me(Re, Me, Se, $e, be[3], 3572445317, 16), $e = me($e, Re, Me, Se, be[6], 76029189, 23), Se = me(Se, $e, Re, Me, be[9], 3654602809, 4), Me = me(Me, Se, $e, Re, be[12], 3873151461, 11), Re = me(Re, Me, Se, $e, be[15], 530742520, 16), $e = me($e, Re, Me, Se, be[2], 3299628645, 23), Se = ye(Se, $e, Re, Me, be[0], 4096336452, 6), Me = ye(Me, Se, $e, Re, be[7], 1126891415, 10), Re = ye(Re, Me, Se, $e, be[14], 2878612391, 15), $e = ye($e, Re, Me, Se, be[5], 4237533241, 21), Se = ye(Se, $e, Re, Me, be[12], 1700485571, 6), Me = ye(Me, Se, $e, Re, be[3], 2399980690, 10), Re = ye(Re, Me, Se, $e, be[10], 4293915773, 15), $e = ye($e, Re, Me, Se, be[1], 2240044497, 21), Se = ye(Se, $e, Re, Me, be[8], 1873313359, 6), Me = ye(Me, Se, $e, Re, be[15], 4264355552, 10), Re = ye(Re, Me, Se, $e, be[6], 2734768916, 15), $e = ye($e, Re, Me, Se, be[13], 1309151649, 21), Se = ye(Se, $e, Re, Me, be[4], 4149444226, 6), Me = ye(Me, Se, $e, Re, be[11], 3174756917, 10), Re = ye(Re, Me, Se, $e, be[2], 718787259, 15), $e = ye($e, Re, Me, Se, be[9], 3951481745, 21), this._a = this._a + Se | 0, this._b = this._b + $e | 0, this._c = this._c + Re | 0, this._d = this._d + Me | 0;
  }, fe.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var be = n.allocUnsafe(16);
    return be.writeInt32LE(this._a, 0), be.writeInt32LE(this._b, 4), be.writeInt32LE(this._c, 8), be.writeInt32LE(this._d, 12), be;
  };
  function ae(be, Ae) {
    return be << Ae | be >>> 32 - Ae;
  }
  function le(be, Ae, Se, $e, Re, Me, ke) {
    return ae(be + (Ae & Se | ~Ae & $e) + Re + Me | 0, ke) + Ae | 0;
  }
  function he(be, Ae, Se, $e, Re, Me, ke) {
    return ae(be + (Ae & $e | Se & ~$e) + Re + Me | 0, ke) + Ae | 0;
  }
  function me(be, Ae, Se, $e, Re, Me, ke) {
    return ae(be + (Ae ^ Se ^ $e) + Re + Me | 0, ke) + Ae | 0;
  }
  function ye(be, Ae, Se, $e, Re, Me, ke) {
    return ae(be + (Se ^ (Ae | ~$e)) + Re + Me | 0, ke) + Ae | 0;
  }
  return md5_js = fe, md5_js;
}
var ripemd160, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160;
  hasRequiredRipemd160 = 1;
  var c = require$$0$5.Buffer, t = inherits_browserExports, n = requireHashBase(), ie = new Array(16), fe = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], ae = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], le = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], he = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], me = [0, 1518500249, 1859775393, 2400959708, 2840853838], ye = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function be() {
    n.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  t(be, n), be.prototype._update = function() {
    for (var Te = ie, Ie = 0; Ie < 16; ++Ie) Te[Ie] = this._block.readInt32LE(Ie * 4);
    for (var qe = this._a | 0, Ue = this._b | 0, ze = this._c | 0, Ve = this._d | 0, Mt = this._e | 0, Rt = this._a | 0, je = this._b | 0, jt = this._c | 0, _e = this._d | 0, se = this._e | 0, ce = 0; ce < 80; ce += 1) {
      var de, pe;
      ce < 16 ? (de = Se(qe, Ue, ze, Ve, Mt, Te[fe[ce]], me[0], le[ce]), pe = ke(Rt, je, jt, _e, se, Te[ae[ce]], ye[0], he[ce])) : ce < 32 ? (de = $e(qe, Ue, ze, Ve, Mt, Te[fe[ce]], me[1], le[ce]), pe = Me(Rt, je, jt, _e, se, Te[ae[ce]], ye[1], he[ce])) : ce < 48 ? (de = Re(qe, Ue, ze, Ve, Mt, Te[fe[ce]], me[2], le[ce]), pe = Re(Rt, je, jt, _e, se, Te[ae[ce]], ye[2], he[ce])) : ce < 64 ? (de = Me(qe, Ue, ze, Ve, Mt, Te[fe[ce]], me[3], le[ce]), pe = $e(Rt, je, jt, _e, se, Te[ae[ce]], ye[3], he[ce])) : (de = ke(qe, Ue, ze, Ve, Mt, Te[fe[ce]], me[4], le[ce]), pe = Se(Rt, je, jt, _e, se, Te[ae[ce]], ye[4], he[ce])), qe = Mt, Mt = Ve, Ve = Ae(ze, 10), ze = Ue, Ue = de, Rt = se, se = _e, _e = Ae(jt, 10), jt = je, je = pe;
    }
    var ve = this._b + ze + _e | 0;
    this._b = this._c + Ve + se | 0, this._c = this._d + Mt + Rt | 0, this._d = this._e + qe + je | 0, this._e = this._a + Ue + jt | 0, this._a = ve;
  }, be.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var Te = c.alloc ? c.alloc(20) : new c(20);
    return Te.writeInt32LE(this._a, 0), Te.writeInt32LE(this._b, 4), Te.writeInt32LE(this._c, 8), Te.writeInt32LE(this._d, 12), Te.writeInt32LE(this._e, 16), Te;
  };
  function Ae(Te, Ie) {
    return Te << Ie | Te >>> 32 - Ie;
  }
  function Se(Te, Ie, qe, Ue, ze, Ve, Mt, Rt) {
    return Ae(Te + (Ie ^ qe ^ Ue) + Ve + Mt | 0, Rt) + ze | 0;
  }
  function $e(Te, Ie, qe, Ue, ze, Ve, Mt, Rt) {
    return Ae(Te + (Ie & qe | ~Ie & Ue) + Ve + Mt | 0, Rt) + ze | 0;
  }
  function Re(Te, Ie, qe, Ue, ze, Ve, Mt, Rt) {
    return Ae(Te + ((Ie | ~qe) ^ Ue) + Ve + Mt | 0, Rt) + ze | 0;
  }
  function Me(Te, Ie, qe, Ue, ze, Ve, Mt, Rt) {
    return Ae(Te + (Ie & Ue | qe & ~Ue) + Ve + Mt | 0, Rt) + ze | 0;
  }
  function ke(Te, Ie, qe, Ue, ze, Ve, Mt, Rt) {
    return Ae(Te + (Ie ^ (qe | ~Ue)) + Ve + Mt | 0, Rt) + ze | 0;
  }
  return ripemd160 = be, ripemd160;
}
var sha_js = { exports: {} }, hash$2, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash) return hash$2;
  hasRequiredHash = 1;
  var c = safeBufferExports.Buffer;
  function t(n, ie) {
    this._block = c.alloc(n), this._finalSize = ie, this._blockSize = n, this._len = 0;
  }
  return t.prototype.update = function(n, ie) {
    typeof n == "string" && (ie = ie || "utf8", n = c.from(n, ie));
    for (var fe = this._block, ae = this._blockSize, le = n.length, he = this._len, me = 0; me < le; ) {
      for (var ye = he % ae, be = Math.min(le - me, ae - ye), Ae = 0; Ae < be; Ae++)
        fe[ye + Ae] = n[me + Ae];
      he += be, me += be, he % ae === 0 && this._update(fe);
    }
    return this._len += le, this;
  }, t.prototype.digest = function(n) {
    var ie = this._len % this._blockSize;
    this._block[ie] = 128, this._block.fill(0, ie + 1), ie >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var fe = this._len * 8;
    if (fe <= 4294967295)
      this._block.writeUInt32BE(fe, this._blockSize - 4);
    else {
      var ae = (fe & 4294967295) >>> 0, le = (fe - ae) / 4294967296;
      this._block.writeUInt32BE(le, this._blockSize - 8), this._block.writeUInt32BE(ae, this._blockSize - 4);
    }
    this._update(this._block);
    var he = this._hash();
    return n ? he.toString(n) : he;
  }, t.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$2 = t, hash$2;
}
var sha, hasRequiredSha;
function requireSha() {
  if (hasRequiredSha) return sha;
  hasRequiredSha = 1;
  var c = inherits_browserExports, t = requireHash(), n = safeBufferExports.Buffer, ie = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], fe = new Array(80);
  function ae() {
    this.init(), this._w = fe, t.call(this, 64, 56);
  }
  c(ae, t), ae.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function le(ye) {
    return ye << 5 | ye >>> 27;
  }
  function he(ye) {
    return ye << 30 | ye >>> 2;
  }
  function me(ye, be, Ae, Se) {
    return ye === 0 ? be & Ae | ~be & Se : ye === 2 ? be & Ae | be & Se | Ae & Se : be ^ Ae ^ Se;
  }
  return ae.prototype._update = function(ye) {
    for (var be = this._w, Ae = this._a | 0, Se = this._b | 0, $e = this._c | 0, Re = this._d | 0, Me = this._e | 0, ke = 0; ke < 16; ++ke) be[ke] = ye.readInt32BE(ke * 4);
    for (; ke < 80; ++ke) be[ke] = be[ke - 3] ^ be[ke - 8] ^ be[ke - 14] ^ be[ke - 16];
    for (var Te = 0; Te < 80; ++Te) {
      var Ie = ~~(Te / 20), qe = le(Ae) + me(Ie, Se, $e, Re) + Me + be[Te] + ie[Ie] | 0;
      Me = Re, Re = $e, $e = he(Se), Se = Ae, Ae = qe;
    }
    this._a = Ae + this._a | 0, this._b = Se + this._b | 0, this._c = $e + this._c | 0, this._d = Re + this._d | 0, this._e = Me + this._e | 0;
  }, ae.prototype._hash = function() {
    var ye = n.allocUnsafe(20);
    return ye.writeInt32BE(this._a | 0, 0), ye.writeInt32BE(this._b | 0, 4), ye.writeInt32BE(this._c | 0, 8), ye.writeInt32BE(this._d | 0, 12), ye.writeInt32BE(this._e | 0, 16), ye;
  }, sha = ae, sha;
}
var sha1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1) return sha1;
  hasRequiredSha1 = 1;
  var c = inherits_browserExports, t = requireHash(), n = safeBufferExports.Buffer, ie = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], fe = new Array(80);
  function ae() {
    this.init(), this._w = fe, t.call(this, 64, 56);
  }
  c(ae, t), ae.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function le(be) {
    return be << 1 | be >>> 31;
  }
  function he(be) {
    return be << 5 | be >>> 27;
  }
  function me(be) {
    return be << 30 | be >>> 2;
  }
  function ye(be, Ae, Se, $e) {
    return be === 0 ? Ae & Se | ~Ae & $e : be === 2 ? Ae & Se | Ae & $e | Se & $e : Ae ^ Se ^ $e;
  }
  return ae.prototype._update = function(be) {
    for (var Ae = this._w, Se = this._a | 0, $e = this._b | 0, Re = this._c | 0, Me = this._d | 0, ke = this._e | 0, Te = 0; Te < 16; ++Te) Ae[Te] = be.readInt32BE(Te * 4);
    for (; Te < 80; ++Te) Ae[Te] = le(Ae[Te - 3] ^ Ae[Te - 8] ^ Ae[Te - 14] ^ Ae[Te - 16]);
    for (var Ie = 0; Ie < 80; ++Ie) {
      var qe = ~~(Ie / 20), Ue = he(Se) + ye(qe, $e, Re, Me) + ke + Ae[Ie] + ie[qe] | 0;
      ke = Me, Me = Re, Re = me($e), $e = Se, Se = Ue;
    }
    this._a = Se + this._a | 0, this._b = $e + this._b | 0, this._c = Re + this._c | 0, this._d = Me + this._d | 0, this._e = ke + this._e | 0;
  }, ae.prototype._hash = function() {
    var be = n.allocUnsafe(20);
    return be.writeInt32BE(this._a | 0, 0), be.writeInt32BE(this._b | 0, 4), be.writeInt32BE(this._c | 0, 8), be.writeInt32BE(this._d | 0, 12), be.writeInt32BE(this._e | 0, 16), be;
  }, sha1 = ae, sha1;
}
var sha256$1, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256) return sha256$1;
  hasRequiredSha256 = 1;
  var c = inherits_browserExports, t = requireHash(), n = safeBufferExports.Buffer, ie = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], fe = new Array(64);
  function ae() {
    this.init(), this._w = fe, t.call(this, 64, 56);
  }
  c(ae, t), ae.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function le(Se, $e, Re) {
    return Re ^ Se & ($e ^ Re);
  }
  function he(Se, $e, Re) {
    return Se & $e | Re & (Se | $e);
  }
  function me(Se) {
    return (Se >>> 2 | Se << 30) ^ (Se >>> 13 | Se << 19) ^ (Se >>> 22 | Se << 10);
  }
  function ye(Se) {
    return (Se >>> 6 | Se << 26) ^ (Se >>> 11 | Se << 21) ^ (Se >>> 25 | Se << 7);
  }
  function be(Se) {
    return (Se >>> 7 | Se << 25) ^ (Se >>> 18 | Se << 14) ^ Se >>> 3;
  }
  function Ae(Se) {
    return (Se >>> 17 | Se << 15) ^ (Se >>> 19 | Se << 13) ^ Se >>> 10;
  }
  return ae.prototype._update = function(Se) {
    for (var $e = this._w, Re = this._a | 0, Me = this._b | 0, ke = this._c | 0, Te = this._d | 0, Ie = this._e | 0, qe = this._f | 0, Ue = this._g | 0, ze = this._h | 0, Ve = 0; Ve < 16; ++Ve) $e[Ve] = Se.readInt32BE(Ve * 4);
    for (; Ve < 64; ++Ve) $e[Ve] = Ae($e[Ve - 2]) + $e[Ve - 7] + be($e[Ve - 15]) + $e[Ve - 16] | 0;
    for (var Mt = 0; Mt < 64; ++Mt) {
      var Rt = ze + ye(Ie) + le(Ie, qe, Ue) + ie[Mt] + $e[Mt] | 0, je = me(Re) + he(Re, Me, ke) | 0;
      ze = Ue, Ue = qe, qe = Ie, Ie = Te + Rt | 0, Te = ke, ke = Me, Me = Re, Re = Rt + je | 0;
    }
    this._a = Re + this._a | 0, this._b = Me + this._b | 0, this._c = ke + this._c | 0, this._d = Te + this._d | 0, this._e = Ie + this._e | 0, this._f = qe + this._f | 0, this._g = Ue + this._g | 0, this._h = ze + this._h | 0;
  }, ae.prototype._hash = function() {
    var Se = n.allocUnsafe(32);
    return Se.writeInt32BE(this._a, 0), Se.writeInt32BE(this._b, 4), Se.writeInt32BE(this._c, 8), Se.writeInt32BE(this._d, 12), Se.writeInt32BE(this._e, 16), Se.writeInt32BE(this._f, 20), Se.writeInt32BE(this._g, 24), Se.writeInt32BE(this._h, 28), Se;
  }, sha256$1 = ae, sha256$1;
}
var sha224$1, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224) return sha224$1;
  hasRequiredSha224 = 1;
  var c = inherits_browserExports, t = requireSha256(), n = requireHash(), ie = safeBufferExports.Buffer, fe = new Array(64);
  function ae() {
    this.init(), this._w = fe, n.call(this, 64, 56);
  }
  return c(ae, t), ae.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, ae.prototype._hash = function() {
    var le = ie.allocUnsafe(28);
    return le.writeInt32BE(this._a, 0), le.writeInt32BE(this._b, 4), le.writeInt32BE(this._c, 8), le.writeInt32BE(this._d, 12), le.writeInt32BE(this._e, 16), le.writeInt32BE(this._f, 20), le.writeInt32BE(this._g, 24), le;
  }, sha224$1 = ae, sha224$1;
}
var sha512$1, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512) return sha512$1;
  hasRequiredSha512 = 1;
  var c = inherits_browserExports, t = requireHash(), n = safeBufferExports.Buffer, ie = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], fe = new Array(160);
  function ae() {
    this.init(), this._w = fe, t.call(this, 128, 112);
  }
  c(ae, t), ae.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function le(Me, ke, Te) {
    return Te ^ Me & (ke ^ Te);
  }
  function he(Me, ke, Te) {
    return Me & ke | Te & (Me | ke);
  }
  function me(Me, ke) {
    return (Me >>> 28 | ke << 4) ^ (ke >>> 2 | Me << 30) ^ (ke >>> 7 | Me << 25);
  }
  function ye(Me, ke) {
    return (Me >>> 14 | ke << 18) ^ (Me >>> 18 | ke << 14) ^ (ke >>> 9 | Me << 23);
  }
  function be(Me, ke) {
    return (Me >>> 1 | ke << 31) ^ (Me >>> 8 | ke << 24) ^ Me >>> 7;
  }
  function Ae(Me, ke) {
    return (Me >>> 1 | ke << 31) ^ (Me >>> 8 | ke << 24) ^ (Me >>> 7 | ke << 25);
  }
  function Se(Me, ke) {
    return (Me >>> 19 | ke << 13) ^ (ke >>> 29 | Me << 3) ^ Me >>> 6;
  }
  function $e(Me, ke) {
    return (Me >>> 19 | ke << 13) ^ (ke >>> 29 | Me << 3) ^ (Me >>> 6 | ke << 26);
  }
  function Re(Me, ke) {
    return Me >>> 0 < ke >>> 0 ? 1 : 0;
  }
  return ae.prototype._update = function(Me) {
    for (var ke = this._w, Te = this._ah | 0, Ie = this._bh | 0, qe = this._ch | 0, Ue = this._dh | 0, ze = this._eh | 0, Ve = this._fh | 0, Mt = this._gh | 0, Rt = this._hh | 0, je = this._al | 0, jt = this._bl | 0, _e = this._cl | 0, se = this._dl | 0, ce = this._el | 0, de = this._fl | 0, pe = this._gl | 0, ve = this._hl | 0, we = 0; we < 32; we += 2)
      ke[we] = Me.readInt32BE(we * 4), ke[we + 1] = Me.readInt32BE(we * 4 + 4);
    for (; we < 160; we += 2) {
      var Ee = ke[we - 30], xe = ke[we - 15 * 2 + 1], ue = be(Ee, xe), ge = Ae(xe, Ee);
      Ee = ke[we - 2 * 2], xe = ke[we - 2 * 2 + 1];
      var Be = Se(Ee, xe), Ne = $e(xe, Ee), Fe = ke[we - 7 * 2], Pe = ke[we - 7 * 2 + 1], Je = ke[we - 16 * 2], Ke = ke[we - 16 * 2 + 1], Ze = ge + Pe | 0, Ye = ue + Fe + Re(Ze, ge) | 0;
      Ze = Ze + Ne | 0, Ye = Ye + Be + Re(Ze, Ne) | 0, Ze = Ze + Ke | 0, Ye = Ye + Je + Re(Ze, Ke) | 0, ke[we] = Ye, ke[we + 1] = Ze;
    }
    for (var Pt = 0; Pt < 160; Pt += 2) {
      Ye = ke[Pt], Ze = ke[Pt + 1];
      var Ft = he(Te, Ie, qe), Le = he(je, jt, _e), $t = me(Te, je), Jt = me(je, Te), Ht = ye(ze, ce), Vt = ye(ce, ze), xn = ie[Pt], Zt = ie[Pt + 1], Gt = le(ze, Ve, Mt), An = le(ce, de, pe), Qt = ve + Vt | 0, Xt = Rt + Ht + Re(Qt, ve) | 0;
      Qt = Qt + An | 0, Xt = Xt + Gt + Re(Qt, An) | 0, Qt = Qt + Zt | 0, Xt = Xt + xn + Re(Qt, Zt) | 0, Qt = Qt + Ze | 0, Xt = Xt + Ye + Re(Qt, Ze) | 0;
      var wn = Jt + Le | 0, Qe = $t + Ft + Re(wn, Jt) | 0;
      Rt = Mt, ve = pe, Mt = Ve, pe = de, Ve = ze, de = ce, ce = se + Qt | 0, ze = Ue + Xt + Re(ce, se) | 0, Ue = qe, se = _e, qe = Ie, _e = jt, Ie = Te, jt = je, je = Qt + wn | 0, Te = Xt + Qe + Re(je, Qt) | 0;
    }
    this._al = this._al + je | 0, this._bl = this._bl + jt | 0, this._cl = this._cl + _e | 0, this._dl = this._dl + se | 0, this._el = this._el + ce | 0, this._fl = this._fl + de | 0, this._gl = this._gl + pe | 0, this._hl = this._hl + ve | 0, this._ah = this._ah + Te + Re(this._al, je) | 0, this._bh = this._bh + Ie + Re(this._bl, jt) | 0, this._ch = this._ch + qe + Re(this._cl, _e) | 0, this._dh = this._dh + Ue + Re(this._dl, se) | 0, this._eh = this._eh + ze + Re(this._el, ce) | 0, this._fh = this._fh + Ve + Re(this._fl, de) | 0, this._gh = this._gh + Mt + Re(this._gl, pe) | 0, this._hh = this._hh + Rt + Re(this._hl, ve) | 0;
  }, ae.prototype._hash = function() {
    var Me = n.allocUnsafe(64);
    function ke(Te, Ie, qe) {
      Me.writeInt32BE(Te, qe), Me.writeInt32BE(Ie, qe + 4);
    }
    return ke(this._ah, this._al, 0), ke(this._bh, this._bl, 8), ke(this._ch, this._cl, 16), ke(this._dh, this._dl, 24), ke(this._eh, this._el, 32), ke(this._fh, this._fl, 40), ke(this._gh, this._gl, 48), ke(this._hh, this._hl, 56), Me;
  }, sha512$1 = ae, sha512$1;
}
var sha384$1, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384) return sha384$1;
  hasRequiredSha384 = 1;
  var c = inherits_browserExports, t = requireSha512(), n = requireHash(), ie = safeBufferExports.Buffer, fe = new Array(160);
  function ae() {
    this.init(), this._w = fe, n.call(this, 128, 112);
  }
  return c(ae, t), ae.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, ae.prototype._hash = function() {
    var le = ie.allocUnsafe(48);
    function he(me, ye, be) {
      le.writeInt32BE(me, be), le.writeInt32BE(ye, be + 4);
    }
    return he(this._ah, this._al, 0), he(this._bh, this._bl, 8), he(this._ch, this._cl, 16), he(this._dh, this._dl, 24), he(this._eh, this._el, 32), he(this._fh, this._fl, 40), le;
  }, sha384$1 = ae, sha384$1;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js) return sha_js.exports;
  hasRequiredSha_js = 1;
  var c = sha_js.exports = function(n) {
    n = n.toLowerCase();
    var ie = c[n];
    if (!ie) throw new Error(n + " is not supported (we accept pull requests)");
    return new ie();
  };
  return c.sha = requireSha(), c.sha1 = requireSha1(), c.sha224 = requireSha224(), c.sha256 = requireSha256(), c.sha384 = requireSha384(), c.sha512 = requireSha512(), sha_js.exports;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify) return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = n;
  var c = requireEvents().EventEmitter, t = inherits_browserExports;
  t(n, c), n.Readable = require_stream_readable$1(), n.Writable = require_stream_writable$1(), n.Duplex = require_stream_duplex$1(), n.Transform = require_stream_transform$1(), n.PassThrough = require_stream_passthrough$1(), n.finished = requireEndOfStream(), n.pipeline = requirePipeline(), n.Stream = n;
  function n() {
    c.call(this);
  }
  return n.prototype.pipe = function(ie, fe) {
    var ae = this;
    function le($e) {
      ie.writable && ie.write($e) === !1 && ae.pause && ae.pause();
    }
    ae.on("data", le);
    function he() {
      ae.readable && ae.resume && ae.resume();
    }
    ie.on("drain", he), !ie._isStdio && (!fe || fe.end !== !1) && (ae.on("end", ye), ae.on("close", be));
    var me = !1;
    function ye() {
      me || (me = !0, ie.end());
    }
    function be() {
      me || (me = !0, typeof ie.destroy == "function" && ie.destroy());
    }
    function Ae($e) {
      if (Se(), c.listenerCount(this, "error") === 0)
        throw $e;
    }
    ae.on("error", Ae), ie.on("error", Ae);
    function Se() {
      ae.removeListener("data", le), ie.removeListener("drain", he), ae.removeListener("end", ye), ae.removeListener("close", be), ae.removeListener("error", Ae), ie.removeListener("error", Ae), ae.removeListener("end", Se), ae.removeListener("close", Se), ie.removeListener("close", Se);
    }
    return ae.on("end", Se), ae.on("close", Se), ie.on("close", Se), ie.emit("pipe", ae), ie;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase) return cipherBase;
  hasRequiredCipherBase = 1;
  var c = safeBufferExports.Buffer, t = requireStreamBrowserify().Transform, n = requireString_decoder().StringDecoder, ie = inherits_browserExports;
  function fe(me) {
    t.call(this), this.hashMode = typeof me == "string", this.hashMode ? this[me] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  ie(fe, t);
  var ae = typeof Uint8Array < "u", le = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (c.prototype instanceof Uint8Array || c.TYPED_ARRAY_SUPPORT);
  function he(me, ye) {
    if (me instanceof c)
      return me;
    if (typeof me == "string")
      return c.from(me, ye);
    if (le && ArrayBuffer.isView(me)) {
      if (me.byteLength === 0)
        return c.alloc(0);
      var be = c.from(me.buffer, me.byteOffset, me.byteLength);
      if (be.byteLength === me.byteLength)
        return be;
    }
    if (ae && me instanceof Uint8Array || c.isBuffer(me) && me.constructor && typeof me.constructor.isBuffer == "function" && me.constructor.isBuffer(me))
      return c.from(me);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return fe.prototype.update = function(me, ye, be) {
    var Ae = he(me, ye), Se = this._update(Ae);
    return this.hashMode ? this : (be && (Se = this._toString(Se, be)), Se);
  }, fe.prototype.setAutoPadding = function() {
  }, fe.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, fe.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, fe.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, fe.prototype._transform = function(me, ye, be) {
    var Ae;
    try {
      this.hashMode ? this._update(me) : this.push(this._update(me));
    } catch (Se) {
      Ae = Se;
    } finally {
      be(Ae);
    }
  }, fe.prototype._flush = function(me) {
    var ye;
    try {
      this.push(this.__final());
    } catch (be) {
      ye = be;
    }
    me(ye);
  }, fe.prototype._finalOrDigest = function(me) {
    var ye = this.__final() || c.alloc(0);
    return me && (ye = this._toString(ye, me, !0)), ye;
  }, fe.prototype._toString = function(me, ye, be) {
    if (this._decoder || (this._decoder = new n(ye), this._encoding = ye), this._encoding !== ye)
      throw new Error("can’t switch encodings");
    var Ae = this._decoder.write(me);
    return be && (Ae += this._decoder.end()), Ae;
  }, cipherBase = fe, cipherBase;
}
var browser$9, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$9;
  hasRequiredBrowser$9 = 1;
  var c = inherits_browserExports, t = requireMd5_js(), n = requireRipemd160(), ie = requireSha_js(), fe = requireCipherBase();
  function ae(le) {
    fe.call(this, "digest"), this._hash = le;
  }
  return c(ae, fe), ae.prototype._update = function(le) {
    this._hash.update(le);
  }, ae.prototype._final = function() {
    return this._hash.digest();
  }, browser$9 = function(he) {
    return he = he.toLowerCase(), he === "md5" ? new t() : he === "rmd160" || he === "ripemd160" ? new n() : new ae(ie(he));
  }, browser$9;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  var c = inherits_browserExports, t = safeBufferExports.Buffer, n = requireCipherBase(), ie = t.alloc(128), fe = 64;
  function ae(le, he) {
    n.call(this, "digest"), typeof he == "string" && (he = t.from(he)), this._alg = le, this._key = he, he.length > fe ? he = le(he) : he.length < fe && (he = t.concat([he, ie], fe));
    for (var me = this._ipad = t.allocUnsafe(fe), ye = this._opad = t.allocUnsafe(fe), be = 0; be < fe; be++)
      me[be] = he[be] ^ 54, ye[be] = he[be] ^ 92;
    this._hash = [me];
  }
  return c(ae, n), ae.prototype._update = function(le) {
    this._hash.push(le);
  }, ae.prototype._final = function() {
    var le = this._alg(t.concat(this._hash));
    return this._alg(t.concat([this._opad, le]));
  }, legacy = ae, legacy;
}
var md5, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5;
  hasRequiredMd5 = 1;
  var c = requireMd5_js();
  return md5 = function(t) {
    return new c().update(t).digest();
  }, md5;
}
var browser$8, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$8;
  hasRequiredBrowser$8 = 1;
  var c = inherits_browserExports, t = requireLegacy(), n = requireCipherBase(), ie = safeBufferExports.Buffer, fe = requireMd5(), ae = requireRipemd160(), le = requireSha_js(), he = ie.alloc(128);
  function me(ye, be) {
    n.call(this, "digest"), typeof be == "string" && (be = ie.from(be));
    var Ae = ye === "sha512" || ye === "sha384" ? 128 : 64;
    if (this._alg = ye, this._key = be, be.length > Ae) {
      var Se = ye === "rmd160" ? new ae() : le(ye);
      be = Se.update(be).digest();
    } else be.length < Ae && (be = ie.concat([be, he], Ae));
    for (var $e = this._ipad = ie.allocUnsafe(Ae), Re = this._opad = ie.allocUnsafe(Ae), Me = 0; Me < Ae; Me++)
      $e[Me] = be[Me] ^ 54, Re[Me] = be[Me] ^ 92;
    this._hash = ye === "rmd160" ? new ae() : le(ye), this._hash.update($e);
  }
  return c(me, n), me.prototype._update = function(ye) {
    this._hash.update(ye);
  }, me.prototype._final = function() {
    var ye = this._hash.digest(), be = this._alg === "rmd160" ? new ae() : le(this._alg);
    return be.update(this._opad).update(ye).digest();
  }, browser$8 = function(be, Ae) {
    return be = be.toLowerCase(), be === "rmd160" || be === "ripemd160" ? new me("rmd160", Ae) : be === "md5" ? new t(fe, Ae) : new me(be, Ae);
  }, browser$8;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6$1 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256,
  sha224,
  sha384,
  sha512,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6$1), algos;
}
var browser$7 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var c = Math.pow(2, 30) - 1;
  return precondition = function(t, n) {
    if (typeof t != "number")
      throw new TypeError("Iterations not a number");
    if (t < 0)
      throw new TypeError("Bad iterations");
    if (typeof n != "number")
      throw new TypeError("Key length not a number");
    if (n < 0 || n > c || n !== n)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var c;
  if (globalThis.process && globalThis.process.browser)
    c = "utf-8";
  else if (globalThis.process && globalThis.process.version) {
    var t = parseInt(process$1.version.split(".")[0].slice(1), 10);
    c = t >= 6 ? "utf-8" : "binary";
  } else
    c = "utf-8";
  return defaultEncoding_1 = c, defaultEncoding_1;
}
var toBuffer, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer;
  hasRequiredToBuffer = 1;
  var c = safeBufferExports.Buffer;
  return toBuffer = function(t, n, ie) {
    if (c.isBuffer(t))
      return t;
    if (typeof t == "string")
      return c.from(t, n);
    if (ArrayBuffer.isView(t))
      return c.from(t.buffer);
    throw new TypeError(ie + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var c = requireMd5(), t = requireRipemd160(), n = requireSha_js(), ie = safeBufferExports.Buffer, fe = requirePrecondition(), ae = requireDefaultEncoding(), le = requireToBuffer(), he = ie.alloc(128), me = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function ye(Se, $e, Re) {
    var Me = be(Se), ke = Se === "sha512" || Se === "sha384" ? 128 : 64;
    $e.length > ke ? $e = Me($e) : $e.length < ke && ($e = ie.concat([$e, he], ke));
    for (var Te = ie.allocUnsafe(ke + me[Se]), Ie = ie.allocUnsafe(ke + me[Se]), qe = 0; qe < ke; qe++)
      Te[qe] = $e[qe] ^ 54, Ie[qe] = $e[qe] ^ 92;
    var Ue = ie.allocUnsafe(ke + Re + 4);
    Te.copy(Ue, 0, 0, ke), this.ipad1 = Ue, this.ipad2 = Te, this.opad = Ie, this.alg = Se, this.blocksize = ke, this.hash = Me, this.size = me[Se];
  }
  ye.prototype.run = function(Se, $e) {
    Se.copy($e, this.blocksize);
    var Re = this.hash($e);
    return Re.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function be(Se) {
    function $e(Me) {
      return n(Se).update(Me).digest();
    }
    function Re(Me) {
      return new t().update(Me).digest();
    }
    return Se === "rmd160" || Se === "ripemd160" ? Re : Se === "md5" ? c : $e;
  }
  function Ae(Se, $e, Re, Me, ke) {
    fe(Re, Me), Se = le(Se, ae, "Password"), $e = le($e, ae, "Salt"), ke = ke || "sha1";
    var Te = new ye(ke, Se, $e.length), Ie = ie.allocUnsafe(Me), qe = ie.allocUnsafe($e.length + 4);
    $e.copy(qe, 0, 0, $e.length);
    for (var Ue = 0, ze = me[ke], Ve = Math.ceil(Me / ze), Mt = 1; Mt <= Ve; Mt++) {
      qe.writeUInt32BE(Mt, $e.length);
      for (var Rt = Te.run(qe, Te.ipad1), je = Rt, jt = 1; jt < Re; jt++) {
        je = Te.run(je, Te.ipad2);
        for (var _e = 0; _e < ze; _e++) Rt[_e] ^= je[_e];
      }
      Rt.copy(Ie, Ue), Ue += ze;
    }
    return Ie;
  }
  return syncBrowser = Ae, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var c = safeBufferExports.Buffer, t = requirePrecondition(), n = requireDefaultEncoding(), ie = requireSyncBrowser(), fe = requireToBuffer(), ae, le = globalThis.crypto && globalThis.crypto.subtle, he = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, me = [];
  function ye(Re) {
    if (globalThis.process && !globalThis.process.browser || !le || !le.importKey || !le.deriveBits)
      return Promise.resolve(!1);
    if (me[Re] !== void 0)
      return me[Re];
    ae = ae || c.alloc(8);
    var Me = Se(ae, ae, 10, 128, Re).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return me[Re] = Me, Me;
  }
  var be;
  function Ae() {
    return be || (globalThis.process && globalThis.process.nextTick ? be = globalThis.process.nextTick : globalThis.queueMicrotask ? be = globalThis.queueMicrotask : globalThis.setImmediate ? be = globalThis.setImmediate : be = globalThis.setTimeout, be);
  }
  function Se(Re, Me, ke, Te, Ie) {
    return le.importKey(
      "raw",
      Re,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(qe) {
      return le.deriveBits({
        name: "PBKDF2",
        salt: Me,
        iterations: ke,
        hash: {
          name: Ie
        }
      }, qe, Te << 3);
    }).then(function(qe) {
      return c.from(qe);
    });
  }
  function $e(Re, Me) {
    Re.then(function(ke) {
      Ae()(function() {
        Me(null, ke);
      });
    }, function(ke) {
      Ae()(function() {
        Me(ke);
      });
    });
  }
  return async = function(Re, Me, ke, Te, Ie, qe) {
    typeof Ie == "function" && (qe = Ie, Ie = void 0), Ie = Ie || "sha1";
    var Ue = he[Ie.toLowerCase()];
    if (!Ue || typeof globalThis.Promise != "function") {
      Ae()(function() {
        var ze;
        try {
          ze = ie(Re, Me, ke, Te, Ie);
        } catch (Ve) {
          return qe(Ve);
        }
        qe(null, ze);
      });
      return;
    }
    if (t(ke, Te), Re = fe(Re, n, "Password"), Me = fe(Me, n, "Salt"), typeof qe != "function") throw new Error("No callback provided to pbkdf2");
    $e(ye(Ue).then(function(ze) {
      return ze ? Se(Re, Me, ke, Te, Ue) : ie(Re, Me, ke, Te, Ie);
    }), qe);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$7.pbkdf2 = requireAsync(), browser$7.pbkdf2Sync = requireSyncBrowser()), browser$7;
}
var browser$6 = {}, des$1 = {}, utils$d = {}, hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$d;
  hasRequiredUtils$1 = 1, utils$d.readUInt32BE = function(fe, ae) {
    var le = fe[0 + ae] << 24 | fe[1 + ae] << 16 | fe[2 + ae] << 8 | fe[3 + ae];
    return le >>> 0;
  }, utils$d.writeUInt32BE = function(fe, ae, le) {
    fe[0 + le] = ae >>> 24, fe[1 + le] = ae >>> 16 & 255, fe[2 + le] = ae >>> 8 & 255, fe[3 + le] = ae & 255;
  }, utils$d.ip = function(fe, ae, le, he) {
    for (var me = 0, ye = 0, be = 6; be >= 0; be -= 2) {
      for (var Ae = 0; Ae <= 24; Ae += 8)
        me <<= 1, me |= ae >>> Ae + be & 1;
      for (var Ae = 0; Ae <= 24; Ae += 8)
        me <<= 1, me |= fe >>> Ae + be & 1;
    }
    for (var be = 6; be >= 0; be -= 2) {
      for (var Ae = 1; Ae <= 25; Ae += 8)
        ye <<= 1, ye |= ae >>> Ae + be & 1;
      for (var Ae = 1; Ae <= 25; Ae += 8)
        ye <<= 1, ye |= fe >>> Ae + be & 1;
    }
    le[he + 0] = me >>> 0, le[he + 1] = ye >>> 0;
  }, utils$d.rip = function(fe, ae, le, he) {
    for (var me = 0, ye = 0, be = 0; be < 4; be++)
      for (var Ae = 24; Ae >= 0; Ae -= 8)
        me <<= 1, me |= ae >>> Ae + be & 1, me <<= 1, me |= fe >>> Ae + be & 1;
    for (var be = 4; be < 8; be++)
      for (var Ae = 24; Ae >= 0; Ae -= 8)
        ye <<= 1, ye |= ae >>> Ae + be & 1, ye <<= 1, ye |= fe >>> Ae + be & 1;
    le[he + 0] = me >>> 0, le[he + 1] = ye >>> 0;
  }, utils$d.pc1 = function(fe, ae, le, he) {
    for (var me = 0, ye = 0, be = 7; be >= 5; be--) {
      for (var Ae = 0; Ae <= 24; Ae += 8)
        me <<= 1, me |= ae >> Ae + be & 1;
      for (var Ae = 0; Ae <= 24; Ae += 8)
        me <<= 1, me |= fe >> Ae + be & 1;
    }
    for (var Ae = 0; Ae <= 24; Ae += 8)
      me <<= 1, me |= ae >> Ae + be & 1;
    for (var be = 1; be <= 3; be++) {
      for (var Ae = 0; Ae <= 24; Ae += 8)
        ye <<= 1, ye |= ae >> Ae + be & 1;
      for (var Ae = 0; Ae <= 24; Ae += 8)
        ye <<= 1, ye |= fe >> Ae + be & 1;
    }
    for (var Ae = 0; Ae <= 24; Ae += 8)
      ye <<= 1, ye |= fe >> Ae + be & 1;
    le[he + 0] = me >>> 0, le[he + 1] = ye >>> 0;
  }, utils$d.r28shl = function(fe, ae) {
    return fe << ae & 268435455 | fe >>> 28 - ae;
  };
  var c = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$d.pc2 = function(fe, ae, le, he) {
    for (var me = 0, ye = 0, be = c.length >>> 1, Ae = 0; Ae < be; Ae++)
      me <<= 1, me |= fe >>> c[Ae] & 1;
    for (var Ae = be; Ae < c.length; Ae++)
      ye <<= 1, ye |= ae >>> c[Ae] & 1;
    le[he + 0] = me >>> 0, le[he + 1] = ye >>> 0;
  }, utils$d.expand = function(fe, ae, le) {
    var he = 0, me = 0;
    he = (fe & 1) << 5 | fe >>> 27;
    for (var ye = 23; ye >= 15; ye -= 4)
      he <<= 6, he |= fe >>> ye & 63;
    for (var ye = 11; ye >= 3; ye -= 4)
      me |= fe >>> ye & 63, me <<= 6;
    me |= (fe & 31) << 1 | fe >>> 31, ae[le + 0] = he >>> 0, ae[le + 1] = me >>> 0;
  };
  var t = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$d.substitute = function(fe, ae) {
    for (var le = 0, he = 0; he < 4; he++) {
      var me = fe >>> 18 - he * 6 & 63, ye = t[he * 64 + me];
      le <<= 4, le |= ye;
    }
    for (var he = 0; he < 4; he++) {
      var me = ae >>> 18 - he * 6 & 63, ye = t[4 * 64 + he * 64 + me];
      le <<= 4, le |= ye;
    }
    return le >>> 0;
  };
  var n = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$d.permute = function(fe) {
    for (var ae = 0, le = 0; le < n.length; le++)
      ae <<= 1, ae |= fe >>> n[le] & 1;
    return ae >>> 0;
  }, utils$d.padSplit = function(fe, ae, le) {
    for (var he = fe.toString(2); he.length < ae; )
      he = "0" + he;
    for (var me = [], ye = 0; ye < ae; ye += le)
      me.push(he.slice(ye, ye + le));
    return me.join(" ");
  }, utils$d;
}
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var c = minimalisticAssert$1;
  function t(n) {
    this.options = n, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = n.padding !== !1;
  }
  return cipher = t, t.prototype._init = function() {
  }, t.prototype.update = function(ie) {
    return ie.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(ie) : this._updateEncrypt(ie);
  }, t.prototype._buffer = function(ie, fe) {
    for (var ae = Math.min(this.buffer.length - this.bufferOff, ie.length - fe), le = 0; le < ae; le++)
      this.buffer[this.bufferOff + le] = ie[fe + le];
    return this.bufferOff += ae, ae;
  }, t.prototype._flushBuffer = function(ie, fe) {
    return this._update(this.buffer, 0, ie, fe), this.bufferOff = 0, this.blockSize;
  }, t.prototype._updateEncrypt = function(ie) {
    var fe = 0, ae = 0, le = (this.bufferOff + ie.length) / this.blockSize | 0, he = new Array(le * this.blockSize);
    this.bufferOff !== 0 && (fe += this._buffer(ie, fe), this.bufferOff === this.buffer.length && (ae += this._flushBuffer(he, ae)));
    for (var me = ie.length - (ie.length - fe) % this.blockSize; fe < me; fe += this.blockSize)
      this._update(ie, fe, he, ae), ae += this.blockSize;
    for (; fe < ie.length; fe++, this.bufferOff++)
      this.buffer[this.bufferOff] = ie[fe];
    return he;
  }, t.prototype._updateDecrypt = function(ie) {
    for (var fe = 0, ae = 0, le = Math.ceil((this.bufferOff + ie.length) / this.blockSize) - 1, he = new Array(le * this.blockSize); le > 0; le--)
      fe += this._buffer(ie, fe), ae += this._flushBuffer(he, ae);
    return fe += this._buffer(ie, fe), he;
  }, t.prototype.final = function(ie) {
    var fe;
    ie && (fe = this.update(ie));
    var ae;
    return this.type === "encrypt" ? ae = this._finalEncrypt() : ae = this._finalDecrypt(), fe ? fe.concat(ae) : ae;
  }, t.prototype._pad = function(ie, fe) {
    if (fe === 0)
      return !1;
    for (; fe < ie.length; )
      ie[fe++] = 0;
    return !0;
  }, t.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var ie = new Array(this.blockSize);
    return this._update(this.buffer, 0, ie, 0), ie;
  }, t.prototype._unpad = function(ie) {
    return ie;
  }, t.prototype._finalDecrypt = function() {
    c.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var ie = new Array(this.blockSize);
    return this._flushBuffer(ie, 0), this._unpad(ie);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var c = minimalisticAssert$1, t = inherits_browserExports, n = requireUtils$1(), ie = requireCipher();
  function fe() {
    this.tmp = new Array(2), this.keys = null;
  }
  function ae(he) {
    ie.call(this, he);
    var me = new fe();
    this._desState = me, this.deriveKeys(me, he.key);
  }
  t(ae, ie), des = ae, ae.create = function(me) {
    return new ae(me);
  };
  var le = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return ae.prototype.deriveKeys = function(me, ye) {
    me.keys = new Array(16 * 2), c.equal(ye.length, this.blockSize, "Invalid key length");
    var be = n.readUInt32BE(ye, 0), Ae = n.readUInt32BE(ye, 4);
    n.pc1(be, Ae, me.tmp, 0), be = me.tmp[0], Ae = me.tmp[1];
    for (var Se = 0; Se < me.keys.length; Se += 2) {
      var $e = le[Se >>> 1];
      be = n.r28shl(be, $e), Ae = n.r28shl(Ae, $e), n.pc2(be, Ae, me.keys, Se);
    }
  }, ae.prototype._update = function(me, ye, be, Ae) {
    var Se = this._desState, $e = n.readUInt32BE(me, ye), Re = n.readUInt32BE(me, ye + 4);
    n.ip($e, Re, Se.tmp, 0), $e = Se.tmp[0], Re = Se.tmp[1], this.type === "encrypt" ? this._encrypt(Se, $e, Re, Se.tmp, 0) : this._decrypt(Se, $e, Re, Se.tmp, 0), $e = Se.tmp[0], Re = Se.tmp[1], n.writeUInt32BE(be, $e, Ae), n.writeUInt32BE(be, Re, Ae + 4);
  }, ae.prototype._pad = function(me, ye) {
    if (this.padding === !1)
      return !1;
    for (var be = me.length - ye, Ae = ye; Ae < me.length; Ae++)
      me[Ae] = be;
    return !0;
  }, ae.prototype._unpad = function(me) {
    if (this.padding === !1)
      return me;
    for (var ye = me[me.length - 1], be = me.length - ye; be < me.length; be++)
      c.equal(me[be], ye);
    return me.slice(0, me.length - ye);
  }, ae.prototype._encrypt = function(me, ye, be, Ae, Se) {
    for (var $e = ye, Re = be, Me = 0; Me < me.keys.length; Me += 2) {
      var ke = me.keys[Me], Te = me.keys[Me + 1];
      n.expand(Re, me.tmp, 0), ke ^= me.tmp[0], Te ^= me.tmp[1];
      var Ie = n.substitute(ke, Te), qe = n.permute(Ie), Ue = Re;
      Re = ($e ^ qe) >>> 0, $e = Ue;
    }
    n.rip(Re, $e, Ae, Se);
  }, ae.prototype._decrypt = function(me, ye, be, Ae, Se) {
    for (var $e = be, Re = ye, Me = me.keys.length - 2; Me >= 0; Me -= 2) {
      var ke = me.keys[Me], Te = me.keys[Me + 1];
      n.expand($e, me.tmp, 0), ke ^= me.tmp[0], Te ^= me.tmp[1];
      var Ie = n.substitute(ke, Te), qe = n.permute(Ie), Ue = $e;
      $e = (Re ^ qe) >>> 0, Re = Ue;
    }
    n.rip($e, Re, Ae, Se);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var c = minimalisticAssert$1, t = inherits_browserExports, n = {};
  function ie(ae) {
    c.equal(ae.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var le = 0; le < this.iv.length; le++)
      this.iv[le] = ae[le];
  }
  function fe(ae) {
    function le(be) {
      ae.call(this, be), this._cbcInit();
    }
    t(le, ae);
    for (var he = Object.keys(n), me = 0; me < he.length; me++) {
      var ye = he[me];
      le.prototype[ye] = n[ye];
    }
    return le.create = function(Ae) {
      return new le(Ae);
    }, le;
  }
  return cbc$1.instantiate = fe, n._cbcInit = function() {
    var le = new ie(this.options.iv);
    this._cbcState = le;
  }, n._update = function(le, he, me, ye) {
    var be = this._cbcState, Ae = this.constructor.super_.prototype, Se = be.iv;
    if (this.type === "encrypt") {
      for (var $e = 0; $e < this.blockSize; $e++)
        Se[$e] ^= le[he + $e];
      Ae._update.call(this, Se, 0, me, ye);
      for (var $e = 0; $e < this.blockSize; $e++)
        Se[$e] = me[ye + $e];
    } else {
      Ae._update.call(this, le, he, me, ye);
      for (var $e = 0; $e < this.blockSize; $e++)
        me[ye + $e] ^= Se[$e];
      for (var $e = 0; $e < this.blockSize; $e++)
        Se[$e] = le[he + $e];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var c = minimalisticAssert$1, t = inherits_browserExports, n = requireCipher(), ie = requireDes$1();
  function fe(le, he) {
    c.equal(he.length, 24, "Invalid key length");
    var me = he.slice(0, 8), ye = he.slice(8, 16), be = he.slice(16, 24);
    le === "encrypt" ? this.ciphers = [
      ie.create({ type: "encrypt", key: me }),
      ie.create({ type: "decrypt", key: ye }),
      ie.create({ type: "encrypt", key: be })
    ] : this.ciphers = [
      ie.create({ type: "decrypt", key: be }),
      ie.create({ type: "encrypt", key: ye }),
      ie.create({ type: "decrypt", key: me })
    ];
  }
  function ae(le) {
    n.call(this, le);
    var he = new fe(this.type, this.options.key);
    this._edeState = he;
  }
  return t(ae, n), ede = ae, ae.create = function(he) {
    return new ae(he);
  }, ae.prototype._update = function(he, me, ye, be) {
    var Ae = this._edeState;
    Ae.ciphers[0]._update(he, me, ye, be), Ae.ciphers[1]._update(ye, be, ye, be), Ae.ciphers[2]._update(ye, be, ye, be);
  }, ae.prototype._pad = ie.prototype._pad, ae.prototype._unpad = ie.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$1(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var c = requireCipherBase(), t = requireDes(), n = inherits_browserExports, ie = safeBufferExports.Buffer, fe = {
    "des-ede3-cbc": t.CBC.instantiate(t.EDE),
    "des-ede3": t.EDE,
    "des-ede-cbc": t.CBC.instantiate(t.EDE),
    "des-ede": t.EDE,
    "des-cbc": t.CBC.instantiate(t.DES),
    "des-ecb": t.DES
  };
  fe.des = fe["des-cbc"], fe.des3 = fe["des-ede3-cbc"], browserifyDes = ae, n(ae, c);
  function ae(le) {
    c.call(this);
    var he = le.mode.toLowerCase(), me = fe[he], ye;
    le.decrypt ? ye = "decrypt" : ye = "encrypt";
    var be = le.key;
    ie.isBuffer(be) || (be = ie.from(be)), (he === "des-ede" || he === "des-ede-cbc") && (be = ie.concat([be, be.slice(0, 8)]));
    var Ae = le.iv;
    ie.isBuffer(Ae) || (Ae = ie.from(Ae)), this._des = me.create({
      key: be,
      iv: Ae,
      type: ye
    });
  }
  return ae.prototype._update = function(le) {
    return ie.from(this._des.update(le));
  }, ae.prototype._final = function() {
    return ie.from(this._des.final());
  }, browserifyDes;
}
var browser$5 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(c, t) {
    return c._cipher.encryptBlock(t);
  }, ecb.decrypt = function(c, t) {
    return c._cipher.decryptBlock(t);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(t, n) {
    for (var ie = Math.min(t.length, n.length), fe = new Buffer$7(ie), ae = 0; ae < ie; ++ae)
      fe[ae] = t[ae] ^ n[ae];
    return fe;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var c = requireBufferXor();
  return cbc.encrypt = function(t, n) {
    var ie = c(n, t._prev);
    return t._prev = t._cipher.encryptBlock(ie), t._prev;
  }, cbc.decrypt = function(t, n) {
    var ie = t._prev;
    t._prev = n;
    var fe = t._cipher.decryptBlock(n);
    return c(fe, ie);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var c = safeBufferExports.Buffer, t = requireBufferXor();
  function n(ie, fe, ae) {
    var le = fe.length, he = t(fe, ie._cache);
    return ie._cache = ie._cache.slice(le), ie._prev = c.concat([ie._prev, ae ? fe : he]), he;
  }
  return cfb.encrypt = function(ie, fe, ae) {
    for (var le = c.allocUnsafe(0), he; fe.length; )
      if (ie._cache.length === 0 && (ie._cache = ie._cipher.encryptBlock(ie._prev), ie._prev = c.allocUnsafe(0)), ie._cache.length <= fe.length)
        he = ie._cache.length, le = c.concat([le, n(ie, fe.slice(0, he), ae)]), fe = fe.slice(he);
      else {
        le = c.concat([le, n(ie, fe, ae)]);
        break;
      }
    return le;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var c = safeBufferExports.Buffer;
  function t(n, ie, fe) {
    var ae = n._cipher.encryptBlock(n._prev), le = ae[0] ^ ie;
    return n._prev = c.concat([
      n._prev.slice(1),
      c.from([fe ? ie : le])
    ]), le;
  }
  return cfb8.encrypt = function(n, ie, fe) {
    for (var ae = ie.length, le = c.allocUnsafe(ae), he = -1; ++he < ae; )
      le[he] = t(n, ie[he], fe);
    return le;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var c = safeBufferExports.Buffer;
  function t(ie, fe, ae) {
    for (var le, he = -1, me = 8, ye = 0, be, Ae; ++he < me; )
      le = ie._cipher.encryptBlock(ie._prev), be = fe & 1 << 7 - he ? 128 : 0, Ae = le[0] ^ be, ye += (Ae & 128) >> he % 8, ie._prev = n(ie._prev, ae ? be : Ae);
    return ye;
  }
  function n(ie, fe) {
    var ae = ie.length, le = -1, he = c.allocUnsafe(ie.length);
    for (ie = c.concat([ie, c.from([fe])]); ++le < ae; )
      he[le] = ie[le] << 1 | ie[le + 1] >> 7;
    return he;
  }
  return cfb1.encrypt = function(ie, fe, ae) {
    for (var le = fe.length, he = c.allocUnsafe(le), me = -1; ++me < le; )
      he[me] = t(ie, fe[me], ae);
    return he;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var c = requireBufferXor();
  function t(n) {
    return n._prev = n._cipher.encryptBlock(n._prev), n._prev;
  }
  return ofb.encrypt = function(n, ie) {
    for (; n._cache.length < ie.length; )
      n._cache = Buffer$7.concat([n._cache, t(n)]);
    var fe = n._cache.slice(0, ie.length);
    return n._cache = n._cache.slice(ie.length), c(ie, fe);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function c(t) {
    for (var n = t.length, ie; n--; )
      if (ie = t.readUInt8(n), ie === 255)
        t.writeUInt8(0, n);
      else {
        ie++, t.writeUInt8(ie, n);
        break;
      }
  }
  return incr32_1 = c, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var c = requireBufferXor(), t = safeBufferExports.Buffer, n = requireIncr32();
  function ie(ae) {
    var le = ae._cipher.encryptBlockRaw(ae._prev);
    return n(ae._prev), le;
  }
  var fe = 16;
  return ctr.encrypt = function(ae, le) {
    var he = Math.ceil(le.length / fe), me = ae._cache.length;
    ae._cache = t.concat([
      ae._cache,
      t.allocUnsafe(he * fe)
    ]);
    for (var ye = 0; ye < he; ye++) {
      var be = ie(ae), Ae = me + ye * fe;
      ae._cache.writeUInt32BE(be[0], Ae + 0), ae._cache.writeUInt32BE(be[1], Ae + 4), ae._cache.writeUInt32BE(be[2], Ae + 8), ae._cache.writeUInt32BE(be[3], Ae + 12);
    }
    var Se = ae._cache.slice(0, le.length);
    return ae._cache = ae._cache.slice(le.length), c(le, Se);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var c = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, t = require$$2;
  for (var n in t)
    t[n].module = c[t[n].mode];
  return modes_1 = t, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var c = safeBufferExports.Buffer;
  function t(he) {
    c.isBuffer(he) || (he = c.from(he));
    for (var me = he.length / 4 | 0, ye = new Array(me), be = 0; be < me; be++)
      ye[be] = he.readUInt32BE(be * 4);
    return ye;
  }
  function n(he) {
    for (var me = 0; me < he.length; he++)
      he[me] = 0;
  }
  function ie(he, me, ye, be, Ae) {
    for (var Se = ye[0], $e = ye[1], Re = ye[2], Me = ye[3], ke = he[0] ^ me[0], Te = he[1] ^ me[1], Ie = he[2] ^ me[2], qe = he[3] ^ me[3], Ue, ze, Ve, Mt, Rt = 4, je = 1; je < Ae; je++)
      Ue = Se[ke >>> 24] ^ $e[Te >>> 16 & 255] ^ Re[Ie >>> 8 & 255] ^ Me[qe & 255] ^ me[Rt++], ze = Se[Te >>> 24] ^ $e[Ie >>> 16 & 255] ^ Re[qe >>> 8 & 255] ^ Me[ke & 255] ^ me[Rt++], Ve = Se[Ie >>> 24] ^ $e[qe >>> 16 & 255] ^ Re[ke >>> 8 & 255] ^ Me[Te & 255] ^ me[Rt++], Mt = Se[qe >>> 24] ^ $e[ke >>> 16 & 255] ^ Re[Te >>> 8 & 255] ^ Me[Ie & 255] ^ me[Rt++], ke = Ue, Te = ze, Ie = Ve, qe = Mt;
    return Ue = (be[ke >>> 24] << 24 | be[Te >>> 16 & 255] << 16 | be[Ie >>> 8 & 255] << 8 | be[qe & 255]) ^ me[Rt++], ze = (be[Te >>> 24] << 24 | be[Ie >>> 16 & 255] << 16 | be[qe >>> 8 & 255] << 8 | be[ke & 255]) ^ me[Rt++], Ve = (be[Ie >>> 24] << 24 | be[qe >>> 16 & 255] << 16 | be[ke >>> 8 & 255] << 8 | be[Te & 255]) ^ me[Rt++], Mt = (be[qe >>> 24] << 24 | be[ke >>> 16 & 255] << 16 | be[Te >>> 8 & 255] << 8 | be[Ie & 255]) ^ me[Rt++], Ue = Ue >>> 0, ze = ze >>> 0, Ve = Ve >>> 0, Mt = Mt >>> 0, [Ue, ze, Ve, Mt];
  }
  var fe = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], ae = function() {
    for (var he = new Array(256), me = 0; me < 256; me++)
      me < 128 ? he[me] = me << 1 : he[me] = me << 1 ^ 283;
    for (var ye = [], be = [], Ae = [[], [], [], []], Se = [[], [], [], []], $e = 0, Re = 0, Me = 0; Me < 256; ++Me) {
      var ke = Re ^ Re << 1 ^ Re << 2 ^ Re << 3 ^ Re << 4;
      ke = ke >>> 8 ^ ke & 255 ^ 99, ye[$e] = ke, be[ke] = $e;
      var Te = he[$e], Ie = he[Te], qe = he[Ie], Ue = he[ke] * 257 ^ ke * 16843008;
      Ae[0][$e] = Ue << 24 | Ue >>> 8, Ae[1][$e] = Ue << 16 | Ue >>> 16, Ae[2][$e] = Ue << 8 | Ue >>> 24, Ae[3][$e] = Ue, Ue = qe * 16843009 ^ Ie * 65537 ^ Te * 257 ^ $e * 16843008, Se[0][ke] = Ue << 24 | Ue >>> 8, Se[1][ke] = Ue << 16 | Ue >>> 16, Se[2][ke] = Ue << 8 | Ue >>> 24, Se[3][ke] = Ue, $e === 0 ? $e = Re = 1 : ($e = Te ^ he[he[he[qe ^ Te]]], Re ^= he[he[Re]]);
    }
    return {
      SBOX: ye,
      INV_SBOX: be,
      SUB_MIX: Ae,
      INV_SUB_MIX: Se
    };
  }();
  function le(he) {
    this._key = t(he), this._reset();
  }
  return le.blockSize = 4 * 4, le.keySize = 256 / 8, le.prototype.blockSize = le.blockSize, le.prototype.keySize = le.keySize, le.prototype._reset = function() {
    for (var he = this._key, me = he.length, ye = me + 6, be = (ye + 1) * 4, Ae = [], Se = 0; Se < me; Se++)
      Ae[Se] = he[Se];
    for (Se = me; Se < be; Se++) {
      var $e = Ae[Se - 1];
      Se % me === 0 ? ($e = $e << 8 | $e >>> 24, $e = ae.SBOX[$e >>> 24] << 24 | ae.SBOX[$e >>> 16 & 255] << 16 | ae.SBOX[$e >>> 8 & 255] << 8 | ae.SBOX[$e & 255], $e ^= fe[Se / me | 0] << 24) : me > 6 && Se % me === 4 && ($e = ae.SBOX[$e >>> 24] << 24 | ae.SBOX[$e >>> 16 & 255] << 16 | ae.SBOX[$e >>> 8 & 255] << 8 | ae.SBOX[$e & 255]), Ae[Se] = Ae[Se - me] ^ $e;
    }
    for (var Re = [], Me = 0; Me < be; Me++) {
      var ke = be - Me, Te = Ae[ke - (Me % 4 ? 0 : 4)];
      Me < 4 || ke <= 4 ? Re[Me] = Te : Re[Me] = ae.INV_SUB_MIX[0][ae.SBOX[Te >>> 24]] ^ ae.INV_SUB_MIX[1][ae.SBOX[Te >>> 16 & 255]] ^ ae.INV_SUB_MIX[2][ae.SBOX[Te >>> 8 & 255]] ^ ae.INV_SUB_MIX[3][ae.SBOX[Te & 255]];
    }
    this._nRounds = ye, this._keySchedule = Ae, this._invKeySchedule = Re;
  }, le.prototype.encryptBlockRaw = function(he) {
    return he = t(he), ie(he, this._keySchedule, ae.SUB_MIX, ae.SBOX, this._nRounds);
  }, le.prototype.encryptBlock = function(he) {
    var me = this.encryptBlockRaw(he), ye = c.allocUnsafe(16);
    return ye.writeUInt32BE(me[0], 0), ye.writeUInt32BE(me[1], 4), ye.writeUInt32BE(me[2], 8), ye.writeUInt32BE(me[3], 12), ye;
  }, le.prototype.decryptBlock = function(he) {
    he = t(he);
    var me = he[1];
    he[1] = he[3], he[3] = me;
    var ye = ie(he, this._invKeySchedule, ae.INV_SUB_MIX, ae.INV_SBOX, this._nRounds), be = c.allocUnsafe(16);
    return be.writeUInt32BE(ye[0], 0), be.writeUInt32BE(ye[3], 4), be.writeUInt32BE(ye[2], 8), be.writeUInt32BE(ye[1], 12), be;
  }, le.prototype.scrub = function() {
    n(this._keySchedule), n(this._invKeySchedule), n(this._key);
  }, aes.AES = le, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var c = safeBufferExports.Buffer, t = c.alloc(16, 0);
  function n(ae) {
    return [
      ae.readUInt32BE(0),
      ae.readUInt32BE(4),
      ae.readUInt32BE(8),
      ae.readUInt32BE(12)
    ];
  }
  function ie(ae) {
    var le = c.allocUnsafe(16);
    return le.writeUInt32BE(ae[0] >>> 0, 0), le.writeUInt32BE(ae[1] >>> 0, 4), le.writeUInt32BE(ae[2] >>> 0, 8), le.writeUInt32BE(ae[3] >>> 0, 12), le;
  }
  function fe(ae) {
    this.h = ae, this.state = c.alloc(16, 0), this.cache = c.allocUnsafe(0);
  }
  return fe.prototype.ghash = function(ae) {
    for (var le = -1; ++le < ae.length; )
      this.state[le] ^= ae[le];
    this._multiply();
  }, fe.prototype._multiply = function() {
    for (var ae = n(this.h), le = [0, 0, 0, 0], he, me, ye, be = -1; ++be < 128; ) {
      for (me = (this.state[~~(be / 8)] & 1 << 7 - be % 8) !== 0, me && (le[0] ^= ae[0], le[1] ^= ae[1], le[2] ^= ae[2], le[3] ^= ae[3]), ye = (ae[3] & 1) !== 0, he = 3; he > 0; he--)
        ae[he] = ae[he] >>> 1 | (ae[he - 1] & 1) << 31;
      ae[0] = ae[0] >>> 1, ye && (ae[0] = ae[0] ^ 225 << 24);
    }
    this.state = ie(le);
  }, fe.prototype.update = function(ae) {
    this.cache = c.concat([this.cache, ae]);
    for (var le; this.cache.length >= 16; )
      le = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(le);
  }, fe.prototype.final = function(ae, le) {
    return this.cache.length && this.ghash(c.concat([this.cache, t], 16)), this.ghash(ie([0, ae, 0, le])), this.state;
  }, ghash = fe, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var c = requireAes(), t = safeBufferExports.Buffer, n = requireCipherBase(), ie = inherits_browserExports, fe = requireGhash(), ae = requireBufferXor(), le = requireIncr32();
  function he(be, Ae) {
    var Se = 0;
    be.length !== Ae.length && Se++;
    for (var $e = Math.min(be.length, Ae.length), Re = 0; Re < $e; ++Re)
      Se += be[Re] ^ Ae[Re];
    return Se;
  }
  function me(be, Ae, Se) {
    if (Ae.length === 12)
      return be._finID = t.concat([Ae, t.from([0, 0, 0, 1])]), t.concat([Ae, t.from([0, 0, 0, 2])]);
    var $e = new fe(Se), Re = Ae.length, Me = Re % 16;
    $e.update(Ae), Me && (Me = 16 - Me, $e.update(t.alloc(Me, 0))), $e.update(t.alloc(8, 0));
    var ke = Re * 8, Te = t.alloc(8);
    Te.writeUIntBE(ke, 0, 8), $e.update(Te), be._finID = $e.state;
    var Ie = t.from(be._finID);
    return le(Ie), Ie;
  }
  function ye(be, Ae, Se, $e) {
    n.call(this);
    var Re = t.alloc(4, 0);
    this._cipher = new c.AES(Ae);
    var Me = this._cipher.encryptBlock(Re);
    this._ghash = new fe(Me), Se = me(this, Se, Me), this._prev = t.from(Se), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = $e, this._alen = 0, this._len = 0, this._mode = be, this._authTag = null, this._called = !1;
  }
  return ie(ye, n), ye.prototype._update = function(be) {
    if (!this._called && this._alen) {
      var Ae = 16 - this._alen % 16;
      Ae < 16 && (Ae = t.alloc(Ae, 0), this._ghash.update(Ae));
    }
    this._called = !0;
    var Se = this._mode.encrypt(this, be);
    return this._decrypt ? this._ghash.update(be) : this._ghash.update(Se), this._len += be.length, Se;
  }, ye.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var be = ae(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && he(be, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = be, this._cipher.scrub();
  }, ye.prototype.getAuthTag = function() {
    if (this._decrypt || !t.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, ye.prototype.setAuthTag = function(Ae) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = Ae;
  }, ye.prototype.setAAD = function(Ae) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(Ae), this._alen += Ae.length;
  }, authCipher = ye, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var c = requireAes(), t = safeBufferExports.Buffer, n = requireCipherBase(), ie = inherits_browserExports;
  function fe(ae, le, he, me) {
    n.call(this), this._cipher = new c.AES(le), this._prev = t.from(he), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = me, this._mode = ae;
  }
  return ie(fe, n), fe.prototype._update = function(ae) {
    return this._mode.encrypt(this, ae, this._decrypt);
  }, fe.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = fe, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var c = safeBufferExports.Buffer, t = requireMd5_js();
  function n(ie, fe, ae, le) {
    if (c.isBuffer(ie) || (ie = c.from(ie, "binary")), fe && (c.isBuffer(fe) || (fe = c.from(fe, "binary")), fe.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var he = ae / 8, me = c.alloc(he), ye = c.alloc(le || 0), be = c.alloc(0); he > 0 || le > 0; ) {
      var Ae = new t();
      Ae.update(be), Ae.update(ie), fe && Ae.update(fe), be = Ae.digest();
      var Se = 0;
      if (he > 0) {
        var $e = me.length - he;
        Se = Math.min(he, be.length), be.copy(me, $e, 0, Se), he -= Se;
      }
      if (Se < be.length && le > 0) {
        var Re = ye.length - le, Me = Math.min(le, be.length - Se);
        be.copy(ye, Re, Se, Se + Me), le -= Me;
      }
    }
    return be.fill(0), { key: me, iv: ye };
  }
  return evp_bytestokey = n, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var c = requireModes$1(), t = requireAuthCipher(), n = safeBufferExports.Buffer, ie = requireStreamCipher(), fe = requireCipherBase(), ae = requireAes(), le = requireEvp_bytestokey(), he = inherits_browserExports;
  function me($e, Re, Me) {
    fe.call(this), this._cache = new be(), this._cipher = new ae.AES(Re), this._prev = n.from(Me), this._mode = $e, this._autopadding = !0;
  }
  he(me, fe), me.prototype._update = function($e) {
    this._cache.add($e);
    for (var Re, Me, ke = []; Re = this._cache.get(); )
      Me = this._mode.encrypt(this, Re), ke.push(Me);
    return n.concat(ke);
  };
  var ye = n.alloc(16, 16);
  me.prototype._final = function() {
    var $e = this._cache.flush();
    if (this._autopadding)
      return $e = this._mode.encrypt(this, $e), this._cipher.scrub(), $e;
    if (!$e.equals(ye))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, me.prototype.setAutoPadding = function($e) {
    return this._autopadding = !!$e, this;
  };
  function be() {
    this.cache = n.allocUnsafe(0);
  }
  be.prototype.add = function($e) {
    this.cache = n.concat([this.cache, $e]);
  }, be.prototype.get = function() {
    if (this.cache.length > 15) {
      var $e = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), $e;
    }
    return null;
  }, be.prototype.flush = function() {
    for (var $e = 16 - this.cache.length, Re = n.allocUnsafe($e), Me = -1; ++Me < $e; )
      Re.writeUInt8($e, Me);
    return n.concat([this.cache, Re]);
  };
  function Ae($e, Re, Me) {
    var ke = c[$e.toLowerCase()];
    if (!ke) throw new TypeError("invalid suite type");
    if (typeof Re == "string" && (Re = n.from(Re)), Re.length !== ke.key / 8) throw new TypeError("invalid key length " + Re.length);
    if (typeof Me == "string" && (Me = n.from(Me)), ke.mode !== "GCM" && Me.length !== ke.iv) throw new TypeError("invalid iv length " + Me.length);
    return ke.type === "stream" ? new ie(ke.module, Re, Me) : ke.type === "auth" ? new t(ke.module, Re, Me) : new me(ke.module, Re, Me);
  }
  function Se($e, Re) {
    var Me = c[$e.toLowerCase()];
    if (!Me) throw new TypeError("invalid suite type");
    var ke = le(Re, !1, Me.key, Me.iv);
    return Ae($e, ke.key, ke.iv);
  }
  return encrypter.createCipheriv = Ae, encrypter.createCipher = Se, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var c = requireAuthCipher(), t = safeBufferExports.Buffer, n = requireModes$1(), ie = requireStreamCipher(), fe = requireCipherBase(), ae = requireAes(), le = requireEvp_bytestokey(), he = inherits_browserExports;
  function me($e, Re, Me) {
    fe.call(this), this._cache = new ye(), this._last = void 0, this._cipher = new ae.AES(Re), this._prev = t.from(Me), this._mode = $e, this._autopadding = !0;
  }
  he(me, fe), me.prototype._update = function($e) {
    this._cache.add($e);
    for (var Re, Me, ke = []; Re = this._cache.get(this._autopadding); )
      Me = this._mode.decrypt(this, Re), ke.push(Me);
    return t.concat(ke);
  }, me.prototype._final = function() {
    var $e = this._cache.flush();
    if (this._autopadding)
      return be(this._mode.decrypt(this, $e));
    if ($e)
      throw new Error("data not multiple of block length");
  }, me.prototype.setAutoPadding = function($e) {
    return this._autopadding = !!$e, this;
  };
  function ye() {
    this.cache = t.allocUnsafe(0);
  }
  ye.prototype.add = function($e) {
    this.cache = t.concat([this.cache, $e]);
  }, ye.prototype.get = function($e) {
    var Re;
    if ($e) {
      if (this.cache.length > 16)
        return Re = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Re;
    } else if (this.cache.length >= 16)
      return Re = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Re;
    return null;
  }, ye.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function be($e) {
    var Re = $e[15];
    if (Re < 1 || Re > 16)
      throw new Error("unable to decrypt data");
    for (var Me = -1; ++Me < Re; )
      if ($e[Me + (16 - Re)] !== Re)
        throw new Error("unable to decrypt data");
    if (Re !== 16)
      return $e.slice(0, 16 - Re);
  }
  function Ae($e, Re, Me) {
    var ke = n[$e.toLowerCase()];
    if (!ke) throw new TypeError("invalid suite type");
    if (typeof Me == "string" && (Me = t.from(Me)), ke.mode !== "GCM" && Me.length !== ke.iv) throw new TypeError("invalid iv length " + Me.length);
    if (typeof Re == "string" && (Re = t.from(Re)), Re.length !== ke.key / 8) throw new TypeError("invalid key length " + Re.length);
    return ke.type === "stream" ? new ie(ke.module, Re, Me, !0) : ke.type === "auth" ? new c(ke.module, Re, Me, !0) : new me(ke.module, Re, Me);
  }
  function Se($e, Re) {
    var Me = n[$e.toLowerCase()];
    if (!Me) throw new TypeError("invalid suite type");
    var ke = le(Re, !1, Me.key, Me.iv);
    return Ae($e, ke.key, ke.iv);
  }
  return decrypter.createDecipher = Se, decrypter.createDecipheriv = Ae, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$5;
  hasRequiredBrowser$6 = 1;
  var c = requireEncrypter(), t = requireDecrypter(), n = require$$2;
  function ie() {
    return Object.keys(n);
  }
  return browser$5.createCipher = browser$5.Cipher = c.createCipher, browser$5.createCipheriv = browser$5.Cipheriv = c.createCipheriv, browser$5.createDecipher = browser$5.Decipher = t.createDecipher, browser$5.createDecipheriv = browser$5.Decipheriv = t.createDecipheriv, browser$5.listCiphers = browser$5.getCiphers = ie, browser$5;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(c) {
    c["des-ecb"] = {
      key: 8,
      iv: 0
    }, c["des-cbc"] = c.des = {
      key: 8,
      iv: 8
    }, c["des-ede3-cbc"] = c.des3 = {
      key: 24,
      iv: 8
    }, c["des-ede3"] = {
      key: 24,
      iv: 0
    }, c["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, c["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$6;
  hasRequiredBrowser$5 = 1;
  var c = requireBrowserifyDes(), t = requireBrowser$6(), n = requireModes$1(), ie = requireModes(), fe = requireEvp_bytestokey();
  function ae(be, Ae) {
    be = be.toLowerCase();
    var Se, $e;
    if (n[be])
      Se = n[be].key, $e = n[be].iv;
    else if (ie[be])
      Se = ie[be].key * 8, $e = ie[be].iv;
    else
      throw new TypeError("invalid suite type");
    var Re = fe(Ae, !1, Se, $e);
    return he(be, Re.key, Re.iv);
  }
  function le(be, Ae) {
    be = be.toLowerCase();
    var Se, $e;
    if (n[be])
      Se = n[be].key, $e = n[be].iv;
    else if (ie[be])
      Se = ie[be].key * 8, $e = ie[be].iv;
    else
      throw new TypeError("invalid suite type");
    var Re = fe(Ae, !1, Se, $e);
    return me(be, Re.key, Re.iv);
  }
  function he(be, Ae, Se) {
    if (be = be.toLowerCase(), n[be]) return t.createCipheriv(be, Ae, Se);
    if (ie[be]) return new c({ key: Ae, iv: Se, mode: be });
    throw new TypeError("invalid suite type");
  }
  function me(be, Ae, Se) {
    if (be = be.toLowerCase(), n[be]) return t.createDecipheriv(be, Ae, Se);
    if (ie[be]) return new c({ key: Ae, iv: Se, mode: be, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function ye() {
    return Object.keys(ie).concat(t.getCiphers());
  }
  return browser$6.createCipher = browser$6.Cipher = ae, browser$6.createCipheriv = browser$6.Cipheriv = he, browser$6.createDecipher = browser$6.Decipher = le, browser$6.createDecipheriv = browser$6.Decipheriv = me, browser$6.listCiphers = browser$6.getCiphers = ye, browser$6;
}
var browser$4 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$5;
function requireBn$5() {
  return hasRequiredBn$5 || (hasRequiredBn$5 = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var c;
  brorand.exports = function(fe) {
    return c || (c = new t(null)), c.generate(fe);
  };
  function t(ie) {
    this.rand = ie;
  }
  if (brorand.exports.Rand = t, t.prototype.generate = function(fe) {
    return this._rand(fe);
  }, t.prototype._rand = function(fe) {
    if (this.rand.getBytes)
      return this.rand.getBytes(fe);
    for (var ae = new Uint8Array(fe), le = 0; le < ae.length; le++)
      ae[le] = this.rand.getByte();
    return ae;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? t.prototype._rand = function(fe) {
      var ae = new Uint8Array(fe);
      return self.crypto.getRandomValues(ae), ae;
    } : self.msCrypto && self.msCrypto.getRandomValues ? t.prototype._rand = function(fe) {
      var ae = new Uint8Array(fe);
      return self.msCrypto.getRandomValues(ae), ae;
    } : typeof window == "object" && (t.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var n = requireCryptoBrowserify();
      if (typeof n.randomBytes != "function")
        throw new Error("Not supported");
      t.prototype._rand = function(fe) {
        return n.randomBytes(fe);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var c = requireBn$4(), t = requireBrorand();
  function n(ie) {
    this.rand = ie || new t.Rand();
  }
  return mr = n, n.create = function(fe) {
    return new n(fe);
  }, n.prototype._randbelow = function(fe) {
    var ae = fe.bitLength(), le = Math.ceil(ae / 8);
    do
      var he = new c(this.rand.generate(le));
    while (he.cmp(fe) >= 0);
    return he;
  }, n.prototype._randrange = function(fe, ae) {
    var le = ae.sub(fe);
    return fe.add(this._randbelow(le));
  }, n.prototype.test = function(fe, ae, le) {
    var he = fe.bitLength(), me = c.mont(fe), ye = new c(1).toRed(me);
    ae || (ae = Math.max(1, he / 48 | 0));
    for (var be = fe.subn(1), Ae = 0; !be.testn(Ae); Ae++)
      ;
    for (var Se = fe.shrn(Ae), $e = be.toRed(me), Re = !0; ae > 0; ae--) {
      var Me = this._randrange(new c(2), be);
      le && le(Me);
      var ke = Me.toRed(me).redPow(Se);
      if (!(ke.cmp(ye) === 0 || ke.cmp($e) === 0)) {
        for (var Te = 1; Te < Ae; Te++) {
          if (ke = ke.redSqr(), ke.cmp(ye) === 0)
            return !1;
          if (ke.cmp($e) === 0)
            break;
        }
        if (Te === Ae)
          return !1;
      }
    }
    return Re;
  }, n.prototype.getDivisor = function(fe, ae) {
    var le = fe.bitLength(), he = c.mont(fe), me = new c(1).toRed(he);
    ae || (ae = Math.max(1, le / 48 | 0));
    for (var ye = fe.subn(1), be = 0; !ye.testn(be); be++)
      ;
    for (var Ae = fe.shrn(be), Se = ye.toRed(he); ae > 0; ae--) {
      var $e = this._randrange(new c(2), ye), Re = fe.gcd($e);
      if (Re.cmpn(1) !== 0)
        return Re;
      var Me = $e.toRed(he).redPow(Ae);
      if (!(Me.cmp(me) === 0 || Me.cmp(Se) === 0)) {
        for (var ke = 1; ke < be; ke++) {
          if (Me = Me.redSqr(), Me.cmp(me) === 0)
            return Me.fromRed().subn(1).gcd(fe);
          if (Me.cmp(Se) === 0)
            break;
        }
        if (ke === be)
          return Me = Me.redSqr(), Me.fromRed().subn(1).gcd(fe);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var c = requireBrowser$b();
  generatePrime = ke, ke.simpleSieve = Re, ke.fermatTest = Me;
  var t = requireBn$5(), n = new t(24), ie = requireMr(), fe = new ie(), ae = new t(1), le = new t(2), he = new t(5);
  new t(16), new t(8);
  var me = new t(10), ye = new t(3);
  new t(7);
  var be = new t(11), Ae = new t(4);
  new t(12);
  var Se = null;
  function $e() {
    if (Se !== null)
      return Se;
    var Te = 1048576, Ie = [];
    Ie[0] = 2;
    for (var qe = 1, Ue = 3; Ue < Te; Ue += 2) {
      for (var ze = Math.ceil(Math.sqrt(Ue)), Ve = 0; Ve < qe && Ie[Ve] <= ze && Ue % Ie[Ve] !== 0; Ve++)
        ;
      qe !== Ve && Ie[Ve] <= ze || (Ie[qe++] = Ue);
    }
    return Se = Ie, Ie;
  }
  function Re(Te) {
    for (var Ie = $e(), qe = 0; qe < Ie.length; qe++)
      if (Te.modn(Ie[qe]) === 0)
        return Te.cmpn(Ie[qe]) === 0;
    return !0;
  }
  function Me(Te) {
    var Ie = t.mont(Te);
    return le.toRed(Ie).redPow(Te.subn(1)).fromRed().cmpn(1) === 0;
  }
  function ke(Te, Ie) {
    if (Te < 16)
      return Ie === 2 || Ie === 5 ? new t([140, 123]) : new t([140, 39]);
    Ie = new t(Ie);
    for (var qe, Ue; ; ) {
      for (qe = new t(c(Math.ceil(Te / 8))); qe.bitLength() > Te; )
        qe.ishrn(1);
      if (qe.isEven() && qe.iadd(ae), qe.testn(1) || qe.iadd(le), Ie.cmp(le)) {
        if (!Ie.cmp(he))
          for (; qe.mod(me).cmp(ye); )
            qe.iadd(Ae);
      } else for (; qe.mod(n).cmp(be); )
        qe.iadd(Ae);
      if (Ue = qe.shrn(1), Re(Ue) && Re(qe) && Me(Ue) && Me(qe) && fe.test(Ue) && fe.test(qe))
        return qe;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var c = requireBn$5(), t = requireMr(), n = new t(), ie = new c(24), fe = new c(11), ae = new c(10), le = new c(3), he = new c(7), me = requireGeneratePrime(), ye = requireBrowser$b();
  dh = Re;
  function be(ke, Te) {
    return Te = Te || "utf8", Buffer$7.isBuffer(ke) || (ke = new Buffer$7(ke, Te)), this._pub = new c(ke), this;
  }
  function Ae(ke, Te) {
    return Te = Te || "utf8", Buffer$7.isBuffer(ke) || (ke = new Buffer$7(ke, Te)), this._priv = new c(ke), this;
  }
  var Se = {};
  function $e(ke, Te) {
    var Ie = Te.toString("hex"), qe = [Ie, ke.toString(16)].join("_");
    if (qe in Se)
      return Se[qe];
    var Ue = 0;
    if (ke.isEven() || !me.simpleSieve || !me.fermatTest(ke) || !n.test(ke))
      return Ue += 1, Ie === "02" || Ie === "05" ? Ue += 8 : Ue += 4, Se[qe] = Ue, Ue;
    n.test(ke.shrn(1)) || (Ue += 2);
    var ze;
    switch (Ie) {
      case "02":
        ke.mod(ie).cmp(fe) && (Ue += 8);
        break;
      case "05":
        ze = ke.mod(ae), ze.cmp(le) && ze.cmp(he) && (Ue += 8);
        break;
      default:
        Ue += 4;
    }
    return Se[qe] = Ue, Ue;
  }
  function Re(ke, Te, Ie) {
    this.setGenerator(Te), this.__prime = new c(ke), this._prime = c.mont(this.__prime), this._primeLen = ke.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Ie ? (this.setPublicKey = be, this.setPrivateKey = Ae) : this._primeCode = 8;
  }
  Object.defineProperty(Re.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = $e(this.__prime, this.__gen)), this._primeCode;
    }
  }), Re.prototype.generateKeys = function() {
    return this._priv || (this._priv = new c(ye(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Re.prototype.computeSecret = function(ke) {
    ke = new c(ke), ke = ke.toRed(this._prime);
    var Te = ke.redPow(this._priv).fromRed(), Ie = new Buffer$7(Te.toArray()), qe = this.getPrime();
    if (Ie.length < qe.length) {
      var Ue = new Buffer$7(qe.length - Ie.length);
      Ue.fill(0), Ie = Buffer$7.concat([Ue, Ie]);
    }
    return Ie;
  }, Re.prototype.getPublicKey = function(Te) {
    return Me(this._pub, Te);
  }, Re.prototype.getPrivateKey = function(Te) {
    return Me(this._priv, Te);
  }, Re.prototype.getPrime = function(ke) {
    return Me(this.__prime, ke);
  }, Re.prototype.getGenerator = function(ke) {
    return Me(this._gen, ke);
  }, Re.prototype.setGenerator = function(ke, Te) {
    return Te = Te || "utf8", Buffer$7.isBuffer(ke) || (ke = new Buffer$7(ke, Te)), this.__gen = ke, this._gen = new c(ke), this;
  };
  function Me(ke, Te) {
    var Ie = new Buffer$7(ke.toArray());
    return Te ? Ie.toString(Te) : Ie;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$4;
  hasRequiredBrowser$4 = 1;
  var c = requireGeneratePrime(), t = require$$1$1, n = requireDh();
  function ie(le) {
    var he = new Buffer$7(t[le].prime, "hex"), me = new Buffer$7(t[le].gen, "hex");
    return new n(he, me);
  }
  var fe = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function ae(le, he, me, ye) {
    return Buffer$7.isBuffer(he) || fe[he] === void 0 ? ae(le, "binary", he, me) : (he = he || "binary", ye = ye || "binary", me = me || new Buffer$7([2]), Buffer$7.isBuffer(me) || (me = new Buffer$7(me, ye)), typeof le == "number" ? new n(c(le, me), me, !0) : (Buffer$7.isBuffer(le) || (le = new Buffer$7(le, he)), new n(le, me, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = ie, browser$4.createDiffieHellman = browser$4.DiffieHellman = ae, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: c } : processNextickArgs.exports = process$1;
  function c(t, n, ie, fe) {
    if (typeof t != "function")
      throw new TypeError('"callback" argument must be a function');
    var ae = arguments.length, le, he;
    switch (ae) {
      case 0:
      case 1:
        return process$1.nextTick(t);
      case 2:
        return process$1.nextTick(function() {
          t.call(null, n);
        });
      case 3:
        return process$1.nextTick(function() {
          t.call(null, n, ie);
        });
      case 4:
        return process$1.nextTick(function() {
          t.call(null, n, ie, fe);
        });
      default:
        for (le = new Array(ae - 1), he = 0; he < le.length; )
          le[he++] = arguments[he];
        return process$1.nextTick(function() {
          t.apply(null, le);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var c = {}.toString;
  return isarray = Array.isArray || function(t) {
    return c.call(t) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = requireEvents().EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(c, t) {
    var n = require$$0$5, ie = n.Buffer;
    function fe(le, he) {
      for (var me in le)
        he[me] = le[me];
    }
    ie.from && ie.alloc && ie.allocUnsafe && ie.allocUnsafeSlow ? c.exports = n : (fe(n, t), t.Buffer = ae);
    function ae(le, he, me) {
      return ie(le, he, me);
    }
    fe(ie, ae), ae.from = function(le, he, me) {
      if (typeof le == "number")
        throw new TypeError("Argument must not be a number");
      return ie(le, he, me);
    }, ae.alloc = function(le, he, me) {
      if (typeof le != "number")
        throw new TypeError("Argument must be a number");
      var ye = ie(le);
      return he !== void 0 ? typeof me == "string" ? ye.fill(he, me) : ye.fill(he) : ye.fill(0), ye;
    }, ae.allocUnsafe = function(le) {
      if (typeof le != "number")
        throw new TypeError("Argument must be a number");
      return ie(le);
    }, ae.allocUnsafeSlow = function(le) {
      if (typeof le != "number")
        throw new TypeError("Argument must be a number");
      return n.SlowBuffer(le);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  function c(Me) {
    return Array.isArray ? Array.isArray(Me) : Re(Me) === "[object Array]";
  }
  util.isArray = c;
  function t(Me) {
    return typeof Me == "boolean";
  }
  util.isBoolean = t;
  function n(Me) {
    return Me === null;
  }
  util.isNull = n;
  function ie(Me) {
    return Me == null;
  }
  util.isNullOrUndefined = ie;
  function fe(Me) {
    return typeof Me == "number";
  }
  util.isNumber = fe;
  function ae(Me) {
    return typeof Me == "string";
  }
  util.isString = ae;
  function le(Me) {
    return typeof Me == "symbol";
  }
  util.isSymbol = le;
  function he(Me) {
    return Me === void 0;
  }
  util.isUndefined = he;
  function me(Me) {
    return Re(Me) === "[object RegExp]";
  }
  util.isRegExp = me;
  function ye(Me) {
    return typeof Me == "object" && Me !== null;
  }
  util.isObject = ye;
  function be(Me) {
    return Re(Me) === "[object Date]";
  }
  util.isDate = be;
  function Ae(Me) {
    return Re(Me) === "[object Error]" || Me instanceof Error;
  }
  util.isError = Ae;
  function Se(Me) {
    return typeof Me == "function";
  }
  util.isFunction = Se;
  function $e(Me) {
    return Me === null || typeof Me == "boolean" || typeof Me == "number" || typeof Me == "string" || typeof Me == "symbol" || // ES6 symbol
    typeof Me > "u";
  }
  util.isPrimitive = $e, util.isBuffer = Buffer$7.isBuffer;
  function Re(Me) {
    return Object.prototype.toString.call(Me);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(c) {
    function t(ae, le) {
      if (!(ae instanceof le))
        throw new TypeError("Cannot call a class as a function");
    }
    var n = requireSafeBuffer().Buffer, ie = requireUtil$1();
    function fe(ae, le, he) {
      ae.copy(le, he);
    }
    c.exports = function() {
      function ae() {
        t(this, ae), this.head = null, this.tail = null, this.length = 0;
      }
      return ae.prototype.push = function(he) {
        var me = { data: he, next: null };
        this.length > 0 ? this.tail.next = me : this.head = me, this.tail = me, ++this.length;
      }, ae.prototype.unshift = function(he) {
        var me = { data: he, next: this.head };
        this.length === 0 && (this.tail = me), this.head = me, ++this.length;
      }, ae.prototype.shift = function() {
        if (this.length !== 0) {
          var he = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, he;
        }
      }, ae.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, ae.prototype.join = function(he) {
        if (this.length === 0) return "";
        for (var me = this.head, ye = "" + me.data; me = me.next; )
          ye += he + me.data;
        return ye;
      }, ae.prototype.concat = function(he) {
        if (this.length === 0) return n.alloc(0);
        for (var me = n.allocUnsafe(he >>> 0), ye = this.head, be = 0; ye; )
          fe(ye.data, me, be), be += ye.data.length, ye = ye.next;
        return me;
      }, ae;
    }(), ie && ie.inspect && ie.inspect.custom && (c.exports.prototype[ie.inspect.custom] = function() {
      var ae = ie.inspect({ length: this.length });
      return this.constructor.name + " " + ae;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var c = requireProcessNextickArgs();
  function t(fe, ae) {
    var le = this, he = this._readableState && this._readableState.destroyed, me = this._writableState && this._writableState.destroyed;
    return he || me ? (ae ? ae(fe) : fe && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, c.nextTick(ie, this, fe)) : c.nextTick(ie, this, fe)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(fe || null, function(ye) {
      !ae && ye ? le._writableState ? le._writableState.errorEmitted || (le._writableState.errorEmitted = !0, c.nextTick(ie, le, ye)) : c.nextTick(ie, le, ye) : ae && ae(ye);
    }), this);
  }
  function n() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function ie(fe, ae) {
    fe.emit("error", ae);
  }
  return destroy_1 = {
    destroy: t,
    undestroy: n
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var c = requireProcessNextickArgs();
  _stream_writable = Me;
  function t(we) {
    var Ee = this;
    this.next = null, this.entry = null, this.finish = function() {
      ve(Ee, we);
    };
  }
  var n = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : c.nextTick, ie;
  Me.WritableState = $e;
  var fe = Object.create(requireUtil());
  fe.inherits = inherits_browserExports;
  var ae = {
    deprecate: requireBrowser$a()
  }, le = requireStreamBrowser(), he = requireSafeBuffer().Buffer, me = (typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ye(we) {
    return he.from(we);
  }
  function be(we) {
    return he.isBuffer(we) || we instanceof me;
  }
  var Ae = requireDestroy();
  fe.inherits(Me, le);
  function Se() {
  }
  function $e(we, Ee) {
    ie = ie || require_stream_duplex(), we = we || {};
    var xe = Ee instanceof ie;
    this.objectMode = !!we.objectMode, xe && (this.objectMode = this.objectMode || !!we.writableObjectMode);
    var ue = we.highWaterMark, ge = we.writableHighWaterMark, Be = this.objectMode ? 16 : 16 * 1024;
    ue || ue === 0 ? this.highWaterMark = ue : xe && (ge || ge === 0) ? this.highWaterMark = ge : this.highWaterMark = Be, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Ne = we.decodeStrings === !1;
    this.decodeStrings = !Ne, this.defaultEncoding = we.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Fe) {
      Mt(Ee, Fe);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  $e.prototype.getBuffer = function() {
    for (var Ee = this.bufferedRequest, xe = []; Ee; )
      xe.push(Ee), Ee = Ee.next;
    return xe;
  }, function() {
    try {
      Object.defineProperty($e.prototype, "buffer", {
        get: ae.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Re;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Re = Function.prototype[Symbol.hasInstance], Object.defineProperty(Me, Symbol.hasInstance, {
    value: function(we) {
      return Re.call(this, we) ? !0 : this !== Me ? !1 : we && we._writableState instanceof $e;
    }
  })) : Re = function(we) {
    return we instanceof this;
  };
  function Me(we) {
    if (ie = ie || require_stream_duplex(), !Re.call(Me, this) && !(this instanceof ie))
      return new Me(we);
    this._writableState = new $e(we, this), this.writable = !0, we && (typeof we.write == "function" && (this._write = we.write), typeof we.writev == "function" && (this._writev = we.writev), typeof we.destroy == "function" && (this._destroy = we.destroy), typeof we.final == "function" && (this._final = we.final)), le.call(this);
  }
  Me.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function ke(we, Ee) {
    var xe = new Error("write after end");
    we.emit("error", xe), c.nextTick(Ee, xe);
  }
  function Te(we, Ee, xe, ue) {
    var ge = !0, Be = !1;
    return xe === null ? Be = new TypeError("May not write null values to stream") : typeof xe != "string" && xe !== void 0 && !Ee.objectMode && (Be = new TypeError("Invalid non-string/buffer chunk")), Be && (we.emit("error", Be), c.nextTick(ue, Be), ge = !1), ge;
  }
  Me.prototype.write = function(we, Ee, xe) {
    var ue = this._writableState, ge = !1, Be = !ue.objectMode && be(we);
    return Be && !he.isBuffer(we) && (we = ye(we)), typeof Ee == "function" && (xe = Ee, Ee = null), Be ? Ee = "buffer" : Ee || (Ee = ue.defaultEncoding), typeof xe != "function" && (xe = Se), ue.ended ? ke(this, xe) : (Be || Te(this, ue, we, xe)) && (ue.pendingcb++, ge = qe(this, ue, Be, we, Ee, xe)), ge;
  }, Me.prototype.cork = function() {
    var we = this._writableState;
    we.corked++;
  }, Me.prototype.uncork = function() {
    var we = this._writableState;
    we.corked && (we.corked--, !we.writing && !we.corked && !we.bufferProcessing && we.bufferedRequest && jt(this, we));
  }, Me.prototype.setDefaultEncoding = function(Ee) {
    if (typeof Ee == "string" && (Ee = Ee.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ee + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Ee);
    return this._writableState.defaultEncoding = Ee, this;
  };
  function Ie(we, Ee, xe) {
    return !we.objectMode && we.decodeStrings !== !1 && typeof Ee == "string" && (Ee = he.from(Ee, xe)), Ee;
  }
  Object.defineProperty(Me.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function qe(we, Ee, xe, ue, ge, Be) {
    if (!xe) {
      var Ne = Ie(Ee, ue, ge);
      ue !== Ne && (xe = !0, ge = "buffer", ue = Ne);
    }
    var Fe = Ee.objectMode ? 1 : ue.length;
    Ee.length += Fe;
    var Pe = Ee.length < Ee.highWaterMark;
    if (Pe || (Ee.needDrain = !0), Ee.writing || Ee.corked) {
      var Je = Ee.lastBufferedRequest;
      Ee.lastBufferedRequest = {
        chunk: ue,
        encoding: ge,
        isBuf: xe,
        callback: Be,
        next: null
      }, Je ? Je.next = Ee.lastBufferedRequest : Ee.bufferedRequest = Ee.lastBufferedRequest, Ee.bufferedRequestCount += 1;
    } else
      Ue(we, Ee, !1, Fe, ue, ge, Be);
    return Pe;
  }
  function Ue(we, Ee, xe, ue, ge, Be, Ne) {
    Ee.writelen = ue, Ee.writecb = Ne, Ee.writing = !0, Ee.sync = !0, xe ? we._writev(ge, Ee.onwrite) : we._write(ge, Be, Ee.onwrite), Ee.sync = !1;
  }
  function ze(we, Ee, xe, ue, ge) {
    --Ee.pendingcb, xe ? (c.nextTick(ge, ue), c.nextTick(de, we, Ee), we._writableState.errorEmitted = !0, we.emit("error", ue)) : (ge(ue), we._writableState.errorEmitted = !0, we.emit("error", ue), de(we, Ee));
  }
  function Ve(we) {
    we.writing = !1, we.writecb = null, we.length -= we.writelen, we.writelen = 0;
  }
  function Mt(we, Ee) {
    var xe = we._writableState, ue = xe.sync, ge = xe.writecb;
    if (Ve(xe), Ee) ze(we, xe, ue, Ee, ge);
    else {
      var Be = _e(xe);
      !Be && !xe.corked && !xe.bufferProcessing && xe.bufferedRequest && jt(we, xe), ue ? n(Rt, we, xe, Be, ge) : Rt(we, xe, Be, ge);
    }
  }
  function Rt(we, Ee, xe, ue) {
    xe || je(we, Ee), Ee.pendingcb--, ue(), de(we, Ee);
  }
  function je(we, Ee) {
    Ee.length === 0 && Ee.needDrain && (Ee.needDrain = !1, we.emit("drain"));
  }
  function jt(we, Ee) {
    Ee.bufferProcessing = !0;
    var xe = Ee.bufferedRequest;
    if (we._writev && xe && xe.next) {
      var ue = Ee.bufferedRequestCount, ge = new Array(ue), Be = Ee.corkedRequestsFree;
      Be.entry = xe;
      for (var Ne = 0, Fe = !0; xe; )
        ge[Ne] = xe, xe.isBuf || (Fe = !1), xe = xe.next, Ne += 1;
      ge.allBuffers = Fe, Ue(we, Ee, !0, Ee.length, ge, "", Be.finish), Ee.pendingcb++, Ee.lastBufferedRequest = null, Be.next ? (Ee.corkedRequestsFree = Be.next, Be.next = null) : Ee.corkedRequestsFree = new t(Ee), Ee.bufferedRequestCount = 0;
    } else {
      for (; xe; ) {
        var Pe = xe.chunk, Je = xe.encoding, Ke = xe.callback, Ze = Ee.objectMode ? 1 : Pe.length;
        if (Ue(we, Ee, !1, Ze, Pe, Je, Ke), xe = xe.next, Ee.bufferedRequestCount--, Ee.writing)
          break;
      }
      xe === null && (Ee.lastBufferedRequest = null);
    }
    Ee.bufferedRequest = xe, Ee.bufferProcessing = !1;
  }
  Me.prototype._write = function(we, Ee, xe) {
    xe(new Error("_write() is not implemented"));
  }, Me.prototype._writev = null, Me.prototype.end = function(we, Ee, xe) {
    var ue = this._writableState;
    typeof we == "function" ? (xe = we, we = null, Ee = null) : typeof Ee == "function" && (xe = Ee, Ee = null), we != null && this.write(we, Ee), ue.corked && (ue.corked = 1, this.uncork()), ue.ending || pe(this, ue, xe);
  };
  function _e(we) {
    return we.ending && we.length === 0 && we.bufferedRequest === null && !we.finished && !we.writing;
  }
  function se(we, Ee) {
    we._final(function(xe) {
      Ee.pendingcb--, xe && we.emit("error", xe), Ee.prefinished = !0, we.emit("prefinish"), de(we, Ee);
    });
  }
  function ce(we, Ee) {
    !Ee.prefinished && !Ee.finalCalled && (typeof we._final == "function" ? (Ee.pendingcb++, Ee.finalCalled = !0, c.nextTick(se, we, Ee)) : (Ee.prefinished = !0, we.emit("prefinish")));
  }
  function de(we, Ee) {
    var xe = _e(Ee);
    return xe && (ce(we, Ee), Ee.pendingcb === 0 && (Ee.finished = !0, we.emit("finish"))), xe;
  }
  function pe(we, Ee, xe) {
    Ee.ending = !0, de(we, Ee), xe && (Ee.finished ? c.nextTick(xe) : we.once("finish", xe)), Ee.ended = !0, we.writable = !1;
  }
  function ve(we, Ee, xe) {
    var ue = we.entry;
    for (we.entry = null; ue; ) {
      var ge = ue.callback;
      Ee.pendingcb--, ge(xe), ue = ue.next;
    }
    Ee.corkedRequestsFree.next = we;
  }
  return Object.defineProperty(Me.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(we) {
      this._writableState && (this._writableState.destroyed = we);
    }
  }), Me.prototype.destroy = Ae.destroy, Me.prototype._undestroy = Ae.undestroy, Me.prototype._destroy = function(we, Ee) {
    this.end(), Ee(we);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var c = requireProcessNextickArgs(), t = Object.keys || function(Ae) {
    var Se = [];
    for (var $e in Ae)
      Se.push($e);
    return Se;
  };
  _stream_duplex = me;
  var n = Object.create(requireUtil());
  n.inherits = inherits_browserExports;
  var ie = require_stream_readable(), fe = require_stream_writable();
  n.inherits(me, ie);
  for (var ae = t(fe.prototype), le = 0; le < ae.length; le++) {
    var he = ae[le];
    me.prototype[he] || (me.prototype[he] = fe.prototype[he]);
  }
  function me(Ae) {
    if (!(this instanceof me)) return new me(Ae);
    ie.call(this, Ae), fe.call(this, Ae), Ae && Ae.readable === !1 && (this.readable = !1), Ae && Ae.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, Ae && Ae.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", ye);
  }
  Object.defineProperty(me.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ye() {
    this.allowHalfOpen || this._writableState.ended || c.nextTick(be, this);
  }
  function be(Ae) {
    Ae.end();
  }
  return Object.defineProperty(me.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(Ae) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = Ae, this._writableState.destroyed = Ae);
    }
  }), me.prototype._destroy = function(Ae, Se) {
    this.push(null), this.end(), c.nextTick(Se, Ae);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var c = requireProcessNextickArgs();
  _stream_readable = Ie;
  var t = requireIsarray(), n;
  Ie.ReadableState = Te, requireEvents().EventEmitter;
  var ie = function(Ke, Ze) {
    return Ke.listeners(Ze).length;
  }, fe = requireStreamBrowser(), ae = requireSafeBuffer().Buffer, le = (typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function he(Ke) {
    return ae.from(Ke);
  }
  function me(Ke) {
    return ae.isBuffer(Ke) || Ke instanceof le;
  }
  var ye = Object.create(requireUtil());
  ye.inherits = inherits_browserExports;
  var be = requireUtil$1(), Ae = void 0;
  be && be.debuglog ? Ae = be.debuglog("stream") : Ae = function() {
  };
  var Se = requireBufferList(), $e = requireDestroy(), Re;
  ye.inherits(Ie, fe);
  var Me = ["error", "close", "destroy", "pause", "resume"];
  function ke(Ke, Ze, Ye) {
    if (typeof Ke.prependListener == "function") return Ke.prependListener(Ze, Ye);
    !Ke._events || !Ke._events[Ze] ? Ke.on(Ze, Ye) : t(Ke._events[Ze]) ? Ke._events[Ze].unshift(Ye) : Ke._events[Ze] = [Ye, Ke._events[Ze]];
  }
  function Te(Ke, Ze) {
    n = n || require_stream_duplex(), Ke = Ke || {};
    var Ye = Ze instanceof n;
    this.objectMode = !!Ke.objectMode, Ye && (this.objectMode = this.objectMode || !!Ke.readableObjectMode);
    var Pt = Ke.highWaterMark, Ft = Ke.readableHighWaterMark, Le = this.objectMode ? 16 : 16 * 1024;
    Pt || Pt === 0 ? this.highWaterMark = Pt : Ye && (Ft || Ft === 0) ? this.highWaterMark = Ft : this.highWaterMark = Le, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new Se(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = Ke.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ke.encoding && (Re || (Re = requireString_decoder().StringDecoder), this.decoder = new Re(Ke.encoding), this.encoding = Ke.encoding);
  }
  function Ie(Ke) {
    if (n = n || require_stream_duplex(), !(this instanceof Ie)) return new Ie(Ke);
    this._readableState = new Te(Ke, this), this.readable = !0, Ke && (typeof Ke.read == "function" && (this._read = Ke.read), typeof Ke.destroy == "function" && (this._destroy = Ke.destroy)), fe.call(this);
  }
  Object.defineProperty(Ie.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Ke) {
      this._readableState && (this._readableState.destroyed = Ke);
    }
  }), Ie.prototype.destroy = $e.destroy, Ie.prototype._undestroy = $e.undestroy, Ie.prototype._destroy = function(Ke, Ze) {
    this.push(null), Ze(Ke);
  }, Ie.prototype.push = function(Ke, Ze) {
    var Ye = this._readableState, Pt;
    return Ye.objectMode ? Pt = !0 : typeof Ke == "string" && (Ze = Ze || Ye.defaultEncoding, Ze !== Ye.encoding && (Ke = ae.from(Ke, Ze), Ze = ""), Pt = !0), qe(this, Ke, Ze, !1, Pt);
  }, Ie.prototype.unshift = function(Ke) {
    return qe(this, Ke, null, !0, !1);
  };
  function qe(Ke, Ze, Ye, Pt, Ft) {
    var Le = Ke._readableState;
    if (Ze === null)
      Le.reading = !1, jt(Ke, Le);
    else {
      var $t;
      Ft || ($t = ze(Le, Ze)), $t ? Ke.emit("error", $t) : Le.objectMode || Ze && Ze.length > 0 ? (typeof Ze != "string" && !Le.objectMode && Object.getPrototypeOf(Ze) !== ae.prototype && (Ze = he(Ze)), Pt ? Le.endEmitted ? Ke.emit("error", new Error("stream.unshift() after end event")) : Ue(Ke, Le, Ze, !0) : Le.ended ? Ke.emit("error", new Error("stream.push() after EOF")) : (Le.reading = !1, Le.decoder && !Ye ? (Ze = Le.decoder.write(Ze), Le.objectMode || Ze.length !== 0 ? Ue(Ke, Le, Ze, !1) : ce(Ke, Le)) : Ue(Ke, Le, Ze, !1))) : Pt || (Le.reading = !1);
    }
    return Ve(Le);
  }
  function Ue(Ke, Ze, Ye, Pt) {
    Ze.flowing && Ze.length === 0 && !Ze.sync ? (Ke.emit("data", Ye), Ke.read(0)) : (Ze.length += Ze.objectMode ? 1 : Ye.length, Pt ? Ze.buffer.unshift(Ye) : Ze.buffer.push(Ye), Ze.needReadable && _e(Ke)), ce(Ke, Ze);
  }
  function ze(Ke, Ze) {
    var Ye;
    return !me(Ze) && typeof Ze != "string" && Ze !== void 0 && !Ke.objectMode && (Ye = new TypeError("Invalid non-string/buffer chunk")), Ye;
  }
  function Ve(Ke) {
    return !Ke.ended && (Ke.needReadable || Ke.length < Ke.highWaterMark || Ke.length === 0);
  }
  Ie.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ie.prototype.setEncoding = function(Ke) {
    return Re || (Re = requireString_decoder().StringDecoder), this._readableState.decoder = new Re(Ke), this._readableState.encoding = Ke, this;
  };
  var Mt = 8388608;
  function Rt(Ke) {
    return Ke >= Mt ? Ke = Mt : (Ke--, Ke |= Ke >>> 1, Ke |= Ke >>> 2, Ke |= Ke >>> 4, Ke |= Ke >>> 8, Ke |= Ke >>> 16, Ke++), Ke;
  }
  function je(Ke, Ze) {
    return Ke <= 0 || Ze.length === 0 && Ze.ended ? 0 : Ze.objectMode ? 1 : Ke !== Ke ? Ze.flowing && Ze.length ? Ze.buffer.head.data.length : Ze.length : (Ke > Ze.highWaterMark && (Ze.highWaterMark = Rt(Ke)), Ke <= Ze.length ? Ke : Ze.ended ? Ze.length : (Ze.needReadable = !0, 0));
  }
  Ie.prototype.read = function(Ke) {
    Ae("read", Ke), Ke = parseInt(Ke, 10);
    var Ze = this._readableState, Ye = Ke;
    if (Ke !== 0 && (Ze.emittedReadable = !1), Ke === 0 && Ze.needReadable && (Ze.length >= Ze.highWaterMark || Ze.ended))
      return Ae("read: emitReadable", Ze.length, Ze.ended), Ze.length === 0 && Ze.ended ? Fe(this) : _e(this), null;
    if (Ke = je(Ke, Ze), Ke === 0 && Ze.ended)
      return Ze.length === 0 && Fe(this), null;
    var Pt = Ze.needReadable;
    Ae("need readable", Pt), (Ze.length === 0 || Ze.length - Ke < Ze.highWaterMark) && (Pt = !0, Ae("length less than watermark", Pt)), Ze.ended || Ze.reading ? (Pt = !1, Ae("reading or ended", Pt)) : Pt && (Ae("do read"), Ze.reading = !0, Ze.sync = !0, Ze.length === 0 && (Ze.needReadable = !0), this._read(Ze.highWaterMark), Ze.sync = !1, Ze.reading || (Ke = je(Ye, Ze)));
    var Ft;
    return Ke > 0 ? Ft = ue(Ke, Ze) : Ft = null, Ft === null ? (Ze.needReadable = !0, Ke = 0) : Ze.length -= Ke, Ze.length === 0 && (Ze.ended || (Ze.needReadable = !0), Ye !== Ke && Ze.ended && Fe(this)), Ft !== null && this.emit("data", Ft), Ft;
  };
  function jt(Ke, Ze) {
    if (!Ze.ended) {
      if (Ze.decoder) {
        var Ye = Ze.decoder.end();
        Ye && Ye.length && (Ze.buffer.push(Ye), Ze.length += Ze.objectMode ? 1 : Ye.length);
      }
      Ze.ended = !0, _e(Ke);
    }
  }
  function _e(Ke) {
    var Ze = Ke._readableState;
    Ze.needReadable = !1, Ze.emittedReadable || (Ae("emitReadable", Ze.flowing), Ze.emittedReadable = !0, Ze.sync ? c.nextTick(se, Ke) : se(Ke));
  }
  function se(Ke) {
    Ae("emit readable"), Ke.emit("readable"), xe(Ke);
  }
  function ce(Ke, Ze) {
    Ze.readingMore || (Ze.readingMore = !0, c.nextTick(de, Ke, Ze));
  }
  function de(Ke, Ze) {
    for (var Ye = Ze.length; !Ze.reading && !Ze.flowing && !Ze.ended && Ze.length < Ze.highWaterMark && (Ae("maybeReadMore read 0"), Ke.read(0), Ye !== Ze.length); )
      Ye = Ze.length;
    Ze.readingMore = !1;
  }
  Ie.prototype._read = function(Ke) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Ie.prototype.pipe = function(Ke, Ze) {
    var Ye = this, Pt = this._readableState;
    switch (Pt.pipesCount) {
      case 0:
        Pt.pipes = Ke;
        break;
      case 1:
        Pt.pipes = [Pt.pipes, Ke];
        break;
      default:
        Pt.pipes.push(Ke);
        break;
    }
    Pt.pipesCount += 1, Ae("pipe count=%d opts=%j", Pt.pipesCount, Ze);
    var Ft = (!Ze || Ze.end !== !1) && Ke !== process$1.stdout && Ke !== process$1.stderr, Le = Ft ? Jt : wn;
    Pt.endEmitted ? c.nextTick(Le) : Ye.once("end", Le), Ke.on("unpipe", $t);
    function $t(Qe, Dt) {
      Ae("onunpipe"), Qe === Ye && Dt && Dt.hasUnpiped === !1 && (Dt.hasUnpiped = !0, xn());
    }
    function Jt() {
      Ae("onend"), Ke.end();
    }
    var Ht = pe(Ye);
    Ke.on("drain", Ht);
    var Vt = !1;
    function xn() {
      Ae("cleanup"), Ke.removeListener("close", Qt), Ke.removeListener("finish", Xt), Ke.removeListener("drain", Ht), Ke.removeListener("error", An), Ke.removeListener("unpipe", $t), Ye.removeListener("end", Jt), Ye.removeListener("end", wn), Ye.removeListener("data", Gt), Vt = !0, Pt.awaitDrain && (!Ke._writableState || Ke._writableState.needDrain) && Ht();
    }
    var Zt = !1;
    Ye.on("data", Gt);
    function Gt(Qe) {
      Ae("ondata"), Zt = !1;
      var Dt = Ke.write(Qe);
      Dt === !1 && !Zt && ((Pt.pipesCount === 1 && Pt.pipes === Ke || Pt.pipesCount > 1 && Je(Pt.pipes, Ke) !== -1) && !Vt && (Ae("false write response, pause", Pt.awaitDrain), Pt.awaitDrain++, Zt = !0), Ye.pause());
    }
    function An(Qe) {
      Ae("onerror", Qe), wn(), Ke.removeListener("error", An), ie(Ke, "error") === 0 && Ke.emit("error", Qe);
    }
    ke(Ke, "error", An);
    function Qt() {
      Ke.removeListener("finish", Xt), wn();
    }
    Ke.once("close", Qt);
    function Xt() {
      Ae("onfinish"), Ke.removeListener("close", Qt), wn();
    }
    Ke.once("finish", Xt);
    function wn() {
      Ae("unpipe"), Ye.unpipe(Ke);
    }
    return Ke.emit("pipe", Ye), Pt.flowing || (Ae("pipe resume"), Ye.resume()), Ke;
  };
  function pe(Ke) {
    return function() {
      var Ze = Ke._readableState;
      Ae("pipeOnDrain", Ze.awaitDrain), Ze.awaitDrain && Ze.awaitDrain--, Ze.awaitDrain === 0 && ie(Ke, "data") && (Ze.flowing = !0, xe(Ke));
    };
  }
  Ie.prototype.unpipe = function(Ke) {
    var Ze = this._readableState, Ye = { hasUnpiped: !1 };
    if (Ze.pipesCount === 0) return this;
    if (Ze.pipesCount === 1)
      return Ke && Ke !== Ze.pipes ? this : (Ke || (Ke = Ze.pipes), Ze.pipes = null, Ze.pipesCount = 0, Ze.flowing = !1, Ke && Ke.emit("unpipe", this, Ye), this);
    if (!Ke) {
      var Pt = Ze.pipes, Ft = Ze.pipesCount;
      Ze.pipes = null, Ze.pipesCount = 0, Ze.flowing = !1;
      for (var Le = 0; Le < Ft; Le++)
        Pt[Le].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var $t = Je(Ze.pipes, Ke);
    return $t === -1 ? this : (Ze.pipes.splice($t, 1), Ze.pipesCount -= 1, Ze.pipesCount === 1 && (Ze.pipes = Ze.pipes[0]), Ke.emit("unpipe", this, Ye), this);
  }, Ie.prototype.on = function(Ke, Ze) {
    var Ye = fe.prototype.on.call(this, Ke, Ze);
    if (Ke === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (Ke === "readable") {
      var Pt = this._readableState;
      !Pt.endEmitted && !Pt.readableListening && (Pt.readableListening = Pt.needReadable = !0, Pt.emittedReadable = !1, Pt.reading ? Pt.length && _e(this) : c.nextTick(ve, this));
    }
    return Ye;
  }, Ie.prototype.addListener = Ie.prototype.on;
  function ve(Ke) {
    Ae("readable nexttick read 0"), Ke.read(0);
  }
  Ie.prototype.resume = function() {
    var Ke = this._readableState;
    return Ke.flowing || (Ae("resume"), Ke.flowing = !0, we(this, Ke)), this;
  };
  function we(Ke, Ze) {
    Ze.resumeScheduled || (Ze.resumeScheduled = !0, c.nextTick(Ee, Ke, Ze));
  }
  function Ee(Ke, Ze) {
    Ze.reading || (Ae("resume read 0"), Ke.read(0)), Ze.resumeScheduled = !1, Ze.awaitDrain = 0, Ke.emit("resume"), xe(Ke), Ze.flowing && !Ze.reading && Ke.read(0);
  }
  Ie.prototype.pause = function() {
    return Ae("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Ae("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function xe(Ke) {
    var Ze = Ke._readableState;
    for (Ae("flow", Ze.flowing); Ze.flowing && Ke.read() !== null; )
      ;
  }
  Ie.prototype.wrap = function(Ke) {
    var Ze = this, Ye = this._readableState, Pt = !1;
    Ke.on("end", function() {
      if (Ae("wrapped end"), Ye.decoder && !Ye.ended) {
        var $t = Ye.decoder.end();
        $t && $t.length && Ze.push($t);
      }
      Ze.push(null);
    }), Ke.on("data", function($t) {
      if (Ae("wrapped data"), Ye.decoder && ($t = Ye.decoder.write($t)), !(Ye.objectMode && $t == null) && !(!Ye.objectMode && (!$t || !$t.length))) {
        var Jt = Ze.push($t);
        Jt || (Pt = !0, Ke.pause());
      }
    });
    for (var Ft in Ke)
      this[Ft] === void 0 && typeof Ke[Ft] == "function" && (this[Ft] = /* @__PURE__ */ function($t) {
        return function() {
          return Ke[$t].apply(Ke, arguments);
        };
      }(Ft));
    for (var Le = 0; Le < Me.length; Le++)
      Ke.on(Me[Le], this.emit.bind(this, Me[Le]));
    return this._read = function($t) {
      Ae("wrapped _read", $t), Pt && (Pt = !1, Ke.resume());
    }, this;
  }, Object.defineProperty(Ie.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Ie._fromList = ue;
  function ue(Ke, Ze) {
    if (Ze.length === 0) return null;
    var Ye;
    return Ze.objectMode ? Ye = Ze.buffer.shift() : !Ke || Ke >= Ze.length ? (Ze.decoder ? Ye = Ze.buffer.join("") : Ze.buffer.length === 1 ? Ye = Ze.buffer.head.data : Ye = Ze.buffer.concat(Ze.length), Ze.buffer.clear()) : Ye = ge(Ke, Ze.buffer, Ze.decoder), Ye;
  }
  function ge(Ke, Ze, Ye) {
    var Pt;
    return Ke < Ze.head.data.length ? (Pt = Ze.head.data.slice(0, Ke), Ze.head.data = Ze.head.data.slice(Ke)) : Ke === Ze.head.data.length ? Pt = Ze.shift() : Pt = Ye ? Be(Ke, Ze) : Ne(Ke, Ze), Pt;
  }
  function Be(Ke, Ze) {
    var Ye = Ze.head, Pt = 1, Ft = Ye.data;
    for (Ke -= Ft.length; Ye = Ye.next; ) {
      var Le = Ye.data, $t = Ke > Le.length ? Le.length : Ke;
      if ($t === Le.length ? Ft += Le : Ft += Le.slice(0, Ke), Ke -= $t, Ke === 0) {
        $t === Le.length ? (++Pt, Ye.next ? Ze.head = Ye.next : Ze.head = Ze.tail = null) : (Ze.head = Ye, Ye.data = Le.slice($t));
        break;
      }
      ++Pt;
    }
    return Ze.length -= Pt, Ft;
  }
  function Ne(Ke, Ze) {
    var Ye = ae.allocUnsafe(Ke), Pt = Ze.head, Ft = 1;
    for (Pt.data.copy(Ye), Ke -= Pt.data.length; Pt = Pt.next; ) {
      var Le = Pt.data, $t = Ke > Le.length ? Le.length : Ke;
      if (Le.copy(Ye, Ye.length - Ke, 0, $t), Ke -= $t, Ke === 0) {
        $t === Le.length ? (++Ft, Pt.next ? Ze.head = Pt.next : Ze.head = Ze.tail = null) : (Ze.head = Pt, Pt.data = Le.slice($t));
        break;
      }
      ++Ft;
    }
    return Ze.length -= Ft, Ye;
  }
  function Fe(Ke) {
    var Ze = Ke._readableState;
    if (Ze.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Ze.endEmitted || (Ze.ended = !0, c.nextTick(Pe, Ze, Ke));
  }
  function Pe(Ke, Ze) {
    !Ke.endEmitted && Ke.length === 0 && (Ke.endEmitted = !0, Ze.readable = !1, Ze.emit("end"));
  }
  function Je(Ke, Ze) {
    for (var Ye = 0, Pt = Ke.length; Ye < Pt; Ye++)
      if (Ke[Ye] === Ze) return Ye;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = ie;
  var c = require_stream_duplex(), t = Object.create(requireUtil());
  t.inherits = inherits_browserExports, t.inherits(ie, c);
  function n(le, he) {
    var me = this._transformState;
    me.transforming = !1;
    var ye = me.writecb;
    if (!ye)
      return this.emit("error", new Error("write callback called multiple times"));
    me.writechunk = null, me.writecb = null, he != null && this.push(he), ye(le);
    var be = this._readableState;
    be.reading = !1, (be.needReadable || be.length < be.highWaterMark) && this._read(be.highWaterMark);
  }
  function ie(le) {
    if (!(this instanceof ie)) return new ie(le);
    c.call(this, le), this._transformState = {
      afterTransform: n.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, le && (typeof le.transform == "function" && (this._transform = le.transform), typeof le.flush == "function" && (this._flush = le.flush)), this.on("prefinish", fe);
  }
  function fe() {
    var le = this;
    typeof this._flush == "function" ? this._flush(function(he, me) {
      ae(le, he, me);
    }) : ae(this, null, null);
  }
  ie.prototype.push = function(le, he) {
    return this._transformState.needTransform = !1, c.prototype.push.call(this, le, he);
  }, ie.prototype._transform = function(le, he, me) {
    throw new Error("_transform() is not implemented");
  }, ie.prototype._write = function(le, he, me) {
    var ye = this._transformState;
    if (ye.writecb = me, ye.writechunk = le, ye.writeencoding = he, !ye.transforming) {
      var be = this._readableState;
      (ye.needTransform || be.needReadable || be.length < be.highWaterMark) && this._read(be.highWaterMark);
    }
  }, ie.prototype._read = function(le) {
    var he = this._transformState;
    he.writechunk !== null && he.writecb && !he.transforming ? (he.transforming = !0, this._transform(he.writechunk, he.writeencoding, he.afterTransform)) : he.needTransform = !0;
  }, ie.prototype._destroy = function(le, he) {
    var me = this;
    c.prototype._destroy.call(this, le, function(ye) {
      he(ye), me.emit("close");
    });
  };
  function ae(le, he, me) {
    if (he) return le.emit("error", he);
    if (me != null && le.push(me), le._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (le._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return le.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = n;
  var c = require_stream_transform(), t = Object.create(requireUtil());
  t.inherits = inherits_browserExports, t.inherits(n, c);
  function n(ie) {
    if (!(this instanceof n)) return new n(ie);
    c.call(this, ie);
  }
  return n.prototype._transform = function(ie, fe, ae) {
    ae(null, ie);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(c, t) {
    t = c.exports = require_stream_readable(), t.Stream = t, t.Readable = t, t.Writable = require_stream_writable(), t.Duplex = require_stream_duplex(), t.Transform = require_stream_transform(), t.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign = { exports: {} }, browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var c = bnExports$3, t = requireBrowser$b(), n = safeBufferExports.Buffer;
  function ie(le) {
    var he = le.modulus.byteLength(), me;
    do
      me = new c(t(he));
    while (me.cmp(le.modulus) >= 0 || !me.umod(le.prime1) || !me.umod(le.prime2));
    return me;
  }
  function fe(le) {
    var he = ie(le), me = he.toRed(c.mont(le.modulus)).redPow(new c(le.publicExponent)).fromRed();
    return { blinder: me, unblinder: he.invm(le.modulus) };
  }
  function ae(le, he) {
    var me = fe(he), ye = he.modulus.byteLength(), be = new c(le).mul(me.blinder).umod(he.modulus), Ae = be.toRed(c.mont(he.prime1)), Se = be.toRed(c.mont(he.prime2)), $e = he.coefficient, Re = he.prime1, Me = he.prime2, ke = Ae.redPow(he.exponent1).fromRed(), Te = Se.redPow(he.exponent2).fromRed(), Ie = ke.isub(Te).imul($e).umod(Re).imul(Me);
    return Te.iadd(Ie).imul(me.unblinder).umod(he.modulus).toArrayLike(n, "be", ye);
  }
  return ae.getr = ie, browserifyRsa = ae, browserifyRsa;
}
var elliptic$1 = {};
const name$1 = "elliptic", version$4 = "6.6.1", description$1 = "EC cryptography", main$1 = "lib/elliptic.js", files$1 = [
  "lib"
], scripts$1 = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository$1 = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords$1 = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author$1 = "Fedor Indutny <fedor@indutny.com>", license$1 = "MIT", bugs$1 = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage$1 = "https://github.com/indutny/elliptic", devDependencies$1 = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies$1 = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$1 = {
  name: name$1,
  version: version$4,
  description: description$1,
  main: main$1,
  files: files$1,
  scripts: scripts$1,
  repository: repository$1,
  keywords: keywords$1,
  author: author$1,
  license: license$1,
  bugs: bugs$1,
  homepage: homepage$1,
  devDependencies: devDependencies$1,
  dependencies: dependencies$1
};
var utils$c = {}, bn$4 = { exports: {} };
bn$4.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn$4)), bn$4.exports;
}
var utils$b = {};
(function(c) {
  var t = c;
  function n(ae, le) {
    if (Array.isArray(ae))
      return ae.slice();
    if (!ae)
      return [];
    var he = [];
    if (typeof ae != "string") {
      for (var me = 0; me < ae.length; me++)
        he[me] = ae[me] | 0;
      return he;
    }
    if (le === "hex") {
      ae = ae.replace(/[^a-z0-9]+/ig, ""), ae.length % 2 !== 0 && (ae = "0" + ae);
      for (var me = 0; me < ae.length; me += 2)
        he.push(parseInt(ae[me] + ae[me + 1], 16));
    } else
      for (var me = 0; me < ae.length; me++) {
        var ye = ae.charCodeAt(me), be = ye >> 8, Ae = ye & 255;
        be ? he.push(be, Ae) : he.push(Ae);
      }
    return he;
  }
  t.toArray = n;
  function ie(ae) {
    return ae.length === 1 ? "0" + ae : ae;
  }
  t.zero2 = ie;
  function fe(ae) {
    for (var le = "", he = 0; he < ae.length; he++)
      le += ie(ae[he].toString(16));
    return le;
  }
  t.toHex = fe, t.encode = function(le, he) {
    return he === "hex" ? fe(le) : le;
  };
})(utils$b);
var hasRequiredUtils;
function requireUtils() {
  return hasRequiredUtils || (hasRequiredUtils = 1, function(c) {
    var t = c, n = requireBn$3(), ie = minimalisticAssert$1, fe = utils$b;
    t.assert = ie, t.toArray = fe.toArray, t.zero2 = fe.zero2, t.toHex = fe.toHex, t.encode = fe.encode;
    function ae(be, Ae, Se) {
      var $e = new Array(Math.max(be.bitLength(), Se) + 1), Re;
      for (Re = 0; Re < $e.length; Re += 1)
        $e[Re] = 0;
      var Me = 1 << Ae + 1, ke = be.clone();
      for (Re = 0; Re < $e.length; Re++) {
        var Te, Ie = ke.andln(Me - 1);
        ke.isOdd() ? (Ie > (Me >> 1) - 1 ? Te = (Me >> 1) - Ie : Te = Ie, ke.isubn(Te)) : Te = 0, $e[Re] = Te, ke.iushrn(1);
      }
      return $e;
    }
    t.getNAF = ae;
    function le(be, Ae) {
      var Se = [
        [],
        []
      ];
      be = be.clone(), Ae = Ae.clone();
      for (var $e = 0, Re = 0, Me; be.cmpn(-$e) > 0 || Ae.cmpn(-Re) > 0; ) {
        var ke = be.andln(3) + $e & 3, Te = Ae.andln(3) + Re & 3;
        ke === 3 && (ke = -1), Te === 3 && (Te = -1);
        var Ie;
        ke & 1 ? (Me = be.andln(7) + $e & 7, (Me === 3 || Me === 5) && Te === 2 ? Ie = -ke : Ie = ke) : Ie = 0, Se[0].push(Ie);
        var qe;
        Te & 1 ? (Me = Ae.andln(7) + Re & 7, (Me === 3 || Me === 5) && ke === 2 ? qe = -Te : qe = Te) : qe = 0, Se[1].push(qe), 2 * $e === Ie + 1 && ($e = 1 - $e), 2 * Re === qe + 1 && (Re = 1 - Re), be.iushrn(1), Ae.iushrn(1);
      }
      return Se;
    }
    t.getJSF = le;
    function he(be, Ae, Se) {
      var $e = "_" + Ae;
      be.prototype[Ae] = function() {
        return this[$e] !== void 0 ? this[$e] : this[$e] = Se.call(this);
      };
    }
    t.cachedProperty = he;
    function me(be) {
      return typeof be == "string" ? t.toArray(be, "hex") : be;
    }
    t.parseBytes = me;
    function ye(be) {
      return new n(be, "hex", "le");
    }
    t.intFromLE = ye;
  }(utils$c)), utils$c;
}
var curve$1 = {}, base$2, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1) return base$2;
  hasRequiredBase$1 = 1;
  var c = requireBn$3(), t = requireUtils(), n = t.getNAF, ie = t.getJSF, fe = t.assert;
  function ae(he, me) {
    this.type = he, this.p = new c(me.p, 16), this.red = me.prime ? c.red(me.prime) : c.mont(this.p), this.zero = new c(0).toRed(this.red), this.one = new c(1).toRed(this.red), this.two = new c(2).toRed(this.red), this.n = me.n && new c(me.n, 16), this.g = me.g && this.pointFromJSON(me.g, me.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var ye = this.n && this.p.div(this.n);
    !ye || ye.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$2 = ae, ae.prototype.point = function() {
    throw new Error("Not implemented");
  }, ae.prototype.validate = function() {
    throw new Error("Not implemented");
  }, ae.prototype._fixedNafMul = function(me, ye) {
    fe(me.precomputed);
    var be = me._getDoubles(), Ae = n(ye, 1, this._bitLength), Se = (1 << be.step + 1) - (be.step % 2 === 0 ? 2 : 1);
    Se /= 3;
    var $e = [], Re, Me;
    for (Re = 0; Re < Ae.length; Re += be.step) {
      Me = 0;
      for (var ke = Re + be.step - 1; ke >= Re; ke--)
        Me = (Me << 1) + Ae[ke];
      $e.push(Me);
    }
    for (var Te = this.jpoint(null, null, null), Ie = this.jpoint(null, null, null), qe = Se; qe > 0; qe--) {
      for (Re = 0; Re < $e.length; Re++)
        Me = $e[Re], Me === qe ? Ie = Ie.mixedAdd(be.points[Re]) : Me === -qe && (Ie = Ie.mixedAdd(be.points[Re].neg()));
      Te = Te.add(Ie);
    }
    return Te.toP();
  }, ae.prototype._wnafMul = function(me, ye) {
    var be = 4, Ae = me._getNAFPoints(be);
    be = Ae.wnd;
    for (var Se = Ae.points, $e = n(ye, be, this._bitLength), Re = this.jpoint(null, null, null), Me = $e.length - 1; Me >= 0; Me--) {
      for (var ke = 0; Me >= 0 && $e[Me] === 0; Me--)
        ke++;
      if (Me >= 0 && ke++, Re = Re.dblp(ke), Me < 0)
        break;
      var Te = $e[Me];
      fe(Te !== 0), me.type === "affine" ? Te > 0 ? Re = Re.mixedAdd(Se[Te - 1 >> 1]) : Re = Re.mixedAdd(Se[-Te - 1 >> 1].neg()) : Te > 0 ? Re = Re.add(Se[Te - 1 >> 1]) : Re = Re.add(Se[-Te - 1 >> 1].neg());
    }
    return me.type === "affine" ? Re.toP() : Re;
  }, ae.prototype._wnafMulAdd = function(me, ye, be, Ae, Se) {
    var $e = this._wnafT1, Re = this._wnafT2, Me = this._wnafT3, ke = 0, Te, Ie, qe;
    for (Te = 0; Te < Ae; Te++) {
      qe = ye[Te];
      var Ue = qe._getNAFPoints(me);
      $e[Te] = Ue.wnd, Re[Te] = Ue.points;
    }
    for (Te = Ae - 1; Te >= 1; Te -= 2) {
      var ze = Te - 1, Ve = Te;
      if ($e[ze] !== 1 || $e[Ve] !== 1) {
        Me[ze] = n(be[ze], $e[ze], this._bitLength), Me[Ve] = n(be[Ve], $e[Ve], this._bitLength), ke = Math.max(Me[ze].length, ke), ke = Math.max(Me[Ve].length, ke);
        continue;
      }
      var Mt = [
        ye[ze],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        ye[Ve]
        /* 7 */
      ];
      ye[ze].y.cmp(ye[Ve].y) === 0 ? (Mt[1] = ye[ze].add(ye[Ve]), Mt[2] = ye[ze].toJ().mixedAdd(ye[Ve].neg())) : ye[ze].y.cmp(ye[Ve].y.redNeg()) === 0 ? (Mt[1] = ye[ze].toJ().mixedAdd(ye[Ve]), Mt[2] = ye[ze].add(ye[Ve].neg())) : (Mt[1] = ye[ze].toJ().mixedAdd(ye[Ve]), Mt[2] = ye[ze].toJ().mixedAdd(ye[Ve].neg()));
      var Rt = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], je = ie(be[ze], be[Ve]);
      for (ke = Math.max(je[0].length, ke), Me[ze] = new Array(ke), Me[Ve] = new Array(ke), Ie = 0; Ie < ke; Ie++) {
        var jt = je[0][Ie] | 0, _e = je[1][Ie] | 0;
        Me[ze][Ie] = Rt[(jt + 1) * 3 + (_e + 1)], Me[Ve][Ie] = 0, Re[ze] = Mt;
      }
    }
    var se = this.jpoint(null, null, null), ce = this._wnafT4;
    for (Te = ke; Te >= 0; Te--) {
      for (var de = 0; Te >= 0; ) {
        var pe = !0;
        for (Ie = 0; Ie < Ae; Ie++)
          ce[Ie] = Me[Ie][Te] | 0, ce[Ie] !== 0 && (pe = !1);
        if (!pe)
          break;
        de++, Te--;
      }
      if (Te >= 0 && de++, se = se.dblp(de), Te < 0)
        break;
      for (Ie = 0; Ie < Ae; Ie++) {
        var ve = ce[Ie];
        ve !== 0 && (ve > 0 ? qe = Re[Ie][ve - 1 >> 1] : ve < 0 && (qe = Re[Ie][-ve - 1 >> 1].neg()), qe.type === "affine" ? se = se.mixedAdd(qe) : se = se.add(qe));
      }
    }
    for (Te = 0; Te < Ae; Te++)
      Re[Te] = null;
    return Se ? se : se.toP();
  };
  function le(he, me) {
    this.curve = he, this.type = me, this.precomputed = null;
  }
  return ae.BasePoint = le, le.prototype.eq = function() {
    throw new Error("Not implemented");
  }, le.prototype.validate = function() {
    return this.curve.validate(this);
  }, ae.prototype.decodePoint = function(me, ye) {
    me = t.toArray(me, ye);
    var be = this.p.byteLength();
    if ((me[0] === 4 || me[0] === 6 || me[0] === 7) && me.length - 1 === 2 * be) {
      me[0] === 6 ? fe(me[me.length - 1] % 2 === 0) : me[0] === 7 && fe(me[me.length - 1] % 2 === 1);
      var Ae = this.point(
        me.slice(1, 1 + be),
        me.slice(1 + be, 1 + 2 * be)
      );
      return Ae;
    } else if ((me[0] === 2 || me[0] === 3) && me.length - 1 === be)
      return this.pointFromX(me.slice(1, 1 + be), me[0] === 3);
    throw new Error("Unknown point format");
  }, le.prototype.encodeCompressed = function(me) {
    return this.encode(me, !0);
  }, le.prototype._encode = function(me) {
    var ye = this.curve.p.byteLength(), be = this.getX().toArray("be", ye);
    return me ? [this.getY().isEven() ? 2 : 3].concat(be) : [4].concat(be, this.getY().toArray("be", ye));
  }, le.prototype.encode = function(me, ye) {
    return t.encode(this._encode(ye), me);
  }, le.prototype.precompute = function(me) {
    if (this.precomputed)
      return this;
    var ye = {
      doubles: null,
      naf: null,
      beta: null
    };
    return ye.naf = this._getNAFPoints(8), ye.doubles = this._getDoubles(4, me), ye.beta = this._getBeta(), this.precomputed = ye, this;
  }, le.prototype._hasDoubles = function(me) {
    if (!this.precomputed)
      return !1;
    var ye = this.precomputed.doubles;
    return ye ? ye.points.length >= Math.ceil((me.bitLength() + 1) / ye.step) : !1;
  }, le.prototype._getDoubles = function(me, ye) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var be = [this], Ae = this, Se = 0; Se < ye; Se += me) {
      for (var $e = 0; $e < me; $e++)
        Ae = Ae.dbl();
      be.push(Ae);
    }
    return {
      step: me,
      points: be
    };
  }, le.prototype._getNAFPoints = function(me) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var ye = [this], be = (1 << me) - 1, Ae = be === 1 ? null : this.dbl(), Se = 1; Se < be; Se++)
      ye[Se] = ye[Se - 1].add(Ae);
    return {
      wnd: me,
      points: ye
    };
  }, le.prototype._getBeta = function() {
    return null;
  }, le.prototype.dblp = function(me) {
    for (var ye = this, be = 0; be < me; be++)
      ye = ye.dbl();
    return ye;
  }, base$2;
}
var short$1, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort) return short$1;
  hasRequiredShort = 1;
  var c = requireUtils(), t = requireBn$3(), n = inherits_browserExports, ie = requireBase$1(), fe = c.assert;
  function ae(me) {
    ie.call(this, "short", me), this.a = new t(me.a, 16).toRed(this.red), this.b = new t(me.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(me), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  n(ae, ie), short$1 = ae, ae.prototype._getEndomorphism = function(ye) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var be, Ae;
      if (ye.beta)
        be = new t(ye.beta, 16).toRed(this.red);
      else {
        var Se = this._getEndoRoots(this.p);
        be = Se[0].cmp(Se[1]) < 0 ? Se[0] : Se[1], be = be.toRed(this.red);
      }
      if (ye.lambda)
        Ae = new t(ye.lambda, 16);
      else {
        var $e = this._getEndoRoots(this.n);
        this.g.mul($e[0]).x.cmp(this.g.x.redMul(be)) === 0 ? Ae = $e[0] : (Ae = $e[1], fe(this.g.mul(Ae).x.cmp(this.g.x.redMul(be)) === 0));
      }
      var Re;
      return ye.basis ? Re = ye.basis.map(function(Me) {
        return {
          a: new t(Me.a, 16),
          b: new t(Me.b, 16)
        };
      }) : Re = this._getEndoBasis(Ae), {
        beta: be,
        lambda: Ae,
        basis: Re
      };
    }
  }, ae.prototype._getEndoRoots = function(ye) {
    var be = ye === this.p ? this.red : t.mont(ye), Ae = new t(2).toRed(be).redInvm(), Se = Ae.redNeg(), $e = new t(3).toRed(be).redNeg().redSqrt().redMul(Ae), Re = Se.redAdd($e).fromRed(), Me = Se.redSub($e).fromRed();
    return [Re, Me];
  }, ae.prototype._getEndoBasis = function(ye) {
    for (var be = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), Ae = ye, Se = this.n.clone(), $e = new t(1), Re = new t(0), Me = new t(0), ke = new t(1), Te, Ie, qe, Ue, ze, Ve, Mt, Rt = 0, je, jt; Ae.cmpn(0) !== 0; ) {
      var _e = Se.div(Ae);
      je = Se.sub(_e.mul(Ae)), jt = Me.sub(_e.mul($e));
      var se = ke.sub(_e.mul(Re));
      if (!qe && je.cmp(be) < 0)
        Te = Mt.neg(), Ie = $e, qe = je.neg(), Ue = jt;
      else if (qe && ++Rt === 2)
        break;
      Mt = je, Se = Ae, Ae = je, Me = $e, $e = jt, ke = Re, Re = se;
    }
    ze = je.neg(), Ve = jt;
    var ce = qe.sqr().add(Ue.sqr()), de = ze.sqr().add(Ve.sqr());
    return de.cmp(ce) >= 0 && (ze = Te, Ve = Ie), qe.negative && (qe = qe.neg(), Ue = Ue.neg()), ze.negative && (ze = ze.neg(), Ve = Ve.neg()), [
      { a: qe, b: Ue },
      { a: ze, b: Ve }
    ];
  }, ae.prototype._endoSplit = function(ye) {
    var be = this.endo.basis, Ae = be[0], Se = be[1], $e = Se.b.mul(ye).divRound(this.n), Re = Ae.b.neg().mul(ye).divRound(this.n), Me = $e.mul(Ae.a), ke = Re.mul(Se.a), Te = $e.mul(Ae.b), Ie = Re.mul(Se.b), qe = ye.sub(Me).sub(ke), Ue = Te.add(Ie).neg();
    return { k1: qe, k2: Ue };
  }, ae.prototype.pointFromX = function(ye, be) {
    ye = new t(ye, 16), ye.red || (ye = ye.toRed(this.red));
    var Ae = ye.redSqr().redMul(ye).redIAdd(ye.redMul(this.a)).redIAdd(this.b), Se = Ae.redSqrt();
    if (Se.redSqr().redSub(Ae).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var $e = Se.fromRed().isOdd();
    return (be && !$e || !be && $e) && (Se = Se.redNeg()), this.point(ye, Se);
  }, ae.prototype.validate = function(ye) {
    if (ye.inf)
      return !0;
    var be = ye.x, Ae = ye.y, Se = this.a.redMul(be), $e = be.redSqr().redMul(be).redIAdd(Se).redIAdd(this.b);
    return Ae.redSqr().redISub($e).cmpn(0) === 0;
  }, ae.prototype._endoWnafMulAdd = function(ye, be, Ae) {
    for (var Se = this._endoWnafT1, $e = this._endoWnafT2, Re = 0; Re < ye.length; Re++) {
      var Me = this._endoSplit(be[Re]), ke = ye[Re], Te = ke._getBeta();
      Me.k1.negative && (Me.k1.ineg(), ke = ke.neg(!0)), Me.k2.negative && (Me.k2.ineg(), Te = Te.neg(!0)), Se[Re * 2] = ke, Se[Re * 2 + 1] = Te, $e[Re * 2] = Me.k1, $e[Re * 2 + 1] = Me.k2;
    }
    for (var Ie = this._wnafMulAdd(1, Se, $e, Re * 2, Ae), qe = 0; qe < Re * 2; qe++)
      Se[qe] = null, $e[qe] = null;
    return Ie;
  };
  function le(me, ye, be, Ae) {
    ie.BasePoint.call(this, me, "affine"), ye === null && be === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new t(ye, 16), this.y = new t(be, 16), Ae && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  n(le, ie.BasePoint), ae.prototype.point = function(ye, be, Ae) {
    return new le(this, ye, be, Ae);
  }, ae.prototype.pointFromJSON = function(ye, be) {
    return le.fromJSON(this, ye, be);
  }, le.prototype._getBeta = function() {
    if (this.curve.endo) {
      var ye = this.precomputed;
      if (ye && ye.beta)
        return ye.beta;
      var be = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (ye) {
        var Ae = this.curve, Se = function($e) {
          return Ae.point($e.x.redMul(Ae.endo.beta), $e.y);
        };
        ye.beta = be, be.precomputed = {
          beta: null,
          naf: ye.naf && {
            wnd: ye.naf.wnd,
            points: ye.naf.points.map(Se)
          },
          doubles: ye.doubles && {
            step: ye.doubles.step,
            points: ye.doubles.points.map(Se)
          }
        };
      }
      return be;
    }
  }, le.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, le.fromJSON = function(ye, be, Ae) {
    typeof be == "string" && (be = JSON.parse(be));
    var Se = ye.point(be[0], be[1], Ae);
    if (!be[2])
      return Se;
    function $e(Me) {
      return ye.point(Me[0], Me[1], Ae);
    }
    var Re = be[2];
    return Se.precomputed = {
      beta: null,
      doubles: Re.doubles && {
        step: Re.doubles.step,
        points: [Se].concat(Re.doubles.points.map($e))
      },
      naf: Re.naf && {
        wnd: Re.naf.wnd,
        points: [Se].concat(Re.naf.points.map($e))
      }
    }, Se;
  }, le.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, le.prototype.isInfinity = function() {
    return this.inf;
  }, le.prototype.add = function(ye) {
    if (this.inf)
      return ye;
    if (ye.inf)
      return this;
    if (this.eq(ye))
      return this.dbl();
    if (this.neg().eq(ye))
      return this.curve.point(null, null);
    if (this.x.cmp(ye.x) === 0)
      return this.curve.point(null, null);
    var be = this.y.redSub(ye.y);
    be.cmpn(0) !== 0 && (be = be.redMul(this.x.redSub(ye.x).redInvm()));
    var Ae = be.redSqr().redISub(this.x).redISub(ye.x), Se = be.redMul(this.x.redSub(Ae)).redISub(this.y);
    return this.curve.point(Ae, Se);
  }, le.prototype.dbl = function() {
    if (this.inf)
      return this;
    var ye = this.y.redAdd(this.y);
    if (ye.cmpn(0) === 0)
      return this.curve.point(null, null);
    var be = this.curve.a, Ae = this.x.redSqr(), Se = ye.redInvm(), $e = Ae.redAdd(Ae).redIAdd(Ae).redIAdd(be).redMul(Se), Re = $e.redSqr().redISub(this.x.redAdd(this.x)), Me = $e.redMul(this.x.redSub(Re)).redISub(this.y);
    return this.curve.point(Re, Me);
  }, le.prototype.getX = function() {
    return this.x.fromRed();
  }, le.prototype.getY = function() {
    return this.y.fromRed();
  }, le.prototype.mul = function(ye) {
    return ye = new t(ye, 16), this.isInfinity() ? this : this._hasDoubles(ye) ? this.curve._fixedNafMul(this, ye) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [ye]) : this.curve._wnafMul(this, ye);
  }, le.prototype.mulAdd = function(ye, be, Ae) {
    var Se = [this, be], $e = [ye, Ae];
    return this.curve.endo ? this.curve._endoWnafMulAdd(Se, $e) : this.curve._wnafMulAdd(1, Se, $e, 2);
  }, le.prototype.jmulAdd = function(ye, be, Ae) {
    var Se = [this, be], $e = [ye, Ae];
    return this.curve.endo ? this.curve._endoWnafMulAdd(Se, $e, !0) : this.curve._wnafMulAdd(1, Se, $e, 2, !0);
  }, le.prototype.eq = function(ye) {
    return this === ye || this.inf === ye.inf && (this.inf || this.x.cmp(ye.x) === 0 && this.y.cmp(ye.y) === 0);
  }, le.prototype.neg = function(ye) {
    if (this.inf)
      return this;
    var be = this.curve.point(this.x, this.y.redNeg());
    if (ye && this.precomputed) {
      var Ae = this.precomputed, Se = function($e) {
        return $e.neg();
      };
      be.precomputed = {
        naf: Ae.naf && {
          wnd: Ae.naf.wnd,
          points: Ae.naf.points.map(Se)
        },
        doubles: Ae.doubles && {
          step: Ae.doubles.step,
          points: Ae.doubles.points.map(Se)
        }
      };
    }
    return be;
  }, le.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var ye = this.curve.jpoint(this.x, this.y, this.curve.one);
    return ye;
  };
  function he(me, ye, be, Ae) {
    ie.BasePoint.call(this, me, "jacobian"), ye === null && be === null && Ae === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new t(0)) : (this.x = new t(ye, 16), this.y = new t(be, 16), this.z = new t(Ae, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return n(he, ie.BasePoint), ae.prototype.jpoint = function(ye, be, Ae) {
    return new he(this, ye, be, Ae);
  }, he.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var ye = this.z.redInvm(), be = ye.redSqr(), Ae = this.x.redMul(be), Se = this.y.redMul(be).redMul(ye);
    return this.curve.point(Ae, Se);
  }, he.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, he.prototype.add = function(ye) {
    if (this.isInfinity())
      return ye;
    if (ye.isInfinity())
      return this;
    var be = ye.z.redSqr(), Ae = this.z.redSqr(), Se = this.x.redMul(be), $e = ye.x.redMul(Ae), Re = this.y.redMul(be.redMul(ye.z)), Me = ye.y.redMul(Ae.redMul(this.z)), ke = Se.redSub($e), Te = Re.redSub(Me);
    if (ke.cmpn(0) === 0)
      return Te.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Ie = ke.redSqr(), qe = Ie.redMul(ke), Ue = Se.redMul(Ie), ze = Te.redSqr().redIAdd(qe).redISub(Ue).redISub(Ue), Ve = Te.redMul(Ue.redISub(ze)).redISub(Re.redMul(qe)), Mt = this.z.redMul(ye.z).redMul(ke);
    return this.curve.jpoint(ze, Ve, Mt);
  }, he.prototype.mixedAdd = function(ye) {
    if (this.isInfinity())
      return ye.toJ();
    if (ye.isInfinity())
      return this;
    var be = this.z.redSqr(), Ae = this.x, Se = ye.x.redMul(be), $e = this.y, Re = ye.y.redMul(be).redMul(this.z), Me = Ae.redSub(Se), ke = $e.redSub(Re);
    if (Me.cmpn(0) === 0)
      return ke.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Te = Me.redSqr(), Ie = Te.redMul(Me), qe = Ae.redMul(Te), Ue = ke.redSqr().redIAdd(Ie).redISub(qe).redISub(qe), ze = ke.redMul(qe.redISub(Ue)).redISub($e.redMul(Ie)), Ve = this.z.redMul(Me);
    return this.curve.jpoint(Ue, ze, Ve);
  }, he.prototype.dblp = function(ye) {
    if (ye === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!ye)
      return this.dbl();
    var be;
    if (this.curve.zeroA || this.curve.threeA) {
      var Ae = this;
      for (be = 0; be < ye; be++)
        Ae = Ae.dbl();
      return Ae;
    }
    var Se = this.curve.a, $e = this.curve.tinv, Re = this.x, Me = this.y, ke = this.z, Te = ke.redSqr().redSqr(), Ie = Me.redAdd(Me);
    for (be = 0; be < ye; be++) {
      var qe = Re.redSqr(), Ue = Ie.redSqr(), ze = Ue.redSqr(), Ve = qe.redAdd(qe).redIAdd(qe).redIAdd(Se.redMul(Te)), Mt = Re.redMul(Ue), Rt = Ve.redSqr().redISub(Mt.redAdd(Mt)), je = Mt.redISub(Rt), jt = Ve.redMul(je);
      jt = jt.redIAdd(jt).redISub(ze);
      var _e = Ie.redMul(ke);
      be + 1 < ye && (Te = Te.redMul(ze)), Re = Rt, ke = _e, Ie = jt;
    }
    return this.curve.jpoint(Re, Ie.redMul($e), ke);
  }, he.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, he.prototype._zeroDbl = function() {
    var ye, be, Ae;
    if (this.zOne) {
      var Se = this.x.redSqr(), $e = this.y.redSqr(), Re = $e.redSqr(), Me = this.x.redAdd($e).redSqr().redISub(Se).redISub(Re);
      Me = Me.redIAdd(Me);
      var ke = Se.redAdd(Se).redIAdd(Se), Te = ke.redSqr().redISub(Me).redISub(Me), Ie = Re.redIAdd(Re);
      Ie = Ie.redIAdd(Ie), Ie = Ie.redIAdd(Ie), ye = Te, be = ke.redMul(Me.redISub(Te)).redISub(Ie), Ae = this.y.redAdd(this.y);
    } else {
      var qe = this.x.redSqr(), Ue = this.y.redSqr(), ze = Ue.redSqr(), Ve = this.x.redAdd(Ue).redSqr().redISub(qe).redISub(ze);
      Ve = Ve.redIAdd(Ve);
      var Mt = qe.redAdd(qe).redIAdd(qe), Rt = Mt.redSqr(), je = ze.redIAdd(ze);
      je = je.redIAdd(je), je = je.redIAdd(je), ye = Rt.redISub(Ve).redISub(Ve), be = Mt.redMul(Ve.redISub(ye)).redISub(je), Ae = this.y.redMul(this.z), Ae = Ae.redIAdd(Ae);
    }
    return this.curve.jpoint(ye, be, Ae);
  }, he.prototype._threeDbl = function() {
    var ye, be, Ae;
    if (this.zOne) {
      var Se = this.x.redSqr(), $e = this.y.redSqr(), Re = $e.redSqr(), Me = this.x.redAdd($e).redSqr().redISub(Se).redISub(Re);
      Me = Me.redIAdd(Me);
      var ke = Se.redAdd(Se).redIAdd(Se).redIAdd(this.curve.a), Te = ke.redSqr().redISub(Me).redISub(Me);
      ye = Te;
      var Ie = Re.redIAdd(Re);
      Ie = Ie.redIAdd(Ie), Ie = Ie.redIAdd(Ie), be = ke.redMul(Me.redISub(Te)).redISub(Ie), Ae = this.y.redAdd(this.y);
    } else {
      var qe = this.z.redSqr(), Ue = this.y.redSqr(), ze = this.x.redMul(Ue), Ve = this.x.redSub(qe).redMul(this.x.redAdd(qe));
      Ve = Ve.redAdd(Ve).redIAdd(Ve);
      var Mt = ze.redIAdd(ze);
      Mt = Mt.redIAdd(Mt);
      var Rt = Mt.redAdd(Mt);
      ye = Ve.redSqr().redISub(Rt), Ae = this.y.redAdd(this.z).redSqr().redISub(Ue).redISub(qe);
      var je = Ue.redSqr();
      je = je.redIAdd(je), je = je.redIAdd(je), je = je.redIAdd(je), be = Ve.redMul(Mt.redISub(ye)).redISub(je);
    }
    return this.curve.jpoint(ye, be, Ae);
  }, he.prototype._dbl = function() {
    var ye = this.curve.a, be = this.x, Ae = this.y, Se = this.z, $e = Se.redSqr().redSqr(), Re = be.redSqr(), Me = Ae.redSqr(), ke = Re.redAdd(Re).redIAdd(Re).redIAdd(ye.redMul($e)), Te = be.redAdd(be);
    Te = Te.redIAdd(Te);
    var Ie = Te.redMul(Me), qe = ke.redSqr().redISub(Ie.redAdd(Ie)), Ue = Ie.redISub(qe), ze = Me.redSqr();
    ze = ze.redIAdd(ze), ze = ze.redIAdd(ze), ze = ze.redIAdd(ze);
    var Ve = ke.redMul(Ue).redISub(ze), Mt = Ae.redAdd(Ae).redMul(Se);
    return this.curve.jpoint(qe, Ve, Mt);
  }, he.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var ye = this.x.redSqr(), be = this.y.redSqr(), Ae = this.z.redSqr(), Se = be.redSqr(), $e = ye.redAdd(ye).redIAdd(ye), Re = $e.redSqr(), Me = this.x.redAdd(be).redSqr().redISub(ye).redISub(Se);
    Me = Me.redIAdd(Me), Me = Me.redAdd(Me).redIAdd(Me), Me = Me.redISub(Re);
    var ke = Me.redSqr(), Te = Se.redIAdd(Se);
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), Te = Te.redIAdd(Te);
    var Ie = $e.redIAdd(Me).redSqr().redISub(Re).redISub(ke).redISub(Te), qe = be.redMul(Ie);
    qe = qe.redIAdd(qe), qe = qe.redIAdd(qe);
    var Ue = this.x.redMul(ke).redISub(qe);
    Ue = Ue.redIAdd(Ue), Ue = Ue.redIAdd(Ue);
    var ze = this.y.redMul(Ie.redMul(Te.redISub(Ie)).redISub(Me.redMul(ke)));
    ze = ze.redIAdd(ze), ze = ze.redIAdd(ze), ze = ze.redIAdd(ze);
    var Ve = this.z.redAdd(Me).redSqr().redISub(Ae).redISub(ke);
    return this.curve.jpoint(Ue, ze, Ve);
  }, he.prototype.mul = function(ye, be) {
    return ye = new t(ye, be), this.curve._wnafMul(this, ye);
  }, he.prototype.eq = function(ye) {
    if (ye.type === "affine")
      return this.eq(ye.toJ());
    if (this === ye)
      return !0;
    var be = this.z.redSqr(), Ae = ye.z.redSqr();
    if (this.x.redMul(Ae).redISub(ye.x.redMul(be)).cmpn(0) !== 0)
      return !1;
    var Se = be.redMul(this.z), $e = Ae.redMul(ye.z);
    return this.y.redMul($e).redISub(ye.y.redMul(Se)).cmpn(0) === 0;
  }, he.prototype.eqXToP = function(ye) {
    var be = this.z.redSqr(), Ae = ye.toRed(this.curve.red).redMul(be);
    if (this.x.cmp(Ae) === 0)
      return !0;
    for (var Se = ye.clone(), $e = this.curve.redN.redMul(be); ; ) {
      if (Se.iadd(this.curve.n), Se.cmp(this.curve.p) >= 0)
        return !1;
      if (Ae.redIAdd($e), this.x.cmp(Ae) === 0)
        return !0;
    }
  }, he.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, he.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short$1;
}
var mont$1, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont) return mont$1;
  hasRequiredMont = 1;
  var c = requireBn$3(), t = inherits_browserExports, n = requireBase$1(), ie = requireUtils();
  function fe(le) {
    n.call(this, "mont", le), this.a = new c(le.a, 16).toRed(this.red), this.b = new c(le.b, 16).toRed(this.red), this.i4 = new c(4).toRed(this.red).redInvm(), this.two = new c(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  t(fe, n), mont$1 = fe, fe.prototype.validate = function(he) {
    var me = he.normalize().x, ye = me.redSqr(), be = ye.redMul(me).redAdd(ye.redMul(this.a)).redAdd(me), Ae = be.redSqrt();
    return Ae.redSqr().cmp(be) === 0;
  };
  function ae(le, he, me) {
    n.BasePoint.call(this, le, "projective"), he === null && me === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new c(he, 16), this.z = new c(me, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return t(ae, n.BasePoint), fe.prototype.decodePoint = function(he, me) {
    return this.point(ie.toArray(he, me), 1);
  }, fe.prototype.point = function(he, me) {
    return new ae(this, he, me);
  }, fe.prototype.pointFromJSON = function(he) {
    return ae.fromJSON(this, he);
  }, ae.prototype.precompute = function() {
  }, ae.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, ae.fromJSON = function(he, me) {
    return new ae(he, me[0], me[1] || he.one);
  }, ae.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, ae.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, ae.prototype.dbl = function() {
    var he = this.x.redAdd(this.z), me = he.redSqr(), ye = this.x.redSub(this.z), be = ye.redSqr(), Ae = me.redSub(be), Se = me.redMul(be), $e = Ae.redMul(be.redAdd(this.curve.a24.redMul(Ae)));
    return this.curve.point(Se, $e);
  }, ae.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, ae.prototype.diffAdd = function(he, me) {
    var ye = this.x.redAdd(this.z), be = this.x.redSub(this.z), Ae = he.x.redAdd(he.z), Se = he.x.redSub(he.z), $e = Se.redMul(ye), Re = Ae.redMul(be), Me = me.z.redMul($e.redAdd(Re).redSqr()), ke = me.x.redMul($e.redISub(Re).redSqr());
    return this.curve.point(Me, ke);
  }, ae.prototype.mul = function(he) {
    for (var me = he.clone(), ye = this, be = this.curve.point(null, null), Ae = this, Se = []; me.cmpn(0) !== 0; me.iushrn(1))
      Se.push(me.andln(1));
    for (var $e = Se.length - 1; $e >= 0; $e--)
      Se[$e] === 0 ? (ye = ye.diffAdd(be, Ae), be = be.dbl()) : (be = ye.diffAdd(be, Ae), ye = ye.dbl());
    return be;
  }, ae.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, ae.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, ae.prototype.eq = function(he) {
    return this.getX().cmp(he.getX()) === 0;
  }, ae.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, ae.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont$1;
}
var edwards$1, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards) return edwards$1;
  hasRequiredEdwards = 1;
  var c = requireUtils(), t = requireBn$3(), n = inherits_browserExports, ie = requireBase$1(), fe = c.assert;
  function ae(he) {
    this.twisted = (he.a | 0) !== 1, this.mOneA = this.twisted && (he.a | 0) === -1, this.extended = this.mOneA, ie.call(this, "edwards", he), this.a = new t(he.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new t(he.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new t(he.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), fe(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (he.c | 0) === 1;
  }
  n(ae, ie), edwards$1 = ae, ae.prototype._mulA = function(me) {
    return this.mOneA ? me.redNeg() : this.a.redMul(me);
  }, ae.prototype._mulC = function(me) {
    return this.oneC ? me : this.c.redMul(me);
  }, ae.prototype.jpoint = function(me, ye, be, Ae) {
    return this.point(me, ye, be, Ae);
  }, ae.prototype.pointFromX = function(me, ye) {
    me = new t(me, 16), me.red || (me = me.toRed(this.red));
    var be = me.redSqr(), Ae = this.c2.redSub(this.a.redMul(be)), Se = this.one.redSub(this.c2.redMul(this.d).redMul(be)), $e = Ae.redMul(Se.redInvm()), Re = $e.redSqrt();
    if (Re.redSqr().redSub($e).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var Me = Re.fromRed().isOdd();
    return (ye && !Me || !ye && Me) && (Re = Re.redNeg()), this.point(me, Re);
  }, ae.prototype.pointFromY = function(me, ye) {
    me = new t(me, 16), me.red || (me = me.toRed(this.red));
    var be = me.redSqr(), Ae = be.redSub(this.c2), Se = be.redMul(this.d).redMul(this.c2).redSub(this.a), $e = Ae.redMul(Se.redInvm());
    if ($e.cmp(this.zero) === 0) {
      if (ye)
        throw new Error("invalid point");
      return this.point(this.zero, me);
    }
    var Re = $e.redSqrt();
    if (Re.redSqr().redSub($e).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return Re.fromRed().isOdd() !== ye && (Re = Re.redNeg()), this.point(Re, me);
  }, ae.prototype.validate = function(me) {
    if (me.isInfinity())
      return !0;
    me.normalize();
    var ye = me.x.redSqr(), be = me.y.redSqr(), Ae = ye.redMul(this.a).redAdd(be), Se = this.c2.redMul(this.one.redAdd(this.d.redMul(ye).redMul(be)));
    return Ae.cmp(Se) === 0;
  };
  function le(he, me, ye, be, Ae) {
    ie.BasePoint.call(this, he, "projective"), me === null && ye === null && be === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new t(me, 16), this.y = new t(ye, 16), this.z = be ? new t(be, 16) : this.curve.one, this.t = Ae && new t(Ae, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return n(le, ie.BasePoint), ae.prototype.pointFromJSON = function(me) {
    return le.fromJSON(this, me);
  }, ae.prototype.point = function(me, ye, be, Ae) {
    return new le(this, me, ye, be, Ae);
  }, le.fromJSON = function(me, ye) {
    return new le(me, ye[0], ye[1], ye[2]);
  }, le.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, le.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, le.prototype._extDbl = function() {
    var me = this.x.redSqr(), ye = this.y.redSqr(), be = this.z.redSqr();
    be = be.redIAdd(be);
    var Ae = this.curve._mulA(me), Se = this.x.redAdd(this.y).redSqr().redISub(me).redISub(ye), $e = Ae.redAdd(ye), Re = $e.redSub(be), Me = Ae.redSub(ye), ke = Se.redMul(Re), Te = $e.redMul(Me), Ie = Se.redMul(Me), qe = Re.redMul($e);
    return this.curve.point(ke, Te, qe, Ie);
  }, le.prototype._projDbl = function() {
    var me = this.x.redAdd(this.y).redSqr(), ye = this.x.redSqr(), be = this.y.redSqr(), Ae, Se, $e, Re, Me, ke;
    if (this.curve.twisted) {
      Re = this.curve._mulA(ye);
      var Te = Re.redAdd(be);
      this.zOne ? (Ae = me.redSub(ye).redSub(be).redMul(Te.redSub(this.curve.two)), Se = Te.redMul(Re.redSub(be)), $e = Te.redSqr().redSub(Te).redSub(Te)) : (Me = this.z.redSqr(), ke = Te.redSub(Me).redISub(Me), Ae = me.redSub(ye).redISub(be).redMul(ke), Se = Te.redMul(Re.redSub(be)), $e = Te.redMul(ke));
    } else
      Re = ye.redAdd(be), Me = this.curve._mulC(this.z).redSqr(), ke = Re.redSub(Me).redSub(Me), Ae = this.curve._mulC(me.redISub(Re)).redMul(ke), Se = this.curve._mulC(Re).redMul(ye.redISub(be)), $e = Re.redMul(ke);
    return this.curve.point(Ae, Se, $e);
  }, le.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, le.prototype._extAdd = function(me) {
    var ye = this.y.redSub(this.x).redMul(me.y.redSub(me.x)), be = this.y.redAdd(this.x).redMul(me.y.redAdd(me.x)), Ae = this.t.redMul(this.curve.dd).redMul(me.t), Se = this.z.redMul(me.z.redAdd(me.z)), $e = be.redSub(ye), Re = Se.redSub(Ae), Me = Se.redAdd(Ae), ke = be.redAdd(ye), Te = $e.redMul(Re), Ie = Me.redMul(ke), qe = $e.redMul(ke), Ue = Re.redMul(Me);
    return this.curve.point(Te, Ie, Ue, qe);
  }, le.prototype._projAdd = function(me) {
    var ye = this.z.redMul(me.z), be = ye.redSqr(), Ae = this.x.redMul(me.x), Se = this.y.redMul(me.y), $e = this.curve.d.redMul(Ae).redMul(Se), Re = be.redSub($e), Me = be.redAdd($e), ke = this.x.redAdd(this.y).redMul(me.x.redAdd(me.y)).redISub(Ae).redISub(Se), Te = ye.redMul(Re).redMul(ke), Ie, qe;
    return this.curve.twisted ? (Ie = ye.redMul(Me).redMul(Se.redSub(this.curve._mulA(Ae))), qe = Re.redMul(Me)) : (Ie = ye.redMul(Me).redMul(Se.redSub(Ae)), qe = this.curve._mulC(Re).redMul(Me)), this.curve.point(Te, Ie, qe);
  }, le.prototype.add = function(me) {
    return this.isInfinity() ? me : me.isInfinity() ? this : this.curve.extended ? this._extAdd(me) : this._projAdd(me);
  }, le.prototype.mul = function(me) {
    return this._hasDoubles(me) ? this.curve._fixedNafMul(this, me) : this.curve._wnafMul(this, me);
  }, le.prototype.mulAdd = function(me, ye, be) {
    return this.curve._wnafMulAdd(1, [this, ye], [me, be], 2, !1);
  }, le.prototype.jmulAdd = function(me, ye, be) {
    return this.curve._wnafMulAdd(1, [this, ye], [me, be], 2, !0);
  }, le.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var me = this.z.redInvm();
    return this.x = this.x.redMul(me), this.y = this.y.redMul(me), this.t && (this.t = this.t.redMul(me)), this.z = this.curve.one, this.zOne = !0, this;
  }, le.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, le.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, le.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, le.prototype.eq = function(me) {
    return this === me || this.getX().cmp(me.getX()) === 0 && this.getY().cmp(me.getY()) === 0;
  }, le.prototype.eqXToP = function(me) {
    var ye = me.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(ye) === 0)
      return !0;
    for (var be = me.clone(), Ae = this.curve.redN.redMul(this.z); ; ) {
      if (be.iadd(this.curve.n), be.cmp(this.curve.p) >= 0)
        return !1;
      if (ye.redIAdd(Ae), this.x.cmp(ye) === 0)
        return !0;
    }
  }, le.prototype.toP = le.prototype.normalize, le.prototype.mixedAdd = le.prototype.add, edwards$1;
}
var hasRequiredCurve;
function requireCurve() {
  return hasRequiredCurve || (hasRequiredCurve = 1, function(c) {
    var t = c;
    t.base = requireBase$1(), t.short = requireShort(), t.mont = requireMont(), t.edwards = requireEdwards();
  }(curve$1)), curve$1;
}
var curves$2 = {}, secp256k1$1, hasRequiredSecp256k1$1;
function requireSecp256k1$1() {
  return hasRequiredSecp256k1$1 || (hasRequiredSecp256k1$1 = 1, secp256k1$1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$1;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(c) {
    var t = c, n = hash$5, ie = requireCurve(), fe = requireUtils(), ae = fe.assert;
    function le(ye) {
      ye.type === "short" ? this.curve = new ie.short(ye) : ye.type === "edwards" ? this.curve = new ie.edwards(ye) : this.curve = new ie.mont(ye), this.g = this.curve.g, this.n = this.curve.n, this.hash = ye.hash, ae(this.g.validate(), "Invalid curve"), ae(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    t.PresetCurve = le;
    function he(ye, be) {
      Object.defineProperty(t, ye, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var Ae = new le(be);
          return Object.defineProperty(t, ye, {
            configurable: !0,
            enumerable: !0,
            value: Ae
          }), Ae;
        }
      });
    }
    he("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: n.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), he("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: n.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), he("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: n.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), he("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: n.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), he("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: n.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), he("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: n.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), he("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: n.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var me;
    try {
      me = requireSecp256k1$1();
    } catch {
      me = void 0;
    }
    he("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: n.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        me
      ]
    });
  }(curves$2)), curves$2;
}
var hash$1 = hash$5, utils$a = utils$b, assert$8 = minimalisticAssert$1;
function HmacDRBG(c) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(c);
  this.hash = c.hash, this.predResist = !!c.predResist, this.outLen = this.hash.outSize, this.minEntropy = c.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var t = utils$a.toArray(c.entropy, c.entropyEnc || "hex"), n = utils$a.toArray(c.nonce, c.nonceEnc || "hex"), ie = utils$a.toArray(c.pers, c.persEnc || "hex");
  assert$8(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(t, n, ie);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function c(t, n, ie) {
  var fe = t.concat(n).concat(ie);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var ae = 0; ae < this.V.length; ae++)
    this.K[ae] = 0, this.V[ae] = 1;
  this._update(fe), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function c() {
  return new hash$1.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function c(t) {
  var n = this._hmac().update(this.V).update([0]);
  t && (n = n.update(t)), this.K = n.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function c(t, n, ie, fe) {
  typeof n != "string" && (fe = ie, ie = n, n = null), t = utils$a.toArray(t, n), ie = utils$a.toArray(ie, fe), assert$8(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(t.concat(ie || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function c(t, n, ie, fe) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof n != "string" && (fe = ie, ie = n, n = null), ie && (ie = utils$a.toArray(ie, fe || "hex"), this._update(ie));
  for (var ae = []; ae.length < t; )
    this.V = this._hmac().update(this.V).digest(), ae = ae.concat(this.V);
  var le = ae.slice(0, t);
  return this._update(ie), this._reseed++, utils$a.encode(le, n);
};
var key$3, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1) return key$3;
  hasRequiredKey$1 = 1;
  var c = requireBn$3(), t = requireUtils(), n = t.assert;
  function ie(fe, ae) {
    this.ec = fe, this.priv = null, this.pub = null, ae.priv && this._importPrivate(ae.priv, ae.privEnc), ae.pub && this._importPublic(ae.pub, ae.pubEnc);
  }
  return key$3 = ie, ie.fromPublic = function(ae, le, he) {
    return le instanceof ie ? le : new ie(ae, {
      pub: le,
      pubEnc: he
    });
  }, ie.fromPrivate = function(ae, le, he) {
    return le instanceof ie ? le : new ie(ae, {
      priv: le,
      privEnc: he
    });
  }, ie.prototype.validate = function() {
    var ae = this.getPublic();
    return ae.isInfinity() ? { result: !1, reason: "Invalid public key" } : ae.validate() ? ae.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, ie.prototype.getPublic = function(ae, le) {
    return typeof ae == "string" && (le = ae, ae = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), le ? this.pub.encode(le, ae) : this.pub;
  }, ie.prototype.getPrivate = function(ae) {
    return ae === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, ie.prototype._importPrivate = function(ae, le) {
    this.priv = new c(ae, le || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, ie.prototype._importPublic = function(ae, le) {
    if (ae.x || ae.y) {
      this.ec.curve.type === "mont" ? n(ae.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && n(ae.x && ae.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(ae.x, ae.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(ae, le);
  }, ie.prototype.derive = function(ae) {
    return ae.validate() || n(ae.validate(), "public point not validated"), ae.mul(this.priv).getX();
  }, ie.prototype.sign = function(ae, le, he) {
    return this.ec.sign(ae, this, le, he);
  }, ie.prototype.verify = function(ae, le, he) {
    return this.ec.verify(ae, le, this, void 0, he);
  }, ie.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$3;
}
var signature$3, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1) return signature$3;
  hasRequiredSignature$1 = 1;
  var c = requireBn$3(), t = requireUtils(), n = t.assert;
  function ie(me, ye) {
    if (me instanceof ie)
      return me;
    this._importDER(me, ye) || (n(me.r && me.s, "Signature without r or s"), this.r = new c(me.r, 16), this.s = new c(me.s, 16), me.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = me.recoveryParam);
  }
  signature$3 = ie;
  function fe() {
    this.place = 0;
  }
  function ae(me, ye) {
    var be = me[ye.place++];
    if (!(be & 128))
      return be;
    var Ae = be & 15;
    if (Ae === 0 || Ae > 4 || me[ye.place] === 0)
      return !1;
    for (var Se = 0, $e = 0, Re = ye.place; $e < Ae; $e++, Re++)
      Se <<= 8, Se |= me[Re], Se >>>= 0;
    return Se <= 127 ? !1 : (ye.place = Re, Se);
  }
  function le(me) {
    for (var ye = 0, be = me.length - 1; !me[ye] && !(me[ye + 1] & 128) && ye < be; )
      ye++;
    return ye === 0 ? me : me.slice(ye);
  }
  ie.prototype._importDER = function(ye, be) {
    ye = t.toArray(ye, be);
    var Ae = new fe();
    if (ye[Ae.place++] !== 48)
      return !1;
    var Se = ae(ye, Ae);
    if (Se === !1 || Se + Ae.place !== ye.length || ye[Ae.place++] !== 2)
      return !1;
    var $e = ae(ye, Ae);
    if ($e === !1 || ye[Ae.place] & 128)
      return !1;
    var Re = ye.slice(Ae.place, $e + Ae.place);
    if (Ae.place += $e, ye[Ae.place++] !== 2)
      return !1;
    var Me = ae(ye, Ae);
    if (Me === !1 || ye.length !== Me + Ae.place || ye[Ae.place] & 128)
      return !1;
    var ke = ye.slice(Ae.place, Me + Ae.place);
    if (Re[0] === 0)
      if (Re[1] & 128)
        Re = Re.slice(1);
      else
        return !1;
    if (ke[0] === 0)
      if (ke[1] & 128)
        ke = ke.slice(1);
      else
        return !1;
    return this.r = new c(Re), this.s = new c(ke), this.recoveryParam = null, !0;
  };
  function he(me, ye) {
    if (ye < 128) {
      me.push(ye);
      return;
    }
    var be = 1 + (Math.log(ye) / Math.LN2 >>> 3);
    for (me.push(be | 128); --be; )
      me.push(ye >>> (be << 3) & 255);
    me.push(ye);
  }
  return ie.prototype.toDER = function(ye) {
    var be = this.r.toArray(), Ae = this.s.toArray();
    for (be[0] & 128 && (be = [0].concat(be)), Ae[0] & 128 && (Ae = [0].concat(Ae)), be = le(be), Ae = le(Ae); !Ae[0] && !(Ae[1] & 128); )
      Ae = Ae.slice(1);
    var Se = [2];
    he(Se, be.length), Se = Se.concat(be), Se.push(2), he(Se, Ae.length);
    var $e = Se.concat(Ae), Re = [48];
    return he(Re, $e.length), Re = Re.concat($e), t.encode(Re, ye);
  }, signature$3;
}
var ec$1, hasRequiredEc$1;
function requireEc$1() {
  if (hasRequiredEc$1) return ec$1;
  hasRequiredEc$1 = 1;
  var c = requireBn$3(), t = hmacDrbg, n = requireUtils(), ie = requireCurves(), fe = requireBrorand(), ae = n.assert, le = requireKey$1(), he = requireSignature$1();
  function me(ye) {
    if (!(this instanceof me))
      return new me(ye);
    typeof ye == "string" && (ae(
      Object.prototype.hasOwnProperty.call(ie, ye),
      "Unknown curve " + ye
    ), ye = ie[ye]), ye instanceof ie.PresetCurve && (ye = { curve: ye }), this.curve = ye.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = ye.curve.g, this.g.precompute(ye.curve.n.bitLength() + 1), this.hash = ye.hash || ye.curve.hash;
  }
  return ec$1 = me, me.prototype.keyPair = function(be) {
    return new le(this, be);
  }, me.prototype.keyFromPrivate = function(be, Ae) {
    return le.fromPrivate(this, be, Ae);
  }, me.prototype.keyFromPublic = function(be, Ae) {
    return le.fromPublic(this, be, Ae);
  }, me.prototype.genKeyPair = function(be) {
    be || (be = {});
    for (var Ae = new t({
      hash: this.hash,
      pers: be.pers,
      persEnc: be.persEnc || "utf8",
      entropy: be.entropy || fe(this.hash.hmacStrength),
      entropyEnc: be.entropy && be.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Se = this.n.byteLength(), $e = this.n.sub(new c(2)); ; ) {
      var Re = new c(Ae.generate(Se));
      if (!(Re.cmp($e) > 0))
        return Re.iaddn(1), this.keyFromPrivate(Re);
    }
  }, me.prototype._truncateToN = function(be, Ae, Se) {
    var $e;
    if (c.isBN(be) || typeof be == "number")
      be = new c(be, 16), $e = be.byteLength();
    else if (typeof be == "object")
      $e = be.length, be = new c(be, 16);
    else {
      var Re = be.toString();
      $e = Re.length + 1 >>> 1, be = new c(Re, 16);
    }
    typeof Se != "number" && (Se = $e * 8);
    var Me = Se - this.n.bitLength();
    return Me > 0 && (be = be.ushrn(Me)), !Ae && be.cmp(this.n) >= 0 ? be.sub(this.n) : be;
  }, me.prototype.sign = function(be, Ae, Se, $e) {
    if (typeof Se == "object" && ($e = Se, Se = null), $e || ($e = {}), typeof be != "string" && typeof be != "number" && !c.isBN(be)) {
      ae(
        typeof be == "object" && be && typeof be.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), ae(be.length >>> 0 === be.length);
      for (var Re = 0; Re < be.length; Re++) ae((be[Re] & 255) === be[Re]);
    }
    Ae = this.keyFromPrivate(Ae, Se), be = this._truncateToN(be, !1, $e.msgBitLength), ae(!be.isNeg(), "Can not sign a negative message");
    var Me = this.n.byteLength(), ke = Ae.getPrivate().toArray("be", Me), Te = be.toArray("be", Me);
    ae(new c(Te).eq(be), "Can not sign message");
    for (var Ie = new t({
      hash: this.hash,
      entropy: ke,
      nonce: Te,
      pers: $e.pers,
      persEnc: $e.persEnc || "utf8"
    }), qe = this.n.sub(new c(1)), Ue = 0; ; Ue++) {
      var ze = $e.k ? $e.k(Ue) : new c(Ie.generate(this.n.byteLength()));
      if (ze = this._truncateToN(ze, !0), !(ze.cmpn(1) <= 0 || ze.cmp(qe) >= 0)) {
        var Ve = this.g.mul(ze);
        if (!Ve.isInfinity()) {
          var Mt = Ve.getX(), Rt = Mt.umod(this.n);
          if (Rt.cmpn(0) !== 0) {
            var je = ze.invm(this.n).mul(Rt.mul(Ae.getPrivate()).iadd(be));
            if (je = je.umod(this.n), je.cmpn(0) !== 0) {
              var jt = (Ve.getY().isOdd() ? 1 : 0) | (Mt.cmp(Rt) !== 0 ? 2 : 0);
              return $e.canonical && je.cmp(this.nh) > 0 && (je = this.n.sub(je), jt ^= 1), new he({ r: Rt, s: je, recoveryParam: jt });
            }
          }
        }
      }
    }
  }, me.prototype.verify = function(be, Ae, Se, $e, Re) {
    Re || (Re = {}), be = this._truncateToN(be, !1, Re.msgBitLength), Se = this.keyFromPublic(Se, $e), Ae = new he(Ae, "hex");
    var Me = Ae.r, ke = Ae.s;
    if (Me.cmpn(1) < 0 || Me.cmp(this.n) >= 0 || ke.cmpn(1) < 0 || ke.cmp(this.n) >= 0)
      return !1;
    var Te = ke.invm(this.n), Ie = Te.mul(be).umod(this.n), qe = Te.mul(Me).umod(this.n), Ue;
    return this.curve._maxwellTrick ? (Ue = this.g.jmulAdd(Ie, Se.getPublic(), qe), Ue.isInfinity() ? !1 : Ue.eqXToP(Me)) : (Ue = this.g.mulAdd(Ie, Se.getPublic(), qe), Ue.isInfinity() ? !1 : Ue.getX().umod(this.n).cmp(Me) === 0);
  }, me.prototype.recoverPubKey = function(ye, be, Ae, Se) {
    ae((3 & Ae) === Ae, "The recovery param is more than two bits"), be = new he(be, Se);
    var $e = this.n, Re = new c(ye), Me = be.r, ke = be.s, Te = Ae & 1, Ie = Ae >> 1;
    if (Me.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Ie)
      throw new Error("Unable to find sencond key candinate");
    Ie ? Me = this.curve.pointFromX(Me.add(this.curve.n), Te) : Me = this.curve.pointFromX(Me, Te);
    var qe = be.r.invm($e), Ue = $e.sub(Re).mul(qe).umod($e), ze = ke.mul(qe).umod($e);
    return this.g.mulAdd(Ue, Me, ze);
  }, me.prototype.getKeyRecoveryParam = function(ye, be, Ae, Se) {
    if (be = new he(be, Se), be.recoveryParam !== null)
      return be.recoveryParam;
    for (var $e = 0; $e < 4; $e++) {
      var Re;
      try {
        Re = this.recoverPubKey(ye, be, $e);
      } catch {
        continue;
      }
      if (Re.eq(Ae))
        return $e;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec$1;
}
var key$2, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey) return key$2;
  hasRequiredKey = 1;
  var c = requireUtils(), t = c.assert, n = c.parseBytes, ie = c.cachedProperty;
  function fe(ae, le) {
    this.eddsa = ae, this._secret = n(le.secret), ae.isPoint(le.pub) ? this._pub = le.pub : this._pubBytes = n(le.pub);
  }
  return fe.fromPublic = function(le, he) {
    return he instanceof fe ? he : new fe(le, { pub: he });
  }, fe.fromSecret = function(le, he) {
    return he instanceof fe ? he : new fe(le, { secret: he });
  }, fe.prototype.secret = function() {
    return this._secret;
  }, ie(fe, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), ie(fe, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), ie(fe, "privBytes", function() {
    var le = this.eddsa, he = this.hash(), me = le.encodingLength - 1, ye = he.slice(0, le.encodingLength);
    return ye[0] &= 248, ye[me] &= 127, ye[me] |= 64, ye;
  }), ie(fe, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), ie(fe, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), ie(fe, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), fe.prototype.sign = function(le) {
    return t(this._secret, "KeyPair can only verify"), this.eddsa.sign(le, this);
  }, fe.prototype.verify = function(le, he) {
    return this.eddsa.verify(le, he, this);
  }, fe.prototype.getSecret = function(le) {
    return t(this._secret, "KeyPair is public only"), c.encode(this.secret(), le);
  }, fe.prototype.getPublic = function(le) {
    return c.encode(this.pubBytes(), le);
  }, key$2 = fe, key$2;
}
var signature$2, hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature) return signature$2;
  hasRequiredSignature = 1;
  var c = requireBn$3(), t = requireUtils(), n = t.assert, ie = t.cachedProperty, fe = t.parseBytes;
  function ae(le, he) {
    this.eddsa = le, typeof he != "object" && (he = fe(he)), Array.isArray(he) && (n(he.length === le.encodingLength * 2, "Signature has invalid size"), he = {
      R: he.slice(0, le.encodingLength),
      S: he.slice(le.encodingLength)
    }), n(he.R && he.S, "Signature without R or S"), le.isPoint(he.R) && (this._R = he.R), he.S instanceof c && (this._S = he.S), this._Rencoded = Array.isArray(he.R) ? he.R : he.Rencoded, this._Sencoded = Array.isArray(he.S) ? he.S : he.Sencoded;
  }
  return ie(ae, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), ie(ae, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), ie(ae, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), ie(ae, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), ae.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, ae.prototype.toHex = function() {
    return t.encode(this.toBytes(), "hex").toUpperCase();
  }, signature$2 = ae, signature$2;
}
var eddsa$1, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa) return eddsa$1;
  hasRequiredEddsa = 1;
  var c = hash$5, t = requireCurves(), n = requireUtils(), ie = n.assert, fe = n.parseBytes, ae = requireKey(), le = requireSignature();
  function he(me) {
    if (ie(me === "ed25519", "only tested with ed25519 so far"), !(this instanceof he))
      return new he(me);
    me = t[me].curve, this.curve = me, this.g = me.g, this.g.precompute(me.n.bitLength() + 1), this.pointClass = me.point().constructor, this.encodingLength = Math.ceil(me.n.bitLength() / 8), this.hash = c.sha512;
  }
  return eddsa$1 = he, he.prototype.sign = function(ye, be) {
    ye = fe(ye);
    var Ae = this.keyFromSecret(be), Se = this.hashInt(Ae.messagePrefix(), ye), $e = this.g.mul(Se), Re = this.encodePoint($e), Me = this.hashInt(Re, Ae.pubBytes(), ye).mul(Ae.priv()), ke = Se.add(Me).umod(this.curve.n);
    return this.makeSignature({ R: $e, S: ke, Rencoded: Re });
  }, he.prototype.verify = function(ye, be, Ae) {
    if (ye = fe(ye), be = this.makeSignature(be), be.S().gte(be.eddsa.curve.n) || be.S().isNeg())
      return !1;
    var Se = this.keyFromPublic(Ae), $e = this.hashInt(be.Rencoded(), Se.pubBytes(), ye), Re = this.g.mul(be.S()), Me = be.R().add(Se.pub().mul($e));
    return Me.eq(Re);
  }, he.prototype.hashInt = function() {
    for (var ye = this.hash(), be = 0; be < arguments.length; be++)
      ye.update(arguments[be]);
    return n.intFromLE(ye.digest()).umod(this.curve.n);
  }, he.prototype.keyFromPublic = function(ye) {
    return ae.fromPublic(this, ye);
  }, he.prototype.keyFromSecret = function(ye) {
    return ae.fromSecret(this, ye);
  }, he.prototype.makeSignature = function(ye) {
    return ye instanceof le ? ye : new le(this, ye);
  }, he.prototype.encodePoint = function(ye) {
    var be = ye.getY().toArray("le", this.encodingLength);
    return be[this.encodingLength - 1] |= ye.getX().isOdd() ? 128 : 0, be;
  }, he.prototype.decodePoint = function(ye) {
    ye = n.parseBytes(ye);
    var be = ye.length - 1, Ae = ye.slice(0, be).concat(ye[be] & -129), Se = (ye[be] & 128) !== 0, $e = n.intFromLE(Ae);
    return this.curve.pointFromY($e, Se);
  }, he.prototype.encodeInt = function(ye) {
    return ye.toArray("le", this.encodingLength);
  }, he.prototype.decodeInt = function(ye) {
    return n.intFromLE(ye);
  }, he.prototype.isPoint = function(ye) {
    return ye instanceof this.pointClass;
  }, eddsa$1;
}
var hasRequiredElliptic$1;
function requireElliptic$1() {
  return hasRequiredElliptic$1 || (hasRequiredElliptic$1 = 1, function(c) {
    var t = c;
    t.version = require$$0$1.version, t.utils = requireUtils(), t.rand = requireBrorand(), t.curve = requireCurve(), t.curves = requireCurves(), t.ec = requireEc$1(), t.eddsa = requireEddsa();
  }(elliptic$1)), elliptic$1;
}
var asn1$1 = {}, asn1 = {}, bn$3 = { exports: {} };
bn$3.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn$3)), bn$3.exports;
}
var api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(c, t) {
      if (c.indexOf) return c.indexOf(t);
      for (var n = 0; n < c.length; n++)
        if (c[n] === t) return n;
      return -1;
    }, Object_keys = function(c) {
      if (Object.keys) return Object.keys(c);
      var t = [];
      for (var n in c) t.push(n);
      return t;
    }, forEach = function(c, t) {
      if (c.forEach) return c.forEach(t);
      for (var n = 0; n < c.length; n++)
        t(c[n], n, c);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(c, t, n) {
          Object.defineProperty(c, t, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: n
          });
        };
      } catch {
        return function(t, n, ie) {
          t[n] = ie;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(t) {
      if (!(this instanceof Script)) return new Script(t);
      this.code = t;
    };
    Script.prototype.runInContext = function(c) {
      if (!(c instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var t = document.createElement("iframe");
      t.style || (t.style = {}), t.style.display = "none", document.body.appendChild(t);
      var n = t.contentWindow, ie = n.eval, fe = n.execScript;
      !ie && fe && (fe.call(n, "null"), ie = n.eval), forEach(Object_keys(c), function(he) {
        n[he] = c[he];
      }), forEach(globals, function(he) {
        c[he] && (n[he] = c[he]);
      });
      var ae = Object_keys(n), le = ie.call(n, this.code);
      return forEach(Object_keys(n), function(he) {
        (he in c || indexOf(ae, he) === -1) && (c[he] = n[he]);
      }), forEach(globals, function(he) {
        he in c || defineProp(c, he, n[he]);
      }), document.body.removeChild(t), le;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(c) {
      var t = Script.createContext(c), n = this.runInContext(t);
      return c && forEach(Object_keys(t), function(ie) {
        c[ie] = t[ie];
      }), n;
    }, forEach(Object_keys(Script.prototype), function(c) {
      exports[c] = Script[c] = function(t) {
        var n = Script(t);
        return n[c].apply(n, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(c) {
      return c instanceof Context;
    }, exports.createScript = function(c) {
      return exports.Script(c);
    }, exports.createContext = Script.createContext = function(c) {
      var t = new Context();
      return typeof c == "object" && forEach(Object_keys(c), function(n) {
        t[n] = c[n];
      }), t;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(c) {
    var t = requireAsn1$1(), n = inherits_browserExports, ie = c;
    ie.define = function(le, he) {
      return new fe(le, he);
    };
    function fe(ae, le) {
      this.name = ae, this.body = le, this.decoders = {}, this.encoders = {};
    }
    fe.prototype._createNamed = function(le) {
      var he;
      try {
        he = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        he = function(ye) {
          this._initNamed(ye);
        };
      }
      return n(he, le), he.prototype._initNamed = function(ye) {
        le.call(this, ye);
      }, new he(this);
    }, fe.prototype._getDecoder = function(le) {
      return le = le || "der", this.decoders.hasOwnProperty(le) || (this.decoders[le] = this._createNamed(t.decoders[le])), this.decoders[le];
    }, fe.prototype.decode = function(le, he, me) {
      return this._getDecoder(he).decode(le, me);
    }, fe.prototype._getEncoder = function(le) {
      return le = le || "der", this.encoders.hasOwnProperty(le) || (this.encoders[le] = this._createNamed(t.encoders[le])), this.encoders[le];
    }, fe.prototype.encode = function(le, he, me) {
      return this._getEncoder(he).encode(le, me);
    };
  }(api)), api;
}
var base$1 = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var c = inherits_browserExports;
  function t(ie) {
    this._reporterState = {
      obj: null,
      path: [],
      options: ie || {},
      errors: []
    };
  }
  reporter.Reporter = t, t.prototype.isError = function(fe) {
    return fe instanceof n;
  }, t.prototype.save = function() {
    var fe = this._reporterState;
    return { obj: fe.obj, pathLen: fe.path.length };
  }, t.prototype.restore = function(fe) {
    var ae = this._reporterState;
    ae.obj = fe.obj, ae.path = ae.path.slice(0, fe.pathLen);
  }, t.prototype.enterKey = function(fe) {
    return this._reporterState.path.push(fe);
  }, t.prototype.exitKey = function(fe) {
    var ae = this._reporterState;
    ae.path = ae.path.slice(0, fe - 1);
  }, t.prototype.leaveKey = function(fe, ae, le) {
    var he = this._reporterState;
    this.exitKey(fe), he.obj !== null && (he.obj[ae] = le);
  }, t.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, t.prototype.enterObject = function() {
    var fe = this._reporterState, ae = fe.obj;
    return fe.obj = {}, ae;
  }, t.prototype.leaveObject = function(fe) {
    var ae = this._reporterState, le = ae.obj;
    return ae.obj = fe, le;
  }, t.prototype.error = function(fe) {
    var ae, le = this._reporterState, he = fe instanceof n;
    if (he ? ae = fe : ae = new n(le.path.map(function(me) {
      return "[" + JSON.stringify(me) + "]";
    }).join(""), fe.message || fe, fe.stack), !le.options.partial)
      throw ae;
    return he || le.errors.push(ae), ae;
  }, t.prototype.wrapResult = function(fe) {
    var ae = this._reporterState;
    return ae.options.partial ? {
      result: this.isError(fe) ? null : fe,
      errors: ae.errors
    } : fe;
  };
  function n(ie, fe) {
    this.path = ie, this.rethrow(fe);
  }
  return c(n, Error), n.prototype.rethrow = function(fe) {
    if (this.message = fe + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, n), !this.stack)
      try {
        throw new Error(this.message);
      } catch (ae) {
        this.stack = ae.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var c = inherits_browserExports, t = requireBase().Reporter, n = require$$0$5.Buffer;
  function ie(ae, le) {
    if (t.call(this, le), !n.isBuffer(ae)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = ae, this.offset = 0, this.length = ae.length;
  }
  c(ie, t), buffer.DecoderBuffer = ie, ie.prototype.save = function() {
    return { offset: this.offset, reporter: t.prototype.save.call(this) };
  }, ie.prototype.restore = function(le) {
    var he = new ie(this.base);
    return he.offset = le.offset, he.length = this.offset, this.offset = le.offset, t.prototype.restore.call(this, le.reporter), he;
  }, ie.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, ie.prototype.readUInt8 = function(le) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(le || "DecoderBuffer overrun");
  }, ie.prototype.skip = function(le, he) {
    if (!(this.offset + le <= this.length))
      return this.error(he || "DecoderBuffer overrun");
    var me = new ie(this.base);
    return me._reporterState = this._reporterState, me.offset = this.offset, me.length = this.offset + le, this.offset += le, me;
  }, ie.prototype.raw = function(le) {
    return this.base.slice(le ? le.offset : this.offset, this.length);
  };
  function fe(ae, le) {
    if (Array.isArray(ae))
      this.length = 0, this.value = ae.map(function(he) {
        return he instanceof fe || (he = new fe(he, le)), this.length += he.length, he;
      }, this);
    else if (typeof ae == "number") {
      if (!(0 <= ae && ae <= 255))
        return le.error("non-byte EncoderBuffer value");
      this.value = ae, this.length = 1;
    } else if (typeof ae == "string")
      this.value = ae, this.length = n.byteLength(ae);
    else if (n.isBuffer(ae))
      this.value = ae, this.length = ae.length;
    else
      return le.error("Unsupported type: " + typeof ae);
  }
  return buffer.EncoderBuffer = fe, fe.prototype.join = function(le, he) {
    return le || (le = new n(this.length)), he || (he = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(me) {
      me.join(le, he), he += me.length;
    }) : (typeof this.value == "number" ? le[he] = this.value : typeof this.value == "string" ? le.write(this.value, he) : n.isBuffer(this.value) && this.value.copy(le, he), he += this.length)), le;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var c = requireBase().Reporter, t = requireBase().EncoderBuffer, n = requireBase().DecoderBuffer, ie = minimalisticAssert$1, fe = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], ae = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(fe), le = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function he(ye, be) {
    var Ae = {};
    this._baseState = Ae, Ae.enc = ye, Ae.parent = be || null, Ae.children = null, Ae.tag = null, Ae.args = null, Ae.reverseArgs = null, Ae.choice = null, Ae.optional = !1, Ae.any = !1, Ae.obj = !1, Ae.use = null, Ae.useDecoder = null, Ae.key = null, Ae.default = null, Ae.explicit = null, Ae.implicit = null, Ae.contains = null, Ae.parent || (Ae.children = [], this._wrap());
  }
  node = he;
  var me = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return he.prototype.clone = function() {
    var be = this._baseState, Ae = {};
    me.forEach(function($e) {
      Ae[$e] = be[$e];
    });
    var Se = new this.constructor(Ae.parent);
    return Se._baseState = Ae, Se;
  }, he.prototype._wrap = function() {
    var be = this._baseState;
    ae.forEach(function(Ae) {
      this[Ae] = function() {
        var $e = new this.constructor(this);
        return be.children.push($e), $e[Ae].apply($e, arguments);
      };
    }, this);
  }, he.prototype._init = function(be) {
    var Ae = this._baseState;
    ie(Ae.parent === null), be.call(this), Ae.children = Ae.children.filter(function(Se) {
      return Se._baseState.parent === this;
    }, this), ie.equal(Ae.children.length, 1, "Root node can have only one child");
  }, he.prototype._useArgs = function(be) {
    var Ae = this._baseState, Se = be.filter(function($e) {
      return $e instanceof this.constructor;
    }, this);
    be = be.filter(function($e) {
      return !($e instanceof this.constructor);
    }, this), Se.length !== 0 && (ie(Ae.children === null), Ae.children = Se, Se.forEach(function($e) {
      $e._baseState.parent = this;
    }, this)), be.length !== 0 && (ie(Ae.args === null), Ae.args = be, Ae.reverseArgs = be.map(function($e) {
      if (typeof $e != "object" || $e.constructor !== Object)
        return $e;
      var Re = {};
      return Object.keys($e).forEach(function(Me) {
        Me == (Me | 0) && (Me |= 0);
        var ke = $e[Me];
        Re[ke] = Me;
      }), Re;
    }));
  }, le.forEach(function(ye) {
    he.prototype[ye] = function() {
      var Ae = this._baseState;
      throw new Error(ye + " not implemented for encoding: " + Ae.enc);
    };
  }), fe.forEach(function(ye) {
    he.prototype[ye] = function() {
      var Ae = this._baseState, Se = Array.prototype.slice.call(arguments);
      return ie(Ae.tag === null), Ae.tag = ye, this._useArgs(Se), this;
    };
  }), he.prototype.use = function(be) {
    ie(be);
    var Ae = this._baseState;
    return ie(Ae.use === null), Ae.use = be, this;
  }, he.prototype.optional = function() {
    var be = this._baseState;
    return be.optional = !0, this;
  }, he.prototype.def = function(be) {
    var Ae = this._baseState;
    return ie(Ae.default === null), Ae.default = be, Ae.optional = !0, this;
  }, he.prototype.explicit = function(be) {
    var Ae = this._baseState;
    return ie(Ae.explicit === null && Ae.implicit === null), Ae.explicit = be, this;
  }, he.prototype.implicit = function(be) {
    var Ae = this._baseState;
    return ie(Ae.explicit === null && Ae.implicit === null), Ae.implicit = be, this;
  }, he.prototype.obj = function() {
    var be = this._baseState, Ae = Array.prototype.slice.call(arguments);
    return be.obj = !0, Ae.length !== 0 && this._useArgs(Ae), this;
  }, he.prototype.key = function(be) {
    var Ae = this._baseState;
    return ie(Ae.key === null), Ae.key = be, this;
  }, he.prototype.any = function() {
    var be = this._baseState;
    return be.any = !0, this;
  }, he.prototype.choice = function(be) {
    var Ae = this._baseState;
    return ie(Ae.choice === null), Ae.choice = be, this._useArgs(Object.keys(be).map(function(Se) {
      return be[Se];
    })), this;
  }, he.prototype.contains = function(be) {
    var Ae = this._baseState;
    return ie(Ae.use === null), Ae.contains = be, this;
  }, he.prototype._decode = function(be, Ae) {
    var Se = this._baseState;
    if (Se.parent === null)
      return be.wrapResult(Se.children[0]._decode(be, Ae));
    var $e = Se.default, Re = !0, Me = null;
    if (Se.key !== null && (Me = be.enterKey(Se.key)), Se.optional) {
      var ke = null;
      if (Se.explicit !== null ? ke = Se.explicit : Se.implicit !== null ? ke = Se.implicit : Se.tag !== null && (ke = Se.tag), ke === null && !Se.any) {
        var Te = be.save();
        try {
          Se.choice === null ? this._decodeGeneric(Se.tag, be, Ae) : this._decodeChoice(be, Ae), Re = !0;
        } catch {
          Re = !1;
        }
        be.restore(Te);
      } else if (Re = this._peekTag(be, ke, Se.any), be.isError(Re))
        return Re;
    }
    var Ie;
    if (Se.obj && Re && (Ie = be.enterObject()), Re) {
      if (Se.explicit !== null) {
        var qe = this._decodeTag(be, Se.explicit);
        if (be.isError(qe))
          return qe;
        be = qe;
      }
      var Ue = be.offset;
      if (Se.use === null && Se.choice === null) {
        if (Se.any)
          var Te = be.save();
        var ze = this._decodeTag(
          be,
          Se.implicit !== null ? Se.implicit : Se.tag,
          Se.any
        );
        if (be.isError(ze))
          return ze;
        Se.any ? $e = be.raw(Te) : be = ze;
      }
      if (Ae && Ae.track && Se.tag !== null && Ae.track(be.path(), Ue, be.length, "tagged"), Ae && Ae.track && Se.tag !== null && Ae.track(be.path(), be.offset, be.length, "content"), Se.any ? $e = $e : Se.choice === null ? $e = this._decodeGeneric(Se.tag, be, Ae) : $e = this._decodeChoice(be, Ae), be.isError($e))
        return $e;
      if (!Se.any && Se.choice === null && Se.children !== null && Se.children.forEach(function(Rt) {
        Rt._decode(be, Ae);
      }), Se.contains && (Se.tag === "octstr" || Se.tag === "bitstr")) {
        var Ve = new n($e);
        $e = this._getUse(Se.contains, be._reporterState.obj)._decode(Ve, Ae);
      }
    }
    return Se.obj && Re && ($e = be.leaveObject(Ie)), Se.key !== null && ($e !== null || Re === !0) ? be.leaveKey(Me, Se.key, $e) : Me !== null && be.exitKey(Me), $e;
  }, he.prototype._decodeGeneric = function(be, Ae, Se) {
    var $e = this._baseState;
    return be === "seq" || be === "set" ? null : be === "seqof" || be === "setof" ? this._decodeList(Ae, be, $e.args[0], Se) : /str$/.test(be) ? this._decodeStr(Ae, be, Se) : be === "objid" && $e.args ? this._decodeObjid(Ae, $e.args[0], $e.args[1], Se) : be === "objid" ? this._decodeObjid(Ae, null, null, Se) : be === "gentime" || be === "utctime" ? this._decodeTime(Ae, be, Se) : be === "null_" ? this._decodeNull(Ae, Se) : be === "bool" ? this._decodeBool(Ae, Se) : be === "objDesc" ? this._decodeStr(Ae, be, Se) : be === "int" || be === "enum" ? this._decodeInt(Ae, $e.args && $e.args[0], Se) : $e.use !== null ? this._getUse($e.use, Ae._reporterState.obj)._decode(Ae, Se) : Ae.error("unknown tag: " + be);
  }, he.prototype._getUse = function(be, Ae) {
    var Se = this._baseState;
    return Se.useDecoder = this._use(be, Ae), ie(Se.useDecoder._baseState.parent === null), Se.useDecoder = Se.useDecoder._baseState.children[0], Se.implicit !== Se.useDecoder._baseState.implicit && (Se.useDecoder = Se.useDecoder.clone(), Se.useDecoder._baseState.implicit = Se.implicit), Se.useDecoder;
  }, he.prototype._decodeChoice = function(be, Ae) {
    var Se = this._baseState, $e = null, Re = !1;
    return Object.keys(Se.choice).some(function(Me) {
      var ke = be.save(), Te = Se.choice[Me];
      try {
        var Ie = Te._decode(be, Ae);
        if (be.isError(Ie))
          return !1;
        $e = { type: Me, value: Ie }, Re = !0;
      } catch {
        return be.restore(ke), !1;
      }
      return !0;
    }, this), Re ? $e : be.error("Choice not matched");
  }, he.prototype._createEncoderBuffer = function(be) {
    return new t(be, this.reporter);
  }, he.prototype._encode = function(be, Ae, Se) {
    var $e = this._baseState;
    if (!($e.default !== null && $e.default === be)) {
      var Re = this._encodeValue(be, Ae, Se);
      if (Re !== void 0 && !this._skipDefault(Re, Ae, Se))
        return Re;
    }
  }, he.prototype._encodeValue = function(be, Ae, Se) {
    var $e = this._baseState;
    if ($e.parent === null)
      return $e.children[0]._encode(be, Ae || new c());
    var Te = null;
    if (this.reporter = Ae, $e.optional && be === void 0)
      if ($e.default !== null)
        be = $e.default;
      else
        return;
    var Re = null, Me = !1;
    if ($e.any)
      Te = this._createEncoderBuffer(be);
    else if ($e.choice)
      Te = this._encodeChoice(be, Ae);
    else if ($e.contains)
      Re = this._getUse($e.contains, Se)._encode(be, Ae), Me = !0;
    else if ($e.children)
      Re = $e.children.map(function(Ue) {
        if (Ue._baseState.tag === "null_")
          return Ue._encode(null, Ae, be);
        if (Ue._baseState.key === null)
          return Ae.error("Child should have a key");
        var ze = Ae.enterKey(Ue._baseState.key);
        if (typeof be != "object")
          return Ae.error("Child expected, but input is not object");
        var Ve = Ue._encode(be[Ue._baseState.key], Ae, be);
        return Ae.leaveKey(ze), Ve;
      }, this).filter(function(Ue) {
        return Ue;
      }), Re = this._createEncoderBuffer(Re);
    else if ($e.tag === "seqof" || $e.tag === "setof") {
      if (!($e.args && $e.args.length === 1))
        return Ae.error("Too many args for : " + $e.tag);
      if (!Array.isArray(be))
        return Ae.error("seqof/setof, but data is not Array");
      var ke = this.clone();
      ke._baseState.implicit = null, Re = this._createEncoderBuffer(be.map(function(Ue) {
        var ze = this._baseState;
        return this._getUse(ze.args[0], be)._encode(Ue, Ae);
      }, ke));
    } else $e.use !== null ? Te = this._getUse($e.use, Se)._encode(be, Ae) : (Re = this._encodePrimitive($e.tag, be), Me = !0);
    var Te;
    if (!$e.any && $e.choice === null) {
      var Ie = $e.implicit !== null ? $e.implicit : $e.tag, qe = $e.implicit === null ? "universal" : "context";
      Ie === null ? $e.use === null && Ae.error("Tag could be omitted only for .use()") : $e.use === null && (Te = this._encodeComposite(Ie, Me, qe, Re));
    }
    return $e.explicit !== null && (Te = this._encodeComposite($e.explicit, !1, "context", Te)), Te;
  }, he.prototype._encodeChoice = function(be, Ae) {
    var Se = this._baseState, $e = Se.choice[be.type];
    return $e || ie(
      !1,
      be.type + " not found in " + JSON.stringify(Object.keys(Se.choice))
    ), $e._encode(be.value, Ae);
  }, he.prototype._encodePrimitive = function(be, Ae) {
    var Se = this._baseState;
    if (/str$/.test(be))
      return this._encodeStr(Ae, be);
    if (be === "objid" && Se.args)
      return this._encodeObjid(Ae, Se.reverseArgs[0], Se.args[1]);
    if (be === "objid")
      return this._encodeObjid(Ae, null, null);
    if (be === "gentime" || be === "utctime")
      return this._encodeTime(Ae, be);
    if (be === "null_")
      return this._encodeNull();
    if (be === "int" || be === "enum")
      return this._encodeInt(Ae, Se.args && Se.reverseArgs[0]);
    if (be === "bool")
      return this._encodeBool(Ae);
    if (be === "objDesc")
      return this._encodeStr(Ae, be);
    throw new Error("Unsupported tag: " + be);
  }, he.prototype._isNumstr = function(be) {
    return /^[0-9 ]*$/.test(be);
  }, he.prototype._isPrintstr = function(be) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(be);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(c) {
    var t = c;
    t.Reporter = requireReporter().Reporter, t.DecoderBuffer = requireBuffer().DecoderBuffer, t.EncoderBuffer = requireBuffer().EncoderBuffer, t.Node = requireNode();
  }(base$1)), base$1;
}
var constants = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(c) {
    var t = requireConstants();
    c.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, c.tagClassByName = t._reverse(c.tagClass), c.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, c.tagByName = t._reverse(c.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(c) {
    var t = c;
    t._reverse = function(ie) {
      var fe = {};
      return Object.keys(ie).forEach(function(ae) {
        (ae | 0) == ae && (ae = ae | 0);
        var le = ie[ae];
        fe[le] = ae;
      }), fe;
    }, t.der = requireDer$2();
  }(constants)), constants;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var c = inherits_browserExports, t = requireAsn1$1(), n = t.base, ie = t.bignum, fe = t.constants.der;
  function ae(ye) {
    this.enc = "der", this.name = ye.name, this.entity = ye, this.tree = new le(), this.tree._init(ye.body);
  }
  der_1$1 = ae, ae.prototype.decode = function(be, Ae) {
    return be instanceof n.DecoderBuffer || (be = new n.DecoderBuffer(be, Ae)), this.tree._decode(be, Ae);
  };
  function le(ye) {
    n.Node.call(this, "der", ye);
  }
  c(le, n.Node), le.prototype._peekTag = function(be, Ae, Se) {
    if (be.isEmpty())
      return !1;
    var $e = be.save(), Re = he(be, 'Failed to peek tag: "' + Ae + '"');
    return be.isError(Re) ? Re : (be.restore($e), Re.tag === Ae || Re.tagStr === Ae || Re.tagStr + "of" === Ae || Se);
  }, le.prototype._decodeTag = function(be, Ae, Se) {
    var $e = he(
      be,
      'Failed to decode tag of "' + Ae + '"'
    );
    if (be.isError($e))
      return $e;
    var Re = me(
      be,
      $e.primitive,
      'Failed to get length of "' + Ae + '"'
    );
    if (be.isError(Re))
      return Re;
    if (!Se && $e.tag !== Ae && $e.tagStr !== Ae && $e.tagStr + "of" !== Ae)
      return be.error('Failed to match tag: "' + Ae + '"');
    if ($e.primitive || Re !== null)
      return be.skip(Re, 'Failed to match body of: "' + Ae + '"');
    var Me = be.save(), ke = this._skipUntilEnd(
      be,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return be.isError(ke) ? ke : (Re = be.offset - Me.offset, be.restore(Me), be.skip(Re, 'Failed to match body of: "' + Ae + '"'));
  }, le.prototype._skipUntilEnd = function(be, Ae) {
    for (; ; ) {
      var Se = he(be, Ae);
      if (be.isError(Se))
        return Se;
      var $e = me(be, Se.primitive, Ae);
      if (be.isError($e))
        return $e;
      var Re;
      if (Se.primitive || $e !== null ? Re = be.skip($e) : Re = this._skipUntilEnd(be, Ae), be.isError(Re))
        return Re;
      if (Se.tagStr === "end")
        break;
    }
  }, le.prototype._decodeList = function(be, Ae, Se, $e) {
    for (var Re = []; !be.isEmpty(); ) {
      var Me = this._peekTag(be, "end");
      if (be.isError(Me))
        return Me;
      var ke = Se.decode(be, "der", $e);
      if (be.isError(ke) && Me)
        break;
      Re.push(ke);
    }
    return Re;
  }, le.prototype._decodeStr = function(be, Ae) {
    if (Ae === "bitstr") {
      var Se = be.readUInt8();
      return be.isError(Se) ? Se : { unused: Se, data: be.raw() };
    } else if (Ae === "bmpstr") {
      var $e = be.raw();
      if ($e.length % 2 === 1)
        return be.error("Decoding of string type: bmpstr length mismatch");
      for (var Re = "", Me = 0; Me < $e.length / 2; Me++)
        Re += String.fromCharCode($e.readUInt16BE(Me * 2));
      return Re;
    } else if (Ae === "numstr") {
      var ke = be.raw().toString("ascii");
      return this._isNumstr(ke) ? ke : be.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (Ae === "octstr")
        return be.raw();
      if (Ae === "objDesc")
        return be.raw();
      if (Ae === "printstr") {
        var Te = be.raw().toString("ascii");
        return this._isPrintstr(Te) ? Te : be.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(Ae) ? be.raw().toString() : be.error("Decoding of string type: " + Ae + " unsupported");
    }
  }, le.prototype._decodeObjid = function(be, Ae, Se) {
    for (var $e, Re = [], Me = 0; !be.isEmpty(); ) {
      var ke = be.readUInt8();
      Me <<= 7, Me |= ke & 127, ke & 128 || (Re.push(Me), Me = 0);
    }
    ke & 128 && Re.push(Me);
    var Te = Re[0] / 40 | 0, Ie = Re[0] % 40;
    if (Se ? $e = Re : $e = [Te, Ie].concat(Re.slice(1)), Ae) {
      var qe = Ae[$e.join(" ")];
      qe === void 0 && (qe = Ae[$e.join(".")]), qe !== void 0 && ($e = qe);
    }
    return $e;
  }, le.prototype._decodeTime = function(be, Ae) {
    var Se = be.raw().toString();
    if (Ae === "gentime")
      var $e = Se.slice(0, 4) | 0, Re = Se.slice(4, 6) | 0, Me = Se.slice(6, 8) | 0, ke = Se.slice(8, 10) | 0, Te = Se.slice(10, 12) | 0, Ie = Se.slice(12, 14) | 0;
    else if (Ae === "utctime") {
      var $e = Se.slice(0, 2) | 0, Re = Se.slice(2, 4) | 0, Me = Se.slice(4, 6) | 0, ke = Se.slice(6, 8) | 0, Te = Se.slice(8, 10) | 0, Ie = Se.slice(10, 12) | 0;
      $e < 70 ? $e = 2e3 + $e : $e = 1900 + $e;
    } else
      return be.error("Decoding " + Ae + " time is not supported yet");
    return Date.UTC($e, Re - 1, Me, ke, Te, Ie, 0);
  }, le.prototype._decodeNull = function(be) {
    return null;
  }, le.prototype._decodeBool = function(be) {
    var Ae = be.readUInt8();
    return be.isError(Ae) ? Ae : Ae !== 0;
  }, le.prototype._decodeInt = function(be, Ae) {
    var Se = be.raw(), $e = new ie(Se);
    return Ae && ($e = Ae[$e.toString(10)] || $e), $e;
  }, le.prototype._use = function(be, Ae) {
    return typeof be == "function" && (be = be(Ae)), be._getDecoder("der").tree;
  };
  function he(ye, be) {
    var Ae = ye.readUInt8(be);
    if (ye.isError(Ae))
      return Ae;
    var Se = fe.tagClass[Ae >> 6], $e = (Ae & 32) === 0;
    if ((Ae & 31) === 31) {
      var Re = Ae;
      for (Ae = 0; (Re & 128) === 128; ) {
        if (Re = ye.readUInt8(be), ye.isError(Re))
          return Re;
        Ae <<= 7, Ae |= Re & 127;
      }
    } else
      Ae &= 31;
    var Me = fe.tag[Ae];
    return {
      cls: Se,
      primitive: $e,
      tag: Ae,
      tagStr: Me
    };
  }
  function me(ye, be, Ae) {
    var Se = ye.readUInt8(Ae);
    if (ye.isError(Se))
      return Se;
    if (!be && Se === 128)
      return null;
    if (!(Se & 128))
      return Se;
    var $e = Se & 127;
    if ($e > 4)
      return ye.error("length octect is too long");
    Se = 0;
    for (var Re = 0; Re < $e; Re++) {
      Se <<= 8;
      var Me = ye.readUInt8(Ae);
      if (ye.isError(Me))
        return Me;
      Se |= Me;
    }
    return Se;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var c = inherits_browserExports, t = require$$0$5.Buffer, n = requireDer$1();
  function ie(fe) {
    n.call(this, fe), this.enc = "pem";
  }
  return c(ie, n), pem$1 = ie, ie.prototype.decode = function(ae, le) {
    for (var he = ae.toString().split(/[\r\n]+/g), me = le.label.toUpperCase(), ye = /^-----(BEGIN|END) ([^-]+)-----$/, be = -1, Ae = -1, Se = 0; Se < he.length; Se++) {
      var $e = he[Se].match(ye);
      if ($e !== null && $e[2] === me)
        if (be === -1) {
          if ($e[1] !== "BEGIN")
            break;
          be = Se;
        } else {
          if ($e[1] !== "END")
            break;
          Ae = Se;
          break;
        }
    }
    if (be === -1 || Ae === -1)
      throw new Error("PEM section not found for: " + me);
    var Re = he.slice(be + 1, Ae).join("");
    Re.replace(/[^a-z0-9\+\/=]+/gi, "");
    var Me = new t(Re, "base64");
    return n.prototype.decode.call(this, Me, le);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(c) {
    var t = c;
    t.der = requireDer$1(), t.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var c = inherits_browserExports, t = require$$0$5.Buffer, n = requireAsn1$1(), ie = n.base, fe = n.constants.der;
  function ae(ye) {
    this.enc = "der", this.name = ye.name, this.entity = ye, this.tree = new le(), this.tree._init(ye.body);
  }
  der_1 = ae, ae.prototype.encode = function(be, Ae) {
    return this.tree._encode(be, Ae).join();
  };
  function le(ye) {
    ie.Node.call(this, "der", ye);
  }
  c(le, ie.Node), le.prototype._encodeComposite = function(be, Ae, Se, $e) {
    var Re = me(be, Ae, Se, this.reporter);
    if ($e.length < 128) {
      var Te = new t(2);
      return Te[0] = Re, Te[1] = $e.length, this._createEncoderBuffer([Te, $e]);
    }
    for (var Me = 1, ke = $e.length; ke >= 256; ke >>= 8)
      Me++;
    var Te = new t(2 + Me);
    Te[0] = Re, Te[1] = 128 | Me;
    for (var ke = 1 + Me, Ie = $e.length; Ie > 0; ke--, Ie >>= 8)
      Te[ke] = Ie & 255;
    return this._createEncoderBuffer([Te, $e]);
  }, le.prototype._encodeStr = function(be, Ae) {
    if (Ae === "bitstr")
      return this._createEncoderBuffer([be.unused | 0, be.data]);
    if (Ae === "bmpstr") {
      for (var Se = new t(be.length * 2), $e = 0; $e < be.length; $e++)
        Se.writeUInt16BE(be.charCodeAt($e), $e * 2);
      return this._createEncoderBuffer(Se);
    } else return Ae === "numstr" ? this._isNumstr(be) ? this._createEncoderBuffer(be) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : Ae === "printstr" ? this._isPrintstr(be) ? this._createEncoderBuffer(be) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(Ae) ? this._createEncoderBuffer(be) : Ae === "objDesc" ? this._createEncoderBuffer(be) : this.reporter.error("Encoding of string type: " + Ae + " unsupported");
  }, le.prototype._encodeObjid = function(be, Ae, Se) {
    if (typeof be == "string") {
      if (!Ae)
        return this.reporter.error("string objid given, but no values map found");
      if (!Ae.hasOwnProperty(be))
        return this.reporter.error("objid not found in values map");
      be = Ae[be].split(/[\s\.]+/g);
      for (var $e = 0; $e < be.length; $e++)
        be[$e] |= 0;
    } else if (Array.isArray(be)) {
      be = be.slice();
      for (var $e = 0; $e < be.length; $e++)
        be[$e] |= 0;
    }
    if (!Array.isArray(be))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(be));
    if (!Se) {
      if (be[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      be.splice(0, 2, be[0] * 40 + be[1]);
    }
    for (var Re = 0, $e = 0; $e < be.length; $e++) {
      var Me = be[$e];
      for (Re++; Me >= 128; Me >>= 7)
        Re++;
    }
    for (var ke = new t(Re), Te = ke.length - 1, $e = be.length - 1; $e >= 0; $e--) {
      var Me = be[$e];
      for (ke[Te--] = Me & 127; (Me >>= 7) > 0; )
        ke[Te--] = 128 | Me & 127;
    }
    return this._createEncoderBuffer(ke);
  };
  function he(ye) {
    return ye < 10 ? "0" + ye : ye;
  }
  le.prototype._encodeTime = function(be, Ae) {
    var Se, $e = new Date(be);
    return Ae === "gentime" ? Se = [
      he($e.getFullYear()),
      he($e.getUTCMonth() + 1),
      he($e.getUTCDate()),
      he($e.getUTCHours()),
      he($e.getUTCMinutes()),
      he($e.getUTCSeconds()),
      "Z"
    ].join("") : Ae === "utctime" ? Se = [
      he($e.getFullYear() % 100),
      he($e.getUTCMonth() + 1),
      he($e.getUTCDate()),
      he($e.getUTCHours()),
      he($e.getUTCMinutes()),
      he($e.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + Ae + " time is not supported yet"), this._encodeStr(Se, "octstr");
  }, le.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, le.prototype._encodeInt = function(be, Ae) {
    if (typeof be == "string") {
      if (!Ae)
        return this.reporter.error("String int or enum given, but no values map");
      if (!Ae.hasOwnProperty(be))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(be));
      be = Ae[be];
    }
    if (typeof be != "number" && !t.isBuffer(be)) {
      var Se = be.toArray();
      !be.sign && Se[0] & 128 && Se.unshift(0), be = new t(Se);
    }
    if (t.isBuffer(be)) {
      var $e = be.length;
      be.length === 0 && $e++;
      var Me = new t($e);
      return be.copy(Me), be.length === 0 && (Me[0] = 0), this._createEncoderBuffer(Me);
    }
    if (be < 128)
      return this._createEncoderBuffer(be);
    if (be < 256)
      return this._createEncoderBuffer([0, be]);
    for (var $e = 1, Re = be; Re >= 256; Re >>= 8)
      $e++;
    for (var Me = new Array($e), Re = Me.length - 1; Re >= 0; Re--)
      Me[Re] = be & 255, be >>= 8;
    return Me[0] & 128 && Me.unshift(0), this._createEncoderBuffer(new t(Me));
  }, le.prototype._encodeBool = function(be) {
    return this._createEncoderBuffer(be ? 255 : 0);
  }, le.prototype._use = function(be, Ae) {
    return typeof be == "function" && (be = be(Ae)), be._getEncoder("der").tree;
  }, le.prototype._skipDefault = function(be, Ae, Se) {
    var $e = this._baseState, Re;
    if ($e.default === null)
      return !1;
    var Me = be.join();
    if ($e.defaultBuffer === void 0 && ($e.defaultBuffer = this._encodeValue($e.default, Ae, Se).join()), Me.length !== $e.defaultBuffer.length)
      return !1;
    for (Re = 0; Re < Me.length; Re++)
      if (Me[Re] !== $e.defaultBuffer[Re])
        return !1;
    return !0;
  };
  function me(ye, be, Ae, Se) {
    var $e;
    if (ye === "seqof" ? ye = "seq" : ye === "setof" && (ye = "set"), fe.tagByName.hasOwnProperty(ye))
      $e = fe.tagByName[ye];
    else if (typeof ye == "number" && (ye | 0) === ye)
      $e = ye;
    else
      return Se.error("Unknown tag: " + ye);
    return $e >= 31 ? Se.error("Multi-octet tag encoding unsupported") : (be || ($e |= 32), $e |= fe.tagClassByName[Ae || "universal"] << 6, $e);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var c = inherits_browserExports, t = requireDer();
  function n(ie) {
    t.call(this, ie), this.enc = "pem";
  }
  return c(n, t), pem = n, n.prototype.encode = function(fe, ae) {
    for (var le = t.prototype.encode.call(this, fe), he = le.toString("base64"), me = ["-----BEGIN " + ae.label + "-----"], ye = 0; ye < he.length; ye += 64)
      me.push(he.slice(ye, ye + 64));
    return me.push("-----END " + ae.label + "-----"), me.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(c) {
    var t = c;
    t.der = requireDer(), t.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(c) {
    var t = c;
    t.bignum = requireBn$2(), t.define = requireApi().define, t.base = requireBase(), t.constants = requireConstants(), t.decoders = requireDecoders(), t.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var c = requireAsn1$1(), t = c.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), n = c.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), ie = c.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), fe = c.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(ie),
      this.key("subjectPublicKey").bitstr()
    );
  }), ae = c.define("RelativeDistinguishedName", function() {
    this.setof(n);
  }), le = c.define("RDNSequence", function() {
    this.seqof(ae);
  }), he = c.define("Name", function() {
    this.choice({
      rdnSequence: this.use(le)
    });
  }), me = c.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(t),
      this.key("notAfter").use(t)
    );
  }), ye = c.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), be = c.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(ie),
      this.key("issuer").use(he),
      this.key("validity").use(me),
      this.key("subject").use(he),
      this.key("subjectPublicKeyInfo").use(fe),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(ye).optional()
    );
  }), Ae = c.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(be),
      this.key("signatureAlgorithm").use(ie),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = Ae, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var c = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var t = c.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = t;
  var n = c.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = n;
  var ie = c.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), fe = c.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(ie),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = fe;
  var ae = c.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(ie),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = ae;
  var le = c.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = le;
  var he = c.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = he, asn1$1.DSAparam = c.define("DSAparam", function() {
    this.int();
  });
  var me = c.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), ye = c.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(me),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = ye, asn1$1.signature = c.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var c = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, t = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, n = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, ie = requireEvp_bytestokey(), fe = requireBrowser$6(), ae = safeBufferExports.Buffer;
  return fixProc = function(le, he) {
    var me = le.toString(), ye = me.match(c), be;
    if (ye) {
      var Se = "aes" + ye[1], $e = ae.from(ye[2], "hex"), Re = ae.from(ye[3].replace(/[\r\n]/g, ""), "base64"), Me = ie(he, $e.slice(0, 8), parseInt(ye[1], 10)).key, ke = [], Te = fe.createDecipheriv(Se, Me, $e);
      ke.push(Te.update(Re)), ke.push(Te.final()), be = ae.concat(ke);
    } else {
      var Ae = me.match(n);
      be = ae.from(Ae[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Ie = me.match(t)[1];
    return {
      tag: Ie,
      data: be
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var c = requireAsn1(), t = require$$1, n = requireFixProc(), ie = requireBrowser$6(), fe = requireBrowser$7(), ae = safeBufferExports.Buffer;
  function le(me, ye) {
    var be = me.algorithm.decrypt.kde.kdeparams.salt, Ae = parseInt(me.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), Se = t[me.algorithm.decrypt.cipher.algo.join(".")], $e = me.algorithm.decrypt.cipher.iv, Re = me.subjectPrivateKey, Me = parseInt(Se.split("-")[1], 10) / 8, ke = fe.pbkdf2Sync(ye, be, Ae, Me, "sha1"), Te = ie.createDecipheriv(Se, ke, $e), Ie = [];
    return Ie.push(Te.update(Re)), Ie.push(Te.final()), ae.concat(Ie);
  }
  function he(me) {
    var ye;
    typeof me == "object" && !ae.isBuffer(me) && (ye = me.passphrase, me = me.key), typeof me == "string" && (me = ae.from(me));
    var be = n(me, ye), Ae = be.tag, Se = be.data, $e, Re;
    switch (Ae) {
      case "CERTIFICATE":
        Re = c.certificate.decode(Se, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (Re || (Re = c.PublicKey.decode(Se, "der")), $e = Re.algorithm.algorithm.join("."), $e) {
          case "1.2.840.113549.1.1.1":
            return c.RSAPublicKey.decode(Re.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return Re.subjectPrivateKey = Re.subjectPublicKey, {
              type: "ec",
              data: Re
            };
          case "1.2.840.10040.4.1":
            return Re.algorithm.params.pub_key = c.DSAparam.decode(Re.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: Re.algorithm.params
            };
          default:
            throw new Error("unknown key id " + $e);
        }
      case "ENCRYPTED PRIVATE KEY":
        Se = c.EncryptedPrivateKey.decode(Se, "der"), Se = le(Se, ye);
      case "PRIVATE KEY":
        switch (Re = c.PrivateKey.decode(Se, "der"), $e = Re.algorithm.algorithm.join("."), $e) {
          case "1.2.840.113549.1.1.1":
            return c.RSAPrivateKey.decode(Re.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: Re.algorithm.curve,
              privateKey: c.ECPrivateKey.decode(Re.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return Re.algorithm.params.priv_key = c.DSAparam.decode(Re.subjectPrivateKey, "der"), {
              type: "dsa",
              params: Re.algorithm.params
            };
          default:
            throw new Error("unknown key id " + $e);
        }
      case "RSA PUBLIC KEY":
        return c.RSAPublicKey.decode(Se, "der");
      case "RSA PRIVATE KEY":
        return c.RSAPrivateKey.decode(Se, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: c.DSAPrivateKey.decode(Se, "der")
        };
      case "EC PRIVATE KEY":
        return Se = c.ECPrivateKey.decode(Se, "der"), {
          curve: Se.parameters.value,
          privateKey: Se.privateKey
        };
      default:
        throw new Error("unknown key type " + Ae);
    }
  }
  return he.signature = c.signature, parseAsn1 = he, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign.exports;
  hasRequiredSign = 1;
  var c = safeBufferExports.Buffer, t = requireBrowser$8(), n = requireBrowserifyRsa(), ie = requireElliptic$1().ec, fe = bnExports$3, ae = requireParseAsn1(), le = require$$4, he = 1;
  function me(Te, Ie, qe, Ue, ze) {
    var Ve = ae(Ie);
    if (Ve.curve) {
      if (Ue !== "ecdsa" && Ue !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return ye(Te, Ve);
    } else if (Ve.type === "dsa") {
      if (Ue !== "dsa")
        throw new Error("wrong private key type");
      return be(Te, Ve, qe);
    }
    if (Ue !== "rsa" && Ue !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Ie.padding !== void 0 && Ie.padding !== he)
      throw new Error("illegal or unsupported padding mode");
    Te = c.concat([ze, Te]);
    for (var Mt = Ve.modulus.byteLength(), Rt = [0, 1]; Te.length + Rt.length + 1 < Mt; )
      Rt.push(255);
    Rt.push(0);
    for (var je = -1; ++je < Te.length; )
      Rt.push(Te[je]);
    var jt = n(Rt, Ve);
    return jt;
  }
  function ye(Te, Ie) {
    var qe = le[Ie.curve.join(".")];
    if (!qe)
      throw new Error("unknown curve " + Ie.curve.join("."));
    var Ue = new ie(qe), ze = Ue.keyFromPrivate(Ie.privateKey), Ve = ze.sign(Te);
    return c.from(Ve.toDER());
  }
  function be(Te, Ie, qe) {
    for (var Ue = Ie.params.priv_key, ze = Ie.params.p, Ve = Ie.params.q, Mt = Ie.params.g, Rt = new fe(0), je, jt = $e(Te, Ve).mod(Ve), _e = !1, se = Se(Ue, Ve, Te, qe); _e === !1; )
      je = Me(Ve, se, qe), Rt = ke(Mt, je, ze, Ve), _e = je.invm(Ve).imul(jt.add(Ue.mul(Rt))).mod(Ve), _e.cmpn(0) === 0 && (_e = !1, Rt = new fe(0));
    return Ae(Rt, _e);
  }
  function Ae(Te, Ie) {
    Te = Te.toArray(), Ie = Ie.toArray(), Te[0] & 128 && (Te = [0].concat(Te)), Ie[0] & 128 && (Ie = [0].concat(Ie));
    var qe = Te.length + Ie.length + 4, Ue = [
      48,
      qe,
      2,
      Te.length
    ];
    return Ue = Ue.concat(Te, [2, Ie.length], Ie), c.from(Ue);
  }
  function Se(Te, Ie, qe, Ue) {
    if (Te = c.from(Te.toArray()), Te.length < Ie.byteLength()) {
      var ze = c.alloc(Ie.byteLength() - Te.length);
      Te = c.concat([ze, Te]);
    }
    var Ve = qe.length, Mt = Re(qe, Ie), Rt = c.alloc(Ve);
    Rt.fill(1);
    var je = c.alloc(Ve);
    return je = t(Ue, je).update(Rt).update(c.from([0])).update(Te).update(Mt).digest(), Rt = t(Ue, je).update(Rt).digest(), je = t(Ue, je).update(Rt).update(c.from([1])).update(Te).update(Mt).digest(), Rt = t(Ue, je).update(Rt).digest(), { k: je, v: Rt };
  }
  function $e(Te, Ie) {
    var qe = new fe(Te), Ue = (Te.length << 3) - Ie.bitLength();
    return Ue > 0 && qe.ishrn(Ue), qe;
  }
  function Re(Te, Ie) {
    Te = $e(Te, Ie), Te = Te.mod(Ie);
    var qe = c.from(Te.toArray());
    if (qe.length < Ie.byteLength()) {
      var Ue = c.alloc(Ie.byteLength() - qe.length);
      qe = c.concat([Ue, qe]);
    }
    return qe;
  }
  function Me(Te, Ie, qe) {
    var Ue, ze;
    do {
      for (Ue = c.alloc(0); Ue.length * 8 < Te.bitLength(); )
        Ie.v = t(qe, Ie.k).update(Ie.v).digest(), Ue = c.concat([Ue, Ie.v]);
      ze = $e(Ue, Te), Ie.k = t(qe, Ie.k).update(Ie.v).update(c.from([0])).digest(), Ie.v = t(qe, Ie.k).update(Ie.v).digest();
    } while (ze.cmp(Te) !== -1);
    return ze;
  }
  function ke(Te, Ie, qe, Ue) {
    return Te.toRed(fe.mont(qe)).redPow(Ie).fromRed().mod(Ue);
  }
  return sign.exports = me, sign.exports.getKey = Se, sign.exports.makeKey = Me, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var c = safeBufferExports.Buffer, t = bnExports$3, n = requireElliptic$1().ec, ie = requireParseAsn1(), fe = require$$4;
  function ae(ye, be, Ae, Se, $e) {
    var Re = ie(Ae);
    if (Re.type === "ec") {
      if (Se !== "ecdsa" && Se !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return le(ye, be, Re);
    } else if (Re.type === "dsa") {
      if (Se !== "dsa")
        throw new Error("wrong public key type");
      return he(ye, be, Re);
    }
    if (Se !== "rsa" && Se !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    be = c.concat([$e, be]);
    for (var Me = Re.modulus.byteLength(), ke = [1], Te = 0; be.length + ke.length + 2 < Me; )
      ke.push(255), Te += 1;
    ke.push(0);
    for (var Ie = -1; ++Ie < be.length; )
      ke.push(be[Ie]);
    ke = c.from(ke);
    var qe = t.mont(Re.modulus);
    ye = new t(ye).toRed(qe), ye = ye.redPow(new t(Re.publicExponent)), ye = c.from(ye.fromRed().toArray());
    var Ue = Te < 8 ? 1 : 0;
    for (Me = Math.min(ye.length, ke.length), ye.length !== ke.length && (Ue = 1), Ie = -1; ++Ie < Me; )
      Ue |= ye[Ie] ^ ke[Ie];
    return Ue === 0;
  }
  function le(ye, be, Ae) {
    var Se = fe[Ae.data.algorithm.curve.join(".")];
    if (!Se)
      throw new Error("unknown curve " + Ae.data.algorithm.curve.join("."));
    var $e = new n(Se), Re = Ae.data.subjectPrivateKey.data;
    return $e.verify(be, ye, Re);
  }
  function he(ye, be, Ae) {
    var Se = Ae.data.p, $e = Ae.data.q, Re = Ae.data.g, Me = Ae.data.pub_key, ke = ie.signature.decode(ye, "der"), Te = ke.s, Ie = ke.r;
    me(Te, $e), me(Ie, $e);
    var qe = t.mont(Se), Ue = Te.invm($e), ze = Re.toRed(qe).redPow(new t(be).mul(Ue).mod($e)).fromRed().mul(Me.toRed(qe).redPow(Ie.mul(Ue).mod($e)).fromRed()).mod(Se).mod($e);
    return ze.cmp(Ie) === 0;
  }
  function me(ye, be) {
    if (ye.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (ye.cmp(be) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = ae, verify_1;
}
var browser$3, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$3;
  hasRequiredBrowser$3 = 1;
  var c = safeBufferExports.Buffer, t = requireBrowser$9(), n = requireReadableBrowser(), ie = inherits_browserExports, fe = requireSign(), ae = requireVerify(), le = require$$6$1;
  Object.keys(le).forEach(function(Ae) {
    le[Ae].id = c.from(le[Ae].id, "hex"), le[Ae.toLowerCase()] = le[Ae];
  });
  function he(Ae) {
    n.Writable.call(this);
    var Se = le[Ae];
    if (!Se)
      throw new Error("Unknown message digest");
    this._hashType = Se.hash, this._hash = t(Se.hash), this._tag = Se.id, this._signType = Se.sign;
  }
  ie(he, n.Writable), he.prototype._write = function(Se, $e, Re) {
    this._hash.update(Se), Re();
  }, he.prototype.update = function(Se, $e) {
    return this._hash.update(typeof Se == "string" ? c.from(Se, $e) : Se), this;
  }, he.prototype.sign = function(Se, $e) {
    this.end();
    var Re = this._hash.digest(), Me = fe(Re, Se, this._hashType, this._signType, this._tag);
    return $e ? Me.toString($e) : Me;
  };
  function me(Ae) {
    n.Writable.call(this);
    var Se = le[Ae];
    if (!Se)
      throw new Error("Unknown message digest");
    this._hash = t(Se.hash), this._tag = Se.id, this._signType = Se.sign;
  }
  ie(me, n.Writable), me.prototype._write = function(Se, $e, Re) {
    this._hash.update(Se), Re();
  }, me.prototype.update = function(Se, $e) {
    return this._hash.update(typeof Se == "string" ? c.from(Se, $e) : Se), this;
  }, me.prototype.verify = function(Se, $e, Re) {
    var Me = typeof $e == "string" ? c.from($e, Re) : $e;
    this.end();
    var ke = this._hash.digest();
    return ae(Me, ke, Se, this._signType, this._tag);
  };
  function ye(Ae) {
    return new he(Ae);
  }
  function be(Ae) {
    return new me(Ae);
  }
  return browser$3 = {
    Sign: ye,
    Verify: be,
    createSign: ye,
    createVerify: be
  }, browser$3;
}
var elliptic = {};
const name = "elliptic", version$3 = "6.5.4", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0 = {
  name,
  version: version$3,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$9 = {}, bn$2 = { exports: {} };
bn$2.exports;
(function(c) {
  (function(t, n) {
    function ie(_e, se) {
      if (!_e) throw new Error(se || "Assertion failed");
    }
    function fe(_e, se) {
      _e.super_ = se;
      var ce = function() {
      };
      ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
    }
    function ae(_e, se, ce) {
      if (ae.isBN(_e))
        return _e;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
    }
    typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
    var le;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
    } catch {
    }
    ae.isBN = function(se) {
      return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
    }, ae.max = function(se, ce) {
      return se.cmp(ce) > 0 ? se : ce;
    }, ae.min = function(se, ce) {
      return se.cmp(ce) < 0 ? se : ce;
    }, ae.prototype._init = function(se, ce, de) {
      if (typeof se == "number")
        return this._initNumber(se, ce, de);
      if (typeof se == "object")
        return this._initArray(se, ce, de);
      ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
      var pe = 0;
      se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
    }, ae.prototype._initNumber = function(se, ce, de) {
      se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
        se & 67108863,
        se / 67108864 & 67108863
      ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
        se & 67108863,
        se / 67108864 & 67108863,
        1
      ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
    }, ae.prototype._initArray = function(se, ce, de) {
      if (ie(typeof se.length == "number"), se.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve, we, Ee = 0;
      if (de === "be")
        for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
          we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      else if (de === "le")
        for (pe = 0, ve = 0; pe < se.length; pe += 3)
          we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
      return this.strip();
    };
    function he(_e, se) {
      var ce = _e.charCodeAt(se);
      return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
    }
    function me(_e, se, ce) {
      var de = he(_e, ce);
      return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
    }
    ae.prototype._parseHex = function(se, ce, de) {
      this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
      for (var pe = 0; pe < this.length; pe++)
        this.words[pe] = 0;
      var ve = 0, we = 0, Ee;
      if (de === "be")
        for (pe = se.length - 1; pe >= ce; pe -= 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      else {
        var xe = se.length - ce;
        for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
          Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
      }
      this.strip();
    };
    function ye(_e, se, ce, de) {
      for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
        var Ee = _e.charCodeAt(we) - 48;
        pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
      }
      return pe;
    }
    ae.prototype._parseBase = function(se, ce, de) {
      this.words = [0], this.length = 1;
      for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
        pe++;
      pe--, ve = ve / ce | 0;
      for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
        ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      if (Ee !== 0) {
        var Be = 1;
        for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
          Be *= ce;
        this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
      }
      this.strip();
    }, ae.prototype.copy = function(se) {
      se.words = new Array(this.length);
      for (var ce = 0; ce < this.length; ce++)
        se.words[ce] = this.words[ce];
      se.length = this.length, se.negative = this.negative, se.red = this.red;
    }, ae.prototype.clone = function() {
      var se = new ae(null);
      return this.copy(se), se;
    }, ae.prototype._expand = function(se) {
      for (; this.length < se; )
        this.words[this.length++] = 0;
      return this;
    }, ae.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, ae.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, ae.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var be = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Ae = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Se = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    ae.prototype.toString = function(se, ce) {
      se = se || 10, ce = ce | 0 || 1;
      var de;
      if (se === 16 || se === "hex") {
        de = "";
        for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
          var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
          ve = Ee >>> 24 - pe & 16777215, ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de, pe += 2, pe >= 26 && (pe -= 26, we--);
        }
        for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      if (se === (se | 0) && se >= 2 && se <= 36) {
        var ue = Ae[se], ge = Se[se];
        de = "";
        var Be = this.clone();
        for (Be.negative = 0; !Be.isZero(); ) {
          var Ne = Be.modn(ge).toString(se);
          Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
        }
        for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
          de = "0" + de;
        return this.negative !== 0 && (de = "-" + de), de;
      }
      ie(!1, "Base should be between 2 and 36");
    }, ae.prototype.toNumber = function() {
      var se = this.words[0];
      return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
    }, ae.prototype.toJSON = function() {
      return this.toString(16);
    }, ae.prototype.toBuffer = function(se, ce) {
      return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
    }, ae.prototype.toArray = function(se, ce) {
      return this.toArrayLike(Array, se, ce);
    }, ae.prototype.toArrayLike = function(se, ce, de) {
      var pe = this.byteLength(), ve = de || Math.max(1, pe);
      ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
      var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
      if (we) {
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
        for (; ue < ve; ue++)
          Ee[ue] = 0;
      } else {
        for (ue = 0; ue < ve - pe; ue++)
          Ee[ue] = 0;
        for (ue = 0; !ge.isZero(); ue++)
          xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
      }
      return Ee;
    }, Math.clz32 ? ae.prototype._countBits = function(se) {
      return 32 - Math.clz32(se);
    } : ae.prototype._countBits = function(se) {
      var ce = se, de = 0;
      return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
    }, ae.prototype._zeroBits = function(se) {
      if (se === 0) return 26;
      var ce = se, de = 0;
      return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
    }, ae.prototype.bitLength = function() {
      var se = this.words[this.length - 1], ce = this._countBits(se);
      return (this.length - 1) * 26 + ce;
    };
    function $e(_e) {
      for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
        var de = ce / 26 | 0, pe = ce % 26;
        se[ce] = (_e.words[de] & 1 << pe) >>> pe;
      }
      return se;
    }
    ae.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var se = 0, ce = 0; ce < this.length; ce++) {
        var de = this._zeroBits(this.words[ce]);
        if (se += de, de !== 26) break;
      }
      return se;
    }, ae.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, ae.prototype.toTwos = function(se) {
      return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
    }, ae.prototype.fromTwos = function(se) {
      return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
    }, ae.prototype.isNeg = function() {
      return this.negative !== 0;
    }, ae.prototype.neg = function() {
      return this.clone().ineg();
    }, ae.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, ae.prototype.iuor = function(se) {
      for (; this.length < se.length; )
        this.words[this.length++] = 0;
      for (var ce = 0; ce < se.length; ce++)
        this.words[ce] = this.words[ce] | se.words[ce];
      return this.strip();
    }, ae.prototype.ior = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuor(se);
    }, ae.prototype.or = function(se) {
      return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
    }, ae.prototype.uor = function(se) {
      return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
    }, ae.prototype.iuand = function(se) {
      var ce;
      this.length > se.length ? ce = se : ce = this;
      for (var de = 0; de < ce.length; de++)
        this.words[de] = this.words[de] & se.words[de];
      return this.length = ce.length, this.strip();
    }, ae.prototype.iand = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuand(se);
    }, ae.prototype.and = function(se) {
      return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
    }, ae.prototype.uand = function(se) {
      return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
    }, ae.prototype.iuxor = function(se) {
      var ce, de;
      this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
      for (var pe = 0; pe < de.length; pe++)
        this.words[pe] = ce.words[pe] ^ de.words[pe];
      if (this !== ce)
        for (; pe < ce.length; pe++)
          this.words[pe] = ce.words[pe];
      return this.length = ce.length, this.strip();
    }, ae.prototype.ixor = function(se) {
      return ie((this.negative | se.negative) === 0), this.iuxor(se);
    }, ae.prototype.xor = function(se) {
      return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
    }, ae.prototype.uxor = function(se) {
      return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
    }, ae.prototype.inotn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = Math.ceil(se / 26) | 0, de = se % 26;
      this._expand(ce), de > 0 && ce--;
      for (var pe = 0; pe < ce; pe++)
        this.words[pe] = ~this.words[pe] & 67108863;
      return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
    }, ae.prototype.notn = function(se) {
      return this.clone().inotn(se);
    }, ae.prototype.setn = function(se, ce) {
      ie(typeof se == "number" && se >= 0);
      var de = se / 26 | 0, pe = se % 26;
      return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
    }, ae.prototype.iadd = function(se) {
      var ce;
      if (this.negative !== 0 && se.negative === 0)
        return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && se.negative !== 0)
        return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
      var de, pe;
      this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
      for (var ve = 0, we = 0; we < pe.length; we++)
        ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      for (; ve !== 0 && we < de.length; we++)
        ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
      if (this.length = de.length, ve !== 0)
        this.words[this.length] = ve, this.length++;
      else if (de !== this)
        for (; we < de.length; we++)
          this.words[we] = de.words[we];
      return this;
    }, ae.prototype.add = function(se) {
      var ce;
      return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
    }, ae.prototype.isub = function(se) {
      if (se.negative !== 0) {
        se.negative = 0;
        var ce = this.iadd(se);
        return se.negative = 1, ce._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
      var de = this.cmp(se);
      if (de === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var pe, ve;
      de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
      for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
        ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      for (; we !== 0 && Ee < pe.length; Ee++)
        ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
      if (we === 0 && Ee < pe.length && pe !== this)
        for (; Ee < pe.length; Ee++)
          this.words[Ee] = pe.words[Ee];
      return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
    }, ae.prototype.sub = function(se) {
      return this.clone().isub(se);
    };
    function Re(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative;
      var de = _e.length + se.length | 0;
      ce.length = de, de = de - 1 | 0;
      var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
      ce.words[0] = Ee;
      for (var ue = 1; ue < de; ue++) {
        for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
          var Pe = ue - Fe | 0;
          pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
        }
        ce.words[ue] = Be | 0, xe = ge | 0;
      }
      return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
    }
    var Me = function(se, ce, de) {
      var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
      de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
      var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
      var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
      var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
      var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
      var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
      var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
      var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
      var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
      var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
      var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
      var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
      var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
      var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
      var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
      var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
      var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
      var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
      var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
      var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
      return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
    };
    Math.imul || (Me = Re);
    function ke(_e, se, ce) {
      ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
      for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
        var we = pe;
        pe = 0;
        for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
          var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
          we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
        }
        ce.words[ve] = Ee, de = we, we = pe;
      }
      return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
    }
    function Te(_e, se, ce) {
      var de = new Ie();
      return de.mulp(_e, se, ce);
    }
    ae.prototype.mulTo = function(se, ce) {
      var de, pe = this.length + se.length;
      return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
    };
    function Ie(_e, se) {
      this.x = _e, this.y = se;
    }
    Ie.prototype.makeRBT = function(se) {
      for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
        ce[pe] = this.revBin(pe, de, se);
      return ce;
    }, Ie.prototype.revBin = function(se, ce, de) {
      if (se === 0 || se === de - 1) return se;
      for (var pe = 0, ve = 0; ve < ce; ve++)
        pe |= (se & 1) << ce - ve - 1, se >>= 1;
      return pe;
    }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
      for (var Ee = 0; Ee < we; Ee++)
        pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
    }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
      this.permute(we, se, ce, de, pe, ve);
      for (var Ee = 1; Ee < ve; Ee <<= 1)
        for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
          for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
            var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
            Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
          }
    }, Ie.prototype.guessLen13b = function(se, ce) {
      var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
      for (de = de / 2 | 0; de; de = de >>> 1)
        ve++;
      return 1 << ve + 1 + pe;
    }, Ie.prototype.conjugate = function(se, ce, de) {
      if (!(de <= 1))
        for (var pe = 0; pe < de / 2; pe++) {
          var ve = se[pe];
          se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
        }
    }, Ie.prototype.normalize13b = function(se, ce) {
      for (var de = 0, pe = 0; pe < ce / 2; pe++) {
        var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
        se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
      }
      return se;
    }, Ie.prototype.convert13b = function(se, ce, de, pe) {
      for (var ve = 0, we = 0; we < ce; we++)
        ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
      for (we = 2 * ce; we < pe; ++we)
        de[we] = 0;
      ie(ve === 0), ie((ve & -8192) === 0);
    }, Ie.prototype.stub = function(se) {
      for (var ce = new Array(se), de = 0; de < se; de++)
        ce[de] = 0;
      return ce;
    }, Ie.prototype.mulp = function(se, ce, de) {
      var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
      Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
      for (var Pe = 0; Pe < pe; Pe++) {
        var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
        ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
      }
      return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
    }, ae.prototype.mul = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
    }, ae.prototype.mulf = function(se) {
      var ce = new ae(null);
      return ce.words = new Array(this.length + se.length), Te(this, se, ce);
    }, ae.prototype.imul = function(se) {
      return this.clone().mulTo(se, this);
    }, ae.prototype.imuln = function(se) {
      ie(typeof se == "number"), ie(se < 67108864);
      for (var ce = 0, de = 0; de < this.length; de++) {
        var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
        ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
      }
      return ce !== 0 && (this.words[de] = ce, this.length++), this;
    }, ae.prototype.muln = function(se) {
      return this.clone().imuln(se);
    }, ae.prototype.sqr = function() {
      return this.mul(this);
    }, ae.prototype.isqr = function() {
      return this.imul(this.clone());
    }, ae.prototype.pow = function(se) {
      var ce = $e(se);
      if (ce.length === 0) return new ae(1);
      for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
        ;
      if (++pe < ce.length)
        for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
          ce[pe] !== 0 && (de = de.mul(ve));
      return de;
    }, ae.prototype.iushln = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
      if (ce !== 0) {
        var we = 0;
        for (ve = 0; ve < this.length; ve++) {
          var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
          this.words[ve] = xe | we, we = Ee >>> 26 - ce;
        }
        we && (this.words[ve] = we, this.length++);
      }
      if (de !== 0) {
        for (ve = this.length - 1; ve >= 0; ve--)
          this.words[ve + de] = this.words[ve];
        for (ve = 0; ve < de; ve++)
          this.words[ve] = 0;
        this.length += de;
      }
      return this.strip();
    }, ae.prototype.ishln = function(se) {
      return ie(this.negative === 0), this.iushln(se);
    }, ae.prototype.iushrn = function(se, ce, de) {
      ie(typeof se == "number" && se >= 0);
      var pe;
      ce ? pe = (ce - ce % 26) / 26 : pe = 0;
      var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
      if (pe -= we, pe = Math.max(0, pe), xe) {
        for (var ue = 0; ue < we; ue++)
          xe.words[ue] = this.words[ue];
        xe.length = we;
      }
      if (we !== 0) if (this.length > we)
        for (this.length -= we, ue = 0; ue < this.length; ue++)
          this.words[ue] = this.words[ue + we];
      else
        this.words[0] = 0, this.length = 1;
      var ge = 0;
      for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
        var Be = this.words[ue] | 0;
        this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
      }
      return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, ae.prototype.ishrn = function(se, ce, de) {
      return ie(this.negative === 0), this.iushrn(se, ce, de);
    }, ae.prototype.shln = function(se) {
      return this.clone().ishln(se);
    }, ae.prototype.ushln = function(se) {
      return this.clone().iushln(se);
    }, ae.prototype.shrn = function(se) {
      return this.clone().ishrn(se);
    }, ae.prototype.ushrn = function(se) {
      return this.clone().iushrn(se);
    }, ae.prototype.testn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de) return !1;
      var ve = this.words[de];
      return !!(ve & pe);
    }, ae.prototype.imaskn = function(se) {
      ie(typeof se == "number" && se >= 0);
      var ce = se % 26, de = (se - ce) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
        return this;
      if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
        var pe = 67108863 ^ 67108863 >>> ce << ce;
        this.words[this.length - 1] &= pe;
      }
      return this.strip();
    }, ae.prototype.maskn = function(se) {
      return this.clone().imaskn(se);
    }, ae.prototype.iaddn = function(se) {
      return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
    }, ae.prototype._iaddn = function(se) {
      this.words[0] += se;
      for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
        this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
      return this.length = Math.max(this.length, ce + 1), this;
    }, ae.prototype.isubn = function(se) {
      if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(se), this.negative = 1, this;
      if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
          this.words[ce] += 67108864, this.words[ce + 1] -= 1;
      return this.strip();
    }, ae.prototype.addn = function(se) {
      return this.clone().iaddn(se);
    }, ae.prototype.subn = function(se) {
      return this.clone().isubn(se);
    }, ae.prototype.iabs = function() {
      return this.negative = 0, this;
    }, ae.prototype.abs = function() {
      return this.clone().iabs();
    }, ae.prototype._ishlnsubmul = function(se, ce, de) {
      var pe = se.length + de, ve;
      this._expand(pe);
      var we, Ee = 0;
      for (ve = 0; ve < se.length; ve++) {
        we = (this.words[ve + de] | 0) + Ee;
        var xe = (se.words[ve] | 0) * ce;
        we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
      }
      for (; ve < this.length - de; ve++)
        we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
      if (Ee === 0) return this.strip();
      for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
        we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
      return this.negative = 1, this.strip();
    }, ae.prototype._wordDiv = function(se, ce) {
      var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
      de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
      var xe = pe.length - ve.length, ue;
      if (ce !== "mod") {
        ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
        for (var ge = 0; ge < ue.length; ge++)
          ue.words[ge] = 0;
      }
      var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
      Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
      for (var Ne = xe - 1; Ne >= 0; Ne--) {
        var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
        for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
          Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
        ue && (ue.words[Ne] = Fe);
      }
      return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
        div: ue || null,
        mod: pe
      };
    }, ae.prototype.divmod = function(se, ce, de) {
      if (ie(!se.isZero()), this.isZero())
        return {
          div: new ae(0),
          mod: new ae(0)
        };
      var pe, ve, we;
      return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
        div: pe,
        mod: ve
      }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
        div: pe,
        mod: we.mod
      }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
        div: we.div,
        mod: ve
      }) : se.length > this.length || this.cmp(se) < 0 ? {
        div: new ae(0),
        mod: this
      } : se.length === 1 ? ce === "div" ? {
        div: this.divn(se.words[0]),
        mod: null
      } : ce === "mod" ? {
        div: null,
        mod: new ae(this.modn(se.words[0]))
      } : {
        div: this.divn(se.words[0]),
        mod: new ae(this.modn(se.words[0]))
      } : this._wordDiv(se, ce);
    }, ae.prototype.div = function(se) {
      return this.divmod(se, "div", !1).div;
    }, ae.prototype.mod = function(se) {
      return this.divmod(se, "mod", !1).mod;
    }, ae.prototype.umod = function(se) {
      return this.divmod(se, "mod", !0).mod;
    }, ae.prototype.divRound = function(se) {
      var ce = this.divmod(se);
      if (ce.mod.isZero()) return ce.div;
      var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
      return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
    }, ae.prototype.modn = function(se) {
      ie(se <= 67108863);
      for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
        de = (ce * de + (this.words[pe] | 0)) % se;
      return de;
    }, ae.prototype.idivn = function(se) {
      ie(se <= 67108863);
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = (this.words[de] | 0) + ce * 67108864;
        this.words[de] = pe / se | 0, ce = pe % se;
      }
      return this.strip();
    }, ae.prototype.divn = function(se) {
      return this.clone().idivn(se);
    }, ae.prototype.egcd = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
        ce.iushrn(1), de.iushrn(1), ++xe;
      for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
        for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
        if (Be > 0)
          for (ce.iushrn(Be); Be-- > 0; )
            (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
        for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
        if (Fe > 0)
          for (de.iushrn(Fe); Fe-- > 0; )
            (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
      }
      return {
        a: we,
        b: Ee,
        gcd: de.iushln(xe)
      };
    }, ae.prototype._invmp = function(se) {
      ie(se.negative === 0), ie(!se.isZero());
      var ce = this, de = se.clone();
      ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
      for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
        for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
        if (Ee > 0)
          for (ce.iushrn(Ee); Ee-- > 0; )
            pe.isOdd() && pe.iadd(we), pe.iushrn(1);
        for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
        if (ue > 0)
          for (de.iushrn(ue); ue-- > 0; )
            ve.isOdd() && ve.iadd(we), ve.iushrn(1);
        ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
      }
      var Be;
      return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
    }, ae.prototype.gcd = function(se) {
      if (this.isZero()) return se.abs();
      if (se.isZero()) return this.abs();
      var ce = this.clone(), de = se.clone();
      ce.negative = 0, de.negative = 0;
      for (var pe = 0; ce.isEven() && de.isEven(); pe++)
        ce.iushrn(1), de.iushrn(1);
      do {
        for (; ce.isEven(); )
          ce.iushrn(1);
        for (; de.isEven(); )
          de.iushrn(1);
        var ve = ce.cmp(de);
        if (ve < 0) {
          var we = ce;
          ce = de, de = we;
        } else if (ve === 0 || de.cmpn(1) === 0)
          break;
        ce.isub(de);
      } while (!0);
      return de.iushln(pe);
    }, ae.prototype.invm = function(se) {
      return this.egcd(se).a.umod(se);
    }, ae.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, ae.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, ae.prototype.andln = function(se) {
      return this.words[0] & se;
    }, ae.prototype.bincn = function(se) {
      ie(typeof se == "number");
      var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
      if (this.length <= de)
        return this._expand(de + 1), this.words[de] |= pe, this;
      for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
        var Ee = this.words[we] | 0;
        Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
      }
      return ve !== 0 && (this.words[we] = ve, this.length++), this;
    }, ae.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, ae.prototype.cmpn = function(se) {
      var ce = se < 0;
      if (this.negative !== 0 && !ce) return -1;
      if (this.negative === 0 && ce) return 1;
      this.strip();
      var de;
      if (this.length > 1)
        de = 1;
      else {
        ce && (se = -se), ie(se <= 67108863, "Number is too big");
        var pe = this.words[0] | 0;
        de = pe === se ? 0 : pe < se ? -1 : 1;
      }
      return this.negative !== 0 ? -de | 0 : de;
    }, ae.prototype.cmp = function(se) {
      if (this.negative !== 0 && se.negative === 0) return -1;
      if (this.negative === 0 && se.negative !== 0) return 1;
      var ce = this.ucmp(se);
      return this.negative !== 0 ? -ce | 0 : ce;
    }, ae.prototype.ucmp = function(se) {
      if (this.length > se.length) return 1;
      if (this.length < se.length) return -1;
      for (var ce = 0, de = this.length - 1; de >= 0; de--) {
        var pe = this.words[de] | 0, ve = se.words[de] | 0;
        if (pe !== ve) {
          pe < ve ? ce = -1 : pe > ve && (ce = 1);
          break;
        }
      }
      return ce;
    }, ae.prototype.gtn = function(se) {
      return this.cmpn(se) === 1;
    }, ae.prototype.gt = function(se) {
      return this.cmp(se) === 1;
    }, ae.prototype.gten = function(se) {
      return this.cmpn(se) >= 0;
    }, ae.prototype.gte = function(se) {
      return this.cmp(se) >= 0;
    }, ae.prototype.ltn = function(se) {
      return this.cmpn(se) === -1;
    }, ae.prototype.lt = function(se) {
      return this.cmp(se) === -1;
    }, ae.prototype.lten = function(se) {
      return this.cmpn(se) <= 0;
    }, ae.prototype.lte = function(se) {
      return this.cmp(se) <= 0;
    }, ae.prototype.eqn = function(se) {
      return this.cmpn(se) === 0;
    }, ae.prototype.eq = function(se) {
      return this.cmp(se) === 0;
    }, ae.red = function(se) {
      return new je(se);
    }, ae.prototype.toRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
    }, ae.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, ae.prototype._forceRed = function(se) {
      return this.red = se, this;
    }, ae.prototype.forceRed = function(se) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
    }, ae.prototype.redAdd = function(se) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
    }, ae.prototype.redIAdd = function(se) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
    }, ae.prototype.redSub = function(se) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
    }, ae.prototype.redISub = function(se) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
    }, ae.prototype.redShl = function(se) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
    }, ae.prototype.redMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
    }, ae.prototype.redIMul = function(se) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
    }, ae.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, ae.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, ae.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, ae.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, ae.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, ae.prototype.redPow = function(se) {
      return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
    };
    var qe = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ue(_e, se) {
      this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ue.prototype._tmp = function() {
      var se = new ae(null);
      return se.words = new Array(Math.ceil(this.n / 13)), se;
    }, Ue.prototype.ireduce = function(se) {
      var ce = se, de;
      do
        this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
      while (de > this.n);
      var pe = de < this.n ? -1 : ce.ucmp(this.p);
      return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
    }, Ue.prototype.split = function(se, ce) {
      se.iushrn(this.n, 0, ce);
    }, Ue.prototype.imulK = function(se) {
      return se.imul(this.k);
    };
    function ze() {
      Ue.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    fe(ze, Ue), ze.prototype.split = function(se, ce) {
      for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
        ce.words[ve] = se.words[ve];
      if (ce.length = pe, se.length <= 9) {
        se.words[0] = 0, se.length = 1;
        return;
      }
      var we = se.words[9];
      for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
        var Ee = se.words[ve] | 0;
        se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
      }
      we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
    }, ze.prototype.imulK = function(se) {
      se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = se.words[de] | 0;
        ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
      }
      return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
    };
    function Ve() {
      Ue.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    fe(Ve, Ue);
    function Mt() {
      Ue.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    fe(Mt, Ue);
    function Rt() {
      Ue.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    fe(Rt, Ue), Rt.prototype.imulK = function(se) {
      for (var ce = 0, de = 0; de < se.length; de++) {
        var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
        pe >>>= 26, se.words[de] = ve, ce = pe;
      }
      return ce !== 0 && (se.words[se.length++] = ce), se;
    }, ae._prime = function(se) {
      if (qe[se]) return qe[se];
      var ce;
      if (se === "k256")
        ce = new ze();
      else if (se === "p224")
        ce = new Ve();
      else if (se === "p192")
        ce = new Mt();
      else if (se === "p25519")
        ce = new Rt();
      else
        throw new Error("Unknown prime " + se);
      return qe[se] = ce, ce;
    };
    function je(_e) {
      if (typeof _e == "string") {
        var se = ae._prime(_e);
        this.m = se.p, this.prime = se;
      } else
        ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
    }
    je.prototype._verify1 = function(se) {
      ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
    }, je.prototype._verify2 = function(se, ce) {
      ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
        se.red && se.red === ce.red,
        "red works only with red numbers"
      );
    }, je.prototype.imod = function(se) {
      return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
    }, je.prototype.neg = function(se) {
      return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
    }, je.prototype.add = function(se, ce) {
      this._verify2(se, ce);
      var de = se.add(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
    }, je.prototype.iadd = function(se, ce) {
      this._verify2(se, ce);
      var de = se.iadd(ce);
      return de.cmp(this.m) >= 0 && de.isub(this.m), de;
    }, je.prototype.sub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.sub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
    }, je.prototype.isub = function(se, ce) {
      this._verify2(se, ce);
      var de = se.isub(ce);
      return de.cmpn(0) < 0 && de.iadd(this.m), de;
    }, je.prototype.shl = function(se, ce) {
      return this._verify1(se), this.imod(se.ushln(ce));
    }, je.prototype.imul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.imul(ce));
    }, je.prototype.mul = function(se, ce) {
      return this._verify2(se, ce), this.imod(se.mul(ce));
    }, je.prototype.isqr = function(se) {
      return this.imul(se, se.clone());
    }, je.prototype.sqr = function(se) {
      return this.mul(se, se);
    }, je.prototype.sqrt = function(se) {
      if (se.isZero()) return se.clone();
      var ce = this.m.andln(3);
      if (ie(ce % 2 === 1), ce === 3) {
        var de = this.m.add(new ae(1)).iushrn(2);
        return this.pow(se, de);
      }
      for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
        ve++, pe.iushrn(1);
      ie(!pe.isZero());
      var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
      for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
        ue.redIAdd(Ee);
      for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
        for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
          Pe = Pe.redSqr();
        ie(Je < Fe);
        var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
        Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
      }
      return Be;
    }, je.prototype.invm = function(se) {
      var ce = se._invmp(this.m);
      return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
    }, je.prototype.pow = function(se, ce) {
      if (ce.isZero()) return new ae(1).toRed(this);
      if (ce.cmpn(1) === 0) return se.clone();
      var de = 4, pe = new Array(1 << de);
      pe[0] = new ae(1).toRed(this), pe[1] = se;
      for (var ve = 2; ve < pe.length; ve++)
        pe[ve] = this.mul(pe[ve - 1], se);
      var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
      for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
        for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
          var Ne = ge >> Be & 1;
          if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
            xe = 0;
            continue;
          }
          Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
        }
        ue = 26;
      }
      return we;
    }, je.prototype.convertTo = function(se) {
      var ce = se.umod(this.m);
      return ce === se ? ce.clone() : ce;
    }, je.prototype.convertFrom = function(se) {
      var ce = se.clone();
      return ce.red = null, ce;
    }, ae.mont = function(se) {
      return new jt(se);
    };
    function jt(_e) {
      je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    fe(jt, je), jt.prototype.convertTo = function(se) {
      return this.imod(se.ushln(this.shift));
    }, jt.prototype.convertFrom = function(se) {
      var ce = this.imod(se.mul(this.rinv));
      return ce.red = null, ce;
    }, jt.prototype.imul = function(se, ce) {
      if (se.isZero() || ce.isZero())
        return se.words[0] = 0, se.length = 1, se;
      var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.mul = function(se, ce) {
      if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
      var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
      return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
    }, jt.prototype.invm = function(se) {
      var ce = this.imod(se._invmp(this.m).mul(this.r2));
      return ce._forceRed(this);
    };
  })(c, commonjsGlobal);
})(bn$2);
var bnExports = bn$2.exports;
(function(c) {
  var t = c, n = bnExports, ie = minimalisticAssert$1, fe = utils$b;
  t.assert = ie, t.toArray = fe.toArray, t.zero2 = fe.zero2, t.toHex = fe.toHex, t.encode = fe.encode;
  function ae(be, Ae, Se) {
    var $e = new Array(Math.max(be.bitLength(), Se) + 1);
    $e.fill(0);
    for (var Re = 1 << Ae + 1, Me = be.clone(), ke = 0; ke < $e.length; ke++) {
      var Te, Ie = Me.andln(Re - 1);
      Me.isOdd() ? (Ie > (Re >> 1) - 1 ? Te = (Re >> 1) - Ie : Te = Ie, Me.isubn(Te)) : Te = 0, $e[ke] = Te, Me.iushrn(1);
    }
    return $e;
  }
  t.getNAF = ae;
  function le(be, Ae) {
    var Se = [
      [],
      []
    ];
    be = be.clone(), Ae = Ae.clone();
    for (var $e = 0, Re = 0, Me; be.cmpn(-$e) > 0 || Ae.cmpn(-Re) > 0; ) {
      var ke = be.andln(3) + $e & 3, Te = Ae.andln(3) + Re & 3;
      ke === 3 && (ke = -1), Te === 3 && (Te = -1);
      var Ie;
      ke & 1 ? (Me = be.andln(7) + $e & 7, (Me === 3 || Me === 5) && Te === 2 ? Ie = -ke : Ie = ke) : Ie = 0, Se[0].push(Ie);
      var qe;
      Te & 1 ? (Me = Ae.andln(7) + Re & 7, (Me === 3 || Me === 5) && ke === 2 ? qe = -Te : qe = Te) : qe = 0, Se[1].push(qe), 2 * $e === Ie + 1 && ($e = 1 - $e), 2 * Re === qe + 1 && (Re = 1 - Re), be.iushrn(1), Ae.iushrn(1);
    }
    return Se;
  }
  t.getJSF = le;
  function he(be, Ae, Se) {
    var $e = "_" + Ae;
    be.prototype[Ae] = function() {
      return this[$e] !== void 0 ? this[$e] : this[$e] = Se.call(this);
    };
  }
  t.cachedProperty = he;
  function me(be) {
    return typeof be == "string" ? t.toArray(be, "hex") : be;
  }
  t.parseBytes = me;
  function ye(be) {
    return new n(be, "hex", "le");
  }
  t.intFromLE = ye;
})(utils$9);
var curve = {}, BN$6 = bnExports, utils$8 = utils$9, getNAF = utils$8.getNAF, getJSF = utils$8.getJSF, assert$7 = utils$8.assert;
function BaseCurve(c, t) {
  this.type = c, this.p = new BN$6(t.p, 16), this.red = t.prime ? BN$6.red(t.prime) : BN$6.mont(this.p), this.zero = new BN$6(0).toRed(this.red), this.one = new BN$6(1).toRed(this.red), this.two = new BN$6(2).toRed(this.red), this.n = t.n && new BN$6(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var n = this.n && this.p.div(this.n);
  !n || n.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base = BaseCurve;
BaseCurve.prototype.point = function c() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function c() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function c(t, n) {
  assert$7(t.precomputed);
  var ie = t._getDoubles(), fe = getNAF(n, 1, this._bitLength), ae = (1 << ie.step + 1) - (ie.step % 2 === 0 ? 2 : 1);
  ae /= 3;
  var le = [], he, me;
  for (he = 0; he < fe.length; he += ie.step) {
    me = 0;
    for (var ye = he + ie.step - 1; ye >= he; ye--)
      me = (me << 1) + fe[ye];
    le.push(me);
  }
  for (var be = this.jpoint(null, null, null), Ae = this.jpoint(null, null, null), Se = ae; Se > 0; Se--) {
    for (he = 0; he < le.length; he++)
      me = le[he], me === Se ? Ae = Ae.mixedAdd(ie.points[he]) : me === -Se && (Ae = Ae.mixedAdd(ie.points[he].neg()));
    be = be.add(Ae);
  }
  return be.toP();
};
BaseCurve.prototype._wnafMul = function c(t, n) {
  var ie = 4, fe = t._getNAFPoints(ie);
  ie = fe.wnd;
  for (var ae = fe.points, le = getNAF(n, ie, this._bitLength), he = this.jpoint(null, null, null), me = le.length - 1; me >= 0; me--) {
    for (var ye = 0; me >= 0 && le[me] === 0; me--)
      ye++;
    if (me >= 0 && ye++, he = he.dblp(ye), me < 0)
      break;
    var be = le[me];
    assert$7(be !== 0), t.type === "affine" ? be > 0 ? he = he.mixedAdd(ae[be - 1 >> 1]) : he = he.mixedAdd(ae[-be - 1 >> 1].neg()) : be > 0 ? he = he.add(ae[be - 1 >> 1]) : he = he.add(ae[-be - 1 >> 1].neg());
  }
  return t.type === "affine" ? he.toP() : he;
};
BaseCurve.prototype._wnafMulAdd = function c(t, n, ie, fe, ae) {
  var le = this._wnafT1, he = this._wnafT2, me = this._wnafT3, ye = 0, be, Ae, Se;
  for (be = 0; be < fe; be++) {
    Se = n[be];
    var $e = Se._getNAFPoints(t);
    le[be] = $e.wnd, he[be] = $e.points;
  }
  for (be = fe - 1; be >= 1; be -= 2) {
    var Re = be - 1, Me = be;
    if (le[Re] !== 1 || le[Me] !== 1) {
      me[Re] = getNAF(ie[Re], le[Re], this._bitLength), me[Me] = getNAF(ie[Me], le[Me], this._bitLength), ye = Math.max(me[Re].length, ye), ye = Math.max(me[Me].length, ye);
      continue;
    }
    var ke = [
      n[Re],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      n[Me]
      /* 7 */
    ];
    n[Re].y.cmp(n[Me].y) === 0 ? (ke[1] = n[Re].add(n[Me]), ke[2] = n[Re].toJ().mixedAdd(n[Me].neg())) : n[Re].y.cmp(n[Me].y.redNeg()) === 0 ? (ke[1] = n[Re].toJ().mixedAdd(n[Me]), ke[2] = n[Re].add(n[Me].neg())) : (ke[1] = n[Re].toJ().mixedAdd(n[Me]), ke[2] = n[Re].toJ().mixedAdd(n[Me].neg()));
    var Te = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Ie = getJSF(ie[Re], ie[Me]);
    for (ye = Math.max(Ie[0].length, ye), me[Re] = new Array(ye), me[Me] = new Array(ye), Ae = 0; Ae < ye; Ae++) {
      var qe = Ie[0][Ae] | 0, Ue = Ie[1][Ae] | 0;
      me[Re][Ae] = Te[(qe + 1) * 3 + (Ue + 1)], me[Me][Ae] = 0, he[Re] = ke;
    }
  }
  var ze = this.jpoint(null, null, null), Ve = this._wnafT4;
  for (be = ye; be >= 0; be--) {
    for (var Mt = 0; be >= 0; ) {
      var Rt = !0;
      for (Ae = 0; Ae < fe; Ae++)
        Ve[Ae] = me[Ae][be] | 0, Ve[Ae] !== 0 && (Rt = !1);
      if (!Rt)
        break;
      Mt++, be--;
    }
    if (be >= 0 && Mt++, ze = ze.dblp(Mt), be < 0)
      break;
    for (Ae = 0; Ae < fe; Ae++) {
      var je = Ve[Ae];
      je !== 0 && (je > 0 ? Se = he[Ae][je - 1 >> 1] : je < 0 && (Se = he[Ae][-je - 1 >> 1].neg()), Se.type === "affine" ? ze = ze.mixedAdd(Se) : ze = ze.add(Se));
    }
  }
  for (be = 0; be < fe; be++)
    he[be] = null;
  return ae ? ze : ze.toP();
};
function BasePoint(c, t) {
  this.curve = c, this.type = t, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function c() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function c() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function c(t, n) {
  t = utils$8.toArray(t, n);
  var ie = this.p.byteLength();
  if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * ie) {
    t[0] === 6 ? assert$7(t[t.length - 1] % 2 === 0) : t[0] === 7 && assert$7(t[t.length - 1] % 2 === 1);
    var fe = this.point(
      t.slice(1, 1 + ie),
      t.slice(1 + ie, 1 + 2 * ie)
    );
    return fe;
  } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === ie)
    return this.pointFromX(t.slice(1, 1 + ie), t[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function c(t) {
  return this.encode(t, !0);
};
BasePoint.prototype._encode = function c(t) {
  var n = this.curve.p.byteLength(), ie = this.getX().toArray("be", n);
  return t ? [this.getY().isEven() ? 2 : 3].concat(ie) : [4].concat(ie, this.getY().toArray("be", n));
};
BasePoint.prototype.encode = function c(t, n) {
  return utils$8.encode(this._encode(n), t);
};
BasePoint.prototype.precompute = function c(t) {
  if (this.precomputed)
    return this;
  var n = {
    doubles: null,
    naf: null,
    beta: null
  };
  return n.naf = this._getNAFPoints(8), n.doubles = this._getDoubles(4, t), n.beta = this._getBeta(), this.precomputed = n, this;
};
BasePoint.prototype._hasDoubles = function c(t) {
  if (!this.precomputed)
    return !1;
  var n = this.precomputed.doubles;
  return n ? n.points.length >= Math.ceil((t.bitLength() + 1) / n.step) : !1;
};
BasePoint.prototype._getDoubles = function c(t, n) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var ie = [this], fe = this, ae = 0; ae < n; ae += t) {
    for (var le = 0; le < t; le++)
      fe = fe.dbl();
    ie.push(fe);
  }
  return {
    step: t,
    points: ie
  };
};
BasePoint.prototype._getNAFPoints = function c(t) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var n = [this], ie = (1 << t) - 1, fe = ie === 1 ? null : this.dbl(), ae = 1; ae < ie; ae++)
    n[ae] = n[ae - 1].add(fe);
  return {
    wnd: t,
    points: n
  };
};
BasePoint.prototype._getBeta = function c() {
  return null;
};
BasePoint.prototype.dblp = function c(t) {
  for (var n = this, ie = 0; ie < t; ie++)
    n = n.dbl();
  return n;
};
var utils$7 = utils$9, BN$5 = bnExports, inherits$2 = inherits_browserExports, Base$2 = base, assert$6 = utils$7.assert;
function ShortCurve(c) {
  Base$2.call(this, "short", c), this.a = new BN$5(c.a, 16).toRed(this.red), this.b = new BN$5(c.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(c), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$2(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function c(t) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var n, ie;
    if (t.beta)
      n = new BN$5(t.beta, 16).toRed(this.red);
    else {
      var fe = this._getEndoRoots(this.p);
      n = fe[0].cmp(fe[1]) < 0 ? fe[0] : fe[1], n = n.toRed(this.red);
    }
    if (t.lambda)
      ie = new BN$5(t.lambda, 16);
    else {
      var ae = this._getEndoRoots(this.n);
      this.g.mul(ae[0]).x.cmp(this.g.x.redMul(n)) === 0 ? ie = ae[0] : (ie = ae[1], assert$6(this.g.mul(ie).x.cmp(this.g.x.redMul(n)) === 0));
    }
    var le;
    return t.basis ? le = t.basis.map(function(he) {
      return {
        a: new BN$5(he.a, 16),
        b: new BN$5(he.b, 16)
      };
    }) : le = this._getEndoBasis(ie), {
      beta: n,
      lambda: ie,
      basis: le
    };
  }
};
ShortCurve.prototype._getEndoRoots = function c(t) {
  var n = t === this.p ? this.red : BN$5.mont(t), ie = new BN$5(2).toRed(n).redInvm(), fe = ie.redNeg(), ae = new BN$5(3).toRed(n).redNeg().redSqrt().redMul(ie), le = fe.redAdd(ae).fromRed(), he = fe.redSub(ae).fromRed();
  return [le, he];
};
ShortCurve.prototype._getEndoBasis = function c(t) {
  for (var n = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), ie = t, fe = this.n.clone(), ae = new BN$5(1), le = new BN$5(0), he = new BN$5(0), me = new BN$5(1), ye, be, Ae, Se, $e, Re, Me, ke = 0, Te, Ie; ie.cmpn(0) !== 0; ) {
    var qe = fe.div(ie);
    Te = fe.sub(qe.mul(ie)), Ie = he.sub(qe.mul(ae));
    var Ue = me.sub(qe.mul(le));
    if (!Ae && Te.cmp(n) < 0)
      ye = Me.neg(), be = ae, Ae = Te.neg(), Se = Ie;
    else if (Ae && ++ke === 2)
      break;
    Me = Te, fe = ie, ie = Te, he = ae, ae = Ie, me = le, le = Ue;
  }
  $e = Te.neg(), Re = Ie;
  var ze = Ae.sqr().add(Se.sqr()), Ve = $e.sqr().add(Re.sqr());
  return Ve.cmp(ze) >= 0 && ($e = ye, Re = be), Ae.negative && (Ae = Ae.neg(), Se = Se.neg()), $e.negative && ($e = $e.neg(), Re = Re.neg()), [
    { a: Ae, b: Se },
    { a: $e, b: Re }
  ];
};
ShortCurve.prototype._endoSplit = function c(t) {
  var n = this.endo.basis, ie = n[0], fe = n[1], ae = fe.b.mul(t).divRound(this.n), le = ie.b.neg().mul(t).divRound(this.n), he = ae.mul(ie.a), me = le.mul(fe.a), ye = ae.mul(ie.b), be = le.mul(fe.b), Ae = t.sub(he).sub(me), Se = ye.add(be).neg();
  return { k1: Ae, k2: Se };
};
ShortCurve.prototype.pointFromX = function c(t, n) {
  t = new BN$5(t, 16), t.red || (t = t.toRed(this.red));
  var ie = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), fe = ie.redSqrt();
  if (fe.redSqr().redSub(ie).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var ae = fe.fromRed().isOdd();
  return (n && !ae || !n && ae) && (fe = fe.redNeg()), this.point(t, fe);
};
ShortCurve.prototype.validate = function c(t) {
  if (t.inf)
    return !0;
  var n = t.x, ie = t.y, fe = this.a.redMul(n), ae = n.redSqr().redMul(n).redIAdd(fe).redIAdd(this.b);
  return ie.redSqr().redISub(ae).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function c(t, n, ie) {
  for (var fe = this._endoWnafT1, ae = this._endoWnafT2, le = 0; le < t.length; le++) {
    var he = this._endoSplit(n[le]), me = t[le], ye = me._getBeta();
    he.k1.negative && (he.k1.ineg(), me = me.neg(!0)), he.k2.negative && (he.k2.ineg(), ye = ye.neg(!0)), fe[le * 2] = me, fe[le * 2 + 1] = ye, ae[le * 2] = he.k1, ae[le * 2 + 1] = he.k2;
  }
  for (var be = this._wnafMulAdd(1, fe, ae, le * 2, ie), Ae = 0; Ae < le * 2; Ae++)
    fe[Ae] = null, ae[Ae] = null;
  return be;
};
function Point$2(c, t, n, ie) {
  Base$2.BasePoint.call(this, c, "affine"), t === null && n === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$5(t, 16), this.y = new BN$5(n, 16), ie && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$2(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function c(t, n, ie) {
  return new Point$2(this, t, n, ie);
};
ShortCurve.prototype.pointFromJSON = function c(t, n) {
  return Point$2.fromJSON(this, t, n);
};
Point$2.prototype._getBeta = function c() {
  if (this.curve.endo) {
    var t = this.precomputed;
    if (t && t.beta)
      return t.beta;
    var n = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (t) {
      var ie = this.curve, fe = function(ae) {
        return ie.point(ae.x.redMul(ie.endo.beta), ae.y);
      };
      t.beta = n, n.precomputed = {
        beta: null,
        naf: t.naf && {
          wnd: t.naf.wnd,
          points: t.naf.points.map(fe)
        },
        doubles: t.doubles && {
          step: t.doubles.step,
          points: t.doubles.points.map(fe)
        }
      };
    }
    return n;
  }
};
Point$2.prototype.toJSON = function c() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function c(t, n, ie) {
  typeof n == "string" && (n = JSON.parse(n));
  var fe = t.point(n[0], n[1], ie);
  if (!n[2])
    return fe;
  function ae(he) {
    return t.point(he[0], he[1], ie);
  }
  var le = n[2];
  return fe.precomputed = {
    beta: null,
    doubles: le.doubles && {
      step: le.doubles.step,
      points: [fe].concat(le.doubles.points.map(ae))
    },
    naf: le.naf && {
      wnd: le.naf.wnd,
      points: [fe].concat(le.naf.points.map(ae))
    }
  }, fe;
};
Point$2.prototype.inspect = function c() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function c() {
  return this.inf;
};
Point$2.prototype.add = function c(t) {
  if (this.inf)
    return t;
  if (t.inf)
    return this;
  if (this.eq(t))
    return this.dbl();
  if (this.neg().eq(t))
    return this.curve.point(null, null);
  if (this.x.cmp(t.x) === 0)
    return this.curve.point(null, null);
  var n = this.y.redSub(t.y);
  n.cmpn(0) !== 0 && (n = n.redMul(this.x.redSub(t.x).redInvm()));
  var ie = n.redSqr().redISub(this.x).redISub(t.x), fe = n.redMul(this.x.redSub(ie)).redISub(this.y);
  return this.curve.point(ie, fe);
};
Point$2.prototype.dbl = function c() {
  if (this.inf)
    return this;
  var t = this.y.redAdd(this.y);
  if (t.cmpn(0) === 0)
    return this.curve.point(null, null);
  var n = this.curve.a, ie = this.x.redSqr(), fe = t.redInvm(), ae = ie.redAdd(ie).redIAdd(ie).redIAdd(n).redMul(fe), le = ae.redSqr().redISub(this.x.redAdd(this.x)), he = ae.redMul(this.x.redSub(le)).redISub(this.y);
  return this.curve.point(le, he);
};
Point$2.prototype.getX = function c() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function c() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function c(t) {
  return t = new BN$5(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
};
Point$2.prototype.mulAdd = function c(t, n, ie) {
  var fe = [this, n], ae = [t, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(fe, ae) : this.curve._wnafMulAdd(1, fe, ae, 2);
};
Point$2.prototype.jmulAdd = function c(t, n, ie) {
  var fe = [this, n], ae = [t, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(fe, ae, !0) : this.curve._wnafMulAdd(1, fe, ae, 2, !0);
};
Point$2.prototype.eq = function c(t) {
  return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
};
Point$2.prototype.neg = function c(t) {
  if (this.inf)
    return this;
  var n = this.curve.point(this.x, this.y.redNeg());
  if (t && this.precomputed) {
    var ie = this.precomputed, fe = function(ae) {
      return ae.neg();
    };
    n.precomputed = {
      naf: ie.naf && {
        wnd: ie.naf.wnd,
        points: ie.naf.points.map(fe)
      },
      doubles: ie.doubles && {
        step: ie.doubles.step,
        points: ie.doubles.points.map(fe)
      }
    };
  }
  return n;
};
Point$2.prototype.toJ = function c() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var t = this.curve.jpoint(this.x, this.y, this.curve.one);
  return t;
};
function JPoint(c, t, n, ie) {
  Base$2.BasePoint.call(this, c, "jacobian"), t === null && n === null && ie === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$5(0)) : (this.x = new BN$5(t, 16), this.y = new BN$5(n, 16), this.z = new BN$5(ie, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$2(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function c(t, n, ie) {
  return new JPoint(this, t, n, ie);
};
JPoint.prototype.toP = function c() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var t = this.z.redInvm(), n = t.redSqr(), ie = this.x.redMul(n), fe = this.y.redMul(n).redMul(t);
  return this.curve.point(ie, fe);
};
JPoint.prototype.neg = function c() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function c(t) {
  if (this.isInfinity())
    return t;
  if (t.isInfinity())
    return this;
  var n = t.z.redSqr(), ie = this.z.redSqr(), fe = this.x.redMul(n), ae = t.x.redMul(ie), le = this.y.redMul(n.redMul(t.z)), he = t.y.redMul(ie.redMul(this.z)), me = fe.redSub(ae), ye = le.redSub(he);
  if (me.cmpn(0) === 0)
    return ye.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var be = me.redSqr(), Ae = be.redMul(me), Se = fe.redMul(be), $e = ye.redSqr().redIAdd(Ae).redISub(Se).redISub(Se), Re = ye.redMul(Se.redISub($e)).redISub(le.redMul(Ae)), Me = this.z.redMul(t.z).redMul(me);
  return this.curve.jpoint($e, Re, Me);
};
JPoint.prototype.mixedAdd = function c(t) {
  if (this.isInfinity())
    return t.toJ();
  if (t.isInfinity())
    return this;
  var n = this.z.redSqr(), ie = this.x, fe = t.x.redMul(n), ae = this.y, le = t.y.redMul(n).redMul(this.z), he = ie.redSub(fe), me = ae.redSub(le);
  if (he.cmpn(0) === 0)
    return me.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var ye = he.redSqr(), be = ye.redMul(he), Ae = ie.redMul(ye), Se = me.redSqr().redIAdd(be).redISub(Ae).redISub(Ae), $e = me.redMul(Ae.redISub(Se)).redISub(ae.redMul(be)), Re = this.z.redMul(he);
  return this.curve.jpoint(Se, $e, Re);
};
JPoint.prototype.dblp = function c(t) {
  if (t === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!t)
    return this.dbl();
  var n;
  if (this.curve.zeroA || this.curve.threeA) {
    var ie = this;
    for (n = 0; n < t; n++)
      ie = ie.dbl();
    return ie;
  }
  var fe = this.curve.a, ae = this.curve.tinv, le = this.x, he = this.y, me = this.z, ye = me.redSqr().redSqr(), be = he.redAdd(he);
  for (n = 0; n < t; n++) {
    var Ae = le.redSqr(), Se = be.redSqr(), $e = Se.redSqr(), Re = Ae.redAdd(Ae).redIAdd(Ae).redIAdd(fe.redMul(ye)), Me = le.redMul(Se), ke = Re.redSqr().redISub(Me.redAdd(Me)), Te = Me.redISub(ke), Ie = Re.redMul(Te);
    Ie = Ie.redIAdd(Ie).redISub($e);
    var qe = be.redMul(me);
    n + 1 < t && (ye = ye.redMul($e)), le = ke, me = qe, be = Ie;
  }
  return this.curve.jpoint(le, be.redMul(ae), me);
};
JPoint.prototype.dbl = function c() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function c() {
  var t, n, ie;
  if (this.zOne) {
    var fe = this.x.redSqr(), ae = this.y.redSqr(), le = ae.redSqr(), he = this.x.redAdd(ae).redSqr().redISub(fe).redISub(le);
    he = he.redIAdd(he);
    var me = fe.redAdd(fe).redIAdd(fe), ye = me.redSqr().redISub(he).redISub(he), be = le.redIAdd(le);
    be = be.redIAdd(be), be = be.redIAdd(be), t = ye, n = me.redMul(he.redISub(ye)).redISub(be), ie = this.y.redAdd(this.y);
  } else {
    var Ae = this.x.redSqr(), Se = this.y.redSqr(), $e = Se.redSqr(), Re = this.x.redAdd(Se).redSqr().redISub(Ae).redISub($e);
    Re = Re.redIAdd(Re);
    var Me = Ae.redAdd(Ae).redIAdd(Ae), ke = Me.redSqr(), Te = $e.redIAdd($e);
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), t = ke.redISub(Re).redISub(Re), n = Me.redMul(Re.redISub(t)).redISub(Te), ie = this.y.redMul(this.z), ie = ie.redIAdd(ie);
  }
  return this.curve.jpoint(t, n, ie);
};
JPoint.prototype._threeDbl = function c() {
  var t, n, ie;
  if (this.zOne) {
    var fe = this.x.redSqr(), ae = this.y.redSqr(), le = ae.redSqr(), he = this.x.redAdd(ae).redSqr().redISub(fe).redISub(le);
    he = he.redIAdd(he);
    var me = fe.redAdd(fe).redIAdd(fe).redIAdd(this.curve.a), ye = me.redSqr().redISub(he).redISub(he);
    t = ye;
    var be = le.redIAdd(le);
    be = be.redIAdd(be), be = be.redIAdd(be), n = me.redMul(he.redISub(ye)).redISub(be), ie = this.y.redAdd(this.y);
  } else {
    var Ae = this.z.redSqr(), Se = this.y.redSqr(), $e = this.x.redMul(Se), Re = this.x.redSub(Ae).redMul(this.x.redAdd(Ae));
    Re = Re.redAdd(Re).redIAdd(Re);
    var Me = $e.redIAdd($e);
    Me = Me.redIAdd(Me);
    var ke = Me.redAdd(Me);
    t = Re.redSqr().redISub(ke), ie = this.y.redAdd(this.z).redSqr().redISub(Se).redISub(Ae);
    var Te = Se.redSqr();
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), n = Re.redMul(Me.redISub(t)).redISub(Te);
  }
  return this.curve.jpoint(t, n, ie);
};
JPoint.prototype._dbl = function c() {
  var t = this.curve.a, n = this.x, ie = this.y, fe = this.z, ae = fe.redSqr().redSqr(), le = n.redSqr(), he = ie.redSqr(), me = le.redAdd(le).redIAdd(le).redIAdd(t.redMul(ae)), ye = n.redAdd(n);
  ye = ye.redIAdd(ye);
  var be = ye.redMul(he), Ae = me.redSqr().redISub(be.redAdd(be)), Se = be.redISub(Ae), $e = he.redSqr();
  $e = $e.redIAdd($e), $e = $e.redIAdd($e), $e = $e.redIAdd($e);
  var Re = me.redMul(Se).redISub($e), Me = ie.redAdd(ie).redMul(fe);
  return this.curve.jpoint(Ae, Re, Me);
};
JPoint.prototype.trpl = function c() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var t = this.x.redSqr(), n = this.y.redSqr(), ie = this.z.redSqr(), fe = n.redSqr(), ae = t.redAdd(t).redIAdd(t), le = ae.redSqr(), he = this.x.redAdd(n).redSqr().redISub(t).redISub(fe);
  he = he.redIAdd(he), he = he.redAdd(he).redIAdd(he), he = he.redISub(le);
  var me = he.redSqr(), ye = fe.redIAdd(fe);
  ye = ye.redIAdd(ye), ye = ye.redIAdd(ye), ye = ye.redIAdd(ye);
  var be = ae.redIAdd(he).redSqr().redISub(le).redISub(me).redISub(ye), Ae = n.redMul(be);
  Ae = Ae.redIAdd(Ae), Ae = Ae.redIAdd(Ae);
  var Se = this.x.redMul(me).redISub(Ae);
  Se = Se.redIAdd(Se), Se = Se.redIAdd(Se);
  var $e = this.y.redMul(be.redMul(ye.redISub(be)).redISub(he.redMul(me)));
  $e = $e.redIAdd($e), $e = $e.redIAdd($e), $e = $e.redIAdd($e);
  var Re = this.z.redAdd(he).redSqr().redISub(ie).redISub(me);
  return this.curve.jpoint(Se, $e, Re);
};
JPoint.prototype.mul = function c(t, n) {
  return t = new BN$5(t, n), this.curve._wnafMul(this, t);
};
JPoint.prototype.eq = function c(t) {
  if (t.type === "affine")
    return this.eq(t.toJ());
  if (this === t)
    return !0;
  var n = this.z.redSqr(), ie = t.z.redSqr();
  if (this.x.redMul(ie).redISub(t.x.redMul(n)).cmpn(0) !== 0)
    return !1;
  var fe = n.redMul(this.z), ae = ie.redMul(t.z);
  return this.y.redMul(ae).redISub(t.y.redMul(fe)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function c(t) {
  var n = this.z.redSqr(), ie = t.toRed(this.curve.red).redMul(n);
  if (this.x.cmp(ie) === 0)
    return !0;
  for (var fe = t.clone(), ae = this.curve.redN.redMul(n); ; ) {
    if (fe.iadd(this.curve.n), fe.cmp(this.curve.p) >= 0)
      return !1;
    if (ie.redIAdd(ae), this.x.cmp(ie) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function c() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function c() {
  return this.z.cmpn(0) === 0;
};
var BN$4 = bnExports, inherits$1 = inherits_browserExports, Base$1 = base, utils$6 = utils$9;
function MontCurve(c) {
  Base$1.call(this, "mont", c), this.a = new BN$4(c.a, 16).toRed(this.red), this.b = new BN$4(c.b, 16).toRed(this.red), this.i4 = new BN$4(4).toRed(this.red).redInvm(), this.two = new BN$4(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$1(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function c(t) {
  var n = t.normalize().x, ie = n.redSqr(), fe = ie.redMul(n).redAdd(ie.redMul(this.a)).redAdd(n), ae = fe.redSqrt();
  return ae.redSqr().cmp(fe) === 0;
};
function Point$1(c, t, n) {
  Base$1.BasePoint.call(this, c, "projective"), t === null && n === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$4(t, 16), this.z = new BN$4(n, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$1(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function c(t, n) {
  return this.point(utils$6.toArray(t, n), 1);
};
MontCurve.prototype.point = function c(t, n) {
  return new Point$1(this, t, n);
};
MontCurve.prototype.pointFromJSON = function c(t) {
  return Point$1.fromJSON(this, t);
};
Point$1.prototype.precompute = function c() {
};
Point$1.prototype._encode = function c() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function c(t, n) {
  return new Point$1(t, n[0], n[1] || t.one);
};
Point$1.prototype.inspect = function c() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function c() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function c() {
  var t = this.x.redAdd(this.z), n = t.redSqr(), ie = this.x.redSub(this.z), fe = ie.redSqr(), ae = n.redSub(fe), le = n.redMul(fe), he = ae.redMul(fe.redAdd(this.curve.a24.redMul(ae)));
  return this.curve.point(le, he);
};
Point$1.prototype.add = function c() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function c(t, n) {
  var ie = this.x.redAdd(this.z), fe = this.x.redSub(this.z), ae = t.x.redAdd(t.z), le = t.x.redSub(t.z), he = le.redMul(ie), me = ae.redMul(fe), ye = n.z.redMul(he.redAdd(me).redSqr()), be = n.x.redMul(he.redISub(me).redSqr());
  return this.curve.point(ye, be);
};
Point$1.prototype.mul = function c(t) {
  for (var n = t.clone(), ie = this, fe = this.curve.point(null, null), ae = this, le = []; n.cmpn(0) !== 0; n.iushrn(1))
    le.push(n.andln(1));
  for (var he = le.length - 1; he >= 0; he--)
    le[he] === 0 ? (ie = ie.diffAdd(fe, ae), fe = fe.dbl()) : (fe = ie.diffAdd(fe, ae), ie = ie.dbl());
  return fe;
};
Point$1.prototype.mulAdd = function c() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function c() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function c(t) {
  return this.getX().cmp(t.getX()) === 0;
};
Point$1.prototype.normalize = function c() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function c() {
  return this.normalize(), this.x.fromRed();
};
var utils$5 = utils$9, BN$3 = bnExports, inherits = inherits_browserExports, Base = base, assert$5 = utils$5.assert;
function EdwardsCurve(c) {
  this.twisted = (c.a | 0) !== 1, this.mOneA = this.twisted && (c.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", c), this.a = new BN$3(c.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$3(c.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$3(c.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$5(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (c.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function c(t) {
  return this.mOneA ? t.redNeg() : this.a.redMul(t);
};
EdwardsCurve.prototype._mulC = function c(t) {
  return this.oneC ? t : this.c.redMul(t);
};
EdwardsCurve.prototype.jpoint = function c(t, n, ie, fe) {
  return this.point(t, n, ie, fe);
};
EdwardsCurve.prototype.pointFromX = function c(t, n) {
  t = new BN$3(t, 16), t.red || (t = t.toRed(this.red));
  var ie = t.redSqr(), fe = this.c2.redSub(this.a.redMul(ie)), ae = this.one.redSub(this.c2.redMul(this.d).redMul(ie)), le = fe.redMul(ae.redInvm()), he = le.redSqrt();
  if (he.redSqr().redSub(le).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var me = he.fromRed().isOdd();
  return (n && !me || !n && me) && (he = he.redNeg()), this.point(t, he);
};
EdwardsCurve.prototype.pointFromY = function c(t, n) {
  t = new BN$3(t, 16), t.red || (t = t.toRed(this.red));
  var ie = t.redSqr(), fe = ie.redSub(this.c2), ae = ie.redMul(this.d).redMul(this.c2).redSub(this.a), le = fe.redMul(ae.redInvm());
  if (le.cmp(this.zero) === 0) {
    if (n)
      throw new Error("invalid point");
    return this.point(this.zero, t);
  }
  var he = le.redSqrt();
  if (he.redSqr().redSub(le).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return he.fromRed().isOdd() !== n && (he = he.redNeg()), this.point(he, t);
};
EdwardsCurve.prototype.validate = function c(t) {
  if (t.isInfinity())
    return !0;
  t.normalize();
  var n = t.x.redSqr(), ie = t.y.redSqr(), fe = n.redMul(this.a).redAdd(ie), ae = this.c2.redMul(this.one.redAdd(this.d.redMul(n).redMul(ie)));
  return fe.cmp(ae) === 0;
};
function Point(c, t, n, ie, fe) {
  Base.BasePoint.call(this, c, "projective"), t === null && n === null && ie === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$3(t, 16), this.y = new BN$3(n, 16), this.z = ie ? new BN$3(ie, 16) : this.curve.one, this.t = fe && new BN$3(fe, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function c(t) {
  return Point.fromJSON(this, t);
};
EdwardsCurve.prototype.point = function c(t, n, ie, fe) {
  return new Point(this, t, n, ie, fe);
};
Point.fromJSON = function c(t, n) {
  return new Point(t, n[0], n[1], n[2]);
};
Point.prototype.inspect = function c() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function c() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function c() {
  var t = this.x.redSqr(), n = this.y.redSqr(), ie = this.z.redSqr();
  ie = ie.redIAdd(ie);
  var fe = this.curve._mulA(t), ae = this.x.redAdd(this.y).redSqr().redISub(t).redISub(n), le = fe.redAdd(n), he = le.redSub(ie), me = fe.redSub(n), ye = ae.redMul(he), be = le.redMul(me), Ae = ae.redMul(me), Se = he.redMul(le);
  return this.curve.point(ye, be, Se, Ae);
};
Point.prototype._projDbl = function c() {
  var t = this.x.redAdd(this.y).redSqr(), n = this.x.redSqr(), ie = this.y.redSqr(), fe, ae, le, he, me, ye;
  if (this.curve.twisted) {
    he = this.curve._mulA(n);
    var be = he.redAdd(ie);
    this.zOne ? (fe = t.redSub(n).redSub(ie).redMul(be.redSub(this.curve.two)), ae = be.redMul(he.redSub(ie)), le = be.redSqr().redSub(be).redSub(be)) : (me = this.z.redSqr(), ye = be.redSub(me).redISub(me), fe = t.redSub(n).redISub(ie).redMul(ye), ae = be.redMul(he.redSub(ie)), le = be.redMul(ye));
  } else
    he = n.redAdd(ie), me = this.curve._mulC(this.z).redSqr(), ye = he.redSub(me).redSub(me), fe = this.curve._mulC(t.redISub(he)).redMul(ye), ae = this.curve._mulC(he).redMul(n.redISub(ie)), le = he.redMul(ye);
  return this.curve.point(fe, ae, le);
};
Point.prototype.dbl = function c() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function c(t) {
  var n = this.y.redSub(this.x).redMul(t.y.redSub(t.x)), ie = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)), fe = this.t.redMul(this.curve.dd).redMul(t.t), ae = this.z.redMul(t.z.redAdd(t.z)), le = ie.redSub(n), he = ae.redSub(fe), me = ae.redAdd(fe), ye = ie.redAdd(n), be = le.redMul(he), Ae = me.redMul(ye), Se = le.redMul(ye), $e = he.redMul(me);
  return this.curve.point(be, Ae, $e, Se);
};
Point.prototype._projAdd = function c(t) {
  var n = this.z.redMul(t.z), ie = n.redSqr(), fe = this.x.redMul(t.x), ae = this.y.redMul(t.y), le = this.curve.d.redMul(fe).redMul(ae), he = ie.redSub(le), me = ie.redAdd(le), ye = this.x.redAdd(this.y).redMul(t.x.redAdd(t.y)).redISub(fe).redISub(ae), be = n.redMul(he).redMul(ye), Ae, Se;
  return this.curve.twisted ? (Ae = n.redMul(me).redMul(ae.redSub(this.curve._mulA(fe))), Se = he.redMul(me)) : (Ae = n.redMul(me).redMul(ae.redSub(fe)), Se = this.curve._mulC(he).redMul(me)), this.curve.point(be, Ae, Se);
};
Point.prototype.add = function c(t) {
  return this.isInfinity() ? t : t.isInfinity() ? this : this.curve.extended ? this._extAdd(t) : this._projAdd(t);
};
Point.prototype.mul = function c(t) {
  return this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve._wnafMul(this, t);
};
Point.prototype.mulAdd = function c(t, n, ie) {
  return this.curve._wnafMulAdd(1, [this, n], [t, ie], 2, !1);
};
Point.prototype.jmulAdd = function c(t, n, ie) {
  return this.curve._wnafMulAdd(1, [this, n], [t, ie], 2, !0);
};
Point.prototype.normalize = function c() {
  if (this.zOne)
    return this;
  var t = this.z.redInvm();
  return this.x = this.x.redMul(t), this.y = this.y.redMul(t), this.t && (this.t = this.t.redMul(t)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function c() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function c() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function c() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function c(t) {
  return this === t || this.getX().cmp(t.getX()) === 0 && this.getY().cmp(t.getY()) === 0;
};
Point.prototype.eqXToP = function c(t) {
  var n = t.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(n) === 0)
    return !0;
  for (var ie = t.clone(), fe = this.curve.redN.redMul(this.z); ; ) {
    if (ie.iadd(this.curve.n), ie.cmp(this.curve.p) >= 0)
      return !1;
    if (n.redIAdd(fe), this.x.cmp(n) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(c) {
  var t = c;
  t.base = base, t.short = short, t.mont = mont, t.edwards = edwards;
})(curve);
var curves$1 = {}, secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
(function(c) {
  var t = c, n = hash$5, ie = curve, fe = utils$9, ae = fe.assert;
  function le(ye) {
    ye.type === "short" ? this.curve = new ie.short(ye) : ye.type === "edwards" ? this.curve = new ie.edwards(ye) : this.curve = new ie.mont(ye), this.g = this.curve.g, this.n = this.curve.n, this.hash = ye.hash, ae(this.g.validate(), "Invalid curve"), ae(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  t.PresetCurve = le;
  function he(ye, be) {
    Object.defineProperty(t, ye, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var Ae = new le(be);
        return Object.defineProperty(t, ye, {
          configurable: !0,
          enumerable: !0,
          value: Ae
        }), Ae;
      }
    });
  }
  he("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: n.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), he("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: n.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), he("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: n.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), he("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: n.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), he("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: n.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), he("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: n.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), he("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: n.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var me;
  try {
    me = requireSecp256k1();
  } catch {
    me = void 0;
  }
  he("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: n.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      me
    ]
  });
})(curves$1);
var BN$2 = bnExports, utils$4 = utils$9, assert$4 = utils$4.assert;
function KeyPair$2(c, t) {
  this.ec = c, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var key$1 = KeyPair$2;
KeyPair$2.fromPublic = function c(t, n, ie) {
  return n instanceof KeyPair$2 ? n : new KeyPair$2(t, {
    pub: n,
    pubEnc: ie
  });
};
KeyPair$2.fromPrivate = function c(t, n, ie) {
  return n instanceof KeyPair$2 ? n : new KeyPair$2(t, {
    priv: n,
    privEnc: ie
  });
};
KeyPair$2.prototype.validate = function c() {
  var t = this.getPublic();
  return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$2.prototype.getPublic = function c(t, n) {
  return typeof t == "string" && (n = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), n ? this.pub.encode(n, t) : this.pub;
};
KeyPair$2.prototype.getPrivate = function c(t) {
  return t === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$2.prototype._importPrivate = function c(t, n) {
  this.priv = new BN$2(t, n || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$2.prototype._importPublic = function c(t, n) {
  if (t.x || t.y) {
    this.ec.curve.type === "mont" ? assert$4(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$4(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(t, n);
};
KeyPair$2.prototype.derive = function c(t) {
  return t.validate() || assert$4(t.validate(), "public point not validated"), t.mul(this.priv).getX();
};
KeyPair$2.prototype.sign = function c(t, n, ie) {
  return this.ec.sign(t, this, n, ie);
};
KeyPair$2.prototype.verify = function c(t, n) {
  return this.ec.verify(t, n, this);
};
KeyPair$2.prototype.inspect = function c() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$1 = bnExports, utils$3 = utils$9, assert$3 = utils$3.assert;
function Signature$2(c, t) {
  if (c instanceof Signature$2)
    return c;
  this._importDER(c, t) || (assert$3(c.r && c.s, "Signature without r or s"), this.r = new BN$1(c.r, 16), this.s = new BN$1(c.s, 16), c.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = c.recoveryParam);
}
var signature$1 = Signature$2;
function Position() {
  this.place = 0;
}
function getLength(c, t) {
  var n = c[t.place++];
  if (!(n & 128))
    return n;
  var ie = n & 15;
  if (ie === 0 || ie > 4)
    return !1;
  for (var fe = 0, ae = 0, le = t.place; ae < ie; ae++, le++)
    fe <<= 8, fe |= c[le], fe >>>= 0;
  return fe <= 127 ? !1 : (t.place = le, fe);
}
function rmPadding(c) {
  for (var t = 0, n = c.length - 1; !c[t] && !(c[t + 1] & 128) && t < n; )
    t++;
  return t === 0 ? c : c.slice(t);
}
Signature$2.prototype._importDER = function c(t, n) {
  t = utils$3.toArray(t, n);
  var ie = new Position();
  if (t[ie.place++] !== 48)
    return !1;
  var fe = getLength(t, ie);
  if (fe === !1 || fe + ie.place !== t.length || t[ie.place++] !== 2)
    return !1;
  var ae = getLength(t, ie);
  if (ae === !1)
    return !1;
  var le = t.slice(ie.place, ae + ie.place);
  if (ie.place += ae, t[ie.place++] !== 2)
    return !1;
  var he = getLength(t, ie);
  if (he === !1 || t.length !== he + ie.place)
    return !1;
  var me = t.slice(ie.place, he + ie.place);
  if (le[0] === 0)
    if (le[1] & 128)
      le = le.slice(1);
    else
      return !1;
  if (me[0] === 0)
    if (me[1] & 128)
      me = me.slice(1);
    else
      return !1;
  return this.r = new BN$1(le), this.s = new BN$1(me), this.recoveryParam = null, !0;
};
function constructLength(c, t) {
  if (t < 128) {
    c.push(t);
    return;
  }
  var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
  for (c.push(n | 128); --n; )
    c.push(t >>> (n << 3) & 255);
  c.push(t);
}
Signature$2.prototype.toDER = function c(t) {
  var n = this.r.toArray(), ie = this.s.toArray();
  for (n[0] & 128 && (n = [0].concat(n)), ie[0] & 128 && (ie = [0].concat(ie)), n = rmPadding(n), ie = rmPadding(ie); !ie[0] && !(ie[1] & 128); )
    ie = ie.slice(1);
  var fe = [2];
  constructLength(fe, n.length), fe = fe.concat(n), fe.push(2), constructLength(fe, ie.length);
  var ae = fe.concat(ie), le = [48];
  return constructLength(le, ae.length), le = le.concat(ae), utils$3.encode(le, t);
};
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec;
  hasRequiredEc = 1;
  var c = bnExports, t = hmacDrbg, n = utils$9, ie = curves$1, fe = requireBrorand(), ae = n.assert, le = key$1, he = signature$1;
  function me(ye) {
    if (!(this instanceof me))
      return new me(ye);
    typeof ye == "string" && (ae(
      Object.prototype.hasOwnProperty.call(ie, ye),
      "Unknown curve " + ye
    ), ye = ie[ye]), ye instanceof ie.PresetCurve && (ye = { curve: ye }), this.curve = ye.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = ye.curve.g, this.g.precompute(ye.curve.n.bitLength() + 1), this.hash = ye.hash || ye.curve.hash;
  }
  return ec = me, me.prototype.keyPair = function(be) {
    return new le(this, be);
  }, me.prototype.keyFromPrivate = function(be, Ae) {
    return le.fromPrivate(this, be, Ae);
  }, me.prototype.keyFromPublic = function(be, Ae) {
    return le.fromPublic(this, be, Ae);
  }, me.prototype.genKeyPair = function(be) {
    be || (be = {});
    for (var Ae = new t({
      hash: this.hash,
      pers: be.pers,
      persEnc: be.persEnc || "utf8",
      entropy: be.entropy || fe(this.hash.hmacStrength),
      entropyEnc: be.entropy && be.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Se = this.n.byteLength(), $e = this.n.sub(new c(2)); ; ) {
      var Re = new c(Ae.generate(Se));
      if (!(Re.cmp($e) > 0))
        return Re.iaddn(1), this.keyFromPrivate(Re);
    }
  }, me.prototype._truncateToN = function(be, Ae) {
    var Se = be.byteLength() * 8 - this.n.bitLength();
    return Se > 0 && (be = be.ushrn(Se)), !Ae && be.cmp(this.n) >= 0 ? be.sub(this.n) : be;
  }, me.prototype.sign = function(be, Ae, Se, $e) {
    typeof Se == "object" && ($e = Se, Se = null), $e || ($e = {}), Ae = this.keyFromPrivate(Ae, Se), be = this._truncateToN(new c(be, 16));
    for (var Re = this.n.byteLength(), Me = Ae.getPrivate().toArray("be", Re), ke = be.toArray("be", Re), Te = new t({
      hash: this.hash,
      entropy: Me,
      nonce: ke,
      pers: $e.pers,
      persEnc: $e.persEnc || "utf8"
    }), Ie = this.n.sub(new c(1)), qe = 0; ; qe++) {
      var Ue = $e.k ? $e.k(qe) : new c(Te.generate(this.n.byteLength()));
      if (Ue = this._truncateToN(Ue, !0), !(Ue.cmpn(1) <= 0 || Ue.cmp(Ie) >= 0)) {
        var ze = this.g.mul(Ue);
        if (!ze.isInfinity()) {
          var Ve = ze.getX(), Mt = Ve.umod(this.n);
          if (Mt.cmpn(0) !== 0) {
            var Rt = Ue.invm(this.n).mul(Mt.mul(Ae.getPrivate()).iadd(be));
            if (Rt = Rt.umod(this.n), Rt.cmpn(0) !== 0) {
              var je = (ze.getY().isOdd() ? 1 : 0) | (Ve.cmp(Mt) !== 0 ? 2 : 0);
              return $e.canonical && Rt.cmp(this.nh) > 0 && (Rt = this.n.sub(Rt), je ^= 1), new he({ r: Mt, s: Rt, recoveryParam: je });
            }
          }
        }
      }
    }
  }, me.prototype.verify = function(be, Ae, Se, $e) {
    be = this._truncateToN(new c(be, 16)), Se = this.keyFromPublic(Se, $e), Ae = new he(Ae, "hex");
    var Re = Ae.r, Me = Ae.s;
    if (Re.cmpn(1) < 0 || Re.cmp(this.n) >= 0 || Me.cmpn(1) < 0 || Me.cmp(this.n) >= 0)
      return !1;
    var ke = Me.invm(this.n), Te = ke.mul(be).umod(this.n), Ie = ke.mul(Re).umod(this.n), qe;
    return this.curve._maxwellTrick ? (qe = this.g.jmulAdd(Te, Se.getPublic(), Ie), qe.isInfinity() ? !1 : qe.eqXToP(Re)) : (qe = this.g.mulAdd(Te, Se.getPublic(), Ie), qe.isInfinity() ? !1 : qe.getX().umod(this.n).cmp(Re) === 0);
  }, me.prototype.recoverPubKey = function(ye, be, Ae, Se) {
    ae((3 & Ae) === Ae, "The recovery param is more than two bits"), be = new he(be, Se);
    var $e = this.n, Re = new c(ye), Me = be.r, ke = be.s, Te = Ae & 1, Ie = Ae >> 1;
    if (Me.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Ie)
      throw new Error("Unable to find sencond key candinate");
    Ie ? Me = this.curve.pointFromX(Me.add(this.curve.n), Te) : Me = this.curve.pointFromX(Me, Te);
    var qe = be.r.invm($e), Ue = $e.sub(Re).mul(qe).umod($e), ze = ke.mul(qe).umod($e);
    return this.g.mulAdd(Ue, Me, ze);
  }, me.prototype.getKeyRecoveryParam = function(ye, be, Ae, Se) {
    if (be = new he(be, Se), be.recoveryParam !== null)
      return be.recoveryParam;
    for (var $e = 0; $e < 4; $e++) {
      var Re;
      try {
        Re = this.recoverPubKey(ye, be, $e);
      } catch {
        continue;
      }
      if (Re.eq(Ae))
        return $e;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var utils$2 = utils$9, assert$2 = utils$2.assert, parseBytes$2 = utils$2.parseBytes, cachedProperty$1 = utils$2.cachedProperty;
function KeyPair$1(c, t) {
  this.eddsa = c, this._secret = parseBytes$2(t.secret), c.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = parseBytes$2(t.pub);
}
KeyPair$1.fromPublic = function c(t, n) {
  return n instanceof KeyPair$1 ? n : new KeyPair$1(t, { pub: n });
};
KeyPair$1.fromSecret = function c(t, n) {
  return n instanceof KeyPair$1 ? n : new KeyPair$1(t, { secret: n });
};
KeyPair$1.prototype.secret = function c() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function c() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function c() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function c() {
  var t = this.eddsa, n = this.hash(), ie = t.encodingLength - 1, fe = n.slice(0, t.encodingLength);
  return fe[0] &= 248, fe[ie] &= 127, fe[ie] |= 64, fe;
});
cachedProperty$1(KeyPair$1, "priv", function c() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function c() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function c() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function c(t) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(t, this);
};
KeyPair$1.prototype.verify = function c(t, n) {
  return this.eddsa.verify(t, n, this);
};
KeyPair$1.prototype.getSecret = function c(t) {
  return assert$2(this._secret, "KeyPair is public only"), utils$2.encode(this.secret(), t);
};
KeyPair$1.prototype.getPublic = function c(t) {
  return utils$2.encode(this.pubBytes(), t);
};
var key = KeyPair$1, BN = bnExports, utils$1 = utils$9, assert$1 = utils$1.assert, cachedProperty = utils$1.cachedProperty, parseBytes$1 = utils$1.parseBytes;
function Signature$1(c, t) {
  this.eddsa = c, typeof t != "object" && (t = parseBytes$1(t)), Array.isArray(t) && (t = {
    R: t.slice(0, c.encodingLength),
    S: t.slice(c.encodingLength)
  }), assert$1(t.R && t.S, "Signature without R or S"), c.isPoint(t.R) && (this._R = t.R), t.S instanceof BN && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
}
cachedProperty(Signature$1, "S", function c() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function c() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function c() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function c() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function c() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function c() {
  return utils$1.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$1, hash = hash$5, curves = curves$1, utils = utils$9, assert = utils.assert, parseBytes = utils.parseBytes, KeyPair = key, Signature = signature;
function EDDSA(c) {
  if (assert(c === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(c);
  c = curves[c].curve, this.curve = c, this.g = c.g, this.g.precompute(c.n.bitLength() + 1), this.pointClass = c.point().constructor, this.encodingLength = Math.ceil(c.n.bitLength() / 8), this.hash = hash.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function c(t, n) {
  t = parseBytes(t);
  var ie = this.keyFromSecret(n), fe = this.hashInt(ie.messagePrefix(), t), ae = this.g.mul(fe), le = this.encodePoint(ae), he = this.hashInt(le, ie.pubBytes(), t).mul(ie.priv()), me = fe.add(he).umod(this.curve.n);
  return this.makeSignature({ R: ae, S: me, Rencoded: le });
};
EDDSA.prototype.verify = function c(t, n, ie) {
  t = parseBytes(t), n = this.makeSignature(n);
  var fe = this.keyFromPublic(ie), ae = this.hashInt(n.Rencoded(), fe.pubBytes(), t), le = this.g.mul(n.S()), he = n.R().add(fe.pub().mul(ae));
  return he.eq(le);
};
EDDSA.prototype.hashInt = function c() {
  for (var t = this.hash(), n = 0; n < arguments.length; n++)
    t.update(arguments[n]);
  return utils.intFromLE(t.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function c(t) {
  return KeyPair.fromPublic(this, t);
};
EDDSA.prototype.keyFromSecret = function c(t) {
  return KeyPair.fromSecret(this, t);
};
EDDSA.prototype.makeSignature = function c(t) {
  return t instanceof Signature ? t : new Signature(this, t);
};
EDDSA.prototype.encodePoint = function c(t) {
  var n = t.getY().toArray("le", this.encodingLength);
  return n[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0, n;
};
EDDSA.prototype.decodePoint = function c(t) {
  t = utils.parseBytes(t);
  var n = t.length - 1, ie = t.slice(0, n).concat(t[n] & -129), fe = (t[n] & 128) !== 0, ae = utils.intFromLE(ie);
  return this.curve.pointFromY(ae, fe);
};
EDDSA.prototype.encodeInt = function c(t) {
  return t.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function c(t) {
  return utils.intFromLE(t);
};
EDDSA.prototype.isPoint = function c(t) {
  return t instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(c) {
    var t = c;
    t.version = require$$0.version, t.utils = utils$9, t.rand = requireBrorand(), t.curve = curve, t.curves = curves$1, t.ec = requireEc(), t.eddsa = eddsa;
  }(elliptic)), elliptic;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var browser$2, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$2;
  hasRequiredBrowser$2 = 1;
  var c = requireElliptic(), t = requireBn$1();
  browser$2 = function(le) {
    return new ie(le);
  };
  var n = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  n.p224 = n.secp224r1, n.p256 = n.secp256r1 = n.prime256v1, n.p192 = n.secp192r1 = n.prime192v1, n.p384 = n.secp384r1, n.p521 = n.secp521r1;
  function ie(ae) {
    this.curveType = n[ae], this.curveType || (this.curveType = {
      name: ae
    }), this.curve = new c.ec(this.curveType.name), this.keys = void 0;
  }
  ie.prototype.generateKeys = function(ae, le) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(ae, le);
  }, ie.prototype.computeSecret = function(ae, le, he) {
    le = le || "utf8", Buffer$7.isBuffer(ae) || (ae = new Buffer$7(ae, le));
    var me = this.curve.keyFromPublic(ae).getPublic(), ye = me.mul(this.keys.getPrivate()).getX();
    return fe(ye, he, this.curveType.byteLength);
  }, ie.prototype.getPublicKey = function(ae, le) {
    var he = this.keys.getPublic(le === "compressed", !0);
    return le === "hybrid" && (he[he.length - 1] % 2 ? he[0] = 7 : he[0] = 6), fe(he, ae);
  }, ie.prototype.getPrivateKey = function(ae) {
    return fe(this.keys.getPrivate(), ae);
  }, ie.prototype.setPublicKey = function(ae, le) {
    return le = le || "utf8", Buffer$7.isBuffer(ae) || (ae = new Buffer$7(ae, le)), this.keys._importPublic(ae), this;
  }, ie.prototype.setPrivateKey = function(ae, le) {
    le = le || "utf8", Buffer$7.isBuffer(ae) || (ae = new Buffer$7(ae, le));
    var he = new t(ae);
    return he = he.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(he), this;
  };
  function fe(ae, le, he) {
    Array.isArray(ae) || (ae = ae.toArray());
    var me = new Buffer$7(ae);
    if (he && me.length < he) {
      var ye = new Buffer$7(he - me.length);
      ye.fill(0), me = Buffer$7.concat([ye, me]);
    }
    return le ? me.toString(le) : me;
  }
  return browser$2;
}
var browser$1 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var c = requireBrowser$9(), t = safeBufferExports.Buffer;
  mgf = function(ie, fe) {
    for (var ae = t.alloc(0), le = 0, he; ae.length < fe; )
      he = n(le++), ae = t.concat([ae, c("sha1").update(ie).update(he).digest()]);
    return ae.slice(0, fe);
  };
  function n(ie) {
    var fe = t.allocUnsafe(4);
    return fe.writeUInt32BE(ie, 0), fe;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(t, n) {
    for (var ie = t.length, fe = -1; ++fe < ie; )
      t[fe] ^= n[fe];
    return t;
  }), xor;
}
var bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(c) {
    (function(t, n) {
      function ie(_e, se) {
        if (!_e) throw new Error(se || "Assertion failed");
      }
      function fe(_e, se) {
        _e.super_ = se;
        var ce = function() {
        };
        ce.prototype = se.prototype, _e.prototype = new ce(), _e.prototype.constructor = _e;
      }
      function ae(_e, se, ce) {
        if (ae.isBN(_e))
          return _e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((se === "le" || se === "be") && (ce = se, se = 10), this._init(_e || 0, se || 10, ce || "be"));
      }
      typeof t == "object" ? t.exports = ae : n.BN = ae, ae.BN = ae, ae.wordSize = 26;
      var le;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? le = window.Buffer : le = require$$0$5.Buffer;
      } catch {
      }
      ae.isBN = function(se) {
        return se instanceof ae ? !0 : se !== null && typeof se == "object" && se.constructor.wordSize === ae.wordSize && Array.isArray(se.words);
      }, ae.max = function(se, ce) {
        return se.cmp(ce) > 0 ? se : ce;
      }, ae.min = function(se, ce) {
        return se.cmp(ce) < 0 ? se : ce;
      }, ae.prototype._init = function(se, ce, de) {
        if (typeof se == "number")
          return this._initNumber(se, ce, de);
        if (typeof se == "object")
          return this._initArray(se, ce, de);
        ce === "hex" && (ce = 16), ie(ce === (ce | 0) && ce >= 2 && ce <= 36), se = se.toString().replace(/\s+/g, "");
        var pe = 0;
        se[0] === "-" && (pe++, this.negative = 1), pe < se.length && (ce === 16 ? this._parseHex(se, pe, de) : (this._parseBase(se, ce, pe), de === "le" && this._initArray(this.toArray(), ce, de)));
      }, ae.prototype._initNumber = function(se, ce, de) {
        se < 0 && (this.negative = 1, se = -se), se < 67108864 ? (this.words = [se & 67108863], this.length = 1) : se < 4503599627370496 ? (this.words = [
          se & 67108863,
          se / 67108864 & 67108863
        ], this.length = 2) : (ie(se < 9007199254740992), this.words = [
          se & 67108863,
          se / 67108864 & 67108863,
          1
        ], this.length = 3), de === "le" && this._initArray(this.toArray(), ce, de);
      }, ae.prototype._initArray = function(se, ce, de) {
        if (ie(typeof se.length == "number"), se.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(se.length / 3), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve, we, Ee = 0;
        if (de === "be")
          for (pe = se.length - 1, ve = 0; pe >= 0; pe -= 3)
            we = se[pe] | se[pe - 1] << 8 | se[pe - 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        else if (de === "le")
          for (pe = 0, ve = 0; pe < se.length; pe += 3)
            we = se[pe] | se[pe + 1] << 8 | se[pe + 2] << 16, this.words[ve] |= we << Ee & 67108863, this.words[ve + 1] = we >>> 26 - Ee & 67108863, Ee += 24, Ee >= 26 && (Ee -= 26, ve++);
        return this.strip();
      };
      function he(_e, se) {
        var ce = _e.charCodeAt(se);
        return ce >= 65 && ce <= 70 ? ce - 55 : ce >= 97 && ce <= 102 ? ce - 87 : ce - 48 & 15;
      }
      function me(_e, se, ce) {
        var de = he(_e, ce);
        return ce - 1 >= se && (de |= he(_e, ce - 1) << 4), de;
      }
      ae.prototype._parseHex = function(se, ce, de) {
        this.length = Math.ceil((se.length - ce) / 6), this.words = new Array(this.length);
        for (var pe = 0; pe < this.length; pe++)
          this.words[pe] = 0;
        var ve = 0, we = 0, Ee;
        if (de === "be")
          for (pe = se.length - 1; pe >= ce; pe -= 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        else {
          var xe = se.length - ce;
          for (pe = xe % 2 === 0 ? ce + 1 : ce; pe < se.length; pe += 2)
            Ee = me(se, ce, pe) << ve, this.words[we] |= Ee & 67108863, ve >= 18 ? (ve -= 18, we += 1, this.words[we] |= Ee >>> 26) : ve += 8;
        }
        this.strip();
      };
      function ye(_e, se, ce, de) {
        for (var pe = 0, ve = Math.min(_e.length, ce), we = se; we < ve; we++) {
          var Ee = _e.charCodeAt(we) - 48;
          pe *= de, Ee >= 49 ? pe += Ee - 49 + 10 : Ee >= 17 ? pe += Ee - 17 + 10 : pe += Ee;
        }
        return pe;
      }
      ae.prototype._parseBase = function(se, ce, de) {
        this.words = [0], this.length = 1;
        for (var pe = 0, ve = 1; ve <= 67108863; ve *= ce)
          pe++;
        pe--, ve = ve / ce | 0;
        for (var we = se.length - de, Ee = we % pe, xe = Math.min(we, we - Ee) + de, ue = 0, ge = de; ge < xe; ge += pe)
          ue = ye(se, ge, ge + pe, ce), this.imuln(ve), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        if (Ee !== 0) {
          var Be = 1;
          for (ue = ye(se, ge, se.length, ce), ge = 0; ge < Ee; ge++)
            Be *= ce;
          this.imuln(Be), this.words[0] + ue < 67108864 ? this.words[0] += ue : this._iaddn(ue);
        }
        this.strip();
      }, ae.prototype.copy = function(se) {
        se.words = new Array(this.length);
        for (var ce = 0; ce < this.length; ce++)
          se.words[ce] = this.words[ce];
        se.length = this.length, se.negative = this.negative, se.red = this.red;
      }, ae.prototype.clone = function() {
        var se = new ae(null);
        return this.copy(se), se;
      }, ae.prototype._expand = function(se) {
        for (; this.length < se; )
          this.words[this.length++] = 0;
        return this;
      }, ae.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, ae.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, ae.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var be = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Ae = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Se = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      ae.prototype.toString = function(se, ce) {
        se = se || 10, ce = ce | 0 || 1;
        var de;
        if (se === 16 || se === "hex") {
          de = "";
          for (var pe = 0, ve = 0, we = 0; we < this.length; we++) {
            var Ee = this.words[we], xe = ((Ee << pe | ve) & 16777215).toString(16);
            ve = Ee >>> 24 - pe & 16777215, pe += 2, pe >= 26 && (pe -= 26, we--), ve !== 0 || we !== this.length - 1 ? de = be[6 - xe.length] + xe + de : de = xe + de;
          }
          for (ve !== 0 && (de = ve.toString(16) + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        if (se === (se | 0) && se >= 2 && se <= 36) {
          var ue = Ae[se], ge = Se[se];
          de = "";
          var Be = this.clone();
          for (Be.negative = 0; !Be.isZero(); ) {
            var Ne = Be.modn(ge).toString(se);
            Be = Be.idivn(ge), Be.isZero() ? de = Ne + de : de = be[ue - Ne.length] + Ne + de;
          }
          for (this.isZero() && (de = "0" + de); de.length % ce !== 0; )
            de = "0" + de;
          return this.negative !== 0 && (de = "-" + de), de;
        }
        ie(!1, "Base should be between 2 and 36");
      }, ae.prototype.toNumber = function() {
        var se = this.words[0];
        return this.length === 2 ? se += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? se += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -se : se;
      }, ae.prototype.toJSON = function() {
        return this.toString(16);
      }, ae.prototype.toBuffer = function(se, ce) {
        return ie(typeof le < "u"), this.toArrayLike(le, se, ce);
      }, ae.prototype.toArray = function(se, ce) {
        return this.toArrayLike(Array, se, ce);
      }, ae.prototype.toArrayLike = function(se, ce, de) {
        var pe = this.byteLength(), ve = de || Math.max(1, pe);
        ie(pe <= ve, "byte array longer than desired length"), ie(ve > 0, "Requested array length <= 0"), this.strip();
        var we = ce === "le", Ee = new se(ve), xe, ue, ge = this.clone();
        if (we) {
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ue] = xe;
          for (; ue < ve; ue++)
            Ee[ue] = 0;
        } else {
          for (ue = 0; ue < ve - pe; ue++)
            Ee[ue] = 0;
          for (ue = 0; !ge.isZero(); ue++)
            xe = ge.andln(255), ge.iushrn(8), Ee[ve - ue - 1] = xe;
        }
        return Ee;
      }, Math.clz32 ? ae.prototype._countBits = function(se) {
        return 32 - Math.clz32(se);
      } : ae.prototype._countBits = function(se) {
        var ce = se, de = 0;
        return ce >= 4096 && (de += 13, ce >>>= 13), ce >= 64 && (de += 7, ce >>>= 7), ce >= 8 && (de += 4, ce >>>= 4), ce >= 2 && (de += 2, ce >>>= 2), de + ce;
      }, ae.prototype._zeroBits = function(se) {
        if (se === 0) return 26;
        var ce = se, de = 0;
        return ce & 8191 || (de += 13, ce >>>= 13), ce & 127 || (de += 7, ce >>>= 7), ce & 15 || (de += 4, ce >>>= 4), ce & 3 || (de += 2, ce >>>= 2), ce & 1 || de++, de;
      }, ae.prototype.bitLength = function() {
        var se = this.words[this.length - 1], ce = this._countBits(se);
        return (this.length - 1) * 26 + ce;
      };
      function $e(_e) {
        for (var se = new Array(_e.bitLength()), ce = 0; ce < se.length; ce++) {
          var de = ce / 26 | 0, pe = ce % 26;
          se[ce] = (_e.words[de] & 1 << pe) >>> pe;
        }
        return se;
      }
      ae.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var se = 0, ce = 0; ce < this.length; ce++) {
          var de = this._zeroBits(this.words[ce]);
          if (se += de, de !== 26) break;
        }
        return se;
      }, ae.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, ae.prototype.toTwos = function(se) {
        return this.negative !== 0 ? this.abs().inotn(se).iaddn(1) : this.clone();
      }, ae.prototype.fromTwos = function(se) {
        return this.testn(se - 1) ? this.notn(se).iaddn(1).ineg() : this.clone();
      }, ae.prototype.isNeg = function() {
        return this.negative !== 0;
      }, ae.prototype.neg = function() {
        return this.clone().ineg();
      }, ae.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, ae.prototype.iuor = function(se) {
        for (; this.length < se.length; )
          this.words[this.length++] = 0;
        for (var ce = 0; ce < se.length; ce++)
          this.words[ce] = this.words[ce] | se.words[ce];
        return this.strip();
      }, ae.prototype.ior = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuor(se);
      }, ae.prototype.or = function(se) {
        return this.length > se.length ? this.clone().ior(se) : se.clone().ior(this);
      }, ae.prototype.uor = function(se) {
        return this.length > se.length ? this.clone().iuor(se) : se.clone().iuor(this);
      }, ae.prototype.iuand = function(se) {
        var ce;
        this.length > se.length ? ce = se : ce = this;
        for (var de = 0; de < ce.length; de++)
          this.words[de] = this.words[de] & se.words[de];
        return this.length = ce.length, this.strip();
      }, ae.prototype.iand = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuand(se);
      }, ae.prototype.and = function(se) {
        return this.length > se.length ? this.clone().iand(se) : se.clone().iand(this);
      }, ae.prototype.uand = function(se) {
        return this.length > se.length ? this.clone().iuand(se) : se.clone().iuand(this);
      }, ae.prototype.iuxor = function(se) {
        var ce, de;
        this.length > se.length ? (ce = this, de = se) : (ce = se, de = this);
        for (var pe = 0; pe < de.length; pe++)
          this.words[pe] = ce.words[pe] ^ de.words[pe];
        if (this !== ce)
          for (; pe < ce.length; pe++)
            this.words[pe] = ce.words[pe];
        return this.length = ce.length, this.strip();
      }, ae.prototype.ixor = function(se) {
        return ie((this.negative | se.negative) === 0), this.iuxor(se);
      }, ae.prototype.xor = function(se) {
        return this.length > se.length ? this.clone().ixor(se) : se.clone().ixor(this);
      }, ae.prototype.uxor = function(se) {
        return this.length > se.length ? this.clone().iuxor(se) : se.clone().iuxor(this);
      }, ae.prototype.inotn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = Math.ceil(se / 26) | 0, de = se % 26;
        this._expand(ce), de > 0 && ce--;
        for (var pe = 0; pe < ce; pe++)
          this.words[pe] = ~this.words[pe] & 67108863;
        return de > 0 && (this.words[pe] = ~this.words[pe] & 67108863 >> 26 - de), this.strip();
      }, ae.prototype.notn = function(se) {
        return this.clone().inotn(se);
      }, ae.prototype.setn = function(se, ce) {
        ie(typeof se == "number" && se >= 0);
        var de = se / 26 | 0, pe = se % 26;
        return this._expand(de + 1), ce ? this.words[de] = this.words[de] | 1 << pe : this.words[de] = this.words[de] & ~(1 << pe), this.strip();
      }, ae.prototype.iadd = function(se) {
        var ce;
        if (this.negative !== 0 && se.negative === 0)
          return this.negative = 0, ce = this.isub(se), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && se.negative !== 0)
          return se.negative = 0, ce = this.isub(se), se.negative = 1, ce._normSign();
        var de, pe;
        this.length > se.length ? (de = this, pe = se) : (de = se, pe = this);
        for (var ve = 0, we = 0; we < pe.length; we++)
          ce = (de.words[we] | 0) + (pe.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        for (; ve !== 0 && we < de.length; we++)
          ce = (de.words[we] | 0) + ve, this.words[we] = ce & 67108863, ve = ce >>> 26;
        if (this.length = de.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (de !== this)
          for (; we < de.length; we++)
            this.words[we] = de.words[we];
        return this;
      }, ae.prototype.add = function(se) {
        var ce;
        return se.negative !== 0 && this.negative === 0 ? (se.negative = 0, ce = this.sub(se), se.negative ^= 1, ce) : se.negative === 0 && this.negative !== 0 ? (this.negative = 0, ce = se.sub(this), this.negative = 1, ce) : this.length > se.length ? this.clone().iadd(se) : se.clone().iadd(this);
      }, ae.prototype.isub = function(se) {
        if (se.negative !== 0) {
          se.negative = 0;
          var ce = this.iadd(se);
          return se.negative = 1, ce._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(se), this.negative = 1, this._normSign();
        var de = this.cmp(se);
        if (de === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var pe, ve;
        de > 0 ? (pe = this, ve = se) : (pe = se, ve = this);
        for (var we = 0, Ee = 0; Ee < ve.length; Ee++)
          ce = (pe.words[Ee] | 0) - (ve.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        for (; we !== 0 && Ee < pe.length; Ee++)
          ce = (pe.words[Ee] | 0) + we, we = ce >> 26, this.words[Ee] = ce & 67108863;
        if (we === 0 && Ee < pe.length && pe !== this)
          for (; Ee < pe.length; Ee++)
            this.words[Ee] = pe.words[Ee];
        return this.length = Math.max(this.length, Ee), pe !== this && (this.negative = 1), this.strip();
      }, ae.prototype.sub = function(se) {
        return this.clone().isub(se);
      };
      function Re(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative;
        var de = _e.length + se.length | 0;
        ce.length = de, de = de - 1 | 0;
        var pe = _e.words[0] | 0, ve = se.words[0] | 0, we = pe * ve, Ee = we & 67108863, xe = we / 67108864 | 0;
        ce.words[0] = Ee;
        for (var ue = 1; ue < de; ue++) {
          for (var ge = xe >>> 26, Be = xe & 67108863, Ne = Math.min(ue, se.length - 1), Fe = Math.max(0, ue - _e.length + 1); Fe <= Ne; Fe++) {
            var Pe = ue - Fe | 0;
            pe = _e.words[Pe] | 0, ve = se.words[Fe] | 0, we = pe * ve + Be, ge += we / 67108864 | 0, Be = we & 67108863;
          }
          ce.words[ue] = Be | 0, xe = ge | 0;
        }
        return xe !== 0 ? ce.words[ue] = xe | 0 : ce.length--, ce.strip();
      }
      var Me = function(se, ce, de) {
        var pe = se.words, ve = ce.words, we = de.words, Ee = 0, xe, ue, ge, Be = pe[0] | 0, Ne = Be & 8191, Fe = Be >>> 13, Pe = pe[1] | 0, Je = Pe & 8191, Ke = Pe >>> 13, Ze = pe[2] | 0, Ye = Ze & 8191, Pt = Ze >>> 13, Ft = pe[3] | 0, Le = Ft & 8191, $t = Ft >>> 13, Jt = pe[4] | 0, Ht = Jt & 8191, Vt = Jt >>> 13, xn = pe[5] | 0, Zt = xn & 8191, Gt = xn >>> 13, An = pe[6] | 0, Qt = An & 8191, Xt = An >>> 13, wn = pe[7] | 0, Qe = wn & 8191, Dt = wn >>> 13, en = pe[8] | 0, We = en & 8191, De = en >>> 13, Ge = pe[9] | 0, Oe = Ge & 8191, Ce = Ge >>> 13, He = ve[0] | 0, Xe = He & 8191, Kt = He >>> 13, tn = ve[1] | 0, Wt = tn & 8191, Yt = tn >>> 13, _n = ve[2] | 0, rn = _n & 8191, nn = _n >>> 13, En = ve[3] | 0, an = En & 8191, dn = En >>> 13, Mn = ve[4] | 0, on = Mn & 8191, hn = Mn >>> 13, Rn = ve[5] | 0, sn = Rn & 8191, pn = Rn >>> 13, Bn = ve[6] | 0, fn = Bn & 8191, yn = Bn >>> 13, kn = ve[7] | 0, un = kn & 8191, mn = kn >>> 13, Tn = ve[8] | 0, cn = Tn & 8191, gn = Tn >>> 13, Cn = ve[9] | 0, ln = Cn & 8191, vn = Cn >>> 13;
        de.negative = se.negative ^ ce.negative, de.length = 19, xe = Math.imul(Ne, Xe), ue = Math.imul(Ne, Kt), ue = ue + Math.imul(Fe, Xe) | 0, ge = Math.imul(Fe, Kt);
        var Sn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, xe = Math.imul(Je, Xe), ue = Math.imul(Je, Kt), ue = ue + Math.imul(Ke, Xe) | 0, ge = Math.imul(Ke, Kt), xe = xe + Math.imul(Ne, Wt) | 0, ue = ue + Math.imul(Ne, Yt) | 0, ue = ue + Math.imul(Fe, Wt) | 0, ge = ge + Math.imul(Fe, Yt) | 0;
        var $n = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + ($n >>> 26) | 0, $n &= 67108863, xe = Math.imul(Ye, Xe), ue = Math.imul(Ye, Kt), ue = ue + Math.imul(Pt, Xe) | 0, ge = Math.imul(Pt, Kt), xe = xe + Math.imul(Je, Wt) | 0, ue = ue + Math.imul(Je, Yt) | 0, ue = ue + Math.imul(Ke, Wt) | 0, ge = ge + Math.imul(Ke, Yt) | 0, xe = xe + Math.imul(Ne, rn) | 0, ue = ue + Math.imul(Ne, nn) | 0, ue = ue + Math.imul(Fe, rn) | 0, ge = ge + Math.imul(Fe, nn) | 0;
        var Nn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Nn >>> 26) | 0, Nn &= 67108863, xe = Math.imul(Le, Xe), ue = Math.imul(Le, Kt), ue = ue + Math.imul($t, Xe) | 0, ge = Math.imul($t, Kt), xe = xe + Math.imul(Ye, Wt) | 0, ue = ue + Math.imul(Ye, Yt) | 0, ue = ue + Math.imul(Pt, Wt) | 0, ge = ge + Math.imul(Pt, Yt) | 0, xe = xe + Math.imul(Je, rn) | 0, ue = ue + Math.imul(Je, nn) | 0, ue = ue + Math.imul(Ke, rn) | 0, ge = ge + Math.imul(Ke, nn) | 0, xe = xe + Math.imul(Ne, an) | 0, ue = ue + Math.imul(Ne, dn) | 0, ue = ue + Math.imul(Fe, an) | 0, ge = ge + Math.imul(Fe, dn) | 0;
        var In = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (In >>> 26) | 0, In &= 67108863, xe = Math.imul(Ht, Xe), ue = Math.imul(Ht, Kt), ue = ue + Math.imul(Vt, Xe) | 0, ge = Math.imul(Vt, Kt), xe = xe + Math.imul(Le, Wt) | 0, ue = ue + Math.imul(Le, Yt) | 0, ue = ue + Math.imul($t, Wt) | 0, ge = ge + Math.imul($t, Yt) | 0, xe = xe + Math.imul(Ye, rn) | 0, ue = ue + Math.imul(Ye, nn) | 0, ue = ue + Math.imul(Pt, rn) | 0, ge = ge + Math.imul(Pt, nn) | 0, xe = xe + Math.imul(Je, an) | 0, ue = ue + Math.imul(Je, dn) | 0, ue = ue + Math.imul(Ke, an) | 0, ge = ge + Math.imul(Ke, dn) | 0, xe = xe + Math.imul(Ne, on) | 0, ue = ue + Math.imul(Ne, hn) | 0, ue = ue + Math.imul(Fe, on) | 0, ge = ge + Math.imul(Fe, hn) | 0;
        var Pn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Pn >>> 26) | 0, Pn &= 67108863, xe = Math.imul(Zt, Xe), ue = Math.imul(Zt, Kt), ue = ue + Math.imul(Gt, Xe) | 0, ge = Math.imul(Gt, Kt), xe = xe + Math.imul(Ht, Wt) | 0, ue = ue + Math.imul(Ht, Yt) | 0, ue = ue + Math.imul(Vt, Wt) | 0, ge = ge + Math.imul(Vt, Yt) | 0, xe = xe + Math.imul(Le, rn) | 0, ue = ue + Math.imul(Le, nn) | 0, ue = ue + Math.imul($t, rn) | 0, ge = ge + Math.imul($t, nn) | 0, xe = xe + Math.imul(Ye, an) | 0, ue = ue + Math.imul(Ye, dn) | 0, ue = ue + Math.imul(Pt, an) | 0, ge = ge + Math.imul(Pt, dn) | 0, xe = xe + Math.imul(Je, on) | 0, ue = ue + Math.imul(Je, hn) | 0, ue = ue + Math.imul(Ke, on) | 0, ge = ge + Math.imul(Ke, hn) | 0, xe = xe + Math.imul(Ne, sn) | 0, ue = ue + Math.imul(Ne, pn) | 0, ue = ue + Math.imul(Fe, sn) | 0, ge = ge + Math.imul(Fe, pn) | 0;
        var On = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (On >>> 26) | 0, On &= 67108863, xe = Math.imul(Qt, Xe), ue = Math.imul(Qt, Kt), ue = ue + Math.imul(Xt, Xe) | 0, ge = Math.imul(Xt, Kt), xe = xe + Math.imul(Zt, Wt) | 0, ue = ue + Math.imul(Zt, Yt) | 0, ue = ue + Math.imul(Gt, Wt) | 0, ge = ge + Math.imul(Gt, Yt) | 0, xe = xe + Math.imul(Ht, rn) | 0, ue = ue + Math.imul(Ht, nn) | 0, ue = ue + Math.imul(Vt, rn) | 0, ge = ge + Math.imul(Vt, nn) | 0, xe = xe + Math.imul(Le, an) | 0, ue = ue + Math.imul(Le, dn) | 0, ue = ue + Math.imul($t, an) | 0, ge = ge + Math.imul($t, dn) | 0, xe = xe + Math.imul(Ye, on) | 0, ue = ue + Math.imul(Ye, hn) | 0, ue = ue + Math.imul(Pt, on) | 0, ge = ge + Math.imul(Pt, hn) | 0, xe = xe + Math.imul(Je, sn) | 0, ue = ue + Math.imul(Je, pn) | 0, ue = ue + Math.imul(Ke, sn) | 0, ge = ge + Math.imul(Ke, pn) | 0, xe = xe + Math.imul(Ne, fn) | 0, ue = ue + Math.imul(Ne, yn) | 0, ue = ue + Math.imul(Fe, fn) | 0, ge = ge + Math.imul(Fe, yn) | 0;
        var Ln = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Ln >>> 26) | 0, Ln &= 67108863, xe = Math.imul(Qe, Xe), ue = Math.imul(Qe, Kt), ue = ue + Math.imul(Dt, Xe) | 0, ge = Math.imul(Dt, Kt), xe = xe + Math.imul(Qt, Wt) | 0, ue = ue + Math.imul(Qt, Yt) | 0, ue = ue + Math.imul(Xt, Wt) | 0, ge = ge + Math.imul(Xt, Yt) | 0, xe = xe + Math.imul(Zt, rn) | 0, ue = ue + Math.imul(Zt, nn) | 0, ue = ue + Math.imul(Gt, rn) | 0, ge = ge + Math.imul(Gt, nn) | 0, xe = xe + Math.imul(Ht, an) | 0, ue = ue + Math.imul(Ht, dn) | 0, ue = ue + Math.imul(Vt, an) | 0, ge = ge + Math.imul(Vt, dn) | 0, xe = xe + Math.imul(Le, on) | 0, ue = ue + Math.imul(Le, hn) | 0, ue = ue + Math.imul($t, on) | 0, ge = ge + Math.imul($t, hn) | 0, xe = xe + Math.imul(Ye, sn) | 0, ue = ue + Math.imul(Ye, pn) | 0, ue = ue + Math.imul(Pt, sn) | 0, ge = ge + Math.imul(Pt, pn) | 0, xe = xe + Math.imul(Je, fn) | 0, ue = ue + Math.imul(Je, yn) | 0, ue = ue + Math.imul(Ke, fn) | 0, ge = ge + Math.imul(Ke, yn) | 0, xe = xe + Math.imul(Ne, un) | 0, ue = ue + Math.imul(Ne, mn) | 0, ue = ue + Math.imul(Fe, un) | 0, ge = ge + Math.imul(Fe, mn) | 0;
        var Dn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Dn >>> 26) | 0, Dn &= 67108863, xe = Math.imul(We, Xe), ue = Math.imul(We, Kt), ue = ue + Math.imul(De, Xe) | 0, ge = Math.imul(De, Kt), xe = xe + Math.imul(Qe, Wt) | 0, ue = ue + Math.imul(Qe, Yt) | 0, ue = ue + Math.imul(Dt, Wt) | 0, ge = ge + Math.imul(Dt, Yt) | 0, xe = xe + Math.imul(Qt, rn) | 0, ue = ue + Math.imul(Qt, nn) | 0, ue = ue + Math.imul(Xt, rn) | 0, ge = ge + Math.imul(Xt, nn) | 0, xe = xe + Math.imul(Zt, an) | 0, ue = ue + Math.imul(Zt, dn) | 0, ue = ue + Math.imul(Gt, an) | 0, ge = ge + Math.imul(Gt, dn) | 0, xe = xe + Math.imul(Ht, on) | 0, ue = ue + Math.imul(Ht, hn) | 0, ue = ue + Math.imul(Vt, on) | 0, ge = ge + Math.imul(Vt, hn) | 0, xe = xe + Math.imul(Le, sn) | 0, ue = ue + Math.imul(Le, pn) | 0, ue = ue + Math.imul($t, sn) | 0, ge = ge + Math.imul($t, pn) | 0, xe = xe + Math.imul(Ye, fn) | 0, ue = ue + Math.imul(Ye, yn) | 0, ue = ue + Math.imul(Pt, fn) | 0, ge = ge + Math.imul(Pt, yn) | 0, xe = xe + Math.imul(Je, un) | 0, ue = ue + Math.imul(Je, mn) | 0, ue = ue + Math.imul(Ke, un) | 0, ge = ge + Math.imul(Ke, mn) | 0, xe = xe + Math.imul(Ne, cn) | 0, ue = ue + Math.imul(Ne, gn) | 0, ue = ue + Math.imul(Fe, cn) | 0, ge = ge + Math.imul(Fe, gn) | 0;
        var qn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, xe = Math.imul(Oe, Xe), ue = Math.imul(Oe, Kt), ue = ue + Math.imul(Ce, Xe) | 0, ge = Math.imul(Ce, Kt), xe = xe + Math.imul(We, Wt) | 0, ue = ue + Math.imul(We, Yt) | 0, ue = ue + Math.imul(De, Wt) | 0, ge = ge + Math.imul(De, Yt) | 0, xe = xe + Math.imul(Qe, rn) | 0, ue = ue + Math.imul(Qe, nn) | 0, ue = ue + Math.imul(Dt, rn) | 0, ge = ge + Math.imul(Dt, nn) | 0, xe = xe + Math.imul(Qt, an) | 0, ue = ue + Math.imul(Qt, dn) | 0, ue = ue + Math.imul(Xt, an) | 0, ge = ge + Math.imul(Xt, dn) | 0, xe = xe + Math.imul(Zt, on) | 0, ue = ue + Math.imul(Zt, hn) | 0, ue = ue + Math.imul(Gt, on) | 0, ge = ge + Math.imul(Gt, hn) | 0, xe = xe + Math.imul(Ht, sn) | 0, ue = ue + Math.imul(Ht, pn) | 0, ue = ue + Math.imul(Vt, sn) | 0, ge = ge + Math.imul(Vt, pn) | 0, xe = xe + Math.imul(Le, fn) | 0, ue = ue + Math.imul(Le, yn) | 0, ue = ue + Math.imul($t, fn) | 0, ge = ge + Math.imul($t, yn) | 0, xe = xe + Math.imul(Ye, un) | 0, ue = ue + Math.imul(Ye, mn) | 0, ue = ue + Math.imul(Pt, un) | 0, ge = ge + Math.imul(Pt, mn) | 0, xe = xe + Math.imul(Je, cn) | 0, ue = ue + Math.imul(Je, gn) | 0, ue = ue + Math.imul(Ke, cn) | 0, ge = ge + Math.imul(Ke, gn) | 0, xe = xe + Math.imul(Ne, ln) | 0, ue = ue + Math.imul(Ne, vn) | 0, ue = ue + Math.imul(Fe, ln) | 0, ge = ge + Math.imul(Fe, vn) | 0;
        var Fn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, xe = Math.imul(Oe, Wt), ue = Math.imul(Oe, Yt), ue = ue + Math.imul(Ce, Wt) | 0, ge = Math.imul(Ce, Yt), xe = xe + Math.imul(We, rn) | 0, ue = ue + Math.imul(We, nn) | 0, ue = ue + Math.imul(De, rn) | 0, ge = ge + Math.imul(De, nn) | 0, xe = xe + Math.imul(Qe, an) | 0, ue = ue + Math.imul(Qe, dn) | 0, ue = ue + Math.imul(Dt, an) | 0, ge = ge + Math.imul(Dt, dn) | 0, xe = xe + Math.imul(Qt, on) | 0, ue = ue + Math.imul(Qt, hn) | 0, ue = ue + Math.imul(Xt, on) | 0, ge = ge + Math.imul(Xt, hn) | 0, xe = xe + Math.imul(Zt, sn) | 0, ue = ue + Math.imul(Zt, pn) | 0, ue = ue + Math.imul(Gt, sn) | 0, ge = ge + Math.imul(Gt, pn) | 0, xe = xe + Math.imul(Ht, fn) | 0, ue = ue + Math.imul(Ht, yn) | 0, ue = ue + Math.imul(Vt, fn) | 0, ge = ge + Math.imul(Vt, yn) | 0, xe = xe + Math.imul(Le, un) | 0, ue = ue + Math.imul(Le, mn) | 0, ue = ue + Math.imul($t, un) | 0, ge = ge + Math.imul($t, mn) | 0, xe = xe + Math.imul(Ye, cn) | 0, ue = ue + Math.imul(Ye, gn) | 0, ue = ue + Math.imul(Pt, cn) | 0, ge = ge + Math.imul(Pt, gn) | 0, xe = xe + Math.imul(Je, ln) | 0, ue = ue + Math.imul(Je, vn) | 0, ue = ue + Math.imul(Ke, ln) | 0, ge = ge + Math.imul(Ke, vn) | 0;
        var Un = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Un >>> 26) | 0, Un &= 67108863, xe = Math.imul(Oe, rn), ue = Math.imul(Oe, nn), ue = ue + Math.imul(Ce, rn) | 0, ge = Math.imul(Ce, nn), xe = xe + Math.imul(We, an) | 0, ue = ue + Math.imul(We, dn) | 0, ue = ue + Math.imul(De, an) | 0, ge = ge + Math.imul(De, dn) | 0, xe = xe + Math.imul(Qe, on) | 0, ue = ue + Math.imul(Qe, hn) | 0, ue = ue + Math.imul(Dt, on) | 0, ge = ge + Math.imul(Dt, hn) | 0, xe = xe + Math.imul(Qt, sn) | 0, ue = ue + Math.imul(Qt, pn) | 0, ue = ue + Math.imul(Xt, sn) | 0, ge = ge + Math.imul(Xt, pn) | 0, xe = xe + Math.imul(Zt, fn) | 0, ue = ue + Math.imul(Zt, yn) | 0, ue = ue + Math.imul(Gt, fn) | 0, ge = ge + Math.imul(Gt, yn) | 0, xe = xe + Math.imul(Ht, un) | 0, ue = ue + Math.imul(Ht, mn) | 0, ue = ue + Math.imul(Vt, un) | 0, ge = ge + Math.imul(Vt, mn) | 0, xe = xe + Math.imul(Le, cn) | 0, ue = ue + Math.imul(Le, gn) | 0, ue = ue + Math.imul($t, cn) | 0, ge = ge + Math.imul($t, gn) | 0, xe = xe + Math.imul(Ye, ln) | 0, ue = ue + Math.imul(Ye, vn) | 0, ue = ue + Math.imul(Pt, ln) | 0, ge = ge + Math.imul(Pt, vn) | 0;
        var Kn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, xe = Math.imul(Oe, an), ue = Math.imul(Oe, dn), ue = ue + Math.imul(Ce, an) | 0, ge = Math.imul(Ce, dn), xe = xe + Math.imul(We, on) | 0, ue = ue + Math.imul(We, hn) | 0, ue = ue + Math.imul(De, on) | 0, ge = ge + Math.imul(De, hn) | 0, xe = xe + Math.imul(Qe, sn) | 0, ue = ue + Math.imul(Qe, pn) | 0, ue = ue + Math.imul(Dt, sn) | 0, ge = ge + Math.imul(Dt, pn) | 0, xe = xe + Math.imul(Qt, fn) | 0, ue = ue + Math.imul(Qt, yn) | 0, ue = ue + Math.imul(Xt, fn) | 0, ge = ge + Math.imul(Xt, yn) | 0, xe = xe + Math.imul(Zt, un) | 0, ue = ue + Math.imul(Zt, mn) | 0, ue = ue + Math.imul(Gt, un) | 0, ge = ge + Math.imul(Gt, mn) | 0, xe = xe + Math.imul(Ht, cn) | 0, ue = ue + Math.imul(Ht, gn) | 0, ue = ue + Math.imul(Vt, cn) | 0, ge = ge + Math.imul(Vt, gn) | 0, xe = xe + Math.imul(Le, ln) | 0, ue = ue + Math.imul(Le, vn) | 0, ue = ue + Math.imul($t, ln) | 0, ge = ge + Math.imul($t, vn) | 0;
        var Hn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Hn >>> 26) | 0, Hn &= 67108863, xe = Math.imul(Oe, on), ue = Math.imul(Oe, hn), ue = ue + Math.imul(Ce, on) | 0, ge = Math.imul(Ce, hn), xe = xe + Math.imul(We, sn) | 0, ue = ue + Math.imul(We, pn) | 0, ue = ue + Math.imul(De, sn) | 0, ge = ge + Math.imul(De, pn) | 0, xe = xe + Math.imul(Qe, fn) | 0, ue = ue + Math.imul(Qe, yn) | 0, ue = ue + Math.imul(Dt, fn) | 0, ge = ge + Math.imul(Dt, yn) | 0, xe = xe + Math.imul(Qt, un) | 0, ue = ue + Math.imul(Qt, mn) | 0, ue = ue + Math.imul(Xt, un) | 0, ge = ge + Math.imul(Xt, mn) | 0, xe = xe + Math.imul(Zt, cn) | 0, ue = ue + Math.imul(Zt, gn) | 0, ue = ue + Math.imul(Gt, cn) | 0, ge = ge + Math.imul(Gt, gn) | 0, xe = xe + Math.imul(Ht, ln) | 0, ue = ue + Math.imul(Ht, vn) | 0, ue = ue + Math.imul(Vt, ln) | 0, ge = ge + Math.imul(Vt, vn) | 0;
        var zn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, xe = Math.imul(Oe, sn), ue = Math.imul(Oe, pn), ue = ue + Math.imul(Ce, sn) | 0, ge = Math.imul(Ce, pn), xe = xe + Math.imul(We, fn) | 0, ue = ue + Math.imul(We, yn) | 0, ue = ue + Math.imul(De, fn) | 0, ge = ge + Math.imul(De, yn) | 0, xe = xe + Math.imul(Qe, un) | 0, ue = ue + Math.imul(Qe, mn) | 0, ue = ue + Math.imul(Dt, un) | 0, ge = ge + Math.imul(Dt, mn) | 0, xe = xe + Math.imul(Qt, cn) | 0, ue = ue + Math.imul(Qt, gn) | 0, ue = ue + Math.imul(Xt, cn) | 0, ge = ge + Math.imul(Xt, gn) | 0, xe = xe + Math.imul(Zt, ln) | 0, ue = ue + Math.imul(Zt, vn) | 0, ue = ue + Math.imul(Gt, ln) | 0, ge = ge + Math.imul(Gt, vn) | 0;
        var jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, xe = Math.imul(Oe, fn), ue = Math.imul(Oe, yn), ue = ue + Math.imul(Ce, fn) | 0, ge = Math.imul(Ce, yn), xe = xe + Math.imul(We, un) | 0, ue = ue + Math.imul(We, mn) | 0, ue = ue + Math.imul(De, un) | 0, ge = ge + Math.imul(De, mn) | 0, xe = xe + Math.imul(Qe, cn) | 0, ue = ue + Math.imul(Qe, gn) | 0, ue = ue + Math.imul(Dt, cn) | 0, ge = ge + Math.imul(Dt, gn) | 0, xe = xe + Math.imul(Qt, ln) | 0, ue = ue + Math.imul(Qt, vn) | 0, ue = ue + Math.imul(Xt, ln) | 0, ge = ge + Math.imul(Xt, vn) | 0;
        var Gn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, xe = Math.imul(Oe, un), ue = Math.imul(Oe, mn), ue = ue + Math.imul(Ce, un) | 0, ge = Math.imul(Ce, mn), xe = xe + Math.imul(We, cn) | 0, ue = ue + Math.imul(We, gn) | 0, ue = ue + Math.imul(De, cn) | 0, ge = ge + Math.imul(De, gn) | 0, xe = xe + Math.imul(Qe, ln) | 0, ue = ue + Math.imul(Qe, vn) | 0, ue = ue + Math.imul(Dt, ln) | 0, ge = ge + Math.imul(Dt, vn) | 0;
        var Wn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, xe = Math.imul(Oe, cn), ue = Math.imul(Oe, gn), ue = ue + Math.imul(Ce, cn) | 0, ge = Math.imul(Ce, gn), xe = xe + Math.imul(We, ln) | 0, ue = ue + Math.imul(We, vn) | 0, ue = ue + Math.imul(De, ln) | 0, ge = ge + Math.imul(De, vn) | 0;
        var Vn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        Ee = (ge + (ue >>> 13) | 0) + (Vn >>> 26) | 0, Vn &= 67108863, xe = Math.imul(Oe, ln), ue = Math.imul(Oe, vn), ue = ue + Math.imul(Ce, ln) | 0, ge = Math.imul(Ce, vn);
        var Jn = (Ee + xe | 0) + ((ue & 8191) << 13) | 0;
        return Ee = (ge + (ue >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, we[0] = Sn, we[1] = $n, we[2] = Nn, we[3] = In, we[4] = Pn, we[5] = On, we[6] = Ln, we[7] = Dn, we[8] = qn, we[9] = Fn, we[10] = Un, we[11] = Kn, we[12] = Hn, we[13] = zn, we[14] = jn, we[15] = Gn, we[16] = Wn, we[17] = Vn, we[18] = Jn, Ee !== 0 && (we[19] = Ee, de.length++), de;
      };
      Math.imul || (Me = Re);
      function ke(_e, se, ce) {
        ce.negative = se.negative ^ _e.negative, ce.length = _e.length + se.length;
        for (var de = 0, pe = 0, ve = 0; ve < ce.length - 1; ve++) {
          var we = pe;
          pe = 0;
          for (var Ee = de & 67108863, xe = Math.min(ve, se.length - 1), ue = Math.max(0, ve - _e.length + 1); ue <= xe; ue++) {
            var ge = ve - ue, Be = _e.words[ge] | 0, Ne = se.words[ue] | 0, Fe = Be * Ne, Pe = Fe & 67108863;
            we = we + (Fe / 67108864 | 0) | 0, Pe = Pe + Ee | 0, Ee = Pe & 67108863, we = we + (Pe >>> 26) | 0, pe += we >>> 26, we &= 67108863;
          }
          ce.words[ve] = Ee, de = we, we = pe;
        }
        return de !== 0 ? ce.words[ve] = de : ce.length--, ce.strip();
      }
      function Te(_e, se, ce) {
        var de = new Ie();
        return de.mulp(_e, se, ce);
      }
      ae.prototype.mulTo = function(se, ce) {
        var de, pe = this.length + se.length;
        return this.length === 10 && se.length === 10 ? de = Me(this, se, ce) : pe < 63 ? de = Re(this, se, ce) : pe < 1024 ? de = ke(this, se, ce) : de = Te(this, se, ce), de;
      };
      function Ie(_e, se) {
        this.x = _e, this.y = se;
      }
      Ie.prototype.makeRBT = function(se) {
        for (var ce = new Array(se), de = ae.prototype._countBits(se) - 1, pe = 0; pe < se; pe++)
          ce[pe] = this.revBin(pe, de, se);
        return ce;
      }, Ie.prototype.revBin = function(se, ce, de) {
        if (se === 0 || se === de - 1) return se;
        for (var pe = 0, ve = 0; ve < ce; ve++)
          pe |= (se & 1) << ce - ve - 1, se >>= 1;
        return pe;
      }, Ie.prototype.permute = function(se, ce, de, pe, ve, we) {
        for (var Ee = 0; Ee < we; Ee++)
          pe[Ee] = ce[se[Ee]], ve[Ee] = de[se[Ee]];
      }, Ie.prototype.transform = function(se, ce, de, pe, ve, we) {
        this.permute(we, se, ce, de, pe, ve);
        for (var Ee = 1; Ee < ve; Ee <<= 1)
          for (var xe = Ee << 1, ue = Math.cos(2 * Math.PI / xe), ge = Math.sin(2 * Math.PI / xe), Be = 0; Be < ve; Be += xe)
            for (var Ne = ue, Fe = ge, Pe = 0; Pe < Ee; Pe++) {
              var Je = de[Be + Pe], Ke = pe[Be + Pe], Ze = de[Be + Pe + Ee], Ye = pe[Be + Pe + Ee], Pt = Ne * Ze - Fe * Ye;
              Ye = Ne * Ye + Fe * Ze, Ze = Pt, de[Be + Pe] = Je + Ze, pe[Be + Pe] = Ke + Ye, de[Be + Pe + Ee] = Je - Ze, pe[Be + Pe + Ee] = Ke - Ye, Pe !== xe && (Pt = ue * Ne - ge * Fe, Fe = ue * Fe + ge * Ne, Ne = Pt);
            }
      }, Ie.prototype.guessLen13b = function(se, ce) {
        var de = Math.max(ce, se) | 1, pe = de & 1, ve = 0;
        for (de = de / 2 | 0; de; de = de >>> 1)
          ve++;
        return 1 << ve + 1 + pe;
      }, Ie.prototype.conjugate = function(se, ce, de) {
        if (!(de <= 1))
          for (var pe = 0; pe < de / 2; pe++) {
            var ve = se[pe];
            se[pe] = se[de - pe - 1], se[de - pe - 1] = ve, ve = ce[pe], ce[pe] = -ce[de - pe - 1], ce[de - pe - 1] = -ve;
          }
      }, Ie.prototype.normalize13b = function(se, ce) {
        for (var de = 0, pe = 0; pe < ce / 2; pe++) {
          var ve = Math.round(se[2 * pe + 1] / ce) * 8192 + Math.round(se[2 * pe] / ce) + de;
          se[pe] = ve & 67108863, ve < 67108864 ? de = 0 : de = ve / 67108864 | 0;
        }
        return se;
      }, Ie.prototype.convert13b = function(se, ce, de, pe) {
        for (var ve = 0, we = 0; we < ce; we++)
          ve = ve + (se[we] | 0), de[2 * we] = ve & 8191, ve = ve >>> 13, de[2 * we + 1] = ve & 8191, ve = ve >>> 13;
        for (we = 2 * ce; we < pe; ++we)
          de[we] = 0;
        ie(ve === 0), ie((ve & -8192) === 0);
      }, Ie.prototype.stub = function(se) {
        for (var ce = new Array(se), de = 0; de < se; de++)
          ce[de] = 0;
        return ce;
      }, Ie.prototype.mulp = function(se, ce, de) {
        var pe = 2 * this.guessLen13b(se.length, ce.length), ve = this.makeRBT(pe), we = this.stub(pe), Ee = new Array(pe), xe = new Array(pe), ue = new Array(pe), ge = new Array(pe), Be = new Array(pe), Ne = new Array(pe), Fe = de.words;
        Fe.length = pe, this.convert13b(se.words, se.length, Ee, pe), this.convert13b(ce.words, ce.length, ge, pe), this.transform(Ee, we, xe, ue, pe, ve), this.transform(ge, we, Be, Ne, pe, ve);
        for (var Pe = 0; Pe < pe; Pe++) {
          var Je = xe[Pe] * Be[Pe] - ue[Pe] * Ne[Pe];
          ue[Pe] = xe[Pe] * Ne[Pe] + ue[Pe] * Be[Pe], xe[Pe] = Je;
        }
        return this.conjugate(xe, ue, pe), this.transform(xe, ue, Fe, we, pe, ve), this.conjugate(Fe, we, pe), this.normalize13b(Fe, pe), de.negative = se.negative ^ ce.negative, de.length = se.length + ce.length, de.strip();
      }, ae.prototype.mul = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), this.mulTo(se, ce);
      }, ae.prototype.mulf = function(se) {
        var ce = new ae(null);
        return ce.words = new Array(this.length + se.length), Te(this, se, ce);
      }, ae.prototype.imul = function(se) {
        return this.clone().mulTo(se, this);
      }, ae.prototype.imuln = function(se) {
        ie(typeof se == "number"), ie(se < 67108864);
        for (var ce = 0, de = 0; de < this.length; de++) {
          var pe = (this.words[de] | 0) * se, ve = (pe & 67108863) + (ce & 67108863);
          ce >>= 26, ce += pe / 67108864 | 0, ce += ve >>> 26, this.words[de] = ve & 67108863;
        }
        return ce !== 0 && (this.words[de] = ce, this.length++), this;
      }, ae.prototype.muln = function(se) {
        return this.clone().imuln(se);
      }, ae.prototype.sqr = function() {
        return this.mul(this);
      }, ae.prototype.isqr = function() {
        return this.imul(this.clone());
      }, ae.prototype.pow = function(se) {
        var ce = $e(se);
        if (ce.length === 0) return new ae(1);
        for (var de = this, pe = 0; pe < ce.length && ce[pe] === 0; pe++, de = de.sqr())
          ;
        if (++pe < ce.length)
          for (var ve = de.sqr(); pe < ce.length; pe++, ve = ve.sqr())
            ce[pe] !== 0 && (de = de.mul(ve));
        return de;
      }, ae.prototype.iushln = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 67108863 >>> 26 - ce << 26 - ce, ve;
        if (ce !== 0) {
          var we = 0;
          for (ve = 0; ve < this.length; ve++) {
            var Ee = this.words[ve] & pe, xe = (this.words[ve] | 0) - Ee << ce;
            this.words[ve] = xe | we, we = Ee >>> 26 - ce;
          }
          we && (this.words[ve] = we, this.length++);
        }
        if (de !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + de] = this.words[ve];
          for (ve = 0; ve < de; ve++)
            this.words[ve] = 0;
          this.length += de;
        }
        return this.strip();
      }, ae.prototype.ishln = function(se) {
        return ie(this.negative === 0), this.iushln(se);
      }, ae.prototype.iushrn = function(se, ce, de) {
        ie(typeof se == "number" && se >= 0);
        var pe;
        ce ? pe = (ce - ce % 26) / 26 : pe = 0;
        var ve = se % 26, we = Math.min((se - ve) / 26, this.length), Ee = 67108863 ^ 67108863 >>> ve << ve, xe = de;
        if (pe -= we, pe = Math.max(0, pe), xe) {
          for (var ue = 0; ue < we; ue++)
            xe.words[ue] = this.words[ue];
          xe.length = we;
        }
        if (we !== 0) if (this.length > we)
          for (this.length -= we, ue = 0; ue < this.length; ue++)
            this.words[ue] = this.words[ue + we];
        else
          this.words[0] = 0, this.length = 1;
        var ge = 0;
        for (ue = this.length - 1; ue >= 0 && (ge !== 0 || ue >= pe); ue--) {
          var Be = this.words[ue] | 0;
          this.words[ue] = ge << 26 - ve | Be >>> ve, ge = Be & Ee;
        }
        return xe && ge !== 0 && (xe.words[xe.length++] = ge), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, ae.prototype.ishrn = function(se, ce, de) {
        return ie(this.negative === 0), this.iushrn(se, ce, de);
      }, ae.prototype.shln = function(se) {
        return this.clone().ishln(se);
      }, ae.prototype.ushln = function(se) {
        return this.clone().iushln(se);
      }, ae.prototype.shrn = function(se) {
        return this.clone().ishrn(se);
      }, ae.prototype.ushrn = function(se) {
        return this.clone().iushrn(se);
      }, ae.prototype.testn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de) return !1;
        var ve = this.words[de];
        return !!(ve & pe);
      }, ae.prototype.imaskn = function(se) {
        ie(typeof se == "number" && se >= 0);
        var ce = se % 26, de = (se - ce) / 26;
        if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= de)
          return this;
        if (ce !== 0 && de++, this.length = Math.min(de, this.length), ce !== 0) {
          var pe = 67108863 ^ 67108863 >>> ce << ce;
          this.words[this.length - 1] &= pe;
        }
        return this.strip();
      }, ae.prototype.maskn = function(se) {
        return this.clone().imaskn(se);
      }, ae.prototype.iaddn = function(se) {
        return ie(typeof se == "number"), ie(se < 67108864), se < 0 ? this.isubn(-se) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < se ? (this.words[0] = se - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(se), this.negative = 1, this) : this._iaddn(se);
      }, ae.prototype._iaddn = function(se) {
        this.words[0] += se;
        for (var ce = 0; ce < this.length && this.words[ce] >= 67108864; ce++)
          this.words[ce] -= 67108864, ce === this.length - 1 ? this.words[ce + 1] = 1 : this.words[ce + 1]++;
        return this.length = Math.max(this.length, ce + 1), this;
      }, ae.prototype.isubn = function(se) {
        if (ie(typeof se == "number"), ie(se < 67108864), se < 0) return this.iaddn(-se);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(se), this.negative = 1, this;
        if (this.words[0] -= se, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ce = 0; ce < this.length && this.words[ce] < 0; ce++)
            this.words[ce] += 67108864, this.words[ce + 1] -= 1;
        return this.strip();
      }, ae.prototype.addn = function(se) {
        return this.clone().iaddn(se);
      }, ae.prototype.subn = function(se) {
        return this.clone().isubn(se);
      }, ae.prototype.iabs = function() {
        return this.negative = 0, this;
      }, ae.prototype.abs = function() {
        return this.clone().iabs();
      }, ae.prototype._ishlnsubmul = function(se, ce, de) {
        var pe = se.length + de, ve;
        this._expand(pe);
        var we, Ee = 0;
        for (ve = 0; ve < se.length; ve++) {
          we = (this.words[ve + de] | 0) + Ee;
          var xe = (se.words[ve] | 0) * ce;
          we -= xe & 67108863, Ee = (we >> 26) - (xe / 67108864 | 0), this.words[ve + de] = we & 67108863;
        }
        for (; ve < this.length - de; ve++)
          we = (this.words[ve + de] | 0) + Ee, Ee = we >> 26, this.words[ve + de] = we & 67108863;
        if (Ee === 0) return this.strip();
        for (ie(Ee === -1), Ee = 0, ve = 0; ve < this.length; ve++)
          we = -(this.words[ve] | 0) + Ee, Ee = we >> 26, this.words[ve] = we & 67108863;
        return this.negative = 1, this.strip();
      }, ae.prototype._wordDiv = function(se, ce) {
        var de = this.length - se.length, pe = this.clone(), ve = se, we = ve.words[ve.length - 1] | 0, Ee = this._countBits(we);
        de = 26 - Ee, de !== 0 && (ve = ve.ushln(de), pe.iushln(de), we = ve.words[ve.length - 1] | 0);
        var xe = pe.length - ve.length, ue;
        if (ce !== "mod") {
          ue = new ae(null), ue.length = xe + 1, ue.words = new Array(ue.length);
          for (var ge = 0; ge < ue.length; ge++)
            ue.words[ge] = 0;
        }
        var Be = pe.clone()._ishlnsubmul(ve, 1, xe);
        Be.negative === 0 && (pe = Be, ue && (ue.words[xe] = 1));
        for (var Ne = xe - 1; Ne >= 0; Ne--) {
          var Fe = (pe.words[ve.length + Ne] | 0) * 67108864 + (pe.words[ve.length + Ne - 1] | 0);
          for (Fe = Math.min(Fe / we | 0, 67108863), pe._ishlnsubmul(ve, Fe, Ne); pe.negative !== 0; )
            Fe--, pe.negative = 0, pe._ishlnsubmul(ve, 1, Ne), pe.isZero() || (pe.negative ^= 1);
          ue && (ue.words[Ne] = Fe);
        }
        return ue && ue.strip(), pe.strip(), ce !== "div" && de !== 0 && pe.iushrn(de), {
          div: ue || null,
          mod: pe
        };
      }, ae.prototype.divmod = function(se, ce, de) {
        if (ie(!se.isZero()), this.isZero())
          return {
            div: new ae(0),
            mod: new ae(0)
          };
        var pe, ve, we;
        return this.negative !== 0 && se.negative === 0 ? (we = this.neg().divmod(se, ce), ce !== "mod" && (pe = we.div.neg()), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.iadd(se)), {
          div: pe,
          mod: ve
        }) : this.negative === 0 && se.negative !== 0 ? (we = this.divmod(se.neg(), ce), ce !== "mod" && (pe = we.div.neg()), {
          div: pe,
          mod: we.mod
        }) : this.negative & se.negative ? (we = this.neg().divmod(se.neg(), ce), ce !== "div" && (ve = we.mod.neg(), de && ve.negative !== 0 && ve.isub(se)), {
          div: we.div,
          mod: ve
        }) : se.length > this.length || this.cmp(se) < 0 ? {
          div: new ae(0),
          mod: this
        } : se.length === 1 ? ce === "div" ? {
          div: this.divn(se.words[0]),
          mod: null
        } : ce === "mod" ? {
          div: null,
          mod: new ae(this.modn(se.words[0]))
        } : {
          div: this.divn(se.words[0]),
          mod: new ae(this.modn(se.words[0]))
        } : this._wordDiv(se, ce);
      }, ae.prototype.div = function(se) {
        return this.divmod(se, "div", !1).div;
      }, ae.prototype.mod = function(se) {
        return this.divmod(se, "mod", !1).mod;
      }, ae.prototype.umod = function(se) {
        return this.divmod(se, "mod", !0).mod;
      }, ae.prototype.divRound = function(se) {
        var ce = this.divmod(se);
        if (ce.mod.isZero()) return ce.div;
        var de = ce.div.negative !== 0 ? ce.mod.isub(se) : ce.mod, pe = se.ushrn(1), ve = se.andln(1), we = de.cmp(pe);
        return we < 0 || ve === 1 && we === 0 ? ce.div : ce.div.negative !== 0 ? ce.div.isubn(1) : ce.div.iaddn(1);
      }, ae.prototype.modn = function(se) {
        ie(se <= 67108863);
        for (var ce = (1 << 26) % se, de = 0, pe = this.length - 1; pe >= 0; pe--)
          de = (ce * de + (this.words[pe] | 0)) % se;
        return de;
      }, ae.prototype.idivn = function(se) {
        ie(se <= 67108863);
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = (this.words[de] | 0) + ce * 67108864;
          this.words[de] = pe / se | 0, ce = pe % se;
        }
        return this.strip();
      }, ae.prototype.divn = function(se) {
        return this.clone().idivn(se);
      }, ae.prototype.egcd = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = new ae(0), Ee = new ae(1), xe = 0; ce.isEven() && de.isEven(); )
          ce.iushrn(1), de.iushrn(1), ++xe;
        for (var ue = de.clone(), ge = ce.clone(); !ce.isZero(); ) {
          for (var Be = 0, Ne = 1; !(ce.words[0] & Ne) && Be < 26; ++Be, Ne <<= 1) ;
          if (Be > 0)
            for (ce.iushrn(Be); Be-- > 0; )
              (pe.isOdd() || ve.isOdd()) && (pe.iadd(ue), ve.isub(ge)), pe.iushrn(1), ve.iushrn(1);
          for (var Fe = 0, Pe = 1; !(de.words[0] & Pe) && Fe < 26; ++Fe, Pe <<= 1) ;
          if (Fe > 0)
            for (de.iushrn(Fe); Fe-- > 0; )
              (we.isOdd() || Ee.isOdd()) && (we.iadd(ue), Ee.isub(ge)), we.iushrn(1), Ee.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(we), ve.isub(Ee)) : (de.isub(ce), we.isub(pe), Ee.isub(ve));
        }
        return {
          a: we,
          b: Ee,
          gcd: de.iushln(xe)
        };
      }, ae.prototype._invmp = function(se) {
        ie(se.negative === 0), ie(!se.isZero());
        var ce = this, de = se.clone();
        ce.negative !== 0 ? ce = ce.umod(se) : ce = ce.clone();
        for (var pe = new ae(1), ve = new ae(0), we = de.clone(); ce.cmpn(1) > 0 && de.cmpn(1) > 0; ) {
          for (var Ee = 0, xe = 1; !(ce.words[0] & xe) && Ee < 26; ++Ee, xe <<= 1) ;
          if (Ee > 0)
            for (ce.iushrn(Ee); Ee-- > 0; )
              pe.isOdd() && pe.iadd(we), pe.iushrn(1);
          for (var ue = 0, ge = 1; !(de.words[0] & ge) && ue < 26; ++ue, ge <<= 1) ;
          if (ue > 0)
            for (de.iushrn(ue); ue-- > 0; )
              ve.isOdd() && ve.iadd(we), ve.iushrn(1);
          ce.cmp(de) >= 0 ? (ce.isub(de), pe.isub(ve)) : (de.isub(ce), ve.isub(pe));
        }
        var Be;
        return ce.cmpn(1) === 0 ? Be = pe : Be = ve, Be.cmpn(0) < 0 && Be.iadd(se), Be;
      }, ae.prototype.gcd = function(se) {
        if (this.isZero()) return se.abs();
        if (se.isZero()) return this.abs();
        var ce = this.clone(), de = se.clone();
        ce.negative = 0, de.negative = 0;
        for (var pe = 0; ce.isEven() && de.isEven(); pe++)
          ce.iushrn(1), de.iushrn(1);
        do {
          for (; ce.isEven(); )
            ce.iushrn(1);
          for (; de.isEven(); )
            de.iushrn(1);
          var ve = ce.cmp(de);
          if (ve < 0) {
            var we = ce;
            ce = de, de = we;
          } else if (ve === 0 || de.cmpn(1) === 0)
            break;
          ce.isub(de);
        } while (!0);
        return de.iushln(pe);
      }, ae.prototype.invm = function(se) {
        return this.egcd(se).a.umod(se);
      }, ae.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, ae.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, ae.prototype.andln = function(se) {
        return this.words[0] & se;
      }, ae.prototype.bincn = function(se) {
        ie(typeof se == "number");
        var ce = se % 26, de = (se - ce) / 26, pe = 1 << ce;
        if (this.length <= de)
          return this._expand(de + 1), this.words[de] |= pe, this;
        for (var ve = pe, we = de; ve !== 0 && we < this.length; we++) {
          var Ee = this.words[we] | 0;
          Ee += ve, ve = Ee >>> 26, Ee &= 67108863, this.words[we] = Ee;
        }
        return ve !== 0 && (this.words[we] = ve, this.length++), this;
      }, ae.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, ae.prototype.cmpn = function(se) {
        var ce = se < 0;
        if (this.negative !== 0 && !ce) return -1;
        if (this.negative === 0 && ce) return 1;
        this.strip();
        var de;
        if (this.length > 1)
          de = 1;
        else {
          ce && (se = -se), ie(se <= 67108863, "Number is too big");
          var pe = this.words[0] | 0;
          de = pe === se ? 0 : pe < se ? -1 : 1;
        }
        return this.negative !== 0 ? -de | 0 : de;
      }, ae.prototype.cmp = function(se) {
        if (this.negative !== 0 && se.negative === 0) return -1;
        if (this.negative === 0 && se.negative !== 0) return 1;
        var ce = this.ucmp(se);
        return this.negative !== 0 ? -ce | 0 : ce;
      }, ae.prototype.ucmp = function(se) {
        if (this.length > se.length) return 1;
        if (this.length < se.length) return -1;
        for (var ce = 0, de = this.length - 1; de >= 0; de--) {
          var pe = this.words[de] | 0, ve = se.words[de] | 0;
          if (pe !== ve) {
            pe < ve ? ce = -1 : pe > ve && (ce = 1);
            break;
          }
        }
        return ce;
      }, ae.prototype.gtn = function(se) {
        return this.cmpn(se) === 1;
      }, ae.prototype.gt = function(se) {
        return this.cmp(se) === 1;
      }, ae.prototype.gten = function(se) {
        return this.cmpn(se) >= 0;
      }, ae.prototype.gte = function(se) {
        return this.cmp(se) >= 0;
      }, ae.prototype.ltn = function(se) {
        return this.cmpn(se) === -1;
      }, ae.prototype.lt = function(se) {
        return this.cmp(se) === -1;
      }, ae.prototype.lten = function(se) {
        return this.cmpn(se) <= 0;
      }, ae.prototype.lte = function(se) {
        return this.cmp(se) <= 0;
      }, ae.prototype.eqn = function(se) {
        return this.cmpn(se) === 0;
      }, ae.prototype.eq = function(se) {
        return this.cmp(se) === 0;
      }, ae.red = function(se) {
        return new je(se);
      }, ae.prototype.toRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), se.convertTo(this)._forceRed(se);
      }, ae.prototype.fromRed = function() {
        return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, ae.prototype._forceRed = function(se) {
        return this.red = se, this;
      }, ae.prototype.forceRed = function(se) {
        return ie(!this.red, "Already a number in reduction context"), this._forceRed(se);
      }, ae.prototype.redAdd = function(se) {
        return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, se);
      }, ae.prototype.redIAdd = function(se) {
        return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, se);
      }, ae.prototype.redSub = function(se) {
        return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, se);
      }, ae.prototype.redISub = function(se) {
        return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, se);
      }, ae.prototype.redShl = function(se) {
        return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, se);
      }, ae.prototype.redMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.mul(this, se);
      }, ae.prototype.redIMul = function(se) {
        return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, se), this.red.imul(this, se);
      }, ae.prototype.redSqr = function() {
        return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, ae.prototype.redISqr = function() {
        return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, ae.prototype.redSqrt = function() {
        return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, ae.prototype.redInvm = function() {
        return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, ae.prototype.redNeg = function() {
        return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, ae.prototype.redPow = function(se) {
        return ie(this.red && !se.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, se);
      };
      var qe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Ue(_e, se) {
        this.name = _e, this.p = new ae(se, 16), this.n = this.p.bitLength(), this.k = new ae(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Ue.prototype._tmp = function() {
        var se = new ae(null);
        return se.words = new Array(Math.ceil(this.n / 13)), se;
      }, Ue.prototype.ireduce = function(se) {
        var ce = se, de;
        do
          this.split(ce, this.tmp), ce = this.imulK(ce), ce = ce.iadd(this.tmp), de = ce.bitLength();
        while (de > this.n);
        var pe = de < this.n ? -1 : ce.ucmp(this.p);
        return pe === 0 ? (ce.words[0] = 0, ce.length = 1) : pe > 0 ? ce.isub(this.p) : ce.strip !== void 0 ? ce.strip() : ce._strip(), ce;
      }, Ue.prototype.split = function(se, ce) {
        se.iushrn(this.n, 0, ce);
      }, Ue.prototype.imulK = function(se) {
        return se.imul(this.k);
      };
      function ze() {
        Ue.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      fe(ze, Ue), ze.prototype.split = function(se, ce) {
        for (var de = 4194303, pe = Math.min(se.length, 9), ve = 0; ve < pe; ve++)
          ce.words[ve] = se.words[ve];
        if (ce.length = pe, se.length <= 9) {
          se.words[0] = 0, se.length = 1;
          return;
        }
        var we = se.words[9];
        for (ce.words[ce.length++] = we & de, ve = 10; ve < se.length; ve++) {
          var Ee = se.words[ve] | 0;
          se.words[ve - 10] = (Ee & de) << 4 | we >>> 22, we = Ee;
        }
        we >>>= 22, se.words[ve - 10] = we, we === 0 && se.length > 10 ? se.length -= 10 : se.length -= 9;
      }, ze.prototype.imulK = function(se) {
        se.words[se.length] = 0, se.words[se.length + 1] = 0, se.length += 2;
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = se.words[de] | 0;
          ce += pe * 977, se.words[de] = ce & 67108863, ce = pe * 64 + (ce / 67108864 | 0);
        }
        return se.words[se.length - 1] === 0 && (se.length--, se.words[se.length - 1] === 0 && se.length--), se;
      };
      function Ve() {
        Ue.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      fe(Ve, Ue);
      function Mt() {
        Ue.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      fe(Mt, Ue);
      function Rt() {
        Ue.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      fe(Rt, Ue), Rt.prototype.imulK = function(se) {
        for (var ce = 0, de = 0; de < se.length; de++) {
          var pe = (se.words[de] | 0) * 19 + ce, ve = pe & 67108863;
          pe >>>= 26, se.words[de] = ve, ce = pe;
        }
        return ce !== 0 && (se.words[se.length++] = ce), se;
      }, ae._prime = function(se) {
        if (qe[se]) return qe[se];
        var ce;
        if (se === "k256")
          ce = new ze();
        else if (se === "p224")
          ce = new Ve();
        else if (se === "p192")
          ce = new Mt();
        else if (se === "p25519")
          ce = new Rt();
        else
          throw new Error("Unknown prime " + se);
        return qe[se] = ce, ce;
      };
      function je(_e) {
        if (typeof _e == "string") {
          var se = ae._prime(_e);
          this.m = se.p, this.prime = se;
        } else
          ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
      }
      je.prototype._verify1 = function(se) {
        ie(se.negative === 0, "red works only with positives"), ie(se.red, "red works only with red numbers");
      }, je.prototype._verify2 = function(se, ce) {
        ie((se.negative | ce.negative) === 0, "red works only with positives"), ie(
          se.red && se.red === ce.red,
          "red works only with red numbers"
        );
      }, je.prototype.imod = function(se) {
        return this.prime ? this.prime.ireduce(se)._forceRed(this) : se.umod(this.m)._forceRed(this);
      }, je.prototype.neg = function(se) {
        return se.isZero() ? se.clone() : this.m.sub(se)._forceRed(this);
      }, je.prototype.add = function(se, ce) {
        this._verify2(se, ce);
        var de = se.add(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de._forceRed(this);
      }, je.prototype.iadd = function(se, ce) {
        this._verify2(se, ce);
        var de = se.iadd(ce);
        return de.cmp(this.m) >= 0 && de.isub(this.m), de;
      }, je.prototype.sub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.sub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de._forceRed(this);
      }, je.prototype.isub = function(se, ce) {
        this._verify2(se, ce);
        var de = se.isub(ce);
        return de.cmpn(0) < 0 && de.iadd(this.m), de;
      }, je.prototype.shl = function(se, ce) {
        return this._verify1(se), this.imod(se.ushln(ce));
      }, je.prototype.imul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.imul(ce));
      }, je.prototype.mul = function(se, ce) {
        return this._verify2(se, ce), this.imod(se.mul(ce));
      }, je.prototype.isqr = function(se) {
        return this.imul(se, se.clone());
      }, je.prototype.sqr = function(se) {
        return this.mul(se, se);
      }, je.prototype.sqrt = function(se) {
        if (se.isZero()) return se.clone();
        var ce = this.m.andln(3);
        if (ie(ce % 2 === 1), ce === 3) {
          var de = this.m.add(new ae(1)).iushrn(2);
          return this.pow(se, de);
        }
        for (var pe = this.m.subn(1), ve = 0; !pe.isZero() && pe.andln(1) === 0; )
          ve++, pe.iushrn(1);
        ie(!pe.isZero());
        var we = new ae(1).toRed(this), Ee = we.redNeg(), xe = this.m.subn(1).iushrn(1), ue = this.m.bitLength();
        for (ue = new ae(2 * ue * ue).toRed(this); this.pow(ue, xe).cmp(Ee) !== 0; )
          ue.redIAdd(Ee);
        for (var ge = this.pow(ue, pe), Be = this.pow(se, pe.addn(1).iushrn(1)), Ne = this.pow(se, pe), Fe = ve; Ne.cmp(we) !== 0; ) {
          for (var Pe = Ne, Je = 0; Pe.cmp(we) !== 0; Je++)
            Pe = Pe.redSqr();
          ie(Je < Fe);
          var Ke = this.pow(ge, new ae(1).iushln(Fe - Je - 1));
          Be = Be.redMul(Ke), ge = Ke.redSqr(), Ne = Ne.redMul(ge), Fe = Je;
        }
        return Be;
      }, je.prototype.invm = function(se) {
        var ce = se._invmp(this.m);
        return ce.negative !== 0 ? (ce.negative = 0, this.imod(ce).redNeg()) : this.imod(ce);
      }, je.prototype.pow = function(se, ce) {
        if (ce.isZero()) return new ae(1).toRed(this);
        if (ce.cmpn(1) === 0) return se.clone();
        var de = 4, pe = new Array(1 << de);
        pe[0] = new ae(1).toRed(this), pe[1] = se;
        for (var ve = 2; ve < pe.length; ve++)
          pe[ve] = this.mul(pe[ve - 1], se);
        var we = pe[0], Ee = 0, xe = 0, ue = ce.bitLength() % 26;
        for (ue === 0 && (ue = 26), ve = ce.length - 1; ve >= 0; ve--) {
          for (var ge = ce.words[ve], Be = ue - 1; Be >= 0; Be--) {
            var Ne = ge >> Be & 1;
            if (we !== pe[0] && (we = this.sqr(we)), Ne === 0 && Ee === 0) {
              xe = 0;
              continue;
            }
            Ee <<= 1, Ee |= Ne, xe++, !(xe !== de && (ve !== 0 || Be !== 0)) && (we = this.mul(we, pe[Ee]), xe = 0, Ee = 0);
          }
          ue = 26;
        }
        return we;
      }, je.prototype.convertTo = function(se) {
        var ce = se.umod(this.m);
        return ce === se ? ce.clone() : ce;
      }, je.prototype.convertFrom = function(se) {
        var ce = se.clone();
        return ce.red = null, ce;
      }, ae.mont = function(se) {
        return new jt(se);
      };
      function jt(_e) {
        je.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new ae(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      fe(jt, je), jt.prototype.convertTo = function(se) {
        return this.imod(se.ushln(this.shift));
      }, jt.prototype.convertFrom = function(se) {
        var ce = this.imod(se.mul(this.rinv));
        return ce.red = null, ce;
      }, jt.prototype.imul = function(se, ce) {
        if (se.isZero() || ce.isZero())
          return se.words[0] = 0, se.length = 1, se;
        var de = se.imul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.mul = function(se, ce) {
        if (se.isZero() || ce.isZero()) return new ae(0)._forceRed(this);
        var de = se.mul(ce), pe = de.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = de.isub(pe).iushrn(this.shift), we = ve;
        return ve.cmp(this.m) >= 0 ? we = ve.isub(this.m) : ve.cmpn(0) < 0 && (we = ve.iadd(this.m)), we._forceRed(this);
      }, jt.prototype.invm = function(se) {
        var ce = this.imod(se._invmp(this.m).mul(this.r2));
        return ce._forceRed(this);
      };
    })(c, commonjsGlobal);
  }(bn)), bn.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var c = requireBn(), t = safeBufferExports.Buffer;
  function n(ie, fe) {
    return t.from(ie.toRed(c.mont(fe.modulus)).redPow(new c(fe.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = n, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var c = requireParseAsn1(), t = requireBrowser$b(), n = requireBrowser$9(), ie = requireMgf(), fe = requireXor(), ae = requireBn(), le = requireWithPublic(), he = requireBrowserifyRsa(), me = safeBufferExports.Buffer;
  publicEncrypt = function($e, Re, Me) {
    var ke;
    $e.padding ? ke = $e.padding : Me ? ke = 1 : ke = 4;
    var Te = c($e), Ie;
    if (ke === 4)
      Ie = ye(Te, Re);
    else if (ke === 1)
      Ie = be(Te, Re, Me);
    else if (ke === 3) {
      if (Ie = new ae(Re), Ie.cmp(Te.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return Me ? he(Ie, Te) : le(Ie, Te);
  };
  function ye(Se, $e) {
    var Re = Se.modulus.byteLength(), Me = $e.length, ke = n("sha1").update(me.alloc(0)).digest(), Te = ke.length, Ie = 2 * Te;
    if (Me > Re - Ie - 2)
      throw new Error("message too long");
    var qe = me.alloc(Re - Me - Ie - 2), Ue = Re - Te - 1, ze = t(Te), Ve = fe(me.concat([ke, qe, me.alloc(1, 1), $e], Ue), ie(ze, Ue)), Mt = fe(ze, ie(Ve, Te));
    return new ae(me.concat([me.alloc(1), Mt, Ve], Re));
  }
  function be(Se, $e, Re) {
    var Me = $e.length, ke = Se.modulus.byteLength();
    if (Me > ke - 11)
      throw new Error("message too long");
    var Te;
    return Re ? Te = me.alloc(ke - Me - 3, 255) : Te = Ae(ke - Me - 3), new ae(me.concat([me.from([0, Re ? 1 : 2]), Te, me.alloc(1), $e], ke));
  }
  function Ae(Se) {
    for (var $e = me.allocUnsafe(Se), Re = 0, Me = t(Se * 2), ke = 0, Te; Re < Se; )
      ke === Me.length && (Me = t(Se * 2), ke = 0), Te = Me[ke++], Te && ($e[Re++] = Te);
    return $e;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var c = requireParseAsn1(), t = requireMgf(), n = requireXor(), ie = requireBn(), fe = requireBrowserifyRsa(), ae = requireBrowser$9(), le = requireWithPublic(), he = safeBufferExports.Buffer;
  privateDecrypt = function(Se, $e, Re) {
    var Me;
    Se.padding ? Me = Se.padding : Re ? Me = 1 : Me = 4;
    var ke = c(Se), Te = ke.modulus.byteLength();
    if ($e.length > Te || new ie($e).cmp(ke.modulus) >= 0)
      throw new Error("decryption error");
    var Ie;
    Re ? Ie = le(new ie($e), ke) : Ie = fe($e, ke);
    var qe = he.alloc(Te - Ie.length);
    if (Ie = he.concat([qe, Ie], Te), Me === 4)
      return me(ke, Ie);
    if (Me === 1)
      return ye(ke, Ie, Re);
    if (Me === 3)
      return Ie;
    throw new Error("unknown padding");
  };
  function me(Ae, Se) {
    var $e = Ae.modulus.byteLength(), Re = ae("sha1").update(he.alloc(0)).digest(), Me = Re.length;
    if (Se[0] !== 0)
      throw new Error("decryption error");
    var ke = Se.slice(1, Me + 1), Te = Se.slice(Me + 1), Ie = n(ke, t(Te, Me)), qe = n(Te, t(Ie, $e - Me - 1));
    if (be(Re, qe.slice(0, Me)))
      throw new Error("decryption error");
    for (var Ue = Me; qe[Ue] === 0; )
      Ue++;
    if (qe[Ue++] !== 1)
      throw new Error("decryption error");
    return qe.slice(Ue);
  }
  function ye(Ae, Se, $e) {
    for (var Re = Se.slice(0, 2), Me = 2, ke = 0; Se[Me++] !== 0; )
      if (Me >= Se.length) {
        ke++;
        break;
      }
    var Te = Se.slice(2, Me - 1);
    if ((Re.toString("hex") !== "0002" && !$e || Re.toString("hex") !== "0001" && $e) && ke++, Te.length < 8 && ke++, ke)
      throw new Error("decryption error");
    return Se.slice(Me);
  }
  function be(Ae, Se) {
    Ae = he.from(Ae), Se = he.from(Se);
    var $e = 0, Re = Ae.length;
    Ae.length !== Se.length && ($e++, Re = Math.min(Ae.length, Se.length));
    for (var Me = -1; ++Me < Re; )
      $e += Ae[Me] ^ Se[Me];
    return $e;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(c) {
    c.publicEncrypt = requirePublicEncrypt(), c.privateDecrypt = requirePrivateDecrypt(), c.privateEncrypt = function(n, ie) {
      return c.publicEncrypt(n, ie, !0);
    }, c.publicDecrypt = function(n, ie) {
      return c.privateDecrypt(n, ie, !0);
    };
  }(browser$1)), browser$1;
}
var browser = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  function c() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var t = safeBufferExports, n = requireBrowser$b(), ie = t.Buffer, fe = t.kMaxLength, ae = globalThis.crypto || globalThis.msCrypto, le = Math.pow(2, 32) - 1;
  function he(Se, $e) {
    if (typeof Se != "number" || Se !== Se)
      throw new TypeError("offset must be a number");
    if (Se > le || Se < 0)
      throw new TypeError("offset must be a uint32");
    if (Se > fe || Se > $e)
      throw new RangeError("offset out of range");
  }
  function me(Se, $e, Re) {
    if (typeof Se != "number" || Se !== Se)
      throw new TypeError("size must be a number");
    if (Se > le || Se < 0)
      throw new TypeError("size must be a uint32");
    if (Se + $e > Re || Se > fe)
      throw new RangeError("buffer too small");
  }
  ae && ae.getRandomValues || !process$1.browser ? (browser.randomFill = ye, browser.randomFillSync = Ae) : (browser.randomFill = c, browser.randomFillSync = c);
  function ye(Se, $e, Re, Me) {
    if (!ie.isBuffer(Se) && !(Se instanceof globalThis.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof $e == "function")
      Me = $e, $e = 0, Re = Se.length;
    else if (typeof Re == "function")
      Me = Re, Re = Se.length - $e;
    else if (typeof Me != "function")
      throw new TypeError('"cb" argument must be a function');
    return he($e, Se.length), me(Re, $e, Se.length), be(Se, $e, Re, Me);
  }
  function be(Se, $e, Re, Me) {
    if (process$1.browser) {
      var ke = Se.buffer, Te = new Uint8Array(ke, $e, Re);
      if (ae.getRandomValues(Te), Me) {
        process$1.nextTick(function() {
          Me(null, Se);
        });
        return;
      }
      return Se;
    }
    if (Me) {
      n(Re, function(qe, Ue) {
        if (qe)
          return Me(qe);
        Ue.copy(Se, $e), Me(null, Se);
      });
      return;
    }
    var Ie = n(Re);
    return Ie.copy(Se, $e), Se;
  }
  function Ae(Se, $e, Re) {
    if (typeof $e > "u" && ($e = 0), !ie.isBuffer(Se) && !(Se instanceof globalThis.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return he($e, Se.length), Re === void 0 && (Re = Se.length - $e), me(Re, $e, Se.length), be(Se, $e, Re);
  }
  return browser;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var c = requireAlgos(), t = Object.keys(c), n = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(t);
  cryptoBrowserify.getHashes = function() {
    return n;
  };
  var ie = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = ie.pbkdf2, cryptoBrowserify.pbkdf2Sync = ie.pbkdf2Sync;
  var fe = requireBrowser$5();
  cryptoBrowserify.Cipher = fe.Cipher, cryptoBrowserify.createCipher = fe.createCipher, cryptoBrowserify.Cipheriv = fe.Cipheriv, cryptoBrowserify.createCipheriv = fe.createCipheriv, cryptoBrowserify.Decipher = fe.Decipher, cryptoBrowserify.createDecipher = fe.createDecipher, cryptoBrowserify.Decipheriv = fe.Decipheriv, cryptoBrowserify.createDecipheriv = fe.createDecipheriv, cryptoBrowserify.getCiphers = fe.getCiphers, cryptoBrowserify.listCiphers = fe.listCiphers;
  var ae = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = ae.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = ae.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = ae.getDiffieHellman, cryptoBrowserify.createDiffieHellman = ae.createDiffieHellman, cryptoBrowserify.DiffieHellman = ae.DiffieHellman;
  var le = requireBrowser$3();
  cryptoBrowserify.createSign = le.createSign, cryptoBrowserify.Sign = le.Sign, cryptoBrowserify.createVerify = le.createVerify, cryptoBrowserify.Verify = le.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var he = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = he.publicEncrypt, cryptoBrowserify.privateEncrypt = he.privateEncrypt, cryptoBrowserify.publicDecrypt = he.publicDecrypt, cryptoBrowserify.privateDecrypt = he.privateDecrypt;
  var me = requireBrowser();
  return cryptoBrowserify.randomFill = me.randomFill, cryptoBrowserify.randomFillSync = me.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var hasRequiredCore;
function requireCore() {
  return hasRequiredCore || (hasRequiredCore = 1, function(c, t) {
    (function(n, ie) {
      c.exports = ie();
    })(commonjsGlobal, function() {
      var n = n || function(ie, fe) {
        var ae;
        if (typeof window < "u" && window.crypto && (ae = window.crypto), typeof self < "u" && self.crypto && (ae = self.crypto), typeof globalThis < "u" && globalThis.crypto && (ae = globalThis.crypto), !ae && typeof window < "u" && window.msCrypto && (ae = window.msCrypto), !ae && typeof globalThis < "u" && globalThis.crypto && (ae = globalThis.crypto), !ae && typeof commonjsRequire == "function")
          try {
            ae = requireCryptoBrowserify();
          } catch {
          }
        var le = function() {
          if (ae) {
            if (typeof ae.getRandomValues == "function")
              try {
                return ae.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof ae.randomBytes == "function")
              try {
                return ae.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, he = Object.create || /* @__PURE__ */ function() {
          function Ie() {
          }
          return function(qe) {
            var Ue;
            return Ie.prototype = qe, Ue = new Ie(), Ie.prototype = null, Ue;
          };
        }(), me = {}, ye = me.lib = {}, be = ye.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(Ie) {
              var qe = he(this);
              return Ie && qe.mixIn(Ie), (!qe.hasOwnProperty("init") || this.init === qe.init) && (qe.init = function() {
                qe.$super.init.apply(this, arguments);
              }), qe.init.prototype = qe, qe.$super = this, qe;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var Ie = this.extend();
              return Ie.init.apply(Ie, arguments), Ie;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(Ie) {
              for (var qe in Ie)
                Ie.hasOwnProperty(qe) && (this[qe] = Ie[qe]);
              Ie.hasOwnProperty("toString") && (this.toString = Ie.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), Ae = ye.WordArray = be.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(Ie, qe) {
            Ie = this.words = Ie || [], qe != fe ? this.sigBytes = qe : this.sigBytes = Ie.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(Ie) {
            return (Ie || $e).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(Ie) {
            var qe = this.words, Ue = Ie.words, ze = this.sigBytes, Ve = Ie.sigBytes;
            if (this.clamp(), ze % 4)
              for (var Mt = 0; Mt < Ve; Mt++) {
                var Rt = Ue[Mt >>> 2] >>> 24 - Mt % 4 * 8 & 255;
                qe[ze + Mt >>> 2] |= Rt << 24 - (ze + Mt) % 4 * 8;
              }
            else
              for (var je = 0; je < Ve; je += 4)
                qe[ze + je >>> 2] = Ue[je >>> 2];
            return this.sigBytes += Ve, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var Ie = this.words, qe = this.sigBytes;
            Ie[qe >>> 2] &= 4294967295 << 32 - qe % 4 * 8, Ie.length = ie.ceil(qe / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var Ie = be.clone.call(this);
            return Ie.words = this.words.slice(0), Ie;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(Ie) {
            for (var qe = [], Ue = 0; Ue < Ie; Ue += 4)
              qe.push(le());
            return new Ae.init(qe, Ie);
          }
        }), Se = me.enc = {}, $e = Se.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(Ie) {
            for (var qe = Ie.words, Ue = Ie.sigBytes, ze = [], Ve = 0; Ve < Ue; Ve++) {
              var Mt = qe[Ve >>> 2] >>> 24 - Ve % 4 * 8 & 255;
              ze.push((Mt >>> 4).toString(16)), ze.push((Mt & 15).toString(16));
            }
            return ze.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(Ie) {
            for (var qe = Ie.length, Ue = [], ze = 0; ze < qe; ze += 2)
              Ue[ze >>> 3] |= parseInt(Ie.substr(ze, 2), 16) << 24 - ze % 8 * 4;
            return new Ae.init(Ue, qe / 2);
          }
        }, Re = Se.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(Ie) {
            for (var qe = Ie.words, Ue = Ie.sigBytes, ze = [], Ve = 0; Ve < Ue; Ve++) {
              var Mt = qe[Ve >>> 2] >>> 24 - Ve % 4 * 8 & 255;
              ze.push(String.fromCharCode(Mt));
            }
            return ze.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(Ie) {
            for (var qe = Ie.length, Ue = [], ze = 0; ze < qe; ze++)
              Ue[ze >>> 2] |= (Ie.charCodeAt(ze) & 255) << 24 - ze % 4 * 8;
            return new Ae.init(Ue, qe);
          }
        }, Me = Se.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(Ie) {
            try {
              return decodeURIComponent(escape(Re.stringify(Ie)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(Ie) {
            return Re.parse(unescape(encodeURIComponent(Ie)));
          }
        }, ke = ye.BufferedBlockAlgorithm = be.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new Ae.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(Ie) {
            typeof Ie == "string" && (Ie = Me.parse(Ie)), this._data.concat(Ie), this._nDataBytes += Ie.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(Ie) {
            var qe, Ue = this._data, ze = Ue.words, Ve = Ue.sigBytes, Mt = this.blockSize, Rt = Mt * 4, je = Ve / Rt;
            Ie ? je = ie.ceil(je) : je = ie.max((je | 0) - this._minBufferSize, 0);
            var jt = je * Mt, _e = ie.min(jt * 4, Ve);
            if (jt) {
              for (var se = 0; se < jt; se += Mt)
                this._doProcessBlock(ze, se);
              qe = ze.splice(0, jt), Ue.sigBytes -= _e;
            }
            return new Ae.init(qe, _e);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var Ie = be.clone.call(this);
            return Ie._data = this._data.clone(), Ie;
          },
          _minBufferSize: 0
        });
        ye.Hasher = ke.extend({
          /**
           * Configuration options.
           */
          cfg: be.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(Ie) {
            this.cfg = this.cfg.extend(Ie), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            ke.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(Ie) {
            return this._append(Ie), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(Ie) {
            Ie && this._append(Ie);
            var qe = this._doFinalize();
            return qe;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(Ie) {
            return function(qe, Ue) {
              return new Ie.init(Ue).finalize(qe);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(Ie) {
            return function(qe, Ue) {
              return new Te.HMAC.init(Ie, Ue).finalize(qe);
            };
          }
        });
        var Te = me.algo = {};
        return me;
      }(Math);
      return n;
    });
  }(core)), core.exports;
}
(function(c, t) {
  (function(n, ie) {
    c.exports = ie(requireCore());
  })(commonjsGlobal, function(n) {
    return function(ie) {
      var fe = n, ae = fe.lib, le = ae.WordArray, he = ae.Hasher, me = fe.algo, ye = [], be = [];
      (function() {
        function $e(Te) {
          for (var Ie = ie.sqrt(Te), qe = 2; qe <= Ie; qe++)
            if (!(Te % qe))
              return !1;
          return !0;
        }
        function Re(Te) {
          return (Te - (Te | 0)) * 4294967296 | 0;
        }
        for (var Me = 2, ke = 0; ke < 64; )
          $e(Me) && (ke < 8 && (ye[ke] = Re(ie.pow(Me, 1 / 2))), be[ke] = Re(ie.pow(Me, 1 / 3)), ke++), Me++;
      })();
      var Ae = [], Se = me.SHA256 = he.extend({
        _doReset: function() {
          this._hash = new le.init(ye.slice(0));
        },
        _doProcessBlock: function($e, Re) {
          for (var Me = this._hash.words, ke = Me[0], Te = Me[1], Ie = Me[2], qe = Me[3], Ue = Me[4], ze = Me[5], Ve = Me[6], Mt = Me[7], Rt = 0; Rt < 64; Rt++) {
            if (Rt < 16)
              Ae[Rt] = $e[Re + Rt] | 0;
            else {
              var je = Ae[Rt - 15], jt = (je << 25 | je >>> 7) ^ (je << 14 | je >>> 18) ^ je >>> 3, _e = Ae[Rt - 2], se = (_e << 15 | _e >>> 17) ^ (_e << 13 | _e >>> 19) ^ _e >>> 10;
              Ae[Rt] = jt + Ae[Rt - 7] + se + Ae[Rt - 16];
            }
            var ce = Ue & ze ^ ~Ue & Ve, de = ke & Te ^ ke & Ie ^ Te & Ie, pe = (ke << 30 | ke >>> 2) ^ (ke << 19 | ke >>> 13) ^ (ke << 10 | ke >>> 22), ve = (Ue << 26 | Ue >>> 6) ^ (Ue << 21 | Ue >>> 11) ^ (Ue << 7 | Ue >>> 25), we = Mt + ve + ce + be[Rt] + Ae[Rt], Ee = pe + de;
            Mt = Ve, Ve = ze, ze = Ue, Ue = qe + we | 0, qe = Ie, Ie = Te, Te = ke, ke = we + Ee | 0;
          }
          Me[0] = Me[0] + ke | 0, Me[1] = Me[1] + Te | 0, Me[2] = Me[2] + Ie | 0, Me[3] = Me[3] + qe | 0, Me[4] = Me[4] + Ue | 0, Me[5] = Me[5] + ze | 0, Me[6] = Me[6] + Ve | 0, Me[7] = Me[7] + Mt | 0;
        },
        _doFinalize: function() {
          var $e = this._data, Re = $e.words, Me = this._nDataBytes * 8, ke = $e.sigBytes * 8;
          return Re[ke >>> 5] |= 128 << 24 - ke % 32, Re[(ke + 64 >>> 9 << 4) + 14] = ie.floor(Me / 4294967296), Re[(ke + 64 >>> 9 << 4) + 15] = Me, $e.sigBytes = Re.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var $e = he.clone.call(this);
          return $e._hash = this._hash.clone(), $e;
        }
      });
      fe.SHA256 = he._createHelper(Se), fe.HmacSHA256 = he._createHmacHelper(Se);
    }(Math), n.SHA256;
  });
})(sha256$2);
var sha256Exports = sha256$2.exports, sha3 = { exports: {} }, x64Core = { exports: {} }, hasRequiredX64Core;
function requireX64Core() {
  return hasRequiredX64Core || (hasRequiredX64Core = 1, function(c, t) {
    (function(n, ie) {
      c.exports = ie(requireCore());
    })(commonjsGlobal, function(n) {
      return function(ie) {
        var fe = n, ae = fe.lib, le = ae.Base, he = ae.WordArray, me = fe.x64 = {};
        me.Word = le.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(ye, be) {
            this.high = ye, this.low = be;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), me.WordArray = le.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(ye, be) {
            ye = this.words = ye || [], be != ie ? this.sigBytes = be : this.sigBytes = ye.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var ye = this.words, be = ye.length, Ae = [], Se = 0; Se < be; Se++) {
              var $e = ye[Se];
              Ae.push($e.high), Ae.push($e.low);
            }
            return he.create(Ae, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var ye = le.clone.call(this), be = ye.words = this.words.slice(0), Ae = be.length, Se = 0; Se < Ae; Se++)
              be[Se] = be[Se].clone();
            return ye;
          }
        });
      }(), n;
    });
  }(x64Core)), x64Core.exports;
}
(function(c, t) {
  (function(n, ie, fe) {
    c.exports = ie(requireCore(), requireX64Core());
  })(commonjsGlobal, function(n) {
    return function(ie) {
      var fe = n, ae = fe.lib, le = ae.WordArray, he = ae.Hasher, me = fe.x64, ye = me.Word, be = fe.algo, Ae = [], Se = [], $e = [];
      (function() {
        for (var ke = 1, Te = 0, Ie = 0; Ie < 24; Ie++) {
          Ae[ke + 5 * Te] = (Ie + 1) * (Ie + 2) / 2 % 64;
          var qe = Te % 5, Ue = (2 * ke + 3 * Te) % 5;
          ke = qe, Te = Ue;
        }
        for (var ke = 0; ke < 5; ke++)
          for (var Te = 0; Te < 5; Te++)
            Se[ke + 5 * Te] = Te + (2 * ke + 3 * Te) % 5 * 5;
        for (var ze = 1, Ve = 0; Ve < 24; Ve++) {
          for (var Mt = 0, Rt = 0, je = 0; je < 7; je++) {
            if (ze & 1) {
              var jt = (1 << je) - 1;
              jt < 32 ? Rt ^= 1 << jt : Mt ^= 1 << jt - 32;
            }
            ze & 128 ? ze = ze << 1 ^ 113 : ze <<= 1;
          }
          $e[Ve] = ye.create(Mt, Rt);
        }
      })();
      var Re = [];
      (function() {
        for (var ke = 0; ke < 25; ke++)
          Re[ke] = ye.create();
      })();
      var Me = be.SHA3 = he.extend({
        /**
         * Configuration options.
         *
         * @property {number} outputLength
         *   The desired number of bits in the output hash.
         *   Only values permitted are: 224, 256, 384, 512.
         *   Default: 512
         */
        cfg: he.cfg.extend({
          outputLength: 512
        }),
        _doReset: function() {
          for (var ke = this._state = [], Te = 0; Te < 25; Te++)
            ke[Te] = new ye.init();
          this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
        },
        _doProcessBlock: function(ke, Te) {
          for (var Ie = this._state, qe = this.blockSize / 2, Ue = 0; Ue < qe; Ue++) {
            var ze = ke[Te + 2 * Ue], Ve = ke[Te + 2 * Ue + 1];
            ze = (ze << 8 | ze >>> 24) & 16711935 | (ze << 24 | ze >>> 8) & 4278255360, Ve = (Ve << 8 | Ve >>> 24) & 16711935 | (Ve << 24 | Ve >>> 8) & 4278255360;
            var Mt = Ie[Ue];
            Mt.high ^= Ve, Mt.low ^= ze;
          }
          for (var Rt = 0; Rt < 24; Rt++) {
            for (var je = 0; je < 5; je++) {
              for (var jt = 0, _e = 0, se = 0; se < 5; se++) {
                var Mt = Ie[je + 5 * se];
                jt ^= Mt.high, _e ^= Mt.low;
              }
              var ce = Re[je];
              ce.high = jt, ce.low = _e;
            }
            for (var je = 0; je < 5; je++)
              for (var de = Re[(je + 4) % 5], pe = Re[(je + 1) % 5], ve = pe.high, we = pe.low, jt = de.high ^ (ve << 1 | we >>> 31), _e = de.low ^ (we << 1 | ve >>> 31), se = 0; se < 5; se++) {
                var Mt = Ie[je + 5 * se];
                Mt.high ^= jt, Mt.low ^= _e;
              }
            for (var Ee = 1; Ee < 25; Ee++) {
              var jt, _e, Mt = Ie[Ee], xe = Mt.high, ue = Mt.low, ge = Ae[Ee];
              ge < 32 ? (jt = xe << ge | ue >>> 32 - ge, _e = ue << ge | xe >>> 32 - ge) : (jt = ue << ge - 32 | xe >>> 64 - ge, _e = xe << ge - 32 | ue >>> 64 - ge);
              var Be = Re[Se[Ee]];
              Be.high = jt, Be.low = _e;
            }
            var Ne = Re[0], Fe = Ie[0];
            Ne.high = Fe.high, Ne.low = Fe.low;
            for (var je = 0; je < 5; je++)
              for (var se = 0; se < 5; se++) {
                var Ee = je + 5 * se, Mt = Ie[Ee], Pe = Re[Ee], Je = Re[(je + 1) % 5 + 5 * se], Ke = Re[(je + 2) % 5 + 5 * se];
                Mt.high = Pe.high ^ ~Je.high & Ke.high, Mt.low = Pe.low ^ ~Je.low & Ke.low;
              }
            var Mt = Ie[0], Ze = $e[Rt];
            Mt.high ^= Ze.high, Mt.low ^= Ze.low;
          }
        },
        _doFinalize: function() {
          var ke = this._data, Te = ke.words;
          this._nDataBytes * 8;
          var Ie = ke.sigBytes * 8, qe = this.blockSize * 32;
          Te[Ie >>> 5] |= 1 << 24 - Ie % 32, Te[(ie.ceil((Ie + 1) / qe) * qe >>> 5) - 1] |= 128, ke.sigBytes = Te.length * 4, this._process();
          for (var Ue = this._state, ze = this.cfg.outputLength / 8, Ve = ze / 8, Mt = [], Rt = 0; Rt < Ve; Rt++) {
            var je = Ue[Rt], jt = je.high, _e = je.low;
            jt = (jt << 8 | jt >>> 24) & 16711935 | (jt << 24 | jt >>> 8) & 4278255360, _e = (_e << 8 | _e >>> 24) & 16711935 | (_e << 24 | _e >>> 8) & 4278255360, Mt.push(_e), Mt.push(jt);
          }
          return new le.init(Mt, ze);
        },
        clone: function() {
          for (var ke = he.clone.call(this), Te = ke._state = this._state.slice(0), Ie = 0; Ie < 25; Ie++)
            Te[Ie] = Te[Ie].clone();
          return ke;
        }
      });
      fe.SHA3 = he._createHelper(Me), fe.HmacSHA3 = he._createHmacHelper(Me);
    }(Math), n.SHA3;
  });
})(sha3);
var sha3Exports = sha3.exports, encHex = { exports: {} };
(function(c, t) {
  (function(n, ie) {
    c.exports = ie(requireCore());
  })(commonjsGlobal, function(n) {
    return n.enc.Hex;
  });
})(encHex);
var encHexExports = encHex.exports, libTypedarrays = { exports: {} };
(function(c, t) {
  (function(n, ie) {
    c.exports = ie(requireCore());
  })(commonjsGlobal, function(n) {
    return function() {
      if (typeof ArrayBuffer == "function") {
        var ie = n, fe = ie.lib, ae = fe.WordArray, le = ae.init, he = ae.init = function(me) {
          if (me instanceof ArrayBuffer && (me = new Uint8Array(me)), (me instanceof Int8Array || typeof Uint8ClampedArray < "u" && me instanceof Uint8ClampedArray || me instanceof Int16Array || me instanceof Uint16Array || me instanceof Int32Array || me instanceof Uint32Array || me instanceof Float32Array || me instanceof Float64Array) && (me = new Uint8Array(me.buffer, me.byteOffset, me.byteLength)), me instanceof Uint8Array) {
            for (var ye = me.byteLength, be = [], Ae = 0; Ae < ye; Ae++)
              be[Ae >>> 2] |= me[Ae] << 24 - Ae % 4 * 8;
            le.call(this, be, ye);
          } else
            le.apply(this, arguments);
        };
        he.prototype = ae;
      }
    }(), n.lib.WordArray;
  });
})(libTypedarrays);
var libTypedarraysExports = libTypedarrays.exports;
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__importDefault || function(Ue) {
    return Ue && Ue.__esModule ? Ue : { default: Ue };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.getParentDomain = c.labelNameHash = c.splitDomainName = c.fromDecStringToHex = c.fromHexStringToDecimals = c.znsChildhash = c.znsNamehash = c.eip137Childhash = c.eip137Namehash = void 0;
  var n = t(sha256Exports), ie = t(sha3Exports), fe = t(encHexExports), ae = t(libTypedarraysExports), le = t(bnExports$2), he = sha3Exports$1;
  function me(Ue) {
    var ze = $e(Ue, "sha3");
    return Re(ze);
  }
  c.eip137Namehash = me;
  function ye(Ue, ze) {
    return Se(Ue, ze, "sha3");
  }
  c.eip137Childhash = ye;
  function be(Ue) {
    var ze = $e(Ue, "sha256");
    return Re(ze);
  }
  c.znsNamehash = be;
  function Ae(Ue, ze) {
    return Se(Ue, ze, "sha256");
  }
  c.znsChildhash = Ae;
  function Se(Ue, ze, Ve) {
    var Mt = Ve === "sha256" ? n.default : ie.default, Rt = { outputLength: 256 }, je = Ue.replace(/^0x/, ""), jt = fe.default.stringify(Mt(ze, Rt));
    return "0x".concat(fe.default.stringify(Mt(fe.default.parse("".concat(je).concat(jt)), Rt)));
  }
  function $e(Ue, ze) {
    if (!Ue)
      return ae.default.create(Array.from(new Uint8Array(8)));
    var Ve = ze === "sha256" ? n.default : ie.default, Mt = { outputLength: 256 }, Rt = Ue.split("."), je = Rt[0], jt = Rt.slice(1), _e = Ve(je, Mt), se = $e(jt.join("."), ze);
    return Ve(se.concat(_e), Mt);
  }
  function Re(Ue) {
    return "0x".concat(fe.default.stringify(Ue));
  }
  function Me(Ue) {
    if (Ue.startsWith("0x")) {
      var ze = Ue.slice(2, Ue.length), Ve = new le.default(ze, 16);
      return Ve.toString(10);
    }
    return Ue;
  }
  c.fromHexStringToDecimals = Me;
  function ke(Ue) {
    if (!Ue.startsWith("0x")) {
      var ze = new le.default(Ue, 10), Ve = ze.toString(16);
      return "0x".concat(Ve.padStart(64, "0"));
    }
    return Ue;
  }
  c.fromDecStringToHex = ke;
  var Te = function(Ue) {
    var ze = Ue.split("."), Ve = ze[0], Mt = ze[1];
    return ze.length - 1 < 2 ? { label: Ve, tld: Mt } : (Mt = ze[-1], Ve = ze.slice(0, -1).join("."), { label: Ve, tld: Mt });
  };
  c.splitDomainName = Te;
  var Ie = function(Ue) {
    var ze = (0, c.splitDomainName)(Ue), Ve = (0, he.keccak256)(Buffer$7.from(ze.label, "utf8"));
    return "0x".concat(Ve);
  };
  c.labelNameHash = Ie;
  var qe = function(Ue) {
    var ze = Ue.split(".");
    return "".concat(ze[-2], ".").concat(ze[-1]);
  };
  c.getParentDomain = qe;
})(namehash);
var NamingService$1 = {};
Object.defineProperty(NamingService$1, "__esModule", { value: !0 });
NamingService$1.NamingService = void 0;
var NamingService = (
  /** @class */
  /* @__PURE__ */ function() {
    function c() {
    }
    return c;
  }()
);
NamingService$1.NamingService = NamingService;
var configurationError = {};
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var le = function(he, me) {
      return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ye, be) {
        ye.__proto__ = be;
      } || function(ye, be) {
        for (var Ae in be) Object.prototype.hasOwnProperty.call(be, Ae) && (ye[Ae] = be[Ae]);
      }, le(he, me);
    };
    return function(he, me) {
      if (typeof me != "function" && me !== null)
        throw new TypeError("Class extends value " + String(me) + " is not a constructor or null");
      le(he, me);
      function ye() {
        this.constructor = he;
      }
      he.prototype = me === null ? Object.create(me) : (ye.prototype = me.prototype, new ye());
    };
  }(), n;
  Object.defineProperty(c, "__esModule", { value: !0 }), c.ConfigurationError = c.ConfigurationErrorCode = void 0;
  var ie;
  (function(le) {
    le.IncorrectProvider = "IncorrectProvider", le.UnsupportedNetwork = "UnsupportedNetwork", le.UnspecifiedUrl = "UnspecifiedUrl", le.NetworkConfigMissing = "NetworkConfigMissing", le.CustomNetworkConfigMissing = "CustomNetworkConfigMissing", le.InvalidConfigurationField = "InvalidProxyReader", le.DependencyMissing = "DependencyMissing";
  })(ie = c.ConfigurationErrorCode || (c.ConfigurationErrorCode = {}));
  var fe = (n = {}, n[ie.IncorrectProvider] = function() {
    return "Provider doesn't implement sendAsync or send method";
  }, n[ie.UnsupportedNetwork] = function(le) {
    return "Unsupported network in Resolution ".concat(le.method || "", " configuration");
  }, n[ie.UnspecifiedUrl] = function(le) {
    return "Unspecified url in Resolution ".concat(le.method, " configuration");
  }, n[ie.NetworkConfigMissing] = function(le) {
    return "Missing configuration in Resolution ".concat(le.method, ". Please specify ").concat(le.config);
  }, n[ie.CustomNetworkConfigMissing] = function(le) {
    return "Missing configuration in Resolution ".concat(le.method, ". Please specify ").concat(le.config, " when using a custom network");
  }, n[ie.InvalidConfigurationField] = function(le) {
    return "Invalid '".concat(le.field, "' in Resolution ").concat(le.method);
  }, n[ie.DependencyMissing] = function(le) {
    return "Missing dependency for this functionality. Please install ".concat(le.dependency, " @ ").concat(le.version, " via npm or yarn");
  }, n), ae = (
    /** @class */
    function(le) {
      t(he, le);
      function he(me, ye) {
        ye === void 0 && (ye = {});
        var be = this, Ae = fe[me];
        return be = le.call(this, Ae(ye)) || this, be.code = me, be.method = ye.method, be.name = "ConfigurationError", Object.setPrototypeOf(be, he.prototype), be;
      }
      return he;
    }(Error)
  );
  c.ConfigurationError = ae, c.default = ae;
})(configurationError);
const version$2 = "0.2.6", networks$1 = {
  1: {
    contracts: {
      ENSRegistry: {
        address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        deploymentBlock: "0x8f221c"
      },
      BaseRegistrarImplementation: {
        address: "0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85",
        deploymentBlock: "0x8f223a"
      },
      ReverseRegistrar: {
        address: "0xa58E81fe9b61B5c3fE2AFD33CF304c454AbFc7Cb",
        deploymentBlock: "0x10243a6"
      },
      DummyOracle: {
        address: "0x0000000000000000000000000000000000000000",
        deploymentBlock: "0x0"
      },
      StablePriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        deploymentBlock: "0x0"
      },
      NameWrapper: {
        address: "0xD4416b13d2b3a9aBae7AcD5D6C2BbDBE25686401",
        deploymentBlock: "0x10243a8"
      },
      ETHRegistrarController: {
        address: "0x253553366Da8546fC250F225fe3d25d0C782303b",
        deploymentBlock: "0x10243b2"
      },
      PublicResolver: {
        address: "0x231b0Ee14048e9dCcD1d247744d114a4EB5E8E63",
        legacyAddresses: [
          "0x4976fb03C32e5B8cfe2b6cCB31c09Ba78EBaBa41"
        ],
        deploymentBlock: "0x10243b3"
      },
      ProxyAdmin: {
        address: "0xAA16DA78110D9A9742c760a1a064F28654Ab93de",
        deploymentBlock: "0xc2fedc"
      },
      ENSCustody: {
        address: "0x27c9B34eB43523447d3e1bcf26f009D814522687",
        deploymentBlock: "0x010ae8a9",
        implementation: "0x1FF7fC4473E3CDA0428830a1bc96028A0C12244C",
        forwarder: "0x27c9B34eB43523447d3e1bcf26f009D814522687"
      },
      LegacyENSRegistry: {
        address: "0x314159265dD8dbb310642f98f50C066173C1259b",
        deploymentBlock: "0x32c5b9"
      },
      LegacyETHRegistrarController: {
        address: "0x283Af0B28c62C092C9727F1Ee09c02CA627EB7F5",
        deploymentBlock: "0x8f2277"
      },
      DNSRegistrar: {
        address: "0x58774Bb8acD458A640aF0B88238369A167546ef2",
        deploymentBlock: "0xc6faf4"
      },
      DNSSECImpl: {
        address: "0x46c6F79952d3046Bf673a28132ff2a81F306959c",
        deploymentBlock: "0xc6fa9e"
      },
      Root: {
        address: "0xaB528d626EC275E3faD363fF1393A41F581c5897",
        deploymentBlock: "0x8F22BC"
      }
    }
  },
  1337: {
    contracts: {
      ENSRegistry: {
        address: "0x50eBEc0b0EAfc732324C1A28963C1FcB7889DA39",
        deploymentBlock: "0x5e",
        legacyAddresses: []
      },
      BaseRegistrarImplementation: {
        address: "0xc86965b7720a64c86263030f7B2902c752084F46",
        deploymentBlock: "0x5f",
        legacyAddresses: []
      },
      ReverseRegistrar: {
        address: "0xdb787398b6595b4F0a8d6072A8AF69774D967f5F",
        deploymentBlock: "0x60",
        legacyAddresses: []
      },
      NameWrapper: {
        address: "0xd70Ab4F5767a8fa0e1e261A2f51189316a7C0d86",
        deploymentBlock: "0x63",
        legacyAddresses: []
      },
      DummyOracle: {
        address: "0x6D264795bBa755974bBBB84Ea5E66eA893BbF606",
        deploymentBlock: "0x65",
        legacyAddresses: []
      },
      StablePriceOracle: {
        address: "0x25D0359804421aDF8E28c3629f611bfD4F04F4fD",
        deploymentBlock: "0x66",
        legacyAddresses: []
      },
      ETHRegistrarController: {
        address: "0x51A944e573DdcA58500583A997F2E46616A15770",
        deploymentBlock: "0x67",
        legacyAddresses: []
      },
      PublicResolver: {
        address: "0xcA8C131DC1f9f62EE54012b10BCA2DA71B8d42e7",
        deploymentBlock: "0x70",
        legacyAddresses: [
          "0xb9025e16A304BA1604e4b93e0A5d6cc4C699a772"
        ]
      },
      ProxyAdmin: {
        address: "0x4e44E79e0cEc05D9e62e952B2088c02A3C450aeC",
        deploymentBlock: "0x36",
        legacyAddresses: []
      },
      ENSCustody: {
        address: "0x57b1b0EABC6d5004a227A707625BdCD2257Acd63",
        deploymentBlock: "0x87",
        implementation: "0x97e711b69fa03aA2859153FCA5656F213A7b51c3",
        forwarder: "0x57b1b0EABC6d5004a227A707625BdCD2257Acd63",
        legacyAddresses: []
      },
      LegacyENSRegistry: {
        address: "0xDF1eCDd1d075d212f62d77e33f152c2FF8F26D69",
        deploymentBlock: "0x73",
        legacyAddresses: []
      },
      LegacyETHRegistrarController: {
        address: "0x942518378eb0f32aAaB57B9c8176432AcCCdA331",
        deploymentBlock: "0x68",
        legacyAddresses: []
      },
      DNSSECImpl: {
        address: "0x87d45031F0507132474f7b913ba7e1B8A9B222a6",
        deploymentBlock: "0x7a"
      },
      DNSRegistrar: {
        address: "0x15f5427fbbE5e4c3aA2137C176B7558F5B53265D",
        deploymentBlock: "0x81"
      },
      Root: {
        address: "0x99127fc7FB6d6ef5eE2d59b9e0F30c8451A0d9ce",
        deploymentBlock: "0x82"
      },
      LegacyPublicResolver: {
        address: "0x4fbf7B2f171336958BE5D15FF762a5CfF5363568",
        deploymentBlock: "0x3b"
      }
    }
  },
  11155111: {
    contracts: {
      ENSRegistry: {
        address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        deploymentBlock: "0x387fc8"
      },
      BaseRegistrarImplementation: {
        address: "0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85",
        deploymentBlock: "0x387fcb"
      },
      ReverseRegistrar: {
        address: "0xA0a1AbcDAe1a2a4A2EF8e9113Ff0e02DD81DC0C6",
        deploymentBlock: "0x39d263"
      },
      NameWrapper: {
        address: "0x0635513f179D50A207757E05759CbD106d7dFcE8",
        deploymentBlock: "0x39d549"
      },
      DummyOracle: {
        address: "0x10E7e7D64d7dA687f7DcF8443Df58A0415329b15",
        deploymentBlock: "0x39d560"
      },
      StablePriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        deploymentBlock: "0x0"
      },
      ETHRegistrarController: {
        address: "0xFED6a969AaA60E4961FCD3EBF1A2e8913ac65B72",
        deploymentBlock: "0x39d5a4"
      },
      PublicResolver: {
        address: "0x8FADE66B79cC9f707aB26799354482EB93a5B7dD",
        legacyAddresses: [
          "0x0CeEC524b2807841739D3B5E161F5bf1430FFA48"
        ],
        deploymentBlock: "0x39d5ab"
      },
      LegacyENSRegistry: {
        address: "0x94f523b8261B815b87EFfCf4d18E6aBeF18d6e4b",
        deploymentBlock: "0x387fc1"
      },
      LegacyETHRegistrarController: {
        address: "0x7e02892cfc2Bfd53a75275451d73cF620e793fc0",
        deploymentBlock: "0x39d575"
      },
      DNSRegistrar: {
        address: "0x5a07C75Ae469Bf3ee2657B588e8E6ABAC6741b4f",
        deploymentBlock: "0x4c7608"
      },
      DNSSECImpl: {
        address: "0xe62E4b6cE018Ad6e916fcC24545e20a33b9d8653",
        deploymentBlock: "0x3f3236"
      },
      Root: {
        address: "0xDaaF96c344f63131acadD0Ea35170E7892d3dfBA",
        deploymentBlock: "0x387fc9"
      },
      ProxyAdmin: {
        address: "0xCbF16B0E2A06916F0Ca4892F704349d13E11cF66",
        legacyAddresses: [],
        deploymentBlock: "0x5588B8"
      },
      ENSCustody: {
        address: "0xd2Bf816C7b23fF6e7d141ECC4c1e41DcC857aD45",
        deploymentBlock: "0x5588b9",
        implementation: "0x49Ac063337cF2fB26dD421Ab650b893CD54b900F",
        forwarder: "0xd2Bf816C7b23fF6e7d141ECC4c1e41DcC857aD45"
      }
    }
  }
}, require$$17 = {
  version: version$2,
  networks: networks$1
};
var __extends$3 = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var c = function(t, n) {
    return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ie, fe) {
      ie.__proto__ = fe;
    } || function(ie, fe) {
      for (var ae in fe) Object.prototype.hasOwnProperty.call(fe, ae) && (ie[ae] = fe[ae]);
    }, c(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    c(t, n);
    function ie() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (ie.prototype = n.prototype, new ie());
  };
}(), __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$7(t, c, n);
  return __setModuleDefault$7(t, c), t;
}, __awaiter$6 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$6 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Ens$1, "__esModule", { value: !0 });
var contentHash = __importStar$7(src), bip44_constants_1 = __importDefault$5(bip44Constants), address_encoder_1 = require$$2$1, ens_1 = __importDefault$5(ens), resolver_1 = __importDefault$5(resolver), nameWrapper_1 = __importDefault$5(nameWrapper), baseRegistrar_1 = __importDefault$5(baseRegistrar), reverseRegistrar_1 = __importDefault$5(reverseRegistrar), types_1$3 = types$3, resolutionError_1$7 = resolutionError, EthereumContract_1$1 = __importDefault$5(EthereumContract$1), publicTypes_1$5 = publicTypes, utils_1$5 = utils$e, FetchProvider_1$3 = __importDefault$5(FetchProvider$1), namehash_1$6 = namehash, NamingService_1$3 = NamingService$1, configurationError_1$5 = __importStar$7(configurationError), utils_2 = utils$e, ens_config_json_1 = __importDefault$5(require$$17), Networking_1$3 = __importDefault$5(Networking$1), Ens = (
  /** @class */
  function(c) {
    __extends$3(t, c);
    function t(n) {
      var ie = c.call(this) || this;
      ie.name = publicTypes_1$5.NamingServiceName.ENS;
      var fe = { url: "", network: "mainnet" };
      n && (fe = ie.checkNetworkConfig(n)), ie.network = utils_2.EthereumNetworks[fe.network], ie.networkName = fe.network, ie.url = fe.url, ie.provider = fe.provider || FetchProvider_1$3.default.factory(publicTypes_1$5.NamingServiceName.ENS, ie.url), ie.proxyServiceApiKey = fe.proxyServiceApiKey;
      var ae = fe.registryAddress || ens_config_json_1.default.networks[ie.network].contracts.ENSRegistry.address;
      ie.registryContract = new EthereumContract_1$1.default(ens_1.default, ae, ie.provider, ie.proxyServiceApiKey);
      var le = ie.determineNameWrapperAddress(ie.network);
      ie.nameWrapperContract = new EthereumContract_1$1.default(nameWrapper_1.default, le, ie.provider, ie.proxyServiceApiKey);
      var he = ie.determineBaseRegistrarAddress(ie.network);
      return ie.baseRegistrarContract = new EthereumContract_1$1.default(baseRegistrar_1.default, he, ie.provider, ie.proxyServiceApiKey), ie;
    }
    return t.autoNetwork = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator$6(this, function(le) {
          switch (le.label) {
            case 0:
              if ((0, types_1$3.hasProvider)(n))
                ie = n.provider;
              else {
                if (!n.url)
                  throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.UnspecifiedUrl, {
                    method: publicTypes_1$5.NamingServiceName.ENS
                  });
                ie = FetchProvider_1$3.default.factory(publicTypes_1$5.NamingServiceName.ENS, n.url);
              }
              return [4, ie.request({
                method: "net_version"
              })];
            case 1:
              if (fe = le.sent(), ae = utils_1$5.EthereumNetworksInverted[fe], !ae || !types_1$3.EnsSupportedNetwork.guard(ae))
                throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.UnsupportedNetwork, {
                  method: publicTypes_1$5.NamingServiceName.ENS
                });
              return [2, new this({ network: ae, provider: ie })];
          }
        });
      });
    }, t.prototype.serviceName = function() {
      return this.name;
    }, t.prototype.namehash = function(n) {
      if (!this.checkSupportedDomain(n))
        throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedDomain, {
          domain: n
        });
      return (0, namehash_1$6.eip137Namehash)(n);
    }, t.prototype.childhash = function(n, ie) {
      return (0, namehash_1$6.eip137Childhash)(n, ie);
    }, t.prototype.isSupportedDomain = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          return [2, this.checkSupportedDomain(n)];
        });
      });
    }, t.prototype.owner = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$6(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.namehash(n), [4, this.determineIsWrappedDomain(ie)];
            case 1:
              return fe = ae.sent(), fe ? [4, this.callMethod(this.nameWrapperContract, "ownerOf", [
                ie
              ])] : [3, 3];
            case 2:
              return [2, ae.sent()];
            case 3:
              return [4, this.callMethod(this.registryContract, "owner", [ie])];
            case 4:
              return [2, ae.sent()];
          }
        });
      });
    }, t.prototype.resolver = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$6(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.namehash(n), [4, this.callMethod(this.registryContract, "resolver", [ie])];
            case 1:
              if (fe = ae.sent(), (0, utils_1$5.isNullAddress)(fe))
                throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnspecifiedResolver);
              return [2, fe];
          }
        });
      });
    }, t.prototype.record = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        var fe;
        return __generator$6(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.getTextRecord(n, ie)];
            case 1:
              if (fe = ae.sent(), !fe)
                throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.RecordNotFound, {
                  domain: n,
                  recordName: ie,
                  method: this.name,
                  methodName: "record"
                });
              return [2, fe];
          }
        });
      });
    }, t.prototype.records = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(fe) {
          throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "records",
            domain: n,
            method: this.serviceName()
          });
        });
      });
    }, t.prototype.dns = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(fe) {
          throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "dns",
            method: this.serviceName(),
            domain: n
          });
        });
      });
    }, t.prototype.reverse = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(fe) {
          throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverse"
          });
        });
      });
    }, t.prototype.reverseOf = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me, ye, be;
        return __generator$6(this, function(Ae) {
          switch (Ae.label) {
            case 0:
              return ie = n, n.startsWith("0x") && (n = n.substr(2)), fe = this.determineReverseRegistrarAddress(this.network), ae = new EthereumContract_1$1.default(reverseRegistrar_1.default, fe, this.provider, this.proxyServiceApiKey), [4, this.reverseRegistrarCallToNode(ae, n)];
            case 1:
              return le = Ae.sent(), [4, this.callMethod(this.registryContract, "resolver", [le])];
            case 2:
              return he = Ae.sent(), (0, utils_1$5.isNullAddress)(he) ? [2, null] : (me = new EthereumContract_1$1.default((0, resolver_1.default)(he, types_1$3.EthCoinIndex), he, this.provider, this.proxyServiceApiKey), [4, this.resolverCallToName(me, le)]);
            case 3:
              return ye = Ae.sent(), [4, this.resolverCallToAddr(me, ye)];
            case 4:
              return be = Ae.sent(), (be == null ? void 0 : be.toLowerCase()) !== ie.toLowerCase() ? [2, null] : [2, ye];
          }
        });
      });
    }, t.prototype.getTokenUri = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator$6(this, function(le) {
          switch (le.label) {
            case 0:
              return ie = this.namehash(n), [4, this.determineIsWrappedDomain(ie)];
            case 1:
              return fe = le.sent(), fe ? [2, "https://metadata.ens.domains/".concat(this.networkName, "/").concat(this.nameWrapperContract.address, "/").concat(ie)] : (ae = (0, namehash_1$6.labelNameHash)(n), [2, "https://metadata.ens.domains/".concat(this.networkName, "/").concat(this.baseRegistrarContract.address, "/").concat(ae)]);
          }
        });
      });
    }, t.prototype.isAvailable = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.isRegistered(n)];
            case 1:
              return [2, !ie.sent()];
          }
        });
      });
    }, t.prototype.registryAddress = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          return [2, this.registryContract.address];
        });
      });
    }, t.prototype.isRegistered = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie;
        return __generator$6(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.owner(n)];
            case 1:
              return ie = fe.sent(), [2, !(0, utils_1$5.isNullAddress)(ie)];
          }
        });
      });
    }, t.prototype.getDomainFromTokenId = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, le, ae, le;
        return __generator$6(this, function(he) {
          switch (he.label) {
            case 0:
              return ie = "", [4, Networking_1$3.default.fetch("https://metadata.ens.domains/".concat(this.networkName, "/").concat(this.nameWrapperContract.address, "/").concat(n))];
            case 1:
              return fe = he.sent(), fe.status !== 200 ? [3, 3] : [4, fe.json()];
            case 2:
              return le = he.sent(), ie = le.name, [2, ie];
            case 3:
              return [4, Networking_1$3.default.fetch("https://metadata.ens.domains/".concat(this.networkName, "/").concat(this.baseRegistrarContract.address, "/").concat(n))];
            case 4:
              return ae = he.sent(), ae.status !== 200 ? [3, 6] : [4, ae.json()];
            case 5:
              le = he.sent(), ie = le.name, he.label = 6;
            case 6:
              return [2, ie];
          }
        });
      });
    }, t.prototype.locations = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me, ye;
        return __generator$6(this, function(be) {
          switch (be.label) {
            case 0:
              ie = {}, fe = 0, ae = n, be.label = 1;
            case 1:
              return fe < ae.length ? (le = ae[fe], he = ie, me = le, ye = {}, [4, this.getResolverContract(le)]) : [3, 5];
            case 2:
              return ye.resolverAddress = be.sent().address, ye.registryAddress = this.registryContract.address, ye.networkId = this.network, ye.blockchain = publicTypes_1$5.BlockchainType.ETH, [4, this.addr(le, publicTypes_1$5.BlockchainType.ETH)];
            case 3:
              he[me] = (ye.ownerAddress = be.sent() || "", ye.blockchainProviderUrl = this.url, ye), be.label = 4;
            case 4:
              return fe++, [3, 1];
            case 5:
              return [2, ie];
          }
        });
      });
    }, t.prototype.getAddress = function(n, ie, fe) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ae) {
          throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "getAddress",
            domain: n,
            method: this.serviceName()
          });
        });
      });
    }, t.prototype.resolverCallToName = function(n, ie) {
      return this.callMethod(n, "name", [ie]);
    }, t.prototype.reverseRegistrarCallToNode = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.callMethod(n, "node", [ie])];
            case 1:
              return [2, fe.sent()];
          }
        });
      });
    }, t.prototype.resolverCallToAddr = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.callMethod(n, "addr", [
                this.namehash(ie)
              ])];
            case 1:
              return [2, fe.sent()];
          }
        });
      });
    }, t.prototype.twitter = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie;
        return __generator$6(this, function(fe) {
          switch (fe.label) {
            case 0:
              return fe.trys.push([0, 2, , 3]), [4, this.record(n, "com.twitter")];
            case 1:
              return [2, fe.sent()];
            case 2:
              throw ie = fe.sent(), new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.RecordNotFound, {
                domain: n,
                method: this.name,
                methodName: "twitter",
                recordName: ie.recordName
              });
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.allRecords = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedMethod, {
            domain: n,
            methodName: "allRecords"
          });
        });
      });
    }, t.prototype.getCoinType = function(n) {
      var ie = bip44_constants_1.default.findIndex(function(fe) {
        return fe[1] === n.toUpperCase() || fe[2] === n.toUpperCase();
      });
      if (ie < 0 || !address_encoder_1.formatsByCoinType[ie])
        throw new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnsupportedCurrency, {
          currencyTicker: n
        });
      return ie.toString();
    }, t.prototype.addr = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        var fe, ae, le;
        return __generator$6(this, function(he) {
          switch (he.label) {
            case 0:
              return [4, this.resolver(n).catch(function(me) {
                if (me.code !== resolutionError_1$7.ResolutionErrorCode.UnspecifiedResolver)
                  throw me;
              })];
            case 1:
              return fe = he.sent(), fe ? [3, 3] : [4, this.owner(n)];
            case 2:
              throw ae = he.sent(), (0, utils_1$5.isNullAddress)(ae) ? new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnregisteredDomain, {
                domain: n
              }) : new resolutionError_1$7.ResolutionError(resolutionError_1$7.ResolutionErrorCode.UnspecifiedResolver, {
                domain: n
              });
            case 3:
              return le = this.getCoinType(ie.toUpperCase()), [4, this.fetchAddress(fe, n, le)];
            case 4:
              return [2, he.sent()];
          }
        });
      });
    }, t.prototype.fetchAddress = function(n, ie, fe) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ae, le, he, me, ye;
        return __generator$6(this, function(be) {
          switch (be.label) {
            case 0:
              return ae = new EthereumContract_1$1.default((0, resolver_1.default)(n, fe), n, this.provider, this.proxyServiceApiKey), le = this.namehash(ie), fe === types_1$3.EthCoinIndex ? [3, 2] : [4, this.callMethod(ae, "addr", [le, fe])];
            case 1:
              return me = be.sent(), [3, 4];
            case 2:
              return [4, this.callMethod(ae, "addr", [le])];
            case 3:
              me = be.sent(), be.label = 4;
            case 4:
              return he = me, (0, utils_1$5.isNullAddress)(he) ? [2, void 0] : (ye = Buffer$7.from(he.replace("0x", ""), "hex"), [2, address_encoder_1.formatsByCoinType[fe].encoder(ye)]);
          }
        });
      });
    }, t.prototype.getTextRecord = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        var fe, ae, le;
        return __generator$6(this, function(he) {
          switch (he.label) {
            case 0:
              return ie !== "contenthash" ? [3, 2] : [4, this.getContentHash(n)];
            case 1:
              return [2, he.sent()];
            case 2:
              return fe = this.namehash(n), [4, this.getResolverContract(n)];
            case 3:
              return ae = he.sent(), [4, this.callMethod(ae, "text", [fe, ie])];
            case 4:
              return le = he.sent(), [2, le];
          }
        });
      });
    }, t.prototype.getContentHash = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$6(this, function(he) {
          switch (he.label) {
            case 0:
              return ie = this.namehash(n), [4, this.getResolverContract(n)];
            case 1:
              return fe = he.sent(), [4, this.callMethod(fe, "contenthash", [ie])];
            case 2:
              return ae = he.sent(), le = contentHash.getCodec(ae), le !== "ipfs-ns" ? [2, void 0] : [2, contentHash.decode(ae)];
          }
        });
      });
    }, t.prototype.getResolverContract = function(n, ie) {
      return __awaiter$6(this, void 0, void 0, function() {
        var fe;
        return __generator$6(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.resolver(n)];
            case 1:
              return fe = ae.sent(), [2, new EthereumContract_1$1.default((0, resolver_1.default)(fe, ie), fe, this.provider, this.proxyServiceApiKey)];
          }
        });
      });
    }, t.prototype.callMethod = function(n, ie, fe) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ae;
        return __generator$6(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, n.call(ie, fe)];
            case 1:
              return ae = le.sent(), [2, ae[0]];
          }
        });
      });
    }, t.prototype.checkSupportedDomain = function(n) {
      return n === "eth" || /^([^\s\\.]+\.)+(eth)+$/.test(n) || /^([^\s\\.]+\.)(addr\.)(reverse)$/.test(n);
    }, t.prototype.checkNetworkConfig = function(n) {
      if (!(n != null && n.network))
        throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.UnsupportedNetwork, {
          method: this.name
        });
      return types_1$3.EnsSupportedNetwork.guard(n.network) || this.checkCustomNetworkConfig(n), n;
    }, t.prototype.checkCustomNetworkConfig = function(n) {
      if (!this.isValidRegistryAddress(n.registryAddress))
        throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.InvalidConfigurationField, {
          method: this.name,
          field: "registryAddress"
        });
      if (!n.url && !n.provider)
        throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: this.name,
          config: "url or provider"
        });
    }, t.prototype.isValidRegistryAddress = function(n) {
      if (!n)
        throw new configurationError_1$5.default(configurationError_1$5.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: this.name,
          config: "registryAddress"
        });
      var ie = new RegExp("^0x[a-fA-F0-9]{40}$");
      return ie.test(n);
    }, t.prototype.getAddressForWrappedDomain = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$6(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.getOwnerOfFromNameHashContract(n)];
            case 1:
              return ie = ae.sent(), [4, this.owner(n)];
            case 2:
              return fe = ae.sent(), ie ? [2, ie] : fe ? [2, fe] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.determineNameWrapperAddress = function(n) {
      return ens_config_json_1.default.networks[n].contracts.NameWrapper.address;
    }, t.prototype.determineBaseRegistrarAddress = function(n) {
      return ens_config_json_1.default.networks[n].contracts.BaseRegistrarImplementation.address;
    }, t.prototype.determineReverseRegistrarAddress = function(n) {
      return ens_config_json_1.default.networks[n].contracts.ReverseRegistrar.address;
    }, t.prototype.determineIsWrappedDomain = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.callMethod(this.nameWrapperContract, "isWrapped", [
                n
              ])];
            case 1:
              return [2, ie.sent()];
          }
        });
      });
    }, t.prototype.getOwnerOfFromNameHashContract = function(n) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$6(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.callMethod(this.nameWrapperContract, "ownerOf", [
                this.namehash(n)
              ])];
            case 1:
              return [2, ie.sent()];
          }
        });
      });
    }, t;
  }(NamingService_1$3.NamingService)
);
Ens$1.default = Ens;
var Zns$1 = {}, znsUtils = {};
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__importDefault || function(ze) {
    return ze && ze.__esModule ? ze : { default: ze };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.fromBech32Address = c.toBech32Address = c.toChecksumAddress = void 0;
  var n = t(bnExports$2), ie = t(sha256Exports), fe = t(encHexExports), ae = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", le = [996825010, 642813549, 513874426, 1027748829, 705979059], he = "zil", me = "tzil";
  function ye(ze, Ve) {
    return !!ze.replace("0x", "").match("^[0-9a-fA-F]{".concat(Ve, "}$"));
  }
  function be(ze) {
    return ye(ze, 40);
  }
  function Ae(ze, Ve, Mt, Rt) {
    Rt === void 0 && (Rt = !0);
    for (var je = 0, jt = 0, _e = [], se = (1 << Mt) - 1, ce = 0; ce < ze.length; ++ce) {
      var de = ze[ce];
      if (de < 0 || de >> Ve)
        return null;
      for (je = je << Ve | de, jt += Ve; jt >= Mt; )
        jt -= Mt, _e.push(je >> jt & se);
    }
    if (Rt)
      jt > 0 && _e.push(je << Mt - jt & se);
    else if (jt >= Ve || je << Mt - jt & se)
      return null;
    return Buffer$7.from(_e);
  }
  function Se(ze) {
    var Ve = [], Mt;
    for (Mt = 0; Mt < ze.length; ++Mt)
      Ve.push(ze.charCodeAt(Mt) >> 5);
    for (Ve.push(0), Mt = 0; Mt < ze.length; ++Mt)
      Ve.push(ze.charCodeAt(Mt) & 31);
    return Buffer$7.from(Ve);
  }
  function $e(ze) {
    for (var Ve = 1, Mt = 0; Mt < ze.length; ++Mt) {
      var Rt = Ve >> 25;
      Ve = (Ve & 33554431) << 5 ^ ze[Mt];
      for (var je = 0; je < 5; ++je)
        Rt >> je & 1 && (Ve ^= le[je]);
    }
    return Ve;
  }
  function Re(ze, Ve) {
    for (var Mt = Buffer$7.concat([
      Buffer$7.from(Se(ze)),
      Ve,
      Buffer$7.from([0, 0, 0, 0, 0, 0])
    ]), Rt = $e(Mt) ^ 1, je = [], jt = 0; jt < 6; ++jt)
      je.push(Rt >> 5 * (5 - jt) & 31);
    return Buffer$7.from(je);
  }
  function Me(ze, Ve) {
    return $e(Buffer$7.concat([Se(ze), Ve])) === 1;
  }
  function ke(ze, Ve) {
    for (var Mt = Buffer$7.concat([Ve, Re(ze, Ve)]), Rt = ze + "1", je = 0; je < Mt.length; ++je)
      Rt += ae.charAt(Mt[je]);
    return Rt;
  }
  function Te(ze) {
    var Ve, Mt = !1, Rt = !1;
    for (Ve = 0; Ve < ze.length; ++Ve) {
      if (ze.charCodeAt(Ve) < 33 || ze.charCodeAt(Ve) > 126)
        return null;
      ze.charCodeAt(Ve) >= 97 && ze.charCodeAt(Ve) <= 122 && (Mt = !0), ze.charCodeAt(Ve) >= 65 && ze.charCodeAt(Ve) <= 90 && (Rt = !0);
    }
    if (Mt && Rt)
      return null;
    ze = ze.toLowerCase();
    var je = ze.lastIndexOf("1");
    if (je < 1 || je + 7 > ze.length || ze.length > 90)
      return null;
    var jt = ze.substring(0, je), _e = [];
    for (Ve = je + 1; Ve < ze.length; ++Ve) {
      var se = ae.indexOf(ze.charAt(Ve));
      if (se === -1)
        return null;
      _e.push(se);
    }
    return Me(jt, Buffer$7.from(_e)) ? { hrp: jt, data: Buffer$7.from(_e.slice(0, _e.length - 6)) } : null;
  }
  var Ie = function(ze) {
    if (!be(ze))
      throw new Error("".concat(ze, " is not a valid base 16 address"));
    ze = ze.toLowerCase().replace("0x", "");
    for (var Ve = fe.default.stringify((0, ie.default)(fe.default.parse(ze))), Mt = new n.default(Ve, "hex", "be"), Rt = "0x", je = 0; je < ze.length; je++)
      "0123456789".indexOf(ze[je]) !== -1 ? Rt += ze[je] : Rt += Mt.and(new n.default(2).pow(new n.default(255 - 6 * je))).gte(new n.default(1)) ? ze[je].toUpperCase() : ze[je].toLowerCase();
    return Rt;
  };
  c.toChecksumAddress = Ie;
  function qe(ze, Ve) {
    if (Ve === void 0 && (Ve = !1), !be(ze))
      throw new Error("Invalid address format.");
    var Mt = Ae(Buffer$7.from(ze.replace("0x", ""), "hex"), 8, 5);
    if (Mt === null)
      throw new Error("Could not convert byte Buffer to 5-bit Buffer");
    return ke(Ve ? me : he, Mt);
  }
  c.toBech32Address = qe;
  function Ue(ze, Ve) {
    Ve === void 0 && (Ve = !1);
    var Mt = Te(ze);
    if (Mt === null)
      throw new Error("Invalid bech32 address");
    var Rt = Mt.hrp, je = Mt.data, jt = Ve ? me : he;
    if (Rt !== jt)
      throw new Error("Expected hrp to be ".concat(jt, " but got ").concat(Rt));
    var _e = Ae(je, 5, 8, !1);
    if (_e === null)
      throw new Error("Could not convert buffer to bytes");
    return (0, c.toChecksumAddress)(_e.toString("hex"));
  }
  c.fromBech32Address = Ue;
})(znsUtils);
var __extends$2 = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var c = function(t, n) {
    return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ie, fe) {
      ie.__proto__ = fe;
    } || function(ie, fe) {
      for (var ae in fe) Object.prototype.hasOwnProperty.call(fe, ae) && (ie[ae] = fe[ae]);
    }, c(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    c(t, n);
    function ie() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (ie.prototype = n.prototype, new ie());
  };
}(), __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$1 = Object.assign || function(c) {
    for (var t, n = 1, ie = arguments.length; n < ie; n++) {
      t = arguments[n];
      for (var fe in t) Object.prototype.hasOwnProperty.call(t, fe) && (c[fe] = t[fe]);
    }
    return c;
  }, __assign$1.apply(this, arguments);
}, __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$6(t, c, n);
  return __setModuleDefault$6(t, c), t;
}, __awaiter$5 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$5 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Zns$1, "__esModule", { value: !0 });
var znsUtils_1$1 = znsUtils, utils_1$4 = utils$e, types_1$2 = types$3, resolutionError_1$6 = resolutionError, publicTypes_1$4 = publicTypes, FetchProvider_1$2 = __importDefault$4(FetchProvider$1), namehash_1$5 = namehash, NamingService_1$2 = NamingService$1, configurationError_1$4 = __importStar$6(configurationError), Zns = (
  /** @class */
  function(c) {
    __extends$2(t, c);
    function t(n) {
      n === void 0 && (n = {
        url: t.UrlMap[1],
        network: "mainnet"
      });
      var ie = c.call(this) || this;
      return ie.name = publicTypes_1$4.NamingServiceName.ZNS, ie.checkNetworkConfig(n), ie.network = t.NetworkNameMap[n.network], ie.url = n.url || t.UrlMap[ie.network], ie.provider = n.provider || new FetchProvider_1$2.default(ie.name, ie.url), ie.registryAddr = n.registryAddress || t.RegistryMap[ie.network], ie.checkRegistryAddress(ie.registryAddr), ie.registryAddr.startsWith("0x") && (ie.registryAddr = (0, znsUtils_1$1.toBech32Address)(ie.registryAddr)), ie;
    }
    return t.prototype.owner = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$5(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.getRecordsAddresses(n)];
            case 1:
              if (ie = ae.sent(), !ie)
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              if (fe = ie[0], !fe)
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              return [2, fe];
          }
        });
      });
    }, t.prototype.resolver = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$5(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.getRecordsAddresses(n)];
            case 1:
              if (ie = ae.sent(), !ie || !ie[0])
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              if (fe = ie[1], (0, utils_1$4.isNullAddress)(fe))
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnspecifiedResolver, {
                  domain: n
                });
              return [2, fe];
          }
        });
      });
    }, t.prototype.namehash = function(n) {
      if (!this.checkDomain(n))
        throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedDomain, {
          domain: n
        });
      return (0, namehash_1$5.znsNamehash)(n);
    }, t.prototype.childhash = function(n, ie) {
      return (0, namehash_1$5.znsChildhash)(n, ie);
    }, t.prototype.isSupportedDomain = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          return [2, this.checkDomain(n)];
        });
      });
    }, t.prototype.record = function(n, ie) {
      return __awaiter$5(this, void 0, void 0, function() {
        var fe, ae;
        return __generator$5(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, this.records(n, [ie])];
            case 1:
              if (fe = le.sent(), ae = fe[ie], !ae)
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.RecordNotFound, {
                  domain: n,
                  recordName: ie
                });
              return [2, ae];
          }
        });
      });
    }, t.prototype.getAddress = function(n, ie, fe) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ae) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "isSupportedDomain"
          });
        });
      });
    }, t.prototype.records = function(n, ie) {
      return __awaiter$5(this, void 0, void 0, function() {
        var fe;
        return __generator$5(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.allRecords(n)];
            case 1:
              return fe = ae.sent(), [2, (0, utils_1$4.constructRecords)(ie, fe)];
          }
        });
      });
    }, t.prototype.allRecords = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie;
        return __generator$5(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.resolver(n)];
            case 1:
              return ie = fe.sent(), [2, this.getResolverRecords(ie)];
          }
        });
      });
    }, t.prototype.twitter = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            domain: n,
            methodName: "twitter"
          });
        });
      });
    }, t.prototype.reverse = function(n, ie) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(fe) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverse"
          });
        });
      });
    }, t.prototype.reverseOf = function(n, ie) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(fe) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverseOf"
          });
        });
      });
    }, t.prototype.isRegistered = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie;
        return __generator$5(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.getRecordsAddresses(n)];
            case 1:
              return ie = fe.sent(), [2, !!(ie && ie[0])];
          }
        });
      });
    }, t.prototype.getTokenUri = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "getTokenUri"
          });
        });
      });
    }, t.prototype.getDomainFromTokenId = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "getDomainFromTokenId"
          });
        });
      });
    }, t.prototype.isAvailable = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.isRegistered(n)];
            case 1:
              return [2, !ie.sent()];
          }
        });
      });
    }, t.prototype.registryAddress = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        return __generator$5(this, function(ie) {
          return [2, this.registryAddr];
        });
      });
    }, t.prototype.locations = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie, fe = this;
        return __generator$5(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, Promise.all(n.map(function(le) {
                return fe.getRecordsAddresses(le);
              }))];
            case 1:
              return ie = ae.sent(), [2, n.reduce(function(le, he, me) {
                var ye, be = null, Ae = ie[me];
                if (Ae) {
                  var Se = Ae[0], $e = Ae[1];
                  be = {
                    registryAddress: fe.registryAddr,
                    resolverAddress: $e,
                    networkId: fe.network,
                    blockchain: publicTypes_1$4.BlockchainType.ZIL,
                    ownerAddress: Se,
                    blockchainProviderUrl: fe.url
                  };
                }
                return __assign$1(__assign$1({}, le), (ye = {}, ye[he] = be, ye));
              }, {})];
          }
        });
      });
    }, t.prototype.getRecordsAddresses = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$5(this, function(he) {
          switch (he.label) {
            case 0:
              if (!this.isSupportedDomain(n))
                throw new resolutionError_1$6.ResolutionError(resolutionError_1$6.ResolutionErrorCode.UnsupportedDomain, {
                  domain: n
                });
              return [4, this.getContractMapValue(this.registryAddr, "records", this.namehash(n))];
            case 1:
              return ie = he.sent(), ie ? (fe = ie.arguments, ae = fe[0], le = fe[1], [2, [
                ae.startsWith("0x") ? (0, znsUtils_1$1.toBech32Address)(ae) : ae,
                le
              ]]) : [2, void 0];
          }
        });
      });
    }, t.prototype.getResolverRecords = function(n) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ie;
        return __generator$5(this, function(fe) {
          switch (fe.label) {
            case 0:
              return (0, utils_1$4.isNullAddress)(n) ? [2, {}] : (ie = (0, znsUtils_1$1.toChecksumAddress)(n), [4, this.getContractField(ie, "records")]);
            case 1:
              return [2, fe.sent() || {}];
          }
        });
      });
    }, t.prototype.fetchSubState = function(n, ie, fe) {
      return fe === void 0 && (fe = []), __awaiter$5(this, void 0, void 0, function() {
        var ae, le;
        return __generator$5(this, function(he) {
          return ae = [n.replace("0x", ""), ie, fe], le = "GetSmartContractSubState", [2, this.provider.request({ method: le, params: ae })];
        });
      });
    }, t.prototype.getContractField = function(n, ie, fe) {
      return fe === void 0 && (fe = []), __awaiter$5(this, void 0, void 0, function() {
        var ae, le;
        return __generator$5(this, function(he) {
          switch (he.label) {
            case 0:
              return ae = n.startsWith("zil1") ? (0, znsUtils_1$1.fromBech32Address)(n) : n, [4, this.fetchSubState(ae, ie, fe)];
            case 1:
              return le = he.sent() || {}, [2, le[ie]];
          }
        });
      });
    }, t.prototype.getContractMapValue = function(n, ie, fe) {
      return __awaiter$5(this, void 0, void 0, function() {
        var ae;
        return __generator$5(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, this.getContractField(n, ie, [fe])];
            case 1:
              return ae = le.sent(), [2, ae && ae[fe] || null];
          }
        });
      });
    }, t.prototype.checkDomain = function(n) {
      var ie = n.split(".");
      return !!ie.length && ie[ie.length - 1] === "zil" && ie.every(function(fe) {
        return !!fe.length;
      });
    }, t.prototype.checkNetworkConfig = function(n) {
      if (!n.network)
        throw new configurationError_1$4.default(configurationError_1$4.ConfigurationErrorCode.UnsupportedNetwork, {
          method: publicTypes_1$4.NamingServiceName.ZNS
        });
      types_1$2.ZnsSupportedNetwork.guard(n.network) || this.checkCustomNetworkConfig(n);
    }, t.prototype.checkRegistryAddress = function(n) {
      var ie = new RegExp("^0x[a-fA-F0-9]{40}$|^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$");
      if (!ie.test(n))
        throw new configurationError_1$4.default(configurationError_1$4.ConfigurationErrorCode.InvalidConfigurationField, {
          method: this.name,
          field: "registryAddress"
        });
    }, t.prototype.checkCustomNetworkConfig = function(n) {
      if (!n.registryAddress)
        throw new configurationError_1$4.default(configurationError_1$4.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: publicTypes_1$4.NamingServiceName.ZNS,
          config: "registryAddress"
        });
      if (!n.url && !n.provider)
        throw new configurationError_1$4.default(configurationError_1$4.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: publicTypes_1$4.NamingServiceName.ZNS,
          config: "url or provider"
        });
    }, t.UrlMap = {
      1: "https://api.zilliqa.com",
      333: "https://dev-api.zilliqa.com",
      111: "http://localhost:4201"
    }, t.NetworkNameMap = {
      mainnet: 1,
      testnet: 333,
      localnet: 111
    }, t.RegistryMap = {
      1: "zil1jcgu2wlx6xejqk9jw3aaankw6lsjzeunx2j0jz",
      333: "zil1hyj6m5w4atcn7s806s69r0uh5g4t84e8gp6nps"
    }, t;
  }(NamingService_1$2.NamingService)
);
Zns$1.default = Zns;
var Uns$1 = {}, TwitterSignatureValidator = {}, recoverSignature = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 }), c.recover = c.hashMessage = void 0;
  var t = sha3Exports$1, n = utils$e, ie = requireElliptic(), fe = new ie.ec("secp256k1"), ae = function(Se) {
    return (Se.length - 2) / 2;
  }, le = function(Se, $e, Re) {
    return "0x" + Re.slice(Se * 2 + 2, $e * 2 + 2);
  }, he = function(Se) {
    return parseInt(Se.slice(2), 16);
  }, me = function(Se) {
    return [
      le(64, ae(Se), Se),
      le(0, 32, Se),
      le(32, 64, Se)
    ];
  }, ye = function(Se) {
    for (var $e = (0, t.keccak256)(Se.slice(2)), Re = "0x", Me = 0; Me < 40; Me++)
      Re += parseInt($e[Me + 2], 16) > 7 ? Se[Me + 2].toUpperCase() : Se[Me + 2];
    return Re;
  }, be = function(Se) {
    var $e = (0, n.hexToBytes)(Buffer$7.from(Se, "utf8").toString("hex")), Re = Buffer$7.from($e), Me = `Ethereum Signed Message:
` + $e.length, ke = Buffer$7.from(Me), Te = Buffer$7.concat([ke, Re]);
    return "0x" + (0, t.keccak256)(Te.toString());
  };
  c.hashMessage = be;
  var Ae = function(Se, $e) {
    var Re = (0, c.hashMessage)(Se), Me = me($e), ke = {
      v: he(Me[0]),
      r: Me[1].slice(2),
      s: Me[2].slice(2)
    }, Te = fe.recoverPubKey(Buffer$7.from(Re.slice(2), "hex"), ke, ke.v < 2 ? ke.v : 1 - ke.v % 2), Ie = "0x" + Te.encode("hex", !1).slice(2), qe = "0x" + (0, t.keccak256)((0, n.hexToBytes)(Ie));
    return ye("0x" + qe.slice(-40));
  };
  c.recover = Ae;
})(recoverSignature);
Object.defineProperty(TwitterSignatureValidator, "__esModule", { value: !0 });
TwitterSignatureValidator.isValidTwitterSignature = void 0;
var index_1 = utils$e, js_sha3_1 = sha3Exports$1, recoverSignature_1 = recoverSignature, namehash_1$4 = namehash, TwitterVerificationAddress = "0x12cfb13522F13a78b650a8bCbFCf50b7CB899d82", isValidTwitterSignature = function(c) {
  var t = c.tokenId, n = c.owner, ie = c.twitterHandle, fe = c.validationSignature, ae = (0, namehash_1$4.fromHexStringToDecimals)(t), le = [
    ae,
    n,
    "social.twitter.username",
    ie
  ].map(function(me) {
    return "0x" + (0, js_sha3_1.keccak256)(me.startsWith("0x") ? (0, index_1.hexToBytes)(me) : me);
  }).reduce(function(me, ye) {
    return me + ye;
  }, ""), he = (0, recoverSignature_1.recover)(le, fe);
  return he === TwitterVerificationAddress;
};
TwitterSignatureValidator.isValidTwitterSignature = isValidTwitterSignature;
var UnsInternal$1 = {}, proxyReader = {};
Object.defineProperty(proxyReader, "__esModule", { value: !0 });
proxyReader.default = [
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "uint8", name: "version", type: "uint8" }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "tokenKey",
        type: "string"
      }
    ],
    name: "SetLegacyRecords",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "string", name: "network", type: "string" }
    ],
    name: "SetNetworkFamily",
    type: "event"
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "networks", type: "string[]" },
      { internalType: "string[]", name: "families", type: "string[]" }
    ],
    name: "addBlockchainNetworks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "networks", type: "string[]" },
      { internalType: "string", name: "family", type: "string" }
    ],
    name: "addBlockchainNetworks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[][]", name: "legacyKeys", type: "string[][]" }
    ],
    name: "addLegacyRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "exists",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "get",
    outputs: [{ internalType: "string", name: "value", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "network", type: "string" },
      { internalType: "string", name: "token", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getAddress",
    outputs: [{ internalType: "string", name: "addr", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "network", type: "string" },
      { internalType: "string", name: "token", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getAddressKey",
    outputs: [{ internalType: "string", name: "key", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "network", type: "string" },
      { internalType: "string", name: "token", type: "string" }
    ],
    name: "getAddressKeys",
    outputs: [{ internalType: "string[]", name: "keys", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "keyHash", type: "uint256" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getByHash",
    outputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getData",
    outputs: [
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getDataByHash",
    outputs: [
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }
    ],
    name: "getDataByHashForMany",
    outputs: [
      { internalType: "address[]", name: "resolvers", type: "address[]" },
      { internalType: "address[]", name: "owners", type: "address[]" },
      { internalType: "string[][]", name: "keys", type: "string[][]" },
      { internalType: "string[][]", name: "values", type: "string[][]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }
    ],
    name: "getDataForMany",
    outputs: [
      { internalType: "address[]", name: "resolvers", type: "address[]" },
      { internalType: "address[]", name: "owners", type: "address[]" },
      { internalType: "string[][]", name: "values", type: "string[][]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getMany",
    outputs: [{ internalType: "string[]", name: "values", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getManyByHash",
    outputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IUNSRegistry",
        name: "unsRegistry",
        type: "address"
      },
      {
        internalType: "contract ICNSRegistry",
        name: "cnsRegistry",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "isApprovedOrOwner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes[]", name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ internalType: "bytes[]", name: "results", type: "bytes[]" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "string[]", name: "labels", type: "string[]" }],
    name: "namehash",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }],
    name: "ownerOfForMany",
    outputs: [{ internalType: "address[]", name: "owners", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "registryOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "resolverOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseNameOf",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const version$1 = "0.9.11", networks = {
  1: {
    contracts: {
      UNSRegistry: {
        address: "0x049aba7510f45BA5b64ea9E658E342F904DB358D",
        implementation: "0xCd451149ffa9d059030528917842bcE14327DfD6",
        legacyAddresses: [],
        deploymentBlock: "0xc2fede",
        forwarder: "0x049aba7510f45BA5b64ea9E658E342F904DB358D"
      },
      CNSRegistry: {
        address: "0xD1E5b0FF1287aA9f9A268759062E4Ab08b9Dacbe",
        legacyAddresses: [],
        deploymentBlock: "0x8a958b",
        forwarder: "0x97B0E89fC1B7eD4A8B237D9d8Fcce9b234f25A37"
      },
      MintingManager: {
        address: "0x2a7084870bB724175a3C96Da8FaA55128fa3E19D",
        implementation: "0xc2729efaBe5746C0875AE8969ce386a02A19fB13",
        legacyAddresses: [],
        deploymentBlock: "0xc2fee0",
        forwarder: "0xb970fbCF52cd8111c76c379D4f2FE12E7f8AE7fb"
      },
      UNSOperator: {
        address: "0x28400c6e89f11a99fD7145a24d39c19f949Ab86e",
        implementation: "0x4f78Db4b434128a45C6236bd61dFf2258637cd7f",
        legacyAddresses: [],
        deploymentBlock: "0xfdd3a7"
      },
      ProxyAdmin: {
        address: "0xAA16DA78110D9A9742c760a1a064F28654Ab93de",
        legacyAddresses: [],
        deploymentBlock: "0xc2fedc"
      },
      SignatureController: {
        address: "0x82EF94294C95aD0930055f31e53A34509227c5f7",
        legacyAddresses: [],
        deploymentBlock: "0x8a95a6"
      },
      MintingController: {
        address: "0xb0EE56339C3253361730F50c08d3d7817ecD60Ca",
        legacyAddresses: [],
        deploymentBlock: "0x8a95aa",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0xd3fF3377b0ceade1303dAF9Db04068ef8a650757",
        legacyAddresses: [],
        deploymentBlock: "0xa76ad3",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x09B091492759737C03da9dB7eDF1CD6BCC3A9d91",
        legacyAddresses: [],
        deploymentBlock: "0x8a95ae",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0xeA70777e28E00E81f58b8921fC47F78B8a72eFE7",
        legacyAddresses: [],
        deploymentBlock: "0x98ca20",
        deprecated: !0
      },
      Resolver: {
        address: "0xb66DcE2DA6afAAa98F2013446dBCB0f4B0ab2842",
        legacyAddresses: [
          "0xa1cac442be6673c49f8e74ffc7c4fd746f3cbd0d",
          "0x878bc2f3f717766ab69c0a5f9a6144931e61aed3"
        ],
        deploymentBlock: "0x960844",
        forwarder: "0x486eb10E4F48C038513ECAf11585Ca2779768CF2"
      },
      ProxyReader: {
        address: "0x578853aa776Eef10CeE6c4dd2B5862bdcE767A8B",
        implementation: "0xF83b08F90C1d5eEf255E8DB50b3Ab158A37a9AD4",
        legacyAddresses: [
          "0x6E68f3EaAD2CC946C6CC7f4859251d8D70Dd3EDB",
          "0x1BDc0fD4fbABeed3E611fd6195fCd5d41dcEF393",
          "0x58034A288D2E56B661c9056A0C27273E5460B63c",
          "0xc3C2BAB5e3e52DBF311b2aAcEf2e40344f19494E",
          "0xfEe4D4F0aDFF8D84c12170306507554bC7045878",
          "0xa6E7cEf2EDDEA66352Fd68E5915b60BDbb7309f5",
          "0x7ea9Ee21077F84339eDa9C80048ec6db678642B1"
        ],
        deploymentBlock: "0xf2f03c"
      },
      TwitterValidationOperator: {
        address: "0x2F659766E3D08561CA3408FbAba7C0749ab2c402",
        legacyAddresses: [
          "0xbb486C6E9cF1faA86a6E3eAAFE2e5665C0507855"
        ],
        deploymentBlock: "0xc300b5"
      },
      FreeMinter: {
        address: "0x1fC985cAc641ED5846b631f96F35d9b48Bc3b834",
        legacyAddresses: [],
        deploymentBlock: "0xacc390",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x932532aA4c0174b8453839A6E44eE09Cc615F2b7",
        legacyAddresses: [],
        deploymentBlock: "0xa3cf69"
      },
      RootChainManager: {
        address: "0xA0c68C638235ee32657e8f720a23ceC1bFc77C77",
        legacyAddresses: [],
        deploymentBlock: "0xa3cf4d"
      },
      DotCoinBurner: {
        address: "0x65c6abdf52aD08A53A77488D1Acc5c666ada840F",
        legacyAddresses: [],
        deploymentBlock: "0xf335e0"
      },
      ZilliqaRecover: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0"
      },
      SeaportProxyBuyer: {
        address: "0x0000000000000000000000000000000000000000",
        deploymentBlock: "0x0",
        implementation: "0x0000000000000000000000000000000000000000",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      USDC: {
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        deploymentBlock: "0x0"
      },
      L1GasPriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  137: {
    contracts: {
      UNSRegistry: {
        address: "0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f",
        implementation: "0x11227E54F19934164A81d5aDd1ce5825D46B2271",
        legacyAddresses: [],
        deploymentBlock: "0x01272eb5",
        forwarder: "0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f"
      },
      CNSRegistry: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      MintingManager: {
        address: "0x7be83293BeeDc9Eba1bd76c66A65F10F3efaeC26",
        implementation: "0x8Efbe119357753c5d12f078AC081E37a5AFACf33",
        legacyAddresses: [],
        deploymentBlock: "0x01272f41",
        forwarder: "0xC37d3c4326ab0E1D2b9D8b916bBdf5715f780fcF"
      },
      UNSOperator: {
        address: "0x8f0c61C9BD21d3a5c078FB03eCA01AE2Ff5380dB",
        implementation: "0xbB101ae4B5Df5F9375112D38D9f5a3394916EA97",
        legacyAddresses: [],
        deploymentBlock: "0x025809c0"
      },
      ProxyAdmin: {
        address: "0xe1D668052D52388F52b90f4d1798DB2b04bC3b88",
        legacyAddresses: [],
        deploymentBlock: "0x01272d15"
      },
      SignatureController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      MintingController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      Resolver: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      ProxyReader: {
        address: "0x91EDd8708062bd4233f4Dd0FCE15A7cb4d500091",
        implementation: "0x989730eAe394d0415eaB088e0C1d83aCD40A66A1",
        legacyAddresses: [
          "0x68Af8fFFCdC6218836C62Bc2Fd2D35dA544471dD",
          "0x3E67b8c702a1292d1CEb025494C84367fcb12b45",
          "0x423F2531bd5d3C3D4EF7C318c2D1d9BEDE67c680",
          "0xA3f32c8cd786dc089Bd1fC175F2707223aeE5d00"
        ],
        deploymentBlock: "0x021b1c05"
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      RootChainManager: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      DotCoinBurner: {
        address: "0x65c6abdf52aD08A53A77488D1Acc5c666ada840F",
        legacyAddresses: [],
        deploymentBlock: "0x021cac00"
      },
      ZilliqaRecover: {
        address: "0x07B58C81f160257BCb3a2d549ea02D36E3e70461",
        legacyAddresses: [],
        deploymentBlock: "0x032b35a6",
        implementation: "0x50752EcBedBb07543C4191E2492e2e888a7D04bD",
        forwarder: "0x07B58C81f160257BCb3a2d549ea02D36E3e70461"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0"
      },
      SeaportProxyBuyer: {
        address: "0x8b031F472F7f90ac1fAE1616Ddf1283CDDe084bF",
        deploymentBlock: "0x037b22db",
        implementation: "0x53B01e32807127D3c2Fb6eA1A3b268753183Ed68",
        forwarder: "0x8b031F472F7f90ac1fAE1616Ddf1283CDDe084bF"
      },
      USDC: {
        address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
        deploymentBlock: "0x0"
      },
      L1GasPriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  1337: {
    contracts: {
      UNSRegistry: {
        address: "0x107733feD96C4Cd390c944a31F5425A7FB98Ae5e",
        implementation: "0x62b11ad5F582a5C5d378fB310125b030042554F1",
        legacyAddresses: [],
        deploymentBlock: "0x15",
        forwarder: "0x107733feD96C4Cd390c944a31F5425A7FB98Ae5e"
      },
      CNSRegistry: {
        address: "0xC58206842E4030a3B2CaBC78780Ae7635173C533",
        legacyAddresses: [],
        deploymentBlock: "0x01",
        forwarder: "0xAc52F68f31577E44aE0C7E95A42dC9eb574B9383"
      },
      MintingManager: {
        address: "0x39a27956B78d00a4E00EA8833Ff0947410A2933F",
        implementation: "0x229C56b7805aB5935a883207F6a6bD5847E65Aee",
        legacyAddresses: [],
        deploymentBlock: "0x17",
        forwarder: "0x7c3c91245769c8B7450aD522792deC4bd4bf797f"
      },
      UNSOperator: {
        address: "0xCE4bb7Dc1Eb9DCe75743dE6a4B48534fD427Ef51",
        legacyAddresses: [],
        deploymentBlock: "0x19",
        implementation: "0xe85541865Bbb62A05064ce5C9F41cC293A8eA996"
      },
      ProxyAdmin: {
        address: "0x4e44E79e0cEc05D9e62e952B2088c02A3C450aeC",
        legacyAddresses: [],
        deploymentBlock: "0x01"
      },
      SignatureController: {
        address: "0x7bB6Cd9be29fab783c0b494A06FED8b2E2596B7a",
        legacyAddresses: [],
        deploymentBlock: "0x02"
      },
      MintingController: {
        address: "0x4a3C194eB88966178bfDD81744ddDafED611B830",
        legacyAddresses: [],
        deploymentBlock: "0x03",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x4872CC1be60A9DB9c880A0A437Da7a6AF134F08f",
        legacyAddresses: [],
        deploymentBlock: "0x04",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      Resolver: {
        address: "0xF8C26340C1eAeA6c7fF1760B25005e1306953572",
        legacyAddresses: [],
        deploymentBlock: "0x08",
        forwarder: "0x11dD97b7Ca847DfB6504e61B7B9Eb30F55E554a0"
      },
      ProxyReader: {
        address: "0xcd12F3f3faae97679a844aA184c0589ea8176656",
        implementation: "0x0930ffb2c192B0C9A9dd2372Cf7f2845ef39CBb6",
        legacyAddresses: [],
        deploymentBlock: "0x23"
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x58a175BEbc8ec21A94ea63Aa5a28743945940EE6",
        legacyAddresses: [],
        deploymentBlock: "0x0d"
      },
      RootChainManager: {
        address: "0x27935e7e85db3c4e7885eB828B9e889BA69a4e7f",
        legacyAddresses: [],
        deploymentBlock: "0x0f"
      },
      DotCoinBurner: {
        address: "0x951c830a0471C04DCB60Ce244DEe38eE4b0609ec",
        legacyAddresses: [],
        deploymentBlock: "0x5c"
      },
      ZilliqaRecover: {
        address: "0xDD622cF8306F18d736705e4Cc03f7FF83A899FD0",
        deploymentBlock: "0x2e",
        implementation: "0xf6b7c221342BC966f4396790895530bF4E9799eB",
        legacyAddresses: [],
        forwarder: "0xDD622cF8306F18d736705e4Cc03f7FF83A899FD0"
      },
      Seaport: {
        address: "0x5CC819C9915eADfcEBd76952B8C1BC36CADd7376",
        deploymentBlock: "0x1f"
      },
      SeaportProxyBuyer: {
        address: "0x7e76aE49D6F4c6158757693b050BF88f039DeA21",
        deploymentBlock: "0x29",
        implementation: "0x24F45688D421f46cca60734BdC648ad192dB0f2E",
        forwarder: "0x7e76aE49D6F4c6158757693b050BF88f039DeA21"
      },
      USDC: {
        address: "0xbE92182CAB5b84Fd18b34881A0c32771e84f5b8B",
        deploymentBlock: "0x21",
        implementation: "0xDa9E1b3e395bFb0A45F03C7F615146B9d896c959",
        forwarder: "0xbE92182CAB5b84Fd18b34881A0c32771e84f5b8B"
      },
      L1GasPriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  8453: {
    contracts: {
      CNSRegistry: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      SignatureController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      MintingController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      Resolver: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      RootChainManager: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0",
        legacyAddresses: []
      },
      DotCoinBurner: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      ZilliqaRecover: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      USDC: {
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        deploymentBlock: "0x0",
        legacyAddresses: []
      },
      ProxyAdmin: {
        address: "0x03EBd257caDe479638c9f1Dc69d1ECbbF98e301C",
        deploymentBlock: "0x1215A51",
        legacyAddresses: []
      },
      UNSRegistry: {
        address: "0xF6c1b83977DE3dEffC476f5048A0a84d3375d498",
        deploymentBlock: "0x01215a53",
        implementation: "0xE0F063F1e63E8Ac83118B08b03603d7826C718bb",
        forwarder: "0xF6c1b83977DE3dEffC476f5048A0a84d3375d498",
        legacyAddresses: []
      },
      MintingManager: {
        address: "0xe56D6aa367B7a16385Ea867F556339bbC361F983",
        deploymentBlock: "0x01215a5c",
        implementation: "0xd30b3cB992777134E2a338BcF422a311339E75b1",
        forwarder: "0xd57f8F7be4BaE8f2bf24792Fec2Ca06513c83c1D",
        legacyAddresses: []
      },
      UNSOperator: {
        address: "0x1E2A1f502fbe0018ED1a019D9c874e21d0a66Cb3",
        deploymentBlock: "0x01215a62",
        implementation: "0x9fd7AF306e76DCf7CF41D5c9bFbc55BA33C962B1",
        legacyAddresses: []
      },
      ProxyReader: {
        address: "0x78c4b414e1abdf0de267deda01dffd4cd0817a16",
        deploymentBlock: "0x1219245",
        implementation: "0x6B5F9068Aa94eFf728585665244cb5AB8735E71A",
        legacyAddresses: []
      },
      SeaportProxyBuyer: {
        address: "0x19d40e8b3338669BfC40747F5D5bDb8a14422Fdb",
        deploymentBlock: "0x01215b4f",
        implementation: "0x99d55A02f5d9c76d31C6Ff57cc36A7862D5E1029",
        forwarder: "0x19d40e8b3338669BfC40747F5D5bDb8a14422Fdb",
        legacyAddresses: []
      },
      L1GasPriceOracle: {
        address: "0x420000000000000000000000000000000000000F",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  80002: {
    contracts: {
      CNSRegistry: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      SignatureController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      MintingController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      Resolver: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      RootChainManager: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      ProxyAdmin: {
        address: "0xCbF16B0E2A06916F0Ca4892F704349d13E11cF66",
        legacyAddresses: [],
        deploymentBlock: "0x53f24d"
      },
      UNSOperator: {
        address: "0x89D35aABc8427a32ee7032e73975271e1480fd4E",
        legacyAddresses: [],
        deploymentBlock: "0x53f775",
        implementation: "0x49Ac063337cF2fB26dD421Ab650b893CD54b900F"
      },
      UNSRegistry: {
        address: "0xAb005176D74900A9c25fDA144e2f9f329A409166",
        legacyAddresses: [],
        deploymentBlock: "0x53f76a",
        implementation: "0x223350B4892300EA6E8adEF48C955dcf1C544D02",
        forwarder: "0xAb005176D74900A9c25fDA144e2f9f329A409166"
      },
      MintingManager: {
        address: "0xabec3fF0F0b6375F65CB9aEB01e8347bf697082F",
        legacyAddresses: [],
        deploymentBlock: "0x53f770",
        implementation: "0x5e6f02BA94648Fb25Ca98C6a577c04A0Db34c724",
        forwarder: "0xC738bD0E31CF0f7a777D815F8cA965f3c064C012"
      },
      ProxyReader: {
        address: "0x109e7315189E476AB21166955a0fB9BE9b531BEc",
        legacyAddresses: [],
        deploymentBlock: "0x53fff5",
        implementation: "0xA35F199591bD4F0Cb301ff85b6109Bda146dfb09"
      },
      DotCoinBurner: {
        address: "0xFc86844dE82FA7906C9789ca3161004F18Ca8ff4",
        legacyAddresses: [],
        deploymentBlock: "0x540d0d"
      },
      ZilliqaRecover: {
        address: "0x002380ccAFf852dEF50a176873d50f8019e36FBc",
        legacyAddresses: [],
        deploymentBlock: "0x540d6a",
        implementation: "0xBf101Ad6226024D1d26180136311d77387353c71",
        forwarder: "0x002380ccAFf852dEF50a176873d50f8019e36FBc"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0"
      },
      SeaportProxyBuyer: {
        address: "0x4FF860525ccb6E992E0A4579860465f7EF581aed",
        deploymentBlock: "0x7c4d06",
        implementation: "0xf02a5fA08b86aC35EC3D6Df6878832334696788E",
        forwarder: "0x4FF860525ccb6E992E0A4579860465f7EF581aed"
      },
      USDC: {
        address: "0x9E85b0F8a298Eb0ACc175cFFEd0674718d552C11",
        deploymentBlock: "0xb7c92b",
        implementation: "0xf66A05D55F6a71E74e131b9870B9131EE56ef12E",
        forwarder: "0x9E85b0F8a298Eb0ACc175cFFEd0674718d552C11"
      },
      L1GasPriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  84532: {
    contracts: {
      CNSRegistry: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      SignatureController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      MintingController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      Resolver: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      RootChainManager: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0",
        legacyAddresses: []
      },
      ProxyAdmin: {
        address: "0xd57f8F7be4BaE8f2bf24792Fec2Ca06513c83c1D",
        legacyAddresses: [],
        deploymentBlock: "0xcbf182"
      },
      UNSRegistry: {
        address: "0xEc353DCE22C2B97814608A6b2e44889506A4Aabf",
        deploymentBlock: "0xcbf184",
        implementation: "0xD0AB7f2490736c60575123aF2Ce0D2D6b13D5490",
        forwarder: "0xEc353DCE22C2B97814608A6b2e44889506A4Aabf",
        legacyAddresses: []
      },
      MintingManager: {
        address: "0x050Ceb85167D510558E793a483b479f2917B4b9b",
        deploymentBlock: "0xcbf18d",
        implementation: "0x6B5F9068Aa94eFf728585665244cb5AB8735E71A",
        forwarder: "0xEa5AE30C714ccd63Fca6D791Eea1E26CB1be0c1d",
        legacyAddresses: []
      },
      UNSOperator: {
        address: "0x99d55A02f5d9c76d31C6Ff57cc36A7862D5E1029",
        deploymentBlock: "0xcbf193",
        implementation: "0x3a2Ad968667a8214BEAe6AfA45192DD24109a3e7",
        legacyAddresses: []
      },
      ProxyReader: {
        address: "0x8Fc4DBA4A6F5AE8992E8f9B64D6d995BD3AfE2c4",
        deploymentBlock: "0xcbf1a9",
        implementation: "0x37e22Fd398B8c95128f5235e991682cF6e9F5d9c",
        legacyAddresses: []
      },
      SeaportProxyBuyer: {
        address: "0x78c4B414e1AbdF0dE267deDa01DFFd4cd0817A16",
        deploymentBlock: "0xcbf1b5",
        implementation: "0x6C95A12CcEA79971C51b16f707D8CdDd7d1b5033",
        forwarder: "0x78c4B414e1AbdF0dE267deDa01DFFd4cd0817A16",
        legacyAddresses: []
      },
      DotCoinBurner: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      ZilliqaRecover: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      USDC: {
        address: "0x5dEaC602762362FE5f135FA5904351916053cF70",
        deploymentBlock: "0x0"
      },
      L1GasPriceOracle: {
        address: "0x420000000000000000000000000000000000000F",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  },
  11155111: {
    contracts: {
      ProxyAdmin: {
        address: "0xCbF16B0E2A06916F0Ca4892F704349d13E11cF66",
        legacyAddresses: [],
        deploymentBlock: "0x5588B8"
      },
      ENSCustody: {
        address: "0xd2Bf816C7b23fF6e7d141ECC4c1e41DcC857aD45",
        legacyAddresses: [],
        deploymentBlock: "0x5588b9",
        implementation: "0x49Ac063337cF2fB26dD421Ab650b893CD54b900F",
        forwarder: "0xd2Bf816C7b23fF6e7d141ECC4c1e41DcC857aD45"
      },
      CNSRegistry: {
        address: "0xAb005176D74900A9c25fDA144e2f9f329A409166",
        legacyAddresses: [],
        deploymentBlock: "0x558be7",
        forwarder: "0xD3146C740c0Fa128ab1aEA90e4E75194AC0Bbc9B"
      },
      SignatureController: {
        address: "0x5e6f02BA94648Fb25Ca98C6a577c04A0Db34c724",
        legacyAddresses: [],
        deploymentBlock: "0x558bee"
      },
      MintingController: {
        address: "0xabec3fF0F0b6375F65CB9aEB01e8347bf697082F",
        legacyAddresses: [],
        deploymentBlock: "0x558bef",
        deprecated: !0
      },
      URIPrefixController: {
        address: "0x89D35aABc8427a32ee7032e73975271e1480fd4E",
        legacyAddresses: [],
        deploymentBlock: "0x558bf6",
        deprecated: !0
      },
      Resolver: {
        address: "0xf8F0622A88eC688140890153191Db1713442618D",
        legacyAddresses: [],
        deploymentBlock: "0x558bfc",
        forwarder: "0xA35F199591bD4F0Cb301ff85b6109Bda146dfb09"
      },
      WhitelistedMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      DomainZoneController: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      TwitterValidationOperator: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      FreeMinter: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0",
        deprecated: !0
      },
      MintableERC721Predicate: {
        address: "0xf8D2ecCA43F50F04922A13c417aEd05C34F1EF52",
        legacyAddresses: [],
        deploymentBlock: "0x486873"
      },
      RootChainManager: {
        address: "0x34F5A25B627f50Bb3f5cAb72807c4D4F405a9232",
        legacyAddresses: [],
        deploymentBlock: "0x486867"
      },
      UNSRegistry: {
        address: "0xDD907B4d80B4a979fd77eE502580c55F2700292c",
        deploymentBlock: "0x55a711",
        legacyAddresses: [],
        implementation: "0x7f21bA760352326c55FD6A83D218c2FCd294Dd1c",
        forwarder: "0xDD907B4d80B4a979fd77eE502580c55F2700292c"
      },
      MintingManager: {
        address: "0x1620637c0ce88cccfa919ef562b4398e3187189d",
        deploymentBlock: "0x55a715",
        legacyAddresses: [],
        implementation: "0x63B6F3F80d12A70eA26a57cdFDc16F33e6fD319A",
        forwarder: "0x38F532B32E0b42E747483A37Dfaf05460b1F4Fa3"
      },
      UNSOperator: {
        address: "0x41fD65E5a1cbdcCdD69F8C11DA4c829F7d3565A6",
        deploymentBlock: "0x55A717",
        legacyAddresses: [],
        implementation: "0xf9A7A6516Ee73E4Bd3FA9fbABdA3C8DeA40c89FA"
      },
      ProxyReader: {
        address: "0x880F7D37E9E4EB6868F92F4bB9C8C0995178fdA9",
        deploymentBlock: "0x55a857",
        legacyAddresses: [],
        implementation: "0xdA0E8ec8f801593161e689275Ab1394e7791ee18"
      },
      DotCoinBurner: {
        address: "0x64E3ecF931610d2503247b7c7A885688de54241A",
        legacyAddresses: [],
        deploymentBlock: "0x55f932"
      },
      ZilliqaRecover: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      },
      Seaport: {
        address: "0x0000000000000068F116a894984e2DB1123eB395",
        deploymentBlock: "0x0"
      },
      SeaportProxyBuyer: {
        address: "0x0000000000000000000000000000000000000000",
        deploymentBlock: "0x0",
        implementation: "0x0000000000000000000000000000000000000000",
        forwarder: "0x0000000000000000000000000000000000000000"
      },
      USDC: {
        address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
        deploymentBlock: "0x0"
      },
      L1GasPriceOracle: {
        address: "0x0000000000000000000000000000000000000000",
        legacyAddresses: [],
        deploymentBlock: "0x0"
      }
    }
  }
}, require$$6 = {
  version: version$1,
  networks
};
var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$5(t, c, n);
  return __setModuleDefault$5(t, c), t;
}, __awaiter$4 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$4 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __spreadArray$2 = commonjsGlobal && commonjsGlobal.__spreadArray || function(c, t, n) {
  if (n || arguments.length === 2) for (var ie = 0, fe = t.length, ae; ie < fe; ie++)
    (ae || !(ie in t)) && (ae || (ae = Array.prototype.slice.call(t, 0, ie)), ae[ie] = t[ie]);
  return c.concat(ae || Array.prototype.slice.call(t));
}, __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(UnsInternal$1, "__esModule", { value: !0 });
var types_1$1 = types$3, configurationError_1$3 = __importDefault$3(configurationError), configurationError_2$1 = configurationError, utils_1$3 = utils$e, FetchProvider_1$1 = __importDefault$3(FetchProvider$1), EthereumContract_1 = __importDefault$3(EthereumContract$1), proxyReader_1 = __importDefault$3(proxyReader), uns_config_json_1 = __importDefault$3(require$$6), resolutionError_1$5 = __importStar$5(resolutionError), namehash_1$3 = namehash, UnsInternal = (
  /** @class */
  function() {
    function c(t, n, ie) {
      this.unsLocation = t, this.checkNetworkConfig(t, n), this.network = n.network, this.blockchain = ie, this.url = n.url, this.provider = n.provider || new FetchProvider_1$1.default(this.unsLocation, this.url), this.readerContract = new EthereumContract_1.default(proxyReader_1.default, n.proxyReaderAddress || c.ProxyReaderMap[utils_1$3.EthereumNetworks[this.network]], this.provider, n.proxyServiceApiKey);
    }
    return c.prototype.exists = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var n;
        return __generator$4(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.readerContract.call("exists", [
                this.namehash(t)
              ])];
            case 1:
              return n = ie.sent()[0], [2, n];
          }
        });
      });
    }, c.prototype.reverseOf = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var n;
        return __generator$4(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.readerContract.call("reverseOf", [t])];
            case 1:
              return n = ie.sent()[0], [2, n];
          }
        });
      });
    }, c.prototype.getAddress = function(t, n, ie) {
      return __awaiter$4(this, void 0, void 0, function() {
        var fe, ae;
        return __generator$4(this, function(le) {
          switch (le.label) {
            case 0:
              return fe = this.namehash(t), [4, this.readerContract.call("getAddress", [
                n,
                ie,
                fe
              ])];
            case 1:
              return ae = le.sent()[0], [2, ae];
          }
        });
      });
    }, c.prototype.getTokenUri = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var n;
        return __generator$4(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.readerContract.call("tokenURI", [t])];
            case 1:
              return n = ie.sent()[0], [2, n];
          }
        });
      });
    }, c.prototype.registryAddress = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var n, ie, fe;
        return __generator$4(this, function(ae) {
          switch (ae.label) {
            case 0:
              if (n = !t.includes("."), !this.checkDomain(t, n))
                throw new resolutionError_1$5.default(resolutionError_1$5.ResolutionErrorCode.UnsupportedDomain, {
                  domain: t
                });
              return ie = n ? t : this.namehash(t), [4, this.readerContract.call("registryOf", [ie])];
            case 1:
              if (fe = ae.sent()[0], (0, utils_1$3.isNullAddress)(fe))
                throw new resolutionError_1$5.default(resolutionError_1$5.ResolutionErrorCode.UnregisteredDomain, {
                  domain: t
                });
              return [2, fe];
          }
        });
      });
    }, c.prototype.resolver = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        return __generator$4(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.getVerifiedData(t)];
            case 1:
              return [2, n.sent().resolver];
          }
        });
      });
    }, c.prototype.get = function(t, n) {
      return n === void 0 && (n = []), __awaiter$4(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$4(this, function(he) {
          switch (he.label) {
            case 0:
              return [4, this.readerContract.call("getData", [n, t])];
            case 1:
              return ie = he.sent(), fe = ie[0], ae = ie[1], le = ie[2], [2, {
                owner: ae,
                resolver: fe,
                records: (0, utils_1$3.constructRecords)(n, le),
                location: this.unsLocation
              }];
          }
        });
      });
    }, c.prototype.locations = function(t) {
      return __awaiter$4(this, void 0, void 0, function() {
        var n, ie, fe, ae, le, he, me, ye = this;
        return __generator$4(this, function(be) {
          switch (be.label) {
            case 0:
              return n = t.map(function(Ae) {
                return ye.namehash(Ae);
              }), [4, this.readerContract.multicall(__spreadArray$2([
                {
                  method: "getDataForMany",
                  args: [[], n]
                }
              ], n.map(function(Ae) {
                return {
                  method: "registryOf",
                  args: [Ae]
                };
              }), !0))];
            case 1:
              return ie = be.sent(), fe = ie[0], ae = fe[0], le = fe[1], he = ie.slice(1), me = t.reduce(function(Ae, Se, $e) {
                return Ae[Se] = null, le && le[$e] !== types_1$1.NullAddress && (Ae[Se] = {
                  resolverAddress: ae[$e],
                  registryAddress: he[$e][0],
                  ownerAddress: le[$e],
                  networkId: utils_1$3.EthereumNetworks[ye.network],
                  blockchain: ye.blockchain,
                  blockchainProviderUrl: ye.url
                }), Ae;
              }, {}), [2, me];
          }
        });
      });
    }, c.prototype.namehash = function(t) {
      if (!this.checkDomain(t))
        throw new resolutionError_1$5.default(resolutionError_1$5.ResolutionErrorCode.UnsupportedDomain, {
          domain: t
        });
      return (0, namehash_1$3.eip137Namehash)(t);
    }, c.prototype.checkDomain = function(t, n) {
      if (n === void 0 && (n = !1), n)
        return !0;
      var ie = t.split(".");
      return !!ie.length && !(t === "eth" || /^[^-]*[^-]*\.(eth|addr\.reverse)$/.test(t)) && ie.every(function(fe) {
        return !!fe.length;
      });
    }, c.prototype.getVerifiedData = function(t, n) {
      return __awaiter$4(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$4(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.namehash(t), [4, this.get(ie, n)];
            case 1:
              if (fe = ae.sent(), (0, utils_1$3.isNullAddress)(fe.resolver))
                throw (0, utils_1$3.isNullAddress)(fe.owner) ? new resolutionError_1$5.default(resolutionError_1$5.ResolutionErrorCode.UnregisteredDomain, {
                  domain: t
                }) : new resolutionError_1$5.default(resolutionError_1$5.ResolutionErrorCode.UnspecifiedResolver, {
                  location: this.unsLocation,
                  domain: t
                });
              return [2, fe];
          }
        });
      });
    }, c.prototype.checkNetworkConfig = function(t, n) {
      if (!n.network)
        throw new configurationError_1$3.default(configurationError_2$1.ConfigurationErrorCode.UnsupportedNetwork, {
          method: t
        });
      if (n.proxyReaderAddress && !this.isValidProxyReader(n.proxyReaderAddress))
        throw new configurationError_1$3.default(configurationError_2$1.ConfigurationErrorCode.InvalidConfigurationField, {
          method: this.unsLocation,
          field: "proxyReaderAddress"
        });
      types_1$1.UnsSupportedNetwork.guard(n.network) || this.checkCustomNetworkConfig(n);
    }, c.prototype.checkCustomNetworkConfig = function(t) {
      if (!this.isValidProxyReader(t.proxyReaderAddress))
        throw new configurationError_1$3.default(configurationError_2$1.ConfigurationErrorCode.InvalidConfigurationField, {
          method: this.unsLocation,
          field: "proxyReaderAddress"
        });
      if (!t.url && !t.provider)
        throw new configurationError_1$3.default(configurationError_2$1.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: this.unsLocation,
          config: "url or provider"
        });
    }, c.prototype.isValidProxyReader = function(t) {
      if (!t)
        throw new configurationError_1$3.default(configurationError_2$1.ConfigurationErrorCode.CustomNetworkConfigMissing, {
          method: this.unsLocation,
          config: "proxyReaderAddress"
        });
      var n = new RegExp("^0x[a-fA-F0-9]{40}$");
      return n.test(t);
    }, c.ProxyReaderMap = getProxyReaderMap(), c;
  }()
);
UnsInternal$1.default = UnsInternal;
function getProxyReaderMap() {
  for (var c = {}, t = 0, n = Object.keys(uns_config_json_1.default.networks); t < n.length; t++) {
    var ie = n[t];
    c[ie] = uns_config_json_1.default.networks[ie].contracts.ProxyReader.address.toLowerCase();
  }
  return c;
}
const version = "2.1.33", information = {
  description: "This file describes all resolver keys with a defined meaning and related metadata used by Unstoppable Domains UNS Registry",
  documentation: "https://docs.unstoppabledomains.com/developer-toolkit/records-reference/",
  contribution: "https://github.com/unstoppabledomains/uns/blob/main/resolver-keys.json"
}, keys = {
  "crypto.BTC.address": {
    deprecatedKeyName: "BTC",
    deprecated: !1,
    validationRegex: "^bc1[ac-hj-np-z02-9]{6,87}$|^[13][a-km-zA-HJ-NP-Z1-9]{25,39}$"
  },
  "crypto.B2M.version.MATIC.address": {
    deprecatedKeyName: "B2M_MATIC",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.B2M.version.BEP20.address": {
    deprecatedKeyName: "B2M_BEP20",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.B2M.version.ERC20.address": {
    deprecatedKeyName: "B2M_ERC20",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ETH.address": {
    deprecatedKeyName: "ETH",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.ZIL.address": {
    deprecatedKeyName: "ZIL",
    deprecated: !1,
    validationRegex: "^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$"
  },
  "crypto.LTC.address": {
    deprecatedKeyName: "LTC",
    deprecated: !1,
    validationRegex: "^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$|^ltc1[a-zA-HJ-NP-Z0-9]{25,39}$"
  },
  "crypto.ETC.address": {
    deprecatedKeyName: "ETC",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.EQL.address": {
    deprecatedKeyName: "EQL",
    deprecated: !1,
    validationRegex: "^bnb[0-9a-z]{39}$"
  },
  "crypto.LINK.address": {
    deprecatedKeyName: "LINK",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.FARMS.version.MATIC.address": {
    deprecatedKeyName: "FARMS_MATIC",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.USDC.address": {
    deprecatedKeyName: "USDC",
    deprecated: !0,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.USDC.version.ERC20.address": {
    deprecatedKeyName: "USDC_ERC20",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.USDC.version.OKT.address": {
    deprecatedKeyName: "USDC_OKT",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$|^ex[a-zA-HJ-NP-Z0-9]{6,90}$"
  },
  "crypto.USDC.version.MATIC.address": {
    deprecatedKeyName: "USDC_MATIC",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.USDC.version.SOL.address": {
    deprecatedKeyName: "USDC_SOL",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]*$"
  },
  "crypto.USDC.version.AVAX.address": {
    deprecatedKeyName: "USDC_AVAX",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]*$"
  },
  "crypto.BAT.address": {
    deprecatedKeyName: "BAT",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.REP.address": {
    deprecatedKeyName: "REP",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.ZRX.address": {
    deprecatedKeyName: "ZRX",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.DAI.address": {
    deprecatedKeyName: "DAI",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.BCH.address": {
    deprecatedKeyName: "BCH",
    deprecated: !1,
    validationRegex: "^[13][a-km-zA-HJ-NP-Z1-9]{33}$|^((bitcoincash|bchreg|bchtest):)?(q|p)[a-z0-9]{41}$|^((BITCOINCASH:)?(Q|P)[A-Z0-9]{41})$"
  },
  "crypto.XMR.address": {
    deprecatedKeyName: "XMR",
    deprecated: !1,
    validationRegex: "^[48]{1}[0-9AB][1-9A-HJ-NP-Za-km-z]{93}$"
  },
  "crypto.DASH.address": {
    deprecatedKeyName: "DASH",
    deprecated: !1,
    validationRegex: "^X[1-9A-HJ-NP-Za-km-z]{33}$"
  },
  "crypto.NEO.address": {
    deprecatedKeyName: "NEO",
    deprecated: !1,
    validationRegex: "^A[0-9a-zA-Z]{33}$"
  },
  "crypto.SWTH.address": {
    deprecatedKeyName: "SWTH",
    deprecated: !1,
    validationRegex: "^A[0-9a-zA-Z]{33}$"
  },
  "crypto.DOGE.address": {
    deprecatedKeyName: "DOGE",
    deprecated: !1,
    validationRegex: "^D[5-9A-HJ-NP-U]{1}[1-9A-HJ-NP-Za-km-z]{32}$"
  },
  "crypto.XRP.address": {
    deprecatedKeyName: "XRP",
    deprecated: !1,
    validationRegex: "^r[1-9a-km-zA-HJ-NP-Z]{24,34}$"
  },
  "crypto.ZEC.address": {
    deprecatedKeyName: "ZEC",
    deprecated: !1,
    validationRegex: "^z([a-zA-Z0-9]){94}$|^zs1([a-zA-Z0-9]){75}$|^t([a-zA-Z0-9]){34}$"
  },
  "crypto.YEC.address": {
    deprecatedKeyName: "YEC",
    deprecated: !1,
    validationRegex: "^y([a-zA-Z0-9]){94}$|^ys1([a-zA-Z0-9]){75}$|^s([a-zA-Z0-9]){34}$"
  },
  "crypto.ADA.address": {
    deprecatedKeyName: "ADA",
    deprecated: !1,
    validationRegex: "^[1-9a-km-zA-HJ-NP-Z]{104}$|^A[1-9A-HJ-NP-Za-km-z]{58}$|^addr([0-9a-zA-Z]{99}|[0-9a-zA-Z]{54})$"
  },
  "crypto.EOS.address": {
    deprecatedKeyName: "EOS",
    deprecated: !1,
    validationRegex: "^[1-5a-z]{12}$|^EOS[a-zA-Z0-9]{50}$|^PUB_K[0-9]_[a-zA-Z0-9]{50}$"
  },
  "crypto.XLM.address": {
    deprecatedKeyName: "XLM",
    deprecated: !1,
    validationRegex: "^G[A-Z2-7]{55}$"
  },
  "crypto.BNB.address": {
    deprecatedKeyName: "BNB",
    deprecated: !0,
    validationRegex: "^bnb[0-9a-z]{39}$"
  },
  "crypto.BNB.version.BEP2.address": {
    deprecatedKeyName: "BNB_BEP2",
    deprecated: !1,
    validationRegex: "^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$"
  },
  "crypto.BNB.version.BEP20.address": {
    deprecatedKeyName: "BNB_BEP20",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.BTG.address": {
    deprecatedKeyName: "BTG",
    deprecated: !1,
    validationRegex: "^[GA][a-km-zA-HJ-NP-Z1-9]{33}$"
  },
  "crypto.NANO.address": {
    deprecatedKeyName: "NANO",
    deprecated: !1,
    validationRegex: "^nano_[1-9a-z]{60}$"
  },
  "crypto.WAVES.address": {
    deprecatedKeyName: "WAVES",
    deprecated: !1,
    validationRegex: "^3[a-km-zA-HJ-NP-Z1-9]{34}$"
  },
  "crypto.KMD.address": {
    deprecatedKeyName: "KMD",
    deprecated: !1,
    validationRegex: "^R[a-km-zA-Z1-9]{33}$"
  },
  "crypto.AE.address": {
    deprecatedKeyName: "AE",
    deprecated: !1,
    validationRegex: "^ak_[a-km-zA-Z1-9]{48,52}$"
  },
  "crypto.RSK.address": {
    deprecatedKeyName: "RSK",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.WAN.address": {
    deprecatedKeyName: "WAN",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.STRAT.address": {
    deprecatedKeyName: "STRAT",
    deprecated: !1,
    validationRegex: "^S[a-km-zA-HJ-NP-Z1-9]{33}$"
  },
  "crypto.UBQ.address": {
    deprecatedKeyName: "UBQ",
    deprecated: !1,
    validationRegex: "^0x[a-km-zA-HJ-NP-Z0-9]{40}$"
  },
  "crypto.XTZ.address": {
    deprecatedKeyName: "XTZ",
    deprecated: !1,
    validationRegex: "^(tz|KT)[a-km-zA-HJ-NP-Z1-9]{34}$"
  },
  "crypto.IOTA.address": {
    deprecatedKeyName: "IOTA",
    deprecated: !1,
    validationRegex: "^[A-Z0-9]{90}$|^iota1[a-z0-9]{59}$"
  },
  "crypto.VET.address": {
    deprecatedKeyName: "VET",
    deprecated: !1,
    validationRegex: "^0x[a-km-zA-HJ-NP-Z0-9]{40}$"
  },
  "crypto.QTUM.address": {
    deprecatedKeyName: "QTUM",
    deprecated: !1,
    validationRegex: "^Q[a-km-zA-HJ-NP-Z1-9]{33}$"
  },
  "crypto.ICX.address": {
    deprecatedKeyName: "ICX",
    deprecated: !1,
    validationRegex: "^[a-km-zA-HJ-NP-Z0-9]{42}$"
  },
  "crypto.DGB.address": {
    deprecatedKeyName: "DGB",
    deprecated: !1,
    validationRegex: "(^[a-km-zA-HJ-NP-Z1-9]{34}$)|(^[a-zA-Z1-9]{42}$)|(^dgb1[a-zA-Z0-9]{39}$)"
  },
  "crypto.XZC.address": {
    deprecatedKeyName: "XZC",
    deprecated: !0,
    validationRegex: "^[a-km-zA-HJ-NP-Z1-9]{34}$"
  },
  "crypto.FIRO.address": {
    deprecatedKeyName: "FIRO",
    deprecated: !1,
    validationRegex: "^[a-km-zA-HJ-NP-Z1-9]{34}$"
  },
  "crypto.BURST.address": {
    deprecatedKeyName: "BURST",
    deprecated: !1,
    validationRegex: "^BURST-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{5}"
  },
  "crypto.DCR.address": {
    deprecatedKeyName: "DCR",
    deprecated: !1,
    validationRegex: "^D[a-zA-Z0-9]*$"
  },
  "crypto.XEM.address": {
    deprecatedKeyName: "XEM",
    deprecated: !1,
    validationRegex: "^N[ABCDEFGHIJKLMNOPQRSTUVWXYZ234567]{39}$"
  },
  "crypto.LSK.address": {
    deprecatedKeyName: "LSK",
    deprecated: !1,
    validationRegex: "^[0-9a-z]{3}[23456789abcdefghjkmnopqrstuvwxyz]{38}$"
  },
  "crypto.ATOM.address": {
    deprecatedKeyName: "ATOM",
    deprecated: !1,
    validationRegex: "^(cosmos)1([qpzry9x8gf2tvdw0s3jn54khce6mua7l]+)$"
  },
  "crypto.ONG.address": {
    deprecatedKeyName: "ONG",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.ONT.address": {
    deprecatedKeyName: "ONT",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.SMART.address": {
    deprecatedKeyName: "SMART",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.TPAY.address": {
    deprecatedKeyName: "TPAY",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.GRS.address": {
    deprecatedKeyName: "GRS",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.BSV.address": {
    deprecatedKeyName: "BSV",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{33,34}$"
  },
  "crypto.GAS.address": {
    deprecatedKeyName: "GAS",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]*$"
  },
  "crypto.TRX.address": {
    deprecatedKeyName: "TRX",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.VTHO.address": {
    deprecatedKeyName: "VTHO",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{42}$"
  },
  "crypto.BCD.address": {
    deprecatedKeyName: "BCD",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.BTT.address": {
    deprecatedKeyName: "BTT",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.KIN.address": {
    deprecatedKeyName: "KIN",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{56}$"
  },
  "crypto.RVN.address": {
    deprecatedKeyName: "RVN",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.ARK.address": {
    deprecatedKeyName: "ARK",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.XVG.address": {
    deprecatedKeyName: "XVG",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$|^[1-9A-HJ-NP-Za-km-z]{95}$"
  },
  "crypto.ALGO.address": {
    deprecatedKeyName: "ALGO",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{58}$"
  },
  "crypto.NEBL.address": {
    deprecatedKeyName: "NEBL",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.XPM.address": {
    deprecatedKeyName: "XPM",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.ONE.address": {
    deprecatedKeyName: "ONE",
    deprecated: !1,
    validationRegex: "^one[a-zA-Z0-9]{39}$|^0x[a-fA-F0-9]{40}$"
  },
  "crypto.BNTY.address": {
    deprecatedKeyName: "BNTY",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.CRO.address": {
    deprecatedKeyName: "CRO",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.TWT.address": {
    deprecatedKeyName: "TWT",
    deprecated: !1,
    validationRegex: "^bnb[0-9a-z]{39}$"
  },
  "crypto.SIERRA.address": {
    deprecatedKeyName: "SIERRA",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.VSYS.address": {
    deprecatedKeyName: "VSYS",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{35}$"
  },
  "crypto.HIVE.address": {
    deprecatedKeyName: "HIVE",
    validationRegex: "^(?!s*$).+",
    deprecated: !1
  },
  "crypto.HT.address": {
    deprecatedKeyName: "HT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ENJ.address": {
    deprecatedKeyName: "ENJ",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.YFI.address": {
    deprecatedKeyName: "YFI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MTA.address": {
    deprecatedKeyName: "MTA",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.COMP.address": {
    deprecatedKeyName: "COMP",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BAL.address": {
    deprecatedKeyName: "BAL",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AMPL.address": {
    deprecatedKeyName: "AMPL",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LEND.address": {
    deprecatedKeyName: "LEND",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TLOS.address": {
    deprecatedKeyName: "TLOS",
    validationRegex: "^[1-5a-z]{12}$",
    deprecated: !1
  },
  "crypto.XDC.address": {
    deprecatedKeyName: "XDC",
    validationRegex: "^xdc[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XST.address": {
    deprecatedKeyName: "XST",
    validationRegex: "(?:RwxQ3jUs2BjKhseNX1em4msn2GyV5XAec[PQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|RwxQ3jUs2BjKhseNX1em4msn2GyV5XAe[defghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|RwxQ3jUs2BjKhseNX1em4msn2GyV5XA[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{2}|RwxQ3jUs2BjKhseNX1em4msn2GyV5X[BCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{3}|RwxQ3jUs2BjKhseNX1em4msn2GyV5[YZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{4}|RwxQ3jUs2BjKhseNX1em4msn2GyV[6789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{5}|RwxQ3jUs2BjKhseNX1em4msn2Gy[WXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{6}|RwxQ3jUs2BjKhseNX1em4msn2G[z][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{7}|RwxQ3jUs2BjKhseNX1em4msn2[HJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8}|RwxQ3jUs2BjKhseNX1em4msn[3456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{9}|RwxQ3jUs2BjKhseNX1em4ms[opqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{10}|RwxQ3jUs2BjKhseNX1em4m[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{11}|RwxQ3jUs2BjKhseNX1em4[nopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{12}|RwxQ3jUs2BjKhseNX1em[56789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{13}|RwxQ3jUs2BjKhseNX1e[nopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{14}|RwxQ3jUs2BjKhseNX1[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{15}|RwxQ3jUs2BjKhseNX[23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{16}|RwxQ3jUs2BjKhseN[YZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{17}|RwxQ3jUs2BjKhse[PQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{18}|RwxQ3jUs2BjKhs[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{19}|RwxQ3jUs2BjKh[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{20}|RwxQ3jUs2BjK[ijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{21}|RwxQ3jUs2Bj[LMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{22}|RwxQ3jUs2B[kmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{23}|RwxQ3jUs2[CDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{24}|RwxQ3jUs[3456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{25}|RwxQ3jU[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{26}|RwxQ3j[VWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{27}|RwxQ3[kmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{28}|RwxQ[456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|Rwx[RSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{30}|Rw[yz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{31}|R[xyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{32}|S[123456789ABCDEFGHJKL][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{32}|SM[123456789ABCDEFGH][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{31}|SMJ11[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|SMJ11[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|SMJ12[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnop][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{28}|SMJ12q[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{27}|SMJ12qn[12345678][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{26}|SMJ12qn9[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghi][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{25}|SMJ12qn9j[123456789ABCDEFGHJKLM][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{24}|SMJ12qn9jN[123456789AB][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{23}|SMJ12qn9jNC[123456789AB][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{22}|SMJ12qn9jNCC[123456789ABCDEFGHJKLMNPQRSTUVW][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{21}|SMJ12qn9jNCCX[123456789ABCDEFGH][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{20}|SMJ12qn9jNCCXJ[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{19}|SMJ12qn9jNCCXJn[123456789ABCDEFGHJKLMNPQRS][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{18}|SMJ12qn9jNCCXJnT[123456789ABCDEFGHJKLMNPQRSTUVWX][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{17}|SMJ12qn9jNCCXJnTY[123456789ABCDEFGHJKLMNPQ][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{16}|SMJ12qn9jNCCXJnTYR[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxy][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{15}|SMJ12qn9jNCCXJnTYRz[1234][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{14}|SMJ12qn9jNCCXJnTYRz5[123456789ABCDEFGHJKLMNPQRSTUVWX][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{13}|SMJ12qn9jNCCXJnTYRz5Y[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrst][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{12}|SMJ12qn9jNCCXJnTYRz5Yu[12345678][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{11}|SMJ12qn9jNCCXJnTYRz5Yu9[123456789ABCDEFGHJKLMNPQRSTUVWXY][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{10}|SMJ12qn9jNCCXJnTYRz5Yu9Z[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcd][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{9}|SMJ12qn9jNCCXJnTYRz5Yu9Ze[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8}|SMJ12qn9jNCCXJnTYRz5Yu9Zen[123456789ABCD][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{7}|SMJ12qn9jNCCXJnTYRz5Yu9ZenE[123456789ABCDEFGHJKLMNPQ][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{6}|SMJ12qn9jNCCXJnTYRz5Yu9ZenER[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{5}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERn[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghij][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{4}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnk[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghij][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{3}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkk[123456789ABCDEFGHJKLMNPQRST][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{2}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkkU[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstu][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkkUv[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghi])",
    deprecated: !1
  },
  "crypto.STRAX.address": {
    deprecatedKeyName: "STRAX",
    validationRegex: "^X[a-km-zA-HJ-NP-Z1-9]{33}$",
    deprecated: !1
  },
  "crypto.SIGNA.address": {
    deprecatedKeyName: "SIGNA",
    validationRegex: "^S-((?=[A-Z2-9]{4})(?:[^IO]{4})-){3}(?=[A-Z2-9]{5})(?:[^IO]{5})$",
    deprecated: !1
  },
  "crypto.NIM.address": {
    deprecatedKeyName: "NIM",
    validationRegex: "^NQ[0-9]{2} ([A-Z0-9]{4} ){7}[A-Z0-9]{4}$",
    deprecated: !1
  },
  "crypto.GUAP.address": {
    deprecatedKeyName: "GUAP",
    validationRegex: "^(G|P)[a-zA-HJ-NP-Z0-9]{25,39}$",
    deprecated: !1
  },
  "crypto.YLD.address": {
    deprecatedKeyName: "YLD",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.OKT.address": {
    deprecatedKeyName: "OKT",
    validationRegex: "^0x[a-fA-F0-9]{40}$|^ex[a-zA-HJ-NP-Z0-9]{6,90}$",
    deprecated: !1
  },
  "crypto.ELA.version.ELA.address": {
    deprecatedKeyName: "ELA_ELA",
    validationRegex: "E[a-zA-HJ-NP-Z0-9]{33}",
    deprecated: !1
  },
  "crypto.ELA.version.ESC.address": {
    deprecatedKeyName: "ELA_ESC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WETH.version.ERC20.address": {
    deprecatedKeyName: "WETH_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WETH.version.MATIC.address": {
    deprecatedKeyName: "WETH_MATIC",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.WETH.version.BEP20.address": {
    deprecatedKeyName: "WETH_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDT.version.ERC20.address": {
    deprecatedKeyName: "USDT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDT.version.MATIC.address": {
    deprecatedKeyName: "USDT_MATIC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDT.version.TRON.address": {
    deprecatedKeyName: "USDT_TRON",
    validationRegex: "^[T][a-zA-HJ-NP-Z0-9]{33}$",
    deprecated: !1
  },
  "crypto.USDT.version.EOS.address": {
    deprecatedKeyName: "USDT_EOS",
    validationRegex: "^[1-5a-z]{12}$|^EOS[a-zA-Z0-9]{50}$|^PUB_K[0-9]_[a-zA-Z0-9]{50}$",
    deprecated: !1
  },
  "crypto.USDT.version.OMNI.address": {
    deprecatedKeyName: "USDT_OMNI",
    validationRegex: "^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$",
    deprecated: !1
  },
  "crypto.USDT.version.OKB.address": {
    deprecatedKeyName: "USDT_OKB",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDT.version.OKC.address": {
    deprecatedKeyName: "USDT_OKC",
    validationRegex: "^0x[a-fA-F0-9]{40}$|^ex[a-zA-HJ-NP-Z0-9]{6,90}$",
    deprecated: !0
  },
  "crypto.FTM.version.ERC20.address": {
    deprecatedKeyName: "FTM_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FTM.version.BEP2.address": {
    deprecatedKeyName: "FTM_BEP2",
    validationRegex: "^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.FTM.version.OPERA.address": {
    deprecatedKeyName: "FTM_OPERA",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FUSE.version.ERC20.address": {
    deprecatedKeyName: "FUSE_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FUSE.version.FUSE.address": {
    deprecatedKeyName: "FUSE_FUSE",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MATIC.version.MATIC.address": {
    deprecatedKeyName: "MATIC_MATIC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MATIC.version.BEP20.address": {
    deprecatedKeyName: "MATIC_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MATIC.version.ERC20.address": {
    deprecatedKeyName: "MATIC_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "social.payid.name": {
    deprecatedKeyName: "payid",
    validationRegex: "^[0-9a-zA-Z]+\\$[0-9a-zA-Z]+\\.[0-9a-zA-Z]+$",
    deprecated: !1
  },
  "social.picture.value": {
    deprecatedKeyName: "picture",
    validationRegex: null,
    deprecated: !1
  },
  "whois.email.value": {
    deprecatedKeyName: "email",
    validationRegex: "^[^@]+@[^\\.]+\\..+$",
    deprecated: !1
  },
  "whois.for_sale.value": {
    deprecatedKeyName: "for_sale",
    validationRegex: "(true)|(false)",
    deprecated: !1
  },
  "ipfs.html.value": {
    deprecatedKeyName: "html",
    validationRegex: ".{0,100}",
    deprecated: !1
  },
  "ipfs.redirect_domain.value": {
    deprecatedKeyName: "redirect_domain",
    validationRegex: ".{0,253}",
    deprecated: !1
  },
  "dweb.ipfs.hash": {
    deprecatedKeyName: "dweb_hash",
    validationRegex: ".{0,100}",
    deprecated: !1
  },
  "browser.redirect_url": {
    deprecatedKeyName: "browser_redirect",
    validationRegex: ".{0,253}",
    deprecated: !1
  },
  "browser.preferred_protocols": {
    deprecatedKeyName: "browser_preferred_protocols",
    validationRegex: null,
    deprecated: !1
  },
  "gundb.username.value": {
    deprecatedKeyName: "gundb_username",
    validationRegex: null,
    deprecated: !1
  },
  "gundb.public_key.value": {
    deprecatedKeyName: "gundb_public_key",
    validationRegex: null,
    deprecated: !1
  },
  "social.image.value": {
    deprecatedKeyName: "image",
    validationRegex: null,
    deprecated: !1
  },
  "social.twitter.username": {
    deprecatedKeyName: "twitter_username",
    validationRegex: null,
    deprecated: !1
  },
  "validation.social.twitter.username": {
    deprecatedKeyName: "validation_twitter_username",
    validationRegex: null,
    deprecated: !1
  },
  "forwarding.url": {
    deprecatedKeyName: "forwarding_url",
    validationRegex: "^(https?)://[^\\s/$.?#].[^\\s]*$",
    deprecated: !1
  },
  "dns.ttl": {
    deprecatedKeyName: "dns_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.A": {
    deprecatedKeyName: "dns_A",
    validationRegex: null,
    deprecated: !1
  },
  "dns.A.ttl": {
    deprecatedKeyName: "dns_A_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.AAAA": {
    deprecatedKeyName: "dns_AAAA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.AAAA.ttl": {
    deprecatedKeyName: "dns_AAAA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.AFSDB": {
    deprecatedKeyName: "dns_AFSDB",
    validationRegex: null,
    deprecated: !1
  },
  "dns.AFSDB.ttl": {
    deprecatedKeyName: "dns_AFSDB_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.APL": {
    deprecatedKeyName: "dns_APL",
    validationRegex: null,
    deprecated: !1
  },
  "dns.APL.ttl": {
    deprecatedKeyName: "dns_APL_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CAA": {
    deprecatedKeyName: "dns_CAA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CAA.ttl": {
    deprecatedKeyName: "dns_CAA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CDNSKEY": {
    deprecatedKeyName: "dns_CDNSKEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CDNSKEY.ttl": {
    deprecatedKeyName: "dns_CDNSKEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CDS": {
    deprecatedKeyName: "dns_CDS",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CDS.ttl": {
    deprecatedKeyName: "dns_CDS_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CERT": {
    deprecatedKeyName: "dns_CERT",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CERT.ttl": {
    deprecatedKeyName: "dns_CERT_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CNAME": {
    deprecatedKeyName: "dns_CNAME",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CNAME.ttl": {
    deprecatedKeyName: "dns_CNAME_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CSYNC": {
    deprecatedKeyName: "dns_CSYNC",
    validationRegex: null,
    deprecated: !1
  },
  "dns.CSYNC.ttl": {
    deprecatedKeyName: "dns_CSYNC_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DHCID": {
    deprecatedKeyName: "dns_DHCID",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DHCID.ttl": {
    deprecatedKeyName: "dns_DHCID_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DLV": {
    deprecatedKeyName: "dns_DLV",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DLV.ttl": {
    deprecatedKeyName: "dns_DLV_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DNAME": {
    deprecatedKeyName: "dns_DNAME",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DNAME.ttl": {
    deprecatedKeyName: "dns_DNAME_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DNSKEY": {
    deprecatedKeyName: "dns_DNSKEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DNSKEY.ttl": {
    deprecatedKeyName: "dns_DNSKEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DS": {
    deprecatedKeyName: "dns_DS",
    validationRegex: null,
    deprecated: !1
  },
  "dns.DS.ttl": {
    deprecatedKeyName: "dns_DS_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.EUI48": {
    deprecatedKeyName: "dns_EUI48",
    validationRegex: null,
    deprecated: !1
  },
  "dns.EUI48.ttl": {
    deprecatedKeyName: "dns_EUI48_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.EUI64": {
    deprecatedKeyName: "dns_EUI64",
    validationRegex: null,
    deprecated: !1
  },
  "dns.EUI64.ttl": {
    deprecatedKeyName: "dns_EUI64_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HINFO": {
    deprecatedKeyName: "dns_HINFO",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HINFO.ttl": {
    deprecatedKeyName: "dns_HINFO_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HIP": {
    deprecatedKeyName: "dns_HIP",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HIP.ttl": {
    deprecatedKeyName: "dns_HIP_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HTTPS": {
    deprecatedKeyName: "dns_HTTPS",
    validationRegex: null,
    deprecated: !1
  },
  "dns.HTTPS.ttl": {
    deprecatedKeyName: "dns_HTTPS_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.IPSECKEY": {
    deprecatedKeyName: "dns_IPSECKEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.IPSECKEY.ttl": {
    deprecatedKeyName: "dns_IPSECKEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.KEY": {
    deprecatedKeyName: "dns_KEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.KEY.ttl": {
    deprecatedKeyName: "dns_KEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.KX": {
    deprecatedKeyName: "dns_KX",
    validationRegex: null,
    deprecated: !1
  },
  "dns.KX.ttl": {
    deprecatedKeyName: "dns_KX_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.LOC": {
    deprecatedKeyName: "dns_LOC",
    validationRegex: null,
    deprecated: !1
  },
  "dns.LOC.ttl": {
    deprecatedKeyName: "dns_LOC_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.MX": {
    deprecatedKeyName: "dns_MX",
    validationRegex: null,
    deprecated: !1
  },
  "dns.MX.ttl": {
    deprecatedKeyName: "dns_MX_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NAPTR": {
    deprecatedKeyName: "dns_NAPTR",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NAPTR.ttl": {
    deprecatedKeyName: "dns_NAPTR_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NS": {
    deprecatedKeyName: "dns_NS",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NS.ttl": {
    deprecatedKeyName: "dns_NS_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC": {
    deprecatedKeyName: "dns_NSEC",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC.ttl": {
    deprecatedKeyName: "dns_NSEC_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC3": {
    deprecatedKeyName: "dns_NSEC3",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC3.ttl": {
    deprecatedKeyName: "dns_NSEC3_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC3PARAM": {
    deprecatedKeyName: "dns_NSEC3PARAM",
    validationRegex: null,
    deprecated: !1
  },
  "dns.NSEC3PARAM.ttl": {
    deprecatedKeyName: "dns_NSEC3PARAM_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.OPENPGPKEY": {
    deprecatedKeyName: "dns_OPENPGPKEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.OPENPGPKEY.ttl": {
    deprecatedKeyName: "dns_OPENPGPKEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.PTR": {
    deprecatedKeyName: "dns_PTR",
    validationRegex: null,
    deprecated: !1
  },
  "dns.PTR.ttl": {
    deprecatedKeyName: "dns_PTR_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.RP": {
    deprecatedKeyName: "dns_RP",
    validationRegex: null,
    deprecated: !1
  },
  "dns.RP.ttl": {
    deprecatedKeyName: "dns_RP_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.RRSIG": {
    deprecatedKeyName: "dns_RRSIG",
    validationRegex: null,
    deprecated: !1
  },
  "dns.RRSIG.ttl": {
    deprecatedKeyName: "dns_RRSIG_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SIG": {
    deprecatedKeyName: "dns_SIG",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SIG.ttl": {
    deprecatedKeyName: "dns_SIG_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SMIMEA": {
    deprecatedKeyName: "dns_SMIMEA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SMIMEA.ttl": {
    deprecatedKeyName: "dns_SMIMEA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SOA": {
    deprecatedKeyName: "dns_SOA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SOA.ttl": {
    deprecatedKeyName: "dns_SOA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SRV": {
    deprecatedKeyName: "dns_SRV",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SRV.ttl": {
    deprecatedKeyName: "dns_SRV_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SSHFP": {
    deprecatedKeyName: "dns_SSHFP",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SSHFP.ttl": {
    deprecatedKeyName: "dns_SSHFP_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SVCB": {
    deprecatedKeyName: "dns_SVCB",
    validationRegex: null,
    deprecated: !1
  },
  "dns.SVCB.ttl": {
    deprecatedKeyName: "dns_SVCB_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TA": {
    deprecatedKeyName: "dns_TA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TA.ttl": {
    deprecatedKeyName: "dns_TA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TKEY": {
    deprecatedKeyName: "dns_TKEY",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TKEY.ttl": {
    deprecatedKeyName: "dns_TKEY_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TLSA": {
    deprecatedKeyName: "dns_TLSA",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TLSA.ttl": {
    deprecatedKeyName: "dns_TLSA_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TSIG": {
    deprecatedKeyName: "dns_TSIG",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TSIG.ttl": {
    deprecatedKeyName: "dns_TSIG_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TXT": {
    deprecatedKeyName: "dns_TXT",
    validationRegex: null,
    deprecated: !1
  },
  "dns.TXT.ttl": {
    deprecatedKeyName: "dns_TXT_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.URI": {
    deprecatedKeyName: "dns_URI",
    validationRegex: null,
    deprecated: !1
  },
  "dns.URI.ttl": {
    deprecatedKeyName: "dns_URI_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "dns.ZONEMD": {
    deprecatedKeyName: "dns_ZONEMD",
    validationRegex: null,
    deprecated: !1
  },
  "dns.ZONEMD.ttl": {
    deprecatedKeyName: "dns_ZONEMD_ttl",
    validationRegex: null,
    deprecated: !1
  },
  "crypto.DOT.address": {
    deprecatedKeyName: "DOT",
    validationRegex: "^1[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UNI.version.ERC20.address": {
    deprecatedKeyName: "UNI_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.UNI.version.BEP20.address": {
    deprecatedKeyName: "UNI_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.UNI.version.MATIC.address": {
    deprecatedKeyName: "UNI_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UNI.version.HRC20.address": {
    deprecatedKeyName: "UNI_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.UNI.version.XDAI.address": {
    deprecatedKeyName: "UNI_XDAI",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SOL.address": {
    deprecatedKeyName: "SOL",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.BUSD.version.ERC20.address": {
    deprecatedKeyName: "BUSD_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BUSD.version.BEP20.address": {
    deprecatedKeyName: "BUSD_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BUSD.version.HRC20.address": {
    deprecatedKeyName: "BUSD_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ICP.address": {
    deprecatedKeyName: "ICP",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.THETA.address": {
    deprecatedKeyName: "THETA",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.WBTC.version.ERC20.address": {
    deprecatedKeyName: "WBTC_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WBTC.version.MATIC.address": {
    deprecatedKeyName: "WBTC_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.WBTC.version.FANTOM.address": {
    deprecatedKeyName: "WBTC_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.WBTC.version.HRC20.address": {
    deprecatedKeyName: "WBTC_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WBTC.version.XDAI.address": {
    deprecatedKeyName: "WBTC_XDAI",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.FIL.address": {
    deprecatedKeyName: "FIL",
    validationRegex: "^f[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CDAI.address": {
    deprecatedKeyName: "CDAI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KSM.address": {
    deprecatedKeyName: "KSM",
    validationRegex: "^[CDEFGHJ][a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.OKB.address": {
    deprecatedKeyName: "OKB",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AAVE.version.ERC20.address": {
    deprecatedKeyName: "AAVE_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AAVE.version.MATIC.address": {
    deprecatedKeyName: "AAVE_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.AAVE.version.FANTOM.address": {
    deprecatedKeyName: "AAVE_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.AAVE.version.HRC20.address": {
    deprecatedKeyName: "AAVE_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BLOCKS.address": {
    deprecatedKeyName: "BLOCKS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SHIB.version.ERC20.address": {
    deprecatedKeyName: "SHIB_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SHIB.version.MATIC.address": {
    deprecatedKeyName: "SHIB_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SHIB.version.FANTOM.address": {
    deprecatedKeyName: "SHIB_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CEL.version.ERC20.address": {
    deprecatedKeyName: "CEL_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CEL.version.MATIC.address": {
    deprecatedKeyName: "CEL_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CEL.version.FANTOM.address": {
    deprecatedKeyName: "CEL_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CEL.version.HRC20.address": {
    deprecatedKeyName: "CEL_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CUSDC.address": {
    deprecatedKeyName: "CUSDC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CETH.address": {
    deprecatedKeyName: "CETH",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AMP.address": {
    deprecatedKeyName: "AMP",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CAKE.version.BEP20.address": {
    deprecatedKeyName: "CAKE_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CAKE.version.HRC20.address": {
    deprecatedKeyName: "CAKE_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MIOTA.address": {
    deprecatedKeyName: "MIOTA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.FTT.address": {
    deprecatedKeyName: "FTT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MKR.address": {
    deprecatedKeyName: "MKR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TFUEL.address": {
    deprecatedKeyName: "TFUEL",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.KLAY.address": {
    deprecatedKeyName: "KLAY",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.LUNA.address": {
    deprecatedKeyName: "LUNA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.AVAX.address": {
    deprecatedKeyName: "AVAX",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.LEO.address": {
    deprecatedKeyName: "LEO",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SAFEMOON.version.BEP20.address": {
    deprecatedKeyName: "SAFEMOON_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SAFEMOON.version.HRC20.address": {
    deprecatedKeyName: "SAFEMOON_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.UST.address": {
    deprecatedKeyName: "UST",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RUNE.address": {
    deprecatedKeyName: "RUNE",
    validationRegex: "^thor[a-zA-HJ-NP-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.HBAR.address": {
    deprecatedKeyName: "HBAR",
    validationRegex: "^(0|(?:[1-9]\\d*))\\.(0|(?:[1-9]\\d*))\\.(0|(?:[1-9]\\d*))(?:-([a-z]{5}))?$",
    deprecated: !1
  },
  "crypto.TEL.version.ERC20.address": {
    deprecatedKeyName: "TEL_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TEL.version.MATIC.address": {
    deprecatedKeyName: "TEL_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CHZ.address": {
    deprecatedKeyName: "CHZ",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SUSHI.version.ERC20.address": {
    deprecatedKeyName: "SUSHI_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SUSHI.version.BEP20.address": {
    deprecatedKeyName: "SUSHI_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SUSHI.version.MATIC.address": {
    deprecatedKeyName: "SUSHI_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SUSHI.version.FANTOM.address": {
    deprecatedKeyName: "SUSHI_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SUSHI.version.HRC20.address": {
    deprecatedKeyName: "SUSHI_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.EGLD.address": {
    deprecatedKeyName: "EGLD",
    validationRegex: "^erd[a-zA-Z0-9]{59}$",
    deprecated: !1
  },
  "crypto.TUSD.version.ERC20.address": {
    deprecatedKeyName: "TUSD_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TUSD.version.BEP20.address": {
    deprecatedKeyName: "TUSD_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TUSD.version.AVAX.address": {
    deprecatedKeyName: "TUSD_AVAX",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.TUSD.version.HRC20.address": {
    deprecatedKeyName: "TUSD_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TUSD.version.BEP2.address": {
    deprecatedKeyName: "TUSD_BEP2",
    validationRegex: "^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.TUSD.version.TRON.address": {
    deprecatedKeyName: "TUSD_TRON",
    validationRegex: "^[T][a-zA-HJ-NP-Z0-9]{33}$",
    deprecated: !1
  },
  "crypto.HBTC.version.ERC20.address": {
    deprecatedKeyName: "HBTC_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HBTC.version.HRC20.address": {
    deprecatedKeyName: "HBTC_HRC20",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SNX.version.ERC20.address": {
    deprecatedKeyName: "SNX_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SNX.version.MATIC.address": {
    deprecatedKeyName: "SNX_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SNX.version.FANTOM.address": {
    deprecatedKeyName: "SNX_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SNX.version.HRC20.address": {
    deprecatedKeyName: "SNX_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HOT.version.ERC20.address": {
    deprecatedKeyName: "HOT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HOT.version.HRC20.address": {
    deprecatedKeyName: "HOT_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NEAR.address": {
    deprecatedKeyName: "NEAR",
    validationRegex: "^((([a-z\\d]+[\\-_])*[a-z\\d]+\\.)*([a-z\\d]+[\\-_])*[a-z\\d]+)|([a-f0-9]{64})$",
    deprecated: !1
  },
  "crypto.HNT.address": {
    deprecatedKeyName: "HNT",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.STETH.address": {
    deprecatedKeyName: "STETH",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NEXO.version.ERC20.address": {
    deprecatedKeyName: "NEXO_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NEXO.version.FANTOM.address": {
    deprecatedKeyName: "NEXO_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.PAX.address": {
    deprecatedKeyName: "PAX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.STX.address": {
    deprecatedKeyName: "STX",
    validationRegex: "^SP[A-Z0-9]{38,39}$",
    deprecated: !1
  },
  "crypto.MANA.version.ERC20.address": {
    deprecatedKeyName: "MANA_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MANA.version.MATIC.address": {
    deprecatedKeyName: "MANA_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.MDX.version.HRC20.address": {
    deprecatedKeyName: "MDX_HRC20",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.MDX.version.BEP20.address": {
    deprecatedKeyName: "MDX_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ZEN.address": {
    deprecatedKeyName: "ZEN",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ARRR.address": {
    deprecatedKeyName: "ARRR",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.BNT.address": {
    deprecatedKeyName: "BNT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LUSD.version.ERC20.address": {
    deprecatedKeyName: "LUSD_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LUSD.version.MATIC.address": {
    deprecatedKeyName: "LUSD_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.GRT.version.ERC20.address": {
    deprecatedKeyName: "GRT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GRT.version.MATIC.address": {
    deprecatedKeyName: "GRT_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.GRT.version.HRC20.address": {
    deprecatedKeyName: "GRT_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SC.address": {
    deprecatedKeyName: "SC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.HUSD.version.ERC20.address": {
    deprecatedKeyName: "HUSD_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HUSD.version.HRC20.address": {
    deprecatedKeyName: "HUSD_HRC20",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CRV.version.ERC20.address": {
    deprecatedKeyName: "CRV_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CRV.version.MATIC.address": {
    deprecatedKeyName: "CRV_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.CRV.version.FANTOM.address": {
    deprecatedKeyName: "CRV_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UMA.address": {
    deprecatedKeyName: "UMA",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WRX.version.BEP2.address": {
    deprecatedKeyName: "WRX_BEP2",
    validationRegex: "^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.WRX.version.MATIC.address": {
    deprecatedKeyName: "WRX_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.AR.address": {
    deprecatedKeyName: "AR",
    validationRegex: "^[a-zA-Z0-9-_]{43}$",
    deprecated: !1
  },
  "crypto.OMG.address": {
    deprecatedKeyName: "OMG",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GT.address": {
    deprecatedKeyName: "GT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.QNT.address": {
    deprecatedKeyName: "QNT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CHSB.address": {
    deprecatedKeyName: "CHSB",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.IOST.address": {
    deprecatedKeyName: "IOST",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.NXM.address": {
    deprecatedKeyName: "NXM",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KCS.address": {
    deprecatedKeyName: "KCS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LPT.version.ERC20.address": {
    deprecatedKeyName: "LPT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LPT.version.HRC20.address": {
    deprecatedKeyName: "LPT_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XSUSHI.address": {
    deprecatedKeyName: "XSUSHI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CUSDT.address": {
    deprecatedKeyName: "CUSDT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FLOW.address": {
    deprecatedKeyName: "FLOW",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ANKR.address": {
    deprecatedKeyName: "ANKR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HBC.address": {
    deprecatedKeyName: "HBC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.VGX.address": {
    deprecatedKeyName: "VGX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FEI.address": {
    deprecatedKeyName: "FEI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BAKE.version.BEP20.address": {
    deprecatedKeyName: "BAKE_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BAKE.version.HRC20.address": {
    deprecatedKeyName: "BAKE_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.1INCH.version.ERC20.address": {
    deprecatedKeyName: "1INCH_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.1INCH.version.BEP20.address": {
    deprecatedKeyName: "1INCH_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.1INCH.version.MATIC.address": {
    deprecatedKeyName: "1INCH_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.1INCH.version.HRC20.address": {
    deprecatedKeyName: "1INCH_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CKB.address": {
    deprecatedKeyName: "CKB",
    validationRegex: "^ckb1q[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.WOO.version.ERC20.address": {
    deprecatedKeyName: "WOO_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WOO.version.HRC20.address": {
    deprecatedKeyName: "WOO_HRC20",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.TITAN.address": {
    deprecatedKeyName: "TITAN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.OMI.address": {
    deprecatedKeyName: "OMI",
    validationRegex: "^0x[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.MINA.address": {
    deprecatedKeyName: "MINA",
    validationRegex: "^B62[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SETH.address": {
    deprecatedKeyName: "SETH",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RSR.address": {
    deprecatedKeyName: "RSR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.OXY.version.SOLANA.address": {
    deprecatedKeyName: "OXY_SOLANA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.OXY.version.ERC20.address": {
    deprecatedKeyName: "OXY_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.REN.version.ERC20.address": {
    deprecatedKeyName: "REN_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.REN.version.HRC20.address": {
    deprecatedKeyName: "REN_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XCH.address": {
    deprecatedKeyName: "XCH",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.RENBTC.version.ERC20.address": {
    deprecatedKeyName: "RENBTC_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RENBTC.version.BEP20.address": {
    deprecatedKeyName: "RENBTC_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RENBTC.version.HRC20.address": {
    deprecatedKeyName: "RENBTC_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDN.address": {
    deprecatedKeyName: "USDN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BCHA.address": {
    deprecatedKeyName: "BCHA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.LRC.address": {
    deprecatedKeyName: "LRC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.PUNDIX.address": {
    deprecatedKeyName: "PUNDIX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ERG.address": {
    deprecatedKeyName: "ERG",
    validationRegex: "^[a-zA-Z0-9]{51}$",
    deprecated: !1
  },
  "crypto.WIN.address": {
    deprecatedKeyName: "WIN",
    validationRegex: "^[T][a-zA-HJ-NP-Z0-9]{33}$",
    deprecated: !1
  },
  "crypto.NPXS.address": {
    deprecatedKeyName: "NPXS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TRIBE.address": {
    deprecatedKeyName: "TRIBE",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MAID.address": {
    deprecatedKeyName: "MAID",
    validationRegex: "^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$",
    deprecated: !1
  },
  "crypto.ASD.address": {
    deprecatedKeyName: "ASD",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CUNI.address": {
    deprecatedKeyName: "CUNI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CELO.address": {
    deprecatedKeyName: "CELO",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.DENT.address": {
    deprecatedKeyName: "DENT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SNT.address": {
    deprecatedKeyName: "SNT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FEG.version.ERC20.address": {
    deprecatedKeyName: "FEG_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FEG.version.HRC20.address": {
    deprecatedKeyName: "FEG_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SKL.address": {
    deprecatedKeyName: "SKL",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ALUSD.address": {
    deprecatedKeyName: "ALUSD",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MIR.version.ERC20.address": {
    deprecatedKeyName: "MIR_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MIR.version.BEP20.address": {
    deprecatedKeyName: "MIR_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GLM.address": {
    deprecatedKeyName: "GLM",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.PAXG.version.ERC20.address": {
    deprecatedKeyName: "PAXG_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.PAXG.version.HRC20.address": {
    deprecatedKeyName: "PAXG_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CFX.address": {
    deprecatedKeyName: "CFX",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UOS.address": {
    deprecatedKeyName: "UOS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SVCS.address": {
    deprecatedKeyName: "SVCS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.REEF.version.ERC20.address": {
    deprecatedKeyName: "REEF_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.REEF.version.BEP20.address": {
    deprecatedKeyName: "REEF_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.REEF.version.HRC20.address": {
    deprecatedKeyName: "REEF_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GNO.address": {
    deprecatedKeyName: "GNO",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.USDP.address": {
    deprecatedKeyName: "USDP",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KAVA.address": {
    deprecatedKeyName: "KAVA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ALCX.address": {
    deprecatedKeyName: "ALCX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.EWT.address": {
    deprecatedKeyName: "EWT",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.TON.address": {
    deprecatedKeyName: "TON",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RLC.address": {
    deprecatedKeyName: "RLC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AXS.address": {
    deprecatedKeyName: "AXS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AUDIO.address": {
    deprecatedKeyName: "AUDIO",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XVS.address": {
    deprecatedKeyName: "XVS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BAND.version.ERC20.address": {
    deprecatedKeyName: "BAND_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.BAND.version.FANTOM.address": {
    deprecatedKeyName: "BAND_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.NMR.address": {
    deprecatedKeyName: "NMR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.INJ.version.ERC20.address": {
    deprecatedKeyName: "INJ_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.INJ.version.BEP20.address": {
    deprecatedKeyName: "INJ_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.WAXP.address": {
    deprecatedKeyName: "WAXP",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UQC.address": {
    deprecatedKeyName: "UQC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.IOTX.address": {
    deprecatedKeyName: "IOTX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FUN.address": {
    deprecatedKeyName: "FUN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.OCEAN.address": {
    deprecatedKeyName: "OCEAN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SAND.version.ERC20.address": {
    deprecatedKeyName: "SAND_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SAND.version.HRC20.address": {
    deprecatedKeyName: "SAND_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CTSI.version.ERC20.address": {
    deprecatedKeyName: "CTSI_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CTSI.version.BEP20.address": {
    deprecatedKeyName: "CTSI_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CTSI.version.MATIC.address": {
    deprecatedKeyName: "CTSI_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.RAY.address": {
    deprecatedKeyName: "RAY",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ANC.version.TERRA.address": {
    deprecatedKeyName: "ANC_TERRA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ANC.version.ERC20.address": {
    deprecatedKeyName: "ANC_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.IQ.version.ERC20.address": {
    deprecatedKeyName: "IQ_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.IQ.version.BEP20.address": {
    deprecatedKeyName: "IQ_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.IQ.version.MATIC.address": {
    deprecatedKeyName: "IQ_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SUSD.version.ERC20.address": {
    deprecatedKeyName: "SUSD_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SUSD.version.FANTOM.address": {
    deprecatedKeyName: "SUSD_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.KLV.address": {
    deprecatedKeyName: "KLV",
    validationRegex: "^((k|K)(l|L)(v|V))[a-zA-Z0-9]{59}$",
    deprecated: !1
  },
  "crypto.BTCST.address": {
    deprecatedKeyName: "BTCST",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TLM.address": {
    deprecatedKeyName: "TLM",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AKT.address": {
    deprecatedKeyName: "AKT",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.STMX.address": {
    deprecatedKeyName: "STMX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.PROM.address": {
    deprecatedKeyName: "PROM",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XPRT.address": {
    deprecatedKeyName: "XPRT",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.SRM.version.ERC20.address": {
    deprecatedKeyName: "SRM_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SRM.version.SOLANA.address": {
    deprecatedKeyName: "SRM_SOLANA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.RPL.address": {
    deprecatedKeyName: "RPL",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AGIX.address": {
    deprecatedKeyName: "AGIX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CELR.address": {
    deprecatedKeyName: "CELR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FET.address": {
    deprecatedKeyName: "FET",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !0
  },
  "crypto.FET.version.ERC20.address": {
    deprecatedKeyName: "FET_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.FET.version.FETCHAI.address": {
    deprecatedKeyName: "FET_FETCHAI",
    validationRegex: "^fetch[a-zA-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.OXT.address": {
    deprecatedKeyName: "OXT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ARDR.address": {
    deprecatedKeyName: "ARDR",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.MATH.address": {
    deprecatedKeyName: "MATH",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.10SET.address": {
    deprecatedKeyName: "10SET",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.POLY.address": {
    deprecatedKeyName: "POLY",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GUSD.address": {
    deprecatedKeyName: "GUSD",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NKN.address": {
    deprecatedKeyName: "NKN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CVC.address": {
    deprecatedKeyName: "CVC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.GTC.address": {
    deprecatedKeyName: "GTC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.STEEM.address": {
    deprecatedKeyName: "STEEM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ORN.address": {
    deprecatedKeyName: "ORN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KEEP.version.ERC20.address": {
    deprecatedKeyName: "KEEP_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KEEP.version.HRC20.address": {
    deprecatedKeyName: "KEEP_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HXRO.address": {
    deprecatedKeyName: "HXRO",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ORBS.address": {
    deprecatedKeyName: "ORBS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ALPHA.version.ERC20.address": {
    deprecatedKeyName: "ALPHA_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ALPHA.version.BEP20.address": {
    deprecatedKeyName: "ALPHA_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MCONTENT.version.ERC20.address": {
    deprecatedKeyName: "MCONTENT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MCONTENT.version.BEP20.address": {
    deprecatedKeyName: "MCONTENT_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.DODO.version.ERC20.address": {
    deprecatedKeyName: "DODO_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.DODO.version.BEP20.address": {
    deprecatedKeyName: "DODO_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.OGN.address": {
    deprecatedKeyName: "OGN",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KNCL.version.ERC20.address": {
    deprecatedKeyName: "KNCL_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KNCL.version.FANTOM.address": {
    deprecatedKeyName: "KNCL_FANTOM",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.KNCL.version.HRC20.address": {
    deprecatedKeyName: "KNCL_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MED.address": {
    deprecatedKeyName: "MED",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.XAUT.address": {
    deprecatedKeyName: "XAUT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.VLX.address": {
    deprecatedKeyName: "VLX",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.PHA.address": {
    deprecatedKeyName: "PHA",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.KOBE.address": {
    deprecatedKeyName: "KOBE",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.PERP.address": {
    deprecatedKeyName: "PERP",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XHV.address": {
    deprecatedKeyName: "XHV",
    validationRegex: "^hv[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.META.address": {
    deprecatedKeyName: "META",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SEUR.address": {
    deprecatedKeyName: "SEUR",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.MONA.address": {
    deprecatedKeyName: "MONA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ANT.address": {
    deprecatedKeyName: "ANT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HYDRA.address": {
    deprecatedKeyName: "HYDRA",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.ZKS.address": {
    deprecatedKeyName: "ZKS",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SXP.version.ERC20.address": {
    deprecatedKeyName: "SXP_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SXP.version.BEP20.address": {
    deprecatedKeyName: "SXP_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SXP.version.HRC20.address": {
    deprecatedKeyName: "SXP_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.CSPR.address": {
    deprecatedKeyName: "CSPR",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.MTL.address": {
    deprecatedKeyName: "MTL",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NU.address": {
    deprecatedKeyName: "NU",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ZMT.address": {
    deprecatedKeyName: "ZMT",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.LOC.address": {
    deprecatedKeyName: "LOC",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.TKO.address": {
    deprecatedKeyName: "TKO",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.ETN.address": {
    deprecatedKeyName: "ETN",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.UBT.version.ERC20.address": {
    deprecatedKeyName: "UBT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.UBT.version.MATIC.address": {
    deprecatedKeyName: "UBT_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.EXRD.address": {
    deprecatedKeyName: "EXRD",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NMX.address": {
    deprecatedKeyName: "NMX",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.RIF.address": {
    deprecatedKeyName: "RIF",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.STORJ.version.ERC20.address": {
    deprecatedKeyName: "STORJ_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.STORJ.version.HRC20.address": {
    deprecatedKeyName: "STORJ_HRC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.AVA.address": {
    deprecatedKeyName: "AVA",
    validationRegex: "^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.DPI.version.ERC20.address": {
    deprecatedKeyName: "DPI_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.DPI.version.MATIC.address": {
    deprecatedKeyName: "DPI_MATIC",
    validationRegex: "^[a-zA-Z0-9]*$",
    deprecated: !1
  },
  "crypto.DOG.version.MATIC.address": {
    deprecatedKeyName: "DOG_MATIC",
    validationRegex: null,
    deprecated: !1
  },
  "crypto.DOG.version.BEP20.address": {
    deprecatedKeyName: "DOG_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.DOG.version.ERC20.address": {
    deprecatedKeyName: "DOG_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.DOG.version.AETH.address": {
    deprecatedKeyName: "DOG_AETH",
    validationRegex: null,
    deprecated: !1
  },
  "crypto.DOG.version.OP.address": {
    deprecatedKeyName: "DOG_OP",
    validationRegex: null,
    deprecated: !1
  },
  "crypto.GALA.version.ERC20.address": {
    deprecatedKeyName: "GALA_ERC20",
    validationRegex: "^0x[a-zA-Z0-9]{40}$",
    deprecated: !1
  },
  "crypto.GALA.version.BEP20.address": {
    deprecatedKeyName: "GALA_BEP20",
    validationRegex: "^0x[a-zA-Z0-9]{40}$",
    deprecated: !1
  },
  "crypto.MOBX.address": {
    deprecatedKeyName: "MOBX",
    validationRegex: "^fetch[a-zA-Z0-9]{39}$",
    deprecated: !1
  },
  "crypto.FAB.address": {
    deprecatedKeyName: "FAB",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{34}$"
  },
  "crypto.BEAM.address": {
    deprecatedKeyName: "BEAM",
    deprecated: !1,
    validationRegex: null
  },
  "crypto.DESO.address": {
    deprecatedKeyName: "DESO",
    deprecated: !1,
    validationRegex: "^[a-zA-Z0-9]{54,55}$"
  },
  "crypto.FLR.address": {
    deprecatedKeyName: "FLR",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.SGB.address": {
    deprecatedKeyName: "SGB",
    deprecated: !1,
    validationRegex: "^0x[a-fA-F0-9]{40}$"
  },
  "crypto.0ZK.version.ERC20.address": {
    deprecatedKeyName: "0ZK_ERC20",
    validationRegex: "(^0zk1)([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{52})([qzyxg2vwsj5kc6u7])(unpd9kxwatwq)([qpzry9x8])([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{57})",
    deprecated: !1
  },
  "crypto.0ZK.version.BEP20.address": {
    deprecatedKeyName: "0ZK_BEP20",
    validationRegex: "(^0zk1)([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{52})([qzyxg2vwsj5kc6u7])(unpd9kxwatw8)([qpzry9x8])([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{57})",
    deprecated: !1
  },
  "crypto.0ZK.version.MATIC.address": {
    deprecatedKeyName: "0ZK_MATIC",
    validationRegex: "(^0zk1)([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{52})([qzyxg2vwsj5kc6u7])(unpd9kxwatw3)([qpzry9x8])([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{57})",
    deprecated: !1
  },
  "crypto.0ZK.version.0ZK.address": {
    deprecatedKeyName: "0ZK_0ZK",
    validationRegex: "(^0zk1)([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{52})([pr98ftd03n4hemal])(rv7j6fe3z53l)([ce6mua7l])([qpzry9x8gf2tvdw0s3jn54khce6mua7l]{57})",
    deprecated: !1
  },
  "crypto.SUI.address": {
    deprecatedKeyName: "SUI",
    validationRegex: "^0x([0-9a-fA-F]{64}|[a-fA-F0-9]{40})$",
    deprecated: !1
  },
  "crypto.MOON.address": {
    deprecatedKeyName: "MOON",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SWEAT.version.ERC20.address": {
    deprecatedKeyName: "SWEAT_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.SWEAT.version.NEP-141.address": {
    deprecatedKeyName: "SWEAT_NEP-141",
    validationRegex: "^([a-f0-9]{64})|([a-z\\d_-]{2,59}\\.near)$",
    deprecated: !1
  },
  "crypto.POKT.address": {
    deprecatedKeyName: "POKT",
    validationRegex: "^[0-9a-fA-F]{40}$",
    deprecated: !1
  },
  "crypto.KAI.address": {
    deprecatedKeyName: "KAI",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.XLA.address": {
    deprecatedKeyName: "XLA",
    validationRegex: "^(S|Ss)+([1-9A-HJ-NP-Za-km-z]{96})$",
    deprecated: !1
  },
  "crypto.APT.address": {
    deprecatedKeyName: "APT",
    validationRegex: "^0x[a-f0-9]{64}$",
    deprecated: !1
  },
  "crypto.GTH.address": {
    deprecatedKeyName: "GTH",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HI.version.ERC20.address": {
    deprecatedKeyName: "HI_ERC20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.HI.version.BEP20.address": {
    deprecatedKeyName: "HI_BEP20",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.VERSE.address": {
    deprecatedKeyName: "VERSE",
    validationRegex: "^0x[a-fA-F0-9]{40}$",
    deprecated: !1
  },
  "crypto.NIBI.address": {
    deprecatedKeyName: "NIBI",
    validationRegex: "^nibi1[a-z0-9]{38}$",
    deprecated: !1
  }
}, require$$11 = {
  version,
  information,
  keys
};
var __extends$1 = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var c = function(t, n) {
    return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ie, fe) {
      ie.__proto__ = fe;
    } || function(ie, fe) {
      for (var ae in fe) Object.prototype.hasOwnProperty.call(fe, ae) && (ie[ae] = fe[ae]);
    }, c(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    c(t, n);
    function ie() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (ie.prototype = n.prototype, new ie());
  };
}(), __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign = Object.assign || function(c) {
    for (var t, n = 1, ie = arguments.length; n < ie; n++) {
      t = arguments[n];
      for (var fe in t) Object.prototype.hasOwnProperty.call(t, fe) && (c[fe] = t[fe]);
    }
    return c;
  }, __assign.apply(this, arguments);
}, __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$4(t, c, n);
  return __setModuleDefault$4(t, c), t;
}, __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$3 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __asyncValues = commonjsGlobal && commonjsGlobal.__asyncValues || function(c) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = c[Symbol.asyncIterator], n;
  return t ? t.call(c) : (c = typeof __values == "function" ? __values(c) : c[Symbol.iterator](), n = {}, ie("next"), ie("throw"), ie("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function ie(ae) {
    n[ae] = c[ae] && function(le) {
      return new Promise(function(he, me) {
        le = c[ae](le), fe(he, me, le.done, le.value);
      });
    };
  }
  function fe(ae, le, he, me) {
    Promise.resolve(me).then(function(ye) {
      ae({ value: ye, done: he });
    }, le);
  }
}, __spreadArray$1 = commonjsGlobal && commonjsGlobal.__spreadArray || function(c, t, n) {
  if (n || arguments.length === 2) for (var ie = 0, fe = t.length, ae; ie < fe; ie++)
    (ae || !(ie in t)) && (ae || (ae = Array.prototype.slice.call(t, 0, ie)), ae[ie] = t[ie]);
  return c.concat(ae || Array.prototype.slice.call(t));
}, __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Uns$1, "__esModule", { value: !0 });
var types_1 = types$3, resolutionError_1$4 = __importStar$4(resolutionError), utils_1$2 = utils$e, publicTypes_1$3 = publicTypes, TwitterSignatureValidator_1$1 = TwitterSignatureValidator, FetchProvider_1 = __importDefault$2(FetchProvider$1), namehash_1$2 = namehash, NamingService_1$1 = NamingService$1, configurationError_1$2 = __importStar$4(configurationError), UnsInternal_1 = __importDefault$2(UnsInternal$1), Networking_1$2 = __importDefault$2(Networking$1), resolver_keys_json_1 = __importDefault$2(require$$11), ensureValidSourceConfig = function(c) {
  var t;
  if (!c.locations || !c.locations.Layer1 || !c.locations.Layer2)
    throw new configurationError_1$2.default(configurationError_1$2.ConfigurationErrorCode.NetworkConfigMissing, {
      method: publicTypes_1$3.NamingServiceName.UNS,
      config: !((t = c == null ? void 0 : c.locations) === null || t === void 0) && t.Layer1 ? "Layer2" : "Layer1"
    });
  var n = c.locations.Layer1;
  if (!n.url && !n.provider)
    throw new configurationError_1$2.default(configurationError_1$2.ConfigurationErrorCode.NetworkConfigMissing, {
      method: publicTypes_1$3.NamingServiceName.UNS,
      config: "Layer1.url"
    });
  var ie = c.locations.Layer2;
  if (!ie.url && !ie.provider)
    throw new configurationError_1$2.default(configurationError_1$2.ConfigurationErrorCode.NetworkConfigMissing, {
      method: publicTypes_1$3.NamingServiceName.UNS,
      config: "Layer2.url"
    });
}, Uns = (
  /** @class */
  function(c) {
    __extends$1(t, c);
    function t(n) {
      var ie = this, fe, ae;
      return ie = c.call(this) || this, ie.name = publicTypes_1$3.NamingServiceName.UNS, n ? ensureValidSourceConfig(n) : n = {
        locations: {
          Layer1: {
            url: "",
            network: "mainnet"
          },
          Layer2: {
            url: "",
            network: "polygon-mainnet"
          }
        }
      }, ie.unsl1 = new UnsInternal_1.default(publicTypes_1$3.UnsLocation.Layer1, n.locations.Layer1, (fe = n.locations.Layer1.blockchain) !== null && fe !== void 0 ? fe : publicTypes_1$3.BlockchainType.ETH), ie.unsl2 = new UnsInternal_1.default(publicTypes_1$3.UnsLocation.Layer2, n.locations.Layer2, (ae = n.locations.Layer2.blockchain) !== null && ae !== void 0 ? ae : publicTypes_1$3.BlockchainType.POL), ie;
    }
    return t.autoNetwork = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me;
        return __generator$3(this, function(ye) {
          switch (ye.label) {
            case 0:
              if ((0, types_1.hasProvider)(n.locations.Layer1) && (0, types_1.hasProvider)(n.locations.Layer2))
                ie = n.locations.Layer1.provider, fe = n.locations.Layer2.provider;
              else {
                if (!n.locations.Layer1.url || !n.locations.Layer2.url)
                  throw new configurationError_1$2.default(configurationError_1$2.ConfigurationErrorCode.UnspecifiedUrl, {
                    method: publicTypes_1$3.NamingServiceName.UNS
                  });
                ie = FetchProvider_1.default.factory(publicTypes_1$3.NamingServiceName.UNS, n.locations.Layer1.url), fe = FetchProvider_1.default.factory(publicTypes_1$3.NamingServiceName.UNS, n.locations.Layer2.url);
              }
              return [4, ie.request({
                method: "net_version"
              })];
            case 1:
              return ae = ye.sent(), [4, fe.request({
                method: "net_version"
              })];
            case 2:
              if (le = ye.sent(), he = utils_1$2.EthereumNetworksInverted[ae], me = utils_1$2.EthereumNetworksInverted[le], !he || !types_1.UnsSupportedNetwork.guard(he) || !me || !types_1.UnsSupportedNetwork.guard(me))
                throw new configurationError_1$2.default(configurationError_1$2.ConfigurationErrorCode.UnsupportedNetwork, {
                  method: publicTypes_1$3.NamingServiceName.UNS
                });
              return [2, new this({
                locations: {
                  Layer1: { network: he, provider: ie },
                  Layer2: { network: me, provider: fe }
                }
              })];
          }
        });
      });
    }, t.prototype.namehash = function(n) {
      if (!this.checkDomain(n))
        throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnsupportedDomain, {
          domain: n
        });
      return (0, namehash_1$2.eip137Namehash)(n);
    }, t.prototype.childhash = function(n, ie) {
      return (0, namehash_1$2.eip137Childhash)(n, ie);
    }, t.prototype.isSupportedDomain = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$3(this, function(he) {
          switch (he.label) {
            case 0:
              return this.checkDomain(n) ? (ie = n.split(".").pop(), ie ? [4, Promise.all([
                this.unsl1.exists(ie),
                this.unsl2.exists(ie)
              ])] : [2, !1]) : [2, !1];
            case 1:
              return fe = he.sent(), ae = fe[0], le = fe[1], [2, ae || le];
          }
        });
      });
    }, t.prototype.owner = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$3(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.namehash(n), [4, this.get(ie, [])];
            case 1:
              if (fe = ae.sent(), (0, utils_1$2.isNullAddress)(fe.owner))
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              return [2, fe.owner];
          }
        });
      });
    }, t.prototype.resolver = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator$3(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.getVerifiedData(n)];
            case 1:
              return [2, ie.sent().resolver];
          }
        });
      });
    }, t.prototype.record = function(n, ie) {
      return __awaiter$3(this, void 0, void 0, function() {
        var fe;
        return __generator$3(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.records(n, [ie])];
            case 1:
              if (fe = ae.sent()[ie], !fe)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.RecordNotFound, {
                  recordName: ie,
                  domain: n
                });
              return [2, fe];
          }
        });
      });
    }, t.prototype.records = function(n, ie) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator$3(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.getVerifiedData(n, ie)];
            case 1:
              return [2, fe.sent().records];
          }
        });
      });
    }, t.prototype.allRecords = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator$3(this, function(ie) {
          return [2, this.records(n, __spreadArray$1([], Object.keys(resolver_keys_json_1.default.keys), !0))];
        });
      });
    }, t.prototype.twitter = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me, ye, be;
        return __generator$3(this, function(Ae) {
          switch (Ae.label) {
            case 0:
              return ie = this.namehash(n), fe = [
                "validation.social.twitter.username",
                "social.twitter.username"
              ], [4, this.getVerifiedData(n, fe)];
            case 1:
              if (ae = Ae.sent(), le = ae.records, he = ae.location, me = le["validation.social.twitter.username"], ye = le["social.twitter.username"], (0, utils_1$2.isNullAddress)(me))
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.RecordNotFound, {
                  domain: n,
                  location: he,
                  recordName: "validation.social.twitter.username"
                });
              if (!ye)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.RecordNotFound, {
                  domain: n,
                  location: he,
                  recordName: "social.twitter.username"
                });
              if (be = ae.owner, !(0, TwitterSignatureValidator_1$1.isValidTwitterSignature)({
                tokenId: ie,
                owner: be,
                twitterHandle: ye,
                validationSignature: me
              }))
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.InvalidTwitterVerification, {
                  domain: n
                });
              return [2, ye];
          }
        });
      });
    }, t.prototype.reverse = function(n, ie) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator$3(this, function(fe) {
          throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverse"
          });
        });
      });
    }, t.prototype.isRegistered = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe;
        return __generator$3(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ie = this.namehash(n), [4, this.get(ie, [])];
            case 1:
              return fe = ae.sent(), [2, !(0, utils_1$2.isNullAddress)(fe.owner)];
          }
        });
      });
    }, t.prototype.getTokenUri = function(n) {
      var ie, fe;
      return __awaiter$3(this, void 0, void 0, function() {
        var ae, le, he, me, ye, be = this;
        return __generator$3(this, function(Ae) {
          switch (Ae.label) {
            case 0:
              Ae.trys.push([0, 5, 6, 11]), ae = __asyncValues([
                (0, utils_1$2.wrapResult)(function() {
                  return be.unsl2.getTokenUri(n);
                }),
                (0, utils_1$2.wrapResult)(function() {
                  return be.unsl1.getTokenUri(n);
                })
              ]), Ae.label = 1;
            case 1:
              return [4, ae.next()];
            case 2:
              if (le = Ae.sent(), !!le.done) return [3, 4];
              if (he = le.value, me = (0, utils_1$2.unwrapResult)(he), me)
                return [2, me];
              Ae.label = 3;
            case 3:
              return [3, 1];
            case 4:
              return [3, 11];
            case 5:
              return ye = Ae.sent(), ie = { error: ye }, [3, 11];
            case 6:
              return Ae.trys.push([6, , 9, 10]), le && !le.done && (fe = ae.return) ? [4, fe.call(ae)] : [3, 8];
            case 7:
              Ae.sent(), Ae.label = 8;
            case 8:
              return [3, 10];
            case 9:
              if (ie) throw ie.error;
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return [
                7
                /*endfinally*/
              ];
            case 11:
              throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnregisteredDomain, {
                domain: "with tokenId ".concat(n)
              });
          }
        });
      });
    }, t.prototype.isAvailable = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        return __generator$3(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.isRegistered(n)];
            case 1:
              return [2, !ie.sent()];
          }
        });
      });
    }, t.prototype.registryAddress = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator$3(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, Promise.all([
                this.unsl1.registryAddress(n).catch(function(he) {
                  return he;
                }),
                this.unsl2.registryAddress(n).catch(function(he) {
                  return he;
                })
              ])];
            case 1:
              if (ie = le.sent(), fe = ie[0], ae = ie[1], ae instanceof Error)
                validResolutionErrorOrThrow(ae, resolutionError_1$4.ResolutionErrorCode.UnregisteredDomain);
              else if (!(0, utils_1$2.isNullAddress)(ae))
                return [2, ae];
              return [2, validResultOrThrow(fe)];
          }
        });
      });
    }, t.prototype.locations = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$3(this, function(he) {
          switch (he.label) {
            case 0:
              return [4, Promise.all([
                this.unsl1.locations(n),
                this.unsl2.locations(n)
              ])];
            case 1:
              return ie = he.sent(), fe = ie[0], ae = ie[1], le = Object.keys(ae).filter(function(me) {
                return ae[me] != null;
              }).reduce(function(me, ye) {
                var be;
                return __assign(__assign({}, me), (be = {}, be[ye] = ae[ye], be));
              }, {}), [2, __assign(__assign({}, fe), le)];
          }
        });
      });
    }, t.prototype.reverseOf = function(n, ie) {
      return __awaiter$3(this, void 0, void 0, function() {
        var fe, ae, le, he, me, ye, be;
        return __generator$3(this, function(Ae) {
          switch (Ae.label) {
            case 0:
              return [4, Promise.all([
                this.unsl1.reverseOf(n).catch(function(Se) {
                  return Se;
                }),
                this.unsl2.reverseOf(n).catch(function(Se) {
                  return Se;
                })
              ])];
            case 1:
              return fe = Ae.sent(), ae = fe[0], le = fe[1], he = function() {
                return validResultOrThrow(ae), ae._hex !== "0x00" ? (0, namehash_1$2.fromHexStringToDecimals)(ae._hex) : null;
              }, me = function() {
                return validResultOrThrow(le), le._hex !== "0x00" ? (0, namehash_1$2.fromHexStringToDecimals)(le._hex) : null;
              }, ie === publicTypes_1$3.UnsLocation.Layer1 ? [2, he()] : ie === publicTypes_1$3.UnsLocation.Layer2 ? [2, me()] : (ye = he(), ye ? [2, ye] : (be = me(), be ? [2, be] : [2, null]));
          }
        });
      });
    }, t.prototype.getAddress = function(n, ie, fe) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ae, le, he, me, ye, be, Ae;
        return __generator$3(this, function(Se) {
          switch (Se.label) {
            case 0:
              return ie = ie.toUpperCase(), fe = fe.toUpperCase(), [4, Promise.all([
                this.unsl1.getAddress(n, ie, fe).catch(function($e) {
                  return $e;
                }),
                this.unsl2.getAddress(n, ie, fe).catch(function($e) {
                  return $e;
                })
              ])];
            case 1:
              return ae = Se.sent(), le = ae[0], he = ae[1], me = function() {
                return validResultOrThrow(le), le !== "" ? le : null;
              }, ye = function() {
                return validResultOrThrow(he), he !== "" ? he : null;
              }, be = ye(), be ? [2, be] : (Ae = me(), Ae ? [2, Ae] : [2, null]);
          }
        });
      });
    }, t.prototype.getDomainFromTokenId = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie;
        return __generator$3(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.getMetadata(n)];
            case 1:
              if (ie = fe.sent(), this.namehash(ie.name) !== n)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.ServiceProviderError, {
                  methodName: "unhash",
                  domain: ie.name,
                  providerMessage: "Service provider returned an invalid domain name"
                });
              return [2, ie.name];
          }
        });
      });
    }, t.prototype.getMetadata = function(n) {
      return __awaiter$3(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator$3(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, this.getTokenUri(n)];
            case 1:
              return ie = le.sent(), [4, Networking_1$2.default.fetch(ie).catch(function(he) {
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.MetadataEndpointError, {
                  tokenUri: ie || "undefined",
                  errorMessage: he.message
                });
              })];
            case 2:
              if (fe = le.sent(), !fe.ok)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.MetadataEndpointError, {
                  tokenUri: ie || "undefined"
                });
              return [4, fe.json()];
            case 3:
              if (ae = le.sent(), !ae.name)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnregisteredDomain, {
                  domain: "with tokenId ".concat(n)
                });
              if (this.namehash(ae.name) !== n)
                throw new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.ServiceProviderError, {
                  methodName: "unhash",
                  domain: ae.name,
                  providerMessage: "Service provider returned an invalid domain name"
                });
              return [2, ae];
          }
        });
      });
    }, t.prototype.getVerifiedData = function(n, ie) {
      return __awaiter$3(this, void 0, void 0, function() {
        var fe, ae;
        return __generator$3(this, function(le) {
          switch (le.label) {
            case 0:
              return fe = this.namehash(n), [4, this.get(fe, ie)];
            case 1:
              if (ae = le.sent(), (0, utils_1$2.isNullAddress)(ae.resolver))
                throw (0, utils_1$2.isNullAddress)(ae.owner) ? new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                }) : new resolutionError_1$4.default(resolutionError_1$4.ResolutionErrorCode.UnspecifiedResolver, {
                  location: ae.location,
                  domain: n
                });
              return [2, ae];
          }
        });
      });
    }, t.prototype.get = function(n, ie) {
      return ie === void 0 && (ie = []), __awaiter$3(this, void 0, void 0, function() {
        var fe, ae, le, he, me, ye, be, Ae, Se;
        return __generator$3(this, function($e) {
          switch ($e.label) {
            case 0:
              return [4, Promise.all([
                this.unsl1.get(n, ie).catch(function(Re) {
                  return Re;
                }),
                this.unsl2.get(n, ie).catch(function(Re) {
                  return Re;
                })
              ])];
            case 1:
              return fe = $e.sent(), ae = fe[0], le = fe[1], validResultOrThrow(le), he = le.resolver, me = le.owner, ye = le.records, (0, utils_1$2.isNullAddress)(me) ? (validResultOrThrow(ae), be = ae.resolver, Ae = ae.owner, Se = ae.records, [2, {
                resolver: be,
                owner: Ae,
                records: (0, utils_1$2.constructRecords)(ie, Se),
                location: publicTypes_1$3.UnsLocation.Layer1
              }]) : [2, {
                resolver: he,
                owner: me,
                records: (0, utils_1$2.constructRecords)(ie, ye),
                location: publicTypes_1$3.UnsLocation.Layer2
              }];
          }
        });
      });
    }, t.prototype.checkDomain = function(n, ie) {
      if (ie === void 0 && (ie = !1), ie)
        return !0;
      var fe = n.split(".");
      return !!fe.length && !(n === "eth" || /^[^-]*[^-]*\.(eth|addr\.reverse)$/.test(n)) && fe.every(function(ae) {
        return !!ae.length;
      });
    }, t;
  }(NamingService_1$1.NamingService)
);
Uns$1.default = Uns;
function validResultOrThrow(c) {
  if (c instanceof Error)
    throw c;
  return c;
}
function validResolutionErrorOrThrow(c, t) {
  if (!(c instanceof resolutionError_1$4.default))
    throw c;
  if (c.code === t)
    return !0;
  throw c;
}
var UdApi$1 = {}, __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var c = function(t, n) {
    return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ie, fe) {
      ie.__proto__ = fe;
    } || function(ie, fe) {
      for (var ae in fe) Object.prototype.hasOwnProperty.call(fe, ae) && (ie[ae] = fe[ae]);
    }, c(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    c(t, n);
    function ie() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (ie.prototype = n.prototype, new ie());
  };
}(), __awaiter$2 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$2 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(UdApi$1, "__esModule", { value: !0 });
var znsUtils_1 = znsUtils, resolutionError_1$3 = resolutionError, TwitterSignatureValidator_1 = TwitterSignatureValidator, publicTypes_1$2 = publicTypes, Networking_1$1 = __importDefault$1(Networking$1), utils_1$1 = utils$e, namehash_1$1 = namehash, NamingService_1 = NamingService$1, UdApi = (
  /** @class */
  function(c) {
    __extends(t, c);
    function t(n) {
      var ie = c.call(this) || this;
      ie.url = (n == null ? void 0 : n.url) || "https://unstoppabledomains.com/api/v1";
      var fe = "cross-fetch/4.0.0 (+https://github.com/lquixada/cross-fetch)", ae = "".concat(fe, " Resolution");
      return ie.headers = { "X-user-agent": ae }, ie;
    }
    return t.prototype.isSupportedDomain = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "isSupportedDomain"
          });
        });
      });
    }, t.prototype.namehash = function(n) {
      throw new Error("Unsupported method when using UD Resolution API");
    }, t.prototype.childhash = function(n, ie) {
      throw new Error("Unsupported method when using UD Resolution API");
    }, t.prototype.record = function(n, ie) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.records(n, [ie])];
            case 1:
              return [2, fe.sent()[ie]];
          }
        });
      });
    }, t.prototype.records = function(n, ie) {
      return __awaiter$2(this, void 0, void 0, function() {
        var fe;
        return __generator$2(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.allRecords(n)];
            case 1:
              return fe = ae.sent(), [2, (0, utils_1$1.constructRecords)(ie, fe)];
          }
        });
      });
    }, t.prototype.owner = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$2(this, function(he) {
          switch (he.label) {
            case 0:
              return [4, this.resolve(n)];
            case 1:
              if (ie = he.sent(), fe = ie.meta, ae = fe.owner, le = fe.blockchain, !ae)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              return le === publicTypes_1$2.BlockchainType.ZIL && !ae.startsWith("zil1") ? [2, (0, znsUtils_1.toBech32Address)(ae)] : [2, ae];
          }
        });
      });
    }, t.prototype.twitter = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me;
        return __generator$2(this, function(ye) {
          switch (ye.label) {
            case 0:
              return [4, (0, utils_1$1.findNamingServiceName)(n)];
            case 1:
              if (ie = ye.sent(), ie !== publicTypes_1$2.NamingServiceName.UNS)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
                  domain: n,
                  methodName: "twitter"
                });
              return [4, this.resolve(n)];
            case 2:
              if (fe = ye.sent(), !fe.meta.owner)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnregisteredDomain, {
                  domain: n
                });
              if (ae = fe.meta.owner, le = fe.records || {}, he = le["validation.social.twitter.username"], me = le["social.twitter.username"], !he)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.RecordNotFound, {
                  recordName: "validation.social.twitter.username",
                  domain: n
                });
              if (!me)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.RecordNotFound, {
                  recordName: "social.twitter.username",
                  domain: n
                });
              if (!(0, TwitterSignatureValidator_1.isValidTwitterSignature)({
                tokenId: fe.meta.namehash,
                owner: ae,
                twitterHandle: me,
                validationSignature: he
              }))
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.InvalidTwitterVerification, {
                  domain: n
                });
              return [2, me];
          }
        });
      });
    }, t.prototype.getAddress = function(n, ie, fe) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ae) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "isSupportedDomain"
          });
        });
      });
    }, t.prototype.allRecords = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.resolve(n)];
            case 1:
              return [2, ie.sent().records || {}];
          }
        });
      });
    }, t.prototype.getDomainFromTokenId = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie;
        return __generator$2(this, function(fe) {
          switch (fe.label) {
            case 0:
              return n = (0, namehash_1$1.fromDecStringToHex)(n), [4, this.getMetadata(n)];
            case 1:
              return ie = fe.sent(), [2, ie.meta.domain];
          }
        });
      });
    }, t.prototype.getMetadata = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator$2(this, function(he) {
          switch (he.label) {
            case 0:
              return ie = "".concat(this.url, "/").concat(n), [4, Networking_1$1.default.fetch(ie).catch(function(me) {
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.MetadataEndpointError, {
                  tokenUri: ie || "undefined",
                  errorMessage: me.message
                });
              })];
            case 1:
              return fe = he.sent(), [4, fe.json()];
            case 2:
              if (ae = he.sent(), !ae.meta || !ae.meta.domain)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnregisteredDomain, {
                  domain: "with tokenId ".concat(n)
                });
              if (le = ae.meta.blockchain === publicTypes_1$2.BlockchainType.ZIL ? (0, namehash_1$1.znsNamehash)(ae.meta.domain) : (0, namehash_1$1.eip137Namehash)(ae.meta.domain), le !== n)
                throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.ServiceProviderError, {
                  methodName: "unhash",
                  domain: ae.meta.domain,
                  providerMessage: "Service provider returned an invalid domain name"
                });
              return [2, ae];
          }
        });
      });
    }, t.prototype.resolve = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie;
        return __generator$2(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, Networking_1$1.default.fetch("".concat(this.url, "/").concat(n), {
                method: "GET",
                headers: this.headers
              })];
            case 1:
              return ie = fe.sent(), [2, ie.json()];
          }
        });
      });
    }, t.prototype.resolver = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie;
        return __generator$2(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.resolve(n)];
            case 1:
              return ie = fe.sent(), [2, ie.meta.resolver];
          }
        });
      });
    }, t.prototype.reverse = function(n, ie) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(fe) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverse"
          });
        });
      });
    }, t.prototype.reverseOf = function(n, ie) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(fe) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "reverseOf"
          });
        });
      });
    }, t.prototype.isRegistered = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        var ie;
        return __generator$2(this, function(fe) {
          switch (fe.label) {
            case 0:
              return [4, this.resolve(n)];
            case 1:
              return ie = fe.sent(), [2, !(0, utils_1$1.isNullAddress)(ie.meta.owner)];
          }
        });
      });
    }, t.prototype.getTokenUri = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "getTokenUri"
          });
        });
      });
    }, t.prototype.isAvailable = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.isRegistered(n)];
            case 1:
              return [2, !ie.sent()];
          }
        });
      });
    }, t.prototype.registryAddress = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            domain: n,
            methodName: "registryAddress"
          });
        });
      });
    }, t.prototype.locations = function(n) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$2(this, function(ie) {
          throw new resolutionError_1$3.ResolutionError(resolutionError_1$3.ResolutionErrorCode.UnsupportedMethod, {
            methodName: "locations"
          });
        });
      });
    }, t;
  }(NamingService_1.NamingService)
);
UdApi$1.default = UdApi;
var DnsUtils$1 = {}, dnsRecordsError = {};
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var le = function(he, me) {
      return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ye, be) {
        ye.__proto__ = be;
      } || function(ye, be) {
        for (var Ae in be) Object.prototype.hasOwnProperty.call(be, Ae) && (ye[Ae] = be[Ae]);
      }, le(he, me);
    };
    return function(he, me) {
      if (typeof me != "function" && me !== null)
        throw new TypeError("Class extends value " + String(me) + " is not a constructor or null");
      le(he, me);
      function ye() {
        this.constructor = he;
      }
      he.prototype = me === null ? Object.create(me) : (ye.prototype = me.prototype, new ye());
    };
  }(), n;
  Object.defineProperty(c, "__esModule", { value: !0 }), c.DnsRecordsError = c.DnsRecordsErrorCode = void 0;
  var ie;
  (function(le) {
    le.InconsistentTtl = "InconsistentTtl", le.DnsRecordCorrupted = "DnsRecordCorrupted";
  })(ie = c.DnsRecordsErrorCode || (c.DnsRecordsErrorCode = {}));
  var fe = (n = {}, n[ie.InconsistentTtl] = function(le) {
    return "ttl for record ".concat(le.recordType, " is different for other records of the same type");
  }, n[ie.DnsRecordCorrupted] = function(le) {
    return "dns record ".concat(le.recordType, " is invalid json-string");
  }, n), ae = (
    /** @class */
    function(le) {
      t(he, le);
      function he(me, ye) {
        ye === void 0 && (ye = {});
        var be = this, Ae = fe[me];
        return be = le.call(this, Ae(ye)) || this, be.code = me, be.name = "DnsRecordsError", Object.setPrototypeOf(be, he.prototype), be;
      }
      return he;
    }(Error)
  );
  c.DnsRecordsError = ae, c.default = ae;
})(dnsRecordsError);
var __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$3(t, c, n);
  return __setModuleDefault$3(t, c), t;
};
Object.defineProperty(DnsUtils$1, "__esModule", { value: !0 });
var dnsRecordsError_1 = __importStar$3(dnsRecordsError), publicTypes_1$1 = publicTypes, DnsUtils = (
  /** @class */
  function() {
    function c() {
    }
    return c.prototype.toList = function(t) {
      var n, ie = this, fe = this.getAllDnsTypes(t);
      return (n = []).concat.apply(n, fe.map(function(ae) {
        return ie.constructDnsRecords(t, ae);
      }));
    }, c.prototype.toCrypto = function(t) {
      for (var n = {}, ie = 0, fe = t; ie < fe.length; ie++) {
        var ae = fe[ie], le = ae.type, he = ae.TTL, me = ae.data, ye = this.getJsonNumber(n["dns.".concat(le, ".ttl")]), be = this.getJsonArray(n, "dns.".concat(le));
        if (be ? (be.push(me), n["dns.".concat(le)] = JSON.stringify(be)) : (n["dns.".concat(le)] = JSON.stringify([me]), n["dns.".concat(le, ".ttl")] = he.toString(10)), ye && ye !== he)
          throw new dnsRecordsError_1.default(dnsRecordsError_1.DnsRecordsErrorCode.InconsistentTtl, {
            recordType: le
          });
      }
      return n;
    }, c.prototype.protectFromCorruptRecord = function(t, n) {
      try {
        return t ? JSON.parse(t) : void 0;
      } catch (ie) {
        throw ie instanceof SyntaxError ? new dnsRecordsError_1.default(dnsRecordsError_1.DnsRecordsErrorCode.DnsRecordCorrupted, {
          recordType: n
        }) : ie;
      }
    }, c.prototype.getJsonArray = function(t, n) {
      var ie = t[n], fe = n.split(".")[1];
      return this.protectFromCorruptRecord(ie, fe);
    }, c.prototype.getJsonNumber = function(t) {
      return t ? parseInt(t, 10) : void 0;
    }, c.prototype.getAllDnsTypes = function(t) {
      var n = /* @__PURE__ */ new Set();
      return Object.keys(t).forEach(function(ie) {
        var fe = ie.split("."), ae = fe[1] && fe[1] !== "ttl";
        ae && n.add(publicTypes_1$1.DnsRecordType[fe[1]]);
      }), Array.from(n);
    }, c.prototype.constructDnsRecords = function(t, n) {
      var ie = this.parseTtl(t, n), fe = t["dns.".concat(n)];
      if (!fe)
        return [];
      var ae = this.protectFromCorruptRecord(fe, n);
      return this.isStringArray(ae) ? ae.map(function(le) {
        return { TTL: ie, data: le, type: n };
      }) : [];
    }, c.prototype.parseTtl = function(t, n) {
      var ie = t["dns.ttl"], fe = t["dns.".concat(n, ".ttl")];
      if (fe) {
        var ae = this.parseIfNumber(fe);
        if (ae)
          return ae;
      }
      if (ie) {
        var ae = this.parseIfNumber(ie);
        if (ae)
          return ae;
      }
      return c.DefaultTtl;
    }, c.prototype.parseIfNumber = function(t) {
      var n = parseInt(t, 10);
      if (!isNaN(n))
        return n;
    }, c.prototype.isStringArray = function(t) {
      return t instanceof Array ? t.every(function(n) {
        return typeof n == "string";
      }) : !1;
    }, c.DefaultTtl = 300, c;
  }()
);
DnsUtils$1.default = DnsUtils;
var Eip1993Factories = {}, __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$2(t, c, n);
  return __setModuleDefault$2(t, c), t;
}, __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator$1 = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(c, t, n) {
  if (n || arguments.length === 2) for (var ie = 0, fe = t.length, ae; ie < fe; ie++)
    (ae || !(ie in t)) && (ae || (ae = Array.prototype.slice.call(t, 0, ie)), ae[ie] = t[ie]);
  return c.concat(ae || Array.prototype.slice.call(t));
};
Object.defineProperty(Eip1993Factories, "__esModule", { value: !0 });
Eip1993Factories.Eip1993Factories = void 0;
var configurationError_1$1 = configurationError, resolutionError_1$2 = __importStar$2(resolutionError);
Eip1993Factories.Eip1993Factories = {
  fromWeb3Version0Provider,
  fromWeb3Version1Provider,
  fromEthersProvider,
  fromZilliqaProvider
};
function fromWeb3Version0Provider(c) {
  if (c.sendAsync === void 0)
    throw new configurationError_1$1.ConfigurationError(configurationError_1$1.ConfigurationErrorCode.IncorrectProvider);
  return {
    request: function(t) {
      return new Promise(function(n, ie) {
        c.sendAsync({
          jsonrpc: "2.0",
          method: t.method,
          params: wrapArray(t.params),
          id: 1
        }, function(fe, ae) {
          fe && ie(fe), ae.error && ie(new resolutionError_1$2.default(resolutionError_1$2.ResolutionErrorCode.ServiceProviderError, {
            providerMessage: ae.error
          })), n(ae.result);
        });
      });
    }
  };
}
function fromWeb3Version1Provider(c) {
  if (c && c.send === void 0)
    throw new configurationError_1$1.ConfigurationError(configurationError_1$1.ConfigurationErrorCode.IncorrectProvider);
  return {
    request: function(t) {
      return new Promise(function(n, ie) {
        c.send({
          jsonrpc: "2.0",
          method: t.method,
          params: wrapArray(t.params),
          id: 1
        }, function(fe, ae) {
          fe && ie(fe), ae.error && ie(new resolutionError_1$2.default(resolutionError_1$2.ResolutionErrorCode.ServiceProviderError, {
            providerMessage: ae.error
          })), n(ae.result);
        });
      });
    }
  };
}
function fromEthersProvider(c) {
  var t = this;
  if (c.call === void 0)
    throw new configurationError_1$1.ConfigurationError(configurationError_1$1.ConfigurationErrorCode.IncorrectProvider);
  return {
    request: function(n) {
      return __awaiter$1(t, void 0, void 0, function() {
        var ie, fe;
        return __generator$1(this, function(ae) {
          switch (ae.label) {
            case 0:
              switch (ae.trys.push([0, 7, , 8]), ie = n.method, ie) {
                case "eth_call":
                  return [3, 1];
                case "eth_getLogs":
                  return [3, 3];
              }
              return [3, 5];
            case 1:
              return [4, c.call(n.params[0])];
            case 2:
              return [2, ae.sent()];
            case 3:
              return [4, c.getLogs(n.params[0])];
            case 4:
              return [2, ae.sent()];
            case 5:
              throw new resolutionError_1$2.default(resolutionError_1$2.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: "Unsupported provider method ".concat(n.method)
              });
            case 6:
              return [3, 8];
            case 7:
              throw fe = ae.sent(), new resolutionError_1$2.default(resolutionError_1$2.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: fe.message
              });
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
  };
}
function fromZilliqaProvider(c) {
  var t = this;
  if (c.middleware === void 0 || c.send === void 0)
    throw new configurationError_1$1.ConfigurationError(configurationError_1$1.ConfigurationErrorCode.IncorrectProvider);
  return {
    request: function(n) {
      return __awaiter$1(t, void 0, void 0, function() {
        var ie, fe;
        return __generator$1(this, function(ae) {
          switch (ae.label) {
            case 0:
              return ae.trys.push([0, 2, , 3]), [4, c.send.apply(c, __spreadArray([n.method], n.params || [], !1))];
            case 1:
              if (ie = ae.sent(), ie.error)
                throw new Error(ie.error.message);
              return [2, ie.result];
            case 2:
              throw fe = ae.sent(), new resolutionError_1$2.default(resolutionError_1$2.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: fe.message
              });
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
  };
}
function wrapArray(c) {
  return c === void 0 && (c = []), c instanceof Array ? c : [c];
}
var prepareAndValidate = {}, __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding$1(t, c, n);
  return __setModuleDefault$1(t, c), t;
};
Object.defineProperty(prepareAndValidate, "__esModule", { value: !0 });
prepareAndValidate.prepareAndValidateDomain = void 0;
var resolutionError_1$1 = __importStar$1(resolutionError), reg = RegExp("^[.a-z0-9-]+$");
function prepareAndValidateDomain(c) {
  var t = c ? c.trim().toLowerCase() : "";
  if (!reg.test(t))
    throw new resolutionError_1$1.default(resolutionError_1$1.ResolutionErrorCode.InvalidDomainAddress, {
      domain: c
    });
  return t;
}
prepareAndValidate.prepareAndValidateDomain = prepareAndValidateDomain;
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, t, n, ie) {
  ie === void 0 && (ie = n);
  var fe = Object.getOwnPropertyDescriptor(t, n);
  (!fe || ("get" in fe ? !t.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(c, ie, fe);
} : function(c, t, n, ie) {
  ie === void 0 && (ie = n), c[ie] = t[n];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(c, t) {
  Object.defineProperty(c, "default", { enumerable: !0, value: t });
} : function(c, t) {
  c.default = t;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(c) {
  if (c && c.__esModule) return c;
  var t = {};
  if (c != null) for (var n in c) n !== "default" && Object.prototype.hasOwnProperty.call(c, n) && __createBinding(t, c, n);
  return __setModuleDefault(t, c), t;
}, __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(c, t, n, ie) {
  function fe(ae) {
    return ae instanceof n ? ae : new n(function(le) {
      le(ae);
    });
  }
  return new (n || (n = Promise))(function(ae, le) {
    function he(be) {
      try {
        ye(ie.next(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function me(be) {
      try {
        ye(ie.throw(be));
      } catch (Ae) {
        le(Ae);
      }
    }
    function ye(be) {
      be.done ? ae(be.value) : fe(be.value).then(he, me);
    }
    ye((ie = ie.apply(c, t || [])).next());
  });
}, __generator = commonjsGlobal && commonjsGlobal.__generator || function(c, t) {
  var n = { label: 0, sent: function() {
    if (ae[0] & 1) throw ae[1];
    return ae[1];
  }, trys: [], ops: [] }, ie, fe, ae, le;
  return le = { next: he(0), throw: he(1), return: he(2) }, typeof Symbol == "function" && (le[Symbol.iterator] = function() {
    return this;
  }), le;
  function he(ye) {
    return function(be) {
      return me([ye, be]);
    };
  }
  function me(ye) {
    if (ie) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (ie = 1, fe && (ae = ye[0] & 2 ? fe.return : ye[0] ? fe.throw || ((ae = fe.return) && ae.call(fe), 0) : fe.next) && !(ae = ae.call(fe, ye[1])).done) return ae;
      switch (fe = 0, ae && (ye = [ye[0] & 2, ae.value]), ye[0]) {
        case 0:
        case 1:
          ae = ye;
          break;
        case 4:
          return n.label++, { value: ye[1], done: !1 };
        case 5:
          n.label++, fe = ye[1], ye = [0];
          continue;
        case 7:
          ye = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (ae = n.trys, !(ae = ae.length > 0 && ae[ae.length - 1]) && (ye[0] === 6 || ye[0] === 2)) {
            n = 0;
            continue;
          }
          if (ye[0] === 3 && (!ae || ye[1] > ae[0] && ye[1] < ae[3])) {
            n.label = ye[1];
            break;
          }
          if (ye[0] === 6 && n.label < ae[1]) {
            n.label = ae[1], ae = ye;
            break;
          }
          if (ae && n.label < ae[2]) {
            n.label = ae[2], n.ops.push(ye);
            break;
          }
          ae[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      ye = t.call(c, n);
    } catch (be) {
      ye = [6, be], fe = 0;
    } finally {
      ie = ae = 0;
    }
    if (ye[0] & 5) throw ye[1];
    return { value: ye[0] ? ye[1] : void 0, done: !0 };
  }
}, __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(c) {
  return c && c.__esModule ? c : { default: c };
};
Object.defineProperty(Resolution$1, "__esModule", { value: !0 });
Resolution$1.Resolution = void 0;
var bn_js_1 = __importDefault(bnExports$2), Ens_1 = __importDefault(Ens$1), Zns_1 = __importDefault(Zns$1), Uns_1 = __importDefault(Uns$1), UdApi_1 = __importDefault(UdApi$1), publicTypes_1 = publicTypes, resolutionError_1 = __importStar(resolutionError), DnsUtils_1 = __importDefault(DnsUtils$1), utils_1 = utils$e, Eip1993Factories_1 = Eip1993Factories, configurationError_1 = __importDefault(configurationError), configurationError_2 = configurationError, Networking_1 = __importDefault(Networking$1), prepareAndValidate_1 = prepareAndValidate, namehash_1 = namehash, DEFAULT_UNS_PROXY_SERVICE_URL = "https://api.unstoppabledomains.com/resolve", Resolution = (
  /** @class */
  function() {
    function c(t) {
      var n;
      t === void 0 && (t = {});
      var ie = this.getUnsConfig(t), fe = this.getUnsBaseConfig(t), ae = this.getZnsConfig(t), le = this.getEnsConfig(t), he = ie instanceof UdApi_1.default && ae instanceof UdApi_1.default && ie.url === ae.url;
      this.serviceMap = (n = {}, n[publicTypes_1.NamingServiceName.UNS] = {
        usedServices: [ie],
        native: ie instanceof Uns_1.default ? ie : new Uns_1.default()
      }, n[publicTypes_1.NamingServiceName.UNS_BASE] = {
        usedServices: [fe],
        native: fe instanceof Uns_1.default ? fe : new Uns_1.default()
      }, n[publicTypes_1.NamingServiceName.ZNS] = {
        usedServices: he ? [ie] : [ie, ae],
        native: ae instanceof Zns_1.default ? ae : new Zns_1.default()
      }, n[publicTypes_1.NamingServiceName.ENS] = {
        usedServices: [le],
        native: le instanceof Ens_1.default ? le : new Ens_1.default()
      }, n);
    }
    return c.autoNetwork = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n, ie, fe;
        return __generator(this, function(ae) {
          switch (ae.label) {
            case 0:
              if (n = new this(), !t.uns && !t.ens)
                throw new configurationError_1.default(configurationError_2.ConfigurationErrorCode.UnsupportedNetwork);
              return t.uns ? [4, Uns_1.default.autoNetwork(t.uns)] : [3, 2];
            case 1:
              ie = ae.sent(), n.serviceMap[publicTypes_1.NamingServiceName.UNS] = {
                usedServices: [ie],
                native: ie
              }, ae.label = 2;
            case 2:
              return t.ens ? [4, Ens_1.default.autoNetwork(t.ens)] : [3, 4];
            case 3:
              fe = ae.sent(), n.serviceMap[publicTypes_1.NamingServiceName.ENS] = {
                usedServices: [fe],
                native: fe
              }, ae.label = 4;
            case 4:
              return [2, n];
          }
        });
      });
    }, c.infura = function(t, n) {
      var ie, fe, ae, le, he, me;
      return new this({
        sourceConfig: {
          ens: {
            url: (0, utils_1.signedInfuraLink)(t, (ie = n == null ? void 0 : n.ens) === null || ie === void 0 ? void 0 : ie.network),
            network: ((fe = n == null ? void 0 : n.ens) === null || fe === void 0 ? void 0 : fe.network) || "mainnet"
          },
          uns: {
            locations: {
              Layer1: {
                url: (0, utils_1.signedLink)(t, ((ae = n == null ? void 0 : n.uns) === null || ae === void 0 ? void 0 : ae.locations.Layer1.network) || "mainnet", "infura"),
                network: ((le = n == null ? void 0 : n.uns) === null || le === void 0 ? void 0 : le.locations.Layer1.network) || "mainnet"
              },
              Layer2: {
                url: (0, utils_1.signedLink)(t, ((he = n == null ? void 0 : n.uns) === null || he === void 0 ? void 0 : he.locations.Layer2.network) || "polygon-mainnet", "infura"),
                network: ((me = n == null ? void 0 : n.uns) === null || me === void 0 ? void 0 : me.locations.Layer2.network) || "polygon-mainnet"
              }
            }
          }
        }
      });
    }, c.alchemy = function(t, n) {
      var ie, fe, ae, le;
      return new this({
        sourceConfig: {
          uns: {
            locations: {
              Layer1: {
                url: (0, utils_1.signedLink)(t, ((ie = n == null ? void 0 : n.uns) === null || ie === void 0 ? void 0 : ie.locations.Layer1.network) || "mainnet"),
                network: ((fe = n == null ? void 0 : n.uns) === null || fe === void 0 ? void 0 : fe.locations.Layer1.network) || "mainnet"
              },
              Layer2: {
                url: (0, utils_1.signedLink)(t, ((ae = n == null ? void 0 : n.uns) === null || ae === void 0 ? void 0 : ae.locations.Layer2.network) || "polygon-mainnet"),
                network: ((le = n == null ? void 0 : n.uns) === null || le === void 0 ? void 0 : le.locations.Layer2.network) || "polygon-mainnet"
              }
            }
          }
        }
      });
    }, c.fromResolutionProvider = function(t) {
      if (t.ens || t.uns)
        return this.fromEthereumEip1193Provider({
          ens: t.ens,
          uns: t.uns
        });
      if (t.zns)
        return this.fromZilliqaProvider(t.zns.provider, t);
      throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
        providerMessage: "Must specify network for uns, ens, or zns"
      });
    }, c.fromEthereumEip1193Provider = function(t) {
      var n, ie = {};
      return t.ens && (ie.ens = {
        provider: t.ens.provider,
        network: ((n = t == null ? void 0 : t.ens) === null || n === void 0 ? void 0 : n.network) || "mainnet"
      }), t.uns && (ie.uns = {
        locations: {
          Layer1: {
            provider: t.uns.locations.Layer1.provider,
            network: t.uns.locations.Layer1.network || "mainnet"
          },
          Layer2: {
            provider: t.uns.locations.Layer2.provider,
            network: t.uns.locations.Layer2.network || "polygon-mainnet"
          }
        }
      }), new this({
        sourceConfig: ie
      });
    }, c.fromZilliqaProvider = function(t, n) {
      var ie;
      return new this({
        sourceConfig: {
          zns: { provider: t, network: ((ie = n == null ? void 0 : n.zns) === null || ie === void 0 ? void 0 : ie.network) || "mainnet" }
        }
      });
    }, c.fromWeb3Version0Provider = function(t) {
      return this.fromEthereumEip1193Provider({
        ens: t.ens ? {
          network: t.ens.network,
          provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version0Provider(t.ens.provider)
        } : void 0,
        uns: t.uns ? {
          locations: {
            Layer1: {
              network: t.uns.locations.Layer1.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version0Provider(t.uns.locations.Layer1.provider)
            },
            Layer2: {
              network: t.uns.locations.Layer2.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version0Provider(t.uns.locations.Layer2.provider)
            }
          }
        } : void 0
      });
    }, c.fromWeb3Version1Provider = function(t) {
      return this.fromEthereumEip1193Provider({
        ens: t.ens ? {
          network: t.ens.network,
          provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version1Provider(t.ens.provider)
        } : void 0,
        uns: t.uns ? {
          locations: {
            Layer1: {
              network: t.uns.locations.Layer1.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version1Provider(t.uns.locations.Layer1.provider)
            },
            Layer2: {
              network: t.uns.locations.Layer2.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromWeb3Version1Provider(t.uns.locations.Layer2.provider)
            }
          }
        } : void 0
      });
    }, c.fromEthersProvider = function(t) {
      return this.fromEthereumEip1193Provider({
        ens: t.ens ? {
          network: t.ens.network,
          provider: Eip1993Factories_1.Eip1993Factories.fromEthersProvider(t.ens.provider)
        } : void 0,
        uns: t.uns ? {
          locations: {
            Layer1: {
              network: t.uns.locations.Layer1.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromEthersProvider(t.uns.locations.Layer1.provider)
            },
            Layer2: {
              network: t.uns.locations.Layer2.network,
              provider: Eip1993Factories_1.Eip1993Factories.fromEthersProvider(t.uns.locations.Layer2.provider)
            }
          }
        } : void 0
      });
    }, c.prototype.addr = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie = this;
        return __generator(this, function(fe) {
          switch (fe.label) {
            case 0:
              return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [4, this.callServiceForDomain(t, function(ae) {
                return __awaiter(ie, void 0, void 0, function() {
                  return __generator(this, function(le) {
                    switch (le.label) {
                      case 0:
                        return ae instanceof Ens_1.default ? [4, ae.addr(t, n)] : [3, 2];
                      case 1:
                        return [2, le.sent()];
                      case 2:
                        return [4, this.record(t, "crypto.".concat(n.toUpperCase(), ".address"))];
                      case 3:
                        return [2, le.sent()];
                    }
                  });
                });
              })];
            case 1:
              return [2, fe.sent()];
          }
        });
      });
    }, c.prototype.multiChainAddr = function(t, n, ie) {
      return __awaiter(this, void 0, void 0, function() {
        var fe, ae = this;
        return __generator(this, function(le) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), fe = "crypto.".concat(n.toUpperCase(), ".version.").concat(ie.toUpperCase(), ".address"), [2, this.callServiceForDomain(t, function(he) {
            return __awaiter(ae, void 0, void 0, function() {
              return __generator(this, function(me) {
                switch (me.label) {
                  case 0:
                    if (he instanceof Ens_1.default)
                      throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedMethod, {
                        methodName: "multiChainAddr",
                        domain: t,
                        method: he.name
                      });
                    return [4, he.record(t, fe)];
                  case 1:
                    return [2, me.sent()];
                }
              });
            });
          })];
        });
      });
    }, c.prototype.twitter = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(ie) {
            return ie.twitter(t);
          })];
        });
      });
    }, c.prototype.chatId = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return ie.trys.push([0, 2, , 3]), [4, this.record(t, "gundb.username.value")];
            case 1:
              return [2, ie.sent()];
            case 2:
              throw n = ie.sent(), n.code === resolutionError_1.ResolutionErrorCode.RecordNotFound ? new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                domain: t,
                method: n.method,
                methodName: "chatId",
                recordName: n.recordName
              }) : n;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, c.prototype.chatPk = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return ie.trys.push([0, 2, , 3]), [4, this.record(t, "gundb.public_key.value")];
            case 1:
              return [2, ie.sent()];
            case 2:
              throw n = ie.sent(), n.code === resolutionError_1.ResolutionErrorCode.RecordNotFound ? new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                domain: t,
                method: n.method,
                methodName: "chatId",
                recordName: n.recordName
              }) : n;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, c.prototype.ipfsHash = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n = this;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [4, this.callServiceForDomain(t, function(fe) {
                return __awaiter(n, void 0, void 0, function() {
                  var ae;
                  return __generator(this, function(le) {
                    switch (le.label) {
                      case 0:
                        return fe instanceof Ens_1.default ? [4, fe.record(t, "contenthash")] : [3, 2];
                      case 1:
                        return ae = le.sent(), [2, "ipfs://".concat(ae)];
                      case 2:
                        return [4, this.getPreferableNewRecord(t, "dweb.ipfs.hash", "ipfs.html.value")];
                      case 3:
                        return [2, le.sent()];
                    }
                  });
                });
              })];
            case 1:
              return [2, ie.sent()];
          }
        });
      });
    }, c.prototype.httpUrl = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n = this;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [4, this.callServiceForDomain(t, function(fe) {
                return __awaiter(n, void 0, void 0, function() {
                  return __generator(this, function(ae) {
                    switch (ae.label) {
                      case 0:
                        return fe instanceof Ens_1.default ? [4, fe.record(t, "url")] : [3, 2];
                      case 1:
                        return [2, ae.sent()];
                      case 2:
                        return [4, this.getPreferableNewRecord(t, "browser.redirect_url", "ipfs.redirect_domain.value")];
                      case 3:
                        return [2, ae.sent()];
                    }
                  });
                });
              })];
            case 1:
              return [2, ie.sent()];
          }
        });
      });
    }, c.prototype.email = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n, ie, fe;
        return __generator(this, function(ae) {
          switch (ae.label) {
            case 0:
              return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), n = "whois.email.value", [4, (0, utils_1.findNamingServiceName)(t)];
            case 1:
              ie = ae.sent(), ie === "ENS" && (n = "email"), ae.label = 2;
            case 2:
              return ae.trys.push([2, 4, , 5]), [4, this.record(t, n)];
            case 3:
              return [2, ae.sent()];
            case 4:
              throw fe = ae.sent(), new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                domain: t,
                method: fe.method,
                methodName: "email",
                recordName: fe.recordName
              });
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, c.prototype.resolver = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [4, this.callServiceForDomain(t, function(fe) {
                return fe.resolver(t);
              })];
            case 1:
              if (n = ie.sent(), !n)
                throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnspecifiedResolver, {
                  domain: t
                });
              return [2, n];
          }
        });
      });
    }, c.prototype.owner = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(ie) {
            return ie.owner(t);
          })];
        });
      });
    }, c.prototype.getAddress = function(t, n, ie) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(fe) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(ae) {
            return ae.getAddress(t, n, ie);
          })];
        });
      });
    }, c.prototype.record = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(ie) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(fe) {
            return fe.record(t, n);
          })];
        });
      });
    }, c.prototype.records = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(ie) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(fe) {
            return fe.records(t, n);
          })];
        });
      });
    }, c.prototype.isRegistered = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomainBoolean(t, function(ie) {
            return ie.isRegistered(t);
          }, {
            throwIfUnsupportedDomain: !0,
            expectedValue: !0
          })];
        });
      });
    }, c.prototype.isAvailable = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomainBoolean(t, function(ie) {
            return ie.isAvailable(t);
          }, {
            throwIfUnsupportedDomain: !0,
            expectedValue: !1
          })];
        });
      });
    }, c.prototype.namehash = function(t, n, ie) {
      ie === void 0 && (ie = publicTypes_1.NamehashOptionsDefault);
      var fe = this.serviceMap[n];
      if (!fe)
        throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedService, {
          namingService: n
        });
      return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), this.formatNamehash(fe.native.namehash(t), ie);
    }, c.prototype.childhash = function(t, n, ie, fe) {
      fe === void 0 && (fe = publicTypes_1.NamehashOptionsDefault);
      var ae = this.serviceMap[ie];
      if (!ae)
        throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedService, {
          namingService: ie
        });
      return this.formatNamehash(ae.native.childhash(t, n), fe);
    }, c.prototype.formatNamehash = function(t, n) {
      return t = t.replace("0x", ""), n.format === "dec" ? new bn_js_1.default(t, "hex").toString(10) : n.prefix ? "0x" + t : t;
    }, c.prototype.isValidHash = function(t, n, ie) {
      var fe = this.serviceMap[ie];
      if (!fe)
        throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedService, {
          namingService: ie
        });
      return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), fe.native.namehash(t) === n;
    }, c.prototype.isSupportedDomain = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomainBoolean(t, function(ie) {
            return ie.isSupportedDomain(t);
          }, {
            throwIfUnsupportedDomain: !1,
            expectedValue: !0
          })];
        });
      });
    }, c.prototype.allRecords = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), [2, this.callServiceForDomain(t, function(ie) {
            return ie.allRecords(t);
          })];
        });
      });
    }, c.prototype.dns = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator(this, function(le) {
          switch (le.label) {
            case 0:
              return ie = new DnsUtils_1.default(), t = (0, prepareAndValidate_1.prepareAndValidateDomain)(t), fe = this.getDnsRecordKeys(n), [4, this.callServiceForDomain(t, function(he) {
                return he.records(t, fe);
              })];
            case 1:
              return ae = le.sent(), [2, ie.toList(ae)];
          }
        });
      });
    }, c.prototype.tokenURI = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n = this;
        return __generator(this, function(ie) {
          return [2, this.callServiceForDomain(t, function(fe) {
            if (fe.name === publicTypes_1.NamingServiceName.UNS) {
              var ae = n.namehash(t, publicTypes_1.NamingServiceName.UNS);
              return fe.getTokenUri(ae);
            } else if (fe.name === publicTypes_1.NamingServiceName.ENS)
              return fe.getTokenUri(t);
            var le = n.namehash(t, publicTypes_1.NamingServiceName.ZNS);
            return fe.getTokenUri(le);
          })];
        });
      });
    }, c.prototype.tokenURIMetadata = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n;
        return __generator(this, function(ie) {
          switch (ie.label) {
            case 0:
              return [4, this.tokenURI(t)];
            case 1:
              return n = ie.sent(), [2, this.getMetadataFromTokenURI(n)];
          }
        });
      });
    }, c.prototype.registryAddress = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(n) {
          return [2, this.callServiceForDomain(t, function(ie) {
            return ie.registryAddress(t);
          })];
        });
      });
    }, c.prototype.unhash = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe;
        return __generator(this, function(ae) {
          return t = (0, namehash_1.fromDecStringToHex)(t), ie = this.serviceMap[n].usedServices, fe = ie[ie.length - 1], [2, fe.getDomainFromTokenId(t)];
        });
      });
    }, c.prototype.locations = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n, ie, fe, ae, le, he, me, ye, be, Ae, Se, $e, Re, Me, ke;
        return __generator(this, function(Te) {
          switch (Te.label) {
            case 0:
              return n = t.filter(function(Ie) {
                return Ie.endsWith(".zil");
              }), ie = t.filter(function(Ie) {
                return Ie.match(/^([^\s\\.]+\.)+(eth)+$/);
              }), fe = t.filter(function(Ie) {
                return !Ie.match(/^([^\s\\.]+\.)+(eth)+$/);
              }), ae = this.serviceMap.UNS.usedServices[0].locations(fe), [4, ae];
            case 1:
              return le = Te.sent(), n.length ? (he = this.serviceMap.ZNS.usedServices, me = he[he.length - 1], ye = (0, utils_1.wrapResult)(function() {
                return me.locations(n);
              }), be = Object.entries(le).filter(function(Ie) {
                var qe = Ie[0], Ue = Ie[1];
                return qe.endsWith(".zil") && !Ue;
              }), [4, ye.then(utils_1.unwrapResult)]) : [3, 3];
            case 2:
              for (Ae = Te.sent(), Se = 0, $e = be; Se < $e.length; Se++)
                Re = $e[Se][0], le[Re] = Ae[Re];
              Te.label = 3;
            case 3:
              return ie.length ? [4, this.serviceMap.ENS.usedServices[0].locations(ie)] : [3, 5];
            case 4:
              Me = Te.sent();
              for (ke in Me)
                le[ke] = Me[ke];
              Te.label = 5;
            case 5:
              return [2, le];
          }
        });
      });
    }, c.prototype.reverseTokenId = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe, ae, le;
        return __generator(this, function(he) {
          switch (he.label) {
            case 0:
              return [4, this.reverseGetTokenId(t, n == null ? void 0 : n.location)];
            case 1:
              return ie = he.sent(), ie ? [2, ie] : (fe = this.serviceMap.ENS.native, [4, fe.reverseOf(t)]);
            case 2:
              return ae = he.sent(), ae ? (le = fe.namehash(ae), [2, "".concat(BigInt(le))]) : [2, null];
          }
        });
      });
    }, c.prototype.reverse = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, this.reverseGetTokenId(t, n == null ? void 0 : n.location)];
            case 1:
              return ie = le.sent(), ie ? [2, this.unhash(ie, publicTypes_1.NamingServiceName.UNS)] : (fe = this.serviceMap.ENS.native, [4, fe.reverseOf(t)]);
            case 2:
              return ae = le.sent(), ae ? [2, ae] : [2, null];
          }
        });
      });
    }, c.prototype.getMetadataFromTokenURI = function(t) {
      return __awaiter(this, void 0, void 0, function() {
        var n, ie, fe, ae;
        return __generator(this, function(le) {
          switch (le.label) {
            case 0:
              return [4, Networking_1.default.fetch(t)];
            case 1:
              return n = le.sent(), n.ok ? [2, n.json()] : (ie = resolutionError_1.default.bind, fe = [void 0, resolutionError_1.ResolutionErrorCode.ServiceProviderError], ae = {}, [4, n.text()]);
            case 2:
              throw new (ie.apply(resolutionError_1.default, fe.concat([(ae.providerMessage = le.sent(), ae.method = "UDAPI", ae.methodName = "tokenURIMetadata", ae)])))();
          }
        });
      });
    }, c.prototype.getDnsRecordKeys = function(t) {
      var n = ["dns.ttl"];
      return t.forEach(function(ie) {
        n.push("dns.".concat(ie)), n.push("dns.".concat(ie, ".ttl"));
      }), n;
    }, c.prototype.getPreferableNewRecord = function(t, n, ie) {
      return __awaiter(this, void 0, void 0, function() {
        var fe;
        return __generator(this, function(ae) {
          switch (ae.label) {
            case 0:
              return [4, this.records(t, [n, ie])];
            case 1:
              if (fe = ae.sent(), !fe[n] && !fe[ie])
                throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                  recordName: n,
                  domain: t
                });
              return [2, fe[n] || fe[ie]];
          }
        });
      });
    }, c.prototype.callServiceForDomain = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe, ae, le, he, me;
        return __generator(this, function(ye) {
          switch (ye.label) {
            case 0:
              return [4, (0, utils_1.findNamingServiceName)(t)];
            case 1:
              if (ie = ye.sent(), !ie)
                throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                  domain: t
                });
              fe = this.serviceMap[ie].usedServices.map(function(be) {
                return (0, utils_1.wrapResult)(function() {
                  return n(be);
                });
              }), ae = 0, le = fe, ye.label = 2;
            case 2:
              return ae < le.length ? (he = le[ae], [4, he]) : [3, 5];
            case 3:
              if (me = ye.sent(), me.error !== null) {
                if (!(me.error instanceof resolutionError_1.default && me.error.code === resolutionError_1.ResolutionErrorCode.UnregisteredDomain))
                  throw me.error;
              } else
                return [2, me.result];
              ye.label = 4;
            case 4:
              return ae++, [3, 2];
            case 5:
              throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                domain: t
              });
          }
        });
      });
    }, c.prototype.callServiceForDomainBoolean = function(t, n, ie) {
      return __awaiter(this, void 0, void 0, function() {
        var fe, ae, le, he, me, ye, be, Ae;
        return __generator(this, function(Se) {
          switch (Se.label) {
            case 0:
              return [4, (0, utils_1.findNamingServiceName)(t)];
            case 1:
              if (fe = Se.sent(), !fe) {
                if (!ie.throwIfUnsupportedDomain)
                  return [2, !ie.expectedValue];
                throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                  domain: t
                });
              }
              ae = this.serviceMap[fe].usedServices.map(function($e) {
                return (0, utils_1.wrapResult)(function() {
                  return n($e);
                });
              }), le = 0, he = ae, Se.label = 2;
            case 2:
              return le < he.length ? (me = he[le], [4, me]) : [3, 5];
            case 3:
              if (ye = Se.sent(), be = ye.result, Ae = ye.error, Ae) {
                if (!(Ae instanceof resolutionError_1.default && Ae.code === resolutionError_1.ResolutionErrorCode.UnregisteredDomain))
                  throw Ae;
              } else if (be === ie.expectedValue)
                return [2, be];
              Se.label = 4;
            case 4:
              return le++, [3, 2];
            case 5:
              return [2, !ie.expectedValue];
          }
        });
      });
    }, c.prototype.reverseGetTokenId = function(t, n) {
      return __awaiter(this, void 0, void 0, function() {
        var ie, fe, ae;
        return __generator(this, function(le) {
          switch (le.label) {
            case 0:
              return ie = null, fe = this.serviceMap.UNS.native, [4, fe.reverseOf(t, n)];
            case 1:
              return ie = le.sent(), ie ? [3, 3] : (ae = this.serviceMap.UNS_BASE.native, [4, ae.reverseOf(t, n)]);
            case 2:
              ie = le.sent(), le.label = 3;
            case 3:
              return [2, ie];
          }
        });
      });
    }, c.prototype.getUnsConfig = function(t) {
      var n, ie, fe;
      return t.apiKey ? new Uns_1.default({
        locations: {
          Layer1: {
            url: "".concat(DEFAULT_UNS_PROXY_SERVICE_URL, "/chains/eth/rpc"),
            network: "mainnet",
            proxyServiceApiKey: t.apiKey,
            blockchain: publicTypes_1.BlockchainType.ETH
          },
          Layer2: {
            url: "".concat(DEFAULT_UNS_PROXY_SERVICE_URL, "/chains/matic/rpc"),
            network: "polygon-mainnet",
            proxyServiceApiKey: t.apiKey,
            blockchain: publicTypes_1.BlockchainType.POL
          }
        }
      }) : isApi((n = t.sourceConfig) === null || n === void 0 ? void 0 : n.uns) ? new UdApi_1.default((ie = t.sourceConfig) === null || ie === void 0 ? void 0 : ie.uns) : new Uns_1.default((fe = t.sourceConfig) === null || fe === void 0 ? void 0 : fe.uns);
    }, c.prototype.getUnsBaseConfig = function(t) {
      var n, ie, fe;
      return t.apiKey ? new Uns_1.default({
        locations: {
          Layer1: {
            url: "".concat(DEFAULT_UNS_PROXY_SERVICE_URL, "/chains/eth/rpc"),
            network: "mainnet",
            proxyServiceApiKey: t.apiKey,
            blockchain: publicTypes_1.BlockchainType.ETH
          },
          Layer2: {
            url: "".concat(DEFAULT_UNS_PROXY_SERVICE_URL, "/chains/base/rpc"),
            network: "base-mainnet",
            proxyServiceApiKey: t.apiKey,
            blockchain: publicTypes_1.BlockchainType.BASE
          }
        }
      }) : isApi((n = t.sourceConfig) === null || n === void 0 ? void 0 : n.uns) ? new UdApi_1.default((ie = t.sourceConfig) === null || ie === void 0 ? void 0 : ie.uns) : new Uns_1.default((fe = t.sourceConfig) === null || fe === void 0 ? void 0 : fe.uns);
    }, c.prototype.getZnsConfig = function(t) {
      var n, ie, fe;
      return isApi((n = t.sourceConfig) === null || n === void 0 ? void 0 : n.zns) ? new UdApi_1.default((ie = t.sourceConfig) === null || ie === void 0 ? void 0 : ie.zns) : new Zns_1.default((fe = t.sourceConfig) === null || fe === void 0 ? void 0 : fe.zns);
    }, c.prototype.getEnsConfig = function(t) {
      var n, ie, fe;
      return t.apiKey ? new Ens_1.default({
        url: "".concat(DEFAULT_UNS_PROXY_SERVICE_URL, "/chains/eth/rpc"),
        network: "mainnet",
        proxyServiceApiKey: t.apiKey
      }) : isApi((n = t.sourceConfig) === null || n === void 0 ? void 0 : n.ens) ? new UdApi_1.default((ie = t.sourceConfig) === null || ie === void 0 ? void 0 : ie.ens) : new Ens_1.default((fe = t.sourceConfig) === null || fe === void 0 ? void 0 : fe.ens);
    }, c;
  }()
);
Resolution$1.Resolution = Resolution;
Resolution$1.default = Resolution;
function isApi(c) {
  return typeof c == "object" && c !== null && "api" in c && typeof c.api == "boolean";
}
(function(c) {
  var t = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Se, $e, Re, Me) {
    Me === void 0 && (Me = Re);
    var ke = Object.getOwnPropertyDescriptor($e, Re);
    (!ke || ("get" in ke ? !$e.__esModule : ke.writable || ke.configurable)) && (ke = { enumerable: !0, get: function() {
      return $e[Re];
    } }), Object.defineProperty(Se, Me, ke);
  } : function(Se, $e, Re, Me) {
    Me === void 0 && (Me = Re), Se[Me] = $e[Re];
  }), n = commonjsGlobal && commonjsGlobal.__exportStar || function(Se, $e) {
    for (var Re in Se) Re !== "default" && !Object.prototype.hasOwnProperty.call($e, Re) && t($e, Se, Re);
  }, ie = commonjsGlobal && commonjsGlobal.__importDefault || function(Se) {
    return Se && Se.__esModule ? Se : { default: Se };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.ProviderFactories = c.Eip1193Factories = c.Eip1993Factories = c.DnsRecordsErrorCode = c.DnsRecordsError = c.ConfigurationErrorCode = c.ConfigurationError = c.ResolutionErrorCode = c.ResolutionError = c.DnsUtils = c.default = c.Resolution = void 0;
  var fe = Resolution$1;
  Object.defineProperty(c, "Resolution", { enumerable: !0, get: function() {
    return fe.Resolution;
  } }), Object.defineProperty(c, "default", { enumerable: !0, get: function() {
    return fe.Resolution;
  } }), n(publicTypes, c);
  var ae = DnsUtils$1;
  Object.defineProperty(c, "DnsUtils", { enumerable: !0, get: function() {
    return ie(ae).default;
  } });
  var le = resolutionError;
  Object.defineProperty(c, "ResolutionError", { enumerable: !0, get: function() {
    return le.ResolutionError;
  } }), Object.defineProperty(c, "ResolutionErrorCode", { enumerable: !0, get: function() {
    return le.ResolutionErrorCode;
  } });
  var he = configurationError;
  Object.defineProperty(c, "ConfigurationError", { enumerable: !0, get: function() {
    return he.ConfigurationError;
  } }), Object.defineProperty(c, "ConfigurationErrorCode", { enumerable: !0, get: function() {
    return he.ConfigurationErrorCode;
  } });
  var me = dnsRecordsError;
  Object.defineProperty(c, "DnsRecordsError", { enumerable: !0, get: function() {
    return me.DnsRecordsError;
  } }), Object.defineProperty(c, "DnsRecordsErrorCode", { enumerable: !0, get: function() {
    return me.DnsRecordsErrorCode;
  } });
  var ye = Eip1993Factories;
  Object.defineProperty(c, "Eip1993Factories", { enumerable: !0, get: function() {
    return ye.Eip1993Factories;
  } });
  var be = Eip1993Factories;
  Object.defineProperty(c, "Eip1193Factories", { enumerable: !0, get: function() {
    return be.Eip1993Factories;
  } });
  var Ae = Eip1993Factories;
  Object.defineProperty(c, "ProviderFactories", { enumerable: !0, get: function() {
    return Ae.Eip1993Factories;
  } });
})(build);
var win;
typeof window < "u" ? win = window : typeof globalThis < "u" ? win = globalThis : typeof self < "u" ? win = self : win = {};
var window_1 = win;
const u = /* @__PURE__ */ getDefaultExportFromCjs$2(window_1), crypto$1 = crypto, isCryptoKey = (c) => c instanceof CryptoKey, encoder = new TextEncoder(), decoder = new TextDecoder();
function concat(...c) {
  const t = c.reduce((fe, { length: ae }) => fe + ae, 0), n = new Uint8Array(t);
  let ie = 0;
  return c.forEach((fe) => {
    n.set(fe, ie), ie += fe.length;
  }), n;
}
const decodeBase64 = (c) => {
  const t = atob(c), n = new Uint8Array(t.length);
  for (let ie = 0; ie < t.length; ie++)
    n[ie] = t.charCodeAt(ie);
  return n;
}, decode = (c) => {
  let t = c;
  t instanceof Uint8Array && (t = decoder.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return decodeBase64(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class JOSEError extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(t) {
    var n;
    super(t), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}
class JWTClaimValidationFailed extends JOSEError {
  static get code() {
    return "ERR_JWT_CLAIM_VALIDATION_FAILED";
  }
  constructor(t, n = "unspecified", ie = "unspecified") {
    super(t), this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED", this.claim = n, this.reason = ie;
  }
}
class JWTExpired extends JOSEError {
  static get code() {
    return "ERR_JWT_EXPIRED";
  }
  constructor(t, n = "unspecified", ie = "unspecified") {
    super(t), this.code = "ERR_JWT_EXPIRED", this.claim = n, this.reason = ie;
  }
}
class JOSEAlgNotAllowed extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
  }
  static get code() {
    return "ERR_JOSE_ALG_NOT_ALLOWED";
  }
}
class JOSENotSupported extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
  static get code() {
    return "ERR_JOSE_NOT_SUPPORTED";
  }
}
class JWSInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWS_INVALID";
  }
  static get code() {
    return "ERR_JWS_INVALID";
  }
}
class JWTInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
  static get code() {
    return "ERR_JWT_INVALID";
  }
}
class JWKSInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_INVALID";
  }
  static get code() {
    return "ERR_JWKS_INVALID";
  }
}
class JWKSNoMatchingKey extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_NO_MATCHING_KEY", this.message = "no applicable key found in the JSON Web Key Set";
  }
  static get code() {
    return "ERR_JWKS_NO_MATCHING_KEY";
  }
}
class JWKSMultipleMatchingKeys extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS", this.message = "multiple matching keys found in the JSON Web Key Set";
  }
  static get code() {
    return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
  }
}
class JWKSTimeout extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_TIMEOUT", this.message = "request timed out";
  }
  static get code() {
    return "ERR_JWKS_TIMEOUT";
  }
}
class JWSSignatureVerificationFailed extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED", this.message = "signature verification failed";
  }
  static get code() {
    return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
  }
}
function unusable(c, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${c}`);
}
function isAlgorithm(c, t) {
  return c.name === t;
}
function getHashLength(c) {
  return parseInt(c.name.slice(4), 10);
}
function getNamedCurve(c) {
  switch (c) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function checkUsage(c, t) {
  if (t.length && !t.some((n) => c.usages.includes(n))) {
    let n = "CryptoKey does not support this operation, its usages must include ";
    if (t.length > 2) {
      const ie = t.pop();
      n += `one of ${t.join(", ")}, or ${ie}.`;
    } else t.length === 2 ? n += `one of ${t[0]} or ${t[1]}.` : n += `${t[0]}.`;
    throw new TypeError(n);
  }
}
function checkSigCryptoKey(c, t, ...n) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!isAlgorithm(c.algorithm, "HMAC"))
        throw unusable("HMAC");
      const ie = parseInt(t.slice(2), 10);
      if (getHashLength(c.algorithm.hash) !== ie)
        throw unusable(`SHA-${ie}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!isAlgorithm(c.algorithm, "RSASSA-PKCS1-v1_5"))
        throw unusable("RSASSA-PKCS1-v1_5");
      const ie = parseInt(t.slice(2), 10);
      if (getHashLength(c.algorithm.hash) !== ie)
        throw unusable(`SHA-${ie}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!isAlgorithm(c.algorithm, "RSA-PSS"))
        throw unusable("RSA-PSS");
      const ie = parseInt(t.slice(2), 10);
      if (getHashLength(c.algorithm.hash) !== ie)
        throw unusable(`SHA-${ie}`, "algorithm.hash");
      break;
    }
    case "EdDSA": {
      if (c.algorithm.name !== "Ed25519" && c.algorithm.name !== "Ed448")
        throw unusable("Ed25519 or Ed448");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!isAlgorithm(c.algorithm, "ECDSA"))
        throw unusable("ECDSA");
      const ie = getNamedCurve(t);
      if (c.algorithm.namedCurve !== ie)
        throw unusable(ie, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  checkUsage(c, n);
}
function message(c, t, ...n) {
  if (n.length > 2) {
    const ie = n.pop();
    c += `one of type ${n.join(", ")}, or ${ie}.`;
  } else n.length === 2 ? c += `one of type ${n[0]} or ${n[1]}.` : c += `of type ${n[0]}.`;
  return t == null ? c += ` Received ${t}` : typeof t == "function" && t.name ? c += ` Received function ${t.name}` : typeof t == "object" && t != null && t.constructor && t.constructor.name && (c += ` Received an instance of ${t.constructor.name}`), c;
}
const invalidKeyInput = (c, ...t) => message("Key must be ", c, ...t);
function withAlg(c, t, ...n) {
  return message(`Key for the ${c} algorithm must be `, t, ...n);
}
const isKeyLike = (c) => isCryptoKey(c), types = ["CryptoKey"], isDisjoint = (...c) => {
  const t = c.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let n;
  for (const ie of t) {
    const fe = Object.keys(ie);
    if (!n || n.size === 0) {
      n = new Set(fe);
      continue;
    }
    for (const ae of fe) {
      if (n.has(ae))
        return !1;
      n.add(ae);
    }
  }
  return !0;
};
function isObjectLike(c) {
  return typeof c == "object" && c !== null;
}
function isObject(c) {
  if (!isObjectLike(c) || Object.prototype.toString.call(c) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(c) === null)
    return !0;
  let t = c;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(c) === t;
}
const checkKeyLength = (c, t) => {
  if (c.startsWith("RS") || c.startsWith("PS")) {
    const { modulusLength: n } = t.algorithm;
    if (typeof n != "number" || n < 2048)
      throw new TypeError(`${c} requires key modulusLength to be 2048 bits or larger`);
  }
};
function subtleMapping(c) {
  let t, n;
  switch (c.kty) {
    case "oct": {
      switch (c.alg) {
        case "HS256":
        case "HS384":
        case "HS512":
          t = { name: "HMAC", hash: `SHA-${c.alg.slice(-3)}` }, n = ["sign", "verify"];
          break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
          throw new JOSENotSupported(`${c.alg} keys cannot be imported as CryptoKey instances`);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
          t = { name: "AES-GCM" }, n = ["encrypt", "decrypt"];
          break;
        case "A128KW":
        case "A192KW":
        case "A256KW":
          t = { name: "AES-KW" }, n = ["wrapKey", "unwrapKey"];
          break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
          t = { name: "PBKDF2" }, n = ["deriveBits"];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "RSA": {
      switch (c.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${c.alg.slice(-3)}` }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${c.alg.slice(-3)}` }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(c.alg.slice(-3), 10) || 1}`
          }, n = c.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (c.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: c.crv }, n = c.d ? ["deriveBits"] : [];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (c.alg) {
        case "EdDSA":
          t = { name: c.crv }, n = c.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: c.crv }, n = c.d ? ["deriveBits"] : [];
          break;
        default:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new JOSENotSupported('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: n };
}
const parse = async (c) => {
  var t, n;
  if (!c.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: ie, keyUsages: fe } = subtleMapping(c), ae = [
    ie,
    (t = c.ext) !== null && t !== void 0 ? t : !1,
    (n = c.key_ops) !== null && n !== void 0 ? n : fe
  ];
  if (ie.name === "PBKDF2")
    return crypto$1.subtle.importKey("raw", decode(c.k), ...ae);
  const le = { ...c };
  return delete le.alg, delete le.use, crypto$1.subtle.importKey("jwk", le, ...ae);
};
async function importJWK(c, t, n) {
  var ie;
  if (!isObject(c))
    throw new TypeError("JWK must be an object");
  switch (t || (t = c.alg), c.kty) {
    case "oct":
      if (typeof c.k != "string" || !c.k)
        throw new TypeError('missing "k" (Key Value) Parameter value');
      return n ?? (n = c.ext !== !0), n ? parse({ ...c, alg: t, ext: (ie = c.ext) !== null && ie !== void 0 ? ie : !1 }) : decode(c.k);
    case "RSA":
      if (c.oth !== void 0)
        throw new JOSENotSupported('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
    case "EC":
    case "OKP":
      return parse({ ...c, alg: t });
    default:
      throw new JOSENotSupported('Unsupported "kty" (Key Type) Parameter value');
  }
}
const symmetricTypeCheck = (c, t) => {
  if (!(t instanceof Uint8Array)) {
    if (!isKeyLike(t))
      throw new TypeError(withAlg(c, t, ...types, "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${types.join(" or ")} instances for symmetric algorithms must be of type "secret"`);
  }
}, asymmetricTypeCheck = (c, t, n) => {
  if (!isKeyLike(t))
    throw new TypeError(withAlg(c, t, ...types));
  if (t.type === "secret")
    throw new TypeError(`${types.join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.algorithm && n === "verify" && t.type === "private")
    throw new TypeError(`${types.join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
  if (t.algorithm && n === "encrypt" && t.type === "private")
    throw new TypeError(`${types.join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
}, checkKeyType = (c, t, n) => {
  c.startsWith("HS") || c === "dir" || c.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(c) ? symmetricTypeCheck(c, t) : asymmetricTypeCheck(c, t, n);
};
function validateCrit(c, t, n, ie, fe) {
  if (fe.crit !== void 0 && ie.crit === void 0)
    throw new c('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!ie || ie.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(ie.crit) || ie.crit.length === 0 || ie.crit.some((le) => typeof le != "string" || le.length === 0))
    throw new c('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let ae;
  n !== void 0 ? ae = new Map([...Object.entries(n), ...t.entries()]) : ae = t;
  for (const le of ie.crit) {
    if (!ae.has(le))
      throw new JOSENotSupported(`Extension Header Parameter "${le}" is not recognized`);
    if (fe[le] === void 0)
      throw new c(`Extension Header Parameter "${le}" is missing`);
    if (ae.get(le) && ie[le] === void 0)
      throw new c(`Extension Header Parameter "${le}" MUST be integrity protected`);
  }
  return new Set(ie.crit);
}
const validateAlgorithms = (c, t) => {
  if (t !== void 0 && (!Array.isArray(t) || t.some((n) => typeof n != "string")))
    throw new TypeError(`"${c}" option must be an array of strings`);
  if (t)
    return new Set(t);
};
function subtleDsa(c, t) {
  const n = `SHA-${c.slice(-3)}`;
  switch (c) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: n, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: n, name: "RSA-PSS", saltLength: c.slice(-3) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: n, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: n, name: "ECDSA", namedCurve: t.namedCurve };
    case "EdDSA":
      return { name: t.name };
    default:
      throw new JOSENotSupported(`alg ${c} is not supported either by JOSE or your javascript runtime`);
  }
}
function getCryptoKey(c, t, n) {
  if (isCryptoKey(t))
    return checkSigCryptoKey(t, c, n), t;
  if (t instanceof Uint8Array) {
    if (!c.startsWith("HS"))
      throw new TypeError(invalidKeyInput(t, ...types));
    return crypto$1.subtle.importKey("raw", t, { hash: `SHA-${c.slice(-3)}`, name: "HMAC" }, !1, [n]);
  }
  throw new TypeError(invalidKeyInput(t, ...types, "Uint8Array"));
}
const verify = async (c, t, n, ie) => {
  const fe = await getCryptoKey(c, t, "verify");
  checkKeyLength(c, fe);
  const ae = subtleDsa(c, fe.algorithm);
  try {
    return await crypto$1.subtle.verify(ae, fe, n, ie);
  } catch {
    return !1;
  }
};
async function flattenedVerify(c, t, n) {
  var ie;
  if (!isObject(c))
    throw new JWSInvalid("Flattened JWS must be an object");
  if (c.protected === void 0 && c.header === void 0)
    throw new JWSInvalid('Flattened JWS must have either of the "protected" or "header" members');
  if (c.protected !== void 0 && typeof c.protected != "string")
    throw new JWSInvalid("JWS Protected Header incorrect type");
  if (c.payload === void 0)
    throw new JWSInvalid("JWS Payload missing");
  if (typeof c.signature != "string")
    throw new JWSInvalid("JWS Signature missing or incorrect type");
  if (c.header !== void 0 && !isObject(c.header))
    throw new JWSInvalid("JWS Unprotected Header incorrect type");
  let fe = {};
  if (c.protected)
    try {
      const ke = decode(c.protected);
      fe = JSON.parse(decoder.decode(ke));
    } catch {
      throw new JWSInvalid("JWS Protected Header is invalid");
    }
  if (!isDisjoint(fe, c.header))
    throw new JWSInvalid("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
  const ae = {
    ...fe,
    ...c.header
  }, le = validateCrit(JWSInvalid, /* @__PURE__ */ new Map([["b64", !0]]), n == null ? void 0 : n.crit, fe, ae);
  let he = !0;
  if (le.has("b64") && (he = fe.b64, typeof he != "boolean"))
    throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
  const { alg: me } = ae;
  if (typeof me != "string" || !me)
    throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');
  const ye = n && validateAlgorithms("algorithms", n.algorithms);
  if (ye && !ye.has(me))
    throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter not allowed');
  if (he) {
    if (typeof c.payload != "string")
      throw new JWSInvalid("JWS Payload must be a string");
  } else if (typeof c.payload != "string" && !(c.payload instanceof Uint8Array))
    throw new JWSInvalid("JWS Payload must be a string or an Uint8Array instance");
  let be = !1;
  typeof t == "function" && (t = await t(fe, c), be = !0), checkKeyType(me, t, "verify");
  const Ae = concat(encoder.encode((ie = c.protected) !== null && ie !== void 0 ? ie : ""), encoder.encode("."), typeof c.payload == "string" ? encoder.encode(c.payload) : c.payload);
  let Se;
  try {
    Se = decode(c.signature);
  } catch {
    throw new JWSInvalid("Failed to base64url decode the signature");
  }
  if (!await verify(me, t, Se, Ae))
    throw new JWSSignatureVerificationFailed();
  let Re;
  if (he)
    try {
      Re = decode(c.payload);
    } catch {
      throw new JWSInvalid("Failed to base64url decode the payload");
    }
  else typeof c.payload == "string" ? Re = encoder.encode(c.payload) : Re = c.payload;
  const Me = { payload: Re };
  return c.protected !== void 0 && (Me.protectedHeader = fe), c.header !== void 0 && (Me.unprotectedHeader = c.header), be ? { ...Me, key: t } : Me;
}
async function compactVerify(c, t, n) {
  if (c instanceof Uint8Array && (c = decoder.decode(c)), typeof c != "string")
    throw new JWSInvalid("Compact JWS must be a string or Uint8Array");
  const { 0: ie, 1: fe, 2: ae, length: le } = c.split(".");
  if (le !== 3)
    throw new JWSInvalid("Invalid Compact JWS");
  const he = await flattenedVerify({ payload: fe, protected: ie, signature: ae }, t, n), me = { payload: he.payload, protectedHeader: he.protectedHeader };
  return typeof t == "function" ? { ...me, key: he.key } : me;
}
const epoch = (c) => Math.floor(c.getTime() / 1e3), minute = 60, hour = minute * 60, day = hour * 24, week = day * 7, year = day * 365.25, REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i, secs = (c) => {
  const t = REGEX.exec(c);
  if (!t)
    throw new TypeError("Invalid time period format");
  const n = parseFloat(t[1]);
  switch (t[2].toLowerCase()) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      return Math.round(n);
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      return Math.round(n * minute);
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      return Math.round(n * hour);
    case "day":
    case "days":
    case "d":
      return Math.round(n * day);
    case "week":
    case "weeks":
    case "w":
      return Math.round(n * week);
    default:
      return Math.round(n * year);
  }
}, normalizeTyp = (c) => c.toLowerCase().replace(/^application\//, ""), checkAudiencePresence = (c, t) => typeof c == "string" ? t.includes(c) : Array.isArray(c) ? t.some(Set.prototype.has.bind(new Set(c))) : !1, jwtPayload = (c, t, n = {}) => {
  const { typ: ie } = n;
  if (ie && (typeof c.typ != "string" || normalizeTyp(c.typ) !== normalizeTyp(ie)))
    throw new JWTClaimValidationFailed('unexpected "typ" JWT header value', "typ", "check_failed");
  let fe;
  try {
    fe = JSON.parse(decoder.decode(t));
  } catch {
  }
  if (!isObject(fe))
    throw new JWTInvalid("JWT Claims Set must be a top-level JSON object");
  const { requiredClaims: ae = [], issuer: le, subject: he, audience: me, maxTokenAge: ye } = n;
  ye !== void 0 && ae.push("iat"), me !== void 0 && ae.push("aud"), he !== void 0 && ae.push("sub"), le !== void 0 && ae.push("iss");
  for (const $e of new Set(ae.reverse()))
    if (!($e in fe))
      throw new JWTClaimValidationFailed(`missing required "${$e}" claim`, $e, "missing");
  if (le && !(Array.isArray(le) ? le : [le]).includes(fe.iss))
    throw new JWTClaimValidationFailed('unexpected "iss" claim value', "iss", "check_failed");
  if (he && fe.sub !== he)
    throw new JWTClaimValidationFailed('unexpected "sub" claim value', "sub", "check_failed");
  if (me && !checkAudiencePresence(fe.aud, typeof me == "string" ? [me] : me))
    throw new JWTClaimValidationFailed('unexpected "aud" claim value', "aud", "check_failed");
  let be;
  switch (typeof n.clockTolerance) {
    case "string":
      be = secs(n.clockTolerance);
      break;
    case "number":
      be = n.clockTolerance;
      break;
    case "undefined":
      be = 0;
      break;
    default:
      throw new TypeError("Invalid clockTolerance option type");
  }
  const { currentDate: Ae } = n, Se = epoch(Ae || /* @__PURE__ */ new Date());
  if ((fe.iat !== void 0 || ye) && typeof fe.iat != "number")
    throw new JWTClaimValidationFailed('"iat" claim must be a number', "iat", "invalid");
  if (fe.nbf !== void 0) {
    if (typeof fe.nbf != "number")
      throw new JWTClaimValidationFailed('"nbf" claim must be a number', "nbf", "invalid");
    if (fe.nbf > Se + be)
      throw new JWTClaimValidationFailed('"nbf" claim timestamp check failed', "nbf", "check_failed");
  }
  if (fe.exp !== void 0) {
    if (typeof fe.exp != "number")
      throw new JWTClaimValidationFailed('"exp" claim must be a number', "exp", "invalid");
    if (fe.exp <= Se - be)
      throw new JWTExpired('"exp" claim timestamp check failed', "exp", "check_failed");
  }
  if (ye) {
    const $e = Se - fe.iat, Re = typeof ye == "number" ? ye : secs(ye);
    if ($e - be > Re)
      throw new JWTExpired('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
    if ($e < 0 - be)
      throw new JWTClaimValidationFailed('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
  }
  return fe;
};
async function jwtVerify(c, t, n) {
  var ie;
  const fe = await compactVerify(c, t, n);
  if (!((ie = fe.protectedHeader.crit) === null || ie === void 0) && ie.includes("b64") && fe.protectedHeader.b64 === !1)
    throw new JWTInvalid("JWTs MUST NOT use unencoded payload");
  const le = { payload: jwtPayload(fe.protectedHeader, fe.payload, n), protectedHeader: fe.protectedHeader };
  return typeof t == "function" ? { ...le, key: fe.key } : le;
}
function getKtyFromAlg(c) {
  switch (typeof c == "string" && c.slice(0, 2)) {
    case "RS":
    case "PS":
      return "RSA";
    case "ES":
      return "EC";
    case "Ed":
      return "OKP";
    default:
      throw new JOSENotSupported('Unsupported "alg" value for a JSON Web Key Set');
  }
}
function isJWKSLike(c) {
  return c && typeof c == "object" && Array.isArray(c.keys) && c.keys.every(isJWKLike);
}
function isJWKLike(c) {
  return isObject(c);
}
function clone(c) {
  return typeof structuredClone == "function" ? structuredClone(c) : JSON.parse(JSON.stringify(c));
}
class LocalJWKSet {
  constructor(t) {
    if (this._cached = /* @__PURE__ */ new WeakMap(), !isJWKSLike(t))
      throw new JWKSInvalid("JSON Web Key Set malformed");
    this._jwks = clone(t);
  }
  async getKey(t, n) {
    const { alg: ie, kid: fe } = { ...t, ...n == null ? void 0 : n.header }, ae = getKtyFromAlg(ie), le = this._jwks.keys.filter((ye) => {
      let be = ae === ye.kty;
      if (be && typeof fe == "string" && (be = fe === ye.kid), be && typeof ye.alg == "string" && (be = ie === ye.alg), be && typeof ye.use == "string" && (be = ye.use === "sig"), be && Array.isArray(ye.key_ops) && (be = ye.key_ops.includes("verify")), be && ie === "EdDSA" && (be = ye.crv === "Ed25519" || ye.crv === "Ed448"), be)
        switch (ie) {
          case "ES256":
            be = ye.crv === "P-256";
            break;
          case "ES256K":
            be = ye.crv === "secp256k1";
            break;
          case "ES384":
            be = ye.crv === "P-384";
            break;
          case "ES512":
            be = ye.crv === "P-521";
            break;
        }
      return be;
    }), { 0: he, length: me } = le;
    if (me === 0)
      throw new JWKSNoMatchingKey();
    if (me !== 1) {
      const ye = new JWKSMultipleMatchingKeys(), { _cached: be } = this;
      throw ye[Symbol.asyncIterator] = async function* () {
        for (const Ae of le)
          try {
            yield await importWithAlgCache(be, Ae, ie);
          } catch {
            continue;
          }
      }, ye;
    }
    return importWithAlgCache(this._cached, he, ie);
  }
}
async function importWithAlgCache(c, t, n) {
  const ie = c.get(t) || c.set(t, {}).get(t);
  if (ie[n] === void 0) {
    const fe = await importJWK({ ...t, ext: !0 }, n);
    if (fe instanceof Uint8Array || fe.type !== "public")
      throw new JWKSInvalid("JSON Web Key Set members must be public keys");
    ie[n] = fe;
  }
  return ie[n];
}
const fetchJwks = async (c, t, n) => {
  let ie, fe, ae = !1;
  typeof AbortController == "function" && (ie = new AbortController(), fe = setTimeout(() => {
    ae = !0, ie.abort();
  }, t));
  const le = await fetch(c.href, {
    signal: ie ? ie.signal : void 0,
    redirect: "manual",
    headers: n.headers
  }).catch((he) => {
    throw ae ? new JWKSTimeout() : he;
  });
  if (fe !== void 0 && clearTimeout(fe), le.status !== 200)
    throw new JOSEError("Expected 200 OK from the JSON Web Key Set HTTP response");
  try {
    return await le.json();
  } catch {
    throw new JOSEError("Failed to parse the JSON Web Key Set HTTP response as JSON");
  }
};
function isCloudflareWorkers() {
  return typeof WebSocketPair < "u" || typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime < "u" && EdgeRuntime === "vercel";
}
class RemoteJWKSet extends LocalJWKSet {
  constructor(t, n) {
    if (super({ keys: [] }), this._jwks = void 0, !(t instanceof URL))
      throw new TypeError("url must be an instance of URL");
    this._url = new URL(t.href), this._options = { agent: n == null ? void 0 : n.agent, headers: n == null ? void 0 : n.headers }, this._timeoutDuration = typeof (n == null ? void 0 : n.timeoutDuration) == "number" ? n == null ? void 0 : n.timeoutDuration : 5e3, this._cooldownDuration = typeof (n == null ? void 0 : n.cooldownDuration) == "number" ? n == null ? void 0 : n.cooldownDuration : 3e4, this._cacheMaxAge = typeof (n == null ? void 0 : n.cacheMaxAge) == "number" ? n == null ? void 0 : n.cacheMaxAge : 6e5;
  }
  coolingDown() {
    return typeof this._jwksTimestamp == "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : !1;
  }
  fresh() {
    return typeof this._jwksTimestamp == "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : !1;
  }
  async getKey(t, n) {
    (!this._jwks || !this.fresh()) && await this.reload();
    try {
      return await super.getKey(t, n);
    } catch (ie) {
      if (ie instanceof JWKSNoMatchingKey && this.coolingDown() === !1)
        return await this.reload(), super.getKey(t, n);
      throw ie;
    }
  }
  async reload() {
    this._pendingFetch && isCloudflareWorkers() && (this._pendingFetch = void 0), this._pendingFetch || (this._pendingFetch = fetchJwks(this._url, this._timeoutDuration, this._options).then((t) => {
      if (!isJWKSLike(t))
        throw new JWKSInvalid("JSON Web Key Set malformed");
      this._jwks = { keys: t.keys }, this._jwksTimestamp = Date.now(), this._pendingFetch = void 0;
    }).catch((t) => {
      throw this._pendingFetch = void 0, t;
    })), await this._pendingFetch;
  }
}
function createRemoteJWKSet(c, t) {
  const n = new RemoteJWKSet(c, t);
  return async function(ie, fe) {
    return n.getKey(ie, fe);
  };
}
function a() {
  return a = Object.assign || function(c) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var ie in n) Object.prototype.hasOwnProperty.call(n, ie) && (c[ie] = n[ie]);
    }
    return c;
  }, a.apply(this, arguments);
}
function l(c, t) {
  c.prototype = Object.create(t.prototype), c.prototype.constructor = c, h(c, t);
}
function f(c) {
  return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, f(c);
}
function h(c, t) {
  return h = Object.setPrototypeOf || function(n, ie) {
    return n.__proto__ = ie, n;
  }, h(c, t);
}
function p() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function d(c, t, n) {
  return d = p() ? Reflect.construct : function(ie, fe, ae) {
    var le = [null];
    le.push.apply(le, fe);
    var he = new (Function.bind.apply(ie, le))();
    return ae && h(he, ae.prototype), he;
  }, d.apply(null, arguments);
}
function m(c) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return m = function(n) {
    if (n === null || Function.toString.call(n).indexOf("[native code]") === -1) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, ie);
    }
    function ie() {
      return d(n, arguments, f(this).constructor);
    }
    return ie.prototype = Object.create(n.prototype, { constructor: { value: ie, enumerable: !1, writable: !0, configurable: !0 } }), h(ie, n);
  }, m(c);
}
function v(c, t) {
  if (c == null) return {};
  var n, ie, fe = {}, ae = Object.keys(c);
  for (ie = 0; ie < ae.length; ie++) t.indexOf(n = ae[ie]) >= 0 || (fe[n] = c[n]);
  return fe;
}
function g(c, t) {
  (t == null || t > c.length) && (t = c.length);
  for (var n = 0, ie = new Array(t); n < t; n++) ie[n] = c[n];
  return ie;
}
function _(c, t) {
  var n = typeof Symbol < "u" && c[Symbol.iterator] || c["@@iterator"];
  if (n) return (n = n.call(c)).next.bind(n);
  if (Array.isArray(c) || (n = function(fe, ae) {
    if (fe) {
      if (typeof fe == "string") return g(fe, ae);
      var le = Object.prototype.toString.call(fe).slice(8, -1);
      return le === "Object" && fe.constructor && (le = fe.constructor.name), le === "Map" || le === "Set" ? Array.from(fe) : le === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(le) ? g(fe, ae) : void 0;
    }
  }(c)) || t) {
    n && (c = n);
    var ie = 0;
    return function() {
      return ie >= c.length ? { done: !0 } : { done: !1, value: c[ie++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w(c, t) {
  return function(n) {
    function ie() {
      var fe;
      return (fe = n.call(this, t) || this).name = c, fe;
    }
    return l(ie, n), ie;
  }(/* @__PURE__ */ m(Error));
}
var y = w("PopupTimeoutError", "The popup has timed out."), b = w("PopupClosedError", "The popup was closed."), P = function(c) {
  return String.fromCharCode.apply(null, Array.from(new Uint8Array(c)));
}, k = new TextEncoder(), S = function() {
  return u;
}, O = function(c) {
  return S().btoa(c);
}, R = function(c) {
  return O(c).replace(/=+$/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, A = function() {
  var c;
  return (c = S().crypto) != null ? c : S().msCrypto;
}, j = function(c) {
  return A().getRandomValues(new Uint8Array(c));
}, T = function() {
  var c;
  return (c = A().subtle) != null ? c : A().webkitSubtle;
}, I = function(c) {
  try {
    var t = T().digest({ name: "SHA-256" }, c);
    return S().msCrypto ? Promise.resolve(new Promise(function(n, ie) {
      t.oncomplete = function(fe) {
        return n(fe.target.result);
      }, t.onerror = function(fe) {
        return ie(fe.error);
      }, t.onabort = function() {
        return ie("The digest operation was aborted");
      };
    })) : Promise.resolve(t);
  } catch (n) {
    return Promise.reject(n);
  }
}, z = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.", U = function(c) {
  return S().atob(c);
}, E = new TextDecoder();
function L(c) {
  return Array.from(new Set(c));
}
var C = function(c) {
  return L(c.trim().split(/\s+/)).sort().join(" ");
};
function x(c) {
  var t = {};
  return c.forEach(function(n, ie) {
    t[ie] = c.getAll(ie).length > 1 ? c.getAll(ie) : c.get(ie);
  }), t;
}
function q(c) {
  var t = new URLSearchParams([].concat(Object.entries(c)).filter(function(n) {
    return n[0] != null && n[1] != null;
  }));
  return t.sort(), t.toString();
}
var D = { createCodeChallengeAndVerifier: function(c, t) {
  c === void 0 && (c = 43), t === void 0 && (t = "S256");
  try {
    var n = function(ie) {
      return Array.from(j(ie)).map(function(fe) {
        return z[fe % z.length];
      }).join("");
    }(c);
    switch (t) {
      case "plain":
        return Promise.resolve({ verifier: n, challenge: n });
      case "S256":
        return Promise.resolve(I(k.encode(n).buffer)).then(function(ie) {
          return { verifier: n, challenge: R(P(ie)) };
        });
      default:
        throw new Error("bad challenge method");
    }
  } catch (ie) {
    return Promise.reject(ie);
  }
}, getCrypto: A, getCryptoSubtle: T, getRandomBytes: j, sha256: I, verifyIdToken: function(c, t, n, ie) {
  try {
    return Promise.resolve(jwtVerify(t, createRemoteJWKSet(new URL(c)), { audience: ie })).then(function(fe) {
      var ae = fe.payload;
      if (ae.__raw = t, n !== ae.nonce) throw new Error("nonces don't match");
      return ae;
    });
  } catch (fe) {
    return Promise.reject(fe);
  }
} }, F = { decodeState: function(c) {
  var t = c.split("."), n = t[1];
  if (t.slice(2).length > 0) throw new Error("failed to decode state");
  return (n == null ? void 0 : n.length) > 0 ? JSON.parse(decodeURIComponent(U(n))) : void 0;
}, encodeState: function(c) {
  return R(P(j(32))) + "." + (c == null ? "" : R(encodeURIComponent(JSON.stringify(c))));
}, fromBase64: U, textDecoder: E, textEncoder: k, toBase64: O, toUrlEncodedBase64: R, stringFromBuffer: P }, N = { __proto__: null, crypto: D, encoding: F, getSortedScope: C, getWindow: S, objectFromEntries: function(c) {
  for (var t, n = {}, ie = _(c); !(t = ie()).done; ) {
    var fe = t.value;
    n[fe[0]] = fe[1];
  }
  return n;
}, objectFromURLSearchParams: x, objectToKey: q, retry: function c(t, n, ie, fe, ae) {
  return n === void 0 && (n = 4), ie === void 0 && (ie = 250), fe === void 0 && (fe = 2), ae === void 0 && (ae = null), n <= 0 ? Promise.reject(ae) : t().catch(function(le) {
    try {
      return Promise.resolve(new Promise(function(he) {
        return setTimeout(he, ie);
      })).then(function() {
        return c(t, n - 1, ie * fe, fe, le);
      });
    } catch (he) {
      return Promise.reject(he);
    }
  });
}, uniqueElementsFromArray: L }, B = /* @__PURE__ */ function(c) {
  function t(n, ie, fe) {
    var ae;
    return (ae = c.call(this, n + ": " + ie + (fe ? `
See more at ` + fe + "." : "")) || this).code = void 0, ae.description = void 0, ae.uri = void 0, ae.code = n, ae.description = ie, ae.uri = fe, ae;
  }
  return l(t, c), t.fromResponse = function(n) {
    return new t(n.error, n.error_description, n.error_uri);
  }, t;
}(/* @__PURE__ */ m(Error)), M = ["url"], W = ["url", "client_id", "client_secret", "client_auth_method"], V = /* @__PURE__ */ function() {
  function c(n) {
    this.options = void 0, this.options = n;
  }
  var t = c.prototype;
  return t.buildAuthorizeUrl = function(n) {
    return this._buildUrl(n);
  }, t.buildLogoutUrl = function(n) {
    return this._buildUrl(n);
  }, t.parseAuthorizeResponseFromFragment = function(n) {
    return this._validateResponse(x(new URLSearchParams(new URL(n).hash.substring(1))));
  }, t.parseAuthorizeResponseFromQuery = function(n) {
    return this._validateResponse(x(new URL(n).searchParams));
  }, t.authorizeWithPopup = function(n, ie) {
    ie === void 0 && (ie = {});
    try {
      var fe, ae = this;
      if (!window) throw new Error("no window in options");
      var le = ae.buildAuthorizeUrl(n), he = ie.popup, me = (fe = ie.timeout) != null ? fe : 36e5;
      if (he) he.location.href = le;
      else {
        var ye, be, Ae = (ye = ie.width) != null ? ye : 600, Se = (be = ie.height) != null ? be : 800;
        if (!(he = window.open(le, "uauth:authorize:popup", "left=" + (window.screenX + (window.innerWidth - Ae) / 2) + ",top=" + (window.screenY + (window.innerHeight - Se) / 2) + ",width=" + Ae + ",height=" + Se + ",resizable,scrollbars=yes,status=1"))) throw new Error("popup failed to be constructed");
      }
      var $e = !1;
      return Promise.resolve(new Promise(function(Re, Me) {
        var ke = setTimeout(function() {
          $e || (clearInterval(Te), he.close(), Me(new y()));
        }, me), Te = setInterval(function() {
          var Ie, qe, Ue, ze;
          !$e && (Ie = he) != null && Ie.closed && (clearInterval(Te), clearTimeout(ke), Me(new b()));
          try {
            qe = he.location.href, Ue = new URL(qe), ze = new URL(n.redirect_uri);
          } catch {
            return;
          }
          if (Ue.hash = "", Ue.href === ze.href) {
            $e = !0, clearInterval(Te), clearTimeout(ke), he.close();
            try {
              Re(ae.parseAuthorizeResponseFromFragment(qe));
            } catch (Ve) {
              Me(Ve);
            }
          }
        }, 10);
      }));
    } catch (Re) {
      return Promise.reject(Re);
    }
  }, t.authorizeWithDevice = function(n) {
    return Promise.resolve({});
  }, t.getToken = function(n) {
    try {
      var ie = this._buildRequest(n, { method: "POST" });
      return Promise.resolve(this._fetchJSON(ie[0], ie[1]));
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, t.introspect = function(n) {
    var ie = this._buildRequest(n, { method: "POST" });
    return this._fetchJSON(ie[0], ie[1]);
  }, t.revoke = function(n) {
    try {
      var ie = this._buildRequest(n, { method: "POST" });
      return Promise.resolve(this._fetchJSON(ie[0], ie[1])).then(function() {
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, t.userinfo = function(n) {
    var ie = this._buildRequest(n, { method: "GET", headers: { Authorization: "Basic " + n.access_token } });
    return this._fetchJSON(ie[0], ie[1]);
  }, t.jwks = function(n) {
    var ie = this._buildRequest(n, { method: "GET" });
    return this._fetchJSON(ie[0], ie[1]);
  }, t.getTokenWithAuthorizationCode = function(n) {
    return this.getToken(n);
  }, t.getTokenWithRefreshToken = function(n) {
    return this.getToken(n);
  }, t.getTokenWithDeviceCode = function(n) {
    return this.getToken(n);
  }, t.getTokenWithPassword = function(n) {
    return this.getToken(n);
  }, t.getTokenWithSAML = function(n) {
    return this.getToken(n);
  }, t.getTokenWithClientCredentials = function(n) {
    return this.getToken(n);
  }, t._buildUrl = function(n) {
    for (var ie = n.url, fe = v(n, M), ae = new URL(ie), le = new URLSearchParams(), he = 0, me = Object.entries(fe); he < me.length; he++) {
      var ye = me[he], be = ye[0], Ae = ye[1];
      be != null && Ae != null && le.append(be, Ae);
    }
    return ae.search = le.toString(), ae.toString();
  }, t._buildRequest = function(n, ie) {
    var fe, ae = n.url, le = n.client_id, he = n.client_secret, me = n.client_auth_method, ye = v(n, W), be = ie.headers, Ae = ie.method, Se = new Headers((fe = this.options.headers) != null ? fe : []);
    new Headers(be ?? []).forEach(function(Re, Me) {
      Se.set(Me, Re);
    }), ie.method === "POST" && Se.set("Content-Type", "application/x-www-form-urlencoded");
    var $e = a({ client_id: le }, ye);
    switch (me) {
      case "client_secret_basic":
        if (he == null) throw new Error("Client secret not present!");
        Se.set("Authorization", "Basic " + O(le + ":" + he));
        break;
      case "client_secret_post":
        if (he == null) throw new Error("Client secret not present!");
        $e.client_secret = he;
        break;
      case "none":
      case void 0:
      case null:
        break;
      default:
        throw new Error("Bad client_auth_method");
    }
    return [ae, { method: Ae, headers: Se, body: Ae === "POST" ? new URLSearchParams(Object.entries($e)) : void 0 }];
  }, t._validateResponse = function(n) {
    if (n.error) throw c.Error.fromResponse(n);
    return n;
  }, t._fetchJSON = function(n, ie) {
    try {
      var fe, ae = this;
      if (ie.headers) {
        var le = new Headers(ie.headers);
        le.set("Accept", "application/json"), ie.headers = le;
      } else ie.headers = { Accept: "application/json" };
      return Promise.resolve((fe = window) == null ? void 0 : fe.fetch(n, ie)).then(function(he) {
        return Promise.resolve(he.json()).then(function(me) {
          if (ae._validateResponse(me), !he.ok) throw new Error(he.status + " " + he.statusText + ": " + JSON.stringify(me));
          return me;
        });
      });
    } catch (he) {
      return Promise.reject(he);
    }
  }, c;
}();
V.Error = B;
var J, H, K, Q, G, Y, X = /* @__PURE__ */ function() {
  function c(n) {
    this.client = void 0, this.client = n;
  }
  var t = c.prototype;
  return t.get = function(n, ie) {
    var fe = ie === void 0 ? {} : ie, ae = fe.mustExist, le = ae !== void 0 && ae, he = fe.deleteAfter, me = he !== void 0 && he;
    try {
      var ye = this;
      return Promise.resolve(ye.client.getStore().get(n)).then(function(be) {
        var Ae;
        function Se(ke) {
          if (Ae) return ke;
          var Te = function() {
            if (me) return Promise.resolve(ye.client.getStore().delete(n)).then(function() {
            });
          }();
          return Te && Te.then ? Te.then(function() {
            return $e;
          }) : $e;
        }
        if (be != null) {
          var $e = be.value, Re = be.expiresAt, Me = function() {
            if (Re !== 0 && Re < Date.now()) return Promise.resolve(ye.client.getStore().delete(n)).then(function() {
              if (le) throw new Error(n + " does not exist in store");
              Ae = 1;
            });
          }();
          return Me && Me.then ? Me.then(Se) : Se(Me);
        }
        if (le) throw new Error(n + " does not exist in store");
      });
    } catch (be) {
      return Promise.reject(be);
    }
  }, t.set = function(n, ie, fe) {
    fe === void 0 && (fe = 0);
    try {
      return Promise.resolve(this.client.getStore().set(n, { expiresAt: fe === 0 ? 0 : Date.now() + fe, value: ie })).then(function() {
      });
    } catch (ae) {
      return Promise.reject(ae);
    }
  }, t.setAuthorizeRequest = function(n) {
    try {
      return Promise.resolve(this.set("request", n, 3e5)).then(function() {
      });
    } catch (ie) {
      return Promise.reject(ie);
    }
  }, t.getAuthorizeRequest = function() {
    return this.get("request", { mustExist: !0, deleteAfter: !0 });
  }, t.setLogoutRequest = function(n) {
    try {
      return Promise.resolve(this.set("logout-request", n, 3e5)).then(function() {
      });
    } catch (ie) {
      return Promise.reject(ie);
    }
  }, t.getLogoutRequest = function() {
    return this.get("logout-request", { mustExist: !0, deleteAfter: !0 });
  }, t.setVerifier = function(n, ie) {
    try {
      return Promise.resolve(this.set("verifier:" + n, ie, 3e5)).then(function() {
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, t.getVerifier = function(n) {
    return this.get("verifier:" + n, { mustExist: !0, deleteAfter: !0 });
  }, t.setOpenIdConfiguration = function(n, ie, fe) {
    try {
      return Promise.resolve(this.set("openidConfiguration:" + n, ie, fe)).then(function() {
      });
    } catch (ae) {
      return Promise.reject(ae);
    }
  }, t.getOpenIdConfiguration = function(n) {
    return this.get("openidConfiguration:" + n);
  }, t.setAuthorization = function(n) {
    try {
      var ie = this, fe = { clientID: n.idToken.aud, resource: n.resource, scope: n.scope, username: n.idToken.sub }, ae = n.expiresAt - Date.now();
      return Promise.resolve(ie.set("username", fe.username, ae)).then(function() {
        var le = ie.set;
        return Promise.resolve(ie._getAuthorizationKey(fe)).then(function(he) {
          return Promise.resolve(le.call(ie, he, n, ae)).then(function() {
          });
        });
      });
    } catch (le) {
      return Promise.reject(le);
    }
  }, t.deleteAuthorization = function(n) {
    try {
      var ie = this;
      return Promise.resolve(ie.get("username")).then(function(fe) {
        return Promise.resolve(ie._getUsername(n.username, fe)).then(function(ae) {
          function le() {
            var me = ie.client.getStore(), ye = me.delete;
            return Promise.resolve(ie._getAuthorizationKey(n)).then(function(be) {
              return ye.call(me, be);
            });
          }
          n.username = ae;
          var he = function() {
            if (n.username === fe) return Promise.resolve(ie.client.getStore().delete("username")).then(function() {
            });
          }();
          return he && he.then ? he.then(le) : le();
        });
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, t.getAuthorization = function(n) {
    try {
      var ie = this, fe = ie.get;
      return Promise.resolve(ie._getAuthorizationKey(n)).then(function(ae) {
        return fe.call(ie, ae, { mustExist: !0 });
      });
    } catch (ae) {
      return Promise.reject(ae);
    }
  }, t._getAuthorizationKey = function(n) {
    try {
      var ie = this, fe = q, ae = ie._getUsername, le = n.username;
      return Promise.resolve(ie.get("username")).then(function(he) {
        return Promise.resolve(ae.call(ie, le, he)).then(function(me) {
          var ye, be, Ae;
          return "authorization?" + fe.call(N, { username: me, clientID: (ye = n.clientID) != null ? ye : ie.client.fallbackLoginOptions.clientID, scope: C((be = n.scope) != null ? be : ie.client.fallbackLoginOptions.scope), resource: (Ae = n.resource) != null ? Ae : ie.client.fallbackLoginOptions.resource });
        });
      });
    } catch (he) {
      return Promise.reject(he);
    }
  }, t._getUsername = function(n, ie) {
    try {
      if (n == null && ie == null) throw new Error("no username given");
      return Promise.resolve(n ?? ie);
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, c;
}(), $ = /* @__PURE__ */ function() {
  function c(n) {
    this.storage = void 0, this.storage = n;
  }
  var t = c.prototype;
  return t.get = function(n) {
    var ie = this.storage.getItem(n);
    return ie != null ? JSON.parse(ie) : null;
  }, t.delete = function(n) {
    return this.storage.removeItem(n), !0;
  }, t.set = function(n, ie) {
    return this.storage.setItem(n, JSON.stringify(ie)), this;
  }, c;
}();
(function(c) {
  c.openid = "openid", c.wallet = "wallet";
})(K || (K = {})), function(c) {
  c.email = "email", c.badges = "badges", c.offline = "offline", c.offline_access = "offline_access", c.humanity_check = "humanity_check", c.profile = "profile", c.social = "social";
}(Q || (Q = {})), function(c) {
  c.twitter = "social:twitter", c.reddit = "social:reddit", c.youtube = "social:youtube", c.discord = "social:discord", c.telegram = "social:telegram";
}(G || (G = {})), function(c) {
  c.display_name = "profile:name", c.profile_location = "profile:location", c.profile_bio = "profile:bio", c.ipfs_website = "profile:ipfs_website", c.profile_picture = "profile:picture", c.profile_uri = "profile:uri", c.profile_phone = "profile:phone";
}(Y || (Y = {}));
var Z = ((J = {})[K.openid] = { optional: !1 }, J[K.wallet] = { optional: !1 }, J), ee = ((H = {})[Q.email] = { optional: !0 }, H[Q.offline] = { optional: !1 }, H[Q.offline_access] = { optional: !1 }, H[Q.humanity_check] = { optional: !0 }, H[Q.badges] = { optional: !0 }, H[Q.profile] = { optional: !0 }, H[Q.social] = { optional: !0 }, H[Y.display_name] = { optional: !0 }, H[Y.profile_location] = { optional: !0 }, H[Y.profile_bio] = { optional: !0 }, H[Y.profile_picture] = { optional: !0 }, H[Y.profile_uri] = { optional: !0 }, H[Y.profile_phone] = { optional: !0 }, H[Y.ipfs_website] = { optional: !0 }, H[G.twitter] = { optional: !0 }, H[G.reddit] = { optional: !0 }, H[G.youtube] = { optional: !0 }, H[G.discord] = { optional: !0 }, H[G.telegram] = { optional: !0 }, H), te = function(c) {
  var t = [], n = c.premium ? ee : Z;
  return Object.keys(n).forEach(function(ie) {
    t.push(ie), n[ie].optional && t.push(ie + ":optional");
  }), t;
}, re = ["clientID", "username", "scope", "resource"];
if (typeof window < "u") {
  var ne = window;
  ne.UAUTH_VERSION = ne.UAUTH_VERSION || {}, ne.UAUTH_VERSION.JS = "3.0.1";
}
var oe = /* @__PURE__ */ function() {
  var c = t.prototype;
  function t(n) {
    var ie, fe, ae, le, he, me, ye, be, Ae, Se;
    this.util = N, this._clientStore = new X(this), this.api = void 0, this.fallbackIssuer = void 0, this.fallbackLoginOptions = void 0, this.fallbackLogoutOptions = void 0, this.cacheOptions = void 0, this.issuerResolver = void 0, this.resolution = void 0, this.store = void 0, this.storeOptions = void 0, this.fallbackIssuer = (ie = n.fallbackIssuer) != null ? ie : "https://auth.unstoppabledomains.com", this.resolution = (fe = n.resolution) != null ? fe : new build.Resolution({ apiKey: process$1.env.RESOLUTION_API_KEY }), this.storeOptions = { store: n.store, storeType: (ae = n.storeType) != null ? ae : "localstore" }, this.cacheOptions = a({ issuer: !1, userinfo: !0 }, (le = n.cacheOptions) != null ? le : {}), this.api = new V({ headers: {} }), this.fallbackLoginOptions = { clientID: n.clientID, clientSecret: n.clientSecret, clientAuthMethod: (he = n.clientAuthMethod) != null ? he : n.clientSecret ? "client_secret_post" : "none", maxAge: (me = n.maxAge) != null ? me : 3e5, prompt: (ye = n.prompt) != null ? ye : "login", resource: n.resource, redirectUri: n.redirectUri, responseMode: (be = n.responseMode) != null ? be : "fragment", scope: (Ae = n.scope) != null ? Ae : "openid wallet" }, this.fallbackLogoutOptions = { rpInitiatedLogout: (Se = n.rpInitiatedLogout) != null ? Se : typeof n.postLogoutRedirectUri == "string", postLogoutRedirectUri: n.postLogoutRedirectUri };
    var $e = this;
    this.issuerResolver = new e({ webfingerResolver: new u$1({ ipfsResolver: new r(function() {
      return (n.createIpfsUrl || r.defaultCreateUrl).apply(void 0, [].slice.call(arguments));
    }), domainResolver: { records: function(Re, Me) {
      try {
        return Promise.resolve(function(ke, Te) {
          try {
            var Ie = Promise.resolve($e.resolution.records(Re, Me));
          } catch (qe) {
            return Te(qe);
          }
          return Ie && Ie.then ? Ie.then(void 0, Te) : Ie;
        }(0, function(ke) {
          if (ke instanceof build.ResolutionError && ke.code === build.ResolutionErrorCode.UnspecifiedResolver) return {};
          throw ke;
        }));
      } catch (ke) {
        return Promise.reject(ke);
      }
    } } }) });
  }
  return c.getStore = function() {
    if (this.store) return this.store;
    if (this.storeOptions.store) this.store = this.storeOptions.store;
    else switch (this.storeOptions.storeType) {
      case "localstore":
        this.store = new $(window.localStorage);
        break;
      case "sessionstore":
        this.store = new $(window.sessionStorage);
        break;
      case "memory":
        this.store = /* @__PURE__ */ new Map();
        break;
      default:
        throw new Error("Bad storeType provided");
    }
    return this.store;
  }, c.buildAuthorizeRequest = function(n) {
    try {
      var ie = this, fe = a({}, ie.fallbackLoginOptions, n), ae = n.username;
      return Promise.resolve(ie.getOpenIdConfiguration(ae)).then(function(le) {
        return Promise.resolve(D.createCodeChallengeAndVerifier(43, "S256")).then(function(he) {
          var me, ye = he.verifier, be = he.challenge, Ae = F.toBase64(F.stringFromBuffer(D.getRandomBytes(32))), Se = F.encodeState(fe.state), $e = { url: le.authorization_endpoint, code_challenge: be, nonce: Ae, state: Se, flow_id: (me = fe.flowId) != null ? me : "login", login_hint: ae, client_id: fe.clientID, client_secret: fe.clientSecret, client_auth_method: fe.clientAuthMethod, max_age: fe.maxAge, prompt: fe.prompt, resource: fe.resource, redirect_uri: fe.redirectUri, response_mode: fe.responseMode, scope: fe.scope, code_challenge_method: "S256", response_type: "code", package_name: (fe == null ? void 0 : fe.packageName) || "@uauth/js", package_version: (fe == null ? void 0 : fe.packageVersion) || "3.0.1", signup_suggestion: fe.signupSuggestion };
          return Promise.resolve(ie._clientStore.setAuthorizeRequest($e)).then(function() {
            return Promise.resolve(ie._clientStore.setVerifier(be, ye)).then(function() {
              return $e;
            });
          });
        });
      });
    } catch (le) {
      return Promise.reject(le);
    }
  }, c.loginWithPopup = function(n, ie) {
    n === void 0 && (n = {});
    try {
      var fe = this;
      return n.responseMode = "fragment", Promise.resolve(fe.buildAuthorizeRequest(n)).then(function(ae) {
        return Promise.resolve(fe.api.authorizeWithPopup(ae, ie)).then(function(le) {
          return Promise.resolve(fe.verifyAuthorizeResponse(ae, le));
        });
      });
    } catch (ae) {
      return Promise.reject(ae);
    }
  }, c.login = function(n) {
    n === void 0 && (n = {});
    try {
      var ie = this;
      return Promise.resolve(ie.buildAuthorizeRequest(n)).then(function(fe) {
        function ae() {
          window.location.href = le;
        }
        var le = ie.api.buildAuthorizeUrl(fe), he = function() {
          if (typeof n.beforeRedirect == "function") return Promise.resolve(n.beforeRedirect(le)).then(function() {
          });
        }();
        return he && he.then ? he.then(ae) : ae();
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, c.loginCallback = function(n) {
    try {
      var ie, fe = this, ae = (ie = n == null ? void 0 : n.url) != null ? ie : window.location.href;
      return Promise.resolve(fe._clientStore.getAuthorizeRequest()).then(function(le) {
        var he;
        if (le.response_mode === "fragment") he = fe.api.parseAuthorizeResponseFromFragment(ae);
        else {
          if (le.response_mode !== "query") throw new Error("Unsupported response_mode");
          he = fe.api.parseAuthorizeResponseFromQuery(ae);
        }
        return Promise.resolve(fe.verifyAuthorizeResponse(le, he)).then(function(me) {
          return { authorization: me, state: F.decodeState(le.state) };
        });
      });
    } catch (le) {
      return Promise.reject(le);
    }
  }, c.verifyAuthorizeResponse = function(n, ie) {
    try {
      var fe = this;
      if (n.state !== ie.state) throw new Error("states don't match");
      return Promise.resolve(fe.getOpenIdConfiguration(n.login_hint)).then(function(ae) {
        var le = ie.code, he = n.client_auth_method, me = n.client_secret, ye = n.client_id, be = ae.token_endpoint;
        return Promise.resolve(fe._clientStore.getVerifier(n.code_challenge)).then(function(Ae) {
          return Promise.resolve(fe.api.getTokenWithAuthorizationCode({ url: be, client_id: ye, client_secret: me, client_auth_method: he, grant_type: "authorization_code", code: le, code_verifier: Ae, redirect_uri: n.redirect_uri })).then(function(Se) {
            return Promise.resolve(D.verifyIdToken(ae.jwks_uri, Se.id_token, n.nonce, n.client_id)).then(function($e) {
              var Re = { accessToken: Se.access_token, expiresAt: Date.now() + 1e3 * Se.expires_in, idToken: $e, scope: C(n.scope), resource: n.resource };
              return Promise.resolve(fe._clientStore.setAuthorization(Re)).then(function() {
                return Re;
              });
            });
          });
        });
      });
    } catch (ae) {
      return Promise.reject(ae);
    }
  }, c.getVerifiedAccounts = function(n, ie) {
    ie === void 0 && (ie = []);
    var fe = [];
    return n.idToken.verified_addresses && n.idToken.verified_addresses.forEach(function(ae) {
      ie.length > 0 && !ie.includes(ae.symbol) || fe.push({ address: ae.address, message: ae.proof.message, signature: ae.proof.signature, symbol: ae.symbol });
    }), fe;
  }, c.getAuthorizationAccount = function(n, ie, fe) {
    var ae;
    ie === void 0 && (ie = "sig"), fe === void 0 && (fe = "v1");
    var le = (ae = n.idToken.amr) == null ? void 0 : ae.filter(function(Se) {
      return Se.startsWith(fe + "." + ie);
    });
    if (le && le.length != 0) {
      var he = le[0].split(".")[3], me = this.getVerifiedAccounts(n);
      if (me) for (var ye, be = _(me); !(ye = be()).done; ) {
        var Ae = ye.value;
        if (Ae.address === he) return Ae;
      }
    }
  }, c.getOpenIdConfiguration = function(n) {
    try {
      var ie, fe = function(he) {
        return ie ? he : Promise.resolve(n ? ae.issuerResolver.resolve(n, ae.fallbackIssuer) : fetch(ae.fallbackIssuer + "/.well-known/openid-configuration").then(function(me) {
          return me.ok ? me.json() : Promise.reject(new Error("bad openid-configuration response"));
        })).then(function(me) {
          return Promise.resolve(ae._clientStore.setOpenIdConfiguration(n ?? "", me, typeof ae.cacheOptions.issuer == "number" ? ae.cacheOptions.issuer : 36e5)).then(function() {
            return me;
          });
        });
      }, ae = this, le = function() {
        if (ae.cacheOptions.issuer) return Promise.resolve(ae._clientStore.getOpenIdConfiguration(n ?? "")).then(function(he) {
          if (he) return ie = 1, he;
        });
      }();
      return Promise.resolve(le && le.then ? le.then(fe) : fe(le));
    } catch (he) {
      return Promise.reject(he);
    }
  }, c.authorization = function(n) {
    n === void 0 && (n = {});
    try {
      var ie = this;
      return Promise.resolve(ie._clientStore.getAuthorization(n)).then(function(fe) {
        return fe.scope && !ie.checkPremiumScopes(fe.scope) && (fe.upgrade = { text: "Please contact Unstoppable Domains to upgrade your account to access premium scopes bd@unstoppabledomains.com", upgrade_for_premium: te({ premium: !0 }).join(" ") }), fe;
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, c.checkPremiumScopes = function(n) {
    return n.split(" ").filter(function(ie) {
      return !te({ premium: !1 }).includes(ie);
    }).length > 0;
  }, c.user = function(n) {
    n === void 0 && (n = {});
    try {
      var ie, fe = this, ae = (ie = n.claims) != null ? ie : ["name", "given_name", "family_name", "middle_name", "nickname", "preferred_username", "profile", "picture", "website", "email", "email_verified", "gender", "birthdate", "zoneinfo", "locale", "phone_number", "phone_number_verified", "address", "updated_at", "wallet_address", "wallet_type_hint", "eip4361_message", "eip4361_signature", "humanity_check_id"];
      return Promise.resolve(fe.authorization(n)).then(function(le) {
        var he = { sub: le.idToken.sub };
        if (le.upgrade && (he.upgrade = le.upgrade, he.email = "upgrade-for-premium", he.address = { formatted: "upgrade-for-premium", street_address: "upgrade-for-premium", locality: "upgrade-for-premium", region: "upgrade-for-premium", postal_code: "upgrade-for-premium", country: "upgrade-for-premium" }, he.phone_number = "upgrade-for-premium", he.name = "upgrade-for-premium", he.given_name = "upgrade-for-premium", he.family_name = "upgrade-for-premium", he.middle_name = "upgrade-for-premium", he.nickname = "upgrade-for-premium", he.preferred_username = "upgrade-for-premium", he.profile = "upgrade-for-premium", he.picture = "https://storage.googleapis.com/unstoppable-client-assets/images/partners/avatar-placeholder.png", he.website = "upgrade-for-premium", he.gender = "upgrade-for-premium", he.birthdate = "upgrade-for-premium", he.zoneinfo = "upgrade-for-premium", he.locale = "upgrade-for-premium", he.updated_at = "upgrade-for-premium", he.humanity_check_id = "upgrade-for-premium"), fe.cacheOptions.userinfo) {
          for (var me, ye = _(ae); !(me = ye()).done; ) {
            var be = me.value;
            le.idToken[be] && (he[be] = le.idToken[be]);
          }
          return he;
        }
        return Promise.resolve(fe.getOpenIdConfiguration(le.idToken.sub)).then(function(Ae) {
          return Promise.resolve(fe.api.userinfo({ client_id: fe.fallbackLoginOptions.clientID, client_secret: fe.fallbackLoginOptions.clientSecret, client_auth_method: fe.fallbackLoginOptions.clientAuthMethod, access_token: le.accessToken, url: Ae.userinfo_endpoint })).then(function(Se) {
            for (var $e, Re = _(ae); !($e = Re()).done; ) {
              var Me = $e.value;
              Se[Me] && (he[Me] = Se[Me]);
            }
            return he;
          });
        });
      });
    } catch (le) {
      return Promise.reject(le);
    }
  }, c.buildLogoutRequest = function(n) {
    try {
      var ie = this;
      return Promise.resolve(ie.authorization(n)).then(function(fe) {
        return Promise.resolve(ie.getOpenIdConfiguration(fe.idToken.sub)).then(function(ae) {
          var le;
          if (ae.end_session_endpoint == null) throw new Error("end_session_endpoint must exist");
          var he = (le = n.postLogoutRedirectUri) != null ? le : ie.fallbackLogoutOptions.postLogoutRedirectUri;
          if (he == null) throw new Error("postLogoutRedirectUri must be supplied");
          var me = { client_id: ie.fallbackLoginOptions.clientID, client_secret: ie.fallbackLoginOptions.clientSecret, client_auth_method: ie.fallbackLoginOptions.clientAuthMethod, url: ae.end_session_endpoint, id_token_hint: fe.idToken.__raw, post_logout_redirect_uri: he, state: F.encodeState(n.state) };
          return Promise.resolve(ie._clientStore.setLogoutRequest(me)).then(function() {
            return me;
          });
        });
      });
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, c.logout = function(n) {
    var ie = n === void 0 ? {} : n, fe = ie.clientID, ae = ie.username, le = ie.scope, he = ie.resource, me = v(ie, re);
    try {
      var ye, be = function(Me) {
        return ye ? Me : Promise.resolve(Ae.buildLogoutRequest(Se)).then(function(ke) {
          function Te() {
            return Promise.resolve(Ae._clientStore.deleteAuthorization($e)).then(function() {
              window.location.href = Ie;
            });
          }
          var Ie = Ae.api.buildLogoutUrl(ke), qe = function() {
            if (typeof Se.beforeRedirect == "function") return Promise.resolve(Se.beforeRedirect(Ie)).then(function() {
            });
          }();
          return qe && qe.then ? qe.then(Te) : Te();
        });
      }, Ae = this, Se = a({}, Ae.fallbackLogoutOptions, me), $e = { clientID: fe, username: ae, scope: le, resource: he }, Re = function() {
        if (!Se.rpInitiatedLogout) return Promise.resolve(Ae._clientStore.deleteAuthorization($e)).then(function() {
          ye = 1;
        });
      }();
      return Promise.resolve(Re && Re.then ? Re.then(be) : be(Re));
    } catch (Me) {
      return Promise.reject(Me);
    }
  }, c.logoutCallback = function(n) {
    n === void 0 && (n = {});
    try {
      var ie, fe, ae = this, le = (ie = (fe = n) == null ? void 0 : fe.url) != null ? ie : window.location.href;
      return Promise.resolve(ae._clientStore.getLogoutRequest()).then(function(he) {
        var me = ae.api.parseAuthorizeResponseFromQuery(le);
        return Promise.resolve(ae.verifyLogoutResponse(he, me)).then(function() {
          return F.decodeState(he.state);
        });
      });
    } catch (he) {
      return Promise.reject(he);
    }
  }, c.verifyLogoutResponse = function(n, ie) {
    try {
      if (n.state !== ie.state) throw new Error("states don't match");
      return Promise.resolve();
    } catch (fe) {
      return Promise.reject(fe);
    }
  }, t;
}();
class UnstoppableProvider {
  constructor(t) {
    this.modalInterface = new defaultModal(), this.wallet = ChainWallet.Phantom, this.network = t, this.axiosInstance = ky.create({
      prefixUrl: this.network === Network.MAINNET ? "https://apiv3.droplinked.com" : "https://apiv3dev.droplinked.com"
    }), this.address = "", this.clientID = "", this.redirectUri = "";
  }
  executeAirdrop(t) {
    throw new Error("Method not implemented.");
  }
  customPayment(t) {
    throw new Error("Method not implemented.");
  }
  setClientID(t, n) {
    this.clientID = t, this.redirectUri = n;
  }
  claimNFTs(t) {
    throw new Error("Method not implemented.");
  }
  setAxiosInstance(t) {
    return this.axiosInstance = t, this;
  }
  async unstoppableLogin(t, n) {
    if (this.clientID = t, this.redirectUri = n, this.clientID === "" || this.redirectUri === "")
      throw new WalletNotFoundException();
    const ie = new oe({
      clientID: this.clientID,
      redirectUri: this.redirectUri
    });
    try {
      return await ie.loginWithPopup();
    } catch (fe) {
      throw console.error(fe), fe;
    }
  }
  async walletLogin() {
    throw new Error("Method not implemented.");
  }
  deployShop(t) {
    throw new Error("Method not implemented.");
  }
  recordProduct(t, n) {
    throw new Error("Method not implemented.");
  }
  publishRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  approveRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  disapproveRequest(t, n) {
    throw new Error("Method not implemented.");
  }
  async payment(t) {
    throw new Error("Method not implemented.");
  }
  async paymentWithToken(t, n, ie) {
    throw new Error("Method not implemented.");
  }
  setAddress(t) {
    return this.address = t, this;
  }
  setWallet(t) {
    return this.wallet = t, this;
  }
  setModal(t) {
    return this.modalInterface = t, this;
  }
  setNFTContractAddress(t) {
    return this.nftContractAddress = t, this;
  }
  setShopContractAddress(t) {
    return this.shopContractAddress = t, this;
  }
  getPaymentData(t, n, ie) {
    throw new Error("Method not implemented.");
  }
}
class DropWeb3 {
  constructor(t) {
    this.chainMapping = {
      [Chain.BINANCE]: {
        [Network.TESTNET]: new EVMProvider(Chain.BINANCE, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.BINANCE, Network.TESTNET, !0),
        [Network.MAINNET]: new EVMProvider(Chain.BINANCE, Network.MAINNET, !0)
      },
      [Chain.POLYGON]: {
        [Network.TESTNET]: new EVMProvider(Chain.POLYGON, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.POLYGON, Network.TESTNET, !0),
        [Network.MAINNET]: new EVMProvider(Chain.POLYGON, Network.MAINNET, !0)
      },
      [Chain.NEAR]: {
        [Network.TESTNET]: new EVMProvider(
          Chain.NEAR,
          Network.TESTNET,
          !0
          // todo
        ),
        [Network.DEV]: new EVMProvider(
          Chain.NEAR,
          Network.TESTNET,
          !0
          // todo
        ),
        [Network.MAINNET]: new EVMProvider(
          Chain.NEAR,
          Network.MAINNET,
          !0
          //todo
        )
      },
      [Chain.CASPER]: {
        [Network.TESTNET]: null,
        [Network.DEV]: null,
        [Network.MAINNET]: null
      },
      [Chain.XRPLSIDECHAIN]: {
        [Network.TESTNET]: null,
        [Network.DEV]: null,
        [Network.MAINNET]: null
      },
      [Chain.BASE]: {
        [Network.TESTNET]: new EVMProvider(Chain.BASE, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.BASE, Network.TESTNET, !0),
        [Network.MAINNET]: new EVMProvider(Chain.BASE, Network.MAINNET, !0)
      },
      [Chain.STACKS]: {
        [Network.TESTNET]: null,
        [Network.DEV]: null,
        [Network.MAINNET]: null
      },
      [Chain.SKALE]: {
        [Network.TESTNET]: new EVMProvider(Chain.SKALE, Network.TESTNET, !1),
        [Network.DEV]: new EVMProvider(Chain.SKALE, Network.TESTNET, !1),
        [Network.MAINNET]: new EVMProvider(Chain.SKALE, Network.MAINNET, !1)
      },
      [Chain.LINEA]: {
        [Network.TESTNET]: new EVMProvider(Chain.LINEA, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.LINEA, Network.TESTNET, !0),
        [Network.MAINNET]: new EVMProvider(Chain.LINEA, Network.MAINNET, !0)
      },
      [Chain.ETH]: {
        [Network.TESTNET]: new EVMProvider(Chain.ETH, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.ETH, Network.TESTNET, !0),
        [Network.MAINNET]: new EVMProvider(Chain.ETH, Network.MAINNET, !0)
      },
      [Chain.SOLANA]: {
        [Network.MAINNET]: new SolanaProvider(Network.MAINNET),
        [Network.TESTNET]: new SolanaProvider(Network.TESTNET),
        [Network.DEV]: new SolanaProvider(Network.TESTNET)
      },
      [Chain.UNSTOPPABLE]: {
        [Network.MAINNET]: new UnstoppableProvider(Network.MAINNET),
        [Network.TESTNET]: new UnstoppableProvider(Network.TESTNET),
        [Network.DEV]: new UnstoppableProvider(Network.TESTNET)
      },
      [Chain.REDBELLY]: {
        [Network.MAINNET]: new EVMProvider(Chain.REDBELLY, Network.MAINNET, !0),
        [Network.TESTNET]: new EVMProvider(Chain.REDBELLY, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.REDBELLY, Network.TESTNET, !0)
      },
      [Chain.BITLAYER]: {
        [Network.MAINNET]: new EVMProvider(Chain.BITLAYER, Network.MAINNET, !0),
        [Network.TESTNET]: new EVMProvider(Chain.BITLAYER, Network.TESTNET, !0),
        [Network.DEV]: new EVMProvider(Chain.BITLAYER, Network.TESTNET, !0)
      }
    }, this.axiosInstance = ky.create({
      prefixUrl: t === Network.TESTNET ? "https://apiv3dev.droplinked.com" : t === Network.MAINNET ? "https://apiv3.droplinked.com" : "http://127.0.0.1"
    }), this.network = t;
  }
  web3Instance(t) {
    var ye;
    const n = this.network, { modalInterface: ie, preferredWallet: fe } = t;
    let ae = "", le = "", he = "", me = Chain.ETH;
    if (t.method === Web3Actions.RECORD_AFFILIATE ? (ae = t.userAddress, le = t.nftContractAddress, he = t.shopContractAddress, me = t.chain) : t.method === Web3Actions.DEPLOY || t.method === Web3Actions.PAYMENT ? (ae = t.userAddress, me = t.chain) : t.method === Web3Actions.CLAIM ? (ae = t.userAddress, he = t.shopContractAddress, me = t.chain) : t.method === Web3Actions.LOGIN ? fe === ChainWallet.Phantom ? me = Chain.SOLANA : fe === ChainWallet.UnstoppableDomains ? me = Chain.UNSTOPPABLE : me = Chain.ETH : t.method === Web3Actions.AIRDROP && (me = t.chain, ae = t.userAddress), this.chainMapping[me][n] === null || this.chainMapping[me][n] === void 0)
      throw new ChainNotImplementedException(
        `The given chain <${me}> and network <${n}> is not implemented yet`
      );
    return (ye = this.chainMapping[me][n]) == null ? void 0 : ye.setAddress(ae || "").setModal(ie || new defaultModal()).setWallet(fe).setAxiosInstance(this.axiosInstance).setNFTContractAddress(le || "").setShopContractAddress(he || "");
  }
  async getWalletInfo() {
    try {
      const t = window.ethereum;
      if (!t)
        throw new WalletNotFoundException();
      if (!t.isMetaMask)
        throw new MetaMaskNotFoundException();
      try {
        await t.request({ method: "eth_requestAccounts" });
      } catch (he) {
        throw console.error(he), new AccountAccessDeniedException();
      }
      const n = Math.floor(Math.random() * 1e7), ie = (/* @__PURE__ */ new Date()).toLocaleString(), fe = `Welcome to Droplinked!

      Please sign this message to verify your identity and securely log in.

      - Nonce: ${n}
      - Date: ${ie}

      This action will not incur any gas fees or blockchain transactions.`;
      let ae;
      try {
        const he = await getAccounts(t);
        if (!he || he.length === 0)
          throw new NoAccountsFoundException();
        ae = he[0];
      } catch (he) {
        throw new WalletError(
          `Failed to retrieve account address: ${he.message}`
        );
      }
      let le;
      try {
        le = await new Web3Provider(t).getSigner().signMessage(fe);
      } catch (he) {
        throw console.error(he), new SignatureRequestDeniedException();
      }
      return {
        address: ae,
        signature: le,
        nonce: n,
        date: ie
      };
    } catch (t) {
      throw console.error("Error fetching wallet information:", t.message), t;
    }
  }
}
export {
  AccountAccessDeniedException,
  AccountChangedException,
  AlreadyRequested,
  Chain,
  ChainError,
  ChainNotImplementedException,
  ChainSwitchException,
  ChainWallet,
  DropWeb3,
  InsufficientBalanceException,
  InsufficientTokenBalanceException,
  InvalidParametersException,
  MetaMaskNotFoundException,
  MetadataUploadFailedException,
  NFTType,
  Network,
  NoAccountsFoundException,
  PaymentMethodType,
  PaymentTokens,
  ProductType,
  RequestAlreadyConfirmed,
  RequestDoesNotExist,
  RequestDoesntExist,
  RequestNotConfirmed,
  SignatureRequestDeniedException,
  TokenStandard,
  Unauthorized,
  UserDeniedException,
  WalletError,
  WalletNotFoundException,
  Web3Actions,
  ZERO_ADDRESS,
  addChain,
  changeChain,
  defaultModal,
  evmLogin,
  getAccounts,
  getBalance,
  getGasPrice$1 as getGasPrice,
  isChainCorrect,
  isCoinBaseInstalled,
  isMetamaskInstalled,
  isWalletConnected,
  isWalletInstalled,
  toEthAddress
};
